import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  MongoID: { input: any; output: any; }
  RegExpAsString: { input: any; output: any; }
};

export type AccessIdsFilterArg = {
  operators?: InputMaybe<Array<Scalars['String']['input']>>;
  organizations?: InputMaybe<Array<Scalars['String']['input']>>;
  storefronts?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AccommodationOperatorMetadata = {
  __typename?: 'AccommodationOperatorMetadata';
  guestRoomQty?: Maybe<Scalars['Float']['output']>;
  shortTermAccommodationLicense?: Maybe<Scalars['String']['output']>;
};

export type AccommodationOperatorMetadataInput = {
  guestRoomQty?: InputMaybe<Scalars['Float']['input']>;
  shortTermAccommodationLicense?: InputMaybe<Scalars['String']['input']>;
};

export type AccommodationProductMetadata = {
  __typename?: 'AccommodationProductMetadata';
  amenities: Array<Tag>;
  calendarLinks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  checkIn?: Maybe<Scalars['String']['output']>;
  checkOut?: Maybe<Scalars['String']['output']>;
  closures: Array<Maybe<Closure>>;
  guestMetadata?: Maybe<GuestMetadata>;
  rooms: Array<Maybe<Room>>;
};

export type AccommodationProductMetadataInput = {
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  calendarLinks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  checkIn?: InputMaybe<Scalars['String']['input']>;
  checkOut?: InputMaybe<Scalars['String']['input']>;
  closures: Array<InputMaybe<ClosureInput>>;
  guestMetadata?: InputMaybe<GuestMetadataInput>;
  rooms: Array<InputMaybe<RoomInput>>;
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  _id: Scalars['MongoID']['output'];
  bulkConnectLogId?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  emailActivity?: Maybe<ActivityLogEmailActivity>;
  entity: EntityReference;
  entityName: Multilingual;
  importRunId?: Maybe<Scalars['MongoID']['output']>;
  initiatedBy: Scalars['String']['output'];
  initiatedByPerson?: Maybe<Scalars['MongoID']['output']>;
  initiatedByUser?: Maybe<Scalars['MongoID']['output']>;
  message: Multilingual;
  owner: Owner;
  resourceId?: Maybe<Scalars['MongoID']['output']>;
  surveyResponse?: Maybe<SurveyResponse>;
  surveyResponseId?: Maybe<Scalars['MongoID']['output']>;
  tags: Array<Maybe<Scalars['MongoID']['output']>>;
  type: EnumActivityLogType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ActivityLogEmailActivity = {
  __typename?: 'ActivityLogEmailActivity';
  fromAddress?: Maybe<ActivityLogEmailActivityFromAddress>;
  recipients?: Maybe<Array<Maybe<ActivityLogEmailActivityRecipients>>>;
  sentHtml?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  templatePreviewHtml?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogEmailActivityFromAddress = {
  __typename?: 'ActivityLogEmailActivityFromAddress';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogEmailActivityFromAddressInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogEmailActivityInput = {
  fromAddress?: InputMaybe<ActivityLogEmailActivityFromAddressInput>;
  recipients?: InputMaybe<Array<InputMaybe<ActivityLogEmailActivityRecipientsInput>>>;
  sentHtml?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  templatePreviewHtml?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogEmailActivityRecipients = {
  __typename?: 'ActivityLogEmailActivityRecipients';
  bouncedAt?: Maybe<Scalars['Date']['output']>;
  clickedAt?: Maybe<Scalars['Date']['output']>;
  deferredAt?: Maybe<Scalars['Date']['output']>;
  deliveredAt?: Maybe<Scalars['Date']['output']>;
  displayName: Scalars['String']['output'];
  droppedAt?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  openedAt?: Maybe<Scalars['Date']['output']>;
  personId?: Maybe<Scalars['MongoID']['output']>;
  spamReportedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['MongoID']['output']>;
};

export type ActivityLogEmailActivityRecipientsInput = {
  bouncedAt?: InputMaybe<Scalars['Date']['input']>;
  clickedAt?: InputMaybe<Scalars['Date']['input']>;
  deferredAt?: InputMaybe<Scalars['Date']['input']>;
  deliveredAt?: InputMaybe<Scalars['Date']['input']>;
  displayName: Scalars['String']['input'];
  droppedAt?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  openedAt?: InputMaybe<Scalars['Date']['input']>;
  personId?: InputMaybe<Scalars['MongoID']['input']>;
  spamReportedAt?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type AddOnBusinessScopeInput = {
  customFieldResponses?: InputMaybe<Array<InputMaybe<CustomFieldResponseInput>>>;
  operatorId: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  location?: Maybe<AddressLocation>;
  postalCode?: Maybe<Scalars['String']['output']>;
  subdivision?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<AddressLocationInput>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
};

export type AddressLocation = {
  __typename?: 'AddressLocation';
  coordinates: Array<Maybe<Scalars['Float']['output']>>;
  type: EnumAddressLocationType;
};

export type AddressLocationInput = {
  coordinates: Array<InputMaybe<Scalars['Float']['input']>>;
  type: EnumAddressLocationType;
};

export type AdminStorefrontSalesReportRow = {
  __typename?: 'AdminStorefrontSalesReportRow';
  chargeCount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  grossSales: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  refunds: Scalars['Int']['output'];
  storefrontId: Scalars['MongoID']['output'];
  stripeFees: Scalars['Int']['output'];
  whereaboutsFees: Scalars['Int']['output'];
};

export type AdminUserInfo = {
  __typename?: 'AdminUserInfo';
  _id: Scalars['MongoID']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  systemPermissions: Array<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
};

export type AdminUserPromoteResult = {
  __typename?: 'AdminUserPromoteResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<AdminUserInfo>;
};

export type AdminlandListingsExportItem = {
  __typename?: 'AdminlandListingsExportItem';
  _entityId: Scalars['MongoID']['output'];
  businessType?: Maybe<Scalars['String']['output']>;
  connectedOrganizations: Array<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  name: Multilingual;
  operationalStatus?: Maybe<Scalars['String']['output']>;
  publicEmailAddress?: Maybe<Scalars['String']['output']>;
  staffEmails: Array<Scalars['String']['output']>;
  status: PublicationStatusType;
  tags: Array<Scalars['String']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type AiImageScanCreatePayload = {
  __typename?: 'AiImageScanCreatePayload';
  taskId: Scalars['MongoID']['output'];
};

export type AiImageScanExecutePayload = {
  __typename?: 'AiImageScanExecutePayload';
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  result?: Maybe<AiImageScanResult>;
  success: Scalars['Boolean']['output'];
};

export type AiImageScanImage = {
  __typename?: 'AiImageScanImage';
  alt?: Maybe<Scalars['String']['output']>;
  isOgImage?: Maybe<Scalars['Boolean']['output']>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type AiImageScanResult = {
  __typename?: 'AiImageScanResult';
  images: Array<Maybe<AiImageScanImage>>;
};

export type AiImageScanUploadPayload = {
  __typename?: 'AiImageScanUploadPayload';
  assets?: Maybe<Array<Maybe<AiImageScanUploadedAsset>>>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AiImageScanUploadedAsset = {
  __typename?: 'AiImageScanUploadedAsset';
  _id: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type AiImageVerifyResult = {
  __typename?: 'AiImageVerifyResult';
  downloadable: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type AiImageVerifyUrlsPayload = {
  __typename?: 'AiImageVerifyUrlsPayload';
  results: Array<AiImageVerifyResult>;
};

export type AiProfileScanAddress = {
  __typename?: 'AiProfileScanAddress';
  city?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<AiProfileScanCoordinates>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  subdivision?: Maybe<Scalars['String']['output']>;
};

export type AiProfileScanCoordinates = {
  __typename?: 'AiProfileScanCoordinates';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type AiProfileScanCreatePayload = {
  __typename?: 'AiProfileScanCreatePayload';
  taskId: Scalars['MongoID']['output'];
};

export type AiProfileScanExecutePayload = {
  __typename?: 'AiProfileScanExecutePayload';
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  result?: Maybe<AiProfileScanResult>;
  success: Scalars['Boolean']['output'];
};

export type AiProfileScanResult = {
  __typename?: 'AiProfileScanResult';
  address?: Maybe<AiProfileScanAddress>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  operatorType?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  socialLinks?: Maybe<Scalars['JSON']['output']>;
  tags?: Maybe<AiProfileScanTags>;
};

export type AiProfileScanTags = {
  __typename?: 'AiProfileScanTags';
  amenity?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  businessType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  global?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AiTask = {
  __typename?: 'AiTask';
  _id: Scalars['MongoID']['output'];
  applied?: Maybe<Scalars['Boolean']['output']>;
  appliedAt?: Maybe<Scalars['Date']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  feedbackNotes?: Maybe<Scalars['String']['output']>;
  initiatedBy: Scalars['String']['output'];
  lastPingAt?: Maybe<Scalars['Date']['output']>;
  operatorId: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<AiTaskRating>;
  status: AiTaskStatus;
  taskType: Scalars['String']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type AiTaskCancelPayload = {
  __typename?: 'AiTaskCancelPayload';
  success: Scalars['Boolean']['output'];
  task?: Maybe<AiTask>;
};

export type AiTaskFeedbackPayload = {
  __typename?: 'AiTaskFeedbackPayload';
  success: Scalars['Boolean']['output'];
  task?: Maybe<AiTask>;
};

export type AiTaskMarkAppliedPayload = {
  __typename?: 'AiTaskMarkAppliedPayload';
  success: Scalars['Boolean']['output'];
  task?: Maybe<AiTask>;
};

export type AiTaskPingPayload = {
  __typename?: 'AiTaskPingPayload';
  status?: Maybe<AiTaskStatus>;
  success: Scalars['Boolean']['output'];
};

export enum AiTaskRating {
  Bad = 'BAD',
  Good = 'GOOD'
}

export enum AiTaskStatus {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export type AnalyticsDashboard = {
  __typename?: 'AnalyticsDashboard';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  dashboardId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Float']['output'];
  updatedBy: Scalars['MongoID']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ApiAccess = {
  __typename?: 'ApiAccess';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  token: Scalars['String']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<UserWithPictureTc>;
};

export type Asset = AssetInterface & {
  __typename?: 'Asset';
  _id: Scalars['String']['output'];
  blurhash: Scalars['String']['output'];
  bytes?: Maybe<Scalars['Float']['output']>;
  caption: Multilingual;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  originalUrl?: Maybe<Scalars['String']['output']>;
  parentEntity: EntityReference;
  sourceEnv?: Maybe<Scalars['String']['output']>;
  type?: Maybe<EnumDKeyAssetType>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type AssetFile = AssetInterface & {
  __typename?: 'AssetFile';
  _id: Scalars['String']['output'];
  blurhash: Scalars['String']['output'];
  bytes?: Maybe<Scalars['Float']['output']>;
  caption: Multilingual;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  originalUrl?: Maybe<Scalars['String']['output']>;
  parentEntity: EntityReference;
  sourceEnv?: Maybe<Scalars['String']['output']>;
  type?: Maybe<EnumDKeyAssetType>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type AssetImage = AssetInterface & {
  __typename?: 'AssetImage';
  _id: Scalars['String']['output'];
  assetUrls?: Maybe<AssetImageUrls>;
  blurhash: Scalars['String']['output'];
  bytes?: Maybe<Scalars['Float']['output']>;
  caption: Multilingual;
  colors?: Maybe<Array<Maybe<Color>>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  detectedObjects?: Maybe<DetectedObjects>;
  duration: Scalars['Float']['output'];
  format: Scalars['String']['output'];
  hasTransparency?: Maybe<Scalars['Boolean']['output']>;
  height: Scalars['Int']['output'];
  isVideo?: Maybe<Scalars['Boolean']['output']>;
  lightness?: Maybe<Scalars['String']['output']>;
  mux?: Maybe<AssetImageMux>;
  originalUrl?: Maybe<Scalars['String']['output']>;
  parentEntity: EntityReference;
  qualityAnalysis?: Maybe<ImageQualityAnalysis>;
  qualityScore?: Maybe<ImageQualityRating>;
  sourceEnv?: Maybe<Scalars['String']['output']>;
  type?: Maybe<EnumDKeyAssetType>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  width: Scalars['Int']['output'];
};

export type AssetImageMux = {
  __typename?: 'AssetImageMux';
  assetId: Scalars['String']['output'];
  playbackId?: Maybe<Scalars['String']['output']>;
  status: EnumAssetImageMuxStatus;
};

export type AssetImageUrls = {
  __typename?: 'AssetImageUrls';
  avatar?: Maybe<Scalars['String']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  videoLarge?: Maybe<Scalars['String']['output']>;
  videoMedium?: Maybe<Scalars['String']['output']>;
  videoSmall?: Maybe<Scalars['String']['output']>;
};

export type AssetInterface = {
  _id: Scalars['String']['output'];
  blurhash: Scalars['String']['output'];
  bytes?: Maybe<Scalars['Float']['output']>;
  caption: Multilingual;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  originalUrl?: Maybe<Scalars['String']['output']>;
  parentEntity: EntityReference;
  sourceEnv?: Maybe<Scalars['String']['output']>;
  type?: Maybe<EnumDKeyAssetType>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type AssetUnion = AssetFile | AssetImage;

export type AudienceTagFilterInput = {
  mode: AudienceTagModeEnum;
  tagId: Scalars['MongoID']['input'];
};

export enum AudienceTagModeEnum {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE'
}

export type Booker = {
  __typename?: 'Booker';
  _id: Scalars['MongoID']['output'];
  approvalSettings?: Maybe<BookerApprovalSettings>;
  /** Logo shown in the booking widget: per-widget customization when set, otherwise this storefront's default widget logo from Settings. */
  brandingLogo?: Maybe<AssetImage>;
  bundles: Array<Maybe<BookerBundles>>;
  businessCompletionTags: Array<Maybe<Scalars['MongoID']['output']>>;
  completionScreen?: Maybe<BookerCompletionScreen>;
  completionTags: Array<Maybe<Scalars['MongoID']['output']>>;
  copiedFrom?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  customerFields?: Maybe<BookerCustomerFields>;
  customizations?: Maybe<BookerCustomizations>;
  discountScopes: Array<Maybe<BookerDiscountScopes>>;
  discounts: Array<Discount>;
  eligibility?: Maybe<BookerEligibility>;
  emailTemplates: Array<Maybe<BookerEmailTemplates>>;
  feeAbsorptionSnapshot?: Maybe<BookerFeeAbsorptionSnapshot>;
  fulfillmentProfile?: Maybe<FulfillmentProfile>;
  isInvoiceTemplate: Scalars['Boolean']['output'];
  name: Multilingual;
  paymentMetadata?: Maybe<OrderPaymentMetadata>;
  paymentMethodSet?: Maybe<PaymentMethodSet>;
  paymentTiming?: Maybe<BookerPaymentTiming>;
  /** Whether checkouts on this widget can be for several businesses, with per-business add-ons. */
  perBusinessAnswersEnabled: Scalars['Boolean']['output'];
  policies: Array<Policy>;
  promoCodeTagOverrides: Array<Maybe<BookerPromoCodeTagOverrides>>;
  publiclyPublishable: Scalars['Boolean']['output'];
  /** Whether membership / renewable-fee checkouts on this widget offer add-ons (storefront-gated). */
  renewableFeeAddOnsEnabled: Scalars['Boolean']['output'];
  renewalSettings?: Maybe<BookerRenewalSettings>;
  /** Whether selling this widget needs a connected Stripe account (anything priced). */
  requiresPayment: Scalars['Boolean']['output'];
  rules: Array<Rule>;
  status: EnumBookerStatus;
  statusNotification?: Maybe<Multilingual>;
  storefront: Scalars['MongoID']['output'];
  survey?: Maybe<Survey>;
  surveyInline: Scalars['Boolean']['output'];
  tagDiscountSettings?: Maybe<BookerTagDiscountSettings>;
  teamVisible: Scalars['Boolean']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  waivers: Array<AssetFile>;
};


export type BookerDiscountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsDiscountInput>;
};


export type BookerPoliciesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPolicyInput>;
};


export type BookerRulesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsRuleInput>;
};


export type BookerWaiversArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsAssetFileInput>;
};

export type BookerApprovalSettings = {
  __typename?: 'BookerApprovalSettings';
  autoCancelUnpaidAfterDays?: Maybe<Scalars['Float']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  messageToGuest?: Maybe<Multilingual>;
  requestExpiryHours?: Maybe<Scalars['Float']['output']>;
};

export type BookerApprovalSettingsInput = {
  autoCancelUnpaidAfterDays?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageToGuest?: InputMaybe<MultilingualInput>;
  requestExpiryHours?: InputMaybe<Scalars['Float']['input']>;
};

export type BookerBundles = {
  __typename?: 'BookerBundles';
  _id?: Maybe<Scalars['MongoID']['output']>;
  product?: Maybe<Product>;
  upsells: Array<Product>;
};

export type BookerBundlesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  product: Scalars['MongoID']['input'];
  upsells?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type BookerCompletionScreen = {
  __typename?: 'BookerCompletionScreen';
  ctaBroadcastId?: Maybe<Scalars['String']['output']>;
  ctaLabel?: Maybe<Multilingual>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Multilingual>;
};

export type BookerCompletionScreenInput = {
  ctaBroadcastId?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<MultilingualInput>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<MultilingualInput>;
};

export type BookerConfirmationEmailPreview = {
  __typename?: 'BookerConfirmationEmailPreview';
  html: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type BookerCustomerFields = {
  __typename?: 'BookerCustomerFields';
  addressRequired?: Maybe<Scalars['Boolean']['output']>;
  businessFieldDescription?: Maybe<Multilingual>;
  businessFieldEnabled?: Maybe<Scalars['Boolean']['output']>;
  guestEmailEnabled?: Maybe<Scalars['Boolean']['output']>;
  guestInfoRequired?: Maybe<Scalars['Boolean']['output']>;
  guestNamesEnabled?: Maybe<Scalars['Boolean']['output']>;
  phoneEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type BookerCustomerFieldsInput = {
  addressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  businessFieldDescription?: InputMaybe<MultilingualInput>;
  businessFieldEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  guestEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  guestInfoRequired?: InputMaybe<Scalars['Boolean']['input']>;
  guestNamesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  phoneEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BookerCustomizations = {
  __typename?: 'BookerCustomizations';
  addressDisplay?: Maybe<EnumBookerCustomizationsAddressDisplay>;
  confirmationEmailBody?: Maybe<Multilingual>;
  confirmationEmailCtaLabel?: Maybe<Multilingual>;
  confirmationEmailCtaUrl?: Maybe<Scalars['String']['output']>;
  confirmationEmailSubject?: Maybe<Multilingual>;
  featuredImage?: Maybe<AssetImage>;
  logo?: Maybe<AssetImage>;
  overrideAddOnsDescription?: Maybe<Multilingual>;
  overrideDiscountCallout?: Maybe<Multilingual>;
  overridePricingCallout?: Maybe<Multilingual>;
  overrideProductDescription?: Maybe<Multilingual>;
  overrideProductName?: Maybe<Multilingual>;
  overrideQuestionnaireDescription?: Maybe<Multilingual>;
  overrideQuestionnaireTitle?: Maybe<Multilingual>;
  sectionOrder?: Maybe<Array<Maybe<EnumBookerCustomizationsSectionOrder>>>;
  showCheckoutChecklist?: Maybe<Scalars['Boolean']['output']>;
};

export type BookerCustomizationsInput = {
  addressDisplay?: InputMaybe<EnumBookerCustomizationsAddressDisplay>;
  confirmationEmailBody?: InputMaybe<MultilingualInput>;
  confirmationEmailCtaLabel?: InputMaybe<MultilingualInput>;
  confirmationEmailCtaUrl?: InputMaybe<Scalars['String']['input']>;
  confirmationEmailSubject?: InputMaybe<MultilingualInput>;
  featuredImage?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  overrideAddOnsDescription?: InputMaybe<MultilingualInput>;
  overrideDiscountCallout?: InputMaybe<MultilingualInput>;
  overridePricingCallout?: InputMaybe<MultilingualInput>;
  overrideProductDescription?: InputMaybe<MultilingualInput>;
  overrideProductName?: InputMaybe<MultilingualInput>;
  overrideQuestionnaireDescription?: InputMaybe<MultilingualInput>;
  overrideQuestionnaireTitle?: InputMaybe<MultilingualInput>;
  sectionOrder?: InputMaybe<Array<InputMaybe<EnumBookerCustomizationsSectionOrder>>>;
  showCheckoutChecklist?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BookerDiscountScopes = {
  __typename?: 'BookerDiscountScopes';
  appliesToTierIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  discount: Scalars['MongoID']['output'];
};

export type BookerDiscountScopesInput = {
  appliesToTierIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discount: Scalars['MongoID']['input'];
};

export type BookerDuplicateToStorefrontResult = {
  __typename?: 'BookerDuplicateToStorefrontResult';
  bookerId: Scalars['MongoID']['output'];
  storefrontId: Scalars['MongoID']['output'];
};

export type BookerEligibility = {
  __typename?: 'BookerEligibility';
  blockedMessage?: Maybe<Multilingual>;
  ineligibleBehavior?: Maybe<EnumBookerEligibilityIneligibleBehavior>;
  mode?: Maybe<EnumBookerEligibilityMode>;
  rule?: Maybe<EnumBookerEligibilityRule>;
  tagId?: Maybe<Scalars['MongoID']['output']>;
};

export type BookerEligibilityInput = {
  blockedMessage?: InputMaybe<MultilingualInput>;
  ineligibleBehavior?: InputMaybe<EnumBookerEligibilityIneligibleBehavior>;
  mode?: InputMaybe<EnumBookerEligibilityMode>;
  rule?: InputMaybe<EnumBookerEligibilityRule>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type BookerEligibilityResult = {
  __typename?: 'BookerEligibilityResult';
  blockedMessage?: Maybe<Multilingual>;
  eligible: Scalars['Boolean']['output'];
  ineligibleBehavior: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export type BookerEmailTemplates = {
  __typename?: 'BookerEmailTemplates';
  body: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  type: EnumBookerEmailTemplatesType;
};

export type BookerEmailTemplatesInput = {
  body: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  type: EnumBookerEmailTemplatesType;
};

export type BookerFeeAbsorptionPreview = {
  __typename?: 'BookerFeeAbsorptionPreview';
  applicationPercent: Scalars['Float']['output'];
  products?: Maybe<Array<Maybe<BookerFeeAbsorptionPreviewProduct>>>;
  snapshotAppliedAt?: Maybe<Scalars['Date']['output']>;
  taxPercent: Scalars['Float']['output'];
};

export type BookerFeeAbsorptionPreviewProduct = {
  __typename?: 'BookerFeeAbsorptionPreviewProduct';
  isMain: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  otherWidgetCount: Scalars['Int']['output'];
  pricePoints?: Maybe<Array<Maybe<BookerFeeAbsorptionPricePoint>>>;
  productId: Scalars['String']['output'];
  productType: Scalars['String']['output'];
};

export type BookerFeeAbsorptionPriceOverrideInput = {
  path: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
};

export type BookerFeeAbsorptionPricePoint = {
  __typename?: 'BookerFeeAbsorptionPricePoint';
  basePrice: Scalars['Int']['output'];
  currentPrice: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type BookerFeeAbsorptionRevertResult = {
  __typename?: 'BookerFeeAbsorptionRevertResult';
  booker?: Maybe<Booker>;
  restoredCount: Scalars['Int']['output'];
  skipped?: Maybe<Array<Maybe<BookerFeeAbsorptionSkippedPricePoint>>>;
};

export type BookerFeeAbsorptionSkippedPricePoint = {
  __typename?: 'BookerFeeAbsorptionSkippedPricePoint';
  label: Scalars['String']['output'];
  path: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
};

export type BookerFeeAbsorptionSnapshot = {
  __typename?: 'BookerFeeAbsorptionSnapshot';
  appliedAt: Scalars['Date']['output'];
  products?: Maybe<Array<Maybe<BookerFeeAbsorptionSnapshotProducts>>>;
};

export type BookerFeeAbsorptionSnapshotInput = {
  appliedAt: Scalars['Date']['input'];
  products?: InputMaybe<Array<InputMaybe<BookerFeeAbsorptionSnapshotProductsInput>>>;
};

export type BookerFeeAbsorptionSnapshotProducts = {
  __typename?: 'BookerFeeAbsorptionSnapshotProducts';
  pricePoints?: Maybe<Array<Maybe<BookerFeeAbsorptionSnapshotProductsPricePoints>>>;
  productId: Scalars['String']['output'];
};

export type BookerFeeAbsorptionSnapshotProductsInput = {
  pricePoints?: InputMaybe<Array<InputMaybe<BookerFeeAbsorptionSnapshotProductsPricePointsInput>>>;
  productId: Scalars['String']['input'];
};

export type BookerFeeAbsorptionSnapshotProductsPricePoints = {
  __typename?: 'BookerFeeAbsorptionSnapshotProductsPricePoints';
  after: Scalars['Float']['output'];
  before: Scalars['Float']['output'];
  path: Scalars['String']['output'];
};

export type BookerFeeAbsorptionSnapshotProductsPricePointsInput = {
  after: Scalars['Float']['input'];
  before: Scalars['Float']['input'];
  path: Scalars['String']['input'];
};

export type BookerFulfillmentOptions = {
  __typename?: 'BookerFulfillmentOptions';
  pickupEnabled: Scalars['Boolean']['output'];
  pickupLocations?: Maybe<Array<PickupLocationOption>>;
  shippingEnabled: Scalars['Boolean']['output'];
  shippingZones?: Maybe<Array<ShippingZoneOption>>;
};

export type OrderPaymentMetadata = {
  __typename?: 'OrderPaymentMetadata';
  acceptedPaymentMethods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  applicationPercentage?: Maybe<Scalars['Float']['output']>;
  applicationPercentageFollowsDefault?: Maybe<Scalars['Boolean']['output']>;
  bankTransferInstructions?: Maybe<Scalars['String']['output']>;
  connectedAccountId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerApplicationPercentage?: Maybe<Scalars['Float']['output']>;
  depositSettings?: Maybe<DepositSettings>;
  feeAbsorption?: Maybe<OrderPaymentMetadataFeeAbsorption>;
  offerTaxExemption?: Maybe<Scalars['Boolean']['output']>;
  optionalCardPostalCode?: Maybe<Scalars['Boolean']['output']>;
  securityDepositSettings?: Maybe<SecurityDepositSettings>;
  stripeRegion?: Maybe<EnumOrderPaymentMetadataStripeRegion>;
  tax?: Maybe<Tax>;
};

export type OrderPaymentMetadataFeeAbsorption = {
  __typename?: 'OrderPaymentMetadataFeeAbsorption';
  roundingIncrementCents?: Maybe<Scalars['Float']['output']>;
  showBreakdownInCheckout?: Maybe<Scalars['Boolean']['output']>;
  stripeFixedCents?: Maybe<Scalars['Float']['output']>;
  stripePercent?: Maybe<Scalars['Float']['output']>;
};

export type OrderPaymentMetadataFeeAbsorptionInput = {
  roundingIncrementCents?: InputMaybe<Scalars['Float']['input']>;
  showBreakdownInCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  stripeFixedCents?: InputMaybe<Scalars['Float']['input']>;
  stripePercent?: InputMaybe<Scalars['Float']['input']>;
};

export type OrderPaymentMetadataInput = {
  acceptedPaymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  applicationPercentage?: InputMaybe<Scalars['Float']['input']>;
  applicationPercentageFollowsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  bankTransferInstructions?: InputMaybe<Scalars['String']['input']>;
  connectedAccountId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customerApplicationPercentage?: InputMaybe<Scalars['Float']['input']>;
  depositSettings?: InputMaybe<DepositSettingsInput>;
  feeAbsorption?: InputMaybe<OrderPaymentMetadataFeeAbsorptionInput>;
  offerTaxExemption?: InputMaybe<Scalars['Boolean']['input']>;
  optionalCardPostalCode?: InputMaybe<Scalars['Boolean']['input']>;
  securityDepositSettings?: InputMaybe<SecurityDepositSettingsInput>;
  stripeRegion?: InputMaybe<EnumOrderPaymentMetadataStripeRegion>;
  tax?: InputMaybe<Scalars['MongoID']['input']>;
};

export type BookerPaymentTiming = {
  __typename?: 'BookerPaymentTiming';
  afterServiceOffsetDays?: Maybe<Scalars['Float']['output']>;
  consolidation?: Maybe<EnumBookerPaymentTimingConsolidation>;
  invoiceDueDays?: Maybe<Scalars['Float']['output']>;
  timing?: Maybe<EnumBookerPaymentTimingTiming>;
};

export type BookerPaymentTimingInput = {
  afterServiceOffsetDays?: InputMaybe<Scalars['Float']['input']>;
  consolidation?: InputMaybe<EnumBookerPaymentTimingConsolidation>;
  invoiceDueDays?: InputMaybe<Scalars['Float']['input']>;
  timing?: InputMaybe<EnumBookerPaymentTimingTiming>;
};

export type BookerPromoCodeTagOverrides = {
  __typename?: 'BookerPromoCodeTagOverrides';
  discountId: Scalars['MongoID']['output'];
  mode: EnumBookerPromoCodeTagOverridesMode;
  tagId: Scalars['MongoID']['output'];
};

export type BookerPromoCodeTagOverridesInput = {
  discountId: Scalars['MongoID']['input'];
  mode: EnumBookerPromoCodeTagOverridesMode;
  tagId: Scalars['MongoID']['input'];
};

export type BookerRenewalSettings = {
  __typename?: 'BookerRenewalSettings';
  renewalMode?: Maybe<EnumBookerRenewalSettingsRenewalMode>;
  renewalReminderDaysBefore?: Maybe<Scalars['Float']['output']>;
  requireApproval?: Maybe<Scalars['Boolean']['output']>;
  sendRenewalReminders?: Maybe<Scalars['Boolean']['output']>;
};

export type BookerRenewalSettingsInput = {
  renewalMode?: InputMaybe<EnumBookerRenewalSettingsRenewalMode>;
  renewalReminderDaysBefore?: InputMaybe<Scalars['Float']['input']>;
  requireApproval?: InputMaybe<Scalars['Boolean']['input']>;
  sendRenewalReminders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BookerTagDiscountSettings = {
  __typename?: 'BookerTagDiscountSettings';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  rules?: Maybe<Array<Maybe<BookerTagDiscountSettingsRules>>>;
};

export type BookerTagDiscountSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<Array<InputMaybe<BookerTagDiscountSettingsRulesInput>>>;
};

export type BookerTagDiscountSettingsRules = {
  __typename?: 'BookerTagDiscountSettingsRules';
  amount?: Maybe<Scalars['Float']['output']>;
  discountType: EnumBookerTagDiscountSettingsRulesDiscountType;
  tag: Scalars['MongoID']['output'];
};

export type BookerTagDiscountSettingsRulesInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  discountType: EnumBookerTagDiscountSettingsRulesDiscountType;
  tag: Scalars['MongoID']['input'];
};

export type BooleanHoursOfOperation = {
  fri?: InputMaybe<Scalars['Boolean']['input']>;
  mon?: InputMaybe<Scalars['Boolean']['input']>;
  sat?: InputMaybe<Scalars['Boolean']['input']>;
  sun?: InputMaybe<Scalars['Boolean']['input']>;
  thu?: InputMaybe<Scalars['Boolean']['input']>;
  tue?: InputMaybe<Scalars['Boolean']['input']>;
  wed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BooleanLinks = {
  bookNow?: InputMaybe<Scalars['Boolean']['input']>;
  facebook?: InputMaybe<Scalars['Boolean']['input']>;
  googleMyBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  instagram?: InputMaybe<Scalars['Boolean']['input']>;
  otherUrls?: InputMaybe<Scalars['Boolean']['input']>;
  pinterest?: InputMaybe<Scalars['Boolean']['input']>;
  tiktok?: InputMaybe<Scalars['Boolean']['input']>;
  tripAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['Boolean']['input']>;
  x?: InputMaybe<Scalars['Boolean']['input']>;
  youtube?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BooleanSeasonality = {
  apr?: InputMaybe<Scalars['Boolean']['input']>;
  aug?: InputMaybe<Scalars['Boolean']['input']>;
  dec?: InputMaybe<Scalars['Boolean']['input']>;
  feb?: InputMaybe<Scalars['Boolean']['input']>;
  jan?: InputMaybe<Scalars['Boolean']['input']>;
  jul?: InputMaybe<Scalars['Boolean']['input']>;
  jun?: InputMaybe<Scalars['Boolean']['input']>;
  mar?: InputMaybe<Scalars['Boolean']['input']>;
  may?: InputMaybe<Scalars['Boolean']['input']>;
  nov?: InputMaybe<Scalars['Boolean']['input']>;
  oct?: InputMaybe<Scalars['Boolean']['input']>;
  sep?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Broadcast = {
  __typename?: 'Broadcast';
  _id: Scalars['MongoID']['output'];
  coverImage?: Maybe<AssetImage>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Multilingual>;
  isTemplate: Scalars['Boolean']['output'];
  name: Multilingual;
  owner: Owner;
  publicName?: Maybe<Multilingual>;
  resources: Array<Maybe<BroadcastResources>>;
  sharedTo?: Maybe<BroadcastSharedTo>;
  status: EnumBroadcastStatus;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type BroadcastAllStatsItem = {
  __typename?: 'BroadcastAllStatsItem';
  broadcastId: Scalars['ID']['output'];
  name: Multilingual;
  ownerName: Scalars['String']['output'];
  ownerType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalCompletions: Scalars['Int']['output'];
  totalResources: Scalars['Int']['output'];
  totalViews: Scalars['Int']['output'];
};

export type BroadcastAllStatsResult = {
  __typename?: 'BroadcastAllStatsResult';
  items: Array<BroadcastAllStatsItem>;
  totalCount: Scalars['Int']['output'];
};

export type BroadcastCloneInput = {
  broadcastId: Scalars['MongoID']['input'];
  targetOwner: OwnerInput;
};

export type BroadcastResourceStats = {
  __typename?: 'BroadcastResourceStats';
  completedPeople: Array<SimplePersonTc>;
  downloadedPeople: Array<SimplePersonTc>;
  inProgressPeople: Array<SimplePersonTc>;
  playedPeople: Array<SimplePersonTc>;
  resourceId: Scalars['ID']['output'];
  totalDownloads: Scalars['Int']['output'];
  totalPlays: Scalars['Int']['output'];
  totalViews: Scalars['Int']['output'];
  viewedPeople: Array<SimplePersonTc>;
};

export type BroadcastResourceViewedStats = {
  __typename?: 'BroadcastResourceViewedStats';
  completed: Scalars['Boolean']['output'];
  downloaded: Scalars['Boolean']['output'];
  inProgress: Scalars['Boolean']['output'];
  played: Scalars['Boolean']['output'];
  resourceId: Scalars['ID']['output'];
  viewed: Scalars['Boolean']['output'];
};

export type BroadcastResources = {
  __typename?: 'BroadcastResources';
  _id?: Maybe<Scalars['MongoID']['output']>;
  allowResubmission?: Maybe<Scalars['Boolean']['output']>;
  allowSaveAndEdit?: Maybe<Scalars['Boolean']['output']>;
  booker?: Maybe<Booker>;
  completionTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  course?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<AssetImage>;
  ctaLabel?: Maybe<Multilingual>;
  description?: Maybe<Multilingual>;
  expirationTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<AssetFile>;
  formMode?: Maybe<EnumBroadcastResourcesFormMode>;
  iframeUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Multilingual>;
  paymentRequestId?: Maybe<Scalars['MongoID']['output']>;
  photos: Array<AssetImage>;
  requireApproval?: Maybe<Scalars['Boolean']['output']>;
  submissionTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  survey?: Maybe<Survey>;
  teamVisible?: Maybe<Scalars['Boolean']['output']>;
  title: Multilingual;
  type: EnumBroadcastResourcesType;
  video?: Maybe<AssetImage>;
  videoURL?: Maybe<Scalars['String']['output']>;
};

export type BroadcastResourcesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  allowResubmission?: InputMaybe<Scalars['Boolean']['input']>;
  allowSaveAndEdit?: InputMaybe<Scalars['Boolean']['input']>;
  booker?: InputMaybe<Scalars['MongoID']['input']>;
  completionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  course?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<MultilingualInput>;
  description?: InputMaybe<MultilingualInput>;
  expirationTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  file?: InputMaybe<Scalars['String']['input']>;
  formMode?: InputMaybe<EnumBroadcastResourcesFormMode>;
  iframeUrl?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<MultilingualInput>;
  paymentRequestId?: InputMaybe<Scalars['MongoID']['input']>;
  photos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requireApproval?: InputMaybe<Scalars['Boolean']['input']>;
  submissionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  survey?: InputMaybe<Scalars['String']['input']>;
  teamVisible?: InputMaybe<Scalars['Boolean']['input']>;
  title: MultilingualInput;
  type: EnumBroadcastResourcesType;
  video?: InputMaybe<Scalars['String']['input']>;
  videoURL?: InputMaybe<Scalars['String']['input']>;
};

export type BroadcastSharedTo = {
  __typename?: 'BroadcastSharedTo';
  operatorsOnly?: Maybe<Scalars['Boolean']['output']>;
  sentToPeople: Array<Maybe<Scalars['MongoID']['output']>>;
  sentToPeopleSystemRoles?: Maybe<Array<Maybe<EnumBroadcastSharedToSentToPeopleSystemRoles>>>;
  sentToPeopleTags?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  skipEmails?: Maybe<Scalars['Boolean']['output']>;
  teaser?: Maybe<BroadcastSharedToTeaser>;
  type: EnumBroadcastSharedToType;
};

export type BroadcastSharedToInput = {
  operatorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sentToPeople: Array<InputMaybe<Scalars['MongoID']['input']>>;
  sentToPeopleSystemRoles?: InputMaybe<Array<InputMaybe<EnumBroadcastSharedToSentToPeopleSystemRoles>>>;
  sentToPeopleTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  skipEmails?: InputMaybe<Scalars['Boolean']['input']>;
  teaser?: InputMaybe<BroadcastSharedToTeaserInput>;
  type: EnumBroadcastSharedToType;
};

export type BroadcastSharedToTeaser = {
  __typename?: 'BroadcastSharedToTeaser';
  description?: Maybe<Multilingual>;
  enabled: Scalars['Boolean']['output'];
};

export type BroadcastSharedToTeaserInput = {
  description?: InputMaybe<MultilingualInput>;
  enabled: Scalars['Boolean']['input'];
};

export type BroadcastStats = {
  __typename?: 'BroadcastStats';
  broadcastId: Scalars['ID']['output'];
  resources: Array<BroadcastResourceStats>;
  totalViews: Scalars['Int']['output'];
  viewedPeople: Array<SimplePersonTc>;
};

export type BroadcastStatsForOrganization = {
  __typename?: 'BroadcastStatsForOrganization';
  completions: Scalars['Int']['output'];
  messageViews: Scalars['Int']['output'];
  pdfDownloads: Scalars['Int']['output'];
  photoViews: Scalars['Int']['output'];
  videoViews: Scalars['Int']['output'];
};

export type BroadcastTeaserResult = {
  __typename?: 'BroadcastTeaserResult';
  description?: Maybe<Scalars['String']['output']>;
};

export type BroadcastViewedStats = {
  __typename?: 'BroadcastViewedStats';
  broadcastId: Scalars['ID']['output'];
  resources: Array<BroadcastResourceViewedStats>;
  viewed: Scalars['Boolean']['output'];
};

export type BroadcastWithOwnerName = {
  __typename?: 'BroadcastWithOwnerName';
  _id: Scalars['MongoID']['output'];
  coverImage?: Maybe<AssetImage>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Multilingual>;
  isTemplate: Scalars['Boolean']['output'];
  name: Multilingual;
  owner: Owner;
  ownerName?: Maybe<Multilingual>;
  publicName?: Maybe<Multilingual>;
  resources: Array<Maybe<BroadcastResources>>;
  sharedTo?: Maybe<BroadcastSharedTo>;
  status: EnumBroadcastStatus;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type BulkConnectLog = {
  __typename?: 'BulkConnectLog';
  _id: Scalars['MongoID']['output'];
  alreadyConnectedCount: Scalars['Float']['output'];
  appliedBackOfficeTagIds: Array<Maybe<Scalars['MongoID']['output']>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  errorCount: Scalars['Float']['output'];
  initiatedByUser: Scalars['MongoID']['output'];
  operatorEntityIds: Array<Maybe<Scalars['String']['output']>>;
  organizationIds: Array<Maybe<Scalars['MongoID']['output']>>;
  results: Array<Maybe<BulkConnectLogResults>>;
  rollbackInfo?: Maybe<BulkConnectLogRollbackInfo>;
  successCount: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type BulkConnectLogResults = {
  __typename?: 'BulkConnectLogResults';
  error?: Maybe<Scalars['String']['output']>;
  operatorEntityId: Scalars['String']['output'];
  operatorName: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  status: EnumBulkConnectLogResultsStatus;
};

export type BulkConnectLogRollbackInfo = {
  __typename?: 'BulkConnectLogRollbackInfo';
  disconnectedCount: Scalars['Float']['output'];
  errorCount: Scalars['Float']['output'];
  errorMessages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rolledBackAt: Scalars['Date']['output'];
  rolledBackBy: Scalars['MongoID']['output'];
};

export type BulkConnectResultInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  operatorEntityId: Scalars['String']['input'];
  operatorName: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type BulkInviteNoContactListing = {
  __typename?: 'BulkInviteNoContactListing';
  entityId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum BulkInviteRecipientMode {
  All = 'ALL',
  Financial = 'FINANCIAL',
  OnePerListing = 'ONE_PER_LISTING',
  Primary = 'PRIMARY'
}

export type BulkInviteTagFilterInput = {
  include?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<BulkInviteTagMatch>;
  tagIds: Array<Scalars['String']['input']>;
};

export enum BulkInviteTagMatch {
  All = 'ALL',
  Any = 'ANY'
}

export enum BulkInviteViewContext {
  AllListings = 'ALL_LISTINGS',
  Draft = 'DRAFT'
}

export type CalendarLinksByProductId = {
  links: Array<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
};

export type Campaign = {
  __typename?: 'Campaign';
  _entityId: Scalars['MongoID']['output'];
  _id: Scalars['MongoID']['output'];
  _versionId: Scalars['MongoID']['output'];
  assets: Array<AssetImage>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  dateRangeISO: DateRangeIso;
  description: Multilingual;
  list: Scalars['MongoID']['output'];
  name: Multilingual;
  owner: Owner;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type CartPrices = {
  __typename?: 'CartPrices';
  customerFee: Scalars['Int']['output'];
  deliveryAvailable?: Maybe<Scalars['Boolean']['output']>;
  depositTotal: Scalars['Int']['output'];
  discountTotal: Scalars['Int']['output'];
  discountTotals: Array<DiscountTotalPerDiscount>;
  grandTotal: Scalars['Int']['output'];
  productPrices: Array<PricePerProduct>;
  promoCodeApplicable?: Maybe<Scalars['Boolean']['output']>;
  shippingTotal?: Maybe<Scalars['Int']['output']>;
  subTotal: Scalars['Int']['output'];
  taxLines: Array<TaxLine>;
  taxTotal: Scalars['Int']['output'];
};

export type Changelog = {
  __typename?: 'Changelog';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  entity: VersionedEntityReference;
  initiatedByUser?: Maybe<UserWithPictureTc>;
  message: Multilingual;
  owner: Owner;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ChangelogPersonDetails = {
  __typename?: 'ChangelogPersonDetails';
  _id: Scalars['ID']['output'];
  changedEntity?: Maybe<VersionedEntityReferenceWithName>;
  changedEntityOwner?: Maybe<OwnerWithName>;
  createdDateISO?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Multilingual>;
};

export type Closure = {
  __typename?: 'Closure';
  _id?: Maybe<Scalars['MongoID']['output']>;
  dateRangeISO: DateRangeIso;
  name: Scalars['String']['output'];
};

export type ClosureData = {
  __typename?: 'ClosureData';
  closure: Closure;
  productIds: Array<Scalars['String']['output']>;
};

export type ClosureInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  dateRangeISO: DateRangeIsoInput;
  name: Scalars['String']['input'];
};

export type Color = {
  __typename?: 'Color';
  _id: Scalars['MongoID']['output'];
  predominance: Scalars['Float']['output'];
  value: Scalars['String']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Links>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneExt?: Maybe<Scalars['String']['output']>;
  tollFreePublicPhone?: Maybe<Scalars['String']['output']>;
};

export type ContactInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<LinksInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  tollFreePublicPhone?: InputMaybe<Scalars['String']['input']>;
};

export enum ContactRole {
  FinancialContact = 'FINANCIAL_CONTACT',
  PrimaryContact = 'PRIMARY_CONTACT'
}

export type ContactUsEmailDetails = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type ContactWithBooleanLinks = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<BooleanLinks>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  tollFreePublicPhone?: InputMaybe<Scalars['String']['input']>;
};

export type CourseProgress = {
  __typename?: 'CourseProgress';
  _id: Scalars['MongoID']['output'];
  broadcast: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['Date']['output']>;
  completionStatus: EnumCourseProgressCompletionStatus;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  firstAccessedAt?: Maybe<Scalars['Date']['output']>;
  lastAccessedAt: Scalars['Date']['output'];
  location?: Maybe<Scalars['String']['output']>;
  progressMeasure?: Maybe<Scalars['Float']['output']>;
  resourceId: Scalars['String']['output'];
  scoreMax?: Maybe<Scalars['Float']['output']>;
  scoreMin?: Maybe<Scalars['Float']['output']>;
  scoreRaw?: Maybe<Scalars['Float']['output']>;
  scoreScaled?: Maybe<Scalars['Float']['output']>;
  scormDataSnapshot?: Maybe<Scalars['JSON']['output']>;
  scormVersion?: Maybe<Scalars['String']['output']>;
  sessionTime?: Maybe<Scalars['String']['output']>;
  successStatus?: Maybe<EnumCourseProgressSuccessStatus>;
  suspendData?: Maybe<Scalars['String']['output']>;
  totalTime?: Maybe<Scalars['String']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  user: Scalars['String']['output'];
};

export type CreateBulkConnectLogInput = {
  alreadyConnectedCount: Scalars['Int']['input'];
  appliedBackOfficeTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  errorCount: Scalars['Int']['input'];
  operatorEntityIds: Array<Scalars['String']['input']>;
  organizationIds: Array<Scalars['String']['input']>;
  results?: InputMaybe<Array<BulkConnectResultInput>>;
  successCount: Scalars['Int']['input'];
  totalCount: Scalars['Int']['input'];
};

export type CreateManyRefundPayload = {
  __typename?: 'CreateManyRefundPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['String']['output']>;
  /** Created documents */
  records?: Maybe<Array<Refund>>;
};

export type CreateManyRuleInput = {
  activePeriod?: InputMaybe<DateRangeIsoInput>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  storefront: Scalars['MongoID']['input'];
  type: EnumRuleType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  value: Scalars['JSON']['input'];
};

export type CreateManyRulePayload = {
  __typename?: 'CreateManyRulePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Rule>>;
};

export type CreateManySurveyQuestionInput = {
  businessScope?: InputMaybe<EnumSurveyQuestionBusinessScope>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<MultilingualInput>;
  isActive: Scalars['Boolean']['input'];
  name: MultilingualInput;
  options?: InputMaybe<Array<InputMaybe<SurveyQuestionOptionsInput>>>;
  owner: OwnerInput;
  parentQuestion?: InputMaybe<Scalars['MongoID']['input']>;
  required: Scalars['Boolean']['input'];
  type: EnumSurveyQuestionType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  whereaboutsSearchEntityType?: InputMaybe<EnumSurveyQuestionWhereaboutsSearchEntityType>;
};

export type CreateManySurveyQuestionPayload = {
  __typename?: 'CreateManySurveyQuestionPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<SurveyQuestion>>;
};

export type CreateManyTagGroupInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  key: EnumTagGroupKey;
  name: MultilingualInput;
  type: EnumTagGroupType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyTagGroupPayload = {
  __typename?: 'CreateManyTagGroupPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<TagGroup>>;
};

export type CreateManyTagInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  embedding?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  engineOwnedRole?: InputMaybe<EnumTagEngineOwnedRole>;
  entityTypes: Array<InputMaybe<EnumTagEntityTypes>>;
  inheritable?: InputMaybe<Scalars['Boolean']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name: MultilingualInput;
  owner?: InputMaybe<OwnerInput>;
  tagGroup: Scalars['MongoID']['input'];
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  usage?: InputMaybe<TagUsageInput>;
};

export type CreateManyTagPayload = {
  __typename?: 'CreateManyTagPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Tag>>;
};

export type CreateOneActivityLogInput = {
  bulkConnectLogId?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  emailActivity?: InputMaybe<ActivityLogEmailActivityInput>;
  entity: EntityReferenceInput;
  entityName: MultilingualInput;
  importRunId?: InputMaybe<Scalars['MongoID']['input']>;
  initiatedBy: Scalars['String']['input'];
  initiatedByPerson?: InputMaybe<Scalars['MongoID']['input']>;
  initiatedByUser?: InputMaybe<Scalars['MongoID']['input']>;
  message: MultilingualInput;
  owner: OwnerInput;
  resourceId?: InputMaybe<Scalars['MongoID']['input']>;
  surveyResponseId?: InputMaybe<Scalars['MongoID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type: EnumActivityLogType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneActivityLogPayload = {
  __typename?: 'CreateOneActivityLogPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ActivityLog>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneAnalyticsDashboardInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  dashboardId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sortOrder: Scalars['Float']['input'];
  updatedBy: Scalars['MongoID']['input'];
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneAnalyticsDashboardPayload = {
  __typename?: 'CreateOneAnalyticsDashboardPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<AnalyticsDashboard>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneApiAccessPayload = {
  __typename?: 'CreateOneApiAccessPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ApiAccess>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneBookerInput = {
  approvalSettings?: InputMaybe<BookerApprovalSettingsInput>;
  bundles?: InputMaybe<Array<InputMaybe<BookerBundlesInput>>>;
  businessCompletionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  completionScreen?: InputMaybe<BookerCompletionScreenInput>;
  completionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customerFields?: InputMaybe<BookerCustomerFieldsInput>;
  customizations?: InputMaybe<BookerCustomizationsInput>;
  discountScopes?: InputMaybe<Array<InputMaybe<BookerDiscountScopesInput>>>;
  discounts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  eligibility?: InputMaybe<BookerEligibilityInput>;
  emailTemplates?: InputMaybe<Array<InputMaybe<BookerEmailTemplatesInput>>>;
  feeAbsorptionSnapshot?: InputMaybe<BookerFeeAbsorptionSnapshotInput>;
  fulfillmentProfile?: InputMaybe<Scalars['MongoID']['input']>;
  isInvoiceTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name: MultilingualInput;
  paymentMetadata?: InputMaybe<OrderPaymentMetadataInput>;
  paymentMethodSet?: InputMaybe<Scalars['MongoID']['input']>;
  paymentTiming?: InputMaybe<BookerPaymentTimingInput>;
  policies?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  promoCodeTagOverrides?: InputMaybe<Array<InputMaybe<BookerPromoCodeTagOverridesInput>>>;
  publiclyPublishable?: InputMaybe<Scalars['Boolean']['input']>;
  renewalSettings?: InputMaybe<BookerRenewalSettingsInput>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  status?: InputMaybe<EnumBookerStatus>;
  statusNotification?: InputMaybe<MultilingualInput>;
  storefront: Scalars['MongoID']['input'];
  survey?: InputMaybe<Scalars['MongoID']['input']>;
  surveyInline?: InputMaybe<Scalars['Boolean']['input']>;
  tagDiscountSettings?: InputMaybe<BookerTagDiscountSettingsInput>;
  teamVisible?: InputMaybe<Scalars['Boolean']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  waivers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateOneBookerPayload = {
  __typename?: 'CreateOneBookerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Booker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneBroadcastInput = {
  coverImage?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<MultilingualInput>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name: MultilingualInput;
  owner: OwnerInput;
  publicName?: InputMaybe<MultilingualInput>;
  resources?: InputMaybe<Array<InputMaybe<BroadcastResourcesInput>>>;
  sharedTo?: InputMaybe<BroadcastSharedToInput>;
  status: EnumBroadcastStatus;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneBroadcastPayload = {
  __typename?: 'CreateOneBroadcastPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Broadcast>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneDiscountInput = {
  amount: Scalars['Float']['input'];
  buyQuantity?: InputMaybe<Scalars['Float']['input']>;
  canCombine?: InputMaybe<Scalars['Boolean']['input']>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  currentUsageCount?: InputMaybe<Scalars['Float']['input']>;
  daysInAdvance?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<MultilingualInput>;
  discountActivePeriod?: InputMaybe<DateRangeIsoOptionalInput>;
  excludeUpsells?: InputMaybe<Scalars['Boolean']['input']>;
  getQuantity?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isOngoing?: InputMaybe<Scalars['Boolean']['input']>;
  maxDaysInAdvance?: InputMaybe<Scalars['Float']['input']>;
  maxNights?: InputMaybe<Scalars['Float']['input']>;
  maxUsageCount?: InputMaybe<Scalars['Float']['input']>;
  minGuestCount?: InputMaybe<Scalars['Float']['input']>;
  minNights?: InputMaybe<Scalars['Float']['input']>;
  minQuantity?: InputMaybe<Scalars['Float']['input']>;
  minSubtotal?: InputMaybe<Scalars['Float']['input']>;
  name: MultilingualInput;
  perTicket?: InputMaybe<Scalars['Boolean']['input']>;
  perTicketApplyFrom?: InputMaybe<Scalars['Float']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  storefront: Scalars['MongoID']['input'];
  type: EnumDiscountType;
  unit: EnumDiscountUnit;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneDiscountPayload = {
  __typename?: 'CreateOneDiscountPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Discount>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneEventInput = {
  access: EventAccessInput;
  attentionIssues?: InputMaybe<Array<InputMaybe<EventAttentionIssuesInput>>>;
  contact?: InputMaybe<ContactInput>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  createdByEmail: Scalars['String']['input'];
  createdByFirstName?: InputMaybe<Scalars['String']['input']>;
  createdByLastName?: InputMaybe<Scalars['String']['input']>;
  createdByPerson?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  /** Set when event is created via import; events with this set are excluded from daily digest notification emails */
  createdViaImportRunId?: InputMaybe<Scalars['MongoID']['input']>;
  description: MultilingualInput;
  duplicateDismissedAt?: InputMaybe<Scalars['Date']['input']>;
  duplicateDismissedBy?: InputMaybe<Scalars['MongoID']['input']>;
  /** The end date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventLocation?: InputMaybe<EventLocationInput>;
  eventLocations?: InputMaybe<Array<InputMaybe<EventLocationInput>>>;
  eventOrganizer: EventLocationInput;
  history?: InputMaybe<Array<InputMaybe<EventHistoryInput>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationType?: InputMaybe<EnumEventLocationType>;
  otherLocations?: InputMaybe<Array<InputMaybe<EventLocationInput>>>;
  presentedBy?: InputMaybe<MultilingualInput>;
  price?: InputMaybe<Scalars['String']['input']>;
  recurrencePattern: EventRecurrencePatternInput;
  schedules: Array<InputMaybe<EventSchedulesInput>>;
  /** The start date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  startDate: Scalars['String']['input'];
  /** Who created the event (GUEST/OPERATOR/ORGANIZATION), derived server-side at create time. Used to exclude operator-sourced drafts from an organization's Events app. */
  submissionSource?: InputMaybe<EnumEventSubmissionSource>;
  suspectedDuplicateOf?: InputMaybe<Scalars['MongoID']['input']>;
  tags?: InputMaybe<EventTagsInput>;
  ticketUrl?: InputMaybe<Scalars['String']['input']>;
  title: MultilingualInput;
  type: EnumEventType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  venue?: InputMaybe<MultilingualInput>;
};

export type CreateOneEventPayload = {
  __typename?: 'CreateOneEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Event>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneFulfillmentProfileInput = {
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pickup?: InputMaybe<FulfillmentProfilePickupInput>;
  shipping?: InputMaybe<FulfillmentProfileShippingInput>;
  storefront: Scalars['MongoID']['input'];
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneFulfillmentProfilePayload = {
  __typename?: 'CreateOneFulfillmentProfilePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<FulfillmentProfile>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneImportInput = {
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  googleSheetsConfig: ImportGoogleSheetsConfigInput;
  importType: EnumImportImportType;
  name: Scalars['String']['input'];
  organization: Scalars['MongoID']['input'];
  status?: InputMaybe<EnumImportStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneImportPayload = {
  __typename?: 'CreateOneImportPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Import>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneImportScrapeInput = {
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  googleSheetsConfig?: InputMaybe<ImportScrapeGoogleSheetsConfigInput>;
  maxRows?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  scraperPrompt?: InputMaybe<Scalars['String']['input']>;
  sitemapEntries?: InputMaybe<Array<InputMaybe<ImportScrapeSitemapEntriesInput>>>;
  sitemapRevision?: InputMaybe<Scalars['Float']['input']>;
  sitemapUrlCount?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<EnumImportScrapeStatus>;
  targetOrganization?: InputMaybe<Scalars['MongoID']['input']>;
  typeOfData: EnumImportScrapeTypeOfData;
  typeOfScrape: EnumImportScrapeTypeOfScrape;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneImportScrapePayload = {
  __typename?: 'CreateOneImportScrapePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ImportScrape>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneInventoryItemInput = {
  claimedDateRangesISO?: InputMaybe<Array<InputMaybe<DateRangeIsoInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  product: Scalars['MongoID']['input'];
  type: EnumInventoryItemType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneInventoryItemPayload = {
  __typename?: 'CreateOneInventoryItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<InventoryItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneItineraryInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<MultilingualInput>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  isLoop: Scalars['Boolean']['input'];
  lastEditedBy?: InputMaybe<Scalars['MongoID']['input']>;
  moreInfoLink?: InputMaybe<Scalars['String']['input']>;
  name: MultilingualInput;
  organization: Scalars['MongoID']['input'];
  owner: OwnerInput;
  published?: InputMaybe<ItineraryPublishedInput>;
  routeDistance?: InputMaybe<Scalars['Float']['input']>;
  routeDuration?: InputMaybe<Scalars['Float']['input']>;
  routePath?: InputMaybe<Scalars['JSON']['input']>;
  routeStatus: EnumItineraryRouteStatus;
  segments?: InputMaybe<Array<InputMaybe<ItinerarySegmentsInput>>>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status: EnumItineraryStatus;
  trailPlace?: InputMaybe<Scalars['MongoID']['input']>;
  travelType: EnumItineraryTravelType;
  tripperSettings?: InputMaybe<ItineraryTripperSettingsInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneItineraryPayload = {
  __typename?: 'CreateOneItineraryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Itinerary>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneListInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  audienceListKey?: InputMaybe<EnumListAudienceListKey>;
  audienceTagId?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description: MultilingualInput;
  entityReferences: Array<InputMaybe<VersionedEntityReferenceInput>>;
  externallyAvailableEntityReferences?: InputMaybe<Array<InputMaybe<VersionedEntityReferenceInput>>>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  filterTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  kind: EnumListKind;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  lockedAt?: InputMaybe<Scalars['Date']['input']>;
  lockedBy?: InputMaybe<Scalars['MongoID']['input']>;
  lockedByName?: InputMaybe<Scalars['String']['input']>;
  memberListKey?: InputMaybe<EnumListMemberListKey>;
  name: MultilingualInput;
  orderIndex?: InputMaybe<Scalars['Float']['input']>;
  owner: OwnerInput;
  selections: Scalars['JSON']['input'];
  tierTagId?: InputMaybe<Scalars['MongoID']['input']>;
  type: EnumListType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneListPayload = {
  __typename?: 'CreateOneListPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<List>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNoteInput = {
  author: Scalars['MongoID']['input'];
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entity: EntityReferenceInput;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<EnumNoteKind>;
  mentions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  message: Scalars['String']['input'];
  noteDateISO?: InputMaybe<Scalars['String']['input']>;
  owner: OwnerInput;
  resolvedBy?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneNotePayload = {
  __typename?: 'CreateOneNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Note>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneOperatorInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  accommodationMetadata?: InputMaybe<AccommodationOperatorMetadataInput>;
  avgImageQuality?: InputMaybe<EnumOperatorAvgImageQuality>;
  canonicalDocument?: InputMaybe<Scalars['String']['input']>;
  claimed: Scalars['Boolean']['input'];
  connectedOrganization?: InputMaybe<Scalars['MongoID']['input']>;
  contact: ContactInput;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<MultilingualInput>;
  enableMembershipLink?: InputMaybe<Scalars['Boolean']['input']>;
  enrollments: Array<InputMaybe<OperatorEnrollmentsInput>>;
  experienceMetadata?: InputMaybe<ExperienceOperatorMetadataInput>;
  externalVideoLinks?: InputMaybe<Array<InputMaybe<OperatorExternalVideoLinksInput>>>;
  hoursOfOperation?: InputMaybe<OperatorHoursOfOperationInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  import?: InputMaybe<Scalars['JSON']['input']>;
  name: MultilingualInput;
  operationalStatus?: InputMaybe<EnumOperatorOperationalStatus>;
  pricing?: InputMaybe<EnumOperatorPricing>;
  restaurantMetadata?: InputMaybe<RestaurantOperatorMetadataInput>;
  searchName?: InputMaybe<MultilingualInput>;
  seasonality?: InputMaybe<SeasonalityInput>;
  selectedTagGroups?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  serviceMetadata?: InputMaybe<ServiceOperatorMetadataInput>;
  shortDescription?: InputMaybe<MultilingualInput>;
  tags?: InputMaybe<OperatorTagsInput>;
  toursMetadata?: InputMaybe<ToursOperatorMetadataInput>;
  type: EnumOperatorType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  whereabotDismissed?: InputMaybe<OperatorWhereabotDismissedInput>;
};

export type CreateOneOperatorPayload = {
  __typename?: 'CreateOneOperatorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Operator>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneOrderPayload = {
  __typename?: 'CreateOneOrderPayload';
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Order>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type CreateOneOrganizationInput = {
  appSettings?: InputMaybe<OrganizationAppSettingsInput>;
  brandColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<ContactInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<MultilingualInput>;
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailBranding?: InputMaybe<OrganizationEmailBrandingInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  license?: InputMaybe<OrganizationLicenseInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<OrganizationMetadataInput>;
  name: MultilingualInput;
  onboardingMetadata: OrganizationOnboardingMetadataInput;
  shortDescription?: InputMaybe<MultilingualInput>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneOrganizationPayload = {
  __typename?: 'CreateOneOrganizationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Organization>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePaymentMethodSetInput = {
  acceptedPaymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bankTransferInstructions?: InputMaybe<Scalars['String']['input']>;
  checkoutDescription?: InputMaybe<Scalars['String']['input']>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  methodLabels?: InputMaybe<PaymentMethodSetMethodLabelsInput>;
  name: Scalars['String']['input'];
  offlinePaymentInstructions?: InputMaybe<Scalars['String']['input']>;
  storefront: Scalars['MongoID']['input'];
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePaymentMethodSetPayload = {
  __typename?: 'CreateOnePaymentMethodSetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PaymentMethodSet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePeopleInput = {
  address?: InputMaybe<AddressInput>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  contactMethod?: InputMaybe<EnumPeopleContactMethod>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  emailLower?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  faxExt?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  import?: InputMaybe<Scalars['JSON']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leads?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  mailingAddress?: InputMaybe<AddressInput>;
  optInEmail?: InputMaybe<Scalars['Boolean']['input']>;
  optInFax?: InputMaybe<Scalars['Boolean']['input']>;
  optInPhone?: InputMaybe<Scalars['Boolean']['input']>;
  optInSMS?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photoUploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTitle?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  visibleTo?: InputMaybe<Array<InputMaybe<PeopleVisibleToInput>>>;
};

export type CreateOnePlaceInput = {
  connectedDmoListing?: InputMaybe<Scalars['MongoID']['input']>;
  connectedListing?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name: MultilingualInput;
  outline?: InputMaybe<PlaceOutlineInput>;
  outlineSimplified?: InputMaybe<PlaceOutlineInput>;
  parentPlace?: InputMaybe<Scalars['MongoID']['input']>;
  subPlaces?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type: EnumPlaceType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePlacePayload = {
  __typename?: 'CreateOnePlacePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Place>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePolicyInput = {
  content: MultilingualInput;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: MultilingualInput;
  storefront: Scalars['MongoID']['input'];
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePolicyPayload = {
  __typename?: 'CreateOnePolicyPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Policy>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProductInput = {
  accommodationMetadata?: InputMaybe<AccommodationProductMetadataInput>;
  addOnSettings?: InputMaybe<ProductAddOnSettingsInput>;
  contact?: InputMaybe<ProductContactInput>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<ProductCustomFieldsInput>>>;
  description?: InputMaybe<MultilingualInput>;
  eventMetadata?: InputMaybe<ProductEventMetadataInput>;
  externalBookingUrl?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inventorySettings?: InputMaybe<ProductTierInventoryInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isUpsellOnly: Scalars['Boolean']['input'];
  merchMetadata?: InputMaybe<MerchMetadataInput>;
  name: MultilingualInput;
  owner: OwnerInput;
  pricing?: InputMaybe<PricingInput>;
  productTiers?: InputMaybe<Array<InputMaybe<ProductTierInput>>>;
  publicationStatus: EnumProductPublicationStatus;
  quantitySettings?: InputMaybe<ProductTierQuantityInput>;
  renewableFeeMetadata?: InputMaybe<RenewableFeeMetadataInput>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  sellingConfig?: InputMaybe<ProductSellingConfigInput>;
  shortDescription?: InputMaybe<MultilingualInput>;
  storefront: Scalars['MongoID']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type: EnumProductType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneProductPayload = {
  __typename?: 'CreateOneProductPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Product>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePromotionInput = {
  access: PromotionAccessInput;
  availability: PromotionAvailabilityInput;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  createdByEmail: Scalars['String']['input'];
  createdByFirstName?: InputMaybe<Scalars['String']['input']>;
  createdByLastName?: InputMaybe<Scalars['String']['input']>;
  createdByPerson?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description: MultilingualInput;
  firstDate?: InputMaybe<Scalars['String']['input']>;
  history?: InputMaybe<Array<InputMaybe<PromotionHistoryInput>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastDate?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  /** Who created the promotion (OPERATOR/ORGANIZATION), derived server-side at create time. */
  submissionSource?: InputMaybe<EnumPromotionSubmissionSource>;
  tags?: InputMaybe<PromotionTagsInput>;
  title: MultilingualInput;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePromotionPayload = {
  __typename?: 'CreateOnePromotionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Promotion>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePublicationStatusInput = {
  changeSummary?: InputMaybe<Scalars['String']['input']>;
  consolidatedChangeSummary?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entity: VersionedEntityReferenceInput;
  isStale?: InputMaybe<Scalars['Boolean']['input']>;
  organization: Scalars['MongoID']['input'];
  status: EnumPublicationStatusStatus;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePublicationStatusPayload = {
  __typename?: 'CreateOnePublicationStatusPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PublicationStatus>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneRuleInput = {
  activePeriod?: InputMaybe<DateRangeIsoInput>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  storefront: Scalars['MongoID']['input'];
  type: EnumRuleType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  value: Scalars['JSON']['input'];
};

export type CreateOneRulePayload = {
  __typename?: 'CreateOneRulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Rule>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneStorefrontInput = {
  accountingCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  applicationFeeDefaults?: InputMaybe<StorefrontApplicationFeeDefaultsInput>;
  applicationPercentage?: InputMaybe<Scalars['Float']['input']>;
  connectedAccountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  connectedListings?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  connectedListingsConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customProductNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultInvoicePolicy?: InputMaybe<Scalars['MongoID']['input']>;
  defaultWidgetLogo?: InputMaybe<Scalars['String']['input']>;
  emailBranding?: InputMaybe<StorefrontEmailBrandingInput>;
  enabledFeeTypes?: InputMaybe<StorefrontEnabledFeeTypesInput>;
  invoiceTemplateBooker?: InputMaybe<Scalars['MongoID']['input']>;
  invoicingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLowStockDigestKey?: InputMaybe<Scalars['String']['input']>;
  launchedAt?: InputMaybe<Scalars['Date']['input']>;
  liveStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  lowStockDigestEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: MultilingualInput;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  paymentsMode?: InputMaybe<EnumStorefrontPaymentsMode>;
  siteMetadata?: InputMaybe<StorefrontSiteMetadataInput>;
  statementSettings?: InputMaybe<StorefrontStatementSettingsInput>;
  stripeRegion?: InputMaybe<EnumStorefrontStripeRegion>;
  testMode?: InputMaybe<Scalars['Boolean']['input']>;
  testStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneStorefrontPayload = {
  __typename?: 'CreateOneStorefrontPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Storefront>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSurveyInput = {
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name: MultilingualInput;
  owner: OwnerInput;
  questions: Array<InputMaybe<Scalars['MongoID']['input']>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneSurveyPayload = {
  __typename?: 'CreateOneSurveyPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Survey>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSurveyQuestionInput = {
  businessScope?: InputMaybe<EnumSurveyQuestionBusinessScope>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<MultilingualInput>;
  isActive: Scalars['Boolean']['input'];
  name: MultilingualInput;
  options?: InputMaybe<Array<InputMaybe<SurveyQuestionOptionsInput>>>;
  owner: OwnerInput;
  parentQuestion?: InputMaybe<Scalars['MongoID']['input']>;
  required: Scalars['Boolean']['input'];
  type: EnumSurveyQuestionType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  whereaboutsSearchEntityType?: InputMaybe<EnumSurveyQuestionWhereaboutsSearchEntityType>;
};

export type CreateOneSurveyQuestionPayload = {
  __typename?: 'CreateOneSurveyQuestionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SurveyQuestion>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSurveyResponseInput = {
  adminStatus?: InputMaybe<EnumSurveyResponseAdminStatus>;
  broadcast?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  history?: InputMaybe<Array<InputMaybe<SurveyResponseHistoryInput>>>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  ownerMetadata?: InputMaybe<SurveyResponseOwnerMetadataInput>;
  person?: InputMaybe<Scalars['MongoID']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  responses: Array<InputMaybe<SurveyResponseResponsesInput>>;
  reviewStatus?: InputMaybe<EnumSurveyResponseReviewStatus>;
  status?: InputMaybe<EnumSurveyResponseStatus>;
  submissionIndex?: InputMaybe<Scalars['Float']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  survey: Scalars['MongoID']['input'];
  surveyUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
  widget?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneSurveyResponsePayload = {
  __typename?: 'CreateOneSurveyResponsePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<SurveyResponse>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTagGroupInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  key: EnumTagGroupKey;
  name: MultilingualInput;
  type: EnumTagGroupType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneTagGroupPayload = {
  __typename?: 'CreateOneTagGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TagGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTagInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  embedding?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  engineOwnedRole?: InputMaybe<EnumTagEngineOwnedRole>;
  entityTypes: Array<InputMaybe<EnumTagEntityTypes>>;
  inheritable?: InputMaybe<Scalars['Boolean']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name: MultilingualInput;
  owner?: InputMaybe<OwnerInput>;
  tagGroup: Scalars['MongoID']['input'];
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  usage?: InputMaybe<TagUsageInput>;
};

export type CreateOneTagPayload = {
  __typename?: 'CreateOneTagPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Tag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTagRelationshipInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  generatedBy: EnumTagRelationshipGeneratedBy;
  sourceTag: Scalars['MongoID']['input'];
  targetTag: Scalars['MongoID']['input'];
  type: EnumTagRelationshipType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  weight: Scalars['Float']['input'];
};

export type CreateOneTagRelationshipPayload = {
  __typename?: 'CreateOneTagRelationshipPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TagRelationship>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTagSuggestionInput = {
  aiResponse?: InputMaybe<TagSuggestionAiResponseInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entityTypes: Array<InputMaybe<EnumTagSuggestionEntityTypes>>;
  name: MultilingualInput;
  owner?: InputMaybe<OwnerInput>;
  tagGroup: Scalars['MongoID']['input'];
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneTagSuggestionPayload = {
  __typename?: 'CreateOneTagSuggestionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<TagSuggestion>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTaxInput = {
  components?: InputMaybe<Array<InputMaybe<TaxComponentsInput>>>;
  country: Scalars['String']['input'];
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<OwnerInput>;
  percentage: Scalars['Float']['input'];
  subdivision: Scalars['String']['input'];
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneTaxPayload = {
  __typename?: 'CreateOneTaxPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Tax>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneUserInput = {
  access: UserAccessInput;
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  confirmationCodes?: InputMaybe<Array<InputMaybe<UserConfirmationCodesInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  emailPreferences?: InputMaybe<Array<InputMaybe<UserEmailPreferencesInput>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastViewedListId?: InputMaybe<Scalars['String']['input']>;
  onboardingMetadata?: InputMaybe<UserOnboardingMetadataInput>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photoUploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  quickLinks?: InputMaybe<Array<InputMaybe<UserQuickLinksInput>>>;
  quickLinksVersion?: InputMaybe<Scalars['Float']['input']>;
  resolvedBroadcasts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  signupToken?: InputMaybe<Scalars['String']['input']>;
  status: EnumUserStatus;
  systemPermissions?: InputMaybe<Array<InputMaybe<EnumUserSystemPermissions>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  userType: EnumUserUserType;
};

export type CreateOneWidgetInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description: MultilingualInput;
  eventSettings?: InputMaybe<WidgetEventSettingsInput>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  gallerySettings?: InputMaybe<WidgetGallerySettingsInput>;
  inquirySettings?: InputMaybe<WidgetInquirySettingsInput>;
  list?: InputMaybe<Scalars['MongoID']['input']>;
  name: MultilingualInput;
  operatorSettings?: InputMaybe<WidgetOperatorSettingsInput>;
  owner: OwnerInput;
  promotionSettings?: InputMaybe<WidgetPromotionSettingsInput>;
  type: EnumWidgetType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneWidgetPayload = {
  __typename?: 'CreateOneWidgetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Widget>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CronJobInfo = {
  __typename?: 'CronJobInfo';
  description: Scalars['String']['output'];
  enabledForCurrentEnv: Scalars['Boolean']['output'];
  lastRun?: Maybe<CronJobLastRun>;
  name: Scalars['String']['output'];
  schedule: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
};

export type CronJobLastRun = {
  __typename?: 'CronJobLastRun';
  completedAt?: Maybe<Scalars['Date']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
};

export type CronJobRunResult = {
  __typename?: 'CronJobRunResult';
  durationMs?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  jobName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CustomFieldResponseInput = {
  fieldId: Scalars['String']['input'];
  response: Array<Scalars['String']['input']>;
};

export type CustomOrderFilter = {
  /** Filter by an array of _ids to match specific orders */
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter booking requests by approval status: PENDING, APPROVED, DECLINED, or EXPIRED */
  approvalStatus?: InputMaybe<Scalars['String']['input']>;
  createdEndDate?: InputMaybe<Scalars['String']['input']>;
  createdStartDate?: InputMaybe<Scalars['String']['input']>;
  /** Filter by refund status computed against successful refunds: NO_REFUND, PARTIAL_REFUND, or FULL_REFUND */
  refundStatus?: InputMaybe<Scalars['String']['input']>;
  /** Filter by search term, matched against order _id, company, customer firstName/lastName (and full name), or customer email */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type DateInput = {
  _eq?: InputMaybe<Scalars['Date']['input']>;
  _gt?: InputMaybe<Scalars['Date']['input']>;
  _gte?: InputMaybe<Scalars['Date']['input']>;
  _lt?: InputMaybe<Scalars['Date']['input']>;
  _lte?: InputMaybe<Scalars['Date']['input']>;
  _ne?: InputMaybe<Scalars['Date']['input']>;
};

export type DateRangeIso = {
  __typename?: 'DateRangeISO';
  _id: Scalars['MongoID']['output'];
  end: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  start: Scalars['String']['output'];
};

export type DateRangeIsoInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  end: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['String']['input'];
};

export type DateRangeIsoOptional = {
  __typename?: 'DateRangeISOOptional';
  _id: Scalars['MongoID']['output'];
  end?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type DateRangeIsoOptionalInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
};

export type DepositSettings = {
  __typename?: 'DepositSettings';
  chargeBalanceDaysBeforeCheckIn: Scalars['Float']['output'];
  enabled: Scalars['Boolean']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  rateType?: Maybe<EnumDepositSettingsRateType>;
};

export type DepositSettingsInput = {
  chargeBalanceDaysBeforeCheckIn?: InputMaybe<Scalars['Float']['input']>;
  enabled: Scalars['Boolean']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateType?: InputMaybe<EnumDepositSettingsRateType>;
};

export type DetailedPersonInfoTc = {
  __typename?: 'DetailedPersonInfoTC';
  _id: Scalars['ID']['output'];
  address?: Maybe<Address>;
  birthday?: Maybe<Scalars['String']['output']>;
  contactMethod?: Maybe<EnumPeopleContactMethod>;
  email: Scalars['String']['output'];
  fax?: Maybe<Scalars['String']['output']>;
  faxExt?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  isRepeatCustomer?: Maybe<Scalars['Boolean']['output']>;
  isUserClaimed?: Maybe<Scalars['Boolean']['output']>;
  isUserInvited?: Maybe<Scalars['Boolean']['output']>;
  isWhereaboutsUser?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  mailingAddress?: Maybe<Address>;
  optInEmail?: Maybe<Scalars['Boolean']['output']>;
  optInFax?: Maybe<Scalars['Boolean']['output']>;
  optInPhone?: Maybe<Scalars['Boolean']['output']>;
  optInSMS?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneExt?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<AssetImage>;
  primaryTitle?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  rightSideContent?: Maybe<Array<Maybe<RightSideContentTc>>>;
  systemRoles?: Maybe<Array<Maybe<EnumPeopleVisibleToSystemRoles>>>;
  tags: Array<Tag>;
  unreadLeads?: Maybe<Array<Maybe<UnreadLeadTc>>>;
};


export type DetailedPersonInfoTcTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsTagInput>;
};

export type DetailedPersonTc = {
  __typename?: 'DetailedPersonTC';
  _id: Scalars['ID']['output'];
  adminOrganizations?: Maybe<Array<Maybe<OrganizationDetailsTc>>>;
  emails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isOnDirectoryOperator?: Maybe<Scalars['Boolean']['output']>;
  isUserClaimed?: Maybe<Scalars['Boolean']['output']>;
  isUserInvited?: Maybe<Scalars['Boolean']['output']>;
  leads?: Maybe<Array<Maybe<PersonDetailsSectionTc>>>;
  operators?: Maybe<Array<Maybe<OperatorDetailsTc>>>;
  orders?: Maybe<Array<Maybe<PersonDetailsSectionTc>>>;
  organizations?: Maybe<Array<Maybe<OrganizationDetailsTc>>>;
  personInfo?: Maybe<DetailedPersonInfoTc>;
  phones?: Maybe<Array<Maybe<PersonMetadataPhone>>>;
  scratchpad?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type DetectedObject = {
  __typename?: 'DetectedObject';
  boundingBox: Array<Scalars['Float']['output']>;
  categories: Array<Scalars['String']['output']>;
  confidence: Scalars['Float']['output'];
};

export type DetectedObjects = {
  __typename?: 'DetectedObjects';
  hasFace?: Maybe<Scalars['Boolean']['output']>;
  hasText?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Array<Maybe<DetectedObject>>>;
};

export type DevMembershipSeedCoverage = {
  __typename?: 'DevMembershipSeedCoverage';
  businessTiers?: Maybe<DevMembershipSeedCoverageBucket>;
  directoryRecords: Scalars['Int']['output'];
  generationMode?: Maybe<DevMembershipSeedMode>;
  individualTiers?: Maybe<DevMembershipSeedCoverageBucket>;
  rateVariants?: Maybe<DevMembershipSeedCoverageBucket>;
  storefrontId?: Maybe<Scalars['String']['output']>;
  storefrontName?: Maybe<Scalars['String']['output']>;
  untaggedControls: Scalars['Int']['output'];
};

export type DevMembershipSeedCoverageBucket = {
  __typename?: 'DevMembershipSeedCoverageBucket';
  blocked?: Maybe<Array<Maybe<DevMembershipSeedCoverageItem>>>;
  covered: Array<Scalars['String']['output']>;
};

export type DevMembershipSeedCoverageItem = {
  __typename?: 'DevMembershipSeedCoverageItem';
  name: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type DevMembershipSeedCreatedIds = {
  __typename?: 'DevMembershipSeedCreatedIds';
  activityLogIds: Array<Scalars['String']['output']>;
  changelogIds: Array<Scalars['String']['output']>;
  membershipEventIds: Array<Scalars['String']['output']>;
  membershipIds: Array<Scalars['String']['output']>;
  operatorEntityIds: Array<Scalars['String']['output']>;
  operatorVersionIds: Array<Scalars['String']['output']>;
  originalOrderIds: Array<Scalars['String']['output']>;
  paymentRequestIds: Array<Scalars['String']['output']>;
  personIds: Array<Scalars['String']['output']>;
  publicationStatusIds: Array<Scalars['String']['output']>;
  renewablePurchaseIds: Array<Scalars['String']['output']>;
  renewalOrderIds: Array<Scalars['String']['output']>;
  renewalRecordIds: Array<Scalars['String']['output']>;
  tagAssignmentIds: Array<Scalars['String']['output']>;
};

export enum DevMembershipSeedEntityComposition {
  OperatorAndContact = 'OPERATOR_AND_CONTACT',
  OperatorOnly = 'OPERATOR_ONLY',
  PersonOnly = 'PERSON_ONLY'
}

export type DevMembershipSeedInput = {
  entityComposition?: InputMaybe<DevMembershipSeedEntityComposition>;
  includeBusinessTiers?: InputMaybe<Scalars['Boolean']['input']>;
  includeIndividualTiers?: InputMaybe<Scalars['Boolean']['input']>;
  includeSpecialRateVariants?: InputMaybe<Scalars['Boolean']['input']>;
  includeUntaggedControls?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<DevMembershipSeedMode>;
  organizationId: Scalars['String']['input'];
  publicationStatus?: InputMaybe<DevMembershipSeedPublicationStatus>;
  recordsPerTier?: InputMaybe<Scalars['Int']['input']>;
  renewalEvidence?: InputMaybe<DevMembershipSeedRenewalEvidence>;
  renewalExactDate?: InputMaybe<Scalars['String']['input']>;
  renewalPeriodEnd?: InputMaybe<Scalars['String']['input']>;
  renewalPeriodStart?: InputMaybe<Scalars['String']['input']>;
  statusTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  untaggedControlCount?: InputMaybe<Scalars['Int']['input']>;
};

export type DevMembershipSeedInputSnapshot = {
  __typename?: 'DevMembershipSeedInputSnapshot';
  entityComposition?: Maybe<DevMembershipSeedEntityComposition>;
  includeBusinessTiers: Scalars['Boolean']['output'];
  includeIndividualTiers: Scalars['Boolean']['output'];
  includeSpecialRateVariants: Scalars['Boolean']['output'];
  includeUntaggedControls: Scalars['Boolean']['output'];
  mode?: Maybe<DevMembershipSeedMode>;
  organizationId: Scalars['String']['output'];
  publicationStatus?: Maybe<DevMembershipSeedPublicationStatus>;
  recordsPerTier: Scalars['Int']['output'];
  renewalEvidence?: Maybe<DevMembershipSeedRenewalEvidence>;
  renewalExactDate?: Maybe<Scalars['String']['output']>;
  renewalPeriodEnd?: Maybe<Scalars['String']['output']>;
  renewalPeriodStart?: Maybe<Scalars['String']['output']>;
  statusTagIds: Array<Scalars['String']['output']>;
  untaggedControlCount: Scalars['Int']['output'];
};

export enum DevMembershipSeedMode {
  DirectoryOnly = 'DIRECTORY_ONLY',
  FullRenewal = 'FULL_RENEWAL',
  MembershipLedger = 'MEMBERSHIP_LEDGER'
}

export type DevMembershipSeedPreview = {
  __typename?: 'DevMembershipSeedPreview';
  blockedCount: Scalars['Int']['output'];
  coverage?: Maybe<DevMembershipSeedCoverage>;
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  readyCount: Scalars['Int']['output'];
  rows?: Maybe<Array<Maybe<DevMembershipSeedRow>>>;
};

export enum DevMembershipSeedPublicationStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT'
}

export enum DevMembershipSeedRateKind {
  Special = 'SPECIAL',
  Standard = 'STANDARD'
}

export enum DevMembershipSeedRenewalEvidence {
  Distributed = 'DISTRIBUTED',
  ExactDate = 'EXACT_DATE',
  None = 'NONE'
}

export type DevMembershipSeedRow = {
  __typename?: 'DevMembershipSeedRow';
  blockReason?: Maybe<Scalars['String']['output']>;
  blocked: Scalars['Boolean']['output'];
  bookerId?: Maybe<Scalars['String']['output']>;
  bookerName?: Maybe<Scalars['String']['output']>;
  caseKey: Scalars['String']['output'];
  cleanupMessages: Array<Scalars['String']['output']>;
  createdIds?: Maybe<DevMembershipSeedCreatedIds>;
  discountId?: Maybe<Scalars['String']['output']>;
  entityComposition?: Maybe<DevMembershipSeedEntityComposition>;
  expectedRenewalAmount?: Maybe<Scalars['Int']['output']>;
  membershipId?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<DevMembershipSeedMode>;
  operatorEntityId?: Maybe<Scalars['String']['output']>;
  operatorName?: Maybe<Scalars['String']['output']>;
  operatorVersionId?: Maybe<Scalars['String']['output']>;
  originalOrderId?: Maybe<Scalars['String']['output']>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productTierId?: Maybe<Scalars['String']['output']>;
  productTierName?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<DevMembershipSeedPublicationStatus>;
  rateKind?: Maybe<DevMembershipSeedRateKind>;
  rateLabel?: Maybe<Scalars['String']['output']>;
  renewablePurchaseId?: Maybe<Scalars['String']['output']>;
  renewalDate?: Maybe<Scalars['String']['output']>;
  renewalPhase?: Maybe<Scalars['String']['output']>;
  statusTagIds: Array<Scalars['String']['output']>;
  statusTagNames: Array<Scalars['String']['output']>;
  subjectType?: Maybe<DevMembershipSeedSubjectType>;
  tierName?: Maybe<Scalars['String']['output']>;
  tierTagId?: Maybe<Scalars['String']['output']>;
  validationMessages: Array<Scalars['String']['output']>;
  validationOk: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type DevMembershipSeedRun = {
  __typename?: 'DevMembershipSeedRun';
  _id: Scalars['MongoID']['output'];
  cleanedAt?: Maybe<Scalars['Date']['output']>;
  cleanedBy?: Maybe<Scalars['String']['output']>;
  cleanedByName?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  input?: Maybe<DevMembershipSeedInputSnapshot>;
  organization: Scalars['MongoID']['output'];
  rows?: Maybe<Array<Maybe<DevMembershipSeedRow>>>;
  status?: Maybe<DevMembershipSeedRunStatus>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export enum DevMembershipSeedRunStatus {
  Cleaned = 'CLEANED',
  Created = 'CREATED',
  PartiallyCleaned = 'PARTIALLY_CLEANED'
}

export enum DevMembershipSeedSubjectType {
  Business = 'BUSINESS',
  Individual = 'INDIVIDUAL',
  NonMember = 'NON_MEMBER'
}

export type DevToolsEmailReplaceEntryInput = {
  emailIndex?: InputMaybe<Scalars['Int']['input']>;
  entityId: Scalars['MongoID']['input'];
  entityType: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
  visibleToIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type DevToolsEmailScanPayload = {
  __typename?: 'DevToolsEmailScanPayload';
  skipped?: Maybe<Array<Maybe<DevToolsEmailScanSkipped>>>;
  toReplace?: Maybe<Array<Maybe<DevToolsEmailScanResult>>>;
};

export type DevToolsEmailScanResult = {
  __typename?: 'DevToolsEmailScanResult';
  context?: Maybe<Scalars['String']['output']>;
  currentEmail: Scalars['String']['output'];
  emailIndex?: Maybe<Scalars['Int']['output']>;
  entityId: Scalars['MongoID']['output'];
  entityType: Scalars['String']['output'];
  suggestedNewEmail: Scalars['String']['output'];
  visibleToIndex?: Maybe<Scalars['Int']['output']>;
};

export type DevToolsEmailScanSkipped = {
  __typename?: 'DevToolsEmailScanSkipped';
  email: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type DirectoryBulkInvitePreviewResult = {
  __typename?: 'DirectoryBulkInvitePreviewResult';
  financialContactCount: Scalars['Int']['output'];
  hasMultiStaffListings: Scalars['Boolean']['output'];
  listingsWithoutContact: Array<BulkInviteNoContactListing>;
  primaryContactCount: Scalars['Int']['output'];
  publicEmailCount: Scalars['Int']['output'];
  totalAlreadyClaimed: Scalars['Int']['output'];
  totalAlreadyInvited: Scalars['Int']['output'];
  totalConnectedStaff: Scalars['Int']['output'];
  totalDmoManaged: Scalars['Int']['output'];
  totalEligible: Scalars['Int']['output'];
  totalInView: Scalars['Int']['output'];
};

export type DirectoryBulkInviteResult = {
  __typename?: 'DirectoryBulkInviteResult';
  queuedListings: Scalars['Int']['output'];
  queuedRecipients: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type DirectoryOperatorsResult = {
  __typename?: 'DirectoryOperatorsResult';
  items: Array<OperatorWithStatus>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export enum DirectorySortEnum {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type Discount = {
  __typename?: 'Discount';
  _id: Scalars['MongoID']['output'];
  amount: Scalars['Float']['output'];
  buyQuantity?: Maybe<Scalars['Float']['output']>;
  canCombine: Scalars['Boolean']['output'];
  copiedFrom?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  currentUsageCount: Scalars['Float']['output'];
  daysInAdvance?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Multilingual>;
  discountActivePeriod?: Maybe<DateRangeIsoOptional>;
  excludeUpsells: Scalars['Boolean']['output'];
  getQuantity?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  isOngoing: Scalars['Boolean']['output'];
  maxDaysInAdvance?: Maybe<Scalars['Float']['output']>;
  maxNights?: Maybe<Scalars['Float']['output']>;
  maxUsageCount?: Maybe<Scalars['Float']['output']>;
  minGuestCount?: Maybe<Scalars['Float']['output']>;
  minNights?: Maybe<Scalars['Float']['output']>;
  minQuantity?: Maybe<Scalars['Float']['output']>;
  minSubtotal?: Maybe<Scalars['Float']['output']>;
  name: Multilingual;
  perTicket: Scalars['Boolean']['output'];
  perTicketApplyFrom?: Maybe<Scalars['Float']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  storefront: Scalars['MongoID']['output'];
  type: EnumDiscountType;
  unit: EnumDiscountUnit;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type DiscountTotalPerDiscount = {
  __typename?: 'DiscountTotalPerDiscount';
  discountId: Scalars['ID']['output'];
  total: Scalars['Int']['output'];
};

export type DryRunLogEntry = {
  __typename?: 'DryRunLogEntry';
  connectedOperatorName?: Maybe<Scalars['String']['output']>;
  entityName: Scalars['String']['output'];
  entityType?: Maybe<Scalars['String']['output']>;
  errorMessages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  existingEntityId?: Maybe<Scalars['String']['output']>;
  existingOperatorOrganizerId?: Maybe<Scalars['String']['output']>;
  existingOperatorOrganizerName?: Maybe<Scalars['String']['output']>;
  existingOperatorVenueId?: Maybe<Scalars['String']['output']>;
  existingOperatorVenueName?: Maybe<Scalars['String']['output']>;
  fieldsToUpdate?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hasAddress?: Maybe<Scalars['Boolean']['output']>;
  hasContact?: Maybe<Scalars['Boolean']['output']>;
  hasDescription?: Maybe<Scalars['Boolean']['output']>;
  imageCount?: Maybe<Scalars['Int']['output']>;
  isExisting?: Maybe<Scalars['Boolean']['output']>;
  isUpdate?: Maybe<Scalars['Boolean']['output']>;
  missingOrganizer?: Maybe<Scalars['Boolean']['output']>;
  missingVenue?: Maybe<Scalars['Boolean']['output']>;
  organizerCouldNotConnect?: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['String']['output'];
  tagsAddedCount?: Maybe<Scalars['Int']['output']>;
  unresolvedOrganizerName?: Maybe<Scalars['String']['output']>;
  unresolvedVenueNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  willBeConnectedToOperator?: Maybe<Scalars['Boolean']['output']>;
  willConnectToExistingOperator?: Maybe<Scalars['Boolean']['output']>;
  willConnectToExistingOperatorAsOrganizer?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailReplaceProgress = {
  __typename?: 'EmailReplaceProgress';
  completed: Scalars['Int']['output'];
  isRunning: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
};

export type EmailResponse = {
  __typename?: 'EmailResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type EmailSuppressionAdminPage = {
  __typename?: 'EmailSuppressionAdminPage';
  items: Array<EmailSuppressionAdminRow>;
  total: Scalars['Int']['output'];
};

export type EmailSuppressionAdminRow = {
  __typename?: 'EmailSuppressionAdminRow';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['MongoID']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  reason: EmailSuppressionReasonEnum;
  source: EmailSuppressionSourceEnum;
};

export enum EmailSuppressionReasonEnum {
  SpamReport = 'SPAM_REPORT',
  Unsubscribe = 'UNSUBSCRIBE'
}

export enum EmailSuppressionSourceEnum {
  Link = 'LINK',
  OneClick = 'ONE_CLICK',
  Sendgrid = 'SENDGRID'
}

export type EntityReference = {
  __typename?: 'EntityReference';
  _entityId: Scalars['MongoID']['output'];
  type: EnumEntityReferenceType;
};

export type EntityReferenceInput = {
  _entityId: Scalars['MongoID']['input'];
  type: EnumEntityReferenceType;
};

export enum EnumActivityLogType {
  BroadcastPublished = 'BROADCAST_PUBLISHED',
  BroadcastViewed = 'BROADCAST_VIEWED',
  CourseCompleted = 'COURSE_COMPLETED',
  CourseStarted = 'COURSE_STARTED',
  DirectoryUpdated = 'DIRECTORY_UPDATED',
  EmailBroadcastNotificationSent = 'EMAIL_BROADCAST_NOTIFICATION_SENT',
  EmailDailyDigestSent = 'EMAIL_DAILY_DIGEST_SENT',
  EmailInviteSent = 'EMAIL_INVITE_SENT',
  EmailPaymentRequestSent = 'EMAIL_PAYMENT_REQUEST_SENT',
  EmailRenewalSent = 'EMAIL_RENEWAL_SENT',
  EventSubmitted = 'EVENT_SUBMITTED',
  FileDownloaded = 'FILE_DOWNLOADED',
  FormCompleted = 'FORM_COMPLETED',
  FormDraftSaved = 'FORM_DRAFT_SAVED',
  FormResubmitted = 'FORM_RESUBMITTED',
  FormSubmissionApproved = 'FORM_SUBMISSION_APPROVED',
  FormSubmissionRejected = 'FORM_SUBMISSION_REJECTED',
  InquiryReceived = 'INQUIRY_RECEIVED',
  OperatorCreated = 'OPERATOR_CREATED',
  OperatorStaffAdded = 'OPERATOR_STAFF_ADDED',
  OperatorUpdated = 'OPERATOR_UPDATED',
  OrderBookingRequest = 'ORDER_BOOKING_REQUEST',
  OrderPaymentPending = 'ORDER_PAYMENT_PENDING',
  OrderPurchased = 'ORDER_PURCHASED',
  PhotosDownloaded = 'PHOTOS_DOWNLOADED',
  PromotionSubmitted = 'PROMOTION_SUBMITTED',
  ResourceViewed = 'RESOURCE_VIEWED',
  UserLoggedIn = 'USER_LOGGED_IN',
  VideoPlayed = 'VIDEO_PLAYED'
}

export enum EnumAddressLocationType {
  Point = 'Point'
}

export enum EnumAssetImageMuxStatus {
  Errored = 'errored',
  Preparing = 'preparing',
  Ready = 'ready'
}

export enum EnumBookerCustomizationsAddressDisplay {
  Full = 'FULL',
  None = 'NONE',
  NoStreet = 'NO_STREET'
}

export enum EnumBookerCustomizationsSectionOrder {
  AddOns = 'ADD_ONS',
  CustomerDetails = 'CUSTOMER_DETAILS',
  Delivery = 'DELIVERY',
  Operator = 'OPERATOR',
  Product = 'PRODUCT',
  Questionnaire = 'QUESTIONNAIRE'
}

export enum EnumBookerEligibilityIneligibleBehavior {
  Block = 'BLOCK',
  PayNow = 'PAY_NOW'
}

export enum EnumBookerEligibilityMode {
  Anyone = 'ANYONE',
  VerifiedMembers = 'VERIFIED_MEMBERS'
}

export enum EnumBookerEligibilityRule {
  MembershipActive = 'MEMBERSHIP_ACTIVE',
  PeopleTag = 'PEOPLE_TAG'
}

export enum EnumBookerEmailTemplatesType {
  CancellationConfirmation = 'CANCELLATION_CONFIRMATION',
  RenewableWelcome = 'RENEWABLE_WELCOME',
  RenewalPaymentRequest = 'RENEWAL_PAYMENT_REQUEST',
  RenewalReminder = 'RENEWAL_REMINDER'
}

export enum EnumOrderPaymentMetadataStripeRegion {
  Ca = 'CA',
  Us = 'US'
}

export enum EnumBookerPaymentTimingConsolidation {
  MonthlyStatement = 'MONTHLY_STATEMENT',
  PerBooking = 'PER_BOOKING'
}

export enum EnumBookerPaymentTimingTiming {
  AfterService = 'AFTER_SERVICE',
  AtCheckout = 'AT_CHECKOUT',
  OnApproval = 'ON_APPROVAL'
}

export enum EnumBookerPromoCodeTagOverridesMode {
  Add = 'ADD',
  Override = 'OVERRIDE'
}

export enum EnumBookerRenewalSettingsRenewalMode {
  AutoCharge = 'AUTO_CHARGE',
  Invoice = 'INVOICE'
}

export enum EnumBookerStatus {
  Archived = 'ARCHIVED',
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Open = 'OPEN'
}

export enum EnumBookerTagDiscountSettingsRulesDiscountType {
  Fixed = 'fixed',
  Free = 'free',
  Percentage = 'percentage'
}

export enum EnumBroadcastResourcesFormMode {
  Collaborative = 'COLLABORATIVE',
  MultiSubmission = 'MULTI_SUBMISSION',
  OneAndDone = 'ONE_AND_DONE'
}

export enum EnumBroadcastResourcesType {
  Course = 'COURSE',
  Custom = 'CUSTOM',
  Forms = 'FORMS',
  Message = 'MESSAGE',
  Pdf = 'PDF',
  Photos = 'PHOTOS',
  Storefront = 'STOREFRONT',
  Video = 'VIDEO'
}

export enum EnumBroadcastSharedToSentToPeopleSystemRoles {
  Customer = 'CUSTOMER',
  DmoStaff = 'DMOStaff',
  EventCreator = 'EVENT_CREATOR',
  Lead = 'LEAD',
  Operator = 'OPERATOR',
  WhereaboutsUser = 'WhereaboutsUser'
}

export enum EnumBroadcastSharedToType {
  AllPeople = 'ALL_PEOPLE',
  PeopleByCustomSelection = 'PEOPLE_BY_CUSTOM_SELECTION',
  PeopleByTag = 'PEOPLE_BY_TAG'
}

export enum EnumBroadcastStatus {
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum EnumBulkConnectLogResultsStatus {
  AlreadyConnected = 'ALREADY_CONNECTED',
  Error = 'ERROR',
  Success = 'SUCCESS'
}

export enum EnumConfirmationCodeType {
  OperatorOwnershipConfirmation = 'OPERATOR_OWNERSHIP_CONFIRMATION'
}

export enum EnumCourseProgressCompletionStatus {
  Completed = 'COMPLETED',
  Incomplete = 'INCOMPLETE',
  NotAttempted = 'NOT_ATTEMPTED',
  Unknown = 'UNKNOWN'
}

export enum EnumCourseProgressSuccessStatus {
  Failed = 'FAILED',
  Passed = 'PASSED',
  Unknown = 'UNKNOWN'
}

export enum EnumDKeyAssetType {
  AssetFile = 'AssetFile',
  AssetImage = 'AssetImage'
}

export enum EnumDepositSettingsRateType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export enum EnumDiscountType {
  AutoApplied = 'AUTO_APPLIED',
  BuyXGetY = 'BUY_X_GET_Y',
  EarlyBird = 'EARLY_BIRD',
  GuestCount = 'GUEST_COUNT',
  LengthOfStay = 'LENGTH_OF_STAY',
  PromoCode = 'PROMO_CODE',
  Quantity = 'QUANTITY',
  SpendThreshold = 'SPEND_THRESHOLD'
}

export enum EnumDiscountUnit {
  Fixed = 'FIXED',
  FlatRate = 'FLAT_RATE',
  Percentage = 'PERCENTAGE'
}

export enum EnumEntityReferenceType {
  Booker = 'BOOKER',
  Broadcast = 'BROADCAST',
  Event = 'EVENT',
  List = 'LIST',
  Note = 'NOTE',
  Operator = 'OPERATOR',
  Order = 'ORDER',
  Organization = 'ORGANIZATION',
  Person = 'PERSON',
  Product = 'PRODUCT',
  Promotion = 'PROMOTION',
  Storefront = 'STOREFRONT',
  Widget = 'WIDGET'
}

export enum EnumEventAccessOperatorSource {
  Creator = 'CREATOR',
  Enrollment = 'ENROLLMENT',
  Import = 'IMPORT',
  Partner = 'PARTNER'
}

export enum EnumEventAccessOperatorStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  ForReview = 'FOR_REVIEW'
}

export enum EnumEventAccessOperatorStatusBeforeCancel {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  ForReview = 'FOR_REVIEW'
}

export enum EnumEventAttentionIssuesType {
  MissingOrganizer = 'MISSING_ORGANIZER',
  MissingVenue = 'MISSING_VENUE',
  UnresolvedOrganizer = 'UNRESOLVED_ORGANIZER',
  UnresolvedVenue = 'UNRESOLVED_VENUE'
}

export enum EnumEventHistoryAction {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Edited = 'EDITED',
  OrgAdded = 'ORG_ADDED',
  OrgDisconnected = 'ORG_DISCONNECTED',
  PartnerShared = 'PARTNER_SHARED',
  Submitted = 'SUBMITTED',
  Uncancelled = 'UNCANCELLED'
}

export enum EnumEventHistorySourceType {
  Guest = 'GUEST',
  Operator = 'OPERATOR',
  Organization = 'ORGANIZATION'
}

export enum EnumEventLocationLocationInfoType {
  Operator = 'OPERATOR',
  Organization = 'ORGANIZATION',
  Storefront = 'STOREFRONT',
  TnbInternal = 'TNB_INTERNAL'
}

export enum EnumEventLocationType {
  InPerson = 'IN_PERSON',
  Virtual = 'VIRTUAL'
}

/** For monthly frequency, the weekday the event should occur on (used in conjuction with dayOfMonthOccurrence) (e.g. WE) */
export enum EnumEventRecurrencePatternDayOfMonth {
  Fr = 'FR',
  Mo = 'MO',
  Sa = 'SA',
  Su = 'SU',
  Th = 'TH',
  Tu = 'TU',
  We = 'WE'
}

export enum EnumEventRecurrencePatternDaysOfWeek {
  Fr = 'FR',
  Mo = 'MO',
  Sa = 'SA',
  Su = 'SU',
  Th = 'TH',
  Tu = 'TU',
  We = 'WE'
}

export enum EnumEventRecurrencePatternFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Once = 'ONCE',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

/** Who created the event (GUEST/OPERATOR/ORGANIZATION), derived server-side at create time. Used to exclude operator-sourced drafts from an organization's Events app. */
export enum EnumEventSubmissionSource {
  Guest = 'GUEST',
  Operator = 'OPERATOR',
  Organization = 'ORGANIZATION'
}

export enum EnumEventType {
  Multi = 'MULTI',
  Recurring = 'RECURRING',
  Single = 'SINGLE'
}

export enum EnumFeatureFlagScope {
  AdminUser = 'adminUser',
  Organization = 'organization',
  Storefront = 'storefront'
}

export enum EnumGalleryNewMediaMediaType {
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export enum EnumGalleryNewMediaStatus {
  Baseline = 'baseline',
  Dismissed = 'dismissed',
  Pending = 'pending',
  Promoted = 'promoted'
}

export enum EnumGuestTierType {
  Adult = 'ADULT',
  Child = 'CHILD',
  General = 'GENERAL',
  Infant = 'INFANT',
  Pet = 'PET',
  Senior = 'SENIOR'
}

export enum EnumImportImportType {
  CustomTags = 'CUSTOM_TAGS',
  Events = 'EVENTS',
  Operator = 'OPERATOR',
  People = 'PEOPLE',
  Tags = 'TAGS'
}

export enum EnumImportManagerSettingsAiScraperGeneratorAiEngine {
  Gpt_4 = 'GPT_4',
  Gpt_4O = 'GPT_4O',
  Gpt_4OMini = 'GPT_4O_MINI',
  Gpt_4_1 = 'GPT_4_1',
  Gpt_4_1Mini = 'GPT_4_1_MINI',
  Gpt_4Turbo = 'GPT_4_TURBO',
  Gpt_5_1 = 'GPT_5_1',
  Gpt_35Turbo = 'GPT_35_TURBO',
  Sonnet_4_5 = 'SONNET_4_5'
}

export enum EnumImportRunDryRunLogStatus {
  Invalid = 'invalid',
  Valid = 'valid'
}

export enum EnumImportRunEntitiesManuallyConnectedToOrgMergeOption {
  NoUpdate = 'NO_UPDATE',
  OverwriteAll = 'OVERWRITE_ALL',
  OverwriteEmpty = 'OVERWRITE_EMPTY'
}

export enum EnumImportRunExistingEntitiesMergeOption {
  NoUpdate = 'NO_UPDATE',
  OverwriteAll = 'OVERWRITE_ALL',
  OverwriteEmpty = 'OVERWRITE_EMPTY'
}

export enum EnumImportRunExistingOperatorsMergeOption {
  NoUpdate = 'NO_UPDATE',
  OverwriteAll = 'OVERWRITE_ALL',
  OverwriteEmpty = 'OVERWRITE_EMPTY'
}

export enum EnumImportRunOperatorsManuallyConnectedToOrgMergeOption {
  NoUpdate = 'NO_UPDATE',
  OverwriteAll = 'OVERWRITE_ALL',
  OverwriteEmpty = 'OVERWRITE_EMPTY'
}

export enum EnumImportRunStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  PartialSuccess = 'PARTIAL_SUCCESS',
  Ready = 'READY',
  Running = 'RUNNING',
  Undone = 'UNDONE'
}

export enum EnumImportScrapeRunActionHistoryAction {
  Cleanup = 'cleanup',
  Enrichment = 'enrichment'
}

export enum EnumImportScrapeRunRating {
  Bad = 'BAD',
  Good = 'GOOD'
}

export enum EnumImportScrapeRunStatus {
  Failed = 'FAILED',
  Partial = 'PARTIAL',
  Success = 'SUCCESS'
}

export enum EnumImportScrapeStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export enum EnumImportScrapeTypeOfData {
  Events = 'EVENTS',
  Operator = 'OPERATOR',
  People = 'PEOPLE'
}

export enum EnumImportScrapeTypeOfScrape {
  GoogleMaps = 'GOOGLE_MAPS',
  Sitemap = 'SITEMAP',
  Spreadsheet = 'SPREADSHEET',
  Website = 'WEBSITE'
}

export enum EnumImportStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export enum EnumInventoryItemType {
  Accommodation = 'ACCOMMODATION',
  Event = 'EVENT'
}

export enum EnumInviteQueueInviteStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Invited = 'INVITED',
  OperatorInvite = 'OPERATOR_INVITE',
  Pending = 'PENDING',
  Sending = 'SENDING',
  Sent = 'SENT',
  Stale = 'STALE'
}

export enum EnumInviteQueueInviteType {
  Claim = 'CLAIM',
  Freshen = 'FRESHEN'
}

export enum EnumInviteQueuePreSendStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Invited = 'INVITED',
  OperatorInvite = 'OPERATOR_INVITE',
  Pending = 'PENDING',
  Sending = 'SENDING',
  Sent = 'SENT',
  Stale = 'STALE'
}

export enum EnumItineraryPublishedTravelType {
  Cycling = 'CYCLING',
  Driving = 'DRIVING',
  Walking = 'WALKING'
}

export enum EnumItineraryRouteStatus {
  Failed = 'failed',
  Generating = 'generating',
  Idle = 'idle',
  Ready = 'ready'
}

export enum EnumItineraryStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum EnumItineraryTravelType {
  Cycling = 'CYCLING',
  Driving = 'DRIVING',
  Walking = 'WALKING'
}

export enum EnumItineraryTripperSettingsMapStyleVariant {
  Default = 'default',
  Faded = 'faded',
  Monochrome = 'monochrome'
}

export enum EnumItineraryTripperSettingsSegmentPreset {
  Custom = 'CUSTOM',
  DayTrip = 'DAY_TRIP',
  MultiDay = 'MULTI_DAY',
  Simple = 'SIMPLE'
}

export enum EnumItineraryWidgetEmbedStyle {
  Inline = 'inline',
  Popover = 'popover',
  RichPreview = 'richPreview',
  TextButton = 'textButton'
}

export enum EnumItineraryWidgetMapStyleVariant {
  Default = 'default',
  Faded = 'faded',
  Monochrome = 'monochrome'
}

export enum EnumItineraryWidgetStatus {
  Active = 'active',
  Paused = 'paused'
}

export enum EnumItineraryWidgetType {
  Embed = 'embed',
  Webpage = 'webpage'
}

export enum EnumLeadMessagesSender {
  Bot = 'bot',
  ExternalUser = 'external_user',
  InternalUser = 'internal_user'
}

export enum EnumLeadSource {
  Api = 'API',
  Broadcast = 'BROADCAST',
  Widget = 'WIDGET'
}

export enum EnumLeadStatus {
  Deleted = 'DELETED',
  Read = 'READ',
  Unread = 'UNREAD'
}

export enum EnumLeadType {
  Inquiry = 'INQUIRY',
  SurveyResponse = 'SURVEY_RESPONSE'
}

export enum EnumListAudienceListKey {
  NoSelectedAudiences = 'NO_SELECTED_AUDIENCES',
  UsedInWidgets = 'USED_IN_WIDGETS'
}

export enum EnumListKind {
  Audience = 'AUDIENCE',
  Member = 'MEMBER',
  Regular = 'REGULAR'
}

export enum EnumListMemberListKey {
  AllMembers = 'ALL_MEMBERS'
}

export enum EnumListType {
  Manual = 'MANUAL',
  Smart = 'SMART'
}

export enum EnumMembershipEmailsDeclinedKind {
  Cancelled = 'CANCELLED',
  Custom = 'CUSTOM',
  Expired = 'EXPIRED',
  Overdue = 'OVERDUE',
  Reminder = 'REMINDER',
  Success = 'SUCCESS'
}

export enum EnumMembershipEmailsSentKind {
  Cancelled = 'CANCELLED',
  Custom = 'CUSTOM',
  Expired = 'EXPIRED',
  Overdue = 'OVERDUE',
  Reminder = 'REMINDER',
  Success = 'SUCCESS'
}

export enum EnumMembershipEventSourceKind {
  AdminManual = 'ADMIN_MANUAL',
  FormCompletion = 'FORM_COMPLETION',
  InquiryWidget = 'INQUIRY_WIDGET',
  Migration = 'MIGRATION',
  OperatorInheritance = 'OPERATOR_INHERITANCE',
  RenewableFeeRenewal = 'RENEWABLE_FEE_RENEWAL',
  RenewalEngine = 'RENEWAL_ENGINE',
  StorefrontCheckout = 'STOREFRONT_CHECKOUT',
  StorefrontExpiration = 'STOREFRONT_EXPIRATION'
}

export enum EnumMembershipEventSubjectType {
  Operator = 'OPERATOR',
  Person = 'PERSON'
}

export enum EnumMembershipEventType {
  EmailDeclined = 'EMAIL_DECLINED',
  Expired = 'EXPIRED',
  Granted = 'GRANTED',
  PaidUpDateCleared = 'PAID_UP_DATE_CLEARED',
  PaidUpDateSet = 'PAID_UP_DATE_SET',
  Reinstated = 'REINSTATED',
  Renewed = 'RENEWED',
  Revoked = 'REVOKED',
  StatusChanged = 'STATUS_CHANGED',
  TierChanged = 'TIER_CHANGED'
}

export enum EnumMembershipLastMembershipEmailKind {
  Cancelled = 'CANCELLED',
  Custom = 'CUSTOM',
  Expired = 'EXPIRED',
  Overdue = 'OVERDUE',
  Reminder = 'REMINDER',
  Success = 'SUCCESS'
}

export enum EnumMembershipSourceContributionsKind {
  AdminManual = 'ADMIN_MANUAL',
  FormCompletion = 'FORM_COMPLETION',
  InquiryWidget = 'INQUIRY_WIDGET',
  Migration = 'MIGRATION',
  OperatorInheritance = 'OPERATOR_INHERITANCE',
  RenewableFeeRenewal = 'RENEWABLE_FEE_RENEWAL',
  RenewalEngine = 'RENEWAL_ENGINE',
  StorefrontCheckout = 'STOREFRONT_CHECKOUT',
  StorefrontExpiration = 'STOREFRONT_EXPIRATION'
}

export enum EnumMembershipStatus {
  Active = 'ACTIVE',
  Lapsed = 'LAPSED',
  None = 'NONE',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export enum EnumMembershipSubjectType {
  Operator = 'OPERATOR',
  Person = 'PERSON'
}

export enum EnumNoteKind {
  MembershipStatusAdded = 'MEMBERSHIP_STATUS_ADDED',
  MembershipStatusRemoved = 'MEMBERSHIP_STATUS_REMOVED',
  MembershipTierAdded = 'MEMBERSHIP_TIER_ADDED',
  MembershipTierRemoved = 'MEMBERSHIP_TIER_REMOVED',
  User = 'USER'
}

export enum EnumOperatorAvgImageQuality {
  Average = 'AVERAGE',
  High = 'HIGH',
  Low = 'LOW'
}

export enum EnumOperatorEnrollmentsCurrentStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  NeedsApproval = 'NEEDS_APPROVAL',
  Unpublished = 'UNPUBLISHED'
}

export enum EnumOperatorEnrollmentsOnboardingStatus {
  CompletedOnboarding = 'COMPLETED_ONBOARDING',
  CompletedSurvey = 'COMPLETED_SURVEY',
  Incomplete = 'INCOMPLETE'
}

export enum EnumOperatorOperationalStatus {
  Open = 'OPEN',
  PermanentlyClosed = 'PERMANENTLY_CLOSED',
  TemporarilyClosed = 'TEMPORARILY_CLOSED'
}

export enum EnumOperatorPricing {
  Expensive = 'EXPENSIVE',
  Inexpensive = 'INEXPENSIVE',
  ModeratelyExpensive = 'MODERATELY_EXPENSIVE',
  VeryExpensive = 'VERY_EXPENSIVE'
}

export enum EnumOperatorType {
  Accommodation = 'ACCOMMODATION',
  Attraction = 'ATTRACTION',
  FestivalsAndEvents = 'FESTIVALS_AND_EVENTS',
  FoodAndBeverageBusinessType = 'FOOD_AND_BEVERAGE_BUSINESS_TYPE',
  Government = 'GOVERNMENT',
  OtherBusinessType = 'OTHER_BUSINESS_TYPE',
  OutdoorRecreation = 'OUTDOOR_RECREATION',
  Retail = 'RETAIL',
  Service = 'SERVICE',
  TourismOrganization = 'TOURISM_ORGANIZATION',
  TourismSupportOrAdjacent = 'TOURISM_SUPPORT_OR_ADJACENT',
  Tours = 'TOURS',
  Transportation = 'TRANSPORTATION',
  Venue = 'VENUE'
}

export enum EnumOrderApprovalStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export enum EnumOrderArrivalHistoryAction {
  Arrived = 'ARRIVED',
  Unmarked = 'UNMARKED'
}

export enum EnumOrderArrivalHistorySource {
  Manual = 'MANUAL',
  QrScan = 'QR_SCAN'
}

export enum EnumOrderBillingConsolidation {
  MonthlyStatement = 'MONTHLY_STATEMENT',
  PerBooking = 'PER_BOOKING'
}

export enum EnumOrderBillingTiming {
  AfterService = 'AFTER_SERVICE',
  AtCheckout = 'AT_CHECKOUT',
  OnApproval = 'ON_APPROVAL'
}

export enum EnumOrderDeliveryMethod {
  Pickup = 'PICKUP',
  Ship = 'SHIP'
}

export enum EnumOrderFulfillmentStatus {
  Fulfilled = 'FULFILLED',
  Packed = 'PACKED',
  PickedUp = 'PICKED_UP',
  Shipped = 'SHIPPED'
}

export enum EnumOrderSourceType {
  PaymentRequest = 'PAYMENT_REQUEST',
  Renewal = 'RENEWAL',
  Standard = 'STANDARD'
}

export enum EnumOrganizationAppSettingsWidgetsEventOrganizerAudienceTagFiltersMode {
  Exclude = 'exclude',
  Include = 'include'
}

export enum EnumOrganizationAppSettingsWidgetsEventVenueAudienceTagFiltersMode {
  Exclude = 'exclude',
  Include = 'include'
}

export enum EnumOrganizationAppSettingsWidgetsOperatorAudienceTagFiltersMode {
  Exclude = 'exclude',
  Include = 'include'
}

export enum EnumOrganizationAppSettingsWidgetsOperatorDefaultImageMode {
  CustomImage = 'CUSTOM_IMAGE',
  DefaultMissingImage = 'DEFAULT_MISSING_IMAGE',
  OrganizationLogo = 'ORGANIZATION_LOGO'
}

export enum EnumOrganizationAppSettingsWidgetsOperatorOperatorWidgetFilter {
  ClaimedAndDmoManagedOnly = 'CLAIMED_AND_DMO_MANAGED_ONLY',
  ClaimedOnly = 'CLAIMED_ONLY',
  None = 'NONE'
}

export enum EnumOrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFiltersMode {
  Exclude = 'exclude',
  Include = 'include'
}

export enum EnumOrganizationEmailDomainPreviousStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  DnsPending = 'DNS_PENDING',
  Requested = 'REQUESTED'
}

export enum EnumOrganizationEmailDomainStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  DnsPending = 'DNS_PENDING',
  Requested = 'REQUESTED'
}

export enum EnumOrganizationManifestAssetsPeopleAction {
  Delete = 'DELETE',
  Disconnect = 'DISCONNECT'
}

export enum EnumOrganizationMetadataDisabledApps {
  CustomLists = 'CUSTOM_LISTS',
  Directory = 'DIRECTORY',
  Events = 'EVENTS',
  Notes = 'NOTES',
  People = 'PEOPLE',
  Storefront = 'STOREFRONT',
  Tripper = 'TRIPPER',
  Widgets = 'WIDGETS'
}

export enum EnumOrganizationMetadataMembershipLaunchMode {
  Fresh = 'FRESH',
  FullImport = 'FULL_IMPORT',
  PartialImport = 'PARTIAL_IMPORT'
}

export enum EnumOrganizationMetadataMembershipLaunchSettingsAtLaunchRenewalType {
  Anniversary = 'ANNIVERSARY',
  FixedDate = 'FIXED_DATE'
}

export enum EnumOrganizationMetadataMembershipLaunchSettingsAtLaunchTerm {
  Lifetime = 'LIFETIME',
  Manual = 'MANUAL',
  Monthly = 'MONTHLY',
  MultiYear = 'MULTI_YEAR',
  Yearly = 'YEARLY'
}

export enum EnumOrganizationMetadataMembershipLaunchState {
  Launched = 'LAUNCHED',
  NotStarted = 'NOT_STARTED',
  Planning = 'PLANNING'
}

export enum EnumOrganizationMetadataRenewalSettingsRenewalType {
  Anniversary = 'ANNIVERSARY',
  FixedDate = 'FIXED_DATE'
}

export enum EnumOrganizationMetadataRenewalSettingsTerm {
  Lifetime = 'LIFETIME',
  Manual = 'MANUAL',
  Monthly = 'MONTHLY',
  MultiYear = 'MULTI_YEAR',
  Yearly = 'YEARLY'
}

export enum EnumOrganizationMetadataStorefrontMode {
  Both = 'BOTH',
  Cad = 'CAD',
  Usd = 'USD'
}

export enum EnumOwnerType {
  Operator = 'OPERATOR',
  Organization = 'ORGANIZATION',
  Storefront = 'STOREFRONT',
  TnbInternal = 'TNB_INTERNAL'
}

export enum EnumPaymentEntryMethod {
  BankTransfer = 'BANK_TRANSFER',
  Card = 'CARD',
  Cash = 'CASH',
  Cheque = 'CHEQUE',
  Complimentary = 'COMPLIMENTARY',
  Eft = 'EFT',
  Interac = 'INTERAC',
  OfflineDebit = 'OFFLINE_DEBIT',
  Other = 'OTHER',
  WireTransfer = 'WIRE_TRANSFER'
}

export enum EnumPaymentEntryType {
  Payment = 'PAYMENT',
  Refund = 'REFUND',
  Reversal = 'REVERSAL'
}

export enum EnumPaymentRequestChangeHistoryAction {
  AccountingMetadataUpdated = 'accounting_metadata_updated',
  Cancelled = 'cancelled',
  Created = 'created',
  ImportedTransaction = 'imported_transaction',
  InternalNote = 'internal_note',
  MarkedPending = 'marked_pending',
  OverpaymentResolved = 'overpayment_resolved',
  Paid = 'paid',
  PaymentRecorded = 'payment_recorded',
  PaymentReversed = 'payment_reversed',
  PendingUndone = 'pending_undone',
  Refunded = 'refunded',
  Resent = 'resent',
  Revised = 'revised',
  Sent = 'sent',
  SubmittedForReview = 'submitted_for_review',
  Updated = 'updated'
}

export enum EnumPaymentRequestChangeHistorySnapshotStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  ForReview = 'FOR_REVIEW',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Pending = 'PENDING',
  Revised = 'REVISED',
  Sent = 'SENT'
}

export enum EnumPaymentRequestDepositScheduleBalanceCollection {
  Card = 'CARD',
  CardOrInvoice = 'CARD_OR_INVOICE',
  Invoice = 'INVOICE'
}

export enum EnumPaymentRequestKind {
  Statement = 'STATEMENT'
}

export enum EnumPaymentRequestScheduledTransition {
  ForReview = 'FOR_REVIEW',
  Send = 'SEND'
}

export enum EnumPaymentRequestStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  ForReview = 'FOR_REVIEW',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Pending = 'PENDING',
  Revised = 'REVISED',
  Sent = 'SENT'
}

export enum EnumPendingRenewalEmailEmailKind {
  Cancelled = 'CANCELLED',
  Custom = 'CUSTOM',
  Expired = 'EXPIRED',
  Overdue = 'OVERDUE',
  Reminder = 'REMINDER',
  Success = 'SUCCESS'
}

export enum EnumPendingRenewalEmailStatus {
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export enum EnumPendingRenewalEmailSubjectType {
  Operator = 'OPERATOR',
  Person = 'PERSON'
}

export enum EnumPeopleContactMethod {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Sms = 'SMS'
}

export enum EnumPeopleVisibleToMetadataPhonesType {
  Fax = 'FAX',
  Home = 'HOME',
  Mobile = 'MOBILE',
  Other = 'OTHER',
  Work = 'WORK'
}

export enum EnumPeopleVisibleToSystemRoles {
  Customer = 'CUSTOMER',
  DmoStaff = 'DMOStaff',
  EventCreator = 'EVENT_CREATOR',
  Lead = 'LEAD',
  Operator = 'OPERATOR',
  WhereaboutsUser = 'WhereaboutsUser'
}

export enum EnumPeopleVisibleToTypes {
  Customer = 'CUSTOMER',
  DmoStaff = 'DMOStaff',
  EventCreator = 'EVENT_CREATOR',
  Lead = 'LEAD',
  Operator = 'OPERATOR',
  WhereaboutsUser = 'WhereaboutsUser'
}

export enum EnumPlaceOutlineType {
  LineString = 'LineString',
  MultiLineString = 'MultiLineString',
  MultiPolygon = 'MultiPolygon',
  Polygon = 'Polygon'
}

export enum EnumPlaceType {
  Country = 'COUNTRY',
  Municipality = 'MUNICIPALITY',
  Other = 'OTHER',
  Province = 'PROVINCE',
  Region = 'REGION',
  State = 'STATE',
  Trail = 'TRAIL'
}

export enum EnumPostHogDataMetadataAppContext {
  OhtoIntegration = 'ohto_integration',
  WhereaboutsNext = 'whereabouts_next',
  WidgetBooker = 'widget_booker',
  WidgetEventSubmit = 'widget_event_submit',
  WidgetEvents = 'widget_events',
  WidgetGallery = 'widget_gallery',
  WidgetMediaProfile = 'widget_media_profile',
  WidgetOperator = 'widget_operator',
  WidgetPromotions = 'widget_promotions',
  WidgetTripper = 'widget_tripper',
  WidgetWhatsNearby = 'widget_whats_nearby'
}

export enum EnumPostHogDataMetadataEventName {
  AmenitiesViewed = 'amenities_viewed',
  BookerLoaded = 'booker_loaded',
  BroadcastViewed = 'broadcast_viewed',
  BuyTicketsCheckoutClick = 'buy_tickets_checkout_click',
  CloseOperatorDetails = 'close_operator_details',
  CustomerDetailsAdded = 'customer_details_added',
  DatesSelected = 'dates_selected',
  DetailsClick = 'details_click',
  EntityImpression = 'entity_impression',
  ExpandedDetailsClick = 'expanded_details_click',
  ExpandedDetailsPageview = 'expanded_details_pageview',
  FilterTagAdded = 'filter_tag_added',
  FilterTagRemoved = 'filter_tag_removed',
  GuestsSelected = 'guests_selected',
  ItineraryEngaged = 'itinerary_engaged',
  MediaCtaClick = 'media_cta_click',
  MediaImpression = 'media_impression',
  MediaLike = 'media_like',
  MediaShare = 'media_share',
  OpenBookNowLink = 'open_book_now_link',
  OutboundClick = 'outbound_click',
  PaymentMethodAdded = 'payment_method_added',
  PdfDownload = 'pdf_download',
  PoliciesAccepted = 'policies_accepted',
  ProductAddedToCart = 'product_added_to_cart',
  ProductRemovedFromCart = 'product_removed_from_cart',
  ProductUpdatedInCart = 'product_updated_in_cart',
  PromoCodeApplied = 'promo_code_applied',
  PurchaseCompleted = 'purchase_completed',
  PurchaseFailed = 'purchase_failed',
  QuestionnaireCompleted = 'questionnaire_completed',
  ResourceCompleted = 'resource_completed',
  ResourceDownloaded = 'resource_downloaded',
  ResourceInProgress = 'resource_in_progress',
  ResourcePlayed = 'resource_played',
  ResourceViewed = 'resource_viewed',
  ScrollEventsLeft = 'scroll_events_left',
  ScrollEventsRight = 'scroll_events_right',
  ScrollOperatorsLeft = 'scroll_operators_left',
  ScrollOperatorsRight = 'scroll_operators_right',
  ScrollRecurringEventsDown = 'scroll_recurring_events_down',
  ScrollRecurringEventsUp = 'scroll_recurring_events_up',
  ScrollViewMoreTags = 'scroll_view_more_tags',
  ScrollViewPreviousTags = 'scroll_view_previous_tags',
  WidgetImpression = 'widget_impression',
  WidgetLaunch = 'widget_launch',
  WidgetView = 'widget_view'
}

export enum EnumPriceTierDiscountUnit {
  Fixed = 'FIXED',
  FlatRate = 'FLAT_RATE',
  Percentage = 'PERCENTAGE'
}

export enum EnumPriceTierPriceType {
  Flat = 'FLAT',
  PerGuest = 'PER_GUEST',
  PerNight = 'PER_NIGHT'
}

export enum EnumProductAddOnSettingsBusinessScope {
  PerBusiness = 'PER_BUSINESS',
  Shared = 'SHARED'
}

export enum EnumProductAddOnSettingsPricingScope {
  PerBusiness = 'PER_BUSINESS',
  PerPurchase = 'PER_PURCHASE'
}

export enum EnumProductCustomFieldsType {
  Boolean = 'BOOLEAN',
  LongText = 'LONG_TEXT',
  Select = 'SELECT',
  ShortText = 'SHORT_TEXT'
}

export enum EnumProductEventMetadataSellingType {
  FlexDays = 'FLEX_DAYS',
  FlexSlots = 'FLEX_SLOTS',
  FullEvent = 'FULL_EVENT',
  SingleDay = 'SINGLE_DAY',
  SingleSlot = 'SINGLE_SLOT'
}

export enum EnumProductEventMetadataSessionGranularity {
  Date = 'DATE',
  TimeSlot = 'TIME_SLOT',
  WholeEvent = 'WHOLE_EVENT'
}

export enum EnumProductEventMetadataTicketStructure {
  Packages = 'PACKAGES',
  Simple = 'SIMPLE'
}

export enum EnumProductPublicationStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  NeedsApproval = 'NEEDS_APPROVAL',
  Unpublished = 'UNPUBLISHED'
}

export enum EnumProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountUnit {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export enum EnumProductSellingConfigRecurringMultiListingMode {
  AllIncluded = 'ALL_INCLUDED',
  PerBusiness = 'PER_BUSINESS',
  Single = 'SINGLE'
}

export enum EnumProductSellingConfigRecurringRenewalType {
  FixedDate = 'FIXED_DATE',
  PurchaseDate = 'PURCHASE_DATE'
}

export enum EnumProductTierConditionClausesComparator {
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  In = 'IN',
  NotEquals = 'NOT_EQUALS'
}

export enum EnumProductTierConditionOperator {
  And = 'AND',
  Or = 'OR'
}

export enum EnumProductTierSessionScope {
  All = 'ALL',
  Custom = 'CUSTOM',
  PickN = 'PICK_N',
  Single = 'SINGLE'
}

export enum EnumProductType {
  Accommodation = 'ACCOMMODATION',
  Event = 'EVENT',
  Fee = 'FEE',
  Merch = 'MERCH',
  RenewableFee = 'RENEWABLE_FEE'
}

export enum EnumPromotionAccessOperatorStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  ForReview = 'FOR_REVIEW'
}

export enum EnumPromotionAvailabilityType {
  DateRange = 'DATE_RANGE',
  Ongoing = 'ONGOING',
  SpecificDates = 'SPECIFIC_DATES'
}

export enum EnumPromotionHistoryAction {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Edited = 'EDITED',
  OrgDisconnected = 'ORG_DISCONNECTED',
  Submitted = 'SUBMITTED',
  Uncancelled = 'UNCANCELLED'
}

export enum EnumPromotionHistorySourceType {
  Operator = 'OPERATOR',
  Organization = 'ORGANIZATION'
}

/** Who created the promotion (OPERATOR/ORGANIZATION), derived server-side at create time. */
export enum EnumPromotionSubmissionSource {
  Operator = 'OPERATOR',
  Organization = 'ORGANIZATION'
}

export enum EnumPublicMediaAttentionIssuesFlag {
  ListingClosed = 'listingClosed',
  ListingDisconnected = 'listingDisconnected',
  SourceMissing = 'sourceMissing'
}

export enum EnumPublicMediaMediaType {
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export enum EnumPublicMediaSourceKind {
  External = 'external',
  Listing = 'listing',
  Org = 'org'
}

export enum EnumPublicMediaStatus {
  Published = 'published',
  Unpublished = 'unpublished'
}

export enum EnumPublicationStatusStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  NeedsApproval = 'NEEDS_APPROVAL',
  Unpublished = 'UNPUBLISHED'
}

export enum EnumPurchasedProductCustomFieldResponsesType {
  Boolean = 'BOOLEAN',
  LongText = 'LONG_TEXT',
  Select = 'SELECT',
  ShortText = 'SHORT_TEXT'
}

export enum EnumRefundStatus {
  Failed = 'failed',
  Pending = 'pending',
  Succeeded = 'succeeded'
}

export enum EnumRenewableFeeMetadataRenewalType {
  FixedDate = 'FIXED_DATE',
  PurchaseDate = 'PURCHASE_DATE'
}

export enum EnumRenewablePurchaseRecurringLineItemsPricingScope {
  PerBusiness = 'PER_BUSINESS',
  PerPurchase = 'PER_PURCHASE'
}

export enum EnumRenewablePurchaseRenewalBilling {
  AutoCharge = 'AUTO_CHARGE',
  Invoice = 'INVOICE'
}

export enum EnumRenewablePurchaseStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Incomplete = 'INCOMPLETE',
  PastDue = 'PAST_DUE',
  PaymentDue = 'PAYMENT_DUE',
  PaymentPending = 'PAYMENT_PENDING'
}

export enum EnumRenewalInvoiceGenerationRunItemsRollbackStatus {
  RolledBack = 'ROLLED_BACK',
  SkippedCancelled = 'SKIPPED_CANCELLED',
  SkippedMissing = 'SKIPPED_MISSING',
  SkippedPaid = 'SKIPPED_PAID',
  SkippedPeriodDrift = 'SKIPPED_PERIOD_DRIFT',
  SkippedSent = 'SKIPPED_SENT'
}

export enum EnumRenewalInvoiceGenerationRunStatus {
  Completed = 'COMPLETED',
  PartiallyRolledBack = 'PARTIALLY_ROLLED_BACK',
  RolledBack = 'ROLLED_BACK'
}

export enum EnumRenewalRecordStatus {
  Approved = 'APPROVED',
  AwaitingPayment = 'AWAITING_PAYMENT',
  Cancelled = 'CANCELLED',
  Completing = 'COMPLETING',
  Failed = 'FAILED',
  Paid = 'PAID',
  PendingApproval = 'PENDING_APPROVAL',
  Processing = 'PROCESSING'
}

export enum EnumRoomType {
  Bath = 'BATH',
  Bed = 'BED'
}

export enum EnumRuleType {
  MaxBookableDate = 'MAX_BOOKABLE_DATE',
  MaxNights = 'MAX_NIGHTS',
  MinBookableDate = 'MIN_BOOKABLE_DATE',
  MinNights = 'MIN_NIGHTS',
  UnavailableCheckInDays = 'UNAVAILABLE_CHECK_IN_DAYS',
  UnavailableCheckOutDays = 'UNAVAILABLE_CHECK_OUT_DAYS'
}

export enum EnumScheduledPaymentStatus {
  Failed = 'FAILED',
  Idle = 'IDLE',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum EnumScheduledPaymentType {
  RemainingBalance = 'REMAINING_BALANCE',
  SecurityHold = 'SECURITY_HOLD'
}

export enum EnumSecurityDepositSettingsRateType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export enum EnumStatementGenerationRunItemsRollbackStatus {
  RolledBack = 'ROLLED_BACK',
  SkippedMissing = 'SKIPPED_MISSING',
  SkippedNotDraft = 'SKIPPED_NOT_DRAFT'
}

export enum EnumStatementGenerationRunStatus {
  Completed = 'COMPLETED',
  PartiallyRolledBack = 'PARTIALLY_ROLLED_BACK',
  RolledBack = 'ROLLED_BACK'
}

export enum EnumStorefrontPaymentsMode {
  FreeOnly = 'FREE_ONLY',
  Stripe = 'STRIPE'
}

export enum EnumStorefrontStripeRegion {
  Ca = 'CA',
  Us = 'US'
}

export enum EnumStripeMetadataInvoiceStatus {
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export enum EnumStripeMetadataSecurityHoldStatus {
  ChargeFailed = 'CHARGE_FAILED',
  ChargeSuccess = 'CHARGE_SUCCESS',
  HoldPlaced = 'HOLD_PLACED'
}

export enum EnumStripeOnboardingStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

export enum EnumSupportTicketClassificationCategory {
  AccountAccess = 'ACCOUNT_ACCESS',
  AutoReply = 'AUTO_REPLY',
  Billing = 'BILLING',
  Bounce = 'BOUNCE',
  Bug = 'BUG',
  ContentChangeRequest = 'CONTENT_CHANGE_REQUEST',
  FeatureRequest = 'FEATURE_REQUEST',
  HowTo = 'HOW_TO',
  Internal = 'INTERNAL',
  Spam = 'SPAM',
  System = 'SYSTEM',
  Unclear = 'UNCLEAR'
}

export enum EnumSupportTicketClassificationClassifiedBy {
  Human = 'HUMAN',
  Llm = 'LLM',
  Rule = 'RULE'
}

export enum EnumSupportTicketClassificationConfidence {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum EnumSupportTicketClassificationHumanType {
  FeatureRequest = 'FEATURE_REQUEST',
  Issue = 'ISSUE',
  Question = 'QUESTION'
}

export enum EnumSupportTicketClassificationSecondaryCategories {
  AccountAccess = 'ACCOUNT_ACCESS',
  AutoReply = 'AUTO_REPLY',
  Billing = 'BILLING',
  Bounce = 'BOUNCE',
  Bug = 'BUG',
  ContentChangeRequest = 'CONTENT_CHANGE_REQUEST',
  FeatureRequest = 'FEATURE_REQUEST',
  HowTo = 'HOW_TO',
  Internal = 'INTERNAL',
  Spam = 'SPAM',
  System = 'SYSTEM',
  Unclear = 'UNCLEAR'
}

export enum EnumSupportTicketClassificationSuggestedAction {
  Ignore = 'IGNORE',
  NeedsAccountAction = 'NEEDS_ACCOUNT_ACTION',
  NeedsBilling = 'NEEDS_BILLING',
  NeedsEngineering = 'NEEDS_ENGINEERING',
  SelfServeReply = 'SELF_SERVE_REPLY'
}

export enum EnumSupportTicketClassificationType {
  FeatureRequest = 'FEATURE_REQUEST',
  Issue = 'ISSUE',
  Question = 'QUESTION'
}

export enum EnumSupportTicketIdentityMatchKind {
  Ambiguous = 'AMBIGUOUS',
  Beacon = 'BEACON',
  InternalStaff = 'INTERNAL_STAFF',
  NoEmail = 'NO_EMAIL',
  PersonOnly = 'PERSON_ONLY',
  PlaceholderEmail = 'PLACEHOLDER_EMAIL',
  Unknown = 'UNKNOWN',
  UserAndPerson = 'USER_AND_PERSON',
  UserOnly = 'USER_ONLY'
}

export enum EnumSupportTicketIdentitySourceEmailField {
  Beacon = 'beacon',
  None = 'none',
  PrimaryCustomer = 'primaryCustomer',
  ThreadCreatedBy = 'threadCreatedBy'
}

export enum EnumSupportTicketInvestigationStatus {
  BudgetReached = 'BUDGET_REACHED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export enum EnumSupportTicketTriageStatus {
  Investigating = 'INVESTIGATING',
  New = 'NEW',
  Resolved = 'RESOLVED'
}

export enum EnumSurveyQuestionBusinessScope {
  PerBusiness = 'PER_BUSINESS',
  Shared = 'SHARED'
}

export enum EnumSurveyQuestionType {
  AddressSearch = 'ADDRESS_SEARCH',
  Boolean = 'BOOLEAN',
  CustomText = 'CUSTOM_TEXT',
  Date = 'DATE',
  LongText = 'LONG_TEXT',
  RichText = 'RICH_TEXT',
  SectionHeading = 'SECTION_HEADING',
  Select = 'SELECT',
  ShortText = 'SHORT_TEXT',
  Toggle = 'TOGGLE',
  WhereaboutsSearch = 'WHEREABOUTS_SEARCH'
}

export enum EnumSurveyQuestionWhereaboutsSearchEntityType {
  Operator = 'OPERATOR'
}

export enum EnumSurveyResponseAdminStatus {
  Read = 'READ',
  Unread = 'UNREAD'
}

export enum EnumSurveyResponseHistoryAction {
  AdminEdit = 'ADMIN_EDIT',
  Save = 'SAVE',
  Submit = 'SUBMIT'
}

export enum EnumSurveyResponseHistoryReviewStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum EnumSurveyResponseReviewStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum EnumSurveyResponseStatus {
  Draft = 'DRAFT',
  PendingReview = 'PENDING_REVIEW',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED'
}

export enum EnumTagEngineOwnedRole {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Overdue = 'OVERDUE',
  Renewing = 'RENEWING'
}

export enum EnumTagEntityTypes {
  Booker = 'BOOKER',
  Broadcast = 'BROADCAST',
  Event = 'EVENT',
  List = 'LIST',
  Note = 'NOTE',
  Operator = 'OPERATOR',
  Order = 'ORDER',
  Organization = 'ORGANIZATION',
  Person = 'PERSON',
  Product = 'PRODUCT',
  Promotion = 'PROMOTION',
  Storefront = 'STOREFRONT',
  Widget = 'WIDGET'
}

export enum EnumTagGroupKey {
  Accommodation = 'ACCOMMODATION',
  Accreditations = 'ACCREDITATIONS',
  AdventureAndOutdoorActivities = 'ADVENTURE_AND_OUTDOOR_ACTIVITIES',
  AdventureExtreme = 'ADVENTURE_EXTREME',
  ArtsAndCulture = 'ARTS_AND_CULTURE',
  ArtsCulture = 'ARTS_CULTURE',
  Attraction = 'ATTRACTION',
  BackOffice = 'BACK_OFFICE',
  BedroomSpecific = 'BEDROOM_SPECIFIC',
  BusinessNetworking = 'BUSINESS_NETWORKING',
  CampingRving = 'CAMPING_RVING',
  CommunitySocial = 'COMMUNITY_SOCIAL',
  CorporateTravel = 'CORPORATE_TRAVEL',
  EventExperience = 'EVENT_EXPERIENCE',
  ExperientialTourism = 'EXPERIENTIAL_TOURISM',
  FamilyEvents = 'FAMILY_EVENTS',
  FestivalsAndEvents = 'FESTIVALS_AND_EVENTS',
  Fishing = 'FISHING',
  FoodAndBeverageBusinessType = 'FOOD_AND_BEVERAGE_BUSINESS_TYPE',
  FoodAndBeverageGlobal = 'FOOD_AND_BEVERAGE_GLOBAL',
  FoodDrink = 'FOOD_DRINK',
  GlobalPerson = 'GLOBAL_PERSON',
  Government = 'GOVERNMENT',
  HealthWellness = 'HEALTH_WELLNESS',
  Heritage = 'HERITAGE',
  Hunting = 'HUNTING',
  MediaGallery = 'MEDIA_GALLERY',
  MembershipTiers = 'MEMBERSHIP_TIERS',
  MemberStatus = 'MEMBER_STATUS',
  NatureGardens = 'NATURE_GARDENS',
  OtherBusinessType = 'OTHER_BUSINESS_TYPE',
  OtherGlobal = 'OTHER_GLOBAL',
  OutdoorRecreation = 'OUTDOOR_RECREATION',
  Person = 'PERSON',
  Recreation = 'RECREATION',
  Region = 'REGION',
  Retail = 'RETAIL',
  RoofedAccommodation = 'ROOFED_ACCOMMODATION',
  ScienceDiscovery = 'SCIENCE_DISCOVERY',
  SeasonalOrThemes = 'SEASONAL_OR_THEMES',
  Service = 'SERVICE',
  Shopping = 'SHOPPING',
  Specializations = 'SPECIALIZATIONS',
  SportsOutdoor = 'SPORTS_OUTDOOR',
  StyleExperience = 'STYLE_EXPERIENCE',
  TechnologyInnovation = 'TECHNOLOGY_INNOVATION',
  TourismEnabler = 'TOURISM_ENABLER',
  TourismOrganization = 'TOURISM_ORGANIZATION',
  TourismSupportOrAdjacent = 'TOURISM_SUPPORT_OR_ADJACENT',
  Tours = 'TOURS',
  Transportation = 'TRANSPORTATION',
  Venue = 'VENUE',
  WellnessAndSpa = 'WELLNESS_AND_SPA',
  WellnessAndSpaAmenity = 'WELLNESS_AND_SPA_AMENITY'
}

export enum EnumTagGroupType {
  Amenity = 'AMENITY',
  BusinessType = 'BUSINESS_TYPE',
  Global = 'GLOBAL',
  GlobalEvent = 'GLOBAL_EVENT',
  GlobalPerson = 'GLOBAL_PERSON',
  OrganizationSpecific = 'ORGANIZATION_SPECIFIC'
}

export enum EnumTagRelationshipGeneratedBy {
  Ai = 'ai',
  CoOccurrence = 'co_occurrence',
  Manual = 'manual'
}

export enum EnumTagRelationshipType {
  Complements = 'complements',
  Similar = 'similar'
}

export enum EnumTagSuggestionAiResponseAction {
  Add = 'ADD',
  MaybeAdd = 'MAYBE_ADD',
  NotAdd = 'NOT_ADD'
}

export enum EnumTagSuggestionEntityTypes {
  Booker = 'BOOKER',
  Broadcast = 'BROADCAST',
  Event = 'EVENT',
  List = 'LIST',
  Note = 'NOTE',
  Operator = 'OPERATOR',
  Order = 'ORDER',
  Organization = 'ORGANIZATION',
  Person = 'PERSON',
  Product = 'PRODUCT',
  Promotion = 'PROMOTION',
  Storefront = 'STOREFRONT',
  Widget = 'WIDGET'
}

export enum EnumUserAccessOperatorsContactRoles {
  FinancialContact = 'FINANCIAL_CONTACT',
  PrimaryContact = 'PRIMARY_CONTACT'
}

export enum EnumUserAccessOperatorsRole {
  Developer = 'DEVELOPER',
  Editor = 'EDITOR',
  NoAccess = 'NO_ACCESS',
  Owner = 'OWNER',
  Staff = 'STAFF',
  ViewOnly = 'VIEW_ONLY'
}

export enum EnumUserAccessOperatorsStatus {
  Accepted = 'ACCEPTED',
  Invited = 'INVITED',
  NotInvited = 'NOT_INVITED',
  Requested = 'REQUESTED'
}

export enum EnumUserConfirmationCodesType {
  OperatorOwnershipConfirmation = 'OPERATOR_OWNERSHIP_CONFIRMATION'
}

export enum EnumUserEmailPreferencesFrequency {
  Always = 'ALWAYS',
  Daily = 'DAILY',
  Never = 'NEVER',
  Weekly = 'WEEKLY'
}

export enum EnumUserEmailPreferencesTemplateName {
  Broadcast = 'BROADCAST',
  Digest = 'DIGEST',
  Invite = 'INVITE',
  StorefrontTransaction = 'STOREFRONT_TRANSACTION',
  Transaction = 'TRANSACTION'
}

export enum EnumUserQuickLinksType {
  Broadcast = 'BROADCAST',
  Event = 'EVENT',
  Operator = 'OPERATOR',
  Organization = 'ORGANIZATION',
  Storefront = 'STOREFRONT'
}

export enum EnumUserStatus {
  Enrolled = 'ENROLLED',
  NotProvisioned = 'NOT_PROVISIONED',
  Provisioned = 'PROVISIONED'
}

export enum EnumUserSystemPermissions {
  Impersonation = 'IMPERSONATION',
  ListingUpdatesTriggerNeedsAttention = 'LISTING_UPDATES_TRIGGER_NEEDS_ATTENTION',
  TagDelete = 'TAG_DELETE',
  TagMerge = 'TAG_MERGE',
  TagSplit = 'TAG_SPLIT',
  TagSuggestionApprove = 'TAG_SUGGESTION_APPROVE',
  TagSuggestionDelete = 'TAG_SUGGESTION_DELETE',
  TagUpdate = 'TAG_UPDATE',
  TnbAdmin = 'TNB_ADMIN'
}

export enum EnumUserUserType {
  PrivateApi = 'PRIVATE_API',
  PublicApi = 'PUBLIC_API',
  TnbInternal = 'TNB_INTERNAL',
  Whereabouts = 'WHEREABOUTS'
}

export enum EnumVersionedEntityReferenceType {
  Booker = 'BOOKER',
  Broadcast = 'BROADCAST',
  Event = 'EVENT',
  List = 'LIST',
  Note = 'NOTE',
  Operator = 'OPERATOR',
  Order = 'ORDER',
  Organization = 'ORGANIZATION',
  Person = 'PERSON',
  Product = 'PRODUCT',
  Promotion = 'PROMOTION',
  Storefront = 'STOREFRONT',
  Widget = 'WIDGET'
}

export enum EnumWhereabotChatKind {
  Operators = 'operators',
  Workbench = 'workbench'
}

export enum EnumWhereabotChatStatus {
  Active = 'active',
  Archived = 'archived'
}

export enum EnumWhereabotMessageRole {
  Assistant = 'assistant',
  System = 'system',
  User = 'user'
}

export enum EnumWhereabotMessageSessionEventsType {
  Action = 'action',
  ConsoleError = 'consoleError',
  Flag = 'flag',
  GqlError = 'gqlError',
  Route = 'route'
}

export enum EnumWidgetEventSettingsDisplayType {
  Carousel = 'CAROUSEL',
  Grid = 'GRID'
}

export enum EnumWidgetEventSettingsPublicFilterMode {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE',
  None = 'NONE'
}

export enum EnumWidgetEventSettingsPublicFilterSort {
  Alphabetical = 'ALPHABETICAL',
  Popular = 'POPULAR'
}

export enum EnumWidgetOperatorSettingsListDisplayMode {
  Carousel = 'CAROUSEL',
  Grid = 'GRID'
}

export enum EnumWidgetOperatorSettingsSortStrategy {
  Alphabetical = 'ALPHABETICAL',
  Random = 'RANDOM'
}

export enum EnumWidgetPromotionSettingsDisplayType {
  Carousel = 'CAROUSEL',
  Grid = 'GRID'
}

export enum EnumWidgetType {
  Event = 'EVENT',
  Gallery = 'GALLERY',
  Inquiry = 'INQUIRY',
  Operator = 'OPERATOR',
  Promotion = 'PROMOTION',
  Tripper = 'TRIPPER'
}

export enum EnumWorkbenchFeatureDocsAudience {
  Internal = 'internal',
  Public = 'public'
}

export enum EnumWorkbenchFeatureDocsSource {
  Boot = 'boot',
  Push = 'push'
}

export enum EnumWorkbenchFeatureDocsSyncStatus {
  Missing = 'missing',
  Synced = 'synced'
}

export enum EnumWorkbenchFeaturePlanSource {
  Boot = 'boot',
  Push = 'push'
}

export enum EnumWorkbenchFeaturePlanSyncStatus {
  Missing = 'missing',
  Synced = 'synced'
}

export enum EnumWorkbenchSeedRunStatus {
  Cleaned = 'CLEANED',
  Created = 'CREATED',
  Failed = 'FAILED',
  PartiallyCleaned = 'PARTIALLY_CLEANED'
}

export enum EnumWorkbenchSuggestionCategory {
  Bug = 'bug',
  Docs = 'docs',
  Question = 'question',
  Scope = 'scope',
  Ux = 'ux'
}

export enum EnumWorkbenchSuggestionEditOperation {
  Append = 'append',
  InsertAfter = 'insertAfter',
  Replace = 'replace'
}

export enum EnumWorkbenchSuggestionKind {
  Edit = 'edit',
  Feedback = 'feedback'
}

export enum EnumWorkbenchSuggestionStatus {
  Accepted = 'accepted',
  Applied = 'applied',
  Dismissed = 'dismissed',
  Integrated = 'integrated',
  Pending = 'pending',
  Reviewed = 'reviewed'
}

export enum EnumWorkbenchSuggestionTarget {
  Docs = 'docs',
  Plan = 'plan'
}

export type ErrorInterface = {
  /** Generic error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type Event = {
  __typename?: 'Event';
  _id: Scalars['MongoID']['output'];
  access: EventAccess;
  attentionIssues: Array<Maybe<EventAttentionIssues>>;
  /** Publicly publishable, OPEN checkout widgets that sell tickets/passes for this event. Prefers the requesting organization's own widget(s); falls back to other sellers' only when the org has none. */
  checkoutWidgets?: Maybe<Array<Maybe<EventCheckoutWidget>>>;
  contact?: Maybe<Contact>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  createdByEmail: Scalars['String']['output'];
  createdByFirstName?: Maybe<Scalars['String']['output']>;
  createdByLastName?: Maybe<Scalars['String']['output']>;
  createdByPerson?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  /** Set when event is created via import; events with this set are excluded from daily digest notification emails */
  createdViaImportRunId?: Maybe<Scalars['MongoID']['output']>;
  description: Multilingual;
  duplicateDismissedAt?: Maybe<Scalars['Date']['output']>;
  duplicateDismissedBy?: Maybe<Scalars['MongoID']['output']>;
  /** The end date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  endDate?: Maybe<Scalars['String']['output']>;
  eventLocation?: Maybe<EventLocation>;
  eventLocations: Array<Maybe<EventLocation>>;
  eventOrganizer: EventLocation;
  history: Array<Maybe<EventHistory>>;
  images: Array<AssetImage>;
  locationType: EnumEventLocationType;
  otherLocations?: Maybe<Array<Maybe<EventLocation>>>;
  presentedBy?: Maybe<Multilingual>;
  price?: Maybe<Scalars['String']['output']>;
  recurrencePattern: EventRecurrencePattern;
  schedules: Array<Maybe<EventSchedules>>;
  /** The start date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  startDate: Scalars['String']['output'];
  /** Who created the event (GUEST/OPERATOR/ORGANIZATION), derived server-side at create time. Used to exclude operator-sourced drafts from an organization's Events app. */
  submissionSource?: Maybe<EnumEventSubmissionSource>;
  submitterPersonId?: Maybe<Scalars['MongoID']['output']>;
  suspectedDuplicateOf?: Maybe<Scalars['MongoID']['output']>;
  tags?: Maybe<EventTags>;
  ticketUrl?: Maybe<Scalars['String']['output']>;
  title: Multilingual;
  type: EnumEventType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  venue?: Maybe<Multilingual>;
};


export type EventEventLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type EventImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type EventAccess = {
  __typename?: 'EventAccess';
  disconnectedOrganizations?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  operator?: Maybe<EventAccessOperator>;
  organizations: Array<Maybe<EventAccessOperator>>;
};

export type EventAccessInput = {
  disconnectedOrganizations?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  operator?: InputMaybe<EventAccessOperatorInput>;
  organizations: Array<InputMaybe<EventAccessOperatorInput>>;
};

export type EventAccessOperator = {
  __typename?: 'EventAccessOperator';
  _entityId: Scalars['MongoID']['output'];
  addedVia?: Maybe<Scalars['MongoID']['output']>;
  source?: Maybe<EnumEventAccessOperatorSource>;
  status?: Maybe<EnumEventAccessOperatorStatus>;
  statusBeforeCancel?: Maybe<EnumEventAccessOperatorStatusBeforeCancel>;
};

export type EventAccessOperatorInput = {
  _entityId: Scalars['MongoID']['input'];
  addedVia?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumEventAccessOperatorSource>;
  status?: InputMaybe<EnumEventAccessOperatorStatus>;
  statusBeforeCancel?: InputMaybe<EnumEventAccessOperatorStatusBeforeCancel>;
};

export type EventAttentionIssues = {
  __typename?: 'EventAttentionIssues';
  sourceName?: Maybe<Scalars['String']['output']>;
  type: EnumEventAttentionIssuesType;
  venueIndex?: Maybe<Scalars['Float']['output']>;
};

export type EventAttentionIssuesInput = {
  sourceName?: InputMaybe<Scalars['String']['input']>;
  type: EnumEventAttentionIssuesType;
  venueIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type EventCalendarGuest = {
  __typename?: 'EventCalendarGuest';
  email?: Maybe<Scalars['String']['output']>;
  eventOptions?: Maybe<Array<Maybe<EventCalendarGuestOption>>>;
  name: Scalars['String']['output'];
};

export type EventCalendarGuestOption = {
  __typename?: 'EventCalendarGuestOption';
  amount?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  sourceTransactionId?: Maybe<Scalars['String']['output']>;
};

export type EventCalendarSaleItem = {
  __typename?: 'EventCalendarSaleItem';
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  sessions: Array<Scalars['String']['output']>;
  spanEndDate: Scalars['String']['output'];
  spanStartDate: Scalars['String']['output'];
  tierId: Scalars['String']['output'];
  tierName: Scalars['String']['output'];
  timeSlots?: Maybe<Array<Maybe<EventCalendarTimeSlot>>>;
  totalSold: Scalars['Int']['output'];
};

export type EventCalendarSessionOrder = {
  __typename?: 'EventCalendarSessionOrder';
  arrivalHistory?: Maybe<Array<Maybe<EventOrderArrivalEntry>>>;
  cancelled: Scalars['Boolean']['output'];
  customerName: Scalars['String']['output'];
  guestNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  guests?: Maybe<Array<Maybe<EventCalendarGuest>>>;
  isPass: Scalars['Boolean']['output'];
  orderId: Scalars['String']['output'];
  purchaseDate: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  sessionIds?: Maybe<Array<Scalars['String']['output']>>;
  tierName: Scalars['String']['output'];
};

export type EventCalendarSessionSale = {
  __typename?: 'EventCalendarSessionSale';
  eventDateArrivedCount: Scalars['Int']['output'];
  eventDatePassesSold: Scalars['Int']['output'];
  eventDateTicketsSold: Scalars['Int']['output'];
  eventDateTotalSold: Scalars['Int']['output'];
  eventId: Scalars['ID']['output'];
  eventName: Scalars['String']['output'];
  eventYearSessionCount?: Maybe<Scalars['Int']['output']>;
  isUnlimited: Scalars['Boolean']['output'];
  passesSold: Scalars['Int']['output'];
  productId: Scalars['ID']['output'];
  remainingCapacity?: Maybe<Scalars['Int']['output']>;
  sessionDate: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  ticketsSold: Scalars['Int']['output'];
  timeSlotLabel?: Maybe<Scalars['String']['output']>;
  totalCapacity?: Maybe<Scalars['Int']['output']>;
  totalSold: Scalars['Int']['output'];
};

export type EventCalendarTimeSlot = {
  __typename?: 'EventCalendarTimeSlot';
  from?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  to?: Maybe<Scalars['String']['output']>;
};

export type EventCheckoutWidget = {
  __typename?: 'EventCheckoutWidget';
  bookerId: Scalars['ID']['output'];
  embed?: Maybe<EventCheckoutWidgetEmbed>;
  image?: Maybe<AssetImage>;
  name?: Maybe<Multilingual>;
  sellingType?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  ticketStructure?: Maybe<Scalars['String']['output']>;
};

export type EventCheckoutWidgetEmbed = {
  __typename?: 'EventCheckoutWidgetEmbed';
  customElementHtml: Scalars['String']['output'];
  /** Self-contained snippet (script tag + <whereabouts-checkout-launcher> element) composing every published checkout widget for this event into a single "Buy tickets" button covering all of them. Paste as-is; no separate script include needed. */
  launcherHtml: Scalars['String']['output'];
  scriptHtml: Scalars['String']['output'];
  scriptSrc: Scalars['String']['output'];
};

export type EventDisconnectOrganizationPayload = {
  __typename?: 'EventDisconnectOrganizationPayload';
  record?: Maybe<Event>;
};

export type EventHistory = {
  __typename?: 'EventHistory';
  action: EnumEventHistoryAction;
  note?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['MongoID']['output']>;
  sourceType?: Maybe<EnumEventHistorySourceType>;
  timestamp: Scalars['Date']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['MongoID']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type EventHistoryInput = {
  action: EnumEventHistoryAction;
  note?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  sourceType?: InputMaybe<EnumEventHistorySourceType>;
  timestamp: Scalars['Date']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type EventInventorySettings = {
  __typename?: 'EventInventorySettings';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  defaultCapacityPerSession?: Maybe<Scalars['Float']['output']>;
  event: Scalars['MongoID']['output'];
  lowStockThreshold?: Maybe<Scalars['Float']['output']>;
  sessionOverrides?: Maybe<Array<Maybe<EventInventorySettingsSessionOverrides>>>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type EventInventorySettingsSessionOverrides = {
  __typename?: 'EventInventorySettingsSessionOverrides';
  capacity: Scalars['Float']['output'];
  sessionId: Scalars['String']['output'];
};

export type EventLinkedWidget = {
  __typename?: 'EventLinkedWidget';
  bookerId: Scalars['ID']['output'];
  name?: Maybe<Multilingual>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  productId: Scalars['ID']['output'];
  sellingType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  storefrontId: Scalars['ID']['output'];
  storefrontName?: Maybe<Multilingual>;
  ticketStructure?: Maybe<Scalars['String']['output']>;
};

export type EventLocation = {
  __typename?: 'EventLocation';
  contact?: Maybe<Contact>;
  locationInfo?: Maybe<EventLocationLocationInfo>;
  venue: Multilingual;
};

export type EventLocationInput = {
  contact?: InputMaybe<ContactInput>;
  locationInfo?: InputMaybe<EventLocationLocationInfoInput>;
  venue: MultilingualInput;
};

export type EventLocationLocationInfo = {
  __typename?: 'EventLocationLocationInfo';
  _entityId?: Maybe<Scalars['MongoID']['output']>;
  _id?: Maybe<Scalars['MongoID']['output']>;
  type?: Maybe<EnumEventLocationLocationInfoType>;
};

export type EventLocationLocationInfoInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumEventLocationLocationInfoType>;
};

export type EventOrderArrivalEntry = {
  __typename?: 'EventOrderArrivalEntry';
  action: Scalars['String']['output'];
  attendanceKeys?: Maybe<Array<Scalars['String']['output']>>;
  guestIndexes: Array<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  performedBy?: Maybe<Scalars['String']['output']>;
  performedByName?: Maybe<Scalars['String']['output']>;
  sessionIds?: Maybe<Array<Scalars['String']['output']>>;
  source: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type EventRecurrencePattern = {
  __typename?: 'EventRecurrencePattern';
  /** For monthly frequency, the extact date each month (e.g. the 15th) */
  dateOfMonth?: Maybe<Scalars['Float']['output']>;
  /** For monthly frequency, the weekday the event should occur on (used in conjuction with dayOfMonthOccurrence) (e.g. WE) */
  dayOfMonth?: Maybe<EnumEventRecurrencePatternDayOfMonth>;
  /** For monthly frequency, the weekday occurrence the event should occur on (used in conjuction with dayOfMonth) (e.g. 3). If this value is 5, it is treated as the 'last occurrence in the month' */
  dayOfMonthOccurrence?: Maybe<Scalars['Float']['output']>;
  /** For daily or weekly frequency, the weekday(s) to recur (e.g. Thursdays and Saturdays) */
  daysOfWeek?: Maybe<Array<Maybe<EnumEventRecurrencePatternDaysOfWeek>>>;
  /** The end date of the recurrence */
  endDate?: Maybe<Scalars['String']['output']>;
  frequency: EnumEventRecurrencePatternFrequency;
  interval?: Maybe<Scalars['Float']['output']>;
  /** For yearly frequency, the MM-dd of the year that the event should occur on */
  monthAndDateOfYear?: Maybe<Scalars['String']['output']>;
  /** A list of dates (yyyy-MM-dd) for the MULTI type event */
  multiDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A list of dates (yyyy-MM-dd) that should be skipped in the recurrence */
  skipDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type EventRecurrencePatternInput = {
  /** For monthly frequency, the extact date each month (e.g. the 15th) */
  dateOfMonth?: InputMaybe<Scalars['Float']['input']>;
  /** For monthly frequency, the weekday the event should occur on (used in conjuction with dayOfMonthOccurrence) (e.g. WE) */
  dayOfMonth?: InputMaybe<EnumEventRecurrencePatternDayOfMonth>;
  /** For monthly frequency, the weekday occurrence the event should occur on (used in conjuction with dayOfMonth) (e.g. 3). If this value is 5, it is treated as the 'last occurrence in the month' */
  dayOfMonthOccurrence?: InputMaybe<Scalars['Float']['input']>;
  /** For daily or weekly frequency, the weekday(s) to recur (e.g. Thursdays and Saturdays) */
  daysOfWeek?: InputMaybe<Array<InputMaybe<EnumEventRecurrencePatternDaysOfWeek>>>;
  /** The end date of the recurrence */
  endDate?: InputMaybe<Scalars['String']['input']>;
  frequency: EnumEventRecurrencePatternFrequency;
  interval?: InputMaybe<Scalars['Float']['input']>;
  /** For yearly frequency, the MM-dd of the year that the event should occur on */
  monthAndDateOfYear?: InputMaybe<Scalars['String']['input']>;
  /** A list of dates (yyyy-MM-dd) for the MULTI type event */
  multiDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of dates (yyyy-MM-dd) that should be skipped in the recurrence */
  skipDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EventSchedules = {
  __typename?: 'EventSchedules';
  allDay: Scalars['Boolean']['output'];
  timeSlots?: Maybe<Array<Maybe<EventSchedulesTimeSlots>>>;
};

export type EventSchedulesInput = {
  allDay: Scalars['Boolean']['input'];
  timeSlots?: InputMaybe<Array<InputMaybe<EventSchedulesTimeSlotsInput>>>;
};

export type EventSchedulesTimeSlots = {
  __typename?: 'EventSchedulesTimeSlots';
  _id?: Maybe<Scalars['MongoID']['output']>;
  endsNextDay?: Maybe<Scalars['Boolean']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type EventSchedulesTimeSlotsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  endsNextDay?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type EventSessionAvailability = {
  __typename?: 'EventSessionAvailability';
  isUnlimited: Scalars['Boolean']['output'];
  remainingCapacity?: Maybe<Scalars['Int']['output']>;
  sessionId: Scalars['String']['output'];
  totalCapacity?: Maybe<Scalars['Int']['output']>;
};

export type EventSessionCapacityOverrideInput = {
  capacity: Scalars['Int']['input'];
  sessionId: Scalars['String']['input'];
};

export enum EventStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  ForReview = 'FOR_REVIEW'
}

export type EventTags = {
  __typename?: 'EventTags';
  global: Array<Tag>;
  organizationSpecific: Array<Tag>;
};

export type EventTagsInput = {
  global?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type EventWithOccurrences = {
  __typename?: 'EventWithOccurrences';
  _id: Scalars['MongoID']['output'];
  access: EventAccess;
  attentionIssues: Array<Maybe<EventAttentionIssues>>;
  contact?: Maybe<Contact>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  createdByEmail: Scalars['String']['output'];
  createdByFirstName?: Maybe<Scalars['String']['output']>;
  createdByLastName?: Maybe<Scalars['String']['output']>;
  createdByPerson?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  /** Set when event is created via import; events with this set are excluded from daily digest notification emails */
  createdViaImportRunId?: Maybe<Scalars['MongoID']['output']>;
  description: Multilingual;
  duplicateDismissedAt?: Maybe<Scalars['Date']['output']>;
  duplicateDismissedBy?: Maybe<Scalars['MongoID']['output']>;
  /** The end date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  endDate?: Maybe<Scalars['String']['output']>;
  eventLocation?: Maybe<EventLocation>;
  eventLocations: Array<Maybe<EventLocation>>;
  eventOrganizer: EventLocation;
  history: Array<Maybe<EventHistory>>;
  images: Array<AssetImage>;
  locationType: EnumEventLocationType;
  occurrences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  otherLocations?: Maybe<Array<Maybe<EventLocation>>>;
  presentedBy?: Maybe<Multilingual>;
  price?: Maybe<Scalars['String']['output']>;
  recurrencePattern: EventRecurrencePattern;
  schedules: Array<Maybe<EventSchedules>>;
  /** The start date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  startDate: Scalars['String']['output'];
  /** Who created the event (GUEST/OPERATOR/ORGANIZATION), derived server-side at create time. Used to exclude operator-sourced drafts from an organization's Events app. */
  submissionSource?: Maybe<EnumEventSubmissionSource>;
  submitterPersonId?: Maybe<Scalars['MongoID']['output']>;
  suspectedDuplicateOf?: Maybe<Scalars['MongoID']['output']>;
  tags?: Maybe<EventTags>;
  ticketUrl?: Maybe<Scalars['String']['output']>;
  title: Multilingual;
  type: EnumEventType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  venue?: Maybe<Multilingual>;
};


export type EventWithOccurrencesEventLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type EventWithOccurrencesImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ExistingEntitySnapshot = {
  __typename?: 'ExistingEntitySnapshot';
  entityId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ExpelResult = {
  __typename?: 'ExpelResult';
  adminGatesCleared: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  orgGatesCleared: Scalars['Int']['output'];
  storefrontGatesCleared: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type ExperienceOperatorMetadata = {
  __typename?: 'ExperienceOperatorMetadata';
  _id?: Maybe<Scalars['MongoID']['output']>;
};

export type ExperienceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FastForwardLogEntry = {
  __typename?: 'FastForwardLogEntry';
  detail?: Maybe<Scalars['String']['output']>;
  event: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type FastForwardRenewalsResult = {
  __typename?: 'FastForwardRenewalsResult';
  autoChargesProcessed: Scalars['Int']['output'];
  invoicesProcessed: Scalars['Int']['output'];
  log?: Maybe<Array<Maybe<FastForwardLogEntry>>>;
  purchasesAdvanced: Scalars['Int']['output'];
  recordsCreated: Scalars['Int']['output'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expelledAt?: Maybe<Scalars['Date']['output']>;
  expelledBy?: Maybe<Scalars['MongoID']['output']>;
  expelledReason?: Maybe<Scalars['String']['output']>;
  expelledReviewChat?: Maybe<Scalars['MongoID']['output']>;
  graduatedAt?: Maybe<Scalars['Date']['output']>;
  graduatedBy?: Maybe<Scalars['MongoID']['output']>;
  group: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  scope: EnumFeatureFlagScope;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type FeatureFlagAdminGate = {
  __typename?: 'FeatureFlagAdminGate';
  email: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  hasExplicitGate: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  userId: Scalars['MongoID']['output'];
};

export type FeatureFlagOrgGate = {
  __typename?: 'FeatureFlagOrgGate';
  enabled: Scalars['Boolean']['output'];
  hasExplicitGate: Scalars['Boolean']['output'];
  organizationId: Scalars['MongoID']['output'];
  organizationName: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagStorefrontGate = {
  __typename?: 'FeatureFlagStorefrontGate';
  enabled: Scalars['Boolean']['output'];
  hasExplicitGate: Scalars['Boolean']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  storefrontId: Scalars['MongoID']['output'];
  storefrontName: Scalars['String']['output'];
  testMode: Scalars['Boolean']['output'];
};

export type FeatureFlagWithGateCount = {
  __typename?: 'FeatureFlagWithGateCount';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabledCount: Scalars['Int']['output'];
  expelled: Scalars['Boolean']['output'];
  expelledAt?: Maybe<Scalars['Date']['output']>;
  expelledBy?: Maybe<Scalars['MongoID']['output']>;
  expelledReason?: Maybe<Scalars['String']['output']>;
  expelledReviewChat?: Maybe<Scalars['MongoID']['output']>;
  graduated: Scalars['Boolean']['output'];
  graduatedAt?: Maybe<Scalars['Date']['output']>;
  graduatedBy?: Maybe<Scalars['MongoID']['output']>;
  group: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  scope: EnumFeatureFlagScope;
  totalTargetCount: Scalars['Int']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type FilterCountActivityLogBulkConnectLogIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountActivityLogEmailActivityFromAddressInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountActivityLogEmailActivityInput = {
  fromAddress?: InputMaybe<FilterCountActivityLogEmailActivityFromAddressInput>;
  recipients?: InputMaybe<Array<InputMaybe<FilterCountActivityLogEmailActivityRecipientsInput>>>;
  sentHtml?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  templatePreviewHtml?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountActivityLogEmailActivityRecipientsInput = {
  bouncedAt?: InputMaybe<Scalars['Date']['input']>;
  clickedAt?: InputMaybe<Scalars['Date']['input']>;
  deferredAt?: InputMaybe<Scalars['Date']['input']>;
  deliveredAt?: InputMaybe<Scalars['Date']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  droppedAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  openedAt?: InputMaybe<Scalars['Date']['input']>;
  personId?: InputMaybe<Scalars['MongoID']['input']>;
  spamReportedAt?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountActivityLogEntityOperatorsInput = {
  _entityId?: InputMaybe<FilterCountActivityLogEntity_EntityIdOperatorsInput>;
};

export type FilterCountActivityLogEntity_EntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountActivityLogImportRunIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountActivityLogInput = {
  AND?: InputMaybe<Array<FilterCountActivityLogInput>>;
  OR?: InputMaybe<Array<FilterCountActivityLogInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountActivityLogOperatorsInput>;
  bulkConnectLogId?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  emailActivity?: InputMaybe<FilterCountActivityLogEmailActivityInput>;
  entity?: InputMaybe<FilterCountEntityReferenceInput>;
  entityName?: InputMaybe<FilterCountMultilingualInput>;
  importRunId?: InputMaybe<Scalars['MongoID']['input']>;
  initiatedBy?: InputMaybe<Scalars['String']['input']>;
  initiatedByPerson?: InputMaybe<Scalars['MongoID']['input']>;
  initiatedByUser?: InputMaybe<Scalars['MongoID']['input']>;
  message?: InputMaybe<FilterCountMultilingualInput>;
  owner?: InputMaybe<FilterCountOwnerInput>;
  resourceId?: InputMaybe<Scalars['MongoID']['input']>;
  surveyResponseId?: InputMaybe<Scalars['MongoID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumActivityLogType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountActivityLogOperatorsInput = {
  _id?: InputMaybe<FilterCountActivityLog_IdOperatorsInput>;
  bulkConnectLogId?: InputMaybe<FilterCountActivityLogBulkConnectLogIdOperatorsInput>;
  entity?: InputMaybe<FilterCountActivityLogEntityOperatorsInput>;
  importRunId?: InputMaybe<FilterCountActivityLogImportRunIdOperatorsInput>;
};

export type FilterCountActivityLog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<AddressLocationInput>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountBroadcastInput = {
  AND?: InputMaybe<Array<FilterCountBroadcastInput>>;
  OR?: InputMaybe<Array<FilterCountBroadcastInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountBroadcastOperatorsInput>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterCountMultilingualInput>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FilterCountMultilingualInput>;
  owner?: InputMaybe<FilterCountOwnerInput>;
  publicName?: InputMaybe<FilterCountMultilingualInput>;
  resources?: InputMaybe<Array<InputMaybe<FilterCountBroadcastResourcesInput>>>;
  sharedTo?: InputMaybe<FilterCountBroadcastSharedToInput>;
  status?: InputMaybe<EnumBroadcastStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountBroadcastOperatorsInput = {
  _id?: InputMaybe<FilterCountBroadcast_IdOperatorsInput>;
};

export type FilterCountBroadcastResourcesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  allowResubmission?: InputMaybe<Scalars['Boolean']['input']>;
  allowSaveAndEdit?: InputMaybe<Scalars['Boolean']['input']>;
  booker?: InputMaybe<Scalars['MongoID']['input']>;
  completionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  course?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<FilterCountMultilingualInput>;
  description?: InputMaybe<FilterCountMultilingualInput>;
  expirationTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  file?: InputMaybe<Scalars['String']['input']>;
  formMode?: InputMaybe<EnumBroadcastResourcesFormMode>;
  iframeUrl?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<FilterCountMultilingualInput>;
  paymentRequestId?: InputMaybe<Scalars['MongoID']['input']>;
  photos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requireApproval?: InputMaybe<Scalars['Boolean']['input']>;
  submissionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  survey?: InputMaybe<Scalars['String']['input']>;
  teamVisible?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<FilterCountMultilingualInput>;
  type?: InputMaybe<EnumBroadcastResourcesType>;
  video?: InputMaybe<Scalars['String']['input']>;
  videoURL?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountBroadcastSharedToInput = {
  operatorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sentToPeople?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  sentToPeopleSystemRoles?: InputMaybe<Array<InputMaybe<EnumBroadcastSharedToSentToPeopleSystemRoles>>>;
  sentToPeopleTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  skipEmails?: InputMaybe<Scalars['Boolean']['input']>;
  teaser?: InputMaybe<FilterCountBroadcastSharedToTeaserInput>;
  type?: InputMaybe<EnumBroadcastSharedToType>;
};

export type FilterCountBroadcastSharedToTeaserInput = {
  description?: InputMaybe<FilterCountMultilingualInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountBroadcast_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountContactInput = {
  address?: InputMaybe<FilterCountAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<FilterCountLinksInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  tollFreePublicPhone?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountEntityReferenceInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumEntityReferenceType>;
};

export type FilterCountImportGoogleSheetsConfigInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
  serviceAccountKey?: InputMaybe<Scalars['String']['input']>;
  sheetId?: InputMaybe<Scalars['String']['input']>;
  sheetUrl?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountImportInput = {
  AND?: InputMaybe<Array<FilterCountImportInput>>;
  OR?: InputMaybe<Array<FilterCountImportInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountImportOperatorsInput>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  googleSheetsConfig?: InputMaybe<FilterCountImportGoogleSheetsConfigInput>;
  importType?: InputMaybe<EnumImportImportType>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumImportStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountImportOperatorsInput = {
  _id?: InputMaybe<FilterCountImport_IdOperatorsInput>;
};

export type FilterCountImportRunDryRunLogInput = {
  connectedOperatorName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  existingEntityId?: InputMaybe<Scalars['String']['input']>;
  existingOperatorEntityId?: InputMaybe<Scalars['String']['input']>;
  existingOperatorOrganizerId?: InputMaybe<Scalars['String']['input']>;
  existingOperatorOrganizerName?: InputMaybe<Scalars['String']['input']>;
  fieldsToUpdate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasAddress?: InputMaybe<Scalars['Boolean']['input']>;
  hasContact?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescription?: InputMaybe<Scalars['Boolean']['input']>;
  imageCount?: InputMaybe<Scalars['Float']['input']>;
  isExisting?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  missingOrganizer?: InputMaybe<Scalars['Boolean']['input']>;
  missingVenue?: InputMaybe<Scalars['Boolean']['input']>;
  operatorName?: InputMaybe<Scalars['String']['input']>;
  operatorType?: InputMaybe<Scalars['String']['input']>;
  organizerCouldNotConnect?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<EnumImportRunDryRunLogStatus>;
  unresolvedOrganizerName?: InputMaybe<Scalars['String']['input']>;
  unresolvedVenueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  willBeConnectedToOperator?: InputMaybe<Scalars['Boolean']['input']>;
  willConnectToExistingOperatorAsOrganizer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountImportRunEntitiesManuallyConnectedToOrgImportDataInput = {
  fields?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<FilterCountImportRunEntitiesManuallyConnectedToOrgImportDataTagsInput>;
};

export type FilterCountImportRunEntitiesManuallyConnectedToOrgImportDataTagsInput = {
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterCountImportRunEntitiesManuallyConnectedToOrgInput = {
  addedImageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedNoteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approvedVersionId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  importData?: InputMaybe<FilterCountImportRunEntitiesManuallyConnectedToOrgImportDataInput>;
  mergeOption?: InputMaybe<EnumImportRunEntitiesManuallyConnectedToOrgMergeOption>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  versionIdBeforeImport?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountImportRunExistingEntitiesImportDataInput = {
  fields?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<FilterCountImportRunExistingEntitiesImportDataTagsInput>;
};

export type FilterCountImportRunExistingEntitiesImportDataTagsInput = {
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterCountImportRunExistingEntitiesInput = {
  addedImageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedNoteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approvedVersionId?: InputMaybe<Scalars['String']['input']>;
  createdPublicationStatusIds?: InputMaybe<Scalars['JSON']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  importData?: InputMaybe<FilterCountImportRunExistingEntitiesImportDataInput>;
  mergeOption?: InputMaybe<EnumImportRunExistingEntitiesMergeOption>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previousPublicationStatuses?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  versionIdBeforeImport?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountImportRunExistingOperatorsImportDataInput = {
  fields?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<FilterCountImportRunExistingOperatorsImportDataTagsInput>;
};

export type FilterCountImportRunExistingOperatorsImportDataTagsInput = {
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterCountImportRunExistingOperatorsInput = {
  addedImageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedNoteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approvedVersionId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  importData?: InputMaybe<FilterCountImportRunExistingOperatorsImportDataInput>;
  mergeOption?: InputMaybe<EnumImportRunExistingOperatorsMergeOption>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  versionIdBeforeImport?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountImportRunImportedEntitiesInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountImportRunImportedOperatorsInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountImportRunInput = {
  AND?: InputMaybe<Array<FilterCountImportRunInput>>;
  OR?: InputMaybe<Array<FilterCountImportRunInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountImportRunOperatorsInput>;
  checkForExistingOperators?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  createdEntityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdNoteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdOperatorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  dryRunLog?: InputMaybe<Array<InputMaybe<FilterCountImportRunDryRunLogInput>>>;
  endingRow?: InputMaybe<Scalars['Float']['input']>;
  entitiesManuallyConnectedToOrg?: InputMaybe<Array<InputMaybe<FilterCountImportRunEntitiesManuallyConnectedToOrgInput>>>;
  entityCount?: InputMaybe<Scalars['Float']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  existingEntities?: InputMaybe<Array<InputMaybe<FilterCountImportRunExistingEntitiesInput>>>;
  existingOperators?: InputMaybe<Array<InputMaybe<FilterCountImportRunExistingOperatorsInput>>>;
  import?: InputMaybe<Scalars['MongoID']['input']>;
  importedEntities?: InputMaybe<Array<InputMaybe<FilterCountImportRunImportedEntitiesInput>>>;
  importedOperators?: InputMaybe<Array<InputMaybe<FilterCountImportRunImportedOperatorsInput>>>;
  isUpdateMode?: InputMaybe<Scalars['Boolean']['input']>;
  jobs?: InputMaybe<FilterCountImportRunJobsInput>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  operatorCount?: InputMaybe<Scalars['Float']['input']>;
  operatorsManuallyConnectedToOrg?: InputMaybe<Array<InputMaybe<FilterCountImportRunOperatorsManuallyConnectedToOrgInput>>>;
  rollbackInfo?: InputMaybe<FilterCountImportRunRollbackInfoInput>;
  rowsImported?: InputMaybe<Scalars['Float']['input']>;
  serverLogs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skipImages?: InputMaybe<Scalars['Boolean']['input']>;
  startedBy?: InputMaybe<Scalars['String']['input']>;
  startingRow?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<EnumImportRunStatus>;
  totalRowsAvailable?: InputMaybe<Scalars['Float']['input']>;
  updateRollbackSnapshots?: InputMaybe<Array<InputMaybe<FilterCountImportRunUpdateRollbackSnapshotsInput>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterCountImportRunJobsInput = {
  errorList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountImportRunOperatorsInput = {
  _id?: InputMaybe<FilterCountImportRun_IdOperatorsInput>;
};

export type FilterCountImportRunOperatorsManuallyConnectedToOrgImportDataInput = {
  fields?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<FilterCountImportRunOperatorsManuallyConnectedToOrgImportDataTagsInput>;
};

export type FilterCountImportRunOperatorsManuallyConnectedToOrgImportDataTagsInput = {
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterCountImportRunOperatorsManuallyConnectedToOrgInput = {
  addedImageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedNoteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approvedVersionId?: InputMaybe<Scalars['String']['input']>;
  createdPublicationStatusIds?: InputMaybe<Scalars['JSON']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  importData?: InputMaybe<FilterCountImportRunOperatorsManuallyConnectedToOrgImportDataInput>;
  mergeOption?: InputMaybe<EnumImportRunOperatorsManuallyConnectedToOrgMergeOption>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previousPublicationStatuses?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  versionIdBeforeImport?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountImportRunRollbackInfoInput = {
  deletedCount?: InputMaybe<Scalars['Float']['input']>;
  entityIdsInCreatedEntityIds?: InputMaybe<Scalars['Float']['input']>;
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imagesDeleted?: InputMaybe<Scalars['Float']['input']>;
  importedEntitiesCount?: InputMaybe<Scalars['Float']['input']>;
  rolledBackAt?: InputMaybe<Scalars['Date']['input']>;
  rolledBackBy?: InputMaybe<Scalars['String']['input']>;
  serverLogs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  totalEntityDocumentsDeleted?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountImportRunUpdateRollbackSnapshotsInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  newValue?: InputMaybe<Scalars['JSON']['input']>;
  originalValue?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterCountImportRun_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountImport_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountLinksInput = {
  bookNow?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  googleMyBusiness?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  otherUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pinterest?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  tripAdvisor?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountMultilingualInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountNoteInput = {
  AND?: InputMaybe<Array<FilterCountNoteInput>>;
  OR?: InputMaybe<Array<FilterCountNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountNoteOperatorsInput>;
  author?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entity?: InputMaybe<FilterCountEntityReferenceInput>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<EnumNoteKind>;
  mentions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  noteDateISO?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<FilterCountOwnerInput>;
  resolvedBy?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterCountNoteKindOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumNoteKind>;
  gte?: InputMaybe<EnumNoteKind>;
  in?: InputMaybe<Array<InputMaybe<EnumNoteKind>>>;
  lt?: InputMaybe<EnumNoteKind>;
  lte?: InputMaybe<EnumNoteKind>;
  ne?: InputMaybe<EnumNoteKind>;
  nin?: InputMaybe<Array<InputMaybe<EnumNoteKind>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountNoteOperatorsInput = {
  _id?: InputMaybe<FilterCountNote_IdOperatorsInput>;
  kind?: InputMaybe<FilterCountNoteKindOperatorsInput>;
};

export type FilterCountNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountOrganizationAppSettingsInput = {
  widgets?: InputMaybe<FilterCountOrganizationAppSettingsWidgetsInput>;
};

export type FilterCountOrganizationAppSettingsWidgetsEventInput = {
  hideCancelledEvents?: InputMaybe<Scalars['Boolean']['input']>;
  organizerAudienceTagFilters?: InputMaybe<Array<InputMaybe<FilterCountOrganizationAppSettingsWidgetsEventOrganizerAudienceTagFiltersInput>>>;
  venueAudienceTagFilters?: InputMaybe<Array<InputMaybe<FilterCountOrganizationAppSettingsWidgetsEventVenueAudienceTagFiltersInput>>>;
};

export type FilterCountOrganizationAppSettingsWidgetsEventOrganizerAudienceTagFiltersInput = {
  mode?: InputMaybe<EnumOrganizationAppSettingsWidgetsEventOrganizerAudienceTagFiltersMode>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountOrganizationAppSettingsWidgetsEventVenueAudienceTagFiltersInput = {
  mode?: InputMaybe<EnumOrganizationAppSettingsWidgetsEventVenueAudienceTagFiltersMode>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountOrganizationAppSettingsWidgetsInput = {
  event?: InputMaybe<FilterCountOrganizationAppSettingsWidgetsEventInput>;
  operator?: InputMaybe<FilterCountOrganizationAppSettingsWidgetsOperatorInput>;
  whatsNearby?: InputMaybe<FilterCountOrganizationAppSettingsWidgetsWhatsNearbyInput>;
};

export type FilterCountOrganizationAppSettingsWidgetsOperatorAudienceTagFiltersInput = {
  mode?: InputMaybe<EnumOrganizationAppSettingsWidgetsOperatorAudienceTagFiltersMode>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountOrganizationAppSettingsWidgetsOperatorInput = {
  audienceTagFilters?: InputMaybe<Array<InputMaybe<FilterCountOrganizationAppSettingsWidgetsOperatorAudienceTagFiltersInput>>>;
  audienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultImageId?: InputMaybe<Scalars['String']['input']>;
  defaultImageMode?: InputMaybe<EnumOrganizationAppSettingsWidgetsOperatorDefaultImageMode>;
  hidePermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  hideTemporarilyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  operatorWidgetFilter?: InputMaybe<EnumOrganizationAppSettingsWidgetsOperatorOperatorWidgetFilter>;
  prioritizeClaimedAndDmoManaged?: InputMaybe<Scalars['Boolean']['input']>;
  showPermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  showTestListings?: InputMaybe<Scalars['Boolean']['input']>;
  tierDisplayOverrides?: InputMaybe<Array<InputMaybe<FilterCountOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesInput>>>;
  tieredSortOrder?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesInput = {
  slideout?: InputMaybe<FilterCountOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesSlideoutInput>;
  statusSortOrder?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
  teaser?: InputMaybe<FilterCountOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesTeaserInput>;
};

export type FilterCountOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesSlideoutInput = {
  hideAddress?: InputMaybe<Scalars['Boolean']['input']>;
  hideExternalLinks?: InputMaybe<Scalars['Boolean']['input']>;
  hideLongDescription?: InputMaybe<Scalars['Boolean']['input']>;
  hideMap?: InputMaybe<Scalars['Boolean']['input']>;
  hideOperatingHours?: InputMaybe<Scalars['Boolean']['input']>;
  limitImages?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesTeaserInput = {
  hideImage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountOrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFiltersInput = {
  mode?: InputMaybe<EnumOrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFiltersMode>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountOrganizationAppSettingsWidgetsWhatsNearbyInput = {
  audienceTagFilters?: InputMaybe<Array<InputMaybe<FilterCountOrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFiltersInput>>>;
  audienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountOrganizationEmailBrandingInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  footerText?: InputMaybe<FilterCountMultilingualInput>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountOrganizationInput = {
  AND?: InputMaybe<Array<FilterCountOrganizationInput>>;
  OR?: InputMaybe<Array<FilterCountOrganizationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountOrganizationOperatorsInput>;
  appSettings?: InputMaybe<FilterCountOrganizationAppSettingsInput>;
  brandColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<FilterCountContactInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterCountMultilingualInput>;
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailBranding?: InputMaybe<FilterCountOrganizationEmailBrandingInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  license?: InputMaybe<FilterCountOrganizationLicenseInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<FilterCountOrganizationMetadataInput>;
  name?: InputMaybe<FilterCountMultilingualInput>;
  onboardingMetadata?: InputMaybe<FilterCountOrganizationOnboardingMetadataInput>;
  shortDescription?: InputMaybe<FilterCountMultilingualInput>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterCountOrganizationLicenseInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  activatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  activatedDate?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountOrganizationMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  canEnableMembershipLink?: InputMaybe<Scalars['Boolean']['input']>;
  claimedListingStaleDays?: InputMaybe<Scalars['Float']['input']>;
  connectedOperator?: InputMaybe<Scalars['MongoID']['input']>;
  connectedStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  connectedTestStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  connectedUsdStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  connectedUsdTestStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  crowdriffEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  customClaimEmailBody?: InputMaybe<Scalars['String']['input']>;
  customClaimEmailSubject?: InputMaybe<Scalars['String']['input']>;
  customPingEmailBody?: InputMaybe<Scalars['String']['input']>;
  customPingEmailSubject?: InputMaybe<Scalars['String']['input']>;
  disabledApps?: InputMaybe<Array<InputMaybe<EnumOrganizationMetadataDisabledApps>>>;
  dmoListingStaleDays?: InputMaybe<Scalars['Float']['input']>;
  eventLookaheadMonths?: InputMaybe<Scalars['Float']['input']>;
  eventPartnerOrganizations?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  eventSharingCode?: InputMaybe<Scalars['String']['input']>;
  externalVideoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  individualMembershipTiers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  internalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inviteWhenAddingStaff?: InputMaybe<Scalars['Boolean']['input']>;
  listingAudienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  listingFreshnessEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  membershipBroadcastId?: InputMaybe<Scalars['MongoID']['input']>;
  membershipHub?: InputMaybe<FilterCountOrganizationMetadataMembershipHubInput>;
  membershipLaunch?: InputMaybe<FilterCountOrganizationMetadataMembershipLaunchInput>;
  membershipPageUrl?: InputMaybe<Scalars['String']['input']>;
  membershipPaymentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  membershipStatusTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  membershipTierCheckouts?: InputMaybe<Array<InputMaybe<FilterCountOrganizationMetadataMembershipTierCheckoutsInput>>>;
  membershipTiers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  nomenclature?: InputMaybe<FilterCountOrganizationMetadataNomenclatureInput>;
  operatorOnboardingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  renewalSettings?: InputMaybe<FilterCountOrganizationMetadataRenewalSettingsInput>;
  sandbox?: InputMaybe<Scalars['Boolean']['input']>;
  storefrontMode?: InputMaybe<EnumOrganizationMetadataStorefrontMode>;
  storefrontOrgConnectionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  testRecordTagId?: InputMaybe<Scalars['MongoID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  whereabotImageDownloadPrompt?: InputMaybe<Scalars['String']['input']>;
  whereabotListingUpdatePrompt?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountOrganizationMetadataMembershipHubInput = {
  hideOfferFromForYou?: InputMaybe<Scalars['Boolean']['input']>;
  tiers?: InputMaybe<Array<InputMaybe<FilterCountOrganizationMetadataMembershipHubTiersInput>>>;
};

export type FilterCountOrganizationMetadataMembershipHubTiersInput = {
  applicationBroadcastId?: InputMaybe<Scalars['MongoID']['input']>;
  applicationResourceId?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<FilterCountMultilingualInput>;
  hideFromNewcomers?: InputMaybe<Scalars['Boolean']['input']>;
  tierTagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountOrganizationMetadataMembershipLaunchInput = {
  launchedAt?: InputMaybe<Scalars['Date']['input']>;
  launchedBy?: InputMaybe<Scalars['MongoID']['input']>;
  mode?: InputMaybe<EnumOrganizationMetadataMembershipLaunchMode>;
  recordedRetroactively?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleHistory?: InputMaybe<Array<InputMaybe<FilterCountOrganizationMetadataMembershipLaunchScheduleHistoryInput>>>;
  settingsAtLaunch?: InputMaybe<FilterCountOrganizationMetadataMembershipLaunchSettingsAtLaunchInput>;
  state?: InputMaybe<EnumOrganizationMetadataMembershipLaunchState>;
};

export type FilterCountOrganizationMetadataMembershipLaunchScheduleHistoryInput = {
  affected?: InputMaybe<Scalars['Float']['input']>;
  at?: InputMaybe<Scalars['Date']['input']>;
  by?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  from?: InputMaybe<FilterCountOrganizationMetadataMembershipLaunchSettingsAtLaunchInput>;
  intent?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<FilterCountOrganizationMetadataMembershipLaunchSettingsAtLaunchInput>;
};

export type FilterCountOrganizationMetadataMembershipLaunchSettingsAtLaunchInput = {
  fixedRenewalDay?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalMonth?: InputMaybe<Scalars['Float']['input']>;
  renewalType?: InputMaybe<EnumOrganizationMetadataMembershipLaunchSettingsAtLaunchRenewalType>;
  term?: InputMaybe<EnumOrganizationMetadataMembershipLaunchSettingsAtLaunchTerm>;
  termYears?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountOrganizationMetadataMembershipTierCheckoutsInput = {
  bookerId?: InputMaybe<Scalars['MongoID']['input']>;
  free?: InputMaybe<Scalars['Boolean']['input']>;
  tierTagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountOrganizationMetadataNomenclatureInput = {
  member?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Scalars['String']['input']>;
  membership?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountOrganizationMetadataRenewalSettingsInput = {
  activeStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  automaticRenewalEmails?: InputMaybe<Scalars['Boolean']['input']>;
  cancelledEmail?: InputMaybe<FilterCountOrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  cancelledStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  clearStatusTagsOnExpiration?: InputMaybe<Scalars['Boolean']['input']>;
  emailCooldownDays?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  engineOwnedTags?: InputMaybe<Scalars['Boolean']['input']>;
  expiredEmail?: InputMaybe<FilterCountOrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  expiredStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  fixedRenewalDay?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalMonth?: InputMaybe<Scalars['Float']['input']>;
  instructionsEmail?: InputMaybe<FilterCountOrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  invoiceLeadDays?: InputMaybe<Scalars['Float']['input']>;
  neverExpireMembers?: InputMaybe<Scalars['Boolean']['input']>;
  overdueEmail?: InputMaybe<FilterCountOrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  overdueStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  pendingStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  proRateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  renewalGraceDays?: InputMaybe<Scalars['Float']['input']>;
  renewalReminderLeadDays?: InputMaybe<Scalars['Float']['input']>;
  renewalType?: InputMaybe<EnumOrganizationMetadataRenewalSettingsRenewalType>;
  sendCancelledEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendExpirationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendOverdueEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendRenewalEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendSuccessEmails?: InputMaybe<Scalars['Boolean']['input']>;
  successEmail?: InputMaybe<FilterCountOrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  term?: InputMaybe<EnumOrganizationMetadataRenewalSettingsTerm>;
  termYears?: InputMaybe<Scalars['Float']['input']>;
  tierReminderEmails?: InputMaybe<Array<InputMaybe<FilterCountOrganizationMetadataRenewalSettingsTierReminderEmailsInput>>>;
};

export type FilterCountOrganizationMetadataRenewalSettingsInstructionsEmailInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountOrganizationMetadataRenewalSettingsTierReminderEmailsInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  hideRenewalDateLine?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tierTagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountOrganizationOnboardingMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  allowColdSignup?: InputMaybe<Scalars['Boolean']['input']>;
  coldSignupTagId?: InputMaybe<Scalars['MongoID']['input']>;
  comingSoonMessage?: InputMaybe<Scalars['String']['input']>;
  introMessage?: InputMaybe<Scalars['String']['input']>;
  typeformSurveyId?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountOrganizationOperatorsInput = {
  _id?: InputMaybe<FilterCountOrganization_IdOperatorsInput>;
  subdomain?: InputMaybe<FilterCountOrganizationSubdomainOperatorsInput>;
};

export type FilterCountOrganizationSubdomainOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountOrganization_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountOwnerInput = {
  entityId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumOwnerType>;
};

export type FilterCountPeopleEmailLowerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountPeopleEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountPeopleInput = {
  AND?: InputMaybe<Array<FilterCountPeopleInput>>;
  OR?: InputMaybe<Array<FilterCountPeopleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPeopleOperatorsInput>;
  address?: InputMaybe<FilterCountAddressInput>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  contactMethod?: InputMaybe<EnumPeopleContactMethod>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailLower?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  faxExt?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  import?: InputMaybe<Scalars['JSON']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leads?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  mailingAddress?: InputMaybe<FilterCountAddressInput>;
  optInEmail?: InputMaybe<Scalars['Boolean']['input']>;
  optInFax?: InputMaybe<Scalars['Boolean']['input']>;
  optInPhone?: InputMaybe<Scalars['Boolean']['input']>;
  optInSMS?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photoUploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTitle?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  visibleTo?: InputMaybe<Array<InputMaybe<FilterCountPeopleVisibleToInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPeopleOperatorsInput = {
  _id?: InputMaybe<FilterCountPeople_IdOperatorsInput>;
  email?: InputMaybe<FilterCountPeopleEmailOperatorsInput>;
  emailLower?: InputMaybe<FilterCountPeopleEmailLowerOperatorsInput>;
};

export type FilterCountPeopleVisibleToInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  entity?: InputMaybe<FilterCountOwnerInput>;
  ignoreLeadSystemRole?: InputMaybe<Scalars['Boolean']['input']>;
  latestActivity?: InputMaybe<Scalars['Date']['input']>;
  metadata?: InputMaybe<FilterCountPeopleVisibleToMetadataInput>;
  scratchpad?: InputMaybe<Scalars['String']['input']>;
  systemRoles?: InputMaybe<Array<InputMaybe<EnumPeopleVisibleToSystemRoles>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<EnumPeopleVisibleToTypes>>>;
  wasManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountPeopleVisibleToMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  operatorOverrides?: InputMaybe<Array<InputMaybe<FilterCountPeopleVisibleToMetadataOperatorOverridesInput>>>;
  phones?: InputMaybe<Array<InputMaybe<FilterCountPeopleVisibleToMetadataPhonesInput>>>;
};

export type FilterCountPeopleVisibleToMetadataOperatorOverridesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  operatorEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountPeopleVisibleToMetadataPhonesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumPeopleVisibleToMetadataPhonesType>;
};

export type FilterCountPeople_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPlaceInput = {
  AND?: InputMaybe<Array<FilterCountPlaceInput>>;
  OR?: InputMaybe<Array<FilterCountPlaceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPlaceOperatorsInput>;
  connectedDmoListing?: InputMaybe<Scalars['MongoID']['input']>;
  connectedListing?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<FilterCountMultilingualInput>;
  outline?: InputMaybe<FilterCountPlaceOutlineInput>;
  outlineSimplified?: InputMaybe<FilterCountPlaceOutlineInput>;
  parentPlace?: InputMaybe<Scalars['MongoID']['input']>;
  subPlaces?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumPlaceType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPlaceOperatorsInput = {
  _id?: InputMaybe<FilterCountPlace_IdOperatorsInput>;
  parentPlace?: InputMaybe<FilterCountPlaceParentPlaceOperatorsInput>;
  type?: InputMaybe<FilterCountPlaceTypeOperatorsInput>;
};

export type FilterCountPlaceOutlineInput = {
  coordinates: Scalars['JSON']['input'];
  type: EnumPlaceOutlineType;
};

export type FilterCountPlaceParentPlaceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPlaceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumPlaceType>;
  gte?: InputMaybe<EnumPlaceType>;
  in?: InputMaybe<Array<InputMaybe<EnumPlaceType>>>;
  lt?: InputMaybe<EnumPlaceType>;
  lte?: InputMaybe<EnumPlaceType>;
  ne?: InputMaybe<EnumPlaceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumPlaceType>>>;
};

export type FilterCountPlace_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountStorefrontApplicationFeeDefaultsInput = {
  membership?: InputMaybe<Scalars['Float']['input']>;
  merch?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountStorefrontEmailBrandingInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  footerText?: InputMaybe<FilterCountMultilingualInput>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
  useOrganizationEmailSettings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountStorefrontEnabledFeeTypesInput = {
  accommodations?: InputMaybe<Scalars['Boolean']['input']>;
  events?: InputMaybe<Scalars['Boolean']['input']>;
  merch?: InputMaybe<Scalars['Boolean']['input']>;
  oneTimeFee?: InputMaybe<Scalars['Boolean']['input']>;
  renewableFees?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountStorefrontInput = {
  AND?: InputMaybe<Array<FilterCountStorefrontInput>>;
  OR?: InputMaybe<Array<FilterCountStorefrontInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountStorefrontOperatorsInput>;
  accountingCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  applicationFeeDefaults?: InputMaybe<FilterCountStorefrontApplicationFeeDefaultsInput>;
  applicationPercentage?: InputMaybe<Scalars['Float']['input']>;
  connectedAccountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  connectedListings?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  connectedListingsConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customProductNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultInvoicePolicy?: InputMaybe<Scalars['MongoID']['input']>;
  defaultWidgetLogo?: InputMaybe<Scalars['String']['input']>;
  emailBranding?: InputMaybe<FilterCountStorefrontEmailBrandingInput>;
  enabledFeeTypes?: InputMaybe<FilterCountStorefrontEnabledFeeTypesInput>;
  invoiceTemplateBooker?: InputMaybe<Scalars['MongoID']['input']>;
  invoicingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLowStockDigestKey?: InputMaybe<Scalars['String']['input']>;
  launchedAt?: InputMaybe<Scalars['Date']['input']>;
  liveStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  lowStockDigestEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FilterCountMultilingualInput>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  paymentsMode?: InputMaybe<EnumStorefrontPaymentsMode>;
  siteMetadata?: InputMaybe<FilterCountStorefrontSiteMetadataInput>;
  statementSettings?: InputMaybe<FilterCountStorefrontStatementSettingsInput>;
  stripeRegion?: InputMaybe<EnumStorefrontStripeRegion>;
  testMode?: InputMaybe<Scalars['Boolean']['input']>;
  testStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterCountStorefrontLiveStorefrontOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountStorefrontOperatorsInput = {
  _id?: InputMaybe<FilterCountStorefront_IdOperatorsInput>;
  liveStorefront?: InputMaybe<FilterCountStorefrontLiveStorefrontOperatorsInput>;
  organization?: InputMaybe<FilterCountStorefrontOrganizationOperatorsInput>;
  testStorefront?: InputMaybe<FilterCountStorefrontTestStorefrontOperatorsInput>;
};

export type FilterCountStorefrontOrganizationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountStorefrontSiteMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  bookers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  description?: InputMaybe<FilterCountMultilingualInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountStorefrontStatementSettingsInput = {
  dayOfMonth?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountStorefrontTestStorefrontOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountStorefront_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountWidgetEventSettingsInput = {
  displayType?: InputMaybe<EnumWidgetEventSettingsDisplayType>;
  eventTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  hiddenPublicFilterTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  hideCancelledEvents?: InputMaybe<Scalars['Boolean']['input']>;
  lookAheadMonths?: InputMaybe<Scalars['Float']['input']>;
  publicFilterMode?: InputMaybe<EnumWidgetEventSettingsPublicFilterMode>;
  publicFilterSort?: InputMaybe<EnumWidgetEventSettingsPublicFilterSort>;
  shownPublicFilterTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  startMonth?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountWidgetGallerySettingsInfiniteScrollInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  listingFilters?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  mediaTagFilters?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountWidgetGallerySettingsInput = {
  allMedia?: InputMaybe<Scalars['Boolean']['input']>;
  enableUrlPush?: InputMaybe<Scalars['Boolean']['input']>;
  infiniteScroll?: InputMaybe<FilterCountWidgetGallerySettingsInfiniteScrollInput>;
  items?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  playerPagePath?: InputMaybe<Scalars['String']['input']>;
  profilePageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountWidgetInput = {
  AND?: InputMaybe<Array<FilterCountWidgetInput>>;
  OR?: InputMaybe<Array<FilterCountWidgetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountWidgetOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterCountMultilingualInput>;
  eventSettings?: InputMaybe<FilterCountWidgetEventSettingsInput>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  gallerySettings?: InputMaybe<FilterCountWidgetGallerySettingsInput>;
  inquirySettings?: InputMaybe<FilterCountWidgetInquirySettingsInput>;
  list?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<FilterCountMultilingualInput>;
  operatorSettings?: InputMaybe<FilterCountWidgetOperatorSettingsInput>;
  owner?: InputMaybe<FilterCountOwnerInput>;
  promotionSettings?: InputMaybe<FilterCountWidgetPromotionSettingsInput>;
  type?: InputMaybe<EnumWidgetType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterCountWidgetInquirySettingsInput = {
  buttonLabel?: InputMaybe<FilterCountMultilingualInput>;
  completionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  description?: InputMaybe<FilterCountMultilingualInput>;
  notificationRecipients?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  preventMultipleSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  submissionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  survey?: InputMaybe<Scalars['String']['input']>;
  thankYouMessage?: InputMaybe<FilterCountMultilingualInput>;
};

export type FilterCountWidgetOperatorSettingsEntityOverridesInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<FilterCountMultilingualInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription?: InputMaybe<FilterCountMultilingualInput>;
};

export type FilterCountWidgetOperatorSettingsInput = {
  allowAdditionalFilters?: InputMaybe<Scalars['Boolean']['input']>;
  allowMapView?: InputMaybe<Scalars['Boolean']['input']>;
  disableOperatorWidgetFilter?: InputMaybe<Scalars['Boolean']['input']>;
  disableTieredSort?: InputMaybe<Scalars['Boolean']['input']>;
  entityOverrides?: InputMaybe<Array<InputMaybe<FilterCountWidgetOperatorSettingsEntityOverridesInput>>>;
  filterableTagGroups?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  filterableTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  hideFiltersInMapView?: InputMaybe<Scalars['Boolean']['input']>;
  hidePermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  hideTemporarilyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  listDisplayMode?: InputMaybe<EnumWidgetOperatorSettingsListDisplayMode>;
  orderedFilters?: InputMaybe<Array<InputMaybe<FilterCountWidgetOperatorSettingsOrderedFiltersInput>>>;
  showEvents?: InputMaybe<Scalars['Boolean']['input']>;
  showOnlyMap?: InputMaybe<Scalars['Boolean']['input']>;
  showPermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  showPromotions?: InputMaybe<Scalars['Boolean']['input']>;
  sortStrategy?: InputMaybe<EnumWidgetOperatorSettingsSortStrategy>;
  tieredSortOrder?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountWidgetOperatorSettingsOrderedFiltersInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  isTagGroup?: InputMaybe<Scalars['Boolean']['input']>;
  labelOverride?: InputMaybe<FilterCountMultilingualInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountWidgetOperatorsInput = {
  _id?: InputMaybe<FilterCountWidget_IdOperatorsInput>;
  owner?: InputMaybe<FilterCountWidgetOwnerOperatorsInput>;
};

export type FilterCountWidgetOwnerEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountWidgetOwnerOperatorsInput = {
  entityId?: InputMaybe<FilterCountWidgetOwnerEntityIdOperatorsInput>;
};

export type FilterCountWidgetPromotionSettingsInput = {
  displayType?: InputMaybe<EnumWidgetPromotionSettingsDisplayType>;
  hiddenPublicFilterTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  hidePublicFilters?: InputMaybe<Scalars['Boolean']['input']>;
  promotionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountWidget_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAccommodationOperatorMetadataInput = {
  guestRoomQty?: InputMaybe<Scalars['Float']['input']>;
  shortTermAccommodationLicense?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyAccommodationProductMetadataInput = {
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  calendarLinks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  checkIn?: InputMaybe<Scalars['String']['input']>;
  checkOut?: InputMaybe<Scalars['String']['input']>;
  closures?: InputMaybe<Array<InputMaybe<FilterFindManyClosureInput>>>;
  guestMetadata?: InputMaybe<FilterFindManyGuestMetadataInput>;
  rooms?: InputMaybe<Array<InputMaybe<FilterFindManyRoomInput>>>;
};

export type FilterFindManyActivityLogBulkConnectLogIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyActivityLogEmailActivityFromAddressInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyActivityLogEmailActivityInput = {
  fromAddress?: InputMaybe<FilterFindManyActivityLogEmailActivityFromAddressInput>;
  recipients?: InputMaybe<Array<InputMaybe<FilterFindManyActivityLogEmailActivityRecipientsInput>>>;
  sentHtml?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  templatePreviewHtml?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyActivityLogEmailActivityRecipientsInput = {
  bouncedAt?: InputMaybe<Scalars['Date']['input']>;
  clickedAt?: InputMaybe<Scalars['Date']['input']>;
  deferredAt?: InputMaybe<Scalars['Date']['input']>;
  deliveredAt?: InputMaybe<Scalars['Date']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  droppedAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  openedAt?: InputMaybe<Scalars['Date']['input']>;
  personId?: InputMaybe<Scalars['MongoID']['input']>;
  spamReportedAt?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyActivityLogEntityOperatorsInput = {
  _entityId?: InputMaybe<FilterFindManyActivityLogEntity_EntityIdOperatorsInput>;
};

export type FilterFindManyActivityLogEntity_EntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyActivityLogImportRunIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyActivityLogInput = {
  AND?: InputMaybe<Array<FilterFindManyActivityLogInput>>;
  OR?: InputMaybe<Array<FilterFindManyActivityLogInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyActivityLogOperatorsInput>;
  bulkConnectLogId?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  emailActivity?: InputMaybe<FilterFindManyActivityLogEmailActivityInput>;
  entity?: InputMaybe<FilterFindManyEntityReferenceInput>;
  /** Filter activity logs by affected entity. Accepts an array of entity _entityIds. */
  entityIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  entityName?: InputMaybe<FilterFindManyMultilingualInput>;
  importRunId?: InputMaybe<Scalars['MongoID']['input']>;
  initiatedBy?: InputMaybe<Scalars['String']['input']>;
  initiatedByPerson?: InputMaybe<Scalars['MongoID']['input']>;
  initiatedByUser?: InputMaybe<Scalars['MongoID']['input']>;
  message?: InputMaybe<FilterFindManyMultilingualInput>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  /** Filter activity logs by owners. Accepts an array of owners. */
  owners?: InputMaybe<Array<InputMaybe<OwnerInput>>>;
  resourceId?: InputMaybe<Scalars['MongoID']['input']>;
  surveyResponseId?: InputMaybe<Scalars['MongoID']['input']>;
  /** Filter activity logs by tags. Returns logs that have at least one of the specified tags. */
  tags?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  type?: InputMaybe<EnumActivityLogType>;
  /** Filter activity logs by type. Accepts an array of types. */
  types?: InputMaybe<Array<EnumActivityLogType>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyActivityLogOperatorsInput = {
  _id?: InputMaybe<FilterFindManyActivityLog_IdOperatorsInput>;
  bulkConnectLogId?: InputMaybe<FilterFindManyActivityLogBulkConnectLogIdOperatorsInput>;
  entity?: InputMaybe<FilterFindManyActivityLogEntityOperatorsInput>;
  importRunId?: InputMaybe<FilterFindManyActivityLogImportRunIdOperatorsInput>;
};

export type FilterFindManyActivityLog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<AddressLocationInput>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyAnalyticsDashboardInput = {
  AND?: InputMaybe<Array<FilterFindManyAnalyticsDashboardInput>>;
  OR?: InputMaybe<Array<FilterFindManyAnalyticsDashboardInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAnalyticsDashboardOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  dashboardId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAnalyticsDashboardOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAnalyticsDashboard_IdOperatorsInput>;
};

export type FilterFindManyAnalyticsDashboard_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyApiAccessInput = {
  AND?: InputMaybe<Array<FilterFindManyApiAccessInput>>;
  OR?: InputMaybe<Array<FilterFindManyApiAccessInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyApiAccessOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  lastUsedAt?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyApiAccessOperatorsInput = {
  _id?: InputMaybe<FilterFindManyApiAccess_IdOperatorsInput>;
  organization?: InputMaybe<FilterFindManyApiAccessOrganizationOperatorsInput>;
  token?: InputMaybe<FilterFindManyApiAccessTokenOperatorsInput>;
};

export type FilterFindManyApiAccessOrganizationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyApiAccessTokenOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyApiAccess_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssetFileInput = {
  AND?: InputMaybe<Array<FilterFindManyAssetInput>>;
  OR?: InputMaybe<Array<FilterFindManyAssetInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAssetOperatorsInput>;
  blurhash?: InputMaybe<Scalars['String']['input']>;
  bytes?: InputMaybe<Scalars['Float']['input']>;
  caption?: InputMaybe<FilterFindManyMultilingualInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  originalUrl?: InputMaybe<Scalars['String']['input']>;
  parentEntity?: InputMaybe<FilterFindManyEntityReferenceInput>;
  sourceEnv?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyAssetImageInput = {
  AND?: InputMaybe<Array<FilterFindManyAssetInput>>;
  OR?: InputMaybe<Array<FilterFindManyAssetInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAssetOperatorsInput>;
  blurhash?: InputMaybe<Scalars['String']['input']>;
  bytes?: InputMaybe<Scalars['Float']['input']>;
  caption?: InputMaybe<FilterFindManyMultilingualInput>;
  colors?: InputMaybe<Array<InputMaybe<FilterFindManyColorInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Currently, our schema only supports facial and text detection, using the built-in Cloudinary AI Content Analysis face detection, and the `cld-text` model. Therefore, the fields returned in `detectedObjects` will be limited to *optional* `humanFace` and `text` fields which are of `IDetectedObject[]` type.
   *
   * &nbsp;
   *
   * `IDetectedObject` contains a `boundingBox` array of `numbers`, a `categories` array of `string`s, and a `number` `confidence` value.
   *
   * &nbsp;
   *
   * ```json
   * interface IDetectedObject extends Document {
   *   boundingBox: number[];
   *   categories: string[];
   *   confidence: number;
   * }
   * ```
   */
  detectedObjects?: InputMaybe<Scalars['JSON']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  hasTransparency?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  lightness?: InputMaybe<Scalars['String']['input']>;
  mux?: InputMaybe<FilterFindManyAssetImageMuxInput>;
  originalUrl?: InputMaybe<Scalars['String']['input']>;
  parentEntity?: InputMaybe<FilterFindManyEntityReferenceInput>;
  qualityAnalysis?: InputMaybe<FilterFindManyImageQualityAnalysisInput>;
  qualityScore?: InputMaybe<Scalars['Float']['input']>;
  sourceEnv?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAssetImageMuxInput = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  playbackId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumAssetImageMuxStatus>;
};

export type FilterFindManyAssetInput = {
  AND?: InputMaybe<Array<FilterFindManyAssetInput>>;
  OR?: InputMaybe<Array<FilterFindManyAssetInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAssetOperatorsInput>;
  blurhash?: InputMaybe<Scalars['String']['input']>;
  bytes?: InputMaybe<Scalars['Float']['input']>;
  caption?: InputMaybe<FilterFindManyMultilingualInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  originalUrl?: InputMaybe<Scalars['String']['input']>;
  parentEntity?: InputMaybe<FilterFindManyEntityReferenceInput>;
  sourceEnv?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumDKeyAssetType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAssetOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAsset_IdOperatorsInput>;
};

export type FilterFindManyAsset_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyBookerApprovalSettingsInput = {
  autoCancelUnpaidAfterDays?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageToGuest?: InputMaybe<FilterFindManyMultilingualInput>;
  requestExpiryHours?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyBookerBundlesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  product?: InputMaybe<Scalars['MongoID']['input']>;
  upsells?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBookerCompletionScreenInput = {
  ctaBroadcastId?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<FilterFindManyMultilingualInput>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<FilterFindManyMultilingualInput>;
};

export type FilterFindManyBookerCopiedFromOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBookerCustomerFieldsInput = {
  addressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  businessFieldDescription?: InputMaybe<FilterFindManyMultilingualInput>;
  businessFieldEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  guestEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  guestInfoRequired?: InputMaybe<Scalars['Boolean']['input']>;
  guestNamesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  phoneEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyBookerCustomizationsInput = {
  addressDisplay?: InputMaybe<EnumBookerCustomizationsAddressDisplay>;
  confirmationEmailBody?: InputMaybe<FilterFindManyMultilingualInput>;
  confirmationEmailCtaLabel?: InputMaybe<FilterFindManyMultilingualInput>;
  confirmationEmailCtaUrl?: InputMaybe<Scalars['String']['input']>;
  confirmationEmailSubject?: InputMaybe<FilterFindManyMultilingualInput>;
  featuredImage?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  overrideAddOnsDescription?: InputMaybe<FilterFindManyMultilingualInput>;
  overrideDiscountCallout?: InputMaybe<FilterFindManyMultilingualInput>;
  overridePricingCallout?: InputMaybe<FilterFindManyMultilingualInput>;
  overrideProductDescription?: InputMaybe<FilterFindManyMultilingualInput>;
  overrideProductName?: InputMaybe<FilterFindManyMultilingualInput>;
  overrideQuestionnaireDescription?: InputMaybe<FilterFindManyMultilingualInput>;
  overrideQuestionnaireTitle?: InputMaybe<FilterFindManyMultilingualInput>;
  sectionOrder?: InputMaybe<Array<InputMaybe<EnumBookerCustomizationsSectionOrder>>>;
  showCheckoutChecklist?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyBookerDiscountScopesInput = {
  appliesToTierIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discount?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyBookerEligibilityInput = {
  blockedMessage?: InputMaybe<FilterFindManyMultilingualInput>;
  ineligibleBehavior?: InputMaybe<EnumBookerEligibilityIneligibleBehavior>;
  mode?: InputMaybe<EnumBookerEligibilityMode>;
  rule?: InputMaybe<EnumBookerEligibilityRule>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyBookerEmailTemplatesInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumBookerEmailTemplatesType>;
};

export type FilterFindManyBookerFeeAbsorptionSnapshotInput = {
  appliedAt?: InputMaybe<Scalars['Date']['input']>;
  products?: InputMaybe<Array<InputMaybe<FilterFindManyBookerFeeAbsorptionSnapshotProductsInput>>>;
};

export type FilterFindManyBookerFeeAbsorptionSnapshotProductsInput = {
  pricePoints?: InputMaybe<Array<InputMaybe<FilterFindManyBookerFeeAbsorptionSnapshotProductsPricePointsInput>>>;
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyBookerFeeAbsorptionSnapshotProductsPricePointsInput = {
  after?: InputMaybe<Scalars['Float']['input']>;
  before?: InputMaybe<Scalars['Float']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyBookerInput = {
  AND?: InputMaybe<Array<FilterFindManyBookerInput>>;
  OR?: InputMaybe<Array<FilterFindManyBookerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBookerOperatorsInput>;
  approvalSettings?: InputMaybe<FilterFindManyBookerApprovalSettingsInput>;
  bundles?: InputMaybe<Array<InputMaybe<FilterFindManyBookerBundlesInput>>>;
  businessCompletionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  completionScreen?: InputMaybe<FilterFindManyBookerCompletionScreenInput>;
  completionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customerFields?: InputMaybe<FilterFindManyBookerCustomerFieldsInput>;
  customizations?: InputMaybe<FilterFindManyBookerCustomizationsInput>;
  discountScopes?: InputMaybe<Array<InputMaybe<FilterFindManyBookerDiscountScopesInput>>>;
  discounts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  eligibility?: InputMaybe<FilterFindManyBookerEligibilityInput>;
  emailTemplates?: InputMaybe<Array<InputMaybe<FilterFindManyBookerEmailTemplatesInput>>>;
  feeAbsorptionSnapshot?: InputMaybe<FilterFindManyBookerFeeAbsorptionSnapshotInput>;
  fulfillmentProfile?: InputMaybe<Scalars['MongoID']['input']>;
  isInvoiceTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  paymentMetadata?: InputMaybe<FilterFindManyOrderPaymentMetadataInput>;
  paymentMethodSet?: InputMaybe<Scalars['MongoID']['input']>;
  paymentTiming?: InputMaybe<FilterFindManyBookerPaymentTimingInput>;
  policies?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  promoCodeTagOverrides?: InputMaybe<Array<InputMaybe<FilterFindManyBookerPromoCodeTagOverridesInput>>>;
  publiclyPublishable?: InputMaybe<Scalars['Boolean']['input']>;
  renewalSettings?: InputMaybe<FilterFindManyBookerRenewalSettingsInput>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  status?: InputMaybe<Array<EnumBookerStatus>>;
  statusNotification?: InputMaybe<FilterFindManyMultilingualInput>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  survey?: InputMaybe<Scalars['MongoID']['input']>;
  surveyInline?: InputMaybe<Scalars['Boolean']['input']>;
  tagDiscountSettings?: InputMaybe<FilterFindManyBookerTagDiscountSettingsInput>;
  teamVisible?: InputMaybe<Scalars['Boolean']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  waivers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyBookerIsInvoiceTemplateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBookerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBooker_IdOperatorsInput>;
  copiedFrom?: InputMaybe<FilterFindManyBookerCopiedFromOperatorsInput>;
  isInvoiceTemplate?: InputMaybe<FilterFindManyBookerIsInvoiceTemplateOperatorsInput>;
};

export type FilterFindManyOrderPaymentMetadataFeeAbsorptionInput = {
  roundingIncrementCents?: InputMaybe<Scalars['Float']['input']>;
  showBreakdownInCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  stripeFixedCents?: InputMaybe<Scalars['Float']['input']>;
  stripePercent?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyOrderPaymentMetadataInput = {
  acceptedPaymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  applicationPercentage?: InputMaybe<Scalars['Float']['input']>;
  applicationPercentageFollowsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  bankTransferInstructions?: InputMaybe<Scalars['String']['input']>;
  connectedAccountId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customerApplicationPercentage?: InputMaybe<Scalars['Float']['input']>;
  depositSettings?: InputMaybe<FilterFindManyDepositSettingsInput>;
  feeAbsorption?: InputMaybe<FilterFindManyOrderPaymentMetadataFeeAbsorptionInput>;
  offerTaxExemption?: InputMaybe<Scalars['Boolean']['input']>;
  optionalCardPostalCode?: InputMaybe<Scalars['Boolean']['input']>;
  securityDepositSettings?: InputMaybe<FilterFindManySecurityDepositSettingsInput>;
  stripeRegion?: InputMaybe<EnumOrderPaymentMetadataStripeRegion>;
  tax?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyBookerPaymentTimingInput = {
  afterServiceOffsetDays?: InputMaybe<Scalars['Float']['input']>;
  consolidation?: InputMaybe<EnumBookerPaymentTimingConsolidation>;
  invoiceDueDays?: InputMaybe<Scalars['Float']['input']>;
  timing?: InputMaybe<EnumBookerPaymentTimingTiming>;
};

export type FilterFindManyBookerPromoCodeTagOverridesInput = {
  discountId?: InputMaybe<Scalars['MongoID']['input']>;
  mode?: InputMaybe<EnumBookerPromoCodeTagOverridesMode>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyBookerRenewalSettingsInput = {
  renewalMode?: InputMaybe<EnumBookerRenewalSettingsRenewalMode>;
  renewalReminderDaysBefore?: InputMaybe<Scalars['Float']['input']>;
  requireApproval?: InputMaybe<Scalars['Boolean']['input']>;
  sendRenewalReminders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyBookerTagDiscountSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<Array<InputMaybe<FilterFindManyBookerTagDiscountSettingsRulesInput>>>;
};

export type FilterFindManyBookerTagDiscountSettingsRulesInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<EnumBookerTagDiscountSettingsRulesDiscountType>;
  tag?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyBooker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBroadcastInput = {
  AND?: InputMaybe<Array<FilterFindManyBroadcastInput>>;
  OR?: InputMaybe<Array<FilterFindManyBroadcastInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBroadcastOperatorsInput>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  /** Filter broadcasts by owners. Accepts an array of owners. */
  owners?: InputMaybe<Array<InputMaybe<OwnerInput>>>;
  publicName?: InputMaybe<FilterFindManyMultilingualInput>;
  resources?: InputMaybe<Array<InputMaybe<FilterFindManyBroadcastResourcesInput>>>;
  sharedTo?: InputMaybe<FilterFindManyBroadcastSharedToInput>;
  /** Filter broadcasts by status. Accepts an array of statuses. */
  status?: InputMaybe<Array<EnumBroadcastStatus>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBroadcastOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBroadcast_IdOperatorsInput>;
};

export type FilterFindManyBroadcastResourcesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  allowResubmission?: InputMaybe<Scalars['Boolean']['input']>;
  allowSaveAndEdit?: InputMaybe<Scalars['Boolean']['input']>;
  booker?: InputMaybe<Scalars['MongoID']['input']>;
  completionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  course?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<FilterFindManyMultilingualInput>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  expirationTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  file?: InputMaybe<Scalars['String']['input']>;
  formMode?: InputMaybe<EnumBroadcastResourcesFormMode>;
  iframeUrl?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<FilterFindManyMultilingualInput>;
  paymentRequestId?: InputMaybe<Scalars['MongoID']['input']>;
  photos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requireApproval?: InputMaybe<Scalars['Boolean']['input']>;
  submissionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  survey?: InputMaybe<Scalars['String']['input']>;
  teamVisible?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<FilterFindManyMultilingualInput>;
  type?: InputMaybe<EnumBroadcastResourcesType>;
  video?: InputMaybe<Scalars['String']['input']>;
  videoURL?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyBroadcastSharedToInput = {
  operatorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sentToPeople?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  sentToPeopleSystemRoles?: InputMaybe<Array<InputMaybe<EnumBroadcastSharedToSentToPeopleSystemRoles>>>;
  sentToPeopleTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  skipEmails?: InputMaybe<Scalars['Boolean']['input']>;
  teaser?: InputMaybe<FilterFindManyBroadcastSharedToTeaserInput>;
  type?: InputMaybe<EnumBroadcastSharedToType>;
};

export type FilterFindManyBroadcastSharedToTeaserInput = {
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyBroadcast_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyBulkConnectLogInput = {
  AND?: InputMaybe<Array<FilterFindManyBulkConnectLogInput>>;
  OR?: InputMaybe<Array<FilterFindManyBulkConnectLogInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBulkConnectLogOperatorsInput>;
  alreadyConnectedCount?: InputMaybe<Scalars['Float']['input']>;
  appliedBackOfficeTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  errorCount?: InputMaybe<Scalars['Float']['input']>;
  initiatedByUser?: InputMaybe<Scalars['MongoID']['input']>;
  operatorEntityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  results?: InputMaybe<Array<InputMaybe<FilterFindManyBulkConnectLogResultsInput>>>;
  rollbackInfo?: InputMaybe<FilterFindManyBulkConnectLogRollbackInfoInput>;
  successCount?: InputMaybe<Scalars['Float']['input']>;
  totalCount?: InputMaybe<Scalars['Float']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBulkConnectLogOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBulkConnectLog_IdOperatorsInput>;
};

export type FilterFindManyBulkConnectLogResultsInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  operatorEntityId?: InputMaybe<Scalars['String']['input']>;
  operatorName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumBulkConnectLogResultsStatus>;
};

export type FilterFindManyBulkConnectLogRollbackInfoInput = {
  disconnectedCount?: InputMaybe<Scalars['Float']['input']>;
  errorCount?: InputMaybe<Scalars['Float']['input']>;
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rolledBackAt?: InputMaybe<Scalars['Date']['input']>;
  rolledBackBy?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyBulkConnectLog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyChangelogInput = {
  AND?: InputMaybe<Array<FilterFindManyChangelogInput>>;
  OR?: InputMaybe<Array<FilterFindManyChangelogInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyChangelogOperatorsInput>;
  /** Filter by createDateISO either _eq, _gt, _lt, _gte, or _lte */
  createdDateISO?: InputMaybe<CreatedDateIso>;
  entity?: InputMaybe<FilterFindManyVersionedEntityReferenceInput>;
  initiatedByUser?: InputMaybe<Scalars['MongoID']['input']>;
  /** Filter by message.en either _eq, _startsWith, or _notStartsWith */
  message?: InputMaybe<Message>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyChangelogOperatorsInput = {
  _id?: InputMaybe<FilterFindManyChangelog_IdOperatorsInput>;
};

export type FilterFindManyChangelog_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyClosureInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  dateRangeISO?: InputMaybe<FilterFindManyDateRangeIsoInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyColorInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  predominance?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyContactInput = {
  address?: InputMaybe<FilterFindManyAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<FilterFindManyLinksInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  tollFreePublicPhone?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyDateRangeIsoInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  end: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['String']['input'];
};

export type FilterFindManyDateRangeIsoOptionalInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyDepositSettingsInput = {
  chargeBalanceDaysBeforeCheckIn?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateType?: InputMaybe<EnumDepositSettingsRateType>;
};

export type FilterFindManyDiscountInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  buyQuantity?: InputMaybe<Scalars['Float']['input']>;
  canCombine?: InputMaybe<Scalars['Boolean']['input']>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  currentUsageCount?: InputMaybe<Scalars['Float']['input']>;
  daysInAdvance?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  discountActivePeriod?: InputMaybe<FilterFindManyDateRangeIsoOptionalInput>;
  excludeUpsells?: InputMaybe<Scalars['Boolean']['input']>;
  getQuantity?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isOngoing?: InputMaybe<Scalars['Boolean']['input']>;
  maxDaysInAdvance?: InputMaybe<Scalars['Float']['input']>;
  maxNights?: InputMaybe<Scalars['Float']['input']>;
  maxUsageCount?: InputMaybe<Scalars['Float']['input']>;
  minGuestCount?: InputMaybe<Scalars['Float']['input']>;
  minNights?: InputMaybe<Scalars['Float']['input']>;
  minQuantity?: InputMaybe<Scalars['Float']['input']>;
  minSubtotal?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  perTicket?: InputMaybe<Scalars['Boolean']['input']>;
  perTicketApplyFrom?: InputMaybe<Scalars['Float']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumDiscountType>;
  unit?: InputMaybe<EnumDiscountUnit>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyEntityReferenceInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumEntityReferenceType>;
};

export type FilterFindManyExperienceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyFulfillmentProfileCopiedFromOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyFulfillmentProfileInput = {
  AND?: InputMaybe<Array<FilterFindManyFulfillmentProfileInput>>;
  OR?: InputMaybe<Array<FilterFindManyFulfillmentProfileInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyFulfillmentProfileOperatorsInput>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pickup?: InputMaybe<FilterFindManyFulfillmentProfilePickupInput>;
  shipping?: InputMaybe<FilterFindManyFulfillmentProfileShippingInput>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyFulfillmentProfileOperatorsInput = {
  _id?: InputMaybe<FilterFindManyFulfillmentProfile_IdOperatorsInput>;
  copiedFrom?: InputMaybe<FilterFindManyFulfillmentProfileCopiedFromOperatorsInput>;
  storefront?: InputMaybe<FilterFindManyFulfillmentProfileStorefrontOperatorsInput>;
};

export type FilterFindManyFulfillmentProfilePickupInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  locations?: InputMaybe<Array<InputMaybe<FilterFindManyFulfillmentProfilePickupLocationsInput>>>;
};

export type FilterFindManyFulfillmentProfilePickupLocationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyFulfillmentProfileShippingInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  zones?: InputMaybe<Array<InputMaybe<FilterFindManyFulfillmentProfileShippingZonesInput>>>;
};

export type FilterFindManyFulfillmentProfileShippingZonesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  freeOver?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  perAdditionalItem?: InputMaybe<Scalars['Float']['input']>;
  subdivisions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyFulfillmentProfileStorefrontOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyFulfillmentProfile_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyGuestMetadataInput = {
  maximumNumber?: InputMaybe<Scalars['Float']['input']>;
  minimumNumber?: InputMaybe<Scalars['Float']['input']>;
  nameEntryAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  nameEntryRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyImageQualityAnalysisInput = {
  blockiness?: InputMaybe<Scalars['Float']['input']>;
  chroma_subsampling?: InputMaybe<Scalars['Float']['input']>;
  color_score?: InputMaybe<Scalars['Float']['input']>;
  contrast?: InputMaybe<Scalars['Float']['input']>;
  dct?: InputMaybe<Scalars['Float']['input']>;
  exposure?: InputMaybe<Scalars['Float']['input']>;
  focus?: InputMaybe<Scalars['Float']['input']>;
  jpeg_chroma?: InputMaybe<Scalars['Float']['input']>;
  jpeg_quality?: InputMaybe<Scalars['Float']['input']>;
  lighting?: InputMaybe<Scalars['Float']['input']>;
  noise?: InputMaybe<Scalars['Float']['input']>;
  pixel_score?: InputMaybe<Scalars['Float']['input']>;
  resolution?: InputMaybe<Scalars['Float']['input']>;
  saturation?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyImportGoogleSheetsConfigInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
  serviceAccountKey?: InputMaybe<Scalars['String']['input']>;
  sheetId?: InputMaybe<Scalars['String']['input']>;
  sheetUrl?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyImportInput = {
  AND?: InputMaybe<Array<FilterFindManyImportInput>>;
  OR?: InputMaybe<Array<FilterFindManyImportInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyImportOperatorsInput>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  googleSheetsConfig?: InputMaybe<FilterFindManyImportGoogleSheetsConfigInput>;
  importType?: InputMaybe<EnumImportImportType>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumImportStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyImportOperatorsInput = {
  _id?: InputMaybe<FilterFindManyImport_IdOperatorsInput>;
};

export type FilterFindManyImportRunDryRunLogInput = {
  connectedOperatorName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  existingEntityId?: InputMaybe<Scalars['String']['input']>;
  existingOperatorEntityId?: InputMaybe<Scalars['String']['input']>;
  existingOperatorOrganizerId?: InputMaybe<Scalars['String']['input']>;
  existingOperatorOrganizerName?: InputMaybe<Scalars['String']['input']>;
  fieldsToUpdate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasAddress?: InputMaybe<Scalars['Boolean']['input']>;
  hasContact?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescription?: InputMaybe<Scalars['Boolean']['input']>;
  imageCount?: InputMaybe<Scalars['Float']['input']>;
  isExisting?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  missingOrganizer?: InputMaybe<Scalars['Boolean']['input']>;
  missingVenue?: InputMaybe<Scalars['Boolean']['input']>;
  operatorName?: InputMaybe<Scalars['String']['input']>;
  operatorType?: InputMaybe<Scalars['String']['input']>;
  organizerCouldNotConnect?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<EnumImportRunDryRunLogStatus>;
  unresolvedOrganizerName?: InputMaybe<Scalars['String']['input']>;
  unresolvedVenueNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  willBeConnectedToOperator?: InputMaybe<Scalars['Boolean']['input']>;
  willConnectToExistingOperatorAsOrganizer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyImportRunEntitiesManuallyConnectedToOrgImportDataInput = {
  fields?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<FilterFindManyImportRunEntitiesManuallyConnectedToOrgImportDataTagsInput>;
};

export type FilterFindManyImportRunEntitiesManuallyConnectedToOrgImportDataTagsInput = {
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyImportRunEntitiesManuallyConnectedToOrgInput = {
  addedImageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedNoteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approvedVersionId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  importData?: InputMaybe<FilterFindManyImportRunEntitiesManuallyConnectedToOrgImportDataInput>;
  mergeOption?: InputMaybe<EnumImportRunEntitiesManuallyConnectedToOrgMergeOption>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  versionIdBeforeImport?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyImportRunExistingEntitiesImportDataInput = {
  fields?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<FilterFindManyImportRunExistingEntitiesImportDataTagsInput>;
};

export type FilterFindManyImportRunExistingEntitiesImportDataTagsInput = {
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyImportRunExistingEntitiesInput = {
  addedImageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedNoteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approvedVersionId?: InputMaybe<Scalars['String']['input']>;
  createdPublicationStatusIds?: InputMaybe<Scalars['JSON']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  importData?: InputMaybe<FilterFindManyImportRunExistingEntitiesImportDataInput>;
  mergeOption?: InputMaybe<EnumImportRunExistingEntitiesMergeOption>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previousPublicationStatuses?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  versionIdBeforeImport?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyImportRunExistingOperatorsImportDataInput = {
  fields?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<FilterFindManyImportRunExistingOperatorsImportDataTagsInput>;
};

export type FilterFindManyImportRunExistingOperatorsImportDataTagsInput = {
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyImportRunExistingOperatorsInput = {
  addedImageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedNoteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approvedVersionId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  importData?: InputMaybe<FilterFindManyImportRunExistingOperatorsImportDataInput>;
  mergeOption?: InputMaybe<EnumImportRunExistingOperatorsMergeOption>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  versionIdBeforeImport?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyImportRunImportedEntitiesInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyImportRunImportedOperatorsInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyImportRunInput = {
  AND?: InputMaybe<Array<FilterFindManyImportRunInput>>;
  OR?: InputMaybe<Array<FilterFindManyImportRunInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyImportRunOperatorsInput>;
  checkForExistingOperators?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  createdEntityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdNoteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdOperatorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  dryRunLog?: InputMaybe<Array<InputMaybe<FilterFindManyImportRunDryRunLogInput>>>;
  endingRow?: InputMaybe<Scalars['Float']['input']>;
  entitiesManuallyConnectedToOrg?: InputMaybe<Array<InputMaybe<FilterFindManyImportRunEntitiesManuallyConnectedToOrgInput>>>;
  entityCount?: InputMaybe<Scalars['Float']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  existingEntities?: InputMaybe<Array<InputMaybe<FilterFindManyImportRunExistingEntitiesInput>>>;
  existingOperators?: InputMaybe<Array<InputMaybe<FilterFindManyImportRunExistingOperatorsInput>>>;
  import?: InputMaybe<Scalars['MongoID']['input']>;
  importedEntities?: InputMaybe<Array<InputMaybe<FilterFindManyImportRunImportedEntitiesInput>>>;
  importedOperators?: InputMaybe<Array<InputMaybe<FilterFindManyImportRunImportedOperatorsInput>>>;
  isUpdateMode?: InputMaybe<Scalars['Boolean']['input']>;
  jobs?: InputMaybe<FilterFindManyImportRunJobsInput>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  operatorCount?: InputMaybe<Scalars['Float']['input']>;
  operatorsManuallyConnectedToOrg?: InputMaybe<Array<InputMaybe<FilterFindManyImportRunOperatorsManuallyConnectedToOrgInput>>>;
  rollbackInfo?: InputMaybe<FilterFindManyImportRunRollbackInfoInput>;
  rowsImported?: InputMaybe<Scalars['Float']['input']>;
  serverLogs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skipImages?: InputMaybe<Scalars['Boolean']['input']>;
  startedBy?: InputMaybe<Scalars['String']['input']>;
  startingRow?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<EnumImportRunStatus>;
  totalRowsAvailable?: InputMaybe<Scalars['Float']['input']>;
  updateRollbackSnapshots?: InputMaybe<Array<InputMaybe<FilterFindManyImportRunUpdateRollbackSnapshotsInput>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyImportRunJobsInput = {
  errorList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyImportRunOperatorsInput = {
  _id?: InputMaybe<FilterFindManyImportRun_IdOperatorsInput>;
};

export type FilterFindManyImportRunOperatorsManuallyConnectedToOrgImportDataInput = {
  fields?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<FilterFindManyImportRunOperatorsManuallyConnectedToOrgImportDataTagsInput>;
};

export type FilterFindManyImportRunOperatorsManuallyConnectedToOrgImportDataTagsInput = {
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyImportRunOperatorsManuallyConnectedToOrgInput = {
  addedImageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedNoteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approvedVersionId?: InputMaybe<Scalars['String']['input']>;
  createdPublicationStatusIds?: InputMaybe<Scalars['JSON']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  importData?: InputMaybe<FilterFindManyImportRunOperatorsManuallyConnectedToOrgImportDataInput>;
  mergeOption?: InputMaybe<EnumImportRunOperatorsManuallyConnectedToOrgMergeOption>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previousPublicationStatuses?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  versionIdBeforeImport?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyImportRunRollbackInfoInput = {
  deletedCount?: InputMaybe<Scalars['Float']['input']>;
  entityIdsInCreatedEntityIds?: InputMaybe<Scalars['Float']['input']>;
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imagesDeleted?: InputMaybe<Scalars['Float']['input']>;
  importedEntitiesCount?: InputMaybe<Scalars['Float']['input']>;
  rolledBackAt?: InputMaybe<Scalars['Date']['input']>;
  rolledBackBy?: InputMaybe<Scalars['String']['input']>;
  serverLogs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  totalEntityDocumentsDeleted?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyImportRunUpdateRollbackSnapshotsInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  newValue?: InputMaybe<Scalars['JSON']['input']>;
  originalValue?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyImportRun_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyImportScrapeGoogleSheetsConfigInput = {
  sheetId?: InputMaybe<Scalars['String']['input']>;
  sheetName?: InputMaybe<Scalars['String']['input']>;
  sheetUrl?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyImportScrapeInput = {
  AND?: InputMaybe<Array<FilterFindManyImportScrapeInput>>;
  OR?: InputMaybe<Array<FilterFindManyImportScrapeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyImportScrapeOperatorsInput>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  googleSheetsConfig?: InputMaybe<FilterFindManyImportScrapeGoogleSheetsConfigInput>;
  maxRows?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scraperPrompt?: InputMaybe<Scalars['String']['input']>;
  sitemapEntries?: InputMaybe<Array<InputMaybe<FilterFindManyImportScrapeSitemapEntriesInput>>>;
  sitemapRevision?: InputMaybe<Scalars['Float']['input']>;
  sitemapUrlCount?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<EnumImportScrapeStatus>;
  targetOrganization?: InputMaybe<Scalars['MongoID']['input']>;
  typeOfData?: InputMaybe<EnumImportScrapeTypeOfData>;
  typeOfScrape?: InputMaybe<EnumImportScrapeTypeOfScrape>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyImportScrapeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyImportScrape_IdOperatorsInput>;
};

export type FilterFindManyImportScrapeRunActionHistoryInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  action?: InputMaybe<EnumImportScrapeRunActionHistoryAction>;
  summary?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyImportScrapeRunInput = {
  AND?: InputMaybe<Array<FilterFindManyImportScrapeRunInput>>;
  OR?: InputMaybe<Array<FilterFindManyImportScrapeRunInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyImportScrapeRunOperatorsInput>;
  actionHistory?: InputMaybe<Array<InputMaybe<FilterFindManyImportScrapeRunActionHistoryInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  dataCleaningPrompt?: InputMaybe<Scalars['String']['input']>;
  errorMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleSheetsResponse?: InputMaybe<Scalars['String']['input']>;
  importReadyData?: InputMaybe<Scalars['String']['input']>;
  importReadyDataSize?: InputMaybe<Scalars['Float']['input']>;
  initiatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  promptUsed?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<EnumImportScrapeRunRating>;
  rawAIResponse?: InputMaybe<Scalars['String']['input']>;
  rawWebsiteData?: InputMaybe<Scalars['String']['input']>;
  rawWebsiteDataSize?: InputMaybe<Scalars['Float']['input']>;
  results?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  rowsAdded?: InputMaybe<Scalars['Float']['input']>;
  scrapeId?: InputMaybe<Scalars['MongoID']['input']>;
  sitemapLeaseExpiresAt?: InputMaybe<Scalars['Date']['input']>;
  sitemapOffset?: InputMaybe<Scalars['Float']['input']>;
  sitemapRevision?: InputMaybe<Scalars['Float']['input']>;
  sitemapTotalUrls?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<EnumImportScrapeRunStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyImportScrapeRunOperatorsInput = {
  _id?: InputMaybe<FilterFindManyImportScrapeRun_IdOperatorsInput>;
  scrapeId?: InputMaybe<FilterFindManyImportScrapeRunScrapeIdOperatorsInput>;
};

export type FilterFindManyImportScrapeRunScrapeIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyImportScrapeRun_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyImportScrapeSitemapEntriesInput = {
  imageUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyImportScrape_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyImport_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInventoryItemInput = {
  AND?: InputMaybe<Array<FilterFindManyInventoryItemInput>>;
  OR?: InputMaybe<Array<FilterFindManyInventoryItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyInventoryItemOperatorsInput>;
  claimedDateRangesISO?: InputMaybe<Array<InputMaybe<FilterFindManyDateRangeIsoInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  product?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumInventoryItemType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyInventoryItemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyInventoryItem_IdOperatorsInput>;
};

export type FilterFindManyInventoryItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInviteQueueBouncedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyInviteQueueInitiatedByUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInviteQueueInput = {
  AND?: InputMaybe<Array<FilterFindManyInviteQueueInput>>;
  OR?: InputMaybe<Array<FilterFindManyInviteQueueInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyInviteQueueOperatorsInput>;
  activityLogIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  bounced?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  initiatedByUser?: InputMaybe<Scalars['MongoID']['input']>;
  initiatedByUserName?: InputMaybe<Scalars['String']['input']>;
  initiatedDate?: InputMaybe<Scalars['Date']['input']>;
  inviteByEmailOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inviteStatus?: InputMaybe<EnumInviteQueueInviteStatus>;
  inviteType?: InputMaybe<EnumInviteQueueInviteType>;
  invitedEmail?: InputMaybe<Scalars['String']['input']>;
  invitedOperator?: InputMaybe<Scalars['MongoID']['input']>;
  invitedOperatorName?: InputMaybe<Scalars['String']['input']>;
  invitedUser?: InputMaybe<Scalars['MongoID']['input']>;
  invitedUserName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['MongoID']['input']>;
  preSendStatus?: InputMaybe<EnumInviteQueuePreSendStatus>;
  sendBatchId?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyInviteQueueInviteStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInviteQueueInviteStatus>;
  gte?: InputMaybe<EnumInviteQueueInviteStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInviteQueueInviteStatus>>>;
  lt?: InputMaybe<EnumInviteQueueInviteStatus>;
  lte?: InputMaybe<EnumInviteQueueInviteStatus>;
  ne?: InputMaybe<EnumInviteQueueInviteStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInviteQueueInviteStatus>>>;
};

export type FilterFindManyInviteQueueInvitedOperatorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInviteQueueInvitedUserOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyInviteQueueOperatorsInput = {
  _id?: InputMaybe<FilterFindManyInviteQueue_IdOperatorsInput>;
  bounced?: InputMaybe<FilterFindManyInviteQueueBouncedOperatorsInput>;
  initiatedByUser?: InputMaybe<FilterFindManyInviteQueueInitiatedByUserOperatorsInput>;
  inviteStatus?: InputMaybe<FilterFindManyInviteQueueInviteStatusOperatorsInput>;
  invitedOperator?: InputMaybe<FilterFindManyInviteQueueInvitedOperatorOperatorsInput>;
  invitedUser?: InputMaybe<FilterFindManyInviteQueueInvitedUserOperatorsInput>;
  organizationId?: InputMaybe<FilterFindManyInviteQueueOrganizationIdOperatorsInput>;
  sendBatchId?: InputMaybe<FilterFindManyInviteQueueSendBatchIdOperatorsInput>;
};

export type FilterFindManyInviteQueueOrganizationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInviteQueueSendBatchIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInviteQueue_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLeadBroadcastIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLeadInput = {
  AND?: InputMaybe<Array<FilterFindManyLeadInput>>;
  OR?: InputMaybe<Array<FilterFindManyLeadInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyLeadOperatorsInput>;
  broadcastId?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<FilterFindManyLeadMessagesInput>>>;
  metadata?: InputMaybe<FilterFindManyLeadMetadataInput>;
  person?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumLeadSource>;
  sourceDetails?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumLeadStatus>;
  subject?: InputMaybe<Scalars['String']['input']>;
  surveyResponse?: InputMaybe<Scalars['MongoID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumLeadType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyLeadMessagesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<EnumLeadMessagesSender>;
  sentAtDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyLeadMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  booker?: InputMaybe<Scalars['MongoID']['input']>;
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLeadOperatorsInput = {
  _id?: InputMaybe<FilterFindManyLead_IdOperatorsInput>;
  broadcastId?: InputMaybe<FilterFindManyLeadBroadcastIdOperatorsInput>;
  person?: InputMaybe<FilterFindManyLeadPersonOperatorsInput>;
  source?: InputMaybe<FilterFindManyLeadSourceOperatorsInput>;
  status?: InputMaybe<FilterFindManyLeadStatusOperatorsInput>;
  surveyResponse?: InputMaybe<FilterFindManyLeadSurveyResponseOperatorsInput>;
  tags?: InputMaybe<FilterFindManyLeadTagsOperatorsInput>;
  type?: InputMaybe<FilterFindManyLeadTypeOperatorsInput>;
};

export type FilterFindManyLeadPersonOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLeadSourceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumLeadSource>;
  gte?: InputMaybe<EnumLeadSource>;
  in?: InputMaybe<Array<InputMaybe<EnumLeadSource>>>;
  lt?: InputMaybe<EnumLeadSource>;
  lte?: InputMaybe<EnumLeadSource>;
  ne?: InputMaybe<EnumLeadSource>;
  nin?: InputMaybe<Array<InputMaybe<EnumLeadSource>>>;
};

export type FilterFindManyLeadStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumLeadStatus>;
  gte?: InputMaybe<EnumLeadStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumLeadStatus>>>;
  lt?: InputMaybe<EnumLeadStatus>;
  lte?: InputMaybe<EnumLeadStatus>;
  ne?: InputMaybe<EnumLeadStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumLeadStatus>>>;
};

export type FilterFindManyLeadSurveyResponseOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLeadTagsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLeadTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumLeadType>;
  gte?: InputMaybe<EnumLeadType>;
  in?: InputMaybe<Array<InputMaybe<EnumLeadType>>>;
  lt?: InputMaybe<EnumLeadType>;
  lte?: InputMaybe<EnumLeadType>;
  ne?: InputMaybe<EnumLeadType>;
  nin?: InputMaybe<Array<InputMaybe<EnumLeadType>>>;
};

export type FilterFindManyLead_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLinksInput = {
  bookNow?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  googleMyBusiness?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  otherUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pinterest?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  tripAdvisor?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyListInput = {
  AND?: InputMaybe<Array<FilterFindManyListInput>>;
  OR?: InputMaybe<Array<FilterFindManyListInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyListOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  audienceListKey?: InputMaybe<EnumListAudienceListKey>;
  audienceTagId?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  entityReferences?: InputMaybe<Array<InputMaybe<FilterFindManyVersionedEntityReferenceInput>>>;
  externallyAvailableEntityReferences?: InputMaybe<Array<InputMaybe<FilterFindManyVersionedEntityReferenceInput>>>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  filterTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  kind?: InputMaybe<EnumListKind>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  lockedAt?: InputMaybe<Scalars['Date']['input']>;
  lockedBy?: InputMaybe<Scalars['MongoID']['input']>;
  lockedByName?: InputMaybe<Scalars['String']['input']>;
  memberListKey?: InputMaybe<EnumListMemberListKey>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  orderIndex?: InputMaybe<Scalars['Float']['input']>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  selections?: InputMaybe<Scalars['JSON']['input']>;
  tierTagId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumListType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyListOperatorsInput = {
  _id?: InputMaybe<FilterFindManyList_IdOperatorsInput>;
};

export type FilterFindManyList_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyMerchMetadataDimensionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  drivesImages?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  values?: InputMaybe<Array<InputMaybe<FilterFindManyMerchMetadataDimensionsValuesInput>>>;
};

export type FilterFindManyMerchMetadataDimensionsValuesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<FilterFindManyMultilingualInput>;
};

export type FilterFindManyMerchMetadataInput = {
  dimensions?: InputMaybe<Array<InputMaybe<FilterFindManyMerchMetadataDimensionsInput>>>;
  lowStockThreshold?: InputMaybe<Scalars['Float']['input']>;
  variants?: InputMaybe<Array<InputMaybe<FilterFindManyMerchMetadataVariantsInput>>>;
};

export type FilterFindManyMerchMetadataVariantsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  dimensionValueIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inventoryCount?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyMultilingualInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyNoteInput = {
  AND?: InputMaybe<Array<FilterFindManyNoteInput>>;
  OR?: InputMaybe<Array<FilterFindManyNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNoteOperatorsInput>;
  author?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entity?: InputMaybe<FilterFindManyEntityReferenceInput>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<EnumNoteKind>;
  mentions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  noteDateISO?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  resolvedBy?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyNoteKindOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumNoteKind>;
  gte?: InputMaybe<EnumNoteKind>;
  in?: InputMaybe<Array<InputMaybe<EnumNoteKind>>>;
  lt?: InputMaybe<EnumNoteKind>;
  lte?: InputMaybe<EnumNoteKind>;
  ne?: InputMaybe<EnumNoteKind>;
  nin?: InputMaybe<Array<InputMaybe<EnumNoteKind>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNoteOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNote_IdOperatorsInput>;
  kind?: InputMaybe<FilterFindManyNoteKindOperatorsInput>;
};

export type FilterFindManyNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOperatorEnrollmentsInput = {
  currentStatus?: InputMaybe<EnumOperatorEnrollmentsCurrentStatus>;
  onboardingStatus?: InputMaybe<EnumOperatorEnrollmentsOnboardingStatus>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  organizationControlled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyOperatorEnrollmentsOperatorsInput = {
  organization?: InputMaybe<FilterFindManyOperatorEnrollmentsOrganizationOperatorsInput>;
};

export type FilterFindManyOperatorEnrollmentsOrganizationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOperatorExternalVideoLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyOperatorInput = {
  AND?: InputMaybe<Array<FilterFindManyOperatorInput>>;
  OR?: InputMaybe<Array<FilterFindManyOperatorInput>>;
  /** Filter operators by _entityId. Accepts an array of _entityId. */
  _entityId?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOperatorOperatorsInput>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  accommodationMetadata?: InputMaybe<FilterFindManyAccommodationOperatorMetadataInput>;
  /** Include/exclude operators by listing-audience Back Office tags. Applied only when listing_audiences is enabled for the org. */
  audienceTagFilters?: InputMaybe<Array<AudienceTagFilterInput>>;
  avgImageQuality?: InputMaybe<EnumOperatorAvgImageQuality>;
  canonicalDocument?: InputMaybe<Scalars['String']['input']>;
  claimed?: InputMaybe<Scalars['Boolean']['input']>;
  connectedOrganization?: InputMaybe<Scalars['MongoID']['input']>;
  /** Filter operators by contact details. You may check if certain links exist or not by passing a boolean value */
  contact?: InputMaybe<ContactWithBooleanLinks>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  enableMembershipLink?: InputMaybe<Scalars['Boolean']['input']>;
  enrollments?: InputMaybe<Array<InputMaybe<FilterFindManyOperatorEnrollmentsInput>>>;
  experienceMetadata?: InputMaybe<FilterFindManyExperienceOperatorMetadataInput>;
  externalVideoLinks?: InputMaybe<Array<InputMaybe<FilterFindManyOperatorExternalVideoLinksInput>>>;
  /** Filter operators by which days of the week they're open or closed. */
  hoursOfOperation?: InputMaybe<BooleanHoursOfOperation>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  import?: InputMaybe<Scalars['JSON']['input']>;
  /** Filter operators by updatedDateISO range. Use after and/or before (inclusive). */
  lastUpdated?: InputMaybe<LastUpdatedFilterInput>;
  /** Filter operators by location using a point and radius. Accepts a value of [longitude, latitude, radius] */
  location?: InputMaybe<Array<Scalars['Float']['input']>>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  /** Filter operators by operationalStatus. Accepts an array of operationalStatus values. */
  operationalStatus?: InputMaybe<Array<InputMaybe<EnumOperatorOperationalStatus>>>;
  /** Filter operators by enrollment organizationControlled status for a specific organization. Uses $elemMatch to ensure both conditions match the same enrollment entry. */
  organizationControlled?: InputMaybe<OrganizationControlledFilterInput>;
  /** Filter operators by organization ids */
  organizations?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter operators by pricing. Accepts an array of pricing values. */
  pricing?: InputMaybe<Array<InputMaybe<EnumOperatorPricing>>>;
  restaurantMetadata?: InputMaybe<FilterFindManyRestaurantOperatorMetadataInput>;
  /** Filter operators by a search string that filters by operator name */
  search?: InputMaybe<Scalars['String']['input']>;
  searchName?: InputMaybe<FilterFindManyMultilingualInput>;
  /** Filter operators by which months of the year they're open or closed. */
  seasonality?: InputMaybe<BooleanSeasonality>;
  /** Search all operators that have selected tag groups that are included */
  selectedTagGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceMetadata?: InputMaybe<FilterFindManyServiceOperatorMetadataInput>;
  shortDescription?: InputMaybe<FilterFindManyMultilingualInput>;
  /** Search all operator tags by $in operator */
  tags?: InputMaybe<OperatorTagsInput>;
  toursMetadata?: InputMaybe<FilterFindManyToursOperatorMetadataInput>;
  type?: InputMaybe<EnumOperatorType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  whereabotDismissed?: InputMaybe<FilterFindManyOperatorWhereabotDismissedInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOperatorOperatorsInput = {
  _entityId?: InputMaybe<FilterFindManyOperator_EntityIdOperatorsInput>;
  _id?: InputMaybe<FilterFindManyOperator_IdOperatorsInput>;
  _versionId?: InputMaybe<FilterFindManyOperator_VersionIdOperatorsInput>;
  enrollments?: InputMaybe<FilterFindManyOperatorEnrollmentsOperatorsInput>;
  type?: InputMaybe<FilterFindManyOperatorTypeOperatorsInput>;
};

export type FilterFindManyOperatorTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumOperatorType>;
  gte?: InputMaybe<EnumOperatorType>;
  in?: InputMaybe<Array<InputMaybe<EnumOperatorType>>>;
  lt?: InputMaybe<EnumOperatorType>;
  lte?: InputMaybe<EnumOperatorType>;
  ne?: InputMaybe<EnumOperatorType>;
  nin?: InputMaybe<Array<InputMaybe<EnumOperatorType>>>;
};

export type FilterFindManyOperatorWhereabotDismissedInput = {
  imageScan?: InputMaybe<Scalars['Date']['input']>;
  listingScan?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyOperator_EntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOperator_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOperator_VersionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOrderAdditionalLineItemsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyOrderApprovalInput = {
  decidedAt?: InputMaybe<Scalars['Date']['input']>;
  decidedBy?: InputMaybe<Scalars['MongoID']['input']>;
  declineReason?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  messageFromGuest?: InputMaybe<Scalars['String']['input']>;
  requestedAt?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<EnumOrderApprovalStatus>;
};

export type FilterFindManyOrderApprovalOperatorsInput = {
  status?: InputMaybe<FilterFindManyOrderApprovalStatusOperatorsInput>;
};

export type FilterFindManyOrderApprovalStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumOrderApprovalStatus>;
  gte?: InputMaybe<EnumOrderApprovalStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumOrderApprovalStatus>>>;
  lt?: InputMaybe<EnumOrderApprovalStatus>;
  lte?: InputMaybe<EnumOrderApprovalStatus>;
  ne?: InputMaybe<EnumOrderApprovalStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumOrderApprovalStatus>>>;
};

export type FilterFindManyOrderArrivalHistoryInput = {
  action?: InputMaybe<EnumOrderArrivalHistoryAction>;
  attendanceKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  guestIndexes?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  performedBy?: InputMaybe<Scalars['MongoID']['input']>;
  performedByName?: InputMaybe<Scalars['String']['input']>;
  sessionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source?: InputMaybe<EnumOrderArrivalHistorySource>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyOrderBillingInput = {
  consolidation?: InputMaybe<EnumOrderBillingConsolidation>;
  invoicePaymentRequestId?: InputMaybe<Scalars['MongoID']['input']>;
  serviceEndAt?: InputMaybe<Scalars['Date']['input']>;
  statementPeriod?: InputMaybe<Scalars['String']['input']>;
  timing?: InputMaybe<EnumOrderBillingTiming>;
};

export type FilterFindManyOrderCustomerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOrderDeliveryInput = {
  method?: InputMaybe<EnumOrderDeliveryMethod>;
  pickupLocationAddress?: InputMaybe<Scalars['String']['input']>;
  pickupLocationId?: InputMaybe<Scalars['String']['input']>;
  pickupLocationName?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<FilterFindManyAddressInput>;
  shippingTotal?: InputMaybe<Scalars['Float']['input']>;
  shippingZoneName?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyOrderFulfillmentInput = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  fulfilledAt?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumOrderFulfillmentStatus>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyOrderGuestsEventOptionsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  sourceTransactionId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyOrderGuestsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  eventOptions?: InputMaybe<Array<InputMaybe<FilterFindManyOrderGuestsEventOptionsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyOrderInput = {
  AND?: InputMaybe<Array<FilterFindManyOrderInput>>;
  OR?: InputMaybe<Array<FilterFindManyOrderInput>>;
  _custom?: InputMaybe<CustomOrderFilter>;
  _id?: InputMaybe<Scalars['String']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOrderOperatorsInput>;
  additionalLineItems?: InputMaybe<Array<InputMaybe<FilterFindManyOrderAdditionalLineItemsInput>>>;
  approval?: InputMaybe<FilterFindManyOrderApprovalInput>;
  arrivalHistory?: InputMaybe<Array<InputMaybe<FilterFindManyOrderArrivalHistoryInput>>>;
  billing?: InputMaybe<FilterFindManyOrderBillingInput>;
  billingAddress?: InputMaybe<FilterFindManyAddressInput>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customer?: InputMaybe<Scalars['MongoID']['input']>;
  delivery?: InputMaybe<FilterFindManyOrderDeliveryInput>;
  discounts?: InputMaybe<Array<InputMaybe<FilterFindManyDiscountInput>>>;
  fulfillment?: InputMaybe<FilterFindManyOrderFulfillmentInput>;
  guests?: InputMaybe<Array<InputMaybe<FilterFindManyOrderGuestsInput>>>;
  manualPaymentNote?: InputMaybe<FilterFindManyOrderManualPaymentNoteInput>;
  paymentMetadata?: InputMaybe<FilterFindManyOrderPaymentMetadataInput>;
  pricingSnapshot?: InputMaybe<FilterFindManyOrderPricingSnapshotInput>;
  purchasedProducts?: InputMaybe<Array<InputMaybe<FilterFindManyPurchasedProductInput>>>;
  source?: InputMaybe<FilterFindManyOrderSourceInput>;
  stripeMetadata?: InputMaybe<FilterFindManyStripeMetadataInput>;
  surveyResponse?: InputMaybe<Scalars['MongoID']['input']>;
  taxExemption?: InputMaybe<FilterFindManyOrderTaxExemptionInput>;
  teamVisible?: InputMaybe<Scalars['Boolean']['input']>;
  testMode?: InputMaybe<Scalars['Boolean']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyOrderManualPaymentNoteInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  recordedAt?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOrderOperatorsInput = {
  _id?: InputMaybe<FilterFindManyOrder_IdOperatorsInput>;
  approval?: InputMaybe<FilterFindManyOrderApprovalOperatorsInput>;
  customer?: InputMaybe<FilterFindManyOrderCustomerOperatorsInput>;
  source?: InputMaybe<FilterFindManyOrderSourceOperatorsInput>;
  teamVisible?: InputMaybe<FilterFindManyOrderTeamVisibleOperatorsInput>;
  testMode?: InputMaybe<FilterFindManyOrderTestModeOperatorsInput>;
};

export type FilterFindManyOrderPricingSnapshotDiscountTotalsInput = {
  discountId?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyOrderPricingSnapshotInput = {
  customerFee?: InputMaybe<Scalars['Float']['input']>;
  depositTotal?: InputMaybe<Scalars['Float']['input']>;
  discountTotal?: InputMaybe<Scalars['Float']['input']>;
  discountTotals?: InputMaybe<Array<InputMaybe<FilterFindManyOrderPricingSnapshotDiscountTotalsInput>>>;
  grandTotal?: InputMaybe<Scalars['Float']['input']>;
  lineItems?: InputMaybe<Array<InputMaybe<FilterFindManyOrderPricingSnapshotLineItemsInput>>>;
  productPrices?: InputMaybe<Array<InputMaybe<FilterFindManyOrderPricingSnapshotProductPricesInput>>>;
  shippingTotal?: InputMaybe<Scalars['Float']['input']>;
  subTotal?: InputMaybe<Scalars['Float']['input']>;
  taxLines?: InputMaybe<Array<InputMaybe<FilterFindManyOrderPricingSnapshotTaxLinesInput>>>;
  taxTotal?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyOrderPricingSnapshotLineItemsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  tierId?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyOrderPricingSnapshotProductPricesInput = {
  price?: InputMaybe<Scalars['Float']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyOrderPricingSnapshotTaxLinesInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ratePercent?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyOrderSourceInput = {
  accountingCode?: InputMaybe<Scalars['String']['input']>;
  accountingDate?: InputMaybe<Scalars['String']['input']>;
  booker?: InputMaybe<Scalars['MongoID']['input']>;
  broadcastId?: InputMaybe<Scalars['MongoID']['input']>;
  broadcastResourceId?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  customerInvoicePayment?: InputMaybe<Scalars['Boolean']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  internalAccountingNotes?: InputMaybe<Scalars['String']['input']>;
  operatorId?: InputMaybe<Scalars['MongoID']['input']>;
  operatorIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  paymentRequestId?: InputMaybe<Scalars['MongoID']['input']>;
  paymentRequestVersion?: InputMaybe<Scalars['Float']['input']>;
  renewablePurchaseId?: InputMaybe<Scalars['MongoID']['input']>;
  renewalNextDate?: InputMaybe<Scalars['String']['input']>;
  renewalRecordId?: InputMaybe<Scalars['MongoID']['input']>;
  renewalStatus?: InputMaybe<Scalars['String']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumOrderSourceType>;
};

export type FilterFindManyOrderSourceOperatorsInput = {
  storefront?: InputMaybe<FilterFindManyOrderSourceStorefrontOperatorsInput>;
};

export type FilterFindManyOrderSourceStorefrontOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOrderTaxExemptionInput = {
  claimed?: InputMaybe<Scalars['Boolean']['input']>;
  exemptionNumber?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyOrderTeamVisibleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyOrderTestModeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyOrder_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyOrganizationAppSettingsInput = {
  widgets?: InputMaybe<FilterFindManyOrganizationAppSettingsWidgetsInput>;
};

export type FilterFindManyOrganizationAppSettingsWidgetsEventInput = {
  hideCancelledEvents?: InputMaybe<Scalars['Boolean']['input']>;
  organizerAudienceTagFilters?: InputMaybe<Array<InputMaybe<FilterFindManyOrganizationAppSettingsWidgetsEventOrganizerAudienceTagFiltersInput>>>;
  venueAudienceTagFilters?: InputMaybe<Array<InputMaybe<FilterFindManyOrganizationAppSettingsWidgetsEventVenueAudienceTagFiltersInput>>>;
};

export type FilterFindManyOrganizationAppSettingsWidgetsEventOrganizerAudienceTagFiltersInput = {
  mode?: InputMaybe<EnumOrganizationAppSettingsWidgetsEventOrganizerAudienceTagFiltersMode>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyOrganizationAppSettingsWidgetsEventVenueAudienceTagFiltersInput = {
  mode?: InputMaybe<EnumOrganizationAppSettingsWidgetsEventVenueAudienceTagFiltersMode>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyOrganizationAppSettingsWidgetsInput = {
  event?: InputMaybe<FilterFindManyOrganizationAppSettingsWidgetsEventInput>;
  operator?: InputMaybe<FilterFindManyOrganizationAppSettingsWidgetsOperatorInput>;
  whatsNearby?: InputMaybe<FilterFindManyOrganizationAppSettingsWidgetsWhatsNearbyInput>;
};

export type FilterFindManyOrganizationAppSettingsWidgetsOperatorAudienceTagFiltersInput = {
  mode?: InputMaybe<EnumOrganizationAppSettingsWidgetsOperatorAudienceTagFiltersMode>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyOrganizationAppSettingsWidgetsOperatorInput = {
  audienceTagFilters?: InputMaybe<Array<InputMaybe<FilterFindManyOrganizationAppSettingsWidgetsOperatorAudienceTagFiltersInput>>>;
  audienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultImageId?: InputMaybe<Scalars['String']['input']>;
  defaultImageMode?: InputMaybe<EnumOrganizationAppSettingsWidgetsOperatorDefaultImageMode>;
  hidePermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  hideTemporarilyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  operatorWidgetFilter?: InputMaybe<EnumOrganizationAppSettingsWidgetsOperatorOperatorWidgetFilter>;
  prioritizeClaimedAndDmoManaged?: InputMaybe<Scalars['Boolean']['input']>;
  showPermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  showTestListings?: InputMaybe<Scalars['Boolean']['input']>;
  tierDisplayOverrides?: InputMaybe<Array<InputMaybe<FilterFindManyOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesInput>>>;
  tieredSortOrder?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesInput = {
  slideout?: InputMaybe<FilterFindManyOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesSlideoutInput>;
  statusSortOrder?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
  teaser?: InputMaybe<FilterFindManyOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesTeaserInput>;
};

export type FilterFindManyOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesSlideoutInput = {
  hideAddress?: InputMaybe<Scalars['Boolean']['input']>;
  hideExternalLinks?: InputMaybe<Scalars['Boolean']['input']>;
  hideLongDescription?: InputMaybe<Scalars['Boolean']['input']>;
  hideMap?: InputMaybe<Scalars['Boolean']['input']>;
  hideOperatingHours?: InputMaybe<Scalars['Boolean']['input']>;
  limitImages?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesTeaserInput = {
  hideImage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyOrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFiltersInput = {
  mode?: InputMaybe<EnumOrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFiltersMode>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyOrganizationAppSettingsWidgetsWhatsNearbyInput = {
  audienceTagFilters?: InputMaybe<Array<InputMaybe<FilterFindManyOrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFiltersInput>>>;
  audienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOrganizationEmailBrandingInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  footerText?: InputMaybe<FilterFindManyMultilingualInput>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyOrganizationInput = {
  AND?: InputMaybe<Array<FilterFindManyOrganizationInput>>;
  OR?: InputMaybe<Array<FilterFindManyOrganizationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOrganizationOperatorsInput>;
  appSettings?: InputMaybe<FilterFindManyOrganizationAppSettingsInput>;
  brandColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<FilterFindManyContactInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailBranding?: InputMaybe<FilterFindManyOrganizationEmailBrandingInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  license?: InputMaybe<FilterFindManyOrganizationLicenseInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<FilterFindManyOrganizationMetadataInput>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  onboardingMetadata?: InputMaybe<FilterFindManyOrganizationOnboardingMetadataInput>;
  shortDescription?: InputMaybe<FilterFindManyMultilingualInput>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyOrganizationLicenseInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  activatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  activatedDate?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyOrganizationMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  canEnableMembershipLink?: InputMaybe<Scalars['Boolean']['input']>;
  claimedListingStaleDays?: InputMaybe<Scalars['Float']['input']>;
  connectedOperator?: InputMaybe<Scalars['MongoID']['input']>;
  connectedStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  connectedTestStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  connectedUsdStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  connectedUsdTestStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  crowdriffEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  customClaimEmailBody?: InputMaybe<Scalars['String']['input']>;
  customClaimEmailSubject?: InputMaybe<Scalars['String']['input']>;
  customPingEmailBody?: InputMaybe<Scalars['String']['input']>;
  customPingEmailSubject?: InputMaybe<Scalars['String']['input']>;
  disabledApps?: InputMaybe<Array<InputMaybe<EnumOrganizationMetadataDisabledApps>>>;
  dmoListingStaleDays?: InputMaybe<Scalars['Float']['input']>;
  eventLookaheadMonths?: InputMaybe<Scalars['Float']['input']>;
  eventPartnerOrganizations?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  eventSharingCode?: InputMaybe<Scalars['String']['input']>;
  externalVideoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  individualMembershipTiers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  internalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inviteWhenAddingStaff?: InputMaybe<Scalars['Boolean']['input']>;
  listingAudienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  listingFreshnessEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  membershipBroadcastId?: InputMaybe<Scalars['MongoID']['input']>;
  membershipHub?: InputMaybe<FilterFindManyOrganizationMetadataMembershipHubInput>;
  membershipLaunch?: InputMaybe<FilterFindManyOrganizationMetadataMembershipLaunchInput>;
  membershipPageUrl?: InputMaybe<Scalars['String']['input']>;
  membershipPaymentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  membershipStatusTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  membershipTierCheckouts?: InputMaybe<Array<InputMaybe<FilterFindManyOrganizationMetadataMembershipTierCheckoutsInput>>>;
  membershipTiers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  nomenclature?: InputMaybe<FilterFindManyOrganizationMetadataNomenclatureInput>;
  operatorOnboardingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  renewalSettings?: InputMaybe<FilterFindManyOrganizationMetadataRenewalSettingsInput>;
  sandbox?: InputMaybe<Scalars['Boolean']['input']>;
  storefrontMode?: InputMaybe<EnumOrganizationMetadataStorefrontMode>;
  storefrontOrgConnectionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  testRecordTagId?: InputMaybe<Scalars['MongoID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  whereabotImageDownloadPrompt?: InputMaybe<Scalars['String']['input']>;
  whereabotListingUpdatePrompt?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyOrganizationMetadataMembershipHubInput = {
  hideOfferFromForYou?: InputMaybe<Scalars['Boolean']['input']>;
  tiers?: InputMaybe<Array<InputMaybe<FilterFindManyOrganizationMetadataMembershipHubTiersInput>>>;
};

export type FilterFindManyOrganizationMetadataMembershipHubTiersInput = {
  applicationBroadcastId?: InputMaybe<Scalars['MongoID']['input']>;
  applicationResourceId?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  hideFromNewcomers?: InputMaybe<Scalars['Boolean']['input']>;
  tierTagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyOrganizationMetadataMembershipLaunchInput = {
  launchedAt?: InputMaybe<Scalars['Date']['input']>;
  launchedBy?: InputMaybe<Scalars['MongoID']['input']>;
  mode?: InputMaybe<EnumOrganizationMetadataMembershipLaunchMode>;
  recordedRetroactively?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleHistory?: InputMaybe<Array<InputMaybe<FilterFindManyOrganizationMetadataMembershipLaunchScheduleHistoryInput>>>;
  settingsAtLaunch?: InputMaybe<FilterFindManyOrganizationMetadataMembershipLaunchSettingsAtLaunchInput>;
  state?: InputMaybe<EnumOrganizationMetadataMembershipLaunchState>;
};

export type FilterFindManyOrganizationMetadataMembershipLaunchScheduleHistoryInput = {
  affected?: InputMaybe<Scalars['Float']['input']>;
  at?: InputMaybe<Scalars['Date']['input']>;
  by?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  from?: InputMaybe<FilterFindManyOrganizationMetadataMembershipLaunchSettingsAtLaunchInput>;
  intent?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<FilterFindManyOrganizationMetadataMembershipLaunchSettingsAtLaunchInput>;
};

export type FilterFindManyOrganizationMetadataMembershipLaunchSettingsAtLaunchInput = {
  fixedRenewalDay?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalMonth?: InputMaybe<Scalars['Float']['input']>;
  renewalType?: InputMaybe<EnumOrganizationMetadataMembershipLaunchSettingsAtLaunchRenewalType>;
  term?: InputMaybe<EnumOrganizationMetadataMembershipLaunchSettingsAtLaunchTerm>;
  termYears?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyOrganizationMetadataMembershipTierCheckoutsInput = {
  bookerId?: InputMaybe<Scalars['MongoID']['input']>;
  free?: InputMaybe<Scalars['Boolean']['input']>;
  tierTagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyOrganizationMetadataNomenclatureInput = {
  member?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Scalars['String']['input']>;
  membership?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyOrganizationMetadataRenewalSettingsInput = {
  activeStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  automaticRenewalEmails?: InputMaybe<Scalars['Boolean']['input']>;
  cancelledEmail?: InputMaybe<FilterFindManyOrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  cancelledStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  clearStatusTagsOnExpiration?: InputMaybe<Scalars['Boolean']['input']>;
  emailCooldownDays?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  engineOwnedTags?: InputMaybe<Scalars['Boolean']['input']>;
  expiredEmail?: InputMaybe<FilterFindManyOrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  expiredStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  fixedRenewalDay?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalMonth?: InputMaybe<Scalars['Float']['input']>;
  instructionsEmail?: InputMaybe<FilterFindManyOrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  invoiceLeadDays?: InputMaybe<Scalars['Float']['input']>;
  neverExpireMembers?: InputMaybe<Scalars['Boolean']['input']>;
  overdueEmail?: InputMaybe<FilterFindManyOrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  overdueStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  pendingStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  proRateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  renewalGraceDays?: InputMaybe<Scalars['Float']['input']>;
  renewalReminderLeadDays?: InputMaybe<Scalars['Float']['input']>;
  renewalType?: InputMaybe<EnumOrganizationMetadataRenewalSettingsRenewalType>;
  sendCancelledEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendExpirationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendOverdueEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendRenewalEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendSuccessEmails?: InputMaybe<Scalars['Boolean']['input']>;
  successEmail?: InputMaybe<FilterFindManyOrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  term?: InputMaybe<EnumOrganizationMetadataRenewalSettingsTerm>;
  termYears?: InputMaybe<Scalars['Float']['input']>;
  tierReminderEmails?: InputMaybe<Array<InputMaybe<FilterFindManyOrganizationMetadataRenewalSettingsTierReminderEmailsInput>>>;
};

export type FilterFindManyOrganizationMetadataRenewalSettingsInstructionsEmailInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyOrganizationMetadataRenewalSettingsTierReminderEmailsInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  hideRenewalDateLine?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tierTagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyOrganizationOnboardingMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  allowColdSignup?: InputMaybe<Scalars['Boolean']['input']>;
  coldSignupTagId?: InputMaybe<Scalars['MongoID']['input']>;
  comingSoonMessage?: InputMaybe<Scalars['String']['input']>;
  introMessage?: InputMaybe<Scalars['String']['input']>;
  typeformSurveyId?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOrganizationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyOrganization_IdOperatorsInput>;
  subdomain?: InputMaybe<FilterFindManyOrganizationSubdomainOperatorsInput>;
};

export type FilterFindManyOrganizationSubdomainOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyOrganization_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyOwnerInput = {
  entityId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumOwnerType>;
};

export type FilterFindManyPaymentMethodSetCopiedFromOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPaymentMethodSetInput = {
  AND?: InputMaybe<Array<FilterFindManyPaymentMethodSetInput>>;
  OR?: InputMaybe<Array<FilterFindManyPaymentMethodSetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPaymentMethodSetOperatorsInput>;
  acceptedPaymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bankTransferInstructions?: InputMaybe<Scalars['String']['input']>;
  checkoutDescription?: InputMaybe<Scalars['String']['input']>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  methodLabels?: InputMaybe<FilterFindManyPaymentMethodSetMethodLabelsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  offlinePaymentInstructions?: InputMaybe<Scalars['String']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyPaymentMethodSetMethodLabelsInput = {
  bank_transfer?: InputMaybe<Scalars['String']['input']>;
  card?: InputMaybe<Scalars['String']['input']>;
  direct_debit?: InputMaybe<Scalars['String']['input']>;
  offline_payment?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPaymentMethodSetOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPaymentMethodSet_IdOperatorsInput>;
  copiedFrom?: InputMaybe<FilterFindManyPaymentMethodSetCopiedFromOperatorsInput>;
};

export type FilterFindManyPaymentMethodSet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPeopleEmailLowerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPeopleEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyPeopleInput = {
  AND?: InputMaybe<Array<FilterFindManyPeopleInput>>;
  OR?: InputMaybe<Array<FilterFindManyPeopleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPeopleOperatorsInput>;
  address?: InputMaybe<FilterFindManyAddressInput>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  contactMethod?: InputMaybe<EnumPeopleContactMethod>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailLower?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  faxExt?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  import?: InputMaybe<Scalars['JSON']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leads?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  mailingAddress?: InputMaybe<FilterFindManyAddressInput>;
  optInEmail?: InputMaybe<Scalars['Boolean']['input']>;
  optInFax?: InputMaybe<Scalars['Boolean']['input']>;
  optInPhone?: InputMaybe<Scalars['Boolean']['input']>;
  optInSMS?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photoUploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTitle?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  visibleTo?: InputMaybe<Array<InputMaybe<FilterFindManyPeopleVisibleToInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPeopleOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPeople_IdOperatorsInput>;
  email?: InputMaybe<FilterFindManyPeopleEmailOperatorsInput>;
  emailLower?: InputMaybe<FilterFindManyPeopleEmailLowerOperatorsInput>;
};

export type FilterFindManyPeopleVisibleToInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  entity?: InputMaybe<FilterFindManyOwnerInput>;
  ignoreLeadSystemRole?: InputMaybe<Scalars['Boolean']['input']>;
  latestActivity?: InputMaybe<Scalars['Date']['input']>;
  metadata?: InputMaybe<FilterFindManyPeopleVisibleToMetadataInput>;
  scratchpad?: InputMaybe<Scalars['String']['input']>;
  systemRoles?: InputMaybe<Array<InputMaybe<EnumPeopleVisibleToSystemRoles>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<EnumPeopleVisibleToTypes>>>;
  wasManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyPeopleVisibleToMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  operatorOverrides?: InputMaybe<Array<InputMaybe<FilterFindManyPeopleVisibleToMetadataOperatorOverridesInput>>>;
  phones?: InputMaybe<Array<InputMaybe<FilterFindManyPeopleVisibleToMetadataPhonesInput>>>;
};

export type FilterFindManyPeopleVisibleToMetadataOperatorOverridesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  operatorEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyPeopleVisibleToMetadataPhonesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumPeopleVisibleToMetadataPhonesType>;
};

export type FilterFindManyPeople_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPlaceInput = {
  AND?: InputMaybe<Array<FilterFindManyPlaceInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlaceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlaceOperatorsInput>;
  connectedDmoListing?: InputMaybe<Scalars['MongoID']['input']>;
  connectedListing?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  outline?: InputMaybe<FilterFindManyPlaceOutlineInput>;
  outlineSimplified?: InputMaybe<FilterFindManyPlaceOutlineInput>;
  parentPlace?: InputMaybe<Scalars['MongoID']['input']>;
  /** Filter places by type(s) */
  placeType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter places by name (searches all language fields) */
  search?: InputMaybe<Scalars['String']['input']>;
  subPlaces?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumPlaceType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlaceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlace_IdOperatorsInput>;
  parentPlace?: InputMaybe<FilterFindManyPlaceParentPlaceOperatorsInput>;
  type?: InputMaybe<FilterFindManyPlaceTypeOperatorsInput>;
};

export type FilterFindManyPlaceOutlineInput = {
  coordinates: Scalars['JSON']['input'];
  type: EnumPlaceOutlineType;
};

export type FilterFindManyPlaceParentPlaceOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPlaceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumPlaceType>;
  gte?: InputMaybe<EnumPlaceType>;
  in?: InputMaybe<Array<InputMaybe<EnumPlaceType>>>;
  lt?: InputMaybe<EnumPlaceType>;
  lte?: InputMaybe<EnumPlaceType>;
  ne?: InputMaybe<EnumPlaceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumPlaceType>>>;
};

export type FilterFindManyPlace_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPolicyCopiedFromOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPolicyInput = {
  AND?: InputMaybe<Array<FilterFindManyPolicyInput>>;
  OR?: InputMaybe<Array<FilterFindManyPolicyInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPolicyOperatorsInput>;
  content?: InputMaybe<FilterFindManyMultilingualInput>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPolicyOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPolicy_IdOperatorsInput>;
  copiedFrom?: InputMaybe<FilterFindManyPolicyCopiedFromOperatorsInput>;
};

export type FilterFindManyPolicy_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPostHogDataInput = {
  AND?: InputMaybe<Array<FilterFindManyPostHogDataInput>>;
  OR?: InputMaybe<Array<FilterFindManyPostHogDataInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPostHogDataOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  metadata?: InputMaybe<FilterFindManyPostHogDataMetadataInput>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by timestamp range (use _gte with _lt) */
  timestampRange?: InputMaybe<DateInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyPostHogDataMetadataInput = {
  appContext?: InputMaybe<EnumPostHogDataMetadataAppContext>;
  booker?: InputMaybe<Scalars['MongoID']['input']>;
  broadcast?: InputMaybe<Scalars['MongoID']['input']>;
  event?: InputMaybe<Scalars['MongoID']['input']>;
  eventName?: InputMaybe<EnumPostHogDataMetadataEventName>;
  eventPersonId?: InputMaybe<Scalars['String']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  itinerary?: InputMaybe<Scalars['MongoID']['input']>;
  linkType?: InputMaybe<Scalars['String']['input']>;
  list?: InputMaybe<Scalars['MongoID']['input']>;
  media?: InputMaybe<Scalars['MongoID']['input']>;
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  person?: InputMaybe<Scalars['MongoID']['input']>;
  product?: InputMaybe<Scalars['MongoID']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  relatedListings?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  resourceId?: InputMaybe<Scalars['MongoID']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  widget?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPostHogDataOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPostHogData_IdOperatorsInput>;
};

export type FilterFindManyPostHogData_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPriceTierInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountUnit?: InputMaybe<EnumPriceTierDiscountUnit>;
  guestCountForPrice?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<FilterFindManyMultilingualInput>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<EnumPriceTierPriceType>;
  type?: InputMaybe<EnumGuestTierType>;
};

export type FilterFindManyPricingInput = {
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  tiers?: InputMaybe<Array<InputMaybe<FilterFindManyPriceTierInput>>>;
};

export type FilterFindManyProductAddOnSettingsInput = {
  businessScope?: InputMaybe<EnumProductAddOnSettingsBusinessScope>;
  pricingScope?: InputMaybe<EnumProductAddOnSettingsPricingScope>;
};

export type FilterFindManyProductContactInput = {
  address?: InputMaybe<FilterFindManyAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tollFreePublicPhone?: InputMaybe<Scalars['String']['input']>;
  useOwnerContact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyProductCustomFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  chargePerChoice?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  label?: InputMaybe<FilterFindManyMultilingualInput>;
  maxChoices?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindManyProductCustomFieldsOptionsInput>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<EnumProductCustomFieldsType>;
};

export type FilterFindManyProductCustomFieldsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<FilterFindManyMultilingualInput>;
};

export type FilterFindManyProductEventMetadataInput = {
  event?: InputMaybe<Scalars['MongoID']['input']>;
  includedSessionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  maxTicketsPerPurchase?: InputMaybe<Scalars['Float']['input']>;
  sellingType?: InputMaybe<EnumProductEventMetadataSellingType>;
  sessionGranularity?: InputMaybe<EnumProductEventMetadataSessionGranularity>;
  ticketStructure?: InputMaybe<EnumProductEventMetadataTicketStructure>;
};

export type FilterFindManyProductInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  accommodationMetadata?: InputMaybe<FilterFindManyAccommodationProductMetadataInput>;
  addOnSettings?: InputMaybe<FilterFindManyProductAddOnSettingsInput>;
  contact?: InputMaybe<FilterFindManyProductContactInput>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<FilterFindManyProductCustomFieldsInput>>>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  eventMetadata?: InputMaybe<FilterFindManyProductEventMetadataInput>;
  externalBookingUrl?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inventorySettings?: InputMaybe<FilterFindManyProductTierInventoryInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isUpsellOnly?: InputMaybe<Scalars['Boolean']['input']>;
  merchMetadata?: InputMaybe<FilterFindManyMerchMetadataInput>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  pricing?: InputMaybe<FilterFindManyPricingInput>;
  productTiers?: InputMaybe<Array<InputMaybe<FilterFindManyProductTierInput>>>;
  publicationStatus?: InputMaybe<EnumProductPublicationStatus>;
  quantitySettings?: InputMaybe<FilterFindManyProductTierQuantityInput>;
  renewableFeeMetadata?: InputMaybe<FilterFindManyRenewableFeeMetadataInput>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  sellingConfig?: InputMaybe<FilterFindManyProductSellingConfigInput>;
  shortDescription?: InputMaybe<FilterFindManyMultilingualInput>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumProductType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyProductSellingConfigInput = {
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  dynamicFeeSurvey?: InputMaybe<Scalars['MongoID']['input']>;
  inventory?: InputMaybe<FilterFindManyProductTierInventoryInput>;
  mode?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindManyProductTierInput>>>;
  quantity?: InputMaybe<FilterFindManyProductTierQuantityInput>;
  recurring?: InputMaybe<FilterFindManyProductSellingConfigRecurringInput>;
};

export type FilterFindManyProductSellingConfigRecurringInput = {
  billingIntervalMonths?: InputMaybe<Scalars['Float']['input']>;
  earlyPurchaseWindowDays?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fixedRenewalDay?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalMonth?: InputMaybe<Scalars['Float']['input']>;
  membershipLinked?: InputMaybe<Scalars['Boolean']['input']>;
  multiListing?: InputMaybe<FilterFindManyProductSellingConfigRecurringMultiListingInput>;
  proRateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  renewalType?: InputMaybe<EnumProductSellingConfigRecurringRenewalType>;
};

export type FilterFindManyProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountUnit>;
};

export type FilterFindManyProductSellingConfigRecurringMultiListingInput = {
  additionalBusinessDiscount?: InputMaybe<FilterFindManyProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountInput>;
  autoIncludeOwnedListings?: InputMaybe<Scalars['Boolean']['input']>;
  maxListings?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumProductSellingConfigRecurringMultiListingMode>;
};

export type FilterFindManyProductTierInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  autoTag?: InputMaybe<Scalars['MongoID']['input']>;
  condition?: InputMaybe<ProductTierConditionInput>;
  description?: InputMaybe<MultilingualInput>;
  includedSessionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inventory?: InputMaybe<ProductTierInventoryInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxSessions?: InputMaybe<Scalars['Float']['input']>;
  minSessions?: InputMaybe<Scalars['Float']['input']>;
  name: MultilingualInput;
  order: Scalars['Float']['input'];
  personTagConfig?: InputMaybe<ProductTierTagConfigInput>;
  price: Scalars['Float']['input'];
  quantity?: InputMaybe<ProductTierQuantityInput>;
  sessionScope?: InputMaybe<EnumProductTierSessionScope>;
  subCapacityPerSession?: InputMaybe<Scalars['Float']['input']>;
  tagConfig?: InputMaybe<ProductTierTagConfigInput>;
};

export type FilterFindManyProductTierInventoryInput = {
  currentCount: Scalars['Float']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  totalCount: Scalars['Float']['input'];
};

export type FilterFindManyProductTierQuantityInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxQuantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyPurchasedProductBusinessScopesInput = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  customFieldResponses?: InputMaybe<Array<InputMaybe<FilterFindManyPurchasedProductCustomFieldResponsesInput>>>;
  operatorId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyPurchasedProductCustomFieldResponsesInput = {
  fieldId: Scalars['String']['input'];
  isChoiceList?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: EnumPurchasedProductCustomFieldResponsesType;
};

export type FilterFindManyPurchasedProductGuestsPerTierInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  sessionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tierId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyPurchasedProductInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  businessScopes?: InputMaybe<Array<InputMaybe<FilterFindManyPurchasedProductBusinessScopesInput>>>;
  customFieldResponses?: InputMaybe<Array<InputMaybe<FilterFindManyPurchasedProductCustomFieldResponsesInput>>>;
  guestsPerTier?: InputMaybe<Array<InputMaybe<FilterFindManyPurchasedProductGuestsPerTierInput>>>;
  inventoryClaims?: InputMaybe<Array<InputMaybe<FilterFindManyPurchasedProductInventoryClaimsInput>>>;
  merchVariantId?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<FilterFindManyProductInput>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  sessionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tierId?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyPurchasedProductInventoryClaimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  claimedDateRangeISO?: InputMaybe<FilterFindManyDateRangeIsoInput>;
  inventory?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyRefundInput = {
  AND?: InputMaybe<Array<FilterFindManyRefundInput>>;
  OR?: InputMaybe<Array<FilterFindManyRefundInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRefundOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  processorChargeId?: InputMaybe<Scalars['String']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumRefundStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRefundOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRefund_IdOperatorsInput>;
  orderId?: InputMaybe<FilterFindManyRefundOrderIdOperatorsInput>;
};

export type FilterFindManyRefundOrderIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyRefund_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyRenewableFeeMetadataInput = {
  billingIntervalMonths?: InputMaybe<Scalars['Float']['input']>;
  earlyPurchaseWindowDays?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalDay?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalMonth?: InputMaybe<Scalars['Float']['input']>;
  membershipLinked?: InputMaybe<Scalars['Boolean']['input']>;
  proRateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  renewalType?: InputMaybe<EnumRenewableFeeMetadataRenewalType>;
};

export type FilterFindManyRestaurantOperatorMetadataInput = {
  seatingCapacity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyRoomInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumRoomType>;
};

export type FilterFindManyRuleCopiedFromOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyRuleInput = {
  AND?: InputMaybe<Array<FilterFindManyRuleInput>>;
  OR?: InputMaybe<Array<FilterFindManyRuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyRuleOperatorsInput>;
  activePeriod?: InputMaybe<FilterFindManyDateRangeIsoInput>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumRuleType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyRuleOperatorsInput = {
  _id?: InputMaybe<FilterFindManyRule_IdOperatorsInput>;
  copiedFrom?: InputMaybe<FilterFindManyRuleCopiedFromOperatorsInput>;
};

export type FilterFindManyRule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyScheduledPaymentInput = {
  AND?: InputMaybe<Array<FilterFindManyScheduledPaymentInput>>;
  OR?: InputMaybe<Array<FilterFindManyScheduledPaymentInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyScheduledPaymentOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  failureReasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Scalars['String']['input']>;
  /** Filter by orders */
  orders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  retryCount?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<EnumScheduledPaymentStatus>;
  stripeMetadata?: InputMaybe<FilterFindManyStripeMetadataInput>;
  successDateISO?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumScheduledPaymentType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyScheduledPaymentOperatorsInput = {
  _id?: InputMaybe<FilterFindManyScheduledPayment_IdOperatorsInput>;
};

export type FilterFindManyScheduledPayment_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySecurityDepositSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  placeHoldDaysBeforeCheckOut?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateType?: InputMaybe<EnumSecurityDepositSettingsRateType>;
};

export type FilterFindManyServiceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyStorefrontApplicationFeeDefaultsInput = {
  membership?: InputMaybe<Scalars['Float']['input']>;
  merch?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyStorefrontEmailBrandingInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  footerText?: InputMaybe<FilterFindManyMultilingualInput>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
  useOrganizationEmailSettings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyStorefrontEnabledFeeTypesInput = {
  accommodations?: InputMaybe<Scalars['Boolean']['input']>;
  events?: InputMaybe<Scalars['Boolean']['input']>;
  merch?: InputMaybe<Scalars['Boolean']['input']>;
  oneTimeFee?: InputMaybe<Scalars['Boolean']['input']>;
  renewableFees?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyStorefrontInput = {
  AND?: InputMaybe<Array<FilterFindManyStorefrontInput>>;
  OR?: InputMaybe<Array<FilterFindManyStorefrontInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyStorefrontOperatorsInput>;
  accountingCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  applicationFeeDefaults?: InputMaybe<FilterFindManyStorefrontApplicationFeeDefaultsInput>;
  applicationPercentage?: InputMaybe<Scalars['Float']['input']>;
  connectedAccountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  connectedListings?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  connectedListingsConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customProductNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultInvoicePolicy?: InputMaybe<Scalars['MongoID']['input']>;
  defaultWidgetLogo?: InputMaybe<Scalars['String']['input']>;
  emailBranding?: InputMaybe<FilterFindManyStorefrontEmailBrandingInput>;
  enabledFeeTypes?: InputMaybe<FilterFindManyStorefrontEnabledFeeTypesInput>;
  invoiceTemplateBooker?: InputMaybe<Scalars['MongoID']['input']>;
  invoicingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLowStockDigestKey?: InputMaybe<Scalars['String']['input']>;
  launchedAt?: InputMaybe<Scalars['Date']['input']>;
  liveStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  lowStockDigestEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  paymentsMode?: InputMaybe<EnumStorefrontPaymentsMode>;
  siteMetadata?: InputMaybe<FilterFindManyStorefrontSiteMetadataInput>;
  statementSettings?: InputMaybe<FilterFindManyStorefrontStatementSettingsInput>;
  stripeRegion?: InputMaybe<EnumStorefrontStripeRegion>;
  testMode?: InputMaybe<Scalars['Boolean']['input']>;
  testStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyStorefrontLiveStorefrontOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyStorefrontOperatorsInput = {
  _id?: InputMaybe<FilterFindManyStorefront_IdOperatorsInput>;
  liveStorefront?: InputMaybe<FilterFindManyStorefrontLiveStorefrontOperatorsInput>;
  organization?: InputMaybe<FilterFindManyStorefrontOrganizationOperatorsInput>;
  testStorefront?: InputMaybe<FilterFindManyStorefrontTestStorefrontOperatorsInput>;
};

export type FilterFindManyStorefrontOrganizationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyStorefrontSiteMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  bookers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyStorefrontStatementSettingsInput = {
  dayOfMonth?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyStorefrontTestStorefrontOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyStorefront_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyStripeMetadataInput = {
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  chargeId?: InputMaybe<Scalars['String']['input']>;
  connectedAccountId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  invoiceStatus?: InputMaybe<EnumStripeMetadataInvoiceStatus>;
  paidAt?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  securityHoldPaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  securityHoldStatus?: InputMaybe<EnumStripeMetadataSecurityHoldStatus>;
  stripeFee?: InputMaybe<Scalars['Float']['input']>;
  whereaboutsFee?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManySurveyCopiedFromOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySurveyInput = {
  AND?: InputMaybe<Array<FilterFindManySurveyInput>>;
  OR?: InputMaybe<Array<FilterFindManySurveyInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySurveyOperatorsInput>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  questions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySurveyOperatorsInput = {
  _id?: InputMaybe<FilterFindManySurvey_IdOperatorsInput>;
  copiedFrom?: InputMaybe<FilterFindManySurveyCopiedFromOperatorsInput>;
};

export type FilterFindManySurveyQuestionInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  businessScope?: InputMaybe<EnumSurveyQuestionBusinessScope>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  options?: InputMaybe<Array<InputMaybe<FilterFindManySurveyQuestionOptionsInput>>>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  parentQuestion?: InputMaybe<Scalars['MongoID']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<EnumSurveyQuestionType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  whereaboutsSearchEntityType?: InputMaybe<EnumSurveyQuestionWhereaboutsSearchEntityType>;
};

export type FilterFindManySurveyQuestionOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<FilterFindManyMultilingualInput>;
};

export type FilterFindManySurveyResponseBroadcastOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySurveyResponseHistoryInput = {
  action?: InputMaybe<EnumSurveyResponseHistoryAction>;
  responses?: InputMaybe<Array<InputMaybe<FilterFindManySurveyResponseResponsesInput>>>;
  reviewNote?: InputMaybe<Scalars['String']['input']>;
  reviewStatus?: InputMaybe<EnumSurveyResponseHistoryReviewStatus>;
  reviewedAt?: InputMaybe<Scalars['Date']['input']>;
  reviewedBy?: InputMaybe<Scalars['MongoID']['input']>;
  savedBy?: InputMaybe<Scalars['MongoID']['input']>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManySurveyResponseInput = {
  AND?: InputMaybe<Array<FilterFindManySurveyResponseInput>>;
  OR?: InputMaybe<Array<FilterFindManySurveyResponseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySurveyResponseOperatorsInput>;
  adminStatus?: InputMaybe<EnumSurveyResponseAdminStatus>;
  broadcast?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  history?: InputMaybe<Array<InputMaybe<FilterFindManySurveyResponseHistoryInput>>>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  ownerMetadata?: InputMaybe<FilterFindManySurveyResponseOwnerMetadataInput>;
  person?: InputMaybe<Scalars['MongoID']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  responses?: InputMaybe<Array<InputMaybe<FilterFindManySurveyResponseResponsesInput>>>;
  reviewStatus?: InputMaybe<EnumSurveyResponseReviewStatus>;
  status?: InputMaybe<EnumSurveyResponseStatus>;
  submissionIndex?: InputMaybe<Scalars['Float']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  survey?: InputMaybe<Scalars['MongoID']['input']>;
  surveyUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
  widget?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySurveyResponseOperatorsInput = {
  _id?: InputMaybe<FilterFindManySurveyResponse_IdOperatorsInput>;
  broadcast?: InputMaybe<FilterFindManySurveyResponseBroadcastOperatorsInput>;
  widget?: InputMaybe<FilterFindManySurveyResponseWidgetOperatorsInput>;
};

export type FilterFindManySurveyResponseOwnerMetadataInput = {
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  operators?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManySurveyResponseResponsesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  byBusiness?: InputMaybe<Array<InputMaybe<SurveyResponseResponsesByBusinessInput>>>;
  questionData: SurveyQuestionInput;
  response: Array<InputMaybe<Scalars['String']['input']>>;
};

export type FilterFindManySurveyResponseWidgetOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySurveyResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySurvey_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTagEntityTypesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumTagEntityTypes>;
  gte?: InputMaybe<EnumTagEntityTypes>;
  in?: InputMaybe<Array<InputMaybe<EnumTagEntityTypes>>>;
  lt?: InputMaybe<EnumTagEntityTypes>;
  lte?: InputMaybe<EnumTagEntityTypes>;
  ne?: InputMaybe<EnumTagEntityTypes>;
  nin?: InputMaybe<Array<InputMaybe<EnumTagEntityTypes>>>;
};

export type FilterFindManyTagGroupInput = {
  AND?: InputMaybe<Array<FilterFindManyTagGroupInput>>;
  OR?: InputMaybe<Array<FilterFindManyTagGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTagGroupOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  key?: InputMaybe<EnumTagGroupKey>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  /** Filter tagGroup by an array of tagGroup types */
  type?: InputMaybe<Array<EnumTagGroupType>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTagGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTagGroup_IdOperatorsInput>;
};

export type FilterFindManyTagGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTagInput = {
  AND?: InputMaybe<Array<FilterFindManyTagInput>>;
  OR?: InputMaybe<Array<FilterFindManyTagInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTagOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  embedding?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  engineOwnedRole?: InputMaybe<EnumTagEngineOwnedRole>;
  /** Filter tags by entityTypes. Accepts an array of entityTypes. */
  entityTypes: Array<InputMaybe<EnumTagEntityTypes>>;
  /** Filter tags by inheritable flag. */
  inheritable?: InputMaybe<Scalars['Boolean']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  /** Filter tags by tagGroup. Accepts an array of tagGroup _ids. */
  tagGroup?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  usage?: InputMaybe<FilterFindManyTagUsageInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTagOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTag_IdOperatorsInput>;
  entityTypes?: InputMaybe<FilterFindManyTagEntityTypesOperatorsInput>;
  tagGroup?: InputMaybe<FilterFindManyTagTagGroupOperatorsInput>;
};

export type FilterFindManyTagSuggestionAiResponseInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  action?: InputMaybe<EnumTagSuggestionAiResponseAction>;
  alternativeSuggestions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  similarTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyTagSuggestionInput = {
  AND?: InputMaybe<Array<FilterFindManyTagSuggestionInput>>;
  OR?: InputMaybe<Array<FilterFindManyTagSuggestionInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTagSuggestionOperatorsInput>;
  aiResponse?: InputMaybe<FilterFindManyTagSuggestionAiResponseInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entityTypes?: InputMaybe<Array<InputMaybe<EnumTagSuggestionEntityTypes>>>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  tagGroup?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTagSuggestionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTagSuggestion_IdOperatorsInput>;
};

export type FilterFindManyTagSuggestion_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTagTagGroupOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTagUsageInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  events?: InputMaybe<Scalars['Float']['input']>;
  operators?: InputMaybe<Scalars['Float']['input']>;
  people?: InputMaybe<Scalars['Float']['input']>;
  products?: InputMaybe<Scalars['Float']['input']>;
  promotions?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTag_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTaxComponentsInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyTaxInput = {
  AND?: InputMaybe<Array<FilterFindManyTaxInput>>;
  OR?: InputMaybe<Array<FilterFindManyTaxInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTaxOperatorsInput>;
  components?: InputMaybe<Array<InputMaybe<FilterFindManyTaxComponentsInput>>>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  /** Filter taxes by whether they have an owner or not. */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTaxOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTax_IdOperatorsInput>;
};

export type FilterFindManyTax_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyToursOperatorMetadataInput = {
  maxGroupSize?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyUserAccessInput = {
  operators?: InputMaybe<Array<InputMaybe<FilterFindManyUserAccessOperatorsInput>>>;
  organizations?: InputMaybe<Array<InputMaybe<FilterFindManyUserAccessOperatorsInput>>>;
  storefronts?: InputMaybe<Array<InputMaybe<FilterFindManyUserAccessOperatorsInput>>>;
};

export type FilterFindManyUserAccessOperatorsInput = {
  contactRoles?: InputMaybe<Array<InputMaybe<EnumUserAccessOperatorsContactRoles>>>;
  entityId: Scalars['MongoID']['input'];
  role: EnumUserAccessOperatorsRole;
  status: EnumUserAccessOperatorsStatus;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyUserAuth0IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserConfirmationCodesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  sentToEmail?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumUserConfirmationCodesType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserEmailPreferencesInput = {
  entity?: InputMaybe<FilterFindManyEntityReferenceInput>;
  frequency?: InputMaybe<EnumUserEmailPreferencesFrequency>;
  templateName?: InputMaybe<EnumUserEmailPreferencesTemplateName>;
};

export type FilterFindManyUserInput = {
  AND?: InputMaybe<Array<FilterFindManyUserInput>>;
  OR?: InputMaybe<Array<FilterFindManyUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUserOperatorsInput>;
  access?: InputMaybe<FilterFindManyUserAccessInput>;
  /** Filter users by their access ids. Accepts arrays of ids for operators, organizations, and storefronts. They will be OR'd together. */
  accessIds?: InputMaybe<AccessIdsFilterArg>;
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  confirmationCodes?: InputMaybe<Array<InputMaybe<FilterFindManyUserConfirmationCodesInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailPreferences?: InputMaybe<Array<InputMaybe<FilterFindManyUserEmailPreferencesInput>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastViewedListId?: InputMaybe<Scalars['String']['input']>;
  onboardingMetadata?: InputMaybe<FilterFindManyUserOnboardingMetadataInput>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photoUploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  quickLinks?: InputMaybe<Array<InputMaybe<FilterFindManyUserQuickLinksInput>>>;
  quickLinksVersion?: InputMaybe<Scalars['Float']['input']>;
  resolvedBroadcasts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  signupToken?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  /** Filter users by storefronts. Accepts an array of storefront ids. */
  storefronts?: InputMaybe<Array<Scalars['String']['input']>>;
  systemPermissions?: InputMaybe<Array<InputMaybe<EnumUserSystemPermissions>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  userType?: InputMaybe<EnumUserUserType>;
};

export type FilterFindManyUserOnboardingMetadataInput = {
  isPostOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingBroadcast?: InputMaybe<Scalars['MongoID']['input']>;
  onboardingOrganization?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUserOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUser_IdOperatorsInput>;
  auth0Id?: InputMaybe<FilterFindManyUserAuth0IdOperatorsInput>;
  email?: InputMaybe<FilterFindManyUserEmailOperatorsInput>;
  signupToken?: InputMaybe<FilterFindManyUserSignupTokenOperatorsInput>;
};

export type FilterFindManyUserQuickLinksInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  lastVisited?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumUserQuickLinksType>;
};

export type FilterFindManyUserSignupTokenOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyVersionedEntityReferenceInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumVersionedEntityReferenceType>;
};

export type FilterFindManyWidgetEventSettingsInput = {
  displayType?: InputMaybe<EnumWidgetEventSettingsDisplayType>;
  eventTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  hiddenPublicFilterTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  hideCancelledEvents?: InputMaybe<Scalars['Boolean']['input']>;
  lookAheadMonths?: InputMaybe<Scalars['Float']['input']>;
  publicFilterMode?: InputMaybe<EnumWidgetEventSettingsPublicFilterMode>;
  publicFilterSort?: InputMaybe<EnumWidgetEventSettingsPublicFilterSort>;
  shownPublicFilterTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  startMonth?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyWidgetGallerySettingsInfiniteScrollInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  listingFilters?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  mediaTagFilters?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyWidgetGallerySettingsInput = {
  allMedia?: InputMaybe<Scalars['Boolean']['input']>;
  enableUrlPush?: InputMaybe<Scalars['Boolean']['input']>;
  infiniteScroll?: InputMaybe<FilterFindManyWidgetGallerySettingsInfiniteScrollInput>;
  items?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  playerPagePath?: InputMaybe<Scalars['String']['input']>;
  profilePageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyWidgetInput = {
  AND?: InputMaybe<Array<FilterFindManyWidgetInput>>;
  OR?: InputMaybe<Array<FilterFindManyWidgetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyWidgetOperatorsInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  eventSettings?: InputMaybe<FilterFindManyWidgetEventSettingsInput>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  gallerySettings?: InputMaybe<FilterFindManyWidgetGallerySettingsInput>;
  inquirySettings?: InputMaybe<FilterFindManyWidgetInquirySettingsInput>;
  list?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<FilterFindManyMultilingualInput>;
  operatorSettings?: InputMaybe<FilterFindManyWidgetOperatorSettingsInput>;
  owner?: InputMaybe<FilterFindManyOwnerInput>;
  promotionSettings?: InputMaybe<FilterFindManyWidgetPromotionSettingsInput>;
  type?: InputMaybe<EnumWidgetType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyWidgetInquirySettingsInput = {
  buttonLabel?: InputMaybe<FilterFindManyMultilingualInput>;
  completionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  notificationRecipients?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  preventMultipleSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  submissionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  survey?: InputMaybe<Scalars['String']['input']>;
  thankYouMessage?: InputMaybe<FilterFindManyMultilingualInput>;
};

export type FilterFindManyWidgetOperatorSettingsEntityOverridesInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<FilterFindManyMultilingualInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription?: InputMaybe<FilterFindManyMultilingualInput>;
};

export type FilterFindManyWidgetOperatorSettingsInput = {
  allowAdditionalFilters?: InputMaybe<Scalars['Boolean']['input']>;
  allowMapView?: InputMaybe<Scalars['Boolean']['input']>;
  disableOperatorWidgetFilter?: InputMaybe<Scalars['Boolean']['input']>;
  disableTieredSort?: InputMaybe<Scalars['Boolean']['input']>;
  entityOverrides?: InputMaybe<Array<InputMaybe<FilterFindManyWidgetOperatorSettingsEntityOverridesInput>>>;
  filterableTagGroups?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  filterableTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  hideFiltersInMapView?: InputMaybe<Scalars['Boolean']['input']>;
  hidePermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  hideTemporarilyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  listDisplayMode?: InputMaybe<EnumWidgetOperatorSettingsListDisplayMode>;
  orderedFilters?: InputMaybe<Array<InputMaybe<FilterFindManyWidgetOperatorSettingsOrderedFiltersInput>>>;
  showEvents?: InputMaybe<Scalars['Boolean']['input']>;
  showOnlyMap?: InputMaybe<Scalars['Boolean']['input']>;
  showPermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  showPromotions?: InputMaybe<Scalars['Boolean']['input']>;
  sortStrategy?: InputMaybe<EnumWidgetOperatorSettingsSortStrategy>;
  tieredSortOrder?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyWidgetOperatorSettingsOrderedFiltersInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  isTagGroup?: InputMaybe<Scalars['Boolean']['input']>;
  labelOverride?: InputMaybe<FilterFindManyMultilingualInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyWidgetOperatorsInput = {
  _id?: InputMaybe<FilterFindManyWidget_IdOperatorsInput>;
  owner?: InputMaybe<FilterFindManyWidgetOwnerOperatorsInput>;
};

export type FilterFindManyWidgetOwnerEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyWidgetOwnerOperatorsInput = {
  entityId?: InputMaybe<FilterFindManyWidgetOwnerEntityIdOperatorsInput>;
};

export type FilterFindManyWidgetPromotionSettingsInput = {
  displayType?: InputMaybe<EnumWidgetPromotionSettingsDisplayType>;
  hiddenPublicFilterTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  hidePublicFilters?: InputMaybe<Scalars['Boolean']['input']>;
  promotionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyWidget_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<AddressLocationInput>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneApiAccessInput = {
  AND?: InputMaybe<Array<FilterFindOneApiAccessInput>>;
  OR?: InputMaybe<Array<FilterFindOneApiAccessInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneApiAccessOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  lastUsedAt?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneApiAccessOperatorsInput = {
  _id?: InputMaybe<FilterFindOneApiAccess_IdOperatorsInput>;
  organization?: InputMaybe<FilterFindOneApiAccessOrganizationOperatorsInput>;
  token?: InputMaybe<FilterFindOneApiAccessTokenOperatorsInput>;
};

export type FilterFindOneApiAccessOrganizationOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneApiAccessTokenOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneApiAccess_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCampaignInput = {
  AND?: InputMaybe<Array<FilterFindOneCampaignInput>>;
  OR?: InputMaybe<Array<FilterFindOneCampaignInput>>;
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCampaignOperatorsInput>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  dateRangeISO?: InputMaybe<FilterFindOneDateRangeIsoInput>;
  description?: InputMaybe<FilterFindOneMultilingualInput>;
  list?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<FilterFindOneMultilingualInput>;
  owner?: InputMaybe<FilterFindOneOwnerInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCampaignOperatorsInput = {
  _entityId?: InputMaybe<FilterFindOneCampaign_EntityIdOperatorsInput>;
  _id?: InputMaybe<FilterFindOneCampaign_IdOperatorsInput>;
  _versionId?: InputMaybe<FilterFindOneCampaign_VersionIdOperatorsInput>;
};

export type FilterFindOneCampaign_EntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCampaign_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCampaign_VersionIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneDateRangeIsoInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneEntityReferenceInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumEntityReferenceType>;
};

export type FilterFindOneImportManagerSettingsAiScraperGeneratorInput = {
  aiEngine?: InputMaybe<EnumImportManagerSettingsAiScraperGeneratorAiEngine>;
  defaultPrompt?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneImportManagerSettingsGoogleSheetTemplatesInput = {
  events?: InputMaybe<Scalars['String']['input']>;
  operators?: InputMaybe<Scalars['String']['input']>;
  people?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneImportManagerSettingsInput = {
  AND?: InputMaybe<Array<FilterFindOneImportManagerSettingsInput>>;
  OR?: InputMaybe<Array<FilterFindOneImportManagerSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneImportManagerSettingsOperatorsInput>;
  aiScraperGenerator?: InputMaybe<FilterFindOneImportManagerSettingsAiScraperGeneratorInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  dummyDataSheets?: InputMaybe<FilterFindOneImportManagerSettingsGoogleSheetTemplatesInput>;
  googleDriveDestinationFolderId?: InputMaybe<Scalars['String']['input']>;
  googleSheetTemplates?: InputMaybe<FilterFindOneImportManagerSettingsGoogleSheetTemplatesInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneImportManagerSettingsOperatorsInput = {
  _id?: InputMaybe<FilterFindOneImportManagerSettings_IdOperatorsInput>;
};

export type FilterFindOneImportManagerSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneMaintenanceDoorstopInput = {
  isLive: Scalars['Boolean']['input'];
  message: MultilingualInput;
};

export type FilterFindOneMaintenanceInput = {
  AND?: InputMaybe<Array<FilterFindOneMaintenanceInput>>;
  OR?: InputMaybe<Array<FilterFindOneMaintenanceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneMaintenanceOperatorsInput>;
  banner?: InputMaybe<FilterFindOneMaintenanceDoorstopInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  doorstop?: InputMaybe<FilterFindOneMaintenanceDoorstopInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneMaintenanceOperatorsInput = {
  _id?: InputMaybe<FilterFindOneMaintenance_IdOperatorsInput>;
};

export type FilterFindOneMaintenance_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneMultilingualInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneOrganizationManifestAssetCountsInput = {
  activityLogs?: InputMaybe<Scalars['Float']['input']>;
  broadcasts?: InputMaybe<Scalars['Float']['input']>;
  customTags?: InputMaybe<Scalars['Float']['input']>;
  events?: InputMaybe<Scalars['Float']['input']>;
  images?: InputMaybe<Scalars['Float']['input']>;
  importRuns?: InputMaybe<Scalars['Float']['input']>;
  imports?: InputMaybe<Scalars['Float']['input']>;
  lists?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['Float']['input']>;
  operators?: InputMaybe<FilterFindOneOrganizationManifestAssetCountsOperatorsInput>;
  people?: InputMaybe<FilterFindOneOrganizationManifestAssetCountsPeopleInput>;
  users?: InputMaybe<Scalars['Float']['input']>;
  widgets?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneOrganizationManifestAssetCountsOperatorsInput = {
  toDelete?: InputMaybe<Scalars['Float']['input']>;
  toDisconnect?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneOrganizationManifestAssetCountsPeopleInput = {
  toDelete?: InputMaybe<Scalars['Float']['input']>;
  toDisconnect?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneOrganizationManifestAssetsInput = {
  activityLogs?: InputMaybe<Array<InputMaybe<FilterFindOneOrganizationManifestAssetsPeopleInput>>>;
  broadcasts?: InputMaybe<Array<InputMaybe<FilterFindOneOrganizationManifestAssetsPeopleInput>>>;
  customTags?: InputMaybe<Array<InputMaybe<FilterFindOneOrganizationManifestAssetsPeopleInput>>>;
  events?: InputMaybe<Array<InputMaybe<FilterFindOneOrganizationManifestAssetsPeopleInput>>>;
  images?: InputMaybe<Array<InputMaybe<FilterFindOneOrganizationManifestAssetsPeopleInput>>>;
  importRuns?: InputMaybe<Array<InputMaybe<FilterFindOneOrganizationManifestAssetsPeopleInput>>>;
  imports?: InputMaybe<Array<InputMaybe<FilterFindOneOrganizationManifestAssetsPeopleInput>>>;
  lists?: InputMaybe<Array<InputMaybe<FilterFindOneOrganizationManifestAssetsPeopleInput>>>;
  notes?: InputMaybe<Array<InputMaybe<FilterFindOneOrganizationManifestAssetsPeopleInput>>>;
  operators?: InputMaybe<Array<InputMaybe<FilterFindOneOrganizationManifestAssetsPeopleInput>>>;
  people?: InputMaybe<Array<InputMaybe<FilterFindOneOrganizationManifestAssetsPeopleInput>>>;
  widgets?: InputMaybe<Array<InputMaybe<FilterFindOneOrganizationManifestAssetsPeopleInput>>>;
};

export type FilterFindOneOrganizationManifestAssetsPeopleInput = {
  _id: Scalars['String']['input'];
  action: EnumOrganizationManifestAssetsPeopleAction;
  entityId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneOrganizationManifestDeletionLogDeletionErrorsInput = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneOrganizationManifestDeletionLogInput = {
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  completedBy?: InputMaybe<Scalars['MongoID']['input']>;
  deletionErrors?: InputMaybe<Array<InputMaybe<FilterFindOneOrganizationManifestDeletionLogDeletionErrorsInput>>>;
  results?: InputMaybe<FilterFindOneOrganizationManifestDeletionLogResultsInput>;
};

export type FilterFindOneOrganizationManifestDeletionLogResultsActivityLogsInput = {
  deleted?: InputMaybe<Scalars['Float']['input']>;
  errors?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneOrganizationManifestDeletionLogResultsBroadcastsInput = {
  deleted?: InputMaybe<Scalars['Float']['input']>;
  errors?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneOrganizationManifestDeletionLogResultsEventsInput = {
  deleted?: InputMaybe<Scalars['Float']['input']>;
  errors?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneOrganizationManifestDeletionLogResultsImagesInput = {
  deleted?: InputMaybe<Scalars['Float']['input']>;
  errors?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneOrganizationManifestDeletionLogResultsImportRunsInput = {
  deleted?: InputMaybe<Scalars['Float']['input']>;
  errors?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneOrganizationManifestDeletionLogResultsImportsInput = {
  deleted?: InputMaybe<Scalars['Float']['input']>;
  errors?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneOrganizationManifestDeletionLogResultsInput = {
  activityLogs?: InputMaybe<FilterFindOneOrganizationManifestDeletionLogResultsActivityLogsInput>;
  broadcasts?: InputMaybe<FilterFindOneOrganizationManifestDeletionLogResultsBroadcastsInput>;
  events?: InputMaybe<FilterFindOneOrganizationManifestDeletionLogResultsEventsInput>;
  images?: InputMaybe<FilterFindOneOrganizationManifestDeletionLogResultsImagesInput>;
  importRuns?: InputMaybe<FilterFindOneOrganizationManifestDeletionLogResultsImportRunsInput>;
  imports?: InputMaybe<FilterFindOneOrganizationManifestDeletionLogResultsImportsInput>;
  lists?: InputMaybe<FilterFindOneOrganizationManifestDeletionLogResultsListsInput>;
  notes?: InputMaybe<FilterFindOneOrganizationManifestDeletionLogResultsNotesInput>;
  operators?: InputMaybe<FilterFindOneOrganizationManifestDeletionLogResultsOperatorsInput>;
  people?: InputMaybe<FilterFindOneOrganizationManifestDeletionLogResultsPeopleInput>;
  widgets?: InputMaybe<FilterFindOneOrganizationManifestDeletionLogResultsWidgetsInput>;
};

export type FilterFindOneOrganizationManifestDeletionLogResultsListsInput = {
  deleted?: InputMaybe<Scalars['Float']['input']>;
  errors?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneOrganizationManifestDeletionLogResultsNotesInput = {
  deleted?: InputMaybe<Scalars['Float']['input']>;
  errors?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneOrganizationManifestDeletionLogResultsOperatorsInput = {
  deleted?: InputMaybe<Scalars['Float']['input']>;
  disconnected?: InputMaybe<Scalars['Float']['input']>;
  errors?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneOrganizationManifestDeletionLogResultsPeopleInput = {
  deleted?: InputMaybe<Scalars['Float']['input']>;
  disconnected?: InputMaybe<Scalars['Float']['input']>;
  errors?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneOrganizationManifestDeletionLogResultsWidgetsInput = {
  deleted?: InputMaybe<Scalars['Float']['input']>;
  errors?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneOrganizationManifestInput = {
  AND?: InputMaybe<Array<FilterFindOneOrganizationManifestInput>>;
  OR?: InputMaybe<Array<FilterFindOneOrganizationManifestInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneOrganizationManifestOperatorsInput>;
  assetCounts?: InputMaybe<FilterFindOneOrganizationManifestAssetCountsInput>;
  assets?: InputMaybe<FilterFindOneOrganizationManifestAssetsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  deletionLog?: InputMaybe<FilterFindOneOrganizationManifestDeletionLogInput>;
  generatedAt?: InputMaybe<Scalars['Date']['input']>;
  generatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  manifestErrors?: InputMaybe<Array<InputMaybe<FilterFindOneOrganizationManifestManifestErrorsInput>>>;
  organizationDeleted?: InputMaybe<FilterFindOneOrganizationManifestOrganizationDeletedInput>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindOneOrganizationManifestManifestErrorsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  assetId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneOrganizationManifestOperatorsInput = {
  _id?: InputMaybe<FilterFindOneOrganizationManifest_IdOperatorsInput>;
  organizationId?: InputMaybe<FilterFindOneOrganizationManifestOrganizationIdOperatorsInput>;
};

export type FilterFindOneOrganizationManifestOrganizationDeletedInput = {
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  deletedBy?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneOrganizationManifestOrganizationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneOrganizationManifest_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneOwnerInput = {
  entityId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumOwnerType>;
};

export type FilterFindOnePeopleEmailLowerOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOnePeopleEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOnePeopleInput = {
  AND?: InputMaybe<Array<FilterFindOnePeopleInput>>;
  OR?: InputMaybe<Array<FilterFindOnePeopleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePeopleOperatorsInput>;
  address?: InputMaybe<FilterFindOneAddressInput>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  contactMethod?: InputMaybe<EnumPeopleContactMethod>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailLower?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  faxExt?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  import?: InputMaybe<Scalars['JSON']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leads?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  mailingAddress?: InputMaybe<FilterFindOneAddressInput>;
  optInEmail?: InputMaybe<Scalars['Boolean']['input']>;
  optInFax?: InputMaybe<Scalars['Boolean']['input']>;
  optInPhone?: InputMaybe<Scalars['Boolean']['input']>;
  optInSMS?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photoUploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTitle?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  visibleTo?: InputMaybe<Array<InputMaybe<FilterFindOnePeopleVisibleToInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePeopleOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePeople_IdOperatorsInput>;
  email?: InputMaybe<FilterFindOnePeopleEmailOperatorsInput>;
  emailLower?: InputMaybe<FilterFindOnePeopleEmailLowerOperatorsInput>;
};

export type FilterFindOnePeopleVisibleToInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  entity?: InputMaybe<FilterFindOneOwnerInput>;
  ignoreLeadSystemRole?: InputMaybe<Scalars['Boolean']['input']>;
  latestActivity?: InputMaybe<Scalars['Date']['input']>;
  metadata?: InputMaybe<FilterFindOnePeopleVisibleToMetadataInput>;
  scratchpad?: InputMaybe<Scalars['String']['input']>;
  systemRoles?: InputMaybe<Array<InputMaybe<EnumPeopleVisibleToSystemRoles>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<EnumPeopleVisibleToTypes>>>;
  wasManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOnePeopleVisibleToMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  operatorOverrides?: InputMaybe<Array<InputMaybe<FilterFindOnePeopleVisibleToMetadataOperatorOverridesInput>>>;
  phones?: InputMaybe<Array<InputMaybe<FilterFindOnePeopleVisibleToMetadataPhonesInput>>>;
};

export type FilterFindOnePeopleVisibleToMetadataOperatorOverridesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  operatorEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOnePeopleVisibleToMetadataPhonesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumPeopleVisibleToMetadataPhonesType>;
};

export type FilterFindOnePeople_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePublicationStatusInput = {
  AND?: InputMaybe<Array<FilterFindOnePublicationStatusInput>>;
  OR?: InputMaybe<Array<FilterFindOnePublicationStatusInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePublicationStatusOperatorsInput>;
  changeSummary?: InputMaybe<Scalars['String']['input']>;
  consolidatedChangeSummary?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entity?: InputMaybe<FilterFindOneVersionedEntityReferenceInput>;
  isStale?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumPublicationStatusStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePublicationStatusOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePublicationStatus_IdOperatorsInput>;
};

export type FilterFindOnePublicationStatus_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneScheduledPaymentInput = {
  AND?: InputMaybe<Array<FilterFindOneScheduledPaymentInput>>;
  OR?: InputMaybe<Array<FilterFindOneScheduledPaymentInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneScheduledPaymentOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  failureReasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Scalars['String']['input']>;
  retryCount?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<EnumScheduledPaymentStatus>;
  stripeMetadata?: InputMaybe<FilterFindOneStripeMetadataInput>;
  successDateISO?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumScheduledPaymentType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneScheduledPaymentOperatorsInput = {
  _id?: InputMaybe<FilterFindOneScheduledPayment_IdOperatorsInput>;
};

export type FilterFindOneScheduledPayment_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneStripeMetadataInput = {
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  chargeId?: InputMaybe<Scalars['String']['input']>;
  connectedAccountId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  invoiceStatus?: InputMaybe<EnumStripeMetadataInvoiceStatus>;
  paidAt?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  securityHoldPaymentIntentId?: InputMaybe<Scalars['String']['input']>;
  securityHoldStatus?: InputMaybe<EnumStripeMetadataSecurityHoldStatus>;
  stripeFee?: InputMaybe<Scalars['Float']['input']>;
  whereaboutsFee?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneSurveyCopiedFromOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneSurveyInput = {
  AND?: InputMaybe<Array<FilterFindOneSurveyInput>>;
  OR?: InputMaybe<Array<FilterFindOneSurveyInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneSurveyOperatorsInput>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<FilterFindOneMultilingualInput>;
  owner?: InputMaybe<FilterFindOneOwnerInput>;
  questions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneSurveyOperatorsInput = {
  _id?: InputMaybe<FilterFindOneSurvey_IdOperatorsInput>;
  copiedFrom?: InputMaybe<FilterFindOneSurveyCopiedFromOperatorsInput>;
};

export type FilterFindOneSurveyQuestionInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  businessScope?: InputMaybe<EnumSurveyQuestionBusinessScope>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<FilterFindOneMultilingualInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<FilterFindOneMultilingualInput>;
  options?: InputMaybe<Array<InputMaybe<FilterFindOneSurveyQuestionOptionsInput>>>;
  owner?: InputMaybe<FilterFindOneOwnerInput>;
  parentQuestion?: InputMaybe<Scalars['MongoID']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<EnumSurveyQuestionType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  whereaboutsSearchEntityType?: InputMaybe<EnumSurveyQuestionWhereaboutsSearchEntityType>;
};

export type FilterFindOneSurveyQuestionOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<FilterFindOneMultilingualInput>;
};

export type FilterFindOneSurveyResponseBroadcastOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneSurveyResponseHistoryInput = {
  action?: InputMaybe<EnumSurveyResponseHistoryAction>;
  responses?: InputMaybe<Array<InputMaybe<FilterFindOneSurveyResponseResponsesInput>>>;
  reviewNote?: InputMaybe<Scalars['String']['input']>;
  reviewStatus?: InputMaybe<EnumSurveyResponseHistoryReviewStatus>;
  reviewedAt?: InputMaybe<Scalars['Date']['input']>;
  reviewedBy?: InputMaybe<Scalars['MongoID']['input']>;
  savedBy?: InputMaybe<Scalars['MongoID']['input']>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindOneSurveyResponseInput = {
  AND?: InputMaybe<Array<FilterFindOneSurveyResponseInput>>;
  OR?: InputMaybe<Array<FilterFindOneSurveyResponseInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneSurveyResponseOperatorsInput>;
  adminStatus?: InputMaybe<EnumSurveyResponseAdminStatus>;
  broadcast?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  history?: InputMaybe<Array<InputMaybe<FilterFindOneSurveyResponseHistoryInput>>>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  ownerMetadata?: InputMaybe<FilterFindOneSurveyResponseOwnerMetadataInput>;
  person?: InputMaybe<Scalars['MongoID']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  responses?: InputMaybe<Array<InputMaybe<FilterFindOneSurveyResponseResponsesInput>>>;
  reviewStatus?: InputMaybe<EnumSurveyResponseReviewStatus>;
  status?: InputMaybe<EnumSurveyResponseStatus>;
  submissionIndex?: InputMaybe<Scalars['Float']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  survey?: InputMaybe<Scalars['MongoID']['input']>;
  surveyUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
  widget?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneSurveyResponseOperatorsInput = {
  _id?: InputMaybe<FilterFindOneSurveyResponse_IdOperatorsInput>;
  broadcast?: InputMaybe<FilterFindOneSurveyResponseBroadcastOperatorsInput>;
  widget?: InputMaybe<FilterFindOneSurveyResponseWidgetOperatorsInput>;
};

export type FilterFindOneSurveyResponseOwnerMetadataInput = {
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  operators?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneSurveyResponseResponsesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  byBusiness?: InputMaybe<Array<InputMaybe<SurveyResponseResponsesByBusinessInput>>>;
  questionData: SurveyQuestionInput;
  response: Array<InputMaybe<Scalars['String']['input']>>;
};

export type FilterFindOneSurveyResponseWidgetOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneSurveyResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneSurvey_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneTagGroupInput = {
  AND?: InputMaybe<Array<FilterFindOneTagGroupInput>>;
  OR?: InputMaybe<Array<FilterFindOneTagGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneTagGroupOperatorsInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  key?: InputMaybe<EnumTagGroupKey>;
  name?: InputMaybe<FilterFindOneMultilingualInput>;
  type?: InputMaybe<EnumTagGroupType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneTagGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindOneTagGroup_IdOperatorsInput>;
};

export type FilterFindOneTagGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUserAccessInput = {
  operators?: InputMaybe<Array<InputMaybe<FilterFindOneUserAccessOperatorsInput>>>;
  organizations?: InputMaybe<Array<InputMaybe<FilterFindOneUserAccessOperatorsInput>>>;
  storefronts?: InputMaybe<Array<InputMaybe<FilterFindOneUserAccessOperatorsInput>>>;
};

export type FilterFindOneUserAccessOperatorsInput = {
  contactRoles?: InputMaybe<Array<InputMaybe<EnumUserAccessOperatorsContactRoles>>>;
  entityId: Scalars['MongoID']['input'];
  role: EnumUserAccessOperatorsRole;
  status: EnumUserAccessOperatorsStatus;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneUserAuth0IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserConfirmationCodesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  sentToEmail?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumUserConfirmationCodesType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserEmailPreferencesInput = {
  entity?: InputMaybe<FilterFindOneEntityReferenceInput>;
  frequency?: InputMaybe<EnumUserEmailPreferencesFrequency>;
  templateName?: InputMaybe<EnumUserEmailPreferencesTemplateName>;
};

export type FilterFindOneUserInput = {
  AND?: InputMaybe<Array<FilterFindOneUserInput>>;
  OR?: InputMaybe<Array<FilterFindOneUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneUserOperatorsInput>;
  access?: InputMaybe<FilterFindOneUserAccessInput>;
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  confirmationCodes?: InputMaybe<Array<InputMaybe<FilterFindOneUserConfirmationCodesInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailPreferences?: InputMaybe<Array<InputMaybe<FilterFindOneUserEmailPreferencesInput>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastViewedListId?: InputMaybe<Scalars['String']['input']>;
  onboardingMetadata?: InputMaybe<FilterFindOneUserOnboardingMetadataInput>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photoUploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  quickLinks?: InputMaybe<Array<InputMaybe<FilterFindOneUserQuickLinksInput>>>;
  quickLinksVersion?: InputMaybe<Scalars['Float']['input']>;
  resolvedBroadcasts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  signupToken?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  systemPermissions?: InputMaybe<Array<InputMaybe<EnumUserSystemPermissions>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  userType?: InputMaybe<EnumUserUserType>;
};

export type FilterFindOneUserOnboardingMetadataInput = {
  isPostOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingBroadcast?: InputMaybe<Scalars['MongoID']['input']>;
  onboardingOrganization?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneUserOperatorsInput = {
  _id?: InputMaybe<FilterFindOneUser_IdOperatorsInput>;
  auth0Id?: InputMaybe<FilterFindOneUserAuth0IdOperatorsInput>;
  email?: InputMaybe<FilterFindOneUserEmailOperatorsInput>;
  signupToken?: InputMaybe<FilterFindOneUserSignupTokenOperatorsInput>;
};

export type FilterFindOneUserQuickLinksInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  lastVisited?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumUserQuickLinksType>;
};

export type FilterFindOneUserSignupTokenOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneVersionedEntityReferenceInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumVersionedEntityReferenceType>;
};

export type ForceRenewalsResult = {
  __typename?: 'ForceRenewalsResult';
  autoChargesProcessed: Scalars['Int']['output'];
  invoicesProcessed: Scalars['Int']['output'];
  processedCount: Scalars['Int']['output'];
  recordsCreated: Scalars['Int']['output'];
};

export type FulfillmentProfile = {
  __typename?: 'FulfillmentProfile';
  _id: Scalars['MongoID']['output'];
  copiedFrom?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pickup?: Maybe<FulfillmentProfilePickup>;
  shipping?: Maybe<FulfillmentProfileShipping>;
  storefront: Scalars['MongoID']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type FulfillmentProfilePickup = {
  __typename?: 'FulfillmentProfilePickup';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  locations?: Maybe<Array<Maybe<FulfillmentProfilePickupLocations>>>;
};

export type FulfillmentProfilePickupInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  locations?: InputMaybe<Array<InputMaybe<FulfillmentProfilePickupLocationsInput>>>;
};

export type FulfillmentProfilePickupLocations = {
  __typename?: 'FulfillmentProfilePickupLocations';
  _id?: Maybe<Scalars['MongoID']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type FulfillmentProfilePickupLocationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type FulfillmentProfileShipping = {
  __typename?: 'FulfillmentProfileShipping';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  taxable?: Maybe<Scalars['Boolean']['output']>;
  zones?: Maybe<Array<Maybe<FulfillmentProfileShippingZones>>>;
};

export type FulfillmentProfileShippingInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  zones?: InputMaybe<Array<InputMaybe<FulfillmentProfileShippingZonesInput>>>;
};

export type FulfillmentProfileShippingZones = {
  __typename?: 'FulfillmentProfileShippingZones';
  _id?: Maybe<Scalars['MongoID']['output']>;
  countries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  flatRate: Scalars['Float']['output'];
  freeOver?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  perAdditionalItem?: Maybe<Scalars['Float']['output']>;
  subdivisions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type FulfillmentProfileShippingZonesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flatRate: Scalars['Float']['input'];
  freeOver?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  perAdditionalItem?: InputMaybe<Scalars['Float']['input']>;
  subdivisions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GalleryNewMedia = {
  __typename?: 'GalleryNewMedia';
  _id: Scalars['MongoID']['output'];
  blurhash?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  listingId: Scalars['MongoID']['output'];
  listingName?: Maybe<Scalars['String']['output']>;
  mediaType: EnumGalleryNewMediaMediaType;
  muxPlaybackId?: Maybe<Scalars['String']['output']>;
  organization: Scalars['MongoID']['output'];
  originalAssetId: Scalars['String']['output'];
  publicMediaId?: Maybe<Scalars['MongoID']['output']>;
  resolvedAt?: Maybe<Scalars['Date']['output']>;
  resolvedBy?: Maybe<Scalars['MongoID']['output']>;
  status: EnumGalleryNewMediaStatus;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type GenerateUpcomingRenewalInvoicesResult = {
  __typename?: 'GenerateUpcomingRenewalInvoicesResult';
  createdCount: Scalars['Int']['output'];
  paymentRequestIds: Array<Scalars['MongoID']['output']>;
  runId?: Maybe<Scalars['MongoID']['output']>;
};

export type GlobalRouteSearchResult = {
  __typename?: 'GlobalRouteSearchResult';
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoCloudinaryId?: Maybe<Scalars['String']['output']>;
  ownerEntityId?: Maybe<Scalars['String']['output']>;
  ownerLabel?: Maybe<Scalars['String']['output']>;
  ownerShortName?: Maybe<Scalars['String']['output']>;
  ownerType: Scalars['String']['output'];
  path: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
};

export type GraduateGroupResult = {
  __typename?: 'GraduateGroupResult';
  error?: Maybe<Scalars['String']['output']>;
  graduatedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type GraduateResult = {
  __typename?: 'GraduateResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GuestMetadata = {
  __typename?: 'GuestMetadata';
  maximumNumber?: Maybe<Scalars['Float']['output']>;
  minimumNumber?: Maybe<Scalars['Float']['output']>;
  nameEntryAllowed: Scalars['Boolean']['output'];
  nameEntryRequired: Scalars['Boolean']['output'];
};

export type GuestMetadataInput = {
  maximumNumber?: InputMaybe<Scalars['Float']['input']>;
  minimumNumber?: InputMaybe<Scalars['Float']['input']>;
  nameEntryAllowed: Scalars['Boolean']['input'];
  nameEntryRequired: Scalars['Boolean']['input'];
};

export type HoursOfOperationLocalTimes = {
  __typename?: 'HoursOfOperationLocalTimes';
  fri?: Maybe<LocalTimeRange>;
  mon?: Maybe<LocalTimeRange>;
  sat?: Maybe<LocalTimeRange>;
  sun?: Maybe<LocalTimeRange>;
  thu?: Maybe<LocalTimeRange>;
  tue?: Maybe<LocalTimeRange>;
  wed?: Maybe<LocalTimeRange>;
};

export type ImageQualityAnalysis = {
  __typename?: 'ImageQualityAnalysis';
  blockiness?: Maybe<Scalars['Float']['output']>;
  chroma_subsampling?: Maybe<Scalars['Float']['output']>;
  color_score?: Maybe<Scalars['Float']['output']>;
  contrast?: Maybe<Scalars['Float']['output']>;
  dct?: Maybe<Scalars['Float']['output']>;
  exposure?: Maybe<Scalars['Float']['output']>;
  focus?: Maybe<Scalars['Float']['output']>;
  jpeg_chroma?: Maybe<Scalars['Float']['output']>;
  jpeg_quality?: Maybe<Scalars['Float']['output']>;
  lighting?: Maybe<Scalars['Float']['output']>;
  noise?: Maybe<Scalars['Float']['output']>;
  pixel_score?: Maybe<Scalars['Float']['output']>;
  resolution?: Maybe<Scalars['Float']['output']>;
  saturation?: Maybe<Scalars['Float']['output']>;
};

export enum ImageQualityRating {
  Average = 'AVERAGE',
  High = 'HIGH',
  Low = 'LOW'
}

export type Import = {
  __typename?: 'Import';
  _id: Scalars['MongoID']['output'];
  createdBy?: Maybe<UserWithPictureTc>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  googleSheetsConfig: ImportGoogleSheetsConfig;
  importType?: Maybe<ImportType>;
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  status?: Maybe<ImportStatus>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ImportGoogleSheetsConfig = {
  __typename?: 'ImportGoogleSheetsConfig';
  apiKey?: Maybe<Scalars['String']['output']>;
  range?: Maybe<Scalars['String']['output']>;
  serviceAccountKey?: Maybe<Scalars['String']['output']>;
  sheetId?: Maybe<Scalars['String']['output']>;
  sheetUrl?: Maybe<Scalars['String']['output']>;
};

export type ImportGoogleSheetsConfigInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
  serviceAccountKey?: InputMaybe<Scalars['String']['input']>;
  sheetId?: InputMaybe<Scalars['String']['input']>;
  sheetUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ImportManagerSettings = {
  __typename?: 'ImportManagerSettings';
  _id: Scalars['MongoID']['output'];
  aiScraperGenerator?: Maybe<ImportManagerSettingsAiScraperGenerator>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  dummyDataSheets?: Maybe<ImportManagerSettingsGoogleSheetTemplates>;
  googleDriveDestinationFolderId?: Maybe<Scalars['String']['output']>;
  googleSheetTemplates?: Maybe<ImportManagerSettingsGoogleSheetTemplates>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ImportManagerSettingsAiScraperGenerator = {
  __typename?: 'ImportManagerSettingsAiScraperGenerator';
  aiEngine?: Maybe<EnumImportManagerSettingsAiScraperGeneratorAiEngine>;
  defaultPrompt?: Maybe<Scalars['String']['output']>;
};

export type ImportManagerSettingsAiScraperGeneratorInput = {
  aiEngine?: InputMaybe<EnumImportManagerSettingsAiScraperGeneratorAiEngine>;
  defaultPrompt?: InputMaybe<Scalars['String']['input']>;
};

export type ImportManagerSettingsGoogleSheetTemplates = {
  __typename?: 'ImportManagerSettingsGoogleSheetTemplates';
  events?: Maybe<Scalars['String']['output']>;
  operators?: Maybe<Scalars['String']['output']>;
  people?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
};

export type ImportManagerSettingsGoogleSheetTemplatesInput = {
  events?: InputMaybe<Scalars['String']['input']>;
  operators?: InputMaybe<Scalars['String']['input']>;
  people?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
};

export type ImportManagerSettingsUpsertInput = {
  aiScraperGenerator?: InputMaybe<ImportManagerSettingsAiScraperGeneratorInput>;
  dummyDataSheets?: InputMaybe<ImportManagerSettingsGoogleSheetTemplatesInput>;
  googleDriveDestinationFolderId?: InputMaybe<Scalars['String']['input']>;
  googleSheetTemplates?: InputMaybe<ImportManagerSettingsGoogleSheetTemplatesInput>;
};

export type ImportPreviewResult = {
  __typename?: 'ImportPreviewResult';
  errors: Array<Scalars['String']['output']>;
  notifications: Array<Scalars['String']['output']>;
  operatorCount: Scalars['Int']['output'];
  sampleOperators?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  totalRowCount: Scalars['Int']['output'];
};

export type ImportRun = {
  __typename?: 'ImportRun';
  _id: Scalars['MongoID']['output'];
  checkForExistingOperators: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  createdEntityIds: Array<Maybe<Scalars['String']['output']>>;
  createdNoteIds: Array<Maybe<Scalars['String']['output']>>;
  createdOperatorIds: Array<Maybe<Scalars['String']['output']>>;
  createdUserIds: Array<Maybe<Scalars['String']['output']>>;
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  dryRunLog?: Maybe<Array<Maybe<DryRunLogEntry>>>;
  endingRow?: Maybe<Scalars['Float']['output']>;
  entitiesManuallyConnectedToOrg?: Maybe<Array<Maybe<ExistingEntitySnapshot>>>;
  entityCount?: Maybe<Scalars['Float']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorMessages: Array<Maybe<Scalars['String']['output']>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  existingEntities?: Maybe<Array<Maybe<ExistingEntitySnapshot>>>;
  existingOperators?: Maybe<Array<Maybe<ExistingEntitySnapshot>>>;
  import?: Maybe<Import>;
  importedEntities?: Maybe<Array<Maybe<ImportedEntitySnapshot>>>;
  importedOperators?: Maybe<Array<Maybe<ImportedEntitySnapshot>>>;
  isUpdateMode?: Maybe<Scalars['Boolean']['output']>;
  jobs?: Maybe<ImportRunJobs>;
  limit?: Maybe<Scalars['Float']['output']>;
  operatorCount?: Maybe<Scalars['Float']['output']>;
  operatorsManuallyConnectedToOrg?: Maybe<Array<Maybe<ExistingEntitySnapshot>>>;
  rollbackInfo?: Maybe<RollbackInfo>;
  rowsImported?: Maybe<Scalars['Float']['output']>;
  serverLogs: Array<Maybe<Scalars['String']['output']>>;
  skipImages: Scalars['Boolean']['output'];
  startedBy: Scalars['String']['output'];
  startingRow?: Maybe<Scalars['Float']['output']>;
  status: EnumImportRunStatus;
  totalRowsAvailable?: Maybe<Scalars['Float']['output']>;
  updateRollbackSnapshots?: Maybe<Array<Maybe<UpdateRollbackSnapshot>>>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ImportRunCancelResult = {
  __typename?: 'ImportRunCancelResult';
  deletedCount: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  imagesDeleted: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type ImportRunDeleteResult = {
  __typename?: 'ImportRunDeleteResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ImportRunJobs = {
  __typename?: 'ImportRunJobs';
  errorList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ImportRunMoveOperatorsResult = {
  __typename?: 'ImportRunMoveOperatorsResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ImportRunResult = {
  __typename?: 'ImportRunResult';
  errors: Array<Scalars['String']['output']>;
  importRunId: Scalars['MongoID']['output'];
  operatorCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type ImportRunRollbackResult = {
  __typename?: 'ImportRunRollbackResult';
  deletedCount: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  imagesDeleted: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type ImportScrape = {
  __typename?: 'ImportScrape';
  _id: Scalars['MongoID']['output'];
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  googleSheetsConfig?: Maybe<ImportScrapeGoogleSheetsConfig>;
  maxRows: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  scraperPrompt?: Maybe<Scalars['String']['output']>;
  sitemapEntries: Array<Maybe<ImportScrapeSitemapEntries>>;
  sitemapRevision: Scalars['Float']['output'];
  sitemapUrlCount: Scalars['Float']['output'];
  status: EnumImportScrapeStatus;
  targetOrganization?: Maybe<Scalars['MongoID']['output']>;
  typeOfData: EnumImportScrapeTypeOfData;
  typeOfScrape: EnumImportScrapeTypeOfScrape;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type ImportScrapeCleanDataPayload = {
  __typename?: 'ImportScrapeCleanDataPayload';
  importReadyData?: Maybe<Scalars['String']['output']>;
  importReadyDataSize?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  reductionPercent?: Maybe<Scalars['Int']['output']>;
  scrape?: Maybe<ImportScrape>;
  success: Scalars['Boolean']['output'];
};

export type ImportScrapeDeleteWithRunsPayload = {
  __typename?: 'ImportScrapeDeleteWithRunsPayload';
  deletedRunsCount?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImportScrapeFetchSitemapPayload = {
  __typename?: 'ImportScrapeFetchSitemapPayload';
  logs?: Maybe<Array<ScrapeLogEntry>>;
  message?: Maybe<Scalars['String']['output']>;
  sampleUrls: Array<Scalars['String']['output']>;
  scrape?: Maybe<ImportScrape>;
  success: Scalars['Boolean']['output'];
  urlCount: Scalars['Int']['output'];
};

export type ImportScrapeFetchSpreadsheetPayload = {
  __typename?: 'ImportScrapeFetchSpreadsheetPayload';
  detectedTags: Array<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  rowCount: Scalars['Int']['output'];
  sampleRows?: Maybe<Scalars['JSON']['output']>;
  scrape?: Maybe<ImportScrape>;
  sourceHeaders: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImportScrapeFetchWebsitePayload = {
  __typename?: 'ImportScrapeFetchWebsitePayload';
  logs?: Maybe<Array<ScrapeLogEntry>>;
  message?: Maybe<Scalars['String']['output']>;
  rawWebsiteData?: Maybe<Scalars['String']['output']>;
  rawWebsiteDataSize?: Maybe<Scalars['Int']['output']>;
  scrape?: Maybe<ImportScrape>;
  success: Scalars['Boolean']['output'];
};

export type ImportScrapeGenerateColumnMappingPayload = {
  __typename?: 'ImportScrapeGenerateColumnMappingPayload';
  columnMapping?: Maybe<Scalars['JSON']['output']>;
  columnWarnings?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  message?: Maybe<Scalars['String']['output']>;
  scrape?: Maybe<ImportScrape>;
  success: Scalars['Boolean']['output'];
  unmappedDestColumns: Array<Scalars['String']['output']>;
  unmappedSourceColumns: Array<Scalars['String']['output']>;
};

export type ImportScrapeGeneratePromptPayload = {
  __typename?: 'ImportScrapeGeneratePromptPayload';
  prompt: Scalars['String']['output'];
  scrape?: Maybe<ImportScrape>;
};

export type ImportScrapeGenerateSheetPayload = {
  __typename?: 'ImportScrapeGenerateSheetPayload';
  scrape?: Maybe<ImportScrape>;
  sheetId: Scalars['String']['output'];
  sheetUrl: Scalars['String']['output'];
};

export type ImportScrapeGoogleSheetsConfig = {
  __typename?: 'ImportScrapeGoogleSheetsConfig';
  sheetId?: Maybe<Scalars['String']['output']>;
  sheetName?: Maybe<Scalars['String']['output']>;
  sheetUrl?: Maybe<Scalars['String']['output']>;
};

export type ImportScrapeGoogleSheetsConfigInput = {
  sheetId?: InputMaybe<Scalars['String']['input']>;
  sheetName?: InputMaybe<Scalars['String']['input']>;
  sheetUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ImportScrapeRun = {
  __typename?: 'ImportScrapeRun';
  _id: Scalars['MongoID']['output'];
  actionHistory?: Maybe<Array<Maybe<ImportScrapeRunActionHistory>>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  dataCleaningPrompt?: Maybe<Scalars['String']['output']>;
  errorMessages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  googleSheetsResponse?: Maybe<Scalars['String']['output']>;
  importReadyData?: Maybe<Scalars['String']['output']>;
  importReadyDataSize?: Maybe<Scalars['Float']['output']>;
  initiatedBy?: Maybe<Scalars['MongoID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  promptUsed: Scalars['String']['output'];
  rating?: Maybe<EnumImportScrapeRunRating>;
  rawAIResponse?: Maybe<Scalars['String']['output']>;
  rawWebsiteData?: Maybe<Scalars['String']['output']>;
  rawWebsiteDataSize?: Maybe<Scalars['Float']['output']>;
  results?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  rowsAdded?: Maybe<Scalars['Float']['output']>;
  scrapeId: Scalars['MongoID']['output'];
  sitemapLeaseExpiresAt?: Maybe<Scalars['Date']['output']>;
  sitemapOffset?: Maybe<Scalars['Float']['output']>;
  sitemapRevision?: Maybe<Scalars['Float']['output']>;
  sitemapTotalUrls?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<EnumImportScrapeRunStatus>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  websiteUrl: Scalars['String']['output'];
};

export type ImportScrapeRunActionHistory = {
  __typename?: 'ImportScrapeRunActionHistory';
  _id?: Maybe<Scalars['MongoID']['output']>;
  action?: Maybe<EnumImportScrapeRunActionHistoryAction>;
  summary?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
};

export type ImportScrapeRunCleanupPayload = {
  __typename?: 'ImportScrapeRunCleanupPayload';
  message?: Maybe<Scalars['String']['output']>;
  rowsMoved: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type ImportScrapeRunEnrichPayload = {
  __typename?: 'ImportScrapeRunEnrichPayload';
  hasMore: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  rowsEnriched: Scalars['Int']['output'];
  rowsProcessed: Scalars['Int']['output'];
  scrapeRun?: Maybe<ImportScrapeRun>;
  success: Scalars['Boolean']['output'];
  totalCandidates: Scalars['Int']['output'];
};

export type ImportScrapeRunPayload = {
  __typename?: 'ImportScrapeRunPayload';
  message?: Maybe<Scalars['String']['output']>;
  rowsAdded: Scalars['Int']['output'];
  scrape?: Maybe<ImportScrape>;
  scrapeRun?: Maybe<ImportScrapeRun>;
  success: Scalars['Boolean']['output'];
};

export type ImportScrapeRunResolveOperatorsPayload = {
  __typename?: 'ImportScrapeRunResolveOperatorsPayload';
  hasMore: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  rowsProcessed: Scalars['Int']['output'];
  rowsResolved: Scalars['Int']['output'];
  scrapeRun?: Maybe<ImportScrapeRun>;
  success: Scalars['Boolean']['output'];
  totalCandidates: Scalars['Int']['output'];
};

export type ImportScrapeRunRetryExtractionPayload = {
  __typename?: 'ImportScrapeRunRetryExtractionPayload';
  message?: Maybe<Scalars['String']['output']>;
  rowsAdded: Scalars['Int']['output'];
  scrapeRun?: Maybe<ImportScrapeRun>;
  success: Scalars['Boolean']['output'];
};

export type ImportScrapeRunRetryWritePayload = {
  __typename?: 'ImportScrapeRunRetryWritePayload';
  message?: Maybe<Scalars['String']['output']>;
  rowsAdded: Scalars['Int']['output'];
  scrapeRun?: Maybe<ImportScrapeRun>;
  success: Scalars['Boolean']['output'];
};

export type ImportScrapeRunSitemapPayload = {
  __typename?: 'ImportScrapeRunSitemapPayload';
  errors: Array<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  nextOffset: Scalars['Int']['output'];
  rowsAdded: Scalars['Int']['output'];
  rowsProcessed: Scalars['Int']['output'];
  scrape?: Maybe<ImportScrape>;
  scrapeRun?: Maybe<ImportScrapeRun>;
  success: Scalars['Boolean']['output'];
  totalUrls: Scalars['Int']['output'];
};

export type ImportScrapeRunSpreadsheetPayload = {
  __typename?: 'ImportScrapeRunSpreadsheetPayload';
  message?: Maybe<Scalars['String']['output']>;
  rowsAdded: Scalars['Int']['output'];
  scrape?: Maybe<ImportScrape>;
  scrapeRun?: Maybe<ImportScrapeRun>;
  success: Scalars['Boolean']['output'];
};

export type ImportScrapeSitemapEntries = {
  __typename?: 'ImportScrapeSitemapEntries';
  imageUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  url: Scalars['String']['output'];
};

export type ImportScrapeSitemapEntriesInput = {
  imageUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url: Scalars['String']['input'];
};

export enum ImportStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export enum ImportType {
  CustomTags = 'CUSTOM_TAGS',
  Events = 'EVENTS',
  Operator = 'OPERATOR',
  People = 'PEOPLE',
  Tags = 'TAGS'
}

export type ImportedEntitySnapshot = {
  __typename?: 'ImportedEntitySnapshot';
  connectedOperatorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entityId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type IntegrateCalendarLinksByProductIds = {
  __typename?: 'IntegrateCalendarLinksByProductIds';
  products: Array<Product>;
  releasedInventoryClaimItems: Array<InventoryItem>;
  updatedInventoryClaimItems: Array<InventoryItem>;
};

export type InventoryBookedDatesSummary = {
  __typename?: 'InventoryBookedDatesSummary';
  bookedDatesISO: Array<Scalars['String']['output']>;
  checkOutOnlyDatesISO: Array<Scalars['String']['output']>;
};

export type InventoryItem = {
  __typename?: 'InventoryItem';
  _id: Scalars['MongoID']['output'];
  claimedDateRangesISO: Array<Maybe<DateRangeIso>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  product: Scalars['MongoID']['output'];
  type: EnumInventoryItemType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type InventoryLogEntry = {
  __typename?: 'InventoryLogEntry';
  change: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  newCount?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  previousCount?: Maybe<Scalars['Int']['output']>;
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  variantLabel?: Maybe<Scalars['String']['output']>;
};

export type InviteQueue = {
  __typename?: 'InviteQueue';
  _id: Scalars['MongoID']['output'];
  activityLogIds: Array<Maybe<Scalars['MongoID']['output']>>;
  bounced: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  initiatedByUser: Scalars['MongoID']['output'];
  initiatedByUserName: Scalars['String']['output'];
  initiatedDate: Scalars['Date']['output'];
  inviteByEmailOnly: Scalars['Boolean']['output'];
  inviteStatus: EnumInviteQueueInviteStatus;
  inviteType: EnumInviteQueueInviteType;
  invitedEmail?: Maybe<Scalars['String']['output']>;
  invitedOperator: Scalars['MongoID']['output'];
  invitedOperatorName: Scalars['String']['output'];
  invitedUser?: Maybe<Scalars['MongoID']['output']>;
  invitedUserName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['MongoID']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['MongoID']['output']>;
  preSendStatus?: Maybe<EnumInviteQueuePreSendStatus>;
  sendBatchId?: Maybe<Scalars['MongoID']['output']>;
  staffDeliveryEmail?: Maybe<Scalars['String']['output']>;
  storedInvitedEmail?: Maybe<Scalars['String']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type InviteQueueAcceptFreshenResult = {
  __typename?: 'InviteQueueAcceptFreshenResult';
  updatedCount: Scalars['Int']['output'];
};

export type InviteQueueCleanupCriteriaInput = {
  olderThanDays?: InputMaybe<Scalars['Int']['input']>;
  removeAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  removeBounced?: InputMaybe<Scalars['Boolean']['input']>;
  removeReady?: InputMaybe<Scalars['Boolean']['input']>;
  sentMoreThan?: InputMaybe<Scalars['Int']['input']>;
};

export type InviteQueueCleanupPreview = {
  __typename?: 'InviteQueueCleanupPreview';
  accepted: Scalars['Int']['output'];
  bounced: Scalars['Int']['output'];
  olderThanDays: Scalars['Int']['output'];
  ready: Scalars['Int']['output'];
  sentMoreThan: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type InviteQueueCleanupResult = {
  __typename?: 'InviteQueueCleanupResult';
  cancelledCount: Scalars['Int']['output'];
};

export type InviteQueueFreshenResult = {
  __typename?: 'InviteQueueFreshenResult';
  activityLogId?: Maybe<Scalars['MongoID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type InviteQueueReinviteByEmailResult = {
  __typename?: 'InviteQueueReinviteByEmailResult';
  activityLogId?: Maybe<Scalars['MongoID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type InviteQueueSendInvitesResult = {
  __typename?: 'InviteQueueSendInvitesResult';
  alreadyProcessing: Scalars['Boolean']['output'];
  started: Scalars['Boolean']['output'];
  totalToSend: Scalars['Int']['output'];
};

export type InvoicePriceComputeResult = {
  __typename?: 'InvoicePriceComputeResult';
  customerFee: Scalars['Int']['output'];
  discountAmount: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  lineItemSubtotal: Scalars['Int']['output'];
  productSubtotal: Scalars['Int']['output'];
  subTotal: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  taxLines: Array<TaxLine>;
};

export type Itinerary = {
  __typename?: 'Itinerary';
  _entityId: Scalars['MongoID']['output'];
  _id: Scalars['MongoID']['output'];
  _versionId: Scalars['MongoID']['output'];
  coverImage?: Maybe<AssetImage>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  createdByUser?: Maybe<User>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Multilingual>;
  favorited: Scalars['Boolean']['output'];
  hasDraftChanges: Scalars['Boolean']['output'];
  isLoop: Scalars['Boolean']['output'];
  lastEditedBy?: Maybe<Scalars['MongoID']['output']>;
  lastEditedByUser?: Maybe<User>;
  moreInfoLink?: Maybe<Scalars['String']['output']>;
  name: Multilingual;
  nightCount: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  owner: Owner;
  published?: Maybe<ItineraryPublished>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  routeDistance?: Maybe<Scalars['Float']['output']>;
  routeDuration?: Maybe<Scalars['Float']['output']>;
  routePath?: Maybe<Scalars['JSON']['output']>;
  routeStatus: EnumItineraryRouteStatus;
  segments?: Maybe<Array<Maybe<ItinerarySegmentData>>>;
  shortCode?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status: EnumItineraryStatus;
  stopCount: Scalars['Int']['output'];
  trailPlace?: Maybe<Place>;
  travelType: EnumItineraryTravelType;
  tripperSettings?: Maybe<ItineraryTripperSettings>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ItineraryByOperatorItem = {
  __typename?: 'ItineraryByOperatorItem';
  _id: Scalars['MongoID']['output'];
  name?: Maybe<Multilingual>;
};

export type ItineraryByOperatorResult = {
  __typename?: 'ItineraryByOperatorResult';
  count: Scalars['Int']['output'];
  itineraries?: Maybe<Array<Maybe<ItineraryByOperatorItem>>>;
};

export type ItineraryDebugItem = {
  __typename?: 'ItineraryDebugItem';
  _id: Scalars['MongoID']['output'];
  isLoop?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['JSON']['output']>;
  routeDistance?: Maybe<Scalars['Float']['output']>;
  routeDuration?: Maybe<Scalars['Float']['output']>;
  routeStatus?: Maybe<Scalars['String']['output']>;
  segmentCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stopCount?: Maybe<Scalars['Int']['output']>;
  travelType?: Maybe<Scalars['String']['output']>;
};

export type ItineraryEntityRef = {
  __typename?: 'ItineraryEntityRef';
  entityId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ItineraryItemLink = {
  __typename?: 'ItineraryItemLink';
  label?: Maybe<Multilingual>;
  url: Scalars['String']['output'];
};

export type ItineraryPublishResult = {
  __typename?: 'ItineraryPublishResult';
  issues: Array<PublishValidationIssue>;
  itinerary?: Maybe<Itinerary>;
  success: Scalars['Boolean']['output'];
};

export type ItineraryPublished = {
  __typename?: 'ItineraryPublished';
  coverImage?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Multilingual>;
  isLoop?: Maybe<Scalars['Boolean']['output']>;
  moreInfoLink?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Multilingual>;
  publishedAt: Scalars['Date']['output'];
  publishedBy?: Maybe<Scalars['MongoID']['output']>;
  routeDistance?: Maybe<Scalars['Float']['output']>;
  routeDuration?: Maybe<Scalars['Float']['output']>;
  routePath?: Maybe<Scalars['JSON']['output']>;
  segments?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  trailPlace?: Maybe<Scalars['MongoID']['output']>;
  travelType?: Maybe<EnumItineraryPublishedTravelType>;
  tripperSettings?: Maybe<ItineraryTripperSettings>;
};

export type ItineraryPublishedInput = {
  coverImage?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<MultilingualInput>;
  isLoop?: InputMaybe<Scalars['Boolean']['input']>;
  moreInfoLink?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<MultilingualInput>;
  publishedAt: Scalars['Date']['input'];
  publishedBy?: InputMaybe<Scalars['MongoID']['input']>;
  routeDistance?: InputMaybe<Scalars['Float']['input']>;
  routeDuration?: InputMaybe<Scalars['Float']['input']>;
  routePath?: InputMaybe<Scalars['JSON']['input']>;
  segments?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  trailPlace?: InputMaybe<Scalars['MongoID']['input']>;
  travelType?: InputMaybe<EnumItineraryPublishedTravelType>;
  tripperSettings?: InputMaybe<ItineraryTripperSettingsInput>;
};

export type ItinerarySegmentBlock = {
  __typename?: 'ItinerarySegmentBlock';
  _id: Scalars['String']['output'];
  blockType: Scalars['String']['output'];
  content?: Maybe<Multilingual>;
  description?: Maybe<Multilingual>;
  distanceFromPrev?: Maybe<Scalars['Float']['output']>;
  entityRef?: Maybe<ItineraryEntityRef>;
  featuredImageId?: Maybe<Scalars['String']['output']>;
  groupType?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<ItinerarySegmentBlock>>>;
  link?: Maybe<ItineraryItemLink>;
  media?: Maybe<ItineraryStopGroupMedia>;
  name?: Maybe<Multilingual>;
  notes?: Maybe<Multilingual>;
  overnight?: Maybe<Scalars['Boolean']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  timeFromPrev?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Multilingual>;
  tweenLabel?: Maybe<Multilingual>;
  tweenType?: Maybe<Scalars['String']['output']>;
};

export type ItinerarySegmentData = {
  __typename?: 'ItinerarySegmentData';
  _id: Scalars['String']['output'];
  distance?: Maybe<Scalars['Float']['output']>;
  items?: Maybe<Array<Maybe<ItinerarySegmentBlock>>>;
  label?: Maybe<Multilingual>;
};

export type ItinerarySegmentsInput = {
  _id: Scalars['String']['input'];
  distance?: InputMaybe<Scalars['Float']['input']>;
  items?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  label: MultilingualInput;
};

export type ItineraryStopGroupMedia = {
  __typename?: 'ItineraryStopGroupMedia';
  alt?: Maybe<Multilingual>;
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mediaId?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ItineraryTripperSettings = {
  __typename?: 'ItineraryTripperSettings';
  fontFamily?: Maybe<Scalars['String']['output']>;
  map3dBuildings?: Maybe<Scalars['Boolean']['output']>;
  map3dObjects?: Maybe<Scalars['Boolean']['output']>;
  map3dTrees?: Maybe<Scalars['Boolean']['output']>;
  mapStyleVariant?: Maybe<EnumItineraryTripperSettingsMapStyleVariant>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  segmentPreset: EnumItineraryTripperSettingsSegmentPreset;
  showPointsOfInterest?: Maybe<Scalars['Boolean']['output']>;
};

export type ItineraryTripperSettingsInput = {
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  map3dBuildings?: InputMaybe<Scalars['Boolean']['input']>;
  map3dObjects?: InputMaybe<Scalars['Boolean']['input']>;
  map3dTrees?: InputMaybe<Scalars['Boolean']['input']>;
  mapStyleVariant?: InputMaybe<EnumItineraryTripperSettingsMapStyleVariant>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  segmentPreset: EnumItineraryTripperSettingsSegmentPreset;
  showPointsOfInterest?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItineraryWidget = {
  __typename?: 'ItineraryWidget';
  _id: Scalars['MongoID']['output'];
  accentColor?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  embedStyle: EnumItineraryWidgetEmbedStyle;
  itinerary: Scalars['MongoID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  map3dBuildings: Scalars['Boolean']['output'];
  map3dObjects: Scalars['Boolean']['output'];
  map3dTrees: Scalars['Boolean']['output'];
  mapStyleVariant?: Maybe<EnumItineraryWidgetMapStyleVariant>;
  organization: Scalars['MongoID']['output'];
  showPointsOfInterest: Scalars['Boolean']['output'];
  status: EnumItineraryWidgetStatus;
  type: EnumItineraryWidgetType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ItineraryWidgetWithName = {
  __typename?: 'ItineraryWidgetWithName';
  _id: Scalars['MongoID']['output'];
  accentColor?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  embedStyle?: Maybe<Scalars['String']['output']>;
  itinerary: Scalars['MongoID']['output'];
  itineraryName: Scalars['String']['output'];
  itineraryStatus?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  organization: Scalars['MongoID']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type LastUpdatedFilterInput = {
  after?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['Date']['input']>;
};

export type Lead = {
  __typename?: 'Lead';
  _id: Scalars['MongoID']['output'];
  broadcastId?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  messages: Array<Maybe<LeadMessages>>;
  metadata: LeadMetadata;
  person?: Maybe<SimplePersonTc>;
  source?: Maybe<EnumLeadSource>;
  sourceDetails?: Maybe<Scalars['String']['output']>;
  status: EnumLeadStatus;
  subject?: Maybe<Scalars['String']['output']>;
  surveyResponse?: Maybe<SurveyResponse>;
  tags: Array<Tag>;
  type?: Maybe<EnumLeadType>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type LeadMessages = {
  __typename?: 'LeadMessages';
  _id?: Maybe<Scalars['MongoID']['output']>;
  message: Scalars['String']['output'];
  sender: EnumLeadMessagesSender;
  sentAtDateISO: Scalars['Date']['output'];
};

export type LeadMetadata = {
  __typename?: 'LeadMetadata';
  _id: Scalars['MongoID']['output'];
  booker?: Maybe<Booker>;
  operator?: Maybe<OperatorWithStatus>;
  organization?: Maybe<Organization>;
  storefront?: Maybe<Storefront>;
};


export type LeadMetadataOperatorArgs = {
  loggedInAs?: InputMaybe<OwnerInput>;
  status?: InputMaybe<PublicationStatusType>;
};

export type Links = {
  __typename?: 'Links';
  bookNow?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  googleMyBusiness?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  otherUrls: Array<Maybe<Scalars['String']['output']>>;
  pinterest?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  tripAdvisor?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type LinksInput = {
  bookNow?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  googleMyBusiness?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  otherUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pinterest?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  tripAdvisor?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type List = {
  __typename?: 'List';
  _id: Scalars['MongoID']['output'];
  archived: Scalars['Boolean']['output'];
  audienceListKey?: Maybe<EnumListAudienceListKey>;
  audienceTagId?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  entityReferences: Array<Maybe<VersionedEntityReference>>;
  externallyAvailableEntityReferences: Array<Maybe<VersionedEntityReference>>;
  favorited: Scalars['Boolean']['output'];
  filterTagIds: Array<Maybe<Scalars['MongoID']['output']>>;
  kind: EnumListKind;
  locked: Scalars['Boolean']['output'];
  lockedAt?: Maybe<Scalars['Date']['output']>;
  lockedBy?: Maybe<Scalars['MongoID']['output']>;
  lockedByName?: Maybe<Scalars['String']['output']>;
  memberListKey?: Maybe<EnumListMemberListKey>;
  name: Multilingual;
  orderIndex?: Maybe<Scalars['Float']['output']>;
  owner: Owner;
  selections: Scalars['JSON']['output'];
  tierTagId?: Maybe<Scalars['MongoID']['output']>;
  type: EnumListType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ListWithEntities = {
  __typename?: 'ListWithEntities';
  _id: Scalars['MongoID']['output'];
  archived: Scalars['Boolean']['output'];
  audienceListKey?: Maybe<EnumListAudienceListKey>;
  audienceTagId?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  entities?: Maybe<Array<OperatorWithStatus>>;
  entityReferences: Array<Maybe<VersionedEntityReference>>;
  externallyAvailableEntityReferences: Array<Maybe<VersionedEntityReference>>;
  favorited: Scalars['Boolean']['output'];
  filterTagIds: Array<Maybe<Scalars['MongoID']['output']>>;
  kind: EnumListKind;
  locked: Scalars['Boolean']['output'];
  lockedAt?: Maybe<Scalars['Date']['output']>;
  lockedBy?: Maybe<Scalars['MongoID']['output']>;
  lockedByName?: Maybe<Scalars['String']['output']>;
  memberListKey?: Maybe<EnumListMemberListKey>;
  name: Multilingual;
  orderIndex?: Maybe<Scalars['Float']['output']>;
  owner: Owner;
  selections: Scalars['JSON']['output'];
  tierTagId?: Maybe<Scalars['MongoID']['output']>;
  type: EnumListType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ListWithEntitiesAndOverrides = {
  __typename?: 'ListWithEntitiesAndOverrides';
  _id: Scalars['MongoID']['output'];
  archived: Scalars['Boolean']['output'];
  audienceListKey?: Maybe<EnumListAudienceListKey>;
  audienceTagId?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  entities: Array<OperatorWithOverrides>;
  entityReferences: Array<Maybe<VersionedEntityReference>>;
  externallyAvailableEntityReferences: Array<Maybe<VersionedEntityReference>>;
  favorited: Scalars['Boolean']['output'];
  filterTagIds: Array<Maybe<Scalars['MongoID']['output']>>;
  kind: EnumListKind;
  locked: Scalars['Boolean']['output'];
  lockedAt?: Maybe<Scalars['Date']['output']>;
  lockedBy?: Maybe<Scalars['MongoID']['output']>;
  lockedByName?: Maybe<Scalars['String']['output']>;
  memberListKey?: Maybe<EnumListMemberListKey>;
  name: Multilingual;
  orderIndex?: Maybe<Scalars['Float']['output']>;
  owner: Owner;
  selections: Scalars['JSON']['output'];
  tierTagId?: Maybe<Scalars['MongoID']['output']>;
  type: EnumListType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type LocalTimeRange = {
  __typename?: 'LocalTimeRange';
  /** Closing time as `HH:mm`. */
  end: Scalars['String']['output'];
  /** Opening time as `HH:mm`. */
  start: Scalars['String']['output'];
};

export type Maintenance = {
  __typename?: 'Maintenance';
  _id: Scalars['MongoID']['output'];
  banner: MaintenanceDoorstop;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  doorstop: MaintenanceDoorstop;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type MaintenanceDoorstop = {
  __typename?: 'MaintenanceDoorstop';
  isLive: Scalars['Boolean']['output'];
  message: Multilingual;
};

export enum MemberContactState {
  Contacted = 'CONTACTED',
  CoolingDown = 'COOLING_DOWN',
  Declined = 'DECLINED',
  NeedsContact = 'NEEDS_CONTACT',
  NoEmail = 'NO_EMAIL',
  Queued = 'QUEUED',
  Unsubscribed = 'UNSUBSCRIBED'
}

export type Membership = {
  __typename?: 'Membership';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  currentPeriodEnd?: Maybe<Scalars['Date']['output']>;
  currentPeriodStart?: Maybe<Scalars['Date']['output']>;
  emailsDeclined?: Maybe<Array<Maybe<MembershipEmailsDeclined>>>;
  emailsSent?: Maybe<Array<Maybe<MembershipEmailsSent>>>;
  expiredAt?: Maybe<Scalars['Date']['output']>;
  firstGrantedAt?: Maybe<Scalars['Date']['output']>;
  lastChangedAt: Scalars['Date']['output'];
  lastMembershipEmail?: Maybe<MembershipLastMembershipEmail>;
  lastRenewalReminderSentFor?: Maybe<Scalars['Date']['output']>;
  latestEventId?: Maybe<Scalars['MongoID']['output']>;
  manualRenewalDate?: Maybe<Scalars['Date']['output']>;
  nextRenewalDate?: Maybe<Scalars['Date']['output']>;
  organization: Scalars['MongoID']['output'];
  renewalAnchorDate?: Maybe<Scalars['Date']['output']>;
  renewalState?: Maybe<MembershipRenewalState>;
  sourceContributions: Array<Maybe<MembershipSourceContributions>>;
  status: EnumMembershipStatus;
  statusAppliedAt?: Maybe<Array<Maybe<MembershipStatusAppliedAt>>>;
  statusTagIds: Array<Maybe<Scalars['MongoID']['output']>>;
  subject: MembershipSubject;
  tierTagId?: Maybe<Scalars['MongoID']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type MembershipBulkSetStatusResult = {
  __typename?: 'MembershipBulkSetStatusResult';
  affected: Scalars['Int']['output'];
  scheduled: Scalars['Int']['output'];
  skipped: Array<Maybe<MembershipBulkSetStatusSkipped>>;
};

export type MembershipBulkSetStatusSkipped = {
  __typename?: 'MembershipBulkSetStatusSkipped';
  entityId: Scalars['MongoID']['output'];
  name: Scalars['String']['output'];
  paidThrough: Scalars['Date']['output'];
};

export type MembershipChecklistAnalysis = {
  __typename?: 'MembershipChecklistAnalysis';
  communication: MembershipChecklistCommunication;
  ledgerEnabled: Scalars['Boolean']['output'];
  memberListsEnabled: Scalars['Boolean']['output'];
  members: MembershipChecklistMembers;
  payment: MembershipChecklistPayment;
  renewal: MembershipChecklistRenewal;
};

export type MembershipChecklistCommunication = {
  __typename?: 'MembershipChecklistCommunication';
  allowColdSignup: Scalars['Boolean']['output'];
  broadcastId?: Maybe<Scalars['ID']['output']>;
  broadcastName?: Maybe<Scalars['String']['output']>;
  broadcastPublished: Scalars['Boolean']['output'];
  broadcastSharedToAll?: Maybe<Scalars['Boolean']['output']>;
};

export type MembershipChecklistFixResult = {
  __typename?: 'MembershipChecklistFixResult';
  affected: Scalars['Int']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  grace?: Maybe<RenewalRebaseGrace>;
  phaseAfter?: Maybe<Scalars['String']['output']>;
  result?: Maybe<MembershipChecklistResult>;
};

export type MembershipChecklistListing = {
  __typename?: 'MembershipChecklistListing';
  entityId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tiers: Array<Scalars['String']['output']>;
};

export type MembershipChecklistMembers = {
  __typename?: 'MembershipChecklistMembers';
  byStatus: Array<MembershipChecklistTagCount>;
  byTier: Array<MembershipChecklistTier>;
  multipleTierListings: Array<MembershipChecklistListing>;
  multipleTiers: Scalars['Int']['output'];
  nonMembers: Scalars['Int']['output'];
  tieredWithoutStatusTag: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalListings: Scalars['Int']['output'];
};

export type MembershipChecklistPayment = {
  __typename?: 'MembershipChecklistPayment';
  byTier: Array<MembershipChecklistPaymentTier>;
  enabled: Scalars['Boolean']['output'];
  hasStorefront: Scalars['Boolean']['output'];
  liveCadStorefrontId?: Maybe<Scalars['ID']['output']>;
  liveUsdStorefrontId?: Maybe<Scalars['ID']['output']>;
  testUsdStorefrontId?: Maybe<Scalars['ID']['output']>;
};

export type MembershipChecklistPaymentTier = {
  __typename?: 'MembershipChecklistPaymentTier';
  bookerId?: Maybe<Scalars['ID']['output']>;
  bookerStorefrontId?: Maybe<Scalars['ID']['output']>;
  free: Scalars['Boolean']['output'];
  isTest: Scalars['Boolean']['output'];
  tagId: Scalars['ID']['output'];
};

export type MembershipChecklistRenewal = {
  __typename?: 'MembershipChecklistRenewal';
  activeStatusTagId?: Maybe<Scalars['ID']['output']>;
  activeStatusTagName?: Maybe<Scalars['String']['output']>;
  attentionStatusTagIds?: Maybe<Array<Scalars['ID']['output']>>;
  enabled: Scalars['Boolean']['output'];
  engineEnabled: Scalars['Boolean']['output'];
  expired: Scalars['Int']['output'];
  fixedRenewalDay?: Maybe<Scalars['Int']['output']>;
  fixedRenewalMonth?: Maybe<Scalars['Int']['output']>;
  paidUp: Scalars['Int']['output'];
  renewalType?: Maybe<Scalars['String']['output']>;
  renewalWindow: Scalars['Int']['output'];
  suggestedBulkDate?: Maybe<Scalars['Date']['output']>;
  tagDrift: Scalars['Int']['output'];
  term?: Maybe<Scalars['String']['output']>;
  termYears?: Maybe<Scalars['Int']['output']>;
  withRenewalDate: Scalars['Int']['output'];
  withoutRenewalDate: Scalars['Int']['output'];
};

export type MembershipChecklistResult = {
  __typename?: 'MembershipChecklistResult';
  analysis: MembershipChecklistAnalysis;
  ranAt: Scalars['Date']['output'];
};

export type MembershipChecklistTagCount = {
  __typename?: 'MembershipChecklistTagCount';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  tagId: Scalars['ID']['output'];
};

export type MembershipChecklistTier = {
  __typename?: 'MembershipChecklistTier';
  byStatus: Array<MembershipChecklistTagCount>;
  count: Scalars['Int']['output'];
  listId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  tagId: Scalars['ID']['output'];
};

export type MembershipCustomEmailPreview = {
  __typename?: 'MembershipCustomEmailPreview';
  missing: Array<Maybe<MembershipListEmailCoverageMissing>>;
  sendable: Scalars['Int']['output'];
  skippedCoolingDown: Scalars['Int']['output'];
  skippedNoEmail: Scalars['Int']['output'];
  skippedQueued: Scalars['Int']['output'];
  skippedUnsubscribed: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MembershipDeclineStatusEmailsResult = {
  __typename?: 'MembershipDeclineStatusEmailsResult';
  declined: Scalars['Int']['output'];
  skippedContacted: Scalars['Int']['output'];
  skippedNoEmail: Scalars['Int']['output'];
  skippedQueued: Scalars['Int']['output'];
};

export type MembershipDisplayForPerson = {
  __typename?: 'MembershipDisplayForPerson';
  listingEntityId?: Maybe<Scalars['MongoID']['output']>;
  listingName?: Maybe<Scalars['String']['output']>;
  membership?: Maybe<Membership>;
  source: Scalars['String']['output'];
};

export type MembershipEmailsDeclined = {
  __typename?: 'MembershipEmailsDeclined';
  actorUserId?: Maybe<Scalars['MongoID']['output']>;
  declinedAt: Scalars['Date']['output'];
  kind: EnumMembershipEmailsDeclinedKind;
};

export type MembershipEmailsSent = {
  __typename?: 'MembershipEmailsSent';
  kind: EnumMembershipEmailsSentKind;
  sentAt: Scalars['Date']['output'];
};

export type MembershipEvent = {
  __typename?: 'MembershipEvent';
  _id: Scalars['MongoID']['output'];
  actorUserId?: Maybe<Scalars['MongoID']['output']>;
  addedTagIds: Array<Maybe<Scalars['MongoID']['output']>>;
  createdAt: Scalars['Date']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  organization: Scalars['MongoID']['output'];
  previousStatusTagIds: Array<Maybe<Scalars['MongoID']['output']>>;
  previousTierTagId?: Maybe<Scalars['MongoID']['output']>;
  removedTagIds: Array<Maybe<Scalars['MongoID']['output']>>;
  source: MembershipEventSource;
  statusTagIds: Array<Maybe<Scalars['MongoID']['output']>>;
  subject: MembershipEventSubject;
  tierTagId?: Maybe<Scalars['MongoID']['output']>;
  type: EnumMembershipEventType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  validFrom?: Maybe<Scalars['Date']['output']>;
  validUntil?: Maybe<Scalars['Date']['output']>;
};

export type MembershipEventAdminRow = {
  __typename?: 'MembershipEventAdminRow';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  listingEntityId?: Maybe<Scalars['MongoID']['output']>;
  listingName?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['MongoID']['output'];
  organizationName: Scalars['String']['output'];
  personEmail?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['MongoID']['output']>;
  type: Scalars['String']['output'];
};

export type MembershipEventSource = {
  __typename?: 'MembershipEventSource';
  fromSubject?: Maybe<MembershipEventSubject>;
  kind: EnumMembershipEventSourceKind;
  refs?: Maybe<MembershipEventSourceRefs>;
};

export type MembershipEventSourceRefs = {
  __typename?: 'MembershipEventSourceRefs';
  broadcastId?: Maybe<Scalars['MongoID']['output']>;
  broadcastResourceId?: Maybe<Scalars['String']['output']>;
  operatorId?: Maybe<Scalars['MongoID']['output']>;
  operatorIds?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  orderId?: Maybe<Scalars['String']['output']>;
  renewablePurchaseId?: Maybe<Scalars['MongoID']['output']>;
  renewalRecordId?: Maybe<Scalars['MongoID']['output']>;
  surveyResponseId?: Maybe<Scalars['MongoID']['output']>;
};

export type MembershipEventSubject = {
  __typename?: 'MembershipEventSubject';
  entityId: Scalars['MongoID']['output'];
  type: EnumMembershipEventSubjectType;
};

export type MembershipHubAddOn = {
  __typename?: 'MembershipHubAddOn';
  amount: Scalars['Int']['output'];
  businessName?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  operatorId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
};

export type MembershipHubOrganization = {
  __typename?: 'MembershipHubOrganization';
  contactEmail?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  hideOfferFromForYou: Scalars['Boolean']['output'];
  organizationId: Scalars['MongoID']['output'];
  purchases?: Maybe<Array<MembershipHubPurchase>>;
  tiers?: Maybe<Array<MembershipHubTier>>;
};

export type MembershipHubPurchase = {
  __typename?: 'MembershipHubPurchase';
  _id: Scalars['MongoID']['output'];
  addOns?: Maybe<Array<MembershipHubAddOn>>;
  canManage: Scalars['Boolean']['output'];
  currentPeriodEnd?: Maybe<Scalars['String']['output']>;
  maxListings?: Maybe<Scalars['Int']['output']>;
  multiListingMode: Scalars['String']['output'];
  operatorIds: Array<Scalars['MongoID']['output']>;
  pendingOperatorIds?: Maybe<Array<Scalars['MongoID']['output']>>;
  renewalBilling: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tierName?: Maybe<Multilingual>;
};

export type MembershipHubTier = {
  __typename?: 'MembershipHubTier';
  action: Scalars['String']['output'];
  applicationBroadcastId?: Maybe<Scalars['MongoID']['output']>;
  applicationResourceId?: Maybe<Scalars['MongoID']['output']>;
  billingIntervalMonths?: Maybe<Scalars['Int']['output']>;
  bookerId?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Multilingual>;
  hideFromNewcomers: Scalars['Boolean']['output'];
  name: Multilingual;
  price?: Maybe<Scalars['Float']['output']>;
  subjectType: Scalars['String']['output'];
  tierTagId: Scalars['MongoID']['output'];
};

export type MembershipHubTierInput = {
  applicationBroadcastId?: InputMaybe<Scalars['MongoID']['input']>;
  applicationResourceId?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hideFromNewcomers?: InputMaybe<Scalars['Boolean']['input']>;
  tierTagId: Scalars['MongoID']['input'];
};

export type MembershipLastMembershipEmail = {
  __typename?: 'MembershipLastMembershipEmail';
  bouncedAt?: Maybe<Scalars['Date']['output']>;
  kind: EnumMembershipLastMembershipEmailKind;
  sentAt: Scalars['Date']['output'];
};

export type MembershipLaunchStatus = {
  __typename?: 'MembershipLaunchStatus';
  blockers: Array<Scalars['String']['output']>;
  derived: Scalars['Boolean']['output'];
  health: MembershipScheduleHealth;
  launchedAt?: Maybe<Scalars['Date']['output']>;
  locked: Scalars['Boolean']['output'];
  mode?: Maybe<Scalars['String']['output']>;
  recordedRetroactively: Scalars['Boolean']['output'];
  scheduleHistory: Array<MembershipScheduleChange>;
  state: Scalars['String']['output'];
};

export type MembershipListEmailCoverage = {
  __typename?: 'MembershipListEmailCoverage';
  missing: Array<Maybe<MembershipListEmailCoverageMissing>>;
  total: Scalars['Int']['output'];
};

export type MembershipListEmailCoverageMissing = {
  __typename?: 'MembershipListEmailCoverageMissing';
  entityId: Scalars['MongoID']['output'];
  name: Scalars['String']['output'];
};

export type MembershipMarkRenewedForOwnerResult = {
  __typename?: 'MembershipMarkRenewedForOwnerResult';
  error?: Maybe<Scalars['String']['output']>;
  operatorEntityId: Scalars['MongoID']['output'];
  renewedUntil?: Maybe<Scalars['Date']['output']>;
};

export type MembershipMultiListingCandidate = {
  __typename?: 'MembershipMultiListingCandidate';
  businesses?: Maybe<Array<MembershipMultiListingCandidateBusiness>>;
  contactEmail: Scalars['String']['output'];
};

export type MembershipMultiListingCandidateBusiness = {
  __typename?: 'MembershipMultiListingCandidateBusiness';
  businessName: Scalars['String']['output'];
  operatorEntityId: Scalars['MongoID']['output'];
  paidThroughDate?: Maybe<Scalars['Date']['output']>;
  renewablePurchaseId?: Maybe<Scalars['MongoID']['output']>;
  tierTagId?: Maybe<Scalars['MongoID']['output']>;
};

export type MembershipOpenRenewalInvoice = {
  __typename?: 'MembershipOpenRenewalInvoice';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  paymentRequestId?: Maybe<Scalars['String']['output']>;
  storefrontId?: Maybe<Scalars['String']['output']>;
};

export type MembershipPaidUpInfo = {
  __typename?: 'MembershipPaidUpInfo';
  contactKind?: Maybe<PendingRenewalEmailKind>;
  contactState?: Maybe<MemberContactState>;
  contactStatusTagId?: Maybe<Scalars['MongoID']['output']>;
  currentPeriodEnd?: Maybe<Scalars['Date']['output']>;
  lastContactedAt?: Maybe<Scalars['Date']['output']>;
  manualRenewalDate?: Maybe<Scalars['Date']['output']>;
  nextRenewalDate?: Maybe<Scalars['Date']['output']>;
  operatorEntityId: Scalars['MongoID']['output'];
  queuedListId?: Maybe<Scalars['MongoID']['output']>;
  queuedListName?: Maybe<Scalars['String']['output']>;
  renewalDay?: Maybe<Scalars['Date']['output']>;
  renewalDisplayDate?: Maybe<Scalars['Date']['output']>;
  renewalPhase?: Maybe<Scalars['String']['output']>;
};

export type MembershipPaidUpSource = {
  __typename?: 'MembershipPaidUpSource';
  orderId: Scalars['String']['output'];
  paidUntil?: Maybe<Scalars['String']['output']>;
  renewablePurchaseId: Scalars['MongoID']['output'];
  storefrontId: Scalars['MongoID']['output'];
};

export type MembershipQueueCustomEmailsResult = {
  __typename?: 'MembershipQueueCustomEmailsResult';
  queued: Scalars['Int']['output'];
  skippedCoolingDown: Scalars['Int']['output'];
  skippedNoEmail: Scalars['Int']['output'];
  skippedQueued: Scalars['Int']['output'];
  skippedUnsubscribed: Scalars['Int']['output'];
};

export type MembershipQueueStatusEmailsResult = {
  __typename?: 'MembershipQueueStatusEmailsResult';
  queued: Scalars['Int']['output'];
  skippedContacted: Scalars['Int']['output'];
  skippedCoolingDown: Scalars['Int']['output'];
  skippedNoEmail: Scalars['Int']['output'];
  skippedQueued: Scalars['Int']['output'];
  skippedUnsubscribed: Scalars['Int']['output'];
};

export type MembershipRenewalAudit = {
  __typename?: 'MembershipRenewalAudit';
  counts: MembershipRenewalAuditCounts;
  discrepancies: Array<MembershipRenewalAuditRow>;
  organizationId: Scalars['MongoID']['output'];
  organizationName: Scalars['String']['output'];
  renewalEngineEnabled: Scalars['Boolean']['output'];
};

export type MembershipRenewalAuditCounts = {
  __typename?: 'MembershipRenewalAuditCounts';
  expired: Scalars['Int']['output'];
  noPolicy: Scalars['Int']['output'];
  paidUp: Scalars['Int']['output'];
  renewalWindow: Scalars['Int']['output'];
  tagDrift: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unknown: Scalars['Int']['output'];
};

export type MembershipRenewalAuditRow = {
  __typename?: 'MembershipRenewalAuditRow';
  currentStatusTags: Array<MembershipRenewalAuditTag>;
  displayName: Scalars['String']['output'];
  entityId: Scalars['MongoID']['output'];
  kind: Scalars['String']['output'];
  membershipId: Scalars['MongoID']['output'];
  nextRenewalDate?: Maybe<Scalars['Date']['output']>;
  paidThroughDate?: Maybe<Scalars['Date']['output']>;
  personId?: Maybe<Scalars['MongoID']['output']>;
  phase: Scalars['String']['output'];
  subjectType: Scalars['String']['output'];
  suggestedAddTags: Array<MembershipRenewalAuditTag>;
  suggestedRemoveTags: Array<MembershipRenewalAuditTag>;
};

export type MembershipRenewalAuditTag = {
  __typename?: 'MembershipRenewalAuditTag';
  name: Scalars['String']['output'];
  tagId: Scalars['ID']['output'];
};

export type MembershipRenewalState = {
  __typename?: 'MembershipRenewalState';
  displayDate?: Maybe<Scalars['Date']['output']>;
  nextRenewalDate?: Maybe<Scalars['Date']['output']>;
  paidThroughDate?: Maybe<Scalars['Date']['output']>;
  phase: Scalars['String']['output'];
};

export type MembershipScheduleChange = {
  __typename?: 'MembershipScheduleChange';
  affected: Scalars['Int']['output'];
  at: Scalars['Date']['output'];
  by?: Maybe<Scalars['ID']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  fromDay?: Maybe<Scalars['Int']['output']>;
  fromMonth?: Maybe<Scalars['Int']['output']>;
  intent?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  toDay?: Maybe<Scalars['Int']['output']>;
  toMonth?: Maybe<Scalars['Int']['output']>;
};

export type MembershipScheduleHealth = {
  __typename?: 'MembershipScheduleHealth';
  graceEndsOn?: Maybe<Scalars['Date']['output']>;
  offSchedule: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
  purchaseSnapshotMismatch: Scalars['Int']['output'];
  staleCheckouts: Scalars['Int']['output'];
  undated: Scalars['Int']['output'];
};

export type MembershipScheduleRepair = {
  __typename?: 'MembershipScheduleRepair';
  checkouts: Scalars['Int']['output'];
  purchases: Scalars['Int']['output'];
};

export type MembershipSendPendingRenewalEmailsNowResult = {
  __typename?: 'MembershipSendPendingRenewalEmailsNowResult';
  sent: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  started?: Maybe<Scalars['Int']['output']>;
};

export type MembershipSourceContributions = {
  __typename?: 'MembershipSourceContributions';
  fromSubject?: Maybe<MembershipSubject>;
  kind: EnumMembershipSourceContributionsKind;
  lastEventId?: Maybe<Scalars['MongoID']['output']>;
  refs?: Maybe<MembershipSourceContributionsRefs>;
  statusTagIds?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tierTagId?: Maybe<Scalars['MongoID']['output']>;
  validFrom?: Maybe<Scalars['Date']['output']>;
  validUntil?: Maybe<Scalars['Date']['output']>;
};

export type MembershipSourceContributionsRefs = {
  __typename?: 'MembershipSourceContributionsRefs';
  broadcastResourceId?: Maybe<Scalars['String']['output']>;
  operatorId?: Maybe<Scalars['MongoID']['output']>;
  operatorIds?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  orderId?: Maybe<Scalars['String']['output']>;
  renewablePurchaseId?: Maybe<Scalars['MongoID']['output']>;
  surveyResponseId?: Maybe<Scalars['MongoID']['output']>;
};

export type MembershipStateCount = {
  __typename?: 'MembershipStateCount';
  count: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  tagId: Scalars['ID']['output'];
};

export type MembershipStats = {
  __typename?: 'MembershipStats';
  byStatus?: Maybe<Array<MembershipTagCount>>;
  byTier?: Maybe<Array<MembershipTagCount>>;
  total: Scalars['Int']['output'];
};

export type MembershipStatusAppliedAt = {
  __typename?: 'MembershipStatusAppliedAt';
  at: Scalars['Date']['output'];
  tagId: Scalars['MongoID']['output'];
};

export type MembershipSubject = {
  __typename?: 'MembershipSubject';
  entityId: Scalars['MongoID']['output'];
  type: EnumMembershipSubjectType;
};

export type MembershipSuggestedRenewalDate = {
  __typename?: 'MembershipSuggestedRenewalDate';
  blockedByInvoice?: Maybe<MembershipOpenRenewalInvoice>;
  currentPaidThroughDate?: Maybe<Scalars['Date']['output']>;
  isFreshGrant: Scalars['Boolean']['output'];
  periodEnd?: Maybe<Scalars['Date']['output']>;
  periodStart?: Maybe<Scalars['Date']['output']>;
  suggestedDate?: Maybe<Scalars['Date']['output']>;
};

export type MembershipTagCount = {
  __typename?: 'MembershipTagCount';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  tagId: Scalars['ID']['output'];
};

export type MembershipTimelineItem = {
  __typename?: 'MembershipTimelineItem';
  _id: Scalars['String']['output'];
  actorName?: Maybe<Scalars['String']['output']>;
  createdDateISO: Scalars['Date']['output'];
  kind: Scalars['String']['output'];
  tagName: Scalars['String']['output'];
  viaSuffix: Scalars['String']['output'];
};

export type MerchMetadata = {
  __typename?: 'MerchMetadata';
  dimensions?: Maybe<Array<Maybe<MerchMetadataDimensions>>>;
  lowStockThreshold?: Maybe<Scalars['Float']['output']>;
  variants?: Maybe<Array<Maybe<MerchMetadataVariants>>>;
};

export type MerchMetadataDimensions = {
  __typename?: 'MerchMetadataDimensions';
  _id?: Maybe<Scalars['MongoID']['output']>;
  drivesImages?: Maybe<Scalars['Boolean']['output']>;
  name: Multilingual;
  values?: Maybe<Array<Maybe<MerchMetadataDimensionsValues>>>;
};

export type MerchMetadataDimensionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  drivesImages?: InputMaybe<Scalars['Boolean']['input']>;
  name: MultilingualInput;
  values?: InputMaybe<Array<InputMaybe<MerchMetadataDimensionsValuesInput>>>;
};

export type MerchMetadataDimensionsValues = {
  __typename?: 'MerchMetadataDimensionsValues';
  _id?: Maybe<Scalars['MongoID']['output']>;
  imageIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  label: Multilingual;
};

export type MerchMetadataDimensionsValuesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label: MultilingualInput;
};

export type MerchMetadataInput = {
  dimensions?: InputMaybe<Array<InputMaybe<MerchMetadataDimensionsInput>>>;
  lowStockThreshold?: InputMaybe<Scalars['Float']['input']>;
  variants?: InputMaybe<Array<InputMaybe<MerchMetadataVariantsInput>>>;
};

export type MerchMetadataVariants = {
  __typename?: 'MerchMetadataVariants';
  _id?: Maybe<Scalars['MongoID']['output']>;
  dimensionValueIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  inventoryCount: Scalars['Float']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  sku?: Maybe<Scalars['String']['output']>;
};

export type MerchMetadataVariantsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  dimensionValueIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inventoryCount: Scalars['Float']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
};

export enum MergeOption {
  NoUpdate = 'NO_UPDATE',
  OverwriteAll = 'OVERWRITE_ALL',
  OverwriteEmpty = 'OVERWRITE_EMPTY'
}

export type MongoError = ErrorInterface & {
  __typename?: 'MongoError';
  /** MongoDB error code */
  code?: Maybe<Scalars['Int']['output']>;
  /** MongoDB error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type Multilingual = {
  __typename?: 'Multilingual';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type MultilingualInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create one document with mongoose defaults, setters, hooks and validation */
  activityLogCreateOne?: Maybe<CreateOneActivityLogPayload>;
  adminFeatureGateReset?: Maybe<ToggleGateResult>;
  adminFeatureGateToggle?: Maybe<ToggleGateResult>;
  adminUserDemote?: Maybe<AdminUserPromoteResult>;
  adminUserPromote?: Maybe<AdminUserPromoteResult>;
  adminUserSetPermissions?: Maybe<AdminUserInfo>;
  aiTaskCancel?: Maybe<AiTaskCancelPayload>;
  aiTaskFeedback?: Maybe<AiTaskFeedbackPayload>;
  aiTaskMarkApplied?: Maybe<AiTaskMarkAppliedPayload>;
  aiTaskPing?: Maybe<AiTaskPingPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  analyticsDashboardCreateOne?: Maybe<CreateOneAnalyticsDashboardPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  analyticsDashboardRemoveById?: Maybe<RemoveByIdAnalyticsDashboardPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  analyticsDashboardUpdateById?: Maybe<UpdateByIdAnalyticsDashboardPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  apiAccessCreate?: Maybe<CreateOneApiAccessPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  apiAccessCreateAdmin?: Maybe<CreateOneApiAccessPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  apiAccessDelete?: Maybe<RemoveByIdApiAccessPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  apiAccessUpdate?: Maybe<UpdateByIdApiAccessPayload>;
  bookerApplyFeeAbsorption?: Maybe<Booker>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  bookerCreate?: Maybe<CreateOneBookerPayload>;
  bookerDuplicateToStorefront?: Maybe<BookerDuplicateToStorefrontResult>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  bookerRemove?: Maybe<RemoveByIdBookerPayload>;
  bookerRevertFeeAbsorption?: Maybe<BookerFeeAbsorptionRevertResult>;
  bookerSendConfirmationTestEmail: Scalars['Boolean']['output'];
  bookerSetApplicationFee?: Maybe<Booker>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  bookerUpdate?: Maybe<UpdateByIdBookerPayload>;
  broadcastCloneById: Broadcast;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  broadcastCreateOne?: Maybe<CreateOneBroadcastPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  broadcastUpdateById?: Maybe<UpdateByIdBroadcastPayload>;
  bulkConnectLogRollback?: Maybe<BulkConnectLog>;
  courseProgressSave?: Maybe<CourseProgress>;
  createBulkConnectLog?: Maybe<BulkConnectLog>;
  createClosuresPerProduct: Array<Scalars['ID']['output']>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  createPublicationStatus?: Maybe<CreateOnePublicationStatusPayload>;
  cronJobRun?: Maybe<CronJobRunResult>;
  devToolsEmailReplace: Scalars['Boolean']['output'];
  devToolsMembershipSeedCleanup?: Maybe<DevMembershipSeedRun>;
  devToolsMembershipSeedCreate?: Maybe<DevMembershipSeedRun>;
  devToolsProdSync?: Maybe<ProdSyncResult>;
  directoryBulkInvite?: Maybe<DirectoryBulkInviteResult>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  discountCreate?: Maybe<CreateOneDiscountPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  discountUpdate?: Maybe<UpdateByIdDiscountPayload>;
  discountValidatePromocode?: Maybe<Discount>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  eventCreate?: Maybe<CreateOneEventPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  eventDeleteById?: Maybe<RemoveByIdEventPayload>;
  eventDisconnectOrganization?: Maybe<EventDisconnectOrganizationPayload>;
  eventInventorySettingsUpsert?: Maybe<EventInventorySettings>;
  eventLowStockThresholdUpdate?: Maybe<Product>;
  eventSessionStockUpdate?: Maybe<Product>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  eventUpdateById?: Maybe<UpdateByIdEventPayload>;
  featureFlagCreate?: Maybe<FeatureFlag>;
  featureFlagExpel?: Maybe<ExpelResult>;
  featureFlagGraduate?: Maybe<GraduateResult>;
  featureFlagGraduateGroup?: Maybe<GraduateGroupResult>;
  featureFlagReinstate?: Maybe<GraduateResult>;
  featureFlagUngraduate?: Maybe<GraduateResult>;
  featureFlagUpdate?: Maybe<FeatureFlag>;
  featureGateReset?: Maybe<ToggleGateResult>;
  featureGateToggle?: Maybe<ToggleGateResult>;
  fileCreateOne: AssetFile;
  fileDeleteFromCloudinaryOnly: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  fileUpdate?: Maybe<UpdateByIdAssetFilePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  fulfillmentProfileCreate?: Maybe<CreateOneFulfillmentProfilePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  fulfillmentProfileUpdate?: Maybe<UpdateByIdFulfillmentProfilePayload>;
  galleryNewMediaDismiss: GalleryNewMedia;
  galleryNewMediaPromote?: Maybe<Scalars['JSON']['output']>;
  imageAnalyze: AssetImage;
  imageCreateOne: AssetImage;
  imageDeleteFromCloudinaryOnly: Scalars['Boolean']['output'];
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  imageUpdate?: Maybe<UpdateByIdAssetImagePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  importCreate?: Maybe<CreateOneImportPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  importDelete?: Maybe<RemoveByIdImportPayload>;
  importManagerSettingsUpsert?: Maybe<ImportManagerSettings>;
  importPreview?: Maybe<ImportPreviewResult>;
  importRunCancel?: Maybe<ImportRunCancelResult>;
  importRunCreate?: Maybe<ImportRunResult>;
  importRunDelete?: Maybe<ImportRunDeleteResult>;
  importRunMoveOperatorsToConnected?: Maybe<ImportRunMoveOperatorsResult>;
  importRunRollback?: Maybe<ImportRunRollbackResult>;
  importRunStart?: Maybe<ImportRunResult>;
  importScrapeCleanData?: Maybe<ImportScrapeCleanDataPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  importScrapeCreate?: Maybe<CreateOneImportScrapePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  importScrapeDelete?: Maybe<RemoveByIdImportScrapePayload>;
  importScrapeDeleteWithRuns?: Maybe<ImportScrapeDeleteWithRunsPayload>;
  importScrapeFetchSitemap?: Maybe<ImportScrapeFetchSitemapPayload>;
  importScrapeFetchSpreadsheet?: Maybe<ImportScrapeFetchSpreadsheetPayload>;
  importScrapeFetchWebsite?: Maybe<ImportScrapeFetchWebsitePayload>;
  importScrapeGenerateColumnMapping?: Maybe<ImportScrapeGenerateColumnMappingPayload>;
  importScrapeGeneratePrompt?: Maybe<ImportScrapeGeneratePromptPayload>;
  importScrapeGenerateSheet?: Maybe<ImportScrapeGenerateSheetPayload>;
  importScrapeRun?: Maybe<ImportScrapeRunPayload>;
  importScrapeRunCleanup?: Maybe<ImportScrapeRunCleanupPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  importScrapeRunDelete?: Maybe<RemoveByIdImportScrapeRunPayload>;
  importScrapeRunEnrich?: Maybe<ImportScrapeRunEnrichPayload>;
  importScrapeRunResolveOperators?: Maybe<ImportScrapeRunResolveOperatorsPayload>;
  importScrapeRunRetryExtraction?: Maybe<ImportScrapeRunRetryExtractionPayload>;
  importScrapeRunRetryWrite?: Maybe<ImportScrapeRunRetryWritePayload>;
  importScrapeRunSitemap?: Maybe<ImportScrapeRunSitemapPayload>;
  importScrapeRunSpreadsheet?: Maybe<ImportScrapeRunSpreadsheetPayload>;
  importScrapeRunUpdateFeedback?: Maybe<ImportScrapeRun>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  importScrapeUpdate?: Maybe<UpdateByIdImportScrapePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  importUpdate?: Maybe<UpdateByIdImportPayload>;
  integrateProductCalendarLinksByProductIds: IntegrateCalendarLinksByProductIds;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  inventoryCreate?: Maybe<CreateOneInventoryItemPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  inventoryRemove?: Maybe<RemoveByIdInventoryItemPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  inventoryUpdate?: Maybe<UpdateByIdInventoryItemPayload>;
  inventoryUpdateClaimedDatesByOrder?: Maybe<Order>;
  inviteQueueAcceptFreshen?: Maybe<InviteQueueAcceptFreshenResult>;
  inviteQueueCancelById: InviteQueue;
  inviteQueueCleanup?: Maybe<InviteQueueCleanupResult>;
  inviteQueueCreateOne: InviteQueue;
  inviteQueueFreshen?: Maybe<InviteQueueFreshenResult>;
  inviteQueueReinviteByEmail?: Maybe<InviteQueueReinviteByEmailResult>;
  inviteQueueSendInvites?: Maybe<InviteQueueSendInvitesResult>;
  itineraryAddBlock?: Maybe<Itinerary>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  itineraryCreateOne?: Maybe<CreateOneItineraryPayload>;
  itineraryDelete: Scalars['Boolean']['output'];
  itineraryDiscardDraft: Itinerary;
  itineraryDuplicate: Itinerary;
  itineraryPublish: ItineraryPublishResult;
  itineraryRemoveBlock?: Maybe<Itinerary>;
  itineraryToggleFavorite?: Maybe<Itinerary>;
  itineraryUnarchive: Itinerary;
  itineraryUnpublish: Itinerary;
  itineraryUpdateBlock?: Maybe<Itinerary>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  itineraryUpdateById?: Maybe<UpdateByIdItineraryPayload>;
  itineraryUpdateSegments?: Maybe<Itinerary>;
  itineraryWidgetCreate: ItineraryWidget;
  itineraryWidgetDeleteById?: Maybe<ItineraryWidget>;
  itineraryWidgetUpdateById: ItineraryWidget;
  itineraryWidgetUpsert?: Maybe<ItineraryWidget>;
  leadCreateOne: Lead;
  leadRemoveById: Lead;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  leadUpdateById?: Maybe<UpdateByIdLeadPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  listCreate?: Maybe<CreateOneListPayload>;
  listCreateListsForAudiences?: Maybe<Array<List>>;
  listCreateMembersForTiers?: Maybe<Array<List>>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  listDeleteById?: Maybe<RemoveByIdListPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  listUpdateById: ListWithEntities;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  maintenanceUpdate?: Maybe<UpdateByIdMaintenancePayload>;
  membershipAdminCancel: Scalars['Boolean']['output'];
  membershipBulkSetStatusForList?: Maybe<MembershipBulkSetStatusResult>;
  membershipCancelPendingRenewalEmails: Scalars['Int']['output'];
  membershipChecklistFix: MembershipChecklistFixResult;
  membershipChecklistRun: MembershipChecklistResult;
  membershipDeclineStatusEmails: MembershipDeclineStatusEmailsResult;
  membershipLaunch: Organization;
  membershipLaunchSetMode: Organization;
  membershipMarkRenewed: Scalars['Date']['output'];
  membershipMarkRenewedForOwner?: Maybe<Array<MembershipMarkRenewedForOwnerResult>>;
  membershipQueueCustomEmails: MembershipQueueCustomEmailsResult;
  membershipQueueStatusEmails: MembershipQueueStatusEmailsResult;
  membershipRepairScheduleSnapshots: MembershipScheduleRepair;
  membershipScheduleRenewalEmailForListings?: Maybe<Array<Maybe<PendingRenewalEmail>>>;
  membershipSendPendingRenewalEmailsNow?: Maybe<MembershipSendPendingRenewalEmailsNowResult>;
  membershipSetManualRenewalDate: Scalars['Boolean']['output'];
  merchLowStockThresholdUpdate?: Maybe<Product>;
  merchVariantStockUpdate?: Maybe<Product>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  noteCreateOne?: Maybe<CreateOneNotePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  noteRemoveById?: Maybe<RemoveByIdNotePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  noteUpdateById?: Maybe<UpdateByIdNotePayload>;
  operatorAddExistingToOrganization: Operator;
  operatorAiImageScanCreate?: Maybe<AiImageScanCreatePayload>;
  operatorAiImageScanExecute?: Maybe<AiImageScanExecutePayload>;
  operatorAiImageScanUpload?: Maybe<AiImageScanUploadPayload>;
  operatorAiImageVerifyUrls?: Maybe<AiImageVerifyUrlsPayload>;
  operatorAiProfileScanCreate?: Maybe<AiProfileScanCreatePayload>;
  operatorAiProfileScanExecute?: Maybe<AiProfileScanExecutePayload>;
  operatorBulkAcceptDrafts: Scalars['Int']['output'];
  operatorBulkApplyAudienceTags: Scalars['Boolean']['output'];
  operatorBulkApplyBackOfficeTags: Scalars['Boolean']['output'];
  /** Create one document with mongoose defaults, setters, hooks and validation */
  operatorCreate?: Maybe<CreateOneOperatorPayload>;
  operatorDelete: OperatorWithStatus;
  operatorDeleteCompletelyByInternal: Scalars['Boolean']['output'];
  operatorMarkDeletedByInternal: OperatorWithStatus;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  operatorUpdate: OperatorWithStatus;
  operatorUpdateContactRoles: Array<UserWithPictureTc>;
  operatorUpdateImages: OperatorWithStatus;
  operatorWhereabotDismiss?: Maybe<OperatorWhereabotDismissPayload>;
  orderApprove?: Maybe<Order>;
  orderConvertHoldToCharge?: Maybe<Order>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  orderCreate?: Maybe<CreateOneOrderPayload>;
  orderDecline?: Maybe<Order>;
  orderFulfill?: Maybe<Order>;
  orderMarkAsPaid?: Maybe<Order>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  orderRemove?: Maybe<RemoveByIdOrderPayload>;
  orderSetArrival?: Maybe<Order>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  orderUpdate?: Maybe<UpdateByIdOrderPayload>;
  orgOperatorOverlayDelete?: Maybe<OrgOperatorOverlay>;
  orgOperatorOverlayUpsert?: Maybe<OrgOperatorOverlay>;
  orgOverviewRebuild: OrgOverviewRebuildResult;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  organizationCreate?: Maybe<CreateOneOrganizationPayload>;
  organizationDelete?: Maybe<OrganizationDeletePayload>;
  organizationDisconnectAssets: OrganizationManifest;
  organizationEmailDomainProvision?: Maybe<OrganizationEmailDomain>;
  organizationEmailDomainRemove: Scalars['Boolean']['output'];
  organizationEmailDomainRequest?: Maybe<OrganizationEmailDomain>;
  organizationEmailDomainRunChecks?: Maybe<OrganizationEmailDomainRunChecksResult>;
  organizationEmailDomainSetDisabled?: Maybe<OrganizationEmailDomain>;
  organizationEmailDomainSetTestOverride?: Maybe<OrganizationEmailDomain>;
  organizationEmailDomainUpdateNote?: Maybe<OrganizationEmailDomain>;
  organizationEventPartnerAdd: OrganizationEventPartnerSettings;
  organizationEventPartnerRemove: OrganizationEventPartnerSettings;
  organizationEventSharingCodeRegenerate: OrganizationEventPartnerSettings;
  organizationManifestGenerate: OrganizationManifest;
  organizationRenewalScheduleApply: RenewalRebasePlan;
  organizationSeedDefaultAudiences: Organization;
  organizationSeedDefaultMembershipStatusTags: Organization;
  organizationSendRenewalTestEmail: Scalars['Boolean']['output'];
  organizationSendTestEmails?: Maybe<OrgSendTestEmailsResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  organizationUpdate?: Maybe<UpdateByIdOrganizationPayload>;
  organizationUpdateImages: Organization;
  organizationUpdateIndividualMembershipTiers: Organization;
  organizationUpdateListingAudiences: Organization;
  organizationUpdateMembershipBroadcast: Organization;
  organizationUpdateMembershipHub: Organization;
  organizationUpdateMembershipPaymentsEnabled: Organization;
  organizationUpdateMembershipStatusTags: Organization;
  organizationUpdateMembershipTierCheckout: Organization;
  organizationUpdateMembershipTiers: Organization;
  organizationUpdateNomenclature: Organization;
  organizationUpdateRenewalSettings: Organization;
  organizationUpsertTierReminderEmail: Organization;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  paymentMethodSetCreate?: Maybe<CreateOnePaymentMethodSetPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  paymentMethodSetUpdate?: Maybe<UpdateByIdPaymentMethodSetPayload>;
  paymentRequestAddInternalNote?: Maybe<PaymentRequest>;
  paymentRequestBulkSend?: Maybe<PaymentRequestBulkSendResult>;
  paymentRequestCancel?: Maybe<PaymentRequest>;
  paymentRequestCheckoutInitiate?: Maybe<PaymentRequestCheckoutInitiateResult>;
  paymentRequestCreate?: Maybe<PaymentRequest>;
  paymentRequestDelete?: Maybe<PaymentRequest>;
  paymentRequestMarkPaid?: Maybe<PaymentRequest>;
  paymentRequestMarkPending?: Maybe<PaymentRequest>;
  paymentRequestRecordPayment?: Maybe<PaymentRequest>;
  paymentRequestResend?: Maybe<PaymentRequest>;
  paymentRequestReversePayment?: Maybe<PaymentRequest>;
  paymentRequestSend?: Maybe<PaymentRequest>;
  paymentRequestSetNeedsAttention?: Maybe<PaymentRequest>;
  /** Takes an order off an unsent statement; it rolls into the next statement run. */
  paymentRequestStatementRemoveOrder?: Maybe<PaymentRequest>;
  paymentRequestSubmitForReview?: Maybe<PaymentRequest>;
  paymentRequestUndoPending?: Maybe<PaymentRequest>;
  paymentRequestUpdate?: Maybe<PaymentRequest>;
  paymentRequestUpdateAccountingMetadata?: Maybe<PaymentRequest>;
  personConnectToListing: DetailedPersonTc;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  personCreate?: Maybe<SimplePersonManyTc>;
  personDelete?: Maybe<Scalars['String']['output']>;
  personDeleteCompletelyByInternal: Scalars['String']['output'];
  personUpdateAddToVisibleTo: SimplePersonManyTc;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  personUpdateCommon: DetailedPersonTc;
  personUpdateVisibleTo: DetailedPersonTc;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  placeCreate?: Maybe<CreateOnePlacePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  placeDelete?: Maybe<RemoveByIdPlacePayload>;
  placeMoveNode: Place;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  placeUpdate?: Maybe<UpdateByIdPlacePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  policyCreate?: Maybe<CreateOnePolicyPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  policyUpdate?: Maybe<UpdateByIdPolicyPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  productCreate?: Maybe<CreateOneProductPayload>;
  productDuplicate?: Maybe<ProductDuplicateResult>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  productRemove?: Maybe<RemoveByIdProductPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  productUpdate?: Maybe<UpdateByIdProductPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  promotionCreate?: Maybe<CreateOnePromotionPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  promotionDeleteById?: Maybe<RemoveByIdPromotionPayload>;
  promotionDisconnectOrganization?: Maybe<PromotionDisconnectOrganizationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  promotionUpdateById?: Maybe<UpdateByIdPromotionPayload>;
  publicMediaCreateFromOrgUpload: PublicMedia;
  publicMediaIgnoreAttention: PublicMedia;
  publicMediaLikeToggle?: Maybe<PublicMedia>;
  publicMediaPromoteFromListing: PublicMedia;
  publicMediaPromoteManyFromListing?: Maybe<Array<PublicMedia>>;
  publicMediaUnpublish: PublicMedia;
  publicMediaUpdateById: PublicMedia;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  refundCreate?: Maybe<CreateManyRefundPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  refundUpdate?: Maybe<UpdateByIdRefundPayload>;
  renewableFeeConfirm?: Maybe<RenewableFeeConfirmResult>;
  renewableFeeInitiate?: Maybe<RenewableFeeInitiateResult>;
  renewablePurchaseCancel?: Maybe<RenewablePurchase>;
  renewablePurchaseChangeTier?: Maybe<RenewablePurchase>;
  renewablePurchaseConsolidate?: Maybe<RenewablePurchase>;
  renewablePurchaseSetRecurringLineItems?: Maybe<RenewablePurchase>;
  renewablePurchaseSetRenewalBilling?: Maybe<RenewablePurchase>;
  renewablePurchaseUpdateListings?: Maybe<RenewablePurchase>;
  renewalEngineDisable: Scalars['Boolean']['output'];
  renewalEngineEnable: RenewalEngineSetupResult;
  renewalRecordApprove?: Maybe<RenewalRecord>;
  renewalRecordCancel?: Maybe<RenewalRecord>;
  renewalRecordPay?: Maybe<RenewalRecordPayResult>;
  renewalRecordRetry?: Maybe<RenewalRecord>;
  reportRebuild: ReportRebuildResult;
  resendBankTransferInstructions?: Maybe<ResendBankTransferInstructionsResult>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  ruleCreate?: Maybe<CreateOneRulePayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  ruleCreateMany?: Maybe<CreateManyRulePayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  ruleDelete?: Maybe<RemoveByIdRulePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  ruleUpdate?: Maybe<UpdateByIdRulePayload>;
  savedReportCreate: SavedReport;
  savedReportDelete: Scalars['Boolean']['output'];
  savedReportUpdate: SavedReport;
  scheduledPaymentRetryFailed: ScheduledPayment;
  siteBuilderMarkReadyForClient: SiteBuilderSite;
  siteBuilderMessageFeedback: SiteBuilderMessageFeedbackResult;
  siteBuilderPublish: SiteBuilderSite;
  siteBuilderQuestionAnswer: SiteBuilderQuestion;
  siteBuilderQuestionDismiss: SiteBuilderQuestion;
  siteBuilderQuestionMarkUnnecessary: Scalars['Boolean']['output'];
  siteBuilderRollback: SiteBuilderPage;
  siteBuilderRunQa: Scalars['JSON']['output'];
  siteBuilderSenderAdd: SiteBuilderEmailChannel;
  siteBuilderSenderRemove: SiteBuilderEmailChannel;
  siteBuilderSenderVerify: SiteBuilderEmailChannel;
  siteBuilderSettingsUpdate: SiteBuilderSettingsResult;
  siteBuilderSiteAddAssets: SiteBuilderSite;
  siteBuilderSiteCreate: SiteBuilderSite;
  siteBuilderSiteDelete: Scalars['Boolean']['output'];
  siteBuilderSiteRemoveAsset: SiteBuilderSite;
  siteBuilderSiteSetBilling: SiteBuilderSite;
  siteBuilderSiteSetReferences: SiteBuilderSite;
  siteBuilderSiteUpdate: SiteBuilderSite;
  siteBuilderSkillFeedbackAdd: SiteBuilderSkillFeedback;
  siteBuilderSkillFeedbackResolve: Scalars['Boolean']['output'];
  siteBuilderUnpublish: SiteBuilderSite;
  storefrontConnectNewStripeAccount?: Maybe<StorefrontConnectNewStripeReturn>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  storefrontCreate?: Maybe<CreateOneStorefrontPayload>;
  storefrontDisconnectStripeAccount?: Maybe<StorefrontDisconnectStripeAccountReturn>;
  storefrontEnsureTestStorefront?: Maybe<StorefrontEnsureTestStorefrontPayload>;
  storefrontFastForwardRenewals?: Maybe<FastForwardRenewalsResult>;
  storefrontFeatureGateReset?: Maybe<ToggleGateResult>;
  storefrontFeatureGateToggle?: Maybe<ToggleGateResult>;
  storefrontForceRenewals?: Maybe<ForceRenewalsResult>;
  /** Creates one For Review statement per member for unbilled after-service orders. Null when there was nothing to bill. */
  storefrontGenerateStatements?: Maybe<StatementGenerationRun>;
  storefrontGenerateUpcomingRenewalInvoices?: Maybe<GenerateUpcomingRenewalInvoicesResult>;
  storefrontInvoiceTemplateEnsure?: Maybe<Booker>;
  storefrontLaunch?: Maybe<StorefrontLaunchPayload>;
  storefrontPageCreate: StorefrontPageResult;
  storefrontPageDelete?: Maybe<StorefrontPageResult>;
  storefrontPageEdit: StorefrontPageResult;
  storefrontPageGenerate: StorefrontPageResult;
  storefrontPageUpdateStatus: StorefrontPageResult;
  storefrontPlatformSettingsUpdate: StorefrontPlatformSettings;
  storefrontPurgeTestData?: Maybe<PurgeTestDataResult>;
  /** Undo a 'generate upcoming invoices' run: deletes the run's invoices that are still unsent and restores each purchase's prior renewal state. Sent/paid invoices are skipped and reported. */
  storefrontRollbackRenewalInvoiceGeneration?: Maybe<RollbackRenewalInvoiceGenerationResult>;
  /** Deletes a run's statements that are still unsent and returns their orders to the next run. Sent statements are skipped. */
  storefrontRollbackStatementGeneration?: Maybe<StatementGenerationRun>;
  storefrontSendTestEmails?: Maybe<StorefrontSendTestEmailsResult>;
  storefrontSetApplicationFee?: Maybe<StorefrontSetApplicationFeeResult>;
  storefrontSetApplicationFeeDefaults?: Maybe<Storefront>;
  storefrontSetInvoicingEnabled?: Maybe<Storefront>;
  storefrontSetRegion: Storefront;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  storefrontUpdate?: Maybe<UpdateByIdStorefrontPayload>;
  stripePayoutsSync: StripeSyncResult;
  supportCaseCreateLinearIssue?: Maybe<SupportTicket>;
  supportCaseDelete: Scalars['Boolean']['output'];
  supportCaseInvestigate?: Maybe<SupportTicket>;
  supportCaseInvestigationCancel?: Maybe<SupportTicket>;
  supportCaseInvestigationRaiseBudget?: Maybe<SupportTicket>;
  supportCaseSetStatus?: Maybe<SupportTicket>;
  supportCaseSetType?: Maybe<SupportTicket>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  surveyCreate?: Maybe<CreateOneSurveyPayload>;
  surveyDelete?: Maybe<SurveyDeleteResult>;
  surveyDuplicate?: Maybe<SurveyDuplicateResult>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  surveyQuestionCreate?: Maybe<CreateOneSurveyQuestionPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  surveyQuestionCreateMany?: Maybe<CreateManySurveyQuestionPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  surveyQuestionUpdate?: Maybe<UpdateByIdSurveyQuestionPayload>;
  surveyResponseAdminEdit: SurveyResponse;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  surveyResponseCreate?: Maybe<CreateOneSurveyResponsePayload>;
  surveyResponseDeleteById?: Maybe<SurveyResponse>;
  surveyResponseReviewSubmission: SurveyResponse;
  surveyResponseSaveForBroadcast: SurveyResponse;
  surveyResponseSubmitForBroadcast: SurveyResponse;
  surveyResponseSubmitForInquiryWidget: SurveyResponse;
  surveyResponseUpdateAdminStatus: SurveyResponse;
  surveyResponseUpdateTags: SurveyResponse;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  surveyUpdate?: Maybe<UpdateByIdSurveyPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  tagCreate?: Maybe<CreateOneTagPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  tagCreateMany?: Maybe<CreateManyTagPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  tagDelete?: Maybe<RemoveByIdTagPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  tagGroupCreate?: Maybe<CreateOneTagGroupPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  tagGroupCreateMany?: Maybe<CreateManyTagGroupPayload>;
  tagMerge?: Maybe<Tag>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  tagRelationshipCreate?: Maybe<CreateOneTagRelationshipPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  tagRelationshipDelete?: Maybe<RemoveByIdTagRelationshipPayload>;
  tagRelationshipGenerateAI?: Maybe<TagRelationshipGenerateResult>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  tagRelationshipUpdate?: Maybe<UpdateByIdTagRelationshipPayload>;
  tagSplit: Array<Tag>;
  tagSuggestionApprove?: Maybe<Tag>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  tagSuggestionCreate?: Maybe<CreateOneTagSuggestionPayload>;
  tagSuggestionReject?: Maybe<Scalars['Boolean']['output']>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  tagSuggestionUpdateById?: Maybe<UpdateByIdTagSuggestionPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  tagUpdate?: Maybe<UpdateByIdTagPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  taxCreate?: Maybe<CreateOneTaxPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  taxRemove?: Maybe<RemoveByIdTaxPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  taxUpdate?: Maybe<UpdateByIdTaxPayload>;
  testRecordCreate?: Maybe<TestRecord>;
  testRecordDelete: Scalars['Boolean']['output'];
  testRecordDeleteAll: Scalars['Int']['output'];
  testRecordReset?: Maybe<TestRecord>;
  testRecordRunRenewalCheck?: Maybe<TestRecordRenewalCheck>;
  testRecordSendClaimInvite?: Maybe<TestRecord>;
  testRecordSendRenewalEmail?: Maybe<TestRenewalEmailResult>;
  testRecordSetShowInWidgets: Scalars['Boolean']['output'];
  testRecordSetSimulatedDate?: Maybe<TestRecord>;
  updateClosuresPerProduct: Array<Scalars['ID']['output']>;
  userApproveAccess?: Maybe<UserWithPictureTc>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  userCreate?: Maybe<UserWithResetPasswordUrlTc>;
  userCreateConfirmationCode: User;
  userCreateInvite?: Maybe<User>;
  userJoinOrganizationFromColdSignup: Scalars['Boolean']['output'];
  userRequestAccess?: Maybe<UserWithPictureTc>;
  userResendConfirmationCode: User;
  userRevokeInvite?: Maybe<User>;
  userSaveQuickLinks?: Maybe<UserWithResetPasswordUrlTc>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  userUpdate?: Maybe<UserWithResetPasswordUrlTc>;
  userValidateConfirmationCode: User;
  videoCreateFromMux: AssetImage;
  videoDeleteFromMuxOnly: Scalars['Boolean']['output'];
  videoMuxStatusRefresh: AssetImage;
  whereabotChatCreate?: Maybe<WhereabotChat>;
  whereabotChatDelete: Scalars['Boolean']['output'];
  whereabotChatSendMessage?: Maybe<WhereabotMessage>;
  whereabotChatUpdate?: Maybe<WhereabotChat>;
  whereabotHelpAsk: WhereabotHelpAnswer;
  whereabotSettingsUpdate?: Maybe<WhereabotSettings>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  widgetCreate?: Maybe<CreateOneWidgetPayload>;
  /** Remove one document: 1) Retrieve one document and remove with hooks via findByIdAndRemove. 2) Return removed document. */
  widgetDeleteById?: Maybe<RemoveByIdWidgetPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  widgetUpdateById?: Maybe<UpdateByIdWidgetPayload>;
  workbenchChangeRequestSummary: WorkbenchChangeRequestResult;
  workbenchChangeRequestsMarkIntegrated: Scalars['Int']['output'];
  workbenchChatCreate: WhereabotChat;
  workbenchChatSendMessage: WhereabotMessage;
  workbenchExpel: WorkbenchLifecycleResult;
  workbenchPlanPush: WorkbenchPushResult;
  workbenchReinstate: WorkbenchLifecycleResult;
  workbenchReviewComplete: WhereabotChat;
  workbenchSeedCleanup: WorkbenchSeedRun;
  workbenchSeedCreate: WorkbenchSeedRun;
  workbenchSeedPreview: WorkbenchSeedPreviewResult;
  workbenchSeedRegenerate: WorkbenchSeedRun;
  workbenchSetHelpScoutUrl: WorkbenchFeature;
  workbenchSetTestOrganization: WorkbenchFeature;
  workbenchSettingsUpdate: Scalars['Boolean']['output'];
  workbenchSuggestionAccept: WorkbenchSuggestion;
  workbenchSuggestionDismiss: WorkbenchSuggestion;
  workbenchSuggestionUpdateStatus: WorkbenchSuggestion;
  workbenchTesterAdd: WorkbenchFeature;
  workbenchTesterRemove: WorkbenchFeature;
  workbenchTestersContact: WorkbenchContactResult;
};


export type MutationActivityLogCreateOneArgs = {
  record: CreateOneActivityLogInput;
};


export type MutationAdminFeatureGateResetArgs = {
  featureFlagId: Scalars['MongoID']['input'];
  userId: Scalars['MongoID']['input'];
};


export type MutationAdminFeatureGateToggleArgs = {
  enabled: Scalars['Boolean']['input'];
  featureFlagId: Scalars['MongoID']['input'];
  userId: Scalars['MongoID']['input'];
};


export type MutationAdminUserDemoteArgs = {
  userId: Scalars['MongoID']['input'];
};


export type MutationAdminUserPromoteArgs = {
  userId: Scalars['MongoID']['input'];
};


export type MutationAdminUserSetPermissionsArgs = {
  permissions: Array<Scalars['String']['input']>;
  userId: Scalars['MongoID']['input'];
};


export type MutationAiTaskCancelArgs = {
  taskId: Scalars['MongoID']['input'];
};


export type MutationAiTaskFeedbackArgs = {
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  rating: AiTaskRating;
  taskId: Scalars['MongoID']['input'];
};


export type MutationAiTaskMarkAppliedArgs = {
  taskId: Scalars['MongoID']['input'];
};


export type MutationAiTaskPingArgs = {
  taskId: Scalars['MongoID']['input'];
};


export type MutationAnalyticsDashboardCreateOneArgs = {
  record: CreateOneAnalyticsDashboardInput;
};


export type MutationAnalyticsDashboardRemoveByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationAnalyticsDashboardUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdAnalyticsDashboardInput;
};


export type MutationApiAccessCreateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationApiAccessCreateAdminArgs = {
  adminUserId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApiAccessDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationApiAccessUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdApiAccessInput;
};


export type MutationBookerApplyFeeAbsorptionArgs = {
  bookerId: Scalars['MongoID']['input'];
  overrides?: InputMaybe<Array<BookerFeeAbsorptionPriceOverrideInput>>;
  productIds: Array<Scalars['String']['input']>;
  roundingIncrementCents: Scalars['Int']['input'];
  stripeFixedCents: Scalars['Int']['input'];
  stripePercent: Scalars['Float']['input'];
};


export type MutationBookerCreateArgs = {
  record: CreateOneBookerInput;
};


export type MutationBookerDuplicateToStorefrontArgs = {
  bookerId: Scalars['MongoID']['input'];
  targetStorefrontId: Scalars['MongoID']['input'];
};


export type MutationBookerRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationBookerRevertFeeAbsorptionArgs = {
  bookerId: Scalars['MongoID']['input'];
};


export type MutationBookerSendConfirmationTestEmailArgs = {
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bookerId: Scalars['MongoID']['input'];
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  recipientUserId: Scalars['ID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBookerSetApplicationFeeArgs = {
  applicationPercentage: Scalars['Float']['input'];
  bookerId: Scalars['String']['input'];
  customerApplicationPercentage: Scalars['Float']['input'];
};


export type MutationBookerUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdBookerInput;
};


export type MutationBroadcastCloneByIdArgs = {
  input: BroadcastCloneInput;
};


export type MutationBroadcastCreateOneArgs = {
  record: CreateOneBroadcastInput;
};


export type MutationBroadcastUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdBroadcastInput;
};


export type MutationBulkConnectLogRollbackArgs = {
  bulkConnectLogId: Scalars['ID']['input'];
};


export type MutationCourseProgressSaveArgs = {
  broadcastId: Scalars['MongoID']['input'];
  resourceId: Scalars['MongoID']['input'];
  scormData: Scalars['JSON']['input'];
  scormVersion?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBulkConnectLogArgs = {
  input: CreateBulkConnectLogInput;
};


export type MutationCreateClosuresPerProductArgs = {
  endISO: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productIds: Array<Scalars['ID']['input']>;
  startISO: Scalars['String']['input'];
};


export type MutationCreatePublicationStatusArgs = {
  record: CreateOnePublicationStatusInput;
};


export type MutationCronJobRunArgs = {
  jobName: Scalars['String']['input'];
};


export type MutationDevToolsEmailReplaceArgs = {
  entries?: InputMaybe<Array<InputMaybe<DevToolsEmailReplaceEntryInput>>>;
};


export type MutationDevToolsMembershipSeedCleanupArgs = {
  runId: Scalars['MongoID']['input'];
};


export type MutationDevToolsMembershipSeedCreateArgs = {
  input: DevMembershipSeedInput;
};


export type MutationDevToolsProdSyncArgs = {
  collectionsToSkip?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationDirectoryBulkInviteArgs = {
  includeDmoManaged?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  recipientMode?: InputMaybe<BulkInviteRecipientMode>;
  tagFilters?: InputMaybe<Array<InputMaybe<BulkInviteTagFilterInput>>>;
  viewContext?: InputMaybe<BulkInviteViewContext>;
};


export type MutationDiscountCreateArgs = {
  record: CreateOneDiscountInput;
};


export type MutationDiscountUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdDiscountInput;
};


export type MutationDiscountValidatePromocodeArgs = {
  bookerId?: InputMaybe<Scalars['ID']['input']>;
  productPurchaseRequests?: InputMaybe<Array<InputMaybe<ProductPurchaseRequest>>>;
  promoCode: Scalars['String']['input'];
  storefrontId: Scalars['ID']['input'];
};


export type MutationEventCreateArgs = {
  record: CreateOneEventInput;
};


export type MutationEventDeleteByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationEventDisconnectOrganizationArgs = {
  eventId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
};


export type MutationEventInventorySettingsUpsertArgs = {
  defaultCapacityPerSession?: InputMaybe<Scalars['Int']['input']>;
  eventId: Scalars['ID']['input'];
  lowStockThreshold?: InputMaybe<Scalars['Int']['input']>;
  sessionOverrides?: InputMaybe<Array<InputMaybe<EventSessionCapacityOverrideInput>>>;
};


export type MutationEventLowStockThresholdUpdateArgs = {
  lowStockThreshold?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['ID']['input'];
};


export type MutationEventSessionStockUpdateArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  remaining: Scalars['Int']['input'];
  sessionId: Scalars['String']['input'];
};


export type MutationEventUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  clearAttentionIssues?: InputMaybe<Scalars['Boolean']['input']>;
  imagesToKeep?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSubmitting?: InputMaybe<Scalars['Boolean']['input']>;
  record: UpdateByIdEventInput;
  setOrganizationTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  setStatus?: InputMaybe<EnumEventAccessOperatorStatus>;
};


export type MutationFeatureFlagCreateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  group: Scalars['String']['input'];
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFeatureFlagExpelArgs = {
  featureFlagId: Scalars['MongoID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationFeatureFlagGraduateArgs = {
  featureFlagId: Scalars['MongoID']['input'];
};


export type MutationFeatureFlagGraduateGroupArgs = {
  group: Scalars['String']['input'];
};


export type MutationFeatureFlagReinstateArgs = {
  featureFlagId: Scalars['MongoID']['input'];
};


export type MutationFeatureFlagUngraduateArgs = {
  featureFlagId: Scalars['MongoID']['input'];
};


export type MutationFeatureFlagUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFeatureGateResetArgs = {
  featureFlagId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
};


export type MutationFeatureGateToggleArgs = {
  enabled: Scalars['Boolean']['input'];
  featureFlagId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
};


export type MutationFileCreateOneArgs = {
  data: Scalars['JSON']['input'];
  defaultCaption?: InputMaybe<MultilingualInput>;
};


export type MutationFileDeleteFromCloudinaryOnlyArgs = {
  cloudinaryPublicId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
};


export type MutationFileUpdateArgs = {
  _id: Scalars['String']['input'];
  record: UpdateByIdAssetFileInput;
};


export type MutationFulfillmentProfileCreateArgs = {
  record: CreateOneFulfillmentProfileInput;
};


export type MutationFulfillmentProfileUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdFulfillmentProfileInput;
};


export type MutationGalleryNewMediaDismissArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationGalleryNewMediaPromoteArgs = {
  _id: Scalars['MongoID']['input'];
  widgetIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};


export type MutationImageAnalyzeArgs = {
  assetId: Scalars['String']['input'];
};


export type MutationImageCreateOneArgs = {
  data: Scalars['JSON']['input'];
  defaultCaption?: InputMaybe<MultilingualInput>;
};


export type MutationImageDeleteFromCloudinaryOnlyArgs = {
  cloudinaryPublicId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
};


export type MutationImageUpdateArgs = {
  _id: Scalars['String']['input'];
  record: UpdateByIdAssetImageInput;
};


export type MutationImportCreateArgs = {
  record: CreateOneImportInput;
};


export type MutationImportDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationImportManagerSettingsUpsertArgs = {
  record: ImportManagerSettingsUpsertInput;
};


export type MutationImportPreviewArgs = {
  googleSheetsConfig?: InputMaybe<ImportGoogleSheetsConfigInput>;
  importId?: InputMaybe<Scalars['MongoID']['input']>;
  importType?: InputMaybe<ImportType>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationImportRunCancelArgs = {
  importRunId: Scalars['MongoID']['input'];
};


export type MutationImportRunCreateArgs = {
  checkForExistingOperators?: InputMaybe<Scalars['Boolean']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  importId: Scalars['MongoID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  skipImages?: InputMaybe<Scalars['Boolean']['input']>;
  startingRow?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationImportRunDeleteArgs = {
  importRunId: Scalars['MongoID']['input'];
};


export type MutationImportRunMoveOperatorsToConnectedArgs = {
  importRunId: Scalars['MongoID']['input'];
  operatorEntityIds: Array<Scalars['ID']['input']>;
};


export type MutationImportRunRollbackArgs = {
  importRunId: Scalars['MongoID']['input'];
};


export type MutationImportRunStartArgs = {
  importRunId: Scalars['MongoID']['input'];
};


export type MutationImportScrapeCleanDataArgs = {
  dataCleaningPrompt?: InputMaybe<Scalars['String']['input']>;
  rawWebsiteData: Scalars['String']['input'];
  scrapeId: Scalars['MongoID']['input'];
};


export type MutationImportScrapeCreateArgs = {
  record: CreateOneImportScrapeInput;
};


export type MutationImportScrapeDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationImportScrapeDeleteWithRunsArgs = {
  scrapeId: Scalars['MongoID']['input'];
};


export type MutationImportScrapeFetchSitemapArgs = {
  scrapeId: Scalars['MongoID']['input'];
  sitemapUrl?: InputMaybe<Scalars['String']['input']>;
  targetOrganization?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationImportScrapeFetchSpreadsheetArgs = {
  scrapeId: Scalars['MongoID']['input'];
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImportScrapeFetchWebsiteArgs = {
  scrapeId: Scalars['MongoID']['input'];
  useDomScrape?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationImportScrapeGenerateColumnMappingArgs = {
  sampleRows?: InputMaybe<Scalars['JSON']['input']>;
  scrapeId: Scalars['MongoID']['input'];
  sourceHeaders: Array<Scalars['String']['input']>;
};


export type MutationImportScrapeGeneratePromptArgs = {
  defaultPrompt?: InputMaybe<Scalars['String']['input']>;
  maxRows: Scalars['Int']['input'];
  scrapeId: Scalars['MongoID']['input'];
  scrapedContent?: InputMaybe<Scalars['String']['input']>;
  websiteUrl: Scalars['String']['input'];
};


export type MutationImportScrapeGenerateSheetArgs = {
  scrapeId: Scalars['MongoID']['input'];
  sheetName: Scalars['String']['input'];
};


export type MutationImportScrapeRunArgs = {
  dataCleaningPrompt?: InputMaybe<Scalars['String']['input']>;
  importReadyData?: InputMaybe<Scalars['String']['input']>;
  initiatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  rawWebsiteData?: InputMaybe<Scalars['String']['input']>;
  scrapeId: Scalars['MongoID']['input'];
};


export type MutationImportScrapeRunCleanupArgs = {
  scrapeRunId: Scalars['MongoID']['input'];
};


export type MutationImportScrapeRunDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationImportScrapeRunEnrichArgs = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  forceEnrichAll?: InputMaybe<Scalars['Boolean']['input']>;
  forceWebScrape?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  scrapeRunId: Scalars['MongoID']['input'];
};


export type MutationImportScrapeRunResolveOperatorsArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  scrapeRunId: Scalars['MongoID']['input'];
};


export type MutationImportScrapeRunRetryExtractionArgs = {
  scrapeRunId: Scalars['MongoID']['input'];
};


export type MutationImportScrapeRunRetryWriteArgs = {
  scrapeRunId: Scalars['MongoID']['input'];
};


export type MutationImportScrapeRunSitemapArgs = {
  initiatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxRows?: InputMaybe<Scalars['Int']['input']>;
  scrapeId: Scalars['MongoID']['input'];
  scrapeRunId?: InputMaybe<Scalars['MongoID']['input']>;
  targetOrganization?: InputMaybe<Scalars['MongoID']['input']>;
  useDomScrape?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationImportScrapeRunSpreadsheetArgs = {
  columnMapping: Scalars['JSON']['input'];
  initiatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  maxRows?: InputMaybe<Scalars['Int']['input']>;
  scrapeId: Scalars['MongoID']['input'];
};


export type MutationImportScrapeRunUpdateFeedbackArgs = {
  _id: Scalars['MongoID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<ScrapeRunRatingEnum>;
};


export type MutationImportScrapeUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdImportScrapeInput;
};


export type MutationImportUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdImportInput;
};


export type MutationIntegrateProductCalendarLinksByProductIdsArgs = {
  calendarLinksByProductIds: Array<CalendarLinksByProductId>;
};


export type MutationInventoryCreateArgs = {
  record: CreateOneInventoryItemInput;
};


export type MutationInventoryRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationInventoryUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdInventoryItemInput;
};


export type MutationInventoryUpdateClaimedDatesByOrderArgs = {
  endISO: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  startISO: Scalars['String']['input'];
};


export type MutationInviteQueueAcceptFreshenArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type MutationInviteQueueCancelByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationInviteQueueCleanupArgs = {
  convertToDmoManaged: Scalars['Boolean']['input'];
  criteria: InviteQueueCleanupCriteriaInput;
  organizationId: Scalars['MongoID']['input'];
};


export type MutationInviteQueueCreateOneArgs = {
  inviteByEmailOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inviteStatus?: InputMaybe<Scalars['String']['input']>;
  invitedEmail?: InputMaybe<Scalars['String']['input']>;
  invitedUserId?: InputMaybe<Scalars['MongoID']['input']>;
  invitedUserName?: InputMaybe<Scalars['String']['input']>;
  operatorEntityId: Scalars['MongoID']['input'];
  operatorName: Scalars['String']['input'];
  organizationId: Scalars['MongoID']['input'];
};


export type MutationInviteQueueFreshenArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationInviteQueueReinviteByEmailArgs = {
  email: Scalars['String']['input'];
  organizationId: Scalars['MongoID']['input'];
  recordIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};


export type MutationInviteQueueSendInvitesArgs = {
  minDaysSinceInvite?: InputMaybe<Scalars['Int']['input']>;
  mode: Scalars['String']['input'];
  organizationId: Scalars['MongoID']['input'];
};


export type MutationItineraryAddBlockArgs = {
  block: Scalars['JSON']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  itineraryId: Scalars['ID']['input'];
  parentGroupId?: InputMaybe<Scalars['ID']['input']>;
  segmentId: Scalars['ID']['input'];
};


export type MutationItineraryCreateOneArgs = {
  record: CreateOneItineraryInput;
};


export type MutationItineraryDeleteArgs = {
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  itineraryId: Scalars['ID']['input'];
};


export type MutationItineraryDiscardDraftArgs = {
  itineraryId: Scalars['ID']['input'];
};


export type MutationItineraryDuplicateArgs = {
  itineraryId: Scalars['ID']['input'];
};


export type MutationItineraryPublishArgs = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  itineraryId: Scalars['ID']['input'];
  map3dBuildings?: InputMaybe<Scalars['Boolean']['input']>;
  map3dObjects?: InputMaybe<Scalars['Boolean']['input']>;
  map3dTrees?: InputMaybe<Scalars['Boolean']['input']>;
  mapStyleVariant?: InputMaybe<Scalars['String']['input']>;
  showPointsOfInterest?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationItineraryRemoveBlockArgs = {
  blockId: Scalars['ID']['input'];
  itineraryId: Scalars['ID']['input'];
};


export type MutationItineraryToggleFavoriteArgs = {
  itineraryId: Scalars['MongoID']['input'];
};


export type MutationItineraryUnarchiveArgs = {
  itineraryId: Scalars['ID']['input'];
};


export type MutationItineraryUnpublishArgs = {
  itineraryId: Scalars['ID']['input'];
};


export type MutationItineraryUpdateBlockArgs = {
  blockId: Scalars['ID']['input'];
  data: Scalars['JSON']['input'];
  itineraryId: Scalars['ID']['input'];
};


export type MutationItineraryUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdItineraryInput;
};


export type MutationItineraryUpdateSegmentsArgs = {
  itineraryId: Scalars['ID']['input'];
  segments: Scalars['JSON']['input'];
};


export type MutationItineraryWidgetCreateArgs = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  embedStyle?: InputMaybe<Scalars['String']['input']>;
  itineraryId: Scalars['MongoID']['input'];
  label: Scalars['String']['input'];
  map3dBuildings?: InputMaybe<Scalars['Boolean']['input']>;
  map3dObjects?: InputMaybe<Scalars['Boolean']['input']>;
  map3dTrees?: InputMaybe<Scalars['Boolean']['input']>;
  mapStyleVariant?: InputMaybe<Scalars['String']['input']>;
  showPointsOfInterest?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationItineraryWidgetDeleteByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationItineraryWidgetUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  accentColor?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  embedStyle?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  map3dBuildings?: InputMaybe<Scalars['Boolean']['input']>;
  map3dObjects?: InputMaybe<Scalars['Boolean']['input']>;
  map3dTrees?: InputMaybe<Scalars['Boolean']['input']>;
  mapStyleVariant?: InputMaybe<Scalars['String']['input']>;
  showPointsOfInterest?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationItineraryWidgetUpsertArgs = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  itineraryId: Scalars['MongoID']['input'];
};


export type MutationLeadCreateOneArgs = {
  bookerId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  operatorId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  storefrontId?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationLeadRemoveByIdArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLeadUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdLeadInput;
};


export type MutationListCreateArgs = {
  record: CreateOneListInput;
};


export type MutationListCreateListsForAudiencesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationListCreateMembersForTiersArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationListDeleteByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationListUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdListInput;
};


export type MutationMaintenanceUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdMaintenanceInput;
};


export type MutationMembershipAdminCancelArgs = {
  operatorEntityId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
};


export type MutationMembershipBulkSetStatusForListArgs = {
  emailKind: PendingRenewalEmailKind;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  listId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
  scheduleEmail: Scalars['Boolean']['input'];
};


export type MutationMembershipCancelPendingRenewalEmailsArgs = {
  ids: Array<Scalars['MongoID']['input']>;
};


export type MutationMembershipChecklistFixArgs = {
  action: Scalars['String']['input'];
  cyclePaid?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dryRun: Scalars['Boolean']['input'];
  fromStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  graceDays?: InputMaybe<Scalars['Int']['input']>;
  neverExpire?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['MongoID']['input'];
  statusTagId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationMembershipChecklistRunArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type MutationMembershipDeclineStatusEmailsArgs = {
  listId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
  statusTagId: Scalars['MongoID']['input'];
};


export type MutationMembershipLaunchArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type MutationMembershipLaunchSetModeArgs = {
  mode: Scalars['String']['input'];
  organizationId: Scalars['MongoID']['input'];
};


export type MutationMembershipMarkRenewedArgs = {
  operatorEntityId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
};


export type MutationMembershipMarkRenewedForOwnerArgs = {
  operatorEntityIds: Array<Scalars['MongoID']['input']>;
  organizationId: Scalars['MongoID']['input'];
};


export type MutationMembershipQueueCustomEmailsArgs = {
  body: Scalars['String']['input'];
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  hideGreeting?: InputMaybe<Scalars['Boolean']['input']>;
  includeCoolingDown?: InputMaybe<Scalars['Boolean']['input']>;
  listId: Scalars['MongoID']['input'];
  operatorEntityIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  organizationId: Scalars['MongoID']['input'];
  subject: Scalars['String']['input'];
};


export type MutationMembershipQueueStatusEmailsArgs = {
  includeCoolingDown?: InputMaybe<Scalars['Boolean']['input']>;
  listId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
  statusTagId: Scalars['MongoID']['input'];
};


export type MutationMembershipRepairScheduleSnapshotsArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type MutationMembershipScheduleRenewalEmailForListingsArgs = {
  emailKind: PendingRenewalEmailKind;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  listId?: InputMaybe<Scalars['MongoID']['input']>;
  operatorEntityIds: Array<Scalars['MongoID']['input']>;
  organizationId: Scalars['MongoID']['input'];
};


export type MutationMembershipSendPendingRenewalEmailsNowArgs = {
  background?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['MongoID']['input']>;
};


export type MutationMembershipSetManualRenewalDateArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  operatorEntityId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
};


export type MutationMerchLowStockThresholdUpdateArgs = {
  lowStockThreshold?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['ID']['input'];
};


export type MutationMerchVariantStockUpdateArgs = {
  inventoryCount: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  variantId: Scalars['ID']['input'];
};


export type MutationNoteCreateOneArgs = {
  record: CreateOneNoteInput;
};


export type MutationNoteRemoveByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationNoteUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNoteInput;
};


export type MutationOperatorAddExistingToOrganizationArgs = {
  importRunId?: InputMaybe<Scalars['MongoID']['input']>;
  mergeOption?: InputMaybe<MergeOption>;
  operatorEntityId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationOperatorAiImageScanCreateArgs = {
  operatorId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  websiteUrl: Scalars['String']['input'];
};


export type MutationOperatorAiImageScanExecuteArgs = {
  taskId: Scalars['MongoID']['input'];
};


export type MutationOperatorAiImageScanUploadArgs = {
  entityId: Scalars['String']['input'];
  taskId: Scalars['MongoID']['input'];
  urls: Array<Scalars['String']['input']>;
};


export type MutationOperatorAiImageVerifyUrlsArgs = {
  urls: Array<Scalars['String']['input']>;
};


export type MutationOperatorAiProfileScanCreateArgs = {
  fieldsRequested: Array<Scalars['String']['input']>;
  operatorId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  websiteUrl: Scalars['String']['input'];
};


export type MutationOperatorAiProfileScanExecuteArgs = {
  taskId: Scalars['MongoID']['input'];
};


export type MutationOperatorBulkAcceptDraftsArgs = {
  operatorEntityIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationOperatorBulkApplyAudienceTagsArgs = {
  action: Scalars['String']['input'];
  audienceTagIds: Array<Scalars['ID']['input']>;
  operatorEntityIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationOperatorBulkApplyBackOfficeTagsArgs = {
  action: Scalars['String']['input'];
  operatorEntityIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']>;
};


export type MutationOperatorCreateArgs = {
  record: CreateOneOperatorInput;
};


export type MutationOperatorDeleteArgs = {
  _entityId: Scalars['ID']['input'];
};


export type MutationOperatorDeleteCompletelyByInternalArgs = {
  _entityId: Scalars['ID']['input'];
};


export type MutationOperatorMarkDeletedByInternalArgs = {
  _entityId: Scalars['ID']['input'];
};


export type MutationOperatorUpdateArgs = {
  _entityId: Scalars['ID']['input'];
  isApproving?: InputMaybe<Scalars['Boolean']['input']>;
  record: UpdateByIdOperatorInput;
  whereabotContributed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationOperatorUpdateContactRolesArgs = {
  contactRoles: Array<InputMaybe<ContactRole>>;
  entity: EntityReferenceInput;
  operatorEntityId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationOperatorUpdateImagesArgs = {
  _entityId: Scalars['ID']['input'];
  imagesToDelete?: InputMaybe<Array<Scalars['String']['input']>>;
  imagesToKeep?: InputMaybe<Array<Scalars['String']['input']>>;
  isApproving?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationOperatorWhereabotDismissArgs = {
  operatorEntityId: Scalars['MongoID']['input'];
  scanType: Scalars['String']['input'];
};


export type MutationOrderApproveArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};


export type MutationOrderConvertHoldToChargeArgs = {
  amount: Scalars['Int']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationOrderCreateArgs = {
  customer: PeopleInput;
  delivery?: InputMaybe<OrderDeliveryInput>;
  guests: Array<InputMaybe<OrderGuestsInput>>;
  messageFromGuest?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['String']['input'];
  productPurchaseRequests: Array<InputMaybe<ProductPurchaseRequest>>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  source: OrderSourceInput;
  surveyResponse?: InputMaybe<SurveyResponseInput>;
  taxExemption?: InputMaybe<OrderTaxExemptionInput>;
};


export type MutationOrderDeclineArgs = {
  orderId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOrderFulfillArgs = {
  carrier?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOrderMarkAsPaidArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationOrderRemoveArgs = {
  _id: Scalars['String']['input'];
};


export type MutationOrderSetArrivalArgs = {
  arrived: Scalars['Boolean']['input'];
  attendanceKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  guestIndexes?: InputMaybe<Array<Scalars['Int']['input']>>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  sessionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationOrderUpdateArgs = {
  _id: Scalars['String']['input'];
  cancelled: Scalars['Boolean']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationOrgOperatorOverlayDeleteArgs = {
  operatorId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
};


export type MutationOrgOperatorOverlayUpsertArgs = {
  record: OrgOperatorOverlayUpsertInput;
};


export type MutationOrgOverviewRebuildArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationCreateArgs = {
  record: CreateOneOrganizationInput;
};


export type MutationOrganizationDeleteArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationDisconnectAssetsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationEmailDomainProvisionArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationEmailDomainRemoveArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationEmailDomainRequestArgs = {
  fromAddress: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationEmailDomainRunChecksArgs = {
  organizationId: Scalars['ID']['input'];
  testRecipientEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOrganizationEmailDomainSetDisabledArgs = {
  disabled: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationEmailDomainSetTestOverrideArgs = {
  allowNonProductionSending: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationEmailDomainUpdateNoteArgs = {
  internalNote?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationEventPartnerAddArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationOrganizationEventPartnerRemoveArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type MutationOrganizationManifestGenerateArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationRenewalScheduleApplyArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  graceDays?: InputMaybe<Scalars['Int']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  month?: InputMaybe<Scalars['Int']['input']>;
  neverExpire?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['MongoID']['input'];
  outlierTarget?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOrganizationSeedDefaultAudiencesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationSeedDefaultMembershipStatusTagsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationSendRenewalTestEmailArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  emailKind: RenewalTestEmailKind;
  hideGreeting?: InputMaybe<Scalars['Boolean']['input']>;
  hideRenewalDateLine?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  recipientUserId: Scalars['ID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOrganizationSendTestEmailsArgs = {
  emailTypes: Array<OrgTestEmailType>;
  organizationId: Scalars['ID']['input'];
  recipientUserId: Scalars['ID']['input'];
};


export type MutationOrganizationUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdOrganizationInput;
};


export type MutationOrganizationUpdateImagesArgs = {
  id: Scalars['ID']['input'];
  imagesToDelete?: InputMaybe<Array<Scalars['String']['input']>>;
  imagesToKeep?: InputMaybe<Array<Scalars['String']['input']>>;
  isLogo?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationOrganizationUpdateIndividualMembershipTiersArgs = {
  individualMembershipTierTagIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationUpdateListingAudiencesArgs = {
  listingAudienceTagIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  removedListAction?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOrganizationUpdateMembershipBroadcastArgs = {
  broadcastId?: InputMaybe<Scalars['MongoID']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationUpdateMembershipHubArgs = {
  hideOfferFromForYou?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['MongoID']['input'];
  tiers?: InputMaybe<Array<MembershipHubTierInput>>;
};


export type MutationOrganizationUpdateMembershipPaymentsEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationUpdateMembershipStatusTagsArgs = {
  membershipStatusTagIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationUpdateMembershipTierCheckoutArgs = {
  bookerId?: InputMaybe<Scalars['MongoID']['input']>;
  free?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  tierTagId: Scalars['MongoID']['input'];
};


export type MutationOrganizationUpdateMembershipTiersArgs = {
  membershipTierTagIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  removedListAction?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOrganizationUpdateNomenclatureArgs = {
  member: Scalars['String']['input'];
  members: Scalars['String']['input'];
  membership: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationOrganizationUpdateRenewalSettingsArgs = {
  activeStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  automaticRenewalEmails?: InputMaybe<Scalars['Boolean']['input']>;
  cancelledEmailBody?: InputMaybe<Scalars['String']['input']>;
  cancelledEmailCtaLabel?: InputMaybe<Scalars['String']['input']>;
  cancelledEmailSubject?: InputMaybe<Scalars['String']['input']>;
  clearStatusTagsOnExpiration?: InputMaybe<Scalars['Boolean']['input']>;
  emailCooldownDays?: InputMaybe<Scalars['Int']['input']>;
  enabled: Scalars['Boolean']['input'];
  expiredEmailBody?: InputMaybe<Scalars['String']['input']>;
  expiredEmailCtaLabel?: InputMaybe<Scalars['String']['input']>;
  expiredEmailSubject?: InputMaybe<Scalars['String']['input']>;
  expiredStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  fixedRenewalDay?: InputMaybe<Scalars['Int']['input']>;
  fixedRenewalMonth?: InputMaybe<Scalars['Int']['input']>;
  instructionsEmailBody?: InputMaybe<Scalars['String']['input']>;
  instructionsEmailCtaLabel?: InputMaybe<Scalars['String']['input']>;
  instructionsEmailSubject?: InputMaybe<Scalars['String']['input']>;
  neverExpireMembers?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  overdueEmailBody?: InputMaybe<Scalars['String']['input']>;
  overdueEmailCtaLabel?: InputMaybe<Scalars['String']['input']>;
  overdueEmailSubject?: InputMaybe<Scalars['String']['input']>;
  pendingStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  proRateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  renewalGraceDays?: InputMaybe<Scalars['Int']['input']>;
  renewalReminderLeadDays?: InputMaybe<Scalars['Int']['input']>;
  renewalType: Scalars['String']['input'];
  sendCancelledEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendExpirationEmails: Scalars['Boolean']['input'];
  sendOverdueEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendRenewalEmails: Scalars['Boolean']['input'];
  sendSuccessEmails: Scalars['Boolean']['input'];
  successEmailBody?: InputMaybe<Scalars['String']['input']>;
  successEmailCtaLabel?: InputMaybe<Scalars['String']['input']>;
  successEmailSubject?: InputMaybe<Scalars['String']['input']>;
  term: Scalars['String']['input'];
  termYears?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationOrganizationUpsertTierReminderEmailArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  hideRenewalDateLine?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  tierTagId: Scalars['MongoID']['input'];
};


export type MutationPaymentMethodSetCreateArgs = {
  record: CreateOnePaymentMethodSetInput;
};


export type MutationPaymentMethodSetUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPaymentMethodSetInput;
};


export type MutationPaymentRequestAddInternalNoteArgs = {
  note: Scalars['String']['input'];
  paymentRequestId: Scalars['MongoID']['input'];
};


export type MutationPaymentRequestBulkSendArgs = {
  paymentRequestIds: Array<Scalars['MongoID']['input']>;
};


export type MutationPaymentRequestCancelArgs = {
  cancellationNote: Scalars['String']['input'];
  paymentRequestId: Scalars['MongoID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationPaymentRequestCheckoutInitiateArgs = {
  cartSnapshot: Scalars['JSON']['input'];
  customer: Scalars['JSON']['input'];
  productPurchaseRequests: Array<Scalars['JSON']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['JSON']['input'];
};


export type MutationPaymentRequestCreateArgs = {
  record: Scalars['JSON']['input'];
};


export type MutationPaymentRequestDeleteArgs = {
  paymentRequestId: Scalars['MongoID']['input'];
};


export type MutationPaymentRequestMarkPaidArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  paymentRequestId: Scalars['MongoID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationPaymentRequestMarkPendingArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  paymentRequestId: Scalars['MongoID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationPaymentRequestRecordPaymentArgs = {
  accountingDate?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['Int']['input'];
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  chequeNumber?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  method: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  paymentRequestId: Scalars['MongoID']['input'];
  processorReference?: InputMaybe<Scalars['String']['input']>;
  receivedDate: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Int']['input'];
};


export type MutationPaymentRequestResendArgs = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentRequestId: Scalars['MongoID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationPaymentRequestReversePaymentArgs = {
  accountingDate?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  paymentEntryId: Scalars['MongoID']['input'];
  paymentRequestId: Scalars['MongoID']['input'];
  reason: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


export type MutationPaymentRequestSendArgs = {
  paymentRequestId: Scalars['MongoID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationPaymentRequestSetNeedsAttentionArgs = {
  needsAttention: Scalars['Boolean']['input'];
  paymentRequestId: Scalars['MongoID']['input'];
};


export type MutationPaymentRequestStatementRemoveOrderArgs = {
  orderId: Scalars['String']['input'];
  paymentRequestId: Scalars['MongoID']['input'];
};


export type MutationPaymentRequestSubmitForReviewArgs = {
  paymentRequestId: Scalars['MongoID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationPaymentRequestUndoPendingArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  paymentRequestId: Scalars['MongoID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationPaymentRequestUpdateArgs = {
  paymentRequestId: Scalars['MongoID']['input'];
  record: Scalars['JSON']['input'];
  version: Scalars['Int']['input'];
};


export type MutationPaymentRequestUpdateAccountingMetadataArgs = {
  accountingCode?: InputMaybe<Scalars['String']['input']>;
  accountingDate?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  internalAccountingNotes?: InputMaybe<Scalars['String']['input']>;
  paymentRequestId: Scalars['MongoID']['input'];
  reason: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


export type MutationPersonConnectToListingArgs = {
  entityId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  operatorEntityId: Scalars['ID']['input'];
  sendInvitationEmail: Scalars['Boolean']['input'];
  type: EnumOwnerType;
};


export type MutationPersonCreateArgs = {
  entityId: Scalars['ID']['input'];
  record: CreateOnePeopleInput;
  type: EnumOwnerType;
};


export type MutationPersonDeleteArgs = {
  entityId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  type: EnumOwnerType;
};


export type MutationPersonDeleteCompletelyByInternalArgs = {
  personId: Scalars['ID']['input'];
};


export type MutationPersonUpdateAddToVisibleToArgs = {
  email: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  type: EnumOwnerType;
};


export type MutationPersonUpdateCommonArgs = {
  _id: Scalars['MongoID']['input'];
  entityId: Scalars['ID']['input'];
  record: UpdateByIdPeopleInput;
  type: EnumOwnerType;
};


export type MutationPersonUpdateVisibleToArgs = {
  entityId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<PersonMetadataInput>;
  scratchpad?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type: EnumOwnerType;
};


export type MutationPlaceCreateArgs = {
  record: CreateOnePlaceInput;
};


export type MutationPlaceDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationPlaceMoveNodeArgs = {
  index: Scalars['Int']['input'];
  newParentId?: InputMaybe<Scalars['MongoID']['input']>;
  placeId: Scalars['MongoID']['input'];
};


export type MutationPlaceUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPlaceInput;
};


export type MutationPolicyCreateArgs = {
  record: CreateOnePolicyInput;
};


export type MutationPolicyUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPolicyInput;
};


export type MutationProductCreateArgs = {
  inventoryCount: Scalars['Int']['input'];
  record: CreateOneProductInput;
};


export type MutationProductDuplicateArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationProductRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationProductUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  imagesToKeep?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  record: UpdateByIdProductInput;
};


export type MutationPromotionCreateArgs = {
  record: CreateOnePromotionInput;
};


export type MutationPromotionDeleteByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationPromotionDisconnectOrganizationArgs = {
  organizationId: Scalars['MongoID']['input'];
  promotionId: Scalars['MongoID']['input'];
};


export type MutationPromotionUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  imagesToKeep?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSubmitting?: InputMaybe<Scalars['Boolean']['input']>;
  record: UpdateByIdPromotionInput;
  setOrganizationTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  setStatus?: InputMaybe<EnumPromotionAccessOperatorStatus>;
};


export type MutationPublicMediaCreateFromOrgUploadArgs = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  blurhash?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mediaTags?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  mediaType: Scalars['String']['input'];
  muxAssetId?: InputMaybe<Scalars['String']['input']>;
  muxPlaybackId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  posterUrl?: InputMaybe<Scalars['String']['input']>;
  relatedListings?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPublicMediaIgnoreAttentionArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationPublicMediaLikeToggleArgs = {
  _id: Scalars['MongoID']['input'];
  like: Scalars['Boolean']['input'];
  organizationId: Scalars['MongoID']['input'];
};


export type MutationPublicMediaPromoteFromListingArgs = {
  listingId: Scalars['MongoID']['input'];
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  originalAssetId: Scalars['String']['input'];
};


export type MutationPublicMediaPromoteManyFromListingArgs = {
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  selections: Array<PublicMediaListingSelectionInput>;
};


export type MutationPublicMediaUnpublishArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationPublicMediaUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  caption?: InputMaybe<MultilingualInput>;
  carouselThumbnailAsset?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<MultilingualInput>;
  mediaTags?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  relatedListings?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  useCarouselThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRefundCreateArgs = {
  amount: Scalars['Int']['input'];
  orderId: Scalars['String']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRefundUpdateArgs = {
  _id: Scalars['String']['input'];
  record: UpdateByIdRefundInput;
};


export type MutationRenewableFeeConfirmArgs = {
  paymentIntentId: Scalars['String']['input'];
  renewablePurchaseId: Scalars['MongoID']['input'];
};


export type MutationRenewableFeeInitiateArgs = {
  addOns?: InputMaybe<Array<RenewableFeeAddOnInput>>;
  autoRenewOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  bookerId: Scalars['MongoID']['input'];
  broadcastId?: InputMaybe<Scalars['MongoID']['input']>;
  broadcastResourceId?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<RenewableFeeCustomerInput>;
  operatorId?: InputMaybe<Scalars['MongoID']['input']>;
  operatorIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  organizationId: Scalars['MongoID']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentRequestId?: InputMaybe<Scalars['MongoID']['input']>;
  productId: Scalars['MongoID']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  surveyResponse?: InputMaybe<SurveyResponseInput>;
  taxExemption?: InputMaybe<RenewableFeeTaxExemptionInput>;
  tierId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRenewablePurchaseCancelArgs = {
  renewablePurchaseId: Scalars['MongoID']['input'];
};


export type MutationRenewablePurchaseChangeTierArgs = {
  renewablePurchaseId: Scalars['MongoID']['input'];
  tierId: Scalars['String']['input'];
};


export type MutationRenewablePurchaseConsolidateArgs = {
  mergePurchaseIds: Array<Scalars['MongoID']['input']>;
  primaryPurchaseId: Scalars['MongoID']['input'];
};


export type MutationRenewablePurchaseSetRecurringLineItemsArgs = {
  lineItems: Array<RenewablePurchaseRecurringLineItemInput>;
  renewablePurchaseId: Scalars['MongoID']['input'];
};


export type MutationRenewablePurchaseSetRenewalBillingArgs = {
  renewablePurchaseId: Scalars['MongoID']['input'];
  renewalBilling: EnumRenewablePurchaseRenewalBilling;
};


export type MutationRenewablePurchaseUpdateListingsArgs = {
  operatorIds: Array<Scalars['MongoID']['input']>;
  renewablePurchaseId: Scalars['MongoID']['input'];
};


export type MutationRenewalEngineDisableArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type MutationRenewalEngineEnableArgs = {
  activeTagId?: InputMaybe<Scalars['MongoID']['input']>;
  expiredTagId?: InputMaybe<Scalars['MongoID']['input']>;
  organizationId: Scalars['MongoID']['input'];
  renewingTagId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationRenewalRecordApproveArgs = {
  renewalRecordId: Scalars['MongoID']['input'];
};


export type MutationRenewalRecordCancelArgs = {
  cancelReason?: InputMaybe<Scalars['String']['input']>;
  cancelledBy?: InputMaybe<Scalars['MongoID']['input']>;
  renewalRecordId: Scalars['MongoID']['input'];
};


export type MutationRenewalRecordPayArgs = {
  renewalRecordId: Scalars['MongoID']['input'];
};


export type MutationRenewalRecordRetryArgs = {
  renewalRecordId: Scalars['MongoID']['input'];
};


export type MutationReportRebuildArgs = {
  reportType: Scalars['String']['input'];
  storefrontId: Scalars['MongoID']['input'];
};


export type MutationResendBankTransferInstructionsArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationRuleCreateArgs = {
  record: CreateOneRuleInput;
};


export type MutationRuleCreateManyArgs = {
  records: Array<CreateManyRuleInput>;
};


export type MutationRuleDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationRuleUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdRuleInput;
};


export type MutationSavedReportCreateArgs = {
  input: SavedReportInput;
  storefrontId: Scalars['MongoID']['input'];
};


export type MutationSavedReportDeleteArgs = {
  savedReportId: Scalars['MongoID']['input'];
  storefrontId: Scalars['MongoID']['input'];
};


export type MutationSavedReportUpdateArgs = {
  input: SavedReportInput;
  savedReportId: Scalars['MongoID']['input'];
  storefrontId: Scalars['MongoID']['input'];
};


export type MutationScheduledPaymentRetryFailedArgs = {
  orderId: Scalars['ID']['input'];
  paymentMethodId: Scalars['String']['input'];
  scheduledPaymentId: Scalars['ID']['input'];
};


export type MutationSiteBuilderMarkReadyForClientArgs = {
  appUrl?: InputMaybe<Scalars['String']['input']>;
  inviteEmail?: InputMaybe<Scalars['String']['input']>;
  inviteName?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['MongoID']['input'];
};


export type MutationSiteBuilderMessageFeedbackArgs = {
  feedback: Scalars['String']['input'];
  messageId: Scalars['MongoID']['input'];
  reasonTags?: InputMaybe<Array<Scalars['String']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSiteBuilderPublishArgs = {
  siteId: Scalars['MongoID']['input'];
};


export type MutationSiteBuilderQuestionAnswerArgs = {
  answer: Scalars['String']['input'];
  questionId: Scalars['MongoID']['input'];
};


export type MutationSiteBuilderQuestionDismissArgs = {
  questionId: Scalars['MongoID']['input'];
};


export type MutationSiteBuilderQuestionMarkUnnecessaryArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['MongoID']['input'];
};


export type MutationSiteBuilderRollbackArgs = {
  siteId: Scalars['MongoID']['input'];
  slug: Scalars['String']['input'];
  toVersion: Scalars['Int']['input'];
};


export type MutationSiteBuilderRunQaArgs = {
  siteId: Scalars['MongoID']['input'];
};


export type MutationSiteBuilderSenderAddArgs = {
  email: Scalars['String']['input'];
  siteId: Scalars['MongoID']['input'];
};


export type MutationSiteBuilderSenderRemoveArgs = {
  email: Scalars['String']['input'];
  siteId: Scalars['MongoID']['input'];
};


export type MutationSiteBuilderSenderVerifyArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  siteId: Scalars['MongoID']['input'];
};


export type MutationSiteBuilderSettingsUpdateArgs = {
  actionConfidenceThreshold?: InputMaybe<Scalars['Float']['input']>;
  allowedInboundDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultBudget?: InputMaybe<Scalars['JSON']['input']>;
  defaultSkillKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  disabledBindingPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  extraBindingPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  killSwitch?: InputMaybe<Scalars['Boolean']['input']>;
  orgMonthlyCostUsdCap?: InputMaybe<Scalars['Float']['input']>;
  staffNotificationEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  tiers?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationSiteBuilderSiteAddAssetsArgs = {
  assetIds: Array<Scalars['String']['input']>;
  siteId: Scalars['MongoID']['input'];
};


export type MutationSiteBuilderSiteCreateArgs = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  billing?: InputMaybe<SiteBuilderBillingInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['MongoID']['input'];
  ownerKind: Scalars['String']['input'];
  references?: InputMaybe<Array<InputMaybe<SiteBuilderReferenceInput>>>;
  reviewMode?: InputMaybe<Scalars['String']['input']>;
  startBuild?: InputMaybe<Scalars['Boolean']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSiteBuilderSiteDeleteArgs = {
  siteId: Scalars['MongoID']['input'];
};


export type MutationSiteBuilderSiteRemoveAssetArgs = {
  assetId: Scalars['String']['input'];
  siteId: Scalars['MongoID']['input'];
};


export type MutationSiteBuilderSiteSetBillingArgs = {
  billing: SiteBuilderBillingInput;
  siteId: Scalars['MongoID']['input'];
};


export type MutationSiteBuilderSiteSetReferencesArgs = {
  references: Array<SiteBuilderReferenceInput>;
  siteId: Scalars['MongoID']['input'];
};


export type MutationSiteBuilderSiteUpdateArgs = {
  budget?: InputMaybe<Scalars['JSON']['input']>;
  clientVisibility?: InputMaybe<Scalars['String']['input']>;
  customDomainHost?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reviewMode?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['MongoID']['input'];
  skillKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationSiteBuilderSkillFeedbackAddArgs = {
  flag?: InputMaybe<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  skillKey: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type MutationSiteBuilderSkillFeedbackResolveArgs = {
  feedbackId: Scalars['MongoID']['input'];
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSiteBuilderUnpublishArgs = {
  siteId: Scalars['MongoID']['input'];
};


export type MutationStorefrontConnectNewStripeAccountArgs = {
  assignToUnassignedBookers?: InputMaybe<Scalars['Boolean']['input']>;
  bookerId?: InputMaybe<Scalars['ID']['input']>;
  redirectUrl: Scalars['String']['input'];
  storefrontId: Scalars['ID']['input'];
};


export type MutationStorefrontCreateArgs = {
  record: CreateOneStorefrontInput;
};


export type MutationStorefrontDisconnectStripeAccountArgs = {
  connectedAccountId: Scalars['String']['input'];
  deleteFromStripe?: InputMaybe<Scalars['Boolean']['input']>;
  storefrontId: Scalars['ID']['input'];
};


export type MutationStorefrontEnsureTestStorefrontArgs = {
  storefrontId: Scalars['MongoID']['input'];
};


export type MutationStorefrontFastForwardRenewalsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  storefrontId: Scalars['ID']['input'];
};


export type MutationStorefrontFeatureGateResetArgs = {
  featureFlagId: Scalars['MongoID']['input'];
  storefrontId: Scalars['MongoID']['input'];
};


export type MutationStorefrontFeatureGateToggleArgs = {
  enabled: Scalars['Boolean']['input'];
  featureFlagId: Scalars['MongoID']['input'];
  storefrontId: Scalars['MongoID']['input'];
};


export type MutationStorefrontForceRenewalsArgs = {
  storefrontId: Scalars['ID']['input'];
};


export type MutationStorefrontGenerateStatementsArgs = {
  period: Scalars['String']['input'];
  storefrontId: Scalars['MongoID']['input'];
};


export type MutationStorefrontGenerateUpcomingRenewalInvoicesArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  storefrontId: Scalars['MongoID']['input'];
};


export type MutationStorefrontInvoiceTemplateEnsureArgs = {
  storefrontId: Scalars['MongoID']['input'];
};


export type MutationStorefrontLaunchArgs = {
  bookerIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  freeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  liveStorefrontId: Scalars['MongoID']['input'];
};


export type MutationStorefrontPageCreateArgs = {
  bookerId: Scalars['MongoID']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  storefrontId: Scalars['MongoID']['input'];
  type: Scalars['String']['input'];
};


export type MutationStorefrontPageDeleteArgs = {
  pageId: Scalars['MongoID']['input'];
};


export type MutationStorefrontPageEditArgs = {
  pageId: Scalars['MongoID']['input'];
  prompt: Scalars['String']['input'];
};


export type MutationStorefrontPageGenerateArgs = {
  pageId: Scalars['MongoID']['input'];
};


export type MutationStorefrontPageUpdateStatusArgs = {
  pageId: Scalars['MongoID']['input'];
  status: Scalars['String']['input'];
};


export type MutationStorefrontPlatformSettingsUpdateArgs = {
  gettingStartedWistiaId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStorefrontPurgeTestDataArgs = {
  storefrontId: Scalars['ID']['input'];
};


export type MutationStorefrontRollbackRenewalInvoiceGenerationArgs = {
  runId: Scalars['MongoID']['input'];
  storefrontId: Scalars['MongoID']['input'];
};


export type MutationStorefrontRollbackStatementGenerationArgs = {
  runId: Scalars['MongoID']['input'];
  storefrontId: Scalars['MongoID']['input'];
};


export type MutationStorefrontSendTestEmailsArgs = {
  emailTypes: Array<StorefrontTestEmailType>;
  recipientUserId: Scalars['ID']['input'];
  storefrontId: Scalars['ID']['input'];
};


export type MutationStorefrontSetApplicationFeeArgs = {
  applicationPercentage: Scalars['Float']['input'];
  storefrontId: Scalars['String']['input'];
};


export type MutationStorefrontSetApplicationFeeDefaultsArgs = {
  membership: Scalars['Float']['input'];
  merch: Scalars['Float']['input'];
  other: Scalars['Float']['input'];
  storefrontId: Scalars['String']['input'];
};


export type MutationStorefrontSetInvoicingEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  storefrontId: Scalars['MongoID']['input'];
};


export type MutationStorefrontSetRegionArgs = {
  storefrontId: Scalars['MongoID']['input'];
  stripeRegion: Scalars['String']['input'];
};


export type MutationStorefrontUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdStorefrontInput;
};


export type MutationStripePayoutsSyncArgs = {
  sinceDays?: InputMaybe<Scalars['Int']['input']>;
  storefrontId: Scalars['MongoID']['input'];
};


export type MutationSupportCaseCreateLinearIssueArgs = {
  _id: Scalars['MongoID']['input'];
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};


export type MutationSupportCaseDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationSupportCaseInvestigateArgs = {
  _id: Scalars['MongoID']['input'];
  maxBudgetCents?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  screenshots?: InputMaybe<Array<InputMaybe<SupportInvestigationScreenshotInput>>>;
};


export type MutationSupportCaseInvestigationCancelArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationSupportCaseInvestigationRaiseBudgetArgs = {
  _id: Scalars['MongoID']['input'];
  maxBudgetCents: Scalars['Int']['input'];
};


export type MutationSupportCaseSetStatusArgs = {
  _id: Scalars['MongoID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  triageStatus: Scalars['String']['input'];
};


export type MutationSupportCaseSetTypeArgs = {
  _id: Scalars['MongoID']['input'];
  type: Scalars['String']['input'];
};


export type MutationSurveyCreateArgs = {
  record: CreateOneSurveyInput;
};


export type MutationSurveyDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationSurveyDuplicateArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationSurveyQuestionCreateArgs = {
  record: CreateOneSurveyQuestionInput;
};


export type MutationSurveyQuestionCreateManyArgs = {
  records: Array<CreateManySurveyQuestionInput>;
};


export type MutationSurveyQuestionUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSurveyQuestionInput;
};


export type MutationSurveyResponseAdminEditArgs = {
  responses: Array<Scalars['JSON']['input']>;
  surveyResponseId: Scalars['String']['input'];
};


export type MutationSurveyResponseCreateArgs = {
  record: CreateOneSurveyResponseInput;
};


export type MutationSurveyResponseDeleteByIdArgs = {
  surveyResponseId: Scalars['String']['input'];
};


export type MutationSurveyResponseReviewSubmissionArgs = {
  decision: Scalars['String']['input'];
  reviewNote?: InputMaybe<Scalars['String']['input']>;
  surveyResponseId: Scalars['String']['input'];
};


export type MutationSurveyResponseSaveForBroadcastArgs = {
  broadcastId: Scalars['String']['input'];
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  isNewSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  operatorId?: InputMaybe<Scalars['String']['input']>;
  operatorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  responses: Array<Scalars['JSON']['input']>;
  savedByPersonId?: InputMaybe<Scalars['String']['input']>;
  submissionIndex?: InputMaybe<Scalars['Int']['input']>;
  surveyId: Scalars['String']['input'];
};


export type MutationSurveyResponseSubmitForBroadcastArgs = {
  broadcastId: Scalars['String']['input'];
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  isNewSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  operatorId?: InputMaybe<Scalars['String']['input']>;
  operatorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  responses: Array<Scalars['JSON']['input']>;
  savedByPersonId?: InputMaybe<Scalars['String']['input']>;
  submissionIndex?: InputMaybe<Scalars['Int']['input']>;
  surveyId: Scalars['String']['input'];
};


export type MutationSurveyResponseSubmitForInquiryWidgetArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  responses: Array<Scalars['JSON']['input']>;
  surveyId: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
};


export type MutationSurveyResponseUpdateAdminStatusArgs = {
  adminStatus: Scalars['String']['input'];
  surveyResponseId: Scalars['String']['input'];
};


export type MutationSurveyResponseUpdateTagsArgs = {
  surveyResponseId: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
};


export type MutationSurveyUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdSurveyInput;
};


export type MutationTagCreateArgs = {
  record: CreateOneTagInput;
};


export type MutationTagCreateManyArgs = {
  records: Array<CreateManyTagInput>;
};


export type MutationTagDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationTagGroupCreateArgs = {
  record: CreateOneTagGroupInput;
};


export type MutationTagGroupCreateManyArgs = {
  records: Array<CreateManyTagGroupInput>;
};


export type MutationTagMergeArgs = {
  tagIdToMergeAndDelete: Scalars['ID']['input'];
  tagIdToMergeInto: Scalars['ID']['input'];
};


export type MutationTagRelationshipCreateArgs = {
  record: CreateOneTagRelationshipInput;
};


export type MutationTagRelationshipDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationTagRelationshipUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTagRelationshipInput;
};


export type MutationTagSplitArgs = {
  id: Scalars['ID']['input'];
  nameForCurrentTag: MultilingualInput;
  namesForNewTags: Array<MultilingualInput>;
};


export type MutationTagSuggestionApproveArgs = {
  entityTypes: Array<EnumTagSuggestionEntityTypes>;
  id: Scalars['ID']['input'];
  name: MultilingualInput;
  tagGroup: Scalars['ID']['input'];
};


export type MutationTagSuggestionCreateArgs = {
  record: CreateOneTagSuggestionInput;
};


export type MutationTagSuggestionRejectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTagSuggestionUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTagSuggestionInput;
};


export type MutationTagUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTagInput;
};


export type MutationTaxCreateArgs = {
  record: CreateOneTaxInput;
};


export type MutationTaxRemoveArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationTaxUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTaxInput;
};


export type MutationTestRecordCreateArgs = {
  input: TestRecordCreateInput;
};


export type MutationTestRecordDeleteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationTestRecordDeleteAllArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationTestRecordResetArgs = {
  id: Scalars['MongoID']['input'];
  listingState?: InputMaybe<TestRecordListingState>;
  membershipState?: InputMaybe<TestRecordMembershipState>;
  tierTagId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTestRecordRunRenewalCheckArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationTestRecordSendClaimInviteArgs = {
  id: Scalars['MongoID']['input'];
};


export type MutationTestRecordSendRenewalEmailArgs = {
  id: Scalars['MongoID']['input'];
  kind: TestRenewalEmailKind;
};


export type MutationTestRecordSetShowInWidgetsArgs = {
  organizationId: Scalars['String']['input'];
  show: Scalars['Boolean']['input'];
};


export type MutationTestRecordSetSimulatedDateArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['MongoID']['input'];
};


export type MutationUpdateClosuresPerProductArgs = {
  closureId: Scalars['ID']['input'];
  deleteClosure: Scalars['Boolean']['input'];
  endISO?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startISO?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserApproveAccessArgs = {
  entity: EntityReferenceInput;
  userId: Scalars['ID']['input'];
};


export type MutationUserCreateArgs = {
  record: CreateOneUserInput;
};


export type MutationUserCreateConfirmationCodeArgs = {
  _id: Scalars['ID']['input'];
  confirmationCodeType: EnumConfirmationCodeType;
  email: Scalars['String']['input'];
};


export type MutationUserCreateInviteArgs = {
  contactRoles?: InputMaybe<Array<InputMaybe<ContactRole>>>;
  email: Scalars['String']['input'];
  emailPreferences?: InputMaybe<Array<InputMaybe<UserEmailPreferencesInput>>>;
  entity: EntityReferenceInput;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  photo?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<RoleType>;
  sendInvitationEmail: Scalars['Boolean']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserJoinOrganizationFromColdSignupArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type MutationUserRequestAccessArgs = {
  entity: EntityReferenceInput;
};


export type MutationUserResendConfirmationCodeArgs = {
  _id: Scalars['ID']['input'];
  sentToEmail: Scalars['String']['input'];
  type: EnumConfirmationCodeType;
};


export type MutationUserRevokeInviteArgs = {
  entity: EntityReferenceInput;
  primaryContactReplacementUserId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationUserSaveQuickLinksArgs = {
  _id: Scalars['MongoID']['input'];
  baseQuickLinks: Array<UserQuickLinksInput>;
  quickLinks: Array<UserQuickLinksInput>;
};


export type MutationUserUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdUserInput;
};


export type MutationUserValidateConfirmationCodeArgs = {
  _id: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};


export type MutationVideoCreateFromMuxArgs = {
  bytes?: InputMaybe<Scalars['Float']['input']>;
  defaultCaption?: InputMaybe<MultilingualInput>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  muxAssetId: Scalars['String']['input'];
  muxPlaybackId?: InputMaybe<Scalars['String']['input']>;
  muxStatus?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationVideoDeleteFromMuxOnlyArgs = {
  muxAssetId: Scalars['String']['input'];
};


export type MutationVideoMuxStatusRefreshArgs = {
  _id: Scalars['String']['input'];
};


export type MutationWhereabotChatCreateArgs = {
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWhereabotChatDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationWhereabotChatSendMessageArgs = {
  chatId: Scalars['MongoID']['input'];
  content: Scalars['String']['input'];
};


export type MutationWhereabotChatUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWhereabotHelpAskArgs = {
  history?: InputMaybe<Array<WhereabotHelpMessageInput>>;
  question: Scalars['String']['input'];
};


export type MutationWhereabotSettingsUpdateArgs = {
  chatModel: Scalars['String']['input'];
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWidgetCreateArgs = {
  record: CreateOneWidgetInput;
};


export type MutationWidgetDeleteByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationWidgetUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdWidgetInput;
};


export type MutationWorkbenchChangeRequestSummaryArgs = {
  featureFlagKey: Scalars['String']['input'];
  regenerate?: InputMaybe<Scalars['Boolean']['input']>;
  target: Scalars['String']['input'];
};


export type MutationWorkbenchChangeRequestsMarkIntegratedArgs = {
  featureFlagKey: Scalars['String']['input'];
  suggestionIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  target?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWorkbenchChatCreateArgs = {
  featureFlagKey: Scalars['String']['input'];
  testOrganizationId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationWorkbenchChatSendMessageArgs = {
  chatId: Scalars['MongoID']['input'];
  content: Scalars['String']['input'];
  sessionEvents?: InputMaybe<Array<WorkbenchSessionEventInput>>;
};


export type MutationWorkbenchExpelArgs = {
  featureFlagKey: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationWorkbenchPlanPushArgs = {
  docsContent?: InputMaybe<Scalars['String']['input']>;
  featureFlagKey: Scalars['String']['input'];
  planContent?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWorkbenchReinstateArgs = {
  featureFlagKey: Scalars['String']['input'];
};


export type MutationWorkbenchReviewCompleteArgs = {
  chatId: Scalars['MongoID']['input'];
};


export type MutationWorkbenchSeedCleanupArgs = {
  runId: Scalars['MongoID']['input'];
};


export type MutationWorkbenchSeedCreateArgs = {
  organizationId: Scalars['MongoID']['input'];
  scenarioKey: Scalars['String']['input'];
};


export type MutationWorkbenchSeedPreviewArgs = {
  organizationId: Scalars['MongoID']['input'];
  scenarioKey: Scalars['String']['input'];
};


export type MutationWorkbenchSeedRegenerateArgs = {
  runId: Scalars['MongoID']['input'];
};


export type MutationWorkbenchSetHelpScoutUrlArgs = {
  featureFlagKey: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWorkbenchSetTestOrganizationArgs = {
  featureFlagKey: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationWorkbenchSettingsUpdateArgs = {
  allowSeedingInProduction?: InputMaybe<Scalars['Boolean']['input']>;
  chatModel?: InputMaybe<WorkbenchModelTierInput>;
  defaultTestOrganizationId?: InputMaybe<Scalars['MongoID']['input']>;
  defaultTestStorefrontId?: InputMaybe<Scalars['MongoID']['input']>;
  summaryModel?: InputMaybe<WorkbenchModelTierInput>;
};


export type MutationWorkbenchSuggestionAcceptArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationWorkbenchSuggestionDismissArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationWorkbenchSuggestionUpdateStatusArgs = {
  _id: Scalars['MongoID']['input'];
  status: Scalars['String']['input'];
};


export type MutationWorkbenchTesterAddArgs = {
  featureFlagKey: Scalars['String']['input'];
  userIds: Array<Scalars['MongoID']['input']>;
};


export type MutationWorkbenchTesterRemoveArgs = {
  featureFlagKey: Scalars['String']['input'];
  userId: Scalars['MongoID']['input'];
};


export type MutationWorkbenchTestersContactArgs = {
  featureFlagKey: Scalars['String']['input'];
  message: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type Note = {
  __typename?: 'Note';
  _id: Scalars['MongoID']['output'];
  author?: Maybe<UserWithPictureTc>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  entity: EntityReference;
  isArchived: Scalars['Boolean']['output'];
  kind: EnumNoteKind;
  mentions: Array<User>;
  message: Scalars['String']['output'];
  noteDateISO?: Maybe<Scalars['String']['output']>;
  owner: Owner;
  resolvedBy?: Maybe<UserWithPictureTc>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type NumberInput = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _ne?: InputMaybe<Scalars['Int']['input']>;
};

export type Operator = {
  __typename?: 'Operator';
  _entityId: Scalars['MongoID']['output'];
  _id: Scalars['MongoID']['output'];
  _versionId: Scalars['MongoID']['output'];
  accommodationMetadata?: Maybe<AccommodationOperatorMetadata>;
  avgImageQuality?: Maybe<EnumOperatorAvgImageQuality>;
  canonicalDocument?: Maybe<Scalars['String']['output']>;
  claimed: Scalars['Boolean']['output'];
  connectedOrganization?: Maybe<Scalars['MongoID']['output']>;
  contact: Contact;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Multilingual>;
  enableMembershipLink: Scalars['Boolean']['output'];
  enrollments: Array<Maybe<OperatorEnrollments>>;
  experienceMetadata?: Maybe<ExperienceOperatorMetadata>;
  externalVideoLinks: Array<Maybe<OperatorExternalVideoLinks>>;
  hoursOfOperation?: Maybe<OperatorHoursOfOperation>;
  images: Array<AssetImage>;
  import: Scalars['JSON']['output'];
  name: Multilingual;
  operationalStatus: EnumOperatorOperationalStatus;
  pricing?: Maybe<EnumOperatorPricing>;
  restaurantMetadata?: Maybe<RestaurantOperatorMetadata>;
  searchName?: Maybe<Multilingual>;
  seasonality?: Maybe<Seasonality>;
  selectedTagGroups: Array<Maybe<Scalars['MongoID']['output']>>;
  serviceMetadata?: Maybe<ServiceOperatorMetadata>;
  shortDescription?: Maybe<Multilingual>;
  tags?: Maybe<OperatorTags>;
  toursMetadata?: Maybe<ToursOperatorMetadata>;
  type: EnumOperatorType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  whereabotDismissed?: Maybe<OperatorWhereabotDismissed>;
};


export type OperatorImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorAudienceDirectoryCounts = {
  __typename?: 'OperatorAudienceDirectoryCounts';
  noSelectedAudiences: Scalars['Int']['output'];
  notInWidgets: Scalars['Int']['output'];
  tagCounts: Array<OperatorAudienceTagCount>;
  usedInWidgets: Scalars['Int']['output'];
};

export type OperatorAudienceTagCount = {
  __typename?: 'OperatorAudienceTagCount';
  count: Scalars['Int']['output'];
  tagId: Scalars['ID']['output'];
};

export type OperatorBillingContactSearchResult = {
  __typename?: 'OperatorBillingContactSearchResult';
  _entityId: Scalars['MongoID']['output'];
  name: Multilingual;
  previewStaff: Array<OperatorBillingContactSearchStaff>;
  staffCount: Scalars['Int']['output'];
};

export type OperatorBillingContactSearchStaff = {
  __typename?: 'OperatorBillingContactSearchStaff';
  _id: Scalars['MongoID']['output'];
  contactRoles: Array<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isOwner: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type OperatorDetailsTc = {
  __typename?: 'OperatorDetailsTC';
  _entityId: Scalars['ID']['output'];
  contactRoles?: Maybe<Array<Maybe<ContactRole>>>;
  name?: Maybe<Multilingual>;
  organizations?: Maybe<Array<Maybe<OperatorOrganizationDetailsTc>>>;
  roleType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type OperatorDirectoryCounts = {
  __typename?: 'OperatorDirectoryCounts';
  allListings: Scalars['Int']['output'];
  archived: Scalars['Int']['output'];
  audienceCounts?: Maybe<OperatorAudienceDirectoryCounts>;
  closed: Scalars['Int']['output'];
  distinctTypes: Array<Scalars['String']['output']>;
  draft: Scalars['Int']['output'];
  hasClaimed: Scalars['Boolean']['output'];
  hasManaged: Scalars['Boolean']['output'];
  inviteQueue: Scalars['Int']['output'];
  needsAttention: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type OperatorEnrollments = {
  __typename?: 'OperatorEnrollments';
  currentStatus?: Maybe<EnumOperatorEnrollmentsCurrentStatus>;
  onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus;
  organization?: Maybe<Organization>;
  organizationControlled: Scalars['Boolean']['output'];
};

export type OperatorEnrollmentsInput = {
  currentStatus?: InputMaybe<EnumOperatorEnrollmentsCurrentStatus>;
  onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus;
  organization: Scalars['MongoID']['input'];
  organizationControlled: Scalars['Boolean']['input'];
};

export type OperatorExternalVideoLinks = {
  __typename?: 'OperatorExternalVideoLinks';
  _id?: Maybe<Scalars['MongoID']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type OperatorExternalVideoLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type OperatorHoursOfOperation = {
  __typename?: 'OperatorHoursOfOperation';
  fri?: Maybe<DateRangeIso>;
  /** Opening hours as plain `HH:mm` local wall-clock times, with no date or UTC offset. Prefer these over the ISO `start`/`end` fields for display. */
  localTimes?: Maybe<HoursOfOperationLocalTimes>;
  mon?: Maybe<DateRangeIso>;
  sat?: Maybe<DateRangeIso>;
  sun?: Maybe<DateRangeIso>;
  thu?: Maybe<DateRangeIso>;
  tue?: Maybe<DateRangeIso>;
  wed?: Maybe<DateRangeIso>;
};

export type OperatorHoursOfOperationInput = {
  fri?: InputMaybe<DateRangeIsoInput>;
  mon?: InputMaybe<DateRangeIsoInput>;
  sat?: InputMaybe<DateRangeIsoInput>;
  sun?: InputMaybe<DateRangeIsoInput>;
  thu?: InputMaybe<DateRangeIsoInput>;
  tue?: InputMaybe<DateRangeIsoInput>;
  wed?: InputMaybe<DateRangeIsoInput>;
};

export enum OperatorManyUseCaseEnum {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type OperatorManyWithOrganizationStatuses = {
  __typename?: 'OperatorManyWithOrganizationStatuses';
  _entityId: Scalars['MongoID']['output'];
  _versionId: Scalars['MongoID']['output'];
  name: Multilingual;
  operationalStatus?: Maybe<Scalars['String']['output']>;
  organizations: Array<OrganizationWithOperatorStatus>;
  type?: Maybe<EnumOperatorType>;
};

export enum OperatorManyWithOrganizationStatusesSortEnum {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type OperatorMember = {
  __typename?: 'OperatorMember';
  avatar?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OperatorMembership = {
  __typename?: 'OperatorMembership';
  contactEmail?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<Maybe<OperatorMember>>>;
  membershipPageUrl?: Maybe<Scalars['String']['output']>;
  operatorName: Multilingual;
  operatorStatus?: Maybe<OperatorStatus>;
  organizationLogo?: Maybe<Scalars['String']['output']>;
  organizationName: Multilingual;
};

export type OperatorOrganizationDetailsTc = {
  __typename?: 'OperatorOrganizationDetailsTC';
  _id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Multilingual>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum OperatorStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type OperatorTags = {
  __typename?: 'OperatorTags';
  amenity: Array<Tag>;
  businessType: Array<Tag>;
  global: Array<Tag>;
  organizationSpecific: Array<Tag>;
};

export type OperatorTagsInput = {
  amenity?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  businessType?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  global?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type OperatorWhereabotDismissPayload = {
  __typename?: 'OperatorWhereabotDismissPayload';
  success: Scalars['Boolean']['output'];
};

export type OperatorWhereabotDismissed = {
  __typename?: 'OperatorWhereabotDismissed';
  imageScan?: Maybe<Scalars['Date']['output']>;
  listingScan?: Maybe<Scalars['Date']['output']>;
};

export type OperatorWhereabotDismissedInput = {
  imageScan?: InputMaybe<Scalars['Date']['input']>;
  listingScan?: InputMaybe<Scalars['Date']['input']>;
};

export type OperatorWithOverrides = {
  __typename?: 'OperatorWithOverrides';
  _entityId: Scalars['MongoID']['output'];
  _id: Scalars['MongoID']['output'];
  _versionId: Scalars['MongoID']['output'];
  accommodationMetadata?: Maybe<AccommodationOperatorMetadata>;
  avgImageQuality?: Maybe<EnumOperatorAvgImageQuality>;
  canonicalDocument?: Maybe<Scalars['String']['output']>;
  claimed: Scalars['Boolean']['output'];
  connectedOrganization?: Maybe<Scalars['MongoID']['output']>;
  contact: Contact;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Multilingual>;
  enableMembershipLink: Scalars['Boolean']['output'];
  enrollments: Array<Maybe<OperatorEnrollments>>;
  experienceMetadata?: Maybe<ExperienceOperatorMetadata>;
  externalVideoLinks: Array<Maybe<OperatorExternalVideoLinks>>;
  hoursOfOperation?: Maybe<OperatorHoursOfOperation>;
  /** This is the invitedOrAcceptedStaffCount for the operator (shorted to iasc for JSON). A value of -1 means the input includeInvitedOrAcceptedStaffCounts was false. */
  iasc?: Maybe<Scalars['Int']['output']>;
  images: Array<AssetImage>;
  import: Scalars['JSON']['output'];
  name: Multilingual;
  operationalStatus: EnumOperatorOperationalStatus;
  overrides?: Maybe<OverrideDetails>;
  pricing?: Maybe<EnumOperatorPricing>;
  restaurantMetadata?: Maybe<RestaurantOperatorMetadata>;
  searchName?: Maybe<Multilingual>;
  seasonality?: Maybe<Seasonality>;
  selectedTagGroups: Array<TagGroup>;
  serviceMetadata?: Maybe<ServiceOperatorMetadata>;
  shortDescription?: Maybe<Multilingual>;
  staff: Array<User>;
  status?: Maybe<PublicationStatusType>;
  tags?: Maybe<OperatorTags>;
  toursMetadata?: Maybe<ToursOperatorMetadata>;
  type: EnumOperatorType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  whereabotDismissed?: Maybe<OperatorWhereabotDismissed>;
};


export type OperatorWithOverridesImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorWithStatus = {
  __typename?: 'OperatorWithStatus';
  _entityId: Scalars['MongoID']['output'];
  _id: Scalars['MongoID']['output'];
  _versionId: Scalars['MongoID']['output'];
  accommodationMetadata?: Maybe<AccommodationOperatorMetadata>;
  avgImageQuality?: Maybe<EnumOperatorAvgImageQuality>;
  canonicalDocument?: Maybe<Scalars['String']['output']>;
  claimed: Scalars['Boolean']['output'];
  connectedOrganization?: Maybe<Organization>;
  contact: Contact;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  /** The CrowdRiff gallery ID for this operator (organization-specific from OrgOperatorOverlay) */
  crowdriffGalleryId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Multilingual>;
  enableMembershipLink: Scalars['Boolean']['output'];
  enrollments: Array<Maybe<OperatorEnrollments>>;
  experienceMetadata?: Maybe<ExperienceOperatorMetadata>;
  externalVideoLinks: Array<Maybe<OperatorExternalVideoLinks>>;
  hoursOfOperation?: Maybe<OperatorHoursOfOperation>;
  /** This is the invitedOrAcceptedStaffCount for the operator (shorted to iasc for JSON). A value of -1 means the input includeInvitedOrAcceptedStaffCounts was false. */
  iasc?: Maybe<Scalars['Int']['output']>;
  images: Array<AssetImage>;
  import: Scalars['JSON']['output'];
  name: Multilingual;
  operationalStatus: EnumOperatorOperationalStatus;
  pricing?: Maybe<EnumOperatorPricing>;
  restaurantMetadata?: Maybe<RestaurantOperatorMetadata>;
  searchName?: Maybe<Multilingual>;
  seasonality?: Maybe<Seasonality>;
  selectedTagGroups: Array<TagGroup>;
  serviceMetadata?: Maybe<ServiceOperatorMetadata>;
  shortDescription?: Maybe<Multilingual>;
  staff: Array<User>;
  status?: Maybe<PublicationStatusType>;
  tags?: Maybe<OperatorTags>;
  toursMetadata?: Maybe<ToursOperatorMetadata>;
  type: EnumOperatorType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  whereabotDismissed?: Maybe<OperatorWhereabotDismissed>;
};


export type OperatorWithStatusImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorWithStatusAndStaff = {
  __typename?: 'OperatorWithStatusAndStaff';
  _entityId: Scalars['MongoID']['output'];
  _id: Scalars['MongoID']['output'];
  _versionId: Scalars['MongoID']['output'];
  accommodationMetadata?: Maybe<AccommodationOperatorMetadata>;
  avgImageQuality?: Maybe<EnumOperatorAvgImageQuality>;
  canonicalDocument?: Maybe<Scalars['String']['output']>;
  claimed: Scalars['Boolean']['output'];
  connectedOrganization?: Maybe<Scalars['MongoID']['output']>;
  contact: Contact;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Multilingual>;
  enableMembershipLink: Scalars['Boolean']['output'];
  enrollments: Array<Maybe<OperatorEnrollments>>;
  experienceMetadata?: Maybe<ExperienceOperatorMetadata>;
  externalVideoLinks: Array<Maybe<OperatorExternalVideoLinks>>;
  hoursOfOperation?: Maybe<OperatorHoursOfOperation>;
  /** This is the invitedOrAcceptedStaffCount for the operator (shorted to iasc for JSON). A value of -1 means the input includeInvitedOrAcceptedStaffCounts was false. */
  iasc?: Maybe<Scalars['Int']['output']>;
  images: Array<AssetImage>;
  import: Scalars['JSON']['output'];
  name: Multilingual;
  operationalStatus: EnumOperatorOperationalStatus;
  pricing?: Maybe<EnumOperatorPricing>;
  restaurantMetadata?: Maybe<RestaurantOperatorMetadata>;
  searchName?: Maybe<Multilingual>;
  seasonality?: Maybe<Seasonality>;
  selectedTagGroups: Array<Maybe<Scalars['MongoID']['output']>>;
  serviceMetadata?: Maybe<ServiceOperatorMetadata>;
  shortDescription?: Maybe<Multilingual>;
  staff: Array<User>;
  status?: Maybe<PublicationStatusType>;
  tags?: Maybe<OperatorTags>;
  toursMetadata?: Maybe<ToursOperatorMetadata>;
  type: EnumOperatorType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  whereabotDismissed?: Maybe<OperatorWhereabotDismissed>;
};


export type OperatorWithStatusAndStaffImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Order = {
  __typename?: 'Order';
  _id: Scalars['String']['output'];
  additionalLineItems: Array<Maybe<OrderAdditionalLineItems>>;
  approval?: Maybe<OrderApproval>;
  arrivalHistory: Array<Maybe<OrderArrivalHistory>>;
  billing?: Maybe<OrderBilling>;
  billingAddress?: Maybe<Address>;
  cancelled: Scalars['Boolean']['output'];
  /** Cents written off as complimentary on the invoice that settled this order. Shown on customer receipts. */
  complimentaryAmount: Scalars['Int']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  customer?: Maybe<SimplePersonTc>;
  delivery?: Maybe<OrderDelivery>;
  discounts: Array<Maybe<Discount>>;
  fulfillment?: Maybe<OrderFulfillment>;
  guests: Array<Maybe<OrderGuests>>;
  /** The latest non-revised accounting PaymentRequest linked to this order. */
  linkedPaymentRequest?: Maybe<PaymentRequest>;
  manualPaymentNote?: Maybe<OrderManualPaymentNote>;
  paymentMetadata: OrderPaymentMetadata;
  pricingSnapshot?: Maybe<OrderPricingSnapshot>;
  purchasedProducts: Array<Maybe<PurchasedProduct>>;
  source: OrderSource;
  stripeMetadata: StripeMetadata;
  surveyResponse?: Maybe<SurveyResponse>;
  taxExemption?: Maybe<OrderTaxExemption>;
  teamVisible: Scalars['Boolean']['output'];
  testMode: Scalars['Boolean']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type OrderAdditionalLineItems = {
  __typename?: 'OrderAdditionalLineItems';
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
};

export type OrderApproval = {
  __typename?: 'OrderApproval';
  decidedAt?: Maybe<Scalars['Date']['output']>;
  decidedBy?: Maybe<Scalars['MongoID']['output']>;
  declineReason?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  messageFromGuest?: Maybe<Scalars['String']['output']>;
  requestedAt: Scalars['Date']['output'];
  status: EnumOrderApprovalStatus;
};

export type OrderArrivalHistory = {
  __typename?: 'OrderArrivalHistory';
  action: EnumOrderArrivalHistoryAction;
  attendanceKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  guestIndexes: Array<Maybe<Scalars['Float']['output']>>;
  note?: Maybe<Scalars['String']['output']>;
  performedBy?: Maybe<Scalars['MongoID']['output']>;
  performedByName?: Maybe<Scalars['String']['output']>;
  sessionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source: EnumOrderArrivalHistorySource;
  timestamp: Scalars['String']['output'];
};

export type OrderBilling = {
  __typename?: 'OrderBilling';
  consolidation: EnumOrderBillingConsolidation;
  invoicePaymentRequestId?: Maybe<Scalars['MongoID']['output']>;
  serviceEndAt?: Maybe<Scalars['Date']['output']>;
  statementPeriod?: Maybe<Scalars['String']['output']>;
  timing: EnumOrderBillingTiming;
};

export type OrderCartPrice = {
  __typename?: 'OrderCartPrice';
  orderId: Scalars['String']['output'];
  prices?: Maybe<CartPrices>;
};

export type OrderDelivery = {
  __typename?: 'OrderDelivery';
  method: EnumOrderDeliveryMethod;
  pickupLocationAddress?: Maybe<Scalars['String']['output']>;
  pickupLocationId?: Maybe<Scalars['String']['output']>;
  pickupLocationName?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<Address>;
  shippingTotal: Scalars['Float']['output'];
  shippingZoneName?: Maybe<Scalars['String']['output']>;
};

export type OrderDeliveryInput = {
  method: OrderDeliveryMethodInput;
  pickupLocationId?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<DeliveryAddressInput>;
};

export enum OrderDeliveryMethodInput {
  Pickup = 'PICKUP',
  Ship = 'SHIP'
}

/** List of items with pagination. */
export type OrderFindMany = {
  __typename?: 'OrderFindMany';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Order>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type OrderFulfillment = {
  __typename?: 'OrderFulfillment';
  carrier?: Maybe<Scalars['String']['output']>;
  fulfilledAt?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EnumOrderFulfillmentStatus>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export type OrderGuests = {
  __typename?: 'OrderGuests';
  _id?: Maybe<Scalars['MongoID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  eventOptions?: Maybe<Array<Maybe<OrderGuestsEventOptions>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderGuestsEventOptions = {
  __typename?: 'OrderGuestsEventOptions';
  amount?: Maybe<Scalars['Float']['output']>;
  label: Scalars['String']['output'];
  sourceTransactionId?: Maybe<Scalars['String']['output']>;
};

export type OrderGuestsEventOptionsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  label: Scalars['String']['input'];
  sourceTransactionId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderGuestsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  eventOptions?: InputMaybe<Array<InputMaybe<OrderGuestsEventOptionsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrderManualPaymentNote = {
  __typename?: 'OrderManualPaymentNote';
  note: Scalars['String']['output'];
  recordedAt: Scalars['String']['output'];
};

export type OrderPricingSnapshot = {
  __typename?: 'OrderPricingSnapshot';
  customerFee: Scalars['Float']['output'];
  depositTotal: Scalars['Float']['output'];
  discountTotal: Scalars['Float']['output'];
  discountTotals?: Maybe<Array<Maybe<OrderPricingSnapshotDiscountTotals>>>;
  grandTotal: Scalars['Float']['output'];
  lineItems?: Maybe<Array<Maybe<OrderPricingSnapshotLineItems>>>;
  productPrices?: Maybe<Array<Maybe<OrderPricingSnapshotProductPrices>>>;
  shippingTotal?: Maybe<Scalars['Float']['output']>;
  subTotal: Scalars['Float']['output'];
  taxLines: Array<Maybe<OrderPricingSnapshotTaxLines>>;
  taxTotal: Scalars['Float']['output'];
};

export type OrderPricingSnapshotDiscountTotals = {
  __typename?: 'OrderPricingSnapshotDiscountTotals';
  discountId: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type OrderPricingSnapshotLineItems = {
  __typename?: 'OrderPricingSnapshotLineItems';
  amount: Scalars['Float']['output'];
  name: Multilingual;
  productId: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  tierId?: Maybe<Scalars['String']['output']>;
  unitPrice: Scalars['Float']['output'];
};

export type OrderPricingSnapshotProductPrices = {
  __typename?: 'OrderPricingSnapshotProductPrices';
  price: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
};

export type OrderPricingSnapshotTaxLines = {
  __typename?: 'OrderPricingSnapshotTaxLines';
  amount: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ratePercent?: Maybe<Scalars['Float']['output']>;
};

export type OrderSource = {
  __typename?: 'OrderSource';
  accountingCode?: Maybe<Scalars['String']['output']>;
  accountingDate?: Maybe<Scalars['String']['output']>;
  booker: Scalars['MongoID']['output'];
  broadcastId?: Maybe<Scalars['MongoID']['output']>;
  broadcastResourceId?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  customerInvoicePayment?: Maybe<Scalars['Boolean']['output']>;
  externalReference?: Maybe<Scalars['String']['output']>;
  internalAccountingNotes?: Maybe<Scalars['String']['output']>;
  operatorId?: Maybe<Scalars['MongoID']['output']>;
  operatorIds?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  paymentRequestId?: Maybe<Scalars['MongoID']['output']>;
  paymentRequestVersion?: Maybe<Scalars['Float']['output']>;
  renewablePurchaseId?: Maybe<Scalars['MongoID']['output']>;
  renewalNextDate?: Maybe<Scalars['String']['output']>;
  renewalRecordId?: Maybe<Scalars['MongoID']['output']>;
  renewalStatus?: Maybe<Scalars['String']['output']>;
  storefront: Scalars['MongoID']['output'];
  type?: Maybe<EnumOrderSourceType>;
};

export type OrderSourceInput = {
  accountingCode?: InputMaybe<Scalars['String']['input']>;
  accountingDate?: InputMaybe<Scalars['String']['input']>;
  booker: Scalars['MongoID']['input'];
  broadcastId?: InputMaybe<Scalars['MongoID']['input']>;
  broadcastResourceId?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  customerInvoicePayment?: InputMaybe<Scalars['Boolean']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  internalAccountingNotes?: InputMaybe<Scalars['String']['input']>;
  operatorId?: InputMaybe<Scalars['MongoID']['input']>;
  operatorIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  paymentRequestId?: InputMaybe<Scalars['MongoID']['input']>;
  paymentRequestVersion?: InputMaybe<Scalars['Float']['input']>;
  renewablePurchaseId?: InputMaybe<Scalars['MongoID']['input']>;
  renewalNextDate?: InputMaybe<Scalars['String']['input']>;
  renewalRecordId?: InputMaybe<Scalars['MongoID']['input']>;
  renewalStatus?: InputMaybe<Scalars['String']['input']>;
  storefront: Scalars['MongoID']['input'];
  type?: InputMaybe<EnumOrderSourceType>;
};

export type OrderTaxExemption = {
  __typename?: 'OrderTaxExemption';
  claimed: Scalars['Boolean']['output'];
  exemptionNumber: Scalars['String']['output'];
};

export type OrderTaxExemptionInput = {
  claimed: Scalars['Boolean']['input'];
  exemptionNumber: Scalars['String']['input'];
};

export type OrgOperatorOverlay = {
  __typename?: 'OrgOperatorOverlay';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  lastApprovedVersionId?: Maybe<Scalars['MongoID']['output']>;
  lastSeenVersionId?: Maybe<Scalars['MongoID']['output']>;
  operator: Scalars['MongoID']['output'];
  organization?: Maybe<Organization>;
  overlayPrivate?: Maybe<OrgOperatorOverlayOverlayPrivate>;
  overlayPublic?: Maybe<OrgOperatorOverlayOverlayPublic>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type OrgOperatorOverlayOverlayPrivate = {
  __typename?: 'OrgOperatorOverlayOverlayPrivate';
  note?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type OrgOperatorOverlayOverlayPrivateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type OrgOperatorOverlayOverlayPublic = {
  __typename?: 'OrgOperatorOverlayOverlayPublic';
  crowdriffGalleryId?: Maybe<Scalars['String']['output']>;
  publicProfileUrl?: Maybe<Scalars['String']['output']>;
};

export type OrgOperatorOverlayOverlayPublicInput = {
  crowdriffGalleryId?: InputMaybe<Scalars['String']['input']>;
  publicProfileUrl?: InputMaybe<Scalars['String']['input']>;
};

export type OrgOperatorOverlayUpsertInput = {
  lastApprovedVersionId?: InputMaybe<Scalars['MongoID']['input']>;
  lastSeenVersionId?: InputMaybe<Scalars['MongoID']['input']>;
  operatorId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
  overlayPrivate?: InputMaybe<OrgOperatorOverlayOverlayPrivateInput>;
  overlayPublic?: InputMaybe<OrgOperatorOverlayOverlayPublicInput>;
};

export type OrgOverviewRebuildResult = {
  __typename?: 'OrgOverviewRebuildResult';
  builtAt: Scalars['Date']['output'];
  eventsCount: Scalars['Int']['output'];
  listingsCount: Scalars['Int']['output'];
  peopleCount: Scalars['Int']['output'];
};

export type OrgOverviewResult = {
  __typename?: 'OrgOverviewResult';
  builtAt?: Maybe<Scalars['Date']['output']>;
  rows?: Maybe<Array<OrgOverviewRow>>;
};

export type OrgOverviewRow = {
  __typename?: 'OrgOverviewRow';
  _id: Scalars['ID']['output'];
  attendeeCount?: Maybe<Scalars['Int']['output']>;
  attendeeSessionDate?: Maybe<Scalars['String']['output']>;
  attendeeSessionDateCount?: Maybe<Scalars['Int']['output']>;
  attendeeStorefrontId?: Maybe<Scalars['String']['output']>;
  customTagNames: Array<Scalars['String']['output']>;
  entityId: Scalars['ID']['output'];
  entityType: Scalars['String']['output'];
  eventCount?: Maybe<Scalars['Int']['output']>;
  eventEndDate?: Maybe<Scalars['String']['output']>;
  eventStartDate?: Maybe<Scalars['String']['output']>;
  financialContactName?: Maybe<Scalars['String']['output']>;
  invoiceStorefrontId?: Maybe<Scalars['String']['output']>;
  membershipRenewalDate?: Maybe<Scalars['Date']['output']>;
  membershipStatusNames: Array<Scalars['String']['output']>;
  membershipTierName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  noteCount: Scalars['Int']['output'];
  paidInvoiceCount: Scalars['Int']['output'];
  paidInvoiceNumbers: Array<Scalars['String']['output']>;
  paidInvoiceTotal: Scalars['Float']['output'];
  peopleCount?: Maybe<Scalars['Int']['output']>;
  primaryContactName?: Maybe<Scalars['String']['output']>;
  primaryTag?: Maybe<Scalars['String']['output']>;
  recurrenceType?: Maybe<Scalars['String']['output']>;
  searchText: Scalars['String']['output'];
  staffNames?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<Scalars['String']['output']>;
  unpaidInvoiceCount: Scalars['Int']['output'];
  unpaidInvoiceNumbers: Array<Scalars['String']['output']>;
  unpaidInvoiceStorefrontId?: Maybe<Scalars['String']['output']>;
  unpaidInvoiceTotal: Scalars['Float']['output'];
};

export type OrgSendTestEmailsResult = {
  __typename?: 'OrgSendTestEmailsResult';
  failed?: Maybe<Array<OrgTestEmailFailure>>;
  sentCount: Scalars['Int']['output'];
};

export type OrgTestEmailFailure = {
  __typename?: 'OrgTestEmailFailure';
  emailType: OrgTestEmailType;
  error: Scalars['String']['output'];
};

export enum OrgTestEmailType {
  Freshen = 'FRESHEN',
  OperatorInvite = 'OPERATOR_INVITE',
  PingAgain = 'PING_AGAIN',
  SignInInvite = 'SIGN_IN_INVITE',
  SignUpInvite = 'SIGN_UP_INVITE'
}

export type Organization = {
  __typename?: 'Organization';
  _id: Scalars['MongoID']['output'];
  appSettings?: Maybe<OrganizationAppSettings>;
  brandColors: Array<Maybe<Scalars['String']['output']>>;
  contact?: Maybe<Contact>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Multilingual>;
  domains: Array<Maybe<Scalars['String']['output']>>;
  emailBranding?: Maybe<OrganizationEmailBranding>;
  images: Array<AssetImage>;
  license?: Maybe<OrganizationLicense>;
  logo?: Maybe<AssetImage>;
  metadata?: Maybe<OrganizationMetadata>;
  name: Multilingual;
  onboardingMetadata: OrganizationOnboardingMetadata;
  shortDescription?: Maybe<Multilingual>;
  shortName: Scalars['String']['output'];
  subdomain?: Maybe<Scalars['String']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type OrganizationAppSettings = {
  __typename?: 'OrganizationAppSettings';
  widgets?: Maybe<OrganizationAppSettingsWidgets>;
};

export type OrganizationAppSettingsInput = {
  widgets?: InputMaybe<OrganizationAppSettingsWidgetsInput>;
};

export type OrganizationAppSettingsWidgets = {
  __typename?: 'OrganizationAppSettingsWidgets';
  event?: Maybe<OrganizationAppSettingsWidgetsEvent>;
  operator?: Maybe<OrganizationAppSettingsWidgetsOperator>;
  whatsNearby?: Maybe<OrganizationAppSettingsWidgetsWhatsNearby>;
};

export type OrganizationAppSettingsWidgetsEvent = {
  __typename?: 'OrganizationAppSettingsWidgetsEvent';
  hideCancelledEvents?: Maybe<Scalars['Boolean']['output']>;
  organizerAudienceTagFilters?: Maybe<Array<Maybe<OrganizationAppSettingsWidgetsEventOrganizerAudienceTagFilters>>>;
  venueAudienceTagFilters?: Maybe<Array<Maybe<OrganizationAppSettingsWidgetsEventVenueAudienceTagFilters>>>;
};

export type OrganizationAppSettingsWidgetsEventInput = {
  hideCancelledEvents?: InputMaybe<Scalars['Boolean']['input']>;
  organizerAudienceTagFilters?: InputMaybe<Array<InputMaybe<OrganizationAppSettingsWidgetsEventOrganizerAudienceTagFiltersInput>>>;
  venueAudienceTagFilters?: InputMaybe<Array<InputMaybe<OrganizationAppSettingsWidgetsEventVenueAudienceTagFiltersInput>>>;
};

export type OrganizationAppSettingsWidgetsEventOrganizerAudienceTagFilters = {
  __typename?: 'OrganizationAppSettingsWidgetsEventOrganizerAudienceTagFilters';
  mode: EnumOrganizationAppSettingsWidgetsEventOrganizerAudienceTagFiltersMode;
  tagId: Scalars['MongoID']['output'];
};

export type OrganizationAppSettingsWidgetsEventOrganizerAudienceTagFiltersInput = {
  mode: EnumOrganizationAppSettingsWidgetsEventOrganizerAudienceTagFiltersMode;
  tagId: Scalars['MongoID']['input'];
};

export type OrganizationAppSettingsWidgetsEventVenueAudienceTagFilters = {
  __typename?: 'OrganizationAppSettingsWidgetsEventVenueAudienceTagFilters';
  mode: EnumOrganizationAppSettingsWidgetsEventVenueAudienceTagFiltersMode;
  tagId: Scalars['MongoID']['output'];
};

export type OrganizationAppSettingsWidgetsEventVenueAudienceTagFiltersInput = {
  mode: EnumOrganizationAppSettingsWidgetsEventVenueAudienceTagFiltersMode;
  tagId: Scalars['MongoID']['input'];
};

export type OrganizationAppSettingsWidgetsInput = {
  event?: InputMaybe<OrganizationAppSettingsWidgetsEventInput>;
  operator?: InputMaybe<OrganizationAppSettingsWidgetsOperatorInput>;
  whatsNearby?: InputMaybe<OrganizationAppSettingsWidgetsWhatsNearbyInput>;
};

export type OrganizationAppSettingsWidgetsOperator = {
  __typename?: 'OrganizationAppSettingsWidgetsOperator';
  audienceTagFilters?: Maybe<Array<Maybe<OrganizationAppSettingsWidgetsOperatorAudienceTagFilters>>>;
  audienceTagIds?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  /** When defaultImageMode is CUSTOM_IMAGE, the resolved placeholder AssetImage. */
  customDefaultFallbackImage?: Maybe<AssetImage>;
  defaultImageId?: Maybe<Scalars['String']['output']>;
  defaultImageMode?: Maybe<EnumOrganizationAppSettingsWidgetsOperatorDefaultImageMode>;
  hidePermanentlyClosed?: Maybe<Scalars['Boolean']['output']>;
  hideTemporarilyClosed?: Maybe<Scalars['Boolean']['output']>;
  operatorWidgetFilter?: Maybe<EnumOrganizationAppSettingsWidgetsOperatorOperatorWidgetFilter>;
  prioritizeClaimedAndDmoManaged?: Maybe<Scalars['Boolean']['output']>;
  showPermanentlyClosed?: Maybe<Scalars['Boolean']['output']>;
  showTestListings?: Maybe<Scalars['Boolean']['output']>;
  tierDisplayOverrides?: Maybe<Array<Maybe<OrganizationAppSettingsWidgetsOperatorTierDisplayOverrides>>>;
  tieredSortOrder?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type OrganizationAppSettingsWidgetsOperatorAudienceTagFilters = {
  __typename?: 'OrganizationAppSettingsWidgetsOperatorAudienceTagFilters';
  mode: EnumOrganizationAppSettingsWidgetsOperatorAudienceTagFiltersMode;
  tagId: Scalars['MongoID']['output'];
};

export type OrganizationAppSettingsWidgetsOperatorAudienceTagFiltersInput = {
  mode: EnumOrganizationAppSettingsWidgetsOperatorAudienceTagFiltersMode;
  tagId: Scalars['MongoID']['input'];
};

export type OrganizationAppSettingsWidgetsOperatorInput = {
  audienceTagFilters?: InputMaybe<Array<InputMaybe<OrganizationAppSettingsWidgetsOperatorAudienceTagFiltersInput>>>;
  audienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultImageId?: InputMaybe<Scalars['String']['input']>;
  defaultImageMode?: InputMaybe<EnumOrganizationAppSettingsWidgetsOperatorDefaultImageMode>;
  hidePermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  hideTemporarilyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  operatorWidgetFilter?: InputMaybe<EnumOrganizationAppSettingsWidgetsOperatorOperatorWidgetFilter>;
  prioritizeClaimedAndDmoManaged?: InputMaybe<Scalars['Boolean']['input']>;
  showPermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  showTestListings?: InputMaybe<Scalars['Boolean']['input']>;
  tierDisplayOverrides?: InputMaybe<Array<InputMaybe<OrganizationAppSettingsWidgetsOperatorTierDisplayOverridesInput>>>;
  tieredSortOrder?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type OrganizationAppSettingsWidgetsOperatorTierDisplayOverrides = {
  __typename?: 'OrganizationAppSettingsWidgetsOperatorTierDisplayOverrides';
  slideout?: Maybe<OrganizationAppSettingsWidgetsOperatorTierDisplayOverridesSlideout>;
  statusSortOrder?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  tagId: Scalars['MongoID']['output'];
  teaser?: Maybe<OrganizationAppSettingsWidgetsOperatorTierDisplayOverridesTeaser>;
};

export type OrganizationAppSettingsWidgetsOperatorTierDisplayOverridesInput = {
  slideout?: InputMaybe<OrganizationAppSettingsWidgetsOperatorTierDisplayOverridesSlideoutInput>;
  statusSortOrder?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagId: Scalars['MongoID']['input'];
  teaser?: InputMaybe<OrganizationAppSettingsWidgetsOperatorTierDisplayOverridesTeaserInput>;
};

export type OrganizationAppSettingsWidgetsOperatorTierDisplayOverridesSlideout = {
  __typename?: 'OrganizationAppSettingsWidgetsOperatorTierDisplayOverridesSlideout';
  hideAddress?: Maybe<Scalars['Boolean']['output']>;
  hideExternalLinks?: Maybe<Scalars['Boolean']['output']>;
  hideLongDescription?: Maybe<Scalars['Boolean']['output']>;
  hideMap?: Maybe<Scalars['Boolean']['output']>;
  hideOperatingHours?: Maybe<Scalars['Boolean']['output']>;
  limitImages?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationAppSettingsWidgetsOperatorTierDisplayOverridesSlideoutInput = {
  hideAddress?: InputMaybe<Scalars['Boolean']['input']>;
  hideExternalLinks?: InputMaybe<Scalars['Boolean']['input']>;
  hideLongDescription?: InputMaybe<Scalars['Boolean']['input']>;
  hideMap?: InputMaybe<Scalars['Boolean']['input']>;
  hideOperatingHours?: InputMaybe<Scalars['Boolean']['input']>;
  limitImages?: InputMaybe<Scalars['Float']['input']>;
};

export type OrganizationAppSettingsWidgetsOperatorTierDisplayOverridesTeaser = {
  __typename?: 'OrganizationAppSettingsWidgetsOperatorTierDisplayOverridesTeaser';
  hideImage?: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationAppSettingsWidgetsOperatorTierDisplayOverridesTeaserInput = {
  hideImage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationAppSettingsWidgetsWhatsNearby = {
  __typename?: 'OrganizationAppSettingsWidgetsWhatsNearby';
  audienceTagFilters?: Maybe<Array<Maybe<OrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFilters>>>;
  audienceTagIds?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type OrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFilters = {
  __typename?: 'OrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFilters';
  mode: EnumOrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFiltersMode;
  tagId: Scalars['MongoID']['output'];
};

export type OrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFiltersInput = {
  mode: EnumOrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFiltersMode;
  tagId: Scalars['MongoID']['input'];
};

export type OrganizationAppSettingsWidgetsWhatsNearbyInput = {
  audienceTagFilters?: InputMaybe<Array<InputMaybe<OrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFiltersInput>>>;
  audienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type OrganizationControlledFilterInput = {
  isControlled: Scalars['Boolean']['input'];
  organizationId: Scalars['String']['input'];
};

export type OrganizationDeletePayload = {
  __typename?: 'OrganizationDeletePayload';
  deletedOrganizationId?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type OrganizationDetailsTc = {
  __typename?: 'OrganizationDetailsTC';
  _id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Multilingual>;
  roleType?: Maybe<Scalars['String']['output']>;
};

export type OrganizationEmailBranding = {
  __typename?: 'OrganizationEmailBranding';
  accentColor?: Maybe<Scalars['String']['output']>;
  footerText?: Maybe<Multilingual>;
  fromName?: Maybe<Scalars['String']['output']>;
  replyTo?: Maybe<Scalars['String']['output']>;
  showContact?: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationEmailBrandingInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  footerText?: InputMaybe<MultilingualInput>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationEmailDomain = {
  __typename?: 'OrganizationEmailDomain';
  _id: Scalars['MongoID']['output'];
  activatedAt?: Maybe<Scalars['Date']['output']>;
  allowNonProductionSending: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  disabledAt?: Maybe<Scalars['Date']['output']>;
  dnsRecords?: Maybe<OrganizationEmailDomainDnsRecords>;
  domain: Scalars['String']['output'];
  fromAddress: Scalars['String']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  lastValidatedAt?: Maybe<Scalars['Date']['output']>;
  organizationId: Scalars['MongoID']['output'];
  previousStatus?: Maybe<EnumOrganizationEmailDomainPreviousStatus>;
  requestedAt?: Maybe<Scalars['Date']['output']>;
  requestedBy?: Maybe<Scalars['MongoID']['output']>;
  sendgridDomainId?: Maybe<Scalars['Float']['output']>;
  status: EnumOrganizationEmailDomainStatus;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  validationResults?: Maybe<OrganizationEmailDomainValidationResults>;
};

export type OrganizationEmailDomainCheckResult = {
  __typename?: 'OrganizationEmailDomainCheckResult';
  message: Scalars['String']['output'];
  passed: Scalars['Boolean']['output'];
};

export type OrganizationEmailDomainDnsRecords = {
  __typename?: 'OrganizationEmailDomainDnsRecords';
  dkim1: OrganizationEmailDomainDnsRecordsMailCname;
  dkim2: OrganizationEmailDomainDnsRecordsMailCname;
  mailCname: OrganizationEmailDomainDnsRecordsMailCname;
};

export type OrganizationEmailDomainDnsRecordsMailCname = {
  __typename?: 'OrganizationEmailDomainDnsRecordsMailCname';
  data: Scalars['String']['output'];
  host: Scalars['String']['output'];
  type: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export type OrganizationEmailDomainRunChecksResult = {
  __typename?: 'OrganizationEmailDomainRunChecksResult';
  config?: Maybe<OrganizationEmailDomain>;
  liveTestSend?: Maybe<OrganizationEmailDomainCheckResult>;
  sendgridValidation: OrganizationEmailDomainCheckResult;
};

export type OrganizationEmailDomainValidationResults = {
  __typename?: 'OrganizationEmailDomainValidationResults';
  dkim1?: Maybe<OrganizationEmailDomainValidationResultsMailCname>;
  dkim2?: Maybe<OrganizationEmailDomainValidationResultsMailCname>;
  mailCname?: Maybe<OrganizationEmailDomainValidationResultsMailCname>;
  spf?: Maybe<OrganizationEmailDomainValidationResultsMailCname>;
};

export type OrganizationEmailDomainValidationResultsMailCname = {
  __typename?: 'OrganizationEmailDomainValidationResultsMailCname';
  reason?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type OrganizationEventPartnerSettings = {
  __typename?: 'OrganizationEventPartnerSettings';
  partners?: Maybe<Array<OrganizationPartnerSummary>>;
  sharingCode: Scalars['String']['output'];
  subscribers?: Maybe<Array<OrganizationPartnerSummary>>;
  suggestions?: Maybe<Array<OrganizationPartnerSummary>>;
};

export type OrganizationEventWidgetSettings = {
  __typename?: 'OrganizationEventWidgetSettings';
  hideCancelledEvents: Scalars['Boolean']['output'];
};

export type OrganizationLicense = {
  __typename?: 'OrganizationLicense';
  _id?: Maybe<Scalars['MongoID']['output']>;
  activatedBy?: Maybe<UserWithPictureTc>;
  activatedDate?: Maybe<Scalars['Date']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationLicenseInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  activatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  activatedDate?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationManifest = {
  __typename?: 'OrganizationManifest';
  _id: Scalars['MongoID']['output'];
  assetCounts: OrganizationManifestAssetCounts;
  assets: OrganizationManifestAssets;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  deletionLog?: Maybe<OrganizationManifestDeletionLog>;
  generatedAt: Scalars['Date']['output'];
  generatedBy: Scalars['MongoID']['output'];
  manifestErrors: Array<Maybe<OrganizationManifestManifestErrors>>;
  organizationDeleted?: Maybe<OrganizationManifestOrganizationDeleted>;
  organizationId: Scalars['MongoID']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type OrganizationManifestAssetCounts = {
  __typename?: 'OrganizationManifestAssetCounts';
  activityLogs: Scalars['Float']['output'];
  broadcasts: Scalars['Float']['output'];
  customTags: Scalars['Float']['output'];
  events: Scalars['Float']['output'];
  images: Scalars['Float']['output'];
  importRuns: Scalars['Float']['output'];
  imports: Scalars['Float']['output'];
  lists: Scalars['Float']['output'];
  notes: Scalars['Float']['output'];
  operators?: Maybe<OrganizationManifestAssetCountsOperators>;
  people?: Maybe<OrganizationManifestAssetCountsPeople>;
  users: Scalars['Float']['output'];
  widgets: Scalars['Float']['output'];
};

export type OrganizationManifestAssetCountsOperators = {
  __typename?: 'OrganizationManifestAssetCountsOperators';
  toDelete: Scalars['Float']['output'];
  toDisconnect: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type OrganizationManifestAssetCountsPeople = {
  __typename?: 'OrganizationManifestAssetCountsPeople';
  toDelete: Scalars['Float']['output'];
  toDisconnect: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type OrganizationManifestAssets = {
  __typename?: 'OrganizationManifestAssets';
  activityLogs?: Maybe<Array<Maybe<OrganizationManifestAssetsPeople>>>;
  broadcasts?: Maybe<Array<Maybe<OrganizationManifestAssetsPeople>>>;
  customTags?: Maybe<Array<Maybe<OrganizationManifestAssetsPeople>>>;
  events?: Maybe<Array<Maybe<OrganizationManifestAssetsPeople>>>;
  images?: Maybe<Array<Maybe<OrganizationManifestAssetsPeople>>>;
  importRuns?: Maybe<Array<Maybe<OrganizationManifestAssetsPeople>>>;
  imports?: Maybe<Array<Maybe<OrganizationManifestAssetsPeople>>>;
  lists?: Maybe<Array<Maybe<OrganizationManifestAssetsPeople>>>;
  notes?: Maybe<Array<Maybe<OrganizationManifestAssetsPeople>>>;
  operators?: Maybe<Array<Maybe<OrganizationManifestAssetsPeople>>>;
  people?: Maybe<Array<Maybe<OrganizationManifestAssetsPeople>>>;
  widgets?: Maybe<Array<Maybe<OrganizationManifestAssetsPeople>>>;
};

export type OrganizationManifestAssetsPeople = {
  __typename?: 'OrganizationManifestAssetsPeople';
  _id: Scalars['String']['output'];
  action: EnumOrganizationManifestAssetsPeopleAction;
  entityId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OrganizationManifestDeletionLog = {
  __typename?: 'OrganizationManifestDeletionLog';
  completedAt: Scalars['Date']['output'];
  completedBy: Scalars['MongoID']['output'];
  deletionErrors?: Maybe<Array<Maybe<OrganizationManifestDeletionLogDeletionErrors>>>;
  results?: Maybe<OrganizationManifestDeletionLogResults>;
};

export type OrganizationManifestDeletionLogDeletionErrors = {
  __typename?: 'OrganizationManifestDeletionLogDeletionErrors';
  assetId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrganizationManifestDeletionLogResults = {
  __typename?: 'OrganizationManifestDeletionLogResults';
  activityLogs?: Maybe<OrganizationManifestDeletionLogResultsActivityLogs>;
  broadcasts?: Maybe<OrganizationManifestDeletionLogResultsBroadcasts>;
  events?: Maybe<OrganizationManifestDeletionLogResultsEvents>;
  images?: Maybe<OrganizationManifestDeletionLogResultsImages>;
  importRuns?: Maybe<OrganizationManifestDeletionLogResultsImportRuns>;
  imports?: Maybe<OrganizationManifestDeletionLogResultsImports>;
  lists?: Maybe<OrganizationManifestDeletionLogResultsLists>;
  notes?: Maybe<OrganizationManifestDeletionLogResultsNotes>;
  operators?: Maybe<OrganizationManifestDeletionLogResultsOperators>;
  people?: Maybe<OrganizationManifestDeletionLogResultsPeople>;
  widgets?: Maybe<OrganizationManifestDeletionLogResultsWidgets>;
};

export type OrganizationManifestDeletionLogResultsActivityLogs = {
  __typename?: 'OrganizationManifestDeletionLogResultsActivityLogs';
  deleted?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationManifestDeletionLogResultsBroadcasts = {
  __typename?: 'OrganizationManifestDeletionLogResultsBroadcasts';
  deleted?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationManifestDeletionLogResultsEvents = {
  __typename?: 'OrganizationManifestDeletionLogResultsEvents';
  deleted?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationManifestDeletionLogResultsImages = {
  __typename?: 'OrganizationManifestDeletionLogResultsImages';
  deleted?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationManifestDeletionLogResultsImportRuns = {
  __typename?: 'OrganizationManifestDeletionLogResultsImportRuns';
  deleted?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationManifestDeletionLogResultsImports = {
  __typename?: 'OrganizationManifestDeletionLogResultsImports';
  deleted?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationManifestDeletionLogResultsLists = {
  __typename?: 'OrganizationManifestDeletionLogResultsLists';
  deleted?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationManifestDeletionLogResultsNotes = {
  __typename?: 'OrganizationManifestDeletionLogResultsNotes';
  deleted?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationManifestDeletionLogResultsOperators = {
  __typename?: 'OrganizationManifestDeletionLogResultsOperators';
  deleted?: Maybe<Scalars['Float']['output']>;
  disconnected?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationManifestDeletionLogResultsPeople = {
  __typename?: 'OrganizationManifestDeletionLogResultsPeople';
  deleted?: Maybe<Scalars['Float']['output']>;
  disconnected?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationManifestDeletionLogResultsWidgets = {
  __typename?: 'OrganizationManifestDeletionLogResultsWidgets';
  deleted?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationManifestManifestErrors = {
  __typename?: 'OrganizationManifestManifestErrors';
  _id?: Maybe<Scalars['MongoID']['output']>;
  assetId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrganizationManifestOrganizationDeleted = {
  __typename?: 'OrganizationManifestOrganizationDeleted';
  deletedAt?: Maybe<Scalars['Date']['output']>;
  deletedBy?: Maybe<Scalars['MongoID']['output']>;
};

export type OrganizationMetadata = {
  __typename?: 'OrganizationMetadata';
  _id?: Maybe<Scalars['MongoID']['output']>;
  canEnableMembershipLink?: Maybe<Scalars['Boolean']['output']>;
  claimedListingStaleDays?: Maybe<Scalars['Float']['output']>;
  connectedOperator?: Maybe<Scalars['MongoID']['output']>;
  connectedStorefront?: Maybe<Scalars['MongoID']['output']>;
  connectedTestStorefront?: Maybe<Scalars['MongoID']['output']>;
  connectedUsdStorefront?: Maybe<Scalars['MongoID']['output']>;
  connectedUsdTestStorefront?: Maybe<Scalars['MongoID']['output']>;
  crowdriffEnabled?: Maybe<Scalars['Boolean']['output']>;
  customClaimEmailBody?: Maybe<Scalars['String']['output']>;
  customClaimEmailSubject?: Maybe<Scalars['String']['output']>;
  customPingEmailBody?: Maybe<Scalars['String']['output']>;
  customPingEmailSubject?: Maybe<Scalars['String']['output']>;
  disabledApps?: Maybe<Array<Maybe<EnumOrganizationMetadataDisabledApps>>>;
  dmoListingStaleDays?: Maybe<Scalars['Float']['output']>;
  eventLookaheadMonths?: Maybe<Scalars['Float']['output']>;
  externalVideoEnabled?: Maybe<Scalars['Boolean']['output']>;
  individualMembershipTiers?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  internalOnly?: Maybe<Scalars['Boolean']['output']>;
  inviteWhenAddingStaff?: Maybe<Scalars['Boolean']['output']>;
  listingAudienceTagIds?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  listingFreshnessEnabled?: Maybe<Scalars['Boolean']['output']>;
  membershipBroadcastId?: Maybe<Scalars['MongoID']['output']>;
  membershipHub?: Maybe<OrganizationMetadataMembershipHub>;
  membershipLaunch?: Maybe<OrganizationMetadataMembershipLaunch>;
  membershipPageUrl?: Maybe<Scalars['String']['output']>;
  membershipPaymentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  membershipStatusTagIds?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  membershipTierCheckouts?: Maybe<Array<Maybe<OrganizationMetadataMembershipTierCheckouts>>>;
  membershipTiers?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  nomenclature?: Maybe<OrganizationMetadataNomenclature>;
  operatorOnboardingDisabled?: Maybe<Scalars['Boolean']['output']>;
  renewalSettings?: Maybe<OrganizationMetadataRenewalSettings>;
  sandbox?: Maybe<Scalars['Boolean']['output']>;
  storefrontMode?: Maybe<EnumOrganizationMetadataStorefrontMode>;
  storefrontOrgConnectionsEnabled?: Maybe<Scalars['Boolean']['output']>;
  testRecordTagId?: Maybe<Scalars['MongoID']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  whereabotImageDownloadPrompt?: Maybe<Scalars['String']['output']>;
  whereabotListingUpdatePrompt?: Maybe<Scalars['String']['output']>;
};

export type OrganizationMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  canEnableMembershipLink?: InputMaybe<Scalars['Boolean']['input']>;
  claimedListingStaleDays?: InputMaybe<Scalars['Float']['input']>;
  connectedOperator?: InputMaybe<Scalars['MongoID']['input']>;
  connectedStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  connectedTestStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  connectedUsdStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  connectedUsdTestStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  crowdriffEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  customClaimEmailBody?: InputMaybe<Scalars['String']['input']>;
  customClaimEmailSubject?: InputMaybe<Scalars['String']['input']>;
  customPingEmailBody?: InputMaybe<Scalars['String']['input']>;
  customPingEmailSubject?: InputMaybe<Scalars['String']['input']>;
  disabledApps?: InputMaybe<Array<InputMaybe<EnumOrganizationMetadataDisabledApps>>>;
  dmoListingStaleDays?: InputMaybe<Scalars['Float']['input']>;
  eventLookaheadMonths?: InputMaybe<Scalars['Float']['input']>;
  eventPartnerOrganizations?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  eventSharingCode?: InputMaybe<Scalars['String']['input']>;
  externalVideoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  individualMembershipTiers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  internalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inviteWhenAddingStaff?: InputMaybe<Scalars['Boolean']['input']>;
  listingAudienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  listingFreshnessEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  membershipBroadcastId?: InputMaybe<Scalars['MongoID']['input']>;
  membershipHub?: InputMaybe<OrganizationMetadataMembershipHubInput>;
  membershipLaunch?: InputMaybe<OrganizationMetadataMembershipLaunchInput>;
  membershipPageUrl?: InputMaybe<Scalars['String']['input']>;
  membershipPaymentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  membershipStatusTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  membershipTierCheckouts?: InputMaybe<Array<InputMaybe<OrganizationMetadataMembershipTierCheckoutsInput>>>;
  membershipTiers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  nomenclature?: InputMaybe<OrganizationMetadataNomenclatureInput>;
  operatorOnboardingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  renewalSettings?: InputMaybe<OrganizationMetadataRenewalSettingsInput>;
  sandbox?: InputMaybe<Scalars['Boolean']['input']>;
  storefrontMode?: InputMaybe<EnumOrganizationMetadataStorefrontMode>;
  storefrontOrgConnectionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  testRecordTagId?: InputMaybe<Scalars['MongoID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  whereabotImageDownloadPrompt?: InputMaybe<Scalars['String']['input']>;
  whereabotListingUpdatePrompt?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationMetadataMembershipHub = {
  __typename?: 'OrganizationMetadataMembershipHub';
  hideOfferFromForYou?: Maybe<Scalars['Boolean']['output']>;
  tiers?: Maybe<Array<Maybe<OrganizationMetadataMembershipHubTiers>>>;
};

export type OrganizationMetadataMembershipHubInput = {
  hideOfferFromForYou?: InputMaybe<Scalars['Boolean']['input']>;
  tiers?: InputMaybe<Array<InputMaybe<OrganizationMetadataMembershipHubTiersInput>>>;
};

export type OrganizationMetadataMembershipHubTiers = {
  __typename?: 'OrganizationMetadataMembershipHubTiers';
  applicationBroadcastId?: Maybe<Scalars['MongoID']['output']>;
  applicationResourceId?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Multilingual>;
  hideFromNewcomers?: Maybe<Scalars['Boolean']['output']>;
  tierTagId: Scalars['MongoID']['output'];
};

export type OrganizationMetadataMembershipHubTiersInput = {
  applicationBroadcastId?: InputMaybe<Scalars['MongoID']['input']>;
  applicationResourceId?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<MultilingualInput>;
  hideFromNewcomers?: InputMaybe<Scalars['Boolean']['input']>;
  tierTagId: Scalars['MongoID']['input'];
};

export type OrganizationMetadataMembershipLaunch = {
  __typename?: 'OrganizationMetadataMembershipLaunch';
  launchedAt?: Maybe<Scalars['Date']['output']>;
  launchedBy?: Maybe<Scalars['MongoID']['output']>;
  mode?: Maybe<EnumOrganizationMetadataMembershipLaunchMode>;
  recordedRetroactively?: Maybe<Scalars['Boolean']['output']>;
  scheduleHistory?: Maybe<Array<Maybe<OrganizationMetadataMembershipLaunchScheduleHistory>>>;
  settingsAtLaunch?: Maybe<OrganizationMetadataMembershipLaunchSettingsAtLaunch>;
  state?: Maybe<EnumOrganizationMetadataMembershipLaunchState>;
};

export type OrganizationMetadataMembershipLaunchInput = {
  launchedAt?: InputMaybe<Scalars['Date']['input']>;
  launchedBy?: InputMaybe<Scalars['MongoID']['input']>;
  mode?: InputMaybe<EnumOrganizationMetadataMembershipLaunchMode>;
  recordedRetroactively?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleHistory?: InputMaybe<Array<InputMaybe<OrganizationMetadataMembershipLaunchScheduleHistoryInput>>>;
  settingsAtLaunch?: InputMaybe<OrganizationMetadataMembershipLaunchSettingsAtLaunchInput>;
  state?: InputMaybe<EnumOrganizationMetadataMembershipLaunchState>;
};

export type OrganizationMetadataMembershipLaunchScheduleHistory = {
  __typename?: 'OrganizationMetadataMembershipLaunchScheduleHistory';
  affected?: Maybe<Scalars['Float']['output']>;
  at: Scalars['Date']['output'];
  by?: Maybe<Scalars['MongoID']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  from?: Maybe<OrganizationMetadataMembershipLaunchSettingsAtLaunch>;
  intent?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  to?: Maybe<OrganizationMetadataMembershipLaunchSettingsAtLaunch>;
};

export type OrganizationMetadataMembershipLaunchScheduleHistoryInput = {
  affected?: InputMaybe<Scalars['Float']['input']>;
  at: Scalars['Date']['input'];
  by?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  from?: InputMaybe<OrganizationMetadataMembershipLaunchSettingsAtLaunchInput>;
  intent?: InputMaybe<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<OrganizationMetadataMembershipLaunchSettingsAtLaunchInput>;
};

export type OrganizationMetadataMembershipLaunchSettingsAtLaunch = {
  __typename?: 'OrganizationMetadataMembershipLaunchSettingsAtLaunch';
  fixedRenewalDay?: Maybe<Scalars['Float']['output']>;
  fixedRenewalMonth?: Maybe<Scalars['Float']['output']>;
  renewalType?: Maybe<EnumOrganizationMetadataMembershipLaunchSettingsAtLaunchRenewalType>;
  term?: Maybe<EnumOrganizationMetadataMembershipLaunchSettingsAtLaunchTerm>;
  termYears?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationMetadataMembershipLaunchSettingsAtLaunchInput = {
  fixedRenewalDay?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalMonth?: InputMaybe<Scalars['Float']['input']>;
  renewalType?: InputMaybe<EnumOrganizationMetadataMembershipLaunchSettingsAtLaunchRenewalType>;
  term?: InputMaybe<EnumOrganizationMetadataMembershipLaunchSettingsAtLaunchTerm>;
  termYears?: InputMaybe<Scalars['Float']['input']>;
};

export type OrganizationMetadataMembershipTierCheckouts = {
  __typename?: 'OrganizationMetadataMembershipTierCheckouts';
  bookerId?: Maybe<Scalars['MongoID']['output']>;
  free?: Maybe<Scalars['Boolean']['output']>;
  tierTagId: Scalars['MongoID']['output'];
};

export type OrganizationMetadataMembershipTierCheckoutsInput = {
  bookerId?: InputMaybe<Scalars['MongoID']['input']>;
  free?: InputMaybe<Scalars['Boolean']['input']>;
  tierTagId: Scalars['MongoID']['input'];
};

export type OrganizationMetadataNomenclature = {
  __typename?: 'OrganizationMetadataNomenclature';
  member?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Scalars['String']['output']>;
  membership?: Maybe<Scalars['String']['output']>;
};

export type OrganizationMetadataNomenclatureInput = {
  member?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Scalars['String']['input']>;
  membership?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationMetadataRenewalSettings = {
  __typename?: 'OrganizationMetadataRenewalSettings';
  activeStatusTagId?: Maybe<Scalars['MongoID']['output']>;
  automaticRenewalEmails?: Maybe<Scalars['Boolean']['output']>;
  cancelledEmail?: Maybe<OrganizationMetadataRenewalSettingsInstructionsEmail>;
  cancelledStatusTagId?: Maybe<Scalars['MongoID']['output']>;
  clearStatusTagsOnExpiration?: Maybe<Scalars['Boolean']['output']>;
  emailCooldownDays?: Maybe<Scalars['Float']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  engineOwnedTags?: Maybe<Scalars['Boolean']['output']>;
  expiredEmail?: Maybe<OrganizationMetadataRenewalSettingsInstructionsEmail>;
  expiredStatusTagId?: Maybe<Scalars['MongoID']['output']>;
  fixedRenewalDay?: Maybe<Scalars['Float']['output']>;
  fixedRenewalMonth?: Maybe<Scalars['Float']['output']>;
  instructionsEmail?: Maybe<OrganizationMetadataRenewalSettingsInstructionsEmail>;
  invoiceLeadDays?: Maybe<Scalars['Float']['output']>;
  neverExpireMembers?: Maybe<Scalars['Boolean']['output']>;
  overdueEmail?: Maybe<OrganizationMetadataRenewalSettingsInstructionsEmail>;
  overdueStatusTagId?: Maybe<Scalars['MongoID']['output']>;
  pendingStatusTagId?: Maybe<Scalars['MongoID']['output']>;
  proRateEnabled?: Maybe<Scalars['Boolean']['output']>;
  renewalGraceDays?: Maybe<Scalars['Float']['output']>;
  renewalReminderLeadDays?: Maybe<Scalars['Float']['output']>;
  renewalType?: Maybe<EnumOrganizationMetadataRenewalSettingsRenewalType>;
  sendCancelledEmails?: Maybe<Scalars['Boolean']['output']>;
  sendExpirationEmails?: Maybe<Scalars['Boolean']['output']>;
  sendOverdueEmails?: Maybe<Scalars['Boolean']['output']>;
  sendRenewalEmails?: Maybe<Scalars['Boolean']['output']>;
  sendSuccessEmails?: Maybe<Scalars['Boolean']['output']>;
  successEmail?: Maybe<OrganizationMetadataRenewalSettingsInstructionsEmail>;
  term?: Maybe<EnumOrganizationMetadataRenewalSettingsTerm>;
  termYears?: Maybe<Scalars['Float']['output']>;
  tierReminderEmails?: Maybe<Array<Maybe<OrganizationMetadataRenewalSettingsTierReminderEmails>>>;
};

export type OrganizationMetadataRenewalSettingsInput = {
  activeStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  automaticRenewalEmails?: InputMaybe<Scalars['Boolean']['input']>;
  cancelledEmail?: InputMaybe<OrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  cancelledStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  clearStatusTagsOnExpiration?: InputMaybe<Scalars['Boolean']['input']>;
  emailCooldownDays?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  engineOwnedTags?: InputMaybe<Scalars['Boolean']['input']>;
  expiredEmail?: InputMaybe<OrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  expiredStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  fixedRenewalDay?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalMonth?: InputMaybe<Scalars['Float']['input']>;
  instructionsEmail?: InputMaybe<OrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  invoiceLeadDays?: InputMaybe<Scalars['Float']['input']>;
  neverExpireMembers?: InputMaybe<Scalars['Boolean']['input']>;
  overdueEmail?: InputMaybe<OrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  overdueStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  pendingStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  proRateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  renewalGraceDays?: InputMaybe<Scalars['Float']['input']>;
  renewalReminderLeadDays?: InputMaybe<Scalars['Float']['input']>;
  renewalType?: InputMaybe<EnumOrganizationMetadataRenewalSettingsRenewalType>;
  sendCancelledEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendExpirationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendOverdueEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendRenewalEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendSuccessEmails?: InputMaybe<Scalars['Boolean']['input']>;
  successEmail?: InputMaybe<OrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  term?: InputMaybe<EnumOrganizationMetadataRenewalSettingsTerm>;
  termYears?: InputMaybe<Scalars['Float']['input']>;
  tierReminderEmails?: InputMaybe<Array<InputMaybe<OrganizationMetadataRenewalSettingsTierReminderEmailsInput>>>;
};

export type OrganizationMetadataRenewalSettingsInstructionsEmail = {
  __typename?: 'OrganizationMetadataRenewalSettingsInstructionsEmail';
  body?: Maybe<Scalars['String']['output']>;
  ctaLabel?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type OrganizationMetadataRenewalSettingsInstructionsEmailInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationMetadataRenewalSettingsTierReminderEmails = {
  __typename?: 'OrganizationMetadataRenewalSettingsTierReminderEmails';
  body?: Maybe<Scalars['String']['output']>;
  ctaLabel?: Maybe<Scalars['String']['output']>;
  hideRenewalDateLine?: Maybe<Scalars['Boolean']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  tierTagId: Scalars['MongoID']['output'];
};

export type OrganizationMetadataRenewalSettingsTierReminderEmailsInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  hideRenewalDateLine?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tierTagId: Scalars['MongoID']['input'];
};

export type OrganizationOnboardingMetadata = {
  __typename?: 'OrganizationOnboardingMetadata';
  _id?: Maybe<Scalars['MongoID']['output']>;
  allowColdSignup?: Maybe<Scalars['Boolean']['output']>;
  coldSignupTagId?: Maybe<Scalars['MongoID']['output']>;
  comingSoonMessage?: Maybe<Scalars['String']['output']>;
  introMessage?: Maybe<Scalars['String']['output']>;
  typeformSurveyId?: Maybe<Scalars['String']['output']>;
  videoId?: Maybe<Scalars['String']['output']>;
};

export type OrganizationOnboardingMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  allowColdSignup?: InputMaybe<Scalars['Boolean']['input']>;
  coldSignupTagId?: InputMaybe<Scalars['MongoID']['input']>;
  comingSoonMessage?: InputMaybe<Scalars['String']['input']>;
  introMessage?: InputMaybe<Scalars['String']['input']>;
  typeformSurveyId?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationPartnerSummary = {
  __typename?: 'OrganizationPartnerSummary';
  _id: Scalars['MongoID']['output'];
  logo?: Maybe<AssetImage>;
  name: Multilingual;
};

export type OrganizationWithOperatorStatus = {
  __typename?: 'OrganizationWithOperatorStatus';
  _id: Scalars['MongoID']['output'];
  name: Multilingual;
  status: PublicationStatusType;
};

export type OverrideDetails = {
  __typename?: 'OverrideDetails';
  description?: Maybe<Multilingual>;
  images: Array<AssetImage>;
  shortDescription?: Maybe<Multilingual>;
};

export type Owner = {
  __typename?: 'Owner';
  entityId: Scalars['MongoID']['output'];
  type: EnumOwnerType;
};

export type OwnerInput = {
  entityId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumOwnerType>;
};

export type OwnerWithName = {
  __typename?: 'OwnerWithName';
  entityId: Scalars['MongoID']['output'];
  name?: Maybe<Multilingual>;
  type: EnumOwnerType;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int']['output'];
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
};

export type PaymentEntry = {
  __typename?: 'PaymentEntry';
  _id: Scalars['MongoID']['output'];
  accountingCode?: Maybe<Scalars['String']['output']>;
  accountingCodeMappingRule?: Maybe<Scalars['String']['output']>;
  accountingDate?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardLast4?: Maybe<Scalars['String']['output']>;
  chequeNumber?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  currency: Scalars['String']['output'];
  effectiveAt?: Maybe<Scalars['String']['output']>;
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  method: EnumPaymentEntryMethod;
  note?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  payer?: Maybe<Scalars['String']['output']>;
  paymentRequest: Scalars['MongoID']['output'];
  processorReference?: Maybe<Scalars['String']['output']>;
  rawAccountingCode?: Maybe<Scalars['String']['output']>;
  receivedDate: Scalars['String']['output'];
  recordedAt?: Maybe<Scalars['String']['output']>;
  recordedBy: Scalars['MongoID']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  refundId?: Maybe<Scalars['String']['output']>;
  reversalOf?: Maybe<Scalars['MongoID']['output']>;
  reversalReason?: Maybe<Scalars['String']['output']>;
  rootPaymentRequestId: Scalars['MongoID']['output'];
  sourceRecordId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  storefront: Scalars['MongoID']['output'];
  type: EnumPaymentEntryType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type PaymentMethodSet = {
  __typename?: 'PaymentMethodSet';
  _id: Scalars['MongoID']['output'];
  acceptedPaymentMethods: Array<Maybe<Scalars['String']['output']>>;
  bankTransferInstructions?: Maybe<Scalars['String']['output']>;
  checkoutDescription?: Maybe<Scalars['String']['output']>;
  copiedFrom?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  isActive: Scalars['Boolean']['output'];
  methodLabels?: Maybe<PaymentMethodSetMethodLabels>;
  name: Scalars['String']['output'];
  offlinePaymentInstructions?: Maybe<Scalars['String']['output']>;
  storefront: Scalars['MongoID']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type PaymentMethodSetMethodLabels = {
  __typename?: 'PaymentMethodSetMethodLabels';
  bank_transfer?: Maybe<Scalars['String']['output']>;
  card?: Maybe<Scalars['String']['output']>;
  direct_debit?: Maybe<Scalars['String']['output']>;
  offline_payment?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodSetMethodLabelsInput = {
  bank_transfer?: InputMaybe<Scalars['String']['input']>;
  card?: InputMaybe<Scalars['String']['input']>;
  direct_debit?: InputMaybe<Scalars['String']['input']>;
  offline_payment?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentRequest = {
  __typename?: 'PaymentRequest';
  _id: Scalars['MongoID']['output'];
  accountingCode?: Maybe<Scalars['String']['output']>;
  accountingDate?: Maybe<Scalars['String']['output']>;
  accountingOnly: Scalars['Boolean']['output'];
  additionalLineItems: Array<Maybe<OrderAdditionalLineItems>>;
  amountPaid: Scalars['Int']['output'];
  appliedDiscount?: Maybe<PaymentRequestAppliedDiscount>;
  balanceDue: Scalars['Int']['output'];
  balanceStatus: Scalars['String']['output'];
  booker: Scalars['MongoID']['output'];
  cancellationNote?: Maybe<Scalars['String']['output']>;
  cartSnapshot: PaymentRequestCartSnapshot;
  changeHistory: Array<Maybe<PaymentRequestChangeHistory>>;
  complimentaryAmount: Scalars['Int']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  creditBalance: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  customerFee?: Maybe<Scalars['Float']['output']>;
  depositInvoice?: Maybe<Scalars['MongoID']['output']>;
  depositSchedule?: Maybe<PaymentRequestDepositSchedule>;
  dueDate?: Maybe<Scalars['String']['output']>;
  dueTermDays?: Maybe<Scalars['Float']['output']>;
  externalReference?: Maybe<Scalars['String']['output']>;
  grandTotal: Scalars['Float']['output'];
  /** Whether the referenced completed order still exists. */
  hasLinkedOrder: Scalars['Boolean']['output'];
  internalAccountingNotes?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicePolicy?: Maybe<Scalars['String']['output']>;
  isComplimentary: Scalars['Boolean']['output'];
  kind?: Maybe<EnumPaymentRequestKind>;
  lineItemSubtotal: Scalars['Float']['output'];
  /** End of the membership coverage window for renewal invoices (yyyy-MM-dd). */
  membershipPeriodEnd?: Maybe<Scalars['String']['output']>;
  /** Start of the membership coverage window for renewal invoices (yyyy-MM-dd). */
  membershipPeriodStart?: Maybe<Scalars['String']['output']>;
  needsAttention: Scalars['Boolean']['output'];
  nextRenewalDate?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  onlinePaymentAttemptId?: Maybe<Scalars['String']['output']>;
  onlinePaymentInitiatedAt?: Maybe<Scalars['String']['output']>;
  operatorId?: Maybe<Scalars['MongoID']['output']>;
  operatorIds?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  order?: Maybe<Scalars['String']['output']>;
  originalOrderId?: Maybe<Scalars['String']['output']>;
  paymentEntries?: Maybe<Array<Maybe<PaymentEntry>>>;
  previousVersion?: Maybe<Scalars['MongoID']['output']>;
  productNameOverride?: Maybe<Scalars['String']['output']>;
  productSubtotal: Scalars['Float']['output'];
  recipient?: Maybe<Scalars['MongoID']['output']>;
  recipientContact?: Maybe<PaymentRequestRecipientContact>;
  recipientPersonAddress?: Maybe<Address>;
  renewablePurchaseId?: Maybe<Scalars['MongoID']['output']>;
  revisionNote?: Maybe<Scalars['String']['output']>;
  rootPaymentRequestId?: Maybe<Scalars['MongoID']['output']>;
  scheduledSendDate?: Maybe<Scalars['String']['output']>;
  scheduledTransition?: Maybe<EnumPaymentRequestScheduledTransition>;
  sentAt?: Maybe<Scalars['String']['output']>;
  statementLines?: Maybe<Array<Maybe<PaymentRequestStatementLines>>>;
  statementPeriod?: Maybe<Scalars['String']['output']>;
  status: EnumPaymentRequestStatus;
  storefront: Scalars['MongoID']['output'];
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  submittedBy?: Maybe<Scalars['MongoID']['output']>;
  taxAmount: Scalars['Float']['output'];
  taxExempt?: Maybe<Scalars['Boolean']['output']>;
  taxLines?: Maybe<Array<Maybe<PaymentRequestTaxLines>>>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  version: Scalars['Float']['output'];
};

export type PaymentRequestAppliedDiscount = {
  __typename?: 'PaymentRequestAppliedDiscount';
  amount: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  discountId: Scalars['String']['output'];
  isOngoing?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  unit: Scalars['String']['output'];
};

export type PaymentRequestBulkSendResult = {
  __typename?: 'PaymentRequestBulkSendResult';
  results?: Maybe<Array<Maybe<PaymentRequestBulkSendResultItem>>>;
  sentCount: Scalars['Int']['output'];
};

export type PaymentRequestBulkSendResultItem = {
  __typename?: 'PaymentRequestBulkSendResultItem';
  error?: Maybe<Scalars['String']['output']>;
  paymentRequestId: Scalars['MongoID']['output'];
  success: Scalars['Boolean']['output'];
};

export type PaymentRequestCartSnapshot = {
  __typename?: 'PaymentRequestCartSnapshot';
  acceptedPolicies?: Maybe<Scalars['Boolean']['output']>;
  businessField?: Maybe<Scalars['JSON']['output']>;
  cart: Array<Maybe<PaymentRequestCartSnapshotCart>>;
  customer?: Maybe<PaymentRequestCartSnapshotCustomer>;
  customerAddress?: Maybe<Scalars['JSON']['output']>;
  customerComplete?: Maybe<Scalars['Boolean']['output']>;
  guestNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  guests?: Maybe<Array<Maybe<PaymentRequestCartSnapshotGuests>>>;
  productPurchaseRequests: Array<Maybe<PaymentRequestCartSnapshotProductPurchaseRequests>>;
  promoCode?: Maybe<Scalars['String']['output']>;
  questionnaireComplete?: Maybe<Scalars['Boolean']['output']>;
  questionnaireResponses?: Maybe<Array<Maybe<PaymentRequestCartSnapshotQuestionnaireResponses>>>;
  selectedBillingInterval?: Maybe<Scalars['String']['output']>;
  selectedOperatorId?: Maybe<Scalars['String']['output']>;
  selectedTierId?: Maybe<Scalars['String']['output']>;
};

export type PaymentRequestCartSnapshotCart = {
  __typename?: 'PaymentRequestCartSnapshotCart';
  businessScopes?: Maybe<Array<Maybe<PurchasedProductBusinessScopes>>>;
  customFieldResponses?: Maybe<Array<Maybe<PurchasedProductCustomFieldResponses>>>;
  endDateISO?: Maybe<Scalars['String']['output']>;
  guestsPerTier: Array<Maybe<PaymentRequestCartSnapshotCartGuestsPerTier>>;
  merchVariantId?: Maybe<Scalars['String']['output']>;
  merchVariantLabel?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  sessionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  startDateISO?: Maybe<Scalars['String']['output']>;
  tierLines: Array<Maybe<PaymentRequestCartSnapshotCartTierLines>>;
  total: Scalars['Float']['output'];
};

export type PaymentRequestCartSnapshotCartGuestsPerTier = {
  __typename?: 'PaymentRequestCartSnapshotCartGuestsPerTier';
  count: Scalars['Float']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  tierId: Scalars['String']['output'];
};

export type PaymentRequestCartSnapshotCartTierLines = {
  __typename?: 'PaymentRequestCartSnapshotCartTierLines';
  amount: Scalars['Float']['output'];
  name: Multilingual;
  quantity: Scalars['Float']['output'];
  tierId?: Maybe<Scalars['String']['output']>;
  unitPrice: Scalars['Float']['output'];
};

export type PaymentRequestCartSnapshotCustomer = {
  __typename?: 'PaymentRequestCartSnapshotCustomer';
  complete?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type PaymentRequestCartSnapshotGuests = {
  __typename?: 'PaymentRequestCartSnapshotGuests';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type PaymentRequestCartSnapshotProductPurchaseRequests = {
  __typename?: 'PaymentRequestCartSnapshotProductPurchaseRequests';
  businessScopes?: Maybe<Array<Maybe<PurchasedProductBusinessScopes>>>;
  customFieldResponses?: Maybe<Array<Maybe<PurchasedProductCustomFieldResponses>>>;
  endDateISO?: Maybe<Scalars['String']['output']>;
  guestTiers: Array<Maybe<PaymentRequestCartSnapshotProductPurchaseRequestsGuestTiers>>;
  merchVariantId?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  startDateISO?: Maybe<Scalars['String']['output']>;
  tierId?: Maybe<Scalars['String']['output']>;
};

export type PaymentRequestCartSnapshotProductPurchaseRequestsGuestTiers = {
  __typename?: 'PaymentRequestCartSnapshotProductPurchaseRequestsGuestTiers';
  count: Scalars['Float']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  tierId: Scalars['String']['output'];
};

export type PaymentRequestCartSnapshotQuestionnaireResponses = {
  __typename?: 'PaymentRequestCartSnapshotQuestionnaireResponses';
  questionData?: Maybe<Scalars['JSON']['output']>;
  response?: Maybe<Scalars['JSON']['output']>;
};

export type PaymentRequestChangeHistory = {
  __typename?: 'PaymentRequestChangeHistory';
  action: EnumPaymentRequestChangeHistoryAction;
  activityLogId?: Maybe<Scalars['MongoID']['output']>;
  changes?: Maybe<Array<Maybe<PaymentRequestChangeHistoryChanges>>>;
  effectiveAt?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  performedBy: Scalars['MongoID']['output'];
  performedByName?: Maybe<Scalars['String']['output']>;
  recordedAt?: Maybe<Scalars['String']['output']>;
  references?: Maybe<PaymentRequestChangeHistoryReferences>;
  snapshot?: Maybe<PaymentRequestChangeHistorySnapshot>;
  timestamp: Scalars['String']['output'];
};

export type PaymentRequestChangeHistoryChanges = {
  __typename?: 'PaymentRequestChangeHistoryChanges';
  after?: Maybe<Scalars['JSON']['output']>;
  before?: Maybe<Scalars['JSON']['output']>;
  field: Scalars['String']['output'];
};

export type PaymentRequestChangeHistoryReferences = {
  __typename?: 'PaymentRequestChangeHistoryReferences';
  activityLogId?: Maybe<Scalars['MongoID']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentEntryId?: Maybe<Scalars['MongoID']['output']>;
  paymentRequestId?: Maybe<Scalars['MongoID']['output']>;
  refundId?: Maybe<Scalars['String']['output']>;
  reversalOfEventId?: Maybe<Scalars['String']['output']>;
};

export type PaymentRequestChangeHistorySnapshot = {
  __typename?: 'PaymentRequestChangeHistorySnapshot';
  amountPaid?: Maybe<Scalars['Float']['output']>;
  balanceDue?: Maybe<Scalars['Float']['output']>;
  grandTotal?: Maybe<Scalars['Float']['output']>;
  lineItemCount?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<EnumPaymentRequestChangeHistorySnapshotStatus>;
};

export type PaymentRequestCheckoutInitiateResult = {
  __typename?: 'PaymentRequestCheckoutInitiateResult';
  invoiceNumber: Scalars['String']['output'];
  paymentRequestId: Scalars['MongoID']['output'];
  status: Scalars['String']['output'];
};

export type PaymentRequestDepositSchedule = {
  __typename?: 'PaymentRequestDepositSchedule';
  balanceAmount: Scalars['Float']['output'];
  balanceCollection: EnumPaymentRequestDepositScheduleBalanceCollection;
  balanceDueDate?: Maybe<Scalars['String']['output']>;
  bookingTotal: Scalars['Float']['output'];
  depositAmount: Scalars['Float']['output'];
};

export type PaymentRequestRecipientContact = {
  __typename?: 'PaymentRequestRecipientContact';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type PaymentRequestStatementLines = {
  __typename?: 'PaymentRequestStatementLines';
  customerFee: Scalars['Float']['output'];
  grandTotal: Scalars['Float']['output'];
  orderId: Scalars['String']['output'];
  serviceDate?: Maybe<Scalars['String']['output']>;
  subTotal: Scalars['Float']['output'];
  taxLines?: Maybe<Array<Maybe<PaymentRequestTaxLines>>>;
};

export type PaymentRequestTaxLines = {
  __typename?: 'PaymentRequestTaxLines';
  amount: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ratePercent?: Maybe<Scalars['Float']['output']>;
};

export type PendingRenewalEmail = {
  __typename?: 'PendingRenewalEmail';
  _id: Scalars['MongoID']['output'];
  actorUserId?: Maybe<Scalars['MongoID']['output']>;
  bodySnapshot?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  ctaLabelSnapshot?: Maybe<Scalars['String']['output']>;
  ctaUrlSnapshot?: Maybe<Scalars['String']['output']>;
  emailKind: EnumPendingRenewalEmailEmailKind;
  forced?: Maybe<Scalars['Boolean']['output']>;
  hideGreetingSnapshot?: Maybe<Scalars['Boolean']['output']>;
  hideRenewalDateLineSnapshot: Scalars['Boolean']['output'];
  listId?: Maybe<Scalars['MongoID']['output']>;
  organization: Scalars['MongoID']['output'];
  scheduledSendAt: Scalars['Date']['output'];
  sendNowRequestedAt?: Maybe<Scalars['Date']['output']>;
  sendingStartedAt?: Maybe<Scalars['Date']['output']>;
  sentAt?: Maybe<Scalars['Date']['output']>;
  status: EnumPendingRenewalEmailStatus;
  statusTagId?: Maybe<Scalars['MongoID']['output']>;
  subject: PendingRenewalEmailSubject;
  subjectSnapshot?: Maybe<Scalars['String']['output']>;
  tierTagId?: Maybe<Scalars['MongoID']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export enum PendingRenewalEmailKind {
  Cancelled = 'CANCELLED',
  Custom = 'CUSTOM',
  Expired = 'EXPIRED',
  Overdue = 'OVERDUE',
  Reminder = 'REMINDER',
  Success = 'SUCCESS'
}

export type PendingRenewalEmailSubject = {
  __typename?: 'PendingRenewalEmailSubject';
  entityId: Scalars['MongoID']['output'];
  type: EnumPendingRenewalEmailSubjectType;
};

export type People = {
  __typename?: 'People';
  _id: Scalars['MongoID']['output'];
  address?: Maybe<Address>;
  birthday?: Maybe<Scalars['String']['output']>;
  contactMethod?: Maybe<EnumPeopleContactMethod>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  emailLower?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  faxExt?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  import: Scalars['JSON']['output'];
  lastName: Scalars['String']['output'];
  leads: Array<Lead>;
  mailingAddress?: Maybe<Address>;
  optInEmail: Scalars['Boolean']['output'];
  optInFax: Scalars['Boolean']['output'];
  optInPhone: Scalars['Boolean']['output'];
  optInSMS: Scalars['Boolean']['output'];
  orders: Array<Order>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneExt?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<AssetImage>;
  photoUploadedBy?: Maybe<Scalars['MongoID']['output']>;
  primaryTitle?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<UserWithPictureTc>;
  visibleTo: Array<Maybe<PeopleVisibleTo>>;
};


export type PeopleLeadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsLeadInput>;
};


export type PeopleOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsOrderInput>;
};

export type PeopleInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<AddressInput>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  contactMethod?: InputMaybe<EnumPeopleContactMethod>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  emailLower?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  faxExt?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  import?: InputMaybe<Scalars['JSON']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leads?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  mailingAddress?: InputMaybe<AddressInput>;
  optInEmail?: InputMaybe<Scalars['Boolean']['input']>;
  optInFax?: InputMaybe<Scalars['Boolean']['input']>;
  optInPhone?: InputMaybe<Scalars['Boolean']['input']>;
  optInSMS?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photoUploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTitle?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  visibleTo?: InputMaybe<Array<InputMaybe<PeopleVisibleToInput>>>;
};

export type PeopleVisibleTo = {
  __typename?: 'PeopleVisibleTo';
  _id?: Maybe<Scalars['MongoID']['output']>;
  entity: Owner;
  ignoreLeadSystemRole?: Maybe<Scalars['Boolean']['output']>;
  latestActivity?: Maybe<Scalars['Date']['output']>;
  metadata: PeopleVisibleToMetadata;
  scratchpad?: Maybe<Scalars['String']['output']>;
  systemRoles?: Maybe<Array<Maybe<EnumPeopleVisibleToSystemRoles>>>;
  tags?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  types?: Maybe<Array<Maybe<EnumPeopleVisibleToTypes>>>;
  wasManuallyCreated?: Maybe<Scalars['Boolean']['output']>;
};

export type PeopleVisibleToInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  entity: OwnerInput;
  ignoreLeadSystemRole?: InputMaybe<Scalars['Boolean']['input']>;
  latestActivity?: InputMaybe<Scalars['Date']['input']>;
  metadata: PeopleVisibleToMetadataInput;
  scratchpad?: InputMaybe<Scalars['String']['input']>;
  systemRoles?: InputMaybe<Array<InputMaybe<EnumPeopleVisibleToSystemRoles>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<EnumPeopleVisibleToTypes>>>;
  wasManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PeopleVisibleToMetadata = {
  __typename?: 'PeopleVisibleToMetadata';
  _id?: Maybe<Scalars['MongoID']['output']>;
  emails: Array<Maybe<Scalars['String']['output']>>;
  operatorOverrides?: Maybe<Array<Maybe<PeopleVisibleToMetadataOperatorOverrides>>>;
  phones: Array<Maybe<PeopleVisibleToMetadataPhones>>;
};

export type PeopleVisibleToMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  emails: Array<InputMaybe<Scalars['String']['input']>>;
  operatorOverrides?: InputMaybe<Array<InputMaybe<PeopleVisibleToMetadataOperatorOverridesInput>>>;
  phones: Array<InputMaybe<PeopleVisibleToMetadataPhonesInput>>;
};

export type PeopleVisibleToMetadataOperatorOverrides = {
  __typename?: 'PeopleVisibleToMetadataOperatorOverrides';
  _id?: Maybe<Scalars['MongoID']['output']>;
  operatorEntityId: Scalars['MongoID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PeopleVisibleToMetadataOperatorOverridesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  operatorEntityId: Scalars['MongoID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PeopleVisibleToMetadataPhones = {
  __typename?: 'PeopleVisibleToMetadataPhones';
  _id?: Maybe<Scalars['MongoID']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  type?: Maybe<EnumPeopleVisibleToMetadataPhonesType>;
};

export type PeopleVisibleToMetadataPhonesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  type?: InputMaybe<EnumPeopleVisibleToMetadataPhonesType>;
};

export type PersonCheckIfExistsByEmail = {
  __typename?: 'PersonCheckIfExistsByEmail';
  email: Scalars['String']['output'];
  exists: Scalars['Boolean']['output'];
  existsInEntity: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneExt?: Maybe<Scalars['String']['output']>;
};

export type PersonDetailsSectionTc = {
  __typename?: 'PersonDetailsSectionTC';
  _id: Scalars['ID']['output'];
  dateEndISO?: Maybe<Scalars['String']['output']>;
  dateISO: Scalars['String']['output'];
  dateStartISO?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Multilingual>;
  name?: Maybe<Multilingual>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PersonMetadataInput = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  operatorOverrides?: InputMaybe<Array<InputMaybe<PersonMetadataOperatorDetailsInput>>>;
  phones?: InputMaybe<Array<InputMaybe<PersonMetadataPhoneInput>>>;
};

export type PersonMetadataOperatorDetailsInput = {
  operatorEntityId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PersonMetadataPhone = {
  __typename?: 'PersonMetadataPhone';
  ext?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PersonMetadataPhoneInput = {
  ext?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PickupLocationOption = {
  __typename?: 'PickupLocationOption';
  _id: Scalars['ID']['output'];
  address?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Place = {
  __typename?: 'Place';
  _id: Scalars['MongoID']['output'];
  connectedDmoListing?: Maybe<Scalars['MongoID']['output']>;
  connectedListing?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  name: Multilingual;
  outline?: Maybe<PlaceOutline>;
  outlineSimplified?: Maybe<PlaceOutline>;
  parentPlace?: Maybe<Scalars['MongoID']['output']>;
  subPlaces: Array<Place>;
  type: EnumPlaceType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};


export type PlaceSubPlacesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPlaceInput>;
};

export type PlaceOutline = {
  __typename?: 'PlaceOutline';
  coordinates: Scalars['JSON']['output'];
  type: EnumPlaceOutlineType;
};

export type PlaceOutlineInput = {
  coordinates: Scalars['JSON']['input'];
  type: EnumPlaceOutlineType;
};

export type Policy = {
  __typename?: 'Policy';
  _id: Scalars['MongoID']['output'];
  content: Multilingual;
  copiedFrom?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Multilingual;
  storefront: Scalars['MongoID']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export enum PostHogAppContext {
  OhtoIntegration = 'ohto_integration',
  WhereaboutsNext = 'whereabouts_next',
  WidgetBooker = 'widget_booker',
  WidgetEventSubmit = 'widget_event_submit',
  WidgetEvents = 'widget_events',
  WidgetGallery = 'widget_gallery',
  WidgetMediaProfile = 'widget_media_profile',
  WidgetOperator = 'widget_operator',
  WidgetPromotions = 'widget_promotions',
  WidgetTripper = 'widget_tripper',
  WidgetWhatsNearby = 'widget_whats_nearby'
}

export type PostHogData = {
  __typename?: 'PostHogData';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  metadata?: Maybe<PostHogMetadata>;
  timestamp: Scalars['Date']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type PostHogEventAndOperatorWidgetStats = {
  __typename?: 'PostHogEventAndOperatorWidgetStats';
  events?: Maybe<PostHogSimpleStats>;
  operators?: Maybe<PostHogSimpleStats>;
};

export enum PostHogEventName {
  AmenitiesViewed = 'amenities_viewed',
  BookerLoaded = 'booker_loaded',
  BroadcastViewed = 'broadcast_viewed',
  BuyTicketsCheckoutClick = 'buy_tickets_checkout_click',
  CloseOperatorDetails = 'close_operator_details',
  CustomerDetailsAdded = 'customer_details_added',
  DatesSelected = 'dates_selected',
  DetailsClick = 'details_click',
  EntityImpression = 'entity_impression',
  ExpandedDetailsClick = 'expanded_details_click',
  ExpandedDetailsPageview = 'expanded_details_pageview',
  FilterTagAdded = 'filter_tag_added',
  FilterTagRemoved = 'filter_tag_removed',
  GuestsSelected = 'guests_selected',
  ItineraryEngaged = 'itinerary_engaged',
  MediaCtaClick = 'media_cta_click',
  MediaImpression = 'media_impression',
  MediaLike = 'media_like',
  MediaShare = 'media_share',
  OpenBookNowLink = 'open_book_now_link',
  OutboundClick = 'outbound_click',
  PaymentMethodAdded = 'payment_method_added',
  PdfDownload = 'pdf_download',
  PoliciesAccepted = 'policies_accepted',
  ProductAddedToCart = 'product_added_to_cart',
  ProductRemovedFromCart = 'product_removed_from_cart',
  ProductUpdatedInCart = 'product_updated_in_cart',
  PromoCodeApplied = 'promo_code_applied',
  PurchaseCompleted = 'purchase_completed',
  PurchaseFailed = 'purchase_failed',
  QuestionnaireCompleted = 'questionnaire_completed',
  ResourceCompleted = 'resource_completed',
  ResourceDownloaded = 'resource_downloaded',
  ResourceInProgress = 'resource_in_progress',
  ResourcePlayed = 'resource_played',
  ResourceViewed = 'resource_viewed',
  ScrollEventsLeft = 'scroll_events_left',
  ScrollEventsRight = 'scroll_events_right',
  ScrollOperatorsLeft = 'scroll_operators_left',
  ScrollOperatorsRight = 'scroll_operators_right',
  ScrollRecurringEventsDown = 'scroll_recurring_events_down',
  ScrollRecurringEventsUp = 'scroll_recurring_events_up',
  ScrollViewMoreTags = 'scroll_view_more_tags',
  ScrollViewPreviousTags = 'scroll_view_previous_tags',
  WidgetImpression = 'widget_impression',
  WidgetLaunch = 'widget_launch',
  WidgetView = 'widget_view'
}

export type PostHogEventStats = {
  __typename?: 'PostHogEventStats';
  impressions?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<PostHogMetadataForEventStats>;
  outboundClicks?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type PostHogMetadata = {
  __typename?: 'PostHogMetadata';
  appContext?: Maybe<Scalars['String']['output']>;
  booker?: Maybe<Booker>;
  broadcast?: Maybe<Broadcast>;
  event?: Maybe<Event>;
  eventName?: Maybe<Scalars['String']['output']>;
  eventPersonId?: Maybe<Scalars['String']['output']>;
  instanceId?: Maybe<Scalars['String']['output']>;
  itinerary?: Maybe<Itinerary>;
  linkType?: Maybe<Scalars['String']['output']>;
  list: ListWithEntities;
  media?: Maybe<Scalars['MongoID']['output']>;
  operator: OperatorWithStatus;
  orderId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  person?: Maybe<SimplePersonTc>;
  product?: Maybe<Product>;
  promoCode?: Maybe<Scalars['String']['output']>;
  relatedListings?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  resource?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserWithPictureTc>;
  widget: WidgetWithListEntities;
};


export type PostHogMetadataOperatorArgs = {
  loggedInAs?: InputMaybe<OwnerInput>;
};

export type PostHogMetadataForEventStats = {
  __typename?: 'PostHogMetadataForEventStats';
  appContext?: Maybe<Scalars['String']['output']>;
  broadcast?: Maybe<Broadcast>;
  event?: Maybe<Event>;
  itinerary?: Maybe<Itinerary>;
  linkType?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Scalars['MongoID']['output']>;
  organization?: Maybe<Organization>;
  person?: Maybe<SimplePersonTc>;
  relatedListings?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  resource?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  widget: WidgetWithListEntities;
};

export type PostHogMetadataForOperatorStats = {
  __typename?: 'PostHogMetadataForOperatorStats';
  appContext?: Maybe<Scalars['String']['output']>;
  broadcast?: Maybe<Broadcast>;
  itinerary?: Maybe<Itinerary>;
  linkType?: Maybe<Scalars['String']['output']>;
  list: ListWithEntities;
  media?: Maybe<Scalars['MongoID']['output']>;
  operator?: Maybe<OperatorWithStatus>;
  organization?: Maybe<Organization>;
  person?: Maybe<SimplePersonTc>;
  relatedListings?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  resource?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  widget: WidgetWithListEntities;
};


export type PostHogMetadataForOperatorStatsOperatorArgs = {
  loggedInAs?: InputMaybe<OwnerInput>;
  status?: InputMaybe<PublicationStatusType>;
};

export type PostHogMetadataForTripperStats = {
  __typename?: 'PostHogMetadataForTripperStats';
  appContext?: Maybe<Scalars['String']['output']>;
  itinerary?: Maybe<Itinerary>;
  media?: Maybe<Scalars['MongoID']['output']>;
  operator: OperatorWithStatus;
  organization?: Maybe<Organization>;
  relatedListings?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  widget: WidgetWithListEntities;
};


export type PostHogMetadataForTripperStatsOperatorArgs = {
  loggedInAs?: InputMaybe<OwnerInput>;
  status?: InputMaybe<PublicationStatusType>;
};

export type PostHogOperatorStats = {
  __typename?: 'PostHogOperatorStats';
  impressions?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<PostHogMetadataForOperatorStats>;
  outboundClicks?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type PostHogSimpleStats = {
  __typename?: 'PostHogSimpleStats';
  impressions?: Maybe<Scalars['Int']['output']>;
  outboundClicks?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type PostHogTripperAggregateStats = {
  __typename?: 'PostHogTripperAggregateStats';
  engagements: Scalars['Int']['output'];
  pdfDownloads: Scalars['Int']['output'];
  referrals: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

export type PostHogTripperStats = {
  __typename?: 'PostHogTripperStats';
  clicks?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<PostHogMetadataForTripperStats>;
  referrals?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type PostHogTripperTimeSeriesPoint = {
  __typename?: 'PostHogTripperTimeSeriesPoint';
  date: Scalars['Date']['output'];
  engagements: Scalars['Int']['output'];
  pdfDownloads: Scalars['Int']['output'];
  referrals: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

export type PricePerProduct = {
  __typename?: 'PricePerProduct';
  price: Scalars['Int']['output'];
  productId: Scalars['ID']['output'];
};

export type PriceTier = {
  __typename?: 'PriceTier';
  _id: Scalars['MongoID']['output'];
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountUnit?: Maybe<EnumPriceTierDiscountUnit>;
  guestCountForPrice?: Maybe<Scalars['Float']['output']>;
  label?: Maybe<Multilingual>;
  price: Scalars['Float']['output'];
  priceType: EnumPriceTierPriceType;
  type: EnumGuestTierType;
};

export type PriceTierInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountUnit?: InputMaybe<EnumPriceTierDiscountUnit>;
  guestCountForPrice?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<MultilingualInput>;
  price: Scalars['Float']['input'];
  priceType: EnumPriceTierPriceType;
  type: EnumGuestTierType;
};

export type Pricing = {
  __typename?: 'Pricing';
  description?: Maybe<Multilingual>;
  tiers: Array<Maybe<PriceTier>>;
};

export type PricingInput = {
  description?: InputMaybe<MultilingualInput>;
  tiers: Array<InputMaybe<PriceTierInput>>;
};

export type ProdSyncCheckPayload = {
  __typename?: 'ProdSyncCheckPayload';
  collections?: Maybe<Array<Maybe<ProdSyncCollectionStat>>>;
  defaultSkipped: Array<Scalars['String']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  totalDocuments: Scalars['Int']['output'];
};

export type ProdSyncCollectionResult = {
  __typename?: 'ProdSyncCollectionResult';
  documentsCopied: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  skipped: Scalars['Boolean']['output'];
};

export type ProdSyncCollectionStat = {
  __typename?: 'ProdSyncCollectionStat';
  docCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  skipped: Scalars['Boolean']['output'];
};

export type ProdSyncResult = {
  __typename?: 'ProdSyncResult';
  collections?: Maybe<Array<Maybe<ProdSyncCollectionResult>>>;
  durationMs: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  totalDocumentsCopied: Scalars['Int']['output'];
};

export type Product = {
  __typename?: 'Product';
  _id: Scalars['MongoID']['output'];
  accommodationMetadata?: Maybe<AccommodationProductMetadata>;
  addOnSettings?: Maybe<ProductAddOnSettings>;
  contact?: Maybe<ProductContact>;
  copiedFrom?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  customFields?: Maybe<Array<Maybe<ProductCustomFields>>>;
  description?: Maybe<Multilingual>;
  eventMetadata?: Maybe<ProductEventMetadata>;
  externalBookingUrl?: Maybe<Scalars['String']['output']>;
  images: Array<AssetImage>;
  inventorySettings?: Maybe<ProductTierInventory>;
  isActive: Scalars['Boolean']['output'];
  isUpsellOnly: Scalars['Boolean']['output'];
  merchMetadata?: Maybe<MerchMetadata>;
  name: Multilingual;
  owner: Owner;
  pricing?: Maybe<Pricing>;
  productTiers?: Maybe<Array<Maybe<ProductTier>>>;
  publicationStatus: EnumProductPublicationStatus;
  quantitySettings?: Maybe<ProductTierQuantity>;
  renewableFeeMetadata?: Maybe<RenewableFeeMetadata>;
  rules: Array<Rule>;
  sellingConfig?: Maybe<ProductSellingConfig>;
  shortDescription?: Maybe<Multilingual>;
  storefront: Scalars['MongoID']['output'];
  tags: Array<Tag>;
  type: EnumProductType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ProductAddOnSettings = {
  __typename?: 'ProductAddOnSettings';
  businessScope?: Maybe<EnumProductAddOnSettingsBusinessScope>;
  pricingScope?: Maybe<EnumProductAddOnSettingsPricingScope>;
};

export type ProductAddOnSettingsInput = {
  businessScope?: InputMaybe<EnumProductAddOnSettingsBusinessScope>;
  pricingScope?: InputMaybe<EnumProductAddOnSettingsPricingScope>;
};

export type ProductContact = {
  __typename?: 'ProductContact';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  tollFreePublicPhone?: Maybe<Scalars['String']['output']>;
  useOwnerContact: Scalars['Boolean']['output'];
};

export type ProductContactInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tollFreePublicPhone?: InputMaybe<Scalars['String']['input']>;
  useOwnerContact: Scalars['Boolean']['input'];
};

export type ProductCustomFields = {
  __typename?: 'ProductCustomFields';
  _id?: Maybe<Scalars['MongoID']['output']>;
  chargePerChoice?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Multilingual>;
  label: Multilingual;
  maxChoices?: Maybe<Scalars['Float']['output']>;
  options?: Maybe<Array<Maybe<ProductCustomFieldsOptions>>>;
  required: Scalars['Boolean']['output'];
  type: EnumProductCustomFieldsType;
};

export type ProductCustomFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  chargePerChoice?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<MultilingualInput>;
  label: MultilingualInput;
  maxChoices?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<ProductCustomFieldsOptionsInput>>>;
  required: Scalars['Boolean']['input'];
  type: EnumProductCustomFieldsType;
};

export type ProductCustomFieldsOptions = {
  __typename?: 'ProductCustomFieldsOptions';
  _id?: Maybe<Scalars['MongoID']['output']>;
  label: Multilingual;
};

export type ProductCustomFieldsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label: MultilingualInput;
};

export type ProductDuplicateResult = {
  __typename?: 'ProductDuplicateResult';
  productId: Scalars['MongoID']['output'];
};

export type ProductEventMetadata = {
  __typename?: 'ProductEventMetadata';
  event: Scalars['MongoID']['output'];
  includedSessionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  maxTicketsPerPurchase?: Maybe<Scalars['Float']['output']>;
  sellingType?: Maybe<EnumProductEventMetadataSellingType>;
  sessionGranularity: EnumProductEventMetadataSessionGranularity;
  ticketStructure: EnumProductEventMetadataTicketStructure;
};

export type ProductEventMetadataInput = {
  event: Scalars['MongoID']['input'];
  includedSessionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  maxTicketsPerPurchase?: InputMaybe<Scalars['Float']['input']>;
  sellingType?: InputMaybe<EnumProductEventMetadataSellingType>;
  sessionGranularity: EnumProductEventMetadataSessionGranularity;
  ticketStructure: EnumProductEventMetadataTicketStructure;
};

export type ProductPurchaseRequest = {
  businessScopes?: InputMaybe<Array<InputMaybe<AddOnBusinessScopeInput>>>;
  customFieldResponses?: InputMaybe<Array<InputMaybe<CustomFieldResponseInput>>>;
  endDateISO?: InputMaybe<Scalars['String']['input']>;
  guestTiers: Array<InputMaybe<PurchasedProductGuestsPerTierInput>>;
  merchVariantId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['MongoID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  sessionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDateISO?: InputMaybe<Scalars['String']['input']>;
  tierId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSellingConfig = {
  __typename?: 'ProductSellingConfig';
  basePrice?: Maybe<Scalars['Float']['output']>;
  dynamicFeeSurvey?: Maybe<Scalars['MongoID']['output']>;
  inventory?: Maybe<ProductTierInventory>;
  mode: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<ProductTier>>>;
  quantity?: Maybe<ProductTierQuantity>;
  recurring?: Maybe<ProductSellingConfigRecurring>;
};

export type ProductSellingConfigInput = {
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  dynamicFeeSurvey?: InputMaybe<Scalars['MongoID']['input']>;
  inventory?: InputMaybe<ProductTierInventoryInput>;
  mode: Scalars['String']['input'];
  options?: InputMaybe<Array<InputMaybe<ProductTierInput>>>;
  quantity?: InputMaybe<ProductTierQuantityInput>;
  recurring?: InputMaybe<ProductSellingConfigRecurringInput>;
};

export type ProductSellingConfigRecurring = {
  __typename?: 'ProductSellingConfigRecurring';
  billingIntervalMonths?: Maybe<Scalars['Float']['output']>;
  earlyPurchaseWindowDays?: Maybe<Scalars['Float']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fixedRenewalDay?: Maybe<Scalars['Float']['output']>;
  fixedRenewalMonth?: Maybe<Scalars['Float']['output']>;
  membershipLinked?: Maybe<Scalars['Boolean']['output']>;
  multiListing?: Maybe<ProductSellingConfigRecurringMultiListing>;
  proRateEnabled?: Maybe<Scalars['Boolean']['output']>;
  renewalType?: Maybe<EnumProductSellingConfigRecurringRenewalType>;
};

export type ProductSellingConfigRecurringInput = {
  billingIntervalMonths?: InputMaybe<Scalars['Float']['input']>;
  earlyPurchaseWindowDays?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fixedRenewalDay?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalMonth?: InputMaybe<Scalars['Float']['input']>;
  membershipLinked?: InputMaybe<Scalars['Boolean']['input']>;
  multiListing?: InputMaybe<ProductSellingConfigRecurringMultiListingInput>;
  proRateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  renewalType?: InputMaybe<EnumProductSellingConfigRecurringRenewalType>;
};

export type ProductSellingConfigRecurringMultiListing = {
  __typename?: 'ProductSellingConfigRecurringMultiListing';
  additionalBusinessDiscount?: Maybe<ProductSellingConfigRecurringMultiListingAdditionalBusinessDiscount>;
  autoIncludeOwnedListings?: Maybe<Scalars['Boolean']['output']>;
  maxListings?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<EnumProductSellingConfigRecurringMultiListingMode>;
};

export type ProductSellingConfigRecurringMultiListingAdditionalBusinessDiscount = {
  __typename?: 'ProductSellingConfigRecurringMultiListingAdditionalBusinessDiscount';
  amount: Scalars['Float']['output'];
  unit: EnumProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountUnit;
};

export type ProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountInput = {
  amount: Scalars['Float']['input'];
  unit: EnumProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountUnit;
};

export type ProductSellingConfigRecurringMultiListingInput = {
  additionalBusinessDiscount?: InputMaybe<ProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountInput>;
  autoIncludeOwnedListings?: InputMaybe<Scalars['Boolean']['input']>;
  maxListings?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumProductSellingConfigRecurringMultiListingMode>;
};

export type ProductTier = {
  __typename?: 'ProductTier';
  _id?: Maybe<Scalars['MongoID']['output']>;
  autoTag?: Maybe<Scalars['MongoID']['output']>;
  condition?: Maybe<ProductTierCondition>;
  description?: Maybe<Multilingual>;
  includedSessionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  inventory?: Maybe<ProductTierInventory>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  maxSessions?: Maybe<Scalars['Float']['output']>;
  minSessions?: Maybe<Scalars['Float']['output']>;
  name: Multilingual;
  order: Scalars['Float']['output'];
  personTagConfig?: Maybe<ProductTierTagConfig>;
  price: Scalars['Float']['output'];
  quantity?: Maybe<ProductTierQuantity>;
  sessionScope?: Maybe<EnumProductTierSessionScope>;
  subCapacityPerSession?: Maybe<Scalars['Float']['output']>;
  tagConfig?: Maybe<ProductTierTagConfig>;
};

export type ProductTierCondition = {
  __typename?: 'ProductTierCondition';
  clauses?: Maybe<Array<Maybe<ProductTierConditionClauses>>>;
  operator: EnumProductTierConditionOperator;
};

export type ProductTierConditionClauses = {
  __typename?: 'ProductTierConditionClauses';
  comparator: EnumProductTierConditionClausesComparator;
  questionId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProductTierConditionClausesInput = {
  comparator: EnumProductTierConditionClausesComparator;
  questionId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ProductTierConditionInput = {
  clauses?: InputMaybe<Array<InputMaybe<ProductTierConditionClausesInput>>>;
  operator: EnumProductTierConditionOperator;
};

export type ProductTierInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  autoTag?: InputMaybe<Scalars['MongoID']['input']>;
  condition?: InputMaybe<ProductTierConditionInput>;
  description?: InputMaybe<MultilingualInput>;
  includedSessionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inventory?: InputMaybe<ProductTierInventoryInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxSessions?: InputMaybe<Scalars['Float']['input']>;
  minSessions?: InputMaybe<Scalars['Float']['input']>;
  name: MultilingualInput;
  order: Scalars['Float']['input'];
  personTagConfig?: InputMaybe<ProductTierTagConfigInput>;
  price: Scalars['Float']['input'];
  quantity?: InputMaybe<ProductTierQuantityInput>;
  sessionScope?: InputMaybe<EnumProductTierSessionScope>;
  subCapacityPerSession?: InputMaybe<Scalars['Float']['input']>;
  tagConfig?: InputMaybe<ProductTierTagConfigInput>;
};

export type ProductTierInventory = {
  __typename?: 'ProductTierInventory';
  currentCount: Scalars['Float']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  totalCount: Scalars['Float']['output'];
};

export type ProductTierInventoryInput = {
  currentCount: Scalars['Float']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  totalCount: Scalars['Float']['input'];
};

export type ProductTierQuantity = {
  __typename?: 'ProductTierQuantity';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  maxQuantity?: Maybe<Scalars['Float']['output']>;
};

export type ProductTierQuantityInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxQuantity?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductTierTagConfig = {
  __typename?: 'ProductTierTagConfig';
  onCancellation?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  onCheckoutCompleted?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  onExpiration?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  onInvoiceOverdue?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  onPaymentFailed?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  onRenewalPending?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  onRenewalSuccess?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type ProductTierTagConfigInput = {
  onCancellation?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  onCheckoutCompleted?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  onExpiration?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  onInvoiceOverdue?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  onPaymentFailed?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  onRenewalPending?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  onRenewalSuccess?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type Promotion = {
  __typename?: 'Promotion';
  _id: Scalars['MongoID']['output'];
  access: PromotionAccess;
  availability: PromotionAvailability;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  createdByEmail: Scalars['String']['output'];
  createdByFirstName?: Maybe<Scalars['String']['output']>;
  createdByLastName?: Maybe<Scalars['String']['output']>;
  createdByPerson?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  firstDate: Scalars['String']['output'];
  history: Array<Maybe<PromotionHistory>>;
  images: Array<AssetImage>;
  lastDate: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  listing?: Maybe<OperatorWithStatus>;
  /** Who created the promotion (OPERATOR/ORGANIZATION), derived server-side at create time. */
  submissionSource?: Maybe<EnumPromotionSubmissionSource>;
  submitterPersonId?: Maybe<Scalars['MongoID']['output']>;
  tags?: Maybe<PromotionTags>;
  title: Multilingual;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};


export type PromotionImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PromotionAccess = {
  __typename?: 'PromotionAccess';
  disconnectedOrganizations?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  operator: PromotionAccessOperator;
  organizations: Array<Maybe<PromotionAccessOperator>>;
};

export type PromotionAccessInput = {
  disconnectedOrganizations?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  operator: PromotionAccessOperatorInput;
  organizations: Array<InputMaybe<PromotionAccessOperatorInput>>;
};

export type PromotionAccessOperator = {
  __typename?: 'PromotionAccessOperator';
  _entityId: Scalars['MongoID']['output'];
  status?: Maybe<EnumPromotionAccessOperatorStatus>;
};

export type PromotionAccessOperatorInput = {
  _entityId: Scalars['MongoID']['input'];
  status?: InputMaybe<EnumPromotionAccessOperatorStatus>;
};

export type PromotionAvailability = {
  __typename?: 'PromotionAvailability';
  dates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  endDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  type: EnumPromotionAvailabilityType;
};

export type PromotionAvailabilityInput = {
  dates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  type: EnumPromotionAvailabilityType;
};

export type PromotionDisconnectOrganizationPayload = {
  __typename?: 'PromotionDisconnectOrganizationPayload';
  record?: Maybe<Promotion>;
};

export type PromotionHistory = {
  __typename?: 'PromotionHistory';
  action: EnumPromotionHistoryAction;
  note?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['MongoID']['output']>;
  sourceType?: Maybe<EnumPromotionHistorySourceType>;
  timestamp: Scalars['Date']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['MongoID']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type PromotionHistoryInput = {
  action: EnumPromotionHistoryAction;
  note?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  sourceType?: InputMaybe<EnumPromotionHistorySourceType>;
  timestamp: Scalars['Date']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionTags = {
  __typename?: 'PromotionTags';
  global: Array<Tag>;
  organizationSpecific: Array<Tag>;
};

export type PromotionTagsInput = {
  global?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export enum PromotionTimeframe {
  Active = 'Active',
  All = 'All',
  Past = 'Past'
}

export type PublicMedia = {
  __typename?: 'PublicMedia';
  _id: Scalars['MongoID']['output'];
  asset?: Maybe<Scalars['String']['output']>;
  attention?: Maybe<PublicMediaAttention>;
  blurhash?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Multilingual>;
  carouselThumbnailAsset?: Maybe<Scalars['String']['output']>;
  copyright?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Multilingual>;
  height?: Maybe<Scalars['Float']['output']>;
  likeCount: Scalars['Float']['output'];
  mediaTags: Array<Maybe<Scalars['MongoID']['output']>>;
  mediaType: EnumPublicMediaMediaType;
  mux?: Maybe<PublicMediaMux>;
  organization: Scalars['MongoID']['output'];
  posterUrl?: Maybe<Scalars['String']['output']>;
  relatedListingNames: Array<Scalars['String']['output']>;
  relatedListings: Array<Maybe<Scalars['MongoID']['output']>>;
  source: PublicMediaSource;
  sourceEnv?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<PublicMediaStats>;
  status: EnumPublicMediaStatus;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  useCarouselThumbnail: Scalars['Boolean']['output'];
  width?: Maybe<Scalars['Float']['output']>;
};

export type PublicMediaAttention = {
  __typename?: 'PublicMediaAttention';
  ignoredAt?: Maybe<Scalars['Date']['output']>;
  ignoredBy?: Maybe<Scalars['MongoID']['output']>;
  issues?: Maybe<Array<Maybe<PublicMediaAttentionIssues>>>;
};

export type PublicMediaAttentionIssues = {
  __typename?: 'PublicMediaAttentionIssues';
  flag: EnumPublicMediaAttentionIssuesFlag;
  flaggedAt: Scalars['Date']['output'];
  listingId?: Maybe<Scalars['MongoID']['output']>;
  listingName?: Maybe<Scalars['String']['output']>;
};

export type PublicMediaListingSelectionInput = {
  listingId: Scalars['MongoID']['input'];
  originalAssetId: Scalars['String']['input'];
};

export type PublicMediaMux = {
  __typename?: 'PublicMediaMux';
  assetId: Scalars['String']['output'];
  playbackId: Scalars['String']['output'];
};

export type PublicMediaSource = {
  __typename?: 'PublicMediaSource';
  externalProvider?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  kind: EnumPublicMediaSourceKind;
  listingId?: Maybe<Scalars['MongoID']['output']>;
  originalAssetId?: Maybe<Scalars['String']['output']>;
};

export type PublicMediaStats = {
  __typename?: 'PublicMediaStats';
  ctaClicks?: Maybe<Scalars['Float']['output']>;
  shares?: Maybe<Scalars['Float']['output']>;
  syncedAt?: Maybe<Scalars['Date']['output']>;
  views?: Maybe<Scalars['Float']['output']>;
};

export type PublicRenewablePurchase = {
  __typename?: 'PublicRenewablePurchase';
  _id: Scalars['MongoID']['output'];
  appliedDiscount?: Maybe<PublicRenewablePurchaseAppliedDiscount>;
  billingIntervalMonths: Scalars['Int']['output'];
  cancelledAt?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['String']['output']>;
  currentPeriodEnd: Scalars['String']['output'];
  currentPeriodStart: Scalars['String']['output'];
  originalChargeAmount?: Maybe<Scalars['Float']['output']>;
  originalOrder: Scalars['String']['output'];
  renewalOrders: Array<Scalars['String']['output']>;
  retryCount: Scalars['Int']['output'];
  selectedTier?: Maybe<PublicRenewablePurchaseSelectedTier>;
  status: Scalars['String']['output'];
};

export type PublicRenewablePurchaseAppliedDiscount = {
  __typename?: 'PublicRenewablePurchaseAppliedDiscount';
  discountAmount?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
};

export type PublicRenewablePurchaseSelectedTier = {
  __typename?: 'PublicRenewablePurchaseSelectedTier';
  price: Scalars['Float']['output'];
  tierId: Scalars['String']['output'];
  tierName?: Maybe<Multilingual>;
};

export type PublicRenewalRecord = {
  __typename?: 'PublicRenewalRecord';
  _id: Scalars['MongoID']['output'];
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  periodEnd: Scalars['String']['output'];
  periodStart: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PublicationStatus = {
  __typename?: 'PublicationStatus';
  _id: Scalars['MongoID']['output'];
  changeSummary?: Maybe<Scalars['String']['output']>;
  consolidatedChangeSummary?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  entity: VersionedEntityReference;
  isStale: Scalars['Boolean']['output'];
  organization?: Maybe<Organization>;
  status?: Maybe<PublicationStatusType>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type PublicationStatusHistoryRecord = {
  __typename?: 'PublicationStatusHistoryRecord';
  changeSummary?: Maybe<Scalars['String']['output']>;
  changedByName?: Maybe<Scalars['String']['output']>;
  consolidatedChangeSummary?: Maybe<Scalars['String']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['String']['output'];
  updatedDateISO?: Maybe<Scalars['String']['output']>;
};

export enum PublicationStatusType {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  NeedsApproval = 'NEEDS_APPROVAL',
  Unpublished = 'UNPUBLISHED'
}

export type PublishValidationIssue = {
  __typename?: 'PublishValidationIssue';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type PurchasedProduct = {
  __typename?: 'PurchasedProduct';
  _id: Scalars['MongoID']['output'];
  businessScopes?: Maybe<Array<Maybe<PurchasedProductBusinessScopes>>>;
  customFieldResponses?: Maybe<Array<Maybe<PurchasedProductCustomFieldResponses>>>;
  guestsPerTier: Array<Maybe<PurchasedProductGuestsPerTier>>;
  inventoryClaims: Array<Maybe<PurchasedProductInventoryClaims>>;
  merchVariantId?: Maybe<Scalars['String']['output']>;
  product: Product;
  quantity: Scalars['Float']['output'];
  sessionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tierId?: Maybe<Scalars['String']['output']>;
};

export type PurchasedProductBusinessScopes = {
  __typename?: 'PurchasedProductBusinessScopes';
  businessName?: Maybe<Scalars['String']['output']>;
  customFieldResponses?: Maybe<Array<Maybe<PurchasedProductCustomFieldResponses>>>;
  operatorId: Scalars['String']['output'];
};

export type PurchasedProductCustomFieldResponses = {
  __typename?: 'PurchasedProductCustomFieldResponses';
  fieldId: Scalars['String']['output'];
  isChoiceList?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: EnumPurchasedProductCustomFieldResponsesType;
};

export type PurchasedProductGuestsPerTier = {
  __typename?: 'PurchasedProductGuestsPerTier';
  count: Scalars['Float']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  sessionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tierId: Scalars['MongoID']['output'];
};

export type PurchasedProductGuestsPerTierInput = {
  count: Scalars['Float']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
  sessionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tierId: Scalars['MongoID']['input'];
};

export type PurchasedProductInventoryClaims = {
  __typename?: 'PurchasedProductInventoryClaims';
  _id?: Maybe<Scalars['MongoID']['output']>;
  claimedDateRangeISO?: Maybe<DateRangeIso>;
  inventory?: Maybe<InventoryItem>;
};

export type PurgeTestDataResult = {
  __typename?: 'PurgeTestDataResult';
  purgedOrderCount: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  activityLogById?: Maybe<ActivityLog>;
  activityLogCount?: Maybe<Scalars['Int']['output']>;
  activityLogMany: Array<ActivityLog>;
  adminStorefrontSalesReport?: Maybe<Array<Maybe<AdminStorefrontSalesReportRow>>>;
  adminUsersList?: Maybe<Array<Maybe<AdminUserInfo>>>;
  adminUsersSearchable?: Maybe<Array<Maybe<AdminUserInfo>>>;
  adminlandListingsExport: Array<AdminlandListingsExportItem>;
  aiTasksByOperator: Array<AiTask>;
  analyticsDashboardById?: Maybe<AnalyticsDashboard>;
  analyticsDashboardMany: Array<AnalyticsDashboard>;
  apiAccessByOrg: Array<Maybe<ApiAccess>>;
  apiAccessMany: Array<ApiAccess>;
  apiAccessOne?: Maybe<ApiAccess>;
  assetById?: Maybe<AssetUnion>;
  assetByIds: Array<AssetUnion>;
  assetMany: Array<AssetUnion>;
  bookerById?: Maybe<Booker>;
  bookerByIds: Array<Booker>;
  bookerByMainProductId?: Maybe<Booker>;
  bookerCartPrice?: Maybe<CartPrices>;
  bookerCheckEligibility: BookerEligibilityResult;
  bookerConfirmationEmailPreview?: Maybe<BookerConfirmationEmailPreview>;
  bookerFeeAbsorptionPreview?: Maybe<BookerFeeAbsorptionPreview>;
  bookerFulfillmentOptions: BookerFulfillmentOptions;
  bookerMany: Array<Booker>;
  bookerSendContactUsEmail?: Maybe<EmailResponse>;
  broadcastAllStats: BroadcastAllStatsResult;
  broadcastById?: Maybe<Broadcast>;
  broadcastByIdStatsPerPerson: BroadcastStats;
  broadcastByUser: Array<BroadcastWithOwnerName>;
  broadcastCount?: Maybe<Scalars['Int']['output']>;
  broadcastMany: Array<Broadcast>;
  broadcastStatsByOrganization: BroadcastStatsForOrganization;
  broadcastTeaserById?: Maybe<BroadcastTeaserResult>;
  broadcastsByIdsStatsForSingleUser: Array<BroadcastViewedStats>;
  bulkConnectLogMany: Array<BulkConnectLog>;
  campaignFindOne?: Maybe<Campaign>;
  changeLogMany: Array<Changelog>;
  changeLogManyPersonDetails: Array<ChangelogPersonDetails>;
  courseProgressGet?: Maybe<CourseProgress>;
  courseProgressMany?: Maybe<Array<Maybe<CourseProgress>>>;
  cronJobsList?: Maybe<Array<Maybe<CronJobInfo>>>;
  devToolsEmailReplaceProgress?: Maybe<EmailReplaceProgress>;
  devToolsEmailScan?: Maybe<DevToolsEmailScanPayload>;
  devToolsMembershipSeedPreview?: Maybe<DevMembershipSeedPreview>;
  devToolsMembershipSeedRuns?: Maybe<Array<Maybe<DevMembershipSeedRun>>>;
  devToolsProdSyncCheck?: Maybe<ProdSyncCheckPayload>;
  directoryBulkInvitePreview?: Maybe<DirectoryBulkInvitePreviewResult>;
  directoryMediaSearch?: Maybe<Scalars['JSON']['output']>;
  directoryOperatorEntityIds: Array<Scalars['String']['output']>;
  directoryOperators?: Maybe<DirectoryOperatorsResult>;
  discountById?: Maybe<Discount>;
  discountByIds: Array<Discount>;
  discountMany: Array<Discount>;
  emailSuppressionsAdmin: EmailSuppressionAdminPage;
  eventById?: Maybe<Event>;
  eventCalendarSales?: Maybe<Array<Maybe<EventCalendarSaleItem>>>;
  eventCalendarSessionSales?: Maybe<Array<Maybe<EventCalendarSessionSale>>>;
  eventCount?: Maybe<Scalars['Int']['output']>;
  eventInventorySettings?: Maybe<EventInventorySettings>;
  eventLinkedWidgets?: Maybe<Array<Maybe<EventLinkedWidget>>>;
  eventLookaheadMonths?: Maybe<Scalars['JSON']['output']>;
  eventMany: Array<EventWithOccurrences>;
  eventSessionAvailability?: Maybe<Array<Maybe<EventSessionAvailability>>>;
  eventSessionOrders?: Maybe<Array<Maybe<EventCalendarSessionOrder>>>;
  eventsByIds: Array<Event>;
  featureFlagAdminGates?: Maybe<Array<Maybe<FeatureFlagAdminGate>>>;
  featureFlagGroups: Array<Scalars['String']['output']>;
  featureFlagList?: Maybe<Array<Maybe<FeatureFlagWithGateCount>>>;
  featureFlagOrgGates?: Maybe<Array<Maybe<FeatureFlagOrgGate>>>;
  featureFlagStorefrontGates?: Maybe<Array<Maybe<FeatureFlagStorefrontGate>>>;
  featureFlagsByAdminUser?: Maybe<Array<Maybe<ResolvedFeatureFlag>>>;
  featureFlagsByOrganization?: Maybe<Array<Maybe<ResolvedFeatureFlag>>>;
  featureFlagsByStorefront?: Maybe<Array<Maybe<ResolvedFeatureFlag>>>;
  fileById?: Maybe<AssetFile>;
  fileByIds: Array<AssetFile>;
  fileMany: Array<AssetFile>;
  fulfillmentProfileById?: Maybe<FulfillmentProfile>;
  fulfillmentProfileMany: Array<FulfillmentProfile>;
  galleryNewMediaCount: Scalars['Int']['output'];
  galleryNewMediaMany?: Maybe<Array<GalleryNewMedia>>;
  globalRouteSearch?: Maybe<Array<Maybe<GlobalRouteSearchResult>>>;
  imageById?: Maybe<AssetImage>;
  imageByIds: Array<AssetImage>;
  imageMany: Array<AssetImage>;
  impersonationUserSearch?: Maybe<Array<Maybe<AdminUserInfo>>>;
  importById?: Maybe<Import>;
  importCount?: Maybe<Scalars['Int']['output']>;
  importManagerSettingsFindOne?: Maybe<ImportManagerSettings>;
  importMany: Array<Import>;
  importRunById?: Maybe<ImportRun>;
  importRunCount?: Maybe<Scalars['Int']['output']>;
  importRunMany: Array<ImportRun>;
  importScrapeById?: Maybe<ImportScrape>;
  importScrapeMany: Array<ImportScrape>;
  importScrapeRunById?: Maybe<ImportScrapeRun>;
  importScrapeRunMany: Array<ImportScrapeRun>;
  inventoryById?: Maybe<InventoryItem>;
  inventoryByIds: Array<InventoryItem>;
  /** This resolver will return all the fully booked dates & the check-out only dates per product. */
  inventoryDatesByProduct?: Maybe<InventoryBookedDatesSummary>;
  inventoryMany: Array<InventoryItem>;
  inviteQueueById?: Maybe<InviteQueue>;
  inviteQueueByOperatorAndOrganization?: Maybe<InviteQueue>;
  inviteQueueCleanupPreview?: Maybe<InviteQueueCleanupPreview>;
  inviteQueueMany: Array<InviteQueue>;
  itinerariesByOperator?: Maybe<ItineraryByOperatorResult>;
  itineraryById?: Maybe<Itinerary>;
  itineraryCount: Scalars['Int']['output'];
  itineraryDebugList: Array<ItineraryDebugItem>;
  itineraryMany: Array<Itinerary>;
  itineraryWidgetByItinerary?: Maybe<ItineraryWidget>;
  itineraryWidgetsByItinerary: Array<ItineraryWidget>;
  itineraryWidgetsByOrganization: Array<ItineraryWidgetWithName>;
  leadById?: Maybe<Lead>;
  leadByIds: Array<Lead>;
  leadMany: Array<Lead>;
  listById: ListWithEntities;
  listMany: Array<List>;
  listsByIds?: Maybe<Array<ListWithEntities>>;
  maintenanceFindOne?: Maybe<Maintenance>;
  mediaGalleryTagGroup?: Maybe<Scalars['JSON']['output']>;
  memberListsByTierTagIds?: Maybe<Array<List>>;
  membershipBySubjectAndOrganization?: Maybe<Membership>;
  membershipChecklistLatest?: Maybe<MembershipChecklistResult>;
  membershipCustomEmailPreview: MembershipCustomEmailPreview;
  membershipDisplayForPerson?: Maybe<MembershipDisplayForPerson>;
  membershipEventsByMembership?: Maybe<Array<Maybe<MembershipEvent>>>;
  membershipEventsRecent?: Maybe<Array<Maybe<MembershipEvent>>>;
  membershipEventsRecentAdmin?: Maybe<Array<MembershipEventAdminRow>>;
  membershipHubForUser?: Maybe<Array<MembershipHubOrganization>>;
  membershipLaunchStatus: MembershipLaunchStatus;
  membershipListEmailCoverage?: Maybe<MembershipListEmailCoverage>;
  membershipMultiListingCandidates?: Maybe<Array<MembershipMultiListingCandidate>>;
  membershipPaidUpByOperators?: Maybe<Array<Maybe<MembershipPaidUpInfo>>>;
  membershipPaidUpSource?: Maybe<MembershipPaidUpSource>;
  membershipRenewalAuditByOrganization: MembershipRenewalAudit;
  membershipStateCounts: Array<MembershipStateCount>;
  membershipStatsByOrganization: MembershipStats;
  membershipSuggestedRenewalDate?: Maybe<MembershipSuggestedRenewalDate>;
  membershipTimelineMany?: Maybe<Array<MembershipTimelineItem>>;
  membershipsByOperator?: Maybe<Array<Maybe<Membership>>>;
  membershipsByPerson?: Maybe<Array<Maybe<Membership>>>;
  noteById?: Maybe<Note>;
  noteCount?: Maybe<Scalars['Int']['output']>;
  noteMany: Array<Note>;
  notesForListingStaff?: Maybe<Array<Note>>;
  operatorById: OperatorWithStatus;
  operatorByIdNullable?: Maybe<OperatorWithStatus>;
  operatorByIdWithCustomDisplayFilters?: Maybe<OperatorWithStatus>;
  operatorByVersionId: OperatorWithStatus;
  operatorByVersionIds: Array<OperatorWithStatus>;
  operatorDirectoryCounts?: Maybe<OperatorDirectoryCounts>;
  operatorEntityIdsByFilter: Array<Scalars['String']['output']>;
  operatorMany: Array<OperatorWithStatus>;
  operatorManyBillingContactSearch: Array<OperatorBillingContactSearchResult>;
  operatorManyDirectoryCount: Scalars['Int']['output'];
  operatorManyInternalSearch: Array<OperatorWithStatus>;
  operatorManyWithOrganizationStatuses: Array<OperatorManyWithOrganizationStatuses>;
  operatorMembership?: Maybe<OperatorMembership>;
  operatorStaff: Array<UserWithPictureTc>;
  operatorWithOrganizationStatusesCount?: Maybe<Scalars['Int']['output']>;
  operatorsByEntityIds: Array<Maybe<OperatorWithStatus>>;
  operatorsByIds: Array<Maybe<OperatorWithStatusAndStaff>>;
  operatorsByUser: Array<Operator>;
  operatorsCount?: Maybe<Scalars['Int']['output']>;
  orderApprovalsPendingCount: Scalars['Int']['output'];
  orderById?: Maybe<Order>;
  orderByIds: Array<Order>;
  orderMany?: Maybe<OrderFindMany>;
  orderPricesById?: Maybe<CartPrices>;
  orderPricesByIds: Array<OrderCartPrice>;
  ordersForBroadcastResource?: Maybe<Array<Maybe<Order>>>;
  ordersForCurrentUser?: Maybe<Array<Maybe<Order>>>;
  orgOperatorOverlayFindOne?: Maybe<OrgOperatorOverlay>;
  orgOperatorOverlaysByOperator?: Maybe<Array<Maybe<OrgOperatorOverlay>>>;
  orgOperatorOverlaysByOrganization?: Maybe<Array<Maybe<OrgOperatorOverlay>>>;
  orgOverviewByOrganization: OrgOverviewResult;
  organizationByEventSharingCode: OrganizationPartnerSummary;
  organizationById?: Maybe<Organization>;
  organizationCount?: Maybe<Scalars['Int']['output']>;
  organizationEmailDomainAdminByOrganization?: Maybe<OrganizationEmailDomain>;
  organizationEmailDomainByOrganization?: Maybe<OrganizationEmailDomain>;
  organizationEventPartnerSettings: OrganizationEventPartnerSettings;
  organizationEventWidgetSettings?: Maybe<OrganizationEventWidgetSettings>;
  organizationManifestByOrganizationId?: Maybe<OrganizationManifest>;
  organizationMany: Array<Organization>;
  organizationRenewalSchedulePreview: RenewalRebasePlan;
  organizationSearchHarness: Array<Organization>;
  organizationStaff: Array<UserWithPictureTc>;
  organizationsByIds: Array<Organization>;
  organizationsByUser: Array<Organization>;
  paymentMethodSetById?: Maybe<PaymentMethodSet>;
  paymentMethodSetByIds: Array<PaymentMethodSet>;
  paymentMethodSetMany: Array<PaymentMethodSet>;
  paymentRequestById?: Maybe<PaymentRequest>;
  paymentRequestByInvoiceNumber?: Maybe<PaymentRequest>;
  paymentRequestPriceCompute?: Maybe<InvoicePriceComputeResult>;
  paymentRequestsByStorefront?: Maybe<Array<Maybe<PaymentRequest>>>;
  paymentRequestsForCurrentUser: Array<UserUnpaidPaymentRequestRow>;
  paymentRequestsForTeamPurchases: Array<UserUnpaidPaymentRequestRow>;
  pendingRenewalEmails?: Maybe<Array<Maybe<PendingRenewalEmail>>>;
  peopleById?: Maybe<SimplePersonTc>;
  peopleByIds: Array<People>;
  peopleByIdsSimple: Array<SimplePersonManyTc>;
  peopleCount?: Maybe<Scalars['Int']['output']>;
  peopleMany: Array<People>;
  peopleManyDetailed: Array<DetailedPersonInfoTc>;
  peopleManySimple: Array<SimplePersonManyTc>;
  perBusinessAnswersEnabledForOrganization: Scalars['Boolean']['output'];
  personCheckIfExistsByEmail: PersonCheckIfExistsByEmail;
  personDetails?: Maybe<DetailedPersonTc>;
  personFindOne?: Maybe<People>;
  personNextOrder?: Maybe<Order>;
  personNextPayment?: Maybe<ScheduledPayment>;
  placeById?: Maybe<Place>;
  placeMany: Array<Place>;
  placeTree: Array<Maybe<Place>>;
  placesCount?: Maybe<Scalars['Int']['output']>;
  policyById?: Maybe<Policy>;
  policyByIds: Array<Policy>;
  policyMany: Array<Policy>;
  postHogDataMany: Array<PostHogData>;
  postHogEventAndOperatorWidgetStatsByOrganization: PostHogEventAndOperatorWidgetStats;
  postHogStatsTripperAggregate: PostHogTripperAggregateStats;
  postHogStatsTripperOperators: Array<PostHogTripperStats>;
  postHogStatsTripperTimeSeries: Array<PostHogTripperTimeSeriesPoint>;
  postHogStatsWidgetEvents: Array<PostHogEventStats>;
  postHogStatsWidgetOperators: Array<PostHogOperatorStats>;
  productById?: Maybe<Product>;
  productCalendarLinkById: Scalars['String']['output'];
  productClosureById?: Maybe<ClosureData>;
  productInBookers?: Maybe<Array<Maybe<Multilingual>>>;
  productMany: Array<Product>;
  productTotalSales: Scalars['Float']['output'];
  productsByIds: Array<Product>;
  promotionById?: Maybe<Promotion>;
  promotionEligibleOrganizations: Array<Organization>;
  promotionMany: Array<Promotion>;
  promotionsByIds: Array<Promotion>;
  publicMediaById?: Maybe<PublicMedia>;
  publicMediaCount: Scalars['Int']['output'];
  publicMediaForGalleryWidget?: Maybe<Array<PublicMedia>>;
  publicMediaMany?: Maybe<Array<PublicMedia>>;
  publicationStatusFindOne?: Maybe<PublicationStatus>;
  publicationStatusHistory?: Maybe<Array<Maybe<PublicationStatusHistoryRecord>>>;
  refundById?: Maybe<Refund>;
  refundMany: Array<Refund>;
  refundsByOrderIds?: Maybe<Array<Refund>>;
  renewableFeeCoveredOperators?: Maybe<Array<RenewableFeeCoveredOperator>>;
  renewableFeeEarlyRenewals?: Maybe<Array<RenewableFeeEarlyRenewal>>;
  renewableFeeQuote?: Maybe<RenewableFeeQuote>;
  renewablePurchaseById?: Maybe<RenewablePurchase>;
  renewablePurchaseByIdPublic?: Maybe<PublicRenewablePurchase>;
  renewablePurchasesByUser?: Maybe<Array<Maybe<RenewablePurchase>>>;
  renewalEngineSetupPreview: RenewalEngineSetupPreview;
  renewalRecordByPaymentRequest?: Maybe<RenewalRecord>;
  renewalRecordsByPurchase?: Maybe<Array<Maybe<RenewalRecord>>>;
  renewalRecordsByPurchasePublic?: Maybe<Array<Maybe<PublicRenewalRecord>>>;
  renewalRecordsByStorefront?: Maybe<Array<Maybe<RenewalRecord>>>;
  reportByStorefront: ReportResult;
  reportDatasetFields: ReportDatasetFields;
  reportFieldValues: Array<Scalars['String']['output']>;
  reportRun: ReportRunResult;
  ruleById?: Maybe<Rule>;
  ruleByIds: Array<Rule>;
  ruleMany: Array<Rule>;
  savedReportsByStorefront: Array<SavedReport>;
  scheduledPaymentFindMany: Array<ScheduledPayment>;
  scheduledPaymentFindOne?: Maybe<ScheduledPayment>;
  siteBuilderCostReport: Array<SiteBuilderCostRow>;
  siteBuilderEmailChannel: SiteBuilderEmailChannel;
  siteBuilderMessages: Array<SiteBuilderMessage>;
  siteBuilderPageViews: SiteBuilderPageViews;
  siteBuilderPages: Array<SiteBuilderPage>;
  siteBuilderQuestions: Array<SiteBuilderQuestion>;
  siteBuilderRevisions: Array<SiteBuilderRevision>;
  siteBuilderSettings: SiteBuilderSettingsResult;
  siteBuilderSignals: Array<SiteBuilderSignal>;
  siteBuilderSite?: Maybe<SiteBuilderSite>;
  siteBuilderSites: Array<SiteBuilderSite>;
  siteBuilderSkillFeedback: Array<SiteBuilderSkillFeedback>;
  siteBuilderSkillsCatalog: Scalars['JSON']['output'];
  siteBuilderStaffUsers: Array<SiteBuilderStaffUser>;
  siteBuilderTasks: Array<SiteBuilderTask>;
  statsSnapshotsByOrganization?: Maybe<Array<StatsSnapshot>>;
  storefrontById?: Maybe<Storefront>;
  storefrontByIds: Array<Storefront>;
  storefrontCalendarFeed?: Maybe<StorefrontCalendarFeed>;
  storefrontConnectedAccounts: Array<StripeAccountStatus>;
  storefrontCount?: Maybe<Scalars['Int']['output']>;
  storefrontInventory: Array<StorefrontInventoryRow>;
  storefrontInventoryLog: Array<InventoryLogEntry>;
  storefrontListingCandidates: Array<StorefrontListingCandidate>;
  storefrontMany: Array<Storefront>;
  storefrontOrderHasCompanyData: Scalars['Boolean']['output'];
  storefrontOrderInvoiceFeed: StorefrontOrderInvoiceFeed;
  storefrontOwnerEntities: Array<StorefrontOwnerEntity>;
  storefrontPagesByStorefront: Array<StorefrontPageResult>;
  storefrontPlatformSettings?: Maybe<StorefrontPlatformSettings>;
  /** Recent 'generate upcoming invoices' runs for a storefront, newest first. */
  storefrontRenewalInvoiceGenerationRuns?: Maybe<Array<Maybe<RenewalInvoiceGenerationRun>>>;
  storefrontResumeStripeAccountSetup: Scalars['String']['output'];
  storefrontStaff: Array<UserWithPictureTc>;
  /** Members a statement run for `period` (YYYY-MM) would bill, with unbilled after-service orders from that month or earlier. */
  storefrontStatementPreview?: Maybe<Array<Maybe<StatementPreviewGroup>>>;
  /** Recent monthly statement runs, newest first. */
  storefrontStatementRuns?: Maybe<Array<Maybe<StatementGenerationRun>>>;
  storefrontStripeAccountBlockingWidgets: Array<Scalars['String']['output']>;
  storefrontUpcomingRenewalInvoicePreview?: Maybe<UpcomingRenewalInvoicePreviewResult>;
  storefrontsByUser: Array<Storefront>;
  supportCaseById?: Maybe<SupportTicket>;
  supportCasesList: Array<SupportTicket>;
  supportCasesOpenCount: Scalars['Int']['output'];
  supportInvestigationConfig?: Maybe<SupportInvestigationConfig>;
  supportLinearAssignees?: Maybe<Array<Maybe<SupportLinearAssignee>>>;
  surveyById?: Maybe<Survey>;
  surveyMany: Array<Survey>;
  surveyOne?: Maybe<Survey>;
  surveyQuestionById?: Maybe<SurveyQuestion>;
  surveyQuestionByIds: Array<SurveyQuestion>;
  surveyQuestionMany: Array<SurveyQuestion>;
  surveyQuestionOne?: Maybe<SurveyQuestion>;
  surveyResponseById?: Maybe<SurveyResponse>;
  surveyResponseForBroadcastResource?: Maybe<SurveyResponse>;
  surveyResponseMany: Array<SurveyResponse>;
  surveyResponseOne?: Maybe<SurveyResponse>;
  surveyResponsesByWidget?: Maybe<Array<Maybe<SurveyResponse>>>;
  surveyResponsesForBroadcastResource?: Maybe<Array<Maybe<SurveyResponse>>>;
  surveyUsage?: Maybe<Array<SurveyUsage>>;
  tagById?: Maybe<Tag>;
  tagByIds: Array<Tag>;
  tagEntityUsage: TagEntityTypeUsage;
  tagGroupById?: Maybe<TagGroup>;
  tagGroupByIds: Array<TagGroup>;
  tagGroupMany: Array<TagGroup>;
  tagGroupOne?: Maybe<TagGroup>;
  tagMany: Array<Tag>;
  tagManyForPeople: Array<Tag>;
  tagRefreshCounts?: Maybe<Scalars['Boolean']['output']>;
  tagRelationshipsByTag?: Maybe<Array<Maybe<TagRelationship>>>;
  tagSuggestionAnalyze: TagSuggestionAiResponse;
  tagSuggestionById?: Maybe<TagSuggestion>;
  tagSuggestionMany: Array<TagSuggestion>;
  taxById?: Maybe<Tax>;
  taxMany: Array<Tax>;
  testRecordProrationPreview?: Maybe<Array<TestProrationRow>>;
  testRecordsByOrganization?: Maybe<TestRecordsPayload>;
  userById?: Maybe<UserWithPictureTc>;
  userByIds: Array<User>;
  userFindOne?: Maybe<UserWithPictureTc>;
  userFindOneByEmail?: Maybe<UserWithResetPasswordUrlTc>;
  userMany: Array<UserWithPictureTc>;
  userManyForMentions: Array<User>;
  userRequestEmailVerification?: Maybe<Scalars['String']['output']>;
  userSummaryByEmail?: Maybe<UserSummaryByEmail>;
  whereabotAvatar?: Maybe<AssetImage>;
  whereabotChatById?: Maybe<WhereabotChat>;
  whereabotChatMany?: Maybe<Array<Maybe<WhereabotChat>>>;
  whereabotMessagesByChat?: Maybe<Array<Maybe<WhereabotMessage>>>;
  whereabotPromptHistory?: Maybe<Array<Maybe<WhereabotPromptHistoryItem>>>;
  whereabotSettingsGet?: Maybe<WhereabotSettingsWithDefault>;
  widgetById: WidgetWithListEntities;
  widgetCount?: Maybe<Scalars['Int']['output']>;
  widgetEmbedActivityAll?: Maybe<Array<WidgetEmbedActivity>>;
  widgetEmbedActivityByOrganization?: Maybe<Array<WidgetEmbedActivity>>;
  widgetEmbedActivityByWidgetId?: Maybe<Array<WidgetEmbedActivity>>;
  widgetMany: Array<WidgetWithListAndItemCount>;
  widgetManySimple: Array<Widget>;
  widgetsByIds: Array<Widget>;
  workbenchChangeRequestStatus: WorkbenchChangeRequestResult;
  workbenchFeature?: Maybe<WorkbenchFeature>;
  workbenchFeatureList: Array<WorkbenchFeatureCard>;
  workbenchGateState: WorkbenchGateState;
  workbenchReviewSummaries: Array<WhereabotChat>;
  workbenchSeedRuns: Array<WorkbenchSeedRun>;
  workbenchSeedScenarios: Array<WorkbenchSeedScenarioInfo>;
  workbenchSettingsGet: WorkbenchSettingsInfo;
  workbenchSuggestionsByFlag: Array<WorkbenchSuggestion>;
  workbenchTesterCandidates: Array<WorkbenchTesterInfo>;
};


export type QueryActivityLogByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryActivityLogCountArgs = {
  filter?: InputMaybe<FilterCountActivityLogInput>;
};


export type QueryActivityLogManyArgs = {
  filter?: InputMaybe<FilterFindManyActivityLogInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyActivityLogInput>;
};


export type QueryAdminStorefrontSalesReportArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryAdminUsersSearchableArgs = {
  search: Scalars['String']['input'];
};


export type QueryAdminlandListingsExportArgs = {
  businessType?: InputMaybe<EnumOperatorType>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagMode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAiTasksByOperatorArgs = {
  operatorId: Scalars['String']['input'];
};


export type QueryAnalyticsDashboardByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryAnalyticsDashboardManyArgs = {
  filter?: InputMaybe<FilterFindManyAnalyticsDashboardInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAnalyticsDashboardInput>;
};


export type QueryApiAccessManyArgs = {
  filter?: InputMaybe<FilterFindManyApiAccessInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyApiAccessInput>;
};


export type QueryApiAccessOneArgs = {
  filter?: InputMaybe<FilterFindOneApiAccessInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneApiAccessInput>;
};


export type QueryAssetByIdArgs = {
  _id: Scalars['String']['input'];
};


export type QueryAssetByIdsArgs = {
  _ids: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsAssetInput>;
};


export type QueryAssetManyArgs = {
  filter?: InputMaybe<FilterFindManyAssetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAssetInput>;
};


export type QueryBookerByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryBookerByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsBookerInput>;
};


export type QueryBookerByMainProductIdArgs = {
  operatorId?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
};


export type QueryBookerCartPriceArgs = {
  bookerId: Scalars['ID']['input'];
  delivery?: InputMaybe<OrderDeliveryInput>;
  productPurchaseRequests: Array<ProductPurchaseRequest>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  taxExempt?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBookerCheckEligibilityArgs = {
  bookerId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBookerConfirmationEmailPreviewArgs = {
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bookerId: Scalars['MongoID']['input'];
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBookerFeeAbsorptionPreviewArgs = {
  bookerId: Scalars['MongoID']['input'];
};


export type QueryBookerFulfillmentOptionsArgs = {
  bookerId: Scalars['ID']['input'];
};


export type QueryBookerManyArgs = {
  filter?: InputMaybe<FilterFindManyBookerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyBookerInput>;
};


export type QueryBookerSendContactUsEmailArgs = {
  bookerId: Scalars['ID']['input'];
  details: ContactUsEmailDetails;
};


export type QueryBroadcastAllStatsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  ownerEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBroadcastByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryBroadcastByIdStatsPerPersonArgs = {
  broadcastId: Scalars['ID']['input'];
};


export type QueryBroadcastCountArgs = {
  filter?: InputMaybe<FilterCountBroadcastInput>;
};


export type QueryBroadcastManyArgs = {
  filter?: InputMaybe<FilterFindManyBroadcastInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyBroadcastInput>;
};


export type QueryBroadcastStatsByOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryBroadcastTeaserByIdArgs = {
  broadcastId: Scalars['MongoID']['input'];
};


export type QueryBroadcastsByIdsStatsForSingleUserArgs = {
  broadcastIds: Array<Scalars['ID']['input']>;
};


export type QueryBulkConnectLogManyArgs = {
  filter?: InputMaybe<FilterFindManyBulkConnectLogInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyBulkConnectLogInput>;
};


export type QueryCampaignFindOneArgs = {
  filter?: InputMaybe<FilterFindOneCampaignInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCampaignInput>;
};


export type QueryChangeLogManyArgs = {
  filter?: InputMaybe<FilterFindManyChangelogInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyChangelogInput>;
};


export type QueryChangeLogManyPersonDetailsArgs = {
  filter?: InputMaybe<FilterFindManyChangelogInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyChangelogInput>;
};


export type QueryCourseProgressGetArgs = {
  broadcastId: Scalars['MongoID']['input'];
  resourceId: Scalars['MongoID']['input'];
};


export type QueryCourseProgressManyArgs = {
  broadcastId: Scalars['MongoID']['input'];
  resourceId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryDevToolsEmailScanArgs = {
  skipDomains: Array<Scalars['String']['input']>;
  targetEmailFormat?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDevToolsMembershipSeedPreviewArgs = {
  input: DevMembershipSeedInput;
};


export type QueryDevToolsMembershipSeedRunsArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDirectoryBulkInvitePreviewArgs = {
  includeDmoManaged?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  recipientMode?: InputMaybe<BulkInviteRecipientMode>;
  tagFilters?: InputMaybe<Array<InputMaybe<BulkInviteTagFilterInput>>>;
  viewContext?: InputMaybe<BulkInviteViewContext>;
};


export type QueryDirectoryMediaSearchArgs = {
  alreadyUsed?: InputMaybe<Scalars['Boolean']['input']>;
  amenityTagIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  backOfficeTagIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  businessTypeTagIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  keywordTagIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listId?: InputMaybe<Scalars['MongoID']['input']>;
  location?: InputMaybe<Array<Scalars['Float']['input']>>;
  mediaTagIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  selectedTagGroupIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
};


export type QueryDirectoryOperatorEntityIdsArgs = {
  audienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  claimed?: InputMaybe<Scalars['Boolean']['input']>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noAudienceTags?: InputMaybe<Scalars['Boolean']['input']>;
  notInWidgets?: InputMaybe<Scalars['Boolean']['input']>;
  operationalStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationControlled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  publicationStatus?: InputMaybe<PublicationStatusType>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  usedInWidgets?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDirectoryOperatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  audienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  claimed?: InputMaybe<Scalars['Boolean']['input']>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  noAudienceTags?: InputMaybe<Scalars['Boolean']['input']>;
  notInWidgets?: InputMaybe<Scalars['Boolean']['input']>;
  operationalStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationControlled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  publicationStatus?: InputMaybe<PublicationStatusType>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<DirectorySortEnum>;
  type?: InputMaybe<Scalars['String']['input']>;
  usedInWidgets?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDiscountByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryDiscountByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsDiscountInput>;
};


export type QueryDiscountManyArgs = {
  filter?: InputMaybe<FilterFindManyDiscountInput>;
  isUsable?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyDiscountInput>;
  types?: InputMaybe<Array<EnumDiscountType>>;
};


export type QueryEmailSuppressionsAdminArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  reason?: InputMaybe<EmailSuppressionReasonEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryEventCalendarSalesArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  storefrontId: Scalars['ID']['input'];
};


export type QueryEventCalendarSessionSalesArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  storefrontId: Scalars['ID']['input'];
};


export type QueryEventCountArgs = {
  endDate: Scalars['String']['input'];
  operatorId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['String']['input'];
};


export type QueryEventInventorySettingsArgs = {
  eventId: Scalars['ID']['input'];
};


export type QueryEventLinkedWidgetsArgs = {
  eventId: Scalars['ID']['input'];
  notInBookerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEventLookaheadMonthsArgs = {
  operatorId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEventManyArgs = {
  allowPastEvents?: InputMaybe<Scalars['Boolean']['input']>;
  endDate: Scalars['String']['input'];
  keepEventsWithNoFutureOccurrences?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Array<Scalars['Float']['input']>>;
  operatorId?: InputMaybe<Scalars['ID']['input']>;
  operatorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  skipRecurrences?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['String']['input'];
  status?: InputMaybe<EventStatus>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  useOrgEventWidgetSettings?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEventSessionAvailabilityArgs = {
  productId: Scalars['ID']['input'];
  sessionIds: Array<Scalars['String']['input']>;
};


export type QueryEventSessionOrdersArgs = {
  eventId: Scalars['ID']['input'];
  sessionDate?: InputMaybe<Scalars['String']['input']>;
  storefrontId: Scalars['ID']['input'];
};


export type QueryEventsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsEventInput>;
};


export type QueryFeatureFlagAdminGatesArgs = {
  featureFlagId: Scalars['MongoID']['input'];
};


export type QueryFeatureFlagListArgs = {
  includeExpelled?: InputMaybe<Scalars['Boolean']['input']>;
  includeGraduated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFeatureFlagOrgGatesArgs = {
  featureFlagId: Scalars['MongoID']['input'];
};


export type QueryFeatureFlagStorefrontGatesArgs = {
  featureFlagId: Scalars['MongoID']['input'];
};


export type QueryFeatureFlagsByOrganizationArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type QueryFeatureFlagsByStorefrontArgs = {
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  storefrontId: Scalars['MongoID']['input'];
};


export type QueryFileByIdArgs = {
  _id: Scalars['String']['input'];
};


export type QueryFileByIdsArgs = {
  _ids: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsAssetFileInput>;
};


export type QueryFileManyArgs = {
  filter?: InputMaybe<FilterFindManyAssetFileInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAssetFileInput>;
};


export type QueryFulfillmentProfileByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryFulfillmentProfileManyArgs = {
  filter?: InputMaybe<FilterFindManyFulfillmentProfileInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyFulfillmentProfileInput>;
};


export type QueryGalleryNewMediaCountArgs = {
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGalleryNewMediaManyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGlobalRouteSearchArgs = {
  kinds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryImageByIdArgs = {
  _id: Scalars['String']['input'];
};


export type QueryImageByIdsArgs = {
  _ids: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsAssetImageInput>;
};


export type QueryImageManyArgs = {
  filter?: InputMaybe<FilterFindManyAssetImageInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAssetImageInput>;
};


export type QueryImpersonationUserSearchArgs = {
  search: Scalars['String']['input'];
};


export type QueryImportByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryImportCountArgs = {
  filter?: InputMaybe<FilterCountImportInput>;
};


export type QueryImportManagerSettingsFindOneArgs = {
  filter?: InputMaybe<FilterFindOneImportManagerSettingsInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneImportManagerSettingsInput>;
};


export type QueryImportManyArgs = {
  filter?: InputMaybe<FilterFindManyImportInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyImportInput>;
};


export type QueryImportRunByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryImportRunCountArgs = {
  filter?: InputMaybe<FilterCountImportRunInput>;
};


export type QueryImportRunManyArgs = {
  filter?: InputMaybe<FilterFindManyImportRunInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyImportRunInput>;
};


export type QueryImportScrapeByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryImportScrapeManyArgs = {
  filter?: InputMaybe<FilterFindManyImportScrapeInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyImportScrapeInput>;
};


export type QueryImportScrapeRunByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryImportScrapeRunManyArgs = {
  filter?: InputMaybe<FilterFindManyImportScrapeRunInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyImportScrapeRunInput>;
};


export type QueryInventoryByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryInventoryByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsInventoryItemInput>;
};


export type QueryInventoryDatesByProductArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryInventoryManyArgs = {
  filter?: InputMaybe<FilterFindManyInventoryItemInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInventoryItemInput>;
};


export type QueryInviteQueueByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryInviteQueueByOperatorAndOrganizationArgs = {
  operatorEntityId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
};


export type QueryInviteQueueCleanupPreviewArgs = {
  criteria: InviteQueueCleanupCriteriaInput;
  organizationId: Scalars['MongoID']['input'];
};


export type QueryInviteQueueManyArgs = {
  filter?: InputMaybe<FilterFindManyInviteQueueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInviteQueueInput>;
};


export type QueryItinerariesByOperatorArgs = {
  operatorEntityId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryItineraryByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryItineraryCountArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryItineraryDebugListArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryItineraryManyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryItineraryWidgetByItineraryArgs = {
  itineraryId: Scalars['MongoID']['input'];
};


export type QueryItineraryWidgetsByItineraryArgs = {
  itineraryId: Scalars['MongoID']['input'];
};


export type QueryItineraryWidgetsByOrganizationArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type QueryLeadByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryLeadByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsLeadInput>;
};


export type QueryLeadManyArgs = {
  filter?: InputMaybe<FilterFindManyLeadInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyLeadInput>;
};


export type QueryListByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryListManyArgs = {
  filter?: InputMaybe<FilterFindManyListInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyListInput>;
};


export type QueryListsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsListInput>;
};


export type QueryMaintenanceFindOneArgs = {
  filter?: InputMaybe<FilterFindOneMaintenanceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneMaintenanceInput>;
};


export type QueryMemberListsByTierTagIdsArgs = {
  organizationId: Scalars['ID']['input'];
  tierTagIds: Array<Scalars['ID']['input']>;
};


export type QueryMembershipBySubjectAndOrganizationArgs = {
  organizationId: Scalars['MongoID']['input'];
  subjectEntityId: Scalars['MongoID']['input'];
  subjectType: Scalars['String']['input'];
};


export type QueryMembershipChecklistLatestArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type QueryMembershipCustomEmailPreviewArgs = {
  listId: Scalars['MongoID']['input'];
  operatorEntityIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  organizationId: Scalars['MongoID']['input'];
};


export type QueryMembershipDisplayForPersonArgs = {
  organizationId: Scalars['MongoID']['input'];
  personId: Scalars['MongoID']['input'];
};


export type QueryMembershipEventsByMembershipArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  membershipId: Scalars['MongoID']['input'];
};


export type QueryMembershipEventsRecentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryMembershipEventsRecentAdminArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryMembershipHubForUserArgs = {
  organizationIds: Array<Scalars['MongoID']['input']>;
};


export type QueryMembershipLaunchStatusArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type QueryMembershipListEmailCoverageArgs = {
  listId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
};


export type QueryMembershipMultiListingCandidatesArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type QueryMembershipPaidUpByOperatorsArgs = {
  includeContact?: InputMaybe<Scalars['Boolean']['input']>;
  operatorEntityIds: Array<Scalars['MongoID']['input']>;
  organizationId: Scalars['MongoID']['input'];
};


export type QueryMembershipPaidUpSourceArgs = {
  organizationId: Scalars['MongoID']['input'];
  subjectEntityId: Scalars['MongoID']['input'];
  subjectType: Scalars['String']['input'];
};


export type QueryMembershipRenewalAuditByOrganizationArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type QueryMembershipStateCountsArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type QueryMembershipStatsByOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryMembershipSuggestedRenewalDateArgs = {
  organizationId: Scalars['MongoID']['input'];
  subjectEntityId: Scalars['MongoID']['input'];
  subjectType: Scalars['String']['input'];
};


export type QueryMembershipTimelineManyArgs = {
  organizationId: Scalars['ID']['input'];
  subjectEntityId: Scalars['ID']['input'];
  subjectType: Scalars['String']['input'];
};


export type QueryMembershipsByOperatorArgs = {
  operatorEntityId: Scalars['MongoID']['input'];
};


export type QueryMembershipsByPersonArgs = {
  personId: Scalars['MongoID']['input'];
};


export type QueryNoteByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryNoteCountArgs = {
  filter?: InputMaybe<FilterCountNoteInput>;
};


export type QueryNoteManyArgs = {
  filter?: InputMaybe<FilterFindManyNoteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNoteInput>;
};


export type QueryNotesForListingStaffArgs = {
  operatorEntityId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryOperatorByIdArgs = {
  loggedInAs?: InputMaybe<OwnerInput>;
  operatorEntityId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatusType>;
};


export type QueryOperatorByIdNullableArgs = {
  loggedInAs?: InputMaybe<OwnerInput>;
  operatorEntityId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatusType>;
};


export type QueryOperatorByIdWithCustomDisplayFiltersArgs = {
  operatorEntityId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatusType>;
};


export type QueryOperatorByVersionIdArgs = {
  operatorVersionId: Scalars['ID']['input'];
};


export type QueryOperatorByVersionIdsArgs = {
  operatorVersionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryOperatorDirectoryCountsArgs = {
  hideTemporarilyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  showPermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOperatorEntityIdsByFilterArgs = {
  businessType?: InputMaybe<EnumOperatorType>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagMode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOperatorManyArgs = {
  avgImageQuality?: InputMaybe<Array<ImageQualityRating>>;
  claimedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  excludePermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  excludeTemporarilyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FilterFindManyOperatorInput>;
  imageCount?: InputMaybe<NumberInput>;
  includeInvitedOrAcceptedStaffCounts?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  noAudienceTagsForOrganization?: InputMaybe<Scalars['MongoID']['input']>;
  publicationStatus?: InputMaybe<PublicationStatusType>;
  publicationStatuses?: InputMaybe<Array<PublicationStatusType>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyOperatorInput>;
  useCase?: InputMaybe<OperatorManyUseCaseEnum>;
  usedInWidgetsForOrganization?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryOperatorManyBillingContactSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['MongoID']['input'];
  search: Scalars['String']['input'];
};


export type QueryOperatorManyDirectoryCountArgs = {
  claimed?: InputMaybe<Scalars['Boolean']['input']>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  operationalStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationControlled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  publicationStatus?: InputMaybe<PublicationStatusType>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOperatorManyInternalSearchArgs = {
  excludeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOperatorManyWithOrganizationStatusesArgs = {
  businessType?: InputMaybe<EnumOperatorType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OperatorManyWithOrganizationStatusesSortEnum>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagMode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOperatorMembershipArgs = {
  operatorEntityId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryOperatorStaffArgs = {
  operatorId: Scalars['ID']['input'];
};


export type QueryOperatorWithOrganizationStatusesCountArgs = {
  businessType?: InputMaybe<EnumOperatorType>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagMode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOperatorsByEntityIdsArgs = {
  operatorEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<PublicationStatusType>;
};


export type QueryOperatorsByIdsArgs = {
  operatorEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<PublicationStatusType>;
};


export type QueryOperatorsCountArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrderApprovalsPendingCountArgs = {
  storefrontId: Scalars['MongoID']['input'];
};


export type QueryOrderByIdArgs = {
  _id: Scalars['String']['input'];
};


export type QueryOrderByIdsArgs = {
  _ids: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsOrderInput>;
};


export type QueryOrderManyArgs = {
  filter?: InputMaybe<FilterFindManyOrderInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyOrderInput>;
};


export type QueryOrderPricesByIdArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryOrderPricesByIdsArgs = {
  orderIds: Array<Scalars['String']['input']>;
};


export type QueryOrdersForBroadcastResourceArgs = {
  bookerId?: InputMaybe<Scalars['String']['input']>;
  broadcastResourceId: Scalars['String']['input'];
  personId: Scalars['String']['input'];
};


export type QueryOrdersForCurrentUserArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  teamOnly: Scalars['Boolean']['input'];
};


export type QueryOrgOperatorOverlayFindOneArgs = {
  operatorId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
};


export type QueryOrgOperatorOverlaysByOperatorArgs = {
  operatorId: Scalars['MongoID']['input'];
};


export type QueryOrgOperatorOverlaysByOrganizationArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type QueryOrgOverviewByOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationByEventSharingCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryOrganizationByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryOrganizationCountArgs = {
  filter?: InputMaybe<FilterCountOrganizationInput>;
};


export type QueryOrganizationEmailDomainAdminByOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationEmailDomainByOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationManifestByOrganizationIdArgs = {
  filter?: InputMaybe<FilterFindOneOrganizationManifestInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneOrganizationManifestInput>;
};


export type QueryOrganizationManyArgs = {
  filter?: InputMaybe<FilterFindManyOrganizationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyOrganizationInput>;
};


export type QueryOrganizationRenewalSchedulePreviewArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  graceDays?: InputMaybe<Scalars['Int']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  month?: InputMaybe<Scalars['Int']['input']>;
  neverExpire?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['MongoID']['input'];
  outlierTarget?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationSearchHarnessArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
};


export type QueryOrganizationStaffArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsOrganizationInput>;
};


export type QueryPaymentMethodSetByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPaymentMethodSetByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPaymentMethodSetInput>;
};


export type QueryPaymentMethodSetManyArgs = {
  filter?: InputMaybe<FilterFindManyPaymentMethodSetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPaymentMethodSetInput>;
};


export type QueryPaymentRequestByIdArgs = {
  paymentRequestId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryPaymentRequestByInvoiceNumberArgs = {
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaymentRequestPriceComputeArgs = {
  additionalLineItems?: InputMaybe<Scalars['JSON']['input']>;
  appliedDiscount?: InputMaybe<Scalars['JSON']['input']>;
  bookerId: Scalars['MongoID']['input'];
  paymentRequestId?: InputMaybe<Scalars['MongoID']['input']>;
  productSubtotal: Scalars['Int']['input'];
  taxExempt?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaymentRequestsByStorefrontArgs = {
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  storefrontId: Scalars['MongoID']['input'];
};


export type QueryPendingRenewalEmailsArgs = {
  listId?: InputMaybe<Scalars['MongoID']['input']>;
  operatorEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  organizationId: Scalars['MongoID']['input'];
};


export type QueryPeopleByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPeopleByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPeopleInput>;
};


export type QueryPeopleByIdsSimpleArgs = {
  ids: Array<Scalars['ID']['input']>;
  visibleTo?: InputMaybe<FilterFindManyPeopleVisibleToInput>;
};


export type QueryPeopleCountArgs = {
  filter?: InputMaybe<FilterCountPeopleInput>;
  queryBuilder?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryPeopleManyArgs = {
  filter?: InputMaybe<FilterFindManyPeopleInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPeopleInput>;
};


export type QueryPeopleManyDetailedArgs = {
  filter?: InputMaybe<FilterFindManyPeopleInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  queryBuilder?: InputMaybe<Scalars['JSON']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPeopleInput>;
};


export type QueryPeopleManySimpleArgs = {
  filter?: InputMaybe<FilterFindManyPeopleInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  queryBuilder?: InputMaybe<Scalars['JSON']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPeopleInput>;
};


export type QueryPerBusinessAnswersEnabledForOrganizationArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type QueryPersonCheckIfExistsByEmailArgs = {
  email: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  type: EnumOwnerType;
};


export type QueryPersonDetailsArgs = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  personId: Scalars['ID']['input'];
  type?: InputMaybe<EnumOwnerType>;
};


export type QueryPersonFindOneArgs = {
  filter?: InputMaybe<FilterFindOnePeopleInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePeopleInput>;
};


export type QueryPersonNextOrderArgs = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  personId: Scalars['ID']['input'];
  type?: InputMaybe<EnumEntityReferenceType>;
};


export type QueryPersonNextPaymentArgs = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  personId: Scalars['ID']['input'];
  type?: InputMaybe<EnumEntityReferenceType>;
};


export type QueryPlaceByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPlaceManyArgs = {
  filter?: InputMaybe<FilterFindManyPlaceInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPlaceInput>;
};


export type QueryPlacesCountArgs = {
  filter?: InputMaybe<FilterCountPlaceInput>;
};


export type QueryPolicyByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPolicyByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPolicyInput>;
};


export type QueryPolicyManyArgs = {
  filter?: InputMaybe<FilterFindManyPolicyInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPolicyInput>;
};


export type QueryPostHogDataManyArgs = {
  filter?: InputMaybe<FilterFindManyPostHogDataInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPostHogDataInput>;
};


export type QueryPostHogEventAndOperatorWidgetStatsByOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  timestampRange: DateInput;
};


export type QueryPostHogStatsTripperAggregateArgs = {
  itineraryId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  timestampRange: DateInput;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPostHogStatsTripperOperatorsArgs = {
  appContext: PostHogAppContext;
  itineraryId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  timestampRange: DateInput;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPostHogStatsTripperTimeSeriesArgs = {
  itineraryId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  timestampRange: DateInput;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPostHogStatsWidgetEventsArgs = {
  appContext: PostHogAppContext;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  eventName?: InputMaybe<PostHogEventName>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  timestampRange: DateInput;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPostHogStatsWidgetOperatorsArgs = {
  appContext: PostHogAppContext;
  eventName?: InputMaybe<PostHogEventName>;
  listId?: InputMaybe<Scalars['ID']['input']>;
  operatorEntityId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  timestampRange: DateInput;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProductCalendarLinkByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductClosureByIdArgs = {
  closureId: Scalars['ID']['input'];
};


export type QueryProductInBookersArgs = {
  notInBookerId?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
};


export type QueryProductManyArgs = {
  filter?: InputMaybe<FilterFindManyProductInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProductInput>;
};


export type QueryProductTotalSalesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProductInput>;
};


export type QueryPromotionByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPromotionEligibleOrganizationsArgs = {
  operatorEntityId: Scalars['ID']['input'];
};


export type QueryPromotionManyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  operatorId?: InputMaybe<Scalars['ID']['input']>;
  operatorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<EnumPromotionAccessOperatorStatus>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  timeframe?: InputMaybe<PromotionTimeframe>;
};


export type QueryPromotionsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPromotionInput>;
};


export type QueryPublicMediaByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPublicMediaCountArgs = {
  needsAttentionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublicMediaForGalleryWidgetArgs = {
  excludeIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['MongoID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  widgetId: Scalars['MongoID']['input'];
};


export type QueryPublicMediaManyArgs = {
  ids?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mediaTagIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  needsAttentionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  usedInWidget?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPublicationStatusFindOneArgs = {
  filter?: InputMaybe<FilterFindOnePublicationStatusInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePublicationStatusInput>;
};


export type QueryPublicationStatusHistoryArgs = {
  entityId: Scalars['MongoID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['MongoID']['input'];
};


export type QueryRefundByIdArgs = {
  _id: Scalars['String']['input'];
};


export type QueryRefundManyArgs = {
  filter?: InputMaybe<FilterFindManyRefundInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRefundInput>;
};


export type QueryRefundsByOrderIdsArgs = {
  orderIds: Array<Scalars['ID']['input']>;
};


export type QueryRenewableFeeCoveredOperatorsArgs = {
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  operatorIds: Array<Scalars['MongoID']['input']>;
  organizationId: Scalars['MongoID']['input'];
};


export type QueryRenewableFeeEarlyRenewalsArgs = {
  bookerId: Scalars['MongoID']['input'];
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  operatorIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['MongoID']['input'];
  tierId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRenewableFeeQuoteArgs = {
  bookerId: Scalars['MongoID']['input'];
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  operatorId?: InputMaybe<Scalars['MongoID']['input']>;
  operatorIds?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  organizationId: Scalars['MongoID']['input'];
  productId: Scalars['MongoID']['input'];
  tierId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRenewablePurchaseByIdArgs = {
  id: Scalars['MongoID']['input'];
};


export type QueryRenewablePurchaseByIdPublicArgs = {
  id: Scalars['MongoID']['input'];
};


export type QueryRenewablePurchasesByUserArgs = {
  customerId: Scalars['MongoID']['input'];
};


export type QueryRenewalEngineSetupPreviewArgs = {
  organizationId: Scalars['MongoID']['input'];
};


export type QueryRenewalRecordByPaymentRequestArgs = {
  paymentRequestId: Scalars['MongoID']['input'];
};


export type QueryRenewalRecordsByPurchaseArgs = {
  renewablePurchaseId: Scalars['MongoID']['input'];
};


export type QueryRenewalRecordsByPurchasePublicArgs = {
  renewablePurchaseId: Scalars['MongoID']['input'];
};


export type QueryRenewalRecordsByStorefrontArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
  storefrontId: Scalars['MongoID']['input'];
};


export type QueryReportByStorefrontArgs = {
  reportType: Scalars['String']['input'];
  storefrontId: Scalars['MongoID']['input'];
};


export type QueryReportDatasetFieldsArgs = {
  dataset: Scalars['String']['input'];
  storefrontId: Scalars['MongoID']['input'];
};


export type QueryReportFieldValuesArgs = {
  dataset: Scalars['String']['input'];
  field: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  storefrontId: Scalars['MongoID']['input'];
};


export type QueryReportRunArgs = {
  definition?: InputMaybe<ReportDefinitionInput>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  savedReportId?: InputMaybe<Scalars['MongoID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storefrontId: Scalars['MongoID']['input'];
};


export type QueryRuleByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryRuleByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsRuleInput>;
};


export type QueryRuleManyArgs = {
  filter?: InputMaybe<FilterFindManyRuleInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyRuleInput>;
};


export type QuerySavedReportsByStorefrontArgs = {
  storefrontId: Scalars['MongoID']['input'];
};


export type QueryScheduledPaymentFindManyArgs = {
  filter?: InputMaybe<FilterFindManyScheduledPaymentInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyScheduledPaymentInput>;
};


export type QueryScheduledPaymentFindOneArgs = {
  filter?: InputMaybe<FilterFindOneScheduledPaymentInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneScheduledPaymentInput>;
};


export type QuerySiteBuilderCostReportArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySiteBuilderEmailChannelArgs = {
  siteId: Scalars['MongoID']['input'];
};


export type QuerySiteBuilderMessagesArgs = {
  before?: InputMaybe<Scalars['MongoID']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['MongoID']['input'];
};


export type QuerySiteBuilderPageViewsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['MongoID']['input'];
};


export type QuerySiteBuilderPagesArgs = {
  siteId: Scalars['MongoID']['input'];
};


export type QuerySiteBuilderQuestionsArgs = {
  siteId?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySiteBuilderRevisionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['MongoID']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySiteBuilderSignalsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  polarity?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['MongoID']['input']>;
  skillKey?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySiteBuilderSiteArgs = {
  siteId: Scalars['MongoID']['input'];
};


export type QuerySiteBuilderSitesArgs = {
  billingStatus?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['MongoID']['input']>;
  ownerKind?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySiteBuilderSkillFeedbackArgs = {
  skillKey?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySiteBuilderTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  siteId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryStatsSnapshotsByOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryStorefrontByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryStorefrontByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsStorefrontInput>;
};


export type QueryStorefrontCalendarFeedArgs = {
  kind?: InputMaybe<StorefrontCalendarKind>;
  rangeEnd: Scalars['String']['input'];
  rangeStart: Scalars['String']['input'];
  storefrontId: Scalars['ID']['input'];
  summaryYear: Scalars['Int']['input'];
};


export type QueryStorefrontConnectedAccountsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStorefrontCountArgs = {
  filter?: InputMaybe<FilterCountStorefrontInput>;
};


export type QueryStorefrontInventoryArgs = {
  storefrontId: Scalars['ID']['input'];
};


export type QueryStorefrontInventoryLogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  storefrontId: Scalars['ID']['input'];
};


export type QueryStorefrontListingCandidatesArgs = {
  storefrontId: Scalars['ID']['input'];
};


export type QueryStorefrontManyArgs = {
  filter?: InputMaybe<FilterFindManyStorefrontInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyStorefrontInput>;
};


export type QueryStorefrontOrderHasCompanyDataArgs = {
  includeInvoices?: Scalars['Boolean']['input'];
  storefrontId: Scalars['MongoID']['input'];
};


export type QueryStorefrontOrderInvoiceFeedArgs = {
  createdEndDate?: InputMaybe<Scalars['String']['input']>;
  createdStartDate?: InputMaybe<Scalars['String']['input']>;
  filter: StorefrontOrderInvoiceFeedFilter;
  includeInvoices?: Scalars['Boolean']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  storefrontId: Scalars['MongoID']['input'];
};


export type QueryStorefrontOwnerEntitiesArgs = {
  storefrontId: Scalars['ID']['input'];
};


export type QueryStorefrontPagesByStorefrontArgs = {
  storefrontId: Scalars['MongoID']['input'];
};


export type QueryStorefrontRenewalInvoiceGenerationRunsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  storefrontId: Scalars['MongoID']['input'];
};


export type QueryStorefrontResumeStripeAccountSetupArgs = {
  connectedAccountId: Scalars['ID']['input'];
  redirectUrl: Scalars['String']['input'];
  storefrontId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStorefrontStaffArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryStorefrontStatementPreviewArgs = {
  period: Scalars['String']['input'];
  storefrontId: Scalars['MongoID']['input'];
};


export type QueryStorefrontStatementRunsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  storefrontId: Scalars['MongoID']['input'];
};


export type QueryStorefrontStripeAccountBlockingWidgetsArgs = {
  connectedAccountId: Scalars['String']['input'];
  storefrontId: Scalars['ID']['input'];
};


export type QueryStorefrontUpcomingRenewalInvoicePreviewArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  storefrontId: Scalars['MongoID']['input'];
};


export type QuerySupportCaseByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySupportCasesListArgs = {
  bucket: SupportCaseBucket;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySurveyByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySurveyManyArgs = {
  filter?: InputMaybe<FilterFindManySurveyInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySurveyInput>;
};


export type QuerySurveyOneArgs = {
  filter?: InputMaybe<FilterFindOneSurveyInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneSurveyInput>;
};


export type QuerySurveyQuestionByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySurveyQuestionByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsSurveyQuestionInput>;
};


export type QuerySurveyQuestionManyArgs = {
  filter?: InputMaybe<FilterFindManySurveyQuestionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySurveyQuestionInput>;
};


export type QuerySurveyQuestionOneArgs = {
  filter?: InputMaybe<FilterFindOneSurveyQuestionInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneSurveyQuestionInput>;
};


export type QuerySurveyResponseByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QuerySurveyResponseForBroadcastResourceArgs = {
  broadcastId: Scalars['String']['input'];
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  personId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  submissionIndex?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySurveyResponseManyArgs = {
  filter?: InputMaybe<FilterFindManySurveyResponseInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManySurveyResponseInput>;
};


export type QuerySurveyResponseOneArgs = {
  filter?: InputMaybe<FilterFindOneSurveyResponseInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneSurveyResponseInput>;
};


export type QuerySurveyResponsesByWidgetArgs = {
  widgetId: Scalars['String']['input'];
};


export type QuerySurveyResponsesForBroadcastResourceArgs = {
  broadcastId: Scalars['String']['input'];
  personId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
};


export type QuerySurveyUsageArgs = {
  surveyIds: Array<Scalars['MongoID']['input']>;
};


export type QueryTagByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTagByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsTagInput>;
};


export type QueryTagEntityUsageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTagGroupByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTagGroupByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsTagGroupInput>;
};


export type QueryTagGroupManyArgs = {
  filter?: InputMaybe<FilterFindManyTagGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTagGroupInput>;
};


export type QueryTagGroupOneArgs = {
  filter?: InputMaybe<FilterFindOneTagGroupInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneTagGroupInput>;
};


export type QueryTagManyArgs = {
  filter?: InputMaybe<FilterFindManyTagInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTagInput>;
};


export type QueryTagRelationshipsByTagArgs = {
  tagId: Scalars['MongoID']['input'];
};


export type QueryTagSuggestionAnalyzeArgs = {
  tagGroupId: Scalars['ID']['input'];
  tagName: Scalars['String']['input'];
};


export type QueryTagSuggestionByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTagSuggestionManyArgs = {
  filter?: InputMaybe<FilterFindManyTagSuggestionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTagSuggestionInput>;
};


export type QueryTaxByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTaxManyArgs = {
  filter?: InputMaybe<FilterFindManyTaxInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTaxInput>;
};


export type QueryTestRecordProrationPreviewArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QueryTestRecordsByOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryUserByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryUserByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsUserInput>;
};


export type QueryUserFindOneArgs = {
  filter?: InputMaybe<FilterFindOneUserInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};


export type QueryUserFindOneByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryUserManyArgs = {
  filter?: InputMaybe<FilterFindManyUserInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};


export type QueryUserSummaryByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryWhereabotChatByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryWhereabotChatManyArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWhereabotMessagesByChatArgs = {
  before?: InputMaybe<Scalars['MongoID']['input']>;
  chatId: Scalars['MongoID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWidgetByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryWidgetCountArgs = {
  filter?: InputMaybe<FilterCountWidgetInput>;
};


export type QueryWidgetEmbedActivityAllArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWidgetEmbedActivityByOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryWidgetEmbedActivityByWidgetIdArgs = {
  widgetId: Scalars['ID']['input'];
};


export type QueryWidgetManyArgs = {
  filter?: InputMaybe<FilterFindManyWidgetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWidgetInput>;
};


export type QueryWidgetManySimpleArgs = {
  filter?: InputMaybe<FilterFindManyWidgetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWidgetInput>;
};


export type QueryWidgetsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsWidgetInput>;
};


export type QueryWorkbenchChangeRequestStatusArgs = {
  featureFlagKey: Scalars['String']['input'];
  target: Scalars['String']['input'];
};


export type QueryWorkbenchFeatureArgs = {
  featureFlagKey: Scalars['String']['input'];
};


export type QueryWorkbenchFeatureListArgs = {
  includeExpelled?: InputMaybe<Scalars['Boolean']['input']>;
  includeGraduated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWorkbenchGateStateArgs = {
  featureFlagKey: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryWorkbenchReviewSummariesArgs = {
  featureFlagKey: Scalars['String']['input'];
};


export type QueryWorkbenchSeedRunsArgs = {
  featureFlagKey: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryWorkbenchSeedScenariosArgs = {
  featureFlagKey: Scalars['String']['input'];
};


export type QueryWorkbenchSuggestionsByFlagArgs = {
  featureFlagKey: Scalars['String']['input'];
  kind?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  target?: InputMaybe<Scalars['String']['input']>;
};

export type Refund = {
  __typename?: 'Refund';
  _id: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  orderId: Scalars['String']['output'];
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  processorChargeId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status: EnumRefundStatus;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type RemoveByIdAnalyticsDashboardPayload = {
  __typename?: 'RemoveByIdAnalyticsDashboardPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<AnalyticsDashboard>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdApiAccessPayload = {
  __typename?: 'RemoveByIdApiAccessPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<ApiAccess>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdBookerPayload = {
  __typename?: 'RemoveByIdBookerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Booker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdEventPayload = {
  __typename?: 'RemoveByIdEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Event>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdImportPayload = {
  __typename?: 'RemoveByIdImportPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Import>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdImportScrapePayload = {
  __typename?: 'RemoveByIdImportScrapePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<ImportScrape>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdImportScrapeRunPayload = {
  __typename?: 'RemoveByIdImportScrapeRunPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<ImportScrapeRun>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdInventoryItemPayload = {
  __typename?: 'RemoveByIdInventoryItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<InventoryItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdListPayload = {
  __typename?: 'RemoveByIdListPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<List>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdNotePayload = {
  __typename?: 'RemoveByIdNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Note>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdOrderPayload = {
  __typename?: 'RemoveByIdOrderPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Order>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type RemoveByIdPlacePayload = {
  __typename?: 'RemoveByIdPlacePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Place>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdProductPayload = {
  __typename?: 'RemoveByIdProductPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Product>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdPromotionPayload = {
  __typename?: 'RemoveByIdPromotionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Promotion>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdRulePayload = {
  __typename?: 'RemoveByIdRulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Rule>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTagPayload = {
  __typename?: 'RemoveByIdTagPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Tag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTagRelationshipPayload = {
  __typename?: 'RemoveByIdTagRelationshipPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<TagRelationship>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdTaxPayload = {
  __typename?: 'RemoveByIdTaxPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Tax>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveByIdWidgetPayload = {
  __typename?: 'RemoveByIdWidgetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Removed document */
  record?: Maybe<Widget>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type RenewableFeeAddOnInput = {
  businessScopes?: InputMaybe<Array<InputMaybe<AddOnBusinessScopeInput>>>;
  customFieldResponses?: InputMaybe<Array<InputMaybe<CustomFieldResponseInput>>>;
  productId: Scalars['MongoID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type RenewableFeeConfirmResult = {
  __typename?: 'RenewableFeeConfirmResult';
  renewablePurchaseId: Scalars['MongoID']['output'];
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RenewableFeeCoveredOperator = {
  __typename?: 'RenewableFeeCoveredOperator';
  coveredByYou: Scalars['Boolean']['output'];
  currentPeriodEnd?: Maybe<Scalars['String']['output']>;
  operatorId: Scalars['MongoID']['output'];
};

export type RenewableFeeCustomerInput = {
  address?: InputMaybe<AddressInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type RenewableFeeEarlyRenewal = {
  __typename?: 'RenewableFeeEarlyRenewal';
  operatorId?: Maybe<Scalars['MongoID']['output']>;
  renewalOpensOn: Scalars['String']['output'];
  renewsOn: Scalars['String']['output'];
};

export type RenewableFeeInitiateResult = {
  __typename?: 'RenewableFeeInitiateResult';
  clientSecret?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
  renewablePurchaseId: Scalars['MongoID']['output'];
};

export type RenewableFeeMetadata = {
  __typename?: 'RenewableFeeMetadata';
  billingIntervalMonths: Scalars['Float']['output'];
  earlyPurchaseWindowDays?: Maybe<Scalars['Float']['output']>;
  fixedRenewalDay?: Maybe<Scalars['Float']['output']>;
  fixedRenewalMonth?: Maybe<Scalars['Float']['output']>;
  membershipLinked?: Maybe<Scalars['Boolean']['output']>;
  proRateEnabled?: Maybe<Scalars['Boolean']['output']>;
  renewalType?: Maybe<EnumRenewableFeeMetadataRenewalType>;
};

export type RenewableFeeMetadataInput = {
  billingIntervalMonths: Scalars['Float']['input'];
  earlyPurchaseWindowDays?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalDay?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalMonth?: InputMaybe<Scalars['Float']['input']>;
  membershipLinked?: InputMaybe<Scalars['Boolean']['input']>;
  proRateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  renewalType?: InputMaybe<EnumRenewableFeeMetadataRenewalType>;
};

export type RenewableFeeQuote = {
  __typename?: 'RenewableFeeQuote';
  additionalBusinessSavings: Scalars['Float']['output'];
  bonusDays: Scalars['Int']['output'];
  chargeAmount: Scalars['Float']['output'];
  freeDaysUntil?: Maybe<Scalars['String']['output']>;
  fullAmount: Scalars['Float']['output'];
  listingLines: Array<Maybe<RenewableFeeQuoteListingLine>>;
  periodEnd: Scalars['String']['output'];
  pricingKind: Scalars['String']['output'];
  tierAmount: Scalars['Float']['output'];
};

export type RenewableFeeQuoteListingLine = {
  __typename?: 'RenewableFeeQuoteListingLine';
  amount: Scalars['Float']['output'];
  fullPrice: Scalars['Float']['output'];
  index: Scalars['Int']['output'];
};

export type RenewableFeeTaxExemptionInput = {
  claimed?: InputMaybe<Scalars['Boolean']['input']>;
  exemptionNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RenewablePurchase = {
  __typename?: 'RenewablePurchase';
  _id: Scalars['MongoID']['output'];
  appliedDiscount?: Maybe<RenewablePurchaseAppliedDiscount>;
  billingIntervalMonths: Scalars['Float']['output'];
  booker: Scalars['MongoID']['output'];
  broadcastId?: Maybe<Scalars['String']['output']>;
  broadcastResourceId?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['String']['output']>;
  checkoutTagsAppliedAt?: Maybe<Scalars['String']['output']>;
  confirmationEmailSentAt?: Maybe<Scalars['String']['output']>;
  connectedAccountId: Scalars['String']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  currentPeriodEnd: Scalars['String']['output'];
  currentPeriodStart: Scalars['String']['output'];
  customer: Scalars['MongoID']['output'];
  failureReasons: Array<Maybe<Scalars['String']['output']>>;
  fixedRenewalDay?: Maybe<Scalars['Float']['output']>;
  fixedRenewalMonth?: Maybe<Scalars['Float']['output']>;
  lastRenewalReminderSentForPeriodEnd?: Maybe<Scalars['String']['output']>;
  lastRetryDate?: Maybe<Scalars['String']['output']>;
  listingLines?: Maybe<Array<Maybe<RenewablePurchaseListingLines>>>;
  operatorId?: Maybe<Scalars['String']['output']>;
  operatorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  organization: Scalars['String']['output'];
  originalChargeAmount?: Maybe<Scalars['Float']['output']>;
  originalOrder: Scalars['String']['output'];
  pendingOperatorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pendingRecurringLineItems?: Maybe<Array<Maybe<RenewablePurchaseRecurringLineItems>>>;
  pendingTierChange?: Maybe<RenewablePurchaseSelectedTier>;
  proRateEnabled?: Maybe<Scalars['Boolean']['output']>;
  product: Scalars['MongoID']['output'];
  promoUsageCommittedAt?: Maybe<Scalars['String']['output']>;
  recurringLineItems?: Maybe<Array<Maybe<RenewablePurchaseRecurringLineItems>>>;
  renewalBilling?: Maybe<EnumRenewablePurchaseRenewalBilling>;
  renewalOrders: Array<Maybe<Scalars['String']['output']>>;
  renewalType?: Maybe<Scalars['String']['output']>;
  retryCount: Scalars['Float']['output'];
  selectedTier?: Maybe<RenewablePurchaseSelectedTier>;
  status: EnumRenewablePurchaseStatus;
  storefront: Scalars['MongoID']['output'];
  stripeCustomerId: Scalars['String']['output'];
  stripePaymentMethodId: Scalars['String']['output'];
  taxExemption?: Maybe<RenewablePurchaseTaxExemption>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<Scalars['MongoID']['output']>;
};

export type RenewablePurchaseAppliedDiscount = {
  __typename?: 'RenewablePurchaseAppliedDiscount';
  amount: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  discountId: Scalars['String']['output'];
  isOngoing?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  unit: Scalars['String']['output'];
};

export type RenewablePurchaseListingLines = {
  __typename?: 'RenewablePurchaseListingLines';
  amount: Scalars['Float']['output'];
  businessName?: Maybe<Scalars['String']['output']>;
  fullPrice: Scalars['Float']['output'];
  operatorId: Scalars['String']['output'];
};

export type RenewablePurchaseRecurringLineItemAnswerInput = {
  fieldId: Scalars['String']['input'];
  isChoiceList?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  response: Array<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type RenewablePurchaseRecurringLineItemInput = {
  amount: Scalars['Int']['input'];
  businessName?: InputMaybe<Scalars['String']['input']>;
  customFieldResponses?: InputMaybe<Array<RenewablePurchaseRecurringLineItemAnswerInput>>;
  description: Scalars['String']['input'];
  operatorId?: InputMaybe<Scalars['String']['input']>;
  pricingScope?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type RenewablePurchaseRecurringLineItems = {
  __typename?: 'RenewablePurchaseRecurringLineItems';
  amount: Scalars['Float']['output'];
  businessName?: Maybe<Scalars['String']['output']>;
  customFieldResponses?: Maybe<Array<Maybe<PurchasedProductCustomFieldResponses>>>;
  description: Scalars['String']['output'];
  operatorId?: Maybe<Scalars['String']['output']>;
  pricingScope?: Maybe<EnumRenewablePurchaseRecurringLineItemsPricingScope>;
  productId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
};

export type RenewablePurchaseSelectedTier = {
  __typename?: 'RenewablePurchaseSelectedTier';
  price: Scalars['Float']['output'];
  tierId: Scalars['String']['output'];
  tierName: Multilingual;
};

export type RenewablePurchaseTaxExemption = {
  __typename?: 'RenewablePurchaseTaxExemption';
  claimed: Scalars['Boolean']['output'];
  exemptionNumber: Scalars['String']['output'];
};

export type RenewalEngineDetectedRole = {
  __typename?: 'RenewalEngineDetectedRole';
  role: Scalars['String']['output'];
  source: Scalars['String']['output'];
  tagId?: Maybe<Scalars['ID']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
};

export type RenewalEngineRoleCount = {
  __typename?: 'RenewalEngineRoleCount';
  count: Scalars['Int']['output'];
  role: Scalars['String']['output'];
};

export type RenewalEngineSetupPreview = {
  __typename?: 'RenewalEngineSetupPreview';
  byRole: Array<RenewalEngineRoleCount>;
  detected: Array<RenewalEngineDetectedRole>;
  engineOwned: Scalars['Boolean']['output'];
  membersChanging: Scalars['Int']['output'];
};

export type RenewalEngineSetupResult = {
  __typename?: 'RenewalEngineSetupResult';
  byRole: Array<RenewalEngineRoleCount>;
  changed: Scalars['Int']['output'];
};

export type RenewalInvoiceGenerationRun = {
  __typename?: 'RenewalInvoiceGenerationRun';
  _id: Scalars['MongoID']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  currency: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  grandTotalSum: Scalars['Float']['output'];
  invoiceCount: Scalars['Float']['output'];
  items: Array<Maybe<RenewalInvoiceGenerationRunItems>>;
  organization: Scalars['String']['output'];
  rolledBackAt?: Maybe<Scalars['String']['output']>;
  rolledBackBy?: Maybe<Scalars['String']['output']>;
  rolledBackByName?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  status: EnumRenewalInvoiceGenerationRunStatus;
  storefront: Scalars['MongoID']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type RenewalInvoiceGenerationRunItems = {
  __typename?: 'RenewalInvoiceGenerationRunItems';
  businessName?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  grandTotal: Scalars['Float']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  paymentRequestId: Scalars['MongoID']['output'];
  periodEnd: Scalars['String']['output'];
  periodStart: Scalars['String']['output'];
  purchasePrior: RenewalInvoiceGenerationRunItemsPurchasePrior;
  renewablePurchaseId: Scalars['MongoID']['output'];
  renewalRecordId: Scalars['MongoID']['output'];
  rollbackStatus?: Maybe<EnumRenewalInvoiceGenerationRunItemsRollbackStatus>;
  rolledBackAt?: Maybe<Scalars['String']['output']>;
};

export type RenewalInvoiceGenerationRunItemsPurchasePrior = {
  __typename?: 'RenewalInvoiceGenerationRunItemsPurchasePrior';
  currentPeriodEnd: Scalars['String']['output'];
  currentPeriodStart: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type RenewalRebaseGrace = {
  __typename?: 'RenewalRebaseGrace';
  currentGraceDays: Scalars['Int']['output'];
  currentGraceEndsOn?: Maybe<Scalars['Date']['output']>;
  currentGraceIsDefault: Scalars['Boolean']['output'];
  currentNeverExpire: Scalars['Boolean']['output'];
  graceDays: Scalars['Int']['output'];
  graceEndsOn?: Maybe<Scalars['Date']['output']>;
  neverExpire: Scalars['Boolean']['output'];
  nextRenewalDate?: Maybe<Scalars['Date']['output']>;
  overdueCount: Scalars['Int']['output'];
  suggestedGraceDays?: Maybe<Scalars['Int']['output']>;
  targetDate?: Maybe<Scalars['Date']['output']>;
  wouldExpireOnNextSweep: Scalars['Int']['output'];
};

export type RenewalRebaseMember = {
  __typename?: 'RenewalRebaseMember';
  currentDate?: Maybe<Scalars['Date']['output']>;
  entityId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subjectType: Scalars['String']['output'];
  targetDate?: Maybe<Scalars['Date']['output']>;
};

export type RenewalRebasePhaseCounts = {
  __typename?: 'RenewalRebasePhaseCounts';
  expired: Scalars['Int']['output'];
  paidUp: Scalars['Int']['output'];
  renewalWindow: Scalars['Int']['output'];
};

export type RenewalRebasePlan = {
  __typename?: 'RenewalRebasePlan';
  affected: Scalars['Int']['output'];
  byPhase: RenewalRebasePhaseCounts;
  from: RenewalScheduleSnapshot;
  grace: RenewalRebaseGrace;
  outliers: Array<RenewalRebaseMember>;
  skipped: Array<RenewalRebaseMember>;
  to: RenewalScheduleSnapshot;
  unchanged: Scalars['Int']['output'];
  undated: Scalars['Int']['output'];
};

export type RenewalRecord = {
  __typename?: 'RenewalRecord';
  _id: Scalars['MongoID']['output'];
  amount: Scalars['Float']['output'];
  appliedDiscount?: Maybe<PaymentRequestAppliedDiscount>;
  billingIntervalMonths: Scalars['Float']['output'];
  cancelReason?: Maybe<Scalars['String']['output']>;
  cancelledBy?: Maybe<Scalars['MongoID']['output']>;
  completionEmailSentAt?: Maybe<Scalars['String']['output']>;
  completionLeaseExpiresAt?: Maybe<Scalars['String']['output']>;
  completionLeaseId?: Maybe<Scalars['String']['output']>;
  completionTagsAppliedAt?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  currency: Scalars['String']['output'];
  customer: Scalars['MongoID']['output'];
  failureCountedForIntentId?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  listingLines?: Maybe<Array<Maybe<RenewablePurchaseListingLines>>>;
  order?: Maybe<Scalars['String']['output']>;
  organization: Scalars['String']['output'];
  paymentAttemptId?: Maybe<Scalars['String']['output']>;
  paymentInitiatedAt?: Maybe<Scalars['String']['output']>;
  paymentMethodLast4?: Maybe<Scalars['String']['output']>;
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  paymentRequest?: Maybe<Scalars['MongoID']['output']>;
  periodEnd: Scalars['String']['output'];
  periodStart: Scalars['String']['output'];
  recurringLineItems?: Maybe<Array<Maybe<RenewablePurchaseRecurringLineItems>>>;
  renewablePurchase: Scalars['MongoID']['output'];
  status: EnumRenewalRecordStatus;
  storefront: Scalars['MongoID']['output'];
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  tierName?: Maybe<Multilingual>;
  tierPrice?: Maybe<Scalars['Float']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type RenewalRecordPayResult = {
  __typename?: 'RenewalRecordPayResult';
  clientSecret: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
};

export type RenewalScheduleSnapshot = {
  __typename?: 'RenewalScheduleSnapshot';
  fixedRenewalDay?: Maybe<Scalars['Int']['output']>;
  fixedRenewalMonth?: Maybe<Scalars['Int']['output']>;
  renewalType?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
  termYears?: Maybe<Scalars['Int']['output']>;
};

export enum RenewalTestEmailKind {
  Custom = 'CUSTOM',
  RenewalCancelled = 'RENEWAL_CANCELLED',
  RenewalExpired = 'RENEWAL_EXPIRED',
  RenewalInstructions = 'RENEWAL_INSTRUCTIONS',
  RenewalOverdue = 'RENEWAL_OVERDUE',
  RenewalSuccess = 'RENEWAL_SUCCESS'
}

export type ReportCell = {
  __typename?: 'ReportCell';
  field: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ReportColumn = {
  __typename?: 'ReportColumn';
  field: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ReportCondition = {
  __typename?: 'ReportCondition';
  field: Scalars['String']['output'];
  op: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type ReportConditionInput = {
  field: Scalars['String']['input'];
  op: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type ReportDatasetFields = {
  __typename?: 'ReportDatasetFields';
  baseColumns: Array<Scalars['String']['output']>;
  builtAt?: Maybe<Scalars['Date']['output']>;
  fields: Array<ReportField>;
  lastStripeSyncAt?: Maybe<Scalars['Date']['output']>;
  timezone: Scalars['String']['output'];
  timezoneSource: Scalars['String']['output'];
};

export type ReportDefinitionInput = {
  columns: Array<Scalars['String']['input']>;
  conditions: Array<ReportConditionInput>;
  dataset: Scalars['String']['input'];
  groupBy?: InputMaybe<Scalars['String']['input']>;
  groupByGranularity?: InputMaybe<Scalars['String']['input']>;
  match: Scalars['String']['input'];
  sort?: InputMaybe<ReportSortInput>;
};

export type ReportEnumOption = {
  __typename?: 'ReportEnumOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ReportField = {
  __typename?: 'ReportField';
  category: Scalars['String']['output'];
  enumValues: Array<ReportEnumOption>;
  isBase: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  operators: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ReportRebuildResult = {
  __typename?: 'ReportRebuildResult';
  builtAt: Scalars['Date']['output'];
  rowCount: Scalars['Int']['output'];
};

export type ReportResolvedCondition = {
  __typename?: 'ReportResolvedCondition';
  field: Scalars['String']['output'];
  op: Scalars['String']['output'];
  rangeEnd?: Maybe<Scalars['String']['output']>;
  rangeStart?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  valueLabels: Array<Scalars['String']['output']>;
  values: Array<Scalars['String']['output']>;
};

export type ReportResult = {
  __typename?: 'ReportResult';
  builtAt?: Maybe<Scalars['Date']['output']>;
  builtTimezone?: Maybe<Scalars['String']['output']>;
  columns: Array<ReportColumn>;
  rows: Array<ReportRow>;
  timezone: Scalars['String']['output'];
  timezoneSource: Scalars['String']['output'];
};

export type ReportRow = {
  __typename?: 'ReportRow';
  _id: Scalars['ID']['output'];
  cells: Array<ReportCell>;
  rowDateISO?: Maybe<Scalars['String']['output']>;
  searchText: Scalars['String']['output'];
};

export type ReportRunColumn = {
  __typename?: 'ReportRunColumn';
  field: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ReportRunGroup = {
  __typename?: 'ReportRunGroup';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  totals: Array<ReportTotalsEntry>;
};

export type ReportRunResult = {
  __typename?: 'ReportRunResult';
  builtAt?: Maybe<Scalars['Date']['output']>;
  builtTimezone?: Maybe<Scalars['String']['output']>;
  columns: Array<ReportRunColumn>;
  groups: Array<ReportRunGroup>;
  hasBuilt: Scalars['Boolean']['output'];
  missingFields: Array<Scalars['String']['output']>;
  resolvedConditions: Array<ReportResolvedCondition>;
  rowCount: Scalars['Int']['output'];
  rows: Array<ReportRunRow>;
  savedReport?: Maybe<SavedReport>;
  timezone: Scalars['String']['output'];
  timezoneSource: Scalars['String']['output'];
  totals: Array<ReportTotalsEntry>;
};

export type ReportRunRow = {
  __typename?: 'ReportRunRow';
  _id: Scalars['ID']['output'];
  cells: Array<ReportCell>;
  groupKey?: Maybe<Scalars['String']['output']>;
};

export type ReportSort = {
  __typename?: 'ReportSort';
  direction: Scalars['String']['output'];
  field: Scalars['String']['output'];
};

export type ReportSortInput = {
  direction: Scalars['String']['input'];
  field: Scalars['String']['input'];
};

export type ReportTotalsEntry = {
  __typename?: 'ReportTotalsEntry';
  count: Scalars['Int']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  values: Array<ReportCell>;
};

export type ResendBankTransferInstructionsResult = {
  __typename?: 'ResendBankTransferInstructionsResult';
  success: Scalars['Boolean']['output'];
};

export type ResolvedFeatureFlag = {
  __typename?: 'ResolvedFeatureFlag';
  _id: Scalars['MongoID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  expelled: Scalars['Boolean']['output'];
  graduated: Scalars['Boolean']['output'];
  group: Scalars['String']['output'];
  hasExplicitGate: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  scope: Scalars['String']['output'];
};

export type RestaurantOperatorMetadata = {
  __typename?: 'RestaurantOperatorMetadata';
  seatingCapacity?: Maybe<Scalars['Float']['output']>;
};

export type RestaurantOperatorMetadataInput = {
  seatingCapacity?: InputMaybe<Scalars['Float']['input']>;
};

export type RightSideContentTc = {
  __typename?: 'RightSideContentTC';
  entityId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export enum RoleType {
  Developer = 'DEVELOPER',
  Editor = 'EDITOR',
  NoAccess = 'NO_ACCESS',
  Owner = 'OWNER',
  Staff = 'STAFF',
  ViewOnly = 'VIEW_ONLY'
}

export type RollbackInfo = {
  __typename?: 'RollbackInfo';
  deletedCount: Scalars['Int']['output'];
  errorMessages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  imagesDeleted: Scalars['Int']['output'];
  rolledBackAt: Scalars['Date']['output'];
  rolledBackBy: Scalars['String']['output'];
};

export type RollbackRenewalInvoiceGenerationItem = {
  __typename?: 'RollbackRenewalInvoiceGenerationItem';
  businessName?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  paymentRequestId: Scalars['MongoID']['output'];
  status: Scalars['String']['output'];
};

export type RollbackRenewalInvoiceGenerationResult = {
  __typename?: 'RollbackRenewalInvoiceGenerationResult';
  items?: Maybe<Array<Maybe<RollbackRenewalInvoiceGenerationItem>>>;
  rolledBackCount: Scalars['Int']['output'];
  runId: Scalars['MongoID']['output'];
  runStatus: Scalars['String']['output'];
  skippedCount: Scalars['Int']['output'];
};

export type Room = {
  __typename?: 'Room';
  _id?: Maybe<Scalars['MongoID']['output']>;
  amenities?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  type: EnumRoomType;
};

export type RoomInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type: EnumRoomType;
};

export type Rule = {
  __typename?: 'Rule';
  _id: Scalars['MongoID']['output'];
  activePeriod?: Maybe<DateRangeIso>;
  copiedFrom?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  isActive: Scalars['Boolean']['output'];
  storefront: Scalars['MongoID']['output'];
  type: EnumRuleType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  value: Scalars['JSON']['output'];
};

export type RuntimeError = ErrorInterface & {
  __typename?: 'RuntimeError';
  /** Runtime error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type SavedReport = {
  __typename?: 'SavedReport';
  _id: Scalars['MongoID']['output'];
  columns: Array<Scalars['String']['output']>;
  conditions: Array<ReportCondition>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  dataset: Scalars['String']['output'];
  groupBy?: Maybe<Scalars['String']['output']>;
  groupByGranularity?: Maybe<Scalars['String']['output']>;
  match: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sort?: Maybe<ReportSort>;
  storefront: Scalars['MongoID']['output'];
  updatedBy?: Maybe<Scalars['MongoID']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type SavedReportInput = {
  columns: Array<Scalars['String']['input']>;
  conditions: Array<ReportConditionInput>;
  dataset: Scalars['String']['input'];
  groupBy?: InputMaybe<Scalars['String']['input']>;
  groupByGranularity?: InputMaybe<Scalars['String']['input']>;
  match: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sort?: InputMaybe<ReportSortInput>;
};

export type ScheduledPayment = {
  __typename?: 'ScheduledPayment';
  _id: Scalars['MongoID']['output'];
  amount: Scalars['Float']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  dueDate: Scalars['String']['output'];
  failureReasons: Array<Maybe<Scalars['String']['output']>>;
  order: Scalars['String']['output'];
  retryCount?: Maybe<Scalars['Float']['output']>;
  status: EnumScheduledPaymentStatus;
  stripeMetadata?: Maybe<StripeMetadata>;
  successDateISO?: Maybe<Scalars['String']['output']>;
  type: EnumScheduledPaymentType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type ScrapeLogEntry = {
  __typename?: 'ScrapeLogEntry';
  details?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  step: Scalars['String']['output'];
  timestamp: Scalars['Float']['output'];
};

export enum ScrapeRunRatingEnum {
  Bad = 'BAD',
  Good = 'GOOD'
}

export type Seasonality = {
  __typename?: 'Seasonality';
  apr?: Maybe<SeasonalityEnum>;
  aug?: Maybe<SeasonalityEnum>;
  dec?: Maybe<SeasonalityEnum>;
  feb?: Maybe<SeasonalityEnum>;
  jan?: Maybe<SeasonalityEnum>;
  jul?: Maybe<SeasonalityEnum>;
  jun?: Maybe<SeasonalityEnum>;
  mar?: Maybe<SeasonalityEnum>;
  may?: Maybe<SeasonalityEnum>;
  nov?: Maybe<SeasonalityEnum>;
  oct?: Maybe<SeasonalityEnum>;
  sep?: Maybe<SeasonalityEnum>;
};

export enum SeasonalityEnum {
  Closed = 'CLOSED',
  High = 'HIGH',
  Low = 'LOW'
}

export type SeasonalityInput = {
  apr?: InputMaybe<SeasonalityEnum>;
  aug?: InputMaybe<SeasonalityEnum>;
  dec?: InputMaybe<SeasonalityEnum>;
  feb?: InputMaybe<SeasonalityEnum>;
  jan?: InputMaybe<SeasonalityEnum>;
  jul?: InputMaybe<SeasonalityEnum>;
  jun?: InputMaybe<SeasonalityEnum>;
  mar?: InputMaybe<SeasonalityEnum>;
  may?: InputMaybe<SeasonalityEnum>;
  nov?: InputMaybe<SeasonalityEnum>;
  oct?: InputMaybe<SeasonalityEnum>;
  sep?: InputMaybe<SeasonalityEnum>;
};

export type SecurityDepositSettings = {
  __typename?: 'SecurityDepositSettings';
  enabled: Scalars['Boolean']['output'];
  placeHoldDaysBeforeCheckOut: Scalars['Float']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  rateType?: Maybe<EnumSecurityDepositSettingsRateType>;
};

export type SecurityDepositSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  placeHoldDaysBeforeCheckOut?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateType?: InputMaybe<EnumSecurityDepositSettingsRateType>;
};

export type ServiceOperatorMetadata = {
  __typename?: 'ServiceOperatorMetadata';
  _id?: Maybe<Scalars['MongoID']['output']>;
};

export type ServiceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export type ShippingZoneOption = {
  __typename?: 'ShippingZoneOption';
  countries: Array<Scalars['String']['output']>;
  flatRate: Scalars['Int']['output'];
  freeOver?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  perAdditionalItem?: Maybe<Scalars['Int']['output']>;
  subdivisions: Array<Scalars['String']['output']>;
};

export type SimplePersonManyTc = {
  __typename?: 'SimplePersonManyTC';
  _id: Scalars['ID']['output'];
  address?: Maybe<Address>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  isRepeatCustomer?: Maybe<Scalars['Boolean']['output']>;
  isUserClaimed?: Maybe<Scalars['Boolean']['output']>;
  isUserInvited?: Maybe<Scalars['Boolean']['output']>;
  isWhereaboutsUser?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<AssetImage>;
  rightSideContent?: Maybe<Array<Maybe<RightSideContentTc>>>;
  systemRoles?: Maybe<Array<Maybe<EnumPeopleVisibleToSystemRoles>>>;
  tags: Array<Tag>;
  unreadLeads?: Maybe<Array<Maybe<UnreadLeadTc>>>;
};


export type SimplePersonManyTcTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsTagInput>;
};

export type SimplePersonTc = {
  __typename?: 'SimplePersonTC';
  _id: Scalars['ID']['output'];
  address?: Maybe<Address>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type SiteBuilderBillingInput = {
  contractRef?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  responsibleStaff?: InputMaybe<Scalars['MongoID']['input']>;
  status: Scalars['String']['input'];
};

export type SiteBuilderCostRow = {
  __typename?: 'SiteBuilderCostRow';
  costUsd: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  siteCount: Scalars['Int']['output'];
  taskCount: Scalars['Int']['output'];
};

export type SiteBuilderEmailChannel = {
  __typename?: 'SiteBuilderEmailChannel';
  configured: Scalars['Boolean']['output'];
  inboundAddress?: Maybe<Scalars['String']['output']>;
  senders: Array<SiteBuilderSender>;
  suggestions: Array<SiteBuilderSenderSuggestion>;
};

export type SiteBuilderMessage = {
  __typename?: 'SiteBuilderMessage';
  _id: Scalars['MongoID']['output'];
  askForFeedback?: Maybe<Scalars['Boolean']['output']>;
  attachments: Array<Scalars['String']['output']>;
  author?: Maybe<Scalars['MongoID']['output']>;
  channel: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  isError?: Maybe<Scalars['Boolean']['output']>;
  role: Scalars['String']['output'];
  taskId?: Maybe<Scalars['MongoID']['output']>;
};

export type SiteBuilderMessageFeedbackResult = {
  __typename?: 'SiteBuilderMessageFeedbackResult';
  message: SiteBuilderMessage;
  removedPages: Array<Scalars['String']['output']>;
  restoredPages: Array<Scalars['String']['output']>;
};

export type SiteBuilderPage = {
  __typename?: 'SiteBuilderPage';
  _id: Scalars['MongoID']['output'];
  bindings?: Maybe<Scalars['JSON']['output']>;
  previewUrl: Scalars['String']['output'];
  publishedVersion?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  version: Scalars['Int']['output'];
  widgetPlacements?: Maybe<Scalars['JSON']['output']>;
};

export type SiteBuilderPageViews = {
  __typename?: 'SiteBuilderPageViews';
  byDay: Scalars['JSON']['output'];
  byPage: Scalars['JSON']['output'];
  total: Scalars['Int']['output'];
};

export type SiteBuilderQuestion = {
  __typename?: 'SiteBuilderQuestion';
  _id: Scalars['MongoID']['output'];
  answer?: Maybe<Scalars['String']['output']>;
  answeredAt?: Maybe<Scalars['Date']['output']>;
  audience: Scalars['String']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  kind: Scalars['String']['output'];
  options: Array<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
  question: Scalars['String']['output'];
  site: Scalars['MongoID']['output'];
  siteName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  whyBlocking?: Maybe<Scalars['String']['output']>;
};

export type SiteBuilderReferenceInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  screenshotAssetId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SiteBuilderRevision = {
  __typename?: 'SiteBuilderRevision';
  _id: Scalars['MongoID']['output'];
  cause?: Maybe<Scalars['JSON']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  pageSlug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type SiteBuilderSender = {
  __typename?: 'SiteBuilderSender';
  email: Scalars['String']['output'];
  pendingExpiresAt?: Maybe<Scalars['Date']['output']>;
  verified: Scalars['Boolean']['output'];
  verifiedAt?: Maybe<Scalars['Date']['output']>;
};

export type SiteBuilderSenderSuggestion = {
  __typename?: 'SiteBuilderSenderSuggestion';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SiteBuilderSettingsResult = {
  __typename?: 'SiteBuilderSettingsResult';
  actionConfidenceThreshold: Scalars['Float']['output'];
  allowedInboundDomains: Array<Scalars['String']['output']>;
  availableSkills: Scalars['JSON']['output'];
  defaultBudget: Scalars['JSON']['output'];
  defaultSkillKeys: Array<Scalars['String']['output']>;
  disabledBindingPaths: Array<Scalars['String']['output']>;
  extraBindingPaths: Array<Scalars['String']['output']>;
  killSwitch: Scalars['Boolean']['output'];
  orgMonthlyCostUsdCap: Scalars['Float']['output'];
  staffNotificationEmails: Array<Scalars['String']['output']>;
  tiers: Scalars['JSON']['output'];
};

export type SiteBuilderSignal = {
  __typename?: 'SiteBuilderSignal';
  _id: Scalars['MongoID']['output'];
  channel?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  kind: Scalars['String']['output'];
  polarity: Scalars['String']['output'];
  reasonTags: Array<Scalars['String']['output']>;
  site: Scalars['MongoID']['output'];
  siteName?: Maybe<Scalars['String']['output']>;
  skillVersions?: Maybe<Scalars['JSON']['output']>;
  task?: Maybe<Scalars['MongoID']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  weight: Scalars['Float']['output'];
};

export type SiteBuilderSite = {
  __typename?: 'SiteBuilderSite';
  _id: Scalars['MongoID']['output'];
  activeTaskId?: Maybe<Scalars['MongoID']['output']>;
  assetIds: Array<Scalars['String']['output']>;
  billing?: Maybe<Scalars['JSON']['output']>;
  billingHistory?: Maybe<Scalars['JSON']['output']>;
  billingLabel: Scalars['String']['output'];
  brief?: Maybe<Scalars['JSON']['output']>;
  budget?: Maybe<Scalars['JSON']['output']>;
  clientVisibility: Scalars['String']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  customDomain?: Maybe<Scalars['JSON']['output']>;
  factsSource?: Maybe<Scalars['JSON']['output']>;
  hasPendingChanges: Scalars['Boolean']['output'];
  inboundAddress?: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nav?: Maybe<Scalars['JSON']['output']>;
  openQuestionCount: Scalars['Int']['output'];
  ownerId: Scalars['MongoID']['output'];
  ownerKind: Scalars['String']['output'];
  pageCount: Scalars['Int']['output'];
  previewUrl: Scalars['String']['output'];
  publicUrl: Scalars['String']['output'];
  publishRequestedAt?: Maybe<Scalars['Date']['output']>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  publishedPages?: Maybe<Scalars['JSON']['output']>;
  references?: Maybe<Scalars['JSON']['output']>;
  reviewMode: Scalars['String']['output'];
  skillKeys: Array<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  subdomain: Scalars['String']['output'];
  theme?: Maybe<Scalars['JSON']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type SiteBuilderSkillFeedback = {
  __typename?: 'SiteBuilderSkillFeedback';
  _id: Scalars['MongoID']['output'];
  authorName?: Maybe<Scalars['String']['output']>;
  commit?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  skillHash: Scalars['String']['output'];
  skillKey: Scalars['String']['output'];
  status: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SiteBuilderStaffUser = {
  __typename?: 'SiteBuilderStaffUser';
  _id: Scalars['MongoID']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SiteBuilderTask = {
  __typename?: 'SiteBuilderTask';
  _id: Scalars['MongoID']['output'];
  cancelReason?: Maybe<Scalars['String']['output']>;
  channel: Scalars['String']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  modelCalls?: Maybe<Scalars['JSON']['output']>;
  progress?: Maybe<Scalars['JSON']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  site: Scalars['MongoID']['output'];
  siteName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  usage?: Maybe<Scalars['JSON']['output']>;
};

export enum SortFindByIdsAssetFileInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsAssetImageInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsAssetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsBookerInput {
  CopiedfromAsc = 'COPIEDFROM_ASC',
  CopiedfromDesc = 'COPIEDFROM_DESC',
  IsinvoicetemplateAsc = 'ISINVOICETEMPLATE_ASC',
  IsinvoicetemplateDesc = 'ISINVOICETEMPLATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsDiscountInput {
  CopiedfromAsc = 'COPIEDFROM_ASC',
  CopiedfromDesc = 'COPIEDFROM_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsEventInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsInventoryItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsLeadInput {
  BroadcastidAsc = 'BROADCASTID_ASC',
  BroadcastidDesc = 'BROADCASTID_DESC',
  PersonAsc = 'PERSON_ASC',
  PersonDesc = 'PERSON_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SurveyresponseAsc = 'SURVEYRESPONSE_ASC',
  SurveyresponseDesc = 'SURVEYRESPONSE_DESC',
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsListInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsOrderInput {
  ApprovalStatusAsc = 'APPROVAL__STATUS_ASC',
  ApprovalStatusDesc = 'APPROVAL__STATUS_DESC',
  ApprovalStatusApprovalExpiresatAsc = 'APPROVAL__STATUS__APPROVAL__EXPIRESAT_ASC',
  ApprovalStatusApprovalExpiresatDesc = 'APPROVAL__STATUS__APPROVAL__EXPIRESAT_DESC',
  CustomerAsc = 'CUSTOMER_ASC',
  CustomerDesc = 'CUSTOMER_DESC',
  CustomerCreateddateisoAsc = 'CUSTOMER__CREATEDDATEISO_ASC',
  CustomerCreateddateisoDesc = 'CUSTOMER__CREATEDDATEISO_DESC',
  SourceStorefrontAsc = 'SOURCE__STOREFRONT_ASC',
  SourceStorefrontDesc = 'SOURCE__STOREFRONT_DESC',
  SourceStorefrontCreateddateisoAsc = 'SOURCE__STOREFRONT__CREATEDDATEISO_ASC',
  SourceStorefrontCreateddateisoDesc = 'SOURCE__STOREFRONT__CREATEDDATEISO_DESC',
  SourceStorefrontPurchasedproductsInventoryclaimsClaimeddaterangeisoStartAsc = 'SOURCE__STOREFRONT__PURCHASEDPRODUCTS__INVENTORYCLAIMS__CLAIMEDDATERANGEISO__START_ASC',
  SourceStorefrontPurchasedproductsInventoryclaimsClaimeddaterangeisoStartDesc = 'SOURCE__STOREFRONT__PURCHASEDPRODUCTS__INVENTORYCLAIMS__CLAIMEDDATERANGEISO__START_DESC',
  SourceStorefrontPurchasedproductsProductIdAsc = 'SOURCE__STOREFRONT__PURCHASEDPRODUCTS__PRODUCT___ID_ASC',
  SourceStorefrontPurchasedproductsProductIdDesc = 'SOURCE__STOREFRONT__PURCHASEDPRODUCTS__PRODUCT___ID_DESC',
  TeamvisibleAsc = 'TEAMVISIBLE_ASC',
  TeamvisibleDesc = 'TEAMVISIBLE_DESC',
  TeamvisibleSourceOperatoridAsc = 'TEAMVISIBLE__SOURCE__OPERATORID_ASC',
  TeamvisibleSourceOperatoridDesc = 'TEAMVISIBLE__SOURCE__OPERATORID_DESC',
  TeamvisibleSourceOperatoridCreateddateisoAsc = 'TEAMVISIBLE__SOURCE__OPERATORID__CREATEDDATEISO_ASC',
  TeamvisibleSourceOperatoridCreateddateisoDesc = 'TEAMVISIBLE__SOURCE__OPERATORID__CREATEDDATEISO_DESC',
  TestmodeAsc = 'TESTMODE_ASC',
  TestmodeDesc = 'TESTMODE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsOrganizationInput {
  SubdomainAsc = 'SUBDOMAIN_ASC',
  SubdomainDesc = 'SUBDOMAIN_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPaymentMethodSetInput {
  CopiedfromAsc = 'COPIEDFROM_ASC',
  CopiedfromDesc = 'COPIEDFROM_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPeopleInput {
  EmaillowerAsc = 'EMAILLOWER_ASC',
  EmaillowerDesc = 'EMAILLOWER_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPlaceInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  ParentplaceAsc = 'PARENTPLACE_ASC',
  ParentplaceDesc = 'PARENTPLACE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPolicyInput {
  CopiedfromAsc = 'COPIEDFROM_ASC',
  CopiedfromDesc = 'COPIEDFROM_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProductInput {
  CopiedfromAsc = 'COPIEDFROM_ASC',
  CopiedfromDesc = 'COPIEDFROM_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPromotionInput {
  AccessOperatorEntityidAsc = 'ACCESS__OPERATOR___ENTITYID_ASC',
  AccessOperatorEntityidDesc = 'ACCESS__OPERATOR___ENTITYID_DESC',
  AccessOperatorEntityidLastdateAsc = 'ACCESS__OPERATOR___ENTITYID__LASTDATE_ASC',
  AccessOperatorEntityidLastdateDesc = 'ACCESS__OPERATOR___ENTITYID__LASTDATE_DESC',
  AccessOrganizationsEntityidAsc = 'ACCESS__ORGANIZATIONS___ENTITYID_ASC',
  AccessOrganizationsEntityidDesc = 'ACCESS__ORGANIZATIONS___ENTITYID_DESC',
  AccessOrganizationsEntityidAccessOrganizationsStatusAsc = 'ACCESS__ORGANIZATIONS___ENTITYID__ACCESS__ORGANIZATIONS__STATUS_ASC',
  AccessOrganizationsEntityidAccessOrganizationsStatusDesc = 'ACCESS__ORGANIZATIONS___ENTITYID__ACCESS__ORGANIZATIONS__STATUS_DESC',
  AccessOrganizationsEntityidAccessOrganizationsStatusLastdateAsc = 'ACCESS__ORGANIZATIONS___ENTITYID__ACCESS__ORGANIZATIONS__STATUS__LASTDATE_ASC',
  AccessOrganizationsEntityidAccessOrganizationsStatusLastdateDesc = 'ACCESS__ORGANIZATIONS___ENTITYID__ACCESS__ORGANIZATIONS__STATUS__LASTDATE_DESC',
  TagsOrganizationspecificAsc = 'TAGS__ORGANIZATIONSPECIFIC_ASC',
  TagsOrganizationspecificDesc = 'TAGS__ORGANIZATIONSPECIFIC_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsRuleInput {
  CopiedfromAsc = 'COPIEDFROM_ASC',
  CopiedfromDesc = 'COPIEDFROM_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsStorefrontInput {
  LivestorefrontAsc = 'LIVESTOREFRONT_ASC',
  LivestorefrontDesc = 'LIVESTOREFRONT_DESC',
  OrganizationAsc = 'ORGANIZATION_ASC',
  OrganizationDesc = 'ORGANIZATION_DESC',
  TeststorefrontAsc = 'TESTSTOREFRONT_ASC',
  TeststorefrontDesc = 'TESTSTOREFRONT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsSurveyQuestionInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsTagGroupInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsTagInput {
  EntitytypesAsc = 'ENTITYTYPES_ASC',
  EntitytypesDesc = 'ENTITYTYPES_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  TaggroupAsc = 'TAGGROUP_ASC',
  TaggroupDesc = 'TAGGROUP_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsUserInput {
  Auth0IdAsc = 'AUTH0ID_ASC',
  Auth0IdDesc = 'AUTH0ID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  SignuptokenAsc = 'SIGNUPTOKEN_ASC',
  SignuptokenDesc = 'SIGNUPTOKEN_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsWidgetInput {
  OwnerEntityidAsc = 'OWNER__ENTITYID_ASC',
  OwnerEntityidDesc = 'OWNER__ENTITYID_DESC',
  OwnerEntityidArchivedAsc = 'OWNER__ENTITYID__ARCHIVED_ASC',
  OwnerEntityidArchivedDesc = 'OWNER__ENTITYID__ARCHIVED_DESC',
  OwnerEntityidArchivedUpdateddateisoAsc = 'OWNER__ENTITYID__ARCHIVED__UPDATEDDATEISO_ASC',
  OwnerEntityidArchivedUpdateddateisoDesc = 'OWNER__ENTITYID__ARCHIVED__UPDATEDDATEISO_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyActivityLogInput {
  BulkconnectlogidAsc = 'BULKCONNECTLOGID_ASC',
  BulkconnectlogidDesc = 'BULKCONNECTLOGID_DESC',
  EntityAsc = 'ENTITY_ASC',
  EntityDesc = 'ENTITY_DESC',
  EntityEntityidAsc = 'ENTITY___ENTITYID_ASC',
  EntityEntityidDesc = 'ENTITY___ENTITYID_DESC',
  EntityEntityidEntityTypeAsc = 'ENTITY___ENTITYID__ENTITY__TYPE_ASC',
  EntityEntityidEntityTypeDesc = 'ENTITY___ENTITYID__ENTITY__TYPE_DESC',
  EntityEntityidEntityTypeResourceidAsc = 'ENTITY___ENTITYID__ENTITY__TYPE__RESOURCEID_ASC',
  EntityEntityidEntityTypeResourceidDesc = 'ENTITY___ENTITYID__ENTITY__TYPE__RESOURCEID_DESC',
  EntityEntityidEntityTypeResourceidInitiatedbyuserAsc = 'ENTITY___ENTITYID__ENTITY__TYPE__RESOURCEID__INITIATEDBYUSER_ASC',
  EntityEntityidEntityTypeResourceidInitiatedbyuserDesc = 'ENTITY___ENTITYID__ENTITY__TYPE__RESOURCEID__INITIATEDBYUSER_DESC',
  EntityEntityidEntityTypeResourceidInitiatedbyuserTypeAsc = 'ENTITY___ENTITYID__ENTITY__TYPE__RESOURCEID__INITIATEDBYUSER__TYPE_ASC',
  EntityEntityidEntityTypeResourceidInitiatedbyuserTypeDesc = 'ENTITY___ENTITYID__ENTITY__TYPE__RESOURCEID__INITIATEDBYUSER__TYPE_DESC',
  EntityEntityidEntityTypeResourceidInitiatedbyuserTypeEntitynameEnAsc = 'ENTITY___ENTITYID__ENTITY__TYPE__RESOURCEID__INITIATEDBYUSER__TYPE__ENTITYNAME__EN_ASC',
  EntityEntityidEntityTypeResourceidInitiatedbyuserTypeEntitynameEnDesc = 'ENTITY___ENTITYID__ENTITY__TYPE__RESOURCEID__INITIATEDBYUSER__TYPE__ENTITYNAME__EN_DESC',
  ImportrunidAsc = 'IMPORTRUNID_ASC',
  ImportrunidDesc = 'IMPORTRUNID_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  CreatedAsc = '_CREATED_ASC',
  CreatedDesc = '_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyAnalyticsDashboardInput {
  SortOrderAsc = 'SORT_ORDER_ASC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyApiAccessInput {
  OrganizationAsc = 'ORGANIZATION_ASC',
  OrganizationDesc = 'ORGANIZATION_DESC',
  TokenAsc = 'TOKEN_ASC',
  TokenDesc = 'TOKEN_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyAssetFileInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyAssetImageInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyAssetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyBookerInput {
  CopiedfromAsc = 'COPIEDFROM_ASC',
  CopiedfromDesc = 'COPIEDFROM_DESC',
  IsinvoicetemplateAsc = 'ISINVOICETEMPLATE_ASC',
  IsinvoicetemplateDesc = 'ISINVOICETEMPLATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyBroadcastInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
  UpdatedAsc = '_UPDATED_ASC',
  UpdatedDesc = '_UPDATED_DESC'
}

export enum SortFindManyBulkConnectLogInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyChangelogInput {
  CreatedAsc = '_CREATED_ASC',
  CreatedDesc = '_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyDiscountInput {
  CopiedfromAsc = 'COPIEDFROM_ASC',
  CopiedfromDesc = 'COPIEDFROM_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyFulfillmentProfileInput {
  CopiedfromAsc = 'COPIEDFROM_ASC',
  CopiedfromDesc = 'COPIEDFROM_DESC',
  StorefrontAsc = 'STOREFRONT_ASC',
  StorefrontDesc = 'STOREFRONT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyImportInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyImportRunInput {
  CreatedAsc = '_CREATED_ASC',
  CreatedDesc = '_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyImportScrapeInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyImportScrapeRunInput {
  ScrapeidAsc = 'SCRAPEID_ASC',
  ScrapeidDesc = 'SCRAPEID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyInventoryItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyInviteQueueInput {
  BouncedAsc = 'BOUNCED_ASC',
  BouncedDesc = 'BOUNCED_DESC',
  InitiatedbyuserAsc = 'INITIATEDBYUSER_ASC',
  InitiatedbyuserDesc = 'INITIATEDBYUSER_DESC',
  InvitedoperatorAsc = 'INVITEDOPERATOR_ASC',
  InvitedoperatorDesc = 'INVITEDOPERATOR_DESC',
  InvitedoperatorOrganizationidAsc = 'INVITEDOPERATOR__ORGANIZATIONID_ASC',
  InvitedoperatorOrganizationidDesc = 'INVITEDOPERATOR__ORGANIZATIONID_DESC',
  InviteduserAsc = 'INVITEDUSER_ASC',
  InviteduserDesc = 'INVITEDUSER_DESC',
  InvitestatusAsc = 'INVITESTATUS_ASC',
  InvitestatusDesc = 'INVITESTATUS_DESC',
  OrganizationidAsc = 'ORGANIZATIONID_ASC',
  OrganizationidDesc = 'ORGANIZATIONID_DESC',
  SendbatchidAsc = 'SENDBATCHID_ASC',
  SendbatchidDesc = 'SENDBATCHID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyLeadInput {
  BroadcastidAsc = 'BROADCASTID_ASC',
  BroadcastidDesc = 'BROADCASTID_DESC',
  PersonAsc = 'PERSON_ASC',
  PersonDesc = 'PERSON_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SurveyresponseAsc = 'SURVEYRESPONSE_ASC',
  SurveyresponseDesc = 'SURVEYRESPONSE_DESC',
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyListInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
  UpdatedAsc = '_UPDATED_ASC',
  UpdatedDesc = '_UPDATED_DESC'
}

export enum SortFindManyNoteInput {
  KindAsc = 'KIND_ASC',
  KindDesc = 'KIND_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
  UpdatedAsc = '_UPDATED_ASC',
  UpdatedDesc = '_UPDATED_DESC'
}

export enum SortFindManyOperatorInput {
  EnrollmentsOrganizationAsc = 'ENROLLMENTS__ORGANIZATION_ASC',
  EnrollmentsOrganizationDesc = 'ENROLLMENTS__ORGANIZATION_DESC',
  EnrollmentsOrganizationEnrollmentsCurrentstatusAsc = 'ENROLLMENTS__ORGANIZATION__ENROLLMENTS__CURRENTSTATUS_ASC',
  EnrollmentsOrganizationEnrollmentsCurrentstatusDesc = 'ENROLLMENTS__ORGANIZATION__ENROLLMENTS__CURRENTSTATUS_DESC',
  EnrollmentsOrganizationEnrollmentsCurrentstatusNameEnAsc = 'ENROLLMENTS__ORGANIZATION__ENROLLMENTS__CURRENTSTATUS__NAME__EN_ASC',
  EnrollmentsOrganizationEnrollmentsCurrentstatusNameEnDesc = 'ENROLLMENTS__ORGANIZATION__ENROLLMENTS__CURRENTSTATUS__NAME__EN_DESC',
  EnrollmentsOrganizationEnrollmentsCurrentstatusNameEnEntityidAsc = 'ENROLLMENTS__ORGANIZATION__ENROLLMENTS__CURRENTSTATUS__NAME__EN___ENTITYID_ASC',
  EnrollmentsOrganizationEnrollmentsCurrentstatusNameEnEntityidDesc = 'ENROLLMENTS__ORGANIZATION__ENROLLMENTS__CURRENTSTATUS__NAME__EN___ENTITYID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  EntityidAsc = '_ENTITYID_ASC',
  EntityidDesc = '_ENTITYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
  VersionidAsc = '_VERSIONID_ASC',
  VersionidDesc = '_VERSIONID_DESC'
}

export enum SortFindManyOrderInput {
  ApprovalStatusAsc = 'APPROVAL__STATUS_ASC',
  ApprovalStatusDesc = 'APPROVAL__STATUS_DESC',
  ApprovalStatusApprovalExpiresatAsc = 'APPROVAL__STATUS__APPROVAL__EXPIRESAT_ASC',
  ApprovalStatusApprovalExpiresatDesc = 'APPROVAL__STATUS__APPROVAL__EXPIRESAT_DESC',
  CustomerAsc = 'CUSTOMER_ASC',
  CustomerDesc = 'CUSTOMER_DESC',
  CustomerCreateddateisoAsc = 'CUSTOMER__CREATEDDATEISO_ASC',
  CustomerCreateddateisoDesc = 'CUSTOMER__CREATEDDATEISO_DESC',
  SourceStorefrontAsc = 'SOURCE__STOREFRONT_ASC',
  SourceStorefrontDesc = 'SOURCE__STOREFRONT_DESC',
  SourceStorefrontCreateddateisoAsc = 'SOURCE__STOREFRONT__CREATEDDATEISO_ASC',
  SourceStorefrontCreateddateisoDesc = 'SOURCE__STOREFRONT__CREATEDDATEISO_DESC',
  SourceStorefrontPurchasedproductsInventoryclaimsClaimeddaterangeisoStartAsc = 'SOURCE__STOREFRONT__PURCHASEDPRODUCTS__INVENTORYCLAIMS__CLAIMEDDATERANGEISO__START_ASC',
  SourceStorefrontPurchasedproductsInventoryclaimsClaimeddaterangeisoStartDesc = 'SOURCE__STOREFRONT__PURCHASEDPRODUCTS__INVENTORYCLAIMS__CLAIMEDDATERANGEISO__START_DESC',
  SourceStorefrontPurchasedproductsProductIdAsc = 'SOURCE__STOREFRONT__PURCHASEDPRODUCTS__PRODUCT___ID_ASC',
  SourceStorefrontPurchasedproductsProductIdDesc = 'SOURCE__STOREFRONT__PURCHASEDPRODUCTS__PRODUCT___ID_DESC',
  TeamvisibleAsc = 'TEAMVISIBLE_ASC',
  TeamvisibleDesc = 'TEAMVISIBLE_DESC',
  TeamvisibleSourceOperatoridAsc = 'TEAMVISIBLE__SOURCE__OPERATORID_ASC',
  TeamvisibleSourceOperatoridDesc = 'TEAMVISIBLE__SOURCE__OPERATORID_DESC',
  TeamvisibleSourceOperatoridCreateddateisoAsc = 'TEAMVISIBLE__SOURCE__OPERATORID__CREATEDDATEISO_ASC',
  TeamvisibleSourceOperatoridCreateddateisoDesc = 'TEAMVISIBLE__SOURCE__OPERATORID__CREATEDDATEISO_DESC',
  TestmodeAsc = 'TESTMODE_ASC',
  TestmodeDesc = 'TESTMODE_DESC',
  ApprovalExpiresAsc = '_APPROVAL_EXPIRES_ASC',
  CreatedAsc = '_CREATED_ASC',
  CreatedDesc = '_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyOrganizationInput {
  SubdomainAsc = 'SUBDOMAIN_ASC',
  SubdomainDesc = 'SUBDOMAIN_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPaymentMethodSetInput {
  CopiedfromAsc = 'COPIEDFROM_ASC',
  CopiedfromDesc = 'COPIEDFROM_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPeopleInput {
  EmaillowerAsc = 'EMAILLOWER_ASC',
  EmaillowerDesc = 'EMAILLOWER_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  LatestActivityAsc = 'LATEST_ACTIVITY_ASC',
  LatestActivityDesc = 'LATEST_ACTIVITY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPlaceInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  ParentplaceAsc = 'PARENTPLACE_ASC',
  ParentplaceDesc = 'PARENTPLACE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPolicyInput {
  CopiedfromAsc = 'COPIEDFROM_ASC',
  CopiedfromDesc = 'COPIEDFROM_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPostHogDataInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProductInput {
  CopiedfromAsc = 'COPIEDFROM_ASC',
  CopiedfromDesc = 'COPIEDFROM_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyRefundInput {
  OrderidAsc = 'ORDERID_ASC',
  OrderidDesc = 'ORDERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyRuleInput {
  CopiedfromAsc = 'COPIEDFROM_ASC',
  CopiedfromDesc = 'COPIEDFROM_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyScheduledPaymentInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyStorefrontInput {
  LivestorefrontAsc = 'LIVESTOREFRONT_ASC',
  LivestorefrontDesc = 'LIVESTOREFRONT_DESC',
  OrganizationAsc = 'ORGANIZATION_ASC',
  OrganizationDesc = 'ORGANIZATION_DESC',
  TeststorefrontAsc = 'TESTSTOREFRONT_ASC',
  TeststorefrontDesc = 'TESTSTOREFRONT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManySurveyInput {
  CopiedfromAsc = 'COPIEDFROM_ASC',
  CopiedfromDesc = 'COPIEDFROM_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManySurveyQuestionInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManySurveyResponseInput {
  BroadcastAsc = 'BROADCAST_ASC',
  BroadcastDesc = 'BROADCAST_DESC',
  BroadcastResourceidAsc = 'BROADCAST__RESOURCEID_ASC',
  BroadcastResourceidDesc = 'BROADCAST__RESOURCEID_DESC',
  BroadcastResourceidPersonAsc = 'BROADCAST__RESOURCEID__PERSON_ASC',
  BroadcastResourceidPersonDesc = 'BROADCAST__RESOURCEID__PERSON_DESC',
  BroadcastResourceidPersonSubmissionindexAsc = 'BROADCAST__RESOURCEID__PERSON__SUBMISSIONINDEX_ASC',
  BroadcastResourceidPersonSubmissionindexDesc = 'BROADCAST__RESOURCEID__PERSON__SUBMISSIONINDEX_DESC',
  WidgetAsc = 'WIDGET_ASC',
  WidgetDesc = 'WIDGET_DESC',
  WidgetPersonAsc = 'WIDGET__PERSON_ASC',
  WidgetPersonDesc = 'WIDGET__PERSON_DESC',
  WidgetPersonSubmissionindexAsc = 'WIDGET__PERSON__SUBMISSIONINDEX_ASC',
  WidgetPersonSubmissionindexDesc = 'WIDGET__PERSON__SUBMISSIONINDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyTagGroupInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyTagInput {
  EntitytypesAsc = 'ENTITYTYPES_ASC',
  EntitytypesDesc = 'ENTITYTYPES_DESC',
  OwnerAsc = 'OWNER_ASC',
  OwnerDesc = 'OWNER_DESC',
  TaggroupAsc = 'TAGGROUP_ASC',
  TaggroupDesc = 'TAGGROUP_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyTagSuggestionInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyTaxInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyUserInput {
  Auth0IdAsc = 'AUTH0ID_ASC',
  Auth0IdDesc = 'AUTH0ID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  SignuptokenAsc = 'SIGNUPTOKEN_ASC',
  SignuptokenDesc = 'SIGNUPTOKEN_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyWidgetInput {
  /** Sort by updatedDateISO ASC */
  UpdatedAsc = '_UPDATED_ASC',
  /** Sort by updatedDateISO DESC */
  UpdatedDesc = '_UPDATED_DESC'
}

export enum SortFindOneApiAccessInput {
  OrganizationAsc = 'ORGANIZATION_ASC',
  OrganizationDesc = 'ORGANIZATION_DESC',
  TokenAsc = 'TOKEN_ASC',
  TokenDesc = 'TOKEN_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCampaignInput {
  EntityidAsc = '_ENTITYID_ASC',
  EntityidDesc = '_ENTITYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
  VersionidAsc = '_VERSIONID_ASC',
  VersionidDesc = '_VERSIONID_DESC'
}

export enum SortFindOneImportManagerSettingsInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneMaintenanceInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneOrganizationManifestInput {
  OrganizationidAsc = 'ORGANIZATIONID_ASC',
  OrganizationidDesc = 'ORGANIZATIONID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePeopleInput {
  EmaillowerAsc = 'EMAILLOWER_ASC',
  EmaillowerDesc = 'EMAILLOWER_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePublicationStatusInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneScheduledPaymentInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneSurveyInput {
  CopiedfromAsc = 'COPIEDFROM_ASC',
  CopiedfromDesc = 'COPIEDFROM_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneSurveyQuestionInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneSurveyResponseInput {
  BroadcastAsc = 'BROADCAST_ASC',
  BroadcastDesc = 'BROADCAST_DESC',
  BroadcastResourceidAsc = 'BROADCAST__RESOURCEID_ASC',
  BroadcastResourceidDesc = 'BROADCAST__RESOURCEID_DESC',
  BroadcastResourceidPersonAsc = 'BROADCAST__RESOURCEID__PERSON_ASC',
  BroadcastResourceidPersonDesc = 'BROADCAST__RESOURCEID__PERSON_DESC',
  BroadcastResourceidPersonSubmissionindexAsc = 'BROADCAST__RESOURCEID__PERSON__SUBMISSIONINDEX_ASC',
  BroadcastResourceidPersonSubmissionindexDesc = 'BROADCAST__RESOURCEID__PERSON__SUBMISSIONINDEX_DESC',
  WidgetAsc = 'WIDGET_ASC',
  WidgetDesc = 'WIDGET_DESC',
  WidgetPersonAsc = 'WIDGET__PERSON_ASC',
  WidgetPersonDesc = 'WIDGET__PERSON_DESC',
  WidgetPersonSubmissionindexAsc = 'WIDGET__PERSON__SUBMISSIONINDEX_ASC',
  WidgetPersonSubmissionindexDesc = 'WIDGET__PERSON__SUBMISSIONINDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneTagGroupInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneUserInput {
  Auth0IdAsc = 'AUTH0ID_ASC',
  Auth0IdDesc = 'AUTH0ID_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  SignuptokenAsc = 'SIGNUPTOKEN_ASC',
  SignuptokenDesc = 'SIGNUPTOKEN_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type StatementGenerationRun = {
  __typename?: 'StatementGenerationRun';
  _id: Scalars['MongoID']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  currency: Scalars['String']['output'];
  grandTotalSum: Scalars['Float']['output'];
  items: Array<Maybe<StatementGenerationRunItems>>;
  period: Scalars['String']['output'];
  rolledBackAt?: Maybe<Scalars['String']['output']>;
  rolledBackBy?: Maybe<Scalars['String']['output']>;
  rolledBackByName?: Maybe<Scalars['String']['output']>;
  statementCount: Scalars['Float']['output'];
  status: EnumStatementGenerationRunStatus;
  storefront: Scalars['MongoID']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type StatementGenerationRunItems = {
  __typename?: 'StatementGenerationRunItems';
  customerName?: Maybe<Scalars['String']['output']>;
  grandTotal: Scalars['Float']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  orderIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  paymentRequestId: Scalars['MongoID']['output'];
  rollbackStatus?: Maybe<EnumStatementGenerationRunItemsRollbackStatus>;
  rolledBackAt?: Maybe<Scalars['String']['output']>;
};

export type StatementPreviewGroup = {
  __typename?: 'StatementPreviewGroup';
  currency: Scalars['String']['output'];
  customerId: Scalars['MongoID']['output'];
  customerName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  grandTotal: Scalars['Int']['output'];
  orderIds: Array<Scalars['String']['output']>;
};

export type StatsSnapshot = {
  __typename?: 'StatsSnapshot';
  _id: Scalars['MongoID']['output'];
  account: StatsSnapshotAccount;
  broadcast: StatsSnapshotBroadcast;
  capturedAt: Scalars['Date']['output'];
  membership: StatsSnapshotMembership;
  periodKey: Scalars['String']['output'];
  widget: StatsSnapshotWidget;
};

export type StatsSnapshotAccount = {
  __typename?: 'StatsSnapshotAccount';
  events: Scalars['Int']['output'];
  notes: Scalars['Int']['output'];
  operators: Scalars['Int']['output'];
  people: Scalars['Int']['output'];
};

export type StatsSnapshotBroadcast = {
  __typename?: 'StatsSnapshotBroadcast';
  completions: Scalars['Int']['output'];
  messageViews: Scalars['Int']['output'];
  pdfDownloads: Scalars['Int']['output'];
  photoViews: Scalars['Int']['output'];
  videoViews: Scalars['Int']['output'];
};

export type StatsSnapshotMembership = {
  __typename?: 'StatsSnapshotMembership';
  byStatus?: Maybe<Array<StatsSnapshotMembershipTagCount>>;
  byTier?: Maybe<Array<StatsSnapshotMembershipTagCount>>;
  total: Scalars['Int']['output'];
};

export type StatsSnapshotMembershipTagCount = {
  __typename?: 'StatsSnapshotMembershipTagCount';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  tagId: Scalars['ID']['output'];
};

export type StatsSnapshotWidget = {
  __typename?: 'StatsSnapshotWidget';
  eventClicks: Scalars['Int']['output'];
  eventImpressions: Scalars['Int']['output'];
  operatorClicks: Scalars['Int']['output'];
  operatorViews: Scalars['Int']['output'];
  tripperEngagements: Scalars['Int']['output'];
  tripperPdfDownloads: Scalars['Int']['output'];
  tripperReferrals: Scalars['Int']['output'];
  tripperViews: Scalars['Int']['output'];
};

export type Storefront = {
  __typename?: 'Storefront';
  _id: Scalars['MongoID']['output'];
  accountingCodes: Array<Maybe<Scalars['String']['output']>>;
  applicationFeeDefaults?: Maybe<StorefrontApplicationFeeDefaults>;
  applicationPercentage: Scalars['Float']['output'];
  connectedAccountIds: Array<Maybe<Scalars['String']['output']>>;
  connectedListings: Array<Maybe<Scalars['String']['output']>>;
  connectedListingsConfigured: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  customProductNames: Array<Maybe<Scalars['String']['output']>>;
  defaultInvoicePolicy?: Maybe<Scalars['MongoID']['output']>;
  defaultWidgetLogo?: Maybe<AssetImage>;
  emailBranding?: Maybe<StorefrontEmailBranding>;
  enabledFeeTypes?: Maybe<StorefrontEnabledFeeTypes>;
  invoiceTemplateBooker?: Maybe<Scalars['MongoID']['output']>;
  invoicingEnabled: Scalars['Boolean']['output'];
  isLaunched: Scalars['Boolean']['output'];
  isPaired: Scalars['Boolean']['output'];
  lastLowStockDigestKey?: Maybe<Scalars['String']['output']>;
  launchedAt?: Maybe<Scalars['Date']['output']>;
  linkedOrganization?: Maybe<Organization>;
  liveStorefront?: Maybe<Scalars['MongoID']['output']>;
  lowStockDigestEnabled: Scalars['Boolean']['output'];
  name: Multilingual;
  organization?: Maybe<Scalars['MongoID']['output']>;
  paymentsMode: EnumStorefrontPaymentsMode;
  resolvedTimezone: StorefrontResolvedTimezone;
  siteMetadata?: Maybe<StorefrontSiteMetadata>;
  statementSettings?: Maybe<StorefrontStatementSettings>;
  stripeRegion: EnumStorefrontStripeRegion;
  testMode: Scalars['Boolean']['output'];
  testStorefront?: Maybe<Scalars['MongoID']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type StorefrontApplicationFeeDefaults = {
  __typename?: 'StorefrontApplicationFeeDefaults';
  membership?: Maybe<Scalars['Float']['output']>;
  merch?: Maybe<Scalars['Float']['output']>;
};

export type StorefrontApplicationFeeDefaultsInput = {
  membership?: InputMaybe<Scalars['Float']['input']>;
  merch?: InputMaybe<Scalars['Float']['input']>;
};

export type StorefrontCalendarAccommodationRow = {
  __typename?: 'StorefrontCalendarAccommodationRow';
  approvalStatus?: Maybe<Scalars['String']['output']>;
  cancelled: Scalars['Boolean']['output'];
  customerName: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  guests: Scalars['Int']['output'];
  orderId: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  productName?: Maybe<Multilingual>;
  startDate: Scalars['String']['output'];
};

export type StorefrontCalendarFeed = {
  __typename?: 'StorefrontCalendarFeed';
  accommodationRows?: Maybe<Array<Maybe<StorefrontCalendarAccommodationRow>>>;
  availableYears?: Maybe<Array<Scalars['Int']['output']>>;
  eventSales?: Maybe<Array<Maybe<EventCalendarSessionSale>>>;
  products?: Maybe<Array<Maybe<Product>>>;
  yearSummary?: Maybe<StorefrontCalendarYearSummary>;
};

export enum StorefrontCalendarKind {
  Accommodation = 'ACCOMMODATION',
  Event = 'EVENT'
}

export type StorefrontCalendarMonthAvailability = {
  __typename?: 'StorefrontCalendarMonthAvailability';
  count: Scalars['Int']['output'];
  hasBookings: Scalars['Boolean']['output'];
  hasClosures: Scalars['Boolean']['output'];
  month: Scalars['Int']['output'];
};

export type StorefrontCalendarYearSummary = {
  __typename?: 'StorefrontCalendarYearSummary';
  months?: Maybe<Array<Maybe<StorefrontCalendarMonthAvailability>>>;
  year: Scalars['Int']['output'];
};

export type StorefrontConnectNewStripeReturn = {
  __typename?: 'StorefrontConnectNewStripeReturn';
  link: Scalars['String']['output'];
  record?: Maybe<Storefront>;
};

export type StorefrontDisconnectStripeAccountReturn = {
  __typename?: 'StorefrontDisconnectStripeAccountReturn';
  blockingWidgetNames?: Maybe<Array<Scalars['String']['output']>>;
  record?: Maybe<Storefront>;
  success: Scalars['Boolean']['output'];
};

export type StorefrontEmailBranding = {
  __typename?: 'StorefrontEmailBranding';
  accentColor?: Maybe<Scalars['String']['output']>;
  footerText?: Maybe<Multilingual>;
  fromName?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<AssetImage>;
  replyTo?: Maybe<Scalars['String']['output']>;
  showContact?: Maybe<Scalars['Boolean']['output']>;
  useOrganizationEmailSettings?: Maybe<Scalars['Boolean']['output']>;
};

export type StorefrontEmailBrandingInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  footerText?: InputMaybe<MultilingualInput>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
  useOrganizationEmailSettings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StorefrontEnabledFeeTypes = {
  __typename?: 'StorefrontEnabledFeeTypes';
  accommodations?: Maybe<Scalars['Boolean']['output']>;
  events?: Maybe<Scalars['Boolean']['output']>;
  merch?: Maybe<Scalars['Boolean']['output']>;
  oneTimeFee?: Maybe<Scalars['Boolean']['output']>;
  renewableFees?: Maybe<Scalars['Boolean']['output']>;
};

export type StorefrontEnabledFeeTypesInput = {
  accommodations?: InputMaybe<Scalars['Boolean']['input']>;
  events?: InputMaybe<Scalars['Boolean']['input']>;
  merch?: InputMaybe<Scalars['Boolean']['input']>;
  oneTimeFee?: InputMaybe<Scalars['Boolean']['input']>;
  renewableFees?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StorefrontEnsureTestStorefrontPayload = {
  __typename?: 'StorefrontEnsureTestStorefrontPayload';
  created: Scalars['Boolean']['output'];
  liveStorefront: Storefront;
  testStorefront: Storefront;
};

export type StorefrontInventoryRow = {
  __typename?: 'StorefrontInventoryRow';
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastSoldAt?: Maybe<Scalars['String']['output']>;
  maxCapacity?: Maybe<Scalars['Int']['output']>;
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  remaining?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  sold: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  threshold: Scalars['Int']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  variantId?: Maybe<Scalars['String']['output']>;
  variantLabel?: Maybe<Scalars['String']['output']>;
};

export type StorefrontLaunchCopiedBooker = {
  __typename?: 'StorefrontLaunchCopiedBooker';
  bookerId: Scalars['MongoID']['output'];
  sourceBookerId: Scalars['MongoID']['output'];
};

export type StorefrontLaunchFailedBooker = {
  __typename?: 'StorefrontLaunchFailedBooker';
  message: Scalars['String']['output'];
  sourceBookerId: Scalars['MongoID']['output'];
};

export type StorefrontLaunchPayload = {
  __typename?: 'StorefrontLaunchPayload';
  copied: Array<StorefrontLaunchCopiedBooker>;
  failed: Array<StorefrontLaunchFailedBooker>;
  liveStorefront: Storefront;
  skipped: Array<Scalars['MongoID']['output']>;
};

export type StorefrontListingCandidate = {
  __typename?: 'StorefrontListingCandidate';
  contact?: Maybe<Contact>;
  entityId: Scalars['ID']['output'];
  isConnected: Scalars['Boolean']['output'];
  name: Multilingual;
  productCount: Scalars['Int']['output'];
  type: EnumOwnerType;
};

export type StorefrontOrderInvoiceFeed = {
  __typename?: 'StorefrontOrderInvoiceFeed';
  approvalsPendingCount: Scalars['Int']['output'];
  forReviewCount: Scalars['Int']['output'];
  items?: Maybe<Array<StorefrontOrderInvoiceFeedRow>>;
  needsAttentionCount: Scalars['Int']['output'];
  pageInfo: StorefrontOrderInvoiceFeedPageInfo;
};

export enum StorefrontOrderInvoiceFeedFilter {
  All = 'ALL',
  AllInvoices = 'ALL_INVOICES',
  AllOrders = 'ALL_ORDERS',
  Approvals = 'APPROVALS',
  Cancelled = 'CANCELLED',
  Deferred = 'DEFERRED',
  Draft = 'DRAFT',
  ForReview = 'FOR_REVIEW',
  FullRefund = 'FULL_REFUND',
  NeedsAttention = 'NEEDS_ATTENTION',
  NoRefund = 'NO_REFUND',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  PartialRefund = 'PARTIAL_REFUND',
  Pending = 'PENDING',
  Sent = 'SENT',
  Subscriptions = 'SUBSCRIPTIONS'
}

export enum StorefrontOrderInvoiceFeedKind {
  Invoice = 'INVOICE',
  Order = 'ORDER'
}

export type StorefrontOrderInvoiceFeedPageInfo = {
  __typename?: 'StorefrontOrderInvoiceFeedPageInfo';
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
};

export type StorefrontOrderInvoiceFeedRow = {
  __typename?: 'StorefrontOrderInvoiceFeedRow';
  businessName?: Maybe<Scalars['String']['output']>;
  kind: StorefrontOrderInvoiceFeedKind;
  order?: Maybe<Order>;
  paymentRequest?: Maybe<PaymentRequest>;
  sortKey: Scalars['String']['output'];
};

export type StorefrontOwnerEntity = {
  __typename?: 'StorefrontOwnerEntity';
  contact?: Maybe<Contact>;
  entityId: Scalars['ID']['output'];
  name: Multilingual;
  type: EnumOwnerType;
};

export type StorefrontPageResult = {
  __typename?: 'StorefrontPageResult';
  _id: Scalars['MongoID']['output'];
  booker: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  editPromptHistory: Array<Scalars['String']['output']>;
  generatedPageHtml?: Maybe<Scalars['String']['output']>;
  pageGeneratedAt?: Maybe<Scalars['Date']['output']>;
  pageUrl: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: Scalars['String']['output'];
  storefront: Scalars['MongoID']['output'];
  type: Scalars['String']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type StorefrontPlatformSettings = {
  __typename?: 'StorefrontPlatformSettings';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  gettingStartedWistiaId?: Maybe<Scalars['String']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type StorefrontResolvedTimezone = {
  __typename?: 'StorefrontResolvedTimezone';
  source: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
};

export type StorefrontSendTestEmailsResult = {
  __typename?: 'StorefrontSendTestEmailsResult';
  failed?: Maybe<Array<StorefrontTestEmailFailure>>;
  sentCount: Scalars['Int']['output'];
};

export type StorefrontSetApplicationFeeResult = {
  __typename?: 'StorefrontSetApplicationFeeResult';
  success: Scalars['Boolean']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type StorefrontSiteMetadata = {
  __typename?: 'StorefrontSiteMetadata';
  _id?: Maybe<Scalars['MongoID']['output']>;
  bookers: Array<Booker>;
  description?: Maybe<Multilingual>;
  email?: Maybe<Scalars['String']['output']>;
  featuredImage?: Maybe<AssetImage>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<AssetImage>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};


export type StorefrontSiteMetadataBookersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsBookerInput>;
};

export type StorefrontSiteMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  bookers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  description?: InputMaybe<MultilingualInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type StorefrontStatementSettings = {
  __typename?: 'StorefrontStatementSettings';
  dayOfMonth?: Maybe<Scalars['Float']['output']>;
};

export type StorefrontStatementSettingsInput = {
  dayOfMonth?: InputMaybe<Scalars['Float']['input']>;
};

export type StorefrontTestEmailFailure = {
  __typename?: 'StorefrontTestEmailFailure';
  emailType: StorefrontTestEmailType;
  error: Scalars['String']['output'];
};

export enum StorefrontTestEmailType {
  BankTransferInstructions = 'BANK_TRANSFER_INSTRUCTIONS',
  BookingRequestApprovedInvoice = 'BOOKING_REQUEST_APPROVED_INVOICE',
  BookingRequestDeclined = 'BOOKING_REQUEST_DECLINED',
  BookingRequestExpired = 'BOOKING_REQUEST_EXPIRED',
  BookingRequestReceived = 'BOOKING_REQUEST_RECEIVED',
  BookingRequestStaff = 'BOOKING_REQUEST_STAFF',
  BookingUnpaidCancelled = 'BOOKING_UNPAID_CANCELLED',
  ContactUsStaff = 'CONTACT_US_STAFF',
  CustomBankTransfer = 'CUSTOM_BANK_TRANSFER',
  NewOrderStaff = 'NEW_ORDER_STAFF',
  OrderCancelledCustomer = 'ORDER_CANCELLED_CUSTOMER',
  OrderCancelledStaff = 'ORDER_CANCELLED_STAFF',
  OrderConfirmed = 'ORDER_CONFIRMED',
  OrderDatesChanged = 'ORDER_DATES_CHANGED',
  PaymentRequestInvoice = 'PAYMENT_REQUEST_INVOICE',
  PaymentRequestInvoiceRevision = 'PAYMENT_REQUEST_INVOICE_REVISION',
  RefundInitiated = 'REFUND_INITIATED',
  RefundStatusUpdated = 'REFUND_STATUS_UPDATED',
  RemainingBalanceFailedCustomer = 'REMAINING_BALANCE_FAILED_CUSTOMER',
  RemainingBalanceSuccessStaff = 'REMAINING_BALANCE_SUCCESS_STAFF',
  RenewalCharged = 'RENEWAL_CHARGED',
  RenewalReminder = 'RENEWAL_REMINDER',
  ScheduledPaymentFailedStaff = 'SCHEDULED_PAYMENT_FAILED_STAFF',
  ScheduledPaymentRemainingBalance = 'SCHEDULED_PAYMENT_REMAINING_BALANCE',
  ScheduledPaymentSecurityDeposit = 'SCHEDULED_PAYMENT_SECURITY_DEPOSIT',
  SubscriptionExpired = 'SUBSCRIPTION_EXPIRED'
}

export type StripeAccountStatus = {
  __typename?: 'StripeAccountStatus';
  /** True when removing this account may also delete it from Stripe: test-mode storefront, and the account is neither protected nor shared with another storefront. */
  canDelete: Scalars['Boolean']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: EnumStripeOnboardingStatus;
};

export type StripeMetadata = {
  __typename?: 'StripeMetadata';
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardLast4?: Maybe<Scalars['String']['output']>;
  chargeId: Scalars['String']['output'];
  connectedAccountId?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceStatus?: Maybe<EnumStripeMetadataInvoiceStatus>;
  paidAt?: Maybe<Scalars['String']['output']>;
  paymentIntentId: Scalars['String']['output'];
  paymentMethodId: Scalars['String']['output'];
  securityHoldPaymentIntentId?: Maybe<Scalars['String']['output']>;
  securityHoldStatus?: Maybe<EnumStripeMetadataSecurityHoldStatus>;
  stripeFee?: Maybe<Scalars['Float']['output']>;
  whereaboutsFee?: Maybe<Scalars['Float']['output']>;
};

export type StripeSyncResult = {
  __typename?: 'StripeSyncResult';
  payoutCount: Scalars['Int']['output'];
  syncedAt: Scalars['Date']['output'];
  transactionCount: Scalars['Int']['output'];
};

export enum SupportCaseBucket {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type SupportInvestigationConfig = {
  __typename?: 'SupportInvestigationConfig';
  configured: Scalars['Boolean']['output'];
  defaultBudgetCents: Scalars['Int']['output'];
  linearConfigured: Scalars['Boolean']['output'];
  linearMissing: Array<Scalars['String']['output']>;
  maxBudgetCents: Scalars['Int']['output'];
  missing: Array<Scalars['String']['output']>;
};

export type SupportInvestigationScreenshotInput = {
  dataBase64: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type SupportLinearAssignee = {
  __typename?: 'SupportLinearAssignee';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SupportTicket = {
  __typename?: 'SupportTicket';
  _id: Scalars['MongoID']['output'];
  assignedTo?: Maybe<Scalars['MongoID']['output']>;
  classification?: Maybe<SupportTicketClassification>;
  createdAtHS?: Maybe<Scalars['Date']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerEmailLower?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  excerpt?: Maybe<Scalars['String']['output']>;
  helpScoutId: Scalars['String']['output'];
  helpScoutStatus?: Maybe<Scalars['String']['output']>;
  helpScoutUrl?: Maybe<Scalars['String']['output']>;
  identity?: Maybe<SupportTicketIdentity>;
  investigation?: Maybe<SupportTicketInvestigation>;
  isAgentCreated: Scalars['Boolean']['output'];
  lastCustomerReplyAt?: Maybe<Scalars['Date']['output']>;
  linear?: Maybe<SupportTicketLinear>;
  mailboxId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  previousInvestigations: Array<Maybe<SupportTicketInvestigation>>;
  subject: Scalars['String']['output'];
  tags: Array<Maybe<Scalars['String']['output']>>;
  threadCount?: Maybe<Scalars['Float']['output']>;
  threadSummary?: Maybe<SupportTicketThreadSummary>;
  triageStatus: EnumSupportTicketTriageStatus;
  triagedAt?: Maybe<Scalars['Date']['output']>;
  triagedBy?: Maybe<UserWithPictureTc>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type SupportTicketClassification = {
  __typename?: 'SupportTicketClassification';
  category?: Maybe<EnumSupportTicketClassificationCategory>;
  classifiedAt?: Maybe<Scalars['Date']['output']>;
  classifiedBy: EnumSupportTicketClassificationClassifiedBy;
  confidence?: Maybe<EnumSupportTicketClassificationConfidence>;
  confirmedAt?: Maybe<Scalars['Date']['output']>;
  confirmedBy?: Maybe<Scalars['MongoID']['output']>;
  correctedAt?: Maybe<Scalars['Date']['output']>;
  correctedBy?: Maybe<Scalars['MongoID']['output']>;
  humanType?: Maybe<EnumSupportTicketClassificationHumanType>;
  model?: Maybe<Scalars['String']['output']>;
  prePassRule?: Maybe<Scalars['String']['output']>;
  promptVersion?: Maybe<Scalars['Float']['output']>;
  reasoning?: Maybe<Scalars['String']['output']>;
  secondaryCategories?: Maybe<Array<Maybe<EnumSupportTicketClassificationSecondaryCategories>>>;
  suggestedAction?: Maybe<EnumSupportTicketClassificationSuggestedAction>;
  type: EnumSupportTicketClassificationType;
};

export type SupportTicketIdentity = {
  __typename?: 'SupportTicketIdentity';
  candidates?: Maybe<Array<Maybe<SupportTicketIdentityCandidates>>>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailLower?: Maybe<Scalars['String']['output']>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  lastActivityDateISO?: Maybe<Scalars['Date']['output']>;
  loggedInAs?: Maybe<Scalars['String']['output']>;
  matchKind: EnumSupportTicketIdentityMatchKind;
  operatorEntityIds?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  organizationIds?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  organizationNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  overriddenAt?: Maybe<Scalars['Date']['output']>;
  overriddenBy?: Maybe<Scalars['MongoID']['output']>;
  overriddenPersonId?: Maybe<Scalars['MongoID']['output']>;
  personIds?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  resolvedAt?: Maybe<Scalars['Date']['output']>;
  resolverVersion?: Maybe<Scalars['Float']['output']>;
  sourceEmailField?: Maybe<EnumSupportTicketIdentitySourceEmailField>;
  userId?: Maybe<Scalars['MongoID']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
  whereaboutsVersion?: Maybe<Scalars['String']['output']>;
};

export type SupportTicketIdentityCandidates = {
  __typename?: 'SupportTicketIdentityCandidates';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  refId: Scalars['MongoID']['output'];
};

export type SupportTicketInvestigation = {
  __typename?: 'SupportTicketInvestigation';
  cancelRequestedAt?: Maybe<Scalars['Date']['output']>;
  cancelledByName?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  consoleUrl?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  finalMessage?: Maybe<Scalars['String']['output']>;
  listCostCents?: Maybe<Scalars['Float']['output']>;
  maxBudgetCents: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  report?: Maybe<SupportTicketInvestigationReport>;
  reportProblems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  screenshotNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sessionId: Scalars['String']['output'];
  startedAt: Scalars['Date']['output'];
  startedBy?: Maybe<Scalars['MongoID']['output']>;
  startedByName?: Maybe<Scalars['String']['output']>;
  status: EnumSupportTicketInvestigationStatus;
  wrapUpSentAt?: Maybe<Scalars['Date']['output']>;
};

export type SupportTicketInvestigationReport = {
  __typename?: 'SupportTicketInvestigationReport';
  confidence: Scalars['String']['output'];
  findings?: Maybe<Array<Maybe<SupportTicketInvestigationReportFindings>>>;
  linear?: Maybe<SupportTicketInvestigationReportLinear>;
  questionsForSubmitter?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status: Scalars['String']['output'];
  suggestedFix?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  verdict: Scalars['String']['output'];
};

export type SupportTicketInvestigationReportFindings = {
  __typename?: 'SupportTicketInvestigationReportFindings';
  detail?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<SupportTicketInvestigationReportFindingsFiles>>>;
  title: Scalars['String']['output'];
};

export type SupportTicketInvestigationReportFindingsFiles = {
  __typename?: 'SupportTicketInvestigationReportFindingsFiles';
  lines?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
};

export type SupportTicketInvestigationReportLinear = {
  __typename?: 'SupportTicketInvestigationReportLinear';
  description?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SupportTicketLinear = {
  __typename?: 'SupportTicketLinear';
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  issueId: Scalars['String']['output'];
  issueKey?: Maybe<Scalars['String']['output']>;
  lastSyncedAt?: Maybe<Scalars['Date']['output']>;
  resolvedAt?: Maybe<Scalars['Date']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
  stateType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SupportTicketThreadSummary = {
  __typename?: 'SupportTicketThreadSummary';
  generatedAt: Scalars['Date']['output'];
  lastCustomerReplyAt?: Maybe<Scalars['Date']['output']>;
  model: Scalars['String']['output'];
  text: Scalars['String']['output'];
  threadCount?: Maybe<Scalars['Float']['output']>;
};

export type Survey = {
  __typename?: 'Survey';
  _id: Scalars['MongoID']['output'];
  copiedFrom?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  name: Multilingual;
  owner: Owner;
  /** Whether this form's toggles can be answered per business (owner-gated). */
  perBusinessAnswersEnabled: Scalars['Boolean']['output'];
  questions: Array<SurveyQuestion>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};


export type SurveyQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsSurveyQuestionInput>;
};

export type SurveyDeleteResult = {
  __typename?: 'SurveyDeleteResult';
  deletedQuestionCount: Scalars['Int']['output'];
};

export type SurveyDuplicateResult = {
  __typename?: 'SurveyDuplicateResult';
  surveyId: Scalars['MongoID']['output'];
};

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  _id: Scalars['MongoID']['output'];
  businessScope?: Maybe<EnumSurveyQuestionBusinessScope>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Multilingual>;
  isActive: Scalars['Boolean']['output'];
  name: Multilingual;
  options: Array<Maybe<SurveyQuestionOptions>>;
  owner: Owner;
  parentQuestion?: Maybe<Scalars['MongoID']['output']>;
  required: Scalars['Boolean']['output'];
  type: EnumSurveyQuestionType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  whereaboutsSearchEntityType?: Maybe<EnumSurveyQuestionWhereaboutsSearchEntityType>;
};

export type SurveyQuestionInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  businessScope?: InputMaybe<EnumSurveyQuestionBusinessScope>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<MultilingualInput>;
  isActive: Scalars['Boolean']['input'];
  name: MultilingualInput;
  options?: InputMaybe<Array<InputMaybe<SurveyQuestionOptionsInput>>>;
  owner: OwnerInput;
  parentQuestion?: InputMaybe<Scalars['MongoID']['input']>;
  required: Scalars['Boolean']['input'];
  type: EnumSurveyQuestionType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  whereaboutsSearchEntityType?: InputMaybe<EnumSurveyQuestionWhereaboutsSearchEntityType>;
};

export type SurveyQuestionOptions = {
  __typename?: 'SurveyQuestionOptions';
  _id?: Maybe<Scalars['MongoID']['output']>;
  isActive: Scalars['Boolean']['output'];
  label: Multilingual;
};

export type SurveyQuestionOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive: Scalars['Boolean']['input'];
  label: MultilingualInput;
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  _id: Scalars['MongoID']['output'];
  adminStatus?: Maybe<EnumSurveyResponseAdminStatus>;
  broadcast?: Maybe<Scalars['MongoID']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  history?: Maybe<Array<Maybe<SurveyResponseHistory>>>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  /** Businesses the submission is for, primary first. */
  ownerBusinesses: Array<SurveyResponseBusiness>;
  ownerMetadata?: Maybe<SurveyResponseOwnerMetadata>;
  person?: Maybe<SimplePersonTc>;
  resourceId?: Maybe<Scalars['String']['output']>;
  responses: Array<Maybe<SurveyResponseResponses>>;
  reviewStatus?: Maybe<EnumSurveyResponseReviewStatus>;
  status?: Maybe<EnumSurveyResponseStatus>;
  submissionIndex: Scalars['Float']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  survey?: Maybe<Survey>;
  surveyUpdatedAt?: Maybe<Scalars['Date']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
  widget?: Maybe<Scalars['MongoID']['output']>;
};

export type SurveyResponseBusiness = {
  __typename?: 'SurveyResponseBusiness';
  businessName?: Maybe<Scalars['String']['output']>;
  operatorId: Scalars['String']['output'];
};

export type SurveyResponseHistory = {
  __typename?: 'SurveyResponseHistory';
  action: EnumSurveyResponseHistoryAction;
  personName?: Maybe<Scalars['String']['output']>;
  responses: Array<Maybe<SurveyResponseResponses>>;
  reviewNote?: Maybe<Scalars['String']['output']>;
  reviewStatus?: Maybe<EnumSurveyResponseHistoryReviewStatus>;
  reviewedAt?: Maybe<Scalars['Date']['output']>;
  reviewedBy?: Maybe<Scalars['MongoID']['output']>;
  savedBy: Scalars['MongoID']['output'];
  timestamp: Scalars['Date']['output'];
};

export type SurveyResponseHistoryInput = {
  action: EnumSurveyResponseHistoryAction;
  responses: Array<InputMaybe<SurveyResponseResponsesInput>>;
  reviewNote?: InputMaybe<Scalars['String']['input']>;
  reviewStatus?: InputMaybe<EnumSurveyResponseHistoryReviewStatus>;
  reviewedAt?: InputMaybe<Scalars['Date']['input']>;
  reviewedBy?: InputMaybe<Scalars['MongoID']['input']>;
  savedBy: Scalars['MongoID']['input'];
  timestamp: Scalars['Date']['input'];
};

export type SurveyResponseInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  adminStatus?: InputMaybe<EnumSurveyResponseAdminStatus>;
  broadcast?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  history?: InputMaybe<Array<InputMaybe<SurveyResponseHistoryInput>>>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  ownerMetadata?: InputMaybe<SurveyResponseOwnerMetadataInput>;
  person?: InputMaybe<Scalars['MongoID']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  responses: Array<InputMaybe<SurveyResponseResponsesInput>>;
  reviewStatus?: InputMaybe<EnumSurveyResponseReviewStatus>;
  status?: InputMaybe<EnumSurveyResponseStatus>;
  submissionIndex?: InputMaybe<Scalars['Float']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  survey: Scalars['MongoID']['input'];
  surveyUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
  widget?: InputMaybe<Scalars['MongoID']['input']>;
};

export type SurveyResponseOwnerMetadata = {
  __typename?: 'SurveyResponseOwnerMetadata';
  operator?: Maybe<Scalars['MongoID']['output']>;
  operators?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  organization?: Maybe<Scalars['MongoID']['output']>;
  storefront?: Maybe<Scalars['MongoID']['output']>;
};

export type SurveyResponseOwnerMetadataInput = {
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  operators?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
};

export type SurveyResponseResponses = {
  __typename?: 'SurveyResponseResponses';
  _id?: Maybe<Scalars['MongoID']['output']>;
  byBusiness?: Maybe<Array<Maybe<SurveyResponseResponsesByBusiness>>>;
  questionData: SurveyQuestion;
  response: Array<Maybe<Scalars['String']['output']>>;
};

export type SurveyResponseResponsesByBusiness = {
  __typename?: 'SurveyResponseResponsesByBusiness';
  operatorId: Scalars['String']['output'];
  response?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SurveyResponseResponsesByBusinessInput = {
  operatorId: Scalars['String']['input'];
  response?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SurveyResponseResponsesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  byBusiness?: InputMaybe<Array<InputMaybe<SurveyResponseResponsesByBusinessInput>>>;
  questionData: SurveyQuestionInput;
  response: Array<InputMaybe<Scalars['String']['input']>>;
};

export type SurveyUsage = {
  __typename?: 'SurveyUsage';
  bookers: Array<Multilingual>;
  broadcasts: Array<Multilingual>;
  products: Array<Multilingual>;
  responseCount: Scalars['Int']['output'];
  surveyId: Scalars['MongoID']['output'];
  widgets: Array<Multilingual>;
};

export type Tag = {
  __typename?: 'Tag';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  embedding: Array<Maybe<Scalars['Float']['output']>>;
  engineOwnedRole?: Maybe<EnumTagEngineOwnedRole>;
  entityTypes: Array<Maybe<EnumTagEntityTypes>>;
  inheritable: Scalars['Boolean']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  name: Multilingual;
  owner?: Maybe<Owner>;
  tagGroup?: Maybe<TagGroup>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  usage?: Maybe<TagUsage>;
};

export type TagEntityTypeUsage = {
  __typename?: 'TagEntityTypeUsage';
  _id: Scalars['MongoID']['output'];
  events: Array<Maybe<TagEntityTypeUsageOperators>>;
  lists: Array<Maybe<TagEntityTypeUsageOperators>>;
  operators: Array<Maybe<TagEntityTypeUsageOperators>>;
  people: Array<Maybe<TagEntityTypeUsageOperators>>;
  products: Array<Maybe<TagEntityTypeUsageOperators>>;
  promotions: Array<Maybe<TagEntityTypeUsageOperators>>;
  widgets: Array<Maybe<TagEntityTypeUsageOperators>>;
};

export type TagEntityTypeUsageOperators = {
  __typename?: 'TagEntityTypeUsageOperators';
  _id?: Maybe<Scalars['MongoID']['output']>;
  entityId: Scalars['String']['output'];
  entityName: Multilingual;
  parentId: Scalars['String']['output'];
  parentName: Multilingual;
};

export type TagGroup = {
  __typename?: 'TagGroup';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  key: EnumTagGroupKey;
  name: Multilingual;
  type: EnumTagGroupType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type TagRelationship = {
  __typename?: 'TagRelationship';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  generatedBy: EnumTagRelationshipGeneratedBy;
  sourceTag: Scalars['MongoID']['output'];
  targetTag: Scalars['MongoID']['output'];
  type: EnumTagRelationshipType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  weight: Scalars['Float']['output'];
};

export type TagRelationshipGenerateResult = {
  __typename?: 'TagRelationshipGenerateResult';
  created: Scalars['Int']['output'];
  errors: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type TagSuggestion = {
  __typename?: 'TagSuggestion';
  _id: Scalars['MongoID']['output'];
  aiResponse?: Maybe<TagSuggestionAiResponse>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  entityTypes: Array<Maybe<EnumTagSuggestionEntityTypes>>;
  name: Multilingual;
  owner?: Maybe<Owner>;
  tagGroup?: Maybe<TagGroup>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type TagSuggestionAiResponse = {
  __typename?: 'TagSuggestionAIResponse';
  _id: Scalars['MongoID']['output'];
  action?: Maybe<EnumTagSuggestionAiResponseAction>;
  alternativeSuggestions: Array<Maybe<Scalars['String']['output']>>;
  similarTags: Array<Maybe<Scalars['String']['output']>>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type TagSuggestionAiResponseInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  action?: InputMaybe<EnumTagSuggestionAiResponseAction>;
  alternativeSuggestions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  similarTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type TagUsage = {
  __typename?: 'TagUsage';
  _id?: Maybe<Scalars['MongoID']['output']>;
  events?: Maybe<Scalars['Float']['output']>;
  operators?: Maybe<Scalars['Float']['output']>;
  people?: Maybe<Scalars['Float']['output']>;
  products?: Maybe<Scalars['Float']['output']>;
  promotions?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type TagUsageInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  events?: InputMaybe<Scalars['Float']['input']>;
  operators?: InputMaybe<Scalars['Float']['input']>;
  people?: InputMaybe<Scalars['Float']['input']>;
  products?: InputMaybe<Scalars['Float']['input']>;
  promotions?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type Tax = {
  __typename?: 'Tax';
  _id: Scalars['MongoID']['output'];
  components?: Maybe<Array<Maybe<TaxComponents>>>;
  country: Scalars['String']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Owner>;
  percentage: Scalars['Float']['output'];
  subdivision: Scalars['String']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type TaxComponents = {
  __typename?: 'TaxComponents';
  name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export type TaxComponentsInput = {
  name: Scalars['String']['input'];
  percentage: Scalars['Float']['input'];
};

export type TaxLine = {
  __typename?: 'TaxLine';
  amount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ratePercent?: Maybe<Scalars['Float']['output']>;
};

export type TestMembershipFlow = {
  __typename?: 'TestMembershipFlow';
  broadcastId?: Maybe<Scalars['String']['output']>;
  broadcastName?: Maybe<Scalars['String']['output']>;
  checkoutMode: Scalars['String']['output'];
  checkouts?: Maybe<Array<TestMembershipFlowCheckout>>;
  emails?: Maybe<Array<TestMembershipFlowEmail>>;
  policy?: Maybe<TestMembershipFlowPolicy>;
  prorationAvailable: Scalars['Boolean']['output'];
  renewalsEnabled: Scalars['Boolean']['output'];
  scenarios?: Maybe<Array<TestMembershipScenario>>;
};

export type TestMembershipFlowCheckout = {
  __typename?: 'TestMembershipFlowCheckout';
  bookerName?: Maybe<Scalars['String']['output']>;
  free: Scalars['Boolean']['output'];
  testMode?: Maybe<Scalars['Boolean']['output']>;
  tierName: Scalars['String']['output'];
  tierTagId: Scalars['String']['output'];
};

export type TestMembershipFlowEmail = {
  __typename?: 'TestMembershipFlowEmail';
  custom: Scalars['Boolean']['output'];
  kind: TestRenewalEmailKind;
};

export type TestMembershipFlowPolicy = {
  __typename?: 'TestMembershipFlowPolicy';
  fixedRenewalDay?: Maybe<Scalars['Int']['output']>;
  fixedRenewalMonth?: Maybe<Scalars['Int']['output']>;
  graceDays: Scalars['Int']['output'];
  neverExpires: Scalars['Boolean']['output'];
  proRateEnabled: Scalars['Boolean']['output'];
  reminderLeadDays: Scalars['Int']['output'];
  renewalType: Scalars['String']['output'];
  term: Scalars['String']['output'];
  termYears?: Maybe<Scalars['Int']['output']>;
};

export type TestMembershipScenario = {
  __typename?: 'TestMembershipScenario';
  available: Scalars['Boolean']['output'];
  availableFrom?: Maybe<Scalars['String']['output']>;
  earlyWindowOpens?: Maybe<Scalars['String']['output']>;
  nextRenewalDate?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  state: TestRecordMembershipState;
};

export type TestProrationRow = {
  __typename?: 'TestProrationRow';
  bonusDays: Scalars['Int']['output'];
  chargeAmount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  fullAmount: Scalars['Float']['output'];
  optionName?: Maybe<Scalars['String']['output']>;
  periodEnd: Scalars['String']['output'];
  periodStart: Scalars['String']['output'];
  pricingKind: Scalars['String']['output'];
  tierName: Scalars['String']['output'];
};

export type TestRecord = {
  __typename?: 'TestRecord';
  _id: Scalars['String']['output'];
  addedListingCount: Scalars['Int']['output'];
  claimed: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  entityKind?: Maybe<TestRecordEntityKind>;
  inviteSent: Scalars['Boolean']['output'];
  listingState?: Maybe<TestRecordListingState>;
  membershipState?: Maybe<TestRecordMembershipState>;
  name: Scalars['String']['output'];
  operatorEntityId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  personId: Scalars['String']['output'];
  renewalDate?: Maybe<Scalars['String']['output']>;
  renewalPhase?: Maybe<Scalars['String']['output']>;
  simulatedNow?: Maybe<Scalars['String']['output']>;
  statusTagNames: Array<Scalars['String']['output']>;
  tierName?: Maybe<Scalars['String']['output']>;
  tierTagId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type TestRecordCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  entityKind: TestRecordEntityKind;
  listingState?: InputMaybe<TestRecordListingState>;
  membershipState?: InputMaybe<TestRecordMembershipState>;
  organizationId: Scalars['String']['input'];
  tierTagId?: InputMaybe<Scalars['String']['input']>;
};

export enum TestRecordEntityKind {
  Contact = 'CONTACT',
  Listing = 'LISTING',
  Signup = 'SIGNUP'
}

export enum TestRecordListingState {
  AwaitingApproval = 'AWAITING_APPROVAL',
  Onboarded = 'ONBOARDED',
  OnboardingIncomplete = 'ONBOARDING_INCOMPLETE',
  UnclaimedProspect = 'UNCLAIMED_PROSPECT'
}

export enum TestRecordMembershipState {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  None = 'NONE',
  Overdue = 'OVERDUE',
  RenewingSoon = 'RENEWING_SOON'
}

export type TestRecordRenewalCheck = {
  __typename?: 'TestRecordRenewalCheck';
  expired: Scalars['Int']['output'];
  reminded: Scalars['Int']['output'];
};

export type TestRecordTier = {
  __typename?: 'TestRecordTier';
  _id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TestRecordsPayload = {
  __typename?: 'TestRecordsPayload';
  businessTiers?: Maybe<Array<Maybe<TestRecordTier>>>;
  cap: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  disabledApps: Array<Scalars['String']['output']>;
  hasTestStorefront: Scalars['Boolean']['output'];
  individualTiers?: Maybe<Array<Maybe<TestRecordTier>>>;
  membershipEnabled: Scalars['Boolean']['output'];
  membershipFlow?: Maybe<TestMembershipFlow>;
  records?: Maybe<Array<Maybe<TestRecord>>>;
  showTestListings: Scalars['Boolean']['output'];
  testOperatorEntityIds: Array<Scalars['String']['output']>;
  testTagId?: Maybe<Scalars['String']['output']>;
};

export enum TestRenewalEmailKind {
  Expired = 'EXPIRED',
  Overdue = 'OVERDUE',
  Reminder = 'REMINDER'
}

export type TestRenewalEmailResult = {
  __typename?: 'TestRenewalEmailResult';
  sent: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type ToggleGateResult = {
  __typename?: 'ToggleGateResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ToursOperatorMetadata = {
  __typename?: 'ToursOperatorMetadata';
  maxGroupSize?: Maybe<Scalars['Float']['output']>;
};

export type ToursOperatorMetadataInput = {
  maxGroupSize?: InputMaybe<Scalars['Float']['input']>;
};

export type UnreadLeadTc = {
  __typename?: 'UnreadLeadTC';
  date: Scalars['Date']['output'];
  leadId: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UpcomingRenewalInvoicePreviewRateBreakdown = {
  __typename?: 'UpcomingRenewalInvoicePreviewRateBreakdown';
  count: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  rateType: Scalars['String']['output'];
};

export type UpcomingRenewalInvoicePreviewResult = {
  __typename?: 'UpcomingRenewalInvoicePreviewResult';
  count: Scalars['Int']['output'];
  rows?: Maybe<Array<Maybe<UpcomingRenewalInvoiceQuote>>>;
  samples?: Maybe<Array<Maybe<UpcomingRenewalInvoicePreviewSample>>>;
  totals?: Maybe<UpcomingRenewalInvoicePreviewTotals>;
};

export type UpcomingRenewalInvoicePreviewSample = {
  __typename?: 'UpcomingRenewalInvoicePreviewSample';
  customerName: Scalars['String']['output'];
  periodEnd: Scalars['String']['output'];
  renewablePurchaseId: Scalars['MongoID']['output'];
};

export type UpcomingRenewalInvoicePreviewTotals = {
  __typename?: 'UpcomingRenewalInvoicePreviewTotals';
  addOnAmount: Scalars['Int']['output'];
  byRateType?: Maybe<Array<Maybe<UpcomingRenewalInvoicePreviewRateBreakdown>>>;
  count: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  discountAmount: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  tierPrice: Scalars['Int']['output'];
  warningCount: Scalars['Int']['output'];
};

/** Anticipated renewal invoice for one purchase, priced exactly as the generator would (read-only). */
export type UpcomingRenewalInvoiceQuote = {
  __typename?: 'UpcomingRenewalInvoiceQuote';
  addOnAmount: Scalars['Int']['output'];
  bookerId: Scalars['MongoID']['output'];
  bookerName?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  discountAmount: Scalars['Int']['output'];
  discountName?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['String']['output'];
  feeWaived: Scalars['Boolean']['output'];
  grandTotal: Scalars['Int']['output'];
  periodEnd: Scalars['String']['output'];
  periodStart: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  rateSource: Scalars['String']['output'];
  rateType: Scalars['String']['output'];
  renewablePurchaseId: Scalars['MongoID']['output'];
  renewalMode: Scalars['String']['output'];
  statusTagName?: Maybe<Scalars['String']['output']>;
  subtotal: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  tierName?: Maybe<Scalars['String']['output']>;
  tierPrice: Scalars['Int']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type UpdateByIdAccommodationOperatorMetadataInput = {
  guestRoomQty?: InputMaybe<Scalars['Float']['input']>;
  shortTermAccommodationLicense?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdAccommodationProductMetadataInput = {
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  calendarLinks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  checkIn?: InputMaybe<Scalars['String']['input']>;
  checkOut?: InputMaybe<Scalars['String']['input']>;
  closures?: InputMaybe<Array<InputMaybe<UpdateByIdClosureInput>>>;
  guestMetadata?: InputMaybe<UpdateByIdGuestMetadataInput>;
  rooms?: InputMaybe<Array<InputMaybe<UpdateByIdRoomInput>>>;
};

export type UpdateByIdAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<UpdateByIdAddressLocationInput>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdAddressLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<EnumAddressLocationType>;
};

export type UpdateByIdAnalyticsDashboardInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  dashboardId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  updatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdAnalyticsDashboardPayload = {
  __typename?: 'UpdateByIdAnalyticsDashboardPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<AnalyticsDashboard>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdApiAccessInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  lastUsedAt?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdApiAccessPayload = {
  __typename?: 'UpdateByIdApiAccessPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ApiAccess>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdAssetFileInput = {
  blurhash?: InputMaybe<Scalars['String']['input']>;
  bytes?: InputMaybe<Scalars['Float']['input']>;
  caption?: InputMaybe<UpdateByIdMultilingualInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  originalUrl?: InputMaybe<Scalars['String']['input']>;
  parentEntity?: InputMaybe<UpdateByIdEntityReferenceInput>;
  sourceEnv?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdAssetFilePayload = {
  __typename?: 'UpdateByIdAssetFilePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<AssetFile>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdAssetImageInput = {
  blurhash?: InputMaybe<Scalars['String']['input']>;
  bytes?: InputMaybe<Scalars['Float']['input']>;
  caption?: InputMaybe<UpdateByIdMultilingualInput>;
  colors?: InputMaybe<Array<InputMaybe<UpdateByIdColorInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Currently, our schema only supports facial and text detection, using the built-in Cloudinary AI Content Analysis face detection, and the `cld-text` model. Therefore, the fields returned in `detectedObjects` will be limited to *optional* `humanFace` and `text` fields which are of `IDetectedObject[]` type.
   *
   * &nbsp;
   *
   * `IDetectedObject` contains a `boundingBox` array of `numbers`, a `categories` array of `string`s, and a `number` `confidence` value.
   *
   * &nbsp;
   *
   * ```json
   * interface IDetectedObject extends Document {
   *   boundingBox: number[];
   *   categories: string[];
   *   confidence: number;
   * }
   * ```
   */
  detectedObjects?: InputMaybe<Scalars['JSON']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  hasTransparency?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  lightness?: InputMaybe<Scalars['String']['input']>;
  mux?: InputMaybe<UpdateByIdAssetImageMuxInput>;
  originalUrl?: InputMaybe<Scalars['String']['input']>;
  parentEntity?: InputMaybe<UpdateByIdEntityReferenceInput>;
  qualityAnalysis?: InputMaybe<UpdateByIdImageQualityAnalysisInput>;
  qualityScore?: InputMaybe<Scalars['Float']['input']>;
  sourceEnv?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdAssetImageMuxInput = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  playbackId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumAssetImageMuxStatus>;
};

export type UpdateByIdAssetImagePayload = {
  __typename?: 'UpdateByIdAssetImagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<AssetImage>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdBookerApprovalSettingsInput = {
  autoCancelUnpaidAfterDays?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageToGuest?: InputMaybe<UpdateByIdMultilingualInput>;
  requestExpiryHours?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdBookerBundlesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  product?: InputMaybe<Scalars['MongoID']['input']>;
  upsells?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdBookerCompletionScreenInput = {
  ctaBroadcastId?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<UpdateByIdMultilingualInput>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<UpdateByIdMultilingualInput>;
};

export type UpdateByIdBookerCustomerFieldsInput = {
  addressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  businessFieldDescription?: InputMaybe<UpdateByIdMultilingualInput>;
  businessFieldEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  guestEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  guestInfoRequired?: InputMaybe<Scalars['Boolean']['input']>;
  guestNamesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  phoneEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdBookerCustomizationsInput = {
  addressDisplay?: InputMaybe<EnumBookerCustomizationsAddressDisplay>;
  confirmationEmailBody?: InputMaybe<UpdateByIdMultilingualInput>;
  confirmationEmailCtaLabel?: InputMaybe<UpdateByIdMultilingualInput>;
  confirmationEmailCtaUrl?: InputMaybe<Scalars['String']['input']>;
  confirmationEmailSubject?: InputMaybe<UpdateByIdMultilingualInput>;
  featuredImage?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  overrideAddOnsDescription?: InputMaybe<UpdateByIdMultilingualInput>;
  overrideDiscountCallout?: InputMaybe<UpdateByIdMultilingualInput>;
  overridePricingCallout?: InputMaybe<UpdateByIdMultilingualInput>;
  overrideProductDescription?: InputMaybe<UpdateByIdMultilingualInput>;
  overrideProductName?: InputMaybe<UpdateByIdMultilingualInput>;
  overrideQuestionnaireDescription?: InputMaybe<UpdateByIdMultilingualInput>;
  overrideQuestionnaireTitle?: InputMaybe<UpdateByIdMultilingualInput>;
  sectionOrder?: InputMaybe<Array<InputMaybe<EnumBookerCustomizationsSectionOrder>>>;
  showCheckoutChecklist?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdBookerDiscountScopesInput = {
  appliesToTierIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discount?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdBookerEligibilityInput = {
  blockedMessage?: InputMaybe<UpdateByIdMultilingualInput>;
  ineligibleBehavior?: InputMaybe<EnumBookerEligibilityIneligibleBehavior>;
  mode?: InputMaybe<EnumBookerEligibilityMode>;
  rule?: InputMaybe<EnumBookerEligibilityRule>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdBookerEmailTemplatesInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumBookerEmailTemplatesType>;
};

export type UpdateByIdBookerFeeAbsorptionSnapshotInput = {
  appliedAt?: InputMaybe<Scalars['Date']['input']>;
  products?: InputMaybe<Array<InputMaybe<UpdateByIdBookerFeeAbsorptionSnapshotProductsInput>>>;
};

export type UpdateByIdBookerFeeAbsorptionSnapshotProductsInput = {
  pricePoints?: InputMaybe<Array<InputMaybe<UpdateByIdBookerFeeAbsorptionSnapshotProductsPricePointsInput>>>;
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdBookerFeeAbsorptionSnapshotProductsPricePointsInput = {
  after?: InputMaybe<Scalars['Float']['input']>;
  before?: InputMaybe<Scalars['Float']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdBookerInput = {
  approvalSettings?: InputMaybe<UpdateByIdBookerApprovalSettingsInput>;
  bundles?: InputMaybe<Array<InputMaybe<UpdateByIdBookerBundlesInput>>>;
  businessCompletionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  completionScreen?: InputMaybe<UpdateByIdBookerCompletionScreenInput>;
  completionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customerFields?: InputMaybe<UpdateByIdBookerCustomerFieldsInput>;
  customizations?: InputMaybe<UpdateByIdBookerCustomizationsInput>;
  discountScopes?: InputMaybe<Array<InputMaybe<UpdateByIdBookerDiscountScopesInput>>>;
  discounts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  eligibility?: InputMaybe<UpdateByIdBookerEligibilityInput>;
  emailTemplates?: InputMaybe<Array<InputMaybe<UpdateByIdBookerEmailTemplatesInput>>>;
  feeAbsorptionSnapshot?: InputMaybe<UpdateByIdBookerFeeAbsorptionSnapshotInput>;
  fulfillmentProfile?: InputMaybe<Scalars['MongoID']['input']>;
  isInvoiceTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  paymentMetadata?: InputMaybe<UpdateByIdOrderPaymentMetadataInput>;
  paymentMethodSet?: InputMaybe<Scalars['MongoID']['input']>;
  paymentTiming?: InputMaybe<UpdateByIdBookerPaymentTimingInput>;
  policies?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  promoCodeTagOverrides?: InputMaybe<Array<InputMaybe<UpdateByIdBookerPromoCodeTagOverridesInput>>>;
  publiclyPublishable?: InputMaybe<Scalars['Boolean']['input']>;
  renewalSettings?: InputMaybe<UpdateByIdBookerRenewalSettingsInput>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  status?: InputMaybe<EnumBookerStatus>;
  statusNotification?: InputMaybe<UpdateByIdMultilingualInput>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  survey?: InputMaybe<Scalars['MongoID']['input']>;
  surveyInline?: InputMaybe<Scalars['Boolean']['input']>;
  tagDiscountSettings?: InputMaybe<UpdateByIdBookerTagDiscountSettingsInput>;
  teamVisible?: InputMaybe<Scalars['Boolean']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  waivers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdBookerPayload = {
  __typename?: 'UpdateByIdBookerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Booker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdOrderPaymentMetadataFeeAbsorptionInput = {
  roundingIncrementCents?: InputMaybe<Scalars['Float']['input']>;
  showBreakdownInCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  stripeFixedCents?: InputMaybe<Scalars['Float']['input']>;
  stripePercent?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdOrderPaymentMetadataInput = {
  acceptedPaymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  applicationPercentage?: InputMaybe<Scalars['Float']['input']>;
  applicationPercentageFollowsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  bankTransferInstructions?: InputMaybe<Scalars['String']['input']>;
  connectedAccountId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customerApplicationPercentage?: InputMaybe<Scalars['Float']['input']>;
  depositSettings?: InputMaybe<UpdateByIdDepositSettingsInput>;
  feeAbsorption?: InputMaybe<UpdateByIdOrderPaymentMetadataFeeAbsorptionInput>;
  offerTaxExemption?: InputMaybe<Scalars['Boolean']['input']>;
  optionalCardPostalCode?: InputMaybe<Scalars['Boolean']['input']>;
  securityDepositSettings?: InputMaybe<UpdateByIdSecurityDepositSettingsInput>;
  stripeRegion?: InputMaybe<EnumOrderPaymentMetadataStripeRegion>;
  tax?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdBookerPaymentTimingInput = {
  afterServiceOffsetDays?: InputMaybe<Scalars['Float']['input']>;
  consolidation?: InputMaybe<EnumBookerPaymentTimingConsolidation>;
  invoiceDueDays?: InputMaybe<Scalars['Float']['input']>;
  timing?: InputMaybe<EnumBookerPaymentTimingTiming>;
};

export type UpdateByIdBookerPromoCodeTagOverridesInput = {
  discountId?: InputMaybe<Scalars['MongoID']['input']>;
  mode?: InputMaybe<EnumBookerPromoCodeTagOverridesMode>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdBookerRenewalSettingsInput = {
  renewalMode?: InputMaybe<EnumBookerRenewalSettingsRenewalMode>;
  renewalReminderDaysBefore?: InputMaybe<Scalars['Float']['input']>;
  requireApproval?: InputMaybe<Scalars['Boolean']['input']>;
  sendRenewalReminders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdBookerTagDiscountSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<Array<InputMaybe<UpdateByIdBookerTagDiscountSettingsRulesInput>>>;
};

export type UpdateByIdBookerTagDiscountSettingsRulesInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  discountType?: InputMaybe<EnumBookerTagDiscountSettingsRulesDiscountType>;
  tag?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdBroadcastInput = {
  coverImage?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  publicName?: InputMaybe<UpdateByIdMultilingualInput>;
  resources?: InputMaybe<Array<InputMaybe<UpdateByIdBroadcastResourcesInput>>>;
  sharedTo?: InputMaybe<UpdateByIdBroadcastSharedToInput>;
  status?: InputMaybe<EnumBroadcastStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdBroadcastPayload = {
  __typename?: 'UpdateByIdBroadcastPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Broadcast>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdBroadcastResourcesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  allowResubmission?: InputMaybe<Scalars['Boolean']['input']>;
  allowSaveAndEdit?: InputMaybe<Scalars['Boolean']['input']>;
  booker?: InputMaybe<Scalars['MongoID']['input']>;
  completionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  course?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<UpdateByIdMultilingualInput>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  expirationTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  file?: InputMaybe<Scalars['String']['input']>;
  formMode?: InputMaybe<EnumBroadcastResourcesFormMode>;
  iframeUrl?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<UpdateByIdMultilingualInput>;
  paymentRequestId?: InputMaybe<Scalars['MongoID']['input']>;
  photos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requireApproval?: InputMaybe<Scalars['Boolean']['input']>;
  submissionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  survey?: InputMaybe<Scalars['String']['input']>;
  teamVisible?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<UpdateByIdMultilingualInput>;
  type?: InputMaybe<EnumBroadcastResourcesType>;
  video?: InputMaybe<Scalars['String']['input']>;
  videoURL?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdBroadcastSharedToInput = {
  operatorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sentToPeople?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  sentToPeopleSystemRoles?: InputMaybe<Array<InputMaybe<EnumBroadcastSharedToSentToPeopleSystemRoles>>>;
  sentToPeopleTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  skipEmails?: InputMaybe<Scalars['Boolean']['input']>;
  teaser?: InputMaybe<UpdateByIdBroadcastSharedToTeaserInput>;
  type?: InputMaybe<EnumBroadcastSharedToType>;
};

export type UpdateByIdBroadcastSharedToTeaserInput = {
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdClosureInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  dateRangeISO?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdColorInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  predominance?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdContactInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<LinksInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  tollFreePublicPhone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdDateRangeIsoInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  end: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['String']['input'];
};

export type UpdateByIdDateRangeIsoOptionalInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdDepositSettingsInput = {
  chargeBalanceDaysBeforeCheckIn?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateType?: InputMaybe<EnumDepositSettingsRateType>;
};

export type UpdateByIdDiscountInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  buyQuantity?: InputMaybe<Scalars['Float']['input']>;
  canCombine?: InputMaybe<Scalars['Boolean']['input']>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  currentUsageCount?: InputMaybe<Scalars['Float']['input']>;
  daysInAdvance?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  discountActivePeriod?: InputMaybe<UpdateByIdDateRangeIsoOptionalInput>;
  excludeUpsells?: InputMaybe<Scalars['Boolean']['input']>;
  getQuantity?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isOngoing?: InputMaybe<Scalars['Boolean']['input']>;
  maxDaysInAdvance?: InputMaybe<Scalars['Float']['input']>;
  maxNights?: InputMaybe<Scalars['Float']['input']>;
  maxUsageCount?: InputMaybe<Scalars['Float']['input']>;
  minGuestCount?: InputMaybe<Scalars['Float']['input']>;
  minNights?: InputMaybe<Scalars['Float']['input']>;
  minQuantity?: InputMaybe<Scalars['Float']['input']>;
  minSubtotal?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  perTicket?: InputMaybe<Scalars['Boolean']['input']>;
  perTicketApplyFrom?: InputMaybe<Scalars['Float']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumDiscountType>;
  unit?: InputMaybe<EnumDiscountUnit>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdDiscountPayload = {
  __typename?: 'UpdateByIdDiscountPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Discount>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdEntityReferenceInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumEntityReferenceType>;
};

export type UpdateByIdEventAccessInput = {
  disconnectedOrganizations?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  operator?: InputMaybe<UpdateByIdEventAccessOperatorInput>;
  organizations?: InputMaybe<Array<InputMaybe<UpdateByIdEventAccessOperatorInput>>>;
};

export type UpdateByIdEventAccessOperatorInput = {
  _entityId: Scalars['MongoID']['input'];
  addedVia?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumEventAccessOperatorSource>;
  status?: InputMaybe<EnumEventAccessOperatorStatus>;
  statusBeforeCancel?: InputMaybe<EnumEventAccessOperatorStatusBeforeCancel>;
};

export type UpdateByIdEventAttentionIssuesInput = {
  sourceName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumEventAttentionIssuesType>;
  venueIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdEventHistoryInput = {
  action?: InputMaybe<EnumEventHistoryAction>;
  note?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  sourceType?: InputMaybe<EnumEventHistorySourceType>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdEventInput = {
  access?: InputMaybe<UpdateByIdEventAccessInput>;
  attentionIssues?: InputMaybe<Array<InputMaybe<UpdateByIdEventAttentionIssuesInput>>>;
  contact?: InputMaybe<UpdateByIdContactInput>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  createdByFirstName?: InputMaybe<Scalars['String']['input']>;
  createdByLastName?: InputMaybe<Scalars['String']['input']>;
  createdByPerson?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  /** Set when event is created via import; events with this set are excluded from daily digest notification emails */
  createdViaImportRunId?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  duplicateDismissedAt?: InputMaybe<Scalars['Date']['input']>;
  duplicateDismissedBy?: InputMaybe<Scalars['MongoID']['input']>;
  /** The end date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventLocation?: InputMaybe<UpdateByIdEventLocationInput>;
  eventLocations?: InputMaybe<Array<InputMaybe<UpdateByIdEventLocationInput>>>;
  eventOrganizer?: InputMaybe<UpdateByIdEventLocationInput>;
  history?: InputMaybe<Array<InputMaybe<UpdateByIdEventHistoryInput>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationType?: InputMaybe<EnumEventLocationType>;
  otherLocations?: InputMaybe<Array<InputMaybe<UpdateByIdEventLocationInput>>>;
  presentedBy?: InputMaybe<UpdateByIdMultilingualInput>;
  price?: InputMaybe<Scalars['String']['input']>;
  recurrencePattern?: InputMaybe<UpdateByIdEventRecurrencePatternInput>;
  schedules?: InputMaybe<Array<InputMaybe<UpdateByIdEventSchedulesInput>>>;
  /** The start date of the event. The string will be formatted as yyyy-mm-dd. To have it make sense to humans, the month will start at 01, so Jan 20, 2025 would be 2025-01-20. */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Who created the event (GUEST/OPERATOR/ORGANIZATION), derived server-side at create time. Used to exclude operator-sourced drafts from an organization's Events app. */
  submissionSource?: InputMaybe<EnumEventSubmissionSource>;
  suspectedDuplicateOf?: InputMaybe<Scalars['MongoID']['input']>;
  tags?: InputMaybe<UpdateByIdEventTagsInput>;
  ticketUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<UpdateByIdMultilingualInput>;
  type?: InputMaybe<EnumEventType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  venue?: InputMaybe<UpdateByIdMultilingualInput>;
};

export type UpdateByIdEventLocationInput = {
  contact?: InputMaybe<ContactInput>;
  locationInfo?: InputMaybe<EventLocationLocationInfoInput>;
  venue: MultilingualInput;
};

export type UpdateByIdEventPayload = {
  __typename?: 'UpdateByIdEventPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Event>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdEventRecurrencePatternInput = {
  /** For monthly frequency, the extact date each month (e.g. the 15th) */
  dateOfMonth?: InputMaybe<Scalars['Float']['input']>;
  /** For monthly frequency, the weekday the event should occur on (used in conjuction with dayOfMonthOccurrence) (e.g. WE) */
  dayOfMonth?: InputMaybe<EnumEventRecurrencePatternDayOfMonth>;
  /** For monthly frequency, the weekday occurrence the event should occur on (used in conjuction with dayOfMonth) (e.g. 3). If this value is 5, it is treated as the 'last occurrence in the month' */
  dayOfMonthOccurrence?: InputMaybe<Scalars['Float']['input']>;
  /** For daily or weekly frequency, the weekday(s) to recur (e.g. Thursdays and Saturdays) */
  daysOfWeek?: InputMaybe<Array<InputMaybe<EnumEventRecurrencePatternDaysOfWeek>>>;
  /** The end date of the recurrence */
  endDate?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<EnumEventRecurrencePatternFrequency>;
  interval?: InputMaybe<Scalars['Float']['input']>;
  /** For yearly frequency, the MM-dd of the year that the event should occur on */
  monthAndDateOfYear?: InputMaybe<Scalars['String']['input']>;
  /** A list of dates (yyyy-MM-dd) for the MULTI type event */
  multiDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of dates (yyyy-MM-dd) that should be skipped in the recurrence */
  skipDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdEventSchedulesInput = {
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  timeSlots?: InputMaybe<Array<InputMaybe<UpdateByIdEventSchedulesTimeSlotsInput>>>;
};

export type UpdateByIdEventSchedulesTimeSlotsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  endsNextDay?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdEventTagsInput = {
  global?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdExperienceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdFulfillmentProfileInput = {
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pickup?: InputMaybe<UpdateByIdFulfillmentProfilePickupInput>;
  shipping?: InputMaybe<UpdateByIdFulfillmentProfileShippingInput>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdFulfillmentProfilePayload = {
  __typename?: 'UpdateByIdFulfillmentProfilePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<FulfillmentProfile>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdFulfillmentProfilePickupInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  locations?: InputMaybe<Array<InputMaybe<UpdateByIdFulfillmentProfilePickupLocationsInput>>>;
};

export type UpdateByIdFulfillmentProfilePickupLocationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdFulfillmentProfileShippingInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  zones?: InputMaybe<Array<InputMaybe<UpdateByIdFulfillmentProfileShippingZonesInput>>>;
};

export type UpdateByIdFulfillmentProfileShippingZonesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  freeOver?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  perAdditionalItem?: InputMaybe<Scalars['Float']['input']>;
  subdivisions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateByIdGuestMetadataInput = {
  maximumNumber?: InputMaybe<Scalars['Float']['input']>;
  minimumNumber?: InputMaybe<Scalars['Float']['input']>;
  nameEntryAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  nameEntryRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdImageQualityAnalysisInput = {
  blockiness?: InputMaybe<Scalars['Float']['input']>;
  chroma_subsampling?: InputMaybe<Scalars['Float']['input']>;
  color_score?: InputMaybe<Scalars['Float']['input']>;
  contrast?: InputMaybe<Scalars['Float']['input']>;
  dct?: InputMaybe<Scalars['Float']['input']>;
  exposure?: InputMaybe<Scalars['Float']['input']>;
  focus?: InputMaybe<Scalars['Float']['input']>;
  jpeg_chroma?: InputMaybe<Scalars['Float']['input']>;
  jpeg_quality?: InputMaybe<Scalars['Float']['input']>;
  lighting?: InputMaybe<Scalars['Float']['input']>;
  noise?: InputMaybe<Scalars['Float']['input']>;
  pixel_score?: InputMaybe<Scalars['Float']['input']>;
  resolution?: InputMaybe<Scalars['Float']['input']>;
  saturation?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdImportGoogleSheetsConfigInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
  serviceAccountKey?: InputMaybe<Scalars['String']['input']>;
  sheetId?: InputMaybe<Scalars['String']['input']>;
  sheetUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdImportInput = {
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  googleSheetsConfig?: InputMaybe<UpdateByIdImportGoogleSheetsConfigInput>;
  importType?: InputMaybe<EnumImportImportType>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<EnumImportStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdImportPayload = {
  __typename?: 'UpdateByIdImportPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Import>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdImportScrapeGoogleSheetsConfigInput = {
  sheetId?: InputMaybe<Scalars['String']['input']>;
  sheetName?: InputMaybe<Scalars['String']['input']>;
  sheetUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdImportScrapeInput = {
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  googleSheetsConfig?: InputMaybe<UpdateByIdImportScrapeGoogleSheetsConfigInput>;
  maxRows?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scraperPrompt?: InputMaybe<Scalars['String']['input']>;
  sitemapEntries?: InputMaybe<Array<InputMaybe<UpdateByIdImportScrapeSitemapEntriesInput>>>;
  sitemapRevision?: InputMaybe<Scalars['Float']['input']>;
  sitemapUrlCount?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<EnumImportScrapeStatus>;
  targetOrganization?: InputMaybe<Scalars['MongoID']['input']>;
  typeOfData?: InputMaybe<EnumImportScrapeTypeOfData>;
  typeOfScrape?: InputMaybe<EnumImportScrapeTypeOfScrape>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdImportScrapePayload = {
  __typename?: 'UpdateByIdImportScrapePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ImportScrape>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdImportScrapeSitemapEntriesInput = {
  imageUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdInventoryItemInput = {
  claimedDateRangesISO?: InputMaybe<Array<InputMaybe<UpdateByIdDateRangeIsoInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  product?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumInventoryItemType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdInventoryItemPayload = {
  __typename?: 'UpdateByIdInventoryItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<InventoryItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdItineraryInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  isLoop?: InputMaybe<Scalars['Boolean']['input']>;
  lastEditedBy?: InputMaybe<Scalars['MongoID']['input']>;
  moreInfoLink?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  published?: InputMaybe<UpdateByIdItineraryPublishedInput>;
  routeDistance?: InputMaybe<Scalars['Float']['input']>;
  routeDuration?: InputMaybe<Scalars['Float']['input']>;
  routePath?: InputMaybe<Scalars['JSON']['input']>;
  routeStatus?: InputMaybe<EnumItineraryRouteStatus>;
  segments?: InputMaybe<Array<InputMaybe<UpdateByIdItinerarySegmentsInput>>>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumItineraryStatus>;
  trailPlace?: InputMaybe<Scalars['MongoID']['input']>;
  travelType?: InputMaybe<EnumItineraryTravelType>;
  tripperSettings?: InputMaybe<UpdateByIdItineraryTripperSettingsInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdItineraryPayload = {
  __typename?: 'UpdateByIdItineraryPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Itinerary>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdItineraryPublishedInput = {
  coverImage?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  isLoop?: InputMaybe<Scalars['Boolean']['input']>;
  moreInfoLink?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  publishedAt?: InputMaybe<Scalars['Date']['input']>;
  publishedBy?: InputMaybe<Scalars['MongoID']['input']>;
  routeDistance?: InputMaybe<Scalars['Float']['input']>;
  routeDuration?: InputMaybe<Scalars['Float']['input']>;
  routePath?: InputMaybe<Scalars['JSON']['input']>;
  segments?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  trailPlace?: InputMaybe<Scalars['MongoID']['input']>;
  travelType?: InputMaybe<EnumItineraryPublishedTravelType>;
  tripperSettings?: InputMaybe<UpdateByIdItineraryTripperSettingsInput>;
};

export type UpdateByIdItinerarySegmentsInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  items?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  label?: InputMaybe<UpdateByIdMultilingualInput>;
};

export type UpdateByIdItineraryTripperSettingsInput = {
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  map3dBuildings?: InputMaybe<Scalars['Boolean']['input']>;
  map3dObjects?: InputMaybe<Scalars['Boolean']['input']>;
  map3dTrees?: InputMaybe<Scalars['Boolean']['input']>;
  mapStyleVariant?: InputMaybe<EnumItineraryTripperSettingsMapStyleVariant>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  segmentPreset: EnumItineraryTripperSettingsSegmentPreset;
  showPointsOfInterest?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdLeadInput = {
  broadcastId?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<UpdateByIdLeadMessagesInput>>>;
  metadata?: InputMaybe<UpdateByIdLeadMetadataInput>;
  person?: InputMaybe<Scalars['MongoID']['input']>;
  source?: InputMaybe<EnumLeadSource>;
  sourceDetails?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumLeadStatus>;
  subject?: InputMaybe<Scalars['String']['input']>;
  surveyResponse?: InputMaybe<Scalars['MongoID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumLeadType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdLeadMessagesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<EnumLeadMessagesSender>;
  sentAtDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdLeadMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  booker?: InputMaybe<Scalars['MongoID']['input']>;
  operator?: InputMaybe<Scalars['MongoID']['input']>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdLeadPayload = {
  __typename?: 'UpdateByIdLeadPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Lead>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdListInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  audienceListKey?: InputMaybe<EnumListAudienceListKey>;
  audienceTagId?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  entityReferences?: InputMaybe<Array<InputMaybe<UpdateByIdVersionedEntityReferenceInput>>>;
  externallyAvailableEntityReferences?: InputMaybe<Array<InputMaybe<UpdateByIdVersionedEntityReferenceInput>>>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  filterTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  kind?: InputMaybe<EnumListKind>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  lockedAt?: InputMaybe<Scalars['Date']['input']>;
  lockedBy?: InputMaybe<Scalars['MongoID']['input']>;
  lockedByName?: InputMaybe<Scalars['String']['input']>;
  memberListKey?: InputMaybe<EnumListMemberListKey>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  orderIndex?: InputMaybe<Scalars['Float']['input']>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  selections?: InputMaybe<Scalars['JSON']['input']>;
  tierTagId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumListType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdMaintenanceDoorstopInput = {
  isLive: Scalars['Boolean']['input'];
  message: MultilingualInput;
};

export type UpdateByIdMaintenanceInput = {
  banner?: InputMaybe<UpdateByIdMaintenanceDoorstopInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  doorstop?: InputMaybe<UpdateByIdMaintenanceDoorstopInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdMaintenancePayload = {
  __typename?: 'UpdateByIdMaintenancePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Maintenance>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdMerchMetadataDimensionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  drivesImages?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  values?: InputMaybe<Array<InputMaybe<UpdateByIdMerchMetadataDimensionsValuesInput>>>;
};

export type UpdateByIdMerchMetadataDimensionsValuesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  imageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<UpdateByIdMultilingualInput>;
};

export type UpdateByIdMerchMetadataInput = {
  dimensions?: InputMaybe<Array<InputMaybe<UpdateByIdMerchMetadataDimensionsInput>>>;
  lowStockThreshold?: InputMaybe<Scalars['Float']['input']>;
  variants?: InputMaybe<Array<InputMaybe<UpdateByIdMerchMetadataVariantsInput>>>;
};

export type UpdateByIdMerchMetadataVariantsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  dimensionValueIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inventoryCount?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdMultilingualInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdNoteInput = {
  author?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entity?: InputMaybe<UpdateByIdEntityReferenceInput>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<EnumNoteKind>;
  mentions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  noteDateISO?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  resolvedBy?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdNotePayload = {
  __typename?: 'UpdateByIdNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Note>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdOperatorEnrollmentsInput = {
  currentStatus?: InputMaybe<EnumOperatorEnrollmentsCurrentStatus>;
  onboardingStatus?: InputMaybe<EnumOperatorEnrollmentsOnboardingStatus>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  organizationControlled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdOperatorExternalVideoLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdOperatorHoursOfOperationInput = {
  fri?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  mon?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  sat?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  sun?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  thu?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  tue?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  wed?: InputMaybe<UpdateByIdDateRangeIsoInput>;
};

export type UpdateByIdOperatorInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  accommodationMetadata?: InputMaybe<UpdateByIdAccommodationOperatorMetadataInput>;
  avgImageQuality?: InputMaybe<EnumOperatorAvgImageQuality>;
  canonicalDocument?: InputMaybe<Scalars['String']['input']>;
  claimed?: InputMaybe<Scalars['Boolean']['input']>;
  connectedOrganization?: InputMaybe<Scalars['MongoID']['input']>;
  contact?: InputMaybe<UpdateByIdContactInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  enableMembershipLink?: InputMaybe<Scalars['Boolean']['input']>;
  enrollments?: InputMaybe<Array<InputMaybe<UpdateByIdOperatorEnrollmentsInput>>>;
  experienceMetadata?: InputMaybe<UpdateByIdExperienceOperatorMetadataInput>;
  externalVideoLinks?: InputMaybe<Array<InputMaybe<UpdateByIdOperatorExternalVideoLinksInput>>>;
  hoursOfOperation?: InputMaybe<UpdateByIdOperatorHoursOfOperationInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  import?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  operationalStatus?: InputMaybe<EnumOperatorOperationalStatus>;
  pricing?: InputMaybe<EnumOperatorPricing>;
  restaurantMetadata?: InputMaybe<UpdateByIdRestaurantOperatorMetadataInput>;
  searchName?: InputMaybe<UpdateByIdMultilingualInput>;
  seasonality?: InputMaybe<UpdateByIdSeasonalityInput>;
  selectedTagGroups?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  serviceMetadata?: InputMaybe<UpdateByIdServiceOperatorMetadataInput>;
  shortDescription?: InputMaybe<UpdateByIdMultilingualInput>;
  tags?: InputMaybe<UpdateByIdOperatorTagsInput>;
  toursMetadata?: InputMaybe<UpdateByIdToursOperatorMetadataInput>;
  type?: InputMaybe<EnumOperatorType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  whereabotDismissed?: InputMaybe<UpdateByIdOperatorWhereabotDismissedInput>;
};

export type UpdateByIdOperatorTagsInput = {
  amenity?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  businessType?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  global?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdOperatorWhereabotDismissedInput = {
  imageScan?: InputMaybe<Scalars['Date']['input']>;
  listingScan?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdOrderPayload = {
  __typename?: 'UpdateByIdOrderPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Order>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdOrganizationAppSettingsInput = {
  widgets?: InputMaybe<UpdateByIdOrganizationAppSettingsWidgetsInput>;
};

export type UpdateByIdOrganizationAppSettingsWidgetsEventInput = {
  hideCancelledEvents?: InputMaybe<Scalars['Boolean']['input']>;
  organizerAudienceTagFilters?: InputMaybe<Array<InputMaybe<UpdateByIdOrganizationAppSettingsWidgetsEventOrganizerAudienceTagFiltersInput>>>;
  venueAudienceTagFilters?: InputMaybe<Array<InputMaybe<UpdateByIdOrganizationAppSettingsWidgetsEventVenueAudienceTagFiltersInput>>>;
};

export type UpdateByIdOrganizationAppSettingsWidgetsEventOrganizerAudienceTagFiltersInput = {
  mode?: InputMaybe<EnumOrganizationAppSettingsWidgetsEventOrganizerAudienceTagFiltersMode>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdOrganizationAppSettingsWidgetsEventVenueAudienceTagFiltersInput = {
  mode?: InputMaybe<EnumOrganizationAppSettingsWidgetsEventVenueAudienceTagFiltersMode>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdOrganizationAppSettingsWidgetsInput = {
  event?: InputMaybe<UpdateByIdOrganizationAppSettingsWidgetsEventInput>;
  operator?: InputMaybe<UpdateByIdOrganizationAppSettingsWidgetsOperatorInput>;
  whatsNearby?: InputMaybe<UpdateByIdOrganizationAppSettingsWidgetsWhatsNearbyInput>;
};

export type UpdateByIdOrganizationAppSettingsWidgetsOperatorAudienceTagFiltersInput = {
  mode?: InputMaybe<EnumOrganizationAppSettingsWidgetsOperatorAudienceTagFiltersMode>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdOrganizationAppSettingsWidgetsOperatorInput = {
  audienceTagFilters?: InputMaybe<Array<InputMaybe<UpdateByIdOrganizationAppSettingsWidgetsOperatorAudienceTagFiltersInput>>>;
  audienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  defaultImageId?: InputMaybe<Scalars['String']['input']>;
  defaultImageMode?: InputMaybe<EnumOrganizationAppSettingsWidgetsOperatorDefaultImageMode>;
  hidePermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  hideTemporarilyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  operatorWidgetFilter?: InputMaybe<EnumOrganizationAppSettingsWidgetsOperatorOperatorWidgetFilter>;
  prioritizeClaimedAndDmoManaged?: InputMaybe<Scalars['Boolean']['input']>;
  showPermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  showTestListings?: InputMaybe<Scalars['Boolean']['input']>;
  tierDisplayOverrides?: InputMaybe<Array<InputMaybe<UpdateByIdOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesInput>>>;
  tieredSortOrder?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesInput = {
  slideout?: InputMaybe<UpdateByIdOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesSlideoutInput>;
  statusSortOrder?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
  teaser?: InputMaybe<UpdateByIdOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesTeaserInput>;
};

export type UpdateByIdOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesSlideoutInput = {
  hideAddress?: InputMaybe<Scalars['Boolean']['input']>;
  hideExternalLinks?: InputMaybe<Scalars['Boolean']['input']>;
  hideLongDescription?: InputMaybe<Scalars['Boolean']['input']>;
  hideMap?: InputMaybe<Scalars['Boolean']['input']>;
  hideOperatingHours?: InputMaybe<Scalars['Boolean']['input']>;
  limitImages?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdOrganizationAppSettingsWidgetsOperatorTierDisplayOverridesTeaserInput = {
  hideImage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdOrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFiltersInput = {
  mode?: InputMaybe<EnumOrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFiltersMode>;
  tagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdOrganizationAppSettingsWidgetsWhatsNearbyInput = {
  audienceTagFilters?: InputMaybe<Array<InputMaybe<UpdateByIdOrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFiltersInput>>>;
  audienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdOrganizationEmailBrandingInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  footerText?: InputMaybe<UpdateByIdMultilingualInput>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdOrganizationInput = {
  appSettings?: InputMaybe<UpdateByIdOrganizationAppSettingsInput>;
  brandColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<UpdateByIdContactInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailBranding?: InputMaybe<UpdateByIdOrganizationEmailBrandingInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  license?: InputMaybe<UpdateByIdOrganizationLicenseInput>;
  logo?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<UpdateByIdOrganizationMetadataInput>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  onboardingMetadata?: InputMaybe<UpdateByIdOrganizationOnboardingMetadataInput>;
  shortDescription?: InputMaybe<UpdateByIdMultilingualInput>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdOrganizationLicenseInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  activatedBy?: InputMaybe<Scalars['MongoID']['input']>;
  activatedDate?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdOrganizationMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  canEnableMembershipLink?: InputMaybe<Scalars['Boolean']['input']>;
  claimedListingStaleDays?: InputMaybe<Scalars['Float']['input']>;
  connectedOperator?: InputMaybe<Scalars['MongoID']['input']>;
  connectedStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  connectedTestStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  connectedUsdStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  connectedUsdTestStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  crowdriffEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  customClaimEmailBody?: InputMaybe<Scalars['String']['input']>;
  customClaimEmailSubject?: InputMaybe<Scalars['String']['input']>;
  customPingEmailBody?: InputMaybe<Scalars['String']['input']>;
  customPingEmailSubject?: InputMaybe<Scalars['String']['input']>;
  disabledApps?: InputMaybe<Array<InputMaybe<EnumOrganizationMetadataDisabledApps>>>;
  dmoListingStaleDays?: InputMaybe<Scalars['Float']['input']>;
  eventLookaheadMonths?: InputMaybe<Scalars['Float']['input']>;
  eventPartnerOrganizations?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  eventSharingCode?: InputMaybe<Scalars['String']['input']>;
  externalVideoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  individualMembershipTiers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  internalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inviteWhenAddingStaff?: InputMaybe<Scalars['Boolean']['input']>;
  listingAudienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  listingFreshnessEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  membershipBroadcastId?: InputMaybe<Scalars['MongoID']['input']>;
  membershipHub?: InputMaybe<UpdateByIdOrganizationMetadataMembershipHubInput>;
  membershipLaunch?: InputMaybe<UpdateByIdOrganizationMetadataMembershipLaunchInput>;
  membershipPageUrl?: InputMaybe<Scalars['String']['input']>;
  membershipPaymentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  membershipStatusTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  membershipTierCheckouts?: InputMaybe<Array<InputMaybe<UpdateByIdOrganizationMetadataMembershipTierCheckoutsInput>>>;
  membershipTiers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  nomenclature?: InputMaybe<UpdateByIdOrganizationMetadataNomenclatureInput>;
  operatorOnboardingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  renewalSettings?: InputMaybe<UpdateByIdOrganizationMetadataRenewalSettingsInput>;
  sandbox?: InputMaybe<Scalars['Boolean']['input']>;
  storefrontMode?: InputMaybe<EnumOrganizationMetadataStorefrontMode>;
  storefrontOrgConnectionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  testRecordTagId?: InputMaybe<Scalars['MongoID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  whereabotImageDownloadPrompt?: InputMaybe<Scalars['String']['input']>;
  whereabotListingUpdatePrompt?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdOrganizationMetadataMembershipHubInput = {
  hideOfferFromForYou?: InputMaybe<Scalars['Boolean']['input']>;
  tiers?: InputMaybe<Array<InputMaybe<UpdateByIdOrganizationMetadataMembershipHubTiersInput>>>;
};

export type UpdateByIdOrganizationMetadataMembershipHubTiersInput = {
  applicationBroadcastId?: InputMaybe<Scalars['MongoID']['input']>;
  applicationResourceId?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  hideFromNewcomers?: InputMaybe<Scalars['Boolean']['input']>;
  tierTagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdOrganizationMetadataMembershipLaunchInput = {
  launchedAt?: InputMaybe<Scalars['Date']['input']>;
  launchedBy?: InputMaybe<Scalars['MongoID']['input']>;
  mode?: InputMaybe<EnumOrganizationMetadataMembershipLaunchMode>;
  recordedRetroactively?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleHistory?: InputMaybe<Array<InputMaybe<UpdateByIdOrganizationMetadataMembershipLaunchScheduleHistoryInput>>>;
  settingsAtLaunch?: InputMaybe<UpdateByIdOrganizationMetadataMembershipLaunchSettingsAtLaunchInput>;
  state?: InputMaybe<EnumOrganizationMetadataMembershipLaunchState>;
};

export type UpdateByIdOrganizationMetadataMembershipLaunchScheduleHistoryInput = {
  affected?: InputMaybe<Scalars['Float']['input']>;
  at?: InputMaybe<Scalars['Date']['input']>;
  by?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  from?: InputMaybe<UpdateByIdOrganizationMetadataMembershipLaunchSettingsAtLaunchInput>;
  intent?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<UpdateByIdOrganizationMetadataMembershipLaunchSettingsAtLaunchInput>;
};

export type UpdateByIdOrganizationMetadataMembershipLaunchSettingsAtLaunchInput = {
  fixedRenewalDay?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalMonth?: InputMaybe<Scalars['Float']['input']>;
  renewalType?: InputMaybe<EnumOrganizationMetadataMembershipLaunchSettingsAtLaunchRenewalType>;
  term?: InputMaybe<EnumOrganizationMetadataMembershipLaunchSettingsAtLaunchTerm>;
  termYears?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdOrganizationMetadataMembershipTierCheckoutsInput = {
  bookerId?: InputMaybe<Scalars['MongoID']['input']>;
  free?: InputMaybe<Scalars['Boolean']['input']>;
  tierTagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdOrganizationMetadataNomenclatureInput = {
  member?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Scalars['String']['input']>;
  membership?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdOrganizationMetadataRenewalSettingsInput = {
  activeStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  automaticRenewalEmails?: InputMaybe<Scalars['Boolean']['input']>;
  cancelledEmail?: InputMaybe<UpdateByIdOrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  cancelledStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  clearStatusTagsOnExpiration?: InputMaybe<Scalars['Boolean']['input']>;
  emailCooldownDays?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  engineOwnedTags?: InputMaybe<Scalars['Boolean']['input']>;
  expiredEmail?: InputMaybe<UpdateByIdOrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  expiredStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  fixedRenewalDay?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalMonth?: InputMaybe<Scalars['Float']['input']>;
  instructionsEmail?: InputMaybe<UpdateByIdOrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  invoiceLeadDays?: InputMaybe<Scalars['Float']['input']>;
  neverExpireMembers?: InputMaybe<Scalars['Boolean']['input']>;
  overdueEmail?: InputMaybe<UpdateByIdOrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  overdueStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  pendingStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  proRateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  renewalGraceDays?: InputMaybe<Scalars['Float']['input']>;
  renewalReminderLeadDays?: InputMaybe<Scalars['Float']['input']>;
  renewalType?: InputMaybe<EnumOrganizationMetadataRenewalSettingsRenewalType>;
  sendCancelledEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendExpirationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendOverdueEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendRenewalEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendSuccessEmails?: InputMaybe<Scalars['Boolean']['input']>;
  successEmail?: InputMaybe<UpdateByIdOrganizationMetadataRenewalSettingsInstructionsEmailInput>;
  term?: InputMaybe<EnumOrganizationMetadataRenewalSettingsTerm>;
  termYears?: InputMaybe<Scalars['Float']['input']>;
  tierReminderEmails?: InputMaybe<Array<InputMaybe<UpdateByIdOrganizationMetadataRenewalSettingsTierReminderEmailsInput>>>;
};

export type UpdateByIdOrganizationMetadataRenewalSettingsInstructionsEmailInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdOrganizationMetadataRenewalSettingsTierReminderEmailsInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  hideRenewalDateLine?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tierTagId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdOrganizationOnboardingMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  allowColdSignup?: InputMaybe<Scalars['Boolean']['input']>;
  coldSignupTagId?: InputMaybe<Scalars['MongoID']['input']>;
  comingSoonMessage?: InputMaybe<Scalars['String']['input']>;
  introMessage?: InputMaybe<Scalars['String']['input']>;
  typeformSurveyId?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdOrganizationPayload = {
  __typename?: 'UpdateByIdOrganizationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Organization>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdOwnerInput = {
  entityId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumOwnerType>;
};

export type UpdateByIdPaymentMethodSetInput = {
  acceptedPaymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bankTransferInstructions?: InputMaybe<Scalars['String']['input']>;
  checkoutDescription?: InputMaybe<Scalars['String']['input']>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  methodLabels?: InputMaybe<UpdateByIdPaymentMethodSetMethodLabelsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  offlinePaymentInstructions?: InputMaybe<Scalars['String']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPaymentMethodSetMethodLabelsInput = {
  bank_transfer?: InputMaybe<Scalars['String']['input']>;
  card?: InputMaybe<Scalars['String']['input']>;
  direct_debit?: InputMaybe<Scalars['String']['input']>;
  offline_payment?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdPaymentMethodSetPayload = {
  __typename?: 'UpdateByIdPaymentMethodSetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PaymentMethodSet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPeopleInput = {
  address?: InputMaybe<UpdateByIdAddressInput>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  contactMethod?: InputMaybe<EnumPeopleContactMethod>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailLower?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  faxExt?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  import?: InputMaybe<Scalars['JSON']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leads?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  mailingAddress?: InputMaybe<UpdateByIdAddressInput>;
  optInEmail?: InputMaybe<Scalars['Boolean']['input']>;
  optInFax?: InputMaybe<Scalars['Boolean']['input']>;
  optInPhone?: InputMaybe<Scalars['Boolean']['input']>;
  optInSMS?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photoUploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  primaryTitle?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  visibleTo?: InputMaybe<Array<InputMaybe<UpdateByIdPeopleVisibleToInput>>>;
};

export type UpdateByIdPeopleVisibleToInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  entity?: InputMaybe<UpdateByIdOwnerInput>;
  ignoreLeadSystemRole?: InputMaybe<Scalars['Boolean']['input']>;
  latestActivity?: InputMaybe<Scalars['Date']['input']>;
  metadata?: InputMaybe<UpdateByIdPeopleVisibleToMetadataInput>;
  scratchpad?: InputMaybe<Scalars['String']['input']>;
  systemRoles?: InputMaybe<Array<InputMaybe<EnumPeopleVisibleToSystemRoles>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<EnumPeopleVisibleToTypes>>>;
  wasManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdPeopleVisibleToMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  operatorOverrides?: InputMaybe<Array<InputMaybe<UpdateByIdPeopleVisibleToMetadataOperatorOverridesInput>>>;
  phones?: InputMaybe<Array<InputMaybe<UpdateByIdPeopleVisibleToMetadataPhonesInput>>>;
};

export type UpdateByIdPeopleVisibleToMetadataOperatorOverridesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  operatorEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdPeopleVisibleToMetadataPhonesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumPeopleVisibleToMetadataPhonesType>;
};

export type UpdateByIdPlaceInput = {
  connectedDmoListing?: InputMaybe<Scalars['MongoID']['input']>;
  connectedListing?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  outline?: InputMaybe<UpdateByIdPlaceOutlineInput>;
  outlineSimplified?: InputMaybe<UpdateByIdPlaceOutlineInput>;
  parentPlace?: InputMaybe<Scalars['MongoID']['input']>;
  subPlaces?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumPlaceType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPlaceOutlineInput = {
  coordinates: Scalars['JSON']['input'];
  type: EnumPlaceOutlineType;
};

export type UpdateByIdPlacePayload = {
  __typename?: 'UpdateByIdPlacePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Place>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPolicyInput = {
  content?: InputMaybe<UpdateByIdMultilingualInput>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPolicyPayload = {
  __typename?: 'UpdateByIdPolicyPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Policy>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPriceTierInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountUnit?: InputMaybe<EnumPriceTierDiscountUnit>;
  guestCountForPrice?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<UpdateByIdMultilingualInput>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceType?: InputMaybe<EnumPriceTierPriceType>;
  type?: InputMaybe<EnumGuestTierType>;
};

export type UpdateByIdPricingInput = {
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  tiers?: InputMaybe<Array<InputMaybe<UpdateByIdPriceTierInput>>>;
};

export type UpdateByIdProductAddOnSettingsInput = {
  businessScope?: InputMaybe<EnumProductAddOnSettingsBusinessScope>;
  pricingScope?: InputMaybe<EnumProductAddOnSettingsPricingScope>;
};

export type UpdateByIdProductContactInput = {
  address?: InputMaybe<UpdateByIdAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tollFreePublicPhone?: InputMaybe<Scalars['String']['input']>;
  useOwnerContact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdProductCustomFieldsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  chargePerChoice?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  label?: InputMaybe<UpdateByIdMultilingualInput>;
  maxChoices?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateByIdProductCustomFieldsOptionsInput>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<EnumProductCustomFieldsType>;
};

export type UpdateByIdProductCustomFieldsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  label?: InputMaybe<UpdateByIdMultilingualInput>;
};

export type UpdateByIdProductEventMetadataInput = {
  event?: InputMaybe<Scalars['MongoID']['input']>;
  includedSessionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  maxTicketsPerPurchase?: InputMaybe<Scalars['Float']['input']>;
  sellingType?: InputMaybe<EnumProductEventMetadataSellingType>;
  sessionGranularity?: InputMaybe<EnumProductEventMetadataSessionGranularity>;
  ticketStructure?: InputMaybe<EnumProductEventMetadataTicketStructure>;
};

export type UpdateByIdProductInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  accommodationMetadata?: InputMaybe<UpdateByIdAccommodationProductMetadataInput>;
  addOnSettings?: InputMaybe<UpdateByIdProductAddOnSettingsInput>;
  contact?: InputMaybe<UpdateByIdProductContactInput>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<UpdateByIdProductCustomFieldsInput>>>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  eventMetadata?: InputMaybe<UpdateByIdProductEventMetadataInput>;
  externalBookingUrl?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inventorySettings?: InputMaybe<UpdateByIdProductTierInventoryInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isUpsellOnly?: InputMaybe<Scalars['Boolean']['input']>;
  merchMetadata?: InputMaybe<UpdateByIdMerchMetadataInput>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  pricing?: InputMaybe<UpdateByIdPricingInput>;
  productTiers?: InputMaybe<Array<InputMaybe<UpdateByIdProductTierInput>>>;
  publicationStatus?: InputMaybe<EnumProductPublicationStatus>;
  quantitySettings?: InputMaybe<UpdateByIdProductTierQuantityInput>;
  renewableFeeMetadata?: InputMaybe<UpdateByIdRenewableFeeMetadataInput>;
  rules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  sellingConfig?: InputMaybe<UpdateByIdProductSellingConfigInput>;
  shortDescription?: InputMaybe<UpdateByIdMultilingualInput>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumProductType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdProductPayload = {
  __typename?: 'UpdateByIdProductPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Product>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProductSellingConfigInput = {
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  dynamicFeeSurvey?: InputMaybe<Scalars['MongoID']['input']>;
  inventory?: InputMaybe<UpdateByIdProductTierInventoryInput>;
  mode?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateByIdProductTierInput>>>;
  quantity?: InputMaybe<UpdateByIdProductTierQuantityInput>;
  recurring?: InputMaybe<UpdateByIdProductSellingConfigRecurringInput>;
};

export type UpdateByIdProductSellingConfigRecurringInput = {
  billingIntervalMonths?: InputMaybe<Scalars['Float']['input']>;
  earlyPurchaseWindowDays?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fixedRenewalDay?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalMonth?: InputMaybe<Scalars['Float']['input']>;
  membershipLinked?: InputMaybe<Scalars['Boolean']['input']>;
  multiListing?: InputMaybe<UpdateByIdProductSellingConfigRecurringMultiListingInput>;
  proRateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  renewalType?: InputMaybe<EnumProductSellingConfigRecurringRenewalType>;
};

export type UpdateByIdProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<EnumProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountUnit>;
};

export type UpdateByIdProductSellingConfigRecurringMultiListingInput = {
  additionalBusinessDiscount?: InputMaybe<UpdateByIdProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountInput>;
  autoIncludeOwnedListings?: InputMaybe<Scalars['Boolean']['input']>;
  maxListings?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EnumProductSellingConfigRecurringMultiListingMode>;
};

export type UpdateByIdProductTierInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  autoTag?: InputMaybe<Scalars['MongoID']['input']>;
  condition?: InputMaybe<ProductTierConditionInput>;
  description?: InputMaybe<MultilingualInput>;
  includedSessionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inventory?: InputMaybe<ProductTierInventoryInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxSessions?: InputMaybe<Scalars['Float']['input']>;
  minSessions?: InputMaybe<Scalars['Float']['input']>;
  name: MultilingualInput;
  order: Scalars['Float']['input'];
  personTagConfig?: InputMaybe<ProductTierTagConfigInput>;
  price: Scalars['Float']['input'];
  quantity?: InputMaybe<ProductTierQuantityInput>;
  sessionScope?: InputMaybe<EnumProductTierSessionScope>;
  subCapacityPerSession?: InputMaybe<Scalars['Float']['input']>;
  tagConfig?: InputMaybe<ProductTierTagConfigInput>;
};

export type UpdateByIdProductTierInventoryInput = {
  currentCount: Scalars['Float']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  totalCount: Scalars['Float']['input'];
};

export type UpdateByIdProductTierQuantityInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxQuantity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdPromotionAccessInput = {
  disconnectedOrganizations?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  operator?: InputMaybe<UpdateByIdPromotionAccessOperatorInput>;
  organizations?: InputMaybe<Array<InputMaybe<UpdateByIdPromotionAccessOperatorInput>>>;
};

export type UpdateByIdPromotionAccessOperatorInput = {
  _entityId: Scalars['MongoID']['input'];
  status?: InputMaybe<EnumPromotionAccessOperatorStatus>;
};

export type UpdateByIdPromotionAvailabilityInput = {
  dates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumPromotionAvailabilityType>;
};

export type UpdateByIdPromotionHistoryInput = {
  action?: InputMaybe<EnumPromotionHistoryAction>;
  note?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  sourceType?: InputMaybe<EnumPromotionHistorySourceType>;
  timestamp?: InputMaybe<Scalars['Date']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdPromotionInput = {
  access?: InputMaybe<UpdateByIdPromotionAccessInput>;
  availability?: InputMaybe<UpdateByIdPromotionAvailabilityInput>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  createdByFirstName?: InputMaybe<Scalars['String']['input']>;
  createdByLastName?: InputMaybe<Scalars['String']['input']>;
  createdByPerson?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  firstDate?: InputMaybe<Scalars['String']['input']>;
  history?: InputMaybe<Array<InputMaybe<UpdateByIdPromotionHistoryInput>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastDate?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  /** Who created the promotion (OPERATOR/ORGANIZATION), derived server-side at create time. */
  submissionSource?: InputMaybe<EnumPromotionSubmissionSource>;
  tags?: InputMaybe<UpdateByIdPromotionTagsInput>;
  title?: InputMaybe<UpdateByIdMultilingualInput>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPromotionPayload = {
  __typename?: 'UpdateByIdPromotionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Promotion>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPromotionTagsInput = {
  global?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  organizationSpecific?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdRefundInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  processorChargeId?: InputMaybe<Scalars['String']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumRefundStatus>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdRefundPayload = {
  __typename?: 'UpdateByIdRefundPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Refund>;
  /** Document ID */
  recordId?: Maybe<Scalars['String']['output']>;
};

export type UpdateByIdRenewableFeeMetadataInput = {
  billingIntervalMonths?: InputMaybe<Scalars['Float']['input']>;
  earlyPurchaseWindowDays?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalDay?: InputMaybe<Scalars['Float']['input']>;
  fixedRenewalMonth?: InputMaybe<Scalars['Float']['input']>;
  membershipLinked?: InputMaybe<Scalars['Boolean']['input']>;
  proRateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  renewalType?: InputMaybe<EnumRenewableFeeMetadataRenewalType>;
};

export type UpdateByIdRestaurantOperatorMetadataInput = {
  seatingCapacity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdRoomInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amenities?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  type?: InputMaybe<EnumRoomType>;
};

export type UpdateByIdRuleInput = {
  activePeriod?: InputMaybe<UpdateByIdDateRangeIsoInput>;
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  storefront?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumRuleType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdRulePayload = {
  __typename?: 'UpdateByIdRulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Rule>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSeasonalityInput = {
  apr?: InputMaybe<SeasonalityEnum>;
  aug?: InputMaybe<SeasonalityEnum>;
  dec?: InputMaybe<SeasonalityEnum>;
  feb?: InputMaybe<SeasonalityEnum>;
  jan?: InputMaybe<SeasonalityEnum>;
  jul?: InputMaybe<SeasonalityEnum>;
  jun?: InputMaybe<SeasonalityEnum>;
  mar?: InputMaybe<SeasonalityEnum>;
  may?: InputMaybe<SeasonalityEnum>;
  nov?: InputMaybe<SeasonalityEnum>;
  oct?: InputMaybe<SeasonalityEnum>;
  sep?: InputMaybe<SeasonalityEnum>;
};

export type UpdateByIdSecurityDepositSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  placeHoldDaysBeforeCheckOut?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateType?: InputMaybe<EnumSecurityDepositSettingsRateType>;
};

export type UpdateByIdServiceOperatorMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdStorefrontApplicationFeeDefaultsInput = {
  membership?: InputMaybe<Scalars['Float']['input']>;
  merch?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdStorefrontEmailBrandingInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  footerText?: InputMaybe<UpdateByIdMultilingualInput>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  showContact?: InputMaybe<Scalars['Boolean']['input']>;
  useOrganizationEmailSettings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdStorefrontEnabledFeeTypesInput = {
  accommodations?: InputMaybe<Scalars['Boolean']['input']>;
  events?: InputMaybe<Scalars['Boolean']['input']>;
  merch?: InputMaybe<Scalars['Boolean']['input']>;
  oneTimeFee?: InputMaybe<Scalars['Boolean']['input']>;
  renewableFees?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdStorefrontInput = {
  accountingCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  applicationFeeDefaults?: InputMaybe<UpdateByIdStorefrontApplicationFeeDefaultsInput>;
  applicationPercentage?: InputMaybe<Scalars['Float']['input']>;
  connectedAccountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  connectedListings?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  connectedListingsConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  customProductNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultInvoicePolicy?: InputMaybe<Scalars['MongoID']['input']>;
  defaultWidgetLogo?: InputMaybe<Scalars['String']['input']>;
  emailBranding?: InputMaybe<UpdateByIdStorefrontEmailBrandingInput>;
  enabledFeeTypes?: InputMaybe<UpdateByIdStorefrontEnabledFeeTypesInput>;
  invoiceTemplateBooker?: InputMaybe<Scalars['MongoID']['input']>;
  invoicingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastLowStockDigestKey?: InputMaybe<Scalars['String']['input']>;
  launchedAt?: InputMaybe<Scalars['Date']['input']>;
  liveStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  lowStockDigestEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  organization?: InputMaybe<Scalars['MongoID']['input']>;
  paymentsMode?: InputMaybe<EnumStorefrontPaymentsMode>;
  siteMetadata?: InputMaybe<UpdateByIdStorefrontSiteMetadataInput>;
  statementSettings?: InputMaybe<UpdateByIdStorefrontStatementSettingsInput>;
  stripeRegion?: InputMaybe<EnumStorefrontStripeRegion>;
  testMode?: InputMaybe<Scalars['Boolean']['input']>;
  testStorefront?: InputMaybe<Scalars['MongoID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdStorefrontPayload = {
  __typename?: 'UpdateByIdStorefrontPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Storefront>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdStorefrontSiteMetadataInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  bookers?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdStorefrontStatementSettingsInput = {
  dayOfMonth?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdSurveyInput = {
  copiedFrom?: InputMaybe<Scalars['MongoID']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  questions?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdSurveyPayload = {
  __typename?: 'UpdateByIdSurveyPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Survey>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdSurveyQuestionInput = {
  businessScope?: InputMaybe<EnumSurveyQuestionBusinessScope>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  options?: InputMaybe<Array<InputMaybe<UpdateByIdSurveyQuestionOptionsInput>>>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  parentQuestion?: InputMaybe<Scalars['MongoID']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<EnumSurveyQuestionType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  whereaboutsSearchEntityType?: InputMaybe<EnumSurveyQuestionWhereaboutsSearchEntityType>;
};

export type UpdateByIdSurveyQuestionOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<UpdateByIdMultilingualInput>;
};

export type UpdateByIdSurveyQuestionPayload = {
  __typename?: 'UpdateByIdSurveyQuestionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<SurveyQuestion>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTagInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  embedding?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  engineOwnedRole?: InputMaybe<EnumTagEngineOwnedRole>;
  entityTypes?: InputMaybe<Array<InputMaybe<EnumTagEntityTypes>>>;
  inheritable?: InputMaybe<Scalars['Boolean']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  tagGroup?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  usage?: InputMaybe<UpdateByIdTagUsageInput>;
};

export type UpdateByIdTagPayload = {
  __typename?: 'UpdateByIdTagPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Tag>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTagRelationshipInput = {
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  generatedBy?: InputMaybe<EnumTagRelationshipGeneratedBy>;
  sourceTag?: InputMaybe<Scalars['MongoID']['input']>;
  targetTag?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumTagRelationshipType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTagRelationshipPayload = {
  __typename?: 'UpdateByIdTagRelationshipPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TagRelationship>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTagSuggestionAiResponseInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  action?: InputMaybe<EnumTagSuggestionAiResponseAction>;
  alternativeSuggestions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  similarTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTagSuggestionInput = {
  aiResponse?: InputMaybe<UpdateByIdTagSuggestionAiResponseInput>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  entityTypes?: InputMaybe<Array<InputMaybe<EnumTagSuggestionEntityTypes>>>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  tagGroup?: InputMaybe<Scalars['MongoID']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdTagSuggestionPayload = {
  __typename?: 'UpdateByIdTagSuggestionPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<TagSuggestion>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTagUsageInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  events?: InputMaybe<Scalars['Float']['input']>;
  operators?: InputMaybe<Scalars['Float']['input']>;
  people?: InputMaybe<Scalars['Float']['input']>;
  products?: InputMaybe<Scalars['Float']['input']>;
  promotions?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTaxComponentsInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdTaxInput = {
  components?: InputMaybe<Array<InputMaybe<UpdateByIdTaxComponentsInput>>>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  subdivision?: InputMaybe<Scalars['String']['input']>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdTaxPayload = {
  __typename?: 'UpdateByIdTaxPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Tax>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdToursOperatorMetadataInput = {
  maxGroupSize?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdUserAccessInput = {
  operators?: InputMaybe<Array<InputMaybe<UpdateByIdUserAccessOperatorsInput>>>;
  organizations?: InputMaybe<Array<InputMaybe<UpdateByIdUserAccessOperatorsInput>>>;
  storefronts?: InputMaybe<Array<InputMaybe<UpdateByIdUserAccessOperatorsInput>>>;
};

export type UpdateByIdUserAccessOperatorsInput = {
  contactRoles?: InputMaybe<Array<InputMaybe<EnumUserAccessOperatorsContactRoles>>>;
  entityId: Scalars['MongoID']['input'];
  role: EnumUserAccessOperatorsRole;
  status: EnumUserAccessOperatorsStatus;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdUserConfirmationCodesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  sentToEmail?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumUserConfirmationCodesType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdUserEmailPreferencesInput = {
  entity?: InputMaybe<UpdateByIdEntityReferenceInput>;
  frequency?: InputMaybe<EnumUserEmailPreferencesFrequency>;
  templateName?: InputMaybe<EnumUserEmailPreferencesTemplateName>;
};

export type UpdateByIdUserInput = {
  access?: InputMaybe<UpdateByIdUserAccessInput>;
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  confirmationCodes?: InputMaybe<Array<InputMaybe<UpdateByIdUserConfirmationCodesInput>>>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailPreferences?: InputMaybe<Array<InputMaybe<UpdateByIdUserEmailPreferencesInput>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastViewedListId?: InputMaybe<Scalars['String']['input']>;
  onboardingMetadata?: InputMaybe<UpdateByIdUserOnboardingMetadataInput>;
  photo?: InputMaybe<Scalars['String']['input']>;
  photoUploadedBy?: InputMaybe<Scalars['MongoID']['input']>;
  quickLinks?: InputMaybe<Array<InputMaybe<UpdateByIdUserQuickLinksInput>>>;
  quickLinksVersion?: InputMaybe<Scalars['Float']['input']>;
  resolvedBroadcasts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  signupToken?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatus>;
  systemPermissions?: InputMaybe<Array<InputMaybe<EnumUserSystemPermissions>>>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  userType?: InputMaybe<EnumUserUserType>;
};

export type UpdateByIdUserOnboardingMetadataInput = {
  isPostOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingBroadcast?: InputMaybe<Scalars['MongoID']['input']>;
  onboardingOrganization?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdUserQuickLinksInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  lastVisited?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumUserQuickLinksType>;
};

export type UpdateByIdVersionedEntityReferenceInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumVersionedEntityReferenceType>;
};

export type UpdateByIdWidgetEventSettingsInput = {
  displayType?: InputMaybe<EnumWidgetEventSettingsDisplayType>;
  eventTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  hiddenPublicFilterTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  hideCancelledEvents?: InputMaybe<Scalars['Boolean']['input']>;
  lookAheadMonths?: InputMaybe<Scalars['Float']['input']>;
  publicFilterMode?: InputMaybe<EnumWidgetEventSettingsPublicFilterMode>;
  publicFilterSort?: InputMaybe<EnumWidgetEventSettingsPublicFilterSort>;
  shownPublicFilterTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  startMonth?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdWidgetGallerySettingsInfiniteScrollInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  listingFilters?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  mediaTagFilters?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdWidgetGallerySettingsInput = {
  allMedia?: InputMaybe<Scalars['Boolean']['input']>;
  enableUrlPush?: InputMaybe<Scalars['Boolean']['input']>;
  infiniteScroll?: InputMaybe<UpdateByIdWidgetGallerySettingsInfiniteScrollInput>;
  items?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  playerPagePath?: InputMaybe<Scalars['String']['input']>;
  profilePageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdWidgetInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  eventSettings?: InputMaybe<UpdateByIdWidgetEventSettingsInput>;
  favorited?: InputMaybe<Scalars['Boolean']['input']>;
  gallerySettings?: InputMaybe<UpdateByIdWidgetGallerySettingsInput>;
  inquirySettings?: InputMaybe<UpdateByIdWidgetInquirySettingsInput>;
  list?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<UpdateByIdMultilingualInput>;
  operatorSettings?: InputMaybe<UpdateByIdWidgetOperatorSettingsInput>;
  owner?: InputMaybe<UpdateByIdOwnerInput>;
  promotionSettings?: InputMaybe<UpdateByIdWidgetPromotionSettingsInput>;
  type?: InputMaybe<EnumWidgetType>;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdWidgetInquirySettingsInput = {
  buttonLabel?: InputMaybe<UpdateByIdMultilingualInput>;
  completionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  notificationRecipients?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  preventMultipleSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  submissionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  survey?: InputMaybe<Scalars['String']['input']>;
  thankYouMessage?: InputMaybe<UpdateByIdMultilingualInput>;
};

export type UpdateByIdWidgetOperatorSettingsEntityOverridesInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<UpdateByIdMultilingualInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription?: InputMaybe<UpdateByIdMultilingualInput>;
};

export type UpdateByIdWidgetOperatorSettingsInput = {
  allowAdditionalFilters?: InputMaybe<Scalars['Boolean']['input']>;
  allowMapView?: InputMaybe<Scalars['Boolean']['input']>;
  disableOperatorWidgetFilter?: InputMaybe<Scalars['Boolean']['input']>;
  disableTieredSort?: InputMaybe<Scalars['Boolean']['input']>;
  entityOverrides?: InputMaybe<Array<InputMaybe<UpdateByIdWidgetOperatorSettingsEntityOverridesInput>>>;
  filterableTagGroups?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  filterableTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  hideFiltersInMapView?: InputMaybe<Scalars['Boolean']['input']>;
  hidePermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  hideTemporarilyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  listDisplayMode?: InputMaybe<EnumWidgetOperatorSettingsListDisplayMode>;
  orderedFilters?: InputMaybe<Array<InputMaybe<UpdateByIdWidgetOperatorSettingsOrderedFiltersInput>>>;
  showEvents?: InputMaybe<Scalars['Boolean']['input']>;
  showOnlyMap?: InputMaybe<Scalars['Boolean']['input']>;
  showPermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  showPromotions?: InputMaybe<Scalars['Boolean']['input']>;
  sortStrategy?: InputMaybe<EnumWidgetOperatorSettingsSortStrategy>;
  tieredSortOrder?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateByIdWidgetOperatorSettingsOrderedFiltersInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  isTagGroup?: InputMaybe<Scalars['Boolean']['input']>;
  labelOverride?: InputMaybe<UpdateByIdMultilingualInput>;
};

export type UpdateByIdWidgetPayload = {
  __typename?: 'UpdateByIdWidgetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Widget>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdWidgetPromotionSettingsInput = {
  displayType?: InputMaybe<EnumWidgetPromotionSettingsDisplayType>;
  hiddenPublicFilterTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  hidePublicFilters?: InputMaybe<Scalars['Boolean']['input']>;
  promotionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type UpdateRollbackSnapshot = {
  __typename?: 'UpdateRollbackSnapshot';
  entityId: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  newValue?: Maybe<Scalars['JSON']['output']>;
  originalValue?: Maybe<Scalars['JSON']['output']>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['MongoID']['output'];
  access: UserAccess;
  auth0Id?: Maybe<Scalars['String']['output']>;
  confirmationCodes: Array<Maybe<UserConfirmationCodes>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  emailPreferences: Array<Maybe<UserEmailPreferences>>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  lastViewedListId?: Maybe<Scalars['String']['output']>;
  onboardingMetadata?: Maybe<UserOnboardingMetadata>;
  photo?: Maybe<AssetImage>;
  photoUploadedBy?: Maybe<Scalars['MongoID']['output']>;
  quickLinks: Array<Maybe<UserQuickLinks>>;
  quickLinksVersion: Scalars['Float']['output'];
  resolvedBroadcasts: Array<Maybe<Scalars['MongoID']['output']>>;
  signupToken?: Maybe<Scalars['String']['output']>;
  status: EnumUserStatus;
  systemPermissions: Array<Maybe<EnumUserSystemPermissions>>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  userType: EnumUserUserType;
};

export type UserAccess = {
  __typename?: 'UserAccess';
  operators: Array<Maybe<UserAccessOperators>>;
  organizations: Array<Maybe<UserAccessOperators>>;
  storefronts: Array<Maybe<UserAccessOperators>>;
};

export type UserAccessInput = {
  operators: Array<InputMaybe<UserAccessOperatorsInput>>;
  organizations: Array<InputMaybe<UserAccessOperatorsInput>>;
  storefronts: Array<InputMaybe<UserAccessOperatorsInput>>;
};

export type UserAccessOperators = {
  __typename?: 'UserAccessOperators';
  contactRoles?: Maybe<Array<Maybe<EnumUserAccessOperatorsContactRoles>>>;
  entityId: Scalars['MongoID']['output'];
  role: EnumUserAccessOperatorsRole;
  status: EnumUserAccessOperatorsStatus;
  title?: Maybe<Scalars['String']['output']>;
};

export type UserAccessOperatorsInput = {
  contactRoles?: InputMaybe<Array<InputMaybe<EnumUserAccessOperatorsContactRoles>>>;
  entityId: Scalars['MongoID']['input'];
  role: EnumUserAccessOperatorsRole;
  status: EnumUserAccessOperatorsStatus;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UserConfirmationCodes = {
  __typename?: 'UserConfirmationCodes';
  _id?: Maybe<Scalars['MongoID']['output']>;
  code: Scalars['String']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  sentToEmail: Scalars['String']['output'];
  type: EnumUserConfirmationCodesType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  validated: Scalars['Boolean']['output'];
};

export type UserConfirmationCodesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  code: Scalars['String']['input'];
  createdDateISO?: InputMaybe<Scalars['Date']['input']>;
  sentToEmail: Scalars['String']['input'];
  type: EnumUserConfirmationCodesType;
  updatedDateISO?: InputMaybe<Scalars['Date']['input']>;
  validated: Scalars['Boolean']['input'];
};

export type UserEmailPreferences = {
  __typename?: 'UserEmailPreferences';
  entity?: Maybe<EntityReference>;
  frequency: EnumUserEmailPreferencesFrequency;
  templateName: EnumUserEmailPreferencesTemplateName;
};

export type UserEmailPreferencesInput = {
  entity?: InputMaybe<EntityReferenceInput>;
  frequency: EnumUserEmailPreferencesFrequency;
  templateName: EnumUserEmailPreferencesTemplateName;
};

export type UserMembershipRow = {
  __typename?: 'UserMembershipRow';
  _id: Scalars['MongoID']['output'];
  listingName?: Maybe<Scalars['String']['output']>;
  memberNomenclature: Scalars['String']['output'];
  membershipNomenclature: Scalars['String']['output'];
  needsRenewal: Scalars['Boolean']['output'];
  organizationId: Scalars['MongoID']['output'];
  organizationLogo?: Maybe<Scalars['MongoID']['output']>;
  organizationName: Scalars['String']['output'];
  renewablePurchaseId?: Maybe<Scalars['MongoID']['output']>;
  renewalBilling?: Maybe<Scalars['String']['output']>;
  renewalDate?: Maybe<Scalars['Date']['output']>;
  renewalDateDisplayMode: Scalars['String']['output'];
  status: Scalars['String']['output'];
  statusTagNames: Array<Scalars['String']['output']>;
  subjectEntityId: Scalars['MongoID']['output'];
  subjectType: Scalars['String']['output'];
  tierName?: Maybe<Scalars['String']['output']>;
  tierTagId?: Maybe<Scalars['MongoID']['output']>;
};

export type UserOnboardingMetadata = {
  __typename?: 'UserOnboardingMetadata';
  isPostOnboarding?: Maybe<Scalars['Boolean']['output']>;
  onboardingBroadcast?: Maybe<Scalars['MongoID']['output']>;
  onboardingOrganization?: Maybe<Scalars['MongoID']['output']>;
};

export type UserOnboardingMetadataInput = {
  isPostOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingBroadcast?: InputMaybe<Scalars['MongoID']['input']>;
  onboardingOrganization?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UserQuickLinks = {
  __typename?: 'UserQuickLinks';
  entityId: Scalars['String']['output'];
  lastVisited: Scalars['String']['output'];
  link: Scalars['String']['output'];
  pinned?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  type: EnumUserQuickLinksType;
};

export type UserQuickLinksInput = {
  entityId: Scalars['String']['input'];
  lastVisited: Scalars['String']['input'];
  link: Scalars['String']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: EnumUserQuickLinksType;
};

export type UserSummaryByEmail = {
  __typename?: 'UserSummaryByEmail';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastActivityDateISO?: Maybe<Scalars['Date']['output']>;
  lastName: Scalars['String']['output'];
  listings: Array<UserSummaryListing>;
  organizations: Array<UserSummaryOrganizationStaff>;
};

export type UserSummaryConnectedOrganization = {
  __typename?: 'UserSummaryConnectedOrganization';
  displayName: Scalars['String']['output'];
  entityId: Scalars['MongoID']['output'];
  name?: Maybe<Multilingual>;
  permalink: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
};

export type UserSummaryListing = {
  __typename?: 'UserSummaryListing';
  displayName: Scalars['String']['output'];
  entityId: Scalars['MongoID']['output'];
  name?: Maybe<Multilingual>;
  organizations: Array<UserSummaryConnectedOrganization>;
  permalink: Scalars['String']['output'];
  role: EnumUserAccessOperatorsRole;
  status: EnumUserAccessOperatorsStatus;
};

export type UserSummaryOrganizationStaff = {
  __typename?: 'UserSummaryOrganizationStaff';
  displayName: Scalars['String']['output'];
  entityId: Scalars['MongoID']['output'];
  name?: Maybe<Multilingual>;
  permalink: Scalars['String']['output'];
  role: EnumUserAccessOperatorsRole;
  shortName?: Maybe<Scalars['String']['output']>;
  status: EnumUserAccessOperatorsStatus;
};

export type UserUnpaidPaymentRequestRow = {
  __typename?: 'UserUnpaidPaymentRequestRow';
  _id: Scalars['MongoID']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  currency: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['String']['output']>;
  grandTotal: Scalars['Float']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  productTitle?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  renewablePurchaseId?: Maybe<Scalars['MongoID']['output']>;
  sentAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type UserWithPictureTc = {
  __typename?: 'UserWithPictureTC';
  _id: Scalars['MongoID']['output'];
  access: UserAccess;
  auth0Id?: Maybe<Scalars['String']['output']>;
  confirmationCodes: Array<Maybe<UserConfirmationCodes>>;
  contactRoles?: Maybe<Array<Maybe<ContactRole>>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  emailPreferences: Array<Maybe<UserEmailPreferences>>;
  firstName: Scalars['String']['output'];
  hasPurchases: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  lastViewedListId?: Maybe<Scalars['String']['output']>;
  memberships: Array<UserMembershipRow>;
  onboardingMetadata?: Maybe<UserOnboardingMetadata>;
  personId?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<AssetImage>;
  photoUploadedBy?: Maybe<Scalars['MongoID']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  quickLinks: Array<Maybe<UserQuickLinks>>;
  quickLinksVersion: Scalars['Float']['output'];
  resolvedBroadcasts: Array<Maybe<Scalars['MongoID']['output']>>;
  signupToken?: Maybe<Scalars['String']['output']>;
  status: EnumUserStatus;
  systemPermissions: Array<Maybe<EnumUserSystemPermissions>>;
  title?: Maybe<Scalars['String']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  userType: EnumUserUserType;
};

export type UserWithResetPasswordUrlTc = {
  __typename?: 'UserWithResetPasswordUrlTC';
  _id: Scalars['MongoID']['output'];
  access: UserAccess;
  auth0Id?: Maybe<Scalars['String']['output']>;
  confirmationCodes: Array<Maybe<UserConfirmationCodes>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  emailPreferences: Array<Maybe<UserEmailPreferences>>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  lastViewedListId?: Maybe<Scalars['String']['output']>;
  onboardingMetadata?: Maybe<UserOnboardingMetadata>;
  passwordResetUrl?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<AssetImage>;
  photoUploadedBy?: Maybe<Scalars['MongoID']['output']>;
  quickLinks: Array<Maybe<UserQuickLinks>>;
  quickLinksVersion: Scalars['Float']['output'];
  resolvedBroadcasts: Array<Maybe<Scalars['MongoID']['output']>>;
  signupToken?: Maybe<Scalars['String']['output']>;
  status: EnumUserStatus;
  systemPermissions: Array<Maybe<EnumUserSystemPermissions>>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  userType: EnumUserUserType;
};

export type ValidationError = ErrorInterface & {
  __typename?: 'ValidationError';
  /** List of validator errors */
  errors?: Maybe<Array<ValidatorError>>;
  /** Combined error message from all validators */
  message?: Maybe<Scalars['String']['output']>;
};

export type ValidatorError = {
  __typename?: 'ValidatorError';
  /** Input record idx in array which occurs the validation error. This `idx` is useful for createMany operation. For singular operations it always be 0. For *Many operations `idx` represents record index in array received from user. */
  idx: Scalars['Int']['output'];
  /** Validation error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Source of the validation error from the model path */
  path?: Maybe<Scalars['String']['output']>;
  /** Field value which occurs the validation error */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type VersionedEntityReference = {
  __typename?: 'VersionedEntityReference';
  _entityId: Scalars['MongoID']['output'];
  _versionId: Scalars['MongoID']['output'];
  type: EnumVersionedEntityReferenceType;
};

export type VersionedEntityReferenceInput = {
  _entityId?: InputMaybe<Scalars['MongoID']['input']>;
  _versionId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumVersionedEntityReferenceType>;
};

export type VersionedEntityReferenceWithName = {
  __typename?: 'VersionedEntityReferenceWithName';
  _entityId: Scalars['MongoID']['output'];
  _versionId: Scalars['MongoID']['output'];
  name?: Maybe<Multilingual>;
  type: EnumVersionedEntityReferenceType;
};

export type WhereabotChat = {
  __typename?: 'WhereabotChat';
  _id: Scalars['MongoID']['output'];
  chatModel: Scalars['String']['output'];
  createdBy?: Maybe<UserWithPictureTc>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  featureFlagKey?: Maybe<Scalars['String']['output']>;
  kind: EnumWhereabotChatKind;
  notes?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewCompletedAt?: Maybe<Scalars['Date']['output']>;
  reviewSummary?: Maybe<Scalars['String']['output']>;
  status: EnumWhereabotChatStatus;
  systemPrompt: Scalars['String']['output'];
  testOrganizationId?: Maybe<Scalars['MongoID']['output']>;
  title: Scalars['String']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type WhereabotHelpAnswer = {
  __typename?: 'WhereabotHelpAnswer';
  answer: Scalars['String']['output'];
};

export type WhereabotHelpMessageInput = {
  content: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type WhereabotMessage = {
  __typename?: 'WhereabotMessage';
  _id: Scalars['MongoID']['output'];
  chat: Scalars['MongoID']['output'];
  content: Scalars['String']['output'];
  contextFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  isError: Scalars['Boolean']['output'];
  metadata?: Maybe<WhereabotMessageMetadata>;
  operatorResults?: Maybe<Array<Maybe<WhereabotMessageOperatorResults>>>;
  role: EnumWhereabotMessageRole;
  sessionEvents?: Maybe<Array<Maybe<WhereabotMessageSessionEvents>>>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
  workbenchSuggestions: Array<WorkbenchSuggestion>;
};

export type WhereabotMessageMetadata = {
  __typename?: 'WhereabotMessageMetadata';
  embeddingTimeMs?: Maybe<Scalars['Float']['output']>;
  llmTimeMs?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  operatorsSearched?: Maybe<Scalars['Float']['output']>;
  searchTimeMs?: Maybe<Scalars['Float']['output']>;
  totalTimeMs?: Maybe<Scalars['Float']['output']>;
};

export type WhereabotMessageOperatorResults = {
  __typename?: 'WhereabotMessageOperatorResults';
  isRelated?: Maybe<Scalars['Boolean']['output']>;
  operatorEntityId: Scalars['String']['output'];
  operatorName: Scalars['String']['output'];
  operatorType: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
};

export type WhereabotMessageSessionEvents = {
  __typename?: 'WhereabotMessageSessionEvents';
  at: Scalars['Date']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  flagKey?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  operationName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  type: EnumWhereabotMessageSessionEventsType;
};

export type WhereabotPromptHistoryItem = {
  __typename?: 'WhereabotPromptHistoryItem';
  chatCount?: Maybe<Scalars['Int']['output']>;
  lastUsed?: Maybe<Scalars['Date']['output']>;
  prompt: Scalars['String']['output'];
};

export type WhereabotSettings = {
  __typename?: 'WhereabotSettings';
  _id: Scalars['MongoID']['output'];
  chatModel: Scalars['String']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  platformDocument?: Maybe<Scalars['String']['output']>;
  platformDocumentBuiltAt?: Maybe<Scalars['Date']['output']>;
  systemPrompt?: Maybe<Scalars['String']['output']>;
  updatedBy: Scalars['MongoID']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type WhereabotSettingsWithDefault = {
  __typename?: 'WhereabotSettingsWithDefault';
  _id?: Maybe<Scalars['MongoID']['output']>;
  chatModel?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  defaultSystemPrompt: Scalars['String']['output'];
  platformDocument?: Maybe<Scalars['String']['output']>;
  platformDocumentBuiltAt?: Maybe<Scalars['Date']['output']>;
  systemPrompt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['MongoID']['output']>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type Widget = {
  __typename?: 'Widget';
  _id: Scalars['MongoID']['output'];
  archived: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  eventSettings?: Maybe<WidgetEventSettings>;
  favorited: Scalars['Boolean']['output'];
  gallerySettings?: Maybe<WidgetGallerySettings>;
  inquirySettings?: Maybe<WidgetInquirySettings>;
  list: ListWithEntities;
  listId?: Maybe<Scalars['MongoID']['output']>;
  name: Multilingual;
  operatorSettings?: Maybe<WidgetOperatorSettings>;
  owner: Owner;
  promotionSettings?: Maybe<WidgetPromotionSettings>;
  type: EnumWidgetType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type WidgetEmbedActivity = {
  __typename?: 'WidgetEmbedActivity';
  _id: Scalars['MongoID']['output'];
  firstViewedAt: Scalars['Date']['output'];
  hostname: Scalars['String']['output'];
  lastViewedAt: Scalars['Date']['output'];
  organization?: Maybe<WidgetEmbedActivityOrganization>;
  url: Scalars['String']['output'];
  viewCount: Scalars['Int']['output'];
  widget?: Maybe<WidgetEmbedActivityWidget>;
};

export type WidgetEmbedActivityOrganization = {
  __typename?: 'WidgetEmbedActivityOrganization';
  _id: Scalars['MongoID']['output'];
  name: Scalars['String']['output'];
};

export type WidgetEmbedActivityWidget = {
  __typename?: 'WidgetEmbedActivityWidget';
  _id: Scalars['MongoID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type WidgetEventSettings = {
  __typename?: 'WidgetEventSettings';
  displayType: EnumWidgetEventSettingsDisplayType;
  eventTags: Array<Maybe<Scalars['MongoID']['output']>>;
  hiddenPublicFilterTags?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  hideCancelledEvents?: Maybe<Scalars['Boolean']['output']>;
  lookAheadMonths?: Maybe<Scalars['Float']['output']>;
  publicFilterMode?: Maybe<EnumWidgetEventSettingsPublicFilterMode>;
  publicFilterSort?: Maybe<EnumWidgetEventSettingsPublicFilterSort>;
  shownPublicFilterTags?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  startMonth?: Maybe<Scalars['String']['output']>;
};

export type WidgetEventSettingsInput = {
  displayType: EnumWidgetEventSettingsDisplayType;
  eventTags: Array<InputMaybe<Scalars['MongoID']['input']>>;
  hiddenPublicFilterTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  hideCancelledEvents?: InputMaybe<Scalars['Boolean']['input']>;
  lookAheadMonths?: InputMaybe<Scalars['Float']['input']>;
  publicFilterMode?: InputMaybe<EnumWidgetEventSettingsPublicFilterMode>;
  publicFilterSort?: InputMaybe<EnumWidgetEventSettingsPublicFilterSort>;
  shownPublicFilterTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  startMonth?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetGallerySettings = {
  __typename?: 'WidgetGallerySettings';
  allMedia?: Maybe<Scalars['Boolean']['output']>;
  enableUrlPush?: Maybe<Scalars['Boolean']['output']>;
  infiniteScroll?: Maybe<WidgetGallerySettingsInfiniteScroll>;
  items?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  playerPagePath?: Maybe<Scalars['String']['output']>;
  profilePageEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type WidgetGallerySettingsInfiniteScroll = {
  __typename?: 'WidgetGallerySettingsInfiniteScroll';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  listingFilters?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  mediaTagFilters?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type WidgetGallerySettingsInfiniteScrollInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  listingFilters?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  mediaTagFilters?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type WidgetGallerySettingsInput = {
  allMedia?: InputMaybe<Scalars['Boolean']['input']>;
  enableUrlPush?: InputMaybe<Scalars['Boolean']['input']>;
  infiniteScroll?: InputMaybe<WidgetGallerySettingsInfiniteScrollInput>;
  items?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  playerPagePath?: InputMaybe<Scalars['String']['input']>;
  profilePageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WidgetInquirySettings = {
  __typename?: 'WidgetInquirySettings';
  buttonLabel?: Maybe<Multilingual>;
  completionTags?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  description?: Maybe<Multilingual>;
  notificationRecipients?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  preventMultipleSubmissions?: Maybe<Scalars['Boolean']['output']>;
  submissionTags?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  survey: Scalars['String']['output'];
  thankYouMessage?: Maybe<Multilingual>;
};

export type WidgetInquirySettingsInput = {
  buttonLabel?: InputMaybe<MultilingualInput>;
  completionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  description?: InputMaybe<MultilingualInput>;
  notificationRecipients?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  preventMultipleSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  submissionTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  survey: Scalars['String']['input'];
  thankYouMessage?: InputMaybe<MultilingualInput>;
};

export type WidgetOperatorSettings = {
  __typename?: 'WidgetOperatorSettings';
  allowAdditionalFilters: Scalars['Boolean']['output'];
  allowMapView: Scalars['Boolean']['output'];
  disableOperatorWidgetFilter?: Maybe<Scalars['Boolean']['output']>;
  disableTieredSort?: Maybe<Scalars['Boolean']['output']>;
  filterableTagGroups: Array<TagGroup>;
  filterableTags: Array<Tag>;
  hideFiltersInMapView?: Maybe<Scalars['Boolean']['output']>;
  hidePermanentlyClosed?: Maybe<Scalars['Boolean']['output']>;
  hideTemporarilyClosed?: Maybe<Scalars['Boolean']['output']>;
  listDisplayMode?: Maybe<EnumWidgetOperatorSettingsListDisplayMode>;
  orderedFilters?: Maybe<Array<Maybe<WidgetOperatorSettingsOrderedFilters>>>;
  showEvents?: Maybe<Scalars['Boolean']['output']>;
  showOnlyMap?: Maybe<Scalars['Boolean']['output']>;
  showPermanentlyClosed?: Maybe<Scalars['Boolean']['output']>;
  showPromotions?: Maybe<Scalars['Boolean']['output']>;
  sortStrategy?: Maybe<EnumWidgetOperatorSettingsSortStrategy>;
  tieredSortOrder?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
};

export type WidgetOperatorSettingsEntityOverridesInput = {
  _entityId: Scalars['MongoID']['input'];
  description?: InputMaybe<MultilingualInput>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription?: InputMaybe<MultilingualInput>;
};

export type WidgetOperatorSettingsInput = {
  allowAdditionalFilters: Scalars['Boolean']['input'];
  allowMapView: Scalars['Boolean']['input'];
  disableOperatorWidgetFilter?: InputMaybe<Scalars['Boolean']['input']>;
  disableTieredSort?: InputMaybe<Scalars['Boolean']['input']>;
  entityOverrides?: InputMaybe<Array<InputMaybe<WidgetOperatorSettingsEntityOverridesInput>>>;
  filterableTagGroups: Array<InputMaybe<Scalars['MongoID']['input']>>;
  filterableTags: Array<InputMaybe<Scalars['MongoID']['input']>>;
  hideFiltersInMapView?: InputMaybe<Scalars['Boolean']['input']>;
  hidePermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  hideTemporarilyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  listDisplayMode?: InputMaybe<EnumWidgetOperatorSettingsListDisplayMode>;
  orderedFilters?: InputMaybe<Array<InputMaybe<WidgetOperatorSettingsOrderedFiltersInput>>>;
  showEvents?: InputMaybe<Scalars['Boolean']['input']>;
  showOnlyMap?: InputMaybe<Scalars['Boolean']['input']>;
  showPermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
  showPromotions?: InputMaybe<Scalars['Boolean']['input']>;
  sortStrategy?: InputMaybe<EnumWidgetOperatorSettingsSortStrategy>;
  tieredSortOrder?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type WidgetOperatorSettingsOrderedFilters = {
  __typename?: 'WidgetOperatorSettingsOrderedFilters';
  _id: Scalars['MongoID']['output'];
  additionalTagIds?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  isTagGroup: Scalars['Boolean']['output'];
  labelOverride?: Maybe<Multilingual>;
};

export type WidgetOperatorSettingsOrderedFiltersInput = {
  _id: Scalars['MongoID']['input'];
  additionalTagIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  isTagGroup: Scalars['Boolean']['input'];
  labelOverride?: InputMaybe<MultilingualInput>;
};

export type WidgetPromotionSettings = {
  __typename?: 'WidgetPromotionSettings';
  displayType: EnumWidgetPromotionSettingsDisplayType;
  hiddenPublicFilterTags?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  hidePublicFilters?: Maybe<Scalars['Boolean']['output']>;
  promotionTags: Array<Maybe<Scalars['MongoID']['output']>>;
};

export type WidgetPromotionSettingsInput = {
  displayType: EnumWidgetPromotionSettingsDisplayType;
  hiddenPublicFilterTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  hidePublicFilters?: InputMaybe<Scalars['Boolean']['input']>;
  promotionTags: Array<InputMaybe<Scalars['MongoID']['input']>>;
};

export type WidgetWithListAndItemCount = {
  __typename?: 'WidgetWithListAndItemCount';
  _id: Scalars['MongoID']['output'];
  archived: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  eventSettings?: Maybe<WidgetEventSettings>;
  favorited: Scalars['Boolean']['output'];
  gallerySettings?: Maybe<WidgetGallerySettings>;
  inquirySettings?: Maybe<WidgetInquirySettings>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  list?: Maybe<ListWithEntities>;
  name: Multilingual;
  operatorSettings?: Maybe<WidgetOperatorSettings>;
  owner: Owner;
  promotionSettings?: Maybe<WidgetPromotionSettings>;
  type: EnumWidgetType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type WidgetWithListEntities = {
  __typename?: 'WidgetWithListEntities';
  _id: Scalars['MongoID']['output'];
  archived: Scalars['Boolean']['output'];
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  description: Multilingual;
  eventSettings?: Maybe<WidgetEventSettings>;
  favorited: Scalars['Boolean']['output'];
  gallerySettings?: Maybe<WidgetGallerySettings>;
  inquirySettings?: Maybe<WidgetInquirySettings>;
  list: ListWithEntitiesAndOverrides;
  name: Multilingual;
  operatorSettings?: Maybe<WidgetOperatorSettings>;
  owner: Owner;
  promotionSettings?: Maybe<WidgetPromotionSettings>;
  type: EnumWidgetType;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type WorkbenchAdminGate = {
  __typename?: 'WorkbenchAdminGate';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  userId: Scalars['MongoID']['output'];
};

export type WorkbenchChangeRequestResult = {
  __typename?: 'WorkbenchChangeRequestResult';
  markdown?: Maybe<Scalars['String']['output']>;
  newSinceGenerated: Scalars['Int']['output'];
  openCount: Scalars['Int']['output'];
  openTesterCount: Scalars['Int']['output'];
  stale: Scalars['Boolean']['output'];
  summary?: Maybe<WorkbenchChangeRequestSummary>;
  target: Scalars['String']['output'];
};

export type WorkbenchChangeRequestStep = {
  __typename?: 'WorkbenchChangeRequestStep';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type WorkbenchChangeRequestSummary = {
  __typename?: 'WorkbenchChangeRequestSummary';
  generatedAt: Scalars['Date']['output'];
  integratedAt?: Maybe<Scalars['Date']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  overview: Scalars['String']['output'];
  suggestionCount: Scalars['Int']['output'];
  testerCount: Scalars['Int']['output'];
  themes: Array<WorkbenchChangeRequestTheme>;
};

export type WorkbenchChangeRequestTheme = {
  __typename?: 'WorkbenchChangeRequestTheme';
  conflicts?: Maybe<Scalars['String']['output']>;
  proposedSteps: Array<WorkbenchChangeRequestStep>;
  suggestionIds: Array<Scalars['MongoID']['output']>;
  summary: Scalars['String']['output'];
  testerCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type WorkbenchContactResult = {
  __typename?: 'WorkbenchContactResult';
  failed: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
};

export type WorkbenchFeature = {
  __typename?: 'WorkbenchFeature';
  _id: Scalars['MongoID']['output'];
  active: Scalars['Boolean']['output'];
  codePaths: Array<Maybe<Scalars['String']['output']>>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  docsAudience: EnumWorkbenchFeatureDocsAudience;
  docsContent?: Maybe<Scalars['String']['output']>;
  docsHash?: Maybe<Scalars['String']['output']>;
  docsPath: Scalars['String']['output'];
  docsSource?: Maybe<EnumWorkbenchFeatureDocsSource>;
  docsSyncStatus: EnumWorkbenchFeatureDocsSyncStatus;
  docsSyncedAt?: Maybe<Scalars['Date']['output']>;
  effectiveTestOrganizationId?: Maybe<Scalars['MongoID']['output']>;
  effectiveTestOrganizationName?: Maybe<Scalars['String']['output']>;
  entryPoints: Array<Maybe<WorkbenchFeatureEntryPoints>>;
  featureFlagKey: Scalars['String']['output'];
  flag?: Maybe<FeatureFlag>;
  harnessId?: Maybe<Scalars['String']['output']>;
  helpScoutArticleUrl?: Maybe<Scalars['String']['output']>;
  myActiveChatId?: Maybe<Scalars['MongoID']['output']>;
  planContent?: Maybe<Scalars['String']['output']>;
  planHash?: Maybe<Scalars['String']['output']>;
  planPath: Scalars['String']['output'];
  planSource?: Maybe<EnumWorkbenchFeaturePlanSource>;
  planSyncStatus: EnumWorkbenchFeaturePlanSyncStatus;
  planSyncedAt?: Maybe<Scalars['Date']['output']>;
  stats: WorkbenchFeatureStats;
  testOrganizationId?: Maybe<Scalars['MongoID']['output']>;
  testerUsers: Array<WorkbenchTesterInfo>;
  testers: Array<Maybe<WorkbenchFeatureTesters>>;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type WorkbenchFeatureCard = {
  __typename?: 'WorkbenchFeatureCard';
  assignedToMe: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  docsSyncStatus: Scalars['String']['output'];
  expelled: Scalars['Boolean']['output'];
  featureFlagId?: Maybe<Scalars['MongoID']['output']>;
  featureFlagKey: Scalars['String']['output'];
  graduated: Scalars['Boolean']['output'];
  group: Scalars['String']['output'];
  hasActiveSeedRun: Scalars['Boolean']['output'];
  lastActivityAt?: Maybe<Scalars['Date']['output']>;
  myActiveChatId?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  openFeedbackCount: Scalars['Int']['output'];
  pendingEditCount: Scalars['Int']['output'];
  planSyncStatus: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  testers: Array<WorkbenchTesterInfo>;
};

export type WorkbenchFeatureEntryPoints = {
  __typename?: 'WorkbenchFeatureEntryPoints';
  label: Scalars['String']['output'];
  route: Scalars['String']['output'];
};

export type WorkbenchFeatureStats = {
  __typename?: 'WorkbenchFeatureStats';
  acceptedEditCount: Scalars['Int']['output'];
  activeSeedRunCount: Scalars['Int']['output'];
  openFeedbackCount: Scalars['Int']['output'];
  pendingEditCount: Scalars['Int']['output'];
  reviewCount: Scalars['Int']['output'];
};

export type WorkbenchFeatureTesters = {
  __typename?: 'WorkbenchFeatureTesters';
  addedAt: Scalars['Date']['output'];
  addedBy?: Maybe<Scalars['MongoID']['output']>;
  invitedAt?: Maybe<Scalars['Date']['output']>;
  lastContactedAt?: Maybe<Scalars['Date']['output']>;
  user: Scalars['MongoID']['output'];
};

export type WorkbenchGateState = {
  __typename?: 'WorkbenchGateState';
  enabledOrganizationCount: Scalars['Int']['output'];
  expelled: Scalars['Boolean']['output'];
  featureFlagId: Scalars['MongoID']['output'];
  graduated: Scalars['Boolean']['output'];
  organizationEnabled?: Maybe<Scalars['Boolean']['output']>;
  scope: Scalars['String']['output'];
  testerAdminGates: Array<WorkbenchAdminGate>;
};

export type WorkbenchLifecycleResult = {
  __typename?: 'WorkbenchLifecycleResult';
  error?: Maybe<Scalars['String']['output']>;
  seedRunsCleaned?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type WorkbenchModelTier = {
  __typename?: 'WorkbenchModelTier';
  fallbacks: Array<Scalars['String']['output']>;
  primary: Scalars['String']['output'];
};

export type WorkbenchModelTierInput = {
  fallbacks?: InputMaybe<Array<Scalars['String']['input']>>;
  primary: Scalars['String']['input'];
};

export type WorkbenchPushResult = {
  __typename?: 'WorkbenchPushResult';
  docsChanged: Scalars['Boolean']['output'];
  planChanged: Scalars['Boolean']['output'];
};

export type WorkbenchSeedPreviewCount = {
  __typename?: 'WorkbenchSeedPreviewCount';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type WorkbenchSeedPreviewResult = {
  __typename?: 'WorkbenchSeedPreviewResult';
  counts: Array<WorkbenchSeedPreviewCount>;
  notes: Array<Scalars['String']['output']>;
  sampleNames: Array<Scalars['String']['output']>;
};

export type WorkbenchSeedRun = {
  __typename?: 'WorkbenchSeedRun';
  _id: Scalars['MongoID']['output'];
  cleanedAt?: Maybe<Scalars['Date']['output']>;
  cleanedBy?: Maybe<Scalars['MongoID']['output']>;
  cleanedByName?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  featureFlagKey: Scalars['String']['output'];
  organizationId: Scalars['MongoID']['output'];
  preview?: Maybe<WorkbenchSeedRunPreview>;
  scenarioKey: Scalars['String']['output'];
  status: EnumWorkbenchSeedRunStatus;
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type WorkbenchSeedRunPreview = {
  __typename?: 'WorkbenchSeedRunPreview';
  counts?: Maybe<Array<Maybe<WorkbenchSeedRunPreviewCounts>>>;
  notes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sampleNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type WorkbenchSeedRunPreviewCounts = {
  __typename?: 'WorkbenchSeedRunPreviewCounts';
  count: Scalars['Float']['output'];
  label: Scalars['String']['output'];
};

export type WorkbenchSeedScenarioInfo = {
  __typename?: 'WorkbenchSeedScenarioInfo';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type WorkbenchSessionEventInput = {
  at?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  flagKey?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  operationName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type WorkbenchSettingsInfo = {
  __typename?: 'WorkbenchSettingsInfo';
  allowSeedingInProduction: Scalars['Boolean']['output'];
  anthropicConfigured: Scalars['Boolean']['output'];
  chatModel: WorkbenchModelTier;
  defaultTestOrganizationId?: Maybe<Scalars['MongoID']['output']>;
  defaultTestOrganizationName?: Maybe<Scalars['String']['output']>;
  defaultTestStorefrontId?: Maybe<Scalars['MongoID']['output']>;
  environment: Scalars['String']['output'];
  seedingAllowedHere: Scalars['Boolean']['output'];
  summaryModel: WorkbenchModelTier;
};

export type WorkbenchSuggestion = {
  __typename?: 'WorkbenchSuggestion';
  _id: Scalars['MongoID']['output'];
  body: Scalars['String']['output'];
  category?: Maybe<EnumWorkbenchSuggestionCategory>;
  chat?: Maybe<Scalars['MongoID']['output']>;
  createdBy?: Maybe<Scalars['MongoID']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  createdDateISO?: Maybe<Scalars['Date']['output']>;
  docsSection?: Maybe<Scalars['String']['output']>;
  edit?: Maybe<WorkbenchSuggestionEdit>;
  featureFlagKey: Scalars['String']['output'];
  kind: EnumWorkbenchSuggestionKind;
  message?: Maybe<Scalars['MongoID']['output']>;
  pulledAt?: Maybe<Scalars['Date']['output']>;
  relatedFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reviewedAt?: Maybe<Scalars['Date']['output']>;
  reviewedBy?: Maybe<Scalars['MongoID']['output']>;
  status: EnumWorkbenchSuggestionStatus;
  target: EnumWorkbenchSuggestionTarget;
  title: Scalars['String']['output'];
  updatedDateISO?: Maybe<Scalars['Date']['output']>;
};

export type WorkbenchSuggestionEdit = {
  __typename?: 'WorkbenchSuggestionEdit';
  anchorText?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  operation: EnumWorkbenchSuggestionEditOperation;
  section: Scalars['String']['output'];
};

export type WorkbenchTesterInfo = {
  __typename?: 'WorkbenchTesterInfo';
  addedAt?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  invitedAt?: Maybe<Scalars['Date']['output']>;
  lastContactedAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  userId: Scalars['MongoID']['output'];
};

export type CreatedDateIso = {
  _eq?: InputMaybe<Scalars['Date']['input']>;
  _gt?: InputMaybe<Scalars['Date']['input']>;
  _gte?: InputMaybe<Scalars['Date']['input']>;
  _lt?: InputMaybe<Scalars['Date']['input']>;
  _lte?: InputMaybe<Scalars['Date']['input']>;
};

export type Message = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _notStartsWith?: InputMaybe<Scalars['String']['input']>;
  _startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type ContactFragmentFragment = { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null };

export type AddressFragmentFragment = { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null };

export type BroadcastFragmentFragment = { __typename?: 'Broadcast', _id: any, createdDateISO?: any | null, updatedDateISO?: any | null, status: EnumBroadcastStatus, isTemplate: boolean, coverImage?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, publicName?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, sharedTo?: { __typename?: 'BroadcastSharedTo', type: EnumBroadcastSharedToType, sentToPeople: Array<any | null>, sentToPeopleTags?: Array<any | null> | null, sentToPeopleSystemRoles?: Array<EnumBroadcastSharedToSentToPeopleSystemRoles | null> | null, skipEmails?: boolean | null, operatorsOnly?: boolean | null, teaser?: { __typename?: 'BroadcastSharedToTeaser', enabled: boolean, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null } | null, resources: Array<{ __typename?: 'BroadcastResources', type: EnumBroadcastResourcesType, videoURL?: string | null, course?: string | null, iframeUrl?: string | null, formMode?: EnumBroadcastResourcesFormMode | null, allowSaveAndEdit?: boolean | null, requireApproval?: boolean | null, allowResubmission?: boolean | null, completionTags?: Array<string | null> | null, submissionTags?: Array<string | null> | null, expirationTags?: Array<string | null> | null, teamVisible?: boolean | null, _id?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, coverImage?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, message?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, file?: { __typename?: 'AssetFile', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, bytes?: number | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, video?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, photos: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, survey?: { __typename?: 'Survey', _id: any, updatedDateISO?: any | null, perBusinessAnswersEnabled: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, questions: Array<{ __typename?: 'SurveyQuestion', _id: any, isActive: boolean, required: boolean, type: EnumSurveyQuestionType, parentQuestion?: any | null, businessScope?: EnumSurveyQuestionBusinessScope | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options: Array<{ __typename?: 'SurveyQuestionOptions', _id?: any | null, isActive: boolean, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> }> } | null, booker?: { __typename?: 'Booker', _id: any, status: EnumBookerStatus, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, bundles: Array<{ __typename?: 'BookerBundles', _id?: any | null, product?: { __typename?: 'Product', _id: any, type: EnumProductType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null> } | null, ctaLabel?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> };

export type DateRangeIsoFragmentFragment = { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null };

export type DateRangeIsoOptionalFragmentFragment = { __typename?: 'DateRangeISOOptional', _id: any, start?: string | null, end?: string | null, metadata?: string | null };

export type DiscountFragmentFragment = { __typename?: 'Discount', _id: any, amount: number, canCombine: boolean, currentUsageCount: number, daysInAdvance?: number | null, maxDaysInAdvance?: number | null, excludeUpsells: boolean, isActive: boolean, isOngoing: boolean, maxNights?: number | null, maxUsageCount?: number | null, minGuestCount?: number | null, minNights?: number | null, minQuantity?: number | null, minSubtotal?: number | null, buyQuantity?: number | null, getQuantity?: number | null, perTicket: boolean, perTicketApplyFrom?: number | null, promoCode?: string | null, storefront: any, type: EnumDiscountType, unit: EnumDiscountUnit, discountActivePeriod?: { __typename?: 'DateRangeISOOptional', _id: any, end?: string | null, start?: string | null } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } };

export type EventDetailsFragmentFragment = { __typename?: 'Event', _id: any, createdByEmail: string, createdByFirstName?: string | null, createdByLastName?: string | null, createdByPerson?: any | null, submitterPersonId?: any | null, locationType: EnumEventLocationType, price?: string | null, ticketUrl?: string | null, type: EnumEventType, startDate: string, endDate?: string | null, suspectedDuplicateOf?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, eventOrganizer: { __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null }, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tags?: { __typename?: 'EventTags', global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null, eventLocations: Array<{ __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null } | null>, attentionIssues: Array<{ __typename?: 'EventAttentionIssues', type: EnumEventAttentionIssuesType, sourceName?: string | null, venueIndex?: number | null } | null>, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, schedules: Array<{ __typename?: 'EventSchedules', allDay: boolean, timeSlots?: Array<{ __typename?: 'EventSchedulesTimeSlots', _id?: any | null, from?: string | null, to?: string | null, endsNextDay?: boolean | null, note?: string | null } | null> | null } | null>, recurrencePattern: { __typename?: 'EventRecurrencePattern', frequency: EnumEventRecurrencePatternFrequency, interval?: number | null, daysOfWeek?: Array<EnumEventRecurrencePatternDaysOfWeek | null> | null, dateOfMonth?: number | null, dayOfMonth?: EnumEventRecurrencePatternDayOfMonth | null, dayOfMonthOccurrence?: number | null, monthAndDateOfYear?: string | null, multiDates?: Array<string | null> | null, skipDates?: Array<string | null> | null, endDate?: string | null }, access: { __typename?: 'EventAccess', disconnectedOrganizations?: Array<any | null> | null, operator?: { __typename?: 'EventAccessOperator', _entityId: any } | null, organizations: Array<{ __typename?: 'EventAccessOperator', _entityId: any, status?: EnumEventAccessOperatorStatus | null, source?: EnumEventAccessOperatorSource | null, addedVia?: any | null } | null> }, history: Array<{ __typename?: 'EventHistory', action: EnumEventHistoryAction, timestamp: any, sourceType?: EnumEventHistorySourceType | null, userId?: any | null, userEmail?: string | null, userName?: string | null, organizationId?: any | null, note?: string | null } | null> };

export type EventLocationFragmentFragment = { __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null };

export type FileFragmentFragment = { __typename?: 'AssetFile', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, bytes?: number | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } };

export type FulfillmentProfileFragmentFragment = { __typename?: 'FulfillmentProfile', _id: any, name: string, isActive: boolean, storefront: any, pickup?: { __typename?: 'FulfillmentProfilePickup', enabled?: boolean | null, locations?: Array<{ __typename?: 'FulfillmentProfilePickupLocations', _id?: any | null, name: string, address?: string | null, instructions?: string | null } | null> | null } | null, shipping?: { __typename?: 'FulfillmentProfileShipping', enabled?: boolean | null, taxable?: boolean | null, zones?: Array<{ __typename?: 'FulfillmentProfileShippingZones', _id?: any | null, name: string, countries?: Array<string | null> | null, subdivisions?: Array<string | null> | null, flatRate: number, perAdditionalItem?: number | null, freeOver?: number | null } | null> | null } | null };

export type ImageFragmentFragment = { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null };

export type LeadFragmentFragment = { __typename?: 'Lead', _id: any, subject?: string | null, link?: string | null, status: EnumLeadStatus, type?: EnumLeadType | null, source?: EnumLeadSource | null, sourceDetails?: string | null, broadcastId?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, messages: Array<{ __typename?: 'LeadMessages', message: string, sender: EnumLeadMessagesSender, sentAtDateISO: any } | null>, metadata: { __typename?: 'LeadMetadata', booker?: { __typename?: 'Booker', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, bundles: Array<{ __typename?: 'BookerBundles', product?: { __typename?: 'Product', name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null> } | null, storefront?: { __typename?: 'Storefront', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, organization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, operator?: { __typename?: 'OperatorWithStatus', _id: any, _entityId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }, person?: { __typename?: 'SimplePersonTC', _id: string, firstName: string, lastName: string, email: string, phone?: string | null } | null, surveyResponse?: { __typename?: 'SurveyResponse', _id: any, survey?: { __typename?: 'Survey', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, responses: Array<{ __typename?: 'SurveyResponseResponses', response: Array<string | null>, questionData: { __typename?: 'SurveyQuestion', type: EnumSurveyQuestionType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } } | null> } | null };

export type MembershipChecklistResultFragmentFragment = { __typename?: 'MembershipChecklistResult', ranAt: any, analysis: { __typename?: 'MembershipChecklistAnalysis', memberListsEnabled: boolean, ledgerEnabled: boolean, members: { __typename?: 'MembershipChecklistMembers', total: number, totalListings: number, nonMembers: number, multipleTiers: number, tieredWithoutStatusTag: number, multipleTierListings: Array<{ __typename?: 'MembershipChecklistListing', entityId: string, name: string, tiers: Array<string> }>, byTier: Array<{ __typename?: 'MembershipChecklistTier', tagId: string, name: string, count: number, listId?: string | null, byStatus: Array<{ __typename?: 'MembershipChecklistTagCount', tagId: string, name: string, count: number }> }>, byStatus: Array<{ __typename?: 'MembershipChecklistTagCount', tagId: string, name: string, count: number }> }, renewal: { __typename?: 'MembershipChecklistRenewal', engineEnabled: boolean, enabled: boolean, renewalType?: string | null, term?: string | null, termYears?: number | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, activeStatusTagId?: string | null, activeStatusTagName?: string | null, attentionStatusTagIds?: Array<string> | null, withRenewalDate: number, withoutRenewalDate: number, paidUp: number, renewalWindow: number, expired: number, tagDrift: number, suggestedBulkDate?: any | null }, payment: { __typename?: 'MembershipChecklistPayment', enabled: boolean, hasStorefront: boolean, liveCadStorefrontId?: string | null, liveUsdStorefrontId?: string | null, testUsdStorefrontId?: string | null, byTier: Array<{ __typename?: 'MembershipChecklistPaymentTier', tagId: string, bookerId?: string | null, bookerStorefrontId?: string | null, isTest: boolean, free: boolean }> }, communication: { __typename?: 'MembershipChecklistCommunication', broadcastId?: string | null, broadcastName?: string | null, broadcastPublished: boolean, broadcastSharedToAll?: boolean | null, allowColdSignup: boolean } } };

export type MultilingualFragmentFragment = { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null };

export type NoteFramgmentFragment = { __typename?: 'Note', _id: any, message: string, isArchived: boolean, kind: EnumNoteKind, noteDateISO?: string | null, updatedDateISO?: any | null, createdDateISO?: any | null, author?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null, entity: { __typename?: 'EntityReference', _entityId: any, type: EnumEntityReferenceType }, mentions: Array<{ __typename?: 'User', _id: any, firstName: string, lastName: string }>, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, resolvedBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string } | null };

export type OrgOperatorOverlayFragmentFragment = { __typename?: 'OrgOperatorOverlay', _id: any, operator: any, createdDateISO?: any | null, updatedDateISO?: any | null, organization?: { __typename?: 'Organization', _id: any } | null, overlayPrivate?: { __typename?: 'OrgOperatorOverlayOverlayPrivate', tags?: Array<any | null> | null, note?: string | null } | null, overlayPublic?: { __typename?: 'OrgOperatorOverlayOverlayPublic', publicProfileUrl?: string | null, crowdriffGalleryId?: string | null } | null };

export type OrganizationPartnerSummaryFragmentFragment = { __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null };

export type OrganizationEventPartnerSettingsFragmentFragment = { __typename?: 'OrganizationEventPartnerSettings', sharingCode: string, partners?: Array<{ __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null }> | null, subscribers?: Array<{ __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null }> | null, suggestions?: Array<{ __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null }> | null };

export type PaymentMethodSetFragmentFragment = { __typename?: 'PaymentMethodSet', _id: any, name: string, isActive: boolean, acceptedPaymentMethods: Array<string | null>, bankTransferInstructions?: string | null, offlinePaymentInstructions?: string | null, checkoutDescription?: string | null, storefront: any, methodLabels?: { __typename?: 'PaymentMethodSetMethodLabels', card?: string | null, direct_debit?: string | null, bank_transfer?: string | null, offline_payment?: string | null } | null };

export type PersonDetailsFragmentFragment = { __typename?: 'DetailedPersonTC', _id: string, userId?: string | null, isUserClaimed?: boolean | null, isUserInvited?: boolean | null, emails?: Array<string | null> | null, scratchpad?: string | null, isOnDirectoryOperator?: boolean | null, personInfo?: { __typename?: 'DetailedPersonInfoTC', firstName: string, lastName: string, email: string, isUserClaimed?: boolean | null, isUserInvited?: boolean | null, phone?: string | null, phoneExt?: string | null, fax?: string | null, faxExt?: string | null, pronouns?: string | null, primaryTitle?: string | null, birthday?: string | null, contactMethod?: EnumPeopleContactMethod | null, optInEmail?: boolean | null, optInPhone?: boolean | null, optInSMS?: boolean | null, optInFax?: boolean | null, systemRoles?: Array<EnumPeopleVisibleToSystemRoles | null> | null, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, mailingAddress?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, tags: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> } | null, orders?: Array<{ __typename?: 'PersonDetailsSectionTC', _id: string, dateISO: string, dateStartISO?: string | null, dateEndISO?: string | null, type?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, operators?: Array<{ __typename?: 'OperatorDetailsTC', _entityId: string, roleType?: string | null, title?: string | null, contactRoles?: Array<ContactRole | null> | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, organizations?: Array<{ __typename?: 'OperatorOrganizationDetailsTC', _id: string, logo?: string | null, title?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null } | null> | null, organizations?: Array<{ __typename?: 'OrganizationDetailsTC', _id: string, logo?: string | null, roleType?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, adminOrganizations?: Array<{ __typename?: 'OrganizationDetailsTC', _id: string, logo?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, leads?: Array<{ __typename?: 'PersonDetailsSectionTC', _id: string, dateISO: string, status?: string | null, type?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, phones?: Array<{ __typename?: 'PersonMetadataPhone', phone?: string | null, ext?: string | null, type?: string | null } | null> | null };

export type PersonSimpleManyFragmentFragment = { __typename?: 'SimplePersonManyTC', _id: string, firstName: string, lastName: string, email: string, phone?: string | null, isRepeatCustomer?: boolean | null, lastUpdated?: any | null, systemRoles?: Array<EnumPeopleVisibleToSystemRoles | null> | null, isWhereaboutsUser?: boolean | null, isUserClaimed?: boolean | null, isUserInvited?: boolean | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, tags: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, unreadLeads?: Array<{ __typename?: 'UnreadLeadTC', leadId: string, date: any, type?: string | null } | null> | null, rightSideContent?: Array<{ __typename?: 'RightSideContentTC', entityId: string, text: string } | null> | null };

export type PolicyFragmentFragment = { __typename?: 'Policy', _id: any, isActive: boolean, storefront: any, content: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } };

export type ProductFragmentFragment = { __typename?: 'Product', _id: any, storefront: any, updatedDateISO?: any | null, createdDateISO?: any | null, type: EnumProductType, publicationStatus: EnumProductPublicationStatus, externalBookingUrl?: string | null, isUpsellOnly: boolean, isActive: boolean, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags: Array<{ __typename?: 'Tag', entityTypes: Array<EnumTagEntityTypes | null>, _id: any, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rules: Array<{ __typename?: 'Rule', type: EnumRuleType, value: any, isActive: boolean, storefront: any, _id: any, activePeriod?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null }>, pricing?: { __typename?: 'Pricing', description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tiers: Array<{ __typename?: 'PriceTier', type: EnumGuestTierType, price: number, priceType: EnumPriceTierPriceType, guestCountForPrice?: number | null, discountAmount?: number | null, discountUnit?: EnumPriceTierDiscountUnit | null, _id: any, label?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> } | null, quantitySettings?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, contact?: { __typename?: 'ProductContact', useOwnerContact: boolean, email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null } | null, addOnSettings?: { __typename?: 'ProductAddOnSettings', businessScope?: EnumProductAddOnSettingsBusinessScope | null, pricingScope?: EnumProductAddOnSettingsPricingScope | null } | null, customFields?: Array<{ __typename?: 'ProductCustomFields', _id?: any | null, type: EnumProductCustomFieldsType, required: boolean, chargePerChoice?: boolean | null, maxChoices?: number | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options?: Array<{ __typename?: 'ProductCustomFieldsOptions', _id?: any | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null, renewableFeeMetadata?: { __typename?: 'RenewableFeeMetadata', billingIntervalMonths: number, renewalType?: EnumRenewableFeeMetadataRenewalType | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, proRateEnabled?: boolean | null, earlyPurchaseWindowDays?: number | null, membershipLinked?: boolean | null } | null, merchMetadata?: { __typename?: 'MerchMetadata', lowStockThreshold?: number | null, dimensions?: Array<{ __typename?: 'MerchMetadataDimensions', _id?: any | null, drivesImages?: boolean | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, values?: Array<{ __typename?: 'MerchMetadataDimensionsValues', _id?: any | null, imageIds?: Array<string | null> | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null, variants?: Array<{ __typename?: 'MerchMetadataVariants', _id?: any | null, dimensionValueIds?: Array<string | null> | null, label?: string | null, price: number, sku?: string | null, inventoryCount: number, isActive?: boolean | null } | null> | null } | null, sellingConfig?: { __typename?: 'ProductSellingConfig', mode: string, basePrice?: number | null, dynamicFeeSurvey?: any | null, options?: Array<{ __typename?: 'ProductTier', _id?: any | null, price: number, order: number, autoTag?: any | null, sessionScope?: EnumProductTierSessionScope | null, includedSessionIds?: Array<string | null> | null, minSessions?: number | null, maxSessions?: number | null, subCapacityPerSession?: number | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tagConfig?: { __typename?: 'ProductTierTagConfig', onCheckoutCompleted?: Array<any | null> | null, onRenewalSuccess?: Array<any | null> | null, onRenewalPending?: Array<any | null> | null, onExpiration?: Array<any | null> | null, onCancellation?: Array<any | null> | null, onPaymentFailed?: Array<any | null> | null } | null, personTagConfig?: { __typename?: 'ProductTierTagConfig', onCheckoutCompleted?: Array<any | null> | null, onRenewalSuccess?: Array<any | null> | null, onRenewalPending?: Array<any | null> | null, onExpiration?: Array<any | null> | null, onCancellation?: Array<any | null> | null, onPaymentFailed?: Array<any | null> | null } | null, inventory?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, condition?: { __typename?: 'ProductTierCondition', operator: EnumProductTierConditionOperator, clauses?: Array<{ __typename?: 'ProductTierConditionClauses', questionId: string, comparator: EnumProductTierConditionClausesComparator, value: string } | null> | null } | null } | null> | null, inventory?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, recurring?: { __typename?: 'ProductSellingConfigRecurring', enabled?: boolean | null, billingIntervalMonths?: number | null, renewalType?: EnumProductSellingConfigRecurringRenewalType | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, proRateEnabled?: boolean | null, earlyPurchaseWindowDays?: number | null, membershipLinked?: boolean | null, multiListing?: { __typename?: 'ProductSellingConfigRecurringMultiListing', mode?: EnumProductSellingConfigRecurringMultiListingMode | null, maxListings?: number | null, autoIncludeOwnedListings?: boolean | null, additionalBusinessDiscount?: { __typename?: 'ProductSellingConfigRecurringMultiListingAdditionalBusinessDiscount', unit: EnumProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountUnit, amount: number } | null } | null } | null } | null, productTiers?: Array<{ __typename?: 'ProductTier', _id?: any | null, price: number, order: number, autoTag?: any | null, sessionScope?: EnumProductTierSessionScope | null, includedSessionIds?: Array<string | null> | null, minSessions?: number | null, maxSessions?: number | null, subCapacityPerSession?: number | null, isActive?: boolean | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null } | null> | null, eventMetadata?: { __typename?: 'ProductEventMetadata', event: any, ticketStructure: EnumProductEventMetadataTicketStructure, sessionGranularity: EnumProductEventMetadataSessionGranularity, sellingType?: EnumProductEventMetadataSellingType | null, maxTicketsPerPurchase?: number | null, includedSessionIds?: Array<string | null> | null } | null, inventorySettings?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, accommodationMetadata?: { __typename?: 'AccommodationProductMetadata', checkIn?: string | null, checkOut?: string | null, calendarLinks?: Array<string | null> | null, guestMetadata?: { __typename?: 'GuestMetadata', minimumNumber?: number | null, maximumNumber?: number | null, nameEntryAllowed: boolean, nameEntryRequired: boolean } | null, amenities: Array<{ __typename?: 'Tag', entityTypes: Array<EnumTagEntityTypes | null>, _id: any, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rooms: Array<{ __typename?: 'Room', _id?: any | null, type: EnumRoomType, amenities?: Array<any | null> | null } | null>, closures: Array<{ __typename?: 'Closure', _id?: any | null, name: string, dateRangeISO: { __typename?: 'DateRangeISO', _id: any, end: string, metadata?: string | null, start: string } } | null> } | null };

export type PromotionFragmentFragment = { __typename?: 'Promotion', _id: any, link?: string | null, firstDate: string, lastDate: string, createdByEmail: string, createdByFirstName?: string | null, createdByLastName?: string | null, createdBy?: any | null, createdByPerson?: any | null, submitterPersonId?: any | null, submissionSource?: EnumPromotionSubmissionSource | null, createdDateISO?: any | null, updatedDateISO?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, availability: { __typename?: 'PromotionAvailability', type: EnumPromotionAvailabilityType, dates?: Array<string | null> | null, startDate?: string | null, endDate?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags?: { __typename?: 'PromotionTags', organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> } | null, access: { __typename?: 'PromotionAccess', operator: { __typename?: 'PromotionAccessOperator', _entityId: any, status?: EnumPromotionAccessOperatorStatus | null }, organizations: Array<{ __typename?: 'PromotionAccessOperator', _entityId: any, status?: EnumPromotionAccessOperatorStatus | null } | null> }, history: Array<{ __typename?: 'PromotionHistory', action: EnumPromotionHistoryAction, timestamp: any, sourceType?: EnumPromotionHistorySourceType | null, userId?: any | null, userEmail?: string | null, userName?: string | null, organizationId?: any | null, note?: string | null } | null>, listing?: { __typename?: 'OperatorWithStatus', _entityId: any, operationalStatus: EnumOperatorOperationalStatus, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null };

export type RenewalRebaseGraceFragmentFragment = { __typename?: 'RenewalRebaseGrace', overdueCount: number, targetDate?: any | null, nextRenewalDate?: any | null, currentGraceDays: number, currentGraceIsDefault: boolean, currentGraceEndsOn?: any | null, currentNeverExpire: boolean, suggestedGraceDays?: number | null, graceDays: number, neverExpire: boolean, graceEndsOn?: any | null, wouldExpireOnNextSweep: number };

export type RenewalRebasePlanFragmentFragment = { __typename?: 'RenewalRebasePlan', affected: number, unchanged: number, undated: number, byPhase: { __typename?: 'RenewalRebasePhaseCounts', paidUp: number, renewalWindow: number, expired: number }, outliers: Array<{ __typename?: 'RenewalRebaseMember', subjectType: string, entityId: string, name: string, currentDate?: any | null, targetDate?: any | null }>, skipped: Array<{ __typename?: 'RenewalRebaseMember', subjectType: string, entityId: string, name: string, currentDate?: any | null, targetDate?: any | null }>, grace: { __typename?: 'RenewalRebaseGrace', overdueCount: number, targetDate?: any | null, nextRenewalDate?: any | null, currentGraceDays: number, currentGraceIsDefault: boolean, currentGraceEndsOn?: any | null, currentNeverExpire: boolean, suggestedGraceDays?: number | null, graceDays: number, neverExpire: boolean, graceEndsOn?: any | null, wouldExpireOnNextSweep: number }, from: { __typename?: 'RenewalScheduleSnapshot', fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null }, to: { __typename?: 'RenewalScheduleSnapshot', fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null } };

export type MembershipLaunchStatusFragmentFragment = { __typename?: 'MembershipLaunchStatus', state: string, derived: boolean, mode?: string | null, launchedAt?: any | null, recordedRetroactively: boolean, locked: boolean, blockers: Array<string>, health: { __typename?: 'MembershipScheduleHealth', undated: number, offSchedule: number, purchaseSnapshotMismatch: number, staleCheckouts: number, overdue: number, graceEndsOn?: any | null }, scheduleHistory: Array<{ __typename?: 'MembershipScheduleChange', at: any, kind: string, fromMonth?: number | null, fromDay?: number | null, toMonth?: number | null, toDay?: number | null, intent?: string | null, date?: any | null, affected: number, note?: string | null }> };

export type SurveyFragmentFragment = { __typename?: 'Survey', _id: any, updatedDateISO?: any | null, perBusinessAnswersEnabled: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, questions: Array<{ __typename?: 'SurveyQuestion', _id: any, isActive: boolean, required: boolean, type: EnumSurveyQuestionType, whereaboutsSearchEntityType?: EnumSurveyQuestionWhereaboutsSearchEntityType | null, parentQuestion?: any | null, businessScope?: EnumSurveyQuestionBusinessScope | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options: Array<{ __typename?: 'SurveyQuestionOptions', _id?: any | null, isActive: boolean, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> }> };

export type TagEntityUsageFragmentFragment = { __typename?: 'TagEntityTypeUsageOperators', entityId: string, parentId: string, entityName: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, parentName: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } };

export type TagFragmentFragment = { __typename?: 'Tag', _id: any, entityTypes: Array<EnumTagEntityTypes | null>, inheritable: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null };

export type TagFragmentWithUsageFragment = { __typename?: 'Tag', _id: any, entityTypes: Array<EnumTagEntityTypes | null>, inheritable: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, usage?: { __typename?: 'TagUsage', events?: number | null, operators?: number | null, products?: number | null, total?: number | null } | null };

export type TagSuggestionFragmentFragment = { __typename?: 'TagSuggestion', _id: any, entityTypes: Array<EnumTagSuggestionEntityTypes | null>, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, aiResponse?: { __typename?: 'TagSuggestionAIResponse', action?: EnumTagSuggestionAiResponseAction | null, summary?: string | null, similarTags: Array<string | null>, alternativeSuggestions: Array<string | null> } | null };

export type UpsellProductFragmentFragment = { __typename?: 'Product', _id: any, isUpsellOnly: boolean, publicationStatus: EnumProductPublicationStatus, type: EnumProductType, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, pricing?: { __typename?: 'Pricing', tiers: Array<{ __typename?: 'PriceTier', _id: any, price: number, type: EnumGuestTierType, label?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, quantitySettings?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, addOnSettings?: { __typename?: 'ProductAddOnSettings', businessScope?: EnumProductAddOnSettingsBusinessScope | null, pricingScope?: EnumProductAddOnSettingsPricingScope | null } | null, customFields?: Array<{ __typename?: 'ProductCustomFields', _id?: any | null, type: EnumProductCustomFieldsType, required: boolean, chargePerChoice?: boolean | null, maxChoices?: number | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options?: Array<{ __typename?: 'ProductCustomFieldsOptions', _id?: any | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null };

export type UserFragmentFragment = { __typename?: 'User', _id: any, firstName: string, lastName: string, email: string, status: EnumUserStatus, userType: EnumUserUserType, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, storefronts: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null> }, onboardingMetadata?: { __typename?: 'UserOnboardingMetadata', onboardingOrganization?: any | null, isPostOnboarding?: boolean | null, onboardingBroadcast?: any | null } | null, emailPreferences: Array<{ __typename?: 'UserEmailPreferences', templateName: EnumUserEmailPreferencesTemplateName, frequency: EnumUserEmailPreferencesFrequency, entity?: { __typename?: 'EntityReference', type: EnumEntityReferenceType, _entityId: any } | null } | null> };

export type UserWithPictureFragmentFragment = { __typename?: 'UserWithPictureTC', picture?: string | null, _id: any, personId?: string | null, firstName: string, lastName: string, email: string, title?: string | null, photoUploadedBy?: any | null, contactRoles?: Array<ContactRole | null> | null, status: EnumUserStatus, userType: EnumUserUserType, quickLinksVersion: number, lastViewedListId?: string | null, hasPurchases: boolean, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus, title?: string | null, contactRoles?: Array<EnumUserAccessOperatorsContactRoles | null> | null } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, storefronts: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null> }, onboardingMetadata?: { __typename?: 'UserOnboardingMetadata', onboardingOrganization?: any | null, isPostOnboarding?: boolean | null, onboardingBroadcast?: any | null } | null, emailPreferences: Array<{ __typename?: 'UserEmailPreferences', templateName: EnumUserEmailPreferencesTemplateName, frequency: EnumUserEmailPreferencesFrequency, entity?: { __typename?: 'EntityReference', type: EnumEntityReferenceType, _entityId: any } | null } | null>, quickLinks: Array<{ __typename?: 'UserQuickLinks', title: string, link: string, lastVisited: string, type: EnumUserQuickLinksType, entityId: string, pinned?: boolean | null } | null>, memberships: Array<{ __typename?: 'UserMembershipRow', _id: any, subjectType: string, listingName?: string | null, organizationId: any, organizationName: string, organizationLogo?: any | null, memberNomenclature: string, membershipNomenclature: string, tierName?: string | null, status: string, statusTagNames: Array<string>, renewalDate?: any | null, renewalDateDisplayMode: string, needsRenewal: boolean, tierTagId?: any | null, subjectEntityId: any, renewablePurchaseId?: any | null, renewalBilling?: string | null }> };

export type WorkbenchSuggestionFieldsFragment = { __typename?: 'WorkbenchSuggestion', _id: any, featureFlagKey: string, chat?: any | null, message?: any | null, kind: EnumWorkbenchSuggestionKind, target: EnumWorkbenchSuggestionTarget, title: string, body: string, category?: EnumWorkbenchSuggestionCategory | null, docsSection?: string | null, relatedFiles?: Array<string | null> | null, status: EnumWorkbenchSuggestionStatus, createdBy?: any | null, createdByName?: string | null, createdDateISO?: any | null, pulledAt?: any | null, edit?: { __typename?: 'WorkbenchSuggestionEdit', section: string, operation: EnumWorkbenchSuggestionEditOperation, content: string, anchorText?: string | null } | null };

export type WorkbenchMessageFieldsFragment = { __typename?: 'WhereabotMessage', _id: any, chat: any, role: EnumWhereabotMessageRole, content: string, isError: boolean, createdDateISO?: any | null, metadata?: { __typename?: 'WhereabotMessageMetadata', model?: string | null } | null, sessionEvents?: Array<{ __typename?: 'WhereabotMessageSessionEvents', at: any, type: EnumWhereabotMessageSessionEventsType, route?: string | null, operationName?: string | null, message?: string | null, flagKey?: string | null, enabled?: boolean | null } | null> | null, workbenchSuggestions: Array<{ __typename?: 'WorkbenchSuggestion', _id: any, featureFlagKey: string, chat?: any | null, message?: any | null, kind: EnumWorkbenchSuggestionKind, target: EnumWorkbenchSuggestionTarget, title: string, body: string, category?: EnumWorkbenchSuggestionCategory | null, docsSection?: string | null, relatedFiles?: Array<string | null> | null, status: EnumWorkbenchSuggestionStatus, createdBy?: any | null, createdByName?: string | null, createdDateISO?: any | null, pulledAt?: any | null, edit?: { __typename?: 'WorkbenchSuggestionEdit', section: string, operation: EnumWorkbenchSuggestionEditOperation, content: string, anchorText?: string | null } | null }> };

export type WorkbenchTesterFieldsFragment = { __typename?: 'WorkbenchTesterInfo', userId: any, name: string, email: string, addedAt?: any | null, invitedAt?: any | null, lastContactedAt?: any | null };

export type WorkbenchChangeRequestFieldsFragment = { __typename?: 'WorkbenchChangeRequestResult', target: string, openCount: number, openTesterCount: number, stale: boolean, newSinceGenerated: number, markdown?: string | null, summary?: { __typename?: 'WorkbenchChangeRequestSummary', generatedAt: any, model?: string | null, testerCount: number, suggestionCount: number, overview: string, integratedAt?: any | null, themes: Array<{ __typename?: 'WorkbenchChangeRequestTheme', title: string, summary: string, testerCount: number, suggestionIds: Array<any>, conflicts?: string | null, proposedSteps: Array<{ __typename?: 'WorkbenchChangeRequestStep', title: string, body: string }> }> } | null };

export type WorkbenchSeedRunFieldsFragment = { __typename?: 'WorkbenchSeedRun', _id: any, featureFlagKey: string, scenarioKey: string, organizationId: any, status: EnumWorkbenchSeedRunStatus, createdByName?: string | null, cleanedByName?: string | null, createdDateISO?: any | null, cleanedAt?: any | null, errorMessage?: string | null, preview?: { __typename?: 'WorkbenchSeedRunPreview', sampleNames?: Array<string | null> | null, notes?: Array<string | null> | null, counts?: Array<{ __typename?: 'WorkbenchSeedRunPreviewCounts', label: string, count: number } | null> | null } | null };

export type WorkbenchFeatureFieldsFragment = { __typename?: 'WorkbenchFeature', _id: any, featureFlagKey: string, active: boolean, planPath: string, planContent?: string | null, planSyncedAt?: any | null, planSource?: EnumWorkbenchFeaturePlanSource | null, planSyncStatus: EnumWorkbenchFeaturePlanSyncStatus, docsPath: string, docsContent?: string | null, docsSyncedAt?: any | null, docsSource?: EnumWorkbenchFeatureDocsSource | null, docsSyncStatus: EnumWorkbenchFeatureDocsSyncStatus, docsAudience: EnumWorkbenchFeatureDocsAudience, helpScoutArticleUrl?: string | null, codePaths: Array<string | null>, testOrganizationId?: any | null, effectiveTestOrganizationId?: any | null, effectiveTestOrganizationName?: string | null, myActiveChatId?: any | null, entryPoints: Array<{ __typename?: 'WorkbenchFeatureEntryPoints', label: string, route: string } | null>, testerUsers: Array<{ __typename?: 'WorkbenchTesterInfo', userId: any, name: string, email: string, addedAt?: any | null, invitedAt?: any | null, lastContactedAt?: any | null }>, stats: { __typename?: 'WorkbenchFeatureStats', pendingEditCount: number, acceptedEditCount: number, openFeedbackCount: number, reviewCount: number, activeSeedRunCount: number }, flag?: { __typename?: 'FeatureFlag', _id: any, key: string, name: string, description?: string | null, group: string, scope: EnumFeatureFlagScope, graduatedAt?: any | null, expelledAt?: any | null, expelledReason?: string | null, expelledReviewChat?: any | null } | null };

export type ActivityLogCreateMutationVariables = Exact<{
  record: CreateOneActivityLogInput;
}>;


export type ActivityLogCreateMutation = { __typename?: 'Mutation', activityLogCreateOne?: { __typename?: 'CreateOneActivityLogPayload', record?: { __typename?: 'ActivityLog', _id: any } | null } | null };

export type AdminUserDemoteMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
}>;


export type AdminUserDemoteMutation = { __typename?: 'Mutation', adminUserDemote?: { __typename?: 'AdminUserPromoteResult', success: boolean, error?: string | null, user?: { __typename?: 'AdminUserInfo', _id: any, email: string, firstName: string, lastName: string, status: string, userType: string } | null } | null };

export type AdminUserPromoteMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
}>;


export type AdminUserPromoteMutation = { __typename?: 'Mutation', adminUserPromote?: { __typename?: 'AdminUserPromoteResult', success: boolean, error?: string | null, user?: { __typename?: 'AdminUserInfo', _id: any, email: string, firstName: string, lastName: string, status: string, userType: string } | null } | null };

export type AdminUserSetPermissionsMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  permissions: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AdminUserSetPermissionsMutation = { __typename?: 'Mutation', adminUserSetPermissions?: { __typename?: 'AdminUserInfo', _id: any, email: string, firstName: string, lastName: string, status: string, userType: string, systemPermissions: Array<string> } | null };

export type AiTaskCancelMutationVariables = Exact<{
  taskId: Scalars['MongoID']['input'];
}>;


export type AiTaskCancelMutation = { __typename?: 'Mutation', aiTaskCancel?: { __typename?: 'AiTaskCancelPayload', success: boolean, task?: { __typename?: 'AiTask', _id: any, status: AiTaskStatus } | null } | null };

export type AiTaskFeedbackMutationVariables = Exact<{
  taskId: Scalars['MongoID']['input'];
  rating: AiTaskRating;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
}>;


export type AiTaskFeedbackMutation = { __typename?: 'Mutation', aiTaskFeedback?: { __typename?: 'AiTaskFeedbackPayload', success: boolean, task?: { __typename?: 'AiTask', _id: any, rating?: AiTaskRating | null, feedbackNotes?: string | null } | null } | null };

export type AiTaskMarkAppliedMutationVariables = Exact<{
  taskId: Scalars['MongoID']['input'];
}>;


export type AiTaskMarkAppliedMutation = { __typename?: 'Mutation', aiTaskMarkApplied?: { __typename?: 'AiTaskMarkAppliedPayload', success: boolean, task?: { __typename?: 'AiTask', _id: any, applied?: boolean | null, appliedAt?: any | null } | null } | null };

export type AiTaskPingMutationVariables = Exact<{
  taskId: Scalars['MongoID']['input'];
}>;


export type AiTaskPingMutation = { __typename?: 'Mutation', aiTaskPing?: { __typename?: 'AiTaskPingPayload', success: boolean, status?: AiTaskStatus | null } | null };

export type AnalyticsDashboardCreateOneMutationVariables = Exact<{
  record: CreateOneAnalyticsDashboardInput;
}>;


export type AnalyticsDashboardCreateOneMutation = { __typename?: 'Mutation', analyticsDashboardCreateOne?: { __typename?: 'CreateOneAnalyticsDashboardPayload', record?: { __typename?: 'AnalyticsDashboard', _id: any, name: string, description: string, dashboardId: string, sortOrder: number } | null } | null };

export type AnalyticsDashboardRemoveByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type AnalyticsDashboardRemoveByIdMutation = { __typename?: 'Mutation', analyticsDashboardRemoveById?: { __typename?: 'RemoveByIdAnalyticsDashboardPayload', record?: { __typename?: 'AnalyticsDashboard', _id: any } | null } | null };

export type AnalyticsDashboardUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdAnalyticsDashboardInput;
}>;


export type AnalyticsDashboardUpdateByIdMutation = { __typename?: 'Mutation', analyticsDashboardUpdateById?: { __typename?: 'UpdateByIdAnalyticsDashboardPayload', record?: { __typename?: 'AnalyticsDashboard', _id: any, name: string, description: string, dashboardId: string, sortOrder: number } | null } | null };

export type ApiAccessCreateMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApiAccessCreateMutation = { __typename?: 'Mutation', apiAccessCreate?: { __typename?: 'CreateOneApiAccessPayload', record?: { __typename?: 'ApiAccess', _id: any, token: string, name?: string | null, description?: string | null, organization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, user?: { __typename?: 'UserWithPictureTC', _id: any, email: string, firstName: string, lastName: string, userType: EnumUserUserType } | null } | null } | null };

export type ApiAccessCreateAdminMutationVariables = Exact<{
  adminUserId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApiAccessCreateAdminMutation = { __typename?: 'Mutation', apiAccessCreateAdmin?: { __typename?: 'CreateOneApiAccessPayload', record?: { __typename?: 'ApiAccess', _id: any, token: string, name?: string | null, description?: string | null, user?: { __typename?: 'UserWithPictureTC', _id: any, email: string, firstName: string, lastName: string, userType: EnumUserUserType } | null } | null } | null };

export type ApiAccessDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ApiAccessDeleteMutation = { __typename?: 'Mutation', apiAccessDelete?: { __typename?: 'RemoveByIdApiAccessPayload', recordId?: any | null } | null };

export type ApiAccessUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdApiAccessInput;
}>;


export type ApiAccessUpdateMutation = { __typename?: 'Mutation', apiAccessUpdate?: { __typename?: 'UpdateByIdApiAccessPayload', record?: { __typename?: 'ApiAccess', _id: any, token: string, name?: string | null, description?: string | null, lastUsedAt?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, user?: { __typename?: 'UserWithPictureTC', _id: any, email: string, firstName: string, lastName: string, userType: EnumUserUserType } | null } | null } | null };

export type BookerApplyFeeAbsorptionMutationVariables = Exact<{
  bookerId: Scalars['MongoID']['input'];
  stripePercent: Scalars['Float']['input'];
  stripeFixedCents: Scalars['Int']['input'];
  roundingIncrementCents: Scalars['Int']['input'];
  productIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  overrides?: InputMaybe<Array<BookerFeeAbsorptionPriceOverrideInput> | BookerFeeAbsorptionPriceOverrideInput>;
}>;


export type BookerApplyFeeAbsorptionMutation = { __typename?: 'Mutation', bookerApplyFeeAbsorption?: { __typename?: 'Booker', _id: any } | null };

export type BookerCreateMutationVariables = Exact<{
  record: CreateOneBookerInput;
}>;


export type BookerCreateMutation = { __typename?: 'Mutation', bookerCreate?: { __typename?: 'CreateOneBookerPayload', record?: { __typename?: 'Booker', _id: any } | null } | null };

export type BookerDuplicateToStorefrontMutationVariables = Exact<{
  bookerId: Scalars['MongoID']['input'];
  targetStorefrontId: Scalars['MongoID']['input'];
}>;


export type BookerDuplicateToStorefrontMutation = { __typename?: 'Mutation', bookerDuplicateToStorefront?: { __typename?: 'BookerDuplicateToStorefrontResult', bookerId: any, storefrontId: any } | null };

export type BookerRevertFeeAbsorptionMutationVariables = Exact<{
  bookerId: Scalars['MongoID']['input'];
}>;


export type BookerRevertFeeAbsorptionMutation = { __typename?: 'Mutation', bookerRevertFeeAbsorption?: { __typename?: 'BookerFeeAbsorptionRevertResult', restoredCount: number, skipped?: Array<{ __typename?: 'BookerFeeAbsorptionSkippedPricePoint', productId: string, productName: string, path: string, label: string } | null> | null, booker?: { __typename?: 'Booker', _id: any } | null } | null };

export type BookerSendConfirmationTestEmailMutationVariables = Exact<{
  bookerId: Scalars['MongoID']['input'];
  recipientUserId: Scalars['ID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type BookerSendConfirmationTestEmailMutation = { __typename?: 'Mutation', bookerSendConfirmationTestEmail: boolean };

export type BookerSetApplicationFeeMutationVariables = Exact<{
  bookerId: Scalars['String']['input'];
  applicationPercentage: Scalars['Float']['input'];
  customerApplicationPercentage: Scalars['Float']['input'];
}>;


export type BookerSetApplicationFeeMutation = { __typename?: 'Mutation', bookerSetApplicationFee?: { __typename?: 'Booker', _id: any, paymentMetadata?: { __typename?: 'OrderPaymentMetadata', applicationPercentage?: number | null, customerApplicationPercentage?: number | null } | null } | null };

export type BookerUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdBookerInput;
}>;


export type BookerUpdateMutation = { __typename?: 'Mutation', bookerUpdate?: { __typename?: 'UpdateByIdBookerPayload', record?: { __typename?: 'Booker', _id: any } | null } | null };

export type BroadcastCloneByIdMutationVariables = Exact<{
  input: BroadcastCloneInput;
}>;


export type BroadcastCloneByIdMutation = { __typename?: 'Mutation', broadcastCloneById: { __typename?: 'Broadcast', _id: any, createdDateISO?: any | null, updatedDateISO?: any | null, status: EnumBroadcastStatus, isTemplate: boolean, coverImage?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, publicName?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, sharedTo?: { __typename?: 'BroadcastSharedTo', type: EnumBroadcastSharedToType, sentToPeople: Array<any | null>, sentToPeopleTags?: Array<any | null> | null, sentToPeopleSystemRoles?: Array<EnumBroadcastSharedToSentToPeopleSystemRoles | null> | null, skipEmails?: boolean | null, operatorsOnly?: boolean | null, teaser?: { __typename?: 'BroadcastSharedToTeaser', enabled: boolean, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null } | null, resources: Array<{ __typename?: 'BroadcastResources', type: EnumBroadcastResourcesType, videoURL?: string | null, course?: string | null, iframeUrl?: string | null, formMode?: EnumBroadcastResourcesFormMode | null, allowSaveAndEdit?: boolean | null, requireApproval?: boolean | null, allowResubmission?: boolean | null, completionTags?: Array<string | null> | null, submissionTags?: Array<string | null> | null, expirationTags?: Array<string | null> | null, teamVisible?: boolean | null, _id?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, coverImage?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, message?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, file?: { __typename?: 'AssetFile', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, bytes?: number | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, video?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, photos: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, survey?: { __typename?: 'Survey', _id: any, updatedDateISO?: any | null, perBusinessAnswersEnabled: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, questions: Array<{ __typename?: 'SurveyQuestion', _id: any, isActive: boolean, required: boolean, type: EnumSurveyQuestionType, parentQuestion?: any | null, businessScope?: EnumSurveyQuestionBusinessScope | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options: Array<{ __typename?: 'SurveyQuestionOptions', _id?: any | null, isActive: boolean, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> }> } | null, booker?: { __typename?: 'Booker', _id: any, status: EnumBookerStatus, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, bundles: Array<{ __typename?: 'BookerBundles', _id?: any | null, product?: { __typename?: 'Product', _id: any, type: EnumProductType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null> } | null, ctaLabel?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> } };

export type BroadcastCreateOneMutationVariables = Exact<{
  record: CreateOneBroadcastInput;
}>;


export type BroadcastCreateOneMutation = { __typename?: 'Mutation', broadcastCreateOne?: { __typename?: 'CreateOneBroadcastPayload', record?: { __typename?: 'Broadcast', _id: any } | null } | null };

export type BroadcastUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdBroadcastInput;
}>;


export type BroadcastUpdateByIdMutation = { __typename?: 'Mutation', broadcastUpdateById?: { __typename?: 'UpdateByIdBroadcastPayload', record?: { __typename?: 'Broadcast', _id: any } | null } | null };

export type BulkConnectLogRollbackMutationVariables = Exact<{
  bulkConnectLogId: Scalars['ID']['input'];
}>;


export type BulkConnectLogRollbackMutation = { __typename?: 'Mutation', bulkConnectLogRollback?: { __typename?: 'BulkConnectLog', _id: any, rollbackInfo?: { __typename?: 'BulkConnectLogRollbackInfo', rolledBackAt: any, rolledBackBy: any, disconnectedCount: number, errorCount: number, errorMessages?: Array<string | null> | null } | null } | null };

export type ClosuresCreatePerProductMutationVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  name: Scalars['String']['input'];
  startIso: Scalars['String']['input'];
  endIso: Scalars['String']['input'];
}>;


export type ClosuresCreatePerProductMutation = { __typename?: 'Mutation', createClosuresPerProduct: Array<string> };

export type ClosuresUpdatePerProductMutationVariables = Exact<{
  closureId: Scalars['ID']['input'];
  deleteClosure: Scalars['Boolean']['input'];
  productIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startIso?: InputMaybe<Scalars['String']['input']>;
  endIso?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClosuresUpdatePerProductMutation = { __typename?: 'Mutation', updateClosuresPerProduct: Array<string> };

export type CourseProgressSaveMutationVariables = Exact<{
  resourceId: Scalars['MongoID']['input'];
  broadcastId: Scalars['MongoID']['input'];
  scormData: Scalars['JSON']['input'];
  scormVersion?: InputMaybe<Scalars['String']['input']>;
}>;


export type CourseProgressSaveMutation = { __typename?: 'Mutation', courseProgressSave?: { __typename?: 'CourseProgress', _id: any, user: string, resourceId: string, broadcast: string, completionStatus: EnumCourseProgressCompletionStatus, successStatus?: EnumCourseProgressSuccessStatus | null, scoreScaled?: number | null, scoreRaw?: number | null, location?: string | null, suspendData?: string | null, totalTime?: string | null, progressMeasure?: number | null, lastAccessedAt: any, completedAt?: any | null, scormVersion?: string | null } | null };

export type CreateBulkConnectLogMutationVariables = Exact<{
  input: CreateBulkConnectLogInput;
}>;


export type CreateBulkConnectLogMutation = { __typename?: 'Mutation', createBulkConnectLog?: { __typename?: 'BulkConnectLog', _id: any, totalCount: number, successCount: number, alreadyConnectedCount: number, errorCount: number, appliedBackOfficeTagIds: Array<any | null> } | null };

export type OrderCreateMutationVariables = Exact<{
  source: OrderSourceInput;
  customer: PeopleInput;
  guests: Array<InputMaybe<OrderGuestsInput>> | InputMaybe<OrderGuestsInput>;
  paymentMethodId: Scalars['String']['input'];
  productPurchaseRequests: Array<InputMaybe<ProductPurchaseRequest>> | InputMaybe<ProductPurchaseRequest>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  surveyResponse?: InputMaybe<SurveyResponseInput>;
  taxExemption?: InputMaybe<OrderTaxExemptionInput>;
  delivery?: InputMaybe<OrderDeliveryInput>;
  messageFromGuest?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderCreateMutation = { __typename?: 'Mutation', orderCreate?: { __typename?: 'CreateOneOrderPayload', clientSecret?: string | null, record?: { __typename?: 'Order', _id: string } | null } | null };

export type CreatePublicationStatusMutationVariables = Exact<{
  record: CreateOnePublicationStatusInput;
}>;


export type CreatePublicationStatusMutation = { __typename?: 'Mutation', createPublicationStatus?: { __typename?: 'CreateOnePublicationStatusPayload', record?: { __typename?: 'PublicationStatus', _id: any, status?: PublicationStatusType | null, entity: { __typename?: 'VersionedEntityReference', _entityId: any, _versionId: any, type: EnumVersionedEntityReferenceType } } | null } | null };

export type CronJobRunMutationVariables = Exact<{
  jobName: Scalars['String']['input'];
}>;


export type CronJobRunMutation = { __typename?: 'Mutation', cronJobRun?: { __typename?: 'CronJobRunResult', success: boolean, jobName: string, status: string, durationMs?: number | null, error?: string | null } | null };

export type DevToolsEmailReplaceMutationVariables = Exact<{
  entries: Array<DevToolsEmailReplaceEntryInput> | DevToolsEmailReplaceEntryInput;
}>;


export type DevToolsEmailReplaceMutation = { __typename?: 'Mutation', devToolsEmailReplace: boolean };

export type DevToolsMembershipSeedCleanupMutationVariables = Exact<{
  runId: Scalars['MongoID']['input'];
}>;


export type DevToolsMembershipSeedCleanupMutation = { __typename?: 'Mutation', devToolsMembershipSeedCleanup?: { __typename?: 'DevMembershipSeedRun', _id: any, status?: DevMembershipSeedRunStatus | null, cleanedAt?: any | null, cleanedByName?: string | null, rows?: Array<{ __typename?: 'DevMembershipSeedRow', caseKey: string, cleanupMessages: Array<string> } | null> | null } | null };

export type DevToolsMembershipSeedCreateMutationVariables = Exact<{
  input: DevMembershipSeedInput;
}>;


export type DevToolsMembershipSeedCreateMutation = { __typename?: 'Mutation', devToolsMembershipSeedCreate?: { __typename?: 'DevMembershipSeedRun', _id: any, organization: any, status?: DevMembershipSeedRunStatus | null, createdByName?: string | null, createdDateISO?: any | null, rows?: Array<{ __typename?: 'DevMembershipSeedRow', caseKey: string, mode?: DevMembershipSeedMode | null, subjectType?: DevMembershipSeedSubjectType | null, entityComposition?: DevMembershipSeedEntityComposition | null, publicationStatus?: DevMembershipSeedPublicationStatus | null, blocked: boolean, blockReason?: string | null, warnings: Array<string>, tierName?: string | null, statusTagNames: Array<string>, renewalDate?: string | null, renewalPhase?: string | null, rateKind?: DevMembershipSeedRateKind | null, rateLabel?: string | null, operatorEntityId?: string | null, operatorName?: string | null, personId?: string | null, personEmail?: string | null, membershipId?: string | null, originalOrderId?: string | null, renewablePurchaseId?: string | null, validationOk: boolean, validationMessages: Array<string> } | null> | null } | null };

export type DevToolsProdSyncMutationVariables = Exact<{
  collectionsToSkip?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DevToolsProdSyncMutation = { __typename?: 'Mutation', devToolsProdSync?: { __typename?: 'ProdSyncResult', success: boolean, totalDocumentsCopied: number, durationMs: number, errors: Array<string>, collections?: Array<{ __typename?: 'ProdSyncCollectionResult', name: string, documentsCopied: number, skipped: boolean, error?: string | null } | null> | null } | null };

export type DirectoryBulkInviteMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  viewContext?: InputMaybe<BulkInviteViewContext>;
  tagFilters?: InputMaybe<Array<InputMaybe<BulkInviteTagFilterInput>> | InputMaybe<BulkInviteTagFilterInput>>;
  recipientMode?: InputMaybe<BulkInviteRecipientMode>;
  includeDmoManaged?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DirectoryBulkInviteMutation = { __typename?: 'Mutation', directoryBulkInvite?: { __typename?: 'DirectoryBulkInviteResult', queuedListings: number, queuedRecipients: number, skipped: number } | null };

export type DiscountCreateMutationVariables = Exact<{
  record: CreateOneDiscountInput;
}>;


export type DiscountCreateMutation = { __typename?: 'Mutation', discountCreate?: { __typename?: 'CreateOneDiscountPayload', recordId?: any | null, record?: { __typename?: 'Discount', _id: any, amount: number, canCombine: boolean, currentUsageCount: number, daysInAdvance?: number | null, maxDaysInAdvance?: number | null, excludeUpsells: boolean, isActive: boolean, isOngoing: boolean, maxNights?: number | null, maxUsageCount?: number | null, minGuestCount?: number | null, minNights?: number | null, minQuantity?: number | null, minSubtotal?: number | null, buyQuantity?: number | null, getQuantity?: number | null, perTicket: boolean, perTicketApplyFrom?: number | null, promoCode?: string | null, storefront: any, type: EnumDiscountType, unit: EnumDiscountUnit, discountActivePeriod?: { __typename?: 'DateRangeISOOptional', _id: any, end?: string | null, start?: string | null } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type DiscountUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdDiscountInput;
}>;


export type DiscountUpdateMutation = { __typename?: 'Mutation', discountUpdate?: { __typename?: 'UpdateByIdDiscountPayload', recordId?: any | null, record?: { __typename?: 'Discount', _id: any, amount: number, canCombine: boolean, currentUsageCount: number, daysInAdvance?: number | null, maxDaysInAdvance?: number | null, excludeUpsells: boolean, isActive: boolean, isOngoing: boolean, maxNights?: number | null, maxUsageCount?: number | null, minGuestCount?: number | null, minNights?: number | null, minQuantity?: number | null, minSubtotal?: number | null, buyQuantity?: number | null, getQuantity?: number | null, perTicket: boolean, perTicketApplyFrom?: number | null, promoCode?: string | null, storefront: any, type: EnumDiscountType, unit: EnumDiscountUnit, discountActivePeriod?: { __typename?: 'DateRangeISOOptional', _id: any, end?: string | null, start?: string | null } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type DiscountValidatePromocodeMutationVariables = Exact<{
  promoCode: Scalars['String']['input'];
  storefrontId: Scalars['ID']['input'];
  bookerId?: InputMaybe<Scalars['ID']['input']>;
  productPurchaseRequests?: InputMaybe<Array<ProductPurchaseRequest> | ProductPurchaseRequest>;
}>;


export type DiscountValidatePromocodeMutation = { __typename?: 'Mutation', discountValidatePromocode?: { __typename?: 'Discount', promoCode?: string | null } | null };

export type EventCreateMutationVariables = Exact<{
  record: CreateOneEventInput;
}>;


export type EventCreateMutation = { __typename?: 'Mutation', eventCreate?: { __typename?: 'CreateOneEventPayload', recordId?: any | null, record?: { __typename?: 'Event', _id: any, createdByEmail: string, createdByFirstName?: string | null, createdByLastName?: string | null, createdByPerson?: any | null, submitterPersonId?: any | null, locationType: EnumEventLocationType, price?: string | null, ticketUrl?: string | null, type: EnumEventType, startDate: string, endDate?: string | null, suspectedDuplicateOf?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, eventOrganizer: { __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null }, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tags?: { __typename?: 'EventTags', global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null, eventLocations: Array<{ __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null } | null>, attentionIssues: Array<{ __typename?: 'EventAttentionIssues', type: EnumEventAttentionIssuesType, sourceName?: string | null, venueIndex?: number | null } | null>, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, schedules: Array<{ __typename?: 'EventSchedules', allDay: boolean, timeSlots?: Array<{ __typename?: 'EventSchedulesTimeSlots', _id?: any | null, from?: string | null, to?: string | null, endsNextDay?: boolean | null, note?: string | null } | null> | null } | null>, recurrencePattern: { __typename?: 'EventRecurrencePattern', frequency: EnumEventRecurrencePatternFrequency, interval?: number | null, daysOfWeek?: Array<EnumEventRecurrencePatternDaysOfWeek | null> | null, dateOfMonth?: number | null, dayOfMonth?: EnumEventRecurrencePatternDayOfMonth | null, dayOfMonthOccurrence?: number | null, monthAndDateOfYear?: string | null, multiDates?: Array<string | null> | null, skipDates?: Array<string | null> | null, endDate?: string | null }, access: { __typename?: 'EventAccess', disconnectedOrganizations?: Array<any | null> | null, operator?: { __typename?: 'EventAccessOperator', _entityId: any } | null, organizations: Array<{ __typename?: 'EventAccessOperator', _entityId: any, status?: EnumEventAccessOperatorStatus | null, source?: EnumEventAccessOperatorSource | null, addedVia?: any | null } | null> }, history: Array<{ __typename?: 'EventHistory', action: EnumEventHistoryAction, timestamp: any, sourceType?: EnumEventHistorySourceType | null, userId?: any | null, userEmail?: string | null, userName?: string | null, organizationId?: any | null, note?: string | null } | null> } | null } | null };

export type EventDeleteByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type EventDeleteByIdMutation = { __typename?: 'Mutation', eventDeleteById?: { __typename?: 'RemoveByIdEventPayload', record?: { __typename?: 'Event', _id: any } | null } | null };

export type EventDisconnectOrganizationMutationVariables = Exact<{
  eventId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
}>;


export type EventDisconnectOrganizationMutation = { __typename?: 'Mutation', eventDisconnectOrganization?: { __typename?: 'EventDisconnectOrganizationPayload', record?: { __typename?: 'Event', _id: any, createdByEmail: string, createdByFirstName?: string | null, createdByLastName?: string | null, createdByPerson?: any | null, submitterPersonId?: any | null, locationType: EnumEventLocationType, price?: string | null, ticketUrl?: string | null, type: EnumEventType, startDate: string, endDate?: string | null, suspectedDuplicateOf?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, eventOrganizer: { __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null }, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tags?: { __typename?: 'EventTags', global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null, eventLocations: Array<{ __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null } | null>, attentionIssues: Array<{ __typename?: 'EventAttentionIssues', type: EnumEventAttentionIssuesType, sourceName?: string | null, venueIndex?: number | null } | null>, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, schedules: Array<{ __typename?: 'EventSchedules', allDay: boolean, timeSlots?: Array<{ __typename?: 'EventSchedulesTimeSlots', _id?: any | null, from?: string | null, to?: string | null, endsNextDay?: boolean | null, note?: string | null } | null> | null } | null>, recurrencePattern: { __typename?: 'EventRecurrencePattern', frequency: EnumEventRecurrencePatternFrequency, interval?: number | null, daysOfWeek?: Array<EnumEventRecurrencePatternDaysOfWeek | null> | null, dateOfMonth?: number | null, dayOfMonth?: EnumEventRecurrencePatternDayOfMonth | null, dayOfMonthOccurrence?: number | null, monthAndDateOfYear?: string | null, multiDates?: Array<string | null> | null, skipDates?: Array<string | null> | null, endDate?: string | null }, access: { __typename?: 'EventAccess', disconnectedOrganizations?: Array<any | null> | null, operator?: { __typename?: 'EventAccessOperator', _entityId: any } | null, organizations: Array<{ __typename?: 'EventAccessOperator', _entityId: any, status?: EnumEventAccessOperatorStatus | null, source?: EnumEventAccessOperatorSource | null, addedVia?: any | null } | null> }, history: Array<{ __typename?: 'EventHistory', action: EnumEventHistoryAction, timestamp: any, sourceType?: EnumEventHistorySourceType | null, userId?: any | null, userEmail?: string | null, userName?: string | null, organizationId?: any | null, note?: string | null } | null> } | null } | null };

export type EventInventorySettingsUpsertMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  defaultCapacityPerSession?: InputMaybe<Scalars['Int']['input']>;
  sessionOverrides?: InputMaybe<Array<InputMaybe<EventSessionCapacityOverrideInput>> | InputMaybe<EventSessionCapacityOverrideInput>>;
}>;


export type EventInventorySettingsUpsertMutation = { __typename?: 'Mutation', eventInventorySettingsUpsert?: { __typename?: 'EventInventorySettings', event: any, defaultCapacityPerSession?: number | null, sessionOverrides?: Array<{ __typename?: 'EventInventorySettingsSessionOverrides', sessionId: string, capacity: number } | null> | null } | null };

export type EventUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdEventInput;
  imagesToKeep?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  setStatus?: InputMaybe<EnumEventAccessOperatorStatus>;
  setOrganizationTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
  isSubmitting?: InputMaybe<Scalars['Boolean']['input']>;
  clearAttentionIssues?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EventUpdateByIdMutation = { __typename?: 'Mutation', eventUpdateById?: { __typename?: 'UpdateByIdEventPayload', record?: { __typename?: 'Event', _id: any, createdByEmail: string, createdByFirstName?: string | null, createdByLastName?: string | null, createdByPerson?: any | null, submitterPersonId?: any | null, locationType: EnumEventLocationType, price?: string | null, ticketUrl?: string | null, type: EnumEventType, startDate: string, endDate?: string | null, suspectedDuplicateOf?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, eventOrganizer: { __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null }, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tags?: { __typename?: 'EventTags', global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null, eventLocations: Array<{ __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null } | null>, attentionIssues: Array<{ __typename?: 'EventAttentionIssues', type: EnumEventAttentionIssuesType, sourceName?: string | null, venueIndex?: number | null } | null>, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, schedules: Array<{ __typename?: 'EventSchedules', allDay: boolean, timeSlots?: Array<{ __typename?: 'EventSchedulesTimeSlots', _id?: any | null, from?: string | null, to?: string | null, endsNextDay?: boolean | null, note?: string | null } | null> | null } | null>, recurrencePattern: { __typename?: 'EventRecurrencePattern', frequency: EnumEventRecurrencePatternFrequency, interval?: number | null, daysOfWeek?: Array<EnumEventRecurrencePatternDaysOfWeek | null> | null, dateOfMonth?: number | null, dayOfMonth?: EnumEventRecurrencePatternDayOfMonth | null, dayOfMonthOccurrence?: number | null, monthAndDateOfYear?: string | null, multiDates?: Array<string | null> | null, skipDates?: Array<string | null> | null, endDate?: string | null }, access: { __typename?: 'EventAccess', disconnectedOrganizations?: Array<any | null> | null, operator?: { __typename?: 'EventAccessOperator', _entityId: any } | null, organizations: Array<{ __typename?: 'EventAccessOperator', _entityId: any, status?: EnumEventAccessOperatorStatus | null, source?: EnumEventAccessOperatorSource | null, addedVia?: any | null } | null> }, history: Array<{ __typename?: 'EventHistory', action: EnumEventHistoryAction, timestamp: any, sourceType?: EnumEventHistorySourceType | null, userId?: any | null, userEmail?: string | null, userName?: string | null, organizationId?: any | null, note?: string | null } | null> } | null } | null };

export type FeatureFlagCreateMutationVariables = Exact<{
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  group: Scalars['String']['input'];
}>;


export type FeatureFlagCreateMutation = { __typename?: 'Mutation', featureFlagCreate?: { __typename?: 'FeatureFlag', _id: any, key: string, name: string, description?: string | null, group: string } | null };

export type FeatureFlagGraduateMutationVariables = Exact<{
  featureFlagId: Scalars['MongoID']['input'];
}>;


export type FeatureFlagGraduateMutation = { __typename?: 'Mutation', featureFlagGraduate?: { __typename?: 'GraduateResult', success: boolean, error?: string | null } | null };

export type FeatureFlagUngraduateMutationVariables = Exact<{
  featureFlagId: Scalars['MongoID']['input'];
}>;


export type FeatureFlagUngraduateMutation = { __typename?: 'Mutation', featureFlagUngraduate?: { __typename?: 'GraduateResult', success: boolean, error?: string | null } | null };

export type FeatureFlagUpdateMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
}>;


export type FeatureFlagUpdateMutation = { __typename?: 'Mutation', featureFlagUpdate?: { __typename?: 'FeatureFlag', _id: any, key: string, name: string, description?: string | null, group: string } | null };

export type FeatureGateResetMutationVariables = Exact<{
  featureFlagId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
}>;


export type FeatureGateResetMutation = { __typename?: 'Mutation', featureGateReset?: { __typename?: 'ToggleGateResult', success: boolean, error?: string | null } | null };

export type FeatureGateToggleMutationVariables = Exact<{
  featureFlagId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type FeatureGateToggleMutation = { __typename?: 'Mutation', featureGateToggle?: { __typename?: 'ToggleGateResult', success: boolean, error?: string | null } | null };

export type FileCreateOneMutationVariables = Exact<{
  data: Scalars['JSON']['input'];
  defaultCaption?: InputMaybe<MultilingualInput>;
}>;


export type FileCreateOneMutation = { __typename?: 'Mutation', fileCreateOne: { __typename?: 'AssetFile', _id: string, blurhash: string, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } };

export type FileDeleteFromCloudinaryOnlyMutationVariables = Exact<{
  cloudinaryPublicId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
}>;


export type FileDeleteFromCloudinaryOnlyMutation = { __typename?: 'Mutation', fileDeleteFromCloudinaryOnly: boolean };

export type FileUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  record: UpdateByIdAssetFileInput;
}>;


export type FileUpdateMutation = { __typename?: 'Mutation', fileUpdate?: { __typename?: 'UpdateByIdAssetFilePayload', record?: { __typename?: 'AssetFile', _id: string, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type FulfillmentProfileCreateMutationVariables = Exact<{
  record: CreateOneFulfillmentProfileInput;
}>;


export type FulfillmentProfileCreateMutation = { __typename?: 'Mutation', fulfillmentProfileCreate?: { __typename?: 'CreateOneFulfillmentProfilePayload', recordId?: any | null, record?: { __typename?: 'FulfillmentProfile', _id: any, name: string, isActive: boolean, storefront: any, pickup?: { __typename?: 'FulfillmentProfilePickup', enabled?: boolean | null, locations?: Array<{ __typename?: 'FulfillmentProfilePickupLocations', _id?: any | null, name: string, address?: string | null, instructions?: string | null } | null> | null } | null, shipping?: { __typename?: 'FulfillmentProfileShipping', enabled?: boolean | null, taxable?: boolean | null, zones?: Array<{ __typename?: 'FulfillmentProfileShippingZones', _id?: any | null, name: string, countries?: Array<string | null> | null, subdivisions?: Array<string | null> | null, flatRate: number, perAdditionalItem?: number | null, freeOver?: number | null } | null> | null } | null } | null } | null };

export type FulfillmentProfileUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdFulfillmentProfileInput;
}>;


export type FulfillmentProfileUpdateMutation = { __typename?: 'Mutation', fulfillmentProfileUpdate?: { __typename?: 'UpdateByIdFulfillmentProfilePayload', recordId?: any | null, record?: { __typename?: 'FulfillmentProfile', _id: any, name: string, isActive: boolean, storefront: any, pickup?: { __typename?: 'FulfillmentProfilePickup', enabled?: boolean | null, locations?: Array<{ __typename?: 'FulfillmentProfilePickupLocations', _id?: any | null, name: string, address?: string | null, instructions?: string | null } | null> | null } | null, shipping?: { __typename?: 'FulfillmentProfileShipping', enabled?: boolean | null, taxable?: boolean | null, zones?: Array<{ __typename?: 'FulfillmentProfileShippingZones', _id?: any | null, name: string, countries?: Array<string | null> | null, subdivisions?: Array<string | null> | null, flatRate: number, perAdditionalItem?: number | null, freeOver?: number | null } | null> | null } | null } | null } | null };

export type GalleryNewMediaDismissMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type GalleryNewMediaDismissMutation = { __typename?: 'Mutation', galleryNewMediaDismiss: { __typename?: 'GalleryNewMedia', _id: any, status: EnumGalleryNewMediaStatus, resolvedAt?: any | null } };

export type GalleryNewMediaPromoteMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  widgetIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type GalleryNewMediaPromoteMutation = { __typename?: 'Mutation', galleryNewMediaPromote?: any | null };

export type ImageAnalyzeMutationVariables = Exact<{
  assetId: Scalars['String']['input'];
}>;


export type ImageAnalyzeMutation = { __typename?: 'Mutation', imageAnalyze: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } };

export type ImageCreateOneMutationVariables = Exact<{
  data: Scalars['JSON']['input'];
  defaultCaption?: InputMaybe<MultilingualInput>;
}>;


export type ImageCreateOneMutation = { __typename?: 'Mutation', imageCreateOne: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } };

export type ImageDeleteFromCloudinaryOnlyMutationVariables = Exact<{
  cloudinaryPublicId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
}>;


export type ImageDeleteFromCloudinaryOnlyMutation = { __typename?: 'Mutation', imageDeleteFromCloudinaryOnly: boolean };

export type ImageUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  record: UpdateByIdAssetImageInput;
}>;


export type ImageUpdateMutation = { __typename?: 'Mutation', imageUpdate?: { __typename?: 'UpdateByIdAssetImagePayload', record?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } | null };

export type ImportCreateMutationVariables = Exact<{
  record: CreateOneImportInput;
}>;


export type ImportCreateMutation = { __typename?: 'Mutation', importCreate?: { __typename?: 'CreateOneImportPayload', record?: { __typename?: 'Import', _id: any, name: string, importType?: ImportType | null, organization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, googleSheetsConfig: { __typename?: 'ImportGoogleSheetsConfig', sheetUrl?: string | null, sheetId?: string | null, range?: string | null } } | null } | null };

export type ImportPreviewMutationVariables = Exact<{
  importId?: InputMaybe<Scalars['MongoID']['input']>;
  googleSheetsConfig?: InputMaybe<ImportGoogleSheetsConfigInput>;
  importType?: InputMaybe<ImportType>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type ImportPreviewMutation = { __typename?: 'Mutation', importPreview?: { __typename?: 'ImportPreviewResult', operatorCount: number, totalRowCount: number, sampleOperators?: Array<any | null> | null, errors: Array<string>, notifications: Array<string> } | null };

export type ImportRunCancelMutationVariables = Exact<{
  importRunId: Scalars['MongoID']['input'];
}>;


export type ImportRunCancelMutation = { __typename?: 'Mutation', importRunCancel?: { __typename?: 'ImportRunCancelResult', success: boolean, deletedCount: number, imagesDeleted: number, errors: Array<string> } | null };

export type ImportRunCreateMutationVariables = Exact<{
  importId: Scalars['MongoID']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  checkForExistingOperators?: InputMaybe<Scalars['Boolean']['input']>;
  startingRow?: InputMaybe<Scalars['Int']['input']>;
  skipImages?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ImportRunCreateMutation = { __typename?: 'Mutation', importRunCreate?: { __typename?: 'ImportRunResult', importRunId: any, operatorCount: number, errors: Array<string>, status: string } | null };

export type ImportRunDeleteMutationVariables = Exact<{
  importRunId: Scalars['MongoID']['input'];
}>;


export type ImportRunDeleteMutation = { __typename?: 'Mutation', importRunDelete?: { __typename?: 'ImportRunDeleteResult', success: boolean, message: string } | null };

export type ImportRunMoveOperatorsToConnectedMutationVariables = Exact<{
  importRunId: Scalars['MongoID']['input'];
  operatorEntityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ImportRunMoveOperatorsToConnectedMutation = { __typename?: 'Mutation', importRunMoveOperatorsToConnected?: { __typename?: 'ImportRunMoveOperatorsResult', success: boolean, message: string } | null };

export type ImportRunRollbackMutationVariables = Exact<{
  importRunId: Scalars['MongoID']['input'];
}>;


export type ImportRunRollbackMutation = { __typename?: 'Mutation', importRunRollback?: { __typename?: 'ImportRunRollbackResult', success: boolean, deletedCount: number, errors: Array<string> } | null };

export type ImportRunStartMutationVariables = Exact<{
  importRunId: Scalars['MongoID']['input'];
}>;


export type ImportRunStartMutation = { __typename?: 'Mutation', importRunStart?: { __typename?: 'ImportRunResult', importRunId: any, operatorCount: number, errors: Array<string>, status: string } | null };

export type ImportScrapeGenerateSheetMutationVariables = Exact<{
  scrapeId: Scalars['MongoID']['input'];
  sheetName: Scalars['String']['input'];
}>;


export type ImportScrapeGenerateSheetMutation = { __typename?: 'Mutation', importScrapeGenerateSheet?: { __typename?: 'ImportScrapeGenerateSheetPayload', sheetUrl: string, sheetId: string, scrape?: { __typename?: 'ImportScrape', _id: any, name: string, googleSheetsConfig?: { __typename?: 'ImportScrapeGoogleSheetsConfig', sheetUrl?: string | null, sheetId?: string | null, sheetName?: string | null } | null } | null } | null };

export type ImportUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdImportInput;
}>;


export type ImportUpdateMutation = { __typename?: 'Mutation', importUpdate?: { __typename?: 'UpdateByIdImportPayload', record?: { __typename?: 'Import', _id: any, name: string, importType?: ImportType | null, organization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, googleSheetsConfig: { __typename?: 'ImportGoogleSheetsConfig', sheetUrl?: string | null, sheetId?: string | null, range?: string | null, apiKey?: string | null, serviceAccountKey?: string | null } } | null } | null };

export type InviteQueueAcceptFreshenMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
}>;


export type InviteQueueAcceptFreshenMutation = { __typename?: 'Mutation', inviteQueueAcceptFreshen?: { __typename?: 'InviteQueueAcceptFreshenResult', updatedCount: number } | null };

export type InviteQueueCancelByIdMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type InviteQueueCancelByIdMutation = { __typename?: 'Mutation', inviteQueueCancelById: { __typename?: 'InviteQueue', _id: any, inviteStatus: EnumInviteQueueInviteStatus, createdDateISO?: any | null, initiatedDate: any, initiatedByUserName: string } };

export type InviteQueueCleanupMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  convertToDmoManaged: Scalars['Boolean']['input'];
  criteria: InviteQueueCleanupCriteriaInput;
}>;


export type InviteQueueCleanupMutation = { __typename?: 'Mutation', inviteQueueCleanup?: { __typename?: 'InviteQueueCleanupResult', cancelledCount: number } | null };

export type InviteQueueCreateOneMutationVariables = Exact<{
  operatorEntityId: Scalars['MongoID']['input'];
  operatorName: Scalars['String']['input'];
  organizationId: Scalars['MongoID']['input'];
  inviteByEmailOnly?: InputMaybe<Scalars['Boolean']['input']>;
  invitedEmail?: InputMaybe<Scalars['String']['input']>;
  invitedUserId?: InputMaybe<Scalars['MongoID']['input']>;
  invitedUserName?: InputMaybe<Scalars['String']['input']>;
  inviteStatus?: InputMaybe<Scalars['String']['input']>;
}>;


export type InviteQueueCreateOneMutation = { __typename?: 'Mutation', inviteQueueCreateOne: { __typename?: 'InviteQueue', _id: any, invitedOperator: any, invitedOperatorName: string, inviteByEmailOnly: boolean, invitedEmail?: string | null, invitedUser?: any | null, invitedUserName?: string | null, initiatedByUser: any, initiatedByUserName: string, initiatedDate: any, organizationId?: any | null, organizationName?: string | null, inviteStatus: EnumInviteQueueInviteStatus, createdDateISO?: any | null } };

export type InviteQueueFreshenMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type InviteQueueFreshenMutation = { __typename?: 'Mutation', inviteQueueFreshen?: { __typename?: 'InviteQueueFreshenResult', success: boolean, activityLogId?: any | null } | null };

export type InviteQueueReinviteByEmailMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  email: Scalars['String']['input'];
  recordIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type InviteQueueReinviteByEmailMutation = { __typename?: 'Mutation', inviteQueueReinviteByEmail?: { __typename?: 'InviteQueueReinviteByEmailResult', success: boolean, activityLogId?: any | null } | null };

export type InviteQueueSendInvitesMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  mode: Scalars['String']['input'];
  minDaysSinceInvite?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InviteQueueSendInvitesMutation = { __typename?: 'Mutation', inviteQueueSendInvites?: { __typename?: 'InviteQueueSendInvitesResult', started: boolean, totalToSend: number, alreadyProcessing: boolean } | null };

export type ItineraryDeleteMutationVariables = Exact<{
  itineraryId: Scalars['ID']['input'];
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ItineraryDeleteMutation = { __typename?: 'Mutation', itineraryDelete: boolean };

export type LeadRemoveByIdMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LeadRemoveByIdMutation = { __typename?: 'Mutation', leadRemoveById: { __typename?: 'Lead', _id: any, subject?: string | null, link?: string | null, status: EnumLeadStatus, type?: EnumLeadType | null, source?: EnumLeadSource | null, sourceDetails?: string | null, broadcastId?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, messages: Array<{ __typename?: 'LeadMessages', message: string, sender: EnumLeadMessagesSender, sentAtDateISO: any } | null>, metadata: { __typename?: 'LeadMetadata', booker?: { __typename?: 'Booker', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, bundles: Array<{ __typename?: 'BookerBundles', product?: { __typename?: 'Product', name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null> } | null, storefront?: { __typename?: 'Storefront', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, organization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, operator?: { __typename?: 'OperatorWithStatus', _id: any, _entityId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }, person?: { __typename?: 'SimplePersonTC', _id: string, firstName: string, lastName: string, email: string, phone?: string | null } | null, surveyResponse?: { __typename?: 'SurveyResponse', _id: any, survey?: { __typename?: 'Survey', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, responses: Array<{ __typename?: 'SurveyResponseResponses', response: Array<string | null>, questionData: { __typename?: 'SurveyQuestion', type: EnumSurveyQuestionType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } } | null> } | null } };

export type LeadUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdLeadInput;
}>;


export type LeadUpdateByIdMutation = { __typename?: 'Mutation', leadUpdateById?: { __typename?: 'UpdateByIdLeadPayload', recordId?: any | null, record?: { __typename?: 'Lead', _id: any, subject?: string | null, link?: string | null, status: EnumLeadStatus, type?: EnumLeadType | null, source?: EnumLeadSource | null, sourceDetails?: string | null, broadcastId?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, messages: Array<{ __typename?: 'LeadMessages', message: string, sender: EnumLeadMessagesSender, sentAtDateISO: any } | null>, metadata: { __typename?: 'LeadMetadata', booker?: { __typename?: 'Booker', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, bundles: Array<{ __typename?: 'BookerBundles', product?: { __typename?: 'Product', name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null> } | null, storefront?: { __typename?: 'Storefront', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, organization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, operator?: { __typename?: 'OperatorWithStatus', _id: any, _entityId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }, person?: { __typename?: 'SimplePersonTC', _id: string, firstName: string, lastName: string, email: string, phone?: string | null } | null, surveyResponse?: { __typename?: 'SurveyResponse', _id: any, survey?: { __typename?: 'Survey', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, responses: Array<{ __typename?: 'SurveyResponseResponses', response: Array<string | null>, questionData: { __typename?: 'SurveyQuestion', type: EnumSurveyQuestionType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } } | null> } | null } | null } | null };

export type ListCreateListsForAudiencesMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type ListCreateListsForAudiencesMutation = { __typename?: 'Mutation', listCreateListsForAudiences?: Array<{ __typename?: 'List', _id: any, type: EnumListType, kind: EnumListKind, audienceTagId?: any | null, audienceListKey?: EnumListAudienceListKey | null, archived: boolean, favorited: boolean, orderIndex?: number | null, locked: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> | null };

export type ListCreateMembersForTiersMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type ListCreateMembersForTiersMutation = { __typename?: 'Mutation', listCreateMembersForTiers?: Array<{ __typename?: 'List', _id: any, type: EnumListType, kind: EnumListKind, tierTagId?: any | null, memberListKey?: EnumListMemberListKey | null, archived: boolean, favorited: boolean, orderIndex?: number | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, entityReferences: Array<{ __typename?: 'VersionedEntityReference', _entityId: any, _versionId: any, type: EnumVersionedEntityReferenceType } | null> }> | null };

export type ListCreateMutationVariables = Exact<{
  record: CreateOneListInput;
}>;


export type ListCreateMutation = { __typename?: 'Mutation', listCreate?: { __typename?: 'CreateOneListPayload', record?: { __typename?: 'List', _id: any, selections: any, type: EnumListType, kind: EnumListKind, tierTagId?: any | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, entityReferences: Array<{ __typename?: 'VersionedEntityReference', _entityId: any, _versionId: any, type: EnumVersionedEntityReferenceType } | null> } | null } | null };

export type ListDeleteByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ListDeleteByIdMutation = { __typename?: 'Mutation', listDeleteById?: { __typename?: 'RemoveByIdListPayload', recordId?: any | null } | null };

export type ListUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdListInput;
}>;


export type ListUpdateByIdMutation = { __typename?: 'Mutation', listUpdateById: { __typename?: 'ListWithEntities', _id: any, type: EnumListType, kind: EnumListKind, tierTagId?: any | null, filterTagIds: Array<any | null>, selections: any, archived: boolean, favorited: boolean, orderIndex?: number | null, locked: boolean, lockedAt?: any | null, lockedBy?: any | null, lockedByName?: string | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } };

export type MembershipAdminCancelMutationVariables = Exact<{
  operatorEntityId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
}>;


export type MembershipAdminCancelMutation = { __typename?: 'Mutation', membershipAdminCancel: boolean };

export type MembershipBulkSetStatusForListMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  listId: Scalars['MongoID']['input'];
  emailKind: PendingRenewalEmailKind;
  scheduleEmail: Scalars['Boolean']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MembershipBulkSetStatusForListMutation = { __typename?: 'Mutation', membershipBulkSetStatusForList?: { __typename?: 'MembershipBulkSetStatusResult', affected: number, scheduled: number, skipped: Array<{ __typename?: 'MembershipBulkSetStatusSkipped', entityId: any, name: string, paidThrough: any } | null> } | null };

export type MembershipCancelPendingRenewalEmailsMutationVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type MembershipCancelPendingRenewalEmailsMutation = { __typename?: 'Mutation', membershipCancelPendingRenewalEmails: number };

export type MembershipChecklistFixMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  action: Scalars['String']['input'];
  dryRun: Scalars['Boolean']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  statusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  fromStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  cyclePaid?: InputMaybe<Scalars['Boolean']['input']>;
  graceDays?: InputMaybe<Scalars['Int']['input']>;
  neverExpire?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MembershipChecklistFixMutation = { __typename?: 'Mutation', membershipChecklistFix: { __typename?: 'MembershipChecklistFixResult', affected: number, date?: any | null, phaseAfter?: string | null, grace?: { __typename?: 'RenewalRebaseGrace', overdueCount: number, targetDate?: any | null, nextRenewalDate?: any | null, currentGraceDays: number, currentGraceIsDefault: boolean, currentGraceEndsOn?: any | null, currentNeverExpire: boolean, suggestedGraceDays?: number | null, graceDays: number, neverExpire: boolean, graceEndsOn?: any | null, wouldExpireOnNextSweep: number } | null, result?: { __typename?: 'MembershipChecklistResult', ranAt: any, analysis: { __typename?: 'MembershipChecklistAnalysis', memberListsEnabled: boolean, ledgerEnabled: boolean, members: { __typename?: 'MembershipChecklistMembers', total: number, totalListings: number, nonMembers: number, multipleTiers: number, tieredWithoutStatusTag: number, multipleTierListings: Array<{ __typename?: 'MembershipChecklistListing', entityId: string, name: string, tiers: Array<string> }>, byTier: Array<{ __typename?: 'MembershipChecklistTier', tagId: string, name: string, count: number, listId?: string | null, byStatus: Array<{ __typename?: 'MembershipChecklistTagCount', tagId: string, name: string, count: number }> }>, byStatus: Array<{ __typename?: 'MembershipChecklistTagCount', tagId: string, name: string, count: number }> }, renewal: { __typename?: 'MembershipChecklistRenewal', engineEnabled: boolean, enabled: boolean, renewalType?: string | null, term?: string | null, termYears?: number | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, activeStatusTagId?: string | null, activeStatusTagName?: string | null, attentionStatusTagIds?: Array<string> | null, withRenewalDate: number, withoutRenewalDate: number, paidUp: number, renewalWindow: number, expired: number, tagDrift: number, suggestedBulkDate?: any | null }, payment: { __typename?: 'MembershipChecklistPayment', enabled: boolean, hasStorefront: boolean, liveCadStorefrontId?: string | null, liveUsdStorefrontId?: string | null, testUsdStorefrontId?: string | null, byTier: Array<{ __typename?: 'MembershipChecklistPaymentTier', tagId: string, bookerId?: string | null, bookerStorefrontId?: string | null, isTest: boolean, free: boolean }> }, communication: { __typename?: 'MembershipChecklistCommunication', broadcastId?: string | null, broadcastName?: string | null, broadcastPublished: boolean, broadcastSharedToAll?: boolean | null, allowColdSignup: boolean } } } | null } };

export type MembershipChecklistRunMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
}>;


export type MembershipChecklistRunMutation = { __typename?: 'Mutation', membershipChecklistRun: { __typename?: 'MembershipChecklistResult', ranAt: any, analysis: { __typename?: 'MembershipChecklistAnalysis', memberListsEnabled: boolean, ledgerEnabled: boolean, members: { __typename?: 'MembershipChecklistMembers', total: number, totalListings: number, nonMembers: number, multipleTiers: number, tieredWithoutStatusTag: number, multipleTierListings: Array<{ __typename?: 'MembershipChecklistListing', entityId: string, name: string, tiers: Array<string> }>, byTier: Array<{ __typename?: 'MembershipChecklistTier', tagId: string, name: string, count: number, listId?: string | null, byStatus: Array<{ __typename?: 'MembershipChecklistTagCount', tagId: string, name: string, count: number }> }>, byStatus: Array<{ __typename?: 'MembershipChecklistTagCount', tagId: string, name: string, count: number }> }, renewal: { __typename?: 'MembershipChecklistRenewal', engineEnabled: boolean, enabled: boolean, renewalType?: string | null, term?: string | null, termYears?: number | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, activeStatusTagId?: string | null, activeStatusTagName?: string | null, attentionStatusTagIds?: Array<string> | null, withRenewalDate: number, withoutRenewalDate: number, paidUp: number, renewalWindow: number, expired: number, tagDrift: number, suggestedBulkDate?: any | null }, payment: { __typename?: 'MembershipChecklistPayment', enabled: boolean, hasStorefront: boolean, liveCadStorefrontId?: string | null, liveUsdStorefrontId?: string | null, testUsdStorefrontId?: string | null, byTier: Array<{ __typename?: 'MembershipChecklistPaymentTier', tagId: string, bookerId?: string | null, bookerStorefrontId?: string | null, isTest: boolean, free: boolean }> }, communication: { __typename?: 'MembershipChecklistCommunication', broadcastId?: string | null, broadcastName?: string | null, broadcastPublished: boolean, broadcastSharedToAll?: boolean | null, allowColdSignup: boolean } } } };

export type MembershipDeclineStatusEmailsMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  listId: Scalars['MongoID']['input'];
  statusTagId: Scalars['MongoID']['input'];
}>;


export type MembershipDeclineStatusEmailsMutation = { __typename?: 'Mutation', membershipDeclineStatusEmails: { __typename?: 'MembershipDeclineStatusEmailsResult', declined: number, skippedQueued: number, skippedContacted: number, skippedNoEmail: number } };

export type MembershipLaunchSetModeMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  mode: Scalars['String']['input'];
}>;


export type MembershipLaunchSetModeMutation = { __typename?: 'Mutation', membershipLaunchSetMode: { __typename?: 'Organization', _id: any } };

export type MembershipLaunchMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
}>;


export type MembershipLaunchMutation = { __typename?: 'Mutation', membershipLaunch: { __typename?: 'Organization', _id: any } };

export type MembershipRepairScheduleSnapshotsMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
}>;


export type MembershipRepairScheduleSnapshotsMutation = { __typename?: 'Mutation', membershipRepairScheduleSnapshots: { __typename?: 'MembershipScheduleRepair', checkouts: number, purchases: number } };

export type OrganizationRenewalScheduleApplyMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  kind: Scalars['String']['input'];
  month?: InputMaybe<Scalars['Int']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  outlierTarget?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  graceDays?: InputMaybe<Scalars['Int']['input']>;
  neverExpire?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationRenewalScheduleApplyMutation = { __typename?: 'Mutation', organizationRenewalScheduleApply: { __typename?: 'RenewalRebasePlan', affected: number, unchanged: number, undated: number, byPhase: { __typename?: 'RenewalRebasePhaseCounts', paidUp: number, renewalWindow: number, expired: number }, outliers: Array<{ __typename?: 'RenewalRebaseMember', subjectType: string, entityId: string, name: string, currentDate?: any | null, targetDate?: any | null }>, skipped: Array<{ __typename?: 'RenewalRebaseMember', subjectType: string, entityId: string, name: string, currentDate?: any | null, targetDate?: any | null }>, grace: { __typename?: 'RenewalRebaseGrace', overdueCount: number, targetDate?: any | null, nextRenewalDate?: any | null, currentGraceDays: number, currentGraceIsDefault: boolean, currentGraceEndsOn?: any | null, currentNeverExpire: boolean, suggestedGraceDays?: number | null, graceDays: number, neverExpire: boolean, graceEndsOn?: any | null, wouldExpireOnNextSweep: number }, from: { __typename?: 'RenewalScheduleSnapshot', fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null }, to: { __typename?: 'RenewalScheduleSnapshot', fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null } } };

export type MembershipMarkRenewedMutationVariables = Exact<{
  operatorEntityId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
}>;


export type MembershipMarkRenewedMutation = { __typename?: 'Mutation', membershipMarkRenewed: any };

export type MembershipQueueCustomEmailsMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  listId: Scalars['MongoID']['input'];
  operatorEntityIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  subject: Scalars['String']['input'];
  body: Scalars['String']['input'];
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  hideGreeting?: InputMaybe<Scalars['Boolean']['input']>;
  includeCoolingDown?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MembershipQueueCustomEmailsMutation = { __typename?: 'Mutation', membershipQueueCustomEmails: { __typename?: 'MembershipQueueCustomEmailsResult', queued: number, skippedQueued: number, skippedCoolingDown: number, skippedNoEmail: number } };

export type MembershipQueueStatusEmailsMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  listId: Scalars['MongoID']['input'];
  statusTagId: Scalars['MongoID']['input'];
  includeCoolingDown?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MembershipQueueStatusEmailsMutation = { __typename?: 'Mutation', membershipQueueStatusEmails: { __typename?: 'MembershipQueueStatusEmailsResult', queued: number, skippedContacted: number, skippedCoolingDown: number, skippedNoEmail: number, skippedQueued: number } };

export type MembershipScheduleRenewalEmailForListingsMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  operatorEntityIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  emailKind: PendingRenewalEmailKind;
  listId?: InputMaybe<Scalars['MongoID']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MembershipScheduleRenewalEmailForListingsMutation = { __typename?: 'Mutation', membershipScheduleRenewalEmailForListings?: Array<{ __typename?: 'PendingRenewalEmail', _id: any, emailKind: EnumPendingRenewalEmailEmailKind, scheduledSendAt: any, status: EnumPendingRenewalEmailStatus, subject: { __typename?: 'PendingRenewalEmailSubject', type: EnumPendingRenewalEmailSubjectType, entityId: any } } | null> | null };

export type MembershipSendPendingRenewalEmailsNowMutationVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  background?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MembershipSendPendingRenewalEmailsNowMutation = { __typename?: 'Mutation', membershipSendPendingRenewalEmailsNow?: { __typename?: 'MembershipSendPendingRenewalEmailsNowResult', sent: number, skipped: number, started?: number | null } | null };

export type MembershipSetManualRenewalDateMutationVariables = Exact<{
  operatorEntityId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type MembershipSetManualRenewalDateMutation = { __typename?: 'Mutation', membershipSetManualRenewalDate: boolean };

export type MerchVariantStockUpdateMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
  inventoryCount: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type MerchVariantStockUpdateMutation = { __typename?: 'Mutation', merchVariantStockUpdate?: { __typename?: 'Product', _id: any } | null };

export type EventSessionStockUpdateMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  sessionId: Scalars['String']['input'];
  remaining: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventSessionStockUpdateMutation = { __typename?: 'Mutation', eventSessionStockUpdate?: { __typename?: 'Product', _id: any } | null };

export type EventLowStockThresholdUpdateMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  lowStockThreshold?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventLowStockThresholdUpdateMutation = { __typename?: 'Mutation', eventLowStockThresholdUpdate?: { __typename?: 'Product', _id: any } | null };

export type MerchLowStockThresholdUpdateMutationVariables = Exact<{
  productId: Scalars['ID']['input'];
  lowStockThreshold?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MerchLowStockThresholdUpdateMutation = { __typename?: 'Mutation', merchLowStockThresholdUpdate?: { __typename?: 'Product', _id: any } | null };

export type NoteCreateOneMutationVariables = Exact<{
  record: CreateOneNoteInput;
}>;


export type NoteCreateOneMutation = { __typename?: 'Mutation', noteCreateOne?: { __typename?: 'CreateOneNotePayload', record?: { __typename?: 'Note', _id: any, message: string, isArchived: boolean, kind: EnumNoteKind, noteDateISO?: string | null, updatedDateISO?: any | null, createdDateISO?: any | null, author?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null, entity: { __typename?: 'EntityReference', _entityId: any, type: EnumEntityReferenceType }, mentions: Array<{ __typename?: 'User', _id: any, firstName: string, lastName: string }>, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, resolvedBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string } | null } | null } | null };

export type NoteRemoveByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type NoteRemoveByIdMutation = { __typename?: 'Mutation', noteRemoveById?: { __typename?: 'RemoveByIdNotePayload', record?: { __typename?: 'Note', _id: any, message: string, isArchived: boolean, kind: EnumNoteKind, noteDateISO?: string | null, updatedDateISO?: any | null, createdDateISO?: any | null, author?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null, entity: { __typename?: 'EntityReference', _entityId: any, type: EnumEntityReferenceType }, mentions: Array<{ __typename?: 'User', _id: any, firstName: string, lastName: string }>, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, resolvedBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string } | null } | null } | null };

export type NoteUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdNoteInput;
}>;


export type NoteUpdateByIdMutation = { __typename?: 'Mutation', noteUpdateById?: { __typename?: 'UpdateByIdNotePayload', record?: { __typename?: 'Note', _id: any, message: string, isArchived: boolean, kind: EnumNoteKind, noteDateISO?: string | null, updatedDateISO?: any | null, createdDateISO?: any | null, author?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null, entity: { __typename?: 'EntityReference', _entityId: any, type: EnumEntityReferenceType }, mentions: Array<{ __typename?: 'User', _id: any, firstName: string, lastName: string }>, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, resolvedBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string } | null } | null } | null };

export type OperatorAddExistingToOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  operatorEntityId: Scalars['ID']['input'];
  importRunId?: InputMaybe<Scalars['MongoID']['input']>;
  mergeOption?: InputMaybe<MergeOption>;
}>;


export type OperatorAddExistingToOrganizationMutation = { __typename?: 'Mutation', operatorAddExistingToOrganization: { __typename?: 'Operator', _id: any, _entityId: any, _versionId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } };

export type OperatorAiImageScanCreateMutationVariables = Exact<{
  operatorId: Scalars['String']['input'];
  websiteUrl: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type OperatorAiImageScanCreateMutation = { __typename?: 'Mutation', operatorAiImageScanCreate?: { __typename?: 'AiImageScanCreatePayload', taskId: any } | null };

export type OperatorAiImageScanExecuteMutationVariables = Exact<{
  taskId: Scalars['MongoID']['input'];
}>;


export type OperatorAiImageScanExecuteMutation = { __typename?: 'Mutation', operatorAiImageScanExecute?: { __typename?: 'AiImageScanExecutePayload', success: boolean, cancelled?: boolean | null, errorMessage?: string | null, result?: { __typename?: 'AiImageScanResult', images: Array<{ __typename?: 'AiImageScanImage', url: string, alt?: string | null, pageUrl?: string | null, isOgImage?: boolean | null } | null> } | null } | null };

export type OperatorAiImageScanUploadMutationVariables = Exact<{
  taskId: Scalars['MongoID']['input'];
  entityId: Scalars['String']['input'];
  urls: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OperatorAiImageScanUploadMutation = { __typename?: 'Mutation', operatorAiImageScanUpload?: { __typename?: 'AiImageScanUploadPayload', success: boolean, errorMessage?: string | null, assets?: Array<{ __typename?: 'AiImageScanUploadedAsset', _id: string, url: string, width?: number | null, height?: number | null } | null> | null } | null };

export type OperatorAiImageVerifyUrlsMutationVariables = Exact<{
  urls: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OperatorAiImageVerifyUrlsMutation = { __typename?: 'Mutation', operatorAiImageVerifyUrls?: { __typename?: 'AiImageVerifyUrlsPayload', results: Array<{ __typename?: 'AiImageVerifyResult', url: string, downloadable: boolean }> } | null };

export type OperatorAiProfileScanCreateMutationVariables = Exact<{
  operatorId: Scalars['String']['input'];
  websiteUrl: Scalars['String']['input'];
  fieldsRequested: Array<Scalars['String']['input']> | Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type OperatorAiProfileScanCreateMutation = { __typename?: 'Mutation', operatorAiProfileScanCreate?: { __typename?: 'AiProfileScanCreatePayload', taskId: any } | null };

export type OperatorAiProfileScanExecuteMutationVariables = Exact<{
  taskId: Scalars['MongoID']['input'];
}>;


export type OperatorAiProfileScanExecuteMutation = { __typename?: 'Mutation', operatorAiProfileScanExecute?: { __typename?: 'AiProfileScanExecutePayload', success: boolean, cancelled?: boolean | null, errorMessage?: string | null, result?: { __typename?: 'AiProfileScanResult', description?: string | null, shortDescription?: string | null, socialLinks?: any | null, email?: string | null, phone?: string | null, operatorType?: string | null, tags?: { __typename?: 'AiProfileScanTags', businessType?: Array<string | null> | null, amenity?: Array<string | null> | null, global?: Array<string | null> | null } | null, address?: { __typename?: 'AiProfileScanAddress', line1?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, coordinates?: { __typename?: 'AiProfileScanCoordinates', lng: number, lat: number } | null } | null } | null } | null };

export type OperatorBulkAcceptDraftsMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  operatorEntityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OperatorBulkAcceptDraftsMutation = { __typename?: 'Mutation', operatorBulkAcceptDrafts: number };

export type OperatorBulkApplyAudienceTagsMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  operatorEntityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  audienceTagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  action: Scalars['String']['input'];
}>;


export type OperatorBulkApplyAudienceTagsMutation = { __typename?: 'Mutation', operatorBulkApplyAudienceTags: boolean };

export type OperatorBulkApplyBackOfficeTagsMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  operatorEntityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  action: Scalars['String']['input'];
}>;


export type OperatorBulkApplyBackOfficeTagsMutation = { __typename?: 'Mutation', operatorBulkApplyBackOfficeTags: boolean };

export type OperatorCreateMutationVariables = Exact<{
  record: CreateOneOperatorInput;
}>;


export type OperatorCreateMutation = { __typename?: 'Mutation', operatorCreate?: { __typename?: 'CreateOneOperatorPayload', record?: { __typename?: 'Operator', _entityId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type OperatorDeleteMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
}>;


export type OperatorDeleteMutation = { __typename?: 'Mutation', operatorDelete: { __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, status?: PublicationStatusType | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } };

export type OperatorDeleteCompletelyByInternalMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
}>;


export type OperatorDeleteCompletelyByInternalMutation = { __typename?: 'Mutation', operatorDeleteCompletelyByInternal: boolean };

export type OperatorMarkDeletedByInternalMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
}>;


export type OperatorMarkDeletedByInternalMutation = { __typename?: 'Mutation', operatorMarkDeletedByInternal: { __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, status?: PublicationStatusType | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } };

export type OperatorUpdateMutationVariables = Exact<{
  record: UpdateByIdOperatorInput;
  entityId: Scalars['ID']['input'];
  isApproving?: InputMaybe<Scalars['Boolean']['input']>;
  whereabotContributed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OperatorUpdateMutation = { __typename?: 'Mutation', operatorUpdate: { __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, status?: PublicationStatusType | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, enrollments: Array<{ __typename?: 'OperatorEnrollments', organizationControlled: boolean, onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus, organization?: { __typename?: 'Organization', _id: any } | null } | null>, tags?: { __typename?: 'OperatorTags', organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, businessType: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, amenity: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null } };

export type OperatorUpdateContactRolesMutationVariables = Exact<{
  operatorEntityId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  contactRoles: Array<InputMaybe<ContactRole>> | InputMaybe<ContactRole>;
  title?: InputMaybe<Scalars['String']['input']>;
  entity: EntityReferenceInput;
}>;


export type OperatorUpdateContactRolesMutation = { __typename?: 'Mutation', operatorUpdateContactRoles: Array<{ __typename?: 'UserWithPictureTC', email: string, picture?: string | null, _id: any, personId?: string | null, firstName: string, lastName: string, title?: string | null, photoUploadedBy?: any | null, contactRoles?: Array<ContactRole | null> | null, status: EnumUserStatus, userType: EnumUserUserType, quickLinksVersion: number, lastViewedListId?: string | null, hasPurchases: boolean, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus, title?: string | null, contactRoles?: Array<EnumUserAccessOperatorsContactRoles | null> | null } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, storefronts: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null> }, onboardingMetadata?: { __typename?: 'UserOnboardingMetadata', onboardingOrganization?: any | null, isPostOnboarding?: boolean | null, onboardingBroadcast?: any | null } | null, emailPreferences: Array<{ __typename?: 'UserEmailPreferences', templateName: EnumUserEmailPreferencesTemplateName, frequency: EnumUserEmailPreferencesFrequency, entity?: { __typename?: 'EntityReference', type: EnumEntityReferenceType, _entityId: any } | null } | null>, quickLinks: Array<{ __typename?: 'UserQuickLinks', title: string, link: string, lastVisited: string, type: EnumUserQuickLinksType, entityId: string, pinned?: boolean | null } | null>, memberships: Array<{ __typename?: 'UserMembershipRow', _id: any, subjectType: string, listingName?: string | null, organizationId: any, organizationName: string, organizationLogo?: any | null, memberNomenclature: string, membershipNomenclature: string, tierName?: string | null, status: string, statusTagNames: Array<string>, renewalDate?: any | null, renewalDateDisplayMode: string, needsRenewal: boolean, tierTagId?: any | null, subjectEntityId: any, renewablePurchaseId?: any | null, renewalBilling?: string | null }> }> };

export type OperatorUpdateImagesMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  imagesToKeep?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  imagesToDelete?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isApproving?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OperatorUpdateImagesMutation = { __typename?: 'Mutation', operatorUpdateImages: { __typename?: 'OperatorWithStatus', status?: PublicationStatusType | null } };

export type OperatorWhereabotDismissMutationVariables = Exact<{
  operatorEntityId: Scalars['MongoID']['input'];
  scanType: Scalars['String']['input'];
}>;


export type OperatorWhereabotDismissMutation = { __typename?: 'Mutation', operatorWhereabotDismiss?: { __typename?: 'OperatorWhereabotDismissPayload', success: boolean } | null };

export type OrderApproveMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderApproveMutation = { __typename?: 'Mutation', orderApprove?: { __typename?: 'Order', _id: string, approval?: { __typename?: 'OrderApproval', status: EnumOrderApprovalStatus, decidedAt?: any | null } | null } | null };

export type OrderDeclineMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderDeclineMutation = { __typename?: 'Mutation', orderDecline?: { __typename?: 'Order', _id: string, cancelled: boolean, approval?: { __typename?: 'OrderApproval', status: EnumOrderApprovalStatus, decidedAt?: any | null, declineReason?: string | null } | null } | null };

export type OrderFulfillMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderFulfillMutation = { __typename?: 'Mutation', orderFulfill?: { __typename?: 'Order', _id: string, fulfillment?: { __typename?: 'OrderFulfillment', status?: EnumOrderFulfillmentStatus | null, note?: string | null, fulfilledAt?: string | null, carrier?: string | null, trackingNumber?: string | null } | null } | null };

export type OrderMarkAsPaidMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type OrderMarkAsPaidMutation = { __typename?: 'Mutation', orderMarkAsPaid?: { __typename?: 'Order', _id: string, stripeMetadata: { __typename?: 'StripeMetadata', chargeId: string, invoiceId?: string | null, invoiceStatus?: EnumStripeMetadataInvoiceStatus | null } } | null };

export type OrderSetArrivalMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  sessionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  guestIndexes?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  attendanceKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  arrived: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderSetArrivalMutation = { __typename?: 'Mutation', orderSetArrival?: { __typename?: 'Order', _id: string, arrivalHistory: Array<{ __typename?: 'OrderArrivalHistory', action: EnumOrderArrivalHistoryAction, source: EnumOrderArrivalHistorySource, sessionIds?: Array<string | null> | null, guestIndexes: Array<number | null>, attendanceKeys?: Array<string | null> | null, note?: string | null, timestamp: string, performedBy?: any | null, performedByName?: string | null } | null> } | null };

export type OrderUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  cancelled: Scalars['Boolean']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrderUpdateMutation = { __typename?: 'Mutation', orderUpdate?: { __typename?: 'UpdateByIdOrderPayload', recordId?: string | null, record?: { __typename?: 'Order', _id: string, cancelled: boolean } | null } | null };

export type OrgOperatorOverlayUpsertMutationVariables = Exact<{
  record: OrgOperatorOverlayUpsertInput;
}>;


export type OrgOperatorOverlayUpsertMutation = { __typename?: 'Mutation', orgOperatorOverlayUpsert?: { __typename?: 'OrgOperatorOverlay', _id: any, operator: any, createdDateISO?: any | null, updatedDateISO?: any | null, organization?: { __typename?: 'Organization', _id: any } | null, overlayPrivate?: { __typename?: 'OrgOperatorOverlayOverlayPrivate', tags?: Array<any | null> | null, note?: string | null } | null, overlayPublic?: { __typename?: 'OrgOperatorOverlayOverlayPublic', publicProfileUrl?: string | null, crowdriffGalleryId?: string | null } | null } | null };

export type OrgOverviewRebuildMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrgOverviewRebuildMutation = { __typename?: 'Mutation', orgOverviewRebuild: { __typename?: 'OrgOverviewRebuildResult', builtAt: any, listingsCount: number, peopleCount: number, eventsCount: number } };

export type OrganizationCreateMutationVariables = Exact<{
  record: CreateOneOrganizationInput;
}>;


export type OrganizationCreateMutation = { __typename?: 'Mutation', organizationCreate?: { __typename?: 'CreateOneOrganizationPayload', record?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type OrganizationDeleteMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationDeleteMutation = { __typename?: 'Mutation', organizationDelete?: { __typename?: 'OrganizationDeletePayload', success: boolean, message?: string | null, deletedOrganizationId?: string | null } | null };

export type OrganizationDisconnectAssetsMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationDisconnectAssetsMutation = { __typename?: 'Mutation', organizationDisconnectAssets: { __typename?: 'OrganizationManifest', _id: any, organizationId: any, deletionLog?: { __typename?: 'OrganizationManifestDeletionLog', completedAt: any, completedBy: any, results?: { __typename?: 'OrganizationManifestDeletionLogResults', people?: { __typename?: 'OrganizationManifestDeletionLogResultsPeople', disconnected?: number | null, deleted?: number | null, errors?: number | null } | null, operators?: { __typename?: 'OrganizationManifestDeletionLogResultsOperators', disconnected?: number | null, deleted?: number | null, errors?: number | null } | null, widgets?: { __typename?: 'OrganizationManifestDeletionLogResultsWidgets', deleted?: number | null, errors?: number | null } | null, lists?: { __typename?: 'OrganizationManifestDeletionLogResultsLists', deleted?: number | null, errors?: number | null } | null, notes?: { __typename?: 'OrganizationManifestDeletionLogResultsNotes', deleted?: number | null, errors?: number | null } | null, events?: { __typename?: 'OrganizationManifestDeletionLogResultsEvents', deleted?: number | null, errors?: number | null } | null, broadcasts?: { __typename?: 'OrganizationManifestDeletionLogResultsBroadcasts', deleted?: number | null, errors?: number | null } | null, images?: { __typename?: 'OrganizationManifestDeletionLogResultsImages', deleted?: number | null, errors?: number | null } | null, activityLogs?: { __typename?: 'OrganizationManifestDeletionLogResultsActivityLogs', deleted?: number | null, errors?: number | null } | null, imports?: { __typename?: 'OrganizationManifestDeletionLogResultsImports', deleted?: number | null, errors?: number | null } | null, importRuns?: { __typename?: 'OrganizationManifestDeletionLogResultsImportRuns', deleted?: number | null, errors?: number | null } | null } | null, deletionErrors?: Array<{ __typename?: 'OrganizationManifestDeletionLogDeletionErrors', type: string, message: string, assetId?: string | null } | null> | null } | null } };

export type OrganizationEmailDomainProvisionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationEmailDomainProvisionMutation = { __typename?: 'Mutation', organizationEmailDomainProvision?: { __typename?: 'OrganizationEmailDomain', _id: any, fromAddress: string, domain: string, status: EnumOrganizationEmailDomainStatus, previousStatus?: EnumOrganizationEmailDomainPreviousStatus | null, sendgridDomainId?: number | null, internalNote?: string | null, requestedAt?: any | null, activatedAt?: any | null, lastValidatedAt?: any | null, disabledAt?: any | null, dnsRecords?: { __typename?: 'OrganizationEmailDomainDnsRecords', mailCname: { __typename?: 'OrganizationEmailDomainDnsRecordsMailCname', valid: boolean, type: string, host: string, data: string }, dkim1: { __typename?: 'OrganizationEmailDomainDnsRecordsMailCname', valid: boolean, type: string, host: string, data: string }, dkim2: { __typename?: 'OrganizationEmailDomainDnsRecordsMailCname', valid: boolean, type: string, host: string, data: string } } | null, validationResults?: { __typename?: 'OrganizationEmailDomainValidationResults', mailCname?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null, dkim1?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null, dkim2?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null, spf?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null } | null } | null };

export type OrganizationEmailDomainRemoveMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationEmailDomainRemoveMutation = { __typename?: 'Mutation', organizationEmailDomainRemove: boolean };

export type OrganizationEmailDomainRequestMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  fromAddress: Scalars['String']['input'];
}>;


export type OrganizationEmailDomainRequestMutation = { __typename?: 'Mutation', organizationEmailDomainRequest?: { __typename?: 'OrganizationEmailDomain', _id: any, fromAddress: string, domain: string, status: EnumOrganizationEmailDomainStatus, requestedAt?: any | null, activatedAt?: any | null, lastValidatedAt?: any | null, disabledAt?: any | null, dnsRecords?: { __typename?: 'OrganizationEmailDomainDnsRecords', mailCname: { __typename?: 'OrganizationEmailDomainDnsRecordsMailCname', valid: boolean, type: string, host: string, data: string }, dkim1: { __typename?: 'OrganizationEmailDomainDnsRecordsMailCname', valid: boolean, type: string, host: string, data: string }, dkim2: { __typename?: 'OrganizationEmailDomainDnsRecordsMailCname', valid: boolean, type: string, host: string, data: string } } | null, validationResults?: { __typename?: 'OrganizationEmailDomainValidationResults', mailCname?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null, dkim1?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null, dkim2?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null, spf?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null } | null } | null };

export type OrganizationEmailDomainRunChecksMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  testRecipientEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationEmailDomainRunChecksMutation = { __typename?: 'Mutation', organizationEmailDomainRunChecks?: { __typename?: 'OrganizationEmailDomainRunChecksResult', sendgridValidation: { __typename?: 'OrganizationEmailDomainCheckResult', passed: boolean, message: string }, liveTestSend?: { __typename?: 'OrganizationEmailDomainCheckResult', passed: boolean, message: string } | null, config?: { __typename?: 'OrganizationEmailDomain', _id: any, fromAddress: string, domain: string, status: EnumOrganizationEmailDomainStatus, previousStatus?: EnumOrganizationEmailDomainPreviousStatus | null, sendgridDomainId?: number | null, internalNote?: string | null, requestedAt?: any | null, activatedAt?: any | null, lastValidatedAt?: any | null, disabledAt?: any | null, dnsRecords?: { __typename?: 'OrganizationEmailDomainDnsRecords', mailCname: { __typename?: 'OrganizationEmailDomainDnsRecordsMailCname', valid: boolean, type: string, host: string, data: string }, dkim1: { __typename?: 'OrganizationEmailDomainDnsRecordsMailCname', valid: boolean, type: string, host: string, data: string }, dkim2: { __typename?: 'OrganizationEmailDomainDnsRecordsMailCname', valid: boolean, type: string, host: string, data: string } } | null, validationResults?: { __typename?: 'OrganizationEmailDomainValidationResults', mailCname?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null, dkim1?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null, dkim2?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null, spf?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null } | null } | null } | null };

export type OrganizationEmailDomainSetDisabledMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  disabled: Scalars['Boolean']['input'];
}>;


export type OrganizationEmailDomainSetDisabledMutation = { __typename?: 'Mutation', organizationEmailDomainSetDisabled?: { __typename?: 'OrganizationEmailDomain', _id: any, fromAddress: string, domain: string, status: EnumOrganizationEmailDomainStatus, previousStatus?: EnumOrganizationEmailDomainPreviousStatus | null, sendgridDomainId?: number | null, internalNote?: string | null, requestedAt?: any | null, activatedAt?: any | null, lastValidatedAt?: any | null, disabledAt?: any | null } | null };

export type OrganizationEmailDomainSetTestOverrideMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  allowNonProductionSending: Scalars['Boolean']['input'];
}>;


export type OrganizationEmailDomainSetTestOverrideMutation = { __typename?: 'Mutation', organizationEmailDomainSetTestOverride?: { __typename?: 'OrganizationEmailDomain', _id: any, allowNonProductionSending: boolean } | null };

export type OrganizationEmailDomainUpdateNoteMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationEmailDomainUpdateNoteMutation = { __typename?: 'Mutation', organizationEmailDomainUpdateNote?: { __typename?: 'OrganizationEmailDomain', _id: any, internalNote?: string | null } | null };

export type OrganizationEventPartnerAddMutationVariables = Exact<{
  code?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type OrganizationEventPartnerAddMutation = { __typename?: 'Mutation', organizationEventPartnerAdd: { __typename?: 'OrganizationEventPartnerSettings', sharingCode: string, partners?: Array<{ __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null }> | null, subscribers?: Array<{ __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null }> | null, suggestions?: Array<{ __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null }> | null } };

export type OrganizationEventPartnerRemoveMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
}>;


export type OrganizationEventPartnerRemoveMutation = { __typename?: 'Mutation', organizationEventPartnerRemove: { __typename?: 'OrganizationEventPartnerSettings', sharingCode: string, partners?: Array<{ __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null }> | null, subscribers?: Array<{ __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null }> | null, suggestions?: Array<{ __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null }> | null } };

export type OrganizationEventSharingCodeRegenerateMutationVariables = Exact<{ [key: string]: never; }>;


export type OrganizationEventSharingCodeRegenerateMutation = { __typename?: 'Mutation', organizationEventSharingCodeRegenerate: { __typename?: 'OrganizationEventPartnerSettings', sharingCode: string, partners?: Array<{ __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null }> | null, subscribers?: Array<{ __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null }> | null, suggestions?: Array<{ __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null }> | null } };

export type OrganizationManifestGenerateMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationManifestGenerateMutation = { __typename?: 'Mutation', organizationManifestGenerate: { __typename?: 'OrganizationManifest', _id: any, organizationId: any, generatedAt: any, generatedBy: any, assetCounts: { __typename?: 'OrganizationManifestAssetCounts', widgets: number, lists: number, customTags: number, notes: number, events: number, broadcasts: number, images: number, users: number, activityLogs: number, imports: number, importRuns: number, people?: { __typename?: 'OrganizationManifestAssetCountsPeople', total: number, toDisconnect: number, toDelete: number } | null, operators?: { __typename?: 'OrganizationManifestAssetCountsOperators', total: number, toDisconnect: number, toDelete: number } | null }, manifestErrors: Array<{ __typename?: 'OrganizationManifestManifestErrors', type: string, message: string, assetId?: string | null } | null> } };

export type OrganizationSeedDefaultAudiencesMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationSeedDefaultAudiencesMutation = { __typename?: 'Mutation', organizationSeedDefaultAudiences: { __typename?: 'Organization', _id: any, metadata?: { __typename?: 'OrganizationMetadata', listingAudienceTagIds?: Array<any | null> | null } | null } };

export type OrganizationSeedDefaultMembershipStatusTagsMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationSeedDefaultMembershipStatusTagsMutation = { __typename?: 'Mutation', organizationSeedDefaultMembershipStatusTags: { __typename?: 'Organization', _id: any, metadata?: { __typename?: 'OrganizationMetadata', membershipStatusTagIds?: Array<any | null> | null } | null } };

export type OrganizationSendRenewalTestEmailMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  recipientUserId: Scalars['ID']['input'];
  emailKind: RenewalTestEmailKind;
  subject?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  hideRenewalDateLine?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  hideGreeting?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrganizationSendRenewalTestEmailMutation = { __typename?: 'Mutation', organizationSendRenewalTestEmail: boolean };

export type OrganizationSendTestEmailsMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  recipientUserId: Scalars['ID']['input'];
  emailTypes: Array<OrgTestEmailType> | OrgTestEmailType;
}>;


export type OrganizationSendTestEmailsMutation = { __typename?: 'Mutation', organizationSendTestEmails?: { __typename?: 'OrgSendTestEmailsResult', sentCount: number, failed?: Array<{ __typename?: 'OrgTestEmailFailure', emailType: OrgTestEmailType, error: string }> | null } | null };

export type OrganizationUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdOrganizationInput;
}>;


export type OrganizationUpdateMutation = { __typename?: 'Mutation', organizationUpdate?: { __typename?: 'UpdateByIdOrganizationPayload', record?: { __typename?: 'Organization', _id: any, shortName: string, subdomain?: string | null, brandColors: Array<string | null>, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', website?: string | null, instagram?: string | null, x?: string | null, bookNow?: string | null, youtube?: string | null, pinterest?: string | null, googleMyBusiness?: string | null, tiktok?: string | null, tripAdvisor?: string | null, facebook?: string | null } | null } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, onboardingMetadata: { __typename?: 'OrganizationOnboardingMetadata', videoId?: string | null, introMessage?: string | null, allowColdSignup?: boolean | null, coldSignupTagId?: any | null, comingSoonMessage?: string | null }, metadata?: { __typename?: 'OrganizationMetadata', inviteWhenAddingStaff?: boolean | null, eventLookaheadMonths?: number | null, disabledApps?: Array<EnumOrganizationMetadataDisabledApps | null> | null, connectedStorefront?: any | null, connectedTestStorefront?: any | null, storefrontOrgConnectionsEnabled?: boolean | null, storefrontMode?: EnumOrganizationMetadataStorefrontMode | null, connectedUsdStorefront?: any | null, connectedUsdTestStorefront?: any | null, internalOnly?: boolean | null, canEnableMembershipLink?: boolean | null, membershipPageUrl?: string | null, connectedOperator?: any | null, crowdriffEnabled?: boolean | null, externalVideoEnabled?: boolean | null, membershipTiers?: Array<any | null> | null, individualMembershipTiers?: Array<any | null> | null, timezone?: string | null, nomenclature?: { __typename?: 'OrganizationMetadataNomenclature', membership?: string | null, member?: string | null, members?: string | null } | null } | null, emailBranding?: { __typename?: 'OrganizationEmailBranding', fromName?: string | null, replyTo?: string | null, accentColor?: string | null, showContact?: boolean | null, footerText?: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } | null } | null, license?: { __typename?: 'OrganizationLicense', activatedDate?: any | null, activatedBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null } | null } | null } | null };

export type OrganizationUpdateImagesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  imagesToKeep?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  imagesToDelete?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isLogo?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrganizationUpdateImagesMutation = { __typename?: 'Mutation', organizationUpdateImages: { __typename?: 'Organization', _id: any, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }> } };

export type OrganizationUpdateIndividualMembershipTiersMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  individualMembershipTierTagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrganizationUpdateIndividualMembershipTiersMutation = { __typename?: 'Mutation', organizationUpdateIndividualMembershipTiers: { __typename?: 'Organization', _id: any, metadata?: { __typename?: 'OrganizationMetadata', individualMembershipTiers?: Array<any | null> | null } | null } };

export type OrganizationUpdateListingAudiencesMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  listingAudienceTagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  removedListAction?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationUpdateListingAudiencesMutation = { __typename?: 'Mutation', organizationUpdateListingAudiences: { __typename?: 'Organization', _id: any, metadata?: { __typename?: 'OrganizationMetadata', listingAudienceTagIds?: Array<any | null> | null } | null } };

export type OrganizationUpdateMembershipBroadcastMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  broadcastId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type OrganizationUpdateMembershipBroadcastMutation = { __typename?: 'Mutation', organizationUpdateMembershipBroadcast: { __typename?: 'Organization', _id: any, metadata?: { __typename?: 'OrganizationMetadata', membershipBroadcastId?: any | null } | null } };

export type OrganizationUpdateMembershipHubMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  hideOfferFromForYou?: InputMaybe<Scalars['Boolean']['input']>;
  tiers?: InputMaybe<Array<MembershipHubTierInput> | MembershipHubTierInput>;
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationUpdateMembershipHubMutation = { __typename?: 'Mutation', organizationUpdateMembershipHub: { __typename?: 'Organization', _id: any, metadata?: { __typename?: 'OrganizationMetadata', membershipHub?: { __typename?: 'OrganizationMetadataMembershipHub', hideOfferFromForYou?: boolean | null, tiers?: Array<{ __typename?: 'OrganizationMetadataMembershipHubTiers', tierTagId: any, applicationBroadcastId?: any | null, applicationResourceId?: any | null, hideFromNewcomers?: boolean | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null } | null } | null } };

export type OrganizationUpdateMembershipPaymentsEnabledMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type OrganizationUpdateMembershipPaymentsEnabledMutation = { __typename?: 'Mutation', organizationUpdateMembershipPaymentsEnabled: { __typename?: 'Organization', _id: any, metadata?: { __typename?: 'OrganizationMetadata', membershipPaymentsEnabled?: boolean | null } | null } };

export type OrganizationUpdateMembershipStatusTagsMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  membershipStatusTagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrganizationUpdateMembershipStatusTagsMutation = { __typename?: 'Mutation', organizationUpdateMembershipStatusTags: { __typename?: 'Organization', _id: any, metadata?: { __typename?: 'OrganizationMetadata', membershipStatusTagIds?: Array<any | null> | null } | null } };

export type OrganizationUpdateMembershipTierCheckoutMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  tierTagId: Scalars['MongoID']['input'];
  bookerId?: InputMaybe<Scalars['MongoID']['input']>;
  free?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrganizationUpdateMembershipTierCheckoutMutation = { __typename?: 'Mutation', organizationUpdateMembershipTierCheckout: { __typename?: 'Organization', _id: any, metadata?: { __typename?: 'OrganizationMetadata', membershipTierCheckouts?: Array<{ __typename?: 'OrganizationMetadataMembershipTierCheckouts', tierTagId: any, bookerId?: any | null, free?: boolean | null } | null> | null } | null } };

export type OrganizationUpdateMembershipTiersMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  membershipTierTagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  removedListAction?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationUpdateMembershipTiersMutation = { __typename?: 'Mutation', organizationUpdateMembershipTiers: { __typename?: 'Organization', _id: any, metadata?: { __typename?: 'OrganizationMetadata', membershipTiers?: Array<any | null> | null } | null } };

export type OrganizationUpdateNomenclatureMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  membership: Scalars['String']['input'];
  member: Scalars['String']['input'];
  members: Scalars['String']['input'];
}>;


export type OrganizationUpdateNomenclatureMutation = { __typename?: 'Mutation', organizationUpdateNomenclature: { __typename?: 'Organization', _id: any, metadata?: { __typename?: 'OrganizationMetadata', nomenclature?: { __typename?: 'OrganizationMetadataNomenclature', membership?: string | null, member?: string | null, members?: string | null } | null } | null } };

export type OrganizationUpdateRenewalSettingsMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
  renewalType: Scalars['String']['input'];
  fixedRenewalMonth?: InputMaybe<Scalars['Int']['input']>;
  fixedRenewalDay?: InputMaybe<Scalars['Int']['input']>;
  proRateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  term: Scalars['String']['input'];
  termYears?: InputMaybe<Scalars['Int']['input']>;
  pendingStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  activeStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  expiredStatusTagId?: InputMaybe<Scalars['MongoID']['input']>;
  clearStatusTagsOnExpiration?: InputMaybe<Scalars['Boolean']['input']>;
  sendRenewalEmails: Scalars['Boolean']['input'];
  sendExpirationEmails: Scalars['Boolean']['input'];
  sendSuccessEmails: Scalars['Boolean']['input'];
  sendOverdueEmails?: InputMaybe<Scalars['Boolean']['input']>;
  sendCancelledEmails?: InputMaybe<Scalars['Boolean']['input']>;
  automaticRenewalEmails?: InputMaybe<Scalars['Boolean']['input']>;
  emailCooldownDays?: InputMaybe<Scalars['Int']['input']>;
  renewalReminderLeadDays?: InputMaybe<Scalars['Int']['input']>;
  instructionsEmailSubject?: InputMaybe<Scalars['String']['input']>;
  instructionsEmailBody?: InputMaybe<Scalars['String']['input']>;
  expiredEmailSubject?: InputMaybe<Scalars['String']['input']>;
  expiredEmailBody?: InputMaybe<Scalars['String']['input']>;
  successEmailSubject?: InputMaybe<Scalars['String']['input']>;
  successEmailBody?: InputMaybe<Scalars['String']['input']>;
  overdueEmailSubject?: InputMaybe<Scalars['String']['input']>;
  overdueEmailBody?: InputMaybe<Scalars['String']['input']>;
  cancelledEmailSubject?: InputMaybe<Scalars['String']['input']>;
  cancelledEmailBody?: InputMaybe<Scalars['String']['input']>;
  instructionsEmailCtaLabel?: InputMaybe<Scalars['String']['input']>;
  expiredEmailCtaLabel?: InputMaybe<Scalars['String']['input']>;
  successEmailCtaLabel?: InputMaybe<Scalars['String']['input']>;
  overdueEmailCtaLabel?: InputMaybe<Scalars['String']['input']>;
  cancelledEmailCtaLabel?: InputMaybe<Scalars['String']['input']>;
  renewalGraceDays?: InputMaybe<Scalars['Int']['input']>;
  neverExpireMembers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrganizationUpdateRenewalSettingsMutation = { __typename?: 'Mutation', organizationUpdateRenewalSettings: { __typename?: 'Organization', _id: any, metadata?: { __typename?: 'OrganizationMetadata', renewalSettings?: { __typename?: 'OrganizationMetadataRenewalSettings', enabled?: boolean | null, renewalType?: EnumOrganizationMetadataRenewalSettingsRenewalType | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, proRateEnabled?: boolean | null, term?: EnumOrganizationMetadataRenewalSettingsTerm | null, termYears?: number | null, pendingStatusTagId?: any | null, activeStatusTagId?: any | null, expiredStatusTagId?: any | null, clearStatusTagsOnExpiration?: boolean | null, sendRenewalEmails?: boolean | null, sendExpirationEmails?: boolean | null, sendSuccessEmails?: boolean | null, sendOverdueEmails?: boolean | null, sendCancelledEmails?: boolean | null, automaticRenewalEmails?: boolean | null, emailCooldownDays?: number | null, renewalReminderLeadDays?: number | null, instructionsEmail?: { __typename?: 'OrganizationMetadataRenewalSettingsInstructionsEmail', subject?: string | null, body?: string | null, ctaLabel?: string | null } | null, expiredEmail?: { __typename?: 'OrganizationMetadataRenewalSettingsInstructionsEmail', subject?: string | null, body?: string | null, ctaLabel?: string | null } | null, successEmail?: { __typename?: 'OrganizationMetadataRenewalSettingsInstructionsEmail', subject?: string | null, body?: string | null, ctaLabel?: string | null } | null, overdueEmail?: { __typename?: 'OrganizationMetadataRenewalSettingsInstructionsEmail', subject?: string | null, body?: string | null, ctaLabel?: string | null } | null, cancelledEmail?: { __typename?: 'OrganizationMetadataRenewalSettingsInstructionsEmail', subject?: string | null, body?: string | null, ctaLabel?: string | null } | null, tierReminderEmails?: Array<{ __typename?: 'OrganizationMetadataRenewalSettingsTierReminderEmails', tierTagId: any, subject?: string | null, body?: string | null, hideRenewalDateLine?: boolean | null, ctaLabel?: string | null } | null> | null } | null } | null } };

export type OrganizationUpsertTierReminderEmailMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  tierTagId: Scalars['MongoID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  hideRenewalDateLine?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationUpsertTierReminderEmailMutation = { __typename?: 'Mutation', organizationUpsertTierReminderEmail: { __typename?: 'Organization', _id: any, metadata?: { __typename?: 'OrganizationMetadata', renewalSettings?: { __typename?: 'OrganizationMetadataRenewalSettings', tierReminderEmails?: Array<{ __typename?: 'OrganizationMetadataRenewalSettingsTierReminderEmails', tierTagId: any, subject?: string | null, body?: string | null, hideRenewalDateLine?: boolean | null, ctaLabel?: string | null } | null> | null } | null } | null } };

export type PaymentMethodSetCreateMutationVariables = Exact<{
  record: CreateOnePaymentMethodSetInput;
}>;


export type PaymentMethodSetCreateMutation = { __typename?: 'Mutation', paymentMethodSetCreate?: { __typename?: 'CreateOnePaymentMethodSetPayload', recordId?: any | null, record?: { __typename?: 'PaymentMethodSet', _id: any, name: string, isActive: boolean, acceptedPaymentMethods: Array<string | null>, bankTransferInstructions?: string | null, offlinePaymentInstructions?: string | null, checkoutDescription?: string | null, storefront: any, methodLabels?: { __typename?: 'PaymentMethodSetMethodLabels', card?: string | null, direct_debit?: string | null, bank_transfer?: string | null, offline_payment?: string | null } | null } | null } | null };

export type PaymentMethodSetUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdPaymentMethodSetInput;
}>;


export type PaymentMethodSetUpdateMutation = { __typename?: 'Mutation', paymentMethodSetUpdate?: { __typename?: 'UpdateByIdPaymentMethodSetPayload', recordId?: any | null, record?: { __typename?: 'PaymentMethodSet', _id: any, name: string, isActive: boolean, acceptedPaymentMethods: Array<string | null>, bankTransferInstructions?: string | null, offlinePaymentInstructions?: string | null, checkoutDescription?: string | null, storefront: any, methodLabels?: { __typename?: 'PaymentMethodSetMethodLabels', card?: string | null, direct_debit?: string | null, bank_transfer?: string | null, offline_payment?: string | null } | null } | null } | null };

export type PaymentRequestStatementRemoveOrderMutationVariables = Exact<{
  paymentRequestId: Scalars['MongoID']['input'];
  orderId: Scalars['String']['input'];
}>;


export type PaymentRequestStatementRemoveOrderMutation = { __typename?: 'Mutation', paymentRequestStatementRemoveOrder?: { __typename?: 'PaymentRequest', _id: any, status: EnumPaymentRequestStatus, version: number, grandTotal: number } | null };

export type PersonConnectToListingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  operatorEntityId: Scalars['ID']['input'];
  sendInvitationEmail: Scalars['Boolean']['input'];
  entityId: Scalars['ID']['input'];
  type: EnumOwnerType;
}>;


export type PersonConnectToListingMutation = { __typename?: 'Mutation', personConnectToListing: { __typename?: 'DetailedPersonTC', _id: string, userId?: string | null, isUserClaimed?: boolean | null, isUserInvited?: boolean | null, emails?: Array<string | null> | null, scratchpad?: string | null, isOnDirectoryOperator?: boolean | null, personInfo?: { __typename?: 'DetailedPersonInfoTC', firstName: string, lastName: string, email: string, isUserClaimed?: boolean | null, isUserInvited?: boolean | null, phone?: string | null, phoneExt?: string | null, fax?: string | null, faxExt?: string | null, pronouns?: string | null, primaryTitle?: string | null, birthday?: string | null, contactMethod?: EnumPeopleContactMethod | null, optInEmail?: boolean | null, optInPhone?: boolean | null, optInSMS?: boolean | null, optInFax?: boolean | null, systemRoles?: Array<EnumPeopleVisibleToSystemRoles | null> | null, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, mailingAddress?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, tags: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> } | null, orders?: Array<{ __typename?: 'PersonDetailsSectionTC', _id: string, dateISO: string, dateStartISO?: string | null, dateEndISO?: string | null, type?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, operators?: Array<{ __typename?: 'OperatorDetailsTC', _entityId: string, roleType?: string | null, title?: string | null, contactRoles?: Array<ContactRole | null> | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, organizations?: Array<{ __typename?: 'OperatorOrganizationDetailsTC', _id: string, logo?: string | null, title?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null } | null> | null, organizations?: Array<{ __typename?: 'OrganizationDetailsTC', _id: string, logo?: string | null, roleType?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, adminOrganizations?: Array<{ __typename?: 'OrganizationDetailsTC', _id: string, logo?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, leads?: Array<{ __typename?: 'PersonDetailsSectionTC', _id: string, dateISO: string, status?: string | null, type?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, phones?: Array<{ __typename?: 'PersonMetadataPhone', phone?: string | null, ext?: string | null, type?: string | null } | null> | null } };

export type PersonCreateMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  type: EnumOwnerType;
  record: CreateOnePeopleInput;
}>;


export type PersonCreateMutation = { __typename?: 'Mutation', personCreate?: { __typename?: 'SimplePersonManyTC', _id: string, firstName: string, lastName: string, email: string, phone?: string | null, isRepeatCustomer?: boolean | null, lastUpdated?: any | null, systemRoles?: Array<EnumPeopleVisibleToSystemRoles | null> | null, isWhereaboutsUser?: boolean | null, isUserClaimed?: boolean | null, isUserInvited?: boolean | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, tags: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, unreadLeads?: Array<{ __typename?: 'UnreadLeadTC', leadId: string, date: any, type?: string | null } | null> | null, rightSideContent?: Array<{ __typename?: 'RightSideContentTC', entityId: string, text: string } | null> | null } | null };

export type PersonDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  type: EnumOwnerType;
}>;


export type PersonDeleteMutation = { __typename?: 'Mutation', personDelete?: string | null };

export type PersonDeleteCompletelyByInternalMutationVariables = Exact<{
  personId: Scalars['ID']['input'];
}>;


export type PersonDeleteCompletelyByInternalMutation = { __typename?: 'Mutation', personDeleteCompletelyByInternal: string };

export type PersonUpdateAddToVisibleToMutationVariables = Exact<{
  email: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  type: EnumOwnerType;
}>;


export type PersonUpdateAddToVisibleToMutation = { __typename?: 'Mutation', personUpdateAddToVisibleTo: { __typename?: 'SimplePersonManyTC', _id: string, firstName: string, lastName: string, email: string, phone?: string | null, isRepeatCustomer?: boolean | null, lastUpdated?: any | null, systemRoles?: Array<EnumPeopleVisibleToSystemRoles | null> | null, isWhereaboutsUser?: boolean | null, isUserClaimed?: boolean | null, isUserInvited?: boolean | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, tags: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, unreadLeads?: Array<{ __typename?: 'UnreadLeadTC', leadId: string, date: any, type?: string | null } | null> | null, rightSideContent?: Array<{ __typename?: 'RightSideContentTC', entityId: string, text: string } | null> | null } };

export type PersonUpdateCommonMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdPeopleInput;
  entityId: Scalars['ID']['input'];
  type: EnumOwnerType;
}>;


export type PersonUpdateCommonMutation = { __typename?: 'Mutation', personUpdateCommon: { __typename?: 'DetailedPersonTC', _id: string, userId?: string | null, isUserClaimed?: boolean | null, isUserInvited?: boolean | null, emails?: Array<string | null> | null, scratchpad?: string | null, isOnDirectoryOperator?: boolean | null, personInfo?: { __typename?: 'DetailedPersonInfoTC', firstName: string, lastName: string, email: string, isUserClaimed?: boolean | null, isUserInvited?: boolean | null, phone?: string | null, phoneExt?: string | null, fax?: string | null, faxExt?: string | null, pronouns?: string | null, primaryTitle?: string | null, birthday?: string | null, contactMethod?: EnumPeopleContactMethod | null, optInEmail?: boolean | null, optInPhone?: boolean | null, optInSMS?: boolean | null, optInFax?: boolean | null, systemRoles?: Array<EnumPeopleVisibleToSystemRoles | null> | null, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, mailingAddress?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, tags: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> } | null, orders?: Array<{ __typename?: 'PersonDetailsSectionTC', _id: string, dateISO: string, dateStartISO?: string | null, dateEndISO?: string | null, type?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, operators?: Array<{ __typename?: 'OperatorDetailsTC', _entityId: string, roleType?: string | null, title?: string | null, contactRoles?: Array<ContactRole | null> | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, organizations?: Array<{ __typename?: 'OperatorOrganizationDetailsTC', _id: string, logo?: string | null, title?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null } | null> | null, organizations?: Array<{ __typename?: 'OrganizationDetailsTC', _id: string, logo?: string | null, roleType?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, adminOrganizations?: Array<{ __typename?: 'OrganizationDetailsTC', _id: string, logo?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, leads?: Array<{ __typename?: 'PersonDetailsSectionTC', _id: string, dateISO: string, status?: string | null, type?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, phones?: Array<{ __typename?: 'PersonMetadataPhone', phone?: string | null, ext?: string | null, type?: string | null } | null> | null } };

export type PersonUpdateVisibleToMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  type: EnumOwnerType;
  scratchpad?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  metadata?: InputMaybe<PersonMetadataInput>;
}>;


export type PersonUpdateVisibleToMutation = { __typename?: 'Mutation', personUpdateVisibleTo: { __typename?: 'DetailedPersonTC', _id: string, userId?: string | null, isUserClaimed?: boolean | null, isUserInvited?: boolean | null, emails?: Array<string | null> | null, scratchpad?: string | null, isOnDirectoryOperator?: boolean | null, personInfo?: { __typename?: 'DetailedPersonInfoTC', firstName: string, lastName: string, email: string, isUserClaimed?: boolean | null, isUserInvited?: boolean | null, phone?: string | null, phoneExt?: string | null, fax?: string | null, faxExt?: string | null, pronouns?: string | null, primaryTitle?: string | null, birthday?: string | null, contactMethod?: EnumPeopleContactMethod | null, optInEmail?: boolean | null, optInPhone?: boolean | null, optInSMS?: boolean | null, optInFax?: boolean | null, systemRoles?: Array<EnumPeopleVisibleToSystemRoles | null> | null, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, mailingAddress?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, tags: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> } | null, orders?: Array<{ __typename?: 'PersonDetailsSectionTC', _id: string, dateISO: string, dateStartISO?: string | null, dateEndISO?: string | null, type?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, operators?: Array<{ __typename?: 'OperatorDetailsTC', _entityId: string, roleType?: string | null, title?: string | null, contactRoles?: Array<ContactRole | null> | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, organizations?: Array<{ __typename?: 'OperatorOrganizationDetailsTC', _id: string, logo?: string | null, title?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null } | null> | null, organizations?: Array<{ __typename?: 'OrganizationDetailsTC', _id: string, logo?: string | null, roleType?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, adminOrganizations?: Array<{ __typename?: 'OrganizationDetailsTC', _id: string, logo?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, leads?: Array<{ __typename?: 'PersonDetailsSectionTC', _id: string, dateISO: string, status?: string | null, type?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, phones?: Array<{ __typename?: 'PersonMetadataPhone', phone?: string | null, ext?: string | null, type?: string | null } | null> | null } };

export type PlaceCreateMutationVariables = Exact<{
  record: CreateOnePlaceInput;
}>;


export type PlaceCreateMutation = { __typename?: 'Mutation', placeCreate?: { __typename?: 'CreateOnePlacePayload', record?: { __typename?: 'Place', _id: any, type: EnumPlaceType, connectedListing?: any | null, connectedDmoListing?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, name: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null }, subPlaces: Array<{ __typename?: 'Place', _id: any, type: EnumPlaceType, name: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } }>, outline?: { __typename?: 'PlaceOutline', type: EnumPlaceOutlineType, coordinates: any } | null, outlineSimplified?: { __typename?: 'PlaceOutline', type: EnumPlaceOutlineType, coordinates: any } | null } | null } | null };

export type PlaceDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type PlaceDeleteMutation = { __typename?: 'Mutation', placeDelete?: { __typename?: 'RemoveByIdPlacePayload', recordId?: any | null } | null };

export type PlaceMoveNodeMutationVariables = Exact<{
  placeId: Scalars['MongoID']['input'];
  newParentId?: InputMaybe<Scalars['MongoID']['input']>;
  index: Scalars['Int']['input'];
}>;


export type PlaceMoveNodeMutation = { __typename?: 'Mutation', placeMoveNode: { __typename?: 'Place', _id: any, type: EnumPlaceType, parentPlace?: any | null, name: { __typename?: 'Multilingual', en?: string | null }, subPlaces: Array<{ __typename?: 'Place', _id: any }> } };

export type PlaceUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdPlaceInput;
}>;


export type PlaceUpdateMutation = { __typename?: 'Mutation', placeUpdate?: { __typename?: 'UpdateByIdPlacePayload', record?: { __typename?: 'Place', _id: any, type: EnumPlaceType, connectedListing?: any | null, connectedDmoListing?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, name: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null }, subPlaces: Array<{ __typename?: 'Place', _id: any, type: EnumPlaceType, name: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } }>, outline?: { __typename?: 'PlaceOutline', type: EnumPlaceOutlineType, coordinates: any } | null, outlineSimplified?: { __typename?: 'PlaceOutline', type: EnumPlaceOutlineType, coordinates: any } | null } | null } | null };

export type PolicyCreateMutationVariables = Exact<{
  record: CreateOnePolicyInput;
}>;


export type PolicyCreateMutation = { __typename?: 'Mutation', policyCreate?: { __typename?: 'CreateOnePolicyPayload', recordId?: any | null, record?: { __typename?: 'Policy', _id: any, isActive: boolean, storefront: any, content: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type PolicyUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdPolicyInput;
}>;


export type PolicyUpdateMutation = { __typename?: 'Mutation', policyUpdate?: { __typename?: 'UpdateByIdPolicyPayload', recordId?: any | null, record?: { __typename?: 'Policy', _id: any, isActive: boolean, storefront: any, content: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type ProductCreateMutationVariables = Exact<{
  record: CreateOneProductInput;
  inventoryCount: Scalars['Int']['input'];
}>;


export type ProductCreateMutation = { __typename?: 'Mutation', productCreate?: { __typename?: 'CreateOneProductPayload', recordId?: any | null, record?: { __typename?: 'Product', _id: any, storefront: any, updatedDateISO?: any | null, createdDateISO?: any | null, type: EnumProductType, publicationStatus: EnumProductPublicationStatus, externalBookingUrl?: string | null, isUpsellOnly: boolean, isActive: boolean, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags: Array<{ __typename?: 'Tag', entityTypes: Array<EnumTagEntityTypes | null>, _id: any, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rules: Array<{ __typename?: 'Rule', type: EnumRuleType, value: any, isActive: boolean, storefront: any, _id: any, activePeriod?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null }>, pricing?: { __typename?: 'Pricing', description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tiers: Array<{ __typename?: 'PriceTier', type: EnumGuestTierType, price: number, priceType: EnumPriceTierPriceType, guestCountForPrice?: number | null, discountAmount?: number | null, discountUnit?: EnumPriceTierDiscountUnit | null, _id: any, label?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> } | null, quantitySettings?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, contact?: { __typename?: 'ProductContact', useOwnerContact: boolean, email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null } | null, addOnSettings?: { __typename?: 'ProductAddOnSettings', businessScope?: EnumProductAddOnSettingsBusinessScope | null, pricingScope?: EnumProductAddOnSettingsPricingScope | null } | null, customFields?: Array<{ __typename?: 'ProductCustomFields', _id?: any | null, type: EnumProductCustomFieldsType, required: boolean, chargePerChoice?: boolean | null, maxChoices?: number | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options?: Array<{ __typename?: 'ProductCustomFieldsOptions', _id?: any | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null, renewableFeeMetadata?: { __typename?: 'RenewableFeeMetadata', billingIntervalMonths: number, renewalType?: EnumRenewableFeeMetadataRenewalType | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, proRateEnabled?: boolean | null, earlyPurchaseWindowDays?: number | null, membershipLinked?: boolean | null } | null, merchMetadata?: { __typename?: 'MerchMetadata', lowStockThreshold?: number | null, dimensions?: Array<{ __typename?: 'MerchMetadataDimensions', _id?: any | null, drivesImages?: boolean | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, values?: Array<{ __typename?: 'MerchMetadataDimensionsValues', _id?: any | null, imageIds?: Array<string | null> | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null, variants?: Array<{ __typename?: 'MerchMetadataVariants', _id?: any | null, dimensionValueIds?: Array<string | null> | null, label?: string | null, price: number, sku?: string | null, inventoryCount: number, isActive?: boolean | null } | null> | null } | null, sellingConfig?: { __typename?: 'ProductSellingConfig', mode: string, basePrice?: number | null, dynamicFeeSurvey?: any | null, options?: Array<{ __typename?: 'ProductTier', _id?: any | null, price: number, order: number, autoTag?: any | null, sessionScope?: EnumProductTierSessionScope | null, includedSessionIds?: Array<string | null> | null, minSessions?: number | null, maxSessions?: number | null, subCapacityPerSession?: number | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tagConfig?: { __typename?: 'ProductTierTagConfig', onCheckoutCompleted?: Array<any | null> | null, onRenewalSuccess?: Array<any | null> | null, onRenewalPending?: Array<any | null> | null, onExpiration?: Array<any | null> | null, onCancellation?: Array<any | null> | null, onPaymentFailed?: Array<any | null> | null } | null, personTagConfig?: { __typename?: 'ProductTierTagConfig', onCheckoutCompleted?: Array<any | null> | null, onRenewalSuccess?: Array<any | null> | null, onRenewalPending?: Array<any | null> | null, onExpiration?: Array<any | null> | null, onCancellation?: Array<any | null> | null, onPaymentFailed?: Array<any | null> | null } | null, inventory?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, condition?: { __typename?: 'ProductTierCondition', operator: EnumProductTierConditionOperator, clauses?: Array<{ __typename?: 'ProductTierConditionClauses', questionId: string, comparator: EnumProductTierConditionClausesComparator, value: string } | null> | null } | null } | null> | null, inventory?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, recurring?: { __typename?: 'ProductSellingConfigRecurring', enabled?: boolean | null, billingIntervalMonths?: number | null, renewalType?: EnumProductSellingConfigRecurringRenewalType | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, proRateEnabled?: boolean | null, earlyPurchaseWindowDays?: number | null, membershipLinked?: boolean | null, multiListing?: { __typename?: 'ProductSellingConfigRecurringMultiListing', mode?: EnumProductSellingConfigRecurringMultiListingMode | null, maxListings?: number | null, autoIncludeOwnedListings?: boolean | null, additionalBusinessDiscount?: { __typename?: 'ProductSellingConfigRecurringMultiListingAdditionalBusinessDiscount', unit: EnumProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountUnit, amount: number } | null } | null } | null } | null, productTiers?: Array<{ __typename?: 'ProductTier', _id?: any | null, price: number, order: number, autoTag?: any | null, sessionScope?: EnumProductTierSessionScope | null, includedSessionIds?: Array<string | null> | null, minSessions?: number | null, maxSessions?: number | null, subCapacityPerSession?: number | null, isActive?: boolean | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null } | null> | null, eventMetadata?: { __typename?: 'ProductEventMetadata', event: any, ticketStructure: EnumProductEventMetadataTicketStructure, sessionGranularity: EnumProductEventMetadataSessionGranularity, sellingType?: EnumProductEventMetadataSellingType | null, maxTicketsPerPurchase?: number | null, includedSessionIds?: Array<string | null> | null } | null, inventorySettings?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, accommodationMetadata?: { __typename?: 'AccommodationProductMetadata', checkIn?: string | null, checkOut?: string | null, calendarLinks?: Array<string | null> | null, guestMetadata?: { __typename?: 'GuestMetadata', minimumNumber?: number | null, maximumNumber?: number | null, nameEntryAllowed: boolean, nameEntryRequired: boolean } | null, amenities: Array<{ __typename?: 'Tag', entityTypes: Array<EnumTagEntityTypes | null>, _id: any, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rooms: Array<{ __typename?: 'Room', _id?: any | null, type: EnumRoomType, amenities?: Array<any | null> | null } | null>, closures: Array<{ __typename?: 'Closure', _id?: any | null, name: string, dateRangeISO: { __typename?: 'DateRangeISO', _id: any, end: string, metadata?: string | null, start: string } } | null> } | null } | null } | null };

export type ProductDuplicateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ProductDuplicateMutation = { __typename?: 'Mutation', productDuplicate?: { __typename?: 'ProductDuplicateResult', productId: any } | null };

export type ProductIntegrateCalendarLinksMutationVariables = Exact<{
  calendarLinksByProductIds: Array<CalendarLinksByProductId> | CalendarLinksByProductId;
}>;


export type ProductIntegrateCalendarLinksMutation = { __typename?: 'Mutation', integrateProductCalendarLinksByProductIds: { __typename?: 'IntegrateCalendarLinksByProductIds', products: Array<{ __typename?: 'Product', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, releasedInventoryClaimItems: Array<{ __typename?: 'InventoryItem', _id: any }>, updatedInventoryClaimItems: Array<{ __typename?: 'InventoryItem', _id: any }> } };

export type ProductUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdProductInput;
  imagesToKeep?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type ProductUpdateMutation = { __typename?: 'Mutation', productUpdate?: { __typename?: 'UpdateByIdProductPayload', recordId?: any | null, record?: { __typename?: 'Product', _id: any, storefront: any, updatedDateISO?: any | null, createdDateISO?: any | null, type: EnumProductType, publicationStatus: EnumProductPublicationStatus, externalBookingUrl?: string | null, isUpsellOnly: boolean, isActive: boolean, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags: Array<{ __typename?: 'Tag', entityTypes: Array<EnumTagEntityTypes | null>, _id: any, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rules: Array<{ __typename?: 'Rule', type: EnumRuleType, value: any, isActive: boolean, storefront: any, _id: any, activePeriod?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null }>, pricing?: { __typename?: 'Pricing', description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tiers: Array<{ __typename?: 'PriceTier', type: EnumGuestTierType, price: number, priceType: EnumPriceTierPriceType, guestCountForPrice?: number | null, discountAmount?: number | null, discountUnit?: EnumPriceTierDiscountUnit | null, _id: any, label?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> } | null, quantitySettings?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, contact?: { __typename?: 'ProductContact', useOwnerContact: boolean, email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null } | null, addOnSettings?: { __typename?: 'ProductAddOnSettings', businessScope?: EnumProductAddOnSettingsBusinessScope | null, pricingScope?: EnumProductAddOnSettingsPricingScope | null } | null, customFields?: Array<{ __typename?: 'ProductCustomFields', _id?: any | null, type: EnumProductCustomFieldsType, required: boolean, chargePerChoice?: boolean | null, maxChoices?: number | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options?: Array<{ __typename?: 'ProductCustomFieldsOptions', _id?: any | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null, renewableFeeMetadata?: { __typename?: 'RenewableFeeMetadata', billingIntervalMonths: number, renewalType?: EnumRenewableFeeMetadataRenewalType | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, proRateEnabled?: boolean | null, earlyPurchaseWindowDays?: number | null, membershipLinked?: boolean | null } | null, merchMetadata?: { __typename?: 'MerchMetadata', lowStockThreshold?: number | null, dimensions?: Array<{ __typename?: 'MerchMetadataDimensions', _id?: any | null, drivesImages?: boolean | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, values?: Array<{ __typename?: 'MerchMetadataDimensionsValues', _id?: any | null, imageIds?: Array<string | null> | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null, variants?: Array<{ __typename?: 'MerchMetadataVariants', _id?: any | null, dimensionValueIds?: Array<string | null> | null, label?: string | null, price: number, sku?: string | null, inventoryCount: number, isActive?: boolean | null } | null> | null } | null, sellingConfig?: { __typename?: 'ProductSellingConfig', mode: string, basePrice?: number | null, dynamicFeeSurvey?: any | null, options?: Array<{ __typename?: 'ProductTier', _id?: any | null, price: number, order: number, autoTag?: any | null, sessionScope?: EnumProductTierSessionScope | null, includedSessionIds?: Array<string | null> | null, minSessions?: number | null, maxSessions?: number | null, subCapacityPerSession?: number | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tagConfig?: { __typename?: 'ProductTierTagConfig', onCheckoutCompleted?: Array<any | null> | null, onRenewalSuccess?: Array<any | null> | null, onRenewalPending?: Array<any | null> | null, onExpiration?: Array<any | null> | null, onCancellation?: Array<any | null> | null, onPaymentFailed?: Array<any | null> | null } | null, personTagConfig?: { __typename?: 'ProductTierTagConfig', onCheckoutCompleted?: Array<any | null> | null, onRenewalSuccess?: Array<any | null> | null, onRenewalPending?: Array<any | null> | null, onExpiration?: Array<any | null> | null, onCancellation?: Array<any | null> | null, onPaymentFailed?: Array<any | null> | null } | null, inventory?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, condition?: { __typename?: 'ProductTierCondition', operator: EnumProductTierConditionOperator, clauses?: Array<{ __typename?: 'ProductTierConditionClauses', questionId: string, comparator: EnumProductTierConditionClausesComparator, value: string } | null> | null } | null } | null> | null, inventory?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, recurring?: { __typename?: 'ProductSellingConfigRecurring', enabled?: boolean | null, billingIntervalMonths?: number | null, renewalType?: EnumProductSellingConfigRecurringRenewalType | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, proRateEnabled?: boolean | null, earlyPurchaseWindowDays?: number | null, membershipLinked?: boolean | null, multiListing?: { __typename?: 'ProductSellingConfigRecurringMultiListing', mode?: EnumProductSellingConfigRecurringMultiListingMode | null, maxListings?: number | null, autoIncludeOwnedListings?: boolean | null, additionalBusinessDiscount?: { __typename?: 'ProductSellingConfigRecurringMultiListingAdditionalBusinessDiscount', unit: EnumProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountUnit, amount: number } | null } | null } | null } | null, productTiers?: Array<{ __typename?: 'ProductTier', _id?: any | null, price: number, order: number, autoTag?: any | null, sessionScope?: EnumProductTierSessionScope | null, includedSessionIds?: Array<string | null> | null, minSessions?: number | null, maxSessions?: number | null, subCapacityPerSession?: number | null, isActive?: boolean | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null } | null> | null, eventMetadata?: { __typename?: 'ProductEventMetadata', event: any, ticketStructure: EnumProductEventMetadataTicketStructure, sessionGranularity: EnumProductEventMetadataSessionGranularity, sellingType?: EnumProductEventMetadataSellingType | null, maxTicketsPerPurchase?: number | null, includedSessionIds?: Array<string | null> | null } | null, inventorySettings?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, accommodationMetadata?: { __typename?: 'AccommodationProductMetadata', checkIn?: string | null, checkOut?: string | null, calendarLinks?: Array<string | null> | null, guestMetadata?: { __typename?: 'GuestMetadata', minimumNumber?: number | null, maximumNumber?: number | null, nameEntryAllowed: boolean, nameEntryRequired: boolean } | null, amenities: Array<{ __typename?: 'Tag', entityTypes: Array<EnumTagEntityTypes | null>, _id: any, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rooms: Array<{ __typename?: 'Room', _id?: any | null, type: EnumRoomType, amenities?: Array<any | null> | null } | null>, closures: Array<{ __typename?: 'Closure', _id?: any | null, name: string, dateRangeISO: { __typename?: 'DateRangeISO', _id: any, end: string, metadata?: string | null, start: string } } | null> } | null } | null } | null };

export type PromotionCreateMutationVariables = Exact<{
  record: CreateOnePromotionInput;
}>;


export type PromotionCreateMutation = { __typename?: 'Mutation', promotionCreate?: { __typename?: 'CreateOnePromotionPayload', recordId?: any | null, record?: { __typename?: 'Promotion', _id: any, link?: string | null, firstDate: string, lastDate: string, createdByEmail: string, createdByFirstName?: string | null, createdByLastName?: string | null, createdBy?: any | null, createdByPerson?: any | null, submitterPersonId?: any | null, submissionSource?: EnumPromotionSubmissionSource | null, createdDateISO?: any | null, updatedDateISO?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, availability: { __typename?: 'PromotionAvailability', type: EnumPromotionAvailabilityType, dates?: Array<string | null> | null, startDate?: string | null, endDate?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags?: { __typename?: 'PromotionTags', organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> } | null, access: { __typename?: 'PromotionAccess', operator: { __typename?: 'PromotionAccessOperator', _entityId: any, status?: EnumPromotionAccessOperatorStatus | null }, organizations: Array<{ __typename?: 'PromotionAccessOperator', _entityId: any, status?: EnumPromotionAccessOperatorStatus | null } | null> }, history: Array<{ __typename?: 'PromotionHistory', action: EnumPromotionHistoryAction, timestamp: any, sourceType?: EnumPromotionHistorySourceType | null, userId?: any | null, userEmail?: string | null, userName?: string | null, organizationId?: any | null, note?: string | null } | null>, listing?: { __typename?: 'OperatorWithStatus', _entityId: any, operationalStatus: EnumOperatorOperationalStatus, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null } | null };

export type PromotionDeleteByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type PromotionDeleteByIdMutation = { __typename?: 'Mutation', promotionDeleteById?: { __typename?: 'RemoveByIdPromotionPayload', recordId?: any | null } | null };

export type PromotionDisconnectOrganizationMutationVariables = Exact<{
  promotionId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
}>;


export type PromotionDisconnectOrganizationMutation = { __typename?: 'Mutation', promotionDisconnectOrganization?: { __typename?: 'PromotionDisconnectOrganizationPayload', record?: { __typename?: 'Promotion', _id: any, link?: string | null, firstDate: string, lastDate: string, createdByEmail: string, createdByFirstName?: string | null, createdByLastName?: string | null, createdBy?: any | null, createdByPerson?: any | null, submitterPersonId?: any | null, submissionSource?: EnumPromotionSubmissionSource | null, createdDateISO?: any | null, updatedDateISO?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, availability: { __typename?: 'PromotionAvailability', type: EnumPromotionAvailabilityType, dates?: Array<string | null> | null, startDate?: string | null, endDate?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags?: { __typename?: 'PromotionTags', organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> } | null, access: { __typename?: 'PromotionAccess', operator: { __typename?: 'PromotionAccessOperator', _entityId: any, status?: EnumPromotionAccessOperatorStatus | null }, organizations: Array<{ __typename?: 'PromotionAccessOperator', _entityId: any, status?: EnumPromotionAccessOperatorStatus | null } | null> }, history: Array<{ __typename?: 'PromotionHistory', action: EnumPromotionHistoryAction, timestamp: any, sourceType?: EnumPromotionHistorySourceType | null, userId?: any | null, userEmail?: string | null, userName?: string | null, organizationId?: any | null, note?: string | null } | null>, listing?: { __typename?: 'OperatorWithStatus', _entityId: any, operationalStatus: EnumOperatorOperationalStatus, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null } | null };

export type PromotionUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdPromotionInput;
  imagesToKeep?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  isSubmitting?: InputMaybe<Scalars['Boolean']['input']>;
  setStatus?: InputMaybe<EnumPromotionAccessOperatorStatus>;
  setOrganizationTags?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type PromotionUpdateByIdMutation = { __typename?: 'Mutation', promotionUpdateById?: { __typename?: 'UpdateByIdPromotionPayload', record?: { __typename?: 'Promotion', _id: any, link?: string | null, firstDate: string, lastDate: string, createdByEmail: string, createdByFirstName?: string | null, createdByLastName?: string | null, createdBy?: any | null, createdByPerson?: any | null, submitterPersonId?: any | null, submissionSource?: EnumPromotionSubmissionSource | null, createdDateISO?: any | null, updatedDateISO?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, availability: { __typename?: 'PromotionAvailability', type: EnumPromotionAvailabilityType, dates?: Array<string | null> | null, startDate?: string | null, endDate?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags?: { __typename?: 'PromotionTags', organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> } | null, access: { __typename?: 'PromotionAccess', operator: { __typename?: 'PromotionAccessOperator', _entityId: any, status?: EnumPromotionAccessOperatorStatus | null }, organizations: Array<{ __typename?: 'PromotionAccessOperator', _entityId: any, status?: EnumPromotionAccessOperatorStatus | null } | null> }, history: Array<{ __typename?: 'PromotionHistory', action: EnumPromotionHistoryAction, timestamp: any, sourceType?: EnumPromotionHistorySourceType | null, userId?: any | null, userEmail?: string | null, userName?: string | null, organizationId?: any | null, note?: string | null } | null>, listing?: { __typename?: 'OperatorWithStatus', _entityId: any, operationalStatus: EnumOperatorOperationalStatus, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null } | null };

export type PublicMediaCreateFromOrgUploadMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  mediaType: Scalars['String']['input'];
  assetId?: InputMaybe<Scalars['String']['input']>;
  muxAssetId?: InputMaybe<Scalars['String']['input']>;
  muxPlaybackId?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  blurhash?: InputMaybe<Scalars['String']['input']>;
  posterUrl?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  relatedListings?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  mediaTags?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type PublicMediaCreateFromOrgUploadMutation = { __typename?: 'Mutation', publicMediaCreateFromOrgUpload: { __typename?: 'PublicMedia', _id: any, mediaType: EnumPublicMediaMediaType, status: EnumPublicMediaStatus, asset?: string | null, width?: number | null, height?: number | null, posterUrl?: string | null, mux?: { __typename?: 'PublicMediaMux', assetId: string, playbackId: string } | null } };

export type PublicMediaIgnoreAttentionMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type PublicMediaIgnoreAttentionMutation = { __typename?: 'Mutation', publicMediaIgnoreAttention: { __typename?: 'PublicMedia', _id: any, attention?: { __typename?: 'PublicMediaAttention', ignoredAt?: any | null, issues?: Array<{ __typename?: 'PublicMediaAttentionIssues', flag: EnumPublicMediaAttentionIssuesFlag, listingId?: any | null, listingName?: string | null, flaggedAt: any } | null> | null } | null } };

export type PublicMediaLikeToggleMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
  like: Scalars['Boolean']['input'];
}>;


export type PublicMediaLikeToggleMutation = { __typename?: 'Mutation', publicMediaLikeToggle?: { __typename?: 'PublicMedia', _id: any, likeCount: number } | null };

export type PublicMediaPromoteManyFromListingMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  selections: Array<PublicMediaListingSelectionInput> | PublicMediaListingSelectionInput;
}>;


export type PublicMediaPromoteManyFromListingMutation = { __typename?: 'Mutation', publicMediaPromoteManyFromListing?: Array<{ __typename?: 'PublicMedia', _id: any, mediaType: EnumPublicMediaMediaType, status: EnumPublicMediaStatus, asset?: string | null, posterUrl?: string | null, source: { __typename?: 'PublicMediaSource', kind: EnumPublicMediaSourceKind, listingId?: any | null, originalAssetId?: string | null } }> | null };

export type PublicMediaUnpublishMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type PublicMediaUnpublishMutation = { __typename?: 'Mutation', publicMediaUnpublish: { __typename?: 'PublicMedia', _id: any, status: EnumPublicMediaStatus, attention?: { __typename?: 'PublicMediaAttention', ignoredAt?: any | null, issues?: Array<{ __typename?: 'PublicMediaAttentionIssues', flag: EnumPublicMediaAttentionIssuesFlag, listingId?: any | null, listingName?: string | null } | null> | null } | null } };

export type PublicMediaUpdateByIdMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  headline?: InputMaybe<MultilingualInput>;
  caption?: InputMaybe<MultilingualInput>;
  ctaLink?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  mediaTags?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  relatedListings?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  carouselThumbnailAsset?: InputMaybe<Scalars['String']['input']>;
  useCarouselThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PublicMediaUpdateByIdMutation = { __typename?: 'Mutation', publicMediaUpdateById: { __typename?: 'PublicMedia', _id: any, mediaType: EnumPublicMediaMediaType, status: EnumPublicMediaStatus, ctaLink?: string | null, copyright?: string | null, mediaTags: Array<any | null>, relatedListings: Array<any | null>, carouselThumbnailAsset?: string | null, useCarouselThumbnail: boolean, headline?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, caption?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } };

export type RefundCreateMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RefundCreateMutation = { __typename?: 'Mutation', refundCreate?: { __typename?: 'CreateManyRefundPayload', records?: Array<{ __typename?: 'Refund', _id: string, amount: number, createdDateISO?: any | null, orderId: string, status: EnumRefundStatus, updatedDateISO?: any | null }> | null } | null };

export type RenewableFeeConfirmMutationVariables = Exact<{
  renewablePurchaseId: Scalars['MongoID']['input'];
  paymentIntentId: Scalars['String']['input'];
}>;


export type RenewableFeeConfirmMutation = { __typename?: 'Mutation', renewableFeeConfirm?: { __typename?: 'RenewableFeeConfirmResult', success: boolean, renewablePurchaseId: any, status: string } | null };

export type RenewableFeeInitiateMutationVariables = Exact<{
  bookerId: Scalars['MongoID']['input'];
  productId: Scalars['MongoID']['input'];
  tierId?: InputMaybe<Scalars['String']['input']>;
  customer: RenewableFeeCustomerInput;
  organizationId: Scalars['MongoID']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  taxExemption?: InputMaybe<RenewableFeeTaxExemptionInput>;
  autoRenewOptIn?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RenewableFeeInitiateMutation = { __typename?: 'Mutation', renewableFeeInitiate?: { __typename?: 'RenewableFeeInitiateResult', clientSecret?: string | null, orderId: string, renewablePurchaseId: any, paymentIntentId: string } | null };

export type RenewablePurchaseCancelMutationVariables = Exact<{
  renewablePurchaseId: Scalars['MongoID']['input'];
}>;


export type RenewablePurchaseCancelMutation = { __typename?: 'Mutation', renewablePurchaseCancel?: { __typename?: 'RenewablePurchase', _id: any, status: EnumRenewablePurchaseStatus, cancelledAt?: string | null, currentPeriodEnd: string } | null };

export type RenewablePurchaseSetRenewalBillingMutationVariables = Exact<{
  renewablePurchaseId: Scalars['MongoID']['input'];
  renewalBilling: EnumRenewablePurchaseRenewalBilling;
}>;


export type RenewablePurchaseSetRenewalBillingMutation = { __typename?: 'Mutation', renewablePurchaseSetRenewalBilling?: { __typename?: 'RenewablePurchase', _id: any, renewalBilling?: EnumRenewablePurchaseRenewalBilling | null } | null };

export type RenewablePurchaseUpdateListingsMutationVariables = Exact<{
  renewablePurchaseId: Scalars['MongoID']['input'];
  operatorIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type RenewablePurchaseUpdateListingsMutation = { __typename?: 'Mutation', renewablePurchaseUpdateListings?: { __typename?: 'RenewablePurchase', _id: any, operatorIds?: Array<string | null> | null, pendingOperatorIds?: Array<string | null> | null } | null };

export type RenewalEngineEnableMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  activeTagId?: InputMaybe<Scalars['MongoID']['input']>;
  renewingTagId?: InputMaybe<Scalars['MongoID']['input']>;
  expiredTagId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type RenewalEngineEnableMutation = { __typename?: 'Mutation', renewalEngineEnable: { __typename?: 'RenewalEngineSetupResult', changed: number, byRole: Array<{ __typename?: 'RenewalEngineRoleCount', role: string, count: number }> } };

export type ReportRebuildMutationVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  reportType: Scalars['String']['input'];
}>;


export type ReportRebuildMutation = { __typename?: 'Mutation', reportRebuild: { __typename?: 'ReportRebuildResult', builtAt: any, rowCount: number } };

export type ResendBankTransferInstructionsMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type ResendBankTransferInstructionsMutation = { __typename?: 'Mutation', resendBankTransferInstructions?: { __typename?: 'ResendBankTransferInstructionsResult', success: boolean } | null };

export type RuleCreateMutationVariables = Exact<{
  record: CreateOneRuleInput;
}>;


export type RuleCreateMutation = { __typename?: 'Mutation', ruleCreate?: { __typename?: 'CreateOneRulePayload', record?: { __typename?: 'Rule', _id: any } | null } | null };

export type RuleCreateManyMutationVariables = Exact<{
  records: Array<CreateManyRuleInput> | CreateManyRuleInput;
}>;


export type RuleCreateManyMutation = { __typename?: 'Mutation', ruleCreateMany?: { __typename?: 'CreateManyRulePayload', records?: Array<{ __typename?: 'Rule', _id: any }> | null } | null };

export type RuleDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RuleDeleteMutation = { __typename?: 'Mutation', ruleDelete?: { __typename?: 'RemoveByIdRulePayload', record?: { __typename?: 'Rule', _id: any } | null } | null };

export type RuleUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdRuleInput;
}>;


export type RuleUpdateMutation = { __typename?: 'Mutation', ruleUpdate?: { __typename?: 'UpdateByIdRulePayload', record?: { __typename?: 'Rule', _id: any } | null } | null };

export type SavedReportCreateMutationVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  input: SavedReportInput;
}>;


export type SavedReportCreateMutation = { __typename?: 'Mutation', savedReportCreate: { __typename?: 'SavedReport', _id: any, storefront: any, name: string, dataset: string, columns: Array<string>, match: string, groupBy?: string | null, groupByGranularity?: string | null, updatedDateISO?: any | null, conditions: Array<{ __typename?: 'ReportCondition', field: string, op: string, values: Array<string> }>, sort?: { __typename?: 'ReportSort', field: string, direction: string } | null } };

export type SavedReportDeleteMutationVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  savedReportId: Scalars['MongoID']['input'];
}>;


export type SavedReportDeleteMutation = { __typename?: 'Mutation', savedReportDelete: boolean };

export type SavedReportUpdateMutationVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  savedReportId: Scalars['MongoID']['input'];
  input: SavedReportInput;
}>;


export type SavedReportUpdateMutation = { __typename?: 'Mutation', savedReportUpdate: { __typename?: 'SavedReport', _id: any, storefront: any, name: string, dataset: string, columns: Array<string>, match: string, groupBy?: string | null, groupByGranularity?: string | null, updatedDateISO?: any | null, conditions: Array<{ __typename?: 'ReportCondition', field: string, op: string, values: Array<string> }>, sort?: { __typename?: 'ReportSort', field: string, direction: string } | null } };

export type ScheduledPaymentRetryFailedMutationVariables = Exact<{
  scheduledPaymentId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
  paymentMethodId: Scalars['String']['input'];
}>;


export type ScheduledPaymentRetryFailedMutation = { __typename?: 'Mutation', scheduledPaymentRetryFailed: { __typename?: 'ScheduledPayment', _id: any, amount: number, dueDate: string, order: string, status: EnumScheduledPaymentStatus, type: EnumScheduledPaymentType, stripeMetadata?: { __typename?: 'StripeMetadata', connectedAccountId?: string | null } | null } };

export type StorefrontConnectNewStripeAccountMutationVariables = Exact<{
  storefrontId: Scalars['ID']['input'];
  redirectUrl: Scalars['String']['input'];
  bookerId?: InputMaybe<Scalars['ID']['input']>;
  assignToUnassignedBookers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StorefrontConnectNewStripeAccountMutation = { __typename?: 'Mutation', storefrontConnectNewStripeAccount?: { __typename?: 'StorefrontConnectNewStripeReturn', link: string, record?: { __typename?: 'Storefront', _id: any } | null } | null };

export type StorefrontCreateMutationVariables = Exact<{
  record: CreateOneStorefrontInput;
}>;


export type StorefrontCreateMutation = { __typename?: 'Mutation', storefrontCreate?: { __typename?: 'CreateOneStorefrontPayload', record?: { __typename?: 'Storefront', _id: any, testMode: boolean, name: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } } | null } | null };

export type StorefrontDisconnectStripeAccountMutationVariables = Exact<{
  storefrontId: Scalars['ID']['input'];
  connectedAccountId: Scalars['String']['input'];
  deleteFromStripe?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StorefrontDisconnectStripeAccountMutation = { __typename?: 'Mutation', storefrontDisconnectStripeAccount?: { __typename?: 'StorefrontDisconnectStripeAccountReturn', success: boolean, blockingWidgetNames?: Array<string> | null, record?: { __typename?: 'Storefront', _id: any, connectedAccountIds: Array<string | null> } | null } | null };

export type StorefrontEnsureTestStorefrontMutationVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
}>;


export type StorefrontEnsureTestStorefrontMutation = { __typename?: 'Mutation', storefrontEnsureTestStorefront?: { __typename?: 'StorefrontEnsureTestStorefrontPayload', created: boolean, liveStorefront: { __typename?: 'Storefront', _id: any, testStorefront?: any | null }, testStorefront: { __typename?: 'Storefront', _id: any, liveStorefront?: any | null } } | null };

export type StorefrontFastForwardRenewalsMutationVariables = Exact<{
  storefrontId: Scalars['ID']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
}>;


export type StorefrontFastForwardRenewalsMutation = { __typename?: 'Mutation', storefrontFastForwardRenewals?: { __typename?: 'FastForwardRenewalsResult', purchasesAdvanced: number, recordsCreated: number, autoChargesProcessed: number, invoicesProcessed: number, log?: Array<{ __typename?: 'FastForwardLogEntry', timestamp: string, event: string, detail?: string | null } | null> | null } | null };

export type StorefrontForceRenewalsMutationVariables = Exact<{
  storefrontId: Scalars['ID']['input'];
}>;


export type StorefrontForceRenewalsMutation = { __typename?: 'Mutation', storefrontForceRenewals?: { __typename?: 'ForceRenewalsResult', processedCount: number, recordsCreated: number, autoChargesProcessed: number, invoicesProcessed: number } | null };

export type StorefrontGenerateStatementsMutationVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  period: Scalars['String']['input'];
}>;


export type StorefrontGenerateStatementsMutation = { __typename?: 'Mutation', storefrontGenerateStatements?: { __typename?: 'StatementGenerationRun', _id: any, period: string, status: EnumStatementGenerationRunStatus, createdByName?: string | null, statementCount: number, grandTotalSum: number, currency: string, createdDateISO?: any | null, rolledBackAt?: string | null, rolledBackByName?: string | null, items: Array<{ __typename?: 'StatementGenerationRunItems', paymentRequestId: any, invoiceNumber?: string | null, customerName?: string | null, orderIds?: Array<string | null> | null, grandTotal: number, rollbackStatus?: EnumStatementGenerationRunItemsRollbackStatus | null } | null> } | null };

export type StorefrontLaunchMutationVariables = Exact<{
  liveStorefrontId: Scalars['MongoID']['input'];
  bookerIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  freeOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StorefrontLaunchMutation = { __typename?: 'Mutation', storefrontLaunch?: { __typename?: 'StorefrontLaunchPayload', skipped: Array<any>, liveStorefront: { __typename?: 'Storefront', _id: any, isLaunched: boolean, launchedAt?: any | null, paymentsMode: EnumStorefrontPaymentsMode }, copied: Array<{ __typename?: 'StorefrontLaunchCopiedBooker', sourceBookerId: any, bookerId: any }>, failed: Array<{ __typename?: 'StorefrontLaunchFailedBooker', sourceBookerId: any, message: string }> } | null };

export type StorefrontPageCreateMutationVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  bookerId: Scalars['MongoID']['input'];
  type: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type StorefrontPageCreateMutation = { __typename?: 'Mutation', storefrontPageCreate: { __typename?: 'StorefrontPageResult', _id: any, storefront: any, booker: any, type: string, slug: string, generatedPageHtml?: string | null, pageGeneratedAt?: any | null, editPromptHistory: Array<string>, status: string, pageUrl: string, createdDateISO?: any | null, updatedDateISO?: any | null } };

export type StorefrontPageDeleteMutationVariables = Exact<{
  pageId: Scalars['MongoID']['input'];
}>;


export type StorefrontPageDeleteMutation = { __typename?: 'Mutation', storefrontPageDelete?: { __typename?: 'StorefrontPageResult', _id: any, slug: string } | null };

export type StorefrontPageEditMutationVariables = Exact<{
  pageId: Scalars['MongoID']['input'];
  prompt: Scalars['String']['input'];
}>;


export type StorefrontPageEditMutation = { __typename?: 'Mutation', storefrontPageEdit: { __typename?: 'StorefrontPageResult', _id: any, storefront: any, booker: any, type: string, slug: string, generatedPageHtml?: string | null, pageGeneratedAt?: any | null, editPromptHistory: Array<string>, status: string, pageUrl: string, createdDateISO?: any | null, updatedDateISO?: any | null } };

export type StorefrontPageGenerateMutationVariables = Exact<{
  pageId: Scalars['MongoID']['input'];
}>;


export type StorefrontPageGenerateMutation = { __typename?: 'Mutation', storefrontPageGenerate: { __typename?: 'StorefrontPageResult', _id: any, storefront: any, booker: any, type: string, slug: string, generatedPageHtml?: string | null, pageGeneratedAt?: any | null, editPromptHistory: Array<string>, status: string, pageUrl: string, createdDateISO?: any | null, updatedDateISO?: any | null } };

export type StorefrontPageUpdateStatusMutationVariables = Exact<{
  pageId: Scalars['MongoID']['input'];
  status: Scalars['String']['input'];
}>;


export type StorefrontPageUpdateStatusMutation = { __typename?: 'Mutation', storefrontPageUpdateStatus: { __typename?: 'StorefrontPageResult', _id: any, status: string, pageUrl: string } };

export type StorefrontPlatformSettingsUpdateMutationVariables = Exact<{
  gettingStartedWistiaId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StorefrontPlatformSettingsUpdateMutation = { __typename?: 'Mutation', storefrontPlatformSettingsUpdate: { __typename?: 'StorefrontPlatformSettings', _id: any, gettingStartedWistiaId?: string | null } };

export type StorefrontPurgeTestDataMutationVariables = Exact<{
  storefrontId: Scalars['ID']['input'];
}>;


export type StorefrontPurgeTestDataMutation = { __typename?: 'Mutation', storefrontPurgeTestData?: { __typename?: 'PurgeTestDataResult', purgedOrderCount: number } | null };

export type StorefrontRollbackStatementGenerationMutationVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  runId: Scalars['MongoID']['input'];
}>;


export type StorefrontRollbackStatementGenerationMutation = { __typename?: 'Mutation', storefrontRollbackStatementGeneration?: { __typename?: 'StatementGenerationRun', _id: any, period: string, status: EnumStatementGenerationRunStatus, createdByName?: string | null, statementCount: number, grandTotalSum: number, currency: string, createdDateISO?: any | null, rolledBackAt?: string | null, rolledBackByName?: string | null, items: Array<{ __typename?: 'StatementGenerationRunItems', paymentRequestId: any, invoiceNumber?: string | null, customerName?: string | null, orderIds?: Array<string | null> | null, grandTotal: number, rollbackStatus?: EnumStatementGenerationRunItemsRollbackStatus | null } | null> } | null };

export type StorefrontSendTestEmailsMutationVariables = Exact<{
  storefrontId: Scalars['ID']['input'];
  recipientUserId: Scalars['ID']['input'];
  emailTypes: Array<StorefrontTestEmailType> | StorefrontTestEmailType;
}>;


export type StorefrontSendTestEmailsMutation = { __typename?: 'Mutation', storefrontSendTestEmails?: { __typename?: 'StorefrontSendTestEmailsResult', sentCount: number, failed?: Array<{ __typename?: 'StorefrontTestEmailFailure', emailType: StorefrontTestEmailType, error: string }> | null } | null };

export type StorefrontSetApplicationFeeMutationVariables = Exact<{
  storefrontId: Scalars['String']['input'];
  applicationPercentage: Scalars['Float']['input'];
}>;


export type StorefrontSetApplicationFeeMutation = { __typename?: 'Mutation', storefrontSetApplicationFee?: { __typename?: 'StorefrontSetApplicationFeeResult', success: boolean, updatedCount: number } | null };

export type StorefrontSetApplicationFeeDefaultsMutationVariables = Exact<{
  storefrontId: Scalars['String']['input'];
  other: Scalars['Float']['input'];
  membership: Scalars['Float']['input'];
  merch: Scalars['Float']['input'];
}>;


export type StorefrontSetApplicationFeeDefaultsMutation = { __typename?: 'Mutation', storefrontSetApplicationFeeDefaults?: { __typename?: 'Storefront', _id: any, applicationPercentage: number, applicationFeeDefaults?: { __typename?: 'StorefrontApplicationFeeDefaults', membership?: number | null, merch?: number | null } | null } | null };

export type StorefrontSetInvoicingEnabledMutationVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type StorefrontSetInvoicingEnabledMutation = { __typename?: 'Mutation', storefrontSetInvoicingEnabled?: { __typename?: 'Storefront', _id: any, invoicingEnabled: boolean } | null };

export type StorefrontSetRegionMutationVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  stripeRegion: Scalars['String']['input'];
}>;


export type StorefrontSetRegionMutation = { __typename?: 'Mutation', storefrontSetRegion: { __typename?: 'Storefront', _id: any, stripeRegion: EnumStorefrontStripeRegion } };

export type StorefrontUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdStorefrontInput;
}>;


export type StorefrontUpdateMutation = { __typename?: 'Mutation', storefrontUpdate?: { __typename?: 'UpdateByIdStorefrontPayload', record?: { __typename?: 'Storefront', _id: any, accountingCodes: Array<string | null>, defaultInvoicePolicy?: any | null, connectedListings: Array<string | null>, lowStockDigestEnabled: boolean, defaultWidgetLogo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, emailBranding?: { __typename?: 'StorefrontEmailBranding', fromName?: string | null, replyTo?: string | null, accentColor?: string | null, showContact?: boolean | null, useOrganizationEmailSettings?: boolean | null, footerText?: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } | null, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } | null, name: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null }, enabledFeeTypes?: { __typename?: 'StorefrontEnabledFeeTypes', accommodations?: boolean | null, oneTimeFee?: boolean | null, renewableFees?: boolean | null, events?: boolean | null, merch?: boolean | null } | null } | null } | null };

export type StripePayoutsSyncMutationVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  sinceDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type StripePayoutsSyncMutation = { __typename?: 'Mutation', stripePayoutsSync: { __typename?: 'StripeSyncResult', payoutCount: number, transactionCount: number, syncedAt: any } };

export type SurveyCreateMutationVariables = Exact<{
  record: CreateOneSurveyInput;
}>;


export type SurveyCreateMutation = { __typename?: 'Mutation', surveyCreate?: { __typename?: 'CreateOneSurveyPayload', record?: { __typename?: 'Survey', _id: any } | null } | null };

export type SurveyDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type SurveyDeleteMutation = { __typename?: 'Mutation', surveyDelete?: { __typename?: 'SurveyDeleteResult', deletedQuestionCount: number } | null };

export type SurveyDuplicateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type SurveyDuplicateMutation = { __typename?: 'Mutation', surveyDuplicate?: { __typename?: 'SurveyDuplicateResult', surveyId: any } | null };

export type SurveyQuestionCreateManyMutationVariables = Exact<{
  records: Array<CreateManySurveyQuestionInput> | CreateManySurveyQuestionInput;
}>;


export type SurveyQuestionCreateManyMutation = { __typename?: 'Mutation', surveyQuestionCreateMany?: { __typename?: 'CreateManySurveyQuestionPayload', records?: Array<{ __typename?: 'SurveyQuestion', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> | null } | null };

export type SurveyQuestionUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdSurveyQuestionInput;
}>;


export type SurveyQuestionUpdateMutation = { __typename?: 'Mutation', surveyQuestionUpdate?: { __typename?: 'UpdateByIdSurveyQuestionPayload', record?: { __typename?: 'SurveyQuestion', _id: any } | null } | null };

export type SurveyResponseAdminEditMutationVariables = Exact<{
  surveyResponseId: Scalars['String']['input'];
  responses: Array<Scalars['JSON']['input']> | Scalars['JSON']['input'];
}>;


export type SurveyResponseAdminEditMutation = { __typename?: 'Mutation', surveyResponseAdminEdit: { __typename?: 'SurveyResponse', _id: any, responses: Array<{ __typename?: 'SurveyResponseResponses', response: Array<string | null>, questionData: { __typename?: 'SurveyQuestion', _id: any, isActive: boolean, type: EnumSurveyQuestionType, required: boolean, whereaboutsSearchEntityType?: EnumSurveyQuestionWhereaboutsSearchEntityType | null, parentQuestion?: any | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, options: Array<{ __typename?: 'SurveyQuestionOptions', _id?: any | null, isActive: boolean, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> } } | null>, history?: Array<{ __typename?: 'SurveyResponseHistory', action: EnumSurveyResponseHistoryAction, timestamp: any, personName?: string | null, reviewStatus?: EnumSurveyResponseHistoryReviewStatus | null, reviewNote?: string | null } | null> | null } };

export type SurveyResponseCreateMutationVariables = Exact<{
  record: CreateOneSurveyResponseInput;
}>;


export type SurveyResponseCreateMutation = { __typename?: 'Mutation', surveyResponseCreate?: { __typename?: 'CreateOneSurveyResponsePayload', record?: { __typename?: 'SurveyResponse', _id: any } | null } | null };

export type SurveyResponseDeleteByIdMutationVariables = Exact<{
  surveyResponseId: Scalars['String']['input'];
}>;


export type SurveyResponseDeleteByIdMutation = { __typename?: 'Mutation', surveyResponseDeleteById?: { __typename?: 'SurveyResponse', _id: any } | null };

export type SurveyResponseReviewSubmissionMutationVariables = Exact<{
  surveyResponseId: Scalars['String']['input'];
  decision: Scalars['String']['input'];
  reviewNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type SurveyResponseReviewSubmissionMutation = { __typename?: 'Mutation', surveyResponseReviewSubmission: { __typename?: 'SurveyResponse', _id: any, status?: EnumSurveyResponseStatus | null, version?: number | null, adminStatus?: EnumSurveyResponseAdminStatus | null, responses: Array<{ __typename?: 'SurveyResponseResponses', response: Array<string | null>, questionData: { __typename?: 'SurveyQuestion', _id: any, name: { __typename?: 'Multilingual', en?: string | null } } } | null> } };

export type SurveyResponseSaveForBroadcastMutationVariables = Exact<{
  surveyId: Scalars['String']['input'];
  broadcastId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  personId: Scalars['String']['input'];
  savedByPersonId?: InputMaybe<Scalars['String']['input']>;
  responses: Array<Scalars['JSON']['input']> | Scalars['JSON']['input'];
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  submissionIndex?: InputMaybe<Scalars['Int']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  isNewSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  operatorId?: InputMaybe<Scalars['String']['input']>;
  operatorIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SurveyResponseSaveForBroadcastMutation = { __typename?: 'Mutation', surveyResponseSaveForBroadcast: { __typename?: 'SurveyResponse', _id: any, status?: EnumSurveyResponseStatus | null, version?: number | null, submissionIndex: number, responses: Array<{ __typename?: 'SurveyResponseResponses', response: Array<string | null>, questionData: { __typename?: 'SurveyQuestion', _id: any, name: { __typename?: 'Multilingual', en?: string | null } } } | null>, history?: Array<{ __typename?: 'SurveyResponseHistory', action: EnumSurveyResponseHistoryAction, savedBy: any, personName?: string | null, timestamp: any, reviewStatus?: EnumSurveyResponseHistoryReviewStatus | null, reviewNote?: string | null } | null> | null } };

export type SurveyResponseSubmitForBroadcastMutationVariables = Exact<{
  surveyId: Scalars['String']['input'];
  broadcastId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  personId: Scalars['String']['input'];
  savedByPersonId?: InputMaybe<Scalars['String']['input']>;
  responses: Array<Scalars['JSON']['input']> | Scalars['JSON']['input'];
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  submissionIndex?: InputMaybe<Scalars['Int']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  isNewSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  operatorId?: InputMaybe<Scalars['String']['input']>;
  operatorIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SurveyResponseSubmitForBroadcastMutation = { __typename?: 'Mutation', surveyResponseSubmitForBroadcast: { __typename?: 'SurveyResponse', _id: any, status?: EnumSurveyResponseStatus | null, version?: number | null, submissionIndex: number, adminStatus?: EnumSurveyResponseAdminStatus | null, responses: Array<{ __typename?: 'SurveyResponseResponses', response: Array<string | null>, questionData: { __typename?: 'SurveyQuestion', _id: any, name: { __typename?: 'Multilingual', en?: string | null } } } | null>, history?: Array<{ __typename?: 'SurveyResponseHistory', action: EnumSurveyResponseHistoryAction, savedBy: any, personName?: string | null, timestamp: any, reviewStatus?: EnumSurveyResponseHistoryReviewStatus | null, reviewNote?: string | null } | null> | null } };

export type SurveyResponseUpdateAdminStatusMutationVariables = Exact<{
  surveyResponseId: Scalars['String']['input'];
  adminStatus: Scalars['String']['input'];
}>;


export type SurveyResponseUpdateAdminStatusMutation = { __typename?: 'Mutation', surveyResponseUpdateAdminStatus: { __typename?: 'SurveyResponse', _id: any, adminStatus?: EnumSurveyResponseAdminStatus | null } };

export type SurveyResponseUpdateTagsMutationVariables = Exact<{
  surveyResponseId: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SurveyResponseUpdateTagsMutation = { __typename?: 'Mutation', surveyResponseUpdateTags: { __typename?: 'SurveyResponse', _id: any, tags?: Array<any | null> | null } };

export type SurveyUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdSurveyInput;
}>;


export type SurveyUpdateMutation = { __typename?: 'Mutation', surveyUpdate?: { __typename?: 'UpdateByIdSurveyPayload', record?: { __typename?: 'Survey', _id: any } | null } | null };

export type TagCreateMutationVariables = Exact<{
  record: CreateOneTagInput;
}>;


export type TagCreateMutation = { __typename?: 'Mutation', tagCreate?: { __typename?: 'CreateOneTagPayload', record?: { __typename?: 'Tag', _id: any, entityTypes: Array<EnumTagEntityTypes | null>, inheritable: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null } | null };

export type TagDeleteMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type TagDeleteMutation = { __typename?: 'Mutation', tagDelete?: { __typename?: 'RemoveByIdTagPayload', record?: { __typename?: 'Tag', _id: any } | null } | null };

export type TagGroupManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyTagGroupInput>;
}>;


export type TagGroupManyQuery = { __typename?: 'Query', tagGroupMany: Array<{ __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type TagMergeMutationVariables = Exact<{
  tagIdToMergeAndDelete: Scalars['ID']['input'];
  tagIdToMergeInto: Scalars['ID']['input'];
}>;


export type TagMergeMutation = { __typename?: 'Mutation', tagMerge?: { __typename?: 'Tag', _id: any, entityTypes: Array<EnumTagEntityTypes | null>, inheritable: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, usage?: { __typename?: 'TagUsage', events?: number | null, operators?: number | null, products?: number | null, total?: number | null } | null } | null };

export type TagSplitMutationVariables = Exact<{
  tagSplitId: Scalars['ID']['input'];
  nameForCurrentTag: MultilingualInput;
  namesForNewTags: Array<MultilingualInput> | MultilingualInput;
}>;


export type TagSplitMutation = { __typename?: 'Mutation', tagSplit: Array<{ __typename?: 'Tag', _id: any, entityTypes: Array<EnumTagEntityTypes | null>, inheritable: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, usage?: { __typename?: 'TagUsage', events?: number | null, operators?: number | null, products?: number | null, total?: number | null } | null }> };

export type TagSuggestionApproveMutationVariables = Exact<{
  tagSuggestionApproveId: Scalars['ID']['input'];
  tagGroup: Scalars['ID']['input'];
  name: MultilingualInput;
  entityTypes: Array<EnumTagSuggestionEntityTypes> | EnumTagSuggestionEntityTypes;
}>;


export type TagSuggestionApproveMutation = { __typename?: 'Mutation', tagSuggestionApprove?: { __typename?: 'Tag', _id: any, entityTypes: Array<EnumTagEntityTypes | null>, inheritable: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, usage?: { __typename?: 'TagUsage', events?: number | null, operators?: number | null, products?: number | null, total?: number | null } | null } | null };

export type TagSuggestionCreateMutationVariables = Exact<{
  record: CreateOneTagSuggestionInput;
}>;


export type TagSuggestionCreateMutation = { __typename?: 'Mutation', tagSuggestionCreate?: { __typename?: 'CreateOneTagSuggestionPayload', record?: { __typename?: 'TagSuggestion', _id: any, entityTypes: Array<EnumTagSuggestionEntityTypes | null>, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, aiResponse?: { __typename?: 'TagSuggestionAIResponse', action?: EnumTagSuggestionAiResponseAction | null, summary?: string | null, similarTags: Array<string | null>, alternativeSuggestions: Array<string | null> } | null } | null } | null };

export type TagSuggestionRejectMutationVariables = Exact<{
  tagSuggestionRejectId: Scalars['ID']['input'];
}>;


export type TagSuggestionRejectMutation = { __typename?: 'Mutation', tagSuggestionReject?: boolean | null };

export type TagUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTagInput;
}>;


export type TagUpdateMutation = { __typename?: 'Mutation', tagUpdate?: { __typename?: 'UpdateByIdTagPayload', record?: { __typename?: 'Tag', _id: any, entityTypes: Array<EnumTagEntityTypes | null>, inheritable: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, usage?: { __typename?: 'TagUsage', events?: number | null, operators?: number | null, products?: number | null, total?: number | null } | null } | null } | null };

export type TaxCreateMutationVariables = Exact<{
  record: CreateOneTaxInput;
}>;


export type TaxCreateMutation = { __typename?: 'Mutation', taxCreate?: { __typename?: 'CreateOneTaxPayload', recordId?: any | null, record?: { __typename?: 'Tax', _id: any } | null } | null };

export type TaxUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdTaxInput;
}>;


export type TaxUpdateMutation = { __typename?: 'Mutation', taxUpdate?: { __typename?: 'UpdateByIdTaxPayload', record?: { __typename?: 'Tax', _id: any, percentage: number } | null } | null };

export type UserApproveAccessMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  entity: EntityReferenceInput;
}>;


export type UserApproveAccessMutation = { __typename?: 'Mutation', userApproveAccess?: { __typename?: 'UserWithPictureTC', _id: any } | null };

export type UserCreateMutationVariables = Exact<{
  record: CreateOneUserInput;
}>;


export type UserCreateMutation = { __typename?: 'Mutation', userCreate?: { __typename?: 'UserWithResetPasswordUrlTC', passwordResetUrl?: string | null } | null };

export type UserCreateConfirmationCodeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  confirmationCodeType: EnumConfirmationCodeType;
}>;


export type UserCreateConfirmationCodeMutation = { __typename?: 'Mutation', userCreateConfirmationCode: { __typename?: 'User', _id: any } };

export type UserCreateInviteMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  photo?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  sendInvitationEmail: Scalars['Boolean']['input'];
  entity: EntityReferenceInput;
  role?: InputMaybe<RoleType>;
  contactRoles?: InputMaybe<Array<InputMaybe<ContactRole>> | InputMaybe<ContactRole>>;
  emailPreferences?: InputMaybe<Array<UserEmailPreferencesInput> | UserEmailPreferencesInput>;
}>;


export type UserCreateInviteMutation = { __typename?: 'Mutation', userCreateInvite?: { __typename?: 'User', _id: any, email: string, firstName: string, lastName: string } | null };

export type UserJoinOrganizationFromColdSignupMutationVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
}>;


export type UserJoinOrganizationFromColdSignupMutation = { __typename?: 'Mutation', userJoinOrganizationFromColdSignup: boolean };

export type UserRequestAccessMutationVariables = Exact<{
  entity: EntityReferenceInput;
}>;


export type UserRequestAccessMutation = { __typename?: 'Mutation', userRequestAccess?: { __typename?: 'UserWithPictureTC', picture?: string | null, _id: any, personId?: string | null, firstName: string, lastName: string, email: string, title?: string | null, photoUploadedBy?: any | null, contactRoles?: Array<ContactRole | null> | null, status: EnumUserStatus, userType: EnumUserUserType, quickLinksVersion: number, lastViewedListId?: string | null, hasPurchases: boolean, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus, title?: string | null, contactRoles?: Array<EnumUserAccessOperatorsContactRoles | null> | null } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, storefronts: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null> }, onboardingMetadata?: { __typename?: 'UserOnboardingMetadata', onboardingOrganization?: any | null, isPostOnboarding?: boolean | null, onboardingBroadcast?: any | null } | null, emailPreferences: Array<{ __typename?: 'UserEmailPreferences', templateName: EnumUserEmailPreferencesTemplateName, frequency: EnumUserEmailPreferencesFrequency, entity?: { __typename?: 'EntityReference', type: EnumEntityReferenceType, _entityId: any } | null } | null>, quickLinks: Array<{ __typename?: 'UserQuickLinks', title: string, link: string, lastVisited: string, type: EnumUserQuickLinksType, entityId: string, pinned?: boolean | null } | null>, memberships: Array<{ __typename?: 'UserMembershipRow', _id: any, subjectType: string, listingName?: string | null, organizationId: any, organizationName: string, organizationLogo?: any | null, memberNomenclature: string, membershipNomenclature: string, tierName?: string | null, status: string, statusTagNames: Array<string>, renewalDate?: any | null, renewalDateDisplayMode: string, needsRenewal: boolean, tierTagId?: any | null, subjectEntityId: any, renewablePurchaseId?: any | null, renewalBilling?: string | null }> } | null };

export type UserResendConfirmationCodeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sentToEmail: Scalars['String']['input'];
  type: EnumConfirmationCodeType;
}>;


export type UserResendConfirmationCodeMutation = { __typename?: 'Mutation', userResendConfirmationCode: { __typename?: 'User', _id: any } };

export type UserRevokeInviteMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  entity: EntityReferenceInput;
  primaryContactReplacementUserId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UserRevokeInviteMutation = { __typename?: 'Mutation', userRevokeInvite?: { __typename?: 'User', _id: any } | null };

export type UserSaveQuickLinksMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  baseQuickLinks: Array<UserQuickLinksInput> | UserQuickLinksInput;
  quickLinks: Array<UserQuickLinksInput> | UserQuickLinksInput;
}>;


export type UserSaveQuickLinksMutation = { __typename?: 'Mutation', userSaveQuickLinks?: { __typename?: 'UserWithResetPasswordUrlTC', _id: any, passwordResetUrl?: string | null } | null };

export type UserUpdateMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdUserInput;
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', userUpdate?: { __typename?: 'UserWithResetPasswordUrlTC', _id: any, passwordResetUrl?: string | null, lastViewedListId?: string | null } | null };

export type UserValidateConfirmationCodeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  code: Scalars['String']['input'];
}>;


export type UserValidateConfirmationCodeMutation = { __typename?: 'Mutation', userValidateConfirmationCode: { __typename?: 'User', _id: any } };

export type VideoCreateFromMuxMutationVariables = Exact<{
  muxAssetId: Scalars['String']['input'];
  muxPlaybackId?: InputMaybe<Scalars['String']['input']>;
  muxStatus?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  bytes?: InputMaybe<Scalars['Float']['input']>;
  defaultCaption?: InputMaybe<MultilingualInput>;
}>;


export type VideoCreateFromMuxMutation = { __typename?: 'Mutation', videoCreateFromMux: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null } };

export type VideoDeleteFromMuxOnlyMutationVariables = Exact<{
  muxAssetId: Scalars['String']['input'];
}>;


export type VideoDeleteFromMuxOnlyMutation = { __typename?: 'Mutation', videoDeleteFromMuxOnly: boolean };

export type VideoMuxStatusRefreshMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type VideoMuxStatusRefreshMutation = { __typename?: 'Mutation', videoMuxStatusRefresh: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null } };

export type WhereabotChatCreateMutationVariables = Exact<{
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type WhereabotChatCreateMutation = { __typename?: 'Mutation', whereabotChatCreate?: { __typename?: 'WhereabotChat', _id: any, title: string, chatModel: string, status: EnumWhereabotChatStatus, createdDateISO?: any | null, createdBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, picture?: string | null } | null } | null };

export type WhereabotChatSendMessageMutationVariables = Exact<{
  chatId: Scalars['MongoID']['input'];
  content: Scalars['String']['input'];
}>;


export type WhereabotChatSendMessageMutation = { __typename?: 'Mutation', whereabotChatSendMessage?: { __typename?: 'WhereabotMessage', _id: any, chat: any, role: EnumWhereabotMessageRole, content: string, isError: boolean, createdDateISO?: any | null, operatorResults?: Array<{ __typename?: 'WhereabotMessageOperatorResults', operatorEntityId: string, operatorName: string, operatorType: string, organizationId?: string | null, score: number, isRelated?: boolean | null } | null> | null, metadata?: { __typename?: 'WhereabotMessageMetadata', embeddingTimeMs?: number | null, searchTimeMs?: number | null, llmTimeMs?: number | null, totalTimeMs?: number | null, operatorsSearched?: number | null } | null } | null };

export type WhereabotChatUpdateMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type WhereabotChatUpdateMutation = { __typename?: 'Mutation', whereabotChatUpdate?: { __typename?: 'WhereabotChat', _id: any, title: string, rating?: number | null, notes?: string | null, status: EnumWhereabotChatStatus, updatedDateISO?: any | null } | null };

export type WhereabotHelpAskMutationVariables = Exact<{
  question: Scalars['String']['input'];
  history?: InputMaybe<Array<WhereabotHelpMessageInput> | WhereabotHelpMessageInput>;
}>;


export type WhereabotHelpAskMutation = { __typename?: 'Mutation', whereabotHelpAsk: { __typename?: 'WhereabotHelpAnswer', answer: string } };

export type WhereabotSettingsUpdateMutationVariables = Exact<{
  chatModel: Scalars['String']['input'];
}>;


export type WhereabotSettingsUpdateMutation = { __typename?: 'Mutation', whereabotSettingsUpdate?: { __typename?: 'WhereabotSettings', _id: any, chatModel: string, updatedBy: any, updatedDateISO?: any | null } | null };

export type WidgetCreateMutationVariables = Exact<{
  record: CreateOneWidgetInput;
}>;


export type WidgetCreateMutation = { __typename?: 'Mutation', widgetCreate?: { __typename?: 'CreateOneWidgetPayload', record?: { __typename?: 'Widget', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type WidgetDeleteByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type WidgetDeleteByIdMutation = { __typename?: 'Mutation', widgetDeleteById?: { __typename?: 'RemoveByIdWidgetPayload', record?: { __typename?: 'Widget', _id: any } | null } | null };

export type WidgetUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdWidgetInput;
}>;


export type WidgetUpdateByIdMutation = { __typename?: 'Mutation', widgetUpdateById?: { __typename?: 'UpdateByIdWidgetPayload', record?: { __typename?: 'Widget', _id: any, favorited: boolean, archived: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, eventSettings?: { __typename?: 'WidgetEventSettings', displayType: EnumWidgetEventSettingsDisplayType, eventTags: Array<any | null>, hiddenPublicFilterTags?: Array<any | null> | null, publicFilterMode?: EnumWidgetEventSettingsPublicFilterMode | null, publicFilterSort?: EnumWidgetEventSettingsPublicFilterSort | null, shownPublicFilterTags?: Array<any | null> | null, lookAheadMonths?: number | null, startMonth?: string | null, hideCancelledEvents?: boolean | null } | null, gallerySettings?: { __typename?: 'WidgetGallerySettings', items?: Array<any | null> | null, enableUrlPush?: boolean | null, playerPagePath?: string | null, profilePageEnabled?: boolean | null, allMedia?: boolean | null, infiniteScroll?: { __typename?: 'WidgetGallerySettingsInfiniteScroll', enabled?: boolean | null, mediaTagFilters?: Array<any | null> | null, listingFilters?: Array<any | null> | null } | null } | null } | null } | null };

export type WorkbenchChatCreateMutationVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
  testOrganizationId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type WorkbenchChatCreateMutation = { __typename?: 'Mutation', workbenchChatCreate: { __typename?: 'WhereabotChat', _id: any, title: string, status: EnumWhereabotChatStatus, featureFlagKey?: string | null, testOrganizationId?: any | null } };

export type WorkbenchChatSendMessageMutationVariables = Exact<{
  chatId: Scalars['MongoID']['input'];
  content: Scalars['String']['input'];
  sessionEvents?: InputMaybe<Array<WorkbenchSessionEventInput> | WorkbenchSessionEventInput>;
}>;


export type WorkbenchChatSendMessageMutation = { __typename?: 'Mutation', workbenchChatSendMessage: { __typename?: 'WhereabotMessage', _id: any, chat: any, role: EnumWhereabotMessageRole, content: string, isError: boolean, createdDateISO?: any | null, metadata?: { __typename?: 'WhereabotMessageMetadata', model?: string | null } | null, sessionEvents?: Array<{ __typename?: 'WhereabotMessageSessionEvents', at: any, type: EnumWhereabotMessageSessionEventsType, route?: string | null, operationName?: string | null, message?: string | null, flagKey?: string | null, enabled?: boolean | null } | null> | null, workbenchSuggestions: Array<{ __typename?: 'WorkbenchSuggestion', _id: any, featureFlagKey: string, chat?: any | null, message?: any | null, kind: EnumWorkbenchSuggestionKind, target: EnumWorkbenchSuggestionTarget, title: string, body: string, category?: EnumWorkbenchSuggestionCategory | null, docsSection?: string | null, relatedFiles?: Array<string | null> | null, status: EnumWorkbenchSuggestionStatus, createdBy?: any | null, createdByName?: string | null, createdDateISO?: any | null, pulledAt?: any | null, edit?: { __typename?: 'WorkbenchSuggestionEdit', section: string, operation: EnumWorkbenchSuggestionEditOperation, content: string, anchorText?: string | null } | null }> } };

export type WorkbenchSuggestionAcceptMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type WorkbenchSuggestionAcceptMutation = { __typename?: 'Mutation', workbenchSuggestionAccept: { __typename?: 'WorkbenchSuggestion', _id: any, featureFlagKey: string, chat?: any | null, message?: any | null, kind: EnumWorkbenchSuggestionKind, target: EnumWorkbenchSuggestionTarget, title: string, body: string, category?: EnumWorkbenchSuggestionCategory | null, docsSection?: string | null, relatedFiles?: Array<string | null> | null, status: EnumWorkbenchSuggestionStatus, createdBy?: any | null, createdByName?: string | null, createdDateISO?: any | null, pulledAt?: any | null, edit?: { __typename?: 'WorkbenchSuggestionEdit', section: string, operation: EnumWorkbenchSuggestionEditOperation, content: string, anchorText?: string | null } | null } };

export type WorkbenchSuggestionDismissMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type WorkbenchSuggestionDismissMutation = { __typename?: 'Mutation', workbenchSuggestionDismiss: { __typename?: 'WorkbenchSuggestion', _id: any, featureFlagKey: string, chat?: any | null, message?: any | null, kind: EnumWorkbenchSuggestionKind, target: EnumWorkbenchSuggestionTarget, title: string, body: string, category?: EnumWorkbenchSuggestionCategory | null, docsSection?: string | null, relatedFiles?: Array<string | null> | null, status: EnumWorkbenchSuggestionStatus, createdBy?: any | null, createdByName?: string | null, createdDateISO?: any | null, pulledAt?: any | null, edit?: { __typename?: 'WorkbenchSuggestionEdit', section: string, operation: EnumWorkbenchSuggestionEditOperation, content: string, anchorText?: string | null } | null } };

export type WorkbenchSuggestionUpdateStatusMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  status: Scalars['String']['input'];
}>;


export type WorkbenchSuggestionUpdateStatusMutation = { __typename?: 'Mutation', workbenchSuggestionUpdateStatus: { __typename?: 'WorkbenchSuggestion', _id: any, featureFlagKey: string, chat?: any | null, message?: any | null, kind: EnumWorkbenchSuggestionKind, target: EnumWorkbenchSuggestionTarget, title: string, body: string, category?: EnumWorkbenchSuggestionCategory | null, docsSection?: string | null, relatedFiles?: Array<string | null> | null, status: EnumWorkbenchSuggestionStatus, createdBy?: any | null, createdByName?: string | null, createdDateISO?: any | null, pulledAt?: any | null, edit?: { __typename?: 'WorkbenchSuggestionEdit', section: string, operation: EnumWorkbenchSuggestionEditOperation, content: string, anchorText?: string | null } | null } };

export type WorkbenchReviewCompleteMutationVariables = Exact<{
  chatId: Scalars['MongoID']['input'];
}>;


export type WorkbenchReviewCompleteMutation = { __typename?: 'Mutation', workbenchReviewComplete: { __typename?: 'WhereabotChat', _id: any, status: EnumWhereabotChatStatus, reviewSummary?: string | null, reviewCompletedAt?: any | null } };

export type WorkbenchChangeRequestSummaryMutationVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
  target: Scalars['String']['input'];
  regenerate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WorkbenchChangeRequestSummaryMutation = { __typename?: 'Mutation', workbenchChangeRequestSummary: { __typename?: 'WorkbenchChangeRequestResult', target: string, openCount: number, openTesterCount: number, stale: boolean, newSinceGenerated: number, markdown?: string | null, summary?: { __typename?: 'WorkbenchChangeRequestSummary', generatedAt: any, model?: string | null, testerCount: number, suggestionCount: number, overview: string, integratedAt?: any | null, themes: Array<{ __typename?: 'WorkbenchChangeRequestTheme', title: string, summary: string, testerCount: number, suggestionIds: Array<any>, conflicts?: string | null, proposedSteps: Array<{ __typename?: 'WorkbenchChangeRequestStep', title: string, body: string }> }> } | null } };

export type WorkbenchChangeRequestsMarkIntegratedMutationVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
  target?: InputMaybe<Scalars['String']['input']>;
  suggestionIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type WorkbenchChangeRequestsMarkIntegratedMutation = { __typename?: 'Mutation', workbenchChangeRequestsMarkIntegrated: number };

export type WorkbenchSetHelpScoutUrlMutationVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type WorkbenchSetHelpScoutUrlMutation = { __typename?: 'Mutation', workbenchSetHelpScoutUrl: { __typename?: 'WorkbenchFeature', _id: any, helpScoutArticleUrl?: string | null } };

export type WorkbenchSettingsUpdateMutationVariables = Exact<{
  defaultTestOrganizationId?: InputMaybe<Scalars['MongoID']['input']>;
  defaultTestStorefrontId?: InputMaybe<Scalars['MongoID']['input']>;
  allowSeedingInProduction?: InputMaybe<Scalars['Boolean']['input']>;
  chatModel?: InputMaybe<WorkbenchModelTierInput>;
  summaryModel?: InputMaybe<WorkbenchModelTierInput>;
}>;


export type WorkbenchSettingsUpdateMutation = { __typename?: 'Mutation', workbenchSettingsUpdate: boolean };

export type WorkbenchSetTestOrganizationMutationVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type WorkbenchSetTestOrganizationMutation = { __typename?: 'Mutation', workbenchSetTestOrganization: { __typename?: 'WorkbenchFeature', _id: any, testOrganizationId?: any | null, effectiveTestOrganizationId?: any | null, effectiveTestOrganizationName?: string | null } };

export type WorkbenchSeedPreviewMutationVariables = Exact<{
  scenarioKey: Scalars['String']['input'];
  organizationId: Scalars['MongoID']['input'];
}>;


export type WorkbenchSeedPreviewMutation = { __typename?: 'Mutation', workbenchSeedPreview: { __typename?: 'WorkbenchSeedPreviewResult', sampleNames: Array<string>, notes: Array<string>, counts: Array<{ __typename?: 'WorkbenchSeedPreviewCount', label: string, count: number }> } };

export type WorkbenchSeedCreateMutationVariables = Exact<{
  scenarioKey: Scalars['String']['input'];
  organizationId: Scalars['MongoID']['input'];
}>;


export type WorkbenchSeedCreateMutation = { __typename?: 'Mutation', workbenchSeedCreate: { __typename?: 'WorkbenchSeedRun', _id: any, featureFlagKey: string, scenarioKey: string, organizationId: any, status: EnumWorkbenchSeedRunStatus, createdByName?: string | null, cleanedByName?: string | null, createdDateISO?: any | null, cleanedAt?: any | null, errorMessage?: string | null, preview?: { __typename?: 'WorkbenchSeedRunPreview', sampleNames?: Array<string | null> | null, notes?: Array<string | null> | null, counts?: Array<{ __typename?: 'WorkbenchSeedRunPreviewCounts', label: string, count: number } | null> | null } | null } };

export type WorkbenchSeedRegenerateMutationVariables = Exact<{
  runId: Scalars['MongoID']['input'];
}>;


export type WorkbenchSeedRegenerateMutation = { __typename?: 'Mutation', workbenchSeedRegenerate: { __typename?: 'WorkbenchSeedRun', _id: any, featureFlagKey: string, scenarioKey: string, organizationId: any, status: EnumWorkbenchSeedRunStatus, createdByName?: string | null, cleanedByName?: string | null, createdDateISO?: any | null, cleanedAt?: any | null, errorMessage?: string | null, preview?: { __typename?: 'WorkbenchSeedRunPreview', sampleNames?: Array<string | null> | null, notes?: Array<string | null> | null, counts?: Array<{ __typename?: 'WorkbenchSeedRunPreviewCounts', label: string, count: number } | null> | null } | null } };

export type WorkbenchSeedCleanupMutationVariables = Exact<{
  runId: Scalars['MongoID']['input'];
}>;


export type WorkbenchSeedCleanupMutation = { __typename?: 'Mutation', workbenchSeedCleanup: { __typename?: 'WorkbenchSeedRun', _id: any, featureFlagKey: string, scenarioKey: string, organizationId: any, status: EnumWorkbenchSeedRunStatus, createdByName?: string | null, cleanedByName?: string | null, createdDateISO?: any | null, cleanedAt?: any | null, errorMessage?: string | null, preview?: { __typename?: 'WorkbenchSeedRunPreview', sampleNames?: Array<string | null> | null, notes?: Array<string | null> | null, counts?: Array<{ __typename?: 'WorkbenchSeedRunPreviewCounts', label: string, count: number } | null> | null } | null } };

export type WorkbenchTesterAddMutationVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
  userIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type WorkbenchTesterAddMutation = { __typename?: 'Mutation', workbenchTesterAdd: { __typename?: 'WorkbenchFeature', _id: any, testerUsers: Array<{ __typename?: 'WorkbenchTesterInfo', userId: any, name: string, email: string, addedAt?: any | null, invitedAt?: any | null, lastContactedAt?: any | null }> } };

export type WorkbenchTesterRemoveMutationVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
  userId: Scalars['MongoID']['input'];
}>;


export type WorkbenchTesterRemoveMutation = { __typename?: 'Mutation', workbenchTesterRemove: { __typename?: 'WorkbenchFeature', _id: any, testerUsers: Array<{ __typename?: 'WorkbenchTesterInfo', userId: any, name: string, email: string, addedAt?: any | null, invitedAt?: any | null, lastContactedAt?: any | null }> } };

export type WorkbenchTestersContactMutationVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type WorkbenchTestersContactMutation = { __typename?: 'Mutation', workbenchTestersContact: { __typename?: 'WorkbenchContactResult', sent: number, failed: number } };

export type WorkbenchExpelMutationVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type WorkbenchExpelMutation = { __typename?: 'Mutation', workbenchExpel: { __typename?: 'WorkbenchLifecycleResult', success: boolean, error?: string | null, seedRunsCleaned?: number | null } };

export type WorkbenchReinstateMutationVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
}>;


export type WorkbenchReinstateMutation = { __typename?: 'Mutation', workbenchReinstate: { __typename?: 'WorkbenchLifecycleResult', success: boolean, error?: string | null } };

export type WorkbenchAdminGateToggleMutationVariables = Exact<{
  featureFlagId: Scalars['MongoID']['input'];
  userId: Scalars['MongoID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type WorkbenchAdminGateToggleMutation = { __typename?: 'Mutation', adminFeatureGateToggle?: { __typename?: 'ToggleGateResult', success: boolean, error?: string | null } | null };

export type FeatureFlagExpelMutationVariables = Exact<{
  featureFlagId: Scalars['MongoID']['input'];
  reason: Scalars['String']['input'];
}>;


export type FeatureFlagExpelMutation = { __typename?: 'Mutation', featureFlagExpel?: { __typename?: 'ExpelResult', success: boolean, error?: string | null, orgGatesCleared: number, adminGatesCleared: number, storefrontGatesCleared: number } | null };

export type FeatureFlagReinstateMutationVariables = Exact<{
  featureFlagId: Scalars['MongoID']['input'];
}>;


export type FeatureFlagReinstateMutation = { __typename?: 'Mutation', featureFlagReinstate?: { __typename?: 'GraduateResult', success: boolean, error?: string | null } | null };

export type ActivityLogCountQueryVariables = Exact<{
  filter?: InputMaybe<FilterCountActivityLogInput>;
}>;


export type ActivityLogCountQuery = { __typename?: 'Query', activityLogCount?: number | null };

export type ActivityLogManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyActivityLogInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyActivityLogInput>;
}>;


export type ActivityLogManyQuery = { __typename?: 'Query', activityLogMany: Array<{ __typename?: 'ActivityLog', _id: any, initiatedBy: string, type: EnumActivityLogType, createdDateISO?: any | null, importRunId?: any | null, resourceId?: any | null, surveyResponseId?: any | null, tags: Array<any | null>, entityName: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, message: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, entity: { __typename?: 'EntityReference', _entityId: any, type: EnumEntityReferenceType }, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, surveyResponse?: { __typename?: 'SurveyResponse', _id: any, adminStatus?: EnumSurveyResponseAdminStatus | null, reviewStatus?: EnumSurveyResponseReviewStatus | null, status?: EnumSurveyResponseStatus | null, tags?: Array<any | null> | null } | null, emailActivity?: { __typename?: 'ActivityLogEmailActivity', sentHtml?: string | null, templatePreviewHtml?: string | null, subject?: string | null, fromAddress?: { __typename?: 'ActivityLogEmailActivityFromAddress', name?: string | null, email?: string | null } | null, recipients?: Array<{ __typename?: 'ActivityLogEmailActivityRecipients', userId?: any | null, personId?: any | null, email: string, displayName: string, deliveredAt?: any | null, openedAt?: any | null, clickedAt?: any | null, bouncedAt?: any | null, droppedAt?: any | null, deferredAt?: any | null, spamReportedAt?: any | null } | null> | null } | null }> };

export type AdminStorefrontSalesReportQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type AdminStorefrontSalesReportQuery = { __typename?: 'Query', adminStorefrontSalesReport?: Array<{ __typename?: 'AdminStorefrontSalesReportRow', storefrontId: any, name: string, currency: string, grossSales: number, refunds: number, stripeFees: number, whereaboutsFees: number, chargeCount: number } | null> | null };

export type AdminUsersListQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminUsersListQuery = { __typename?: 'Query', adminUsersList?: Array<{ __typename?: 'AdminUserInfo', _id: any, email: string, firstName: string, lastName: string, status: string, userType: string, systemPermissions: Array<string> } | null> | null };

export type AdminUsersSearchableQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type AdminUsersSearchableQuery = { __typename?: 'Query', adminUsersSearchable?: Array<{ __typename?: 'AdminUserInfo', _id: any, email: string, firstName: string, lastName: string, status: string, userType: string } | null> | null };

export type AiTasksByOperatorQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
}>;


export type AiTasksByOperatorQuery = { __typename?: 'Query', aiTasksByOperator: Array<{ __typename?: 'AiTask', _id: any, taskType: string, operatorId: string, initiatedBy: string, status: AiTaskStatus, applied?: boolean | null, appliedAt?: any | null, organizationId?: string | null, createdDateISO?: any | null, durationMs?: number | null, rating?: AiTaskRating | null, feedbackNotes?: string | null }> };

export type AnalyticsDashboardManyQueryVariables = Exact<{
  sort?: InputMaybe<SortFindManyAnalyticsDashboardInput>;
}>;


export type AnalyticsDashboardManyQuery = { __typename?: 'Query', analyticsDashboardMany: Array<{ __typename?: 'AnalyticsDashboard', _id: any, name: string, description: string, dashboardId: string, sortOrder: number }> };

export type ApiAccessByOrgQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiAccessByOrgQuery = { __typename?: 'Query', apiAccessByOrg: Array<{ __typename?: 'ApiAccess', _id: any, token: string, name?: string | null, description?: string | null, lastUsedAt?: any | null, createdDateISO?: any | null, organization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null> };

export type ApiAccessManyQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiAccessManyQuery = { __typename?: 'Query', apiAccessMany: Array<{ __typename?: 'ApiAccess', _id: any, token: string, name?: string | null, description?: string | null, lastUsedAt?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, organization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, user?: { __typename?: 'UserWithPictureTC', _id: any, email: string, firstName: string, lastName: string, userType: EnumUserUserType } | null }> };

export type AssetManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyAssetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AssetManyQuery = { __typename?: 'Query', assetMany: Array<{ __typename?: 'AssetFile', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, bytes?: number | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }> };

export type BookerByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type BookerByIdQuery = { __typename?: 'Query', bookerById?: { __typename?: 'Booker', storefront: any, status: EnumBookerStatus, copiedFrom?: any | null, requiresPayment: boolean, renewableFeeAddOnsEnabled: boolean, perBusinessAnswersEnabled: boolean, _id: any, surveyInline: boolean, completionTags: Array<any | null>, businessCompletionTags: Array<any | null>, publiclyPublishable: boolean, isInvoiceTemplate: boolean, createdDateISO?: any | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, bundles: Array<{ __typename?: 'BookerBundles', _id?: any | null, product?: { __typename?: 'Product', _id: any, storefront: any, updatedDateISO?: any | null, createdDateISO?: any | null, type: EnumProductType, publicationStatus: EnumProductPublicationStatus, externalBookingUrl?: string | null, isUpsellOnly: boolean, isActive: boolean, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags: Array<{ __typename?: 'Tag', entityTypes: Array<EnumTagEntityTypes | null>, _id: any, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rules: Array<{ __typename?: 'Rule', type: EnumRuleType, value: any, isActive: boolean, storefront: any, _id: any, activePeriod?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null }>, pricing?: { __typename?: 'Pricing', description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tiers: Array<{ __typename?: 'PriceTier', type: EnumGuestTierType, price: number, priceType: EnumPriceTierPriceType, guestCountForPrice?: number | null, discountAmount?: number | null, discountUnit?: EnumPriceTierDiscountUnit | null, _id: any, label?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> } | null, quantitySettings?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, contact?: { __typename?: 'ProductContact', useOwnerContact: boolean, email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null } | null, addOnSettings?: { __typename?: 'ProductAddOnSettings', businessScope?: EnumProductAddOnSettingsBusinessScope | null, pricingScope?: EnumProductAddOnSettingsPricingScope | null } | null, customFields?: Array<{ __typename?: 'ProductCustomFields', _id?: any | null, type: EnumProductCustomFieldsType, required: boolean, chargePerChoice?: boolean | null, maxChoices?: number | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options?: Array<{ __typename?: 'ProductCustomFieldsOptions', _id?: any | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null, renewableFeeMetadata?: { __typename?: 'RenewableFeeMetadata', billingIntervalMonths: number, renewalType?: EnumRenewableFeeMetadataRenewalType | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, proRateEnabled?: boolean | null, earlyPurchaseWindowDays?: number | null, membershipLinked?: boolean | null } | null, merchMetadata?: { __typename?: 'MerchMetadata', lowStockThreshold?: number | null, dimensions?: Array<{ __typename?: 'MerchMetadataDimensions', _id?: any | null, drivesImages?: boolean | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, values?: Array<{ __typename?: 'MerchMetadataDimensionsValues', _id?: any | null, imageIds?: Array<string | null> | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null, variants?: Array<{ __typename?: 'MerchMetadataVariants', _id?: any | null, dimensionValueIds?: Array<string | null> | null, label?: string | null, price: number, sku?: string | null, inventoryCount: number, isActive?: boolean | null } | null> | null } | null, sellingConfig?: { __typename?: 'ProductSellingConfig', mode: string, basePrice?: number | null, dynamicFeeSurvey?: any | null, options?: Array<{ __typename?: 'ProductTier', _id?: any | null, price: number, order: number, autoTag?: any | null, sessionScope?: EnumProductTierSessionScope | null, includedSessionIds?: Array<string | null> | null, minSessions?: number | null, maxSessions?: number | null, subCapacityPerSession?: number | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tagConfig?: { __typename?: 'ProductTierTagConfig', onCheckoutCompleted?: Array<any | null> | null, onRenewalSuccess?: Array<any | null> | null, onRenewalPending?: Array<any | null> | null, onExpiration?: Array<any | null> | null, onCancellation?: Array<any | null> | null, onPaymentFailed?: Array<any | null> | null } | null, personTagConfig?: { __typename?: 'ProductTierTagConfig', onCheckoutCompleted?: Array<any | null> | null, onRenewalSuccess?: Array<any | null> | null, onRenewalPending?: Array<any | null> | null, onExpiration?: Array<any | null> | null, onCancellation?: Array<any | null> | null, onPaymentFailed?: Array<any | null> | null } | null, inventory?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, condition?: { __typename?: 'ProductTierCondition', operator: EnumProductTierConditionOperator, clauses?: Array<{ __typename?: 'ProductTierConditionClauses', questionId: string, comparator: EnumProductTierConditionClausesComparator, value: string } | null> | null } | null } | null> | null, inventory?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, recurring?: { __typename?: 'ProductSellingConfigRecurring', enabled?: boolean | null, billingIntervalMonths?: number | null, renewalType?: EnumProductSellingConfigRecurringRenewalType | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, proRateEnabled?: boolean | null, earlyPurchaseWindowDays?: number | null, membershipLinked?: boolean | null, multiListing?: { __typename?: 'ProductSellingConfigRecurringMultiListing', mode?: EnumProductSellingConfigRecurringMultiListingMode | null, maxListings?: number | null, autoIncludeOwnedListings?: boolean | null, additionalBusinessDiscount?: { __typename?: 'ProductSellingConfigRecurringMultiListingAdditionalBusinessDiscount', unit: EnumProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountUnit, amount: number } | null } | null } | null } | null, productTiers?: Array<{ __typename?: 'ProductTier', _id?: any | null, price: number, order: number, autoTag?: any | null, sessionScope?: EnumProductTierSessionScope | null, includedSessionIds?: Array<string | null> | null, minSessions?: number | null, maxSessions?: number | null, subCapacityPerSession?: number | null, isActive?: boolean | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null } | null> | null, eventMetadata?: { __typename?: 'ProductEventMetadata', event: any, ticketStructure: EnumProductEventMetadataTicketStructure, sessionGranularity: EnumProductEventMetadataSessionGranularity, sellingType?: EnumProductEventMetadataSellingType | null, maxTicketsPerPurchase?: number | null, includedSessionIds?: Array<string | null> | null } | null, inventorySettings?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, accommodationMetadata?: { __typename?: 'AccommodationProductMetadata', checkIn?: string | null, checkOut?: string | null, calendarLinks?: Array<string | null> | null, guestMetadata?: { __typename?: 'GuestMetadata', minimumNumber?: number | null, maximumNumber?: number | null, nameEntryAllowed: boolean, nameEntryRequired: boolean } | null, amenities: Array<{ __typename?: 'Tag', entityTypes: Array<EnumTagEntityTypes | null>, _id: any, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rooms: Array<{ __typename?: 'Room', _id?: any | null, type: EnumRoomType, amenities?: Array<any | null> | null } | null>, closures: Array<{ __typename?: 'Closure', _id?: any | null, name: string, dateRangeISO: { __typename?: 'DateRangeISO', _id: any, end: string, metadata?: string | null, start: string } } | null> } | null } | null, upsells: Array<{ __typename?: 'Product', _id: any, isUpsellOnly: boolean, publicationStatus: EnumProductPublicationStatus, type: EnumProductType, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, pricing?: { __typename?: 'Pricing', tiers: Array<{ __typename?: 'PriceTier', _id: any, price: number, type: EnumGuestTierType, label?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, quantitySettings?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, addOnSettings?: { __typename?: 'ProductAddOnSettings', businessScope?: EnumProductAddOnSettingsBusinessScope | null, pricingScope?: EnumProductAddOnSettingsPricingScope | null } | null, customFields?: Array<{ __typename?: 'ProductCustomFields', _id?: any | null, type: EnumProductCustomFieldsType, required: boolean, chargePerChoice?: boolean | null, maxChoices?: number | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options?: Array<{ __typename?: 'ProductCustomFieldsOptions', _id?: any | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null }> } | null>, paymentMetadata?: { __typename?: 'OrderPaymentMetadata', connectedAccountId?: string | null, currency?: string | null, stripeRegion?: EnumOrderPaymentMetadataStripeRegion | null, customerApplicationPercentage?: number | null, applicationPercentage?: number | null, acceptedPaymentMethods?: Array<string | null> | null, bankTransferInstructions?: string | null, offerTaxExemption?: boolean | null, optionalCardPostalCode?: boolean | null, depositSettings?: { __typename?: 'DepositSettings', enabled: boolean, rate?: number | null, rateType?: EnumDepositSettingsRateType | null, chargeBalanceDaysBeforeCheckIn: number } | null, securityDepositSettings?: { __typename?: 'SecurityDepositSettings', enabled: boolean, placeHoldDaysBeforeCheckOut: number, rate?: number | null, rateType?: EnumSecurityDepositSettingsRateType | null } | null, tax?: { __typename?: 'Tax', _id: any, percentage: number, subdivision: string, country: string } | null, feeAbsorption?: { __typename?: 'OrderPaymentMetadataFeeAbsorption', stripePercent?: number | null, stripeFixedCents?: number | null, roundingIncrementCents?: number | null, showBreakdownInCheckout?: boolean | null } | null } | null, waivers: Array<{ __typename?: 'AssetFile', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, bytes?: number | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rules: Array<{ __typename?: 'Rule', _id: any, isActive: boolean, type: EnumRuleType, value: any, activePeriod?: { __typename?: 'DateRangeISO', _id: any, end: string, start: string, metadata?: string | null } | null }>, policies: Array<{ __typename?: 'Policy', _id: any, isActive: boolean, storefront: any, content: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, fulfillmentProfile?: { __typename?: 'FulfillmentProfile', _id: any, name: string, isActive: boolean, storefront: any, pickup?: { __typename?: 'FulfillmentProfilePickup', enabled?: boolean | null, locations?: Array<{ __typename?: 'FulfillmentProfilePickupLocations', _id?: any | null, name: string, address?: string | null, instructions?: string | null } | null> | null } | null, shipping?: { __typename?: 'FulfillmentProfileShipping', enabled?: boolean | null, taxable?: boolean | null, zones?: Array<{ __typename?: 'FulfillmentProfileShippingZones', _id?: any | null, name: string, countries?: Array<string | null> | null, subdivisions?: Array<string | null> | null, flatRate: number, perAdditionalItem?: number | null, freeOver?: number | null } | null> | null } | null } | null, statusNotification?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, customizations?: { __typename?: 'BookerCustomizations', sectionOrder?: Array<EnumBookerCustomizationsSectionOrder | null> | null, confirmationEmailCtaUrl?: string | null, showCheckoutChecklist?: boolean | null, addressDisplay?: EnumBookerCustomizationsAddressDisplay | null, featuredImage?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, overrideProductName?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, overrideProductDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, overridePricingCallout?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, overrideDiscountCallout?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, overrideAddOnsDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, overrideQuestionnaireTitle?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, overrideQuestionnaireDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, confirmationEmailSubject?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, confirmationEmailBody?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, confirmationEmailCtaLabel?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null, brandingLogo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, discounts: Array<{ __typename?: 'Discount', _id: any, amount: number, canCombine: boolean, currentUsageCount: number, daysInAdvance?: number | null, maxDaysInAdvance?: number | null, excludeUpsells: boolean, isActive: boolean, isOngoing: boolean, maxNights?: number | null, maxUsageCount?: number | null, minGuestCount?: number | null, minNights?: number | null, minQuantity?: number | null, minSubtotal?: number | null, buyQuantity?: number | null, getQuantity?: number | null, perTicket: boolean, perTicketApplyFrom?: number | null, promoCode?: string | null, storefront: any, type: EnumDiscountType, unit: EnumDiscountUnit, discountActivePeriod?: { __typename?: 'DateRangeISOOptional', _id: any, end?: string | null, start?: string | null } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, renewalSettings?: { __typename?: 'BookerRenewalSettings', renewalMode?: EnumBookerRenewalSettingsRenewalMode | null, requireApproval?: boolean | null, sendRenewalReminders?: boolean | null, renewalReminderDaysBefore?: number | null } | null, survey?: { __typename?: 'Survey', _id: any, updatedDateISO?: any | null, perBusinessAnswersEnabled: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, questions: Array<{ __typename?: 'SurveyQuestion', _id: any, isActive: boolean, required: boolean, type: EnumSurveyQuestionType, whereaboutsSearchEntityType?: EnumSurveyQuestionWhereaboutsSearchEntityType | null, parentQuestion?: any | null, businessScope?: EnumSurveyQuestionBusinessScope | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options: Array<{ __typename?: 'SurveyQuestionOptions', _id?: any | null, isActive: boolean, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> }> } | null, paymentMethodSet?: { __typename?: 'PaymentMethodSet', _id: any, name: string, isActive: boolean, acceptedPaymentMethods: Array<string | null>, bankTransferInstructions?: string | null, offlinePaymentInstructions?: string | null, checkoutDescription?: string | null, storefront: any, methodLabels?: { __typename?: 'PaymentMethodSetMethodLabels', card?: string | null, direct_debit?: string | null, bank_transfer?: string | null, offline_payment?: string | null } | null } | null, completionScreen?: { __typename?: 'BookerCompletionScreen', ctaBroadcastId?: string | null, ctaUrl?: string | null, message?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, ctaLabel?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null, customerFields?: { __typename?: 'BookerCustomerFields', businessFieldEnabled?: boolean | null, phoneEnabled?: boolean | null, guestNamesEnabled?: boolean | null, guestEmailEnabled?: boolean | null, guestInfoRequired?: boolean | null, addressRequired?: boolean | null, businessFieldDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null, eligibility?: { __typename?: 'BookerEligibility', mode?: EnumBookerEligibilityMode | null, rule?: EnumBookerEligibilityRule | null, tagId?: any | null, ineligibleBehavior?: EnumBookerEligibilityIneligibleBehavior | null, blockedMessage?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null, approvalSettings?: { __typename?: 'BookerApprovalSettings', enabled?: boolean | null, requestExpiryHours?: number | null, autoCancelUnpaidAfterDays?: number | null, messageToGuest?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null, paymentTiming?: { __typename?: 'BookerPaymentTiming', timing?: EnumBookerPaymentTimingTiming | null, invoiceDueDays?: number | null, afterServiceOffsetDays?: number | null, consolidation?: EnumBookerPaymentTimingConsolidation | null } | null, promoCodeTagOverrides: Array<{ __typename?: 'BookerPromoCodeTagOverrides', discountId: any, tagId: any, mode: EnumBookerPromoCodeTagOverridesMode } | null>, discountScopes: Array<{ __typename?: 'BookerDiscountScopes', discount: any, appliesToTierIds?: Array<string | null> | null } | null> } | null };

export type BookerCartPriceQueryVariables = Exact<{
  bookerId: Scalars['ID']['input'];
  productPurchaseRequests: Array<ProductPurchaseRequest> | ProductPurchaseRequest;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  taxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  delivery?: InputMaybe<OrderDeliveryInput>;
}>;


export type BookerCartPriceQuery = { __typename?: 'Query', bookerCartPrice?: { __typename?: 'CartPrices', depositTotal: number, discountTotal: number, grandTotal: number, subTotal: number, taxTotal: number, customerFee: number, promoCodeApplicable?: boolean | null, shippingTotal?: number | null, deliveryAvailable?: boolean | null, discountTotals: Array<{ __typename?: 'DiscountTotalPerDiscount', discountId: string, total: number }>, taxLines: Array<{ __typename?: 'TaxLine', name: string, ratePercent?: number | null, amount: number }>, productPrices: Array<{ __typename?: 'PricePerProduct', price: number, productId: string }> } | null };

export type BookerCheckEligibilityQueryVariables = Exact<{
  bookerId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
}>;


export type BookerCheckEligibilityQuery = { __typename?: 'Query', bookerCheckEligibility: { __typename?: 'BookerEligibilityResult', required: boolean, eligible: boolean, ineligibleBehavior: string, blockedMessage?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } };

export type BookerConfirmationEmailPreviewQueryVariables = Exact<{
  bookerId: Scalars['MongoID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type BookerConfirmationEmailPreviewQuery = { __typename?: 'Query', bookerConfirmationEmailPreview?: { __typename?: 'BookerConfirmationEmailPreview', subject: string, html: string } | null };

export type BookerFeeAbsorptionPreviewQueryVariables = Exact<{
  bookerId: Scalars['MongoID']['input'];
}>;


export type BookerFeeAbsorptionPreviewQuery = { __typename?: 'Query', bookerFeeAbsorptionPreview?: { __typename?: 'BookerFeeAbsorptionPreview', applicationPercent: number, taxPercent: number, snapshotAppliedAt?: any | null, products?: Array<{ __typename?: 'BookerFeeAbsorptionPreviewProduct', productId: string, name: string, productType: string, isMain: boolean, otherWidgetCount: number, pricePoints?: Array<{ __typename?: 'BookerFeeAbsorptionPricePoint', path: string, label: string, currentPrice: number, basePrice: number } | null> | null } | null> | null } | null };

export type BookerFulfillmentOptionsQueryVariables = Exact<{
  bookerId: Scalars['ID']['input'];
}>;


export type BookerFulfillmentOptionsQuery = { __typename?: 'Query', bookerFulfillmentOptions: { __typename?: 'BookerFulfillmentOptions', pickupEnabled: boolean, shippingEnabled: boolean, pickupLocations?: Array<{ __typename?: 'PickupLocationOption', _id: string, name: string, address?: string | null, instructions?: string | null }> | null, shippingZones?: Array<{ __typename?: 'ShippingZoneOption', name: string, countries: Array<string>, subdivisions: Array<string>, flatRate: number, perAdditionalItem?: number | null, freeOver?: number | null }> | null } };

export type BookerInvoiceHeaderQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type BookerInvoiceHeaderQuery = { __typename?: 'Query', bookerById?: { __typename?: 'Booker', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, customizations?: { __typename?: 'BookerCustomizations', logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } | null, brandingLogo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } | null };

export type BookerManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyBookerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BookerManyQuery = { __typename?: 'Query', bookerMany: Array<{ __typename?: 'Booker', _id: any, updatedDateISO?: any | null, createdDateISO?: any | null, status: EnumBookerStatus, copiedFrom?: any | null, requiresPayment: boolean, storefront: any, isInvoiceTemplate: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, statusNotification?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, bundles: Array<{ __typename?: 'BookerBundles', _id?: any | null, product?: { __typename?: 'Product', _id: any, storefront: any, updatedDateISO?: any | null, createdDateISO?: any | null, type: EnumProductType, publicationStatus: EnumProductPublicationStatus, externalBookingUrl?: string | null, isUpsellOnly: boolean, isActive: boolean, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags: Array<{ __typename?: 'Tag', entityTypes: Array<EnumTagEntityTypes | null>, _id: any, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rules: Array<{ __typename?: 'Rule', type: EnumRuleType, value: any, isActive: boolean, storefront: any, _id: any, activePeriod?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null }>, pricing?: { __typename?: 'Pricing', description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tiers: Array<{ __typename?: 'PriceTier', type: EnumGuestTierType, price: number, priceType: EnumPriceTierPriceType, guestCountForPrice?: number | null, discountAmount?: number | null, discountUnit?: EnumPriceTierDiscountUnit | null, _id: any, label?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> } | null, quantitySettings?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, contact?: { __typename?: 'ProductContact', useOwnerContact: boolean, email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null } | null, addOnSettings?: { __typename?: 'ProductAddOnSettings', businessScope?: EnumProductAddOnSettingsBusinessScope | null, pricingScope?: EnumProductAddOnSettingsPricingScope | null } | null, customFields?: Array<{ __typename?: 'ProductCustomFields', _id?: any | null, type: EnumProductCustomFieldsType, required: boolean, chargePerChoice?: boolean | null, maxChoices?: number | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options?: Array<{ __typename?: 'ProductCustomFieldsOptions', _id?: any | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null, renewableFeeMetadata?: { __typename?: 'RenewableFeeMetadata', billingIntervalMonths: number, renewalType?: EnumRenewableFeeMetadataRenewalType | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, proRateEnabled?: boolean | null, earlyPurchaseWindowDays?: number | null, membershipLinked?: boolean | null } | null, merchMetadata?: { __typename?: 'MerchMetadata', lowStockThreshold?: number | null, dimensions?: Array<{ __typename?: 'MerchMetadataDimensions', _id?: any | null, drivesImages?: boolean | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, values?: Array<{ __typename?: 'MerchMetadataDimensionsValues', _id?: any | null, imageIds?: Array<string | null> | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null, variants?: Array<{ __typename?: 'MerchMetadataVariants', _id?: any | null, dimensionValueIds?: Array<string | null> | null, label?: string | null, price: number, sku?: string | null, inventoryCount: number, isActive?: boolean | null } | null> | null } | null, sellingConfig?: { __typename?: 'ProductSellingConfig', mode: string, basePrice?: number | null, dynamicFeeSurvey?: any | null, options?: Array<{ __typename?: 'ProductTier', _id?: any | null, price: number, order: number, autoTag?: any | null, sessionScope?: EnumProductTierSessionScope | null, includedSessionIds?: Array<string | null> | null, minSessions?: number | null, maxSessions?: number | null, subCapacityPerSession?: number | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tagConfig?: { __typename?: 'ProductTierTagConfig', onCheckoutCompleted?: Array<any | null> | null, onRenewalSuccess?: Array<any | null> | null, onRenewalPending?: Array<any | null> | null, onExpiration?: Array<any | null> | null, onCancellation?: Array<any | null> | null, onPaymentFailed?: Array<any | null> | null } | null, personTagConfig?: { __typename?: 'ProductTierTagConfig', onCheckoutCompleted?: Array<any | null> | null, onRenewalSuccess?: Array<any | null> | null, onRenewalPending?: Array<any | null> | null, onExpiration?: Array<any | null> | null, onCancellation?: Array<any | null> | null, onPaymentFailed?: Array<any | null> | null } | null, inventory?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, condition?: { __typename?: 'ProductTierCondition', operator: EnumProductTierConditionOperator, clauses?: Array<{ __typename?: 'ProductTierConditionClauses', questionId: string, comparator: EnumProductTierConditionClausesComparator, value: string } | null> | null } | null } | null> | null, inventory?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, recurring?: { __typename?: 'ProductSellingConfigRecurring', enabled?: boolean | null, billingIntervalMonths?: number | null, renewalType?: EnumProductSellingConfigRecurringRenewalType | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, proRateEnabled?: boolean | null, earlyPurchaseWindowDays?: number | null, membershipLinked?: boolean | null, multiListing?: { __typename?: 'ProductSellingConfigRecurringMultiListing', mode?: EnumProductSellingConfigRecurringMultiListingMode | null, maxListings?: number | null, autoIncludeOwnedListings?: boolean | null, additionalBusinessDiscount?: { __typename?: 'ProductSellingConfigRecurringMultiListingAdditionalBusinessDiscount', unit: EnumProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountUnit, amount: number } | null } | null } | null } | null, productTiers?: Array<{ __typename?: 'ProductTier', _id?: any | null, price: number, order: number, autoTag?: any | null, sessionScope?: EnumProductTierSessionScope | null, includedSessionIds?: Array<string | null> | null, minSessions?: number | null, maxSessions?: number | null, subCapacityPerSession?: number | null, isActive?: boolean | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null } | null> | null, eventMetadata?: { __typename?: 'ProductEventMetadata', event: any, ticketStructure: EnumProductEventMetadataTicketStructure, sessionGranularity: EnumProductEventMetadataSessionGranularity, sellingType?: EnumProductEventMetadataSellingType | null, maxTicketsPerPurchase?: number | null, includedSessionIds?: Array<string | null> | null } | null, inventorySettings?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, accommodationMetadata?: { __typename?: 'AccommodationProductMetadata', checkIn?: string | null, checkOut?: string | null, calendarLinks?: Array<string | null> | null, guestMetadata?: { __typename?: 'GuestMetadata', minimumNumber?: number | null, maximumNumber?: number | null, nameEntryAllowed: boolean, nameEntryRequired: boolean } | null, amenities: Array<{ __typename?: 'Tag', entityTypes: Array<EnumTagEntityTypes | null>, _id: any, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rooms: Array<{ __typename?: 'Room', _id?: any | null, type: EnumRoomType, amenities?: Array<any | null> | null } | null>, closures: Array<{ __typename?: 'Closure', _id?: any | null, name: string, dateRangeISO: { __typename?: 'DateRangeISO', _id: any, end: string, metadata?: string | null, start: string } } | null> } | null } | null, upsells: Array<{ __typename?: 'Product', _id: any, isUpsellOnly: boolean, publicationStatus: EnumProductPublicationStatus, type: EnumProductType, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, pricing?: { __typename?: 'Pricing', tiers: Array<{ __typename?: 'PriceTier', _id: any, price: number, type: EnumGuestTierType, label?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, quantitySettings?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, addOnSettings?: { __typename?: 'ProductAddOnSettings', businessScope?: EnumProductAddOnSettingsBusinessScope | null, pricingScope?: EnumProductAddOnSettingsPricingScope | null } | null, customFields?: Array<{ __typename?: 'ProductCustomFields', _id?: any | null, type: EnumProductCustomFieldsType, required: boolean, chargePerChoice?: boolean | null, maxChoices?: number | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options?: Array<{ __typename?: 'ProductCustomFieldsOptions', _id?: any | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null }> } | null>, customizations?: { __typename?: 'BookerCustomizations', logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, featuredImage?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } | null, discounts: Array<{ __typename?: 'Discount', type: EnumDiscountType, isActive: boolean, amount: number, unit: EnumDiscountUnit, daysInAdvance?: number | null, minGuestCount?: number | null, minNights?: number | null, maxNights?: number | null, promoCode?: string | null, maxUsageCount?: number | null, currentUsageCount: number, canCombine: boolean, excludeUpsells: boolean, storefront: any, _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, discountActivePeriod?: { __typename?: 'DateRangeISOOptional', _id: any, start?: string | null, end?: string | null, metadata?: string | null } | null }>, paymentMetadata?: { __typename?: 'OrderPaymentMetadata', connectedAccountId?: string | null, applicationPercentage?: number | null, currency?: string | null, tax?: { __typename?: 'Tax', country: string, subdivision: string, percentage: number, _id: any } | null, depositSettings?: { __typename?: 'DepositSettings', rate?: number | null, rateType?: EnumDepositSettingsRateType | null, chargeBalanceDaysBeforeCheckIn: number, enabled: boolean } | null, securityDepositSettings?: { __typename?: 'SecurityDepositSettings', rate?: number | null, rateType?: EnumSecurityDepositSettingsRateType | null, placeHoldDaysBeforeCheckOut: number, enabled: boolean } | null } | null, policies: Array<{ __typename?: 'Policy', _id: any, isActive: boolean, storefront: any, content: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rules: Array<{ __typename?: 'Rule', type: EnumRuleType, value: any, isActive: boolean, storefront: any, _id: any, activePeriod?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null }>, waivers: Array<{ __typename?: 'AssetFile', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, bytes?: number | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> }> };

export type BookerManyAdminlandQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyBookerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BookerManyAdminlandQuery = { __typename?: 'Query', bookerMany: Array<{ __typename?: 'Booker', _id: any, updatedDateISO?: any | null, status: EnumBookerStatus, storefront: any, isInvoiceTemplate: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, bundles: Array<{ __typename?: 'BookerBundles', _id?: any | null, product?: { __typename?: 'Product', _id: any, type: EnumProductType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, eventMetadata?: { __typename?: 'ProductEventMetadata', event: any } | null } | null } | null> }> };

export type BookerSendContactUsEmailQueryVariables = Exact<{
  bookerId: Scalars['ID']['input'];
  details: ContactUsEmailDetails;
}>;


export type BookerSendContactUsEmailQuery = { __typename?: 'Query', bookerSendContactUsEmail?: { __typename?: 'EmailResponse', message: string, success: boolean } | null };

export type BookersByStorefrontForFeesQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyBookerInput>;
}>;


export type BookersByStorefrontForFeesQuery = { __typename?: 'Query', bookerMany: Array<{ __typename?: 'Booker', _id: any, status: EnumBookerStatus, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, paymentMetadata?: { __typename?: 'OrderPaymentMetadata', applicationPercentage?: number | null, applicationPercentageFollowsDefault?: boolean | null, customerApplicationPercentage?: number | null } | null }> };

export type BroadcastAllStatsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  ownerEntityId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type BroadcastAllStatsQuery = { __typename?: 'Query', broadcastAllStats: { __typename?: 'BroadcastAllStatsResult', totalCount: number, items: Array<{ __typename?: 'BroadcastAllStatsItem', broadcastId: string, ownerName: string, ownerType: string, status: string, totalViews: number, totalCompletions: number, totalResources: number, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> } };

export type BroadcastByIdStatsPerPersonQueryVariables = Exact<{
  broadcastId: Scalars['ID']['input'];
}>;


export type BroadcastByIdStatsPerPersonQuery = { __typename?: 'Query', broadcastByIdStatsPerPerson: { __typename?: 'BroadcastStats', broadcastId: string, totalViews: number, viewedPeople: Array<{ __typename?: 'SimplePersonTC', _id: string }>, resources: Array<{ __typename?: 'BroadcastResourceStats', resourceId: string, viewedPeople: Array<{ __typename?: 'SimplePersonTC', _id: string, firstName: string, lastName: string, email: string }>, inProgressPeople: Array<{ __typename?: 'SimplePersonTC', _id: string }>, completedPeople: Array<{ __typename?: 'SimplePersonTC', _id: string }>, downloadedPeople: Array<{ __typename?: 'SimplePersonTC', _id: string }>, playedPeople: Array<{ __typename?: 'SimplePersonTC', _id: string }> }> } };

export type BroadcastByUserQueryVariables = Exact<{ [key: string]: never; }>;


export type BroadcastByUserQuery = { __typename?: 'Query', broadcastByUser: Array<{ __typename?: 'BroadcastWithOwnerName', _id: any, createdDateISO?: any | null, updatedDateISO?: any | null, status: EnumBroadcastStatus, coverImage?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, publicName?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, ownerName?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, sharedTo?: { __typename?: 'BroadcastSharedTo', type: EnumBroadcastSharedToType, sentToPeople: Array<any | null>, sentToPeopleTags?: Array<any | null> | null } | null, resources: Array<{ __typename?: 'BroadcastResources', type: EnumBroadcastResourcesType, videoURL?: string | null, course?: string | null, iframeUrl?: string | null, formMode?: EnumBroadcastResourcesFormMode | null, allowSaveAndEdit?: boolean | null, requireApproval?: boolean | null, allowResubmission?: boolean | null, completionTags?: Array<string | null> | null, submissionTags?: Array<string | null> | null, expirationTags?: Array<string | null> | null, teamVisible?: boolean | null, _id?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, coverImage?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, message?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, file?: { __typename?: 'AssetFile', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, bytes?: number | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, video?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, photos: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, survey?: { __typename?: 'Survey', _id: any, perBusinessAnswersEnabled: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, questions: Array<{ __typename?: 'SurveyQuestion', _id: any, isActive: boolean, required: boolean, type: EnumSurveyQuestionType, parentQuestion?: any | null, businessScope?: EnumSurveyQuestionBusinessScope | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options: Array<{ __typename?: 'SurveyQuestionOptions', _id?: any | null, isActive: boolean, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> }> } | null, booker?: { __typename?: 'Booker', _id: any, status: EnumBookerStatus, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, bundles: Array<{ __typename?: 'BookerBundles', _id?: any | null, product?: { __typename?: 'Product', _id: any, type: EnumProductType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null> } | null, ctaLabel?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> }> };

export type BroadcastCountQueryVariables = Exact<{
  filter?: InputMaybe<FilterCountBroadcastInput>;
}>;


export type BroadcastCountQuery = { __typename?: 'Query', broadcastCount?: number | null };

export type BroadcastManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyBroadcastInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyBroadcastInput>;
}>;


export type BroadcastManyQuery = { __typename?: 'Query', broadcastMany: Array<{ __typename?: 'Broadcast', _id: any, createdDateISO?: any | null, updatedDateISO?: any | null, status: EnumBroadcastStatus, isTemplate: boolean, coverImage?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, publicName?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, sharedTo?: { __typename?: 'BroadcastSharedTo', type: EnumBroadcastSharedToType, sentToPeople: Array<any | null>, sentToPeopleTags?: Array<any | null> | null, sentToPeopleSystemRoles?: Array<EnumBroadcastSharedToSentToPeopleSystemRoles | null> | null, skipEmails?: boolean | null, operatorsOnly?: boolean | null, teaser?: { __typename?: 'BroadcastSharedToTeaser', enabled: boolean, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null } | null, resources: Array<{ __typename?: 'BroadcastResources', type: EnumBroadcastResourcesType, videoURL?: string | null, course?: string | null, iframeUrl?: string | null, formMode?: EnumBroadcastResourcesFormMode | null, allowSaveAndEdit?: boolean | null, requireApproval?: boolean | null, allowResubmission?: boolean | null, completionTags?: Array<string | null> | null, submissionTags?: Array<string | null> | null, expirationTags?: Array<string | null> | null, teamVisible?: boolean | null, _id?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, coverImage?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, message?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, file?: { __typename?: 'AssetFile', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, bytes?: number | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, video?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, photos: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, survey?: { __typename?: 'Survey', _id: any, updatedDateISO?: any | null, perBusinessAnswersEnabled: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, questions: Array<{ __typename?: 'SurveyQuestion', _id: any, isActive: boolean, required: boolean, type: EnumSurveyQuestionType, parentQuestion?: any | null, businessScope?: EnumSurveyQuestionBusinessScope | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options: Array<{ __typename?: 'SurveyQuestionOptions', _id?: any | null, isActive: boolean, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> }> } | null, booker?: { __typename?: 'Booker', _id: any, status: EnumBookerStatus, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, bundles: Array<{ __typename?: 'BookerBundles', _id?: any | null, product?: { __typename?: 'Product', _id: any, type: EnumProductType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null> } | null, ctaLabel?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> }> };

export type BroadcastStatsByOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type BroadcastStatsByOrganizationQuery = { __typename?: 'Query', broadcastStatsByOrganization: { __typename?: 'BroadcastStatsForOrganization', completions: number, messageViews: number, videoViews: number, photoViews: number, pdfDownloads: number } };

export type BroadcastTeaserByIdQueryVariables = Exact<{
  broadcastId: Scalars['MongoID']['input'];
}>;


export type BroadcastTeaserByIdQuery = { __typename?: 'Query', broadcastTeaserById?: { __typename?: 'BroadcastTeaserResult', description?: string | null } | null };

export type BroadcastsByIdsStatsForSingleUserQueryVariables = Exact<{
  broadcastIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BroadcastsByIdsStatsForSingleUserQuery = { __typename?: 'Query', broadcastsByIdsStatsForSingleUser: Array<{ __typename?: 'BroadcastViewedStats', broadcastId: string, viewed: boolean, resources: Array<{ __typename?: 'BroadcastResourceViewedStats', resourceId: string, viewed: boolean, downloaded: boolean, played: boolean, completed: boolean, inProgress: boolean }> }> };

export type BulkConnectLogManyQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BulkConnectLogManyQuery = { __typename?: 'Query', bulkConnectLogMany: Array<{ __typename?: 'BulkConnectLog', _id: any, operatorEntityIds: Array<string | null>, organizationIds: Array<any | null>, totalCount: number, successCount: number, alreadyConnectedCount: number, errorCount: number, appliedBackOfficeTagIds: Array<any | null>, initiatedByUser: any, createdDateISO?: any | null, results: Array<{ __typename?: 'BulkConnectLogResults', operatorEntityId: string, operatorName: string, organizationId: string, organizationName: string, status: EnumBulkConnectLogResultsStatus, error?: string | null } | null>, rollbackInfo?: { __typename?: 'BulkConnectLogRollbackInfo', rolledBackAt: any, rolledBackBy: any, disconnectedCount: number, errorCount: number, errorMessages?: Array<string | null> | null } | null }> };

export type ChangeLogManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyChangelogInput>;
  sort?: InputMaybe<SortFindManyChangelogInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChangeLogManyQuery = { __typename?: 'Query', changeLogMany: Array<{ __typename?: 'Changelog', _id: any, createdDateISO?: any | null, initiatedByUser?: { __typename?: 'UserWithPictureTC', firstName: string } | null, owner: { __typename?: 'Owner', type: EnumOwnerType }, message: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type ChangeLogManyPersonDetailsQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyChangelogInput>;
  sort?: InputMaybe<SortFindManyChangelogInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChangeLogManyPersonDetailsQuery = { __typename?: 'Query', changeLogManyPersonDetails: Array<{ __typename?: 'ChangelogPersonDetails', _id: string, createdDateISO?: string | null, changedEntity?: { __typename?: 'VersionedEntityReferenceWithName', _entityId: any, _versionId: any, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null, changedEntityOwner?: { __typename?: 'OwnerWithName', type: EnumOwnerType, entityId: any, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null, message?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null }> };

export type CourseProgressGetQueryVariables = Exact<{
  resourceId: Scalars['MongoID']['input'];
  broadcastId: Scalars['MongoID']['input'];
}>;


export type CourseProgressGetQuery = { __typename?: 'Query', courseProgressGet?: { __typename?: 'CourseProgress', _id: any, user: string, resourceId: string, broadcast: string, completionStatus: EnumCourseProgressCompletionStatus, successStatus?: EnumCourseProgressSuccessStatus | null, scoreScaled?: number | null, scoreRaw?: number | null, scoreMin?: number | null, scoreMax?: number | null, location?: string | null, suspendData?: string | null, sessionTime?: string | null, totalTime?: string | null, progressMeasure?: number | null, firstAccessedAt?: any | null, lastAccessedAt: any, completedAt?: any | null, scormDataSnapshot?: any | null, scormVersion?: string | null } | null };

export type CronJobsListQueryVariables = Exact<{ [key: string]: never; }>;


export type CronJobsListQuery = { __typename?: 'Query', cronJobsList?: Array<{ __typename?: 'CronJobInfo', name: string, description: string, schedule: string, timezone?: string | null, enabledForCurrentEnv: boolean, lastRun?: { __typename?: 'CronJobLastRun', startedAt: any, completedAt?: any | null, status: string, durationMs?: number | null, error?: string | null } | null } | null> | null };

export type DevToolsEmailReplaceProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type DevToolsEmailReplaceProgressQuery = { __typename?: 'Query', devToolsEmailReplaceProgress?: { __typename?: 'EmailReplaceProgress', total: number, completed: number, isRunning: boolean } | null };

export type DevToolsEmailScanQueryVariables = Exact<{
  skipDomains: Array<Scalars['String']['input']> | Scalars['String']['input'];
  targetEmailFormat?: InputMaybe<Scalars['String']['input']>;
}>;


export type DevToolsEmailScanQuery = { __typename?: 'Query', devToolsEmailScan?: { __typename?: 'DevToolsEmailScanPayload', toReplace?: Array<{ __typename?: 'DevToolsEmailScanResult', entityType: string, entityId: any, currentEmail: string, suggestedNewEmail: string, context?: string | null, visibleToIndex?: number | null, emailIndex?: number | null } | null> | null, skipped?: Array<{ __typename?: 'DevToolsEmailScanSkipped', email: string, reason: string } | null> | null } | null };

export type DevToolsMembershipSeedPreviewQueryVariables = Exact<{
  input: DevMembershipSeedInput;
}>;


export type DevToolsMembershipSeedPreviewQuery = { __typename?: 'Query', devToolsMembershipSeedPreview?: { __typename?: 'DevMembershipSeedPreview', organizationId: string, organizationName: string, blockedCount: number, readyCount: number, coverage?: { __typename?: 'DevMembershipSeedCoverage', generationMode?: DevMembershipSeedMode | null, directoryRecords: number, untaggedControls: number, storefrontId?: string | null, storefrontName?: string | null, businessTiers?: { __typename?: 'DevMembershipSeedCoverageBucket', covered: Array<string>, blocked?: Array<{ __typename?: 'DevMembershipSeedCoverageItem', name: string, reason: string } | null> | null } | null, individualTiers?: { __typename?: 'DevMembershipSeedCoverageBucket', covered: Array<string>, blocked?: Array<{ __typename?: 'DevMembershipSeedCoverageItem', name: string, reason: string } | null> | null } | null, rateVariants?: { __typename?: 'DevMembershipSeedCoverageBucket', covered: Array<string>, blocked?: Array<{ __typename?: 'DevMembershipSeedCoverageItem', name: string, reason: string } | null> | null } | null } | null, rows?: Array<{ __typename?: 'DevMembershipSeedRow', caseKey: string, mode?: DevMembershipSeedMode | null, subjectType?: DevMembershipSeedSubjectType | null, entityComposition?: DevMembershipSeedEntityComposition | null, publicationStatus?: DevMembershipSeedPublicationStatus | null, blocked: boolean, blockReason?: string | null, warnings: Array<string>, tierTagId?: string | null, tierName?: string | null, statusTagIds: Array<string>, statusTagNames: Array<string>, renewalDate?: string | null, renewalPhase?: string | null, rateKind?: DevMembershipSeedRateKind | null, rateLabel?: string | null, productName?: string | null, productTierName?: string | null, bookerName?: string | null, expectedRenewalAmount?: number | null } | null> | null } | null };

export type DevToolsMembershipSeedRunsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DevToolsMembershipSeedRunsQuery = { __typename?: 'Query', devToolsMembershipSeedRuns?: Array<{ __typename?: 'DevMembershipSeedRun', _id: any, organization: any, status?: DevMembershipSeedRunStatus | null, createdByName?: string | null, createdDateISO?: any | null, cleanedAt?: any | null, cleanedByName?: string | null, input?: { __typename?: 'DevMembershipSeedInputSnapshot', organizationId: string, mode?: DevMembershipSeedMode | null, entityComposition?: DevMembershipSeedEntityComposition | null, publicationStatus?: DevMembershipSeedPublicationStatus | null, includeBusinessTiers: boolean, includeIndividualTiers: boolean, includeUntaggedControls: boolean, untaggedControlCount: number, includeSpecialRateVariants: boolean, recordsPerTier: number, renewalEvidence?: DevMembershipSeedRenewalEvidence | null, renewalExactDate?: string | null, renewalPeriodStart?: string | null, renewalPeriodEnd?: string | null, statusTagIds: Array<string> } | null, rows?: Array<{ __typename?: 'DevMembershipSeedRow', caseKey: string, mode?: DevMembershipSeedMode | null, subjectType?: DevMembershipSeedSubjectType | null, entityComposition?: DevMembershipSeedEntityComposition | null, publicationStatus?: DevMembershipSeedPublicationStatus | null, blocked: boolean, blockReason?: string | null, warnings: Array<string>, tierName?: string | null, statusTagNames: Array<string>, renewalDate?: string | null, renewalPhase?: string | null, rateKind?: DevMembershipSeedRateKind | null, rateLabel?: string | null, productName?: string | null, bookerName?: string | null, expectedRenewalAmount?: number | null, operatorEntityId?: string | null, operatorName?: string | null, personId?: string | null, personEmail?: string | null, membershipId?: string | null, originalOrderId?: string | null, renewablePurchaseId?: string | null, validationOk: boolean, validationMessages: Array<string>, cleanupMessages: Array<string> } | null> | null } | null> | null };

export type DevToolsProdSyncCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type DevToolsProdSyncCheckQuery = { __typename?: 'Query', devToolsProdSyncCheck?: { __typename?: 'ProdSyncCheckPayload', isAvailable: boolean, message?: string | null, totalDocuments: number, defaultSkipped: Array<string>, collections?: Array<{ __typename?: 'ProdSyncCollectionStat', name: string, docCount: number, skipped: boolean } | null> | null } | null };

export type DirectoryBulkInvitePreviewQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  viewContext?: InputMaybe<BulkInviteViewContext>;
  tagFilters?: InputMaybe<Array<InputMaybe<BulkInviteTagFilterInput>> | InputMaybe<BulkInviteTagFilterInput>>;
  recipientMode?: InputMaybe<BulkInviteRecipientMode>;
  includeDmoManaged?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DirectoryBulkInvitePreviewQuery = { __typename?: 'Query', directoryBulkInvitePreview?: { __typename?: 'DirectoryBulkInvitePreviewResult', totalInView: number, totalEligible: number, totalDmoManaged: number, totalAlreadyClaimed: number, totalAlreadyInvited: number, totalConnectedStaff: number, primaryContactCount: number, financialContactCount: number, publicEmailCount: number, hasMultiStaffListings: boolean, listingsWithoutContact: Array<{ __typename?: 'BulkInviteNoContactListing', entityId: string, name: string }> } | null };

export type DirectoryMediaSearchQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  alreadyUsed?: InputMaybe<Scalars['Boolean']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  mediaTagIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  businessTypeTagIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  amenityTagIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  backOfficeTagIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  keywordTagIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  selectedTagGroupIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  location?: InputMaybe<Array<Scalars['Float']['input']> | Scalars['Float']['input']>;
  listId?: InputMaybe<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DirectoryMediaSearchQuery = { __typename?: 'Query', directoryMediaSearch?: any | null };

export type DirectoryOperatorEntityIdsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  publicationStatus?: InputMaybe<PublicationStatusType>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  claimed?: InputMaybe<Scalars['Boolean']['input']>;
  organizationControlled?: InputMaybe<Scalars['Boolean']['input']>;
  operationalStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  audienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  usedInWidgets?: InputMaybe<Scalars['Boolean']['input']>;
  notInWidgets?: InputMaybe<Scalars['Boolean']['input']>;
  noAudienceTags?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DirectoryOperatorEntityIdsQuery = { __typename?: 'Query', directoryOperatorEntityIds: Array<string> };

export type DirectoryOperatorsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  publicationStatus?: InputMaybe<PublicationStatusType>;
  sort?: InputMaybe<DirectorySortEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  claimed?: InputMaybe<Scalars['Boolean']['input']>;
  organizationControlled?: InputMaybe<Scalars['Boolean']['input']>;
  operationalStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  audienceTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  usedInWidgets?: InputMaybe<Scalars['Boolean']['input']>;
  notInWidgets?: InputMaybe<Scalars['Boolean']['input']>;
  noAudienceTags?: InputMaybe<Scalars['Boolean']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DirectoryOperatorsQuery = { __typename?: 'Query', directoryOperators?: { __typename?: 'DirectoryOperatorsResult', totalCount?: number, nextCursor?: string | null, items: Array<{ __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, updatedDateISO?: any | null, claimed: boolean, type: EnumOperatorType, operationalStatus: EnumOperatorOperationalStatus, status?: PublicationStatusType | null, iasc?: number | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, enrollments: Array<{ __typename?: 'OperatorEnrollments', organizationControlled: boolean, onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus, organization?: { __typename?: 'Organization', _id: any, shortName: string } | null } | null>, connectedOrganization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } | null }> } | null };

export type DiscountByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type DiscountByIdsQuery = { __typename?: 'Query', discountByIds: Array<{ __typename?: 'Discount', _id: any, promoCode?: string | null, unit: EnumDiscountUnit, type: EnumDiscountType, amount: number, excludeUpsells: boolean, isOngoing: boolean, perTicket: boolean, name: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } }> };

export type DiscountManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyDiscountInput>;
  isUsable?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DiscountManyQuery = { __typename?: 'Query', discountMany: Array<{ __typename?: 'Discount', _id: any, amount: number, canCombine: boolean, currentUsageCount: number, daysInAdvance?: number | null, maxDaysInAdvance?: number | null, excludeUpsells: boolean, isActive: boolean, isOngoing: boolean, maxNights?: number | null, maxUsageCount?: number | null, minGuestCount?: number | null, minNights?: number | null, minQuantity?: number | null, minSubtotal?: number | null, buyQuantity?: number | null, getQuantity?: number | null, perTicket: boolean, perTicketApplyFrom?: number | null, promoCode?: string | null, storefront: any, type: EnumDiscountType, unit: EnumDiscountUnit, discountActivePeriod?: { __typename?: 'DateRangeISOOptional', _id: any, end?: string | null, start?: string | null } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type EmailSuppressionsAdminQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  reason?: InputMaybe<EmailSuppressionReasonEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EmailSuppressionsAdminQuery = { __typename?: 'Query', emailSuppressionsAdmin: { __typename?: 'EmailSuppressionAdminPage', total: number, items: Array<{ __typename?: 'EmailSuppressionAdminRow', _id: any, email: string, organizationId?: any | null, organizationName?: string | null, reason: EmailSuppressionReasonEnum, source: EmailSuppressionSourceEnum, createdDateISO?: any | null }> } };

export type EventByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type EventByIdQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', _id: any, createdByEmail: string, createdByFirstName?: string | null, createdByLastName?: string | null, createdByPerson?: any | null, submitterPersonId?: any | null, locationType: EnumEventLocationType, price?: string | null, ticketUrl?: string | null, type: EnumEventType, startDate: string, endDate?: string | null, suspectedDuplicateOf?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, eventOrganizer: { __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null }, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tags?: { __typename?: 'EventTags', global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null, eventLocations: Array<{ __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null } | null>, attentionIssues: Array<{ __typename?: 'EventAttentionIssues', type: EnumEventAttentionIssuesType, sourceName?: string | null, venueIndex?: number | null } | null>, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, schedules: Array<{ __typename?: 'EventSchedules', allDay: boolean, timeSlots?: Array<{ __typename?: 'EventSchedulesTimeSlots', _id?: any | null, from?: string | null, to?: string | null, endsNextDay?: boolean | null, note?: string | null } | null> | null } | null>, recurrencePattern: { __typename?: 'EventRecurrencePattern', frequency: EnumEventRecurrencePatternFrequency, interval?: number | null, daysOfWeek?: Array<EnumEventRecurrencePatternDaysOfWeek | null> | null, dateOfMonth?: number | null, dayOfMonth?: EnumEventRecurrencePatternDayOfMonth | null, dayOfMonthOccurrence?: number | null, monthAndDateOfYear?: string | null, multiDates?: Array<string | null> | null, skipDates?: Array<string | null> | null, endDate?: string | null }, access: { __typename?: 'EventAccess', disconnectedOrganizations?: Array<any | null> | null, operator?: { __typename?: 'EventAccessOperator', _entityId: any } | null, organizations: Array<{ __typename?: 'EventAccessOperator', _entityId: any, status?: EnumEventAccessOperatorStatus | null, source?: EnumEventAccessOperatorSource | null, addedVia?: any | null } | null> }, history: Array<{ __typename?: 'EventHistory', action: EnumEventHistoryAction, timestamp: any, sourceType?: EnumEventHistorySourceType | null, userId?: any | null, userEmail?: string | null, userName?: string | null, organizationId?: any | null, note?: string | null } | null> } | null };

export type EventByIdPartialDetailsQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type EventByIdPartialDetailsQuery = { __typename?: 'Query', eventById?: { __typename?: 'Event', description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, eventLocations: Array<{ __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null } | null>, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, checkoutWidgets?: Array<{ __typename?: 'EventCheckoutWidget', bookerId: string, status: string, ticketStructure?: string | null, sellingType?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, image?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, embed?: { __typename?: 'EventCheckoutWidgetEmbed', customElementHtml: string, scriptSrc: string, scriptHtml: string, launcherHtml: string } | null } | null> | null } | null };

export type EventCalendarSalesQueryVariables = Exact<{
  storefrontId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type EventCalendarSalesQuery = { __typename?: 'Query', eventCalendarSales?: Array<{ __typename?: 'EventCalendarSaleItem', productId: string, productName: string, tierId: string, tierName: string, totalSold: number, sessions: Array<string>, spanStartDate: string, spanEndDate: string, timeSlots?: Array<{ __typename?: 'EventCalendarTimeSlot', sessionId: string, from?: string | null, to?: string | null } | null> | null } | null> | null };

export type EventCalendarSessionSalesQueryVariables = Exact<{
  storefrontId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type EventCalendarSessionSalesQuery = { __typename?: 'Query', eventCalendarSessionSales?: Array<{ __typename?: 'EventCalendarSessionSale', eventId: string, eventName: string, productId: string, sessionId: string, sessionDate: string, timeSlotLabel?: string | null, totalSold: number, passesSold: number, ticketsSold: number, eventDateTotalSold: number, eventDatePassesSold: number, eventDateTicketsSold: number, totalCapacity?: number | null, remainingCapacity?: number | null, isUnlimited: boolean } | null> | null };

export type EventCountQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  operatorId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type EventCountQuery = { __typename?: 'Query', eventCount?: number | null };

export type EventInventorySettingsQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;


export type EventInventorySettingsQuery = { __typename?: 'Query', eventInventorySettings?: { __typename?: 'EventInventorySettings', event: any, defaultCapacityPerSession?: number | null, sessionOverrides?: Array<{ __typename?: 'EventInventorySettingsSessionOverrides', sessionId: string, capacity: number } | null> | null } | null };

export type EventLinkedWidgetsQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
  notInBookerId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type EventLinkedWidgetsQuery = { __typename?: 'Query', eventLinkedWidgets?: Array<{ __typename?: 'EventLinkedWidget', bookerId: string, status?: string | null, productId: string, ticketStructure?: string | null, sellingType?: string | null, storefrontId: string, organizationId?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, storefrontName?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null };

export type EventLookaheadMonthsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  operatorId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type EventLookaheadMonthsQuery = { __typename?: 'Query', eventLookaheadMonths?: any | null };

export type EventSessionAvailabilityQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  sessionIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type EventSessionAvailabilityQuery = { __typename?: 'Query', eventSessionAvailability?: Array<{ __typename?: 'EventSessionAvailability', sessionId: string, totalCapacity?: number | null, remainingCapacity?: number | null, isUnlimited: boolean } | null> | null };

export type EventSessionOrdersQueryVariables = Exact<{
  storefrontId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
  sessionDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventSessionOrdersQuery = { __typename?: 'Query', eventSessionOrders?: Array<{ __typename?: 'EventCalendarSessionOrder', orderId: string, purchaseDate: string, customerName: string, tierName: string, quantity: number, cancelled: boolean, guestNames?: Array<string | null> | null, sessionIds?: Array<string> | null, isPass: boolean, guests?: Array<{ __typename?: 'EventCalendarGuest', name: string, email?: string | null, eventOptions?: Array<{ __typename?: 'EventCalendarGuestOption', label: string, sourceTransactionId?: string | null, amount?: number | null } | null> | null } | null> | null, arrivalHistory?: Array<{ __typename?: 'EventOrderArrivalEntry', action: string, source: string, sessionIds?: Array<string> | null, guestIndexes: Array<number>, attendanceKeys?: Array<string> | null, note?: string | null, timestamp: string, performedBy?: string | null, performedByName?: string | null } | null> | null } | null> | null };

export type EventsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type EventsByIdsQuery = { __typename?: 'Query', eventsByIds: Array<{ __typename?: 'Event', _id: any, createdByEmail: string, createdByFirstName?: string | null, createdByLastName?: string | null, createdByPerson?: any | null, submitterPersonId?: any | null, locationType: EnumEventLocationType, price?: string | null, ticketUrl?: string | null, type: EnumEventType, startDate: string, endDate?: string | null, suspectedDuplicateOf?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, eventOrganizer: { __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null }, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tags?: { __typename?: 'EventTags', global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null, eventLocations: Array<{ __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null } | null>, attentionIssues: Array<{ __typename?: 'EventAttentionIssues', type: EnumEventAttentionIssuesType, sourceName?: string | null, venueIndex?: number | null } | null>, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, schedules: Array<{ __typename?: 'EventSchedules', allDay: boolean, timeSlots?: Array<{ __typename?: 'EventSchedulesTimeSlots', _id?: any | null, from?: string | null, to?: string | null, endsNextDay?: boolean | null, note?: string | null } | null> | null } | null>, recurrencePattern: { __typename?: 'EventRecurrencePattern', frequency: EnumEventRecurrencePatternFrequency, interval?: number | null, daysOfWeek?: Array<EnumEventRecurrencePatternDaysOfWeek | null> | null, dateOfMonth?: number | null, dayOfMonth?: EnumEventRecurrencePatternDayOfMonth | null, dayOfMonthOccurrence?: number | null, monthAndDateOfYear?: string | null, multiDates?: Array<string | null> | null, skipDates?: Array<string | null> | null, endDate?: string | null }, access: { __typename?: 'EventAccess', disconnectedOrganizations?: Array<any | null> | null, operator?: { __typename?: 'EventAccessOperator', _entityId: any } | null, organizations: Array<{ __typename?: 'EventAccessOperator', _entityId: any, status?: EnumEventAccessOperatorStatus | null, source?: EnumEventAccessOperatorSource | null, addedVia?: any | null } | null> }, history: Array<{ __typename?: 'EventHistory', action: EnumEventHistoryAction, timestamp: any, sourceType?: EnumEventHistorySourceType | null, userId?: any | null, userEmail?: string | null, userName?: string | null, organizationId?: any | null, note?: string | null } | null> }> };

export type EventManyQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  operatorId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<EventStatus>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  keepEventsWithNoFutureOccurrences?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Array<Scalars['Float']['input']> | Scalars['Float']['input']>;
  useOrgEventWidgetSettings?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EventManyQuery = { __typename?: 'Query', eventMany: Array<{ __typename?: 'EventWithOccurrences', _id: any, locationType: EnumEventLocationType, type: EnumEventType, startDate: string, endDate?: string | null, occurrences?: Array<string | null> | null, price?: string | null, ticketUrl?: string | null, eventOrganizer: { __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null }, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, eventLocations: Array<{ __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null } | null>, schedules: Array<{ __typename?: 'EventSchedules', allDay: boolean, timeSlots?: Array<{ __typename?: 'EventSchedulesTimeSlots', from?: string | null, to?: string | null, endsNextDay?: boolean | null, note?: string | null } | null> | null } | null>, recurrencePattern: { __typename?: 'EventRecurrencePattern', frequency: EnumEventRecurrencePatternFrequency, interval?: number | null, multiDates?: Array<string | null> | null, daysOfWeek?: Array<EnumEventRecurrencePatternDaysOfWeek | null> | null, dateOfMonth?: number | null, dayOfMonth?: EnumEventRecurrencePatternDayOfMonth | null, dayOfMonthOccurrence?: number | null, monthAndDateOfYear?: string | null, endDate?: string | null, skipDates?: Array<string | null> | null }, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags?: { __typename?: 'EventTags', global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null, access: { __typename?: 'EventAccess', organizations: Array<{ __typename?: 'EventAccessOperator', _entityId: any, status?: EnumEventAccessOperatorStatus | null } | null> } }> };

export type EventManyAppQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  operatorId?: InputMaybe<Scalars['ID']['input']>;
  operatorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  status?: InputMaybe<EventStatus>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  skipRecurrences?: InputMaybe<Scalars['Boolean']['input']>;
  keepEventsWithNoFutureOccurrences?: InputMaybe<Scalars['Boolean']['input']>;
  useOrgEventWidgetSettings?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EventManyAppQuery = { __typename?: 'Query', eventMany: Array<{ __typename?: 'EventWithOccurrences', _id: any, type: EnumEventType, startDate: string, endDate?: string | null, occurrences?: Array<string | null> | null, updatedDateISO?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, schedules: Array<{ __typename?: 'EventSchedules', allDay: boolean, timeSlots?: Array<{ __typename?: 'EventSchedulesTimeSlots', _id?: any | null, from?: string | null, to?: string | null, endsNextDay?: boolean | null, note?: string | null } | null> | null } | null>, recurrencePattern: { __typename?: 'EventRecurrencePattern', frequency: EnumEventRecurrencePatternFrequency, interval?: number | null, multiDates?: Array<string | null> | null, daysOfWeek?: Array<EnumEventRecurrencePatternDaysOfWeek | null> | null, dateOfMonth?: number | null, dayOfMonth?: EnumEventRecurrencePatternDayOfMonth | null, dayOfMonthOccurrence?: number | null, monthAndDateOfYear?: string | null, endDate?: string | null, skipDates?: Array<string | null> | null }, attentionIssues: Array<{ __typename?: 'EventAttentionIssues', type: EnumEventAttentionIssuesType, sourceName?: string | null, venueIndex?: number | null } | null>, eventOrganizer: { __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null }, eventLocations: Array<{ __typename?: 'EventLocation', venue: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, locationInfo?: { __typename?: 'EventLocationLocationInfo', _entityId?: any | null, type?: EnumEventLocationLocationInfoType | null } | null } | null>, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags?: { __typename?: 'EventTags', organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any } | null }> } | null, access: { __typename?: 'EventAccess', operator?: { __typename?: 'EventAccessOperator', _entityId: any } | null, organizations: Array<{ __typename?: 'EventAccessOperator', _entityId: any, status?: EnumEventAccessOperatorStatus | null, source?: EnumEventAccessOperatorSource | null, addedVia?: any | null } | null> } }> };

export type FeatureFlagGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlagGroupsQuery = { __typename?: 'Query', featureFlagGroups: Array<string> };

export type FeatureFlagListQueryVariables = Exact<{
  includeGraduated?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FeatureFlagListQuery = { __typename?: 'Query', featureFlagList?: Array<{ __typename?: 'FeatureFlagWithGateCount', _id: any, key: string, name: string, description?: string | null, group: string, graduatedAt?: any | null, enabledCount: number, totalTargetCount: number, scope: EnumFeatureFlagScope, graduated: boolean } | null> | null };

export type FeatureFlagOrgGatesQueryVariables = Exact<{
  featureFlagId: Scalars['MongoID']['input'];
}>;


export type FeatureFlagOrgGatesQuery = { __typename?: 'Query', featureFlagOrgGates?: Array<{ __typename?: 'FeatureFlagOrgGate', organizationId: any, organizationName: string, shortName?: string | null, enabled: boolean, hasExplicitGate: boolean } | null> | null };

export type FeatureFlagsByOrganizationQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
}>;


export type FeatureFlagsByOrganizationQuery = { __typename?: 'Query', featureFlagsByOrganization?: Array<{ __typename?: 'ResolvedFeatureFlag', _id: any, key: string, name: string, description?: string | null, group: string, enabled: boolean, graduated: boolean, hasExplicitGate: boolean } | null> | null };

export type FulfillmentProfileManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyFulfillmentProfileInput>;
}>;


export type FulfillmentProfileManyQuery = { __typename?: 'Query', fulfillmentProfileMany: Array<{ __typename?: 'FulfillmentProfile', _id: any, name: string, isActive: boolean, storefront: any, pickup?: { __typename?: 'FulfillmentProfilePickup', enabled?: boolean | null, locations?: Array<{ __typename?: 'FulfillmentProfilePickupLocations', _id?: any | null, name: string, address?: string | null, instructions?: string | null } | null> | null } | null, shipping?: { __typename?: 'FulfillmentProfileShipping', enabled?: boolean | null, taxable?: boolean | null, zones?: Array<{ __typename?: 'FulfillmentProfileShippingZones', _id?: any | null, name: string, countries?: Array<string | null> | null, subdivisions?: Array<string | null> | null, flatRate: number, perAdditionalItem?: number | null, freeOver?: number | null } | null> | null } | null }> };

export type GalleryNewMediaCountQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type GalleryNewMediaCountQuery = { __typename?: 'Query', galleryNewMediaCount: number };

export type GalleryNewMediaManyQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GalleryNewMediaManyQuery = { __typename?: 'Query', galleryNewMediaMany?: Array<{ __typename?: 'GalleryNewMedia', _id: any, listingId: any, listingName?: string | null, originalAssetId: string, mediaType: EnumGalleryNewMediaMediaType, url?: string | null, muxPlaybackId?: string | null, width?: number | null, height?: number | null, blurhash?: string | null, status: EnumGalleryNewMediaStatus, publicMediaId?: any | null, createdDateISO?: any | null }> | null };

export type ImageByIdsQueryVariables = Exact<{
  _ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsAssetImageInput>;
}>;


export type ImageByIdsQuery = { __typename?: 'Query', imageByIds: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }> };

export type ImpersonationUserSearchQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type ImpersonationUserSearchQuery = { __typename?: 'Query', impersonationUserSearch?: Array<{ __typename?: 'AdminUserInfo', _id: any, email: string, firstName: string, lastName: string, userType: string } | null> | null };

export type ImportByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ImportByIdQuery = { __typename?: 'Query', importById?: { __typename?: 'Import', _id: any, name: string, status?: ImportStatus | null, importType?: ImportType | null, createdDateISO?: any | null, updatedDateISO?: any | null, organization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, googleSheetsConfig: { __typename?: 'ImportGoogleSheetsConfig', sheetUrl?: string | null, sheetId?: string | null, range?: string | null, apiKey?: string | null, serviceAccountKey?: string | null }, createdBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null } | null };

export type ImportManagerSettingsFindOneQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportManagerSettingsFindOneQuery = { __typename?: 'Query', importManagerSettingsFindOne?: { __typename?: 'ImportManagerSettings', _id: any, googleDriveDestinationFolderId?: string | null, googleSheetTemplates?: { __typename?: 'ImportManagerSettingsGoogleSheetTemplates', tags?: string | null, operators?: string | null, people?: string | null, events?: string | null } | null, dummyDataSheets?: { __typename?: 'ImportManagerSettingsGoogleSheetTemplates', tags?: string | null, operators?: string | null, people?: string | null, events?: string | null } | null, aiScraperGenerator?: { __typename?: 'ImportManagerSettingsAiScraperGenerator', aiEngine?: EnumImportManagerSettingsAiScraperGeneratorAiEngine | null, defaultPrompt?: string | null } | null } | null };

export type ImportManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyImportInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ImportManyQuery = { __typename?: 'Query', importMany: Array<{ __typename?: 'Import', _id: any, name: string, status?: ImportStatus | null, importType?: ImportType | null, createdDateISO?: any | null, updatedDateISO?: any | null, organization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, googleSheetsConfig: { __typename?: 'ImportGoogleSheetsConfig', sheetUrl?: string | null, sheetId?: string | null, range?: string | null }, createdBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null }> };

export type ImportRunManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyImportRunInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyImportRunInput>;
}>;


export type ImportRunManyQuery = { __typename?: 'Query', importRunMany: Array<{ __typename?: 'ImportRun', _id: any, status: EnumImportRunStatus, operatorCount?: number | null, errors?: Array<string | null> | null, errorMessage?: string | null, createdOperatorIds: Array<string | null>, createdEntityIds: Array<string | null>, dryRun?: boolean | null, isUpdateMode?: boolean | null, limit?: number | null, startingRow?: number | null, rowsImported?: number | null, endingRow?: number | null, totalRowsAvailable?: number | null, startedBy: string, createdDateISO?: any | null, updatedDateISO?: any | null, completedAt?: any | null, serverLogs: Array<string | null>, skipImages: boolean, importedOperators?: Array<{ __typename?: 'ImportedEntitySnapshot', entityId: string, name: string, type?: string | null } | null> | null, importedEntities?: Array<{ __typename?: 'ImportedEntitySnapshot', entityId: string, name: string, type?: string | null } | null> | null, existingOperators?: Array<{ __typename?: 'ExistingEntitySnapshot', entityId: string, name: string, type?: string | null, website?: string | null, organizationNames?: Array<string | null> | null } | null> | null, operatorsManuallyConnectedToOrg?: Array<{ __typename?: 'ExistingEntitySnapshot', entityId: string, name: string, type?: string | null, website?: string | null, organizationNames?: Array<string | null> | null } | null> | null, dryRunLog?: Array<{ __typename?: 'DryRunLogEntry', entityName: string, entityType?: string | null, imageCount?: number | null, hasContact?: boolean | null, hasAddress?: boolean | null, hasDescription?: boolean | null, status: string, errorMessages?: Array<string | null> | null, isExisting?: boolean | null, existingEntityId?: string | null, willBeConnectedToOperator?: boolean | null, connectedOperatorName?: string | null, isUpdate?: boolean | null, fieldsToUpdate?: Array<string | null> | null, willConnectToExistingOperator?: boolean | null, existingOperatorVenueName?: string | null, existingOperatorVenueId?: string | null, tagsAddedCount?: number | null, organizerCouldNotConnect?: boolean | null, missingOrganizer?: boolean | null, unresolvedOrganizerName?: string | null, unresolvedVenueNames?: Array<string | null> | null, missingVenue?: boolean | null, willConnectToExistingOperatorAsOrganizer?: boolean | null, existingOperatorOrganizerName?: string | null, existingOperatorOrganizerId?: string | null } | null> | null, jobs?: { __typename?: 'ImportRunJobs', errorList?: Array<string | null> | null } | null, import?: { __typename?: 'Import', _id: any, importType?: ImportType | null, organization?: { __typename?: 'Organization', _id: any } | null } | null, rollbackInfo?: { __typename?: 'RollbackInfo', rolledBackAt: any, rolledBackBy: string, deletedCount: number, imagesDeleted: number, errorMessages?: Array<string | null> | null } | null }> };

export type ImportScrapeByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ImportScrapeByIdQuery = { __typename?: 'Query', importScrapeById?: { __typename?: 'ImportScrape', _id: any, name: string, typeOfData: EnumImportScrapeTypeOfData, typeOfScrape: EnumImportScrapeTypeOfScrape, status: EnumImportScrapeStatus, websiteUrl?: string | null, maxRows: number, scraperPrompt?: string | null, targetOrganization?: any | null, sitemapUrlCount: number, sitemapRevision: number, createdBy?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, googleSheetsConfig?: { __typename?: 'ImportScrapeGoogleSheetsConfig', sheetUrl?: string | null, sheetId?: string | null, sheetName?: string | null } | null } | null };

export type ImportScrapeManyQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportScrapeManyQuery = { __typename?: 'Query', importScrapeMany: Array<{ __typename?: 'ImportScrape', _id: any, name: string, typeOfData: EnumImportScrapeTypeOfData, typeOfScrape: EnumImportScrapeTypeOfScrape, status: EnumImportScrapeStatus, websiteUrl?: string | null, maxRows: number, scraperPrompt?: string | null, createdBy?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, googleSheetsConfig?: { __typename?: 'ImportScrapeGoogleSheetsConfig', sheetUrl?: string | null, sheetId?: string | null, sheetName?: string | null } | null }> };

export type ImportScrapeRunManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyImportScrapeRunInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyImportScrapeRunInput>;
}>;


export type ImportScrapeRunManyQuery = { __typename?: 'Query', importScrapeRunMany: Array<{ __typename?: 'ImportScrapeRun', _id: any, scrapeId: any, initiatedBy?: any | null, promptUsed: string, websiteUrl: string, status?: EnumImportScrapeRunStatus | null, errorMessages?: Array<string | null> | null, rawAIResponse?: string | null, googleSheetsResponse?: string | null, results?: Array<any | null> | null, rowsAdded?: number | null, sitemapOffset?: number | null, sitemapTotalUrls?: number | null, sitemapRevision?: number | null, rating?: EnumImportScrapeRunRating | null, notes?: string | null, createdDateISO?: any | null }> };

export type InventoryByProductBookedDatesQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type InventoryByProductBookedDatesQuery = { __typename?: 'Query', inventoryDatesByProduct?: { __typename?: 'InventoryBookedDatesSummary', bookedDatesISO: Array<string>, checkOutOnlyDatesISO: Array<string> } | null };

export type InviteQueueByOperatorAndOrganizationQueryVariables = Exact<{
  operatorEntityId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
}>;


export type InviteQueueByOperatorAndOrganizationQuery = { __typename?: 'Query', inviteQueueByOperatorAndOrganization?: { __typename?: 'InviteQueue', _id: any, invitedOperator: any, invitedOperatorName: string, inviteByEmailOnly: boolean, invitedEmail?: string | null, invitedUser?: any | null, invitedUserName?: string | null, initiatedByUser: any, initiatedByUserName: string, initiatedDate: any, organizationId?: any | null, organizationName?: string | null, inviteStatus: EnumInviteQueueInviteStatus, createdDateISO?: any | null, updatedDateISO?: any | null } | null };

export type InviteQueueCleanupPreviewQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  criteria: InviteQueueCleanupCriteriaInput;
}>;


export type InviteQueueCleanupPreviewQuery = { __typename?: 'Query', inviteQueueCleanupPreview?: { __typename?: 'InviteQueueCleanupPreview', sentMoreThan: number, olderThanDays: number, accepted: number, bounced: number, ready: number, total: number } | null };

export type InviteQueueManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyInviteQueueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InviteQueueManyQuery = { __typename?: 'Query', inviteQueueMany: Array<{ __typename?: 'InviteQueue', _id: any, invitedOperator: any, invitedOperatorName: string, inviteByEmailOnly: boolean, storedInvitedEmail?: string | null, staffDeliveryEmail?: string | null, invitedEmail?: string | null, invitedUser?: any | null, invitedUserName?: string | null, initiatedByUserName: string, initiatedDate: any, organizationId?: any | null, organizationName?: string | null, inviteStatus: EnumInviteQueueInviteStatus, inviteType: EnumInviteQueueInviteType, activityLogIds: Array<any | null>, bounced: boolean, personId?: any | null, updatedDateISO?: any | null }> };

export type ItineraryWidgetsForOrgPreviewQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
}>;


export type ItineraryWidgetsForOrgPreviewQuery = { __typename?: 'Query', itineraryWidgetsByOrganization: Array<{ __typename?: 'ItineraryWidgetWithName', _id: any, itinerary: any, organization: any, type: string, label?: string | null, buttonLabel?: string | null, embedStyle?: string | null, accentColor?: string | null, status: string }> };

export type LeadByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type LeadByIdQuery = { __typename?: 'Query', leadById?: { __typename?: 'Lead', _id: any, subject?: string | null, link?: string | null, status: EnumLeadStatus, type?: EnumLeadType | null, source?: EnumLeadSource | null, sourceDetails?: string | null, broadcastId?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, messages: Array<{ __typename?: 'LeadMessages', message: string, sender: EnumLeadMessagesSender, sentAtDateISO: any } | null>, metadata: { __typename?: 'LeadMetadata', booker?: { __typename?: 'Booker', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, bundles: Array<{ __typename?: 'BookerBundles', product?: { __typename?: 'Product', name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null> } | null, storefront?: { __typename?: 'Storefront', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, organization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, operator?: { __typename?: 'OperatorWithStatus', _id: any, _entityId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }, person?: { __typename?: 'SimplePersonTC', _id: string, firstName: string, lastName: string, email: string, phone?: string | null } | null, surveyResponse?: { __typename?: 'SurveyResponse', _id: any, survey?: { __typename?: 'Survey', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, responses: Array<{ __typename?: 'SurveyResponseResponses', response: Array<string | null>, questionData: { __typename?: 'SurveyQuestion', type: EnumSurveyQuestionType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } } | null> } | null } | null };

export type ListByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ListByIdQuery = { __typename?: 'Query', listById: { __typename?: 'ListWithEntities', _id: any, type: EnumListType, kind: EnumListKind, tierTagId?: any | null, memberListKey?: EnumListMemberListKey | null, filterTagIds: Array<any | null>, selections: any, archived: boolean, favorited: boolean, orderIndex?: number | null, locked: boolean, lockedAt?: any | null, lockedBy?: any | null, lockedByName?: string | null, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, entities?: Array<{ __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, status?: PublicationStatusType | null, type: EnumOperatorType, operationalStatus: EnumOperatorOperationalStatus, claimed: boolean, iasc?: number | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tags?: { __typename?: 'OperatorTags', global: Array<{ __typename?: 'Tag', _id: any }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any }> } | null, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, enrollments: Array<{ __typename?: 'OperatorEnrollments', onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus, organizationControlled: boolean, organization?: { __typename?: 'Organization', _id: any, shortName: string } | null } | null> }> | null } };

export type ListManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyListInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyListInput>;
}>;


export type ListManyQuery = { __typename?: 'Query', listMany: Array<{ __typename?: 'List', _id: any, type: EnumListType, kind: EnumListKind, tierTagId?: any | null, memberListKey?: EnumListMemberListKey | null, filterTagIds: Array<any | null>, updatedDateISO?: any | null, archived: boolean, favorited: boolean, orderIndex?: number | null, locked: boolean, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, entityReferences: Array<{ __typename?: 'VersionedEntityReference', _entityId: any, _versionId: any, type: EnumVersionedEntityReferenceType } | null> }> };

export type ListManyNamesQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyListInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyListInput>;
}>;


export type ListManyNamesQuery = { __typename?: 'Query', listMany: Array<{ __typename?: 'List', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type MaintenanceFindOneQueryVariables = Exact<{ [key: string]: never; }>;


export type MaintenanceFindOneQuery = { __typename?: 'Query', maintenanceFindOne?: { __typename?: 'Maintenance', banner: { __typename?: 'MaintenanceDoorstop', isLive: boolean, message: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }, doorstop: { __typename?: 'MaintenanceDoorstop', isLive: boolean, message: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } } | null };

export type MediaGalleryTagGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type MediaGalleryTagGroupQuery = { __typename?: 'Query', mediaGalleryTagGroup?: any | null };

export type MemberListsByTierTagIdsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  tierTagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MemberListsByTierTagIdsQuery = { __typename?: 'Query', memberListsByTierTagIds?: Array<{ __typename?: 'List', _id: any, tierTagId?: any | null, memberListKey?: EnumListMemberListKey | null, filterTagIds: Array<any | null>, archived: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> | null };

export type MembershipBySubjectAndOrganizationQueryVariables = Exact<{
  subjectType: Scalars['String']['input'];
  subjectEntityId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
}>;


export type MembershipBySubjectAndOrganizationQuery = { __typename?: 'Query', membershipBySubjectAndOrganization?: { __typename?: 'Membership', _id: any, status: EnumMembershipStatus, tierTagId?: any | null, statusTagIds: Array<any | null>, currentPeriodEnd?: any | null, nextRenewalDate?: any | null, manualRenewalDate?: any | null, renewalAnchorDate?: any | null, renewalState?: { __typename?: 'MembershipRenewalState', phase: string, paidThroughDate?: any | null, nextRenewalDate?: any | null, displayDate?: any | null } | null } | null };

export type MembershipChecklistLatestQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
}>;


export type MembershipChecklistLatestQuery = { __typename?: 'Query', membershipChecklistLatest?: { __typename?: 'MembershipChecklistResult', ranAt: any, analysis: { __typename?: 'MembershipChecklistAnalysis', memberListsEnabled: boolean, ledgerEnabled: boolean, members: { __typename?: 'MembershipChecklistMembers', total: number, totalListings: number, nonMembers: number, multipleTiers: number, tieredWithoutStatusTag: number, multipleTierListings: Array<{ __typename?: 'MembershipChecklistListing', entityId: string, name: string, tiers: Array<string> }>, byTier: Array<{ __typename?: 'MembershipChecklistTier', tagId: string, name: string, count: number, listId?: string | null, byStatus: Array<{ __typename?: 'MembershipChecklistTagCount', tagId: string, name: string, count: number }> }>, byStatus: Array<{ __typename?: 'MembershipChecklistTagCount', tagId: string, name: string, count: number }> }, renewal: { __typename?: 'MembershipChecklistRenewal', engineEnabled: boolean, enabled: boolean, renewalType?: string | null, term?: string | null, termYears?: number | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, activeStatusTagId?: string | null, activeStatusTagName?: string | null, attentionStatusTagIds?: Array<string> | null, withRenewalDate: number, withoutRenewalDate: number, paidUp: number, renewalWindow: number, expired: number, tagDrift: number, suggestedBulkDate?: any | null }, payment: { __typename?: 'MembershipChecklistPayment', enabled: boolean, hasStorefront: boolean, liveCadStorefrontId?: string | null, liveUsdStorefrontId?: string | null, testUsdStorefrontId?: string | null, byTier: Array<{ __typename?: 'MembershipChecklistPaymentTier', tagId: string, bookerId?: string | null, bookerStorefrontId?: string | null, isTest: boolean, free: boolean }> }, communication: { __typename?: 'MembershipChecklistCommunication', broadcastId?: string | null, broadcastName?: string | null, broadcastPublished: boolean, broadcastSharedToAll?: boolean | null, allowColdSignup: boolean } } } | null };

export type MembershipCheckoutBookersQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyBookerInput>;
}>;


export type MembershipCheckoutBookersQuery = { __typename?: 'Query', bookerMany: Array<{ __typename?: 'Booker', _id: any, status: EnumBookerStatus, storefront: any, businessCompletionTags: Array<any | null>, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, bundles: Array<{ __typename?: 'BookerBundles', _id?: any | null, product?: { __typename?: 'Product', _id: any, type: EnumProductType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, renewableFeeMetadata?: { __typename?: 'RenewableFeeMetadata', membershipLinked?: boolean | null } | null, sellingConfig?: { __typename?: 'ProductSellingConfig', recurring?: { __typename?: 'ProductSellingConfigRecurring', membershipLinked?: boolean | null } | null, options?: Array<{ __typename?: 'ProductTier', _id?: any | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagConfig?: { __typename?: 'ProductTierTagConfig', onCheckoutCompleted?: Array<any | null> | null } | null } | null> | null } | null } | null } | null> }> };

export type MembershipContactStatesByOperatorsQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  operatorEntityIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type MembershipContactStatesByOperatorsQuery = { __typename?: 'Query', membershipPaidUpByOperators?: Array<{ __typename?: 'MembershipPaidUpInfo', operatorEntityId: any, contactStatusTagId?: any | null, contactKind?: PendingRenewalEmailKind | null, contactState?: MemberContactState | null, lastContactedAt?: any | null, queuedListId?: any | null, queuedListName?: string | null } | null> | null };

export type MembershipCustomEmailPreviewQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  listId: Scalars['MongoID']['input'];
  operatorEntityIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type MembershipCustomEmailPreviewQuery = { __typename?: 'Query', membershipCustomEmailPreview: { __typename?: 'MembershipCustomEmailPreview', total: number, sendable: number, skippedQueued: number, skippedCoolingDown: number, skippedNoEmail: number, skippedUnsubscribed: number, missing: Array<{ __typename?: 'MembershipListEmailCoverageMissing', entityId: any, name: string } | null> } };

export type MembershipDisplayForPersonQueryVariables = Exact<{
  personId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
}>;


export type MembershipDisplayForPersonQuery = { __typename?: 'Query', membershipDisplayForPerson?: { __typename?: 'MembershipDisplayForPerson', source: string, listingEntityId?: any | null, listingName?: string | null, membership?: { __typename?: 'Membership', _id: any, status: EnumMembershipStatus, tierTagId?: any | null, statusTagIds: Array<any | null>, currentPeriodEnd?: any | null, nextRenewalDate?: any | null, manualRenewalDate?: any | null, renewalAnchorDate?: any | null, renewalState?: { __typename?: 'MembershipRenewalState', phase: string, paidThroughDate?: any | null, nextRenewalDate?: any | null, displayDate?: any | null } | null } | null } | null };

export type MembershipHubForUserQueryVariables = Exact<{
  organizationIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type MembershipHubForUserQuery = { __typename?: 'Query', membershipHubForUser?: Array<{ __typename?: 'MembershipHubOrganization', organizationId: any, enabled: boolean, hideOfferFromForYou: boolean, contactEmail?: string | null, tiers?: Array<{ __typename?: 'MembershipHubTier', tierTagId: any, subjectType: string, action: string, bookerId?: any | null, price?: number | null, billingIntervalMonths?: number | null, applicationBroadcastId?: any | null, applicationResourceId?: any | null, hideFromNewcomers: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null }> | null, purchases?: Array<{ __typename?: 'MembershipHubPurchase', _id: any, status: string, renewalBilling: string, currentPeriodEnd?: string | null, operatorIds: Array<any>, pendingOperatorIds?: Array<any> | null, multiListingMode: string, maxListings?: number | null, canManage: boolean, tierName?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, addOns?: Array<{ __typename?: 'MembershipHubAddOn', description: string, amount: number, quantity: number, operatorId?: string | null, businessName?: string | null }> | null }> | null }> | null };

export type MembershipLaunchStatusQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
}>;


export type MembershipLaunchStatusQuery = { __typename?: 'Query', membershipLaunchStatus: { __typename?: 'MembershipLaunchStatus', state: string, derived: boolean, mode?: string | null, launchedAt?: any | null, recordedRetroactively: boolean, locked: boolean, blockers: Array<string>, health: { __typename?: 'MembershipScheduleHealth', undated: number, offSchedule: number, purchaseSnapshotMismatch: number, staleCheckouts: number, overdue: number, graceEndsOn?: any | null }, scheduleHistory: Array<{ __typename?: 'MembershipScheduleChange', at: any, kind: string, fromMonth?: number | null, fromDay?: number | null, toMonth?: number | null, toDay?: number | null, intent?: string | null, date?: any | null, affected: number, note?: string | null }> } };

export type OrganizationRenewalSchedulePreviewQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  kind: Scalars['String']['input'];
  month?: InputMaybe<Scalars['Int']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  outlierTarget?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  graceDays?: InputMaybe<Scalars['Int']['input']>;
  neverExpire?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrganizationRenewalSchedulePreviewQuery = { __typename?: 'Query', organizationRenewalSchedulePreview: { __typename?: 'RenewalRebasePlan', affected: number, unchanged: number, undated: number, byPhase: { __typename?: 'RenewalRebasePhaseCounts', paidUp: number, renewalWindow: number, expired: number }, outliers: Array<{ __typename?: 'RenewalRebaseMember', subjectType: string, entityId: string, name: string, currentDate?: any | null, targetDate?: any | null }>, skipped: Array<{ __typename?: 'RenewalRebaseMember', subjectType: string, entityId: string, name: string, currentDate?: any | null, targetDate?: any | null }>, grace: { __typename?: 'RenewalRebaseGrace', overdueCount: number, targetDate?: any | null, nextRenewalDate?: any | null, currentGraceDays: number, currentGraceIsDefault: boolean, currentGraceEndsOn?: any | null, currentNeverExpire: boolean, suggestedGraceDays?: number | null, graceDays: number, neverExpire: boolean, graceEndsOn?: any | null, wouldExpireOnNextSweep: number }, from: { __typename?: 'RenewalScheduleSnapshot', fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null }, to: { __typename?: 'RenewalScheduleSnapshot', fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null } } };

export type MembershipListEmailCoverageQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  listId: Scalars['MongoID']['input'];
}>;


export type MembershipListEmailCoverageQuery = { __typename?: 'Query', membershipListEmailCoverage?: { __typename?: 'MembershipListEmailCoverage', total: number, missing: Array<{ __typename?: 'MembershipListEmailCoverageMissing', entityId: any, name: string } | null> } | null };

export type MembershipPaidUpByOperatorsQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  operatorEntityIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type MembershipPaidUpByOperatorsQuery = { __typename?: 'Query', membershipPaidUpByOperators?: Array<{ __typename?: 'MembershipPaidUpInfo', operatorEntityId: any, manualRenewalDate?: any | null, currentPeriodEnd?: any | null, nextRenewalDate?: any | null, renewalPhase?: string | null, renewalDisplayDate?: any | null, renewalDay?: any | null } | null> | null };

export type MembershipRenewalAuditByOrganizationQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
}>;


export type MembershipRenewalAuditByOrganizationQuery = { __typename?: 'Query', membershipRenewalAuditByOrganization: { __typename?: 'MembershipRenewalAudit', organizationId: any, organizationName: string, renewalEngineEnabled: boolean, counts: { __typename?: 'MembershipRenewalAuditCounts', total: number, paidUp: number, renewalWindow: number, expired: number, unknown: number, noPolicy: number, tagDrift: number }, discrepancies: Array<{ __typename?: 'MembershipRenewalAuditRow', membershipId: any, subjectType: string, entityId: any, displayName: string, personId?: any | null, kind: string, phase: string, paidThroughDate?: any | null, nextRenewalDate?: any | null, currentStatusTags: Array<{ __typename?: 'MembershipRenewalAuditTag', tagId: string, name: string }>, suggestedAddTags: Array<{ __typename?: 'MembershipRenewalAuditTag', tagId: string, name: string }>, suggestedRemoveTags: Array<{ __typename?: 'MembershipRenewalAuditTag', tagId: string, name: string }> }> } };

export type MembershipStatsByOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type MembershipStatsByOrganizationQuery = { __typename?: 'Query', membershipStatsByOrganization: { __typename?: 'MembershipStats', total: number, byTier?: Array<{ __typename?: 'MembershipTagCount', tagId: string, name: string, count: number }> | null, byStatus?: Array<{ __typename?: 'MembershipTagCount', tagId: string, name: string, count: number }> | null } };

export type MembershipSuggestedRenewalDateQueryVariables = Exact<{
  subjectType: Scalars['String']['input'];
  subjectEntityId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
}>;


export type MembershipSuggestedRenewalDateQuery = { __typename?: 'Query', membershipSuggestedRenewalDate?: { __typename?: 'MembershipSuggestedRenewalDate', suggestedDate?: any | null, isFreshGrant: boolean, currentPaidThroughDate?: any | null, periodStart?: any | null, periodEnd?: any | null, blockedByInvoice?: { __typename?: 'MembershipOpenRenewalInvoice', storefrontId?: string | null, paymentRequestId?: string | null, invoiceNumber?: string | null, amount: number, currency: string, dueDate?: string | null } | null } | null };

export type MembershipTimelineManyQueryVariables = Exact<{
  subjectType: Scalars['String']['input'];
  subjectEntityId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type MembershipTimelineManyQuery = { __typename?: 'Query', membershipTimelineMany?: Array<{ __typename?: 'MembershipTimelineItem', _id: string, kind: string, tagName: string, viaSuffix: string, actorName?: string | null, createdDateISO: any }> | null };

export type NoteCountQueryVariables = Exact<{
  filter?: InputMaybe<FilterCountNoteInput>;
}>;


export type NoteCountQuery = { __typename?: 'Query', noteCount?: number | null };

export type NoteManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyNoteInput>;
  sort?: InputMaybe<SortFindManyNoteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NoteManyQuery = { __typename?: 'Query', noteMany: Array<{ __typename?: 'Note', _id: any, message: string, isArchived: boolean, kind: EnumNoteKind, noteDateISO?: string | null, updatedDateISO?: any | null, createdDateISO?: any | null, author?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null, entity: { __typename?: 'EntityReference', _entityId: any, type: EnumEntityReferenceType }, mentions: Array<{ __typename?: 'User', _id: any, firstName: string, lastName: string }>, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, resolvedBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string } | null }> };

export type NotesForListingStaffQueryVariables = Exact<{
  operatorEntityId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type NotesForListingStaffQuery = { __typename?: 'Query', notesForListingStaff?: Array<{ __typename?: 'Note', _id: any, message: string, isArchived: boolean, kind: EnumNoteKind, noteDateISO?: string | null, updatedDateISO?: any | null, createdDateISO?: any | null, author?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null, entity: { __typename?: 'EntityReference', _entityId: any, type: EnumEntityReferenceType }, mentions: Array<{ __typename?: 'User', _id: any, firstName: string, lastName: string }>, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, resolvedBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string } | null }> | null };

export type OperatorByIdQueryVariables = Exact<{
  operatorId: Scalars['ID']['input'];
}>;


export type OperatorByIdQuery = { __typename?: 'Query', operatorById: { __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, updatedDateISO?: any | null, type: EnumOperatorType, claimed: boolean, operationalStatus: EnumOperatorOperationalStatus, pricing?: EnumOperatorPricing | null, status?: PublicationStatusType | null, enableMembershipLink: boolean, crowdriffGalleryId?: string | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags?: { __typename?: 'OperatorTags', organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, businessType: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, amenity: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, contact: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null }, seasonality?: { __typename?: 'Seasonality', jan?: SeasonalityEnum | null, feb?: SeasonalityEnum | null, mar?: SeasonalityEnum | null, apr?: SeasonalityEnum | null, may?: SeasonalityEnum | null, jun?: SeasonalityEnum | null, jul?: SeasonalityEnum | null, aug?: SeasonalityEnum | null, sep?: SeasonalityEnum | null, oct?: SeasonalityEnum | null, nov?: SeasonalityEnum | null, dec?: SeasonalityEnum | null } | null, hoursOfOperation?: { __typename?: 'OperatorHoursOfOperation', sun?: { __typename?: 'DateRangeISO', start: string, end: string } | null, mon?: { __typename?: 'DateRangeISO', start: string, end: string } | null, tue?: { __typename?: 'DateRangeISO', start: string, end: string } | null, wed?: { __typename?: 'DateRangeISO', start: string, end: string } | null, thu?: { __typename?: 'DateRangeISO', start: string, end: string } | null, fri?: { __typename?: 'DateRangeISO', start: string, end: string } | null, sat?: { __typename?: 'DateRangeISO', start: string, end: string } | null } | null, accommodationMetadata?: { __typename?: 'AccommodationOperatorMetadata', shortTermAccommodationLicense?: string | null } | null, enrollments: Array<{ __typename?: 'OperatorEnrollments', organizationControlled: boolean, onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus, organization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, metadata?: { __typename?: 'OrganizationMetadata', disabledApps?: Array<EnumOrganizationMetadataDisabledApps | null> | null, crowdriffEnabled?: boolean | null, membershipTiers?: Array<any | null> | null, individualMembershipTiers?: Array<any | null> | null, nomenclature?: { __typename?: 'OrganizationMetadataNomenclature', membership?: string | null } | null } | null } | null } | null>, connectedOrganization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } | null, externalVideoLinks: Array<{ __typename?: 'OperatorExternalVideoLinks', _id?: any | null, url: string, service?: string | null } | null>, whereabotDismissed?: { __typename?: 'OperatorWhereabotDismissed', listingScan?: any | null, imageScan?: any | null } | null, staff: Array<{ __typename?: 'User', _id: any, firstName: string, lastName: string, email: string, status: EnumUserStatus, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus, contactRoles?: Array<EnumUserAccessOperatorsContactRoles | null> | null } | null> } }> } };

export type OperatorEntityIdsByFilterQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<EnumOperatorType>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tagMode?: InputMaybe<Scalars['String']['input']>;
}>;


export type OperatorEntityIdsByFilterQuery = { __typename?: 'Query', operatorEntityIdsByFilter: Array<string> };

export type OperatorInvoiceHeaderQueryVariables = Exact<{
  operatorId: Scalars['ID']['input'];
}>;


export type OperatorInvoiceHeaderQuery = { __typename?: 'Query', operatorById: { __typename?: 'OperatorWithStatus', _entityId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null }, connectedOrganization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null } | null } };

export type OperatorManyBillingContactSearchQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  search: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OperatorManyBillingContactSearchQuery = { __typename?: 'Query', operatorManyBillingContactSearch: Array<{ __typename?: 'OperatorBillingContactSearchResult', _entityId: any, staffCount: number, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, previewStaff: Array<{ __typename?: 'OperatorBillingContactSearchStaff', _id: any, firstName?: string | null, lastName?: string | null, email?: string | null, isOwner: boolean, contactRoles: Array<string> }> }> };

export type OperatorManyDirectoryCountQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  publicationStatus?: InputMaybe<PublicationStatusType>;
  operationalStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  claimed?: InputMaybe<Scalars['Boolean']['input']>;
  organizationControlled?: InputMaybe<Scalars['Boolean']['input']>;
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type OperatorManyDirectoryCountQuery = { __typename?: 'Query', operatorManyDirectoryCount: number };

export type OperatorManyInternalSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  excludeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OperatorManyInternalSearchQuery = { __typename?: 'Query', operatorManyInternalSearch: Array<{ __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, status?: PublicationStatusType | null, claimed: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact: { __typename?: 'Contact', email?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null }, connectedOrganization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } | null, enrollments: Array<{ __typename?: 'OperatorEnrollments', organization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null> }> };

export type OperatorManyWithOrganizationStatusesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<EnumOperatorType>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tagMode?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<OperatorManyWithOrganizationStatusesSortEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OperatorManyWithOrganizationStatusesQuery = { __typename?: 'Query', operatorManyWithOrganizationStatuses: Array<{ __typename?: 'OperatorManyWithOrganizationStatuses', _entityId: any, _versionId: any, type?: EnumOperatorType | null, operationalStatus?: string | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, organizations: Array<{ __typename?: 'OrganizationWithOperatorStatus', _id: any, status: PublicationStatusType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> }> };

export type OperatorWithOrganizationStatusesCountQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<EnumOperatorType>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tagMode?: InputMaybe<Scalars['String']['input']>;
}>;


export type OperatorWithOrganizationStatusesCountQuery = { __typename?: 'Query', operatorWithOrganizationStatusesCount?: number | null };

export type OperatorNameByIdQueryVariables = Exact<{
  operatorEntityId: Scalars['ID']['input'];
}>;


export type OperatorNameByIdQuery = { __typename?: 'Query', operatorById: { __typename?: 'OperatorWithStatus', name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } };

export type OperatorStaffQueryVariables = Exact<{
  operatorId: Scalars['ID']['input'];
}>;


export type OperatorStaffQuery = { __typename?: 'Query', operatorStaff: Array<{ __typename?: 'UserWithPictureTC', email: string, picture?: string | null, _id: any, personId?: string | null, firstName: string, lastName: string, title?: string | null, photoUploadedBy?: any | null, contactRoles?: Array<ContactRole | null> | null, status: EnumUserStatus, userType: EnumUserUserType, quickLinksVersion: number, lastViewedListId?: string | null, hasPurchases: boolean, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus, title?: string | null, contactRoles?: Array<EnumUserAccessOperatorsContactRoles | null> | null } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, storefronts: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null> }, onboardingMetadata?: { __typename?: 'UserOnboardingMetadata', onboardingOrganization?: any | null, isPostOnboarding?: boolean | null, onboardingBroadcast?: any | null } | null, emailPreferences: Array<{ __typename?: 'UserEmailPreferences', templateName: EnumUserEmailPreferencesTemplateName, frequency: EnumUserEmailPreferencesFrequency, entity?: { __typename?: 'EntityReference', type: EnumEntityReferenceType, _entityId: any } | null } | null>, quickLinks: Array<{ __typename?: 'UserQuickLinks', title: string, link: string, lastVisited: string, type: EnumUserQuickLinksType, entityId: string, pinned?: boolean | null } | null>, memberships: Array<{ __typename?: 'UserMembershipRow', _id: any, subjectType: string, listingName?: string | null, organizationId: any, organizationName: string, organizationLogo?: any | null, memberNomenclature: string, membershipNomenclature: string, tierName?: string | null, status: string, statusTagNames: Array<string>, renewalDate?: any | null, renewalDateDisplayMode: string, needsRenewal: boolean, tierTagId?: any | null, subjectEntityId: any, renewablePurchaseId?: any | null, renewalBilling?: string | null }> }> };

export type OperatorsByIdsQueryVariables = Exact<{
  operatorEntityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  status?: InputMaybe<PublicationStatusType>;
}>;


export type OperatorsByIdsQuery = { __typename?: 'Query', operatorsByIds: Array<{ __typename?: 'OperatorWithStatusAndStaff', _entityId: any, _versionId: any, pricing?: EnumOperatorPricing | null, type: EnumOperatorType, status?: PublicationStatusType | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, staff: Array<{ __typename?: 'User', email: string, firstName: string, lastName: string, _id: any }>, contact: { __typename?: 'Contact', phone?: string | null, email?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', website?: string | null } | null }, tags?: { __typename?: 'OperatorTags', organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null } | null> };

export type OperatorsByIdsEnrollmentsQueryVariables = Exact<{
  operatorEntityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  status?: InputMaybe<PublicationStatusType>;
}>;


export type OperatorsByIdsEnrollmentsQuery = { __typename?: 'Query', operatorsByIds: Array<{ __typename?: 'OperatorWithStatusAndStaff', _entityId: any, _versionId: any, enrollments: Array<{ __typename?: 'OperatorEnrollments', organization?: { __typename?: 'Organization', _id: any } | null } | null> } | null> };

export type OperatorsByIdsEventCreationQueryVariables = Exact<{
  operatorEntityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  status?: InputMaybe<PublicationStatusType>;
}>;


export type OperatorsByIdsEventCreationQuery = { __typename?: 'Query', operatorsByIds: Array<{ __typename?: 'OperatorWithStatusAndStaff', _entityId: any, _versionId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, enrollments: Array<{ __typename?: 'OperatorEnrollments', onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus, organizationControlled: boolean, organization?: { __typename?: 'Organization', _id: any } | null } | null>, contact: { __typename?: 'Contact', email?: string | null, phone?: string | null, links?: { __typename?: 'Links', website?: string | null, instagram?: string | null, x?: string | null, bookNow?: string | null, youtube?: string | null, pinterest?: string | null, googleMyBusiness?: string | null, tiktok?: string | null, facebook?: string | null, tripAdvisor?: string | null } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null } } | null> };

export type OperatorsByUserQueryVariables = Exact<{ [key: string]: never; }>;


export type OperatorsByUserQuery = { __typename?: 'Query', operatorsByUser: Array<{ __typename?: 'Operator', _id: any, _entityId: any, _versionId: any, claimed: boolean, connectedOrganization?: any | null, contact: { __typename?: 'Contact', address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null }, enrollments: Array<{ __typename?: 'OperatorEnrollments', organizationControlled: boolean, onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus, organization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, contact?: { __typename?: 'Contact', email?: string | null, links?: { __typename?: 'Links', website?: string | null } | null } | null, metadata?: { __typename?: 'OrganizationMetadata', internalOnly?: boolean | null, sandbox?: boolean | null, membershipBroadcastId?: any | null } | null } | null } | null>, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }> }> };

export type OperatorsCountQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OperatorsCountQuery = { __typename?: 'Query', operatorsCount?: number | null };

export type OperatorManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyOperatorInput>;
  avgImageQuality?: InputMaybe<Array<ImageQualityRating> | ImageQualityRating>;
  publicationStatus?: InputMaybe<PublicationStatusType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useCase?: InputMaybe<OperatorManyUseCaseEnum>;
  imageCount?: InputMaybe<NumberInput>;
  includeInvitedOrAcceptedStaffCounts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OperatorManyQuery = { __typename?: 'Query', operatorMany: Array<{ __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, updatedDateISO?: any | null, claimed: boolean, type: EnumOperatorType, operationalStatus: EnumOperatorOperationalStatus, status?: PublicationStatusType | null, iasc?: number | null, pricing?: EnumOperatorPricing | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, enrollments: Array<{ __typename?: 'OperatorEnrollments', onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus, organizationControlled: boolean, organization?: { __typename?: 'Organization', _id: any } | null } | null>, contact: { __typename?: 'Contact', email?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null }, hoursOfOperation?: { __typename?: 'OperatorHoursOfOperation', sun?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null, mon?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null, tue?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null, wed?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null, thu?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null, fri?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null, sat?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null } | null, tags?: { __typename?: 'OperatorTags', organizationSpecific: Array<{ __typename?: 'Tag', _id: any }> } | null, selectedTagGroups: Array<{ __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, connectedOrganization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } | null }> };

export type OperatorManyDirectoryQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyOperatorInput>;
  avgImageQuality?: InputMaybe<Array<ImageQualityRating> | ImageQualityRating>;
  publicationStatus?: InputMaybe<PublicationStatusType>;
  sort?: InputMaybe<SortFindManyOperatorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useCase?: InputMaybe<OperatorManyUseCaseEnum>;
  imageCount?: InputMaybe<NumberInput>;
  includeInvitedOrAcceptedStaffCounts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OperatorManyDirectoryQuery = { __typename?: 'Query', operatorMany: Array<{ __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, updatedDateISO?: any | null, claimed: boolean, type: EnumOperatorType, operationalStatus: EnumOperatorOperationalStatus, status?: PublicationStatusType | null, iasc?: number | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, enrollments: Array<{ __typename?: 'OperatorEnrollments', organizationControlled: boolean, onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus, organization?: { __typename?: 'Organization', _id: any, shortName: string } | null } | null>, connectedOrganization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } | null }> };

export type OperatorsManyEventCreationQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyOperatorInput>;
  avgImageQuality?: InputMaybe<Array<ImageQualityRating> | ImageQualityRating>;
  publicationStatus?: InputMaybe<PublicationStatusType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useCase?: InputMaybe<OperatorManyUseCaseEnum>;
  imageCount?: InputMaybe<NumberInput>;
  includeInvitedOrAcceptedStaffCounts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OperatorsManyEventCreationQuery = { __typename?: 'Query', operatorMany: Array<{ __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, enrollments: Array<{ __typename?: 'OperatorEnrollments', onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus, organization?: { __typename?: 'Organization', _id: any } | null } | null>, contact: { __typename?: 'Contact', email?: string | null, phone?: string | null, links?: { __typename?: 'Links', website?: string | null } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null } }> };

export type OperatorManyNamesQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyOperatorInput>;
  avgImageQuality?: InputMaybe<Array<ImageQualityRating> | ImageQualityRating>;
  publicationStatus?: InputMaybe<PublicationStatusType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useCase?: InputMaybe<OperatorManyUseCaseEnum>;
  imageCount?: InputMaybe<NumberInput>;
  includeInvitedOrAcceptedStaffCounts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OperatorManyNamesQuery = { __typename?: 'Query', operatorMany: Array<{ __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type OperatorsManyPersonConnectToListingQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyOperatorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useCase?: InputMaybe<OperatorManyUseCaseEnum>;
  includeInvitedOrAcceptedStaffCounts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OperatorsManyPersonConnectToListingQuery = { __typename?: 'Query', operatorMany: Array<{ __typename?: 'OperatorWithStatus', _entityId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact: { __typename?: 'Contact', address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null }, connectedOrganization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } | null }> };

export type OrderByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type OrderByIdQuery = { __typename?: 'Query', orderById?: { __typename?: 'Order', _id: string, cancelled: boolean, testMode: boolean, complimentaryAmount: number, createdDateISO?: any | null, updatedDateISO?: any | null, approval?: { __typename?: 'OrderApproval', status: EnumOrderApprovalStatus, requestedAt: any, expiresAt?: any | null, messageFromGuest?: string | null, declineReason?: string | null, decidedAt?: any | null } | null, billing?: { __typename?: 'OrderBilling', timing: EnumOrderBillingTiming, consolidation: EnumOrderBillingConsolidation, serviceEndAt?: any | null, statementPeriod?: string | null, invoicePaymentRequestId?: any | null } | null, fulfillment?: { __typename?: 'OrderFulfillment', status?: EnumOrderFulfillmentStatus | null, note?: string | null, fulfilledAt?: string | null, carrier?: string | null, trackingNumber?: string | null } | null, delivery?: { __typename?: 'OrderDelivery', method: EnumOrderDeliveryMethod, pickupLocationName?: string | null, pickupLocationAddress?: string | null, shippingZoneName?: string | null, shippingTotal: number, shippingAddress?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null } | null, manualPaymentNote?: { __typename?: 'OrderManualPaymentNote', note: string, recordedAt: string } | null, customer?: { __typename?: 'SimplePersonTC', _id: string, email: string, firstName: string, lastName: string, phone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null } | null, discounts: Array<{ __typename?: 'Discount', _id: any, amount: number, isActive: boolean, promoCode?: string | null, type: EnumDiscountType, unit: EnumDiscountUnit, excludeUpsells: boolean, perTicket: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null>, guests: Array<{ __typename?: 'OrderGuests', name?: string | null, email?: string | null } | null>, purchasedProducts: Array<{ __typename?: 'PurchasedProduct', _id: any, tierId?: string | null, sessionIds?: Array<string | null> | null, merchVariantId?: string | null, quantity: number, customFieldResponses?: Array<{ __typename?: 'PurchasedProductCustomFieldResponses', fieldId: string, label?: string | null, type: EnumPurchasedProductCustomFieldResponsesType, isChoiceList?: boolean | null, response?: Array<string | null> | null } | null> | null, guestsPerTier: Array<{ __typename?: 'PurchasedProductGuestsPerTier', count: number, tierId: any, sessionId?: string | null, sessionIds?: Array<string | null> | null } | null>, inventoryClaims: Array<{ __typename?: 'PurchasedProductInventoryClaims', _id?: any | null, claimedDateRangeISO?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null } | null>, product: { __typename?: 'Product', _id: any, type: EnumProductType, isUpsellOnly: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, contact?: { __typename?: 'ProductContact', useOwnerContact: boolean, email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null } | null, pricing?: { __typename?: 'Pricing', description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tiers: Array<{ __typename?: 'PriceTier', _id: any, price: number, type: EnumGuestTierType, priceType: EnumPriceTierPriceType, discountAmount?: number | null, discountUnit?: EnumPriceTierDiscountUnit | null, label?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> } | null, accommodationMetadata?: { __typename?: 'AccommodationProductMetadata', checkIn?: string | null, checkOut?: string | null } | null, sellingConfig?: { __typename?: 'ProductSellingConfig', options?: Array<{ __typename?: 'ProductTier', _id?: any | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null, productTiers?: Array<{ __typename?: 'ProductTier', _id?: any | null, sessionScope?: EnumProductTierSessionScope | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null, eventMetadata?: { __typename?: 'ProductEventMetadata', event: any, sessionGranularity: EnumProductEventMetadataSessionGranularity, ticketStructure: EnumProductEventMetadataTicketStructure } | null, merchMetadata?: { __typename?: 'MerchMetadata', dimensions?: Array<{ __typename?: 'MerchMetadataDimensions', _id?: any | null, drivesImages?: boolean | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, values?: Array<{ __typename?: 'MerchMetadataDimensionsValues', _id?: any | null, imageIds?: Array<string | null> | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null, variants?: Array<{ __typename?: 'MerchMetadataVariants', _id?: any | null, label?: string | null, sku?: string | null, dimensionValueIds?: Array<string | null> | null } | null> | null } | null } } | null>, additionalLineItems: Array<{ __typename?: 'OrderAdditionalLineItems', description: string, amount: number, quantity: number } | null>, pricingSnapshot?: { __typename?: 'OrderPricingSnapshot', lineItems?: Array<{ __typename?: 'OrderPricingSnapshotLineItems', productId: string, tierId?: string | null, unitPrice: number, quantity: number, amount: number, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null, source: { __typename?: 'OrderSource', type?: EnumOrderSourceType | null, booker: any, storefront: any, operatorId?: any | null, businessName?: string | null, renewablePurchaseId?: any | null, renewalRecordId?: any | null, paymentRequestId?: any | null, customerInvoicePayment?: boolean | null }, stripeMetadata: { __typename?: 'StripeMetadata', chargeId: string, customerId: string, invoiceId?: string | null, invoiceStatus?: EnumStripeMetadataInvoiceStatus | null, paymentMethodId: string, connectedAccountId?: string | null, securityHoldPaymentIntentId?: string | null, securityHoldStatus?: EnumStripeMetadataSecurityHoldStatus | null }, surveyResponse?: { __typename?: 'SurveyResponse', responses: Array<{ __typename?: 'SurveyResponseResponses', response: Array<string | null>, questionData: { __typename?: 'SurveyQuestion', _id: any, parentQuestion?: any | null, type: EnumSurveyQuestionType, required: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, options: Array<{ __typename?: 'SurveyQuestionOptions', isActive: boolean, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> } } | null> } | null, paymentMetadata: { __typename?: 'OrderPaymentMetadata', depositSettings?: { __typename?: 'DepositSettings', chargeBalanceDaysBeforeCheckIn: number, enabled: boolean, rate?: number | null, rateType?: EnumDepositSettingsRateType | null } | null }, taxExemption?: { __typename?: 'OrderTaxExemption', claimed: boolean, exemptionNumber: string } | null, linkedPaymentRequest?: { __typename?: 'PaymentRequest', _id: any, version: number, status: EnumPaymentRequestStatus, accountingCode?: string | null, internalAccountingNotes?: string | null, externalReference?: string | null, accountingDate?: string | null } | null } | null };

export type OrderManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyOrderInput>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyOrderInput>;
}>;


export type OrderManyQuery = { __typename?: 'Query', orderMany?: { __typename?: 'OrderFindMany', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'Order', _id: string, cancelled: boolean, testMode: boolean, createdDateISO?: any | null, approval?: { __typename?: 'OrderApproval', status: EnumOrderApprovalStatus, requestedAt: any, expiresAt?: any | null, messageFromGuest?: string | null, declineReason?: string | null } | null, billing?: { __typename?: 'OrderBilling', timing: EnumOrderBillingTiming, consolidation: EnumOrderBillingConsolidation, serviceEndAt?: any | null, statementPeriod?: string | null, invoicePaymentRequestId?: any | null } | null, fulfillment?: { __typename?: 'OrderFulfillment', status?: EnumOrderFulfillmentStatus | null, note?: string | null, fulfilledAt?: string | null, carrier?: string | null, trackingNumber?: string | null } | null, delivery?: { __typename?: 'OrderDelivery', method: EnumOrderDeliveryMethod } | null, purchasedProducts: Array<{ __typename?: 'PurchasedProduct', quantity: number, _id: any, product: { __typename?: 'Product', _id: any, type: EnumProductType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }, guestsPerTier: Array<{ __typename?: 'PurchasedProductGuestsPerTier', count: number, tierId: any } | null>, inventoryClaims: Array<{ __typename?: 'PurchasedProductInventoryClaims', _id?: any | null, claimedDateRangeISO?: { __typename?: 'DateRangeISO', _id: any, end: string, metadata?: string | null, start: string } | null } | null> } | null>, source: { __typename?: 'OrderSource', type?: EnumOrderSourceType | null, booker: any, storefront: any, renewablePurchaseId?: any | null, renewalRecordId?: any | null, renewalNextDate?: string | null, renewalStatus?: string | null }, customer?: { __typename?: 'SimplePersonTC', _id: string, firstName: string, lastName: string, email: string } | null, stripeMetadata: { __typename?: 'StripeMetadata', chargeId: string, invoiceId?: string | null, invoiceStatus?: EnumStripeMetadataInvoiceStatus | null, paymentMethodId: string }, paymentMetadata: { __typename?: 'OrderPaymentMetadata', depositSettings?: { __typename?: 'DepositSettings', enabled: boolean } | null }, linkedPaymentRequest?: { __typename?: 'PaymentRequest', _id: any, version: number, status: EnumPaymentRequestStatus, accountingCode?: string | null, internalAccountingNotes?: string | null, externalReference?: string | null, accountingDate?: string | null } | null }> | null } | null };

export type OrderManyIndexQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyOrderInput>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyOrderInput>;
}>;


export type OrderManyIndexQuery = { __typename?: 'Query', orderMany?: { __typename?: 'OrderFindMany', count?: number | null, items?: Array<{ __typename?: 'Order', _id: string, createdDateISO?: any | null, source: { __typename?: 'OrderSource', renewablePurchaseId?: any | null } }> | null } | null };

export type OrderPricesByIdsQueryVariables = Exact<{
  orderIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrderPricesByIdsQuery = { __typename?: 'Query', orderPricesByIds: Array<{ __typename?: 'OrderCartPrice', orderId: string, prices?: { __typename?: 'CartPrices', subTotal: number, taxTotal: number, grandTotal: number, depositTotal: number, discountTotal: number } | null }> };

export type OrderPricesByIdQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type OrderPricesByIdQuery = { __typename?: 'Query', orderPricesById?: { __typename?: 'CartPrices', depositTotal: number, discountTotal: number, grandTotal: number, shippingTotal?: number | null, subTotal: number, taxTotal: number, customerFee: number, discountTotals: Array<{ __typename?: 'DiscountTotalPerDiscount', discountId: string, total: number }>, productPrices: Array<{ __typename?: 'PricePerProduct', price: number, productId: string }>, taxLines: Array<{ __typename?: 'TaxLine', name: string, ratePercent?: number | null, amount: number }> } | null };

export type OrdersForBroadcastResourceQueryVariables = Exact<{
  broadcastResourceId: Scalars['String']['input'];
  personId: Scalars['String']['input'];
  bookerId?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrdersForBroadcastResourceQuery = { __typename?: 'Query', ordersForBroadcastResource?: Array<{ __typename?: 'Order', _id: string, cancelled: boolean, createdDateISO?: any | null, stripeMetadata: { __typename?: 'StripeMetadata', chargeId: string }, purchasedProducts: Array<{ __typename?: 'PurchasedProduct', product: { __typename?: 'Product', _id: any, type: EnumProductType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } } | null>, customer?: { __typename?: 'SimplePersonTC', _id: string, firstName: string, lastName: string } | null } | null> | null };

export type OrdersForCurrentUserQueryVariables = Exact<{
  teamOnly: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrdersForCurrentUserQuery = { __typename?: 'Query', ordersForCurrentUser?: Array<{ __typename?: 'Order', _id: string, cancelled: boolean, createdDateISO?: any | null, stripeMetadata: { __typename?: 'StripeMetadata', chargeId: string }, purchasedProducts: Array<{ __typename?: 'PurchasedProduct', product: { __typename?: 'Product', _id: any, type: EnumProductType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } } | null>, customer?: { __typename?: 'SimplePersonTC', _id: string, firstName: string, lastName: string } | null } | null> | null };

export type OrgOperatorOverlayFindOneQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  operatorId: Scalars['MongoID']['input'];
}>;


export type OrgOperatorOverlayFindOneQuery = { __typename?: 'Query', orgOperatorOverlayFindOne?: { __typename?: 'OrgOperatorOverlay', _id: any, operator: any, createdDateISO?: any | null, updatedDateISO?: any | null, organization?: { __typename?: 'Organization', _id: any } | null, overlayPrivate?: { __typename?: 'OrgOperatorOverlayOverlayPrivate', tags?: Array<any | null> | null, note?: string | null } | null, overlayPublic?: { __typename?: 'OrgOperatorOverlayOverlayPublic', publicProfileUrl?: string | null, crowdriffGalleryId?: string | null } | null } | null };

export type OrgOverviewByOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrgOverviewByOrganizationQuery = { __typename?: 'Query', orgOverviewByOrganization: { __typename?: 'OrgOverviewResult', builtAt?: any | null, rows?: Array<{ __typename?: 'OrgOverviewRow', _id: string, entityType: string, entityId: string, name: string, searchText: string, status?: string | null, peopleCount?: number | null, primaryContactName?: string | null, financialContactName?: string | null, staffNames?: Array<string> | null, paidInvoiceTotal: number, paidInvoiceCount: number, paidInvoiceNumbers: Array<string>, invoiceStorefrontId?: string | null, unpaidInvoiceTotal: number, unpaidInvoiceCount: number, unpaidInvoiceNumbers: Array<string>, unpaidInvoiceStorefrontId?: string | null, membershipTierName?: string | null, membershipStatusNames: Array<string>, membershipRenewalDate?: any | null, noteCount: number, eventCount?: number | null, eventStartDate?: string | null, eventEndDate?: string | null, recurrenceType?: string | null, attendeeCount?: number | null, attendeeStorefrontId?: string | null, attendeeSessionDate?: string | null, attendeeSessionDateCount?: number | null, customTagNames: Array<string>, primaryTag?: string | null }> | null } };

export type OrganizationAppSettingsWidgetsQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type OrganizationAppSettingsWidgetsQuery = { __typename?: 'Query', organizationById?: { __typename?: 'Organization', _id: any, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, appSettings?: { __typename?: 'OrganizationAppSettings', widgets?: { __typename?: 'OrganizationAppSettingsWidgets', operator?: { __typename?: 'OrganizationAppSettingsWidgetsOperator', hideTemporarilyClosed?: boolean | null, showPermanentlyClosed?: boolean | null, tieredSortOrder?: Array<any | null> | null, defaultImageMode?: EnumOrganizationAppSettingsWidgetsOperatorDefaultImageMode | null, defaultImageId?: string | null, operatorWidgetFilter?: EnumOrganizationAppSettingsWidgetsOperatorOperatorWidgetFilter | null, prioritizeClaimedAndDmoManaged?: boolean | null, audienceTagIds?: Array<any | null> | null, customDefaultFallbackImage?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, tierDisplayOverrides?: Array<{ __typename?: 'OrganizationAppSettingsWidgetsOperatorTierDisplayOverrides', tagId: any, statusSortOrder?: Array<any | null> | null, teaser?: { __typename?: 'OrganizationAppSettingsWidgetsOperatorTierDisplayOverridesTeaser', hideImage?: boolean | null } | null, slideout?: { __typename?: 'OrganizationAppSettingsWidgetsOperatorTierDisplayOverridesSlideout', limitImages?: number | null, hideAddress?: boolean | null, hideLongDescription?: boolean | null, hideExternalLinks?: boolean | null, hideOperatingHours?: boolean | null, hideMap?: boolean | null } | null } | null> | null, audienceTagFilters?: Array<{ __typename?: 'OrganizationAppSettingsWidgetsOperatorAudienceTagFilters', tagId: any, mode: EnumOrganizationAppSettingsWidgetsOperatorAudienceTagFiltersMode } | null> | null } | null, whatsNearby?: { __typename?: 'OrganizationAppSettingsWidgetsWhatsNearby', audienceTagIds?: Array<any | null> | null, audienceTagFilters?: Array<{ __typename?: 'OrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFilters', tagId: any, mode: EnumOrganizationAppSettingsWidgetsWhatsNearbyAudienceTagFiltersMode } | null> | null } | null, event?: { __typename?: 'OrganizationAppSettingsWidgetsEvent', hideCancelledEvents?: boolean | null, organizerAudienceTagFilters?: Array<{ __typename?: 'OrganizationAppSettingsWidgetsEventOrganizerAudienceTagFilters', tagId: any, mode: EnumOrganizationAppSettingsWidgetsEventOrganizerAudienceTagFiltersMode } | null> | null, venueAudienceTagFilters?: Array<{ __typename?: 'OrganizationAppSettingsWidgetsEventVenueAudienceTagFilters', tagId: any, mode: EnumOrganizationAppSettingsWidgetsEventVenueAudienceTagFiltersMode } | null> | null } | null } | null } | null } | null };

export type OrganizationByEventSharingCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type OrganizationByEventSharingCodeQuery = { __typename?: 'Query', organizationByEventSharingCode: { __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } };

export type OrganizationByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type OrganizationByIdQuery = { __typename?: 'Query', organizationById?: { __typename?: 'Organization', _id: any, shortName: string, brandColors: Array<string | null>, domains: Array<string | null>, subdomain?: string | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, onboardingMetadata: { __typename?: 'OrganizationOnboardingMetadata', videoId?: string | null, introMessage?: string | null, allowColdSignup?: boolean | null, typeformSurveyId?: string | null, comingSoonMessage?: string | null }, emailBranding?: { __typename?: 'OrganizationEmailBranding', fromName?: string | null, replyTo?: string | null, accentColor?: string | null, showContact?: boolean | null, footerText?: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } | null } | null, metadata?: { __typename?: 'OrganizationMetadata', inviteWhenAddingStaff?: boolean | null, eventLookaheadMonths?: number | null, disabledApps?: Array<EnumOrganizationMetadataDisabledApps | null> | null, connectedStorefront?: any | null, connectedTestStorefront?: any | null, storefrontOrgConnectionsEnabled?: boolean | null, storefrontMode?: EnumOrganizationMetadataStorefrontMode | null, connectedUsdStorefront?: any | null, connectedUsdTestStorefront?: any | null, internalOnly?: boolean | null, sandbox?: boolean | null, connectedOperator?: any | null, canEnableMembershipLink?: boolean | null, membershipPageUrl?: string | null, crowdriffEnabled?: boolean | null, externalVideoEnabled?: boolean | null, membershipTiers?: Array<any | null> | null, individualMembershipTiers?: Array<any | null> | null, membershipStatusTagIds?: Array<any | null> | null, listingAudienceTagIds?: Array<any | null> | null, listingFreshnessEnabled?: boolean | null, dmoListingStaleDays?: number | null, claimedListingStaleDays?: number | null, operatorOnboardingDisabled?: boolean | null, whereabotListingUpdatePrompt?: string | null, whereabotImageDownloadPrompt?: string | null, customClaimEmailSubject?: string | null, customClaimEmailBody?: string | null, customPingEmailSubject?: string | null, customPingEmailBody?: string | null, membershipPaymentsEnabled?: boolean | null, timezone?: string | null, nomenclature?: { __typename?: 'OrganizationMetadataNomenclature', membership?: string | null, member?: string | null, members?: string | null } | null, renewalSettings?: { __typename?: 'OrganizationMetadataRenewalSettings', enabled?: boolean | null, renewalType?: EnumOrganizationMetadataRenewalSettingsRenewalType | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, proRateEnabled?: boolean | null, term?: EnumOrganizationMetadataRenewalSettingsTerm | null, termYears?: number | null, pendingStatusTagId?: any | null, activeStatusTagId?: any | null, expiredStatusTagId?: any | null, clearStatusTagsOnExpiration?: boolean | null, engineOwnedTags?: boolean | null, renewalGraceDays?: number | null, neverExpireMembers?: boolean | null, overdueStatusTagId?: any | null, cancelledStatusTagId?: any | null, sendRenewalEmails?: boolean | null, sendExpirationEmails?: boolean | null, sendSuccessEmails?: boolean | null, sendOverdueEmails?: boolean | null, sendCancelledEmails?: boolean | null, automaticRenewalEmails?: boolean | null, emailCooldownDays?: number | null, renewalReminderLeadDays?: number | null, instructionsEmail?: { __typename?: 'OrganizationMetadataRenewalSettingsInstructionsEmail', subject?: string | null, body?: string | null, ctaLabel?: string | null } | null, expiredEmail?: { __typename?: 'OrganizationMetadataRenewalSettingsInstructionsEmail', subject?: string | null, body?: string | null, ctaLabel?: string | null } | null, successEmail?: { __typename?: 'OrganizationMetadataRenewalSettingsInstructionsEmail', subject?: string | null, body?: string | null, ctaLabel?: string | null } | null, overdueEmail?: { __typename?: 'OrganizationMetadataRenewalSettingsInstructionsEmail', subject?: string | null, body?: string | null, ctaLabel?: string | null } | null, cancelledEmail?: { __typename?: 'OrganizationMetadataRenewalSettingsInstructionsEmail', subject?: string | null, body?: string | null, ctaLabel?: string | null } | null, tierReminderEmails?: Array<{ __typename?: 'OrganizationMetadataRenewalSettingsTierReminderEmails', tierTagId: any, subject?: string | null, body?: string | null, hideRenewalDateLine?: boolean | null, ctaLabel?: string | null } | null> | null } | null, membershipTierCheckouts?: Array<{ __typename?: 'OrganizationMetadataMembershipTierCheckouts', tierTagId: any, bookerId?: any | null, free?: boolean | null } | null> | null } | null, license?: { __typename?: 'OrganizationLicense', activatedDate?: any | null, isActive?: boolean | null, activatedBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null } | null } | null };

export type OrganizationCountQueryVariables = Exact<{
  filter?: InputMaybe<FilterCountOrganizationInput>;
}>;


export type OrganizationCountQuery = { __typename?: 'Query', organizationCount?: number | null };

export type OrganizationEmailDomainAdminByOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationEmailDomainAdminByOrganizationQuery = { __typename?: 'Query', organizationEmailDomainAdminByOrganization?: { __typename?: 'OrganizationEmailDomain', _id: any, fromAddress: string, domain: string, status: EnumOrganizationEmailDomainStatus, previousStatus?: EnumOrganizationEmailDomainPreviousStatus | null, sendgridDomainId?: number | null, internalNote?: string | null, allowNonProductionSending: boolean, requestedBy?: any | null, requestedAt?: any | null, activatedAt?: any | null, lastValidatedAt?: any | null, disabledAt?: any | null, dnsRecords?: { __typename?: 'OrganizationEmailDomainDnsRecords', mailCname: { __typename?: 'OrganizationEmailDomainDnsRecordsMailCname', valid: boolean, type: string, host: string, data: string }, dkim1: { __typename?: 'OrganizationEmailDomainDnsRecordsMailCname', valid: boolean, type: string, host: string, data: string }, dkim2: { __typename?: 'OrganizationEmailDomainDnsRecordsMailCname', valid: boolean, type: string, host: string, data: string } } | null, validationResults?: { __typename?: 'OrganizationEmailDomainValidationResults', mailCname?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null, dkim1?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null, dkim2?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null, spf?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null } | null } | null };

export type OrganizationEmailDomainByOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationEmailDomainByOrganizationQuery = { __typename?: 'Query', organizationEmailDomainByOrganization?: { __typename?: 'OrganizationEmailDomain', _id: any, fromAddress: string, domain: string, status: EnumOrganizationEmailDomainStatus, requestedAt?: any | null, activatedAt?: any | null, lastValidatedAt?: any | null, disabledAt?: any | null, dnsRecords?: { __typename?: 'OrganizationEmailDomainDnsRecords', mailCname: { __typename?: 'OrganizationEmailDomainDnsRecordsMailCname', valid: boolean, type: string, host: string, data: string }, dkim1: { __typename?: 'OrganizationEmailDomainDnsRecordsMailCname', valid: boolean, type: string, host: string, data: string }, dkim2: { __typename?: 'OrganizationEmailDomainDnsRecordsMailCname', valid: boolean, type: string, host: string, data: string } } | null, validationResults?: { __typename?: 'OrganizationEmailDomainValidationResults', mailCname?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null, dkim1?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null, dkim2?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null, spf?: { __typename?: 'OrganizationEmailDomainValidationResultsMailCname', valid: boolean, reason?: string | null } | null } | null } | null };

export type OrganizationEventPartnerSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationEventPartnerSettingsQuery = { __typename?: 'Query', organizationEventPartnerSettings: { __typename?: 'OrganizationEventPartnerSettings', sharingCode: string, partners?: Array<{ __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null }> | null, subscribers?: Array<{ __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null }> | null, suggestions?: Array<{ __typename?: 'OrganizationPartnerSummary', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null }> | null } };

export type OrganizationEventWidgetSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationEventWidgetSettingsQuery = { __typename?: 'Query', organizationEventWidgetSettings?: { __typename?: 'OrganizationEventWidgetSettings', hideCancelledEvents: boolean } | null };

export type OrganizationLogoByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type OrganizationLogoByIdQuery = { __typename?: 'Query', organizationById?: { __typename?: 'Organization', logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } | null };

export type OrganizationManifestByOrganizationIdQueryVariables = Exact<{
  filter: FilterFindOneOrganizationManifestInput;
}>;


export type OrganizationManifestByOrganizationIdQuery = { __typename?: 'Query', organizationManifestByOrganizationId?: { __typename?: 'OrganizationManifest', _id: any, organizationId: any, generatedAt: any, generatedBy: any, assetCounts: { __typename?: 'OrganizationManifestAssetCounts', widgets: number, lists: number, customTags: number, notes: number, events: number, broadcasts: number, images: number, users: number, activityLogs: number, imports: number, importRuns: number, people?: { __typename?: 'OrganizationManifestAssetCountsPeople', total: number, toDisconnect: number, toDelete: number } | null, operators?: { __typename?: 'OrganizationManifestAssetCountsOperators', total: number, toDisconnect: number, toDelete: number } | null }, assets: { __typename?: 'OrganizationManifestAssets', people?: Array<{ __typename?: 'OrganizationManifestAssetsPeople', _id: string, action: EnumOrganizationManifestAssetsPeopleAction, name?: string | null, entityId?: string | null } | null> | null, operators?: Array<{ __typename?: 'OrganizationManifestAssetsPeople', _id: string, action: EnumOrganizationManifestAssetsPeopleAction, name?: string | null, entityId?: string | null } | null> | null, widgets?: Array<{ __typename?: 'OrganizationManifestAssetsPeople', _id: string, action: EnumOrganizationManifestAssetsPeopleAction, name?: string | null } | null> | null, lists?: Array<{ __typename?: 'OrganizationManifestAssetsPeople', _id: string, action: EnumOrganizationManifestAssetsPeopleAction, name?: string | null } | null> | null, customTags?: Array<{ __typename?: 'OrganizationManifestAssetsPeople', _id: string, action: EnumOrganizationManifestAssetsPeopleAction, name?: string | null } | null> | null, notes?: Array<{ __typename?: 'OrganizationManifestAssetsPeople', _id: string, action: EnumOrganizationManifestAssetsPeopleAction, name?: string | null } | null> | null, events?: Array<{ __typename?: 'OrganizationManifestAssetsPeople', _id: string, action: EnumOrganizationManifestAssetsPeopleAction, name?: string | null } | null> | null, broadcasts?: Array<{ __typename?: 'OrganizationManifestAssetsPeople', _id: string, action: EnumOrganizationManifestAssetsPeopleAction, name?: string | null } | null> | null, images?: Array<{ __typename?: 'OrganizationManifestAssetsPeople', _id: string, action: EnumOrganizationManifestAssetsPeopleAction, name?: string | null } | null> | null, activityLogs?: Array<{ __typename?: 'OrganizationManifestAssetsPeople', _id: string, action: EnumOrganizationManifestAssetsPeopleAction, name?: string | null } | null> | null, imports?: Array<{ __typename?: 'OrganizationManifestAssetsPeople', _id: string, action: EnumOrganizationManifestAssetsPeopleAction, name?: string | null } | null> | null, importRuns?: Array<{ __typename?: 'OrganizationManifestAssetsPeople', _id: string, action: EnumOrganizationManifestAssetsPeopleAction, name?: string | null } | null> | null }, deletionLog?: { __typename?: 'OrganizationManifestDeletionLog', completedAt: any, completedBy: any, results?: { __typename?: 'OrganizationManifestDeletionLogResults', people?: { __typename?: 'OrganizationManifestDeletionLogResultsPeople', disconnected?: number | null, deleted?: number | null, errors?: number | null } | null, operators?: { __typename?: 'OrganizationManifestDeletionLogResultsOperators', disconnected?: number | null, deleted?: number | null, errors?: number | null } | null, widgets?: { __typename?: 'OrganizationManifestDeletionLogResultsWidgets', deleted?: number | null, errors?: number | null } | null, lists?: { __typename?: 'OrganizationManifestDeletionLogResultsLists', deleted?: number | null, errors?: number | null } | null, notes?: { __typename?: 'OrganizationManifestDeletionLogResultsNotes', deleted?: number | null, errors?: number | null } | null, events?: { __typename?: 'OrganizationManifestDeletionLogResultsEvents', deleted?: number | null, errors?: number | null } | null, broadcasts?: { __typename?: 'OrganizationManifestDeletionLogResultsBroadcasts', deleted?: number | null, errors?: number | null } | null, images?: { __typename?: 'OrganizationManifestDeletionLogResultsImages', deleted?: number | null, errors?: number | null } | null, activityLogs?: { __typename?: 'OrganizationManifestDeletionLogResultsActivityLogs', deleted?: number | null, errors?: number | null } | null, imports?: { __typename?: 'OrganizationManifestDeletionLogResultsImports', deleted?: number | null, errors?: number | null } | null, importRuns?: { __typename?: 'OrganizationManifestDeletionLogResultsImportRuns', deleted?: number | null, errors?: number | null } | null } | null, deletionErrors?: Array<{ __typename?: 'OrganizationManifestDeletionLogDeletionErrors', type: string, message: string, assetId?: string | null } | null> | null } | null, manifestErrors: Array<{ __typename?: 'OrganizationManifestManifestErrors', type: string, message: string, assetId?: string | null } | null> } | null };

export type OrganizationManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyOrganizationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganizationManyQuery = { __typename?: 'Query', organizationMany: Array<{ __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, metadata?: { __typename?: 'OrganizationMetadata', sandbox?: boolean | null } | null }> };

export type OrganizationMembershipHubSettingsQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type OrganizationMembershipHubSettingsQuery = { __typename?: 'Query', organizationById?: { __typename?: 'Organization', _id: any, metadata?: { __typename?: 'OrganizationMetadata', membershipBroadcastId?: any | null, membershipHub?: { __typename?: 'OrganizationMetadataMembershipHub', hideOfferFromForYou?: boolean | null, tiers?: Array<{ __typename?: 'OrganizationMetadataMembershipHubTiers', tierTagId: any, applicationBroadcastId?: any | null, applicationResourceId?: any | null, hideFromNewcomers?: boolean | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null } | null } | null } | null };

export type OrganizationNameByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type OrganizationNameByIdQuery = { __typename?: 'Query', organizationById?: { __typename?: 'Organization', _id: any, shortName: string, subdomain?: string | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null };

export type OrganizationNamesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganizationNamesByIdsQuery = { __typename?: 'Query', organizationsByIds: Array<{ __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type OrganizationSearchHarnessQueryVariables = Exact<{
  search: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganizationSearchHarnessQuery = { __typename?: 'Query', organizationSearchHarness: Array<{ __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type OrganizationShortNamesForAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationShortNamesForAdminQuery = { __typename?: 'Query', organizationsByUser: Array<{ __typename?: 'Organization', _id: any, shortName: string, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type OrganizationStaffQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationStaffQuery = { __typename?: 'Query', organizationStaff: Array<{ __typename?: 'UserWithPictureTC', email: string, picture?: string | null, _id: any, personId?: string | null, firstName: string, lastName: string, title?: string | null, photoUploadedBy?: any | null, contactRoles?: Array<ContactRole | null> | null, status: EnumUserStatus, userType: EnumUserUserType, quickLinksVersion: number, lastViewedListId?: string | null, hasPurchases: boolean, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus, title?: string | null, contactRoles?: Array<EnumUserAccessOperatorsContactRoles | null> | null } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, storefronts: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null> }, onboardingMetadata?: { __typename?: 'UserOnboardingMetadata', onboardingOrganization?: any | null, isPostOnboarding?: boolean | null, onboardingBroadcast?: any | null } | null, emailPreferences: Array<{ __typename?: 'UserEmailPreferences', templateName: EnumUserEmailPreferencesTemplateName, frequency: EnumUserEmailPreferencesFrequency, entity?: { __typename?: 'EntityReference', type: EnumEntityReferenceType, _entityId: any } | null } | null>, quickLinks: Array<{ __typename?: 'UserQuickLinks', title: string, link: string, lastVisited: string, type: EnumUserQuickLinksType, entityId: string, pinned?: boolean | null } | null>, memberships: Array<{ __typename?: 'UserMembershipRow', _id: any, subjectType: string, listingName?: string | null, organizationId: any, organizationName: string, organizationLogo?: any | null, memberNomenclature: string, membershipNomenclature: string, tierName?: string | null, status: string, statusTagNames: Array<string>, renewalDate?: any | null, renewalDateDisplayMode: string, needsRenewal: boolean, tierTagId?: any | null, subjectEntityId: any, renewablePurchaseId?: any | null, renewalBilling?: string | null }> }> };

export type OrganizationsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsOrganizationInput>;
}>;


export type OrganizationsByIdsQuery = { __typename?: 'Query', organizationsByIds: Array<{ __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, links?: { __typename?: 'Links', website?: string | null } | null } | null, metadata?: { __typename?: 'OrganizationMetadata', eventLookaheadMonths?: number | null, inviteWhenAddingStaff?: boolean | null, disabledApps?: Array<EnumOrganizationMetadataDisabledApps | null> | null, connectedStorefront?: any | null, connectedTestStorefront?: any | null, internalOnly?: boolean | null, connectedOperator?: any | null, canEnableMembershipLink?: boolean | null, membershipPageUrl?: string | null, crowdriffEnabled?: boolean | null, externalVideoEnabled?: boolean | null } | null }> };

export type OrganizationsByUserQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationsByUserQuery = { __typename?: 'Query', organizationsByUser: Array<{ __typename?: 'Organization', _id: any, shortName: string, brandColors: Array<string | null>, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, contact?: { __typename?: 'Contact', links?: { __typename?: 'Links', website?: string | null } | null } | null, emailBranding?: { __typename?: 'OrganizationEmailBranding', fromName?: string | null, replyTo?: string | null, accentColor?: string | null, showContact?: boolean | null, footerText?: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } | null } | null, metadata?: { __typename?: 'OrganizationMetadata', inviteWhenAddingStaff?: boolean | null, eventLookaheadMonths?: number | null, disabledApps?: Array<EnumOrganizationMetadataDisabledApps | null> | null, connectedStorefront?: any | null, connectedTestStorefront?: any | null, storefrontOrgConnectionsEnabled?: boolean | null, storefrontMode?: EnumOrganizationMetadataStorefrontMode | null, connectedUsdStorefront?: any | null, connectedUsdTestStorefront?: any | null, internalOnly?: boolean | null, sandbox?: boolean | null, connectedOperator?: any | null, canEnableMembershipLink?: boolean | null, membershipPageUrl?: string | null, crowdriffEnabled?: boolean | null, externalVideoEnabled?: boolean | null, membershipTiers?: Array<any | null> | null, individualMembershipTiers?: Array<any | null> | null, membershipStatusTagIds?: Array<any | null> | null, listingAudienceTagIds?: Array<any | null> | null, listingFreshnessEnabled?: boolean | null, dmoListingStaleDays?: number | null, claimedListingStaleDays?: number | null, operatorOnboardingDisabled?: boolean | null, whereabotListingUpdatePrompt?: string | null, whereabotImageDownloadPrompt?: string | null, customClaimEmailSubject?: string | null, customClaimEmailBody?: string | null, customPingEmailSubject?: string | null, customPingEmailBody?: string | null, membershipBroadcastId?: any | null, membershipPaymentsEnabled?: boolean | null, timezone?: string | null, nomenclature?: { __typename?: 'OrganizationMetadataNomenclature', membership?: string | null, member?: string | null, members?: string | null } | null, membershipTierCheckouts?: Array<{ __typename?: 'OrganizationMetadataMembershipTierCheckouts', tierTagId: any, bookerId?: any | null, free?: boolean | null } | null> | null } | null, onboardingMetadata: { __typename?: 'OrganizationOnboardingMetadata', allowColdSignup?: boolean | null, coldSignupTagId?: any | null, introMessage?: string | null, comingSoonMessage?: string | null }, license?: { __typename?: 'OrganizationLicense', activatedDate?: any | null, isActive?: boolean | null, activatedBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, email: string } | null } | null }> };

export type PaymentMethodSetManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPaymentMethodSetInput>;
}>;


export type PaymentMethodSetManyQuery = { __typename?: 'Query', paymentMethodSetMany: Array<{ __typename?: 'PaymentMethodSet', _id: any, name: string, isActive: boolean, acceptedPaymentMethods: Array<string | null>, bankTransferInstructions?: string | null, offlinePaymentInstructions?: string | null, checkoutDescription?: string | null, storefront: any, methodLabels?: { __typename?: 'PaymentMethodSetMethodLabels', card?: string | null, direct_debit?: string | null, bank_transfer?: string | null, offline_payment?: string | null } | null }> };

export type PaymentRequestsForCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentRequestsForCurrentUserQuery = { __typename?: 'Query', paymentRequestsForCurrentUser: Array<{ __typename?: 'UserUnpaidPaymentRequestRow', _id: any, invoiceNumber?: string | null, status: string, grandTotal: number, currency: string, dueDate?: string | null, sentAt?: string | null, createdDateISO?: any | null, renewablePurchaseId?: any | null, organizationId?: string | null, productTitle?: string | null }> };

export type PendingRenewalEmailsQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  operatorEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  listId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type PendingRenewalEmailsQuery = { __typename?: 'Query', pendingRenewalEmails?: Array<{ __typename?: 'PendingRenewalEmail', _id: any, emailKind: EnumPendingRenewalEmailEmailKind, scheduledSendAt: any, status: EnumPendingRenewalEmailStatus, listId?: any | null, sendNowRequestedAt?: any | null, subject: { __typename?: 'PendingRenewalEmailSubject', type: EnumPendingRenewalEmailSubjectType, entityId: any } } | null> | null };

export type PeopleByIdsNamesQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PeopleByIdsNamesQuery = { __typename?: 'Query', peopleByIds: Array<{ __typename?: 'People', firstName: string, lastName: string, _id: any }> };

export type PeopleCountQueryVariables = Exact<{
  filter?: InputMaybe<FilterCountPeopleInput>;
  queryBuilder?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type PeopleCountQuery = { __typename?: 'Query', peopleCount?: number | null };

export type PeopleManyNamesQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPeopleInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PeopleManyNamesQuery = { __typename?: 'Query', peopleManySimple: Array<{ __typename?: 'SimplePersonManyTC', _id: string, firstName: string, lastName: string }> };

export type PeopleManySimpleQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPeopleInput>;
  queryBuilder?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<SortFindManyPeopleInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PeopleManySimpleQuery = { __typename?: 'Query', peopleManySimple: Array<{ __typename?: 'SimplePersonManyTC', _id: string, firstName: string, lastName: string, email: string, phone?: string | null, isRepeatCustomer?: boolean | null, lastUpdated?: any | null, systemRoles?: Array<EnumPeopleVisibleToSystemRoles | null> | null, isWhereaboutsUser?: boolean | null, isUserClaimed?: boolean | null, isUserInvited?: boolean | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, tags: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, unreadLeads?: Array<{ __typename?: 'UnreadLeadTC', leadId: string, date: any, type?: string | null } | null> | null, rightSideContent?: Array<{ __typename?: 'RightSideContentTC', entityId: string, text: string } | null> | null }> };

export type PerBusinessAnswersEnabledForOrganizationQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
}>;


export type PerBusinessAnswersEnabledForOrganizationQuery = { __typename?: 'Query', perBusinessAnswersEnabledForOrganization: boolean };

export type PersonCheckIfExistsByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  type: EnumOwnerType;
}>;


export type PersonCheckIfExistsByEmailQuery = { __typename?: 'Query', personCheckIfExistsByEmail: { __typename?: 'PersonCheckIfExistsByEmail', exists: boolean, existsInEntity: boolean, email: string, firstName?: string | null, lastName?: string | null, phone?: string | null, phoneExt?: string | null } };

export type PersonDetailsQueryVariables = Exact<{
  personId: Scalars['ID']['input'];
  entityId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<EnumOwnerType>;
}>;


export type PersonDetailsQuery = { __typename?: 'Query', personDetails?: { __typename?: 'DetailedPersonTC', _id: string, userId?: string | null, isUserClaimed?: boolean | null, isUserInvited?: boolean | null, emails?: Array<string | null> | null, scratchpad?: string | null, isOnDirectoryOperator?: boolean | null, personInfo?: { __typename?: 'DetailedPersonInfoTC', firstName: string, lastName: string, email: string, isUserClaimed?: boolean | null, isUserInvited?: boolean | null, phone?: string | null, phoneExt?: string | null, fax?: string | null, faxExt?: string | null, pronouns?: string | null, primaryTitle?: string | null, birthday?: string | null, contactMethod?: EnumPeopleContactMethod | null, optInEmail?: boolean | null, optInPhone?: boolean | null, optInSMS?: boolean | null, optInFax?: boolean | null, systemRoles?: Array<EnumPeopleVisibleToSystemRoles | null> | null, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, mailingAddress?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, tags: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> } | null, orders?: Array<{ __typename?: 'PersonDetailsSectionTC', _id: string, dateISO: string, dateStartISO?: string | null, dateEndISO?: string | null, type?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, operators?: Array<{ __typename?: 'OperatorDetailsTC', _entityId: string, roleType?: string | null, title?: string | null, contactRoles?: Array<ContactRole | null> | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, organizations?: Array<{ __typename?: 'OperatorOrganizationDetailsTC', _id: string, logo?: string | null, title?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null } | null> | null, organizations?: Array<{ __typename?: 'OrganizationDetailsTC', _id: string, logo?: string | null, roleType?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, adminOrganizations?: Array<{ __typename?: 'OrganizationDetailsTC', _id: string, logo?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, leads?: Array<{ __typename?: 'PersonDetailsSectionTC', _id: string, dateISO: string, status?: string | null, type?: string | null, name?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null, phones?: Array<{ __typename?: 'PersonMetadataPhone', phone?: string | null, ext?: string | null, type?: string | null } | null> | null } | null };

export type PersonFindOneNameQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOnePeopleInput>;
}>;


export type PersonFindOneNameQuery = { __typename?: 'Query', personFindOne?: { __typename?: 'People', _id: any, firstName: string, lastName: string, email: string, phone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, photo?: { __typename?: 'AssetImage', _id: string } | null } | null };

export type PersonNextOrderQueryVariables = Exact<{
  personId: Scalars['ID']['input'];
  entityId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<EnumEntityReferenceType>;
}>;


export type PersonNextOrderQuery = { __typename?: 'Query', personNextOrder?: { __typename?: 'Order', _id: string, purchasedProducts: Array<{ __typename?: 'PurchasedProduct', _id: any, inventoryClaims: Array<{ __typename?: 'PurchasedProductInventoryClaims', _id?: any | null, claimedDateRangeISO?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null } | null>, product: { __typename?: 'Product', _id: any, type: EnumProductType, isUpsellOnly: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } } | null> } | null };

export type PersonNextPaymentQueryVariables = Exact<{
  personId: Scalars['ID']['input'];
  entityId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<EnumEntityReferenceType>;
}>;


export type PersonNextPaymentQuery = { __typename?: 'Query', personNextPayment?: { __typename?: 'ScheduledPayment', _id: any, amount: number, dueDate: string, order: string, status: EnumScheduledPaymentStatus, type: EnumScheduledPaymentType } | null };

export type PlaceByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type PlaceByIdQuery = { __typename?: 'Query', placeById?: { __typename?: 'Place', _id: any, type: EnumPlaceType, parentPlace?: any | null, connectedListing?: any | null, connectedDmoListing?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, name: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null }, subPlaces: Array<{ __typename?: 'Place', _id: any, type: EnumPlaceType, name: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } }>, outline?: { __typename?: 'PlaceOutline', type: EnumPlaceOutlineType, coordinates: any } | null, outlineSimplified?: { __typename?: 'PlaceOutline', type: EnumPlaceOutlineType, coordinates: any } | null } | null };

export type PlaceManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPlaceInput>;
  sort?: InputMaybe<SortFindManyPlaceInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PlaceManyQuery = { __typename?: 'Query', placeMany: Array<{ __typename?: 'Place', _id: any, type: EnumPlaceType, connectedListing?: any | null, connectedDmoListing?: any | null, createdDateISO?: any | null, updatedDateISO?: any | null, name: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null }, subPlaces: Array<{ __typename?: 'Place', _id: any, type: EnumPlaceType, name: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } }>, outlineSimplified?: { __typename?: 'PlaceOutline', type: EnumPlaceOutlineType, coordinates: any } | null }> };

export type PlaceTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type PlaceTreeQuery = { __typename?: 'Query', placeTree: Array<{ __typename?: 'Place', _id: any, type: EnumPlaceType, parentPlace?: any | null, name: { __typename?: 'Multilingual', en?: string | null }, subPlaces: Array<{ __typename?: 'Place', _id: any }> } | null> };

export type PlacesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type PlacesCountQuery = { __typename?: 'Query', placesCount?: number | null };

export type PolicyManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPolicyInput>;
}>;


export type PolicyManyQuery = { __typename?: 'Query', policyMany: Array<{ __typename?: 'Policy', _id: any, isActive: boolean, storefront: any, content: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type PostHogEventAndOperatorWidgetStatsByOrganizationQueryVariables = Exact<{
  timestampRange: DateInput;
  organizationId: Scalars['ID']['input'];
}>;


export type PostHogEventAndOperatorWidgetStatsByOrganizationQuery = { __typename?: 'Query', postHogEventAndOperatorWidgetStatsByOrganization: { __typename?: 'PostHogEventAndOperatorWidgetStats', events?: { __typename?: 'PostHogSimpleStats', impressions?: number | null, outboundClicks?: number | null, views?: number | null } | null, operators?: { __typename?: 'PostHogSimpleStats', impressions?: number | null, outboundClicks?: number | null, views?: number | null } | null } };

export type PostHogStatsTripperAggregateQueryVariables = Exact<{
  timestampRange: DateInput;
  organizationId: Scalars['ID']['input'];
  itineraryId?: InputMaybe<Scalars['ID']['input']>;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PostHogStatsTripperAggregateQuery = { __typename?: 'Query', postHogStatsTripperAggregate: { __typename?: 'PostHogTripperAggregateStats', views: number, engagements: number, referrals: number, pdfDownloads: number } };

export type PostHogStatsTripperOperatorsQueryVariables = Exact<{
  timestampRange: DateInput;
  appContext: PostHogAppContext;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  itineraryId?: InputMaybe<Scalars['ID']['input']>;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PostHogStatsTripperOperatorsQuery = { __typename?: 'Query', postHogStatsTripperOperators: Array<{ __typename?: 'PostHogTripperStats', views?: number | null, clicks?: number | null, referrals?: number | null, metadata?: { __typename?: 'PostHogMetadataForTripperStats', operator: { __typename?: 'OperatorWithStatus', _entityId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } } | null }> };

export type PostHogStatsTripperTimeSeriesQueryVariables = Exact<{
  timestampRange: DateInput;
  organizationId: Scalars['ID']['input'];
  itineraryId?: InputMaybe<Scalars['ID']['input']>;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PostHogStatsTripperTimeSeriesQuery = { __typename?: 'Query', postHogStatsTripperTimeSeries: Array<{ __typename?: 'PostHogTripperTimeSeriesPoint', date: any, views: number, engagements: number, referrals: number, pdfDownloads: number }> };

export type PostHogStatsWidgetEventsQueryVariables = Exact<{
  timestampRange: DateInput;
  appContext: PostHogAppContext;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PostHogStatsWidgetEventsQuery = { __typename?: 'Query', postHogStatsWidgetEvents: Array<{ __typename?: 'PostHogEventStats', impressions?: number | null, outboundClicks?: number | null, views?: number | null, metadata?: { __typename?: 'PostHogMetadataForEventStats', event?: { __typename?: 'Event', _id: any, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null }> };

export type PostHogStatsWidgetOperatorsQueryVariables = Exact<{
  timestampRange: DateInput;
  appContext: PostHogAppContext;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  listId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PostHogStatsWidgetOperatorsQuery = { __typename?: 'Query', postHogStatsWidgetOperators: Array<{ __typename?: 'PostHogOperatorStats', impressions?: number | null, outboundClicks?: number | null, views?: number | null, metadata?: { __typename?: 'PostHogMetadataForOperatorStats', operator?: { __typename?: 'OperatorWithStatus', _entityId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null }> };

export type ProductCalendarLinkByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductCalendarLinkByIdQuery = { __typename?: 'Query', productCalendarLinkById: string };

export type ProductClosureByIdQueryVariables = Exact<{
  closureId: Scalars['ID']['input'];
}>;


export type ProductClosureByIdQuery = { __typename?: 'Query', productClosureById?: { __typename?: 'ClosureData', productIds: Array<string>, closure: { __typename?: 'Closure', _id?: any | null, name: string, dateRangeISO: { __typename?: 'DateRangeISO', _id: any, end: string, start: string, metadata?: string | null } } } | null };

export type ProductInBookersQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  notInBookerId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProductInBookersQuery = { __typename?: 'Query', productInBookers?: Array<{ __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null> | null };

export type ProductManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyProductInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductManyQuery = { __typename?: 'Query', productMany: Array<{ __typename?: 'Product', _id: any, storefront: any, updatedDateISO?: any | null, createdDateISO?: any | null, type: EnumProductType, publicationStatus: EnumProductPublicationStatus, externalBookingUrl?: string | null, isUpsellOnly: boolean, isActive: boolean, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags: Array<{ __typename?: 'Tag', entityTypes: Array<EnumTagEntityTypes | null>, _id: any, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rules: Array<{ __typename?: 'Rule', type: EnumRuleType, value: any, isActive: boolean, storefront: any, _id: any, activePeriod?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null }>, pricing?: { __typename?: 'Pricing', description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tiers: Array<{ __typename?: 'PriceTier', type: EnumGuestTierType, price: number, priceType: EnumPriceTierPriceType, guestCountForPrice?: number | null, discountAmount?: number | null, discountUnit?: EnumPriceTierDiscountUnit | null, _id: any, label?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> } | null, quantitySettings?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, contact?: { __typename?: 'ProductContact', useOwnerContact: boolean, email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null } | null, addOnSettings?: { __typename?: 'ProductAddOnSettings', businessScope?: EnumProductAddOnSettingsBusinessScope | null, pricingScope?: EnumProductAddOnSettingsPricingScope | null } | null, customFields?: Array<{ __typename?: 'ProductCustomFields', _id?: any | null, type: EnumProductCustomFieldsType, required: boolean, chargePerChoice?: boolean | null, maxChoices?: number | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options?: Array<{ __typename?: 'ProductCustomFieldsOptions', _id?: any | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null, renewableFeeMetadata?: { __typename?: 'RenewableFeeMetadata', billingIntervalMonths: number, renewalType?: EnumRenewableFeeMetadataRenewalType | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, proRateEnabled?: boolean | null, earlyPurchaseWindowDays?: number | null, membershipLinked?: boolean | null } | null, merchMetadata?: { __typename?: 'MerchMetadata', lowStockThreshold?: number | null, dimensions?: Array<{ __typename?: 'MerchMetadataDimensions', _id?: any | null, drivesImages?: boolean | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, values?: Array<{ __typename?: 'MerchMetadataDimensionsValues', _id?: any | null, imageIds?: Array<string | null> | null, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> | null } | null> | null, variants?: Array<{ __typename?: 'MerchMetadataVariants', _id?: any | null, dimensionValueIds?: Array<string | null> | null, label?: string | null, price: number, sku?: string | null, inventoryCount: number, isActive?: boolean | null } | null> | null } | null, sellingConfig?: { __typename?: 'ProductSellingConfig', mode: string, basePrice?: number | null, dynamicFeeSurvey?: any | null, options?: Array<{ __typename?: 'ProductTier', _id?: any | null, price: number, order: number, autoTag?: any | null, sessionScope?: EnumProductTierSessionScope | null, includedSessionIds?: Array<string | null> | null, minSessions?: number | null, maxSessions?: number | null, subCapacityPerSession?: number | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, tagConfig?: { __typename?: 'ProductTierTagConfig', onCheckoutCompleted?: Array<any | null> | null, onRenewalSuccess?: Array<any | null> | null, onRenewalPending?: Array<any | null> | null, onExpiration?: Array<any | null> | null, onCancellation?: Array<any | null> | null, onPaymentFailed?: Array<any | null> | null } | null, personTagConfig?: { __typename?: 'ProductTierTagConfig', onCheckoutCompleted?: Array<any | null> | null, onRenewalSuccess?: Array<any | null> | null, onRenewalPending?: Array<any | null> | null, onExpiration?: Array<any | null> | null, onCancellation?: Array<any | null> | null, onPaymentFailed?: Array<any | null> | null } | null, inventory?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, condition?: { __typename?: 'ProductTierCondition', operator: EnumProductTierConditionOperator, clauses?: Array<{ __typename?: 'ProductTierConditionClauses', questionId: string, comparator: EnumProductTierConditionClausesComparator, value: string } | null> | null } | null } | null> | null, inventory?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null, recurring?: { __typename?: 'ProductSellingConfigRecurring', enabled?: boolean | null, billingIntervalMonths?: number | null, renewalType?: EnumProductSellingConfigRecurringRenewalType | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, proRateEnabled?: boolean | null, earlyPurchaseWindowDays?: number | null, membershipLinked?: boolean | null, multiListing?: { __typename?: 'ProductSellingConfigRecurringMultiListing', mode?: EnumProductSellingConfigRecurringMultiListingMode | null, maxListings?: number | null, autoIncludeOwnedListings?: boolean | null, additionalBusinessDiscount?: { __typename?: 'ProductSellingConfigRecurringMultiListingAdditionalBusinessDiscount', unit: EnumProductSellingConfigRecurringMultiListingAdditionalBusinessDiscountUnit, amount: number } | null } | null } | null } | null, productTiers?: Array<{ __typename?: 'ProductTier', _id?: any | null, price: number, order: number, autoTag?: any | null, sessionScope?: EnumProductTierSessionScope | null, includedSessionIds?: Array<string | null> | null, minSessions?: number | null, maxSessions?: number | null, subCapacityPerSession?: number | null, isActive?: boolean | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, quantity?: { __typename?: 'ProductTierQuantity', enabled?: boolean | null, maxQuantity?: number | null } | null } | null> | null, eventMetadata?: { __typename?: 'ProductEventMetadata', event: any, ticketStructure: EnumProductEventMetadataTicketStructure, sessionGranularity: EnumProductEventMetadataSessionGranularity, sellingType?: EnumProductEventMetadataSellingType | null, maxTicketsPerPurchase?: number | null, includedSessionIds?: Array<string | null> | null } | null, inventorySettings?: { __typename?: 'ProductTierInventory', enabled?: boolean | null, totalCount: number, currentCount: number } | null, accommodationMetadata?: { __typename?: 'AccommodationProductMetadata', checkIn?: string | null, checkOut?: string | null, calendarLinks?: Array<string | null> | null, guestMetadata?: { __typename?: 'GuestMetadata', minimumNumber?: number | null, maximumNumber?: number | null, nameEntryAllowed: boolean, nameEntryRequired: boolean } | null, amenities: Array<{ __typename?: 'Tag', entityTypes: Array<EnumTagEntityTypes | null>, _id: any, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, rooms: Array<{ __typename?: 'Room', _id?: any | null, type: EnumRoomType, amenities?: Array<any | null> | null } | null>, closures: Array<{ __typename?: 'Closure', _id?: any | null, name: string, dateRangeISO: { __typename?: 'DateRangeISO', _id: any, end: string, metadata?: string | null, start: string } } | null> } | null }> };

export type PromotionByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type PromotionByIdQuery = { __typename?: 'Query', promotionById?: { __typename?: 'Promotion', _id: any, link?: string | null, firstDate: string, lastDate: string, createdByEmail: string, createdByFirstName?: string | null, createdByLastName?: string | null, createdBy?: any | null, createdByPerson?: any | null, submitterPersonId?: any | null, submissionSource?: EnumPromotionSubmissionSource | null, createdDateISO?: any | null, updatedDateISO?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, availability: { __typename?: 'PromotionAvailability', type: EnumPromotionAvailabilityType, dates?: Array<string | null> | null, startDate?: string | null, endDate?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags?: { __typename?: 'PromotionTags', organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> } | null, access: { __typename?: 'PromotionAccess', operator: { __typename?: 'PromotionAccessOperator', _entityId: any, status?: EnumPromotionAccessOperatorStatus | null }, organizations: Array<{ __typename?: 'PromotionAccessOperator', _entityId: any, status?: EnumPromotionAccessOperatorStatus | null } | null> }, history: Array<{ __typename?: 'PromotionHistory', action: EnumPromotionHistoryAction, timestamp: any, sourceType?: EnumPromotionHistorySourceType | null, userId?: any | null, userEmail?: string | null, userName?: string | null, organizationId?: any | null, note?: string | null } | null>, listing?: { __typename?: 'OperatorWithStatus', _entityId: any, operationalStatus: EnumOperatorOperationalStatus, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null } | null };

export type PromotionEligibleOrganizationsQueryVariables = Exact<{
  operatorEntityId: Scalars['ID']['input'];
}>;


export type PromotionEligibleOrganizationsQuery = { __typename?: 'Query', promotionEligibleOrganizations: Array<{ __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type PromotionManyQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  operatorId?: InputMaybe<Scalars['ID']['input']>;
  operatorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  status?: InputMaybe<EnumPromotionAccessOperatorStatus>;
  timeframe?: InputMaybe<PromotionTimeframe>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PromotionManyQuery = { __typename?: 'Query', promotionMany: Array<{ __typename?: 'Promotion', _id: any, link?: string | null, firstDate: string, lastDate: string, createdByEmail: string, createdByFirstName?: string | null, createdByLastName?: string | null, createdBy?: any | null, createdByPerson?: any | null, submitterPersonId?: any | null, submissionSource?: EnumPromotionSubmissionSource | null, createdDateISO?: any | null, updatedDateISO?: any | null, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, availability: { __typename?: 'PromotionAvailability', type: EnumPromotionAvailabilityType, dates?: Array<string | null> | null, startDate?: string | null, endDate?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags?: { __typename?: 'PromotionTags', organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> } | null, access: { __typename?: 'PromotionAccess', operator: { __typename?: 'PromotionAccessOperator', _entityId: any, status?: EnumPromotionAccessOperatorStatus | null }, organizations: Array<{ __typename?: 'PromotionAccessOperator', _entityId: any, status?: EnumPromotionAccessOperatorStatus | null } | null> }, history: Array<{ __typename?: 'PromotionHistory', action: EnumPromotionHistoryAction, timestamp: any, sourceType?: EnumPromotionHistorySourceType | null, userId?: any | null, userEmail?: string | null, userName?: string | null, organizationId?: any | null, note?: string | null } | null>, listing?: { __typename?: 'OperatorWithStatus', _entityId: any, operationalStatus: EnumOperatorOperationalStatus, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> };

export type PromotionManyPromotionsWidgetQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PromotionManyPromotionsWidgetQuery = { __typename?: 'Query', promotionMany: Array<{ __typename?: 'Promotion', _id: any, link?: string | null, firstDate: string, lastDate: string, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, availability: { __typename?: 'PromotionAvailability', type: EnumPromotionAvailabilityType, dates?: Array<string | null> | null, startDate?: string | null, endDate?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, tags?: { __typename?: 'PromotionTags', organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> } | null, access: { __typename?: 'PromotionAccess', operator: { __typename?: 'PromotionAccessOperator', _entityId: any } }, listing?: { __typename?: 'OperatorWithStatus', _entityId: any, _versionId: any, type: EnumOperatorType, operationalStatus: EnumOperatorOperationalStatus, status?: PublicationStatusType | null, pricing?: EnumOperatorPricing | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, contact: { __typename?: 'Contact', email?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null }, hoursOfOperation?: { __typename?: 'OperatorHoursOfOperation', sun?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null, mon?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null, tue?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null, wed?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null, thu?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null, fri?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null, sat?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string, metadata?: string | null } | null } | null } | null }> };

export type PromotionManyWidgetQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  operatorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PromotionManyWidgetQuery = { __typename?: 'Query', promotionMany: Array<{ __typename?: 'Promotion', _id: any, link?: string | null, firstDate: string, lastDate: string, title: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, availability: { __typename?: 'PromotionAvailability', type: EnumPromotionAvailabilityType, dates?: Array<string | null> | null, startDate?: string | null, endDate?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, access: { __typename?: 'PromotionAccess', operator: { __typename?: 'PromotionAccessOperator', _entityId: any } } }> };

export type PublicMediaCountQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  needsAttentionOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PublicMediaCountQuery = { __typename?: 'Query', publicMediaCount: number };

export type PublicMediaForGalleryWidgetQueryVariables = Exact<{
  widgetId: Scalars['MongoID']['input'];
  organizationId: Scalars['MongoID']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PublicMediaForGalleryWidgetQuery = { __typename?: 'Query', publicMediaForGalleryWidget?: Array<{ __typename?: 'PublicMedia', _id: any, mediaType: EnumPublicMediaMediaType, asset?: string | null, width?: number | null, height?: number | null, posterUrl?: string | null, carouselThumbnailAsset?: string | null, useCarouselThumbnail: boolean, blurhash?: string | null, ctaLink?: string | null, copyright?: string | null, likeCount: number, relatedListings: Array<any | null>, relatedListingNames: Array<string>, headline?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, caption?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, mux?: { __typename?: 'PublicMediaMux', assetId: string, playbackId: string } | null }> | null };

export type PublicMediaManyQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  needsAttentionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  mediaTagIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  usedInWidget?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PublicMediaManyQuery = { __typename?: 'Query', publicMediaMany?: Array<{ __typename?: 'PublicMedia', _id: any, mediaType: EnumPublicMediaMediaType, status: EnumPublicMediaStatus, asset?: string | null, width?: number | null, height?: number | null, posterUrl?: string | null, carouselThumbnailAsset?: string | null, useCarouselThumbnail: boolean, blurhash?: string | null, ctaLink?: string | null, copyright?: string | null, mediaTags: Array<any | null>, relatedListings: Array<any | null>, likeCount: number, createdDateISO?: any | null, stats?: { __typename?: 'PublicMediaStats', views?: number | null, shares?: number | null, ctaClicks?: number | null } | null, headline?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, caption?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, mux?: { __typename?: 'PublicMediaMux', assetId: string, playbackId: string } | null, source: { __typename?: 'PublicMediaSource', kind: EnumPublicMediaSourceKind, listingId?: any | null, originalAssetId?: string | null }, attention?: { __typename?: 'PublicMediaAttention', ignoredAt?: any | null, issues?: Array<{ __typename?: 'PublicMediaAttentionIssues', flag: EnumPublicMediaAttentionIssuesFlag, listingId?: any | null, listingName?: string | null, flaggedAt: any } | null> | null } | null }> | null };

export type PublicMediaProfileByIdQueryVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type PublicMediaProfileByIdQuery = { __typename?: 'Query', publicMediaById?: { __typename?: 'PublicMedia', _id: any, mediaType: EnumPublicMediaMediaType, status: EnumPublicMediaStatus, asset?: string | null, width?: number | null, height?: number | null, posterUrl?: string | null, blurhash?: string | null, ctaLink?: string | null, copyright?: string | null, likeCount: number, relatedListings: Array<any | null>, relatedListingNames: Array<string>, headline?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, caption?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, mux?: { __typename?: 'PublicMediaMux', assetId: string, playbackId: string } | null } | null };

export type RefundManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyRefundInput>;
}>;


export type RefundManyQuery = { __typename?: 'Query', refundMany: Array<{ __typename?: 'Refund', _id: string, amount: number, orderId: string, status: EnumRefundStatus, createdDateISO?: any | null, updatedDateISO?: any | null }> };

export type RefundsByOrderIdsQueryVariables = Exact<{
  orderIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RefundsByOrderIdsQuery = { __typename?: 'Query', refundsByOrderIds?: Array<{ __typename?: 'Refund', _id: string, amount: number, orderId: string, status: EnumRefundStatus, createdDateISO?: any | null, updatedDateISO?: any | null }> | null };

export type RenewableFeeCoveredOperatorsQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
  operatorIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  customerEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenewableFeeCoveredOperatorsQuery = { __typename?: 'Query', renewableFeeCoveredOperators?: Array<{ __typename?: 'RenewableFeeCoveredOperator', operatorId: any, coveredByYou: boolean, currentPeriodEnd?: string | null }> | null };

export type RenewableFeeEarlyRenewalsQueryVariables = Exact<{
  bookerId: Scalars['MongoID']['input'];
  productId: Scalars['MongoID']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  tierId?: InputMaybe<Scalars['String']['input']>;
  operatorIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenewableFeeEarlyRenewalsQuery = { __typename?: 'Query', renewableFeeEarlyRenewals?: Array<{ __typename?: 'RenewableFeeEarlyRenewal', operatorId?: any | null, renewsOn: string, renewalOpensOn: string }> | null };

export type RenewableFeeQuoteQueryVariables = Exact<{
  bookerId: Scalars['MongoID']['input'];
  productId: Scalars['MongoID']['input'];
  tierId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['MongoID']['input'];
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  operatorId?: InputMaybe<Scalars['MongoID']['input']>;
  operatorIds?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
}>;


export type RenewableFeeQuoteQuery = { __typename?: 'Query', renewableFeeQuote?: { __typename?: 'RenewableFeeQuote', fullAmount: number, chargeAmount: number, pricingKind: string, periodEnd: string, bonusDays: number, freeDaysUntil?: string | null, tierAmount: number, additionalBusinessSavings: number, listingLines: Array<{ __typename?: 'RenewableFeeQuoteListingLine', index: number, fullPrice: number, amount: number } | null> } | null };

export type RenewablePurchaseByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RenewablePurchaseByIdQuery = { __typename?: 'Query', renewablePurchaseById?: { __typename?: 'RenewablePurchase', _id: any, status: EnumRenewablePurchaseStatus, renewalBilling?: EnumRenewablePurchaseRenewalBilling | null, billingIntervalMonths: number, renewalType?: string | null, fixedRenewalMonth?: number | null, fixedRenewalDay?: number | null, proRateEnabled?: boolean | null, currentPeriodStart: string, currentPeriodEnd: string, cancelledAt?: string | null, retryCount: number, originalChargeAmount?: number | null, originalOrder: string, renewalOrders: Array<string | null>, createdDateISO?: any | null, selectedTier?: { __typename?: 'RenewablePurchaseSelectedTier', tierId: string, price: number, tierName: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } } | null, appliedDiscount?: { __typename?: 'RenewablePurchaseAppliedDiscount', discountId: string, promoCode?: string | null, name?: string | null, unit: string, amount: number, discountAmount: number, isOngoing?: boolean | null } | null, pendingTierChange?: { __typename?: 'RenewablePurchaseSelectedTier', tierId: string, price: number, tierName: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } } | null } | null };

export type RenewablePurchaseByIdPublicQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type RenewablePurchaseByIdPublicQuery = { __typename?: 'Query', renewablePurchaseByIdPublic?: { __typename?: 'PublicRenewablePurchase', _id: any, status: string, billingIntervalMonths: number, currentPeriodStart: string, currentPeriodEnd: string, cancelledAt?: string | null, retryCount: number, originalChargeAmount?: number | null, originalOrder: string, renewalOrders: Array<string>, createdDateISO?: string | null, selectedTier?: { __typename?: 'PublicRenewablePurchaseSelectedTier', tierId: string, price: number, tierName?: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } | null } | null, appliedDiscount?: { __typename?: 'PublicRenewablePurchaseAppliedDiscount', name?: string | null, promoCode?: string | null, discountAmount?: number | null } | null } | null };

export type RenewalEngineSetupPreviewQueryVariables = Exact<{
  organizationId: Scalars['MongoID']['input'];
}>;


export type RenewalEngineSetupPreviewQuery = { __typename?: 'Query', renewalEngineSetupPreview: { __typename?: 'RenewalEngineSetupPreview', engineOwned: boolean, membersChanging: number, detected: Array<{ __typename?: 'RenewalEngineDetectedRole', role: string, tagId?: string | null, tagName?: string | null, source: string }>, byRole: Array<{ __typename?: 'RenewalEngineRoleCount', role: string, count: number }> } };

export type RenewalRecordsByPurchaseQueryVariables = Exact<{
  renewablePurchaseId: Scalars['MongoID']['input'];
}>;


export type RenewalRecordsByPurchaseQuery = { __typename?: 'Query', renewalRecordsByPurchase?: Array<{ __typename?: 'RenewalRecord', _id: any, status: EnumRenewalRecordStatus, amount: number, tierPrice?: number | null, currency: string, periodStart: string, periodEnd: string, order?: string | null, paymentRequest?: any | null, failureReason?: string | null, stripePaymentIntentId?: string | null, appliedDiscount?: { __typename?: 'PaymentRequestAppliedDiscount', discountId: string, name?: string | null, promoCode?: string | null, unit: string, amount: number, discountAmount: number, isOngoing?: boolean | null } | null } | null> | null };

export type RenewalRecordsByPurchasePublicQueryVariables = Exact<{
  renewablePurchaseId: Scalars['MongoID']['input'];
}>;


export type RenewalRecordsByPurchasePublicQuery = { __typename?: 'Query', renewalRecordsByPurchasePublic?: Array<{ __typename?: 'PublicRenewalRecord', _id: any, status: string, amount: number, currency: string, periodStart: string, periodEnd: string, order?: string | null } | null> | null };

export type ReportByStorefrontQueryVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  reportType: Scalars['String']['input'];
}>;


export type ReportByStorefrontQuery = { __typename?: 'Query', reportByStorefront: { __typename?: 'ReportResult', builtAt?: any | null, timezone: string, timezoneSource: string, builtTimezone?: string | null, columns: Array<{ __typename?: 'ReportColumn', title: string, field: string }>, rows: Array<{ __typename?: 'ReportRow', _id: string, searchText: string, rowDateISO?: string | null, cells: Array<{ __typename?: 'ReportCell', field: string, value: string }> }> } };

export type ReportDatasetFieldsQueryVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  dataset: Scalars['String']['input'];
}>;


export type ReportDatasetFieldsQuery = { __typename?: 'Query', reportDatasetFields: { __typename?: 'ReportDatasetFields', baseColumns: Array<string>, timezone: string, timezoneSource: string, builtAt?: any | null, lastStripeSyncAt?: any | null, fields: Array<{ __typename?: 'ReportField', key: string, title: string, type: string, category: string, isBase: boolean, operators: Array<string>, enumValues: Array<{ __typename?: 'ReportEnumOption', value: string, label: string }> }> } };

export type ReportFieldValuesQueryVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  dataset: Scalars['String']['input'];
  field: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReportFieldValuesQuery = { __typename?: 'Query', reportFieldValues: Array<string> };

export type ReportRunQueryVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  savedReportId?: InputMaybe<Scalars['MongoID']['input']>;
  definition?: InputMaybe<ReportDefinitionInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReportRunQuery = { __typename?: 'Query', reportRun: { __typename?: 'ReportRunResult', builtAt?: any | null, hasBuilt: boolean, timezone: string, timezoneSource: string, builtTimezone?: string | null, missingFields: Array<string>, rowCount: number, columns: Array<{ __typename?: 'ReportRunColumn', field: string, title: string, type: string }>, rows: Array<{ __typename?: 'ReportRunRow', _id: string, groupKey?: string | null, cells: Array<{ __typename?: 'ReportCell', field: string, value: string }> }>, groups: Array<{ __typename?: 'ReportRunGroup', key: string, label: string, count: number, totals: Array<{ __typename?: 'ReportTotalsEntry', currency?: string | null, count: number, values: Array<{ __typename?: 'ReportCell', field: string, value: string }> }> }>, totals: Array<{ __typename?: 'ReportTotalsEntry', currency?: string | null, count: number, values: Array<{ __typename?: 'ReportCell', field: string, value: string }> }>, resolvedConditions: Array<{ __typename?: 'ReportResolvedCondition', field: string, title: string, type: string, op: string, values: Array<string>, valueLabels: Array<string>, rangeStart?: string | null, rangeEnd?: string | null }> } };

export type SavedReportsByStorefrontQueryVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
}>;


export type SavedReportsByStorefrontQuery = { __typename?: 'Query', savedReportsByStorefront: Array<{ __typename?: 'SavedReport', _id: any, storefront: any, name: string, dataset: string, columns: Array<string>, match: string, groupBy?: string | null, groupByGranularity?: string | null, updatedDateISO?: any | null, conditions: Array<{ __typename?: 'ReportCondition', field: string, op: string, values: Array<string> }>, sort?: { __typename?: 'ReportSort', field: string, direction: string } | null }> };

export type SavedReportFieldsFragment = { __typename?: 'SavedReport', _id: any, storefront: any, name: string, dataset: string, columns: Array<string>, match: string, groupBy?: string | null, groupByGranularity?: string | null, updatedDateISO?: any | null, conditions: Array<{ __typename?: 'ReportCondition', field: string, op: string, values: Array<string> }>, sort?: { __typename?: 'ReportSort', field: string, direction: string } | null };

export type ScheduledPaymentFindOneQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneScheduledPaymentInput>;
}>;


export type ScheduledPaymentFindOneQuery = { __typename?: 'Query', scheduledPaymentFindOne?: { __typename?: 'ScheduledPayment', _id: any, amount: number, dueDate: string, order: string, status: EnumScheduledPaymentStatus, type: EnumScheduledPaymentType, stripeMetadata?: { __typename?: 'StripeMetadata', connectedAccountId?: string | null } | null } | null };

export type ScheduledPaymentFindManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyScheduledPaymentInput>;
}>;


export type ScheduledPaymentFindManyQuery = { __typename?: 'Query', scheduledPaymentFindMany: Array<{ __typename?: 'ScheduledPayment', _id: any, amount: number, dueDate: string, order: string, status: EnumScheduledPaymentStatus, type: EnumScheduledPaymentType, stripeMetadata?: { __typename?: 'StripeMetadata', connectedAccountId?: string | null } | null }> };

export type StatsSnapshotsByOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type StatsSnapshotsByOrganizationQuery = { __typename?: 'Query', statsSnapshotsByOrganization?: Array<{ __typename?: 'StatsSnapshot', _id: any, periodKey: string, capturedAt: any, account: { __typename?: 'StatsSnapshotAccount', operators: number, people: number, notes: number, events: number }, widget: { __typename?: 'StatsSnapshotWidget', operatorViews: number, operatorClicks: number, eventImpressions: number, eventClicks: number, tripperViews: number, tripperEngagements: number, tripperReferrals: number, tripperPdfDownloads: number }, broadcast: { __typename?: 'StatsSnapshotBroadcast', completions: number, messageViews: number, videoViews: number, photoViews: number, pdfDownloads: number }, membership: { __typename?: 'StatsSnapshotMembership', total: number, byTier?: Array<{ __typename?: 'StatsSnapshotMembershipTagCount', tagId: string, name: string, count: number }> | null, byStatus?: Array<{ __typename?: 'StatsSnapshotMembershipTagCount', tagId: string, name: string, count: number }> | null } }> | null };

export type StorefrontByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type StorefrontByIdQuery = { __typename?: 'Query', storefrontById?: { __typename?: 'Storefront', _id: any, organization?: any | null, connectedAccountIds: Array<string | null>, testMode: boolean, stripeRegion: EnumStorefrontStripeRegion, testStorefront?: any | null, liveStorefront?: any | null, isPaired: boolean, isLaunched: boolean, launchedAt?: any | null, paymentsMode: EnumStorefrontPaymentsMode, accountingCodes: Array<string | null>, customProductNames: Array<string | null>, defaultInvoicePolicy?: any | null, connectedListings: Array<string | null>, lowStockDigestEnabled: boolean, invoicingEnabled: boolean, timezone?: string | null, defaultWidgetLogo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, name: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null }, enabledFeeTypes?: { __typename?: 'StorefrontEnabledFeeTypes', accommodations?: boolean | null, oneTimeFee?: boolean | null, renewableFees?: boolean | null, events?: boolean | null, merch?: boolean | null } | null, statementSettings?: { __typename?: 'StorefrontStatementSettings', dayOfMonth?: number | null } | null, resolvedTimezone: { __typename?: 'StorefrontResolvedTimezone', timezone: string, source: string }, emailBranding?: { __typename?: 'StorefrontEmailBranding', fromName?: string | null, replyTo?: string | null, accentColor?: string | null, showContact?: boolean | null, useOrganizationEmailSettings?: boolean | null, footerText?: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } | null, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } | null } | null };

export type StorefrontCalendarFeedQueryVariables = Exact<{
  storefrontId: Scalars['ID']['input'];
  kind: StorefrontCalendarKind;
  rangeStart: Scalars['String']['input'];
  rangeEnd: Scalars['String']['input'];
  summaryYear: Scalars['Int']['input'];
}>;


export type StorefrontCalendarFeedQuery = { __typename?: 'Query', storefrontCalendarFeed?: { __typename?: 'StorefrontCalendarFeed', availableYears?: Array<number> | null, accommodationRows?: Array<{ __typename?: 'StorefrontCalendarAccommodationRow', orderId: string, cancelled: boolean, approvalStatus?: string | null, customerName: string, productId: string, startDate: string, endDate: string, guests: number, productName?: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } | null } | null> | null, eventSales?: Array<{ __typename?: 'EventCalendarSessionSale', eventId: string, eventName: string, productId: string, sessionId: string, sessionDate: string, timeSlotLabel?: string | null, totalSold: number, passesSold: number, ticketsSold: number, eventDateTotalSold: number, eventDatePassesSold: number, eventDateTicketsSold: number, eventDateArrivedCount: number, totalCapacity?: number | null, remainingCapacity?: number | null, isUnlimited: boolean, eventYearSessionCount?: number | null } | null> | null, products?: Array<{ __typename?: 'Product', _id: any, type: EnumProductType, name: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null }, accommodationMetadata?: { __typename?: 'AccommodationProductMetadata', closures: Array<{ __typename?: 'Closure', _id?: any | null, name: string, dateRangeISO: { __typename?: 'DateRangeISO', start: string, end: string } } | null> } | null } | null> | null, yearSummary?: { __typename?: 'StorefrontCalendarYearSummary', year: number, months?: Array<{ __typename?: 'StorefrontCalendarMonthAvailability', month: number, count: number, hasBookings: boolean, hasClosures: boolean } | null> | null } | null } | null };

export type StorefrontConnectedAccountsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StorefrontConnectedAccountsQuery = { __typename?: 'Query', storefrontConnectedAccounts: Array<{ __typename?: 'StripeAccountStatus', id: string, name: string, currency?: string | null, status: EnumStripeOnboardingStatus, canDelete: boolean }> };

export type StorefrontCountQueryVariables = Exact<{
  filter?: InputMaybe<FilterCountStorefrontInput>;
}>;


export type StorefrontCountQuery = { __typename?: 'Query', storefrontCount?: number | null };

export type StorefrontInventoryQueryVariables = Exact<{
  storefrontId: Scalars['ID']['input'];
}>;


export type StorefrontInventoryQuery = { __typename?: 'Query', storefrontInventory: Array<{ __typename?: 'StorefrontInventoryRow', id: string, productId: string, productName: string, productType: string, variantId?: string | null, variantLabel?: string | null, sku?: string | null, remaining?: number | null, total?: number | null, maxCapacity?: number | null, sold: number, threshold: number, status: string, isActive: boolean, lastSoldAt?: string | null }> };

export type StorefrontInventoryLogQueryVariables = Exact<{
  storefrontId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type StorefrontInventoryLogQuery = { __typename?: 'Query', storefrontInventoryLog: Array<{ __typename?: 'InventoryLogEntry', id: string, createdAt: string, productId: string, productName: string, productType: string, variantLabel?: string | null, type: string, reason?: string | null, change: number, previousCount?: number | null, newCount?: number | null, note?: string | null, orderId?: string | null, userName?: string | null }> };

export type StorefrontInvoiceHeaderQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type StorefrontInvoiceHeaderQuery = { __typename?: 'Query', storefrontById?: { __typename?: 'Storefront', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, siteMetadata?: { __typename?: 'StorefrontSiteMetadata', name: string, email?: string | null, phone?: string | null, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } | null, linkedOrganization?: { __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null, metadata?: { __typename?: 'OrganizationMetadata', connectedOperator?: any | null } | null } | null } | null };

export type StorefrontListingCandidatesQueryVariables = Exact<{
  storefrontId: Scalars['ID']['input'];
}>;


export type StorefrontListingCandidatesQuery = { __typename?: 'Query', storefrontListingCandidates: Array<{ __typename?: 'StorefrontListingCandidate', type: EnumOwnerType, entityId: string, isConnected: boolean, productCount: number, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null }> };

export type StorefrontManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyStorefrontInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type StorefrontManyQuery = { __typename?: 'Query', storefrontMany: Array<{ __typename?: 'Storefront', _id: any, testMode: boolean, invoicingEnabled: boolean, applicationPercentage: number, applicationFeeDefaults?: { __typename?: 'StorefrontApplicationFeeDefaults', membership?: number | null, merch?: number | null } | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, siteMetadata?: { __typename?: 'StorefrontSiteMetadata', name: string, slug: string, isActive?: boolean | null, logo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null } | null }> };

export type StorefrontOrderHasCompanyDataQueryVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  includeInvoices: Scalars['Boolean']['input'];
}>;


export type StorefrontOrderHasCompanyDataQuery = { __typename?: 'Query', storefrontOrderHasCompanyData: boolean };

export type StorefrontOrderInvoiceFeedQueryVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  filter: StorefrontOrderInvoiceFeedFilter;
  includeInvoices: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  createdStartDate?: InputMaybe<Scalars['String']['input']>;
  createdEndDate?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type StorefrontOrderInvoiceFeedQuery = { __typename?: 'Query', storefrontOrderInvoiceFeed: { __typename?: 'StorefrontOrderInvoiceFeed', forReviewCount: number, needsAttentionCount: number, approvalsPendingCount: number, pageInfo: { __typename?: 'StorefrontOrderInvoiceFeedPageInfo', currentPage: number, perPage: number, pageCount: number, itemCount: number, hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'StorefrontOrderInvoiceFeedRow', kind: StorefrontOrderInvoiceFeedKind, businessName?: string | null, order?: { __typename?: 'Order', _id: string, cancelled: boolean, testMode: boolean, createdDateISO?: any | null, approval?: { __typename?: 'OrderApproval', status: EnumOrderApprovalStatus, requestedAt: any, expiresAt?: any | null, messageFromGuest?: string | null, declineReason?: string | null } | null, billing?: { __typename?: 'OrderBilling', timing: EnumOrderBillingTiming, consolidation: EnumOrderBillingConsolidation, serviceEndAt?: any | null, statementPeriod?: string | null, invoicePaymentRequestId?: any | null } | null, fulfillment?: { __typename?: 'OrderFulfillment', status?: EnumOrderFulfillmentStatus | null, note?: string | null, fulfilledAt?: string | null, carrier?: string | null, trackingNumber?: string | null } | null, delivery?: { __typename?: 'OrderDelivery', method: EnumOrderDeliveryMethod } | null, purchasedProducts: Array<{ __typename?: 'PurchasedProduct', quantity: number, _id: any, product: { __typename?: 'Product', _id: any, type: EnumProductType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }, guestsPerTier: Array<{ __typename?: 'PurchasedProductGuestsPerTier', count: number, tierId: any } | null>, inventoryClaims: Array<{ __typename?: 'PurchasedProductInventoryClaims', _id?: any | null, claimedDateRangeISO?: { __typename?: 'DateRangeISO', _id: any, end: string, metadata?: string | null, start: string } | null } | null> } | null>, source: { __typename?: 'OrderSource', type?: EnumOrderSourceType | null, booker: any, storefront: any, renewablePurchaseId?: any | null, renewalRecordId?: any | null, renewalNextDate?: string | null, renewalStatus?: string | null }, customer?: { __typename?: 'SimplePersonTC', _id: string, firstName: string, lastName: string, email: string } | null, stripeMetadata: { __typename?: 'StripeMetadata', chargeId: string, invoiceId?: string | null, invoiceStatus?: EnumStripeMetadataInvoiceStatus | null, paymentMethodId: string }, paymentMetadata: { __typename?: 'OrderPaymentMetadata', depositSettings?: { __typename?: 'DepositSettings', enabled: boolean } | null }, linkedPaymentRequest?: { __typename?: 'PaymentRequest', _id: any, version: number, status: EnumPaymentRequestStatus, accountingCode?: string | null, internalAccountingNotes?: string | null, externalReference?: string | null, accountingDate?: string | null } | null } | null, paymentRequest?: { __typename?: 'PaymentRequest', _id: any, invoiceNumber?: string | null, booker: any, order?: string | null, status: EnumPaymentRequestStatus, isComplimentary: boolean, version: number, grandTotal: number, currency: string, accountingCode?: string | null, internalAccountingNotes?: string | null, externalReference?: string | null, accountingDate?: string | null, dueDate?: string | null, createdDateISO?: any | null, sentAt?: string | null, renewablePurchaseId?: any | null, originalOrderId?: string | null, nextRenewalDate?: string | null, needsAttention: boolean, productNameOverride?: string | null, kind?: EnumPaymentRequestKind | null, statementPeriod?: string | null, recipientContact?: { __typename?: 'PaymentRequestRecipientContact', firstName?: string | null, lastName?: string | null, email?: string | null } | null, statementLines?: Array<{ __typename?: 'PaymentRequestStatementLines', orderId: string } | null> | null, cartSnapshot: { __typename?: 'PaymentRequestCartSnapshot', cart: Array<{ __typename?: 'PaymentRequestCartSnapshotCart', productName: string } | null> } } | null }> | null } };

export type StorefrontOwnerEntitiesQueryVariables = Exact<{
  storefrontId: Scalars['ID']['input'];
}>;


export type StorefrontOwnerEntitiesQuery = { __typename?: 'Query', storefrontOwnerEntities: Array<{ __typename?: 'StorefrontOwnerEntity', type: EnumOwnerType, entityId: string, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, contact?: { __typename?: 'Contact', email?: string | null, phone?: string | null, tollFreePublicPhone?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null, links?: { __typename?: 'Links', bookNow?: string | null, facebook?: string | null, googleMyBusiness?: string | null, instagram?: string | null, pinterest?: string | null, tiktok?: string | null, tripAdvisor?: string | null, website?: string | null, x?: string | null, youtube?: string | null, otherUrls: Array<string | null> } | null } | null }> };

export type StorefrontPagesByStorefrontQueryVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
}>;


export type StorefrontPagesByStorefrontQuery = { __typename?: 'Query', storefrontPagesByStorefront: Array<{ __typename?: 'StorefrontPageResult', _id: any, storefront: any, booker: any, type: string, slug: string, generatedPageHtml?: string | null, pageGeneratedAt?: any | null, editPromptHistory: Array<string>, status: string, pageUrl: string, createdDateISO?: any | null, updatedDateISO?: any | null }> };

export type StorefrontPlatformSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type StorefrontPlatformSettingsQuery = { __typename?: 'Query', storefrontPlatformSettings?: { __typename?: 'StorefrontPlatformSettings', _id: any, gettingStartedWistiaId?: string | null } | null };

export type StorefrontResumeStripeAccountSetupQueryVariables = Exact<{
  connectedAccountId: Scalars['ID']['input'];
  redirectUrl: Scalars['String']['input'];
  storefrontId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type StorefrontResumeStripeAccountSetupQuery = { __typename?: 'Query', storefrontResumeStripeAccountSetup: string };

export type StorefrontStatementPreviewQueryVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  period: Scalars['String']['input'];
}>;


export type StorefrontStatementPreviewQuery = { __typename?: 'Query', storefrontStatementPreview?: Array<{ __typename?: 'StatementPreviewGroup', customerId: any, customerName: string, email?: string | null, currency: string, orderIds: Array<string>, grandTotal: number } | null> | null };

export type StorefrontStatementRunsQueryVariables = Exact<{
  storefrontId: Scalars['MongoID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type StorefrontStatementRunsQuery = { __typename?: 'Query', storefrontStatementRuns?: Array<{ __typename?: 'StatementGenerationRun', _id: any, period: string, status: EnumStatementGenerationRunStatus, createdByName?: string | null, statementCount: number, grandTotalSum: number, currency: string, createdDateISO?: any | null, rolledBackAt?: string | null, rolledBackByName?: string | null, items: Array<{ __typename?: 'StatementGenerationRunItems', paymentRequestId: any, invoiceNumber?: string | null, customerName?: string | null, orderIds?: Array<string | null> | null, grandTotal: number, rollbackStatus?: EnumStatementGenerationRunItemsRollbackStatus | null } | null> } | null> | null };

export type StorefrontStripeAccountBlockingWidgetsQueryVariables = Exact<{
  storefrontId: Scalars['ID']['input'];
  connectedAccountId: Scalars['String']['input'];
}>;


export type StorefrontStripeAccountBlockingWidgetsQuery = { __typename?: 'Query', storefrontStripeAccountBlockingWidgets: Array<string> };

export type StorefrontTestModeFlagQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type StorefrontTestModeFlagQuery = { __typename?: 'Query', storefrontById?: { __typename?: 'Storefront', _id: any, testMode: boolean } | null };

export type StorefrontsByUserQueryVariables = Exact<{ [key: string]: never; }>;


export type StorefrontsByUserQuery = { __typename?: 'Query', storefrontsByUser: Array<{ __typename?: 'Storefront', _id: any, connectedAccountIds: Array<string | null>, createdDateISO?: any | null, testMode: boolean, stripeRegion: EnumStorefrontStripeRegion, testStorefront?: any | null, liveStorefront?: any | null, isLaunched: boolean, paymentsMode: EnumStorefrontPaymentsMode, name: { __typename?: 'Multilingual', en?: string | null, fr?: string | null, es?: string | null } }> };

export type SurveyByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type SurveyByIdQuery = { __typename?: 'Query', surveyById?: { __typename?: 'Survey', _id: any, updatedDateISO?: any | null, perBusinessAnswersEnabled: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, questions: Array<{ __typename?: 'SurveyQuestion', _id: any, isActive: boolean, required: boolean, type: EnumSurveyQuestionType, whereaboutsSearchEntityType?: EnumSurveyQuestionWhereaboutsSearchEntityType | null, parentQuestion?: any | null, businessScope?: EnumSurveyQuestionBusinessScope | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options: Array<{ __typename?: 'SurveyQuestionOptions', _id?: any | null, isActive: boolean, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> }> } | null };

export type SurveyManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManySurveyInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SurveyManyQuery = { __typename?: 'Query', surveyMany: Array<{ __typename?: 'Survey', _id: any, updatedDateISO?: any | null, perBusinessAnswersEnabled: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, questions: Array<{ __typename?: 'SurveyQuestion', _id: any, isActive: boolean, required: boolean, type: EnumSurveyQuestionType, whereaboutsSearchEntityType?: EnumSurveyQuestionWhereaboutsSearchEntityType | null, parentQuestion?: any | null, businessScope?: EnumSurveyQuestionBusinessScope | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, options: Array<{ __typename?: 'SurveyQuestionOptions', _id?: any | null, isActive: boolean, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> }> }> };

export type SurveyResponseByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type SurveyResponseByIdQuery = { __typename?: 'Query', surveyResponseById?: { __typename?: 'SurveyResponse', _id: any, createdDateISO?: any | null, status?: EnumSurveyResponseStatus | null, adminStatus?: EnumSurveyResponseAdminStatus | null, tags?: Array<any | null> | null, responses: Array<{ __typename?: 'SurveyResponseResponses', response: Array<string | null>, questionData: { __typename?: 'SurveyQuestion', _id: any, isActive: boolean, type: EnumSurveyQuestionType, required: boolean, whereaboutsSearchEntityType?: EnumSurveyQuestionWhereaboutsSearchEntityType | null, parentQuestion?: any | null, businessScope?: EnumSurveyQuestionBusinessScope | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', type: EnumOwnerType, entityId: any }, options: Array<{ __typename?: 'SurveyQuestionOptions', _id?: any | null, isActive: boolean, label: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> }, byBusiness?: Array<{ __typename?: 'SurveyResponseResponsesByBusiness', operatorId: string, response?: Array<string | null> | null } | null> | null } | null>, ownerBusinesses: Array<{ __typename?: 'SurveyResponseBusiness', operatorId: string, businessName?: string | null }>, ownerMetadata?: { __typename?: 'SurveyResponseOwnerMetadata', organization?: any | null } | null, history?: Array<{ __typename?: 'SurveyResponseHistory', action: EnumSurveyResponseHistoryAction, timestamp: any, personName?: string | null, reviewStatus?: EnumSurveyResponseHistoryReviewStatus | null, reviewNote?: string | null } | null> | null, survey?: { __typename?: 'Survey', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, person?: { __typename?: 'SimplePersonTC', _id: string, firstName: string, lastName: string, email: string, phone?: string | null } | null } | null };

export type SurveyResponseForBroadcastResourceQueryVariables = Exact<{
  broadcastId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  personId: Scalars['String']['input'];
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  submissionIndex?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SurveyResponseForBroadcastResourceQuery = { __typename?: 'Query', surveyResponseForBroadcastResource?: { __typename?: 'SurveyResponse', _id: any, status?: EnumSurveyResponseStatus | null, version?: number | null, adminStatus?: EnumSurveyResponseAdminStatus | null, surveyUpdatedAt?: any | null, responses: Array<{ __typename?: 'SurveyResponseResponses', response: Array<string | null>, questionData: { __typename?: 'SurveyQuestion', _id: any, type: EnumSurveyQuestionType, required: boolean, parentQuestion?: any | null, businessScope?: EnumSurveyQuestionBusinessScope | null, name: { __typename?: 'Multilingual', en?: string | null }, options: Array<{ __typename?: 'SurveyQuestionOptions', _id?: any | null, label: { __typename?: 'Multilingual', en?: string | null } } | null> }, byBusiness?: Array<{ __typename?: 'SurveyResponseResponsesByBusiness', operatorId: string, response?: Array<string | null> | null } | null> | null } | null>, ownerBusinesses: Array<{ __typename?: 'SurveyResponseBusiness', operatorId: string, businessName?: string | null }>, history?: Array<{ __typename?: 'SurveyResponseHistory', action: EnumSurveyResponseHistoryAction, savedBy: any, personName?: string | null, timestamp: any, reviewStatus?: EnumSurveyResponseHistoryReviewStatus | null, reviewedBy?: any | null, reviewedAt?: any | null, reviewNote?: string | null } | null> | null } | null };

export type SurveyResponsesByWidgetQueryVariables = Exact<{
  widgetId: Scalars['String']['input'];
}>;


export type SurveyResponsesByWidgetQuery = { __typename?: 'Query', surveyResponsesByWidget?: Array<{ __typename?: 'SurveyResponse', _id: any, createdDateISO?: any | null, adminStatus?: EnumSurveyResponseAdminStatus | null, isTest?: boolean | null, person?: { __typename?: 'SimplePersonTC', _id: string, firstName: string, lastName: string, email: string } | null, responses: Array<{ __typename?: 'SurveyResponseResponses', response: Array<string | null>, questionData: { __typename?: 'SurveyQuestion', _id: any, type: EnumSurveyQuestionType, name: { __typename?: 'Multilingual', en?: string | null } } } | null> } | null> | null };

export type SurveyResponsesForBroadcastResourceQueryVariables = Exact<{
  broadcastId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  personId: Scalars['String']['input'];
}>;


export type SurveyResponsesForBroadcastResourceQuery = { __typename?: 'Query', surveyResponsesForBroadcastResource?: Array<{ __typename?: 'SurveyResponse', _id: any, status?: EnumSurveyResponseStatus | null, version?: number | null, submissionIndex: number, adminStatus?: EnumSurveyResponseAdminStatus | null, summary?: string | null, surveyUpdatedAt?: any | null, person?: { __typename?: 'SimplePersonTC', _id: string } | null, responses: Array<{ __typename?: 'SurveyResponseResponses', response: Array<string | null>, questionData: { __typename?: 'SurveyQuestion', _id: any, type: EnumSurveyQuestionType, required: boolean, name: { __typename?: 'Multilingual', en?: string | null }, options: Array<{ __typename?: 'SurveyQuestionOptions', _id?: any | null, label: { __typename?: 'Multilingual', en?: string | null } } | null> } } | null>, history?: Array<{ __typename?: 'SurveyResponseHistory', action: EnumSurveyResponseHistoryAction, savedBy: any, personName?: string | null, timestamp: any, reviewStatus?: EnumSurveyResponseHistoryReviewStatus | null, reviewedBy?: any | null, reviewedAt?: any | null, reviewNote?: string | null } | null> | null } | null> | null };

export type SurveyUsageQueryVariables = Exact<{
  surveyIds: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
}>;


export type SurveyUsageQuery = { __typename?: 'Query', surveyUsage?: Array<{ __typename?: 'SurveyUsage', surveyId: any, responseCount: number, bookers: Array<{ __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }>, products: Array<{ __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }>, widgets: Array<{ __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }>, broadcasts: Array<{ __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }> }> | null };

export type TagByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type TagByIdQuery = { __typename?: 'Query', tagById?: { __typename?: 'Tag', _id: any, entityTypes: Array<EnumTagEntityTypes | null>, inheritable: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, usage?: { __typename?: 'TagUsage', events?: number | null, operators?: number | null, products?: number | null, total?: number | null } | null } | null };

export type TagEntityUsageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TagEntityUsageQuery = { __typename?: 'Query', tagEntityUsage: { __typename?: 'TagEntityTypeUsage', operators: Array<{ __typename?: 'TagEntityTypeUsageOperators', entityId: string, parentId: string, entityName: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, parentName: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null>, events: Array<{ __typename?: 'TagEntityTypeUsageOperators', entityId: string, parentId: string, entityName: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, parentName: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null>, products: Array<{ __typename?: 'TagEntityTypeUsageOperators', entityId: string, parentId: string, entityName: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, parentName: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null>, lists: Array<{ __typename?: 'TagEntityTypeUsageOperators', entityId: string, parentId: string, entityName: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, parentName: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null>, widgets: Array<{ __typename?: 'TagEntityTypeUsageOperators', entityId: string, parentId: string, entityName: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, parentName: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null>, people: Array<{ __typename?: 'TagEntityTypeUsageOperators', entityId: string, parentId: string, entityName: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, parentName: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null> } };

export type TagGroupOneQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneTagGroupInput>;
}>;


export type TagGroupOneQuery = { __typename?: 'Query', tagGroupOne?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null };

export type TagGroupByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TagGroupByIdsQuery = { __typename?: 'Query', tagGroupByIds: Array<{ __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type TagManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyTagInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TagManyQuery = { __typename?: 'Query', tagMany: Array<{ __typename?: 'Tag', _id: any, entityTypes: Array<EnumTagEntityTypes | null>, inheritable: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> };

export type TagManyLockedIdsQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyTagInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TagManyLockedIdsQuery = { __typename?: 'Query', tagMany: Array<{ __typename?: 'Tag', _id: any }> };

export type TagManyWithCountsQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyTagInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TagManyWithCountsQuery = { __typename?: 'Query', tagMany: Array<{ __typename?: 'Tag', _id: any, entityTypes: Array<EnumTagEntityTypes | null>, inheritable: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, usage?: { __typename?: 'TagUsage', events?: number | null, operators?: number | null, products?: number | null, total?: number | null } | null }> };

export type TagRefreshCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagRefreshCountsQuery = { __typename?: 'Query', tagRefreshCounts?: boolean | null };

export type TagSuggestionAnalyzeQueryVariables = Exact<{
  tagName: Scalars['String']['input'];
  tagGroupId: Scalars['ID']['input'];
}>;


export type TagSuggestionAnalyzeQuery = { __typename?: 'Query', tagSuggestionAnalyze: { __typename?: 'TagSuggestionAIResponse', action?: EnumTagSuggestionAiResponseAction | null, summary?: string | null, similarTags: Array<string | null>, alternativeSuggestions: Array<string | null> } };

export type TagSuggestionByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type TagSuggestionByIdQuery = { __typename?: 'Query', tagSuggestionById?: { __typename?: 'TagSuggestion', _id: any, entityTypes: Array<EnumTagSuggestionEntityTypes | null>, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, aiResponse?: { __typename?: 'TagSuggestionAIResponse', action?: EnumTagSuggestionAiResponseAction | null, summary?: string | null, similarTags: Array<string | null>, alternativeSuggestions: Array<string | null> } | null } | null };

export type TagSuggestionManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyTagSuggestionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TagSuggestionManyQuery = { __typename?: 'Query', tagSuggestionMany: Array<{ __typename?: 'TagSuggestion', _id: any, entityTypes: Array<EnumTagSuggestionEntityTypes | null>, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null, aiResponse?: { __typename?: 'TagSuggestionAIResponse', action?: EnumTagSuggestionAiResponseAction | null, summary?: string | null, similarTags: Array<string | null>, alternativeSuggestions: Array<string | null> } | null }> };

export type TagByIdsQueryVariables = Exact<{
  ids: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TagByIdsQuery = { __typename?: 'Query', tagByIds: Array<{ __typename?: 'Tag', _id: any, entityTypes: Array<EnumTagEntityTypes | null>, inheritable: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null, tagGroup?: { __typename?: 'TagGroup', _id: any, key: EnumTagGroupKey, type: EnumTagGroupType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> };

export type TaxManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyTaxInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TaxManyQuery = { __typename?: 'Query', taxMany: Array<{ __typename?: 'Tax', _id: any, country: string, percentage: number, subdivision: string, owner?: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } | null }> };

export type UserFindOneQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneUserInput>;
}>;


export type UserFindOneQuery = { __typename?: 'Query', userFindOne?: { __typename?: 'UserWithPictureTC', picture?: string | null, _id: any, personId?: string | null, firstName: string, lastName: string, email: string, title?: string | null, photoUploadedBy?: any | null, contactRoles?: Array<ContactRole | null> | null, status: EnumUserStatus, userType: EnumUserUserType, quickLinksVersion: number, lastViewedListId?: string | null, hasPurchases: boolean, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus, title?: string | null, contactRoles?: Array<EnumUserAccessOperatorsContactRoles | null> | null } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, storefronts: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null> }, onboardingMetadata?: { __typename?: 'UserOnboardingMetadata', onboardingOrganization?: any | null, isPostOnboarding?: boolean | null, onboardingBroadcast?: any | null } | null, emailPreferences: Array<{ __typename?: 'UserEmailPreferences', templateName: EnumUserEmailPreferencesTemplateName, frequency: EnumUserEmailPreferencesFrequency, entity?: { __typename?: 'EntityReference', type: EnumEntityReferenceType, _entityId: any } | null } | null>, quickLinks: Array<{ __typename?: 'UserQuickLinks', title: string, link: string, lastVisited: string, type: EnumUserQuickLinksType, entityId: string, pinned?: boolean | null } | null>, memberships: Array<{ __typename?: 'UserMembershipRow', _id: any, subjectType: string, listingName?: string | null, organizationId: any, organizationName: string, organizationLogo?: any | null, memberNomenclature: string, membershipNomenclature: string, tierName?: string | null, status: string, statusTagNames: Array<string>, renewalDate?: any | null, renewalDateDisplayMode: string, needsRenewal: boolean, tierTagId?: any | null, subjectEntityId: any, renewablePurchaseId?: any | null, renewalBilling?: string | null }> } | null };

export type UserFindOneByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UserFindOneByEmailQuery = { __typename?: 'Query', userFindOneByEmail?: { __typename?: 'UserWithResetPasswordUrlTC', _id: any, email: string, firstName: string, lastName: string, photoUploadedBy?: any | null, passwordResetUrl?: string | null, status: EnumUserStatus, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, status: EnumUserAccessOperatorsStatus } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, status: EnumUserAccessOperatorsStatus } | null>, storefronts: Array<{ __typename?: 'UserAccessOperators', entityId: any, status: EnumUserAccessOperatorsStatus } | null> } } | null };

export type UserFindSelfQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneUserInput>;
}>;


export type UserFindSelfQuery = { __typename?: 'Query', userFindOne?: { __typename?: 'UserWithPictureTC', systemPermissions: Array<EnumUserSystemPermissions | null>, resolvedBroadcasts: Array<any | null>, picture?: string | null, _id: any, personId?: string | null, firstName: string, lastName: string, email: string, title?: string | null, photoUploadedBy?: any | null, contactRoles?: Array<ContactRole | null> | null, status: EnumUserStatus, userType: EnumUserUserType, quickLinksVersion: number, lastViewedListId?: string | null, hasPurchases: boolean, photo?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null, access: { __typename?: 'UserAccess', operators: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus, title?: string | null, contactRoles?: Array<EnumUserAccessOperatorsContactRoles | null> | null } | null>, organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, storefronts: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null> }, onboardingMetadata?: { __typename?: 'UserOnboardingMetadata', onboardingOrganization?: any | null, isPostOnboarding?: boolean | null, onboardingBroadcast?: any | null } | null, emailPreferences: Array<{ __typename?: 'UserEmailPreferences', templateName: EnumUserEmailPreferencesTemplateName, frequency: EnumUserEmailPreferencesFrequency, entity?: { __typename?: 'EntityReference', type: EnumEntityReferenceType, _entityId: any } | null } | null>, quickLinks: Array<{ __typename?: 'UserQuickLinks', title: string, link: string, lastVisited: string, type: EnumUserQuickLinksType, entityId: string, pinned?: boolean | null } | null>, memberships: Array<{ __typename?: 'UserMembershipRow', _id: any, subjectType: string, listingName?: string | null, organizationId: any, organizationName: string, organizationLogo?: any | null, memberNomenclature: string, membershipNomenclature: string, tierName?: string | null, status: string, statusTagNames: Array<string>, renewalDate?: any | null, renewalDateDisplayMode: string, needsRenewal: boolean, tierTagId?: any | null, subjectEntityId: any, renewablePurchaseId?: any | null, renewalBilling?: string | null }> } | null };

export type UserManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyUserInput>;
}>;


export type UserManyQuery = { __typename?: 'Query', userMany: Array<{ __typename?: 'UserWithPictureTC', _id: any, email: string, firstName: string, lastName: string, userType: EnumUserUserType, access: { __typename?: 'UserAccess', organizations: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null>, storefronts: Array<{ __typename?: 'UserAccessOperators', entityId: any, role: EnumUserAccessOperatorsRole, status: EnumUserAccessOperatorsStatus } | null> }, emailPreferences: Array<{ __typename?: 'UserEmailPreferences', templateName: EnumUserEmailPreferencesTemplateName, frequency: EnumUserEmailPreferencesFrequency, entity?: { __typename?: 'EntityReference', type: EnumEntityReferenceType, _entityId: any } | null } | null> }> };

export type UserManyForMentionsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserManyForMentionsQuery = { __typename?: 'Query', userManyForMentions: Array<{ __typename?: 'User', _id: any, firstName: string, lastName: string }> };

export type UserRequestEmailVerificationQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRequestEmailVerificationQuery = { __typename?: 'Query', userRequestEmailVerification?: string | null };

export type WhereabotAvatarQueryVariables = Exact<{ [key: string]: never; }>;


export type WhereabotAvatarQuery = { __typename?: 'Query', whereabotAvatar?: { __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null } | null };

export type WhereabotChatByIdQueryVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type WhereabotChatByIdQuery = { __typename?: 'Query', whereabotChatById?: { __typename?: 'WhereabotChat', _id: any, title: string, chatModel: string, rating?: number | null, notes?: string | null, status: EnumWhereabotChatStatus, createdDateISO?: any | null, updatedDateISO?: any | null, createdBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, picture?: string | null } | null } | null };

export type WhereabotChatManyQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type WhereabotChatManyQuery = { __typename?: 'Query', whereabotChatMany?: Array<{ __typename?: 'WhereabotChat', _id: any, title: string, chatModel: string, rating?: number | null, notes?: string | null, status: EnumWhereabotChatStatus, createdDateISO?: any | null, updatedDateISO?: any | null, createdBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string, picture?: string | null } | null } | null> | null };

export type WhereabotMessagesByChatQueryVariables = Exact<{
  chatId: Scalars['MongoID']['input'];
  before?: InputMaybe<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WhereabotMessagesByChatQuery = { __typename?: 'Query', whereabotMessagesByChat?: Array<{ __typename?: 'WhereabotMessage', _id: any, chat: any, role: EnumWhereabotMessageRole, content: string, isError: boolean, createdDateISO?: any | null, operatorResults?: Array<{ __typename?: 'WhereabotMessageOperatorResults', operatorEntityId: string, operatorName: string, operatorType: string, organizationId?: string | null, score: number, isRelated?: boolean | null } | null> | null, metadata?: { __typename?: 'WhereabotMessageMetadata', embeddingTimeMs?: number | null, searchTimeMs?: number | null, llmTimeMs?: number | null, totalTimeMs?: number | null, operatorsSearched?: number | null } | null } | null> | null };

export type WhereabotSettingsGetQueryVariables = Exact<{ [key: string]: never; }>;


export type WhereabotSettingsGetQuery = { __typename?: 'Query', whereabotSettingsGet?: { __typename?: 'WhereabotSettingsWithDefault', _id?: any | null, chatModel?: string | null, updatedBy?: any | null, updatedDateISO?: any | null } | null };

export type WidgetActiveCountQueryVariables = Exact<{
  filter?: InputMaybe<FilterCountWidgetInput>;
}>;


export type WidgetActiveCountQuery = { __typename?: 'Query', widgetCount?: number | null };

export type WidgetByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type WidgetByIdQuery = { __typename?: 'Query', widgetById: { __typename?: 'WidgetWithListEntities', _id: any, type: EnumWidgetType, archived: boolean, favorited: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, description: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, list: { __typename?: 'ListWithEntitiesAndOverrides', _id: any, type: EnumListType, selections: any, archived: boolean, favorited: boolean, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, entities: Array<{ __typename?: 'OperatorWithOverrides', _entityId: any, _versionId: any, status?: PublicationStatusType | null, type: EnumOperatorType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, overrides?: { __typename?: 'OverrideDetails', description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }> } | null }> }, operatorSettings?: { __typename?: 'WidgetOperatorSettings', allowAdditionalFilters: boolean, allowMapView: boolean, sortStrategy?: EnumWidgetOperatorSettingsSortStrategy | null, hideTemporarilyClosed?: boolean | null, showPermanentlyClosed?: boolean | null, tieredSortOrder?: Array<any | null> | null, disableTieredSort?: boolean | null, disableOperatorWidgetFilter?: boolean | null, listDisplayMode?: EnumWidgetOperatorSettingsListDisplayMode | null, showOnlyMap?: boolean | null, hideFiltersInMapView?: boolean | null, showPromotions?: boolean | null, showEvents?: boolean | null, filterableTags: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, filterableTagGroups: Array<{ __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, orderedFilters?: Array<{ __typename?: 'WidgetOperatorSettingsOrderedFilters', _id: any, isTagGroup: boolean, additionalTagIds?: Array<any | null> | null, labelOverride?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null } | null, eventSettings?: { __typename?: 'WidgetEventSettings', displayType: EnumWidgetEventSettingsDisplayType, eventTags: Array<any | null>, hiddenPublicFilterTags?: Array<any | null> | null, publicFilterMode?: EnumWidgetEventSettingsPublicFilterMode | null, publicFilterSort?: EnumWidgetEventSettingsPublicFilterSort | null, shownPublicFilterTags?: Array<any | null> | null, lookAheadMonths?: number | null, startMonth?: string | null, hideCancelledEvents?: boolean | null } | null, inquirySettings?: { __typename?: 'WidgetInquirySettings', survey: string, completionTags?: Array<any | null> | null, submissionTags?: Array<any | null> | null, preventMultipleSubmissions?: boolean | null, notificationRecipients?: Array<any | null> | null, buttonLabel?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, thankYouMessage?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null, gallerySettings?: { __typename?: 'WidgetGallerySettings', items?: Array<any | null> | null, enableUrlPush?: boolean | null, playerPagePath?: string | null, profilePageEnabled?: boolean | null, allMedia?: boolean | null, infiniteScroll?: { __typename?: 'WidgetGallerySettingsInfiniteScroll', enabled?: boolean | null, mediaTagFilters?: Array<any | null> | null, listingFilters?: Array<any | null> | null } | null } | null, promotionSettings?: { __typename?: 'WidgetPromotionSettings', displayType: EnumWidgetPromotionSettingsDisplayType, promotionTags: Array<any | null>, hiddenPublicFilterTags?: Array<any | null> | null, hidePublicFilters?: boolean | null } | null, owner: { __typename?: 'Owner', entityId: any } } };

export type WidgetByIdEventsWidgetQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type WidgetByIdEventsWidgetQuery = { __typename?: 'Query', widgetById: { __typename?: 'WidgetWithListEntities', _id: any, eventSettings?: { __typename?: 'WidgetEventSettings', displayType: EnumWidgetEventSettingsDisplayType, eventTags: Array<any | null>, hiddenPublicFilterTags?: Array<any | null> | null, publicFilterMode?: EnumWidgetEventSettingsPublicFilterMode | null, publicFilterSort?: EnumWidgetEventSettingsPublicFilterSort | null, shownPublicFilterTags?: Array<any | null> | null, lookAheadMonths?: number | null, startMonth?: string | null, hideCancelledEvents?: boolean | null } | null, owner: { __typename?: 'Owner', entityId: any } } };

export type WidgetByIdPromotionsWidgetQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type WidgetByIdPromotionsWidgetQuery = { __typename?: 'Query', widgetById: { __typename?: 'WidgetWithListEntities', _id: any, type: EnumWidgetType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, promotionSettings?: { __typename?: 'WidgetPromotionSettings', displayType: EnumWidgetPromotionSettingsDisplayType, promotionTags: Array<any | null>, hiddenPublicFilterTags?: Array<any | null> | null, hidePublicFilters?: boolean | null } | null, owner: { __typename?: 'Owner', entityId: any } } };

export type WidgetByIdWithEntitiesQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type WidgetByIdWithEntitiesQuery = { __typename?: 'Query', widgetById: { __typename?: 'WidgetWithListEntities', _id: any, type: EnumWidgetType, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, list: { __typename?: 'ListWithEntitiesAndOverrides', entities: Array<{ __typename?: 'OperatorWithOverrides', _entityId: any, _versionId: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, overrides?: { __typename?: 'OverrideDetails', description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }> } | null }> }, operatorSettings?: { __typename?: 'WidgetOperatorSettings', allowAdditionalFilters: boolean, allowMapView: boolean, sortStrategy?: EnumWidgetOperatorSettingsSortStrategy | null, hideTemporarilyClosed?: boolean | null, showPermanentlyClosed?: boolean | null, tieredSortOrder?: Array<any | null> | null, listDisplayMode?: EnumWidgetOperatorSettingsListDisplayMode | null, showOnlyMap?: boolean | null, hideFiltersInMapView?: boolean | null, showPromotions?: boolean | null, showEvents?: boolean | null, filterableTags: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, filterableTagGroups: Array<{ __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, orderedFilters?: Array<{ __typename?: 'WidgetOperatorSettingsOrderedFilters', _id: any, isTagGroup: boolean, additionalTagIds?: Array<any | null> | null, labelOverride?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null } | null> | null } | null } };

export type WidgetEmbedActivityAllQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WidgetEmbedActivityAllQuery = { __typename?: 'Query', widgetEmbedActivityAll?: Array<{ __typename?: 'WidgetEmbedActivity', _id: any, url: string, hostname: string, lastViewedAt: any, firstViewedAt: any, viewCount: number, widget?: { __typename?: 'WidgetEmbedActivityWidget', _id: any, name: string, type: string } | null, organization?: { __typename?: 'WidgetEmbedActivityOrganization', _id: any, name: string } | null }> | null };

export type WidgetEmbedActivityByOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type WidgetEmbedActivityByOrganizationQuery = { __typename?: 'Query', widgetEmbedActivityByOrganization?: Array<{ __typename?: 'WidgetEmbedActivity', _id: any, url: string, hostname: string, lastViewedAt: any, firstViewedAt: any, viewCount: number, widget?: { __typename?: 'WidgetEmbedActivityWidget', _id: any, name: string, type: string } | null }> | null };

export type WidgetEmbedActivityByWidgetIdQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
}>;


export type WidgetEmbedActivityByWidgetIdQuery = { __typename?: 'Query', widgetEmbedActivityByWidgetId?: Array<{ __typename?: 'WidgetEmbedActivity', _id: any, url: string, hostname: string, lastViewedAt: any, firstViewedAt: any, viewCount: number }> | null };

export type WidgetManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyWidgetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWidgetInput>;
}>;


export type WidgetManyQuery = { __typename?: 'Query', widgetMany: Array<{ __typename?: 'WidgetWithListAndItemCount', _id: any, type: EnumWidgetType, itemCount?: number | null, archived: boolean, favorited: boolean, updatedDateISO?: any | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } }> };

export type WidgetManyAdminlandQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyWidgetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWidgetInput>;
}>;


export type WidgetManyAdminlandQuery = { __typename?: 'Query', widgetManySimple: Array<{ __typename?: 'Widget', _id: any, type: EnumWidgetType, archived: boolean, favorited: boolean, updatedDateISO?: any | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType } }> };

export type WidgetManyFastQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyWidgetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWidgetInput>;
}>;


export type WidgetManyFastQuery = { __typename?: 'Query', widgetManySimple: Array<{ __typename?: 'Widget', _id: any, type: EnumWidgetType, archived: boolean, favorited: boolean, updatedDateISO?: any | null, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, owner: { __typename?: 'Owner', entityId: any, type: EnumOwnerType }, gallerySettings?: { __typename?: 'WidgetGallerySettings', allMedia?: boolean | null } | null }> };

export type WidgetManyListIdsQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyWidgetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWidgetInput>;
}>;


export type WidgetManyListIdsQuery = { __typename?: 'Query', widgetManySimple: Array<{ __typename?: 'Widget', _id: any, archived: boolean, listId?: any | null }> };

export type WidgetManyNamesQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyWidgetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWidgetInput>;
}>;


export type WidgetManyNamesQuery = { __typename?: 'Query', widgetManySimple: Array<{ __typename?: 'Widget', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> };

export type WidgetOperatorByVersionIdsWidgetDetailsQueryVariables = Exact<{
  operatorVersionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type WidgetOperatorByVersionIdsWidgetDetailsQuery = { __typename?: 'Query', operatorByVersionIds: Array<{ __typename?: 'OperatorWithStatus', _versionId: any, operationalStatus: EnumOperatorOperationalStatus, enrollments: Array<{ __typename?: 'OperatorEnrollments', onboardingStatus: EnumOperatorEnrollmentsOnboardingStatus, organizationControlled: boolean, organization?: { __typename?: 'Organization', _id: any } | null } | null>, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, selectedTagGroups: Array<{ __typename?: 'TagGroup', _id: any, type: EnumTagGroupType, key: EnumTagGroupKey, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, tags?: { __typename?: 'OperatorTags', businessType: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, type: EnumTagGroupType, key: EnumTagGroupKey, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, type: EnumTagGroupType, key: EnumTagGroupKey, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, type: EnumTagGroupType, key: EnumTagGroupKey, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }>, amenity: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, tagGroup?: { __typename?: 'TagGroup', _id: any, type: EnumTagGroupType, key: EnumTagGroupKey, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } } | null }> } | null }> };

export type WidgetOperatorsByVersionIdsQueryVariables = Exact<{
  operatorVersionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type WidgetOperatorsByVersionIdsQuery = { __typename?: 'Query', operatorByVersionIds: Array<{ __typename?: 'OperatorWithStatus', _versionId: any, operationalStatus: EnumOperatorOperationalStatus, pricing?: EnumOperatorPricing | null, images: Array<{ __typename?: 'AssetImage', _id: string, type?: EnumDKeyAssetType | null, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string, qualityScore?: ImageQualityRating | null, bytes?: number | null, hasTransparency?: boolean | null, lightness?: string | null, caption: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null }, detectedObjects?: { __typename?: 'DetectedObjects', hasText?: boolean | null, hasFace?: boolean | null, text?: Array<{ __typename?: 'DetectedObject', boundingBox: Array<number>, confidence: number, categories: Array<string> } | null> | null } | null, colors?: Array<{ __typename?: 'Color', _id: any, value: string, predominance: number } | null> | null, mux?: { __typename?: 'AssetImageMux', assetId: string, playbackId?: string | null, status: EnumAssetImageMuxStatus } | null }>, shortDescription?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, description?: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } | null, contact: { __typename?: 'Contact', phone?: string | null, email?: string | null, links?: { __typename?: 'Links', website?: string | null, bookNow?: string | null } | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, subdivision?: string | null, postalCode?: string | null, country?: string | null, location?: { __typename?: 'AddressLocation', type: EnumAddressLocationType, coordinates: Array<number | null> } | null } | null }, hoursOfOperation?: { __typename?: 'OperatorHoursOfOperation', mon?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null, tue?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null, wed?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null, thu?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null, fri?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null, sat?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null, sun?: { __typename?: 'DateRangeISO', _id: any, start: string, end: string } | null } | null, selectedTagGroups: Array<{ __typename?: 'TagGroup', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, tags?: { __typename?: 'OperatorTags', businessType: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, global: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, organizationSpecific: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }>, amenity: Array<{ __typename?: 'Tag', _id: any, name: { __typename?: 'Multilingual', en?: string | null, es?: string | null, fr?: string | null } }> } | null }> };

export type WorkbenchFeatureListQueryVariables = Exact<{
  includeGraduated?: InputMaybe<Scalars['Boolean']['input']>;
  includeExpelled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WorkbenchFeatureListQuery = { __typename?: 'Query', workbenchFeatureList: Array<{ __typename?: 'WorkbenchFeatureCard', featureFlagKey: string, featureFlagId?: any | null, name: string, description?: string | null, group: string, scope: string, graduated: boolean, expelled: boolean, pendingEditCount: number, openFeedbackCount: number, lastActivityAt?: any | null, planSyncStatus: string, docsSyncStatus: string, assignedToMe: boolean, myActiveChatId?: any | null, hasActiveSeedRun: boolean, testers: Array<{ __typename?: 'WorkbenchTesterInfo', userId: any, name: string, email: string, addedAt?: any | null, invitedAt?: any | null, lastContactedAt?: any | null }> }> };

export type WorkbenchFeatureQueryVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
}>;


export type WorkbenchFeatureQuery = { __typename?: 'Query', workbenchFeature?: { __typename?: 'WorkbenchFeature', _id: any, featureFlagKey: string, active: boolean, planPath: string, planContent?: string | null, planSyncedAt?: any | null, planSource?: EnumWorkbenchFeaturePlanSource | null, planSyncStatus: EnumWorkbenchFeaturePlanSyncStatus, docsPath: string, docsContent?: string | null, docsSyncedAt?: any | null, docsSource?: EnumWorkbenchFeatureDocsSource | null, docsSyncStatus: EnumWorkbenchFeatureDocsSyncStatus, docsAudience: EnumWorkbenchFeatureDocsAudience, helpScoutArticleUrl?: string | null, codePaths: Array<string | null>, testOrganizationId?: any | null, effectiveTestOrganizationId?: any | null, effectiveTestOrganizationName?: string | null, myActiveChatId?: any | null, entryPoints: Array<{ __typename?: 'WorkbenchFeatureEntryPoints', label: string, route: string } | null>, testerUsers: Array<{ __typename?: 'WorkbenchTesterInfo', userId: any, name: string, email: string, addedAt?: any | null, invitedAt?: any | null, lastContactedAt?: any | null }>, stats: { __typename?: 'WorkbenchFeatureStats', pendingEditCount: number, acceptedEditCount: number, openFeedbackCount: number, reviewCount: number, activeSeedRunCount: number }, flag?: { __typename?: 'FeatureFlag', _id: any, key: string, name: string, description?: string | null, group: string, scope: EnumFeatureFlagScope, graduatedAt?: any | null, expelledAt?: any | null, expelledReason?: string | null, expelledReviewChat?: any | null } | null } | null };

export type WorkbenchSuggestionsByFlagQueryVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
  target?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type WorkbenchSuggestionsByFlagQuery = { __typename?: 'Query', workbenchSuggestionsByFlag: Array<{ __typename?: 'WorkbenchSuggestion', _id: any, featureFlagKey: string, chat?: any | null, message?: any | null, kind: EnumWorkbenchSuggestionKind, target: EnumWorkbenchSuggestionTarget, title: string, body: string, category?: EnumWorkbenchSuggestionCategory | null, docsSection?: string | null, relatedFiles?: Array<string | null> | null, status: EnumWorkbenchSuggestionStatus, createdBy?: any | null, createdByName?: string | null, createdDateISO?: any | null, pulledAt?: any | null, edit?: { __typename?: 'WorkbenchSuggestionEdit', section: string, operation: EnumWorkbenchSuggestionEditOperation, content: string, anchorText?: string | null } | null }> };

export type WorkbenchReviewSummariesQueryVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
}>;


export type WorkbenchReviewSummariesQuery = { __typename?: 'Query', workbenchReviewSummaries: Array<{ __typename?: 'WhereabotChat', _id: any, reviewSummary?: string | null, reviewCompletedAt?: any | null, createdBy?: { __typename?: 'UserWithPictureTC', _id: any, firstName: string, lastName: string } | null }> };

export type WorkbenchChangeRequestStatusQueryVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
  target: Scalars['String']['input'];
}>;


export type WorkbenchChangeRequestStatusQuery = { __typename?: 'Query', workbenchChangeRequestStatus: { __typename?: 'WorkbenchChangeRequestResult', target: string, openCount: number, openTesterCount: number, stale: boolean, newSinceGenerated: number, markdown?: string | null, summary?: { __typename?: 'WorkbenchChangeRequestSummary', generatedAt: any, model?: string | null, testerCount: number, suggestionCount: number, overview: string, integratedAt?: any | null, themes: Array<{ __typename?: 'WorkbenchChangeRequestTheme', title: string, summary: string, testerCount: number, suggestionIds: Array<any>, conflicts?: string | null, proposedSteps: Array<{ __typename?: 'WorkbenchChangeRequestStep', title: string, body: string }> }> } | null } };

export type WorkbenchSettingsGetQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkbenchSettingsGetQuery = { __typename?: 'Query', workbenchSettingsGet: { __typename?: 'WorkbenchSettingsInfo', defaultTestOrganizationId?: any | null, defaultTestOrganizationName?: string | null, defaultTestStorefrontId?: any | null, allowSeedingInProduction: boolean, seedingAllowedHere: boolean, environment: string, anthropicConfigured: boolean, chatModel: { __typename?: 'WorkbenchModelTier', primary: string, fallbacks: Array<string> }, summaryModel: { __typename?: 'WorkbenchModelTier', primary: string, fallbacks: Array<string> } } };

export type WorkbenchSeedScenariosQueryVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
}>;


export type WorkbenchSeedScenariosQuery = { __typename?: 'Query', workbenchSeedScenarios: Array<{ __typename?: 'WorkbenchSeedScenarioInfo', key: string, label: string, description: string }> };

export type WorkbenchSeedRunsQueryVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type WorkbenchSeedRunsQuery = { __typename?: 'Query', workbenchSeedRuns: Array<{ __typename?: 'WorkbenchSeedRun', _id: any, featureFlagKey: string, scenarioKey: string, organizationId: any, status: EnumWorkbenchSeedRunStatus, createdByName?: string | null, cleanedByName?: string | null, createdDateISO?: any | null, cleanedAt?: any | null, errorMessage?: string | null, preview?: { __typename?: 'WorkbenchSeedRunPreview', sampleNames?: Array<string | null> | null, notes?: Array<string | null> | null, counts?: Array<{ __typename?: 'WorkbenchSeedRunPreviewCounts', label: string, count: number } | null> | null } | null }> };

export type WorkbenchTesterCandidatesQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkbenchTesterCandidatesQuery = { __typename?: 'Query', workbenchTesterCandidates: Array<{ __typename?: 'WorkbenchTesterInfo', userId: any, name: string, email: string, addedAt?: any | null, invitedAt?: any | null, lastContactedAt?: any | null }> };

export type WorkbenchGateStateQueryVariables = Exact<{
  featureFlagKey: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type WorkbenchGateStateQuery = { __typename?: 'Query', workbenchGateState: { __typename?: 'WorkbenchGateState', featureFlagId: any, scope: string, graduated: boolean, expelled: boolean, organizationEnabled?: boolean | null, enabledOrganizationCount: number, testerAdminGates: Array<{ __typename?: 'WorkbenchAdminGate', userId: any, name: string, enabled: boolean }> } };

export type WorkbenchMessagesByChatQueryVariables = Exact<{
  chatId: Scalars['MongoID']['input'];
  before?: InputMaybe<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WorkbenchMessagesByChatQuery = { __typename?: 'Query', whereabotMessagesByChat?: Array<{ __typename?: 'WhereabotMessage', _id: any, chat: any, role: EnumWhereabotMessageRole, content: string, isError: boolean, createdDateISO?: any | null, metadata?: { __typename?: 'WhereabotMessageMetadata', model?: string | null } | null, sessionEvents?: Array<{ __typename?: 'WhereabotMessageSessionEvents', at: any, type: EnumWhereabotMessageSessionEventsType, route?: string | null, operationName?: string | null, message?: string | null, flagKey?: string | null, enabled?: boolean | null } | null> | null, workbenchSuggestions: Array<{ __typename?: 'WorkbenchSuggestion', _id: any, featureFlagKey: string, chat?: any | null, message?: any | null, kind: EnumWorkbenchSuggestionKind, target: EnumWorkbenchSuggestionTarget, title: string, body: string, category?: EnumWorkbenchSuggestionCategory | null, docsSection?: string | null, relatedFiles?: Array<string | null> | null, status: EnumWorkbenchSuggestionStatus, createdBy?: any | null, createdByName?: string | null, createdDateISO?: any | null, pulledAt?: any | null, edit?: { __typename?: 'WorkbenchSuggestionEdit', section: string, operation: EnumWorkbenchSuggestionEditOperation, content: string, anchorText?: string | null } | null }> } | null> | null };

export type WorkbenchChatByIdQueryVariables = Exact<{
  _id: Scalars['MongoID']['input'];
}>;


export type WorkbenchChatByIdQuery = { __typename?: 'Query', whereabotChatById?: { __typename?: 'WhereabotChat', _id: any, title: string, status: EnumWhereabotChatStatus, featureFlagKey?: string | null, testOrganizationId?: any | null, reviewSummary?: string | null, reviewCompletedAt?: any | null } | null };

export type WorkbenchOrganizationOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkbenchOrganizationOptionsQuery = { __typename?: 'Query', organizationMany: Array<{ __typename?: 'Organization', _id: any, name: { __typename?: 'Multilingual', en?: string | null }, metadata?: { __typename?: 'OrganizationMetadata', sandbox?: boolean | null } | null }> };

export type WorkbenchWhereabotAvatarQueryVariables = Exact<{
  userId: Scalars['MongoID']['input'];
}>;


export type WorkbenchWhereabotAvatarQuery = { __typename?: 'Query', personFindOne?: { __typename?: 'People', _id: any, photo?: { __typename?: 'AssetImage', _id: string, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string } | null } | null, userFindOne?: { __typename?: 'UserWithPictureTC', _id: any, photo?: { __typename?: 'AssetImage', _id: string, blurhash: string, width: number, height: number, isVideo?: boolean | null, format: string } | null } | null };

export const MultilingualFragmentFragmentDoc = gql`
    fragment MultilingualFragment on Multilingual {
  en
  es
  fr
}
    `;
export const ImageFragmentFragmentDoc = gql`
    fragment ImageFragment on AssetImage {
  _id
  type
  blurhash
  caption {
    ...MultilingualFragment
  }
  width
  height
  isVideo
  format
  qualityScore
  detectedObjects {
    hasText
    hasFace
    text {
      boundingBox
      confidence
      categories
    }
  }
  bytes
  colors {
    _id
    value
    predominance
  }
  hasTransparency
  lightness
  mux {
    assetId
    playbackId
    status
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export const FileFragmentFragmentDoc = gql`
    fragment FileFragment on AssetFile {
  _id
  type
  blurhash
  caption {
    ...MultilingualFragment
  }
  bytes
}
    ${MultilingualFragmentFragmentDoc}`;
export const BroadcastFragmentFragmentDoc = gql`
    fragment BroadcastFragment on Broadcast {
  _id
  createdDateISO
  updatedDateISO
  coverImage {
    ...ImageFragment
  }
  description {
    ...MultilingualFragment
  }
  name {
    ...MultilingualFragment
  }
  publicName {
    ...MultilingualFragment
  }
  owner {
    type
    entityId
  }
  status
  isTemplate
  sharedTo {
    type
    sentToPeople
    sentToPeopleTags
    sentToPeopleSystemRoles
    skipEmails
    operatorsOnly
    teaser {
      enabled
      description {
        ...MultilingualFragment
      }
    }
  }
  resources {
    type
    title {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    coverImage {
      ...ImageFragment
    }
    message {
      ...MultilingualFragment
    }
    file {
      ...FileFragment
    }
    video {
      ...ImageFragment
    }
    videoURL
    photos {
      ...ImageFragment
    }
    course
    iframeUrl
    survey {
      _id
      updatedDateISO
      perBusinessAnswersEnabled
      name {
        ...MultilingualFragment
      }
      owner {
        type
        entityId
      }
      questions {
        _id
        isActive
        name {
          ...MultilingualFragment
        }
        owner {
          type
          entityId
        }
        required
        type
        parentQuestion
        businessScope
        description {
          ...MultilingualFragment
        }
        options {
          _id
          isActive
          label {
            ...MultilingualFragment
          }
        }
      }
    }
    formMode
    allowSaveAndEdit
    requireApproval
    allowResubmission
    completionTags
    submissionTags
    booker {
      _id
      name {
        ...MultilingualFragment
      }
      status
      bundles {
        product {
          _id
          type
          name {
            ...MultilingualFragment
          }
        }
        _id
      }
    }
    expirationTags
    teamVisible
    ctaLabel {
      ...MultilingualFragment
    }
    _id
  }
}
    ${ImageFragmentFragmentDoc}
${MultilingualFragmentFragmentDoc}
${FileFragmentFragmentDoc}`;
export const DateRangeIsoFragmentFragmentDoc = gql`
    fragment DateRangeISOFragment on DateRangeISO {
  _id
  start
  end
  metadata
}
    `;
export const DateRangeIsoOptionalFragmentFragmentDoc = gql`
    fragment DateRangeISOOptionalFragment on DateRangeISOOptional {
  _id
  start
  end
  metadata
}
    `;
export const DiscountFragmentFragmentDoc = gql`
    fragment DiscountFragment on Discount {
  _id
  amount
  canCombine
  currentUsageCount
  daysInAdvance
  maxDaysInAdvance
  discountActivePeriod {
    _id
    end
    start
  }
  excludeUpsells
  isActive
  isOngoing
  maxNights
  maxUsageCount
  minGuestCount
  minNights
  minQuantity
  minSubtotal
  buyQuantity
  getQuantity
  name {
    ...MultilingualFragment
  }
  perTicket
  perTicketApplyFrom
  promoCode
  storefront
  type
  unit
}
    ${MultilingualFragmentFragmentDoc}`;
export const AddressFragmentFragmentDoc = gql`
    fragment AddressFragment on Address {
  line1
  line2
  city
  subdivision
  postalCode
  country
  location {
    type
    coordinates
  }
}
    `;
export const ContactFragmentFragmentDoc = gql`
    fragment ContactFragment on Contact {
  address {
    ...AddressFragment
  }
  email
  links {
    bookNow
    facebook
    googleMyBusiness
    instagram
    pinterest
    tiktok
    tripAdvisor
    website
    x
    youtube
    otherUrls
  }
  phone
  tollFreePublicPhone
}
    ${AddressFragmentFragmentDoc}`;
export const EventLocationFragmentFragmentDoc = gql`
    fragment EventLocationFragment on EventLocation {
  venue {
    ...MultilingualFragment
  }
  contact {
    ...ContactFragment
  }
  locationInfo {
    _entityId
    type
  }
}
    ${MultilingualFragmentFragmentDoc}
${ContactFragmentFragmentDoc}`;
export const EventDetailsFragmentFragmentDoc = gql`
    fragment EventDetailsFragment on Event {
  _id
  createdByEmail
  createdByFirstName
  createdByLastName
  createdByPerson
  submitterPersonId
  eventOrganizer {
    ...EventLocationFragment
  }
  locationType
  title {
    ...MultilingualFragment
  }
  description {
    ...MultilingualFragment
  }
  price
  ticketUrl
  tags {
    global {
      _id
      name {
        ...MultilingualFragment
      }
      tagGroup {
        _id
        name {
          ...MultilingualFragment
        }
      }
    }
    organizationSpecific {
      _id
      name {
        ...MultilingualFragment
      }
      tagGroup {
        _id
        name {
          ...MultilingualFragment
        }
      }
    }
  }
  eventLocations {
    ...EventLocationFragment
  }
  attentionIssues {
    type
    sourceName
    venueIndex
  }
  images {
    ...ImageFragment
  }
  type
  startDate
  endDate
  schedules {
    allDay
    timeSlots {
      _id
      from
      to
      endsNextDay
      note
    }
  }
  recurrencePattern {
    frequency
    interval
    daysOfWeek
    dateOfMonth
    dayOfMonth
    dayOfMonthOccurrence
    monthAndDateOfYear
    multiDates
    skipDates
    endDate
  }
  access {
    operator {
      _entityId
    }
    organizations {
      _entityId
      status
      source
      addedVia
    }
    disconnectedOrganizations
  }
  history {
    action
    timestamp
    sourceType
    userId
    userEmail
    userName
    organizationId
    note
  }
  suspectedDuplicateOf
  createdDateISO
  updatedDateISO
}
    ${EventLocationFragmentFragmentDoc}
${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;
export const FulfillmentProfileFragmentFragmentDoc = gql`
    fragment FulfillmentProfileFragment on FulfillmentProfile {
  _id
  name
  isActive
  storefront
  pickup {
    enabled
    locations {
      _id
      name
      address
      instructions
    }
  }
  shipping {
    enabled
    taxable
    zones {
      _id
      name
      countries
      subdivisions
      flatRate
      perAdditionalItem
      freeOver
    }
  }
}
    `;
export const LeadFragmentFragmentDoc = gql`
    fragment LeadFragment on Lead {
  _id
  subject
  link
  messages {
    message
    sender
    sentAtDateISO
  }
  metadata {
    booker {
      _id
      name {
        ...MultilingualFragment
      }
      bundles {
        product {
          name {
            ...MultilingualFragment
          }
        }
      }
    }
    storefront {
      _id
      name {
        ...MultilingualFragment
      }
    }
    organization {
      _id
      name {
        ...MultilingualFragment
      }
    }
    operator {
      _id
      _entityId
      name {
        ...MultilingualFragment
      }
    }
  }
  person {
    _id
    firstName
    lastName
    email
    phone
  }
  status
  type
  source
  sourceDetails
  broadcastId
  createdDateISO
  updatedDateISO
  surveyResponse {
    _id
    survey {
      _id
      name {
        ...MultilingualFragment
      }
    }
    responses {
      questionData {
        name {
          ...MultilingualFragment
        }
        type
      }
      response
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export const MembershipChecklistResultFragmentFragmentDoc = gql`
    fragment MembershipChecklistResultFragment on MembershipChecklistResult {
  ranAt
  analysis {
    memberListsEnabled
    ledgerEnabled
    members {
      total
      totalListings
      nonMembers
      multipleTiers
      multipleTierListings {
        entityId
        name
        tiers
      }
      tieredWithoutStatusTag
      byTier {
        tagId
        name
        count
        listId
        byStatus {
          tagId
          name
          count
        }
      }
      byStatus {
        tagId
        name
        count
      }
    }
    renewal {
      engineEnabled
      enabled
      renewalType
      term
      termYears
      fixedRenewalMonth
      fixedRenewalDay
      activeStatusTagId
      activeStatusTagName
      attentionStatusTagIds
      withRenewalDate
      withoutRenewalDate
      paidUp
      renewalWindow
      expired
      tagDrift
      suggestedBulkDate
    }
    payment {
      enabled
      hasStorefront
      liveCadStorefrontId
      liveUsdStorefrontId
      testUsdStorefrontId
      byTier {
        tagId
        bookerId
        bookerStorefrontId
        isTest
        free
      }
    }
    communication {
      broadcastId
      broadcastName
      broadcastPublished
      broadcastSharedToAll
      allowColdSignup
    }
  }
}
    `;
export const NoteFramgmentFragmentDoc = gql`
    fragment NoteFramgment on Note {
  _id
  author {
    _id
    firstName
    lastName
    email
  }
  entity {
    _entityId
    type
  }
  mentions {
    _id
    firstName
    lastName
  }
  message
  owner {
    entityId
    type
  }
  resolvedBy {
    _id
    firstName
    lastName
  }
  isArchived
  kind
  noteDateISO
  updatedDateISO
  createdDateISO
}
    `;
export const OrgOperatorOverlayFragmentFragmentDoc = gql`
    fragment OrgOperatorOverlayFragment on OrgOperatorOverlay {
  _id
  organization {
    _id
  }
  operator
  overlayPrivate {
    tags
    note
  }
  overlayPublic {
    publicProfileUrl
    crowdriffGalleryId
  }
  createdDateISO
  updatedDateISO
}
    `;
export const OrganizationPartnerSummaryFragmentFragmentDoc = gql`
    fragment OrganizationPartnerSummaryFragment on OrganizationPartnerSummary {
  _id
  name {
    ...MultilingualFragment
  }
  logo {
    ...ImageFragment
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;
export const OrganizationEventPartnerSettingsFragmentFragmentDoc = gql`
    fragment OrganizationEventPartnerSettingsFragment on OrganizationEventPartnerSettings {
  sharingCode
  partners {
    ...OrganizationPartnerSummaryFragment
  }
  subscribers {
    ...OrganizationPartnerSummaryFragment
  }
  suggestions {
    ...OrganizationPartnerSummaryFragment
  }
}
    ${OrganizationPartnerSummaryFragmentFragmentDoc}`;
export const PaymentMethodSetFragmentFragmentDoc = gql`
    fragment PaymentMethodSetFragment on PaymentMethodSet {
  _id
  name
  isActive
  acceptedPaymentMethods
  bankTransferInstructions
  offlinePaymentInstructions
  methodLabels {
    card
    direct_debit
    bank_transfer
    offline_payment
  }
  checkoutDescription
  storefront
}
    `;
export const PersonDetailsFragmentFragmentDoc = gql`
    fragment PersonDetailsFragment on DetailedPersonTC {
  _id
  userId
  isUserClaimed
  isUserInvited
  personInfo {
    firstName
    lastName
    email
    isUserClaimed
    isUserInvited
    photo {
      ...ImageFragment
    }
    phone
    phoneExt
    fax
    faxExt
    pronouns
    primaryTitle
    birthday
    contactMethod
    optInEmail
    optInPhone
    optInSMS
    optInFax
    address {
      ...AddressFragment
    }
    mailingAddress {
      ...AddressFragment
    }
    systemRoles
    tags {
      _id
      name {
        ...MultilingualFragment
      }
    }
  }
  orders {
    _id
    name {
      ...MultilingualFragment
    }
    dateISO
    dateStartISO
    dateEndISO
    type
  }
  operators {
    _entityId
    name {
      ...MultilingualFragment
    }
    roleType
    title
    contactRoles
    organizations {
      _id
      logo
      name {
        ...MultilingualFragment
      }
      title
    }
  }
  organizations {
    _id
    logo
    name {
      ...MultilingualFragment
    }
    roleType
  }
  adminOrganizations {
    _id
    logo
    name {
      ...MultilingualFragment
    }
  }
  leads {
    _id
    dateISO
    name {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    status
    type
  }
  emails
  phones {
    phone
    ext
    type
  }
  scratchpad
  isOnDirectoryOperator
}
    ${ImageFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${MultilingualFragmentFragmentDoc}`;
export const PersonSimpleManyFragmentFragmentDoc = gql`
    fragment PersonSimpleManyFragment on SimplePersonManyTC {
  _id
  firstName
  lastName
  email
  phone
  address {
    line1
    line2
    city
    subdivision
    postalCode
    country
    location {
      type
      coordinates
    }
  }
  photo {
    ...ImageFragment
  }
  isRepeatCustomer
  lastUpdated
  systemRoles
  tags {
    _id
    name {
      ...MultilingualFragment
    }
  }
  unreadLeads {
    leadId
    date
    type
  }
  rightSideContent {
    entityId
    text
  }
  isWhereaboutsUser
  isUserClaimed
  isUserInvited
}
    ${ImageFragmentFragmentDoc}
${MultilingualFragmentFragmentDoc}`;
export const PolicyFragmentFragmentDoc = gql`
    fragment PolicyFragment on Policy {
  _id
  content {
    ...MultilingualFragment
  }
  isActive
  name {
    ...MultilingualFragment
  }
  storefront
}
    ${MultilingualFragmentFragmentDoc}`;
export const ProductFragmentFragmentDoc = gql`
    fragment ProductFragment on Product {
  _id
  storefront
  updatedDateISO
  createdDateISO
  owner {
    type
    entityId
  }
  type
  name {
    ...MultilingualFragment
  }
  description {
    ...MultilingualFragment
  }
  shortDescription {
    ...MultilingualFragment
  }
  images {
    ...ImageFragment
  }
  tags {
    tagGroup {
      _id
      key
      name {
        ...MultilingualFragment
      }
      type
    }
    name {
      ...MultilingualFragment
    }
    entityTypes
    _id
  }
  rules {
    type
    value
    activePeriod {
      _id
      start
      end
      metadata
    }
    isActive
    storefront
    _id
  }
  publicationStatus
  pricing {
    description {
      ...MultilingualFragment
    }
    tiers {
      label {
        ...MultilingualFragment
      }
      type
      price
      priceType
      guestCountForPrice
      discountAmount
      discountUnit
      _id
    }
  }
  quantitySettings {
    enabled
    maxQuantity
  }
  externalBookingUrl
  contact {
    address {
      ...AddressFragment
    }
    useOwnerContact
    email
    phone
    tollFreePublicPhone
  }
  isUpsellOnly
  addOnSettings {
    businessScope
    pricingScope
  }
  customFields {
    _id
    label {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    type
    required
    chargePerChoice
    maxChoices
    options {
      _id
      label {
        ...MultilingualFragment
      }
    }
  }
  renewableFeeMetadata {
    billingIntervalMonths
    renewalType
    fixedRenewalMonth
    fixedRenewalDay
    proRateEnabled
    earlyPurchaseWindowDays
    membershipLinked
  }
  merchMetadata {
    dimensions {
      _id
      name {
        ...MultilingualFragment
      }
      drivesImages
      values {
        _id
        label {
          ...MultilingualFragment
        }
        imageIds
      }
    }
    variants {
      _id
      dimensionValueIds
      label
      price
      sku
      inventoryCount
      isActive
    }
    lowStockThreshold
  }
  sellingConfig {
    mode
    basePrice
    dynamicFeeSurvey
    options {
      _id
      name {
        ...MultilingualFragment
      }
      description {
        ...MultilingualFragment
      }
      price
      order
      autoTag
      tagConfig {
        onCheckoutCompleted
        onRenewalSuccess
        onRenewalPending
        onExpiration
        onCancellation
        onPaymentFailed
      }
      personTagConfig {
        onCheckoutCompleted
        onRenewalSuccess
        onRenewalPending
        onExpiration
        onCancellation
        onPaymentFailed
      }
      sessionScope
      includedSessionIds
      minSessions
      maxSessions
      subCapacityPerSession
      inventory {
        enabled
        totalCount
        currentCount
      }
      quantity {
        enabled
        maxQuantity
      }
      condition {
        operator
        clauses {
          questionId
          comparator
          value
        }
      }
    }
    inventory {
      enabled
      totalCount
      currentCount
    }
    quantity {
      enabled
      maxQuantity
    }
    recurring {
      enabled
      billingIntervalMonths
      renewalType
      fixedRenewalMonth
      fixedRenewalDay
      proRateEnabled
      earlyPurchaseWindowDays
      membershipLinked
      multiListing {
        mode
        maxListings
        autoIncludeOwnedListings
        additionalBusinessDiscount {
          unit
          amount
        }
      }
    }
  }
  productTiers {
    _id
    name {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    price
    order
    autoTag
    sessionScope
    includedSessionIds
    minSessions
    maxSessions
    subCapacityPerSession
    quantity {
      enabled
      maxQuantity
    }
    isActive
  }
  eventMetadata {
    event
    ticketStructure
    sessionGranularity
    sellingType
    maxTicketsPerPurchase
    includedSessionIds
  }
  inventorySettings {
    enabled
    totalCount
    currentCount
  }
  isActive
  accommodationMetadata {
    guestMetadata {
      minimumNumber
      maximumNumber
      nameEntryAllowed
      nameEntryRequired
    }
    amenities {
      tagGroup {
        _id
        key
        name {
          ...MultilingualFragment
        }
        type
      }
      name {
        ...MultilingualFragment
      }
      entityTypes
      _id
    }
    rooms {
      _id
      type
      amenities
    }
    checkIn
    checkOut
    calendarLinks
    closures {
      _id
      dateRangeISO {
        _id
        end
        metadata
        start
      }
      name
    }
  }
  quantitySettings {
    enabled
    maxQuantity
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;
export const PromotionFragmentFragmentDoc = gql`
    fragment PromotionFragment on Promotion {
  _id
  title {
    ...MultilingualFragment
  }
  description {
    ...MultilingualFragment
  }
  link
  availability {
    type
    dates
    startDate
    endDate
  }
  firstDate
  lastDate
  images {
    ...ImageFragment
  }
  tags {
    organizationSpecific {
      _id
      name {
        ...MultilingualFragment
      }
    }
  }
  access {
    operator {
      _entityId
      status
    }
    organizations {
      _entityId
      status
    }
  }
  createdByEmail
  createdByFirstName
  createdByLastName
  createdBy
  createdByPerson
  submitterPersonId
  submissionSource
  history {
    action
    timestamp
    sourceType
    userId
    userEmail
    userName
    organizationId
    note
  }
  listing {
    _entityId
    name {
      ...MultilingualFragment
    }
    operationalStatus
  }
  createdDateISO
  updatedDateISO
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;
export const RenewalRebaseGraceFragmentFragmentDoc = gql`
    fragment RenewalRebaseGraceFragment on RenewalRebaseGrace {
  overdueCount
  targetDate
  nextRenewalDate
  currentGraceDays
  currentGraceIsDefault
  currentGraceEndsOn
  currentNeverExpire
  suggestedGraceDays
  graceDays
  neverExpire
  graceEndsOn
  wouldExpireOnNextSweep
}
    `;
export const RenewalRebasePlanFragmentFragmentDoc = gql`
    fragment RenewalRebasePlanFragment on RenewalRebasePlan {
  affected
  unchanged
  undated
  byPhase {
    paidUp
    renewalWindow
    expired
  }
  outliers {
    subjectType
    entityId
    name
    currentDate
    targetDate
  }
  skipped {
    subjectType
    entityId
    name
    currentDate
    targetDate
  }
  grace {
    ...RenewalRebaseGraceFragment
  }
  from {
    fixedRenewalMonth
    fixedRenewalDay
  }
  to {
    fixedRenewalMonth
    fixedRenewalDay
  }
}
    ${RenewalRebaseGraceFragmentFragmentDoc}`;
export const MembershipLaunchStatusFragmentFragmentDoc = gql`
    fragment MembershipLaunchStatusFragment on MembershipLaunchStatus {
  state
  derived
  mode
  launchedAt
  recordedRetroactively
  locked
  blockers
  health {
    undated
    offSchedule
    purchaseSnapshotMismatch
    staleCheckouts
    overdue
    graceEndsOn
  }
  scheduleHistory {
    at
    kind
    fromMonth
    fromDay
    toMonth
    toDay
    intent
    date
    affected
    note
  }
}
    `;
export const SurveyFragmentFragmentDoc = gql`
    fragment SurveyFragment on Survey {
  _id
  updatedDateISO
  perBusinessAnswersEnabled
  name {
    ...MultilingualFragment
  }
  owner {
    type
    entityId
  }
  questions {
    _id
    isActive
    name {
      ...MultilingualFragment
    }
    owner {
      type
      entityId
    }
    required
    type
    whereaboutsSearchEntityType
    parentQuestion
    businessScope
    description {
      ...MultilingualFragment
    }
    options {
      _id
      isActive
      label {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export const TagEntityUsageFragmentFragmentDoc = gql`
    fragment TagEntityUsageFragment on TagEntityTypeUsageOperators {
  entityId
  entityName {
    en
    es
    fr
  }
  parentId
  parentName {
    en
    es
    fr
  }
}
    `;
export const TagFragmentFragmentDoc = gql`
    fragment TagFragment on Tag {
  name {
    ...MultilingualFragment
  }
  _id
  entityTypes
  inheritable
  owner {
    entityId
    type
  }
  tagGroup {
    _id
    key
    name {
      ...MultilingualFragment
    }
    type
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export const TagFragmentWithUsageFragmentDoc = gql`
    fragment TagFragmentWithUsage on Tag {
  name {
    ...MultilingualFragment
  }
  _id
  entityTypes
  inheritable
  owner {
    entityId
    type
  }
  tagGroup {
    _id
    key
    name {
      ...MultilingualFragment
    }
    type
  }
  usage {
    events
    operators
    products
    total
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export const TagSuggestionFragmentFragmentDoc = gql`
    fragment TagSuggestionFragment on TagSuggestion {
  name {
    ...MultilingualFragment
  }
  _id
  entityTypes
  owner {
    entityId
    type
  }
  tagGroup {
    _id
    key
    name {
      ...MultilingualFragment
    }
    type
  }
  aiResponse {
    action
    summary
    similarTags
    alternativeSuggestions
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export const UpsellProductFragmentFragmentDoc = gql`
    fragment UpsellProductFragment on Product {
  _id
  isUpsellOnly
  description {
    ...MultilingualFragment
  }
  name {
    ...MultilingualFragment
  }
  pricing {
    tiers {
      _id
      label {
        ...MultilingualFragment
      }
      price
      type
    }
  }
  publicationStatus
  shortDescription {
    ...MultilingualFragment
  }
  type
  quantitySettings {
    enabled
    maxQuantity
  }
  addOnSettings {
    businessScope
    pricingScope
  }
  customFields {
    _id
    label {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    type
    required
    chargePerChoice
    maxChoices
    options {
      _id
      label {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  _id
  firstName
  lastName
  email
  access {
    operators {
      entityId
      role
      status
    }
    organizations {
      entityId
      role
      status
    }
    storefronts {
      entityId
      role
      status
    }
  }
  status
  onboardingMetadata {
    onboardingOrganization
    isPostOnboarding
    onboardingBroadcast
  }
  userType
  emailPreferences {
    templateName
    frequency
    entity {
      type
      _entityId
    }
  }
}
    `;
export const UserWithPictureFragmentFragmentDoc = gql`
    fragment UserWithPictureFragment on UserWithPictureTC {
  picture
  _id
  personId
  firstName
  lastName
  email
  title
  photo {
    ...ImageFragment
  }
  photoUploadedBy
  contactRoles
  access {
    operators {
      entityId
      role
      status
      title
      contactRoles
    }
    organizations {
      entityId
      role
      status
    }
    storefronts {
      entityId
      role
      status
    }
  }
  status
  onboardingMetadata {
    onboardingOrganization
    isPostOnboarding
    onboardingBroadcast
  }
  userType
  emailPreferences {
    templateName
    frequency
    entity {
      type
      _entityId
    }
  }
  quickLinks {
    title
    link
    lastVisited
    type
    entityId
    pinned
  }
  quickLinksVersion
  lastViewedListId
  memberships {
    _id
    subjectType
    listingName
    organizationId
    organizationName
    organizationLogo
    memberNomenclature
    membershipNomenclature
    tierName
    status
    statusTagNames
    renewalDate
    renewalDateDisplayMode
    needsRenewal
    tierTagId
    subjectEntityId
    renewablePurchaseId
    renewalBilling
  }
  hasPurchases
}
    ${ImageFragmentFragmentDoc}`;
export const WorkbenchSuggestionFieldsFragmentDoc = gql`
    fragment WorkbenchSuggestionFields on WorkbenchSuggestion {
  _id
  featureFlagKey
  chat
  message
  kind
  target
  title
  body
  category
  edit {
    section
    operation
    content
    anchorText
  }
  docsSection
  relatedFiles
  status
  createdBy
  createdByName
  createdDateISO
  pulledAt
}
    `;
export const WorkbenchMessageFieldsFragmentDoc = gql`
    fragment WorkbenchMessageFields on WhereabotMessage {
  _id
  chat
  role
  content
  isError
  createdDateISO
  metadata {
    model
  }
  sessionEvents {
    at
    type
    route
    operationName
    message
    flagKey
    enabled
  }
  workbenchSuggestions {
    ...WorkbenchSuggestionFields
  }
}
    ${WorkbenchSuggestionFieldsFragmentDoc}`;
export const WorkbenchChangeRequestFieldsFragmentDoc = gql`
    fragment WorkbenchChangeRequestFields on WorkbenchChangeRequestResult {
  target
  openCount
  openTesterCount
  stale
  newSinceGenerated
  markdown
  summary {
    generatedAt
    model
    testerCount
    suggestionCount
    overview
    integratedAt
    themes {
      title
      summary
      testerCount
      suggestionIds
      conflicts
      proposedSteps {
        title
        body
      }
    }
  }
}
    `;
export const WorkbenchSeedRunFieldsFragmentDoc = gql`
    fragment WorkbenchSeedRunFields on WorkbenchSeedRun {
  _id
  featureFlagKey
  scenarioKey
  organizationId
  status
  createdByName
  cleanedByName
  createdDateISO
  cleanedAt
  errorMessage
  preview {
    counts {
      label
      count
    }
    sampleNames
    notes
  }
}
    `;
export const WorkbenchTesterFieldsFragmentDoc = gql`
    fragment WorkbenchTesterFields on WorkbenchTesterInfo {
  userId
  name
  email
  addedAt
  invitedAt
  lastContactedAt
}
    `;
export const WorkbenchFeatureFieldsFragmentDoc = gql`
    fragment WorkbenchFeatureFields on WorkbenchFeature {
  _id
  featureFlagKey
  active
  planPath
  planContent
  planSyncedAt
  planSource
  planSyncStatus
  docsPath
  docsContent
  docsSyncedAt
  docsSource
  docsSyncStatus
  docsAudience
  helpScoutArticleUrl
  entryPoints {
    label
    route
  }
  codePaths
  testOrganizationId
  effectiveTestOrganizationId
  effectiveTestOrganizationName
  myActiveChatId
  testerUsers {
    ...WorkbenchTesterFields
  }
  stats {
    pendingEditCount
    acceptedEditCount
    openFeedbackCount
    reviewCount
    activeSeedRunCount
  }
  flag {
    _id
    key
    name
    description
    group
    scope
    graduatedAt
    expelledAt
    expelledReason
    expelledReviewChat
  }
}
    ${WorkbenchTesterFieldsFragmentDoc}`;
export const SavedReportFieldsFragmentDoc = gql`
    fragment SavedReportFields on SavedReport {
  _id
  storefront
  name
  dataset
  columns
  match
  groupBy
  groupByGranularity
  conditions {
    field
    op
    values
  }
  sort {
    field
    direction
  }
  updatedDateISO
}
    `;
export const ActivityLogCreateDocument = gql`
    mutation ActivityLogCreate($record: CreateOneActivityLogInput!) {
  activityLogCreateOne(record: $record) {
    record {
      _id
    }
  }
}
    `;
export type ActivityLogCreateMutationFn = Apollo.MutationFunction<ActivityLogCreateMutation, ActivityLogCreateMutationVariables>;

/**
 * __useActivityLogCreateMutation__
 *
 * To run a mutation, you first call `useActivityLogCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivityLogCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activityLogCreateMutation, { data, loading, error }] = useActivityLogCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useActivityLogCreateMutation(baseOptions?: Apollo.MutationHookOptions<ActivityLogCreateMutation, ActivityLogCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivityLogCreateMutation, ActivityLogCreateMutationVariables>(ActivityLogCreateDocument, options);
      }
export type ActivityLogCreateMutationHookResult = ReturnType<typeof useActivityLogCreateMutation>;
export type ActivityLogCreateMutationResult = Apollo.MutationResult<ActivityLogCreateMutation>;
export type ActivityLogCreateMutationOptions = Apollo.BaseMutationOptions<ActivityLogCreateMutation, ActivityLogCreateMutationVariables>;
export const AdminUserDemoteDocument = gql`
    mutation AdminUserDemote($userId: MongoID!) {
  adminUserDemote(userId: $userId) {
    success
    user {
      _id
      email
      firstName
      lastName
      status
      userType
    }
    error
  }
}
    `;
export type AdminUserDemoteMutationFn = Apollo.MutationFunction<AdminUserDemoteMutation, AdminUserDemoteMutationVariables>;

/**
 * __useAdminUserDemoteMutation__
 *
 * To run a mutation, you first call `useAdminUserDemoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUserDemoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUserDemoteMutation, { data, loading, error }] = useAdminUserDemoteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminUserDemoteMutation(baseOptions?: Apollo.MutationHookOptions<AdminUserDemoteMutation, AdminUserDemoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUserDemoteMutation, AdminUserDemoteMutationVariables>(AdminUserDemoteDocument, options);
      }
export type AdminUserDemoteMutationHookResult = ReturnType<typeof useAdminUserDemoteMutation>;
export type AdminUserDemoteMutationResult = Apollo.MutationResult<AdminUserDemoteMutation>;
export type AdminUserDemoteMutationOptions = Apollo.BaseMutationOptions<AdminUserDemoteMutation, AdminUserDemoteMutationVariables>;
export const AdminUserPromoteDocument = gql`
    mutation AdminUserPromote($userId: MongoID!) {
  adminUserPromote(userId: $userId) {
    success
    user {
      _id
      email
      firstName
      lastName
      status
      userType
    }
    error
  }
}
    `;
export type AdminUserPromoteMutationFn = Apollo.MutationFunction<AdminUserPromoteMutation, AdminUserPromoteMutationVariables>;

/**
 * __useAdminUserPromoteMutation__
 *
 * To run a mutation, you first call `useAdminUserPromoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUserPromoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUserPromoteMutation, { data, loading, error }] = useAdminUserPromoteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminUserPromoteMutation(baseOptions?: Apollo.MutationHookOptions<AdminUserPromoteMutation, AdminUserPromoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUserPromoteMutation, AdminUserPromoteMutationVariables>(AdminUserPromoteDocument, options);
      }
export type AdminUserPromoteMutationHookResult = ReturnType<typeof useAdminUserPromoteMutation>;
export type AdminUserPromoteMutationResult = Apollo.MutationResult<AdminUserPromoteMutation>;
export type AdminUserPromoteMutationOptions = Apollo.BaseMutationOptions<AdminUserPromoteMutation, AdminUserPromoteMutationVariables>;
export const AdminUserSetPermissionsDocument = gql`
    mutation AdminUserSetPermissions($userId: MongoID!, $permissions: [String!]!) {
  adminUserSetPermissions(userId: $userId, permissions: $permissions) {
    _id
    email
    firstName
    lastName
    status
    userType
    systemPermissions
  }
}
    `;
export type AdminUserSetPermissionsMutationFn = Apollo.MutationFunction<AdminUserSetPermissionsMutation, AdminUserSetPermissionsMutationVariables>;

/**
 * __useAdminUserSetPermissionsMutation__
 *
 * To run a mutation, you first call `useAdminUserSetPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUserSetPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUserSetPermissionsMutation, { data, loading, error }] = useAdminUserSetPermissionsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useAdminUserSetPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<AdminUserSetPermissionsMutation, AdminUserSetPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUserSetPermissionsMutation, AdminUserSetPermissionsMutationVariables>(AdminUserSetPermissionsDocument, options);
      }
export type AdminUserSetPermissionsMutationHookResult = ReturnType<typeof useAdminUserSetPermissionsMutation>;
export type AdminUserSetPermissionsMutationResult = Apollo.MutationResult<AdminUserSetPermissionsMutation>;
export type AdminUserSetPermissionsMutationOptions = Apollo.BaseMutationOptions<AdminUserSetPermissionsMutation, AdminUserSetPermissionsMutationVariables>;
export const AiTaskCancelDocument = gql`
    mutation AiTaskCancel($taskId: MongoID!) {
  aiTaskCancel(taskId: $taskId) {
    success
    task {
      _id
      status
    }
  }
}
    `;
export type AiTaskCancelMutationFn = Apollo.MutationFunction<AiTaskCancelMutation, AiTaskCancelMutationVariables>;

/**
 * __useAiTaskCancelMutation__
 *
 * To run a mutation, you first call `useAiTaskCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiTaskCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiTaskCancelMutation, { data, loading, error }] = useAiTaskCancelMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useAiTaskCancelMutation(baseOptions?: Apollo.MutationHookOptions<AiTaskCancelMutation, AiTaskCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiTaskCancelMutation, AiTaskCancelMutationVariables>(AiTaskCancelDocument, options);
      }
export type AiTaskCancelMutationHookResult = ReturnType<typeof useAiTaskCancelMutation>;
export type AiTaskCancelMutationResult = Apollo.MutationResult<AiTaskCancelMutation>;
export type AiTaskCancelMutationOptions = Apollo.BaseMutationOptions<AiTaskCancelMutation, AiTaskCancelMutationVariables>;
export const AiTaskFeedbackDocument = gql`
    mutation AiTaskFeedback($taskId: MongoID!, $rating: AiTaskRating!, $feedbackNotes: String) {
  aiTaskFeedback(taskId: $taskId, rating: $rating, feedbackNotes: $feedbackNotes) {
    success
    task {
      _id
      rating
      feedbackNotes
    }
  }
}
    `;
export type AiTaskFeedbackMutationFn = Apollo.MutationFunction<AiTaskFeedbackMutation, AiTaskFeedbackMutationVariables>;

/**
 * __useAiTaskFeedbackMutation__
 *
 * To run a mutation, you first call `useAiTaskFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiTaskFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiTaskFeedbackMutation, { data, loading, error }] = useAiTaskFeedbackMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      rating: // value for 'rating'
 *      feedbackNotes: // value for 'feedbackNotes'
 *   },
 * });
 */
export function useAiTaskFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<AiTaskFeedbackMutation, AiTaskFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiTaskFeedbackMutation, AiTaskFeedbackMutationVariables>(AiTaskFeedbackDocument, options);
      }
export type AiTaskFeedbackMutationHookResult = ReturnType<typeof useAiTaskFeedbackMutation>;
export type AiTaskFeedbackMutationResult = Apollo.MutationResult<AiTaskFeedbackMutation>;
export type AiTaskFeedbackMutationOptions = Apollo.BaseMutationOptions<AiTaskFeedbackMutation, AiTaskFeedbackMutationVariables>;
export const AiTaskMarkAppliedDocument = gql`
    mutation AiTaskMarkApplied($taskId: MongoID!) {
  aiTaskMarkApplied(taskId: $taskId) {
    success
    task {
      _id
      applied
      appliedAt
    }
  }
}
    `;
export type AiTaskMarkAppliedMutationFn = Apollo.MutationFunction<AiTaskMarkAppliedMutation, AiTaskMarkAppliedMutationVariables>;

/**
 * __useAiTaskMarkAppliedMutation__
 *
 * To run a mutation, you first call `useAiTaskMarkAppliedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiTaskMarkAppliedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiTaskMarkAppliedMutation, { data, loading, error }] = useAiTaskMarkAppliedMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useAiTaskMarkAppliedMutation(baseOptions?: Apollo.MutationHookOptions<AiTaskMarkAppliedMutation, AiTaskMarkAppliedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiTaskMarkAppliedMutation, AiTaskMarkAppliedMutationVariables>(AiTaskMarkAppliedDocument, options);
      }
export type AiTaskMarkAppliedMutationHookResult = ReturnType<typeof useAiTaskMarkAppliedMutation>;
export type AiTaskMarkAppliedMutationResult = Apollo.MutationResult<AiTaskMarkAppliedMutation>;
export type AiTaskMarkAppliedMutationOptions = Apollo.BaseMutationOptions<AiTaskMarkAppliedMutation, AiTaskMarkAppliedMutationVariables>;
export const AiTaskPingDocument = gql`
    mutation AiTaskPing($taskId: MongoID!) {
  aiTaskPing(taskId: $taskId) {
    success
    status
  }
}
    `;
export type AiTaskPingMutationFn = Apollo.MutationFunction<AiTaskPingMutation, AiTaskPingMutationVariables>;

/**
 * __useAiTaskPingMutation__
 *
 * To run a mutation, you first call `useAiTaskPingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiTaskPingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiTaskPingMutation, { data, loading, error }] = useAiTaskPingMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useAiTaskPingMutation(baseOptions?: Apollo.MutationHookOptions<AiTaskPingMutation, AiTaskPingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiTaskPingMutation, AiTaskPingMutationVariables>(AiTaskPingDocument, options);
      }
export type AiTaskPingMutationHookResult = ReturnType<typeof useAiTaskPingMutation>;
export type AiTaskPingMutationResult = Apollo.MutationResult<AiTaskPingMutation>;
export type AiTaskPingMutationOptions = Apollo.BaseMutationOptions<AiTaskPingMutation, AiTaskPingMutationVariables>;
export const AnalyticsDashboardCreateOneDocument = gql`
    mutation AnalyticsDashboardCreateOne($record: CreateOneAnalyticsDashboardInput!) {
  analyticsDashboardCreateOne(record: $record) {
    record {
      _id
      name
      description
      dashboardId
      sortOrder
    }
  }
}
    `;
export type AnalyticsDashboardCreateOneMutationFn = Apollo.MutationFunction<AnalyticsDashboardCreateOneMutation, AnalyticsDashboardCreateOneMutationVariables>;

/**
 * __useAnalyticsDashboardCreateOneMutation__
 *
 * To run a mutation, you first call `useAnalyticsDashboardCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsDashboardCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsDashboardCreateOneMutation, { data, loading, error }] = useAnalyticsDashboardCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useAnalyticsDashboardCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsDashboardCreateOneMutation, AnalyticsDashboardCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsDashboardCreateOneMutation, AnalyticsDashboardCreateOneMutationVariables>(AnalyticsDashboardCreateOneDocument, options);
      }
export type AnalyticsDashboardCreateOneMutationHookResult = ReturnType<typeof useAnalyticsDashboardCreateOneMutation>;
export type AnalyticsDashboardCreateOneMutationResult = Apollo.MutationResult<AnalyticsDashboardCreateOneMutation>;
export type AnalyticsDashboardCreateOneMutationOptions = Apollo.BaseMutationOptions<AnalyticsDashboardCreateOneMutation, AnalyticsDashboardCreateOneMutationVariables>;
export const AnalyticsDashboardRemoveByIdDocument = gql`
    mutation AnalyticsDashboardRemoveById($id: MongoID!) {
  analyticsDashboardRemoveById(_id: $id) {
    record {
      _id
    }
  }
}
    `;
export type AnalyticsDashboardRemoveByIdMutationFn = Apollo.MutationFunction<AnalyticsDashboardRemoveByIdMutation, AnalyticsDashboardRemoveByIdMutationVariables>;

/**
 * __useAnalyticsDashboardRemoveByIdMutation__
 *
 * To run a mutation, you first call `useAnalyticsDashboardRemoveByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsDashboardRemoveByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsDashboardRemoveByIdMutation, { data, loading, error }] = useAnalyticsDashboardRemoveByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnalyticsDashboardRemoveByIdMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsDashboardRemoveByIdMutation, AnalyticsDashboardRemoveByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsDashboardRemoveByIdMutation, AnalyticsDashboardRemoveByIdMutationVariables>(AnalyticsDashboardRemoveByIdDocument, options);
      }
export type AnalyticsDashboardRemoveByIdMutationHookResult = ReturnType<typeof useAnalyticsDashboardRemoveByIdMutation>;
export type AnalyticsDashboardRemoveByIdMutationResult = Apollo.MutationResult<AnalyticsDashboardRemoveByIdMutation>;
export type AnalyticsDashboardRemoveByIdMutationOptions = Apollo.BaseMutationOptions<AnalyticsDashboardRemoveByIdMutation, AnalyticsDashboardRemoveByIdMutationVariables>;
export const AnalyticsDashboardUpdateByIdDocument = gql`
    mutation AnalyticsDashboardUpdateById($id: MongoID!, $record: UpdateByIdAnalyticsDashboardInput!) {
  analyticsDashboardUpdateById(_id: $id, record: $record) {
    record {
      _id
      name
      description
      dashboardId
      sortOrder
    }
  }
}
    `;
export type AnalyticsDashboardUpdateByIdMutationFn = Apollo.MutationFunction<AnalyticsDashboardUpdateByIdMutation, AnalyticsDashboardUpdateByIdMutationVariables>;

/**
 * __useAnalyticsDashboardUpdateByIdMutation__
 *
 * To run a mutation, you first call `useAnalyticsDashboardUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsDashboardUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsDashboardUpdateByIdMutation, { data, loading, error }] = useAnalyticsDashboardUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useAnalyticsDashboardUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<AnalyticsDashboardUpdateByIdMutation, AnalyticsDashboardUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyticsDashboardUpdateByIdMutation, AnalyticsDashboardUpdateByIdMutationVariables>(AnalyticsDashboardUpdateByIdDocument, options);
      }
export type AnalyticsDashboardUpdateByIdMutationHookResult = ReturnType<typeof useAnalyticsDashboardUpdateByIdMutation>;
export type AnalyticsDashboardUpdateByIdMutationResult = Apollo.MutationResult<AnalyticsDashboardUpdateByIdMutation>;
export type AnalyticsDashboardUpdateByIdMutationOptions = Apollo.BaseMutationOptions<AnalyticsDashboardUpdateByIdMutation, AnalyticsDashboardUpdateByIdMutationVariables>;
export const ApiAccessCreateDocument = gql`
    mutation ApiAccessCreate($organizationId: String!, $name: String, $description: String) {
  apiAccessCreate(
    organizationId: $organizationId
    name: $name
    description: $description
  ) {
    record {
      _id
      token
      name
      description
      organization {
        _id
        name {
          ...MultilingualFragment
        }
      }
      user {
        _id
        email
        firstName
        lastName
        userType
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type ApiAccessCreateMutationFn = Apollo.MutationFunction<ApiAccessCreateMutation, ApiAccessCreateMutationVariables>;

/**
 * __useApiAccessCreateMutation__
 *
 * To run a mutation, you first call `useApiAccessCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiAccessCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiAccessCreateMutation, { data, loading, error }] = useApiAccessCreateMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useApiAccessCreateMutation(baseOptions?: Apollo.MutationHookOptions<ApiAccessCreateMutation, ApiAccessCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiAccessCreateMutation, ApiAccessCreateMutationVariables>(ApiAccessCreateDocument, options);
      }
export type ApiAccessCreateMutationHookResult = ReturnType<typeof useApiAccessCreateMutation>;
export type ApiAccessCreateMutationResult = Apollo.MutationResult<ApiAccessCreateMutation>;
export type ApiAccessCreateMutationOptions = Apollo.BaseMutationOptions<ApiAccessCreateMutation, ApiAccessCreateMutationVariables>;
export const ApiAccessCreateAdminDocument = gql`
    mutation ApiAccessCreateAdmin($adminUserId: String!, $name: String, $description: String) {
  apiAccessCreateAdmin(
    adminUserId: $adminUserId
    name: $name
    description: $description
  ) {
    record {
      _id
      token
      name
      description
      user {
        _id
        email
        firstName
        lastName
        userType
      }
    }
  }
}
    `;
export type ApiAccessCreateAdminMutationFn = Apollo.MutationFunction<ApiAccessCreateAdminMutation, ApiAccessCreateAdminMutationVariables>;

/**
 * __useApiAccessCreateAdminMutation__
 *
 * To run a mutation, you first call `useApiAccessCreateAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiAccessCreateAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiAccessCreateAdminMutation, { data, loading, error }] = useApiAccessCreateAdminMutation({
 *   variables: {
 *      adminUserId: // value for 'adminUserId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useApiAccessCreateAdminMutation(baseOptions?: Apollo.MutationHookOptions<ApiAccessCreateAdminMutation, ApiAccessCreateAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiAccessCreateAdminMutation, ApiAccessCreateAdminMutationVariables>(ApiAccessCreateAdminDocument, options);
      }
export type ApiAccessCreateAdminMutationHookResult = ReturnType<typeof useApiAccessCreateAdminMutation>;
export type ApiAccessCreateAdminMutationResult = Apollo.MutationResult<ApiAccessCreateAdminMutation>;
export type ApiAccessCreateAdminMutationOptions = Apollo.BaseMutationOptions<ApiAccessCreateAdminMutation, ApiAccessCreateAdminMutationVariables>;
export const ApiAccessDeleteDocument = gql`
    mutation ApiAccessDelete($id: MongoID!) {
  apiAccessDelete(_id: $id) {
    recordId
  }
}
    `;
export type ApiAccessDeleteMutationFn = Apollo.MutationFunction<ApiAccessDeleteMutation, ApiAccessDeleteMutationVariables>;

/**
 * __useApiAccessDeleteMutation__
 *
 * To run a mutation, you first call `useApiAccessDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiAccessDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiAccessDeleteMutation, { data, loading, error }] = useApiAccessDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApiAccessDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ApiAccessDeleteMutation, ApiAccessDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiAccessDeleteMutation, ApiAccessDeleteMutationVariables>(ApiAccessDeleteDocument, options);
      }
export type ApiAccessDeleteMutationHookResult = ReturnType<typeof useApiAccessDeleteMutation>;
export type ApiAccessDeleteMutationResult = Apollo.MutationResult<ApiAccessDeleteMutation>;
export type ApiAccessDeleteMutationOptions = Apollo.BaseMutationOptions<ApiAccessDeleteMutation, ApiAccessDeleteMutationVariables>;
export const ApiAccessUpdateDocument = gql`
    mutation ApiAccessUpdate($id: MongoID!, $record: UpdateByIdApiAccessInput!) {
  apiAccessUpdate(_id: $id, record: $record) {
    record {
      _id
      token
      name
      description
      lastUsedAt
      createdDateISO
      updatedDateISO
      user {
        _id
        email
        firstName
        lastName
        userType
      }
    }
  }
}
    `;
export type ApiAccessUpdateMutationFn = Apollo.MutationFunction<ApiAccessUpdateMutation, ApiAccessUpdateMutationVariables>;

/**
 * __useApiAccessUpdateMutation__
 *
 * To run a mutation, you first call `useApiAccessUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiAccessUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiAccessUpdateMutation, { data, loading, error }] = useApiAccessUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useApiAccessUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ApiAccessUpdateMutation, ApiAccessUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiAccessUpdateMutation, ApiAccessUpdateMutationVariables>(ApiAccessUpdateDocument, options);
      }
export type ApiAccessUpdateMutationHookResult = ReturnType<typeof useApiAccessUpdateMutation>;
export type ApiAccessUpdateMutationResult = Apollo.MutationResult<ApiAccessUpdateMutation>;
export type ApiAccessUpdateMutationOptions = Apollo.BaseMutationOptions<ApiAccessUpdateMutation, ApiAccessUpdateMutationVariables>;
export const BookerApplyFeeAbsorptionDocument = gql`
    mutation BookerApplyFeeAbsorption($bookerId: MongoID!, $stripePercent: Float!, $stripeFixedCents: Int!, $roundingIncrementCents: Int!, $productIds: [String!]!, $overrides: [BookerFeeAbsorptionPriceOverrideInput!]) {
  bookerApplyFeeAbsorption(
    bookerId: $bookerId
    stripePercent: $stripePercent
    stripeFixedCents: $stripeFixedCents
    roundingIncrementCents: $roundingIncrementCents
    productIds: $productIds
    overrides: $overrides
  ) {
    _id
  }
}
    `;
export type BookerApplyFeeAbsorptionMutationFn = Apollo.MutationFunction<BookerApplyFeeAbsorptionMutation, BookerApplyFeeAbsorptionMutationVariables>;

/**
 * __useBookerApplyFeeAbsorptionMutation__
 *
 * To run a mutation, you first call `useBookerApplyFeeAbsorptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookerApplyFeeAbsorptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookerApplyFeeAbsorptionMutation, { data, loading, error }] = useBookerApplyFeeAbsorptionMutation({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      stripePercent: // value for 'stripePercent'
 *      stripeFixedCents: // value for 'stripeFixedCents'
 *      roundingIncrementCents: // value for 'roundingIncrementCents'
 *      productIds: // value for 'productIds'
 *      overrides: // value for 'overrides'
 *   },
 * });
 */
export function useBookerApplyFeeAbsorptionMutation(baseOptions?: Apollo.MutationHookOptions<BookerApplyFeeAbsorptionMutation, BookerApplyFeeAbsorptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookerApplyFeeAbsorptionMutation, BookerApplyFeeAbsorptionMutationVariables>(BookerApplyFeeAbsorptionDocument, options);
      }
export type BookerApplyFeeAbsorptionMutationHookResult = ReturnType<typeof useBookerApplyFeeAbsorptionMutation>;
export type BookerApplyFeeAbsorptionMutationResult = Apollo.MutationResult<BookerApplyFeeAbsorptionMutation>;
export type BookerApplyFeeAbsorptionMutationOptions = Apollo.BaseMutationOptions<BookerApplyFeeAbsorptionMutation, BookerApplyFeeAbsorptionMutationVariables>;
export const BookerCreateDocument = gql`
    mutation BookerCreate($record: CreateOneBookerInput!) {
  bookerCreate(record: $record) {
    record {
      _id
    }
  }
}
    `;
export type BookerCreateMutationFn = Apollo.MutationFunction<BookerCreateMutation, BookerCreateMutationVariables>;

/**
 * __useBookerCreateMutation__
 *
 * To run a mutation, you first call `useBookerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookerCreateMutation, { data, loading, error }] = useBookerCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useBookerCreateMutation(baseOptions?: Apollo.MutationHookOptions<BookerCreateMutation, BookerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookerCreateMutation, BookerCreateMutationVariables>(BookerCreateDocument, options);
      }
export type BookerCreateMutationHookResult = ReturnType<typeof useBookerCreateMutation>;
export type BookerCreateMutationResult = Apollo.MutationResult<BookerCreateMutation>;
export type BookerCreateMutationOptions = Apollo.BaseMutationOptions<BookerCreateMutation, BookerCreateMutationVariables>;
export const BookerDuplicateToStorefrontDocument = gql`
    mutation BookerDuplicateToStorefront($bookerId: MongoID!, $targetStorefrontId: MongoID!) {
  bookerDuplicateToStorefront(
    bookerId: $bookerId
    targetStorefrontId: $targetStorefrontId
  ) {
    bookerId
    storefrontId
  }
}
    `;
export type BookerDuplicateToStorefrontMutationFn = Apollo.MutationFunction<BookerDuplicateToStorefrontMutation, BookerDuplicateToStorefrontMutationVariables>;

/**
 * __useBookerDuplicateToStorefrontMutation__
 *
 * To run a mutation, you first call `useBookerDuplicateToStorefrontMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookerDuplicateToStorefrontMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookerDuplicateToStorefrontMutation, { data, loading, error }] = useBookerDuplicateToStorefrontMutation({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      targetStorefrontId: // value for 'targetStorefrontId'
 *   },
 * });
 */
export function useBookerDuplicateToStorefrontMutation(baseOptions?: Apollo.MutationHookOptions<BookerDuplicateToStorefrontMutation, BookerDuplicateToStorefrontMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookerDuplicateToStorefrontMutation, BookerDuplicateToStorefrontMutationVariables>(BookerDuplicateToStorefrontDocument, options);
      }
export type BookerDuplicateToStorefrontMutationHookResult = ReturnType<typeof useBookerDuplicateToStorefrontMutation>;
export type BookerDuplicateToStorefrontMutationResult = Apollo.MutationResult<BookerDuplicateToStorefrontMutation>;
export type BookerDuplicateToStorefrontMutationOptions = Apollo.BaseMutationOptions<BookerDuplicateToStorefrontMutation, BookerDuplicateToStorefrontMutationVariables>;
export const BookerRevertFeeAbsorptionDocument = gql`
    mutation BookerRevertFeeAbsorption($bookerId: MongoID!) {
  bookerRevertFeeAbsorption(bookerId: $bookerId) {
    restoredCount
    skipped {
      productId
      productName
      path
      label
    }
    booker {
      _id
    }
  }
}
    `;
export type BookerRevertFeeAbsorptionMutationFn = Apollo.MutationFunction<BookerRevertFeeAbsorptionMutation, BookerRevertFeeAbsorptionMutationVariables>;

/**
 * __useBookerRevertFeeAbsorptionMutation__
 *
 * To run a mutation, you first call `useBookerRevertFeeAbsorptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookerRevertFeeAbsorptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookerRevertFeeAbsorptionMutation, { data, loading, error }] = useBookerRevertFeeAbsorptionMutation({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *   },
 * });
 */
export function useBookerRevertFeeAbsorptionMutation(baseOptions?: Apollo.MutationHookOptions<BookerRevertFeeAbsorptionMutation, BookerRevertFeeAbsorptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookerRevertFeeAbsorptionMutation, BookerRevertFeeAbsorptionMutationVariables>(BookerRevertFeeAbsorptionDocument, options);
      }
export type BookerRevertFeeAbsorptionMutationHookResult = ReturnType<typeof useBookerRevertFeeAbsorptionMutation>;
export type BookerRevertFeeAbsorptionMutationResult = Apollo.MutationResult<BookerRevertFeeAbsorptionMutation>;
export type BookerRevertFeeAbsorptionMutationOptions = Apollo.BaseMutationOptions<BookerRevertFeeAbsorptionMutation, BookerRevertFeeAbsorptionMutationVariables>;
export const BookerSendConfirmationTestEmailDocument = gql`
    mutation BookerSendConfirmationTestEmail($bookerId: MongoID!, $recipientUserId: ID!, $subject: String, $bodyHtml: String, $ctaLabel: String, $ctaUrl: String) {
  bookerSendConfirmationTestEmail(
    bookerId: $bookerId
    recipientUserId: $recipientUserId
    subject: $subject
    bodyHtml: $bodyHtml
    ctaLabel: $ctaLabel
    ctaUrl: $ctaUrl
  )
}
    `;
export type BookerSendConfirmationTestEmailMutationFn = Apollo.MutationFunction<BookerSendConfirmationTestEmailMutation, BookerSendConfirmationTestEmailMutationVariables>;

/**
 * __useBookerSendConfirmationTestEmailMutation__
 *
 * To run a mutation, you first call `useBookerSendConfirmationTestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookerSendConfirmationTestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookerSendConfirmationTestEmailMutation, { data, loading, error }] = useBookerSendConfirmationTestEmailMutation({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      recipientUserId: // value for 'recipientUserId'
 *      subject: // value for 'subject'
 *      bodyHtml: // value for 'bodyHtml'
 *      ctaLabel: // value for 'ctaLabel'
 *      ctaUrl: // value for 'ctaUrl'
 *   },
 * });
 */
export function useBookerSendConfirmationTestEmailMutation(baseOptions?: Apollo.MutationHookOptions<BookerSendConfirmationTestEmailMutation, BookerSendConfirmationTestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookerSendConfirmationTestEmailMutation, BookerSendConfirmationTestEmailMutationVariables>(BookerSendConfirmationTestEmailDocument, options);
      }
export type BookerSendConfirmationTestEmailMutationHookResult = ReturnType<typeof useBookerSendConfirmationTestEmailMutation>;
export type BookerSendConfirmationTestEmailMutationResult = Apollo.MutationResult<BookerSendConfirmationTestEmailMutation>;
export type BookerSendConfirmationTestEmailMutationOptions = Apollo.BaseMutationOptions<BookerSendConfirmationTestEmailMutation, BookerSendConfirmationTestEmailMutationVariables>;
export const BookerSetApplicationFeeDocument = gql`
    mutation BookerSetApplicationFee($bookerId: String!, $applicationPercentage: Float!, $customerApplicationPercentage: Float!) {
  bookerSetApplicationFee(
    bookerId: $bookerId
    applicationPercentage: $applicationPercentage
    customerApplicationPercentage: $customerApplicationPercentage
  ) {
    _id
    paymentMetadata {
      applicationPercentage
      customerApplicationPercentage
    }
  }
}
    `;
export type BookerSetApplicationFeeMutationFn = Apollo.MutationFunction<BookerSetApplicationFeeMutation, BookerSetApplicationFeeMutationVariables>;

/**
 * __useBookerSetApplicationFeeMutation__
 *
 * To run a mutation, you first call `useBookerSetApplicationFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookerSetApplicationFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookerSetApplicationFeeMutation, { data, loading, error }] = useBookerSetApplicationFeeMutation({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      applicationPercentage: // value for 'applicationPercentage'
 *      customerApplicationPercentage: // value for 'customerApplicationPercentage'
 *   },
 * });
 */
export function useBookerSetApplicationFeeMutation(baseOptions?: Apollo.MutationHookOptions<BookerSetApplicationFeeMutation, BookerSetApplicationFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookerSetApplicationFeeMutation, BookerSetApplicationFeeMutationVariables>(BookerSetApplicationFeeDocument, options);
      }
export type BookerSetApplicationFeeMutationHookResult = ReturnType<typeof useBookerSetApplicationFeeMutation>;
export type BookerSetApplicationFeeMutationResult = Apollo.MutationResult<BookerSetApplicationFeeMutation>;
export type BookerSetApplicationFeeMutationOptions = Apollo.BaseMutationOptions<BookerSetApplicationFeeMutation, BookerSetApplicationFeeMutationVariables>;
export const BookerUpdateDocument = gql`
    mutation BookerUpdate($id: MongoID!, $record: UpdateByIdBookerInput!) {
  bookerUpdate(_id: $id, record: $record) {
    record {
      _id
    }
  }
}
    `;
export type BookerUpdateMutationFn = Apollo.MutationFunction<BookerUpdateMutation, BookerUpdateMutationVariables>;

/**
 * __useBookerUpdateMutation__
 *
 * To run a mutation, you first call `useBookerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookerUpdateMutation, { data, loading, error }] = useBookerUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useBookerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BookerUpdateMutation, BookerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookerUpdateMutation, BookerUpdateMutationVariables>(BookerUpdateDocument, options);
      }
export type BookerUpdateMutationHookResult = ReturnType<typeof useBookerUpdateMutation>;
export type BookerUpdateMutationResult = Apollo.MutationResult<BookerUpdateMutation>;
export type BookerUpdateMutationOptions = Apollo.BaseMutationOptions<BookerUpdateMutation, BookerUpdateMutationVariables>;
export const BroadcastCloneByIdDocument = gql`
    mutation BroadcastCloneById($input: BroadcastCloneInput!) {
  broadcastCloneById(input: $input) {
    ...BroadcastFragment
  }
}
    ${BroadcastFragmentFragmentDoc}`;
export type BroadcastCloneByIdMutationFn = Apollo.MutationFunction<BroadcastCloneByIdMutation, BroadcastCloneByIdMutationVariables>;

/**
 * __useBroadcastCloneByIdMutation__
 *
 * To run a mutation, you first call `useBroadcastCloneByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBroadcastCloneByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [broadcastCloneByIdMutation, { data, loading, error }] = useBroadcastCloneByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBroadcastCloneByIdMutation(baseOptions?: Apollo.MutationHookOptions<BroadcastCloneByIdMutation, BroadcastCloneByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BroadcastCloneByIdMutation, BroadcastCloneByIdMutationVariables>(BroadcastCloneByIdDocument, options);
      }
export type BroadcastCloneByIdMutationHookResult = ReturnType<typeof useBroadcastCloneByIdMutation>;
export type BroadcastCloneByIdMutationResult = Apollo.MutationResult<BroadcastCloneByIdMutation>;
export type BroadcastCloneByIdMutationOptions = Apollo.BaseMutationOptions<BroadcastCloneByIdMutation, BroadcastCloneByIdMutationVariables>;
export const BroadcastCreateOneDocument = gql`
    mutation BroadcastCreateOne($record: CreateOneBroadcastInput!) {
  broadcastCreateOne(record: $record) {
    record {
      _id
    }
  }
}
    `;
export type BroadcastCreateOneMutationFn = Apollo.MutationFunction<BroadcastCreateOneMutation, BroadcastCreateOneMutationVariables>;

/**
 * __useBroadcastCreateOneMutation__
 *
 * To run a mutation, you first call `useBroadcastCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBroadcastCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [broadcastCreateOneMutation, { data, loading, error }] = useBroadcastCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useBroadcastCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<BroadcastCreateOneMutation, BroadcastCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BroadcastCreateOneMutation, BroadcastCreateOneMutationVariables>(BroadcastCreateOneDocument, options);
      }
export type BroadcastCreateOneMutationHookResult = ReturnType<typeof useBroadcastCreateOneMutation>;
export type BroadcastCreateOneMutationResult = Apollo.MutationResult<BroadcastCreateOneMutation>;
export type BroadcastCreateOneMutationOptions = Apollo.BaseMutationOptions<BroadcastCreateOneMutation, BroadcastCreateOneMutationVariables>;
export const BroadcastUpdateByIdDocument = gql`
    mutation BroadcastUpdateById($id: MongoID!, $record: UpdateByIdBroadcastInput!) {
  broadcastUpdateById(_id: $id, record: $record) {
    record {
      _id
    }
  }
}
    `;
export type BroadcastUpdateByIdMutationFn = Apollo.MutationFunction<BroadcastUpdateByIdMutation, BroadcastUpdateByIdMutationVariables>;

/**
 * __useBroadcastUpdateByIdMutation__
 *
 * To run a mutation, you first call `useBroadcastUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBroadcastUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [broadcastUpdateByIdMutation, { data, loading, error }] = useBroadcastUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useBroadcastUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<BroadcastUpdateByIdMutation, BroadcastUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BroadcastUpdateByIdMutation, BroadcastUpdateByIdMutationVariables>(BroadcastUpdateByIdDocument, options);
      }
export type BroadcastUpdateByIdMutationHookResult = ReturnType<typeof useBroadcastUpdateByIdMutation>;
export type BroadcastUpdateByIdMutationResult = Apollo.MutationResult<BroadcastUpdateByIdMutation>;
export type BroadcastUpdateByIdMutationOptions = Apollo.BaseMutationOptions<BroadcastUpdateByIdMutation, BroadcastUpdateByIdMutationVariables>;
export const BulkConnectLogRollbackDocument = gql`
    mutation BulkConnectLogRollback($bulkConnectLogId: ID!) {
  bulkConnectLogRollback(bulkConnectLogId: $bulkConnectLogId) {
    _id
    rollbackInfo {
      rolledBackAt
      rolledBackBy
      disconnectedCount
      errorCount
      errorMessages
    }
  }
}
    `;
export type BulkConnectLogRollbackMutationFn = Apollo.MutationFunction<BulkConnectLogRollbackMutation, BulkConnectLogRollbackMutationVariables>;

/**
 * __useBulkConnectLogRollbackMutation__
 *
 * To run a mutation, you first call `useBulkConnectLogRollbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkConnectLogRollbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkConnectLogRollbackMutation, { data, loading, error }] = useBulkConnectLogRollbackMutation({
 *   variables: {
 *      bulkConnectLogId: // value for 'bulkConnectLogId'
 *   },
 * });
 */
export function useBulkConnectLogRollbackMutation(baseOptions?: Apollo.MutationHookOptions<BulkConnectLogRollbackMutation, BulkConnectLogRollbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkConnectLogRollbackMutation, BulkConnectLogRollbackMutationVariables>(BulkConnectLogRollbackDocument, options);
      }
export type BulkConnectLogRollbackMutationHookResult = ReturnType<typeof useBulkConnectLogRollbackMutation>;
export type BulkConnectLogRollbackMutationResult = Apollo.MutationResult<BulkConnectLogRollbackMutation>;
export type BulkConnectLogRollbackMutationOptions = Apollo.BaseMutationOptions<BulkConnectLogRollbackMutation, BulkConnectLogRollbackMutationVariables>;
export const ClosuresCreatePerProductDocument = gql`
    mutation ClosuresCreatePerProduct($productIds: [ID!]!, $name: String!, $startIso: String!, $endIso: String!) {
  createClosuresPerProduct(
    productIds: $productIds
    name: $name
    startISO: $startIso
    endISO: $endIso
  )
}
    `;
export type ClosuresCreatePerProductMutationFn = Apollo.MutationFunction<ClosuresCreatePerProductMutation, ClosuresCreatePerProductMutationVariables>;

/**
 * __useClosuresCreatePerProductMutation__
 *
 * To run a mutation, you first call `useClosuresCreatePerProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClosuresCreatePerProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closuresCreatePerProductMutation, { data, loading, error }] = useClosuresCreatePerProductMutation({
 *   variables: {
 *      productIds: // value for 'productIds'
 *      name: // value for 'name'
 *      startIso: // value for 'startIso'
 *      endIso: // value for 'endIso'
 *   },
 * });
 */
export function useClosuresCreatePerProductMutation(baseOptions?: Apollo.MutationHookOptions<ClosuresCreatePerProductMutation, ClosuresCreatePerProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClosuresCreatePerProductMutation, ClosuresCreatePerProductMutationVariables>(ClosuresCreatePerProductDocument, options);
      }
export type ClosuresCreatePerProductMutationHookResult = ReturnType<typeof useClosuresCreatePerProductMutation>;
export type ClosuresCreatePerProductMutationResult = Apollo.MutationResult<ClosuresCreatePerProductMutation>;
export type ClosuresCreatePerProductMutationOptions = Apollo.BaseMutationOptions<ClosuresCreatePerProductMutation, ClosuresCreatePerProductMutationVariables>;
export const ClosuresUpdatePerProductDocument = gql`
    mutation ClosuresUpdatePerProduct($closureId: ID!, $deleteClosure: Boolean!, $productIds: [ID!], $name: String, $startIso: String, $endIso: String) {
  updateClosuresPerProduct(
    closureId: $closureId
    deleteClosure: $deleteClosure
    productIds: $productIds
    name: $name
    startISO: $startIso
    endISO: $endIso
  )
}
    `;
export type ClosuresUpdatePerProductMutationFn = Apollo.MutationFunction<ClosuresUpdatePerProductMutation, ClosuresUpdatePerProductMutationVariables>;

/**
 * __useClosuresUpdatePerProductMutation__
 *
 * To run a mutation, you first call `useClosuresUpdatePerProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClosuresUpdatePerProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closuresUpdatePerProductMutation, { data, loading, error }] = useClosuresUpdatePerProductMutation({
 *   variables: {
 *      closureId: // value for 'closureId'
 *      deleteClosure: // value for 'deleteClosure'
 *      productIds: // value for 'productIds'
 *      name: // value for 'name'
 *      startIso: // value for 'startIso'
 *      endIso: // value for 'endIso'
 *   },
 * });
 */
export function useClosuresUpdatePerProductMutation(baseOptions?: Apollo.MutationHookOptions<ClosuresUpdatePerProductMutation, ClosuresUpdatePerProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClosuresUpdatePerProductMutation, ClosuresUpdatePerProductMutationVariables>(ClosuresUpdatePerProductDocument, options);
      }
export type ClosuresUpdatePerProductMutationHookResult = ReturnType<typeof useClosuresUpdatePerProductMutation>;
export type ClosuresUpdatePerProductMutationResult = Apollo.MutationResult<ClosuresUpdatePerProductMutation>;
export type ClosuresUpdatePerProductMutationOptions = Apollo.BaseMutationOptions<ClosuresUpdatePerProductMutation, ClosuresUpdatePerProductMutationVariables>;
export const CourseProgressSaveDocument = gql`
    mutation CourseProgressSave($resourceId: MongoID!, $broadcastId: MongoID!, $scormData: JSON!, $scormVersion: String) {
  courseProgressSave(
    resourceId: $resourceId
    broadcastId: $broadcastId
    scormData: $scormData
    scormVersion: $scormVersion
  ) {
    _id
    user
    resourceId
    broadcast
    completionStatus
    successStatus
    scoreScaled
    scoreRaw
    location
    suspendData
    totalTime
    progressMeasure
    lastAccessedAt
    completedAt
    scormVersion
  }
}
    `;
export type CourseProgressSaveMutationFn = Apollo.MutationFunction<CourseProgressSaveMutation, CourseProgressSaveMutationVariables>;

/**
 * __useCourseProgressSaveMutation__
 *
 * To run a mutation, you first call `useCourseProgressSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseProgressSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseProgressSaveMutation, { data, loading, error }] = useCourseProgressSaveMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      broadcastId: // value for 'broadcastId'
 *      scormData: // value for 'scormData'
 *      scormVersion: // value for 'scormVersion'
 *   },
 * });
 */
export function useCourseProgressSaveMutation(baseOptions?: Apollo.MutationHookOptions<CourseProgressSaveMutation, CourseProgressSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseProgressSaveMutation, CourseProgressSaveMutationVariables>(CourseProgressSaveDocument, options);
      }
export type CourseProgressSaveMutationHookResult = ReturnType<typeof useCourseProgressSaveMutation>;
export type CourseProgressSaveMutationResult = Apollo.MutationResult<CourseProgressSaveMutation>;
export type CourseProgressSaveMutationOptions = Apollo.BaseMutationOptions<CourseProgressSaveMutation, CourseProgressSaveMutationVariables>;
export const CreateBulkConnectLogDocument = gql`
    mutation CreateBulkConnectLog($input: CreateBulkConnectLogInput!) {
  createBulkConnectLog(input: $input) {
    _id
    totalCount
    successCount
    alreadyConnectedCount
    errorCount
    appliedBackOfficeTagIds
  }
}
    `;
export type CreateBulkConnectLogMutationFn = Apollo.MutationFunction<CreateBulkConnectLogMutation, CreateBulkConnectLogMutationVariables>;

/**
 * __useCreateBulkConnectLogMutation__
 *
 * To run a mutation, you first call `useCreateBulkConnectLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkConnectLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkConnectLogMutation, { data, loading, error }] = useCreateBulkConnectLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBulkConnectLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateBulkConnectLogMutation, CreateBulkConnectLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBulkConnectLogMutation, CreateBulkConnectLogMutationVariables>(CreateBulkConnectLogDocument, options);
      }
export type CreateBulkConnectLogMutationHookResult = ReturnType<typeof useCreateBulkConnectLogMutation>;
export type CreateBulkConnectLogMutationResult = Apollo.MutationResult<CreateBulkConnectLogMutation>;
export type CreateBulkConnectLogMutationOptions = Apollo.BaseMutationOptions<CreateBulkConnectLogMutation, CreateBulkConnectLogMutationVariables>;
export const OrderCreateDocument = gql`
    mutation OrderCreate($source: OrderSourceInput!, $customer: PeopleInput!, $guests: [OrderGuestsInput]!, $paymentMethodId: String!, $productPurchaseRequests: [ProductPurchaseRequest]!, $promoCode: String, $surveyResponse: SurveyResponseInput, $taxExemption: OrderTaxExemptionInput, $delivery: OrderDeliveryInput, $messageFromGuest: String) {
  orderCreate(
    source: $source
    customer: $customer
    guests: $guests
    paymentMethodId: $paymentMethodId
    productPurchaseRequests: $productPurchaseRequests
    promoCode: $promoCode
    surveyResponse: $surveyResponse
    taxExemption: $taxExemption
    delivery: $delivery
    messageFromGuest: $messageFromGuest
  ) {
    record {
      _id
    }
    clientSecret
  }
}
    `;
export type OrderCreateMutationFn = Apollo.MutationFunction<OrderCreateMutation, OrderCreateMutationVariables>;

/**
 * __useOrderCreateMutation__
 *
 * To run a mutation, you first call `useOrderCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCreateMutation, { data, loading, error }] = useOrderCreateMutation({
 *   variables: {
 *      source: // value for 'source'
 *      customer: // value for 'customer'
 *      guests: // value for 'guests'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      productPurchaseRequests: // value for 'productPurchaseRequests'
 *      promoCode: // value for 'promoCode'
 *      surveyResponse: // value for 'surveyResponse'
 *      taxExemption: // value for 'taxExemption'
 *      delivery: // value for 'delivery'
 *      messageFromGuest: // value for 'messageFromGuest'
 *   },
 * });
 */
export function useOrderCreateMutation(baseOptions?: Apollo.MutationHookOptions<OrderCreateMutation, OrderCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderCreateMutation, OrderCreateMutationVariables>(OrderCreateDocument, options);
      }
export type OrderCreateMutationHookResult = ReturnType<typeof useOrderCreateMutation>;
export type OrderCreateMutationResult = Apollo.MutationResult<OrderCreateMutation>;
export type OrderCreateMutationOptions = Apollo.BaseMutationOptions<OrderCreateMutation, OrderCreateMutationVariables>;
export const CreatePublicationStatusDocument = gql`
    mutation CreatePublicationStatus($record: CreateOnePublicationStatusInput!) {
  createPublicationStatus(record: $record) {
    record {
      _id
      status
      entity {
        _entityId
        _versionId
        type
      }
    }
  }
}
    `;
export type CreatePublicationStatusMutationFn = Apollo.MutationFunction<CreatePublicationStatusMutation, CreatePublicationStatusMutationVariables>;

/**
 * __useCreatePublicationStatusMutation__
 *
 * To run a mutation, you first call `useCreatePublicationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicationStatusMutation, { data, loading, error }] = useCreatePublicationStatusMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCreatePublicationStatusMutation(baseOptions?: Apollo.MutationHookOptions<CreatePublicationStatusMutation, CreatePublicationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePublicationStatusMutation, CreatePublicationStatusMutationVariables>(CreatePublicationStatusDocument, options);
      }
export type CreatePublicationStatusMutationHookResult = ReturnType<typeof useCreatePublicationStatusMutation>;
export type CreatePublicationStatusMutationResult = Apollo.MutationResult<CreatePublicationStatusMutation>;
export type CreatePublicationStatusMutationOptions = Apollo.BaseMutationOptions<CreatePublicationStatusMutation, CreatePublicationStatusMutationVariables>;
export const CronJobRunDocument = gql`
    mutation CronJobRun($jobName: String!) {
  cronJobRun(jobName: $jobName) {
    success
    jobName
    status
    durationMs
    error
  }
}
    `;
export type CronJobRunMutationFn = Apollo.MutationFunction<CronJobRunMutation, CronJobRunMutationVariables>;

/**
 * __useCronJobRunMutation__
 *
 * To run a mutation, you first call `useCronJobRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCronJobRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cronJobRunMutation, { data, loading, error }] = useCronJobRunMutation({
 *   variables: {
 *      jobName: // value for 'jobName'
 *   },
 * });
 */
export function useCronJobRunMutation(baseOptions?: Apollo.MutationHookOptions<CronJobRunMutation, CronJobRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CronJobRunMutation, CronJobRunMutationVariables>(CronJobRunDocument, options);
      }
export type CronJobRunMutationHookResult = ReturnType<typeof useCronJobRunMutation>;
export type CronJobRunMutationResult = Apollo.MutationResult<CronJobRunMutation>;
export type CronJobRunMutationOptions = Apollo.BaseMutationOptions<CronJobRunMutation, CronJobRunMutationVariables>;
export const DevToolsEmailReplaceDocument = gql`
    mutation DevToolsEmailReplace($entries: [DevToolsEmailReplaceEntryInput!]!) {
  devToolsEmailReplace(entries: $entries)
}
    `;
export type DevToolsEmailReplaceMutationFn = Apollo.MutationFunction<DevToolsEmailReplaceMutation, DevToolsEmailReplaceMutationVariables>;

/**
 * __useDevToolsEmailReplaceMutation__
 *
 * To run a mutation, you first call `useDevToolsEmailReplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevToolsEmailReplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devToolsEmailReplaceMutation, { data, loading, error }] = useDevToolsEmailReplaceMutation({
 *   variables: {
 *      entries: // value for 'entries'
 *   },
 * });
 */
export function useDevToolsEmailReplaceMutation(baseOptions?: Apollo.MutationHookOptions<DevToolsEmailReplaceMutation, DevToolsEmailReplaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevToolsEmailReplaceMutation, DevToolsEmailReplaceMutationVariables>(DevToolsEmailReplaceDocument, options);
      }
export type DevToolsEmailReplaceMutationHookResult = ReturnType<typeof useDevToolsEmailReplaceMutation>;
export type DevToolsEmailReplaceMutationResult = Apollo.MutationResult<DevToolsEmailReplaceMutation>;
export type DevToolsEmailReplaceMutationOptions = Apollo.BaseMutationOptions<DevToolsEmailReplaceMutation, DevToolsEmailReplaceMutationVariables>;
export const DevToolsMembershipSeedCleanupDocument = gql`
    mutation DevToolsMembershipSeedCleanup($runId: MongoID!) {
  devToolsMembershipSeedCleanup(runId: $runId) {
    _id
    status
    cleanedAt
    cleanedByName
    rows {
      caseKey
      cleanupMessages
    }
  }
}
    `;
export type DevToolsMembershipSeedCleanupMutationFn = Apollo.MutationFunction<DevToolsMembershipSeedCleanupMutation, DevToolsMembershipSeedCleanupMutationVariables>;

/**
 * __useDevToolsMembershipSeedCleanupMutation__
 *
 * To run a mutation, you first call `useDevToolsMembershipSeedCleanupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevToolsMembershipSeedCleanupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devToolsMembershipSeedCleanupMutation, { data, loading, error }] = useDevToolsMembershipSeedCleanupMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useDevToolsMembershipSeedCleanupMutation(baseOptions?: Apollo.MutationHookOptions<DevToolsMembershipSeedCleanupMutation, DevToolsMembershipSeedCleanupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevToolsMembershipSeedCleanupMutation, DevToolsMembershipSeedCleanupMutationVariables>(DevToolsMembershipSeedCleanupDocument, options);
      }
export type DevToolsMembershipSeedCleanupMutationHookResult = ReturnType<typeof useDevToolsMembershipSeedCleanupMutation>;
export type DevToolsMembershipSeedCleanupMutationResult = Apollo.MutationResult<DevToolsMembershipSeedCleanupMutation>;
export type DevToolsMembershipSeedCleanupMutationOptions = Apollo.BaseMutationOptions<DevToolsMembershipSeedCleanupMutation, DevToolsMembershipSeedCleanupMutationVariables>;
export const DevToolsMembershipSeedCreateDocument = gql`
    mutation DevToolsMembershipSeedCreate($input: DevMembershipSeedInput!) {
  devToolsMembershipSeedCreate(input: $input) {
    _id
    organization
    status
    createdByName
    createdDateISO
    rows {
      caseKey
      mode
      subjectType
      entityComposition
      publicationStatus
      blocked
      blockReason
      warnings
      tierName
      statusTagNames
      renewalDate
      renewalPhase
      rateKind
      rateLabel
      operatorEntityId
      operatorName
      personId
      personEmail
      membershipId
      originalOrderId
      renewablePurchaseId
      validationOk
      validationMessages
    }
  }
}
    `;
export type DevToolsMembershipSeedCreateMutationFn = Apollo.MutationFunction<DevToolsMembershipSeedCreateMutation, DevToolsMembershipSeedCreateMutationVariables>;

/**
 * __useDevToolsMembershipSeedCreateMutation__
 *
 * To run a mutation, you first call `useDevToolsMembershipSeedCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevToolsMembershipSeedCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devToolsMembershipSeedCreateMutation, { data, loading, error }] = useDevToolsMembershipSeedCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDevToolsMembershipSeedCreateMutation(baseOptions?: Apollo.MutationHookOptions<DevToolsMembershipSeedCreateMutation, DevToolsMembershipSeedCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevToolsMembershipSeedCreateMutation, DevToolsMembershipSeedCreateMutationVariables>(DevToolsMembershipSeedCreateDocument, options);
      }
export type DevToolsMembershipSeedCreateMutationHookResult = ReturnType<typeof useDevToolsMembershipSeedCreateMutation>;
export type DevToolsMembershipSeedCreateMutationResult = Apollo.MutationResult<DevToolsMembershipSeedCreateMutation>;
export type DevToolsMembershipSeedCreateMutationOptions = Apollo.BaseMutationOptions<DevToolsMembershipSeedCreateMutation, DevToolsMembershipSeedCreateMutationVariables>;
export const DevToolsProdSyncDocument = gql`
    mutation DevToolsProdSync($collectionsToSkip: [String!]) {
  devToolsProdSync(collectionsToSkip: $collectionsToSkip) {
    success
    collections {
      name
      documentsCopied
      skipped
      error
    }
    totalDocumentsCopied
    durationMs
    errors
  }
}
    `;
export type DevToolsProdSyncMutationFn = Apollo.MutationFunction<DevToolsProdSyncMutation, DevToolsProdSyncMutationVariables>;

/**
 * __useDevToolsProdSyncMutation__
 *
 * To run a mutation, you first call `useDevToolsProdSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevToolsProdSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devToolsProdSyncMutation, { data, loading, error }] = useDevToolsProdSyncMutation({
 *   variables: {
 *      collectionsToSkip: // value for 'collectionsToSkip'
 *   },
 * });
 */
export function useDevToolsProdSyncMutation(baseOptions?: Apollo.MutationHookOptions<DevToolsProdSyncMutation, DevToolsProdSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevToolsProdSyncMutation, DevToolsProdSyncMutationVariables>(DevToolsProdSyncDocument, options);
      }
export type DevToolsProdSyncMutationHookResult = ReturnType<typeof useDevToolsProdSyncMutation>;
export type DevToolsProdSyncMutationResult = Apollo.MutationResult<DevToolsProdSyncMutation>;
export type DevToolsProdSyncMutationOptions = Apollo.BaseMutationOptions<DevToolsProdSyncMutation, DevToolsProdSyncMutationVariables>;
export const DirectoryBulkInviteDocument = gql`
    mutation DirectoryBulkInvite($organizationId: ID!, $viewContext: BulkInviteViewContext, $tagFilters: [BulkInviteTagFilterInput], $recipientMode: BulkInviteRecipientMode, $includeDmoManaged: Boolean) {
  directoryBulkInvite(
    organizationId: $organizationId
    viewContext: $viewContext
    tagFilters: $tagFilters
    recipientMode: $recipientMode
    includeDmoManaged: $includeDmoManaged
  ) {
    queuedListings
    queuedRecipients
    skipped
  }
}
    `;
export type DirectoryBulkInviteMutationFn = Apollo.MutationFunction<DirectoryBulkInviteMutation, DirectoryBulkInviteMutationVariables>;

/**
 * __useDirectoryBulkInviteMutation__
 *
 * To run a mutation, you first call `useDirectoryBulkInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDirectoryBulkInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [directoryBulkInviteMutation, { data, loading, error }] = useDirectoryBulkInviteMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      viewContext: // value for 'viewContext'
 *      tagFilters: // value for 'tagFilters'
 *      recipientMode: // value for 'recipientMode'
 *      includeDmoManaged: // value for 'includeDmoManaged'
 *   },
 * });
 */
export function useDirectoryBulkInviteMutation(baseOptions?: Apollo.MutationHookOptions<DirectoryBulkInviteMutation, DirectoryBulkInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DirectoryBulkInviteMutation, DirectoryBulkInviteMutationVariables>(DirectoryBulkInviteDocument, options);
      }
export type DirectoryBulkInviteMutationHookResult = ReturnType<typeof useDirectoryBulkInviteMutation>;
export type DirectoryBulkInviteMutationResult = Apollo.MutationResult<DirectoryBulkInviteMutation>;
export type DirectoryBulkInviteMutationOptions = Apollo.BaseMutationOptions<DirectoryBulkInviteMutation, DirectoryBulkInviteMutationVariables>;
export const DiscountCreateDocument = gql`
    mutation DiscountCreate($record: CreateOneDiscountInput!) {
  discountCreate(record: $record) {
    recordId
    record {
      ...DiscountFragment
    }
  }
}
    ${DiscountFragmentFragmentDoc}`;
export type DiscountCreateMutationFn = Apollo.MutationFunction<DiscountCreateMutation, DiscountCreateMutationVariables>;

/**
 * __useDiscountCreateMutation__
 *
 * To run a mutation, you first call `useDiscountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discountCreateMutation, { data, loading, error }] = useDiscountCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useDiscountCreateMutation(baseOptions?: Apollo.MutationHookOptions<DiscountCreateMutation, DiscountCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscountCreateMutation, DiscountCreateMutationVariables>(DiscountCreateDocument, options);
      }
export type DiscountCreateMutationHookResult = ReturnType<typeof useDiscountCreateMutation>;
export type DiscountCreateMutationResult = Apollo.MutationResult<DiscountCreateMutation>;
export type DiscountCreateMutationOptions = Apollo.BaseMutationOptions<DiscountCreateMutation, DiscountCreateMutationVariables>;
export const DiscountUpdateDocument = gql`
    mutation DiscountUpdate($id: MongoID!, $record: UpdateByIdDiscountInput!) {
  discountUpdate(_id: $id, record: $record) {
    recordId
    record {
      ...DiscountFragment
    }
  }
}
    ${DiscountFragmentFragmentDoc}`;
export type DiscountUpdateMutationFn = Apollo.MutationFunction<DiscountUpdateMutation, DiscountUpdateMutationVariables>;

/**
 * __useDiscountUpdateMutation__
 *
 * To run a mutation, you first call `useDiscountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discountUpdateMutation, { data, loading, error }] = useDiscountUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useDiscountUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DiscountUpdateMutation, DiscountUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscountUpdateMutation, DiscountUpdateMutationVariables>(DiscountUpdateDocument, options);
      }
export type DiscountUpdateMutationHookResult = ReturnType<typeof useDiscountUpdateMutation>;
export type DiscountUpdateMutationResult = Apollo.MutationResult<DiscountUpdateMutation>;
export type DiscountUpdateMutationOptions = Apollo.BaseMutationOptions<DiscountUpdateMutation, DiscountUpdateMutationVariables>;
export const DiscountValidatePromocodeDocument = gql`
    mutation DiscountValidatePromocode($promoCode: String!, $storefrontId: ID!, $bookerId: ID, $productPurchaseRequests: [ProductPurchaseRequest!]) {
  discountValidatePromocode(
    promoCode: $promoCode
    storefrontId: $storefrontId
    bookerId: $bookerId
    productPurchaseRequests: $productPurchaseRequests
  ) {
    promoCode
  }
}
    `;
export type DiscountValidatePromocodeMutationFn = Apollo.MutationFunction<DiscountValidatePromocodeMutation, DiscountValidatePromocodeMutationVariables>;

/**
 * __useDiscountValidatePromocodeMutation__
 *
 * To run a mutation, you first call `useDiscountValidatePromocodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscountValidatePromocodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discountValidatePromocodeMutation, { data, loading, error }] = useDiscountValidatePromocodeMutation({
 *   variables: {
 *      promoCode: // value for 'promoCode'
 *      storefrontId: // value for 'storefrontId'
 *      bookerId: // value for 'bookerId'
 *      productPurchaseRequests: // value for 'productPurchaseRequests'
 *   },
 * });
 */
export function useDiscountValidatePromocodeMutation(baseOptions?: Apollo.MutationHookOptions<DiscountValidatePromocodeMutation, DiscountValidatePromocodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscountValidatePromocodeMutation, DiscountValidatePromocodeMutationVariables>(DiscountValidatePromocodeDocument, options);
      }
export type DiscountValidatePromocodeMutationHookResult = ReturnType<typeof useDiscountValidatePromocodeMutation>;
export type DiscountValidatePromocodeMutationResult = Apollo.MutationResult<DiscountValidatePromocodeMutation>;
export type DiscountValidatePromocodeMutationOptions = Apollo.BaseMutationOptions<DiscountValidatePromocodeMutation, DiscountValidatePromocodeMutationVariables>;
export const EventCreateDocument = gql`
    mutation EventCreate($record: CreateOneEventInput!) {
  eventCreate(record: $record) {
    recordId
    record {
      ...EventDetailsFragment
    }
  }
}
    ${EventDetailsFragmentFragmentDoc}`;
export type EventCreateMutationFn = Apollo.MutationFunction<EventCreateMutation, EventCreateMutationVariables>;

/**
 * __useEventCreateMutation__
 *
 * To run a mutation, you first call `useEventCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventCreateMutation, { data, loading, error }] = useEventCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useEventCreateMutation(baseOptions?: Apollo.MutationHookOptions<EventCreateMutation, EventCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventCreateMutation, EventCreateMutationVariables>(EventCreateDocument, options);
      }
export type EventCreateMutationHookResult = ReturnType<typeof useEventCreateMutation>;
export type EventCreateMutationResult = Apollo.MutationResult<EventCreateMutation>;
export type EventCreateMutationOptions = Apollo.BaseMutationOptions<EventCreateMutation, EventCreateMutationVariables>;
export const EventDeleteByIdDocument = gql`
    mutation EventDeleteById($id: MongoID!) {
  eventDeleteById(_id: $id) {
    record {
      _id
    }
  }
}
    `;
export type EventDeleteByIdMutationFn = Apollo.MutationFunction<EventDeleteByIdMutation, EventDeleteByIdMutationVariables>;

/**
 * __useEventDeleteByIdMutation__
 *
 * To run a mutation, you first call `useEventDeleteByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventDeleteByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventDeleteByIdMutation, { data, loading, error }] = useEventDeleteByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventDeleteByIdMutation(baseOptions?: Apollo.MutationHookOptions<EventDeleteByIdMutation, EventDeleteByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventDeleteByIdMutation, EventDeleteByIdMutationVariables>(EventDeleteByIdDocument, options);
      }
export type EventDeleteByIdMutationHookResult = ReturnType<typeof useEventDeleteByIdMutation>;
export type EventDeleteByIdMutationResult = Apollo.MutationResult<EventDeleteByIdMutation>;
export type EventDeleteByIdMutationOptions = Apollo.BaseMutationOptions<EventDeleteByIdMutation, EventDeleteByIdMutationVariables>;
export const EventDisconnectOrganizationDocument = gql`
    mutation EventDisconnectOrganization($eventId: MongoID!, $organizationId: MongoID!) {
  eventDisconnectOrganization(eventId: $eventId, organizationId: $organizationId) {
    record {
      ...EventDetailsFragment
    }
  }
}
    ${EventDetailsFragmentFragmentDoc}`;
export type EventDisconnectOrganizationMutationFn = Apollo.MutationFunction<EventDisconnectOrganizationMutation, EventDisconnectOrganizationMutationVariables>;

/**
 * __useEventDisconnectOrganizationMutation__
 *
 * To run a mutation, you first call `useEventDisconnectOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventDisconnectOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventDisconnectOrganizationMutation, { data, loading, error }] = useEventDisconnectOrganizationMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useEventDisconnectOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EventDisconnectOrganizationMutation, EventDisconnectOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventDisconnectOrganizationMutation, EventDisconnectOrganizationMutationVariables>(EventDisconnectOrganizationDocument, options);
      }
export type EventDisconnectOrganizationMutationHookResult = ReturnType<typeof useEventDisconnectOrganizationMutation>;
export type EventDisconnectOrganizationMutationResult = Apollo.MutationResult<EventDisconnectOrganizationMutation>;
export type EventDisconnectOrganizationMutationOptions = Apollo.BaseMutationOptions<EventDisconnectOrganizationMutation, EventDisconnectOrganizationMutationVariables>;
export const EventInventorySettingsUpsertDocument = gql`
    mutation EventInventorySettingsUpsert($eventId: ID!, $defaultCapacityPerSession: Int, $sessionOverrides: [EventSessionCapacityOverrideInput]) {
  eventInventorySettingsUpsert(
    eventId: $eventId
    defaultCapacityPerSession: $defaultCapacityPerSession
    sessionOverrides: $sessionOverrides
  ) {
    event
    defaultCapacityPerSession
    sessionOverrides {
      sessionId
      capacity
    }
  }
}
    `;
export type EventInventorySettingsUpsertMutationFn = Apollo.MutationFunction<EventInventorySettingsUpsertMutation, EventInventorySettingsUpsertMutationVariables>;

/**
 * __useEventInventorySettingsUpsertMutation__
 *
 * To run a mutation, you first call `useEventInventorySettingsUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventInventorySettingsUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventInventorySettingsUpsertMutation, { data, loading, error }] = useEventInventorySettingsUpsertMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      defaultCapacityPerSession: // value for 'defaultCapacityPerSession'
 *      sessionOverrides: // value for 'sessionOverrides'
 *   },
 * });
 */
export function useEventInventorySettingsUpsertMutation(baseOptions?: Apollo.MutationHookOptions<EventInventorySettingsUpsertMutation, EventInventorySettingsUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventInventorySettingsUpsertMutation, EventInventorySettingsUpsertMutationVariables>(EventInventorySettingsUpsertDocument, options);
      }
export type EventInventorySettingsUpsertMutationHookResult = ReturnType<typeof useEventInventorySettingsUpsertMutation>;
export type EventInventorySettingsUpsertMutationResult = Apollo.MutationResult<EventInventorySettingsUpsertMutation>;
export type EventInventorySettingsUpsertMutationOptions = Apollo.BaseMutationOptions<EventInventorySettingsUpsertMutation, EventInventorySettingsUpsertMutationVariables>;
export const EventUpdateByIdDocument = gql`
    mutation EventUpdateById($id: MongoID!, $record: UpdateByIdEventInput!, $imagesToKeep: [String], $setStatus: EnumEventAccessOperatorStatus, $setOrganizationTags: [MongoID], $isSubmitting: Boolean, $clearAttentionIssues: Boolean) {
  eventUpdateById(
    _id: $id
    record: $record
    imagesToKeep: $imagesToKeep
    setStatus: $setStatus
    setOrganizationTags: $setOrganizationTags
    isSubmitting: $isSubmitting
    clearAttentionIssues: $clearAttentionIssues
  ) {
    record {
      ...EventDetailsFragment
    }
  }
}
    ${EventDetailsFragmentFragmentDoc}`;
export type EventUpdateByIdMutationFn = Apollo.MutationFunction<EventUpdateByIdMutation, EventUpdateByIdMutationVariables>;

/**
 * __useEventUpdateByIdMutation__
 *
 * To run a mutation, you first call `useEventUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventUpdateByIdMutation, { data, loading, error }] = useEventUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *      imagesToKeep: // value for 'imagesToKeep'
 *      setStatus: // value for 'setStatus'
 *      setOrganizationTags: // value for 'setOrganizationTags'
 *      isSubmitting: // value for 'isSubmitting'
 *      clearAttentionIssues: // value for 'clearAttentionIssues'
 *   },
 * });
 */
export function useEventUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<EventUpdateByIdMutation, EventUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventUpdateByIdMutation, EventUpdateByIdMutationVariables>(EventUpdateByIdDocument, options);
      }
export type EventUpdateByIdMutationHookResult = ReturnType<typeof useEventUpdateByIdMutation>;
export type EventUpdateByIdMutationResult = Apollo.MutationResult<EventUpdateByIdMutation>;
export type EventUpdateByIdMutationOptions = Apollo.BaseMutationOptions<EventUpdateByIdMutation, EventUpdateByIdMutationVariables>;
export const FeatureFlagCreateDocument = gql`
    mutation FeatureFlagCreate($key: String!, $name: String!, $description: String, $group: String!) {
  featureFlagCreate(
    key: $key
    name: $name
    description: $description
    group: $group
  ) {
    _id
    key
    name
    description
    group
  }
}
    `;
export type FeatureFlagCreateMutationFn = Apollo.MutationFunction<FeatureFlagCreateMutation, FeatureFlagCreateMutationVariables>;

/**
 * __useFeatureFlagCreateMutation__
 *
 * To run a mutation, you first call `useFeatureFlagCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featureFlagCreateMutation, { data, loading, error }] = useFeatureFlagCreateMutation({
 *   variables: {
 *      key: // value for 'key'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useFeatureFlagCreateMutation(baseOptions?: Apollo.MutationHookOptions<FeatureFlagCreateMutation, FeatureFlagCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeatureFlagCreateMutation, FeatureFlagCreateMutationVariables>(FeatureFlagCreateDocument, options);
      }
export type FeatureFlagCreateMutationHookResult = ReturnType<typeof useFeatureFlagCreateMutation>;
export type FeatureFlagCreateMutationResult = Apollo.MutationResult<FeatureFlagCreateMutation>;
export type FeatureFlagCreateMutationOptions = Apollo.BaseMutationOptions<FeatureFlagCreateMutation, FeatureFlagCreateMutationVariables>;
export const FeatureFlagGraduateDocument = gql`
    mutation FeatureFlagGraduate($featureFlagId: MongoID!) {
  featureFlagGraduate(featureFlagId: $featureFlagId) {
    success
    error
  }
}
    `;
export type FeatureFlagGraduateMutationFn = Apollo.MutationFunction<FeatureFlagGraduateMutation, FeatureFlagGraduateMutationVariables>;

/**
 * __useFeatureFlagGraduateMutation__
 *
 * To run a mutation, you first call `useFeatureFlagGraduateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagGraduateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featureFlagGraduateMutation, { data, loading, error }] = useFeatureFlagGraduateMutation({
 *   variables: {
 *      featureFlagId: // value for 'featureFlagId'
 *   },
 * });
 */
export function useFeatureFlagGraduateMutation(baseOptions?: Apollo.MutationHookOptions<FeatureFlagGraduateMutation, FeatureFlagGraduateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeatureFlagGraduateMutation, FeatureFlagGraduateMutationVariables>(FeatureFlagGraduateDocument, options);
      }
export type FeatureFlagGraduateMutationHookResult = ReturnType<typeof useFeatureFlagGraduateMutation>;
export type FeatureFlagGraduateMutationResult = Apollo.MutationResult<FeatureFlagGraduateMutation>;
export type FeatureFlagGraduateMutationOptions = Apollo.BaseMutationOptions<FeatureFlagGraduateMutation, FeatureFlagGraduateMutationVariables>;
export const FeatureFlagUngraduateDocument = gql`
    mutation FeatureFlagUngraduate($featureFlagId: MongoID!) {
  featureFlagUngraduate(featureFlagId: $featureFlagId) {
    success
    error
  }
}
    `;
export type FeatureFlagUngraduateMutationFn = Apollo.MutationFunction<FeatureFlagUngraduateMutation, FeatureFlagUngraduateMutationVariables>;

/**
 * __useFeatureFlagUngraduateMutation__
 *
 * To run a mutation, you first call `useFeatureFlagUngraduateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagUngraduateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featureFlagUngraduateMutation, { data, loading, error }] = useFeatureFlagUngraduateMutation({
 *   variables: {
 *      featureFlagId: // value for 'featureFlagId'
 *   },
 * });
 */
export function useFeatureFlagUngraduateMutation(baseOptions?: Apollo.MutationHookOptions<FeatureFlagUngraduateMutation, FeatureFlagUngraduateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeatureFlagUngraduateMutation, FeatureFlagUngraduateMutationVariables>(FeatureFlagUngraduateDocument, options);
      }
export type FeatureFlagUngraduateMutationHookResult = ReturnType<typeof useFeatureFlagUngraduateMutation>;
export type FeatureFlagUngraduateMutationResult = Apollo.MutationResult<FeatureFlagUngraduateMutation>;
export type FeatureFlagUngraduateMutationOptions = Apollo.BaseMutationOptions<FeatureFlagUngraduateMutation, FeatureFlagUngraduateMutationVariables>;
export const FeatureFlagUpdateDocument = gql`
    mutation FeatureFlagUpdate($_id: MongoID!, $name: String, $description: String, $group: String) {
  featureFlagUpdate(
    _id: $_id
    name: $name
    description: $description
    group: $group
  ) {
    _id
    key
    name
    description
    group
  }
}
    `;
export type FeatureFlagUpdateMutationFn = Apollo.MutationFunction<FeatureFlagUpdateMutation, FeatureFlagUpdateMutationVariables>;

/**
 * __useFeatureFlagUpdateMutation__
 *
 * To run a mutation, you first call `useFeatureFlagUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featureFlagUpdateMutation, { data, loading, error }] = useFeatureFlagUpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useFeatureFlagUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FeatureFlagUpdateMutation, FeatureFlagUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeatureFlagUpdateMutation, FeatureFlagUpdateMutationVariables>(FeatureFlagUpdateDocument, options);
      }
export type FeatureFlagUpdateMutationHookResult = ReturnType<typeof useFeatureFlagUpdateMutation>;
export type FeatureFlagUpdateMutationResult = Apollo.MutationResult<FeatureFlagUpdateMutation>;
export type FeatureFlagUpdateMutationOptions = Apollo.BaseMutationOptions<FeatureFlagUpdateMutation, FeatureFlagUpdateMutationVariables>;
export const FeatureGateResetDocument = gql`
    mutation FeatureGateReset($featureFlagId: MongoID!, $organizationId: MongoID!) {
  featureGateReset(featureFlagId: $featureFlagId, organizationId: $organizationId) {
    success
    error
  }
}
    `;
export type FeatureGateResetMutationFn = Apollo.MutationFunction<FeatureGateResetMutation, FeatureGateResetMutationVariables>;

/**
 * __useFeatureGateResetMutation__
 *
 * To run a mutation, you first call `useFeatureGateResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeatureGateResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featureGateResetMutation, { data, loading, error }] = useFeatureGateResetMutation({
 *   variables: {
 *      featureFlagId: // value for 'featureFlagId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFeatureGateResetMutation(baseOptions?: Apollo.MutationHookOptions<FeatureGateResetMutation, FeatureGateResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeatureGateResetMutation, FeatureGateResetMutationVariables>(FeatureGateResetDocument, options);
      }
export type FeatureGateResetMutationHookResult = ReturnType<typeof useFeatureGateResetMutation>;
export type FeatureGateResetMutationResult = Apollo.MutationResult<FeatureGateResetMutation>;
export type FeatureGateResetMutationOptions = Apollo.BaseMutationOptions<FeatureGateResetMutation, FeatureGateResetMutationVariables>;
export const FeatureGateToggleDocument = gql`
    mutation FeatureGateToggle($featureFlagId: MongoID!, $organizationId: MongoID!, $enabled: Boolean!) {
  featureGateToggle(
    featureFlagId: $featureFlagId
    organizationId: $organizationId
    enabled: $enabled
  ) {
    success
    error
  }
}
    `;
export type FeatureGateToggleMutationFn = Apollo.MutationFunction<FeatureGateToggleMutation, FeatureGateToggleMutationVariables>;

/**
 * __useFeatureGateToggleMutation__
 *
 * To run a mutation, you first call `useFeatureGateToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeatureGateToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featureGateToggleMutation, { data, loading, error }] = useFeatureGateToggleMutation({
 *   variables: {
 *      featureFlagId: // value for 'featureFlagId'
 *      organizationId: // value for 'organizationId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useFeatureGateToggleMutation(baseOptions?: Apollo.MutationHookOptions<FeatureGateToggleMutation, FeatureGateToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeatureGateToggleMutation, FeatureGateToggleMutationVariables>(FeatureGateToggleDocument, options);
      }
export type FeatureGateToggleMutationHookResult = ReturnType<typeof useFeatureGateToggleMutation>;
export type FeatureGateToggleMutationResult = Apollo.MutationResult<FeatureGateToggleMutation>;
export type FeatureGateToggleMutationOptions = Apollo.BaseMutationOptions<FeatureGateToggleMutation, FeatureGateToggleMutationVariables>;
export const FileCreateOneDocument = gql`
    mutation FileCreateOne($data: JSON!, $defaultCaption: MultilingualInput) {
  fileCreateOne(data: $data, defaultCaption: $defaultCaption) {
    _id
    blurhash
    caption {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type FileCreateOneMutationFn = Apollo.MutationFunction<FileCreateOneMutation, FileCreateOneMutationVariables>;

/**
 * __useFileCreateOneMutation__
 *
 * To run a mutation, you first call `useFileCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileCreateOneMutation, { data, loading, error }] = useFileCreateOneMutation({
 *   variables: {
 *      data: // value for 'data'
 *      defaultCaption: // value for 'defaultCaption'
 *   },
 * });
 */
export function useFileCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<FileCreateOneMutation, FileCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileCreateOneMutation, FileCreateOneMutationVariables>(FileCreateOneDocument, options);
      }
export type FileCreateOneMutationHookResult = ReturnType<typeof useFileCreateOneMutation>;
export type FileCreateOneMutationResult = Apollo.MutationResult<FileCreateOneMutation>;
export type FileCreateOneMutationOptions = Apollo.BaseMutationOptions<FileCreateOneMutation, FileCreateOneMutationVariables>;
export const FileDeleteFromCloudinaryOnlyDocument = gql`
    mutation FileDeleteFromCloudinaryOnly($cloudinaryPublicId: String!, $resourceType: String!) {
  fileDeleteFromCloudinaryOnly(
    cloudinaryPublicId: $cloudinaryPublicId
    resourceType: $resourceType
  )
}
    `;
export type FileDeleteFromCloudinaryOnlyMutationFn = Apollo.MutationFunction<FileDeleteFromCloudinaryOnlyMutation, FileDeleteFromCloudinaryOnlyMutationVariables>;

/**
 * __useFileDeleteFromCloudinaryOnlyMutation__
 *
 * To run a mutation, you first call `useFileDeleteFromCloudinaryOnlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileDeleteFromCloudinaryOnlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileDeleteFromCloudinaryOnlyMutation, { data, loading, error }] = useFileDeleteFromCloudinaryOnlyMutation({
 *   variables: {
 *      cloudinaryPublicId: // value for 'cloudinaryPublicId'
 *      resourceType: // value for 'resourceType'
 *   },
 * });
 */
export function useFileDeleteFromCloudinaryOnlyMutation(baseOptions?: Apollo.MutationHookOptions<FileDeleteFromCloudinaryOnlyMutation, FileDeleteFromCloudinaryOnlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileDeleteFromCloudinaryOnlyMutation, FileDeleteFromCloudinaryOnlyMutationVariables>(FileDeleteFromCloudinaryOnlyDocument, options);
      }
export type FileDeleteFromCloudinaryOnlyMutationHookResult = ReturnType<typeof useFileDeleteFromCloudinaryOnlyMutation>;
export type FileDeleteFromCloudinaryOnlyMutationResult = Apollo.MutationResult<FileDeleteFromCloudinaryOnlyMutation>;
export type FileDeleteFromCloudinaryOnlyMutationOptions = Apollo.BaseMutationOptions<FileDeleteFromCloudinaryOnlyMutation, FileDeleteFromCloudinaryOnlyMutationVariables>;
export const FileUpdateDocument = gql`
    mutation FileUpdate($id: String!, $record: UpdateByIdAssetFileInput!) {
  fileUpdate(_id: $id, record: $record) {
    record {
      _id
      caption {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type FileUpdateMutationFn = Apollo.MutationFunction<FileUpdateMutation, FileUpdateMutationVariables>;

/**
 * __useFileUpdateMutation__
 *
 * To run a mutation, you first call `useFileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileUpdateMutation, { data, loading, error }] = useFileUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useFileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FileUpdateMutation, FileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileUpdateMutation, FileUpdateMutationVariables>(FileUpdateDocument, options);
      }
export type FileUpdateMutationHookResult = ReturnType<typeof useFileUpdateMutation>;
export type FileUpdateMutationResult = Apollo.MutationResult<FileUpdateMutation>;
export type FileUpdateMutationOptions = Apollo.BaseMutationOptions<FileUpdateMutation, FileUpdateMutationVariables>;
export const FulfillmentProfileCreateDocument = gql`
    mutation FulfillmentProfileCreate($record: CreateOneFulfillmentProfileInput!) {
  fulfillmentProfileCreate(record: $record) {
    recordId
    record {
      ...FulfillmentProfileFragment
    }
  }
}
    ${FulfillmentProfileFragmentFragmentDoc}`;
export type FulfillmentProfileCreateMutationFn = Apollo.MutationFunction<FulfillmentProfileCreateMutation, FulfillmentProfileCreateMutationVariables>;

/**
 * __useFulfillmentProfileCreateMutation__
 *
 * To run a mutation, you first call `useFulfillmentProfileCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentProfileCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fulfillmentProfileCreateMutation, { data, loading, error }] = useFulfillmentProfileCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useFulfillmentProfileCreateMutation(baseOptions?: Apollo.MutationHookOptions<FulfillmentProfileCreateMutation, FulfillmentProfileCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FulfillmentProfileCreateMutation, FulfillmentProfileCreateMutationVariables>(FulfillmentProfileCreateDocument, options);
      }
export type FulfillmentProfileCreateMutationHookResult = ReturnType<typeof useFulfillmentProfileCreateMutation>;
export type FulfillmentProfileCreateMutationResult = Apollo.MutationResult<FulfillmentProfileCreateMutation>;
export type FulfillmentProfileCreateMutationOptions = Apollo.BaseMutationOptions<FulfillmentProfileCreateMutation, FulfillmentProfileCreateMutationVariables>;
export const FulfillmentProfileUpdateDocument = gql`
    mutation FulfillmentProfileUpdate($id: MongoID!, $record: UpdateByIdFulfillmentProfileInput!) {
  fulfillmentProfileUpdate(_id: $id, record: $record) {
    recordId
    record {
      ...FulfillmentProfileFragment
    }
  }
}
    ${FulfillmentProfileFragmentFragmentDoc}`;
export type FulfillmentProfileUpdateMutationFn = Apollo.MutationFunction<FulfillmentProfileUpdateMutation, FulfillmentProfileUpdateMutationVariables>;

/**
 * __useFulfillmentProfileUpdateMutation__
 *
 * To run a mutation, you first call `useFulfillmentProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fulfillmentProfileUpdateMutation, { data, loading, error }] = useFulfillmentProfileUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useFulfillmentProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<FulfillmentProfileUpdateMutation, FulfillmentProfileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FulfillmentProfileUpdateMutation, FulfillmentProfileUpdateMutationVariables>(FulfillmentProfileUpdateDocument, options);
      }
export type FulfillmentProfileUpdateMutationHookResult = ReturnType<typeof useFulfillmentProfileUpdateMutation>;
export type FulfillmentProfileUpdateMutationResult = Apollo.MutationResult<FulfillmentProfileUpdateMutation>;
export type FulfillmentProfileUpdateMutationOptions = Apollo.BaseMutationOptions<FulfillmentProfileUpdateMutation, FulfillmentProfileUpdateMutationVariables>;
export const GalleryNewMediaDismissDocument = gql`
    mutation GalleryNewMediaDismiss($_id: MongoID!) {
  galleryNewMediaDismiss(_id: $_id) {
    _id
    status
    resolvedAt
  }
}
    `;
export type GalleryNewMediaDismissMutationFn = Apollo.MutationFunction<GalleryNewMediaDismissMutation, GalleryNewMediaDismissMutationVariables>;

/**
 * __useGalleryNewMediaDismissMutation__
 *
 * To run a mutation, you first call `useGalleryNewMediaDismissMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGalleryNewMediaDismissMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [galleryNewMediaDismissMutation, { data, loading, error }] = useGalleryNewMediaDismissMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useGalleryNewMediaDismissMutation(baseOptions?: Apollo.MutationHookOptions<GalleryNewMediaDismissMutation, GalleryNewMediaDismissMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GalleryNewMediaDismissMutation, GalleryNewMediaDismissMutationVariables>(GalleryNewMediaDismissDocument, options);
      }
export type GalleryNewMediaDismissMutationHookResult = ReturnType<typeof useGalleryNewMediaDismissMutation>;
export type GalleryNewMediaDismissMutationResult = Apollo.MutationResult<GalleryNewMediaDismissMutation>;
export type GalleryNewMediaDismissMutationOptions = Apollo.BaseMutationOptions<GalleryNewMediaDismissMutation, GalleryNewMediaDismissMutationVariables>;
export const GalleryNewMediaPromoteDocument = gql`
    mutation GalleryNewMediaPromote($_id: MongoID!, $widgetIds: [MongoID!]) {
  galleryNewMediaPromote(_id: $_id, widgetIds: $widgetIds)
}
    `;
export type GalleryNewMediaPromoteMutationFn = Apollo.MutationFunction<GalleryNewMediaPromoteMutation, GalleryNewMediaPromoteMutationVariables>;

/**
 * __useGalleryNewMediaPromoteMutation__
 *
 * To run a mutation, you first call `useGalleryNewMediaPromoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGalleryNewMediaPromoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [galleryNewMediaPromoteMutation, { data, loading, error }] = useGalleryNewMediaPromoteMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      widgetIds: // value for 'widgetIds'
 *   },
 * });
 */
export function useGalleryNewMediaPromoteMutation(baseOptions?: Apollo.MutationHookOptions<GalleryNewMediaPromoteMutation, GalleryNewMediaPromoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GalleryNewMediaPromoteMutation, GalleryNewMediaPromoteMutationVariables>(GalleryNewMediaPromoteDocument, options);
      }
export type GalleryNewMediaPromoteMutationHookResult = ReturnType<typeof useGalleryNewMediaPromoteMutation>;
export type GalleryNewMediaPromoteMutationResult = Apollo.MutationResult<GalleryNewMediaPromoteMutation>;
export type GalleryNewMediaPromoteMutationOptions = Apollo.BaseMutationOptions<GalleryNewMediaPromoteMutation, GalleryNewMediaPromoteMutationVariables>;
export const ImageAnalyzeDocument = gql`
    mutation ImageAnalyze($assetId: String!) {
  imageAnalyze(assetId: $assetId) {
    ...ImageFragment
  }
}
    ${ImageFragmentFragmentDoc}`;
export type ImageAnalyzeMutationFn = Apollo.MutationFunction<ImageAnalyzeMutation, ImageAnalyzeMutationVariables>;

/**
 * __useImageAnalyzeMutation__
 *
 * To run a mutation, you first call `useImageAnalyzeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageAnalyzeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageAnalyzeMutation, { data, loading, error }] = useImageAnalyzeMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useImageAnalyzeMutation(baseOptions?: Apollo.MutationHookOptions<ImageAnalyzeMutation, ImageAnalyzeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageAnalyzeMutation, ImageAnalyzeMutationVariables>(ImageAnalyzeDocument, options);
      }
export type ImageAnalyzeMutationHookResult = ReturnType<typeof useImageAnalyzeMutation>;
export type ImageAnalyzeMutationResult = Apollo.MutationResult<ImageAnalyzeMutation>;
export type ImageAnalyzeMutationOptions = Apollo.BaseMutationOptions<ImageAnalyzeMutation, ImageAnalyzeMutationVariables>;
export const ImageCreateOneDocument = gql`
    mutation ImageCreateOne($data: JSON!, $defaultCaption: MultilingualInput) {
  imageCreateOne(data: $data, defaultCaption: $defaultCaption) {
    ...ImageFragment
  }
}
    ${ImageFragmentFragmentDoc}`;
export type ImageCreateOneMutationFn = Apollo.MutationFunction<ImageCreateOneMutation, ImageCreateOneMutationVariables>;

/**
 * __useImageCreateOneMutation__
 *
 * To run a mutation, you first call `useImageCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageCreateOneMutation, { data, loading, error }] = useImageCreateOneMutation({
 *   variables: {
 *      data: // value for 'data'
 *      defaultCaption: // value for 'defaultCaption'
 *   },
 * });
 */
export function useImageCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<ImageCreateOneMutation, ImageCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageCreateOneMutation, ImageCreateOneMutationVariables>(ImageCreateOneDocument, options);
      }
export type ImageCreateOneMutationHookResult = ReturnType<typeof useImageCreateOneMutation>;
export type ImageCreateOneMutationResult = Apollo.MutationResult<ImageCreateOneMutation>;
export type ImageCreateOneMutationOptions = Apollo.BaseMutationOptions<ImageCreateOneMutation, ImageCreateOneMutationVariables>;
export const ImageDeleteFromCloudinaryOnlyDocument = gql`
    mutation ImageDeleteFromCloudinaryOnly($cloudinaryPublicId: String!, $resourceType: String!) {
  imageDeleteFromCloudinaryOnly(
    cloudinaryPublicId: $cloudinaryPublicId
    resourceType: $resourceType
  )
}
    `;
export type ImageDeleteFromCloudinaryOnlyMutationFn = Apollo.MutationFunction<ImageDeleteFromCloudinaryOnlyMutation, ImageDeleteFromCloudinaryOnlyMutationVariables>;

/**
 * __useImageDeleteFromCloudinaryOnlyMutation__
 *
 * To run a mutation, you first call `useImageDeleteFromCloudinaryOnlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageDeleteFromCloudinaryOnlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageDeleteFromCloudinaryOnlyMutation, { data, loading, error }] = useImageDeleteFromCloudinaryOnlyMutation({
 *   variables: {
 *      cloudinaryPublicId: // value for 'cloudinaryPublicId'
 *      resourceType: // value for 'resourceType'
 *   },
 * });
 */
export function useImageDeleteFromCloudinaryOnlyMutation(baseOptions?: Apollo.MutationHookOptions<ImageDeleteFromCloudinaryOnlyMutation, ImageDeleteFromCloudinaryOnlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageDeleteFromCloudinaryOnlyMutation, ImageDeleteFromCloudinaryOnlyMutationVariables>(ImageDeleteFromCloudinaryOnlyDocument, options);
      }
export type ImageDeleteFromCloudinaryOnlyMutationHookResult = ReturnType<typeof useImageDeleteFromCloudinaryOnlyMutation>;
export type ImageDeleteFromCloudinaryOnlyMutationResult = Apollo.MutationResult<ImageDeleteFromCloudinaryOnlyMutation>;
export type ImageDeleteFromCloudinaryOnlyMutationOptions = Apollo.BaseMutationOptions<ImageDeleteFromCloudinaryOnlyMutation, ImageDeleteFromCloudinaryOnlyMutationVariables>;
export const ImageUpdateDocument = gql`
    mutation ImageUpdate($id: String!, $record: UpdateByIdAssetImageInput!) {
  imageUpdate(_id: $id, record: $record) {
    record {
      ...ImageFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export type ImageUpdateMutationFn = Apollo.MutationFunction<ImageUpdateMutation, ImageUpdateMutationVariables>;

/**
 * __useImageUpdateMutation__
 *
 * To run a mutation, you first call `useImageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageUpdateMutation, { data, loading, error }] = useImageUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useImageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ImageUpdateMutation, ImageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageUpdateMutation, ImageUpdateMutationVariables>(ImageUpdateDocument, options);
      }
export type ImageUpdateMutationHookResult = ReturnType<typeof useImageUpdateMutation>;
export type ImageUpdateMutationResult = Apollo.MutationResult<ImageUpdateMutation>;
export type ImageUpdateMutationOptions = Apollo.BaseMutationOptions<ImageUpdateMutation, ImageUpdateMutationVariables>;
export const ImportCreateDocument = gql`
    mutation ImportCreate($record: CreateOneImportInput!) {
  importCreate(record: $record) {
    record {
      _id
      name
      organization {
        _id
        name {
          ...MultilingualFragment
        }
      }
      googleSheetsConfig {
        sheetUrl
        sheetId
        range
      }
      importType
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type ImportCreateMutationFn = Apollo.MutationFunction<ImportCreateMutation, ImportCreateMutationVariables>;

/**
 * __useImportCreateMutation__
 *
 * To run a mutation, you first call `useImportCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importCreateMutation, { data, loading, error }] = useImportCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useImportCreateMutation(baseOptions?: Apollo.MutationHookOptions<ImportCreateMutation, ImportCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportCreateMutation, ImportCreateMutationVariables>(ImportCreateDocument, options);
      }
export type ImportCreateMutationHookResult = ReturnType<typeof useImportCreateMutation>;
export type ImportCreateMutationResult = Apollo.MutationResult<ImportCreateMutation>;
export type ImportCreateMutationOptions = Apollo.BaseMutationOptions<ImportCreateMutation, ImportCreateMutationVariables>;
export const ImportPreviewDocument = gql`
    mutation ImportPreview($importId: MongoID, $googleSheetsConfig: ImportGoogleSheetsConfigInput, $importType: ImportType, $organizationId: MongoID) {
  importPreview(
    importId: $importId
    googleSheetsConfig: $googleSheetsConfig
    importType: $importType
    organizationId: $organizationId
  ) {
    operatorCount
    totalRowCount
    sampleOperators
    errors
    notifications
  }
}
    `;
export type ImportPreviewMutationFn = Apollo.MutationFunction<ImportPreviewMutation, ImportPreviewMutationVariables>;

/**
 * __useImportPreviewMutation__
 *
 * To run a mutation, you first call `useImportPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPreviewMutation, { data, loading, error }] = useImportPreviewMutation({
 *   variables: {
 *      importId: // value for 'importId'
 *      googleSheetsConfig: // value for 'googleSheetsConfig'
 *      importType: // value for 'importType'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useImportPreviewMutation(baseOptions?: Apollo.MutationHookOptions<ImportPreviewMutation, ImportPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportPreviewMutation, ImportPreviewMutationVariables>(ImportPreviewDocument, options);
      }
export type ImportPreviewMutationHookResult = ReturnType<typeof useImportPreviewMutation>;
export type ImportPreviewMutationResult = Apollo.MutationResult<ImportPreviewMutation>;
export type ImportPreviewMutationOptions = Apollo.BaseMutationOptions<ImportPreviewMutation, ImportPreviewMutationVariables>;
export const ImportRunCancelDocument = gql`
    mutation ImportRunCancel($importRunId: MongoID!) {
  importRunCancel(importRunId: $importRunId) {
    success
    deletedCount
    imagesDeleted
    errors
  }
}
    `;
export type ImportRunCancelMutationFn = Apollo.MutationFunction<ImportRunCancelMutation, ImportRunCancelMutationVariables>;

/**
 * __useImportRunCancelMutation__
 *
 * To run a mutation, you first call `useImportRunCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportRunCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importRunCancelMutation, { data, loading, error }] = useImportRunCancelMutation({
 *   variables: {
 *      importRunId: // value for 'importRunId'
 *   },
 * });
 */
export function useImportRunCancelMutation(baseOptions?: Apollo.MutationHookOptions<ImportRunCancelMutation, ImportRunCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportRunCancelMutation, ImportRunCancelMutationVariables>(ImportRunCancelDocument, options);
      }
export type ImportRunCancelMutationHookResult = ReturnType<typeof useImportRunCancelMutation>;
export type ImportRunCancelMutationResult = Apollo.MutationResult<ImportRunCancelMutation>;
export type ImportRunCancelMutationOptions = Apollo.BaseMutationOptions<ImportRunCancelMutation, ImportRunCancelMutationVariables>;
export const ImportRunCreateDocument = gql`
    mutation ImportRunCreate($importId: MongoID!, $dryRun: Boolean, $limit: Int, $checkForExistingOperators: Boolean, $startingRow: Int, $skipImages: Boolean) {
  importRunCreate(
    importId: $importId
    dryRun: $dryRun
    limit: $limit
    checkForExistingOperators: $checkForExistingOperators
    startingRow: $startingRow
    skipImages: $skipImages
  ) {
    importRunId
    operatorCount
    errors
    status
  }
}
    `;
export type ImportRunCreateMutationFn = Apollo.MutationFunction<ImportRunCreateMutation, ImportRunCreateMutationVariables>;

/**
 * __useImportRunCreateMutation__
 *
 * To run a mutation, you first call `useImportRunCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportRunCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importRunCreateMutation, { data, loading, error }] = useImportRunCreateMutation({
 *   variables: {
 *      importId: // value for 'importId'
 *      dryRun: // value for 'dryRun'
 *      limit: // value for 'limit'
 *      checkForExistingOperators: // value for 'checkForExistingOperators'
 *      startingRow: // value for 'startingRow'
 *      skipImages: // value for 'skipImages'
 *   },
 * });
 */
export function useImportRunCreateMutation(baseOptions?: Apollo.MutationHookOptions<ImportRunCreateMutation, ImportRunCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportRunCreateMutation, ImportRunCreateMutationVariables>(ImportRunCreateDocument, options);
      }
export type ImportRunCreateMutationHookResult = ReturnType<typeof useImportRunCreateMutation>;
export type ImportRunCreateMutationResult = Apollo.MutationResult<ImportRunCreateMutation>;
export type ImportRunCreateMutationOptions = Apollo.BaseMutationOptions<ImportRunCreateMutation, ImportRunCreateMutationVariables>;
export const ImportRunDeleteDocument = gql`
    mutation ImportRunDelete($importRunId: MongoID!) {
  importRunDelete(importRunId: $importRunId) {
    success
    message
  }
}
    `;
export type ImportRunDeleteMutationFn = Apollo.MutationFunction<ImportRunDeleteMutation, ImportRunDeleteMutationVariables>;

/**
 * __useImportRunDeleteMutation__
 *
 * To run a mutation, you first call `useImportRunDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportRunDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importRunDeleteMutation, { data, loading, error }] = useImportRunDeleteMutation({
 *   variables: {
 *      importRunId: // value for 'importRunId'
 *   },
 * });
 */
export function useImportRunDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ImportRunDeleteMutation, ImportRunDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportRunDeleteMutation, ImportRunDeleteMutationVariables>(ImportRunDeleteDocument, options);
      }
export type ImportRunDeleteMutationHookResult = ReturnType<typeof useImportRunDeleteMutation>;
export type ImportRunDeleteMutationResult = Apollo.MutationResult<ImportRunDeleteMutation>;
export type ImportRunDeleteMutationOptions = Apollo.BaseMutationOptions<ImportRunDeleteMutation, ImportRunDeleteMutationVariables>;
export const ImportRunMoveOperatorsToConnectedDocument = gql`
    mutation ImportRunMoveOperatorsToConnected($importRunId: MongoID!, $operatorEntityIds: [ID!]!) {
  importRunMoveOperatorsToConnected(
    importRunId: $importRunId
    operatorEntityIds: $operatorEntityIds
  ) {
    success
    message
  }
}
    `;
export type ImportRunMoveOperatorsToConnectedMutationFn = Apollo.MutationFunction<ImportRunMoveOperatorsToConnectedMutation, ImportRunMoveOperatorsToConnectedMutationVariables>;

/**
 * __useImportRunMoveOperatorsToConnectedMutation__
 *
 * To run a mutation, you first call `useImportRunMoveOperatorsToConnectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportRunMoveOperatorsToConnectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importRunMoveOperatorsToConnectedMutation, { data, loading, error }] = useImportRunMoveOperatorsToConnectedMutation({
 *   variables: {
 *      importRunId: // value for 'importRunId'
 *      operatorEntityIds: // value for 'operatorEntityIds'
 *   },
 * });
 */
export function useImportRunMoveOperatorsToConnectedMutation(baseOptions?: Apollo.MutationHookOptions<ImportRunMoveOperatorsToConnectedMutation, ImportRunMoveOperatorsToConnectedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportRunMoveOperatorsToConnectedMutation, ImportRunMoveOperatorsToConnectedMutationVariables>(ImportRunMoveOperatorsToConnectedDocument, options);
      }
export type ImportRunMoveOperatorsToConnectedMutationHookResult = ReturnType<typeof useImportRunMoveOperatorsToConnectedMutation>;
export type ImportRunMoveOperatorsToConnectedMutationResult = Apollo.MutationResult<ImportRunMoveOperatorsToConnectedMutation>;
export type ImportRunMoveOperatorsToConnectedMutationOptions = Apollo.BaseMutationOptions<ImportRunMoveOperatorsToConnectedMutation, ImportRunMoveOperatorsToConnectedMutationVariables>;
export const ImportRunRollbackDocument = gql`
    mutation ImportRunRollback($importRunId: MongoID!) {
  importRunRollback(importRunId: $importRunId) {
    success
    deletedCount
    errors
  }
}
    `;
export type ImportRunRollbackMutationFn = Apollo.MutationFunction<ImportRunRollbackMutation, ImportRunRollbackMutationVariables>;

/**
 * __useImportRunRollbackMutation__
 *
 * To run a mutation, you first call `useImportRunRollbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportRunRollbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importRunRollbackMutation, { data, loading, error }] = useImportRunRollbackMutation({
 *   variables: {
 *      importRunId: // value for 'importRunId'
 *   },
 * });
 */
export function useImportRunRollbackMutation(baseOptions?: Apollo.MutationHookOptions<ImportRunRollbackMutation, ImportRunRollbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportRunRollbackMutation, ImportRunRollbackMutationVariables>(ImportRunRollbackDocument, options);
      }
export type ImportRunRollbackMutationHookResult = ReturnType<typeof useImportRunRollbackMutation>;
export type ImportRunRollbackMutationResult = Apollo.MutationResult<ImportRunRollbackMutation>;
export type ImportRunRollbackMutationOptions = Apollo.BaseMutationOptions<ImportRunRollbackMutation, ImportRunRollbackMutationVariables>;
export const ImportRunStartDocument = gql`
    mutation ImportRunStart($importRunId: MongoID!) {
  importRunStart(importRunId: $importRunId) {
    importRunId
    operatorCount
    errors
    status
  }
}
    `;
export type ImportRunStartMutationFn = Apollo.MutationFunction<ImportRunStartMutation, ImportRunStartMutationVariables>;

/**
 * __useImportRunStartMutation__
 *
 * To run a mutation, you first call `useImportRunStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportRunStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importRunStartMutation, { data, loading, error }] = useImportRunStartMutation({
 *   variables: {
 *      importRunId: // value for 'importRunId'
 *   },
 * });
 */
export function useImportRunStartMutation(baseOptions?: Apollo.MutationHookOptions<ImportRunStartMutation, ImportRunStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportRunStartMutation, ImportRunStartMutationVariables>(ImportRunStartDocument, options);
      }
export type ImportRunStartMutationHookResult = ReturnType<typeof useImportRunStartMutation>;
export type ImportRunStartMutationResult = Apollo.MutationResult<ImportRunStartMutation>;
export type ImportRunStartMutationOptions = Apollo.BaseMutationOptions<ImportRunStartMutation, ImportRunStartMutationVariables>;
export const ImportScrapeGenerateSheetDocument = gql`
    mutation ImportScrapeGenerateSheet($scrapeId: MongoID!, $sheetName: String!) {
  importScrapeGenerateSheet(scrapeId: $scrapeId, sheetName: $sheetName) {
    sheetUrl
    sheetId
    scrape {
      _id
      name
      googleSheetsConfig {
        sheetUrl
        sheetId
        sheetName
      }
    }
  }
}
    `;
export type ImportScrapeGenerateSheetMutationFn = Apollo.MutationFunction<ImportScrapeGenerateSheetMutation, ImportScrapeGenerateSheetMutationVariables>;

/**
 * __useImportScrapeGenerateSheetMutation__
 *
 * To run a mutation, you first call `useImportScrapeGenerateSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportScrapeGenerateSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importScrapeGenerateSheetMutation, { data, loading, error }] = useImportScrapeGenerateSheetMutation({
 *   variables: {
 *      scrapeId: // value for 'scrapeId'
 *      sheetName: // value for 'sheetName'
 *   },
 * });
 */
export function useImportScrapeGenerateSheetMutation(baseOptions?: Apollo.MutationHookOptions<ImportScrapeGenerateSheetMutation, ImportScrapeGenerateSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportScrapeGenerateSheetMutation, ImportScrapeGenerateSheetMutationVariables>(ImportScrapeGenerateSheetDocument, options);
      }
export type ImportScrapeGenerateSheetMutationHookResult = ReturnType<typeof useImportScrapeGenerateSheetMutation>;
export type ImportScrapeGenerateSheetMutationResult = Apollo.MutationResult<ImportScrapeGenerateSheetMutation>;
export type ImportScrapeGenerateSheetMutationOptions = Apollo.BaseMutationOptions<ImportScrapeGenerateSheetMutation, ImportScrapeGenerateSheetMutationVariables>;
export const ImportUpdateDocument = gql`
    mutation ImportUpdate($id: MongoID!, $record: UpdateByIdImportInput!) {
  importUpdate(_id: $id, record: $record) {
    record {
      _id
      name
      organization {
        _id
        name {
          ...MultilingualFragment
        }
      }
      googleSheetsConfig {
        sheetUrl
        sheetId
        range
        apiKey
        serviceAccountKey
      }
      importType
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type ImportUpdateMutationFn = Apollo.MutationFunction<ImportUpdateMutation, ImportUpdateMutationVariables>;

/**
 * __useImportUpdateMutation__
 *
 * To run a mutation, you first call `useImportUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importUpdateMutation, { data, loading, error }] = useImportUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useImportUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ImportUpdateMutation, ImportUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportUpdateMutation, ImportUpdateMutationVariables>(ImportUpdateDocument, options);
      }
export type ImportUpdateMutationHookResult = ReturnType<typeof useImportUpdateMutation>;
export type ImportUpdateMutationResult = Apollo.MutationResult<ImportUpdateMutation>;
export type ImportUpdateMutationOptions = Apollo.BaseMutationOptions<ImportUpdateMutation, ImportUpdateMutationVariables>;
export const InviteQueueAcceptFreshenDocument = gql`
    mutation InviteQueueAcceptFreshen($organizationId: MongoID!) {
  inviteQueueAcceptFreshen(organizationId: $organizationId) {
    updatedCount
  }
}
    `;
export type InviteQueueAcceptFreshenMutationFn = Apollo.MutationFunction<InviteQueueAcceptFreshenMutation, InviteQueueAcceptFreshenMutationVariables>;

/**
 * __useInviteQueueAcceptFreshenMutation__
 *
 * To run a mutation, you first call `useInviteQueueAcceptFreshenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteQueueAcceptFreshenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteQueueAcceptFreshenMutation, { data, loading, error }] = useInviteQueueAcceptFreshenMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useInviteQueueAcceptFreshenMutation(baseOptions?: Apollo.MutationHookOptions<InviteQueueAcceptFreshenMutation, InviteQueueAcceptFreshenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteQueueAcceptFreshenMutation, InviteQueueAcceptFreshenMutationVariables>(InviteQueueAcceptFreshenDocument, options);
      }
export type InviteQueueAcceptFreshenMutationHookResult = ReturnType<typeof useInviteQueueAcceptFreshenMutation>;
export type InviteQueueAcceptFreshenMutationResult = Apollo.MutationResult<InviteQueueAcceptFreshenMutation>;
export type InviteQueueAcceptFreshenMutationOptions = Apollo.BaseMutationOptions<InviteQueueAcceptFreshenMutation, InviteQueueAcceptFreshenMutationVariables>;
export const InviteQueueCancelByIdDocument = gql`
    mutation InviteQueueCancelById($_id: MongoID!) {
  inviteQueueCancelById(_id: $_id) {
    _id
    inviteStatus
    createdDateISO
    initiatedDate
    initiatedByUserName
  }
}
    `;
export type InviteQueueCancelByIdMutationFn = Apollo.MutationFunction<InviteQueueCancelByIdMutation, InviteQueueCancelByIdMutationVariables>;

/**
 * __useInviteQueueCancelByIdMutation__
 *
 * To run a mutation, you first call `useInviteQueueCancelByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteQueueCancelByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteQueueCancelByIdMutation, { data, loading, error }] = useInviteQueueCancelByIdMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useInviteQueueCancelByIdMutation(baseOptions?: Apollo.MutationHookOptions<InviteQueueCancelByIdMutation, InviteQueueCancelByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteQueueCancelByIdMutation, InviteQueueCancelByIdMutationVariables>(InviteQueueCancelByIdDocument, options);
      }
export type InviteQueueCancelByIdMutationHookResult = ReturnType<typeof useInviteQueueCancelByIdMutation>;
export type InviteQueueCancelByIdMutationResult = Apollo.MutationResult<InviteQueueCancelByIdMutation>;
export type InviteQueueCancelByIdMutationOptions = Apollo.BaseMutationOptions<InviteQueueCancelByIdMutation, InviteQueueCancelByIdMutationVariables>;
export const InviteQueueCleanupDocument = gql`
    mutation InviteQueueCleanup($organizationId: MongoID!, $convertToDmoManaged: Boolean!, $criteria: InviteQueueCleanupCriteriaInput!) {
  inviteQueueCleanup(
    organizationId: $organizationId
    convertToDmoManaged: $convertToDmoManaged
    criteria: $criteria
  ) {
    cancelledCount
  }
}
    `;
export type InviteQueueCleanupMutationFn = Apollo.MutationFunction<InviteQueueCleanupMutation, InviteQueueCleanupMutationVariables>;

/**
 * __useInviteQueueCleanupMutation__
 *
 * To run a mutation, you first call `useInviteQueueCleanupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteQueueCleanupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteQueueCleanupMutation, { data, loading, error }] = useInviteQueueCleanupMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      convertToDmoManaged: // value for 'convertToDmoManaged'
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useInviteQueueCleanupMutation(baseOptions?: Apollo.MutationHookOptions<InviteQueueCleanupMutation, InviteQueueCleanupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteQueueCleanupMutation, InviteQueueCleanupMutationVariables>(InviteQueueCleanupDocument, options);
      }
export type InviteQueueCleanupMutationHookResult = ReturnType<typeof useInviteQueueCleanupMutation>;
export type InviteQueueCleanupMutationResult = Apollo.MutationResult<InviteQueueCleanupMutation>;
export type InviteQueueCleanupMutationOptions = Apollo.BaseMutationOptions<InviteQueueCleanupMutation, InviteQueueCleanupMutationVariables>;
export const InviteQueueCreateOneDocument = gql`
    mutation InviteQueueCreateOne($operatorEntityId: MongoID!, $operatorName: String!, $organizationId: MongoID!, $inviteByEmailOnly: Boolean, $invitedEmail: String, $invitedUserId: MongoID, $invitedUserName: String, $inviteStatus: String) {
  inviteQueueCreateOne(
    operatorEntityId: $operatorEntityId
    operatorName: $operatorName
    organizationId: $organizationId
    inviteByEmailOnly: $inviteByEmailOnly
    invitedEmail: $invitedEmail
    invitedUserId: $invitedUserId
    invitedUserName: $invitedUserName
    inviteStatus: $inviteStatus
  ) {
    _id
    invitedOperator
    invitedOperatorName
    inviteByEmailOnly
    invitedEmail
    invitedUser
    invitedUserName
    initiatedByUser
    initiatedByUserName
    initiatedDate
    organizationId
    organizationName
    inviteStatus
    createdDateISO
  }
}
    `;
export type InviteQueueCreateOneMutationFn = Apollo.MutationFunction<InviteQueueCreateOneMutation, InviteQueueCreateOneMutationVariables>;

/**
 * __useInviteQueueCreateOneMutation__
 *
 * To run a mutation, you first call `useInviteQueueCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteQueueCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteQueueCreateOneMutation, { data, loading, error }] = useInviteQueueCreateOneMutation({
 *   variables: {
 *      operatorEntityId: // value for 'operatorEntityId'
 *      operatorName: // value for 'operatorName'
 *      organizationId: // value for 'organizationId'
 *      inviteByEmailOnly: // value for 'inviteByEmailOnly'
 *      invitedEmail: // value for 'invitedEmail'
 *      invitedUserId: // value for 'invitedUserId'
 *      invitedUserName: // value for 'invitedUserName'
 *      inviteStatus: // value for 'inviteStatus'
 *   },
 * });
 */
export function useInviteQueueCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<InviteQueueCreateOneMutation, InviteQueueCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteQueueCreateOneMutation, InviteQueueCreateOneMutationVariables>(InviteQueueCreateOneDocument, options);
      }
export type InviteQueueCreateOneMutationHookResult = ReturnType<typeof useInviteQueueCreateOneMutation>;
export type InviteQueueCreateOneMutationResult = Apollo.MutationResult<InviteQueueCreateOneMutation>;
export type InviteQueueCreateOneMutationOptions = Apollo.BaseMutationOptions<InviteQueueCreateOneMutation, InviteQueueCreateOneMutationVariables>;
export const InviteQueueFreshenDocument = gql`
    mutation InviteQueueFreshen($_id: MongoID!) {
  inviteQueueFreshen(_id: $_id) {
    success
    activityLogId
  }
}
    `;
export type InviteQueueFreshenMutationFn = Apollo.MutationFunction<InviteQueueFreshenMutation, InviteQueueFreshenMutationVariables>;

/**
 * __useInviteQueueFreshenMutation__
 *
 * To run a mutation, you first call `useInviteQueueFreshenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteQueueFreshenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteQueueFreshenMutation, { data, loading, error }] = useInviteQueueFreshenMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useInviteQueueFreshenMutation(baseOptions?: Apollo.MutationHookOptions<InviteQueueFreshenMutation, InviteQueueFreshenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteQueueFreshenMutation, InviteQueueFreshenMutationVariables>(InviteQueueFreshenDocument, options);
      }
export type InviteQueueFreshenMutationHookResult = ReturnType<typeof useInviteQueueFreshenMutation>;
export type InviteQueueFreshenMutationResult = Apollo.MutationResult<InviteQueueFreshenMutation>;
export type InviteQueueFreshenMutationOptions = Apollo.BaseMutationOptions<InviteQueueFreshenMutation, InviteQueueFreshenMutationVariables>;
export const InviteQueueReinviteByEmailDocument = gql`
    mutation InviteQueueReinviteByEmail($organizationId: MongoID!, $email: String!, $recordIds: [MongoID!]) {
  inviteQueueReinviteByEmail(
    organizationId: $organizationId
    email: $email
    recordIds: $recordIds
  ) {
    success
    activityLogId
  }
}
    `;
export type InviteQueueReinviteByEmailMutationFn = Apollo.MutationFunction<InviteQueueReinviteByEmailMutation, InviteQueueReinviteByEmailMutationVariables>;

/**
 * __useInviteQueueReinviteByEmailMutation__
 *
 * To run a mutation, you first call `useInviteQueueReinviteByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteQueueReinviteByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteQueueReinviteByEmailMutation, { data, loading, error }] = useInviteQueueReinviteByEmailMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      email: // value for 'email'
 *      recordIds: // value for 'recordIds'
 *   },
 * });
 */
export function useInviteQueueReinviteByEmailMutation(baseOptions?: Apollo.MutationHookOptions<InviteQueueReinviteByEmailMutation, InviteQueueReinviteByEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteQueueReinviteByEmailMutation, InviteQueueReinviteByEmailMutationVariables>(InviteQueueReinviteByEmailDocument, options);
      }
export type InviteQueueReinviteByEmailMutationHookResult = ReturnType<typeof useInviteQueueReinviteByEmailMutation>;
export type InviteQueueReinviteByEmailMutationResult = Apollo.MutationResult<InviteQueueReinviteByEmailMutation>;
export type InviteQueueReinviteByEmailMutationOptions = Apollo.BaseMutationOptions<InviteQueueReinviteByEmailMutation, InviteQueueReinviteByEmailMutationVariables>;
export const InviteQueueSendInvitesDocument = gql`
    mutation InviteQueueSendInvites($organizationId: MongoID!, $mode: String!, $minDaysSinceInvite: Int) {
  inviteQueueSendInvites(
    organizationId: $organizationId
    mode: $mode
    minDaysSinceInvite: $minDaysSinceInvite
  ) {
    started
    totalToSend
    alreadyProcessing
  }
}
    `;
export type InviteQueueSendInvitesMutationFn = Apollo.MutationFunction<InviteQueueSendInvitesMutation, InviteQueueSendInvitesMutationVariables>;

/**
 * __useInviteQueueSendInvitesMutation__
 *
 * To run a mutation, you first call `useInviteQueueSendInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteQueueSendInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteQueueSendInvitesMutation, { data, loading, error }] = useInviteQueueSendInvitesMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      mode: // value for 'mode'
 *      minDaysSinceInvite: // value for 'minDaysSinceInvite'
 *   },
 * });
 */
export function useInviteQueueSendInvitesMutation(baseOptions?: Apollo.MutationHookOptions<InviteQueueSendInvitesMutation, InviteQueueSendInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteQueueSendInvitesMutation, InviteQueueSendInvitesMutationVariables>(InviteQueueSendInvitesDocument, options);
      }
export type InviteQueueSendInvitesMutationHookResult = ReturnType<typeof useInviteQueueSendInvitesMutation>;
export type InviteQueueSendInvitesMutationResult = Apollo.MutationResult<InviteQueueSendInvitesMutation>;
export type InviteQueueSendInvitesMutationOptions = Apollo.BaseMutationOptions<InviteQueueSendInvitesMutation, InviteQueueSendInvitesMutationVariables>;
export const ItineraryDeleteDocument = gql`
    mutation ItineraryDelete($itineraryId: ID!, $hardDelete: Boolean) {
  itineraryDelete(itineraryId: $itineraryId, hardDelete: $hardDelete)
}
    `;
export type ItineraryDeleteMutationFn = Apollo.MutationFunction<ItineraryDeleteMutation, ItineraryDeleteMutationVariables>;

/**
 * __useItineraryDeleteMutation__
 *
 * To run a mutation, you first call `useItineraryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useItineraryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [itineraryDeleteMutation, { data, loading, error }] = useItineraryDeleteMutation({
 *   variables: {
 *      itineraryId: // value for 'itineraryId'
 *      hardDelete: // value for 'hardDelete'
 *   },
 * });
 */
export function useItineraryDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ItineraryDeleteMutation, ItineraryDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ItineraryDeleteMutation, ItineraryDeleteMutationVariables>(ItineraryDeleteDocument, options);
      }
export type ItineraryDeleteMutationHookResult = ReturnType<typeof useItineraryDeleteMutation>;
export type ItineraryDeleteMutationResult = Apollo.MutationResult<ItineraryDeleteMutation>;
export type ItineraryDeleteMutationOptions = Apollo.BaseMutationOptions<ItineraryDeleteMutation, ItineraryDeleteMutationVariables>;
export const LeadRemoveByIdDocument = gql`
    mutation LeadRemoveById($id: ID!) {
  leadRemoveById(id: $id) {
    ...LeadFragment
  }
}
    ${LeadFragmentFragmentDoc}`;
export type LeadRemoveByIdMutationFn = Apollo.MutationFunction<LeadRemoveByIdMutation, LeadRemoveByIdMutationVariables>;

/**
 * __useLeadRemoveByIdMutation__
 *
 * To run a mutation, you first call `useLeadRemoveByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeadRemoveByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leadRemoveByIdMutation, { data, loading, error }] = useLeadRemoveByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeadRemoveByIdMutation(baseOptions?: Apollo.MutationHookOptions<LeadRemoveByIdMutation, LeadRemoveByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeadRemoveByIdMutation, LeadRemoveByIdMutationVariables>(LeadRemoveByIdDocument, options);
      }
export type LeadRemoveByIdMutationHookResult = ReturnType<typeof useLeadRemoveByIdMutation>;
export type LeadRemoveByIdMutationResult = Apollo.MutationResult<LeadRemoveByIdMutation>;
export type LeadRemoveByIdMutationOptions = Apollo.BaseMutationOptions<LeadRemoveByIdMutation, LeadRemoveByIdMutationVariables>;
export const LeadUpdateByIdDocument = gql`
    mutation LeadUpdateById($id: MongoID!, $record: UpdateByIdLeadInput!) {
  leadUpdateById(_id: $id, record: $record) {
    recordId
    record {
      ...LeadFragment
    }
  }
}
    ${LeadFragmentFragmentDoc}`;
export type LeadUpdateByIdMutationFn = Apollo.MutationFunction<LeadUpdateByIdMutation, LeadUpdateByIdMutationVariables>;

/**
 * __useLeadUpdateByIdMutation__
 *
 * To run a mutation, you first call `useLeadUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeadUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leadUpdateByIdMutation, { data, loading, error }] = useLeadUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useLeadUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<LeadUpdateByIdMutation, LeadUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeadUpdateByIdMutation, LeadUpdateByIdMutationVariables>(LeadUpdateByIdDocument, options);
      }
export type LeadUpdateByIdMutationHookResult = ReturnType<typeof useLeadUpdateByIdMutation>;
export type LeadUpdateByIdMutationResult = Apollo.MutationResult<LeadUpdateByIdMutation>;
export type LeadUpdateByIdMutationOptions = Apollo.BaseMutationOptions<LeadUpdateByIdMutation, LeadUpdateByIdMutationVariables>;
export const ListCreateListsForAudiencesDocument = gql`
    mutation ListCreateListsForAudiences($organizationId: ID!) {
  listCreateListsForAudiences(organizationId: $organizationId) {
    _id
    name {
      ...MultilingualFragment
    }
    type
    kind
    audienceTagId
    audienceListKey
    archived
    favorited
    orderIndex
    locked
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type ListCreateListsForAudiencesMutationFn = Apollo.MutationFunction<ListCreateListsForAudiencesMutation, ListCreateListsForAudiencesMutationVariables>;

/**
 * __useListCreateListsForAudiencesMutation__
 *
 * To run a mutation, you first call `useListCreateListsForAudiencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListCreateListsForAudiencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listCreateListsForAudiencesMutation, { data, loading, error }] = useListCreateListsForAudiencesMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListCreateListsForAudiencesMutation(baseOptions?: Apollo.MutationHookOptions<ListCreateListsForAudiencesMutation, ListCreateListsForAudiencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListCreateListsForAudiencesMutation, ListCreateListsForAudiencesMutationVariables>(ListCreateListsForAudiencesDocument, options);
      }
export type ListCreateListsForAudiencesMutationHookResult = ReturnType<typeof useListCreateListsForAudiencesMutation>;
export type ListCreateListsForAudiencesMutationResult = Apollo.MutationResult<ListCreateListsForAudiencesMutation>;
export type ListCreateListsForAudiencesMutationOptions = Apollo.BaseMutationOptions<ListCreateListsForAudiencesMutation, ListCreateListsForAudiencesMutationVariables>;
export const ListCreateMembersForTiersDocument = gql`
    mutation ListCreateMembersForTiers($organizationId: ID!) {
  listCreateMembersForTiers(organizationId: $organizationId) {
    _id
    name {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    type
    kind
    tierTagId
    memberListKey
    archived
    favorited
    orderIndex
    entityReferences {
      _entityId
      _versionId
      type
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type ListCreateMembersForTiersMutationFn = Apollo.MutationFunction<ListCreateMembersForTiersMutation, ListCreateMembersForTiersMutationVariables>;

/**
 * __useListCreateMembersForTiersMutation__
 *
 * To run a mutation, you first call `useListCreateMembersForTiersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListCreateMembersForTiersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listCreateMembersForTiersMutation, { data, loading, error }] = useListCreateMembersForTiersMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListCreateMembersForTiersMutation(baseOptions?: Apollo.MutationHookOptions<ListCreateMembersForTiersMutation, ListCreateMembersForTiersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListCreateMembersForTiersMutation, ListCreateMembersForTiersMutationVariables>(ListCreateMembersForTiersDocument, options);
      }
export type ListCreateMembersForTiersMutationHookResult = ReturnType<typeof useListCreateMembersForTiersMutation>;
export type ListCreateMembersForTiersMutationResult = Apollo.MutationResult<ListCreateMembersForTiersMutation>;
export type ListCreateMembersForTiersMutationOptions = Apollo.BaseMutationOptions<ListCreateMembersForTiersMutation, ListCreateMembersForTiersMutationVariables>;
export const ListCreateDocument = gql`
    mutation ListCreate($record: CreateOneListInput!) {
  listCreate(record: $record) {
    record {
      _id
      name {
        ...MultilingualFragment
      }
      owner {
        entityId
        type
      }
      selections
      type
      kind
      tierTagId
      entityReferences {
        _entityId
        _versionId
        type
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type ListCreateMutationFn = Apollo.MutationFunction<ListCreateMutation, ListCreateMutationVariables>;

/**
 * __useListCreateMutation__
 *
 * To run a mutation, you first call `useListCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listCreateMutation, { data, loading, error }] = useListCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useListCreateMutation(baseOptions?: Apollo.MutationHookOptions<ListCreateMutation, ListCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListCreateMutation, ListCreateMutationVariables>(ListCreateDocument, options);
      }
export type ListCreateMutationHookResult = ReturnType<typeof useListCreateMutation>;
export type ListCreateMutationResult = Apollo.MutationResult<ListCreateMutation>;
export type ListCreateMutationOptions = Apollo.BaseMutationOptions<ListCreateMutation, ListCreateMutationVariables>;
export const ListDeleteByIdDocument = gql`
    mutation ListDeleteById($id: MongoID!) {
  listDeleteById(_id: $id) {
    recordId
  }
}
    `;
export type ListDeleteByIdMutationFn = Apollo.MutationFunction<ListDeleteByIdMutation, ListDeleteByIdMutationVariables>;

/**
 * __useListDeleteByIdMutation__
 *
 * To run a mutation, you first call `useListDeleteByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListDeleteByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listDeleteByIdMutation, { data, loading, error }] = useListDeleteByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListDeleteByIdMutation(baseOptions?: Apollo.MutationHookOptions<ListDeleteByIdMutation, ListDeleteByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListDeleteByIdMutation, ListDeleteByIdMutationVariables>(ListDeleteByIdDocument, options);
      }
export type ListDeleteByIdMutationHookResult = ReturnType<typeof useListDeleteByIdMutation>;
export type ListDeleteByIdMutationResult = Apollo.MutationResult<ListDeleteByIdMutation>;
export type ListDeleteByIdMutationOptions = Apollo.BaseMutationOptions<ListDeleteByIdMutation, ListDeleteByIdMutationVariables>;
export const ListUpdateByIdDocument = gql`
    mutation ListUpdateById($id: MongoID!, $record: UpdateByIdListInput!) {
  listUpdateById(_id: $id, record: $record) {
    _id
    type
    kind
    tierTagId
    filterTagIds
    selections
    name {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    archived
    favorited
    orderIndex
    locked
    lockedAt
    lockedBy
    lockedByName
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type ListUpdateByIdMutationFn = Apollo.MutationFunction<ListUpdateByIdMutation, ListUpdateByIdMutationVariables>;

/**
 * __useListUpdateByIdMutation__
 *
 * To run a mutation, you first call `useListUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listUpdateByIdMutation, { data, loading, error }] = useListUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useListUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ListUpdateByIdMutation, ListUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListUpdateByIdMutation, ListUpdateByIdMutationVariables>(ListUpdateByIdDocument, options);
      }
export type ListUpdateByIdMutationHookResult = ReturnType<typeof useListUpdateByIdMutation>;
export type ListUpdateByIdMutationResult = Apollo.MutationResult<ListUpdateByIdMutation>;
export type ListUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ListUpdateByIdMutation, ListUpdateByIdMutationVariables>;
export const MembershipAdminCancelDocument = gql`
    mutation MembershipAdminCancel($operatorEntityId: MongoID!, $organizationId: MongoID!) {
  membershipAdminCancel(
    operatorEntityId: $operatorEntityId
    organizationId: $organizationId
  )
}
    `;
export type MembershipAdminCancelMutationFn = Apollo.MutationFunction<MembershipAdminCancelMutation, MembershipAdminCancelMutationVariables>;

/**
 * __useMembershipAdminCancelMutation__
 *
 * To run a mutation, you first call `useMembershipAdminCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipAdminCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipAdminCancelMutation, { data, loading, error }] = useMembershipAdminCancelMutation({
 *   variables: {
 *      operatorEntityId: // value for 'operatorEntityId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembershipAdminCancelMutation(baseOptions?: Apollo.MutationHookOptions<MembershipAdminCancelMutation, MembershipAdminCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipAdminCancelMutation, MembershipAdminCancelMutationVariables>(MembershipAdminCancelDocument, options);
      }
export type MembershipAdminCancelMutationHookResult = ReturnType<typeof useMembershipAdminCancelMutation>;
export type MembershipAdminCancelMutationResult = Apollo.MutationResult<MembershipAdminCancelMutation>;
export type MembershipAdminCancelMutationOptions = Apollo.BaseMutationOptions<MembershipAdminCancelMutation, MembershipAdminCancelMutationVariables>;
export const MembershipBulkSetStatusForListDocument = gql`
    mutation MembershipBulkSetStatusForList($organizationId: MongoID!, $listId: MongoID!, $emailKind: PendingRenewalEmailKind!, $scheduleEmail: Boolean!, $force: Boolean) {
  membershipBulkSetStatusForList(
    organizationId: $organizationId
    listId: $listId
    emailKind: $emailKind
    scheduleEmail: $scheduleEmail
    force: $force
  ) {
    affected
    scheduled
    skipped {
      entityId
      name
      paidThrough
    }
  }
}
    `;
export type MembershipBulkSetStatusForListMutationFn = Apollo.MutationFunction<MembershipBulkSetStatusForListMutation, MembershipBulkSetStatusForListMutationVariables>;

/**
 * __useMembershipBulkSetStatusForListMutation__
 *
 * To run a mutation, you first call `useMembershipBulkSetStatusForListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipBulkSetStatusForListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipBulkSetStatusForListMutation, { data, loading, error }] = useMembershipBulkSetStatusForListMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      listId: // value for 'listId'
 *      emailKind: // value for 'emailKind'
 *      scheduleEmail: // value for 'scheduleEmail'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useMembershipBulkSetStatusForListMutation(baseOptions?: Apollo.MutationHookOptions<MembershipBulkSetStatusForListMutation, MembershipBulkSetStatusForListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipBulkSetStatusForListMutation, MembershipBulkSetStatusForListMutationVariables>(MembershipBulkSetStatusForListDocument, options);
      }
export type MembershipBulkSetStatusForListMutationHookResult = ReturnType<typeof useMembershipBulkSetStatusForListMutation>;
export type MembershipBulkSetStatusForListMutationResult = Apollo.MutationResult<MembershipBulkSetStatusForListMutation>;
export type MembershipBulkSetStatusForListMutationOptions = Apollo.BaseMutationOptions<MembershipBulkSetStatusForListMutation, MembershipBulkSetStatusForListMutationVariables>;
export const MembershipCancelPendingRenewalEmailsDocument = gql`
    mutation MembershipCancelPendingRenewalEmails($ids: [MongoID!]!) {
  membershipCancelPendingRenewalEmails(ids: $ids)
}
    `;
export type MembershipCancelPendingRenewalEmailsMutationFn = Apollo.MutationFunction<MembershipCancelPendingRenewalEmailsMutation, MembershipCancelPendingRenewalEmailsMutationVariables>;

/**
 * __useMembershipCancelPendingRenewalEmailsMutation__
 *
 * To run a mutation, you first call `useMembershipCancelPendingRenewalEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipCancelPendingRenewalEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipCancelPendingRenewalEmailsMutation, { data, loading, error }] = useMembershipCancelPendingRenewalEmailsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useMembershipCancelPendingRenewalEmailsMutation(baseOptions?: Apollo.MutationHookOptions<MembershipCancelPendingRenewalEmailsMutation, MembershipCancelPendingRenewalEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipCancelPendingRenewalEmailsMutation, MembershipCancelPendingRenewalEmailsMutationVariables>(MembershipCancelPendingRenewalEmailsDocument, options);
      }
export type MembershipCancelPendingRenewalEmailsMutationHookResult = ReturnType<typeof useMembershipCancelPendingRenewalEmailsMutation>;
export type MembershipCancelPendingRenewalEmailsMutationResult = Apollo.MutationResult<MembershipCancelPendingRenewalEmailsMutation>;
export type MembershipCancelPendingRenewalEmailsMutationOptions = Apollo.BaseMutationOptions<MembershipCancelPendingRenewalEmailsMutation, MembershipCancelPendingRenewalEmailsMutationVariables>;
export const MembershipChecklistFixDocument = gql`
    mutation MembershipChecklistFix($organizationId: MongoID!, $action: String!, $dryRun: Boolean!, $date: Date, $statusTagId: MongoID, $fromStatusTagId: MongoID, $cyclePaid: Boolean, $graceDays: Int, $neverExpire: Boolean) {
  membershipChecklistFix(
    organizationId: $organizationId
    action: $action
    dryRun: $dryRun
    date: $date
    statusTagId: $statusTagId
    fromStatusTagId: $fromStatusTagId
    cyclePaid: $cyclePaid
    graceDays: $graceDays
    neverExpire: $neverExpire
  ) {
    affected
    date
    phaseAfter
    grace {
      ...RenewalRebaseGraceFragment
    }
    result {
      ...MembershipChecklistResultFragment
    }
  }
}
    ${RenewalRebaseGraceFragmentFragmentDoc}
${MembershipChecklistResultFragmentFragmentDoc}`;
export type MembershipChecklistFixMutationFn = Apollo.MutationFunction<MembershipChecklistFixMutation, MembershipChecklistFixMutationVariables>;

/**
 * __useMembershipChecklistFixMutation__
 *
 * To run a mutation, you first call `useMembershipChecklistFixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipChecklistFixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipChecklistFixMutation, { data, loading, error }] = useMembershipChecklistFixMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      action: // value for 'action'
 *      dryRun: // value for 'dryRun'
 *      date: // value for 'date'
 *      statusTagId: // value for 'statusTagId'
 *      fromStatusTagId: // value for 'fromStatusTagId'
 *      cyclePaid: // value for 'cyclePaid'
 *      graceDays: // value for 'graceDays'
 *      neverExpire: // value for 'neverExpire'
 *   },
 * });
 */
export function useMembershipChecklistFixMutation(baseOptions?: Apollo.MutationHookOptions<MembershipChecklistFixMutation, MembershipChecklistFixMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipChecklistFixMutation, MembershipChecklistFixMutationVariables>(MembershipChecklistFixDocument, options);
      }
export type MembershipChecklistFixMutationHookResult = ReturnType<typeof useMembershipChecklistFixMutation>;
export type MembershipChecklistFixMutationResult = Apollo.MutationResult<MembershipChecklistFixMutation>;
export type MembershipChecklistFixMutationOptions = Apollo.BaseMutationOptions<MembershipChecklistFixMutation, MembershipChecklistFixMutationVariables>;
export const MembershipChecklistRunDocument = gql`
    mutation MembershipChecklistRun($organizationId: MongoID!) {
  membershipChecklistRun(organizationId: $organizationId) {
    ...MembershipChecklistResultFragment
  }
}
    ${MembershipChecklistResultFragmentFragmentDoc}`;
export type MembershipChecklistRunMutationFn = Apollo.MutationFunction<MembershipChecklistRunMutation, MembershipChecklistRunMutationVariables>;

/**
 * __useMembershipChecklistRunMutation__
 *
 * To run a mutation, you first call `useMembershipChecklistRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipChecklistRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipChecklistRunMutation, { data, loading, error }] = useMembershipChecklistRunMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembershipChecklistRunMutation(baseOptions?: Apollo.MutationHookOptions<MembershipChecklistRunMutation, MembershipChecklistRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipChecklistRunMutation, MembershipChecklistRunMutationVariables>(MembershipChecklistRunDocument, options);
      }
export type MembershipChecklistRunMutationHookResult = ReturnType<typeof useMembershipChecklistRunMutation>;
export type MembershipChecklistRunMutationResult = Apollo.MutationResult<MembershipChecklistRunMutation>;
export type MembershipChecklistRunMutationOptions = Apollo.BaseMutationOptions<MembershipChecklistRunMutation, MembershipChecklistRunMutationVariables>;
export const MembershipDeclineStatusEmailsDocument = gql`
    mutation MembershipDeclineStatusEmails($organizationId: MongoID!, $listId: MongoID!, $statusTagId: MongoID!) {
  membershipDeclineStatusEmails(
    organizationId: $organizationId
    listId: $listId
    statusTagId: $statusTagId
  ) {
    declined
    skippedQueued
    skippedContacted
    skippedNoEmail
  }
}
    `;
export type MembershipDeclineStatusEmailsMutationFn = Apollo.MutationFunction<MembershipDeclineStatusEmailsMutation, MembershipDeclineStatusEmailsMutationVariables>;

/**
 * __useMembershipDeclineStatusEmailsMutation__
 *
 * To run a mutation, you first call `useMembershipDeclineStatusEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipDeclineStatusEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipDeclineStatusEmailsMutation, { data, loading, error }] = useMembershipDeclineStatusEmailsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      listId: // value for 'listId'
 *      statusTagId: // value for 'statusTagId'
 *   },
 * });
 */
export function useMembershipDeclineStatusEmailsMutation(baseOptions?: Apollo.MutationHookOptions<MembershipDeclineStatusEmailsMutation, MembershipDeclineStatusEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipDeclineStatusEmailsMutation, MembershipDeclineStatusEmailsMutationVariables>(MembershipDeclineStatusEmailsDocument, options);
      }
export type MembershipDeclineStatusEmailsMutationHookResult = ReturnType<typeof useMembershipDeclineStatusEmailsMutation>;
export type MembershipDeclineStatusEmailsMutationResult = Apollo.MutationResult<MembershipDeclineStatusEmailsMutation>;
export type MembershipDeclineStatusEmailsMutationOptions = Apollo.BaseMutationOptions<MembershipDeclineStatusEmailsMutation, MembershipDeclineStatusEmailsMutationVariables>;
export const MembershipLaunchSetModeDocument = gql`
    mutation MembershipLaunchSetMode($organizationId: MongoID!, $mode: String!) {
  membershipLaunchSetMode(organizationId: $organizationId, mode: $mode) {
    _id
  }
}
    `;
export type MembershipLaunchSetModeMutationFn = Apollo.MutationFunction<MembershipLaunchSetModeMutation, MembershipLaunchSetModeMutationVariables>;

/**
 * __useMembershipLaunchSetModeMutation__
 *
 * To run a mutation, you first call `useMembershipLaunchSetModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipLaunchSetModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipLaunchSetModeMutation, { data, loading, error }] = useMembershipLaunchSetModeMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useMembershipLaunchSetModeMutation(baseOptions?: Apollo.MutationHookOptions<MembershipLaunchSetModeMutation, MembershipLaunchSetModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipLaunchSetModeMutation, MembershipLaunchSetModeMutationVariables>(MembershipLaunchSetModeDocument, options);
      }
export type MembershipLaunchSetModeMutationHookResult = ReturnType<typeof useMembershipLaunchSetModeMutation>;
export type MembershipLaunchSetModeMutationResult = Apollo.MutationResult<MembershipLaunchSetModeMutation>;
export type MembershipLaunchSetModeMutationOptions = Apollo.BaseMutationOptions<MembershipLaunchSetModeMutation, MembershipLaunchSetModeMutationVariables>;
export const MembershipLaunchDocument = gql`
    mutation MembershipLaunch($organizationId: MongoID!) {
  membershipLaunch(organizationId: $organizationId) {
    _id
  }
}
    `;
export type MembershipLaunchMutationFn = Apollo.MutationFunction<MembershipLaunchMutation, MembershipLaunchMutationVariables>;

/**
 * __useMembershipLaunchMutation__
 *
 * To run a mutation, you first call `useMembershipLaunchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipLaunchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipLaunchMutation, { data, loading, error }] = useMembershipLaunchMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembershipLaunchMutation(baseOptions?: Apollo.MutationHookOptions<MembershipLaunchMutation, MembershipLaunchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipLaunchMutation, MembershipLaunchMutationVariables>(MembershipLaunchDocument, options);
      }
export type MembershipLaunchMutationHookResult = ReturnType<typeof useMembershipLaunchMutation>;
export type MembershipLaunchMutationResult = Apollo.MutationResult<MembershipLaunchMutation>;
export type MembershipLaunchMutationOptions = Apollo.BaseMutationOptions<MembershipLaunchMutation, MembershipLaunchMutationVariables>;
export const MembershipRepairScheduleSnapshotsDocument = gql`
    mutation MembershipRepairScheduleSnapshots($organizationId: MongoID!) {
  membershipRepairScheduleSnapshots(organizationId: $organizationId) {
    checkouts
    purchases
  }
}
    `;
export type MembershipRepairScheduleSnapshotsMutationFn = Apollo.MutationFunction<MembershipRepairScheduleSnapshotsMutation, MembershipRepairScheduleSnapshotsMutationVariables>;

/**
 * __useMembershipRepairScheduleSnapshotsMutation__
 *
 * To run a mutation, you first call `useMembershipRepairScheduleSnapshotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipRepairScheduleSnapshotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipRepairScheduleSnapshotsMutation, { data, loading, error }] = useMembershipRepairScheduleSnapshotsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembershipRepairScheduleSnapshotsMutation(baseOptions?: Apollo.MutationHookOptions<MembershipRepairScheduleSnapshotsMutation, MembershipRepairScheduleSnapshotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipRepairScheduleSnapshotsMutation, MembershipRepairScheduleSnapshotsMutationVariables>(MembershipRepairScheduleSnapshotsDocument, options);
      }
export type MembershipRepairScheduleSnapshotsMutationHookResult = ReturnType<typeof useMembershipRepairScheduleSnapshotsMutation>;
export type MembershipRepairScheduleSnapshotsMutationResult = Apollo.MutationResult<MembershipRepairScheduleSnapshotsMutation>;
export type MembershipRepairScheduleSnapshotsMutationOptions = Apollo.BaseMutationOptions<MembershipRepairScheduleSnapshotsMutation, MembershipRepairScheduleSnapshotsMutationVariables>;
export const OrganizationRenewalScheduleApplyDocument = gql`
    mutation OrganizationRenewalScheduleApply($organizationId: MongoID!, $kind: String!, $month: Int, $day: Int, $intent: String, $outlierTarget: String, $date: Date, $scope: String, $graceDays: Int, $neverExpire: Boolean, $note: String) {
  organizationRenewalScheduleApply(
    organizationId: $organizationId
    kind: $kind
    month: $month
    day: $day
    intent: $intent
    outlierTarget: $outlierTarget
    date: $date
    scope: $scope
    graceDays: $graceDays
    neverExpire: $neverExpire
    note: $note
  ) {
    ...RenewalRebasePlanFragment
  }
}
    ${RenewalRebasePlanFragmentFragmentDoc}`;
export type OrganizationRenewalScheduleApplyMutationFn = Apollo.MutationFunction<OrganizationRenewalScheduleApplyMutation, OrganizationRenewalScheduleApplyMutationVariables>;

/**
 * __useOrganizationRenewalScheduleApplyMutation__
 *
 * To run a mutation, you first call `useOrganizationRenewalScheduleApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRenewalScheduleApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationRenewalScheduleApplyMutation, { data, loading, error }] = useOrganizationRenewalScheduleApplyMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      kind: // value for 'kind'
 *      month: // value for 'month'
 *      day: // value for 'day'
 *      intent: // value for 'intent'
 *      outlierTarget: // value for 'outlierTarget'
 *      date: // value for 'date'
 *      scope: // value for 'scope'
 *      graceDays: // value for 'graceDays'
 *      neverExpire: // value for 'neverExpire'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useOrganizationRenewalScheduleApplyMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationRenewalScheduleApplyMutation, OrganizationRenewalScheduleApplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationRenewalScheduleApplyMutation, OrganizationRenewalScheduleApplyMutationVariables>(OrganizationRenewalScheduleApplyDocument, options);
      }
export type OrganizationRenewalScheduleApplyMutationHookResult = ReturnType<typeof useOrganizationRenewalScheduleApplyMutation>;
export type OrganizationRenewalScheduleApplyMutationResult = Apollo.MutationResult<OrganizationRenewalScheduleApplyMutation>;
export type OrganizationRenewalScheduleApplyMutationOptions = Apollo.BaseMutationOptions<OrganizationRenewalScheduleApplyMutation, OrganizationRenewalScheduleApplyMutationVariables>;
export const MembershipMarkRenewedDocument = gql`
    mutation MembershipMarkRenewed($operatorEntityId: MongoID!, $organizationId: MongoID!) {
  membershipMarkRenewed(
    operatorEntityId: $operatorEntityId
    organizationId: $organizationId
  )
}
    `;
export type MembershipMarkRenewedMutationFn = Apollo.MutationFunction<MembershipMarkRenewedMutation, MembershipMarkRenewedMutationVariables>;

/**
 * __useMembershipMarkRenewedMutation__
 *
 * To run a mutation, you first call `useMembershipMarkRenewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipMarkRenewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipMarkRenewedMutation, { data, loading, error }] = useMembershipMarkRenewedMutation({
 *   variables: {
 *      operatorEntityId: // value for 'operatorEntityId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembershipMarkRenewedMutation(baseOptions?: Apollo.MutationHookOptions<MembershipMarkRenewedMutation, MembershipMarkRenewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipMarkRenewedMutation, MembershipMarkRenewedMutationVariables>(MembershipMarkRenewedDocument, options);
      }
export type MembershipMarkRenewedMutationHookResult = ReturnType<typeof useMembershipMarkRenewedMutation>;
export type MembershipMarkRenewedMutationResult = Apollo.MutationResult<MembershipMarkRenewedMutation>;
export type MembershipMarkRenewedMutationOptions = Apollo.BaseMutationOptions<MembershipMarkRenewedMutation, MembershipMarkRenewedMutationVariables>;
export const MembershipQueueCustomEmailsDocument = gql`
    mutation MembershipQueueCustomEmails($organizationId: MongoID!, $listId: MongoID!, $operatorEntityIds: [MongoID!], $subject: String!, $body: String!, $ctaLabel: String, $ctaUrl: String, $hideGreeting: Boolean, $includeCoolingDown: Boolean) {
  membershipQueueCustomEmails(
    organizationId: $organizationId
    listId: $listId
    operatorEntityIds: $operatorEntityIds
    subject: $subject
    body: $body
    ctaLabel: $ctaLabel
    ctaUrl: $ctaUrl
    hideGreeting: $hideGreeting
    includeCoolingDown: $includeCoolingDown
  ) {
    queued
    skippedQueued
    skippedCoolingDown
    skippedNoEmail
  }
}
    `;
export type MembershipQueueCustomEmailsMutationFn = Apollo.MutationFunction<MembershipQueueCustomEmailsMutation, MembershipQueueCustomEmailsMutationVariables>;

/**
 * __useMembershipQueueCustomEmailsMutation__
 *
 * To run a mutation, you first call `useMembershipQueueCustomEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipQueueCustomEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipQueueCustomEmailsMutation, { data, loading, error }] = useMembershipQueueCustomEmailsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      listId: // value for 'listId'
 *      operatorEntityIds: // value for 'operatorEntityIds'
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      ctaLabel: // value for 'ctaLabel'
 *      ctaUrl: // value for 'ctaUrl'
 *      hideGreeting: // value for 'hideGreeting'
 *      includeCoolingDown: // value for 'includeCoolingDown'
 *   },
 * });
 */
export function useMembershipQueueCustomEmailsMutation(baseOptions?: Apollo.MutationHookOptions<MembershipQueueCustomEmailsMutation, MembershipQueueCustomEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipQueueCustomEmailsMutation, MembershipQueueCustomEmailsMutationVariables>(MembershipQueueCustomEmailsDocument, options);
      }
export type MembershipQueueCustomEmailsMutationHookResult = ReturnType<typeof useMembershipQueueCustomEmailsMutation>;
export type MembershipQueueCustomEmailsMutationResult = Apollo.MutationResult<MembershipQueueCustomEmailsMutation>;
export type MembershipQueueCustomEmailsMutationOptions = Apollo.BaseMutationOptions<MembershipQueueCustomEmailsMutation, MembershipQueueCustomEmailsMutationVariables>;
export const MembershipQueueStatusEmailsDocument = gql`
    mutation MembershipQueueStatusEmails($organizationId: MongoID!, $listId: MongoID!, $statusTagId: MongoID!, $includeCoolingDown: Boolean) {
  membershipQueueStatusEmails(
    organizationId: $organizationId
    listId: $listId
    statusTagId: $statusTagId
    includeCoolingDown: $includeCoolingDown
  ) {
    queued
    skippedContacted
    skippedCoolingDown
    skippedNoEmail
    skippedQueued
  }
}
    `;
export type MembershipQueueStatusEmailsMutationFn = Apollo.MutationFunction<MembershipQueueStatusEmailsMutation, MembershipQueueStatusEmailsMutationVariables>;

/**
 * __useMembershipQueueStatusEmailsMutation__
 *
 * To run a mutation, you first call `useMembershipQueueStatusEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipQueueStatusEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipQueueStatusEmailsMutation, { data, loading, error }] = useMembershipQueueStatusEmailsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      listId: // value for 'listId'
 *      statusTagId: // value for 'statusTagId'
 *      includeCoolingDown: // value for 'includeCoolingDown'
 *   },
 * });
 */
export function useMembershipQueueStatusEmailsMutation(baseOptions?: Apollo.MutationHookOptions<MembershipQueueStatusEmailsMutation, MembershipQueueStatusEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipQueueStatusEmailsMutation, MembershipQueueStatusEmailsMutationVariables>(MembershipQueueStatusEmailsDocument, options);
      }
export type MembershipQueueStatusEmailsMutationHookResult = ReturnType<typeof useMembershipQueueStatusEmailsMutation>;
export type MembershipQueueStatusEmailsMutationResult = Apollo.MutationResult<MembershipQueueStatusEmailsMutation>;
export type MembershipQueueStatusEmailsMutationOptions = Apollo.BaseMutationOptions<MembershipQueueStatusEmailsMutation, MembershipQueueStatusEmailsMutationVariables>;
export const MembershipScheduleRenewalEmailForListingsDocument = gql`
    mutation MembershipScheduleRenewalEmailForListings($organizationId: MongoID!, $operatorEntityIds: [MongoID!]!, $emailKind: PendingRenewalEmailKind!, $listId: MongoID, $force: Boolean) {
  membershipScheduleRenewalEmailForListings(
    organizationId: $organizationId
    operatorEntityIds: $operatorEntityIds
    emailKind: $emailKind
    listId: $listId
    force: $force
  ) {
    _id
    emailKind
    scheduledSendAt
    status
    subject {
      type
      entityId
    }
  }
}
    `;
export type MembershipScheduleRenewalEmailForListingsMutationFn = Apollo.MutationFunction<MembershipScheduleRenewalEmailForListingsMutation, MembershipScheduleRenewalEmailForListingsMutationVariables>;

/**
 * __useMembershipScheduleRenewalEmailForListingsMutation__
 *
 * To run a mutation, you first call `useMembershipScheduleRenewalEmailForListingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipScheduleRenewalEmailForListingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipScheduleRenewalEmailForListingsMutation, { data, loading, error }] = useMembershipScheduleRenewalEmailForListingsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      operatorEntityIds: // value for 'operatorEntityIds'
 *      emailKind: // value for 'emailKind'
 *      listId: // value for 'listId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useMembershipScheduleRenewalEmailForListingsMutation(baseOptions?: Apollo.MutationHookOptions<MembershipScheduleRenewalEmailForListingsMutation, MembershipScheduleRenewalEmailForListingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipScheduleRenewalEmailForListingsMutation, MembershipScheduleRenewalEmailForListingsMutationVariables>(MembershipScheduleRenewalEmailForListingsDocument, options);
      }
export type MembershipScheduleRenewalEmailForListingsMutationHookResult = ReturnType<typeof useMembershipScheduleRenewalEmailForListingsMutation>;
export type MembershipScheduleRenewalEmailForListingsMutationResult = Apollo.MutationResult<MembershipScheduleRenewalEmailForListingsMutation>;
export type MembershipScheduleRenewalEmailForListingsMutationOptions = Apollo.BaseMutationOptions<MembershipScheduleRenewalEmailForListingsMutation, MembershipScheduleRenewalEmailForListingsMutationVariables>;
export const MembershipSendPendingRenewalEmailsNowDocument = gql`
    mutation MembershipSendPendingRenewalEmailsNow($ids: [MongoID!]!, $background: Boolean) {
  membershipSendPendingRenewalEmailsNow(ids: $ids, background: $background) {
    sent
    skipped
    started
  }
}
    `;
export type MembershipSendPendingRenewalEmailsNowMutationFn = Apollo.MutationFunction<MembershipSendPendingRenewalEmailsNowMutation, MembershipSendPendingRenewalEmailsNowMutationVariables>;

/**
 * __useMembershipSendPendingRenewalEmailsNowMutation__
 *
 * To run a mutation, you first call `useMembershipSendPendingRenewalEmailsNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipSendPendingRenewalEmailsNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipSendPendingRenewalEmailsNowMutation, { data, loading, error }] = useMembershipSendPendingRenewalEmailsNowMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      background: // value for 'background'
 *   },
 * });
 */
export function useMembershipSendPendingRenewalEmailsNowMutation(baseOptions?: Apollo.MutationHookOptions<MembershipSendPendingRenewalEmailsNowMutation, MembershipSendPendingRenewalEmailsNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipSendPendingRenewalEmailsNowMutation, MembershipSendPendingRenewalEmailsNowMutationVariables>(MembershipSendPendingRenewalEmailsNowDocument, options);
      }
export type MembershipSendPendingRenewalEmailsNowMutationHookResult = ReturnType<typeof useMembershipSendPendingRenewalEmailsNowMutation>;
export type MembershipSendPendingRenewalEmailsNowMutationResult = Apollo.MutationResult<MembershipSendPendingRenewalEmailsNowMutation>;
export type MembershipSendPendingRenewalEmailsNowMutationOptions = Apollo.BaseMutationOptions<MembershipSendPendingRenewalEmailsNowMutation, MembershipSendPendingRenewalEmailsNowMutationVariables>;
export const MembershipSetManualRenewalDateDocument = gql`
    mutation MembershipSetManualRenewalDate($operatorEntityId: MongoID!, $organizationId: MongoID!, $date: Date, $note: String) {
  membershipSetManualRenewalDate(
    operatorEntityId: $operatorEntityId
    organizationId: $organizationId
    date: $date
    note: $note
  )
}
    `;
export type MembershipSetManualRenewalDateMutationFn = Apollo.MutationFunction<MembershipSetManualRenewalDateMutation, MembershipSetManualRenewalDateMutationVariables>;

/**
 * __useMembershipSetManualRenewalDateMutation__
 *
 * To run a mutation, you first call `useMembershipSetManualRenewalDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMembershipSetManualRenewalDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [membershipSetManualRenewalDateMutation, { data, loading, error }] = useMembershipSetManualRenewalDateMutation({
 *   variables: {
 *      operatorEntityId: // value for 'operatorEntityId'
 *      organizationId: // value for 'organizationId'
 *      date: // value for 'date'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useMembershipSetManualRenewalDateMutation(baseOptions?: Apollo.MutationHookOptions<MembershipSetManualRenewalDateMutation, MembershipSetManualRenewalDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MembershipSetManualRenewalDateMutation, MembershipSetManualRenewalDateMutationVariables>(MembershipSetManualRenewalDateDocument, options);
      }
export type MembershipSetManualRenewalDateMutationHookResult = ReturnType<typeof useMembershipSetManualRenewalDateMutation>;
export type MembershipSetManualRenewalDateMutationResult = Apollo.MutationResult<MembershipSetManualRenewalDateMutation>;
export type MembershipSetManualRenewalDateMutationOptions = Apollo.BaseMutationOptions<MembershipSetManualRenewalDateMutation, MembershipSetManualRenewalDateMutationVariables>;
export const MerchVariantStockUpdateDocument = gql`
    mutation MerchVariantStockUpdate($productId: ID!, $variantId: ID!, $inventoryCount: Int!, $reason: String!, $note: String) {
  merchVariantStockUpdate(
    productId: $productId
    variantId: $variantId
    inventoryCount: $inventoryCount
    reason: $reason
    note: $note
  ) {
    _id
  }
}
    `;
export type MerchVariantStockUpdateMutationFn = Apollo.MutationFunction<MerchVariantStockUpdateMutation, MerchVariantStockUpdateMutationVariables>;

/**
 * __useMerchVariantStockUpdateMutation__
 *
 * To run a mutation, you first call `useMerchVariantStockUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMerchVariantStockUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [merchVariantStockUpdateMutation, { data, loading, error }] = useMerchVariantStockUpdateMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      variantId: // value for 'variantId'
 *      inventoryCount: // value for 'inventoryCount'
 *      reason: // value for 'reason'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useMerchVariantStockUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MerchVariantStockUpdateMutation, MerchVariantStockUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MerchVariantStockUpdateMutation, MerchVariantStockUpdateMutationVariables>(MerchVariantStockUpdateDocument, options);
      }
export type MerchVariantStockUpdateMutationHookResult = ReturnType<typeof useMerchVariantStockUpdateMutation>;
export type MerchVariantStockUpdateMutationResult = Apollo.MutationResult<MerchVariantStockUpdateMutation>;
export type MerchVariantStockUpdateMutationOptions = Apollo.BaseMutationOptions<MerchVariantStockUpdateMutation, MerchVariantStockUpdateMutationVariables>;
export const EventSessionStockUpdateDocument = gql`
    mutation EventSessionStockUpdate($productId: ID!, $sessionId: String!, $remaining: Int!, $reason: String!, $note: String) {
  eventSessionStockUpdate(
    productId: $productId
    sessionId: $sessionId
    remaining: $remaining
    reason: $reason
    note: $note
  ) {
    _id
  }
}
    `;
export type EventSessionStockUpdateMutationFn = Apollo.MutationFunction<EventSessionStockUpdateMutation, EventSessionStockUpdateMutationVariables>;

/**
 * __useEventSessionStockUpdateMutation__
 *
 * To run a mutation, you first call `useEventSessionStockUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventSessionStockUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventSessionStockUpdateMutation, { data, loading, error }] = useEventSessionStockUpdateMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      sessionId: // value for 'sessionId'
 *      remaining: // value for 'remaining'
 *      reason: // value for 'reason'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useEventSessionStockUpdateMutation(baseOptions?: Apollo.MutationHookOptions<EventSessionStockUpdateMutation, EventSessionStockUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventSessionStockUpdateMutation, EventSessionStockUpdateMutationVariables>(EventSessionStockUpdateDocument, options);
      }
export type EventSessionStockUpdateMutationHookResult = ReturnType<typeof useEventSessionStockUpdateMutation>;
export type EventSessionStockUpdateMutationResult = Apollo.MutationResult<EventSessionStockUpdateMutation>;
export type EventSessionStockUpdateMutationOptions = Apollo.BaseMutationOptions<EventSessionStockUpdateMutation, EventSessionStockUpdateMutationVariables>;
export const EventLowStockThresholdUpdateDocument = gql`
    mutation EventLowStockThresholdUpdate($productId: ID!, $lowStockThreshold: Int) {
  eventLowStockThresholdUpdate(
    productId: $productId
    lowStockThreshold: $lowStockThreshold
  ) {
    _id
  }
}
    `;
export type EventLowStockThresholdUpdateMutationFn = Apollo.MutationFunction<EventLowStockThresholdUpdateMutation, EventLowStockThresholdUpdateMutationVariables>;

/**
 * __useEventLowStockThresholdUpdateMutation__
 *
 * To run a mutation, you first call `useEventLowStockThresholdUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventLowStockThresholdUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventLowStockThresholdUpdateMutation, { data, loading, error }] = useEventLowStockThresholdUpdateMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      lowStockThreshold: // value for 'lowStockThreshold'
 *   },
 * });
 */
export function useEventLowStockThresholdUpdateMutation(baseOptions?: Apollo.MutationHookOptions<EventLowStockThresholdUpdateMutation, EventLowStockThresholdUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventLowStockThresholdUpdateMutation, EventLowStockThresholdUpdateMutationVariables>(EventLowStockThresholdUpdateDocument, options);
      }
export type EventLowStockThresholdUpdateMutationHookResult = ReturnType<typeof useEventLowStockThresholdUpdateMutation>;
export type EventLowStockThresholdUpdateMutationResult = Apollo.MutationResult<EventLowStockThresholdUpdateMutation>;
export type EventLowStockThresholdUpdateMutationOptions = Apollo.BaseMutationOptions<EventLowStockThresholdUpdateMutation, EventLowStockThresholdUpdateMutationVariables>;
export const MerchLowStockThresholdUpdateDocument = gql`
    mutation MerchLowStockThresholdUpdate($productId: ID!, $lowStockThreshold: Int) {
  merchLowStockThresholdUpdate(
    productId: $productId
    lowStockThreshold: $lowStockThreshold
  ) {
    _id
  }
}
    `;
export type MerchLowStockThresholdUpdateMutationFn = Apollo.MutationFunction<MerchLowStockThresholdUpdateMutation, MerchLowStockThresholdUpdateMutationVariables>;

/**
 * __useMerchLowStockThresholdUpdateMutation__
 *
 * To run a mutation, you first call `useMerchLowStockThresholdUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMerchLowStockThresholdUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [merchLowStockThresholdUpdateMutation, { data, loading, error }] = useMerchLowStockThresholdUpdateMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      lowStockThreshold: // value for 'lowStockThreshold'
 *   },
 * });
 */
export function useMerchLowStockThresholdUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MerchLowStockThresholdUpdateMutation, MerchLowStockThresholdUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MerchLowStockThresholdUpdateMutation, MerchLowStockThresholdUpdateMutationVariables>(MerchLowStockThresholdUpdateDocument, options);
      }
export type MerchLowStockThresholdUpdateMutationHookResult = ReturnType<typeof useMerchLowStockThresholdUpdateMutation>;
export type MerchLowStockThresholdUpdateMutationResult = Apollo.MutationResult<MerchLowStockThresholdUpdateMutation>;
export type MerchLowStockThresholdUpdateMutationOptions = Apollo.BaseMutationOptions<MerchLowStockThresholdUpdateMutation, MerchLowStockThresholdUpdateMutationVariables>;
export const NoteCreateOneDocument = gql`
    mutation NoteCreateOne($record: CreateOneNoteInput!) {
  noteCreateOne(record: $record) {
    record {
      ...NoteFramgment
    }
  }
}
    ${NoteFramgmentFragmentDoc}`;
export type NoteCreateOneMutationFn = Apollo.MutationFunction<NoteCreateOneMutation, NoteCreateOneMutationVariables>;

/**
 * __useNoteCreateOneMutation__
 *
 * To run a mutation, you first call `useNoteCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteCreateOneMutation, { data, loading, error }] = useNoteCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useNoteCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<NoteCreateOneMutation, NoteCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoteCreateOneMutation, NoteCreateOneMutationVariables>(NoteCreateOneDocument, options);
      }
export type NoteCreateOneMutationHookResult = ReturnType<typeof useNoteCreateOneMutation>;
export type NoteCreateOneMutationResult = Apollo.MutationResult<NoteCreateOneMutation>;
export type NoteCreateOneMutationOptions = Apollo.BaseMutationOptions<NoteCreateOneMutation, NoteCreateOneMutationVariables>;
export const NoteRemoveByIdDocument = gql`
    mutation NoteRemoveById($id: MongoID!) {
  noteRemoveById(_id: $id) {
    record {
      ...NoteFramgment
    }
  }
}
    ${NoteFramgmentFragmentDoc}`;
export type NoteRemoveByIdMutationFn = Apollo.MutationFunction<NoteRemoveByIdMutation, NoteRemoveByIdMutationVariables>;

/**
 * __useNoteRemoveByIdMutation__
 *
 * To run a mutation, you first call `useNoteRemoveByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteRemoveByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteRemoveByIdMutation, { data, loading, error }] = useNoteRemoveByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNoteRemoveByIdMutation(baseOptions?: Apollo.MutationHookOptions<NoteRemoveByIdMutation, NoteRemoveByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoteRemoveByIdMutation, NoteRemoveByIdMutationVariables>(NoteRemoveByIdDocument, options);
      }
export type NoteRemoveByIdMutationHookResult = ReturnType<typeof useNoteRemoveByIdMutation>;
export type NoteRemoveByIdMutationResult = Apollo.MutationResult<NoteRemoveByIdMutation>;
export type NoteRemoveByIdMutationOptions = Apollo.BaseMutationOptions<NoteRemoveByIdMutation, NoteRemoveByIdMutationVariables>;
export const NoteUpdateByIdDocument = gql`
    mutation NoteUpdateById($id: MongoID!, $record: UpdateByIdNoteInput!) {
  noteUpdateById(_id: $id, record: $record) {
    record {
      ...NoteFramgment
    }
  }
}
    ${NoteFramgmentFragmentDoc}`;
export type NoteUpdateByIdMutationFn = Apollo.MutationFunction<NoteUpdateByIdMutation, NoteUpdateByIdMutationVariables>;

/**
 * __useNoteUpdateByIdMutation__
 *
 * To run a mutation, you first call `useNoteUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteUpdateByIdMutation, { data, loading, error }] = useNoteUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useNoteUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<NoteUpdateByIdMutation, NoteUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoteUpdateByIdMutation, NoteUpdateByIdMutationVariables>(NoteUpdateByIdDocument, options);
      }
export type NoteUpdateByIdMutationHookResult = ReturnType<typeof useNoteUpdateByIdMutation>;
export type NoteUpdateByIdMutationResult = Apollo.MutationResult<NoteUpdateByIdMutation>;
export type NoteUpdateByIdMutationOptions = Apollo.BaseMutationOptions<NoteUpdateByIdMutation, NoteUpdateByIdMutationVariables>;
export const OperatorAddExistingToOrganizationDocument = gql`
    mutation operatorAddExistingToOrganization($organizationId: ID!, $operatorEntityId: ID!, $importRunId: MongoID, $mergeOption: MergeOption) {
  operatorAddExistingToOrganization(
    organizationId: $organizationId
    operatorEntityId: $operatorEntityId
    importRunId: $importRunId
    mergeOption: $mergeOption
  ) {
    _id
    _entityId
    _versionId
    name {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type OperatorAddExistingToOrganizationMutationFn = Apollo.MutationFunction<OperatorAddExistingToOrganizationMutation, OperatorAddExistingToOrganizationMutationVariables>;

/**
 * __useOperatorAddExistingToOrganizationMutation__
 *
 * To run a mutation, you first call `useOperatorAddExistingToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorAddExistingToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorAddExistingToOrganizationMutation, { data, loading, error }] = useOperatorAddExistingToOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      operatorEntityId: // value for 'operatorEntityId'
 *      importRunId: // value for 'importRunId'
 *      mergeOption: // value for 'mergeOption'
 *   },
 * });
 */
export function useOperatorAddExistingToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<OperatorAddExistingToOrganizationMutation, OperatorAddExistingToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorAddExistingToOrganizationMutation, OperatorAddExistingToOrganizationMutationVariables>(OperatorAddExistingToOrganizationDocument, options);
      }
export type OperatorAddExistingToOrganizationMutationHookResult = ReturnType<typeof useOperatorAddExistingToOrganizationMutation>;
export type OperatorAddExistingToOrganizationMutationResult = Apollo.MutationResult<OperatorAddExistingToOrganizationMutation>;
export type OperatorAddExistingToOrganizationMutationOptions = Apollo.BaseMutationOptions<OperatorAddExistingToOrganizationMutation, OperatorAddExistingToOrganizationMutationVariables>;
export const OperatorAiImageScanCreateDocument = gql`
    mutation OperatorAiImageScanCreate($operatorId: String!, $websiteUrl: String!, $organizationId: String) {
  operatorAiImageScanCreate(
    operatorId: $operatorId
    websiteUrl: $websiteUrl
    organizationId: $organizationId
  ) {
    taskId
  }
}
    `;
export type OperatorAiImageScanCreateMutationFn = Apollo.MutationFunction<OperatorAiImageScanCreateMutation, OperatorAiImageScanCreateMutationVariables>;

/**
 * __useOperatorAiImageScanCreateMutation__
 *
 * To run a mutation, you first call `useOperatorAiImageScanCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorAiImageScanCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorAiImageScanCreateMutation, { data, loading, error }] = useOperatorAiImageScanCreateMutation({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *      websiteUrl: // value for 'websiteUrl'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOperatorAiImageScanCreateMutation(baseOptions?: Apollo.MutationHookOptions<OperatorAiImageScanCreateMutation, OperatorAiImageScanCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorAiImageScanCreateMutation, OperatorAiImageScanCreateMutationVariables>(OperatorAiImageScanCreateDocument, options);
      }
export type OperatorAiImageScanCreateMutationHookResult = ReturnType<typeof useOperatorAiImageScanCreateMutation>;
export type OperatorAiImageScanCreateMutationResult = Apollo.MutationResult<OperatorAiImageScanCreateMutation>;
export type OperatorAiImageScanCreateMutationOptions = Apollo.BaseMutationOptions<OperatorAiImageScanCreateMutation, OperatorAiImageScanCreateMutationVariables>;
export const OperatorAiImageScanExecuteDocument = gql`
    mutation OperatorAiImageScanExecute($taskId: MongoID!) {
  operatorAiImageScanExecute(taskId: $taskId) {
    success
    cancelled
    result {
      images {
        url
        alt
        pageUrl
        isOgImage
      }
    }
    errorMessage
  }
}
    `;
export type OperatorAiImageScanExecuteMutationFn = Apollo.MutationFunction<OperatorAiImageScanExecuteMutation, OperatorAiImageScanExecuteMutationVariables>;

/**
 * __useOperatorAiImageScanExecuteMutation__
 *
 * To run a mutation, you first call `useOperatorAiImageScanExecuteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorAiImageScanExecuteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorAiImageScanExecuteMutation, { data, loading, error }] = useOperatorAiImageScanExecuteMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useOperatorAiImageScanExecuteMutation(baseOptions?: Apollo.MutationHookOptions<OperatorAiImageScanExecuteMutation, OperatorAiImageScanExecuteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorAiImageScanExecuteMutation, OperatorAiImageScanExecuteMutationVariables>(OperatorAiImageScanExecuteDocument, options);
      }
export type OperatorAiImageScanExecuteMutationHookResult = ReturnType<typeof useOperatorAiImageScanExecuteMutation>;
export type OperatorAiImageScanExecuteMutationResult = Apollo.MutationResult<OperatorAiImageScanExecuteMutation>;
export type OperatorAiImageScanExecuteMutationOptions = Apollo.BaseMutationOptions<OperatorAiImageScanExecuteMutation, OperatorAiImageScanExecuteMutationVariables>;
export const OperatorAiImageScanUploadDocument = gql`
    mutation OperatorAiImageScanUpload($taskId: MongoID!, $entityId: String!, $urls: [String!]!) {
  operatorAiImageScanUpload(taskId: $taskId, entityId: $entityId, urls: $urls) {
    success
    assets {
      _id
      url
      width
      height
    }
    errorMessage
  }
}
    `;
export type OperatorAiImageScanUploadMutationFn = Apollo.MutationFunction<OperatorAiImageScanUploadMutation, OperatorAiImageScanUploadMutationVariables>;

/**
 * __useOperatorAiImageScanUploadMutation__
 *
 * To run a mutation, you first call `useOperatorAiImageScanUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorAiImageScanUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorAiImageScanUploadMutation, { data, loading, error }] = useOperatorAiImageScanUploadMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      entityId: // value for 'entityId'
 *      urls: // value for 'urls'
 *   },
 * });
 */
export function useOperatorAiImageScanUploadMutation(baseOptions?: Apollo.MutationHookOptions<OperatorAiImageScanUploadMutation, OperatorAiImageScanUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorAiImageScanUploadMutation, OperatorAiImageScanUploadMutationVariables>(OperatorAiImageScanUploadDocument, options);
      }
export type OperatorAiImageScanUploadMutationHookResult = ReturnType<typeof useOperatorAiImageScanUploadMutation>;
export type OperatorAiImageScanUploadMutationResult = Apollo.MutationResult<OperatorAiImageScanUploadMutation>;
export type OperatorAiImageScanUploadMutationOptions = Apollo.BaseMutationOptions<OperatorAiImageScanUploadMutation, OperatorAiImageScanUploadMutationVariables>;
export const OperatorAiImageVerifyUrlsDocument = gql`
    mutation OperatorAiImageVerifyUrls($urls: [String!]!) {
  operatorAiImageVerifyUrls(urls: $urls) {
    results {
      url
      downloadable
    }
  }
}
    `;
export type OperatorAiImageVerifyUrlsMutationFn = Apollo.MutationFunction<OperatorAiImageVerifyUrlsMutation, OperatorAiImageVerifyUrlsMutationVariables>;

/**
 * __useOperatorAiImageVerifyUrlsMutation__
 *
 * To run a mutation, you first call `useOperatorAiImageVerifyUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorAiImageVerifyUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorAiImageVerifyUrlsMutation, { data, loading, error }] = useOperatorAiImageVerifyUrlsMutation({
 *   variables: {
 *      urls: // value for 'urls'
 *   },
 * });
 */
export function useOperatorAiImageVerifyUrlsMutation(baseOptions?: Apollo.MutationHookOptions<OperatorAiImageVerifyUrlsMutation, OperatorAiImageVerifyUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorAiImageVerifyUrlsMutation, OperatorAiImageVerifyUrlsMutationVariables>(OperatorAiImageVerifyUrlsDocument, options);
      }
export type OperatorAiImageVerifyUrlsMutationHookResult = ReturnType<typeof useOperatorAiImageVerifyUrlsMutation>;
export type OperatorAiImageVerifyUrlsMutationResult = Apollo.MutationResult<OperatorAiImageVerifyUrlsMutation>;
export type OperatorAiImageVerifyUrlsMutationOptions = Apollo.BaseMutationOptions<OperatorAiImageVerifyUrlsMutation, OperatorAiImageVerifyUrlsMutationVariables>;
export const OperatorAiProfileScanCreateDocument = gql`
    mutation OperatorAiProfileScanCreate($operatorId: String!, $websiteUrl: String!, $fieldsRequested: [String!]!, $organizationId: String) {
  operatorAiProfileScanCreate(
    operatorId: $operatorId
    websiteUrl: $websiteUrl
    fieldsRequested: $fieldsRequested
    organizationId: $organizationId
  ) {
    taskId
  }
}
    `;
export type OperatorAiProfileScanCreateMutationFn = Apollo.MutationFunction<OperatorAiProfileScanCreateMutation, OperatorAiProfileScanCreateMutationVariables>;

/**
 * __useOperatorAiProfileScanCreateMutation__
 *
 * To run a mutation, you first call `useOperatorAiProfileScanCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorAiProfileScanCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorAiProfileScanCreateMutation, { data, loading, error }] = useOperatorAiProfileScanCreateMutation({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *      websiteUrl: // value for 'websiteUrl'
 *      fieldsRequested: // value for 'fieldsRequested'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOperatorAiProfileScanCreateMutation(baseOptions?: Apollo.MutationHookOptions<OperatorAiProfileScanCreateMutation, OperatorAiProfileScanCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorAiProfileScanCreateMutation, OperatorAiProfileScanCreateMutationVariables>(OperatorAiProfileScanCreateDocument, options);
      }
export type OperatorAiProfileScanCreateMutationHookResult = ReturnType<typeof useOperatorAiProfileScanCreateMutation>;
export type OperatorAiProfileScanCreateMutationResult = Apollo.MutationResult<OperatorAiProfileScanCreateMutation>;
export type OperatorAiProfileScanCreateMutationOptions = Apollo.BaseMutationOptions<OperatorAiProfileScanCreateMutation, OperatorAiProfileScanCreateMutationVariables>;
export const OperatorAiProfileScanExecuteDocument = gql`
    mutation OperatorAiProfileScanExecute($taskId: MongoID!) {
  operatorAiProfileScanExecute(taskId: $taskId) {
    success
    cancelled
    result {
      description
      shortDescription
      socialLinks
      tags {
        businessType
        amenity
        global
      }
      email
      phone
      address {
        line1
        city
        subdivision
        postalCode
        country
        coordinates {
          lng
          lat
        }
      }
      operatorType
    }
    errorMessage
  }
}
    `;
export type OperatorAiProfileScanExecuteMutationFn = Apollo.MutationFunction<OperatorAiProfileScanExecuteMutation, OperatorAiProfileScanExecuteMutationVariables>;

/**
 * __useOperatorAiProfileScanExecuteMutation__
 *
 * To run a mutation, you first call `useOperatorAiProfileScanExecuteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorAiProfileScanExecuteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorAiProfileScanExecuteMutation, { data, loading, error }] = useOperatorAiProfileScanExecuteMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useOperatorAiProfileScanExecuteMutation(baseOptions?: Apollo.MutationHookOptions<OperatorAiProfileScanExecuteMutation, OperatorAiProfileScanExecuteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorAiProfileScanExecuteMutation, OperatorAiProfileScanExecuteMutationVariables>(OperatorAiProfileScanExecuteDocument, options);
      }
export type OperatorAiProfileScanExecuteMutationHookResult = ReturnType<typeof useOperatorAiProfileScanExecuteMutation>;
export type OperatorAiProfileScanExecuteMutationResult = Apollo.MutationResult<OperatorAiProfileScanExecuteMutation>;
export type OperatorAiProfileScanExecuteMutationOptions = Apollo.BaseMutationOptions<OperatorAiProfileScanExecuteMutation, OperatorAiProfileScanExecuteMutationVariables>;
export const OperatorBulkAcceptDraftsDocument = gql`
    mutation OperatorBulkAcceptDrafts($organizationId: ID!, $operatorEntityIds: [ID!]!) {
  operatorBulkAcceptDrafts(
    organizationId: $organizationId
    operatorEntityIds: $operatorEntityIds
  )
}
    `;
export type OperatorBulkAcceptDraftsMutationFn = Apollo.MutationFunction<OperatorBulkAcceptDraftsMutation, OperatorBulkAcceptDraftsMutationVariables>;

/**
 * __useOperatorBulkAcceptDraftsMutation__
 *
 * To run a mutation, you first call `useOperatorBulkAcceptDraftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorBulkAcceptDraftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorBulkAcceptDraftsMutation, { data, loading, error }] = useOperatorBulkAcceptDraftsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      operatorEntityIds: // value for 'operatorEntityIds'
 *   },
 * });
 */
export function useOperatorBulkAcceptDraftsMutation(baseOptions?: Apollo.MutationHookOptions<OperatorBulkAcceptDraftsMutation, OperatorBulkAcceptDraftsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorBulkAcceptDraftsMutation, OperatorBulkAcceptDraftsMutationVariables>(OperatorBulkAcceptDraftsDocument, options);
      }
export type OperatorBulkAcceptDraftsMutationHookResult = ReturnType<typeof useOperatorBulkAcceptDraftsMutation>;
export type OperatorBulkAcceptDraftsMutationResult = Apollo.MutationResult<OperatorBulkAcceptDraftsMutation>;
export type OperatorBulkAcceptDraftsMutationOptions = Apollo.BaseMutationOptions<OperatorBulkAcceptDraftsMutation, OperatorBulkAcceptDraftsMutationVariables>;
export const OperatorBulkApplyAudienceTagsDocument = gql`
    mutation OperatorBulkApplyAudienceTags($organizationId: ID!, $operatorEntityIds: [ID!]!, $audienceTagIds: [ID!]!, $action: String!) {
  operatorBulkApplyAudienceTags(
    organizationId: $organizationId
    operatorEntityIds: $operatorEntityIds
    audienceTagIds: $audienceTagIds
    action: $action
  )
}
    `;
export type OperatorBulkApplyAudienceTagsMutationFn = Apollo.MutationFunction<OperatorBulkApplyAudienceTagsMutation, OperatorBulkApplyAudienceTagsMutationVariables>;

/**
 * __useOperatorBulkApplyAudienceTagsMutation__
 *
 * To run a mutation, you first call `useOperatorBulkApplyAudienceTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorBulkApplyAudienceTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorBulkApplyAudienceTagsMutation, { data, loading, error }] = useOperatorBulkApplyAudienceTagsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      operatorEntityIds: // value for 'operatorEntityIds'
 *      audienceTagIds: // value for 'audienceTagIds'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useOperatorBulkApplyAudienceTagsMutation(baseOptions?: Apollo.MutationHookOptions<OperatorBulkApplyAudienceTagsMutation, OperatorBulkApplyAudienceTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorBulkApplyAudienceTagsMutation, OperatorBulkApplyAudienceTagsMutationVariables>(OperatorBulkApplyAudienceTagsDocument, options);
      }
export type OperatorBulkApplyAudienceTagsMutationHookResult = ReturnType<typeof useOperatorBulkApplyAudienceTagsMutation>;
export type OperatorBulkApplyAudienceTagsMutationResult = Apollo.MutationResult<OperatorBulkApplyAudienceTagsMutation>;
export type OperatorBulkApplyAudienceTagsMutationOptions = Apollo.BaseMutationOptions<OperatorBulkApplyAudienceTagsMutation, OperatorBulkApplyAudienceTagsMutationVariables>;
export const OperatorBulkApplyBackOfficeTagsDocument = gql`
    mutation OperatorBulkApplyBackOfficeTags($organizationId: ID!, $operatorEntityIds: [ID!]!, $tagIds: [ID!]!, $action: String!) {
  operatorBulkApplyBackOfficeTags(
    organizationId: $organizationId
    operatorEntityIds: $operatorEntityIds
    tagIds: $tagIds
    action: $action
  )
}
    `;
export type OperatorBulkApplyBackOfficeTagsMutationFn = Apollo.MutationFunction<OperatorBulkApplyBackOfficeTagsMutation, OperatorBulkApplyBackOfficeTagsMutationVariables>;

/**
 * __useOperatorBulkApplyBackOfficeTagsMutation__
 *
 * To run a mutation, you first call `useOperatorBulkApplyBackOfficeTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorBulkApplyBackOfficeTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorBulkApplyBackOfficeTagsMutation, { data, loading, error }] = useOperatorBulkApplyBackOfficeTagsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      operatorEntityIds: // value for 'operatorEntityIds'
 *      tagIds: // value for 'tagIds'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useOperatorBulkApplyBackOfficeTagsMutation(baseOptions?: Apollo.MutationHookOptions<OperatorBulkApplyBackOfficeTagsMutation, OperatorBulkApplyBackOfficeTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorBulkApplyBackOfficeTagsMutation, OperatorBulkApplyBackOfficeTagsMutationVariables>(OperatorBulkApplyBackOfficeTagsDocument, options);
      }
export type OperatorBulkApplyBackOfficeTagsMutationHookResult = ReturnType<typeof useOperatorBulkApplyBackOfficeTagsMutation>;
export type OperatorBulkApplyBackOfficeTagsMutationResult = Apollo.MutationResult<OperatorBulkApplyBackOfficeTagsMutation>;
export type OperatorBulkApplyBackOfficeTagsMutationOptions = Apollo.BaseMutationOptions<OperatorBulkApplyBackOfficeTagsMutation, OperatorBulkApplyBackOfficeTagsMutationVariables>;
export const OperatorCreateDocument = gql`
    mutation OperatorCreate($record: CreateOneOperatorInput!) {
  operatorCreate(record: $record) {
    record {
      _entityId
      name {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type OperatorCreateMutationFn = Apollo.MutationFunction<OperatorCreateMutation, OperatorCreateMutationVariables>;

/**
 * __useOperatorCreateMutation__
 *
 * To run a mutation, you first call `useOperatorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorCreateMutation, { data, loading, error }] = useOperatorCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useOperatorCreateMutation(baseOptions?: Apollo.MutationHookOptions<OperatorCreateMutation, OperatorCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorCreateMutation, OperatorCreateMutationVariables>(OperatorCreateDocument, options);
      }
export type OperatorCreateMutationHookResult = ReturnType<typeof useOperatorCreateMutation>;
export type OperatorCreateMutationResult = Apollo.MutationResult<OperatorCreateMutation>;
export type OperatorCreateMutationOptions = Apollo.BaseMutationOptions<OperatorCreateMutation, OperatorCreateMutationVariables>;
export const OperatorDeleteDocument = gql`
    mutation OperatorDelete($entityId: ID!) {
  operatorDelete(_entityId: $entityId) {
    _entityId
    _versionId
    status
    name {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type OperatorDeleteMutationFn = Apollo.MutationFunction<OperatorDeleteMutation, OperatorDeleteMutationVariables>;

/**
 * __useOperatorDeleteMutation__
 *
 * To run a mutation, you first call `useOperatorDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorDeleteMutation, { data, loading, error }] = useOperatorDeleteMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useOperatorDeleteMutation(baseOptions?: Apollo.MutationHookOptions<OperatorDeleteMutation, OperatorDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorDeleteMutation, OperatorDeleteMutationVariables>(OperatorDeleteDocument, options);
      }
export type OperatorDeleteMutationHookResult = ReturnType<typeof useOperatorDeleteMutation>;
export type OperatorDeleteMutationResult = Apollo.MutationResult<OperatorDeleteMutation>;
export type OperatorDeleteMutationOptions = Apollo.BaseMutationOptions<OperatorDeleteMutation, OperatorDeleteMutationVariables>;
export const OperatorDeleteCompletelyByInternalDocument = gql`
    mutation OperatorDeleteCompletelyByInternal($entityId: ID!) {
  operatorDeleteCompletelyByInternal(_entityId: $entityId)
}
    `;
export type OperatorDeleteCompletelyByInternalMutationFn = Apollo.MutationFunction<OperatorDeleteCompletelyByInternalMutation, OperatorDeleteCompletelyByInternalMutationVariables>;

/**
 * __useOperatorDeleteCompletelyByInternalMutation__
 *
 * To run a mutation, you first call `useOperatorDeleteCompletelyByInternalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorDeleteCompletelyByInternalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorDeleteCompletelyByInternalMutation, { data, loading, error }] = useOperatorDeleteCompletelyByInternalMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useOperatorDeleteCompletelyByInternalMutation(baseOptions?: Apollo.MutationHookOptions<OperatorDeleteCompletelyByInternalMutation, OperatorDeleteCompletelyByInternalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorDeleteCompletelyByInternalMutation, OperatorDeleteCompletelyByInternalMutationVariables>(OperatorDeleteCompletelyByInternalDocument, options);
      }
export type OperatorDeleteCompletelyByInternalMutationHookResult = ReturnType<typeof useOperatorDeleteCompletelyByInternalMutation>;
export type OperatorDeleteCompletelyByInternalMutationResult = Apollo.MutationResult<OperatorDeleteCompletelyByInternalMutation>;
export type OperatorDeleteCompletelyByInternalMutationOptions = Apollo.BaseMutationOptions<OperatorDeleteCompletelyByInternalMutation, OperatorDeleteCompletelyByInternalMutationVariables>;
export const OperatorMarkDeletedByInternalDocument = gql`
    mutation OperatorMarkDeletedByInternal($entityId: ID!) {
  operatorMarkDeletedByInternal(_entityId: $entityId) {
    _entityId
    _versionId
    status
    name {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type OperatorMarkDeletedByInternalMutationFn = Apollo.MutationFunction<OperatorMarkDeletedByInternalMutation, OperatorMarkDeletedByInternalMutationVariables>;

/**
 * __useOperatorMarkDeletedByInternalMutation__
 *
 * To run a mutation, you first call `useOperatorMarkDeletedByInternalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorMarkDeletedByInternalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorMarkDeletedByInternalMutation, { data, loading, error }] = useOperatorMarkDeletedByInternalMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useOperatorMarkDeletedByInternalMutation(baseOptions?: Apollo.MutationHookOptions<OperatorMarkDeletedByInternalMutation, OperatorMarkDeletedByInternalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorMarkDeletedByInternalMutation, OperatorMarkDeletedByInternalMutationVariables>(OperatorMarkDeletedByInternalDocument, options);
      }
export type OperatorMarkDeletedByInternalMutationHookResult = ReturnType<typeof useOperatorMarkDeletedByInternalMutation>;
export type OperatorMarkDeletedByInternalMutationResult = Apollo.MutationResult<OperatorMarkDeletedByInternalMutation>;
export type OperatorMarkDeletedByInternalMutationOptions = Apollo.BaseMutationOptions<OperatorMarkDeletedByInternalMutation, OperatorMarkDeletedByInternalMutationVariables>;
export const OperatorUpdateDocument = gql`
    mutation OperatorUpdate($record: UpdateByIdOperatorInput!, $entityId: ID!, $isApproving: Boolean, $whereabotContributed: Boolean) {
  operatorUpdate(
    record: $record
    _entityId: $entityId
    isApproving: $isApproving
    whereabotContributed: $whereabotContributed
  ) {
    _entityId
    _versionId
    status
    name {
      ...MultilingualFragment
    }
    enrollments {
      organizationControlled
      organization {
        _id
      }
      onboardingStatus
    }
    tags {
      organizationSpecific {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
      global {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
      businessType {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
      amenity {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type OperatorUpdateMutationFn = Apollo.MutationFunction<OperatorUpdateMutation, OperatorUpdateMutationVariables>;

/**
 * __useOperatorUpdateMutation__
 *
 * To run a mutation, you first call `useOperatorUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorUpdateMutation, { data, loading, error }] = useOperatorUpdateMutation({
 *   variables: {
 *      record: // value for 'record'
 *      entityId: // value for 'entityId'
 *      isApproving: // value for 'isApproving'
 *      whereabotContributed: // value for 'whereabotContributed'
 *   },
 * });
 */
export function useOperatorUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OperatorUpdateMutation, OperatorUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorUpdateMutation, OperatorUpdateMutationVariables>(OperatorUpdateDocument, options);
      }
export type OperatorUpdateMutationHookResult = ReturnType<typeof useOperatorUpdateMutation>;
export type OperatorUpdateMutationResult = Apollo.MutationResult<OperatorUpdateMutation>;
export type OperatorUpdateMutationOptions = Apollo.BaseMutationOptions<OperatorUpdateMutation, OperatorUpdateMutationVariables>;
export const OperatorUpdateContactRolesDocument = gql`
    mutation OperatorUpdateContactRoles($operatorEntityId: ID!, $userId: ID!, $contactRoles: [ContactRole]!, $title: String, $entity: EntityReferenceInput!) {
  operatorUpdateContactRoles(
    operatorEntityId: $operatorEntityId
    userId: $userId
    contactRoles: $contactRoles
    title: $title
    entity: $entity
  ) {
    ...UserWithPictureFragment
    email
  }
}
    ${UserWithPictureFragmentFragmentDoc}`;
export type OperatorUpdateContactRolesMutationFn = Apollo.MutationFunction<OperatorUpdateContactRolesMutation, OperatorUpdateContactRolesMutationVariables>;

/**
 * __useOperatorUpdateContactRolesMutation__
 *
 * To run a mutation, you first call `useOperatorUpdateContactRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorUpdateContactRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorUpdateContactRolesMutation, { data, loading, error }] = useOperatorUpdateContactRolesMutation({
 *   variables: {
 *      operatorEntityId: // value for 'operatorEntityId'
 *      userId: // value for 'userId'
 *      contactRoles: // value for 'contactRoles'
 *      title: // value for 'title'
 *      entity: // value for 'entity'
 *   },
 * });
 */
export function useOperatorUpdateContactRolesMutation(baseOptions?: Apollo.MutationHookOptions<OperatorUpdateContactRolesMutation, OperatorUpdateContactRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorUpdateContactRolesMutation, OperatorUpdateContactRolesMutationVariables>(OperatorUpdateContactRolesDocument, options);
      }
export type OperatorUpdateContactRolesMutationHookResult = ReturnType<typeof useOperatorUpdateContactRolesMutation>;
export type OperatorUpdateContactRolesMutationResult = Apollo.MutationResult<OperatorUpdateContactRolesMutation>;
export type OperatorUpdateContactRolesMutationOptions = Apollo.BaseMutationOptions<OperatorUpdateContactRolesMutation, OperatorUpdateContactRolesMutationVariables>;
export const OperatorUpdateImagesDocument = gql`
    mutation OperatorUpdateImages($entityId: ID!, $imagesToKeep: [String!], $imagesToDelete: [String!], $isApproving: Boolean) {
  operatorUpdateImages(
    _entityId: $entityId
    imagesToKeep: $imagesToKeep
    imagesToDelete: $imagesToDelete
    isApproving: $isApproving
  ) {
    status
  }
}
    `;
export type OperatorUpdateImagesMutationFn = Apollo.MutationFunction<OperatorUpdateImagesMutation, OperatorUpdateImagesMutationVariables>;

/**
 * __useOperatorUpdateImagesMutation__
 *
 * To run a mutation, you first call `useOperatorUpdateImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorUpdateImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorUpdateImagesMutation, { data, loading, error }] = useOperatorUpdateImagesMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      imagesToKeep: // value for 'imagesToKeep'
 *      imagesToDelete: // value for 'imagesToDelete'
 *      isApproving: // value for 'isApproving'
 *   },
 * });
 */
export function useOperatorUpdateImagesMutation(baseOptions?: Apollo.MutationHookOptions<OperatorUpdateImagesMutation, OperatorUpdateImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorUpdateImagesMutation, OperatorUpdateImagesMutationVariables>(OperatorUpdateImagesDocument, options);
      }
export type OperatorUpdateImagesMutationHookResult = ReturnType<typeof useOperatorUpdateImagesMutation>;
export type OperatorUpdateImagesMutationResult = Apollo.MutationResult<OperatorUpdateImagesMutation>;
export type OperatorUpdateImagesMutationOptions = Apollo.BaseMutationOptions<OperatorUpdateImagesMutation, OperatorUpdateImagesMutationVariables>;
export const OperatorWhereabotDismissDocument = gql`
    mutation OperatorWhereabotDismiss($operatorEntityId: MongoID!, $scanType: String!) {
  operatorWhereabotDismiss(
    operatorEntityId: $operatorEntityId
    scanType: $scanType
  ) {
    success
  }
}
    `;
export type OperatorWhereabotDismissMutationFn = Apollo.MutationFunction<OperatorWhereabotDismissMutation, OperatorWhereabotDismissMutationVariables>;

/**
 * __useOperatorWhereabotDismissMutation__
 *
 * To run a mutation, you first call `useOperatorWhereabotDismissMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOperatorWhereabotDismissMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [operatorWhereabotDismissMutation, { data, loading, error }] = useOperatorWhereabotDismissMutation({
 *   variables: {
 *      operatorEntityId: // value for 'operatorEntityId'
 *      scanType: // value for 'scanType'
 *   },
 * });
 */
export function useOperatorWhereabotDismissMutation(baseOptions?: Apollo.MutationHookOptions<OperatorWhereabotDismissMutation, OperatorWhereabotDismissMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OperatorWhereabotDismissMutation, OperatorWhereabotDismissMutationVariables>(OperatorWhereabotDismissDocument, options);
      }
export type OperatorWhereabotDismissMutationHookResult = ReturnType<typeof useOperatorWhereabotDismissMutation>;
export type OperatorWhereabotDismissMutationResult = Apollo.MutationResult<OperatorWhereabotDismissMutation>;
export type OperatorWhereabotDismissMutationOptions = Apollo.BaseMutationOptions<OperatorWhereabotDismissMutation, OperatorWhereabotDismissMutationVariables>;
export const OrderApproveDocument = gql`
    mutation OrderApprove($orderId: String!, $note: String) {
  orderApprove(orderId: $orderId, note: $note) {
    _id
    approval {
      status
      decidedAt
    }
  }
}
    `;
export type OrderApproveMutationFn = Apollo.MutationFunction<OrderApproveMutation, OrderApproveMutationVariables>;

/**
 * __useOrderApproveMutation__
 *
 * To run a mutation, you first call `useOrderApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderApproveMutation, { data, loading, error }] = useOrderApproveMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useOrderApproveMutation(baseOptions?: Apollo.MutationHookOptions<OrderApproveMutation, OrderApproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderApproveMutation, OrderApproveMutationVariables>(OrderApproveDocument, options);
      }
export type OrderApproveMutationHookResult = ReturnType<typeof useOrderApproveMutation>;
export type OrderApproveMutationResult = Apollo.MutationResult<OrderApproveMutation>;
export type OrderApproveMutationOptions = Apollo.BaseMutationOptions<OrderApproveMutation, OrderApproveMutationVariables>;
export const OrderDeclineDocument = gql`
    mutation OrderDecline($orderId: String!, $reason: String) {
  orderDecline(orderId: $orderId, reason: $reason) {
    _id
    cancelled
    approval {
      status
      decidedAt
      declineReason
    }
  }
}
    `;
export type OrderDeclineMutationFn = Apollo.MutationFunction<OrderDeclineMutation, OrderDeclineMutationVariables>;

/**
 * __useOrderDeclineMutation__
 *
 * To run a mutation, you first call `useOrderDeclineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderDeclineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderDeclineMutation, { data, loading, error }] = useOrderDeclineMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useOrderDeclineMutation(baseOptions?: Apollo.MutationHookOptions<OrderDeclineMutation, OrderDeclineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderDeclineMutation, OrderDeclineMutationVariables>(OrderDeclineDocument, options);
      }
export type OrderDeclineMutationHookResult = ReturnType<typeof useOrderDeclineMutation>;
export type OrderDeclineMutationResult = Apollo.MutationResult<OrderDeclineMutation>;
export type OrderDeclineMutationOptions = Apollo.BaseMutationOptions<OrderDeclineMutation, OrderDeclineMutationVariables>;
export const OrderFulfillDocument = gql`
    mutation OrderFulfill($orderId: String!, $note: String, $status: String, $carrier: String, $trackingNumber: String) {
  orderFulfill(
    orderId: $orderId
    note: $note
    status: $status
    carrier: $carrier
    trackingNumber: $trackingNumber
  ) {
    _id
    fulfillment {
      status
      note
      fulfilledAt
      carrier
      trackingNumber
    }
  }
}
    `;
export type OrderFulfillMutationFn = Apollo.MutationFunction<OrderFulfillMutation, OrderFulfillMutationVariables>;

/**
 * __useOrderFulfillMutation__
 *
 * To run a mutation, you first call `useOrderFulfillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderFulfillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderFulfillMutation, { data, loading, error }] = useOrderFulfillMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      note: // value for 'note'
 *      status: // value for 'status'
 *      carrier: // value for 'carrier'
 *      trackingNumber: // value for 'trackingNumber'
 *   },
 * });
 */
export function useOrderFulfillMutation(baseOptions?: Apollo.MutationHookOptions<OrderFulfillMutation, OrderFulfillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderFulfillMutation, OrderFulfillMutationVariables>(OrderFulfillDocument, options);
      }
export type OrderFulfillMutationHookResult = ReturnType<typeof useOrderFulfillMutation>;
export type OrderFulfillMutationResult = Apollo.MutationResult<OrderFulfillMutation>;
export type OrderFulfillMutationOptions = Apollo.BaseMutationOptions<OrderFulfillMutation, OrderFulfillMutationVariables>;
export const OrderMarkAsPaidDocument = gql`
    mutation OrderMarkAsPaid($orderId: String!) {
  orderMarkAsPaid(orderId: $orderId) {
    _id
    stripeMetadata {
      chargeId
      invoiceId
      invoiceStatus
    }
  }
}
    `;
export type OrderMarkAsPaidMutationFn = Apollo.MutationFunction<OrderMarkAsPaidMutation, OrderMarkAsPaidMutationVariables>;

/**
 * __useOrderMarkAsPaidMutation__
 *
 * To run a mutation, you first call `useOrderMarkAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderMarkAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderMarkAsPaidMutation, { data, loading, error }] = useOrderMarkAsPaidMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderMarkAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<OrderMarkAsPaidMutation, OrderMarkAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderMarkAsPaidMutation, OrderMarkAsPaidMutationVariables>(OrderMarkAsPaidDocument, options);
      }
export type OrderMarkAsPaidMutationHookResult = ReturnType<typeof useOrderMarkAsPaidMutation>;
export type OrderMarkAsPaidMutationResult = Apollo.MutationResult<OrderMarkAsPaidMutation>;
export type OrderMarkAsPaidMutationOptions = Apollo.BaseMutationOptions<OrderMarkAsPaidMutation, OrderMarkAsPaidMutationVariables>;
export const OrderSetArrivalDocument = gql`
    mutation OrderSetArrival($orderId: String!, $sessionIds: [String!], $guestIndexes: [Int!], $attendanceKeys: [String!], $arrived: Boolean!, $note: String) {
  orderSetArrival(
    orderId: $orderId
    sessionIds: $sessionIds
    guestIndexes: $guestIndexes
    attendanceKeys: $attendanceKeys
    arrived: $arrived
    note: $note
  ) {
    _id
    arrivalHistory {
      action
      source
      sessionIds
      guestIndexes
      attendanceKeys
      note
      timestamp
      performedBy
      performedByName
    }
  }
}
    `;
export type OrderSetArrivalMutationFn = Apollo.MutationFunction<OrderSetArrivalMutation, OrderSetArrivalMutationVariables>;

/**
 * __useOrderSetArrivalMutation__
 *
 * To run a mutation, you first call `useOrderSetArrivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderSetArrivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderSetArrivalMutation, { data, loading, error }] = useOrderSetArrivalMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      sessionIds: // value for 'sessionIds'
 *      guestIndexes: // value for 'guestIndexes'
 *      attendanceKeys: // value for 'attendanceKeys'
 *      arrived: // value for 'arrived'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useOrderSetArrivalMutation(baseOptions?: Apollo.MutationHookOptions<OrderSetArrivalMutation, OrderSetArrivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderSetArrivalMutation, OrderSetArrivalMutationVariables>(OrderSetArrivalDocument, options);
      }
export type OrderSetArrivalMutationHookResult = ReturnType<typeof useOrderSetArrivalMutation>;
export type OrderSetArrivalMutationResult = Apollo.MutationResult<OrderSetArrivalMutation>;
export type OrderSetArrivalMutationOptions = Apollo.BaseMutationOptions<OrderSetArrivalMutation, OrderSetArrivalMutationVariables>;
export const OrderUpdateDocument = gql`
    mutation OrderUpdate($id: String!, $cancelled: Boolean!, $sendEmail: Boolean) {
  orderUpdate(_id: $id, cancelled: $cancelled, sendEmail: $sendEmail) {
    recordId
    record {
      _id
      cancelled
    }
  }
}
    `;
export type OrderUpdateMutationFn = Apollo.MutationFunction<OrderUpdateMutation, OrderUpdateMutationVariables>;

/**
 * __useOrderUpdateMutation__
 *
 * To run a mutation, you first call `useOrderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderUpdateMutation, { data, loading, error }] = useOrderUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cancelled: // value for 'cancelled'
 *      sendEmail: // value for 'sendEmail'
 *   },
 * });
 */
export function useOrderUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrderUpdateMutation, OrderUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderUpdateMutation, OrderUpdateMutationVariables>(OrderUpdateDocument, options);
      }
export type OrderUpdateMutationHookResult = ReturnType<typeof useOrderUpdateMutation>;
export type OrderUpdateMutationResult = Apollo.MutationResult<OrderUpdateMutation>;
export type OrderUpdateMutationOptions = Apollo.BaseMutationOptions<OrderUpdateMutation, OrderUpdateMutationVariables>;
export const OrgOperatorOverlayUpsertDocument = gql`
    mutation OrgOperatorOverlayUpsert($record: OrgOperatorOverlayUpsertInput!) {
  orgOperatorOverlayUpsert(record: $record) {
    ...OrgOperatorOverlayFragment
  }
}
    ${OrgOperatorOverlayFragmentFragmentDoc}`;
export type OrgOperatorOverlayUpsertMutationFn = Apollo.MutationFunction<OrgOperatorOverlayUpsertMutation, OrgOperatorOverlayUpsertMutationVariables>;

/**
 * __useOrgOperatorOverlayUpsertMutation__
 *
 * To run a mutation, you first call `useOrgOperatorOverlayUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgOperatorOverlayUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgOperatorOverlayUpsertMutation, { data, loading, error }] = useOrgOperatorOverlayUpsertMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useOrgOperatorOverlayUpsertMutation(baseOptions?: Apollo.MutationHookOptions<OrgOperatorOverlayUpsertMutation, OrgOperatorOverlayUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrgOperatorOverlayUpsertMutation, OrgOperatorOverlayUpsertMutationVariables>(OrgOperatorOverlayUpsertDocument, options);
      }
export type OrgOperatorOverlayUpsertMutationHookResult = ReturnType<typeof useOrgOperatorOverlayUpsertMutation>;
export type OrgOperatorOverlayUpsertMutationResult = Apollo.MutationResult<OrgOperatorOverlayUpsertMutation>;
export type OrgOperatorOverlayUpsertMutationOptions = Apollo.BaseMutationOptions<OrgOperatorOverlayUpsertMutation, OrgOperatorOverlayUpsertMutationVariables>;
export const OrgOverviewRebuildDocument = gql`
    mutation OrgOverviewRebuild($organizationId: ID!) {
  orgOverviewRebuild(organizationId: $organizationId) {
    builtAt
    listingsCount
    peopleCount
    eventsCount
  }
}
    `;
export type OrgOverviewRebuildMutationFn = Apollo.MutationFunction<OrgOverviewRebuildMutation, OrgOverviewRebuildMutationVariables>;

/**
 * __useOrgOverviewRebuildMutation__
 *
 * To run a mutation, you first call `useOrgOverviewRebuildMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgOverviewRebuildMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgOverviewRebuildMutation, { data, loading, error }] = useOrgOverviewRebuildMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrgOverviewRebuildMutation(baseOptions?: Apollo.MutationHookOptions<OrgOverviewRebuildMutation, OrgOverviewRebuildMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrgOverviewRebuildMutation, OrgOverviewRebuildMutationVariables>(OrgOverviewRebuildDocument, options);
      }
export type OrgOverviewRebuildMutationHookResult = ReturnType<typeof useOrgOverviewRebuildMutation>;
export type OrgOverviewRebuildMutationResult = Apollo.MutationResult<OrgOverviewRebuildMutation>;
export type OrgOverviewRebuildMutationOptions = Apollo.BaseMutationOptions<OrgOverviewRebuildMutation, OrgOverviewRebuildMutationVariables>;
export const OrganizationCreateDocument = gql`
    mutation OrganizationCreate($record: CreateOneOrganizationInput!) {
  organizationCreate(record: $record) {
    record {
      _id
      name {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type OrganizationCreateMutationFn = Apollo.MutationFunction<OrganizationCreateMutation, OrganizationCreateMutationVariables>;

/**
 * __useOrganizationCreateMutation__
 *
 * To run a mutation, you first call `useOrganizationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationCreateMutation, { data, loading, error }] = useOrganizationCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useOrganizationCreateMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationCreateMutation, OrganizationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationCreateMutation, OrganizationCreateMutationVariables>(OrganizationCreateDocument, options);
      }
export type OrganizationCreateMutationHookResult = ReturnType<typeof useOrganizationCreateMutation>;
export type OrganizationCreateMutationResult = Apollo.MutationResult<OrganizationCreateMutation>;
export type OrganizationCreateMutationOptions = Apollo.BaseMutationOptions<OrganizationCreateMutation, OrganizationCreateMutationVariables>;
export const OrganizationDeleteDocument = gql`
    mutation OrganizationDelete($organizationId: ID!) {
  organizationDelete(organizationId: $organizationId) {
    success
    message
    deletedOrganizationId
  }
}
    `;
export type OrganizationDeleteMutationFn = Apollo.MutationFunction<OrganizationDeleteMutation, OrganizationDeleteMutationVariables>;

/**
 * __useOrganizationDeleteMutation__
 *
 * To run a mutation, you first call `useOrganizationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationDeleteMutation, { data, loading, error }] = useOrganizationDeleteMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationDeleteMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationDeleteMutation, OrganizationDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationDeleteMutation, OrganizationDeleteMutationVariables>(OrganizationDeleteDocument, options);
      }
export type OrganizationDeleteMutationHookResult = ReturnType<typeof useOrganizationDeleteMutation>;
export type OrganizationDeleteMutationResult = Apollo.MutationResult<OrganizationDeleteMutation>;
export type OrganizationDeleteMutationOptions = Apollo.BaseMutationOptions<OrganizationDeleteMutation, OrganizationDeleteMutationVariables>;
export const OrganizationDisconnectAssetsDocument = gql`
    mutation OrganizationDisconnectAssets($organizationId: ID!) {
  organizationDisconnectAssets(organizationId: $organizationId) {
    _id
    organizationId
    deletionLog {
      completedAt
      completedBy
      results {
        people {
          disconnected
          deleted
          errors
        }
        operators {
          disconnected
          deleted
          errors
        }
        widgets {
          deleted
          errors
        }
        lists {
          deleted
          errors
        }
        notes {
          deleted
          errors
        }
        events {
          deleted
          errors
        }
        broadcasts {
          deleted
          errors
        }
        images {
          deleted
          errors
        }
        activityLogs {
          deleted
          errors
        }
        imports {
          deleted
          errors
        }
        importRuns {
          deleted
          errors
        }
      }
      deletionErrors {
        type
        message
        assetId
      }
    }
  }
}
    `;
export type OrganizationDisconnectAssetsMutationFn = Apollo.MutationFunction<OrganizationDisconnectAssetsMutation, OrganizationDisconnectAssetsMutationVariables>;

/**
 * __useOrganizationDisconnectAssetsMutation__
 *
 * To run a mutation, you first call `useOrganizationDisconnectAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDisconnectAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationDisconnectAssetsMutation, { data, loading, error }] = useOrganizationDisconnectAssetsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationDisconnectAssetsMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationDisconnectAssetsMutation, OrganizationDisconnectAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationDisconnectAssetsMutation, OrganizationDisconnectAssetsMutationVariables>(OrganizationDisconnectAssetsDocument, options);
      }
export type OrganizationDisconnectAssetsMutationHookResult = ReturnType<typeof useOrganizationDisconnectAssetsMutation>;
export type OrganizationDisconnectAssetsMutationResult = Apollo.MutationResult<OrganizationDisconnectAssetsMutation>;
export type OrganizationDisconnectAssetsMutationOptions = Apollo.BaseMutationOptions<OrganizationDisconnectAssetsMutation, OrganizationDisconnectAssetsMutationVariables>;
export const OrganizationEmailDomainProvisionDocument = gql`
    mutation OrganizationEmailDomainProvision($organizationId: ID!) {
  organizationEmailDomainProvision(organizationId: $organizationId) {
    _id
    fromAddress
    domain
    status
    previousStatus
    sendgridDomainId
    internalNote
    requestedAt
    activatedAt
    lastValidatedAt
    disabledAt
    dnsRecords {
      mailCname {
        valid
        type
        host
        data
      }
      dkim1 {
        valid
        type
        host
        data
      }
      dkim2 {
        valid
        type
        host
        data
      }
    }
    validationResults {
      mailCname {
        valid
        reason
      }
      dkim1 {
        valid
        reason
      }
      dkim2 {
        valid
        reason
      }
      spf {
        valid
        reason
      }
    }
  }
}
    `;
export type OrganizationEmailDomainProvisionMutationFn = Apollo.MutationFunction<OrganizationEmailDomainProvisionMutation, OrganizationEmailDomainProvisionMutationVariables>;

/**
 * __useOrganizationEmailDomainProvisionMutation__
 *
 * To run a mutation, you first call `useOrganizationEmailDomainProvisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEmailDomainProvisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationEmailDomainProvisionMutation, { data, loading, error }] = useOrganizationEmailDomainProvisionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationEmailDomainProvisionMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationEmailDomainProvisionMutation, OrganizationEmailDomainProvisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationEmailDomainProvisionMutation, OrganizationEmailDomainProvisionMutationVariables>(OrganizationEmailDomainProvisionDocument, options);
      }
export type OrganizationEmailDomainProvisionMutationHookResult = ReturnType<typeof useOrganizationEmailDomainProvisionMutation>;
export type OrganizationEmailDomainProvisionMutationResult = Apollo.MutationResult<OrganizationEmailDomainProvisionMutation>;
export type OrganizationEmailDomainProvisionMutationOptions = Apollo.BaseMutationOptions<OrganizationEmailDomainProvisionMutation, OrganizationEmailDomainProvisionMutationVariables>;
export const OrganizationEmailDomainRemoveDocument = gql`
    mutation OrganizationEmailDomainRemove($organizationId: ID!) {
  organizationEmailDomainRemove(organizationId: $organizationId)
}
    `;
export type OrganizationEmailDomainRemoveMutationFn = Apollo.MutationFunction<OrganizationEmailDomainRemoveMutation, OrganizationEmailDomainRemoveMutationVariables>;

/**
 * __useOrganizationEmailDomainRemoveMutation__
 *
 * To run a mutation, you first call `useOrganizationEmailDomainRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEmailDomainRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationEmailDomainRemoveMutation, { data, loading, error }] = useOrganizationEmailDomainRemoveMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationEmailDomainRemoveMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationEmailDomainRemoveMutation, OrganizationEmailDomainRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationEmailDomainRemoveMutation, OrganizationEmailDomainRemoveMutationVariables>(OrganizationEmailDomainRemoveDocument, options);
      }
export type OrganizationEmailDomainRemoveMutationHookResult = ReturnType<typeof useOrganizationEmailDomainRemoveMutation>;
export type OrganizationEmailDomainRemoveMutationResult = Apollo.MutationResult<OrganizationEmailDomainRemoveMutation>;
export type OrganizationEmailDomainRemoveMutationOptions = Apollo.BaseMutationOptions<OrganizationEmailDomainRemoveMutation, OrganizationEmailDomainRemoveMutationVariables>;
export const OrganizationEmailDomainRequestDocument = gql`
    mutation OrganizationEmailDomainRequest($organizationId: ID!, $fromAddress: String!) {
  organizationEmailDomainRequest(
    organizationId: $organizationId
    fromAddress: $fromAddress
  ) {
    _id
    fromAddress
    domain
    status
    requestedAt
    activatedAt
    lastValidatedAt
    disabledAt
    dnsRecords {
      mailCname {
        valid
        type
        host
        data
      }
      dkim1 {
        valid
        type
        host
        data
      }
      dkim2 {
        valid
        type
        host
        data
      }
    }
    validationResults {
      mailCname {
        valid
        reason
      }
      dkim1 {
        valid
        reason
      }
      dkim2 {
        valid
        reason
      }
      spf {
        valid
        reason
      }
    }
  }
}
    `;
export type OrganizationEmailDomainRequestMutationFn = Apollo.MutationFunction<OrganizationEmailDomainRequestMutation, OrganizationEmailDomainRequestMutationVariables>;

/**
 * __useOrganizationEmailDomainRequestMutation__
 *
 * To run a mutation, you first call `useOrganizationEmailDomainRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEmailDomainRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationEmailDomainRequestMutation, { data, loading, error }] = useOrganizationEmailDomainRequestMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      fromAddress: // value for 'fromAddress'
 *   },
 * });
 */
export function useOrganizationEmailDomainRequestMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationEmailDomainRequestMutation, OrganizationEmailDomainRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationEmailDomainRequestMutation, OrganizationEmailDomainRequestMutationVariables>(OrganizationEmailDomainRequestDocument, options);
      }
export type OrganizationEmailDomainRequestMutationHookResult = ReturnType<typeof useOrganizationEmailDomainRequestMutation>;
export type OrganizationEmailDomainRequestMutationResult = Apollo.MutationResult<OrganizationEmailDomainRequestMutation>;
export type OrganizationEmailDomainRequestMutationOptions = Apollo.BaseMutationOptions<OrganizationEmailDomainRequestMutation, OrganizationEmailDomainRequestMutationVariables>;
export const OrganizationEmailDomainRunChecksDocument = gql`
    mutation OrganizationEmailDomainRunChecks($organizationId: ID!, $testRecipientEmail: String) {
  organizationEmailDomainRunChecks(
    organizationId: $organizationId
    testRecipientEmail: $testRecipientEmail
  ) {
    sendgridValidation {
      passed
      message
    }
    liveTestSend {
      passed
      message
    }
    config {
      _id
      fromAddress
      domain
      status
      previousStatus
      sendgridDomainId
      internalNote
      requestedAt
      activatedAt
      lastValidatedAt
      disabledAt
      dnsRecords {
        mailCname {
          valid
          type
          host
          data
        }
        dkim1 {
          valid
          type
          host
          data
        }
        dkim2 {
          valid
          type
          host
          data
        }
      }
      validationResults {
        mailCname {
          valid
          reason
        }
        dkim1 {
          valid
          reason
        }
        dkim2 {
          valid
          reason
        }
        spf {
          valid
          reason
        }
      }
    }
  }
}
    `;
export type OrganizationEmailDomainRunChecksMutationFn = Apollo.MutationFunction<OrganizationEmailDomainRunChecksMutation, OrganizationEmailDomainRunChecksMutationVariables>;

/**
 * __useOrganizationEmailDomainRunChecksMutation__
 *
 * To run a mutation, you first call `useOrganizationEmailDomainRunChecksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEmailDomainRunChecksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationEmailDomainRunChecksMutation, { data, loading, error }] = useOrganizationEmailDomainRunChecksMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      testRecipientEmail: // value for 'testRecipientEmail'
 *   },
 * });
 */
export function useOrganizationEmailDomainRunChecksMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationEmailDomainRunChecksMutation, OrganizationEmailDomainRunChecksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationEmailDomainRunChecksMutation, OrganizationEmailDomainRunChecksMutationVariables>(OrganizationEmailDomainRunChecksDocument, options);
      }
export type OrganizationEmailDomainRunChecksMutationHookResult = ReturnType<typeof useOrganizationEmailDomainRunChecksMutation>;
export type OrganizationEmailDomainRunChecksMutationResult = Apollo.MutationResult<OrganizationEmailDomainRunChecksMutation>;
export type OrganizationEmailDomainRunChecksMutationOptions = Apollo.BaseMutationOptions<OrganizationEmailDomainRunChecksMutation, OrganizationEmailDomainRunChecksMutationVariables>;
export const OrganizationEmailDomainSetDisabledDocument = gql`
    mutation OrganizationEmailDomainSetDisabled($organizationId: ID!, $disabled: Boolean!) {
  organizationEmailDomainSetDisabled(
    organizationId: $organizationId
    disabled: $disabled
  ) {
    _id
    fromAddress
    domain
    status
    previousStatus
    sendgridDomainId
    internalNote
    requestedAt
    activatedAt
    lastValidatedAt
    disabledAt
  }
}
    `;
export type OrganizationEmailDomainSetDisabledMutationFn = Apollo.MutationFunction<OrganizationEmailDomainSetDisabledMutation, OrganizationEmailDomainSetDisabledMutationVariables>;

/**
 * __useOrganizationEmailDomainSetDisabledMutation__
 *
 * To run a mutation, you first call `useOrganizationEmailDomainSetDisabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEmailDomainSetDisabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationEmailDomainSetDisabledMutation, { data, loading, error }] = useOrganizationEmailDomainSetDisabledMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      disabled: // value for 'disabled'
 *   },
 * });
 */
export function useOrganizationEmailDomainSetDisabledMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationEmailDomainSetDisabledMutation, OrganizationEmailDomainSetDisabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationEmailDomainSetDisabledMutation, OrganizationEmailDomainSetDisabledMutationVariables>(OrganizationEmailDomainSetDisabledDocument, options);
      }
export type OrganizationEmailDomainSetDisabledMutationHookResult = ReturnType<typeof useOrganizationEmailDomainSetDisabledMutation>;
export type OrganizationEmailDomainSetDisabledMutationResult = Apollo.MutationResult<OrganizationEmailDomainSetDisabledMutation>;
export type OrganizationEmailDomainSetDisabledMutationOptions = Apollo.BaseMutationOptions<OrganizationEmailDomainSetDisabledMutation, OrganizationEmailDomainSetDisabledMutationVariables>;
export const OrganizationEmailDomainSetTestOverrideDocument = gql`
    mutation OrganizationEmailDomainSetTestOverride($organizationId: ID!, $allowNonProductionSending: Boolean!) {
  organizationEmailDomainSetTestOverride(
    organizationId: $organizationId
    allowNonProductionSending: $allowNonProductionSending
  ) {
    _id
    allowNonProductionSending
  }
}
    `;
export type OrganizationEmailDomainSetTestOverrideMutationFn = Apollo.MutationFunction<OrganizationEmailDomainSetTestOverrideMutation, OrganizationEmailDomainSetTestOverrideMutationVariables>;

/**
 * __useOrganizationEmailDomainSetTestOverrideMutation__
 *
 * To run a mutation, you first call `useOrganizationEmailDomainSetTestOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEmailDomainSetTestOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationEmailDomainSetTestOverrideMutation, { data, loading, error }] = useOrganizationEmailDomainSetTestOverrideMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      allowNonProductionSending: // value for 'allowNonProductionSending'
 *   },
 * });
 */
export function useOrganizationEmailDomainSetTestOverrideMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationEmailDomainSetTestOverrideMutation, OrganizationEmailDomainSetTestOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationEmailDomainSetTestOverrideMutation, OrganizationEmailDomainSetTestOverrideMutationVariables>(OrganizationEmailDomainSetTestOverrideDocument, options);
      }
export type OrganizationEmailDomainSetTestOverrideMutationHookResult = ReturnType<typeof useOrganizationEmailDomainSetTestOverrideMutation>;
export type OrganizationEmailDomainSetTestOverrideMutationResult = Apollo.MutationResult<OrganizationEmailDomainSetTestOverrideMutation>;
export type OrganizationEmailDomainSetTestOverrideMutationOptions = Apollo.BaseMutationOptions<OrganizationEmailDomainSetTestOverrideMutation, OrganizationEmailDomainSetTestOverrideMutationVariables>;
export const OrganizationEmailDomainUpdateNoteDocument = gql`
    mutation OrganizationEmailDomainUpdateNote($organizationId: ID!, $internalNote: String) {
  organizationEmailDomainUpdateNote(
    organizationId: $organizationId
    internalNote: $internalNote
  ) {
    _id
    internalNote
  }
}
    `;
export type OrganizationEmailDomainUpdateNoteMutationFn = Apollo.MutationFunction<OrganizationEmailDomainUpdateNoteMutation, OrganizationEmailDomainUpdateNoteMutationVariables>;

/**
 * __useOrganizationEmailDomainUpdateNoteMutation__
 *
 * To run a mutation, you first call `useOrganizationEmailDomainUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEmailDomainUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationEmailDomainUpdateNoteMutation, { data, loading, error }] = useOrganizationEmailDomainUpdateNoteMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      internalNote: // value for 'internalNote'
 *   },
 * });
 */
export function useOrganizationEmailDomainUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationEmailDomainUpdateNoteMutation, OrganizationEmailDomainUpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationEmailDomainUpdateNoteMutation, OrganizationEmailDomainUpdateNoteMutationVariables>(OrganizationEmailDomainUpdateNoteDocument, options);
      }
export type OrganizationEmailDomainUpdateNoteMutationHookResult = ReturnType<typeof useOrganizationEmailDomainUpdateNoteMutation>;
export type OrganizationEmailDomainUpdateNoteMutationResult = Apollo.MutationResult<OrganizationEmailDomainUpdateNoteMutation>;
export type OrganizationEmailDomainUpdateNoteMutationOptions = Apollo.BaseMutationOptions<OrganizationEmailDomainUpdateNoteMutation, OrganizationEmailDomainUpdateNoteMutationVariables>;
export const OrganizationEventPartnerAddDocument = gql`
    mutation OrganizationEventPartnerAdd($code: String, $organizationId: MongoID) {
  organizationEventPartnerAdd(code: $code, organizationId: $organizationId) {
    ...OrganizationEventPartnerSettingsFragment
  }
}
    ${OrganizationEventPartnerSettingsFragmentFragmentDoc}`;
export type OrganizationEventPartnerAddMutationFn = Apollo.MutationFunction<OrganizationEventPartnerAddMutation, OrganizationEventPartnerAddMutationVariables>;

/**
 * __useOrganizationEventPartnerAddMutation__
 *
 * To run a mutation, you first call `useOrganizationEventPartnerAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEventPartnerAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationEventPartnerAddMutation, { data, loading, error }] = useOrganizationEventPartnerAddMutation({
 *   variables: {
 *      code: // value for 'code'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationEventPartnerAddMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationEventPartnerAddMutation, OrganizationEventPartnerAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationEventPartnerAddMutation, OrganizationEventPartnerAddMutationVariables>(OrganizationEventPartnerAddDocument, options);
      }
export type OrganizationEventPartnerAddMutationHookResult = ReturnType<typeof useOrganizationEventPartnerAddMutation>;
export type OrganizationEventPartnerAddMutationResult = Apollo.MutationResult<OrganizationEventPartnerAddMutation>;
export type OrganizationEventPartnerAddMutationOptions = Apollo.BaseMutationOptions<OrganizationEventPartnerAddMutation, OrganizationEventPartnerAddMutationVariables>;
export const OrganizationEventPartnerRemoveDocument = gql`
    mutation OrganizationEventPartnerRemove($organizationId: MongoID!) {
  organizationEventPartnerRemove(organizationId: $organizationId) {
    ...OrganizationEventPartnerSettingsFragment
  }
}
    ${OrganizationEventPartnerSettingsFragmentFragmentDoc}`;
export type OrganizationEventPartnerRemoveMutationFn = Apollo.MutationFunction<OrganizationEventPartnerRemoveMutation, OrganizationEventPartnerRemoveMutationVariables>;

/**
 * __useOrganizationEventPartnerRemoveMutation__
 *
 * To run a mutation, you first call `useOrganizationEventPartnerRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEventPartnerRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationEventPartnerRemoveMutation, { data, loading, error }] = useOrganizationEventPartnerRemoveMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationEventPartnerRemoveMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationEventPartnerRemoveMutation, OrganizationEventPartnerRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationEventPartnerRemoveMutation, OrganizationEventPartnerRemoveMutationVariables>(OrganizationEventPartnerRemoveDocument, options);
      }
export type OrganizationEventPartnerRemoveMutationHookResult = ReturnType<typeof useOrganizationEventPartnerRemoveMutation>;
export type OrganizationEventPartnerRemoveMutationResult = Apollo.MutationResult<OrganizationEventPartnerRemoveMutation>;
export type OrganizationEventPartnerRemoveMutationOptions = Apollo.BaseMutationOptions<OrganizationEventPartnerRemoveMutation, OrganizationEventPartnerRemoveMutationVariables>;
export const OrganizationEventSharingCodeRegenerateDocument = gql`
    mutation OrganizationEventSharingCodeRegenerate {
  organizationEventSharingCodeRegenerate {
    ...OrganizationEventPartnerSettingsFragment
  }
}
    ${OrganizationEventPartnerSettingsFragmentFragmentDoc}`;
export type OrganizationEventSharingCodeRegenerateMutationFn = Apollo.MutationFunction<OrganizationEventSharingCodeRegenerateMutation, OrganizationEventSharingCodeRegenerateMutationVariables>;

/**
 * __useOrganizationEventSharingCodeRegenerateMutation__
 *
 * To run a mutation, you first call `useOrganizationEventSharingCodeRegenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEventSharingCodeRegenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationEventSharingCodeRegenerateMutation, { data, loading, error }] = useOrganizationEventSharingCodeRegenerateMutation({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationEventSharingCodeRegenerateMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationEventSharingCodeRegenerateMutation, OrganizationEventSharingCodeRegenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationEventSharingCodeRegenerateMutation, OrganizationEventSharingCodeRegenerateMutationVariables>(OrganizationEventSharingCodeRegenerateDocument, options);
      }
export type OrganizationEventSharingCodeRegenerateMutationHookResult = ReturnType<typeof useOrganizationEventSharingCodeRegenerateMutation>;
export type OrganizationEventSharingCodeRegenerateMutationResult = Apollo.MutationResult<OrganizationEventSharingCodeRegenerateMutation>;
export type OrganizationEventSharingCodeRegenerateMutationOptions = Apollo.BaseMutationOptions<OrganizationEventSharingCodeRegenerateMutation, OrganizationEventSharingCodeRegenerateMutationVariables>;
export const OrganizationManifestGenerateDocument = gql`
    mutation OrganizationManifestGenerate($organizationId: ID!) {
  organizationManifestGenerate(organizationId: $organizationId) {
    _id
    organizationId
    generatedAt
    generatedBy
    assetCounts {
      people {
        total
        toDisconnect
        toDelete
      }
      operators {
        total
        toDisconnect
        toDelete
      }
      widgets
      lists
      customTags
      notes
      events
      broadcasts
      images
      users
      activityLogs
      imports
      importRuns
    }
    manifestErrors {
      type
      message
      assetId
    }
  }
}
    `;
export type OrganizationManifestGenerateMutationFn = Apollo.MutationFunction<OrganizationManifestGenerateMutation, OrganizationManifestGenerateMutationVariables>;

/**
 * __useOrganizationManifestGenerateMutation__
 *
 * To run a mutation, you first call `useOrganizationManifestGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationManifestGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationManifestGenerateMutation, { data, loading, error }] = useOrganizationManifestGenerateMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationManifestGenerateMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationManifestGenerateMutation, OrganizationManifestGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationManifestGenerateMutation, OrganizationManifestGenerateMutationVariables>(OrganizationManifestGenerateDocument, options);
      }
export type OrganizationManifestGenerateMutationHookResult = ReturnType<typeof useOrganizationManifestGenerateMutation>;
export type OrganizationManifestGenerateMutationResult = Apollo.MutationResult<OrganizationManifestGenerateMutation>;
export type OrganizationManifestGenerateMutationOptions = Apollo.BaseMutationOptions<OrganizationManifestGenerateMutation, OrganizationManifestGenerateMutationVariables>;
export const OrganizationSeedDefaultAudiencesDocument = gql`
    mutation OrganizationSeedDefaultAudiences($organizationId: ID!) {
  organizationSeedDefaultAudiences(organizationId: $organizationId) {
    _id
    metadata {
      listingAudienceTagIds
    }
  }
}
    `;
export type OrganizationSeedDefaultAudiencesMutationFn = Apollo.MutationFunction<OrganizationSeedDefaultAudiencesMutation, OrganizationSeedDefaultAudiencesMutationVariables>;

/**
 * __useOrganizationSeedDefaultAudiencesMutation__
 *
 * To run a mutation, you first call `useOrganizationSeedDefaultAudiencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSeedDefaultAudiencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationSeedDefaultAudiencesMutation, { data, loading, error }] = useOrganizationSeedDefaultAudiencesMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationSeedDefaultAudiencesMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationSeedDefaultAudiencesMutation, OrganizationSeedDefaultAudiencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationSeedDefaultAudiencesMutation, OrganizationSeedDefaultAudiencesMutationVariables>(OrganizationSeedDefaultAudiencesDocument, options);
      }
export type OrganizationSeedDefaultAudiencesMutationHookResult = ReturnType<typeof useOrganizationSeedDefaultAudiencesMutation>;
export type OrganizationSeedDefaultAudiencesMutationResult = Apollo.MutationResult<OrganizationSeedDefaultAudiencesMutation>;
export type OrganizationSeedDefaultAudiencesMutationOptions = Apollo.BaseMutationOptions<OrganizationSeedDefaultAudiencesMutation, OrganizationSeedDefaultAudiencesMutationVariables>;
export const OrganizationSeedDefaultMembershipStatusTagsDocument = gql`
    mutation OrganizationSeedDefaultMembershipStatusTags($organizationId: ID!) {
  organizationSeedDefaultMembershipStatusTags(organizationId: $organizationId) {
    _id
    metadata {
      membershipStatusTagIds
    }
  }
}
    `;
export type OrganizationSeedDefaultMembershipStatusTagsMutationFn = Apollo.MutationFunction<OrganizationSeedDefaultMembershipStatusTagsMutation, OrganizationSeedDefaultMembershipStatusTagsMutationVariables>;

/**
 * __useOrganizationSeedDefaultMembershipStatusTagsMutation__
 *
 * To run a mutation, you first call `useOrganizationSeedDefaultMembershipStatusTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSeedDefaultMembershipStatusTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationSeedDefaultMembershipStatusTagsMutation, { data, loading, error }] = useOrganizationSeedDefaultMembershipStatusTagsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationSeedDefaultMembershipStatusTagsMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationSeedDefaultMembershipStatusTagsMutation, OrganizationSeedDefaultMembershipStatusTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationSeedDefaultMembershipStatusTagsMutation, OrganizationSeedDefaultMembershipStatusTagsMutationVariables>(OrganizationSeedDefaultMembershipStatusTagsDocument, options);
      }
export type OrganizationSeedDefaultMembershipStatusTagsMutationHookResult = ReturnType<typeof useOrganizationSeedDefaultMembershipStatusTagsMutation>;
export type OrganizationSeedDefaultMembershipStatusTagsMutationResult = Apollo.MutationResult<OrganizationSeedDefaultMembershipStatusTagsMutation>;
export type OrganizationSeedDefaultMembershipStatusTagsMutationOptions = Apollo.BaseMutationOptions<OrganizationSeedDefaultMembershipStatusTagsMutation, OrganizationSeedDefaultMembershipStatusTagsMutationVariables>;
export const OrganizationSendRenewalTestEmailDocument = gql`
    mutation OrganizationSendRenewalTestEmail($organizationId: ID!, $recipientUserId: ID!, $emailKind: RenewalTestEmailKind!, $subject: String, $body: String, $hideRenewalDateLine: Boolean, $ctaLabel: String, $ctaUrl: String, $hideGreeting: Boolean) {
  organizationSendRenewalTestEmail(
    organizationId: $organizationId
    recipientUserId: $recipientUserId
    emailKind: $emailKind
    subject: $subject
    body: $body
    hideRenewalDateLine: $hideRenewalDateLine
    ctaLabel: $ctaLabel
    ctaUrl: $ctaUrl
    hideGreeting: $hideGreeting
  )
}
    `;
export type OrganizationSendRenewalTestEmailMutationFn = Apollo.MutationFunction<OrganizationSendRenewalTestEmailMutation, OrganizationSendRenewalTestEmailMutationVariables>;

/**
 * __useOrganizationSendRenewalTestEmailMutation__
 *
 * To run a mutation, you first call `useOrganizationSendRenewalTestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSendRenewalTestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationSendRenewalTestEmailMutation, { data, loading, error }] = useOrganizationSendRenewalTestEmailMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      recipientUserId: // value for 'recipientUserId'
 *      emailKind: // value for 'emailKind'
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      hideRenewalDateLine: // value for 'hideRenewalDateLine'
 *      ctaLabel: // value for 'ctaLabel'
 *      ctaUrl: // value for 'ctaUrl'
 *      hideGreeting: // value for 'hideGreeting'
 *   },
 * });
 */
export function useOrganizationSendRenewalTestEmailMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationSendRenewalTestEmailMutation, OrganizationSendRenewalTestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationSendRenewalTestEmailMutation, OrganizationSendRenewalTestEmailMutationVariables>(OrganizationSendRenewalTestEmailDocument, options);
      }
export type OrganizationSendRenewalTestEmailMutationHookResult = ReturnType<typeof useOrganizationSendRenewalTestEmailMutation>;
export type OrganizationSendRenewalTestEmailMutationResult = Apollo.MutationResult<OrganizationSendRenewalTestEmailMutation>;
export type OrganizationSendRenewalTestEmailMutationOptions = Apollo.BaseMutationOptions<OrganizationSendRenewalTestEmailMutation, OrganizationSendRenewalTestEmailMutationVariables>;
export const OrganizationSendTestEmailsDocument = gql`
    mutation OrganizationSendTestEmails($organizationId: ID!, $recipientUserId: ID!, $emailTypes: [OrgTestEmailType!]!) {
  organizationSendTestEmails(
    organizationId: $organizationId
    recipientUserId: $recipientUserId
    emailTypes: $emailTypes
  ) {
    sentCount
    failed {
      emailType
      error
    }
  }
}
    `;
export type OrganizationSendTestEmailsMutationFn = Apollo.MutationFunction<OrganizationSendTestEmailsMutation, OrganizationSendTestEmailsMutationVariables>;

/**
 * __useOrganizationSendTestEmailsMutation__
 *
 * To run a mutation, you first call `useOrganizationSendTestEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSendTestEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationSendTestEmailsMutation, { data, loading, error }] = useOrganizationSendTestEmailsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      recipientUserId: // value for 'recipientUserId'
 *      emailTypes: // value for 'emailTypes'
 *   },
 * });
 */
export function useOrganizationSendTestEmailsMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationSendTestEmailsMutation, OrganizationSendTestEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationSendTestEmailsMutation, OrganizationSendTestEmailsMutationVariables>(OrganizationSendTestEmailsDocument, options);
      }
export type OrganizationSendTestEmailsMutationHookResult = ReturnType<typeof useOrganizationSendTestEmailsMutation>;
export type OrganizationSendTestEmailsMutationResult = Apollo.MutationResult<OrganizationSendTestEmailsMutation>;
export type OrganizationSendTestEmailsMutationOptions = Apollo.BaseMutationOptions<OrganizationSendTestEmailsMutation, OrganizationSendTestEmailsMutationVariables>;
export const OrganizationUpdateDocument = gql`
    mutation OrganizationUpdate($id: MongoID!, $record: UpdateByIdOrganizationInput!) {
  organizationUpdate(_id: $id, record: $record) {
    record {
      _id
      name {
        ...MultilingualFragment
      }
      shortName
      subdomain
      contact {
        address {
          ...AddressFragment
        }
        email
        phone
        tollFreePublicPhone
        links {
          website
          instagram
          x
          bookNow
          youtube
          pinterest
          googleMyBusiness
          tiktok
          tripAdvisor
          facebook
        }
      }
      description {
        ...MultilingualFragment
      }
      shortDescription {
        ...MultilingualFragment
      }
      onboardingMetadata {
        videoId
        introMessage
        allowColdSignup
        coldSignupTagId
        comingSoonMessage
      }
      metadata {
        inviteWhenAddingStaff
        eventLookaheadMonths
        disabledApps
        connectedStorefront
        connectedTestStorefront
        storefrontOrgConnectionsEnabled
        storefrontMode
        connectedUsdStorefront
        connectedUsdTestStorefront
        internalOnly
        canEnableMembershipLink
        membershipPageUrl
        connectedOperator
        crowdriffEnabled
        externalVideoEnabled
        membershipTiers
        individualMembershipTiers
        nomenclature {
          membership
          member
          members
        }
        timezone
      }
      brandColors
      emailBranding {
        fromName
        replyTo
        accentColor
        showContact
        footerText {
          en
          fr
          es
        }
      }
      license {
        activatedDate
        activatedBy {
          _id
          firstName
          lastName
          email
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;
export type OrganizationUpdateMutationFn = Apollo.MutationFunction<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>;

/**
 * __useOrganizationUpdateMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateMutation, { data, loading, error }] = useOrganizationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useOrganizationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>(OrganizationUpdateDocument, options);
      }
export type OrganizationUpdateMutationHookResult = ReturnType<typeof useOrganizationUpdateMutation>;
export type OrganizationUpdateMutationResult = Apollo.MutationResult<OrganizationUpdateMutation>;
export type OrganizationUpdateMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>;
export const OrganizationUpdateImagesDocument = gql`
    mutation OrganizationUpdateImages($id: ID!, $imagesToKeep: [String!], $imagesToDelete: [String!], $isLogo: Boolean) {
  organizationUpdateImages(
    id: $id
    imagesToKeep: $imagesToKeep
    imagesToDelete: $imagesToDelete
    isLogo: $isLogo
  ) {
    _id
    logo {
      ...ImageFragment
    }
    images {
      ...ImageFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export type OrganizationUpdateImagesMutationFn = Apollo.MutationFunction<OrganizationUpdateImagesMutation, OrganizationUpdateImagesMutationVariables>;

/**
 * __useOrganizationUpdateImagesMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateImagesMutation, { data, loading, error }] = useOrganizationUpdateImagesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      imagesToKeep: // value for 'imagesToKeep'
 *      imagesToDelete: // value for 'imagesToDelete'
 *      isLogo: // value for 'isLogo'
 *   },
 * });
 */
export function useOrganizationUpdateImagesMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateImagesMutation, OrganizationUpdateImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateImagesMutation, OrganizationUpdateImagesMutationVariables>(OrganizationUpdateImagesDocument, options);
      }
export type OrganizationUpdateImagesMutationHookResult = ReturnType<typeof useOrganizationUpdateImagesMutation>;
export type OrganizationUpdateImagesMutationResult = Apollo.MutationResult<OrganizationUpdateImagesMutation>;
export type OrganizationUpdateImagesMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateImagesMutation, OrganizationUpdateImagesMutationVariables>;
export const OrganizationUpdateIndividualMembershipTiersDocument = gql`
    mutation OrganizationUpdateIndividualMembershipTiers($organizationId: ID!, $individualMembershipTierTagIds: [ID!]!) {
  organizationUpdateIndividualMembershipTiers(
    organizationId: $organizationId
    individualMembershipTierTagIds: $individualMembershipTierTagIds
  ) {
    _id
    metadata {
      individualMembershipTiers
    }
  }
}
    `;
export type OrganizationUpdateIndividualMembershipTiersMutationFn = Apollo.MutationFunction<OrganizationUpdateIndividualMembershipTiersMutation, OrganizationUpdateIndividualMembershipTiersMutationVariables>;

/**
 * __useOrganizationUpdateIndividualMembershipTiersMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateIndividualMembershipTiersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateIndividualMembershipTiersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateIndividualMembershipTiersMutation, { data, loading, error }] = useOrganizationUpdateIndividualMembershipTiersMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      individualMembershipTierTagIds: // value for 'individualMembershipTierTagIds'
 *   },
 * });
 */
export function useOrganizationUpdateIndividualMembershipTiersMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateIndividualMembershipTiersMutation, OrganizationUpdateIndividualMembershipTiersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateIndividualMembershipTiersMutation, OrganizationUpdateIndividualMembershipTiersMutationVariables>(OrganizationUpdateIndividualMembershipTiersDocument, options);
      }
export type OrganizationUpdateIndividualMembershipTiersMutationHookResult = ReturnType<typeof useOrganizationUpdateIndividualMembershipTiersMutation>;
export type OrganizationUpdateIndividualMembershipTiersMutationResult = Apollo.MutationResult<OrganizationUpdateIndividualMembershipTiersMutation>;
export type OrganizationUpdateIndividualMembershipTiersMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateIndividualMembershipTiersMutation, OrganizationUpdateIndividualMembershipTiersMutationVariables>;
export const OrganizationUpdateListingAudiencesDocument = gql`
    mutation OrganizationUpdateListingAudiences($organizationId: ID!, $listingAudienceTagIds: [ID!]!, $removedListAction: String) {
  organizationUpdateListingAudiences(
    organizationId: $organizationId
    listingAudienceTagIds: $listingAudienceTagIds
    removedListAction: $removedListAction
  ) {
    _id
    metadata {
      listingAudienceTagIds
    }
  }
}
    `;
export type OrganizationUpdateListingAudiencesMutationFn = Apollo.MutationFunction<OrganizationUpdateListingAudiencesMutation, OrganizationUpdateListingAudiencesMutationVariables>;

/**
 * __useOrganizationUpdateListingAudiencesMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateListingAudiencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateListingAudiencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateListingAudiencesMutation, { data, loading, error }] = useOrganizationUpdateListingAudiencesMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      listingAudienceTagIds: // value for 'listingAudienceTagIds'
 *      removedListAction: // value for 'removedListAction'
 *   },
 * });
 */
export function useOrganizationUpdateListingAudiencesMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateListingAudiencesMutation, OrganizationUpdateListingAudiencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateListingAudiencesMutation, OrganizationUpdateListingAudiencesMutationVariables>(OrganizationUpdateListingAudiencesDocument, options);
      }
export type OrganizationUpdateListingAudiencesMutationHookResult = ReturnType<typeof useOrganizationUpdateListingAudiencesMutation>;
export type OrganizationUpdateListingAudiencesMutationResult = Apollo.MutationResult<OrganizationUpdateListingAudiencesMutation>;
export type OrganizationUpdateListingAudiencesMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateListingAudiencesMutation, OrganizationUpdateListingAudiencesMutationVariables>;
export const OrganizationUpdateMembershipBroadcastDocument = gql`
    mutation OrganizationUpdateMembershipBroadcast($organizationId: ID!, $broadcastId: MongoID) {
  organizationUpdateMembershipBroadcast(
    organizationId: $organizationId
    broadcastId: $broadcastId
  ) {
    _id
    metadata {
      membershipBroadcastId
    }
  }
}
    `;
export type OrganizationUpdateMembershipBroadcastMutationFn = Apollo.MutationFunction<OrganizationUpdateMembershipBroadcastMutation, OrganizationUpdateMembershipBroadcastMutationVariables>;

/**
 * __useOrganizationUpdateMembershipBroadcastMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateMembershipBroadcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateMembershipBroadcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateMembershipBroadcastMutation, { data, loading, error }] = useOrganizationUpdateMembershipBroadcastMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      broadcastId: // value for 'broadcastId'
 *   },
 * });
 */
export function useOrganizationUpdateMembershipBroadcastMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateMembershipBroadcastMutation, OrganizationUpdateMembershipBroadcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateMembershipBroadcastMutation, OrganizationUpdateMembershipBroadcastMutationVariables>(OrganizationUpdateMembershipBroadcastDocument, options);
      }
export type OrganizationUpdateMembershipBroadcastMutationHookResult = ReturnType<typeof useOrganizationUpdateMembershipBroadcastMutation>;
export type OrganizationUpdateMembershipBroadcastMutationResult = Apollo.MutationResult<OrganizationUpdateMembershipBroadcastMutation>;
export type OrganizationUpdateMembershipBroadcastMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateMembershipBroadcastMutation, OrganizationUpdateMembershipBroadcastMutationVariables>;
export const OrganizationUpdateMembershipHubDocument = gql`
    mutation OrganizationUpdateMembershipHub($organizationId: MongoID!, $hideOfferFromForYou: Boolean, $tiers: [MembershipHubTierInput!], $language: String) {
  organizationUpdateMembershipHub(
    organizationId: $organizationId
    hideOfferFromForYou: $hideOfferFromForYou
    tiers: $tiers
    language: $language
  ) {
    _id
    metadata {
      membershipHub {
        hideOfferFromForYou
        tiers {
          tierTagId
          description {
            ...MultilingualFragment
          }
          applicationBroadcastId
          applicationResourceId
          hideFromNewcomers
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type OrganizationUpdateMembershipHubMutationFn = Apollo.MutationFunction<OrganizationUpdateMembershipHubMutation, OrganizationUpdateMembershipHubMutationVariables>;

/**
 * __useOrganizationUpdateMembershipHubMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateMembershipHubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateMembershipHubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateMembershipHubMutation, { data, loading, error }] = useOrganizationUpdateMembershipHubMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      hideOfferFromForYou: // value for 'hideOfferFromForYou'
 *      tiers: // value for 'tiers'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useOrganizationUpdateMembershipHubMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateMembershipHubMutation, OrganizationUpdateMembershipHubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateMembershipHubMutation, OrganizationUpdateMembershipHubMutationVariables>(OrganizationUpdateMembershipHubDocument, options);
      }
export type OrganizationUpdateMembershipHubMutationHookResult = ReturnType<typeof useOrganizationUpdateMembershipHubMutation>;
export type OrganizationUpdateMembershipHubMutationResult = Apollo.MutationResult<OrganizationUpdateMembershipHubMutation>;
export type OrganizationUpdateMembershipHubMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateMembershipHubMutation, OrganizationUpdateMembershipHubMutationVariables>;
export const OrganizationUpdateMembershipPaymentsEnabledDocument = gql`
    mutation OrganizationUpdateMembershipPaymentsEnabled($organizationId: ID!, $enabled: Boolean!) {
  organizationUpdateMembershipPaymentsEnabled(
    organizationId: $organizationId
    enabled: $enabled
  ) {
    _id
    metadata {
      membershipPaymentsEnabled
    }
  }
}
    `;
export type OrganizationUpdateMembershipPaymentsEnabledMutationFn = Apollo.MutationFunction<OrganizationUpdateMembershipPaymentsEnabledMutation, OrganizationUpdateMembershipPaymentsEnabledMutationVariables>;

/**
 * __useOrganizationUpdateMembershipPaymentsEnabledMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateMembershipPaymentsEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateMembershipPaymentsEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateMembershipPaymentsEnabledMutation, { data, loading, error }] = useOrganizationUpdateMembershipPaymentsEnabledMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useOrganizationUpdateMembershipPaymentsEnabledMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateMembershipPaymentsEnabledMutation, OrganizationUpdateMembershipPaymentsEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateMembershipPaymentsEnabledMutation, OrganizationUpdateMembershipPaymentsEnabledMutationVariables>(OrganizationUpdateMembershipPaymentsEnabledDocument, options);
      }
export type OrganizationUpdateMembershipPaymentsEnabledMutationHookResult = ReturnType<typeof useOrganizationUpdateMembershipPaymentsEnabledMutation>;
export type OrganizationUpdateMembershipPaymentsEnabledMutationResult = Apollo.MutationResult<OrganizationUpdateMembershipPaymentsEnabledMutation>;
export type OrganizationUpdateMembershipPaymentsEnabledMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateMembershipPaymentsEnabledMutation, OrganizationUpdateMembershipPaymentsEnabledMutationVariables>;
export const OrganizationUpdateMembershipStatusTagsDocument = gql`
    mutation OrganizationUpdateMembershipStatusTags($organizationId: ID!, $membershipStatusTagIds: [ID!]!) {
  organizationUpdateMembershipStatusTags(
    organizationId: $organizationId
    membershipStatusTagIds: $membershipStatusTagIds
  ) {
    _id
    metadata {
      membershipStatusTagIds
    }
  }
}
    `;
export type OrganizationUpdateMembershipStatusTagsMutationFn = Apollo.MutationFunction<OrganizationUpdateMembershipStatusTagsMutation, OrganizationUpdateMembershipStatusTagsMutationVariables>;

/**
 * __useOrganizationUpdateMembershipStatusTagsMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateMembershipStatusTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateMembershipStatusTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateMembershipStatusTagsMutation, { data, loading, error }] = useOrganizationUpdateMembershipStatusTagsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      membershipStatusTagIds: // value for 'membershipStatusTagIds'
 *   },
 * });
 */
export function useOrganizationUpdateMembershipStatusTagsMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateMembershipStatusTagsMutation, OrganizationUpdateMembershipStatusTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateMembershipStatusTagsMutation, OrganizationUpdateMembershipStatusTagsMutationVariables>(OrganizationUpdateMembershipStatusTagsDocument, options);
      }
export type OrganizationUpdateMembershipStatusTagsMutationHookResult = ReturnType<typeof useOrganizationUpdateMembershipStatusTagsMutation>;
export type OrganizationUpdateMembershipStatusTagsMutationResult = Apollo.MutationResult<OrganizationUpdateMembershipStatusTagsMutation>;
export type OrganizationUpdateMembershipStatusTagsMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateMembershipStatusTagsMutation, OrganizationUpdateMembershipStatusTagsMutationVariables>;
export const OrganizationUpdateMembershipTierCheckoutDocument = gql`
    mutation OrganizationUpdateMembershipTierCheckout($organizationId: ID!, $tierTagId: MongoID!, $bookerId: MongoID, $free: Boolean) {
  organizationUpdateMembershipTierCheckout(
    organizationId: $organizationId
    tierTagId: $tierTagId
    bookerId: $bookerId
    free: $free
  ) {
    _id
    metadata {
      membershipTierCheckouts {
        tierTagId
        bookerId
        free
      }
    }
  }
}
    `;
export type OrganizationUpdateMembershipTierCheckoutMutationFn = Apollo.MutationFunction<OrganizationUpdateMembershipTierCheckoutMutation, OrganizationUpdateMembershipTierCheckoutMutationVariables>;

/**
 * __useOrganizationUpdateMembershipTierCheckoutMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateMembershipTierCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateMembershipTierCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateMembershipTierCheckoutMutation, { data, loading, error }] = useOrganizationUpdateMembershipTierCheckoutMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      tierTagId: // value for 'tierTagId'
 *      bookerId: // value for 'bookerId'
 *      free: // value for 'free'
 *   },
 * });
 */
export function useOrganizationUpdateMembershipTierCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateMembershipTierCheckoutMutation, OrganizationUpdateMembershipTierCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateMembershipTierCheckoutMutation, OrganizationUpdateMembershipTierCheckoutMutationVariables>(OrganizationUpdateMembershipTierCheckoutDocument, options);
      }
export type OrganizationUpdateMembershipTierCheckoutMutationHookResult = ReturnType<typeof useOrganizationUpdateMembershipTierCheckoutMutation>;
export type OrganizationUpdateMembershipTierCheckoutMutationResult = Apollo.MutationResult<OrganizationUpdateMembershipTierCheckoutMutation>;
export type OrganizationUpdateMembershipTierCheckoutMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateMembershipTierCheckoutMutation, OrganizationUpdateMembershipTierCheckoutMutationVariables>;
export const OrganizationUpdateMembershipTiersDocument = gql`
    mutation OrganizationUpdateMembershipTiers($organizationId: ID!, $membershipTierTagIds: [ID!]!, $removedListAction: String) {
  organizationUpdateMembershipTiers(
    organizationId: $organizationId
    membershipTierTagIds: $membershipTierTagIds
    removedListAction: $removedListAction
  ) {
    _id
    metadata {
      membershipTiers
    }
  }
}
    `;
export type OrganizationUpdateMembershipTiersMutationFn = Apollo.MutationFunction<OrganizationUpdateMembershipTiersMutation, OrganizationUpdateMembershipTiersMutationVariables>;

/**
 * __useOrganizationUpdateMembershipTiersMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateMembershipTiersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateMembershipTiersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateMembershipTiersMutation, { data, loading, error }] = useOrganizationUpdateMembershipTiersMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      membershipTierTagIds: // value for 'membershipTierTagIds'
 *      removedListAction: // value for 'removedListAction'
 *   },
 * });
 */
export function useOrganizationUpdateMembershipTiersMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateMembershipTiersMutation, OrganizationUpdateMembershipTiersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateMembershipTiersMutation, OrganizationUpdateMembershipTiersMutationVariables>(OrganizationUpdateMembershipTiersDocument, options);
      }
export type OrganizationUpdateMembershipTiersMutationHookResult = ReturnType<typeof useOrganizationUpdateMembershipTiersMutation>;
export type OrganizationUpdateMembershipTiersMutationResult = Apollo.MutationResult<OrganizationUpdateMembershipTiersMutation>;
export type OrganizationUpdateMembershipTiersMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateMembershipTiersMutation, OrganizationUpdateMembershipTiersMutationVariables>;
export const OrganizationUpdateNomenclatureDocument = gql`
    mutation OrganizationUpdateNomenclature($organizationId: ID!, $membership: String!, $member: String!, $members: String!) {
  organizationUpdateNomenclature(
    organizationId: $organizationId
    membership: $membership
    member: $member
    members: $members
  ) {
    _id
    metadata {
      nomenclature {
        membership
        member
        members
      }
    }
  }
}
    `;
export type OrganizationUpdateNomenclatureMutationFn = Apollo.MutationFunction<OrganizationUpdateNomenclatureMutation, OrganizationUpdateNomenclatureMutationVariables>;

/**
 * __useOrganizationUpdateNomenclatureMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateNomenclatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateNomenclatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateNomenclatureMutation, { data, loading, error }] = useOrganizationUpdateNomenclatureMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      membership: // value for 'membership'
 *      member: // value for 'member'
 *      members: // value for 'members'
 *   },
 * });
 */
export function useOrganizationUpdateNomenclatureMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateNomenclatureMutation, OrganizationUpdateNomenclatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateNomenclatureMutation, OrganizationUpdateNomenclatureMutationVariables>(OrganizationUpdateNomenclatureDocument, options);
      }
export type OrganizationUpdateNomenclatureMutationHookResult = ReturnType<typeof useOrganizationUpdateNomenclatureMutation>;
export type OrganizationUpdateNomenclatureMutationResult = Apollo.MutationResult<OrganizationUpdateNomenclatureMutation>;
export type OrganizationUpdateNomenclatureMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateNomenclatureMutation, OrganizationUpdateNomenclatureMutationVariables>;
export const OrganizationUpdateRenewalSettingsDocument = gql`
    mutation OrganizationUpdateRenewalSettings($organizationId: ID!, $enabled: Boolean!, $renewalType: String!, $fixedRenewalMonth: Int, $fixedRenewalDay: Int, $proRateEnabled: Boolean, $term: String!, $termYears: Int, $pendingStatusTagId: MongoID, $activeStatusTagId: MongoID, $expiredStatusTagId: MongoID, $clearStatusTagsOnExpiration: Boolean, $sendRenewalEmails: Boolean!, $sendExpirationEmails: Boolean!, $sendSuccessEmails: Boolean!, $sendOverdueEmails: Boolean, $sendCancelledEmails: Boolean, $automaticRenewalEmails: Boolean, $emailCooldownDays: Int, $renewalReminderLeadDays: Int, $instructionsEmailSubject: String, $instructionsEmailBody: String, $expiredEmailSubject: String, $expiredEmailBody: String, $successEmailSubject: String, $successEmailBody: String, $overdueEmailSubject: String, $overdueEmailBody: String, $cancelledEmailSubject: String, $cancelledEmailBody: String, $instructionsEmailCtaLabel: String, $expiredEmailCtaLabel: String, $successEmailCtaLabel: String, $overdueEmailCtaLabel: String, $cancelledEmailCtaLabel: String, $renewalGraceDays: Int, $neverExpireMembers: Boolean) {
  organizationUpdateRenewalSettings(
    organizationId: $organizationId
    enabled: $enabled
    renewalType: $renewalType
    fixedRenewalMonth: $fixedRenewalMonth
    fixedRenewalDay: $fixedRenewalDay
    proRateEnabled: $proRateEnabled
    term: $term
    termYears: $termYears
    pendingStatusTagId: $pendingStatusTagId
    activeStatusTagId: $activeStatusTagId
    expiredStatusTagId: $expiredStatusTagId
    clearStatusTagsOnExpiration: $clearStatusTagsOnExpiration
    sendRenewalEmails: $sendRenewalEmails
    sendExpirationEmails: $sendExpirationEmails
    sendSuccessEmails: $sendSuccessEmails
    sendOverdueEmails: $sendOverdueEmails
    sendCancelledEmails: $sendCancelledEmails
    automaticRenewalEmails: $automaticRenewalEmails
    emailCooldownDays: $emailCooldownDays
    renewalReminderLeadDays: $renewalReminderLeadDays
    instructionsEmailSubject: $instructionsEmailSubject
    instructionsEmailBody: $instructionsEmailBody
    expiredEmailSubject: $expiredEmailSubject
    expiredEmailBody: $expiredEmailBody
    successEmailSubject: $successEmailSubject
    successEmailBody: $successEmailBody
    overdueEmailSubject: $overdueEmailSubject
    overdueEmailBody: $overdueEmailBody
    cancelledEmailSubject: $cancelledEmailSubject
    cancelledEmailBody: $cancelledEmailBody
    instructionsEmailCtaLabel: $instructionsEmailCtaLabel
    expiredEmailCtaLabel: $expiredEmailCtaLabel
    successEmailCtaLabel: $successEmailCtaLabel
    overdueEmailCtaLabel: $overdueEmailCtaLabel
    cancelledEmailCtaLabel: $cancelledEmailCtaLabel
    renewalGraceDays: $renewalGraceDays
    neverExpireMembers: $neverExpireMembers
  ) {
    _id
    metadata {
      renewalSettings {
        enabled
        renewalType
        fixedRenewalMonth
        fixedRenewalDay
        proRateEnabled
        term
        termYears
        pendingStatusTagId
        activeStatusTagId
        expiredStatusTagId
        clearStatusTagsOnExpiration
        sendRenewalEmails
        sendExpirationEmails
        sendSuccessEmails
        sendOverdueEmails
        sendCancelledEmails
        automaticRenewalEmails
        emailCooldownDays
        renewalReminderLeadDays
        instructionsEmail {
          subject
          body
          ctaLabel
        }
        expiredEmail {
          subject
          body
          ctaLabel
        }
        successEmail {
          subject
          body
          ctaLabel
        }
        overdueEmail {
          subject
          body
          ctaLabel
        }
        cancelledEmail {
          subject
          body
          ctaLabel
        }
        tierReminderEmails {
          tierTagId
          subject
          body
          hideRenewalDateLine
          ctaLabel
        }
      }
    }
  }
}
    `;
export type OrganizationUpdateRenewalSettingsMutationFn = Apollo.MutationFunction<OrganizationUpdateRenewalSettingsMutation, OrganizationUpdateRenewalSettingsMutationVariables>;

/**
 * __useOrganizationUpdateRenewalSettingsMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdateRenewalSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdateRenewalSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdateRenewalSettingsMutation, { data, loading, error }] = useOrganizationUpdateRenewalSettingsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      enabled: // value for 'enabled'
 *      renewalType: // value for 'renewalType'
 *      fixedRenewalMonth: // value for 'fixedRenewalMonth'
 *      fixedRenewalDay: // value for 'fixedRenewalDay'
 *      proRateEnabled: // value for 'proRateEnabled'
 *      term: // value for 'term'
 *      termYears: // value for 'termYears'
 *      pendingStatusTagId: // value for 'pendingStatusTagId'
 *      activeStatusTagId: // value for 'activeStatusTagId'
 *      expiredStatusTagId: // value for 'expiredStatusTagId'
 *      clearStatusTagsOnExpiration: // value for 'clearStatusTagsOnExpiration'
 *      sendRenewalEmails: // value for 'sendRenewalEmails'
 *      sendExpirationEmails: // value for 'sendExpirationEmails'
 *      sendSuccessEmails: // value for 'sendSuccessEmails'
 *      sendOverdueEmails: // value for 'sendOverdueEmails'
 *      sendCancelledEmails: // value for 'sendCancelledEmails'
 *      automaticRenewalEmails: // value for 'automaticRenewalEmails'
 *      emailCooldownDays: // value for 'emailCooldownDays'
 *      renewalReminderLeadDays: // value for 'renewalReminderLeadDays'
 *      instructionsEmailSubject: // value for 'instructionsEmailSubject'
 *      instructionsEmailBody: // value for 'instructionsEmailBody'
 *      expiredEmailSubject: // value for 'expiredEmailSubject'
 *      expiredEmailBody: // value for 'expiredEmailBody'
 *      successEmailSubject: // value for 'successEmailSubject'
 *      successEmailBody: // value for 'successEmailBody'
 *      overdueEmailSubject: // value for 'overdueEmailSubject'
 *      overdueEmailBody: // value for 'overdueEmailBody'
 *      cancelledEmailSubject: // value for 'cancelledEmailSubject'
 *      cancelledEmailBody: // value for 'cancelledEmailBody'
 *      instructionsEmailCtaLabel: // value for 'instructionsEmailCtaLabel'
 *      expiredEmailCtaLabel: // value for 'expiredEmailCtaLabel'
 *      successEmailCtaLabel: // value for 'successEmailCtaLabel'
 *      overdueEmailCtaLabel: // value for 'overdueEmailCtaLabel'
 *      cancelledEmailCtaLabel: // value for 'cancelledEmailCtaLabel'
 *      renewalGraceDays: // value for 'renewalGraceDays'
 *      neverExpireMembers: // value for 'neverExpireMembers'
 *   },
 * });
 */
export function useOrganizationUpdateRenewalSettingsMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpdateRenewalSettingsMutation, OrganizationUpdateRenewalSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpdateRenewalSettingsMutation, OrganizationUpdateRenewalSettingsMutationVariables>(OrganizationUpdateRenewalSettingsDocument, options);
      }
export type OrganizationUpdateRenewalSettingsMutationHookResult = ReturnType<typeof useOrganizationUpdateRenewalSettingsMutation>;
export type OrganizationUpdateRenewalSettingsMutationResult = Apollo.MutationResult<OrganizationUpdateRenewalSettingsMutation>;
export type OrganizationUpdateRenewalSettingsMutationOptions = Apollo.BaseMutationOptions<OrganizationUpdateRenewalSettingsMutation, OrganizationUpdateRenewalSettingsMutationVariables>;
export const OrganizationUpsertTierReminderEmailDocument = gql`
    mutation OrganizationUpsertTierReminderEmail($organizationId: ID!, $tierTagId: MongoID!, $subject: String, $body: String, $hideRenewalDateLine: Boolean, $ctaLabel: String) {
  organizationUpsertTierReminderEmail(
    organizationId: $organizationId
    tierTagId: $tierTagId
    subject: $subject
    body: $body
    hideRenewalDateLine: $hideRenewalDateLine
    ctaLabel: $ctaLabel
  ) {
    _id
    metadata {
      renewalSettings {
        tierReminderEmails {
          tierTagId
          subject
          body
          hideRenewalDateLine
          ctaLabel
        }
      }
    }
  }
}
    `;
export type OrganizationUpsertTierReminderEmailMutationFn = Apollo.MutationFunction<OrganizationUpsertTierReminderEmailMutation, OrganizationUpsertTierReminderEmailMutationVariables>;

/**
 * __useOrganizationUpsertTierReminderEmailMutation__
 *
 * To run a mutation, you first call `useOrganizationUpsertTierReminderEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpsertTierReminderEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpsertTierReminderEmailMutation, { data, loading, error }] = useOrganizationUpsertTierReminderEmailMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      tierTagId: // value for 'tierTagId'
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *      hideRenewalDateLine: // value for 'hideRenewalDateLine'
 *      ctaLabel: // value for 'ctaLabel'
 *   },
 * });
 */
export function useOrganizationUpsertTierReminderEmailMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationUpsertTierReminderEmailMutation, OrganizationUpsertTierReminderEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationUpsertTierReminderEmailMutation, OrganizationUpsertTierReminderEmailMutationVariables>(OrganizationUpsertTierReminderEmailDocument, options);
      }
export type OrganizationUpsertTierReminderEmailMutationHookResult = ReturnType<typeof useOrganizationUpsertTierReminderEmailMutation>;
export type OrganizationUpsertTierReminderEmailMutationResult = Apollo.MutationResult<OrganizationUpsertTierReminderEmailMutation>;
export type OrganizationUpsertTierReminderEmailMutationOptions = Apollo.BaseMutationOptions<OrganizationUpsertTierReminderEmailMutation, OrganizationUpsertTierReminderEmailMutationVariables>;
export const PaymentMethodSetCreateDocument = gql`
    mutation PaymentMethodSetCreate($record: CreateOnePaymentMethodSetInput!) {
  paymentMethodSetCreate(record: $record) {
    recordId
    record {
      ...PaymentMethodSetFragment
    }
  }
}
    ${PaymentMethodSetFragmentFragmentDoc}`;
export type PaymentMethodSetCreateMutationFn = Apollo.MutationFunction<PaymentMethodSetCreateMutation, PaymentMethodSetCreateMutationVariables>;

/**
 * __usePaymentMethodSetCreateMutation__
 *
 * To run a mutation, you first call `usePaymentMethodSetCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodSetCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMethodSetCreateMutation, { data, loading, error }] = usePaymentMethodSetCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePaymentMethodSetCreateMutation(baseOptions?: Apollo.MutationHookOptions<PaymentMethodSetCreateMutation, PaymentMethodSetCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentMethodSetCreateMutation, PaymentMethodSetCreateMutationVariables>(PaymentMethodSetCreateDocument, options);
      }
export type PaymentMethodSetCreateMutationHookResult = ReturnType<typeof usePaymentMethodSetCreateMutation>;
export type PaymentMethodSetCreateMutationResult = Apollo.MutationResult<PaymentMethodSetCreateMutation>;
export type PaymentMethodSetCreateMutationOptions = Apollo.BaseMutationOptions<PaymentMethodSetCreateMutation, PaymentMethodSetCreateMutationVariables>;
export const PaymentMethodSetUpdateDocument = gql`
    mutation PaymentMethodSetUpdate($id: MongoID!, $record: UpdateByIdPaymentMethodSetInput!) {
  paymentMethodSetUpdate(_id: $id, record: $record) {
    recordId
    record {
      ...PaymentMethodSetFragment
    }
  }
}
    ${PaymentMethodSetFragmentFragmentDoc}`;
export type PaymentMethodSetUpdateMutationFn = Apollo.MutationFunction<PaymentMethodSetUpdateMutation, PaymentMethodSetUpdateMutationVariables>;

/**
 * __usePaymentMethodSetUpdateMutation__
 *
 * To run a mutation, you first call `usePaymentMethodSetUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodSetUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMethodSetUpdateMutation, { data, loading, error }] = usePaymentMethodSetUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePaymentMethodSetUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PaymentMethodSetUpdateMutation, PaymentMethodSetUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentMethodSetUpdateMutation, PaymentMethodSetUpdateMutationVariables>(PaymentMethodSetUpdateDocument, options);
      }
export type PaymentMethodSetUpdateMutationHookResult = ReturnType<typeof usePaymentMethodSetUpdateMutation>;
export type PaymentMethodSetUpdateMutationResult = Apollo.MutationResult<PaymentMethodSetUpdateMutation>;
export type PaymentMethodSetUpdateMutationOptions = Apollo.BaseMutationOptions<PaymentMethodSetUpdateMutation, PaymentMethodSetUpdateMutationVariables>;
export const PaymentRequestStatementRemoveOrderDocument = gql`
    mutation PaymentRequestStatementRemoveOrder($paymentRequestId: MongoID!, $orderId: String!) {
  paymentRequestStatementRemoveOrder(
    paymentRequestId: $paymentRequestId
    orderId: $orderId
  ) {
    _id
    status
    version
    grandTotal
  }
}
    `;
export type PaymentRequestStatementRemoveOrderMutationFn = Apollo.MutationFunction<PaymentRequestStatementRemoveOrderMutation, PaymentRequestStatementRemoveOrderMutationVariables>;

/**
 * __usePaymentRequestStatementRemoveOrderMutation__
 *
 * To run a mutation, you first call `usePaymentRequestStatementRemoveOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentRequestStatementRemoveOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentRequestStatementRemoveOrderMutation, { data, loading, error }] = usePaymentRequestStatementRemoveOrderMutation({
 *   variables: {
 *      paymentRequestId: // value for 'paymentRequestId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function usePaymentRequestStatementRemoveOrderMutation(baseOptions?: Apollo.MutationHookOptions<PaymentRequestStatementRemoveOrderMutation, PaymentRequestStatementRemoveOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentRequestStatementRemoveOrderMutation, PaymentRequestStatementRemoveOrderMutationVariables>(PaymentRequestStatementRemoveOrderDocument, options);
      }
export type PaymentRequestStatementRemoveOrderMutationHookResult = ReturnType<typeof usePaymentRequestStatementRemoveOrderMutation>;
export type PaymentRequestStatementRemoveOrderMutationResult = Apollo.MutationResult<PaymentRequestStatementRemoveOrderMutation>;
export type PaymentRequestStatementRemoveOrderMutationOptions = Apollo.BaseMutationOptions<PaymentRequestStatementRemoveOrderMutation, PaymentRequestStatementRemoveOrderMutationVariables>;
export const PersonConnectToListingDocument = gql`
    mutation PersonConnectToListing($id: ID!, $operatorEntityId: ID!, $sendInvitationEmail: Boolean!, $entityId: ID!, $type: EnumOwnerType!) {
  personConnectToListing(
    id: $id
    operatorEntityId: $operatorEntityId
    sendInvitationEmail: $sendInvitationEmail
    entityId: $entityId
    type: $type
  ) {
    ...PersonDetailsFragment
  }
}
    ${PersonDetailsFragmentFragmentDoc}`;
export type PersonConnectToListingMutationFn = Apollo.MutationFunction<PersonConnectToListingMutation, PersonConnectToListingMutationVariables>;

/**
 * __usePersonConnectToListingMutation__
 *
 * To run a mutation, you first call `usePersonConnectToListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonConnectToListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personConnectToListingMutation, { data, loading, error }] = usePersonConnectToListingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      operatorEntityId: // value for 'operatorEntityId'
 *      sendInvitationEmail: // value for 'sendInvitationEmail'
 *      entityId: // value for 'entityId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePersonConnectToListingMutation(baseOptions?: Apollo.MutationHookOptions<PersonConnectToListingMutation, PersonConnectToListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersonConnectToListingMutation, PersonConnectToListingMutationVariables>(PersonConnectToListingDocument, options);
      }
export type PersonConnectToListingMutationHookResult = ReturnType<typeof usePersonConnectToListingMutation>;
export type PersonConnectToListingMutationResult = Apollo.MutationResult<PersonConnectToListingMutation>;
export type PersonConnectToListingMutationOptions = Apollo.BaseMutationOptions<PersonConnectToListingMutation, PersonConnectToListingMutationVariables>;
export const PersonCreateDocument = gql`
    mutation PersonCreate($entityId: ID!, $type: EnumOwnerType!, $record: CreateOnePeopleInput!) {
  personCreate(entityId: $entityId, type: $type, record: $record) {
    ...PersonSimpleManyFragment
  }
}
    ${PersonSimpleManyFragmentFragmentDoc}`;
export type PersonCreateMutationFn = Apollo.MutationFunction<PersonCreateMutation, PersonCreateMutationVariables>;

/**
 * __usePersonCreateMutation__
 *
 * To run a mutation, you first call `usePersonCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personCreateMutation, { data, loading, error }] = usePersonCreateMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      type: // value for 'type'
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePersonCreateMutation(baseOptions?: Apollo.MutationHookOptions<PersonCreateMutation, PersonCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersonCreateMutation, PersonCreateMutationVariables>(PersonCreateDocument, options);
      }
export type PersonCreateMutationHookResult = ReturnType<typeof usePersonCreateMutation>;
export type PersonCreateMutationResult = Apollo.MutationResult<PersonCreateMutation>;
export type PersonCreateMutationOptions = Apollo.BaseMutationOptions<PersonCreateMutation, PersonCreateMutationVariables>;
export const PersonDeleteDocument = gql`
    mutation PersonDelete($id: ID!, $entityId: ID!, $type: EnumOwnerType!) {
  personDelete(id: $id, entityId: $entityId, type: $type)
}
    `;
export type PersonDeleteMutationFn = Apollo.MutationFunction<PersonDeleteMutation, PersonDeleteMutationVariables>;

/**
 * __usePersonDeleteMutation__
 *
 * To run a mutation, you first call `usePersonDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personDeleteMutation, { data, loading, error }] = usePersonDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityId: // value for 'entityId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePersonDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PersonDeleteMutation, PersonDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersonDeleteMutation, PersonDeleteMutationVariables>(PersonDeleteDocument, options);
      }
export type PersonDeleteMutationHookResult = ReturnType<typeof usePersonDeleteMutation>;
export type PersonDeleteMutationResult = Apollo.MutationResult<PersonDeleteMutation>;
export type PersonDeleteMutationOptions = Apollo.BaseMutationOptions<PersonDeleteMutation, PersonDeleteMutationVariables>;
export const PersonDeleteCompletelyByInternalDocument = gql`
    mutation PersonDeleteCompletelyByInternal($personId: ID!) {
  personDeleteCompletelyByInternal(personId: $personId)
}
    `;
export type PersonDeleteCompletelyByInternalMutationFn = Apollo.MutationFunction<PersonDeleteCompletelyByInternalMutation, PersonDeleteCompletelyByInternalMutationVariables>;

/**
 * __usePersonDeleteCompletelyByInternalMutation__
 *
 * To run a mutation, you first call `usePersonDeleteCompletelyByInternalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonDeleteCompletelyByInternalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personDeleteCompletelyByInternalMutation, { data, loading, error }] = usePersonDeleteCompletelyByInternalMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonDeleteCompletelyByInternalMutation(baseOptions?: Apollo.MutationHookOptions<PersonDeleteCompletelyByInternalMutation, PersonDeleteCompletelyByInternalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersonDeleteCompletelyByInternalMutation, PersonDeleteCompletelyByInternalMutationVariables>(PersonDeleteCompletelyByInternalDocument, options);
      }
export type PersonDeleteCompletelyByInternalMutationHookResult = ReturnType<typeof usePersonDeleteCompletelyByInternalMutation>;
export type PersonDeleteCompletelyByInternalMutationResult = Apollo.MutationResult<PersonDeleteCompletelyByInternalMutation>;
export type PersonDeleteCompletelyByInternalMutationOptions = Apollo.BaseMutationOptions<PersonDeleteCompletelyByInternalMutation, PersonDeleteCompletelyByInternalMutationVariables>;
export const PersonUpdateAddToVisibleToDocument = gql`
    mutation PersonUpdateAddToVisibleTo($email: String!, $entityId: ID!, $type: EnumOwnerType!) {
  personUpdateAddToVisibleTo(email: $email, entityId: $entityId, type: $type) {
    ...PersonSimpleManyFragment
  }
}
    ${PersonSimpleManyFragmentFragmentDoc}`;
export type PersonUpdateAddToVisibleToMutationFn = Apollo.MutationFunction<PersonUpdateAddToVisibleToMutation, PersonUpdateAddToVisibleToMutationVariables>;

/**
 * __usePersonUpdateAddToVisibleToMutation__
 *
 * To run a mutation, you first call `usePersonUpdateAddToVisibleToMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonUpdateAddToVisibleToMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personUpdateAddToVisibleToMutation, { data, loading, error }] = usePersonUpdateAddToVisibleToMutation({
 *   variables: {
 *      email: // value for 'email'
 *      entityId: // value for 'entityId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePersonUpdateAddToVisibleToMutation(baseOptions?: Apollo.MutationHookOptions<PersonUpdateAddToVisibleToMutation, PersonUpdateAddToVisibleToMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersonUpdateAddToVisibleToMutation, PersonUpdateAddToVisibleToMutationVariables>(PersonUpdateAddToVisibleToDocument, options);
      }
export type PersonUpdateAddToVisibleToMutationHookResult = ReturnType<typeof usePersonUpdateAddToVisibleToMutation>;
export type PersonUpdateAddToVisibleToMutationResult = Apollo.MutationResult<PersonUpdateAddToVisibleToMutation>;
export type PersonUpdateAddToVisibleToMutationOptions = Apollo.BaseMutationOptions<PersonUpdateAddToVisibleToMutation, PersonUpdateAddToVisibleToMutationVariables>;
export const PersonUpdateCommonDocument = gql`
    mutation PersonUpdateCommon($id: MongoID!, $record: UpdateByIdPeopleInput!, $entityId: ID!, $type: EnumOwnerType!) {
  personUpdateCommon(_id: $id, record: $record, entityId: $entityId, type: $type) {
    ...PersonDetailsFragment
  }
}
    ${PersonDetailsFragmentFragmentDoc}`;
export type PersonUpdateCommonMutationFn = Apollo.MutationFunction<PersonUpdateCommonMutation, PersonUpdateCommonMutationVariables>;

/**
 * __usePersonUpdateCommonMutation__
 *
 * To run a mutation, you first call `usePersonUpdateCommonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonUpdateCommonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personUpdateCommonMutation, { data, loading, error }] = usePersonUpdateCommonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *      entityId: // value for 'entityId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePersonUpdateCommonMutation(baseOptions?: Apollo.MutationHookOptions<PersonUpdateCommonMutation, PersonUpdateCommonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersonUpdateCommonMutation, PersonUpdateCommonMutationVariables>(PersonUpdateCommonDocument, options);
      }
export type PersonUpdateCommonMutationHookResult = ReturnType<typeof usePersonUpdateCommonMutation>;
export type PersonUpdateCommonMutationResult = Apollo.MutationResult<PersonUpdateCommonMutation>;
export type PersonUpdateCommonMutationOptions = Apollo.BaseMutationOptions<PersonUpdateCommonMutation, PersonUpdateCommonMutationVariables>;
export const PersonUpdateVisibleToDocument = gql`
    mutation PersonUpdateVisibleTo($id: ID!, $entityId: ID!, $type: EnumOwnerType!, $scratchpad: String, $tags: [ID], $metadata: PersonMetadataInput) {
  personUpdateVisibleTo(
    id: $id
    entityId: $entityId
    type: $type
    scratchpad: $scratchpad
    tags: $tags
    metadata: $metadata
  ) {
    ...PersonDetailsFragment
  }
}
    ${PersonDetailsFragmentFragmentDoc}`;
export type PersonUpdateVisibleToMutationFn = Apollo.MutationFunction<PersonUpdateVisibleToMutation, PersonUpdateVisibleToMutationVariables>;

/**
 * __usePersonUpdateVisibleToMutation__
 *
 * To run a mutation, you first call `usePersonUpdateVisibleToMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonUpdateVisibleToMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personUpdateVisibleToMutation, { data, loading, error }] = usePersonUpdateVisibleToMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityId: // value for 'entityId'
 *      type: // value for 'type'
 *      scratchpad: // value for 'scratchpad'
 *      tags: // value for 'tags'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function usePersonUpdateVisibleToMutation(baseOptions?: Apollo.MutationHookOptions<PersonUpdateVisibleToMutation, PersonUpdateVisibleToMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersonUpdateVisibleToMutation, PersonUpdateVisibleToMutationVariables>(PersonUpdateVisibleToDocument, options);
      }
export type PersonUpdateVisibleToMutationHookResult = ReturnType<typeof usePersonUpdateVisibleToMutation>;
export type PersonUpdateVisibleToMutationResult = Apollo.MutationResult<PersonUpdateVisibleToMutation>;
export type PersonUpdateVisibleToMutationOptions = Apollo.BaseMutationOptions<PersonUpdateVisibleToMutation, PersonUpdateVisibleToMutationVariables>;
export const PlaceCreateDocument = gql`
    mutation PlaceCreate($record: CreateOnePlaceInput!) {
  placeCreate(record: $record) {
    record {
      _id
      name {
        en
        fr
        es
      }
      type
      connectedListing
      connectedDmoListing
      subPlaces {
        _id
        name {
          en
          fr
          es
        }
        type
      }
      outline {
        type
        coordinates
      }
      outlineSimplified {
        type
        coordinates
      }
      createdDateISO
      updatedDateISO
    }
  }
}
    `;
export type PlaceCreateMutationFn = Apollo.MutationFunction<PlaceCreateMutation, PlaceCreateMutationVariables>;

/**
 * __usePlaceCreateMutation__
 *
 * To run a mutation, you first call `usePlaceCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeCreateMutation, { data, loading, error }] = usePlaceCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePlaceCreateMutation(baseOptions?: Apollo.MutationHookOptions<PlaceCreateMutation, PlaceCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaceCreateMutation, PlaceCreateMutationVariables>(PlaceCreateDocument, options);
      }
export type PlaceCreateMutationHookResult = ReturnType<typeof usePlaceCreateMutation>;
export type PlaceCreateMutationResult = Apollo.MutationResult<PlaceCreateMutation>;
export type PlaceCreateMutationOptions = Apollo.BaseMutationOptions<PlaceCreateMutation, PlaceCreateMutationVariables>;
export const PlaceDeleteDocument = gql`
    mutation PlaceDelete($id: MongoID!) {
  placeDelete(_id: $id) {
    recordId
  }
}
    `;
export type PlaceDeleteMutationFn = Apollo.MutationFunction<PlaceDeleteMutation, PlaceDeleteMutationVariables>;

/**
 * __usePlaceDeleteMutation__
 *
 * To run a mutation, you first call `usePlaceDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeDeleteMutation, { data, loading, error }] = usePlaceDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlaceDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PlaceDeleteMutation, PlaceDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaceDeleteMutation, PlaceDeleteMutationVariables>(PlaceDeleteDocument, options);
      }
export type PlaceDeleteMutationHookResult = ReturnType<typeof usePlaceDeleteMutation>;
export type PlaceDeleteMutationResult = Apollo.MutationResult<PlaceDeleteMutation>;
export type PlaceDeleteMutationOptions = Apollo.BaseMutationOptions<PlaceDeleteMutation, PlaceDeleteMutationVariables>;
export const PlaceMoveNodeDocument = gql`
    mutation PlaceMoveNode($placeId: MongoID!, $newParentId: MongoID, $index: Int!) {
  placeMoveNode(placeId: $placeId, newParentId: $newParentId, index: $index) {
    _id
    name {
      en
    }
    type
    parentPlace
    subPlaces {
      _id
    }
  }
}
    `;
export type PlaceMoveNodeMutationFn = Apollo.MutationFunction<PlaceMoveNodeMutation, PlaceMoveNodeMutationVariables>;

/**
 * __usePlaceMoveNodeMutation__
 *
 * To run a mutation, you first call `usePlaceMoveNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceMoveNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeMoveNodeMutation, { data, loading, error }] = usePlaceMoveNodeMutation({
 *   variables: {
 *      placeId: // value for 'placeId'
 *      newParentId: // value for 'newParentId'
 *      index: // value for 'index'
 *   },
 * });
 */
export function usePlaceMoveNodeMutation(baseOptions?: Apollo.MutationHookOptions<PlaceMoveNodeMutation, PlaceMoveNodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaceMoveNodeMutation, PlaceMoveNodeMutationVariables>(PlaceMoveNodeDocument, options);
      }
export type PlaceMoveNodeMutationHookResult = ReturnType<typeof usePlaceMoveNodeMutation>;
export type PlaceMoveNodeMutationResult = Apollo.MutationResult<PlaceMoveNodeMutation>;
export type PlaceMoveNodeMutationOptions = Apollo.BaseMutationOptions<PlaceMoveNodeMutation, PlaceMoveNodeMutationVariables>;
export const PlaceUpdateDocument = gql`
    mutation PlaceUpdate($id: MongoID!, $record: UpdateByIdPlaceInput!) {
  placeUpdate(_id: $id, record: $record) {
    record {
      _id
      name {
        en
        fr
        es
      }
      type
      connectedListing
      connectedDmoListing
      subPlaces {
        _id
        name {
          en
          fr
          es
        }
        type
      }
      outline {
        type
        coordinates
      }
      outlineSimplified {
        type
        coordinates
      }
      createdDateISO
      updatedDateISO
    }
  }
}
    `;
export type PlaceUpdateMutationFn = Apollo.MutationFunction<PlaceUpdateMutation, PlaceUpdateMutationVariables>;

/**
 * __usePlaceUpdateMutation__
 *
 * To run a mutation, you first call `usePlaceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeUpdateMutation, { data, loading, error }] = usePlaceUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePlaceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PlaceUpdateMutation, PlaceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaceUpdateMutation, PlaceUpdateMutationVariables>(PlaceUpdateDocument, options);
      }
export type PlaceUpdateMutationHookResult = ReturnType<typeof usePlaceUpdateMutation>;
export type PlaceUpdateMutationResult = Apollo.MutationResult<PlaceUpdateMutation>;
export type PlaceUpdateMutationOptions = Apollo.BaseMutationOptions<PlaceUpdateMutation, PlaceUpdateMutationVariables>;
export const PolicyCreateDocument = gql`
    mutation PolicyCreate($record: CreateOnePolicyInput!) {
  policyCreate(record: $record) {
    recordId
    record {
      ...PolicyFragment
    }
  }
}
    ${PolicyFragmentFragmentDoc}`;
export type PolicyCreateMutationFn = Apollo.MutationFunction<PolicyCreateMutation, PolicyCreateMutationVariables>;

/**
 * __usePolicyCreateMutation__
 *
 * To run a mutation, you first call `usePolicyCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolicyCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [policyCreateMutation, { data, loading, error }] = usePolicyCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePolicyCreateMutation(baseOptions?: Apollo.MutationHookOptions<PolicyCreateMutation, PolicyCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolicyCreateMutation, PolicyCreateMutationVariables>(PolicyCreateDocument, options);
      }
export type PolicyCreateMutationHookResult = ReturnType<typeof usePolicyCreateMutation>;
export type PolicyCreateMutationResult = Apollo.MutationResult<PolicyCreateMutation>;
export type PolicyCreateMutationOptions = Apollo.BaseMutationOptions<PolicyCreateMutation, PolicyCreateMutationVariables>;
export const PolicyUpdateDocument = gql`
    mutation PolicyUpdate($id: MongoID!, $record: UpdateByIdPolicyInput!) {
  policyUpdate(_id: $id, record: $record) {
    recordId
    record {
      ...PolicyFragment
    }
  }
}
    ${PolicyFragmentFragmentDoc}`;
export type PolicyUpdateMutationFn = Apollo.MutationFunction<PolicyUpdateMutation, PolicyUpdateMutationVariables>;

/**
 * __usePolicyUpdateMutation__
 *
 * To run a mutation, you first call `usePolicyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePolicyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [policyUpdateMutation, { data, loading, error }] = usePolicyUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePolicyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolicyUpdateMutation, PolicyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolicyUpdateMutation, PolicyUpdateMutationVariables>(PolicyUpdateDocument, options);
      }
export type PolicyUpdateMutationHookResult = ReturnType<typeof usePolicyUpdateMutation>;
export type PolicyUpdateMutationResult = Apollo.MutationResult<PolicyUpdateMutation>;
export type PolicyUpdateMutationOptions = Apollo.BaseMutationOptions<PolicyUpdateMutation, PolicyUpdateMutationVariables>;
export const ProductCreateDocument = gql`
    mutation ProductCreate($record: CreateOneProductInput!, $inventoryCount: Int!) {
  productCreate(record: $record, inventoryCount: $inventoryCount) {
    recordId
    record {
      ...ProductFragment
    }
  }
}
    ${ProductFragmentFragmentDoc}`;
export type ProductCreateMutationFn = Apollo.MutationFunction<ProductCreateMutation, ProductCreateMutationVariables>;

/**
 * __useProductCreateMutation__
 *
 * To run a mutation, you first call `useProductCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productCreateMutation, { data, loading, error }] = useProductCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *      inventoryCount: // value for 'inventoryCount'
 *   },
 * });
 */
export function useProductCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProductCreateMutation, ProductCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductCreateMutation, ProductCreateMutationVariables>(ProductCreateDocument, options);
      }
export type ProductCreateMutationHookResult = ReturnType<typeof useProductCreateMutation>;
export type ProductCreateMutationResult = Apollo.MutationResult<ProductCreateMutation>;
export type ProductCreateMutationOptions = Apollo.BaseMutationOptions<ProductCreateMutation, ProductCreateMutationVariables>;
export const ProductDuplicateDocument = gql`
    mutation ProductDuplicate($id: MongoID!) {
  productDuplicate(id: $id) {
    productId
  }
}
    `;
export type ProductDuplicateMutationFn = Apollo.MutationFunction<ProductDuplicateMutation, ProductDuplicateMutationVariables>;

/**
 * __useProductDuplicateMutation__
 *
 * To run a mutation, you first call `useProductDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productDuplicateMutation, { data, loading, error }] = useProductDuplicateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<ProductDuplicateMutation, ProductDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductDuplicateMutation, ProductDuplicateMutationVariables>(ProductDuplicateDocument, options);
      }
export type ProductDuplicateMutationHookResult = ReturnType<typeof useProductDuplicateMutation>;
export type ProductDuplicateMutationResult = Apollo.MutationResult<ProductDuplicateMutation>;
export type ProductDuplicateMutationOptions = Apollo.BaseMutationOptions<ProductDuplicateMutation, ProductDuplicateMutationVariables>;
export const ProductIntegrateCalendarLinksDocument = gql`
    mutation ProductIntegrateCalendarLinks($calendarLinksByProductIds: [CalendarLinksByProductId!]!) {
  integrateProductCalendarLinksByProductIds(
    calendarLinksByProductIds: $calendarLinksByProductIds
  ) {
    products {
      _id
      name {
        ...MultilingualFragment
      }
    }
    releasedInventoryClaimItems {
      _id
    }
    updatedInventoryClaimItems {
      _id
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type ProductIntegrateCalendarLinksMutationFn = Apollo.MutationFunction<ProductIntegrateCalendarLinksMutation, ProductIntegrateCalendarLinksMutationVariables>;

/**
 * __useProductIntegrateCalendarLinksMutation__
 *
 * To run a mutation, you first call `useProductIntegrateCalendarLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductIntegrateCalendarLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productIntegrateCalendarLinksMutation, { data, loading, error }] = useProductIntegrateCalendarLinksMutation({
 *   variables: {
 *      calendarLinksByProductIds: // value for 'calendarLinksByProductIds'
 *   },
 * });
 */
export function useProductIntegrateCalendarLinksMutation(baseOptions?: Apollo.MutationHookOptions<ProductIntegrateCalendarLinksMutation, ProductIntegrateCalendarLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductIntegrateCalendarLinksMutation, ProductIntegrateCalendarLinksMutationVariables>(ProductIntegrateCalendarLinksDocument, options);
      }
export type ProductIntegrateCalendarLinksMutationHookResult = ReturnType<typeof useProductIntegrateCalendarLinksMutation>;
export type ProductIntegrateCalendarLinksMutationResult = Apollo.MutationResult<ProductIntegrateCalendarLinksMutation>;
export type ProductIntegrateCalendarLinksMutationOptions = Apollo.BaseMutationOptions<ProductIntegrateCalendarLinksMutation, ProductIntegrateCalendarLinksMutationVariables>;
export const ProductUpdateDocument = gql`
    mutation ProductUpdate($id: MongoID!, $record: UpdateByIdProductInput!, $imagesToKeep: [String]) {
  productUpdate(_id: $id, record: $record, imagesToKeep: $imagesToKeep) {
    recordId
    record {
      ...ProductFragment
    }
  }
}
    ${ProductFragmentFragmentDoc}`;
export type ProductUpdateMutationFn = Apollo.MutationFunction<ProductUpdateMutation, ProductUpdateMutationVariables>;

/**
 * __useProductUpdateMutation__
 *
 * To run a mutation, you first call `useProductUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productUpdateMutation, { data, loading, error }] = useProductUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *      imagesToKeep: // value for 'imagesToKeep'
 *   },
 * });
 */
export function useProductUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProductUpdateMutation, ProductUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductUpdateMutation, ProductUpdateMutationVariables>(ProductUpdateDocument, options);
      }
export type ProductUpdateMutationHookResult = ReturnType<typeof useProductUpdateMutation>;
export type ProductUpdateMutationResult = Apollo.MutationResult<ProductUpdateMutation>;
export type ProductUpdateMutationOptions = Apollo.BaseMutationOptions<ProductUpdateMutation, ProductUpdateMutationVariables>;
export const PromotionCreateDocument = gql`
    mutation PromotionCreate($record: CreateOnePromotionInput!) {
  promotionCreate(record: $record) {
    recordId
    record {
      ...PromotionFragment
    }
  }
}
    ${PromotionFragmentFragmentDoc}`;
export type PromotionCreateMutationFn = Apollo.MutationFunction<PromotionCreateMutation, PromotionCreateMutationVariables>;

/**
 * __usePromotionCreateMutation__
 *
 * To run a mutation, you first call `usePromotionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromotionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promotionCreateMutation, { data, loading, error }] = usePromotionCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePromotionCreateMutation(baseOptions?: Apollo.MutationHookOptions<PromotionCreateMutation, PromotionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromotionCreateMutation, PromotionCreateMutationVariables>(PromotionCreateDocument, options);
      }
export type PromotionCreateMutationHookResult = ReturnType<typeof usePromotionCreateMutation>;
export type PromotionCreateMutationResult = Apollo.MutationResult<PromotionCreateMutation>;
export type PromotionCreateMutationOptions = Apollo.BaseMutationOptions<PromotionCreateMutation, PromotionCreateMutationVariables>;
export const PromotionDeleteByIdDocument = gql`
    mutation PromotionDeleteById($id: MongoID!) {
  promotionDeleteById(_id: $id) {
    recordId
  }
}
    `;
export type PromotionDeleteByIdMutationFn = Apollo.MutationFunction<PromotionDeleteByIdMutation, PromotionDeleteByIdMutationVariables>;

/**
 * __usePromotionDeleteByIdMutation__
 *
 * To run a mutation, you first call `usePromotionDeleteByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromotionDeleteByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promotionDeleteByIdMutation, { data, loading, error }] = usePromotionDeleteByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePromotionDeleteByIdMutation(baseOptions?: Apollo.MutationHookOptions<PromotionDeleteByIdMutation, PromotionDeleteByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromotionDeleteByIdMutation, PromotionDeleteByIdMutationVariables>(PromotionDeleteByIdDocument, options);
      }
export type PromotionDeleteByIdMutationHookResult = ReturnType<typeof usePromotionDeleteByIdMutation>;
export type PromotionDeleteByIdMutationResult = Apollo.MutationResult<PromotionDeleteByIdMutation>;
export type PromotionDeleteByIdMutationOptions = Apollo.BaseMutationOptions<PromotionDeleteByIdMutation, PromotionDeleteByIdMutationVariables>;
export const PromotionDisconnectOrganizationDocument = gql`
    mutation PromotionDisconnectOrganization($promotionId: MongoID!, $organizationId: MongoID!) {
  promotionDisconnectOrganization(
    promotionId: $promotionId
    organizationId: $organizationId
  ) {
    record {
      ...PromotionFragment
    }
  }
}
    ${PromotionFragmentFragmentDoc}`;
export type PromotionDisconnectOrganizationMutationFn = Apollo.MutationFunction<PromotionDisconnectOrganizationMutation, PromotionDisconnectOrganizationMutationVariables>;

/**
 * __usePromotionDisconnectOrganizationMutation__
 *
 * To run a mutation, you first call `usePromotionDisconnectOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromotionDisconnectOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promotionDisconnectOrganizationMutation, { data, loading, error }] = usePromotionDisconnectOrganizationMutation({
 *   variables: {
 *      promotionId: // value for 'promotionId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function usePromotionDisconnectOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<PromotionDisconnectOrganizationMutation, PromotionDisconnectOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromotionDisconnectOrganizationMutation, PromotionDisconnectOrganizationMutationVariables>(PromotionDisconnectOrganizationDocument, options);
      }
export type PromotionDisconnectOrganizationMutationHookResult = ReturnType<typeof usePromotionDisconnectOrganizationMutation>;
export type PromotionDisconnectOrganizationMutationResult = Apollo.MutationResult<PromotionDisconnectOrganizationMutation>;
export type PromotionDisconnectOrganizationMutationOptions = Apollo.BaseMutationOptions<PromotionDisconnectOrganizationMutation, PromotionDisconnectOrganizationMutationVariables>;
export const PromotionUpdateByIdDocument = gql`
    mutation PromotionUpdateById($id: MongoID!, $record: UpdateByIdPromotionInput!, $imagesToKeep: [String], $isSubmitting: Boolean, $setStatus: EnumPromotionAccessOperatorStatus, $setOrganizationTags: [MongoID]) {
  promotionUpdateById(
    _id: $id
    record: $record
    imagesToKeep: $imagesToKeep
    isSubmitting: $isSubmitting
    setStatus: $setStatus
    setOrganizationTags: $setOrganizationTags
  ) {
    record {
      ...PromotionFragment
    }
  }
}
    ${PromotionFragmentFragmentDoc}`;
export type PromotionUpdateByIdMutationFn = Apollo.MutationFunction<PromotionUpdateByIdMutation, PromotionUpdateByIdMutationVariables>;

/**
 * __usePromotionUpdateByIdMutation__
 *
 * To run a mutation, you first call `usePromotionUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromotionUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promotionUpdateByIdMutation, { data, loading, error }] = usePromotionUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *      imagesToKeep: // value for 'imagesToKeep'
 *      isSubmitting: // value for 'isSubmitting'
 *      setStatus: // value for 'setStatus'
 *      setOrganizationTags: // value for 'setOrganizationTags'
 *   },
 * });
 */
export function usePromotionUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<PromotionUpdateByIdMutation, PromotionUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromotionUpdateByIdMutation, PromotionUpdateByIdMutationVariables>(PromotionUpdateByIdDocument, options);
      }
export type PromotionUpdateByIdMutationHookResult = ReturnType<typeof usePromotionUpdateByIdMutation>;
export type PromotionUpdateByIdMutationResult = Apollo.MutationResult<PromotionUpdateByIdMutation>;
export type PromotionUpdateByIdMutationOptions = Apollo.BaseMutationOptions<PromotionUpdateByIdMutation, PromotionUpdateByIdMutationVariables>;
export const PublicMediaCreateFromOrgUploadDocument = gql`
    mutation PublicMediaCreateFromOrgUpload($organizationId: MongoID, $mediaType: String!, $assetId: String, $muxAssetId: String, $muxPlaybackId: String, $width: Int, $height: Int, $blurhash: String, $posterUrl: String, $copyright: String, $relatedListings: [MongoID!], $mediaTags: [MongoID!]) {
  publicMediaCreateFromOrgUpload(
    organizationId: $organizationId
    mediaType: $mediaType
    assetId: $assetId
    muxAssetId: $muxAssetId
    muxPlaybackId: $muxPlaybackId
    width: $width
    height: $height
    blurhash: $blurhash
    posterUrl: $posterUrl
    copyright: $copyright
    relatedListings: $relatedListings
    mediaTags: $mediaTags
  ) {
    _id
    mediaType
    status
    asset
    width
    height
    posterUrl
    mux {
      assetId
      playbackId
    }
  }
}
    `;
export type PublicMediaCreateFromOrgUploadMutationFn = Apollo.MutationFunction<PublicMediaCreateFromOrgUploadMutation, PublicMediaCreateFromOrgUploadMutationVariables>;

/**
 * __usePublicMediaCreateFromOrgUploadMutation__
 *
 * To run a mutation, you first call `usePublicMediaCreateFromOrgUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicMediaCreateFromOrgUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicMediaCreateFromOrgUploadMutation, { data, loading, error }] = usePublicMediaCreateFromOrgUploadMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      mediaType: // value for 'mediaType'
 *      assetId: // value for 'assetId'
 *      muxAssetId: // value for 'muxAssetId'
 *      muxPlaybackId: // value for 'muxPlaybackId'
 *      width: // value for 'width'
 *      height: // value for 'height'
 *      blurhash: // value for 'blurhash'
 *      posterUrl: // value for 'posterUrl'
 *      copyright: // value for 'copyright'
 *      relatedListings: // value for 'relatedListings'
 *      mediaTags: // value for 'mediaTags'
 *   },
 * });
 */
export function usePublicMediaCreateFromOrgUploadMutation(baseOptions?: Apollo.MutationHookOptions<PublicMediaCreateFromOrgUploadMutation, PublicMediaCreateFromOrgUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublicMediaCreateFromOrgUploadMutation, PublicMediaCreateFromOrgUploadMutationVariables>(PublicMediaCreateFromOrgUploadDocument, options);
      }
export type PublicMediaCreateFromOrgUploadMutationHookResult = ReturnType<typeof usePublicMediaCreateFromOrgUploadMutation>;
export type PublicMediaCreateFromOrgUploadMutationResult = Apollo.MutationResult<PublicMediaCreateFromOrgUploadMutation>;
export type PublicMediaCreateFromOrgUploadMutationOptions = Apollo.BaseMutationOptions<PublicMediaCreateFromOrgUploadMutation, PublicMediaCreateFromOrgUploadMutationVariables>;
export const PublicMediaIgnoreAttentionDocument = gql`
    mutation PublicMediaIgnoreAttention($_id: MongoID!) {
  publicMediaIgnoreAttention(_id: $_id) {
    _id
    attention {
      ignoredAt
      issues {
        flag
        listingId
        listingName
        flaggedAt
      }
    }
  }
}
    `;
export type PublicMediaIgnoreAttentionMutationFn = Apollo.MutationFunction<PublicMediaIgnoreAttentionMutation, PublicMediaIgnoreAttentionMutationVariables>;

/**
 * __usePublicMediaIgnoreAttentionMutation__
 *
 * To run a mutation, you first call `usePublicMediaIgnoreAttentionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicMediaIgnoreAttentionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicMediaIgnoreAttentionMutation, { data, loading, error }] = usePublicMediaIgnoreAttentionMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePublicMediaIgnoreAttentionMutation(baseOptions?: Apollo.MutationHookOptions<PublicMediaIgnoreAttentionMutation, PublicMediaIgnoreAttentionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublicMediaIgnoreAttentionMutation, PublicMediaIgnoreAttentionMutationVariables>(PublicMediaIgnoreAttentionDocument, options);
      }
export type PublicMediaIgnoreAttentionMutationHookResult = ReturnType<typeof usePublicMediaIgnoreAttentionMutation>;
export type PublicMediaIgnoreAttentionMutationResult = Apollo.MutationResult<PublicMediaIgnoreAttentionMutation>;
export type PublicMediaIgnoreAttentionMutationOptions = Apollo.BaseMutationOptions<PublicMediaIgnoreAttentionMutation, PublicMediaIgnoreAttentionMutationVariables>;
export const PublicMediaLikeToggleDocument = gql`
    mutation PublicMediaLikeToggle($_id: MongoID!, $organizationId: MongoID!, $like: Boolean!) {
  publicMediaLikeToggle(_id: $_id, organizationId: $organizationId, like: $like) {
    _id
    likeCount
  }
}
    `;
export type PublicMediaLikeToggleMutationFn = Apollo.MutationFunction<PublicMediaLikeToggleMutation, PublicMediaLikeToggleMutationVariables>;

/**
 * __usePublicMediaLikeToggleMutation__
 *
 * To run a mutation, you first call `usePublicMediaLikeToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicMediaLikeToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicMediaLikeToggleMutation, { data, loading, error }] = usePublicMediaLikeToggleMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      organizationId: // value for 'organizationId'
 *      like: // value for 'like'
 *   },
 * });
 */
export function usePublicMediaLikeToggleMutation(baseOptions?: Apollo.MutationHookOptions<PublicMediaLikeToggleMutation, PublicMediaLikeToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublicMediaLikeToggleMutation, PublicMediaLikeToggleMutationVariables>(PublicMediaLikeToggleDocument, options);
      }
export type PublicMediaLikeToggleMutationHookResult = ReturnType<typeof usePublicMediaLikeToggleMutation>;
export type PublicMediaLikeToggleMutationResult = Apollo.MutationResult<PublicMediaLikeToggleMutation>;
export type PublicMediaLikeToggleMutationOptions = Apollo.BaseMutationOptions<PublicMediaLikeToggleMutation, PublicMediaLikeToggleMutationVariables>;
export const PublicMediaPromoteManyFromListingDocument = gql`
    mutation PublicMediaPromoteManyFromListing($organizationId: MongoID, $selections: [PublicMediaListingSelectionInput!]!) {
  publicMediaPromoteManyFromListing(
    organizationId: $organizationId
    selections: $selections
  ) {
    _id
    mediaType
    status
    asset
    posterUrl
    source {
      kind
      listingId
      originalAssetId
    }
  }
}
    `;
export type PublicMediaPromoteManyFromListingMutationFn = Apollo.MutationFunction<PublicMediaPromoteManyFromListingMutation, PublicMediaPromoteManyFromListingMutationVariables>;

/**
 * __usePublicMediaPromoteManyFromListingMutation__
 *
 * To run a mutation, you first call `usePublicMediaPromoteManyFromListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicMediaPromoteManyFromListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicMediaPromoteManyFromListingMutation, { data, loading, error }] = usePublicMediaPromoteManyFromListingMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      selections: // value for 'selections'
 *   },
 * });
 */
export function usePublicMediaPromoteManyFromListingMutation(baseOptions?: Apollo.MutationHookOptions<PublicMediaPromoteManyFromListingMutation, PublicMediaPromoteManyFromListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublicMediaPromoteManyFromListingMutation, PublicMediaPromoteManyFromListingMutationVariables>(PublicMediaPromoteManyFromListingDocument, options);
      }
export type PublicMediaPromoteManyFromListingMutationHookResult = ReturnType<typeof usePublicMediaPromoteManyFromListingMutation>;
export type PublicMediaPromoteManyFromListingMutationResult = Apollo.MutationResult<PublicMediaPromoteManyFromListingMutation>;
export type PublicMediaPromoteManyFromListingMutationOptions = Apollo.BaseMutationOptions<PublicMediaPromoteManyFromListingMutation, PublicMediaPromoteManyFromListingMutationVariables>;
export const PublicMediaUnpublishDocument = gql`
    mutation PublicMediaUnpublish($_id: MongoID!) {
  publicMediaUnpublish(_id: $_id) {
    _id
    status
    attention {
      ignoredAt
      issues {
        flag
        listingId
        listingName
      }
    }
  }
}
    `;
export type PublicMediaUnpublishMutationFn = Apollo.MutationFunction<PublicMediaUnpublishMutation, PublicMediaUnpublishMutationVariables>;

/**
 * __usePublicMediaUnpublishMutation__
 *
 * To run a mutation, you first call `usePublicMediaUnpublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicMediaUnpublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicMediaUnpublishMutation, { data, loading, error }] = usePublicMediaUnpublishMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePublicMediaUnpublishMutation(baseOptions?: Apollo.MutationHookOptions<PublicMediaUnpublishMutation, PublicMediaUnpublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublicMediaUnpublishMutation, PublicMediaUnpublishMutationVariables>(PublicMediaUnpublishDocument, options);
      }
export type PublicMediaUnpublishMutationHookResult = ReturnType<typeof usePublicMediaUnpublishMutation>;
export type PublicMediaUnpublishMutationResult = Apollo.MutationResult<PublicMediaUnpublishMutation>;
export type PublicMediaUnpublishMutationOptions = Apollo.BaseMutationOptions<PublicMediaUnpublishMutation, PublicMediaUnpublishMutationVariables>;
export const PublicMediaUpdateByIdDocument = gql`
    mutation PublicMediaUpdateById($_id: MongoID!, $headline: MultilingualInput, $caption: MultilingualInput, $ctaLink: String, $copyright: String, $mediaTags: [MongoID!], $relatedListings: [MongoID!], $status: String, $carouselThumbnailAsset: String, $useCarouselThumbnail: Boolean) {
  publicMediaUpdateById(
    _id: $_id
    headline: $headline
    caption: $caption
    ctaLink: $ctaLink
    copyright: $copyright
    mediaTags: $mediaTags
    relatedListings: $relatedListings
    status: $status
    carouselThumbnailAsset: $carouselThumbnailAsset
    useCarouselThumbnail: $useCarouselThumbnail
  ) {
    _id
    mediaType
    status
    ctaLink
    copyright
    mediaTags
    relatedListings
    carouselThumbnailAsset
    useCarouselThumbnail
    headline {
      en
      es
      fr
    }
    caption {
      en
      es
      fr
    }
  }
}
    `;
export type PublicMediaUpdateByIdMutationFn = Apollo.MutationFunction<PublicMediaUpdateByIdMutation, PublicMediaUpdateByIdMutationVariables>;

/**
 * __usePublicMediaUpdateByIdMutation__
 *
 * To run a mutation, you first call `usePublicMediaUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicMediaUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicMediaUpdateByIdMutation, { data, loading, error }] = usePublicMediaUpdateByIdMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      headline: // value for 'headline'
 *      caption: // value for 'caption'
 *      ctaLink: // value for 'ctaLink'
 *      copyright: // value for 'copyright'
 *      mediaTags: // value for 'mediaTags'
 *      relatedListings: // value for 'relatedListings'
 *      status: // value for 'status'
 *      carouselThumbnailAsset: // value for 'carouselThumbnailAsset'
 *      useCarouselThumbnail: // value for 'useCarouselThumbnail'
 *   },
 * });
 */
export function usePublicMediaUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<PublicMediaUpdateByIdMutation, PublicMediaUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublicMediaUpdateByIdMutation, PublicMediaUpdateByIdMutationVariables>(PublicMediaUpdateByIdDocument, options);
      }
export type PublicMediaUpdateByIdMutationHookResult = ReturnType<typeof usePublicMediaUpdateByIdMutation>;
export type PublicMediaUpdateByIdMutationResult = Apollo.MutationResult<PublicMediaUpdateByIdMutation>;
export type PublicMediaUpdateByIdMutationOptions = Apollo.BaseMutationOptions<PublicMediaUpdateByIdMutation, PublicMediaUpdateByIdMutationVariables>;
export const RefundCreateDocument = gql`
    mutation RefundCreate($orderId: String!, $amount: Int!, $sendEmail: Boolean) {
  refundCreate(orderId: $orderId, amount: $amount, sendEmail: $sendEmail) {
    records {
      _id
      amount
      createdDateISO
      orderId
      status
      updatedDateISO
    }
  }
}
    `;
export type RefundCreateMutationFn = Apollo.MutationFunction<RefundCreateMutation, RefundCreateMutationVariables>;

/**
 * __useRefundCreateMutation__
 *
 * To run a mutation, you first call `useRefundCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundCreateMutation, { data, loading, error }] = useRefundCreateMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      amount: // value for 'amount'
 *      sendEmail: // value for 'sendEmail'
 *   },
 * });
 */
export function useRefundCreateMutation(baseOptions?: Apollo.MutationHookOptions<RefundCreateMutation, RefundCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefundCreateMutation, RefundCreateMutationVariables>(RefundCreateDocument, options);
      }
export type RefundCreateMutationHookResult = ReturnType<typeof useRefundCreateMutation>;
export type RefundCreateMutationResult = Apollo.MutationResult<RefundCreateMutation>;
export type RefundCreateMutationOptions = Apollo.BaseMutationOptions<RefundCreateMutation, RefundCreateMutationVariables>;
export const RenewableFeeConfirmDocument = gql`
    mutation RenewableFeeConfirm($renewablePurchaseId: MongoID!, $paymentIntentId: String!) {
  renewableFeeConfirm(
    renewablePurchaseId: $renewablePurchaseId
    paymentIntentId: $paymentIntentId
  ) {
    success
    renewablePurchaseId
    status
  }
}
    `;
export type RenewableFeeConfirmMutationFn = Apollo.MutationFunction<RenewableFeeConfirmMutation, RenewableFeeConfirmMutationVariables>;

/**
 * __useRenewableFeeConfirmMutation__
 *
 * To run a mutation, you first call `useRenewableFeeConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewableFeeConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewableFeeConfirmMutation, { data, loading, error }] = useRenewableFeeConfirmMutation({
 *   variables: {
 *      renewablePurchaseId: // value for 'renewablePurchaseId'
 *      paymentIntentId: // value for 'paymentIntentId'
 *   },
 * });
 */
export function useRenewableFeeConfirmMutation(baseOptions?: Apollo.MutationHookOptions<RenewableFeeConfirmMutation, RenewableFeeConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewableFeeConfirmMutation, RenewableFeeConfirmMutationVariables>(RenewableFeeConfirmDocument, options);
      }
export type RenewableFeeConfirmMutationHookResult = ReturnType<typeof useRenewableFeeConfirmMutation>;
export type RenewableFeeConfirmMutationResult = Apollo.MutationResult<RenewableFeeConfirmMutation>;
export type RenewableFeeConfirmMutationOptions = Apollo.BaseMutationOptions<RenewableFeeConfirmMutation, RenewableFeeConfirmMutationVariables>;
export const RenewableFeeInitiateDocument = gql`
    mutation RenewableFeeInitiate($bookerId: MongoID!, $productId: MongoID!, $tierId: String, $customer: RenewableFeeCustomerInput!, $organizationId: MongoID!, $paymentMethod: String, $promoCode: String, $taxExemption: RenewableFeeTaxExemptionInput, $autoRenewOptIn: Boolean) {
  renewableFeeInitiate(
    bookerId: $bookerId
    productId: $productId
    tierId: $tierId
    customer: $customer
    organizationId: $organizationId
    paymentMethod: $paymentMethod
    promoCode: $promoCode
    taxExemption: $taxExemption
    autoRenewOptIn: $autoRenewOptIn
  ) {
    clientSecret
    orderId
    renewablePurchaseId
    paymentIntentId
  }
}
    `;
export type RenewableFeeInitiateMutationFn = Apollo.MutationFunction<RenewableFeeInitiateMutation, RenewableFeeInitiateMutationVariables>;

/**
 * __useRenewableFeeInitiateMutation__
 *
 * To run a mutation, you first call `useRenewableFeeInitiateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewableFeeInitiateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewableFeeInitiateMutation, { data, loading, error }] = useRenewableFeeInitiateMutation({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      productId: // value for 'productId'
 *      tierId: // value for 'tierId'
 *      customer: // value for 'customer'
 *      organizationId: // value for 'organizationId'
 *      paymentMethod: // value for 'paymentMethod'
 *      promoCode: // value for 'promoCode'
 *      taxExemption: // value for 'taxExemption'
 *      autoRenewOptIn: // value for 'autoRenewOptIn'
 *   },
 * });
 */
export function useRenewableFeeInitiateMutation(baseOptions?: Apollo.MutationHookOptions<RenewableFeeInitiateMutation, RenewableFeeInitiateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewableFeeInitiateMutation, RenewableFeeInitiateMutationVariables>(RenewableFeeInitiateDocument, options);
      }
export type RenewableFeeInitiateMutationHookResult = ReturnType<typeof useRenewableFeeInitiateMutation>;
export type RenewableFeeInitiateMutationResult = Apollo.MutationResult<RenewableFeeInitiateMutation>;
export type RenewableFeeInitiateMutationOptions = Apollo.BaseMutationOptions<RenewableFeeInitiateMutation, RenewableFeeInitiateMutationVariables>;
export const RenewablePurchaseCancelDocument = gql`
    mutation RenewablePurchaseCancel($renewablePurchaseId: MongoID!) {
  renewablePurchaseCancel(renewablePurchaseId: $renewablePurchaseId) {
    _id
    status
    cancelledAt
    currentPeriodEnd
  }
}
    `;
export type RenewablePurchaseCancelMutationFn = Apollo.MutationFunction<RenewablePurchaseCancelMutation, RenewablePurchaseCancelMutationVariables>;

/**
 * __useRenewablePurchaseCancelMutation__
 *
 * To run a mutation, you first call `useRenewablePurchaseCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewablePurchaseCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewablePurchaseCancelMutation, { data, loading, error }] = useRenewablePurchaseCancelMutation({
 *   variables: {
 *      renewablePurchaseId: // value for 'renewablePurchaseId'
 *   },
 * });
 */
export function useRenewablePurchaseCancelMutation(baseOptions?: Apollo.MutationHookOptions<RenewablePurchaseCancelMutation, RenewablePurchaseCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewablePurchaseCancelMutation, RenewablePurchaseCancelMutationVariables>(RenewablePurchaseCancelDocument, options);
      }
export type RenewablePurchaseCancelMutationHookResult = ReturnType<typeof useRenewablePurchaseCancelMutation>;
export type RenewablePurchaseCancelMutationResult = Apollo.MutationResult<RenewablePurchaseCancelMutation>;
export type RenewablePurchaseCancelMutationOptions = Apollo.BaseMutationOptions<RenewablePurchaseCancelMutation, RenewablePurchaseCancelMutationVariables>;
export const RenewablePurchaseSetRenewalBillingDocument = gql`
    mutation RenewablePurchaseSetRenewalBilling($renewablePurchaseId: MongoID!, $renewalBilling: EnumRenewablePurchaseRenewalBilling!) {
  renewablePurchaseSetRenewalBilling(
    renewablePurchaseId: $renewablePurchaseId
    renewalBilling: $renewalBilling
  ) {
    _id
    renewalBilling
  }
}
    `;
export type RenewablePurchaseSetRenewalBillingMutationFn = Apollo.MutationFunction<RenewablePurchaseSetRenewalBillingMutation, RenewablePurchaseSetRenewalBillingMutationVariables>;

/**
 * __useRenewablePurchaseSetRenewalBillingMutation__
 *
 * To run a mutation, you first call `useRenewablePurchaseSetRenewalBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewablePurchaseSetRenewalBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewablePurchaseSetRenewalBillingMutation, { data, loading, error }] = useRenewablePurchaseSetRenewalBillingMutation({
 *   variables: {
 *      renewablePurchaseId: // value for 'renewablePurchaseId'
 *      renewalBilling: // value for 'renewalBilling'
 *   },
 * });
 */
export function useRenewablePurchaseSetRenewalBillingMutation(baseOptions?: Apollo.MutationHookOptions<RenewablePurchaseSetRenewalBillingMutation, RenewablePurchaseSetRenewalBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewablePurchaseSetRenewalBillingMutation, RenewablePurchaseSetRenewalBillingMutationVariables>(RenewablePurchaseSetRenewalBillingDocument, options);
      }
export type RenewablePurchaseSetRenewalBillingMutationHookResult = ReturnType<typeof useRenewablePurchaseSetRenewalBillingMutation>;
export type RenewablePurchaseSetRenewalBillingMutationResult = Apollo.MutationResult<RenewablePurchaseSetRenewalBillingMutation>;
export type RenewablePurchaseSetRenewalBillingMutationOptions = Apollo.BaseMutationOptions<RenewablePurchaseSetRenewalBillingMutation, RenewablePurchaseSetRenewalBillingMutationVariables>;
export const RenewablePurchaseUpdateListingsDocument = gql`
    mutation RenewablePurchaseUpdateListings($renewablePurchaseId: MongoID!, $operatorIds: [MongoID!]!) {
  renewablePurchaseUpdateListings(
    renewablePurchaseId: $renewablePurchaseId
    operatorIds: $operatorIds
  ) {
    _id
    operatorIds
    pendingOperatorIds
  }
}
    `;
export type RenewablePurchaseUpdateListingsMutationFn = Apollo.MutationFunction<RenewablePurchaseUpdateListingsMutation, RenewablePurchaseUpdateListingsMutationVariables>;

/**
 * __useRenewablePurchaseUpdateListingsMutation__
 *
 * To run a mutation, you first call `useRenewablePurchaseUpdateListingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewablePurchaseUpdateListingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewablePurchaseUpdateListingsMutation, { data, loading, error }] = useRenewablePurchaseUpdateListingsMutation({
 *   variables: {
 *      renewablePurchaseId: // value for 'renewablePurchaseId'
 *      operatorIds: // value for 'operatorIds'
 *   },
 * });
 */
export function useRenewablePurchaseUpdateListingsMutation(baseOptions?: Apollo.MutationHookOptions<RenewablePurchaseUpdateListingsMutation, RenewablePurchaseUpdateListingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewablePurchaseUpdateListingsMutation, RenewablePurchaseUpdateListingsMutationVariables>(RenewablePurchaseUpdateListingsDocument, options);
      }
export type RenewablePurchaseUpdateListingsMutationHookResult = ReturnType<typeof useRenewablePurchaseUpdateListingsMutation>;
export type RenewablePurchaseUpdateListingsMutationResult = Apollo.MutationResult<RenewablePurchaseUpdateListingsMutation>;
export type RenewablePurchaseUpdateListingsMutationOptions = Apollo.BaseMutationOptions<RenewablePurchaseUpdateListingsMutation, RenewablePurchaseUpdateListingsMutationVariables>;
export const RenewalEngineEnableDocument = gql`
    mutation RenewalEngineEnable($organizationId: MongoID!, $activeTagId: MongoID, $renewingTagId: MongoID, $expiredTagId: MongoID) {
  renewalEngineEnable(
    organizationId: $organizationId
    activeTagId: $activeTagId
    renewingTagId: $renewingTagId
    expiredTagId: $expiredTagId
  ) {
    changed
    byRole {
      role
      count
    }
  }
}
    `;
export type RenewalEngineEnableMutationFn = Apollo.MutationFunction<RenewalEngineEnableMutation, RenewalEngineEnableMutationVariables>;

/**
 * __useRenewalEngineEnableMutation__
 *
 * To run a mutation, you first call `useRenewalEngineEnableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewalEngineEnableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewalEngineEnableMutation, { data, loading, error }] = useRenewalEngineEnableMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      activeTagId: // value for 'activeTagId'
 *      renewingTagId: // value for 'renewingTagId'
 *      expiredTagId: // value for 'expiredTagId'
 *   },
 * });
 */
export function useRenewalEngineEnableMutation(baseOptions?: Apollo.MutationHookOptions<RenewalEngineEnableMutation, RenewalEngineEnableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewalEngineEnableMutation, RenewalEngineEnableMutationVariables>(RenewalEngineEnableDocument, options);
      }
export type RenewalEngineEnableMutationHookResult = ReturnType<typeof useRenewalEngineEnableMutation>;
export type RenewalEngineEnableMutationResult = Apollo.MutationResult<RenewalEngineEnableMutation>;
export type RenewalEngineEnableMutationOptions = Apollo.BaseMutationOptions<RenewalEngineEnableMutation, RenewalEngineEnableMutationVariables>;
export const ReportRebuildDocument = gql`
    mutation ReportRebuild($storefrontId: MongoID!, $reportType: String!) {
  reportRebuild(storefrontId: $storefrontId, reportType: $reportType) {
    builtAt
    rowCount
  }
}
    `;
export type ReportRebuildMutationFn = Apollo.MutationFunction<ReportRebuildMutation, ReportRebuildMutationVariables>;

/**
 * __useReportRebuildMutation__
 *
 * To run a mutation, you first call `useReportRebuildMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportRebuildMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportRebuildMutation, { data, loading, error }] = useReportRebuildMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      reportType: // value for 'reportType'
 *   },
 * });
 */
export function useReportRebuildMutation(baseOptions?: Apollo.MutationHookOptions<ReportRebuildMutation, ReportRebuildMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportRebuildMutation, ReportRebuildMutationVariables>(ReportRebuildDocument, options);
      }
export type ReportRebuildMutationHookResult = ReturnType<typeof useReportRebuildMutation>;
export type ReportRebuildMutationResult = Apollo.MutationResult<ReportRebuildMutation>;
export type ReportRebuildMutationOptions = Apollo.BaseMutationOptions<ReportRebuildMutation, ReportRebuildMutationVariables>;
export const ResendBankTransferInstructionsDocument = gql`
    mutation ResendBankTransferInstructions($orderId: String!) {
  resendBankTransferInstructions(orderId: $orderId) {
    success
  }
}
    `;
export type ResendBankTransferInstructionsMutationFn = Apollo.MutationFunction<ResendBankTransferInstructionsMutation, ResendBankTransferInstructionsMutationVariables>;

/**
 * __useResendBankTransferInstructionsMutation__
 *
 * To run a mutation, you first call `useResendBankTransferInstructionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendBankTransferInstructionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendBankTransferInstructionsMutation, { data, loading, error }] = useResendBankTransferInstructionsMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useResendBankTransferInstructionsMutation(baseOptions?: Apollo.MutationHookOptions<ResendBankTransferInstructionsMutation, ResendBankTransferInstructionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendBankTransferInstructionsMutation, ResendBankTransferInstructionsMutationVariables>(ResendBankTransferInstructionsDocument, options);
      }
export type ResendBankTransferInstructionsMutationHookResult = ReturnType<typeof useResendBankTransferInstructionsMutation>;
export type ResendBankTransferInstructionsMutationResult = Apollo.MutationResult<ResendBankTransferInstructionsMutation>;
export type ResendBankTransferInstructionsMutationOptions = Apollo.BaseMutationOptions<ResendBankTransferInstructionsMutation, ResendBankTransferInstructionsMutationVariables>;
export const RuleCreateDocument = gql`
    mutation RuleCreate($record: CreateOneRuleInput!) {
  ruleCreate(record: $record) {
    record {
      _id
    }
  }
}
    `;
export type RuleCreateMutationFn = Apollo.MutationFunction<RuleCreateMutation, RuleCreateMutationVariables>;

/**
 * __useRuleCreateMutation__
 *
 * To run a mutation, you first call `useRuleCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRuleCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ruleCreateMutation, { data, loading, error }] = useRuleCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useRuleCreateMutation(baseOptions?: Apollo.MutationHookOptions<RuleCreateMutation, RuleCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RuleCreateMutation, RuleCreateMutationVariables>(RuleCreateDocument, options);
      }
export type RuleCreateMutationHookResult = ReturnType<typeof useRuleCreateMutation>;
export type RuleCreateMutationResult = Apollo.MutationResult<RuleCreateMutation>;
export type RuleCreateMutationOptions = Apollo.BaseMutationOptions<RuleCreateMutation, RuleCreateMutationVariables>;
export const RuleCreateManyDocument = gql`
    mutation RuleCreateMany($records: [CreateManyRuleInput!]!) {
  ruleCreateMany(records: $records) {
    records {
      _id
    }
  }
}
    `;
export type RuleCreateManyMutationFn = Apollo.MutationFunction<RuleCreateManyMutation, RuleCreateManyMutationVariables>;

/**
 * __useRuleCreateManyMutation__
 *
 * To run a mutation, you first call `useRuleCreateManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRuleCreateManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ruleCreateManyMutation, { data, loading, error }] = useRuleCreateManyMutation({
 *   variables: {
 *      records: // value for 'records'
 *   },
 * });
 */
export function useRuleCreateManyMutation(baseOptions?: Apollo.MutationHookOptions<RuleCreateManyMutation, RuleCreateManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RuleCreateManyMutation, RuleCreateManyMutationVariables>(RuleCreateManyDocument, options);
      }
export type RuleCreateManyMutationHookResult = ReturnType<typeof useRuleCreateManyMutation>;
export type RuleCreateManyMutationResult = Apollo.MutationResult<RuleCreateManyMutation>;
export type RuleCreateManyMutationOptions = Apollo.BaseMutationOptions<RuleCreateManyMutation, RuleCreateManyMutationVariables>;
export const RuleDeleteDocument = gql`
    mutation RuleDelete($id: MongoID!) {
  ruleDelete(_id: $id) {
    record {
      _id
    }
  }
}
    `;
export type RuleDeleteMutationFn = Apollo.MutationFunction<RuleDeleteMutation, RuleDeleteMutationVariables>;

/**
 * __useRuleDeleteMutation__
 *
 * To run a mutation, you first call `useRuleDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRuleDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ruleDeleteMutation, { data, loading, error }] = useRuleDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRuleDeleteMutation(baseOptions?: Apollo.MutationHookOptions<RuleDeleteMutation, RuleDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RuleDeleteMutation, RuleDeleteMutationVariables>(RuleDeleteDocument, options);
      }
export type RuleDeleteMutationHookResult = ReturnType<typeof useRuleDeleteMutation>;
export type RuleDeleteMutationResult = Apollo.MutationResult<RuleDeleteMutation>;
export type RuleDeleteMutationOptions = Apollo.BaseMutationOptions<RuleDeleteMutation, RuleDeleteMutationVariables>;
export const RuleUpdateDocument = gql`
    mutation RuleUpdate($id: MongoID!, $record: UpdateByIdRuleInput!) {
  ruleUpdate(_id: $id, record: $record) {
    record {
      _id
    }
  }
}
    `;
export type RuleUpdateMutationFn = Apollo.MutationFunction<RuleUpdateMutation, RuleUpdateMutationVariables>;

/**
 * __useRuleUpdateMutation__
 *
 * To run a mutation, you first call `useRuleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRuleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ruleUpdateMutation, { data, loading, error }] = useRuleUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useRuleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RuleUpdateMutation, RuleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RuleUpdateMutation, RuleUpdateMutationVariables>(RuleUpdateDocument, options);
      }
export type RuleUpdateMutationHookResult = ReturnType<typeof useRuleUpdateMutation>;
export type RuleUpdateMutationResult = Apollo.MutationResult<RuleUpdateMutation>;
export type RuleUpdateMutationOptions = Apollo.BaseMutationOptions<RuleUpdateMutation, RuleUpdateMutationVariables>;
export const SavedReportCreateDocument = gql`
    mutation SavedReportCreate($storefrontId: MongoID!, $input: SavedReportInput!) {
  savedReportCreate(storefrontId: $storefrontId, input: $input) {
    ...SavedReportFields
  }
}
    ${SavedReportFieldsFragmentDoc}`;
export type SavedReportCreateMutationFn = Apollo.MutationFunction<SavedReportCreateMutation, SavedReportCreateMutationVariables>;

/**
 * __useSavedReportCreateMutation__
 *
 * To run a mutation, you first call `useSavedReportCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavedReportCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savedReportCreateMutation, { data, loading, error }] = useSavedReportCreateMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavedReportCreateMutation(baseOptions?: Apollo.MutationHookOptions<SavedReportCreateMutation, SavedReportCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavedReportCreateMutation, SavedReportCreateMutationVariables>(SavedReportCreateDocument, options);
      }
export type SavedReportCreateMutationHookResult = ReturnType<typeof useSavedReportCreateMutation>;
export type SavedReportCreateMutationResult = Apollo.MutationResult<SavedReportCreateMutation>;
export type SavedReportCreateMutationOptions = Apollo.BaseMutationOptions<SavedReportCreateMutation, SavedReportCreateMutationVariables>;
export const SavedReportDeleteDocument = gql`
    mutation SavedReportDelete($storefrontId: MongoID!, $savedReportId: MongoID!) {
  savedReportDelete(storefrontId: $storefrontId, savedReportId: $savedReportId)
}
    `;
export type SavedReportDeleteMutationFn = Apollo.MutationFunction<SavedReportDeleteMutation, SavedReportDeleteMutationVariables>;

/**
 * __useSavedReportDeleteMutation__
 *
 * To run a mutation, you first call `useSavedReportDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavedReportDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savedReportDeleteMutation, { data, loading, error }] = useSavedReportDeleteMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      savedReportId: // value for 'savedReportId'
 *   },
 * });
 */
export function useSavedReportDeleteMutation(baseOptions?: Apollo.MutationHookOptions<SavedReportDeleteMutation, SavedReportDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavedReportDeleteMutation, SavedReportDeleteMutationVariables>(SavedReportDeleteDocument, options);
      }
export type SavedReportDeleteMutationHookResult = ReturnType<typeof useSavedReportDeleteMutation>;
export type SavedReportDeleteMutationResult = Apollo.MutationResult<SavedReportDeleteMutation>;
export type SavedReportDeleteMutationOptions = Apollo.BaseMutationOptions<SavedReportDeleteMutation, SavedReportDeleteMutationVariables>;
export const SavedReportUpdateDocument = gql`
    mutation SavedReportUpdate($storefrontId: MongoID!, $savedReportId: MongoID!, $input: SavedReportInput!) {
  savedReportUpdate(
    storefrontId: $storefrontId
    savedReportId: $savedReportId
    input: $input
  ) {
    ...SavedReportFields
  }
}
    ${SavedReportFieldsFragmentDoc}`;
export type SavedReportUpdateMutationFn = Apollo.MutationFunction<SavedReportUpdateMutation, SavedReportUpdateMutationVariables>;

/**
 * __useSavedReportUpdateMutation__
 *
 * To run a mutation, you first call `useSavedReportUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavedReportUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savedReportUpdateMutation, { data, loading, error }] = useSavedReportUpdateMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      savedReportId: // value for 'savedReportId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavedReportUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SavedReportUpdateMutation, SavedReportUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavedReportUpdateMutation, SavedReportUpdateMutationVariables>(SavedReportUpdateDocument, options);
      }
export type SavedReportUpdateMutationHookResult = ReturnType<typeof useSavedReportUpdateMutation>;
export type SavedReportUpdateMutationResult = Apollo.MutationResult<SavedReportUpdateMutation>;
export type SavedReportUpdateMutationOptions = Apollo.BaseMutationOptions<SavedReportUpdateMutation, SavedReportUpdateMutationVariables>;
export const ScheduledPaymentRetryFailedDocument = gql`
    mutation ScheduledPaymentRetryFailed($scheduledPaymentId: ID!, $orderId: ID!, $paymentMethodId: String!) {
  scheduledPaymentRetryFailed(
    scheduledPaymentId: $scheduledPaymentId
    orderId: $orderId
    paymentMethodId: $paymentMethodId
  ) {
    _id
    amount
    dueDate
    order
    status
    type
    stripeMetadata {
      connectedAccountId
    }
  }
}
    `;
export type ScheduledPaymentRetryFailedMutationFn = Apollo.MutationFunction<ScheduledPaymentRetryFailedMutation, ScheduledPaymentRetryFailedMutationVariables>;

/**
 * __useScheduledPaymentRetryFailedMutation__
 *
 * To run a mutation, you first call `useScheduledPaymentRetryFailedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduledPaymentRetryFailedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduledPaymentRetryFailedMutation, { data, loading, error }] = useScheduledPaymentRetryFailedMutation({
 *   variables: {
 *      scheduledPaymentId: // value for 'scheduledPaymentId'
 *      orderId: // value for 'orderId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useScheduledPaymentRetryFailedMutation(baseOptions?: Apollo.MutationHookOptions<ScheduledPaymentRetryFailedMutation, ScheduledPaymentRetryFailedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduledPaymentRetryFailedMutation, ScheduledPaymentRetryFailedMutationVariables>(ScheduledPaymentRetryFailedDocument, options);
      }
export type ScheduledPaymentRetryFailedMutationHookResult = ReturnType<typeof useScheduledPaymentRetryFailedMutation>;
export type ScheduledPaymentRetryFailedMutationResult = Apollo.MutationResult<ScheduledPaymentRetryFailedMutation>;
export type ScheduledPaymentRetryFailedMutationOptions = Apollo.BaseMutationOptions<ScheduledPaymentRetryFailedMutation, ScheduledPaymentRetryFailedMutationVariables>;
export const StorefrontConnectNewStripeAccountDocument = gql`
    mutation StorefrontConnectNewStripeAccount($storefrontId: ID!, $redirectUrl: String!, $bookerId: ID, $assignToUnassignedBookers: Boolean) {
  storefrontConnectNewStripeAccount(
    storefrontId: $storefrontId
    redirectUrl: $redirectUrl
    bookerId: $bookerId
    assignToUnassignedBookers: $assignToUnassignedBookers
  ) {
    link
    record {
      _id
    }
  }
}
    `;
export type StorefrontConnectNewStripeAccountMutationFn = Apollo.MutationFunction<StorefrontConnectNewStripeAccountMutation, StorefrontConnectNewStripeAccountMutationVariables>;

/**
 * __useStorefrontConnectNewStripeAccountMutation__
 *
 * To run a mutation, you first call `useStorefrontConnectNewStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontConnectNewStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontConnectNewStripeAccountMutation, { data, loading, error }] = useStorefrontConnectNewStripeAccountMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      redirectUrl: // value for 'redirectUrl'
 *      bookerId: // value for 'bookerId'
 *      assignToUnassignedBookers: // value for 'assignToUnassignedBookers'
 *   },
 * });
 */
export function useStorefrontConnectNewStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontConnectNewStripeAccountMutation, StorefrontConnectNewStripeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontConnectNewStripeAccountMutation, StorefrontConnectNewStripeAccountMutationVariables>(StorefrontConnectNewStripeAccountDocument, options);
      }
export type StorefrontConnectNewStripeAccountMutationHookResult = ReturnType<typeof useStorefrontConnectNewStripeAccountMutation>;
export type StorefrontConnectNewStripeAccountMutationResult = Apollo.MutationResult<StorefrontConnectNewStripeAccountMutation>;
export type StorefrontConnectNewStripeAccountMutationOptions = Apollo.BaseMutationOptions<StorefrontConnectNewStripeAccountMutation, StorefrontConnectNewStripeAccountMutationVariables>;
export const StorefrontCreateDocument = gql`
    mutation StorefrontCreate($record: CreateOneStorefrontInput!) {
  storefrontCreate(record: $record) {
    record {
      _id
      testMode
      name {
        en
        fr
        es
      }
    }
  }
}
    `;
export type StorefrontCreateMutationFn = Apollo.MutationFunction<StorefrontCreateMutation, StorefrontCreateMutationVariables>;

/**
 * __useStorefrontCreateMutation__
 *
 * To run a mutation, you first call `useStorefrontCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontCreateMutation, { data, loading, error }] = useStorefrontCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useStorefrontCreateMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontCreateMutation, StorefrontCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontCreateMutation, StorefrontCreateMutationVariables>(StorefrontCreateDocument, options);
      }
export type StorefrontCreateMutationHookResult = ReturnType<typeof useStorefrontCreateMutation>;
export type StorefrontCreateMutationResult = Apollo.MutationResult<StorefrontCreateMutation>;
export type StorefrontCreateMutationOptions = Apollo.BaseMutationOptions<StorefrontCreateMutation, StorefrontCreateMutationVariables>;
export const StorefrontDisconnectStripeAccountDocument = gql`
    mutation StorefrontDisconnectStripeAccount($storefrontId: ID!, $connectedAccountId: String!, $deleteFromStripe: Boolean) {
  storefrontDisconnectStripeAccount(
    storefrontId: $storefrontId
    connectedAccountId: $connectedAccountId
    deleteFromStripe: $deleteFromStripe
  ) {
    success
    blockingWidgetNames
    record {
      _id
      connectedAccountIds
    }
  }
}
    `;
export type StorefrontDisconnectStripeAccountMutationFn = Apollo.MutationFunction<StorefrontDisconnectStripeAccountMutation, StorefrontDisconnectStripeAccountMutationVariables>;

/**
 * __useStorefrontDisconnectStripeAccountMutation__
 *
 * To run a mutation, you first call `useStorefrontDisconnectStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontDisconnectStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontDisconnectStripeAccountMutation, { data, loading, error }] = useStorefrontDisconnectStripeAccountMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      connectedAccountId: // value for 'connectedAccountId'
 *      deleteFromStripe: // value for 'deleteFromStripe'
 *   },
 * });
 */
export function useStorefrontDisconnectStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontDisconnectStripeAccountMutation, StorefrontDisconnectStripeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontDisconnectStripeAccountMutation, StorefrontDisconnectStripeAccountMutationVariables>(StorefrontDisconnectStripeAccountDocument, options);
      }
export type StorefrontDisconnectStripeAccountMutationHookResult = ReturnType<typeof useStorefrontDisconnectStripeAccountMutation>;
export type StorefrontDisconnectStripeAccountMutationResult = Apollo.MutationResult<StorefrontDisconnectStripeAccountMutation>;
export type StorefrontDisconnectStripeAccountMutationOptions = Apollo.BaseMutationOptions<StorefrontDisconnectStripeAccountMutation, StorefrontDisconnectStripeAccountMutationVariables>;
export const StorefrontEnsureTestStorefrontDocument = gql`
    mutation StorefrontEnsureTestStorefront($storefrontId: MongoID!) {
  storefrontEnsureTestStorefront(storefrontId: $storefrontId) {
    created
    liveStorefront {
      _id
      testStorefront
    }
    testStorefront {
      _id
      liveStorefront
    }
  }
}
    `;
export type StorefrontEnsureTestStorefrontMutationFn = Apollo.MutationFunction<StorefrontEnsureTestStorefrontMutation, StorefrontEnsureTestStorefrontMutationVariables>;

/**
 * __useStorefrontEnsureTestStorefrontMutation__
 *
 * To run a mutation, you first call `useStorefrontEnsureTestStorefrontMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontEnsureTestStorefrontMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontEnsureTestStorefrontMutation, { data, loading, error }] = useStorefrontEnsureTestStorefrontMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *   },
 * });
 */
export function useStorefrontEnsureTestStorefrontMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontEnsureTestStorefrontMutation, StorefrontEnsureTestStorefrontMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontEnsureTestStorefrontMutation, StorefrontEnsureTestStorefrontMutationVariables>(StorefrontEnsureTestStorefrontDocument, options);
      }
export type StorefrontEnsureTestStorefrontMutationHookResult = ReturnType<typeof useStorefrontEnsureTestStorefrontMutation>;
export type StorefrontEnsureTestStorefrontMutationResult = Apollo.MutationResult<StorefrontEnsureTestStorefrontMutation>;
export type StorefrontEnsureTestStorefrontMutationOptions = Apollo.BaseMutationOptions<StorefrontEnsureTestStorefrontMutation, StorefrontEnsureTestStorefrontMutationVariables>;
export const StorefrontFastForwardRenewalsDocument = gql`
    mutation StorefrontFastForwardRenewals($storefrontId: ID!, $days: Int) {
  storefrontFastForwardRenewals(storefrontId: $storefrontId, days: $days) {
    purchasesAdvanced
    recordsCreated
    autoChargesProcessed
    invoicesProcessed
    log {
      timestamp
      event
      detail
    }
  }
}
    `;
export type StorefrontFastForwardRenewalsMutationFn = Apollo.MutationFunction<StorefrontFastForwardRenewalsMutation, StorefrontFastForwardRenewalsMutationVariables>;

/**
 * __useStorefrontFastForwardRenewalsMutation__
 *
 * To run a mutation, you first call `useStorefrontFastForwardRenewalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontFastForwardRenewalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontFastForwardRenewalsMutation, { data, loading, error }] = useStorefrontFastForwardRenewalsMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useStorefrontFastForwardRenewalsMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontFastForwardRenewalsMutation, StorefrontFastForwardRenewalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontFastForwardRenewalsMutation, StorefrontFastForwardRenewalsMutationVariables>(StorefrontFastForwardRenewalsDocument, options);
      }
export type StorefrontFastForwardRenewalsMutationHookResult = ReturnType<typeof useStorefrontFastForwardRenewalsMutation>;
export type StorefrontFastForwardRenewalsMutationResult = Apollo.MutationResult<StorefrontFastForwardRenewalsMutation>;
export type StorefrontFastForwardRenewalsMutationOptions = Apollo.BaseMutationOptions<StorefrontFastForwardRenewalsMutation, StorefrontFastForwardRenewalsMutationVariables>;
export const StorefrontForceRenewalsDocument = gql`
    mutation StorefrontForceRenewals($storefrontId: ID!) {
  storefrontForceRenewals(storefrontId: $storefrontId) {
    processedCount
    recordsCreated
    autoChargesProcessed
    invoicesProcessed
  }
}
    `;
export type StorefrontForceRenewalsMutationFn = Apollo.MutationFunction<StorefrontForceRenewalsMutation, StorefrontForceRenewalsMutationVariables>;

/**
 * __useStorefrontForceRenewalsMutation__
 *
 * To run a mutation, you first call `useStorefrontForceRenewalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontForceRenewalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontForceRenewalsMutation, { data, loading, error }] = useStorefrontForceRenewalsMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *   },
 * });
 */
export function useStorefrontForceRenewalsMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontForceRenewalsMutation, StorefrontForceRenewalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontForceRenewalsMutation, StorefrontForceRenewalsMutationVariables>(StorefrontForceRenewalsDocument, options);
      }
export type StorefrontForceRenewalsMutationHookResult = ReturnType<typeof useStorefrontForceRenewalsMutation>;
export type StorefrontForceRenewalsMutationResult = Apollo.MutationResult<StorefrontForceRenewalsMutation>;
export type StorefrontForceRenewalsMutationOptions = Apollo.BaseMutationOptions<StorefrontForceRenewalsMutation, StorefrontForceRenewalsMutationVariables>;
export const StorefrontGenerateStatementsDocument = gql`
    mutation StorefrontGenerateStatements($storefrontId: MongoID!, $period: String!) {
  storefrontGenerateStatements(storefrontId: $storefrontId, period: $period) {
    _id
    period
    status
    createdByName
    statementCount
    grandTotalSum
    currency
    createdDateISO
    rolledBackAt
    rolledBackByName
    items {
      paymentRequestId
      invoiceNumber
      customerName
      orderIds
      grandTotal
      rollbackStatus
    }
  }
}
    `;
export type StorefrontGenerateStatementsMutationFn = Apollo.MutationFunction<StorefrontGenerateStatementsMutation, StorefrontGenerateStatementsMutationVariables>;

/**
 * __useStorefrontGenerateStatementsMutation__
 *
 * To run a mutation, you first call `useStorefrontGenerateStatementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontGenerateStatementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontGenerateStatementsMutation, { data, loading, error }] = useStorefrontGenerateStatementsMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useStorefrontGenerateStatementsMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontGenerateStatementsMutation, StorefrontGenerateStatementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontGenerateStatementsMutation, StorefrontGenerateStatementsMutationVariables>(StorefrontGenerateStatementsDocument, options);
      }
export type StorefrontGenerateStatementsMutationHookResult = ReturnType<typeof useStorefrontGenerateStatementsMutation>;
export type StorefrontGenerateStatementsMutationResult = Apollo.MutationResult<StorefrontGenerateStatementsMutation>;
export type StorefrontGenerateStatementsMutationOptions = Apollo.BaseMutationOptions<StorefrontGenerateStatementsMutation, StorefrontGenerateStatementsMutationVariables>;
export const StorefrontLaunchDocument = gql`
    mutation StorefrontLaunch($liveStorefrontId: MongoID!, $bookerIds: [MongoID!], $freeOnly: Boolean) {
  storefrontLaunch(
    liveStorefrontId: $liveStorefrontId
    bookerIds: $bookerIds
    freeOnly: $freeOnly
  ) {
    liveStorefront {
      _id
      isLaunched
      launchedAt
      paymentsMode
    }
    copied {
      sourceBookerId
      bookerId
    }
    skipped
    failed {
      sourceBookerId
      message
    }
  }
}
    `;
export type StorefrontLaunchMutationFn = Apollo.MutationFunction<StorefrontLaunchMutation, StorefrontLaunchMutationVariables>;

/**
 * __useStorefrontLaunchMutation__
 *
 * To run a mutation, you first call `useStorefrontLaunchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontLaunchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontLaunchMutation, { data, loading, error }] = useStorefrontLaunchMutation({
 *   variables: {
 *      liveStorefrontId: // value for 'liveStorefrontId'
 *      bookerIds: // value for 'bookerIds'
 *      freeOnly: // value for 'freeOnly'
 *   },
 * });
 */
export function useStorefrontLaunchMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontLaunchMutation, StorefrontLaunchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontLaunchMutation, StorefrontLaunchMutationVariables>(StorefrontLaunchDocument, options);
      }
export type StorefrontLaunchMutationHookResult = ReturnType<typeof useStorefrontLaunchMutation>;
export type StorefrontLaunchMutationResult = Apollo.MutationResult<StorefrontLaunchMutation>;
export type StorefrontLaunchMutationOptions = Apollo.BaseMutationOptions<StorefrontLaunchMutation, StorefrontLaunchMutationVariables>;
export const StorefrontPageCreateDocument = gql`
    mutation StorefrontPageCreate($storefrontId: MongoID!, $bookerId: MongoID!, $type: String!, $slug: String) {
  storefrontPageCreate(
    storefrontId: $storefrontId
    bookerId: $bookerId
    type: $type
    slug: $slug
  ) {
    _id
    storefront
    booker
    type
    slug
    generatedPageHtml
    pageGeneratedAt
    editPromptHistory
    status
    pageUrl
    createdDateISO
    updatedDateISO
  }
}
    `;
export type StorefrontPageCreateMutationFn = Apollo.MutationFunction<StorefrontPageCreateMutation, StorefrontPageCreateMutationVariables>;

/**
 * __useStorefrontPageCreateMutation__
 *
 * To run a mutation, you first call `useStorefrontPageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontPageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontPageCreateMutation, { data, loading, error }] = useStorefrontPageCreateMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      bookerId: // value for 'bookerId'
 *      type: // value for 'type'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useStorefrontPageCreateMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontPageCreateMutation, StorefrontPageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontPageCreateMutation, StorefrontPageCreateMutationVariables>(StorefrontPageCreateDocument, options);
      }
export type StorefrontPageCreateMutationHookResult = ReturnType<typeof useStorefrontPageCreateMutation>;
export type StorefrontPageCreateMutationResult = Apollo.MutationResult<StorefrontPageCreateMutation>;
export type StorefrontPageCreateMutationOptions = Apollo.BaseMutationOptions<StorefrontPageCreateMutation, StorefrontPageCreateMutationVariables>;
export const StorefrontPageDeleteDocument = gql`
    mutation StorefrontPageDelete($pageId: MongoID!) {
  storefrontPageDelete(pageId: $pageId) {
    _id
    slug
  }
}
    `;
export type StorefrontPageDeleteMutationFn = Apollo.MutationFunction<StorefrontPageDeleteMutation, StorefrontPageDeleteMutationVariables>;

/**
 * __useStorefrontPageDeleteMutation__
 *
 * To run a mutation, you first call `useStorefrontPageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontPageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontPageDeleteMutation, { data, loading, error }] = useStorefrontPageDeleteMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useStorefrontPageDeleteMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontPageDeleteMutation, StorefrontPageDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontPageDeleteMutation, StorefrontPageDeleteMutationVariables>(StorefrontPageDeleteDocument, options);
      }
export type StorefrontPageDeleteMutationHookResult = ReturnType<typeof useStorefrontPageDeleteMutation>;
export type StorefrontPageDeleteMutationResult = Apollo.MutationResult<StorefrontPageDeleteMutation>;
export type StorefrontPageDeleteMutationOptions = Apollo.BaseMutationOptions<StorefrontPageDeleteMutation, StorefrontPageDeleteMutationVariables>;
export const StorefrontPageEditDocument = gql`
    mutation StorefrontPageEdit($pageId: MongoID!, $prompt: String!) {
  storefrontPageEdit(pageId: $pageId, prompt: $prompt) {
    _id
    storefront
    booker
    type
    slug
    generatedPageHtml
    pageGeneratedAt
    editPromptHistory
    status
    pageUrl
    createdDateISO
    updatedDateISO
  }
}
    `;
export type StorefrontPageEditMutationFn = Apollo.MutationFunction<StorefrontPageEditMutation, StorefrontPageEditMutationVariables>;

/**
 * __useStorefrontPageEditMutation__
 *
 * To run a mutation, you first call `useStorefrontPageEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontPageEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontPageEditMutation, { data, loading, error }] = useStorefrontPageEditMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      prompt: // value for 'prompt'
 *   },
 * });
 */
export function useStorefrontPageEditMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontPageEditMutation, StorefrontPageEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontPageEditMutation, StorefrontPageEditMutationVariables>(StorefrontPageEditDocument, options);
      }
export type StorefrontPageEditMutationHookResult = ReturnType<typeof useStorefrontPageEditMutation>;
export type StorefrontPageEditMutationResult = Apollo.MutationResult<StorefrontPageEditMutation>;
export type StorefrontPageEditMutationOptions = Apollo.BaseMutationOptions<StorefrontPageEditMutation, StorefrontPageEditMutationVariables>;
export const StorefrontPageGenerateDocument = gql`
    mutation StorefrontPageGenerate($pageId: MongoID!) {
  storefrontPageGenerate(pageId: $pageId) {
    _id
    storefront
    booker
    type
    slug
    generatedPageHtml
    pageGeneratedAt
    editPromptHistory
    status
    pageUrl
    createdDateISO
    updatedDateISO
  }
}
    `;
export type StorefrontPageGenerateMutationFn = Apollo.MutationFunction<StorefrontPageGenerateMutation, StorefrontPageGenerateMutationVariables>;

/**
 * __useStorefrontPageGenerateMutation__
 *
 * To run a mutation, you first call `useStorefrontPageGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontPageGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontPageGenerateMutation, { data, loading, error }] = useStorefrontPageGenerateMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useStorefrontPageGenerateMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontPageGenerateMutation, StorefrontPageGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontPageGenerateMutation, StorefrontPageGenerateMutationVariables>(StorefrontPageGenerateDocument, options);
      }
export type StorefrontPageGenerateMutationHookResult = ReturnType<typeof useStorefrontPageGenerateMutation>;
export type StorefrontPageGenerateMutationResult = Apollo.MutationResult<StorefrontPageGenerateMutation>;
export type StorefrontPageGenerateMutationOptions = Apollo.BaseMutationOptions<StorefrontPageGenerateMutation, StorefrontPageGenerateMutationVariables>;
export const StorefrontPageUpdateStatusDocument = gql`
    mutation StorefrontPageUpdateStatus($pageId: MongoID!, $status: String!) {
  storefrontPageUpdateStatus(pageId: $pageId, status: $status) {
    _id
    status
    pageUrl
  }
}
    `;
export type StorefrontPageUpdateStatusMutationFn = Apollo.MutationFunction<StorefrontPageUpdateStatusMutation, StorefrontPageUpdateStatusMutationVariables>;

/**
 * __useStorefrontPageUpdateStatusMutation__
 *
 * To run a mutation, you first call `useStorefrontPageUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontPageUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontPageUpdateStatusMutation, { data, loading, error }] = useStorefrontPageUpdateStatusMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useStorefrontPageUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontPageUpdateStatusMutation, StorefrontPageUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontPageUpdateStatusMutation, StorefrontPageUpdateStatusMutationVariables>(StorefrontPageUpdateStatusDocument, options);
      }
export type StorefrontPageUpdateStatusMutationHookResult = ReturnType<typeof useStorefrontPageUpdateStatusMutation>;
export type StorefrontPageUpdateStatusMutationResult = Apollo.MutationResult<StorefrontPageUpdateStatusMutation>;
export type StorefrontPageUpdateStatusMutationOptions = Apollo.BaseMutationOptions<StorefrontPageUpdateStatusMutation, StorefrontPageUpdateStatusMutationVariables>;
export const StorefrontPlatformSettingsUpdateDocument = gql`
    mutation StorefrontPlatformSettingsUpdate($gettingStartedWistiaId: String) {
  storefrontPlatformSettingsUpdate(
    gettingStartedWistiaId: $gettingStartedWistiaId
  ) {
    _id
    gettingStartedWistiaId
  }
}
    `;
export type StorefrontPlatformSettingsUpdateMutationFn = Apollo.MutationFunction<StorefrontPlatformSettingsUpdateMutation, StorefrontPlatformSettingsUpdateMutationVariables>;

/**
 * __useStorefrontPlatformSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useStorefrontPlatformSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontPlatformSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontPlatformSettingsUpdateMutation, { data, loading, error }] = useStorefrontPlatformSettingsUpdateMutation({
 *   variables: {
 *      gettingStartedWistiaId: // value for 'gettingStartedWistiaId'
 *   },
 * });
 */
export function useStorefrontPlatformSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontPlatformSettingsUpdateMutation, StorefrontPlatformSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontPlatformSettingsUpdateMutation, StorefrontPlatformSettingsUpdateMutationVariables>(StorefrontPlatformSettingsUpdateDocument, options);
      }
export type StorefrontPlatformSettingsUpdateMutationHookResult = ReturnType<typeof useStorefrontPlatformSettingsUpdateMutation>;
export type StorefrontPlatformSettingsUpdateMutationResult = Apollo.MutationResult<StorefrontPlatformSettingsUpdateMutation>;
export type StorefrontPlatformSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<StorefrontPlatformSettingsUpdateMutation, StorefrontPlatformSettingsUpdateMutationVariables>;
export const StorefrontPurgeTestDataDocument = gql`
    mutation StorefrontPurgeTestData($storefrontId: ID!) {
  storefrontPurgeTestData(storefrontId: $storefrontId) {
    purgedOrderCount
  }
}
    `;
export type StorefrontPurgeTestDataMutationFn = Apollo.MutationFunction<StorefrontPurgeTestDataMutation, StorefrontPurgeTestDataMutationVariables>;

/**
 * __useStorefrontPurgeTestDataMutation__
 *
 * To run a mutation, you first call `useStorefrontPurgeTestDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontPurgeTestDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontPurgeTestDataMutation, { data, loading, error }] = useStorefrontPurgeTestDataMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *   },
 * });
 */
export function useStorefrontPurgeTestDataMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontPurgeTestDataMutation, StorefrontPurgeTestDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontPurgeTestDataMutation, StorefrontPurgeTestDataMutationVariables>(StorefrontPurgeTestDataDocument, options);
      }
export type StorefrontPurgeTestDataMutationHookResult = ReturnType<typeof useStorefrontPurgeTestDataMutation>;
export type StorefrontPurgeTestDataMutationResult = Apollo.MutationResult<StorefrontPurgeTestDataMutation>;
export type StorefrontPurgeTestDataMutationOptions = Apollo.BaseMutationOptions<StorefrontPurgeTestDataMutation, StorefrontPurgeTestDataMutationVariables>;
export const StorefrontRollbackStatementGenerationDocument = gql`
    mutation StorefrontRollbackStatementGeneration($storefrontId: MongoID!, $runId: MongoID!) {
  storefrontRollbackStatementGeneration(
    storefrontId: $storefrontId
    runId: $runId
  ) {
    _id
    period
    status
    createdByName
    statementCount
    grandTotalSum
    currency
    createdDateISO
    rolledBackAt
    rolledBackByName
    items {
      paymentRequestId
      invoiceNumber
      customerName
      orderIds
      grandTotal
      rollbackStatus
    }
  }
}
    `;
export type StorefrontRollbackStatementGenerationMutationFn = Apollo.MutationFunction<StorefrontRollbackStatementGenerationMutation, StorefrontRollbackStatementGenerationMutationVariables>;

/**
 * __useStorefrontRollbackStatementGenerationMutation__
 *
 * To run a mutation, you first call `useStorefrontRollbackStatementGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontRollbackStatementGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontRollbackStatementGenerationMutation, { data, loading, error }] = useStorefrontRollbackStatementGenerationMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useStorefrontRollbackStatementGenerationMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontRollbackStatementGenerationMutation, StorefrontRollbackStatementGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontRollbackStatementGenerationMutation, StorefrontRollbackStatementGenerationMutationVariables>(StorefrontRollbackStatementGenerationDocument, options);
      }
export type StorefrontRollbackStatementGenerationMutationHookResult = ReturnType<typeof useStorefrontRollbackStatementGenerationMutation>;
export type StorefrontRollbackStatementGenerationMutationResult = Apollo.MutationResult<StorefrontRollbackStatementGenerationMutation>;
export type StorefrontRollbackStatementGenerationMutationOptions = Apollo.BaseMutationOptions<StorefrontRollbackStatementGenerationMutation, StorefrontRollbackStatementGenerationMutationVariables>;
export const StorefrontSendTestEmailsDocument = gql`
    mutation StorefrontSendTestEmails($storefrontId: ID!, $recipientUserId: ID!, $emailTypes: [StorefrontTestEmailType!]!) {
  storefrontSendTestEmails(
    storefrontId: $storefrontId
    recipientUserId: $recipientUserId
    emailTypes: $emailTypes
  ) {
    sentCount
    failed {
      emailType
      error
    }
  }
}
    `;
export type StorefrontSendTestEmailsMutationFn = Apollo.MutationFunction<StorefrontSendTestEmailsMutation, StorefrontSendTestEmailsMutationVariables>;

/**
 * __useStorefrontSendTestEmailsMutation__
 *
 * To run a mutation, you first call `useStorefrontSendTestEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontSendTestEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontSendTestEmailsMutation, { data, loading, error }] = useStorefrontSendTestEmailsMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      recipientUserId: // value for 'recipientUserId'
 *      emailTypes: // value for 'emailTypes'
 *   },
 * });
 */
export function useStorefrontSendTestEmailsMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontSendTestEmailsMutation, StorefrontSendTestEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontSendTestEmailsMutation, StorefrontSendTestEmailsMutationVariables>(StorefrontSendTestEmailsDocument, options);
      }
export type StorefrontSendTestEmailsMutationHookResult = ReturnType<typeof useStorefrontSendTestEmailsMutation>;
export type StorefrontSendTestEmailsMutationResult = Apollo.MutationResult<StorefrontSendTestEmailsMutation>;
export type StorefrontSendTestEmailsMutationOptions = Apollo.BaseMutationOptions<StorefrontSendTestEmailsMutation, StorefrontSendTestEmailsMutationVariables>;
export const StorefrontSetApplicationFeeDocument = gql`
    mutation StorefrontSetApplicationFee($storefrontId: String!, $applicationPercentage: Float!) {
  storefrontSetApplicationFee(
    storefrontId: $storefrontId
    applicationPercentage: $applicationPercentage
  ) {
    success
    updatedCount
  }
}
    `;
export type StorefrontSetApplicationFeeMutationFn = Apollo.MutationFunction<StorefrontSetApplicationFeeMutation, StorefrontSetApplicationFeeMutationVariables>;

/**
 * __useStorefrontSetApplicationFeeMutation__
 *
 * To run a mutation, you first call `useStorefrontSetApplicationFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontSetApplicationFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontSetApplicationFeeMutation, { data, loading, error }] = useStorefrontSetApplicationFeeMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      applicationPercentage: // value for 'applicationPercentage'
 *   },
 * });
 */
export function useStorefrontSetApplicationFeeMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontSetApplicationFeeMutation, StorefrontSetApplicationFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontSetApplicationFeeMutation, StorefrontSetApplicationFeeMutationVariables>(StorefrontSetApplicationFeeDocument, options);
      }
export type StorefrontSetApplicationFeeMutationHookResult = ReturnType<typeof useStorefrontSetApplicationFeeMutation>;
export type StorefrontSetApplicationFeeMutationResult = Apollo.MutationResult<StorefrontSetApplicationFeeMutation>;
export type StorefrontSetApplicationFeeMutationOptions = Apollo.BaseMutationOptions<StorefrontSetApplicationFeeMutation, StorefrontSetApplicationFeeMutationVariables>;
export const StorefrontSetApplicationFeeDefaultsDocument = gql`
    mutation StorefrontSetApplicationFeeDefaults($storefrontId: String!, $other: Float!, $membership: Float!, $merch: Float!) {
  storefrontSetApplicationFeeDefaults(
    storefrontId: $storefrontId
    other: $other
    membership: $membership
    merch: $merch
  ) {
    _id
    applicationPercentage
    applicationFeeDefaults {
      membership
      merch
    }
  }
}
    `;
export type StorefrontSetApplicationFeeDefaultsMutationFn = Apollo.MutationFunction<StorefrontSetApplicationFeeDefaultsMutation, StorefrontSetApplicationFeeDefaultsMutationVariables>;

/**
 * __useStorefrontSetApplicationFeeDefaultsMutation__
 *
 * To run a mutation, you first call `useStorefrontSetApplicationFeeDefaultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontSetApplicationFeeDefaultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontSetApplicationFeeDefaultsMutation, { data, loading, error }] = useStorefrontSetApplicationFeeDefaultsMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      other: // value for 'other'
 *      membership: // value for 'membership'
 *      merch: // value for 'merch'
 *   },
 * });
 */
export function useStorefrontSetApplicationFeeDefaultsMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontSetApplicationFeeDefaultsMutation, StorefrontSetApplicationFeeDefaultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontSetApplicationFeeDefaultsMutation, StorefrontSetApplicationFeeDefaultsMutationVariables>(StorefrontSetApplicationFeeDefaultsDocument, options);
      }
export type StorefrontSetApplicationFeeDefaultsMutationHookResult = ReturnType<typeof useStorefrontSetApplicationFeeDefaultsMutation>;
export type StorefrontSetApplicationFeeDefaultsMutationResult = Apollo.MutationResult<StorefrontSetApplicationFeeDefaultsMutation>;
export type StorefrontSetApplicationFeeDefaultsMutationOptions = Apollo.BaseMutationOptions<StorefrontSetApplicationFeeDefaultsMutation, StorefrontSetApplicationFeeDefaultsMutationVariables>;
export const StorefrontSetInvoicingEnabledDocument = gql`
    mutation StorefrontSetInvoicingEnabled($storefrontId: MongoID!, $enabled: Boolean!) {
  storefrontSetInvoicingEnabled(storefrontId: $storefrontId, enabled: $enabled) {
    _id
    invoicingEnabled
  }
}
    `;
export type StorefrontSetInvoicingEnabledMutationFn = Apollo.MutationFunction<StorefrontSetInvoicingEnabledMutation, StorefrontSetInvoicingEnabledMutationVariables>;

/**
 * __useStorefrontSetInvoicingEnabledMutation__
 *
 * To run a mutation, you first call `useStorefrontSetInvoicingEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontSetInvoicingEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontSetInvoicingEnabledMutation, { data, loading, error }] = useStorefrontSetInvoicingEnabledMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useStorefrontSetInvoicingEnabledMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontSetInvoicingEnabledMutation, StorefrontSetInvoicingEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontSetInvoicingEnabledMutation, StorefrontSetInvoicingEnabledMutationVariables>(StorefrontSetInvoicingEnabledDocument, options);
      }
export type StorefrontSetInvoicingEnabledMutationHookResult = ReturnType<typeof useStorefrontSetInvoicingEnabledMutation>;
export type StorefrontSetInvoicingEnabledMutationResult = Apollo.MutationResult<StorefrontSetInvoicingEnabledMutation>;
export type StorefrontSetInvoicingEnabledMutationOptions = Apollo.BaseMutationOptions<StorefrontSetInvoicingEnabledMutation, StorefrontSetInvoicingEnabledMutationVariables>;
export const StorefrontSetRegionDocument = gql`
    mutation StorefrontSetRegion($storefrontId: MongoID!, $stripeRegion: String!) {
  storefrontSetRegion(storefrontId: $storefrontId, stripeRegion: $stripeRegion) {
    _id
    stripeRegion
  }
}
    `;
export type StorefrontSetRegionMutationFn = Apollo.MutationFunction<StorefrontSetRegionMutation, StorefrontSetRegionMutationVariables>;

/**
 * __useStorefrontSetRegionMutation__
 *
 * To run a mutation, you first call `useStorefrontSetRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontSetRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontSetRegionMutation, { data, loading, error }] = useStorefrontSetRegionMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      stripeRegion: // value for 'stripeRegion'
 *   },
 * });
 */
export function useStorefrontSetRegionMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontSetRegionMutation, StorefrontSetRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontSetRegionMutation, StorefrontSetRegionMutationVariables>(StorefrontSetRegionDocument, options);
      }
export type StorefrontSetRegionMutationHookResult = ReturnType<typeof useStorefrontSetRegionMutation>;
export type StorefrontSetRegionMutationResult = Apollo.MutationResult<StorefrontSetRegionMutation>;
export type StorefrontSetRegionMutationOptions = Apollo.BaseMutationOptions<StorefrontSetRegionMutation, StorefrontSetRegionMutationVariables>;
export const StorefrontUpdateDocument = gql`
    mutation StorefrontUpdate($id: MongoID!, $record: UpdateByIdStorefrontInput!) {
  storefrontUpdate(_id: $id, record: $record) {
    record {
      _id
      defaultWidgetLogo {
        ...ImageFragment
      }
      emailBranding {
        fromName
        replyTo
        accentColor
        showContact
        useOrganizationEmailSettings
        footerText {
          en
          fr
          es
        }
        logo {
          ...ImageFragment
        }
      }
      name {
        en
        fr
        es
      }
      enabledFeeTypes {
        accommodations
        oneTimeFee
        renewableFees
        events
        merch
      }
      accountingCodes
      defaultInvoicePolicy
      connectedListings
      lowStockDigestEnabled
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export type StorefrontUpdateMutationFn = Apollo.MutationFunction<StorefrontUpdateMutation, StorefrontUpdateMutationVariables>;

/**
 * __useStorefrontUpdateMutation__
 *
 * To run a mutation, you first call `useStorefrontUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontUpdateMutation, { data, loading, error }] = useStorefrontUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useStorefrontUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontUpdateMutation, StorefrontUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontUpdateMutation, StorefrontUpdateMutationVariables>(StorefrontUpdateDocument, options);
      }
export type StorefrontUpdateMutationHookResult = ReturnType<typeof useStorefrontUpdateMutation>;
export type StorefrontUpdateMutationResult = Apollo.MutationResult<StorefrontUpdateMutation>;
export type StorefrontUpdateMutationOptions = Apollo.BaseMutationOptions<StorefrontUpdateMutation, StorefrontUpdateMutationVariables>;
export const StripePayoutsSyncDocument = gql`
    mutation StripePayoutsSync($storefrontId: MongoID!, $sinceDays: Int) {
  stripePayoutsSync(storefrontId: $storefrontId, sinceDays: $sinceDays) {
    payoutCount
    transactionCount
    syncedAt
  }
}
    `;
export type StripePayoutsSyncMutationFn = Apollo.MutationFunction<StripePayoutsSyncMutation, StripePayoutsSyncMutationVariables>;

/**
 * __useStripePayoutsSyncMutation__
 *
 * To run a mutation, you first call `useStripePayoutsSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripePayoutsSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripePayoutsSyncMutation, { data, loading, error }] = useStripePayoutsSyncMutation({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      sinceDays: // value for 'sinceDays'
 *   },
 * });
 */
export function useStripePayoutsSyncMutation(baseOptions?: Apollo.MutationHookOptions<StripePayoutsSyncMutation, StripePayoutsSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripePayoutsSyncMutation, StripePayoutsSyncMutationVariables>(StripePayoutsSyncDocument, options);
      }
export type StripePayoutsSyncMutationHookResult = ReturnType<typeof useStripePayoutsSyncMutation>;
export type StripePayoutsSyncMutationResult = Apollo.MutationResult<StripePayoutsSyncMutation>;
export type StripePayoutsSyncMutationOptions = Apollo.BaseMutationOptions<StripePayoutsSyncMutation, StripePayoutsSyncMutationVariables>;
export const SurveyCreateDocument = gql`
    mutation SurveyCreate($record: CreateOneSurveyInput!) {
  surveyCreate(record: $record) {
    record {
      _id
    }
  }
}
    `;
export type SurveyCreateMutationFn = Apollo.MutationFunction<SurveyCreateMutation, SurveyCreateMutationVariables>;

/**
 * __useSurveyCreateMutation__
 *
 * To run a mutation, you first call `useSurveyCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyCreateMutation, { data, loading, error }] = useSurveyCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useSurveyCreateMutation(baseOptions?: Apollo.MutationHookOptions<SurveyCreateMutation, SurveyCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyCreateMutation, SurveyCreateMutationVariables>(SurveyCreateDocument, options);
      }
export type SurveyCreateMutationHookResult = ReturnType<typeof useSurveyCreateMutation>;
export type SurveyCreateMutationResult = Apollo.MutationResult<SurveyCreateMutation>;
export type SurveyCreateMutationOptions = Apollo.BaseMutationOptions<SurveyCreateMutation, SurveyCreateMutationVariables>;
export const SurveyDeleteDocument = gql`
    mutation SurveyDelete($id: MongoID!) {
  surveyDelete(id: $id) {
    deletedQuestionCount
  }
}
    `;
export type SurveyDeleteMutationFn = Apollo.MutationFunction<SurveyDeleteMutation, SurveyDeleteMutationVariables>;

/**
 * __useSurveyDeleteMutation__
 *
 * To run a mutation, you first call `useSurveyDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyDeleteMutation, { data, loading, error }] = useSurveyDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSurveyDeleteMutation(baseOptions?: Apollo.MutationHookOptions<SurveyDeleteMutation, SurveyDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyDeleteMutation, SurveyDeleteMutationVariables>(SurveyDeleteDocument, options);
      }
export type SurveyDeleteMutationHookResult = ReturnType<typeof useSurveyDeleteMutation>;
export type SurveyDeleteMutationResult = Apollo.MutationResult<SurveyDeleteMutation>;
export type SurveyDeleteMutationOptions = Apollo.BaseMutationOptions<SurveyDeleteMutation, SurveyDeleteMutationVariables>;
export const SurveyDuplicateDocument = gql`
    mutation SurveyDuplicate($id: MongoID!) {
  surveyDuplicate(id: $id) {
    surveyId
  }
}
    `;
export type SurveyDuplicateMutationFn = Apollo.MutationFunction<SurveyDuplicateMutation, SurveyDuplicateMutationVariables>;

/**
 * __useSurveyDuplicateMutation__
 *
 * To run a mutation, you first call `useSurveyDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyDuplicateMutation, { data, loading, error }] = useSurveyDuplicateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSurveyDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<SurveyDuplicateMutation, SurveyDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyDuplicateMutation, SurveyDuplicateMutationVariables>(SurveyDuplicateDocument, options);
      }
export type SurveyDuplicateMutationHookResult = ReturnType<typeof useSurveyDuplicateMutation>;
export type SurveyDuplicateMutationResult = Apollo.MutationResult<SurveyDuplicateMutation>;
export type SurveyDuplicateMutationOptions = Apollo.BaseMutationOptions<SurveyDuplicateMutation, SurveyDuplicateMutationVariables>;
export const SurveyQuestionCreateManyDocument = gql`
    mutation SurveyQuestionCreateMany($records: [CreateManySurveyQuestionInput!]!) {
  surveyQuestionCreateMany(records: $records) {
    records {
      _id
      name {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type SurveyQuestionCreateManyMutationFn = Apollo.MutationFunction<SurveyQuestionCreateManyMutation, SurveyQuestionCreateManyMutationVariables>;

/**
 * __useSurveyQuestionCreateManyMutation__
 *
 * To run a mutation, you first call `useSurveyQuestionCreateManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyQuestionCreateManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyQuestionCreateManyMutation, { data, loading, error }] = useSurveyQuestionCreateManyMutation({
 *   variables: {
 *      records: // value for 'records'
 *   },
 * });
 */
export function useSurveyQuestionCreateManyMutation(baseOptions?: Apollo.MutationHookOptions<SurveyQuestionCreateManyMutation, SurveyQuestionCreateManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyQuestionCreateManyMutation, SurveyQuestionCreateManyMutationVariables>(SurveyQuestionCreateManyDocument, options);
      }
export type SurveyQuestionCreateManyMutationHookResult = ReturnType<typeof useSurveyQuestionCreateManyMutation>;
export type SurveyQuestionCreateManyMutationResult = Apollo.MutationResult<SurveyQuestionCreateManyMutation>;
export type SurveyQuestionCreateManyMutationOptions = Apollo.BaseMutationOptions<SurveyQuestionCreateManyMutation, SurveyQuestionCreateManyMutationVariables>;
export const SurveyQuestionUpdateDocument = gql`
    mutation SurveyQuestionUpdate($id: MongoID!, $record: UpdateByIdSurveyQuestionInput!) {
  surveyQuestionUpdate(_id: $id, record: $record) {
    record {
      _id
    }
  }
}
    `;
export type SurveyQuestionUpdateMutationFn = Apollo.MutationFunction<SurveyQuestionUpdateMutation, SurveyQuestionUpdateMutationVariables>;

/**
 * __useSurveyQuestionUpdateMutation__
 *
 * To run a mutation, you first call `useSurveyQuestionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyQuestionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyQuestionUpdateMutation, { data, loading, error }] = useSurveyQuestionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useSurveyQuestionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SurveyQuestionUpdateMutation, SurveyQuestionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyQuestionUpdateMutation, SurveyQuestionUpdateMutationVariables>(SurveyQuestionUpdateDocument, options);
      }
export type SurveyQuestionUpdateMutationHookResult = ReturnType<typeof useSurveyQuestionUpdateMutation>;
export type SurveyQuestionUpdateMutationResult = Apollo.MutationResult<SurveyQuestionUpdateMutation>;
export type SurveyQuestionUpdateMutationOptions = Apollo.BaseMutationOptions<SurveyQuestionUpdateMutation, SurveyQuestionUpdateMutationVariables>;
export const SurveyResponseAdminEditDocument = gql`
    mutation SurveyResponseAdminEdit($surveyResponseId: String!, $responses: [JSON!]!) {
  surveyResponseAdminEdit(
    surveyResponseId: $surveyResponseId
    responses: $responses
  ) {
    _id
    responses {
      questionData {
        _id
        isActive
        name {
          ...MultilingualFragment
        }
        owner {
          type
          entityId
        }
        type
        required
        whereaboutsSearchEntityType
        parentQuestion
        options {
          _id
          label {
            ...MultilingualFragment
          }
          isActive
        }
      }
      response
    }
    history {
      action
      timestamp
      personName
      reviewStatus
      reviewNote
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type SurveyResponseAdminEditMutationFn = Apollo.MutationFunction<SurveyResponseAdminEditMutation, SurveyResponseAdminEditMutationVariables>;

/**
 * __useSurveyResponseAdminEditMutation__
 *
 * To run a mutation, you first call `useSurveyResponseAdminEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyResponseAdminEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyResponseAdminEditMutation, { data, loading, error }] = useSurveyResponseAdminEditMutation({
 *   variables: {
 *      surveyResponseId: // value for 'surveyResponseId'
 *      responses: // value for 'responses'
 *   },
 * });
 */
export function useSurveyResponseAdminEditMutation(baseOptions?: Apollo.MutationHookOptions<SurveyResponseAdminEditMutation, SurveyResponseAdminEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyResponseAdminEditMutation, SurveyResponseAdminEditMutationVariables>(SurveyResponseAdminEditDocument, options);
      }
export type SurveyResponseAdminEditMutationHookResult = ReturnType<typeof useSurveyResponseAdminEditMutation>;
export type SurveyResponseAdminEditMutationResult = Apollo.MutationResult<SurveyResponseAdminEditMutation>;
export type SurveyResponseAdminEditMutationOptions = Apollo.BaseMutationOptions<SurveyResponseAdminEditMutation, SurveyResponseAdminEditMutationVariables>;
export const SurveyResponseCreateDocument = gql`
    mutation SurveyResponseCreate($record: CreateOneSurveyResponseInput!) {
  surveyResponseCreate(record: $record) {
    record {
      _id
    }
  }
}
    `;
export type SurveyResponseCreateMutationFn = Apollo.MutationFunction<SurveyResponseCreateMutation, SurveyResponseCreateMutationVariables>;

/**
 * __useSurveyResponseCreateMutation__
 *
 * To run a mutation, you first call `useSurveyResponseCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyResponseCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyResponseCreateMutation, { data, loading, error }] = useSurveyResponseCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useSurveyResponseCreateMutation(baseOptions?: Apollo.MutationHookOptions<SurveyResponseCreateMutation, SurveyResponseCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyResponseCreateMutation, SurveyResponseCreateMutationVariables>(SurveyResponseCreateDocument, options);
      }
export type SurveyResponseCreateMutationHookResult = ReturnType<typeof useSurveyResponseCreateMutation>;
export type SurveyResponseCreateMutationResult = Apollo.MutationResult<SurveyResponseCreateMutation>;
export type SurveyResponseCreateMutationOptions = Apollo.BaseMutationOptions<SurveyResponseCreateMutation, SurveyResponseCreateMutationVariables>;
export const SurveyResponseDeleteByIdDocument = gql`
    mutation SurveyResponseDeleteById($surveyResponseId: String!) {
  surveyResponseDeleteById(surveyResponseId: $surveyResponseId) {
    _id
  }
}
    `;
export type SurveyResponseDeleteByIdMutationFn = Apollo.MutationFunction<SurveyResponseDeleteByIdMutation, SurveyResponseDeleteByIdMutationVariables>;

/**
 * __useSurveyResponseDeleteByIdMutation__
 *
 * To run a mutation, you first call `useSurveyResponseDeleteByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyResponseDeleteByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyResponseDeleteByIdMutation, { data, loading, error }] = useSurveyResponseDeleteByIdMutation({
 *   variables: {
 *      surveyResponseId: // value for 'surveyResponseId'
 *   },
 * });
 */
export function useSurveyResponseDeleteByIdMutation(baseOptions?: Apollo.MutationHookOptions<SurveyResponseDeleteByIdMutation, SurveyResponseDeleteByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyResponseDeleteByIdMutation, SurveyResponseDeleteByIdMutationVariables>(SurveyResponseDeleteByIdDocument, options);
      }
export type SurveyResponseDeleteByIdMutationHookResult = ReturnType<typeof useSurveyResponseDeleteByIdMutation>;
export type SurveyResponseDeleteByIdMutationResult = Apollo.MutationResult<SurveyResponseDeleteByIdMutation>;
export type SurveyResponseDeleteByIdMutationOptions = Apollo.BaseMutationOptions<SurveyResponseDeleteByIdMutation, SurveyResponseDeleteByIdMutationVariables>;
export const SurveyResponseReviewSubmissionDocument = gql`
    mutation SurveyResponseReviewSubmission($surveyResponseId: String!, $decision: String!, $reviewNote: String) {
  surveyResponseReviewSubmission(
    surveyResponseId: $surveyResponseId
    decision: $decision
    reviewNote: $reviewNote
  ) {
    _id
    status
    version
    adminStatus
    responses {
      questionData {
        _id
        name {
          en
        }
      }
      response
    }
  }
}
    `;
export type SurveyResponseReviewSubmissionMutationFn = Apollo.MutationFunction<SurveyResponseReviewSubmissionMutation, SurveyResponseReviewSubmissionMutationVariables>;

/**
 * __useSurveyResponseReviewSubmissionMutation__
 *
 * To run a mutation, you first call `useSurveyResponseReviewSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyResponseReviewSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyResponseReviewSubmissionMutation, { data, loading, error }] = useSurveyResponseReviewSubmissionMutation({
 *   variables: {
 *      surveyResponseId: // value for 'surveyResponseId'
 *      decision: // value for 'decision'
 *      reviewNote: // value for 'reviewNote'
 *   },
 * });
 */
export function useSurveyResponseReviewSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<SurveyResponseReviewSubmissionMutation, SurveyResponseReviewSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyResponseReviewSubmissionMutation, SurveyResponseReviewSubmissionMutationVariables>(SurveyResponseReviewSubmissionDocument, options);
      }
export type SurveyResponseReviewSubmissionMutationHookResult = ReturnType<typeof useSurveyResponseReviewSubmissionMutation>;
export type SurveyResponseReviewSubmissionMutationResult = Apollo.MutationResult<SurveyResponseReviewSubmissionMutation>;
export type SurveyResponseReviewSubmissionMutationOptions = Apollo.BaseMutationOptions<SurveyResponseReviewSubmissionMutation, SurveyResponseReviewSubmissionMutationVariables>;
export const SurveyResponseSaveForBroadcastDocument = gql`
    mutation SurveyResponseSaveForBroadcast($surveyId: String!, $broadcastId: String!, $resourceId: String!, $personId: String!, $savedByPersonId: String, $responses: [JSON!]!, $expectedVersion: Int, $submissionIndex: Int, $isShared: Boolean, $isNewSubmission: Boolean, $organizationId: String, $operatorId: String, $operatorIds: [String!]) {
  surveyResponseSaveForBroadcast(
    surveyId: $surveyId
    broadcastId: $broadcastId
    resourceId: $resourceId
    personId: $personId
    savedByPersonId: $savedByPersonId
    responses: $responses
    expectedVersion: $expectedVersion
    submissionIndex: $submissionIndex
    isShared: $isShared
    isNewSubmission: $isNewSubmission
    organizationId: $organizationId
    operatorId: $operatorId
    operatorIds: $operatorIds
  ) {
    _id
    status
    version
    submissionIndex
    responses {
      questionData {
        _id
        name {
          en
        }
      }
      response
    }
    history {
      action
      savedBy
      personName
      timestamp
      reviewStatus
      reviewNote
    }
  }
}
    `;
export type SurveyResponseSaveForBroadcastMutationFn = Apollo.MutationFunction<SurveyResponseSaveForBroadcastMutation, SurveyResponseSaveForBroadcastMutationVariables>;

/**
 * __useSurveyResponseSaveForBroadcastMutation__
 *
 * To run a mutation, you first call `useSurveyResponseSaveForBroadcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyResponseSaveForBroadcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyResponseSaveForBroadcastMutation, { data, loading, error }] = useSurveyResponseSaveForBroadcastMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      broadcastId: // value for 'broadcastId'
 *      resourceId: // value for 'resourceId'
 *      personId: // value for 'personId'
 *      savedByPersonId: // value for 'savedByPersonId'
 *      responses: // value for 'responses'
 *      expectedVersion: // value for 'expectedVersion'
 *      submissionIndex: // value for 'submissionIndex'
 *      isShared: // value for 'isShared'
 *      isNewSubmission: // value for 'isNewSubmission'
 *      organizationId: // value for 'organizationId'
 *      operatorId: // value for 'operatorId'
 *      operatorIds: // value for 'operatorIds'
 *   },
 * });
 */
export function useSurveyResponseSaveForBroadcastMutation(baseOptions?: Apollo.MutationHookOptions<SurveyResponseSaveForBroadcastMutation, SurveyResponseSaveForBroadcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyResponseSaveForBroadcastMutation, SurveyResponseSaveForBroadcastMutationVariables>(SurveyResponseSaveForBroadcastDocument, options);
      }
export type SurveyResponseSaveForBroadcastMutationHookResult = ReturnType<typeof useSurveyResponseSaveForBroadcastMutation>;
export type SurveyResponseSaveForBroadcastMutationResult = Apollo.MutationResult<SurveyResponseSaveForBroadcastMutation>;
export type SurveyResponseSaveForBroadcastMutationOptions = Apollo.BaseMutationOptions<SurveyResponseSaveForBroadcastMutation, SurveyResponseSaveForBroadcastMutationVariables>;
export const SurveyResponseSubmitForBroadcastDocument = gql`
    mutation SurveyResponseSubmitForBroadcast($surveyId: String!, $broadcastId: String!, $resourceId: String!, $personId: String!, $savedByPersonId: String, $responses: [JSON!]!, $expectedVersion: Int, $submissionIndex: Int, $isShared: Boolean, $isNewSubmission: Boolean, $organizationId: String, $operatorId: String, $operatorIds: [String!]) {
  surveyResponseSubmitForBroadcast(
    surveyId: $surveyId
    broadcastId: $broadcastId
    resourceId: $resourceId
    personId: $personId
    savedByPersonId: $savedByPersonId
    responses: $responses
    expectedVersion: $expectedVersion
    submissionIndex: $submissionIndex
    isShared: $isShared
    isNewSubmission: $isNewSubmission
    organizationId: $organizationId
    operatorId: $operatorId
    operatorIds: $operatorIds
  ) {
    _id
    status
    version
    submissionIndex
    adminStatus
    responses {
      questionData {
        _id
        name {
          en
        }
      }
      response
    }
    history {
      action
      savedBy
      personName
      timestamp
      reviewStatus
      reviewNote
    }
  }
}
    `;
export type SurveyResponseSubmitForBroadcastMutationFn = Apollo.MutationFunction<SurveyResponseSubmitForBroadcastMutation, SurveyResponseSubmitForBroadcastMutationVariables>;

/**
 * __useSurveyResponseSubmitForBroadcastMutation__
 *
 * To run a mutation, you first call `useSurveyResponseSubmitForBroadcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyResponseSubmitForBroadcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyResponseSubmitForBroadcastMutation, { data, loading, error }] = useSurveyResponseSubmitForBroadcastMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      broadcastId: // value for 'broadcastId'
 *      resourceId: // value for 'resourceId'
 *      personId: // value for 'personId'
 *      savedByPersonId: // value for 'savedByPersonId'
 *      responses: // value for 'responses'
 *      expectedVersion: // value for 'expectedVersion'
 *      submissionIndex: // value for 'submissionIndex'
 *      isShared: // value for 'isShared'
 *      isNewSubmission: // value for 'isNewSubmission'
 *      organizationId: // value for 'organizationId'
 *      operatorId: // value for 'operatorId'
 *      operatorIds: // value for 'operatorIds'
 *   },
 * });
 */
export function useSurveyResponseSubmitForBroadcastMutation(baseOptions?: Apollo.MutationHookOptions<SurveyResponseSubmitForBroadcastMutation, SurveyResponseSubmitForBroadcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyResponseSubmitForBroadcastMutation, SurveyResponseSubmitForBroadcastMutationVariables>(SurveyResponseSubmitForBroadcastDocument, options);
      }
export type SurveyResponseSubmitForBroadcastMutationHookResult = ReturnType<typeof useSurveyResponseSubmitForBroadcastMutation>;
export type SurveyResponseSubmitForBroadcastMutationResult = Apollo.MutationResult<SurveyResponseSubmitForBroadcastMutation>;
export type SurveyResponseSubmitForBroadcastMutationOptions = Apollo.BaseMutationOptions<SurveyResponseSubmitForBroadcastMutation, SurveyResponseSubmitForBroadcastMutationVariables>;
export const SurveyResponseUpdateAdminStatusDocument = gql`
    mutation SurveyResponseUpdateAdminStatus($surveyResponseId: String!, $adminStatus: String!) {
  surveyResponseUpdateAdminStatus(
    surveyResponseId: $surveyResponseId
    adminStatus: $adminStatus
  ) {
    _id
    adminStatus
  }
}
    `;
export type SurveyResponseUpdateAdminStatusMutationFn = Apollo.MutationFunction<SurveyResponseUpdateAdminStatusMutation, SurveyResponseUpdateAdminStatusMutationVariables>;

/**
 * __useSurveyResponseUpdateAdminStatusMutation__
 *
 * To run a mutation, you first call `useSurveyResponseUpdateAdminStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyResponseUpdateAdminStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyResponseUpdateAdminStatusMutation, { data, loading, error }] = useSurveyResponseUpdateAdminStatusMutation({
 *   variables: {
 *      surveyResponseId: // value for 'surveyResponseId'
 *      adminStatus: // value for 'adminStatus'
 *   },
 * });
 */
export function useSurveyResponseUpdateAdminStatusMutation(baseOptions?: Apollo.MutationHookOptions<SurveyResponseUpdateAdminStatusMutation, SurveyResponseUpdateAdminStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyResponseUpdateAdminStatusMutation, SurveyResponseUpdateAdminStatusMutationVariables>(SurveyResponseUpdateAdminStatusDocument, options);
      }
export type SurveyResponseUpdateAdminStatusMutationHookResult = ReturnType<typeof useSurveyResponseUpdateAdminStatusMutation>;
export type SurveyResponseUpdateAdminStatusMutationResult = Apollo.MutationResult<SurveyResponseUpdateAdminStatusMutation>;
export type SurveyResponseUpdateAdminStatusMutationOptions = Apollo.BaseMutationOptions<SurveyResponseUpdateAdminStatusMutation, SurveyResponseUpdateAdminStatusMutationVariables>;
export const SurveyResponseUpdateTagsDocument = gql`
    mutation SurveyResponseUpdateTags($surveyResponseId: String!, $tags: [String!]!) {
  surveyResponseUpdateTags(surveyResponseId: $surveyResponseId, tags: $tags) {
    _id
    tags
  }
}
    `;
export type SurveyResponseUpdateTagsMutationFn = Apollo.MutationFunction<SurveyResponseUpdateTagsMutation, SurveyResponseUpdateTagsMutationVariables>;

/**
 * __useSurveyResponseUpdateTagsMutation__
 *
 * To run a mutation, you first call `useSurveyResponseUpdateTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyResponseUpdateTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyResponseUpdateTagsMutation, { data, loading, error }] = useSurveyResponseUpdateTagsMutation({
 *   variables: {
 *      surveyResponseId: // value for 'surveyResponseId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useSurveyResponseUpdateTagsMutation(baseOptions?: Apollo.MutationHookOptions<SurveyResponseUpdateTagsMutation, SurveyResponseUpdateTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyResponseUpdateTagsMutation, SurveyResponseUpdateTagsMutationVariables>(SurveyResponseUpdateTagsDocument, options);
      }
export type SurveyResponseUpdateTagsMutationHookResult = ReturnType<typeof useSurveyResponseUpdateTagsMutation>;
export type SurveyResponseUpdateTagsMutationResult = Apollo.MutationResult<SurveyResponseUpdateTagsMutation>;
export type SurveyResponseUpdateTagsMutationOptions = Apollo.BaseMutationOptions<SurveyResponseUpdateTagsMutation, SurveyResponseUpdateTagsMutationVariables>;
export const SurveyUpdateDocument = gql`
    mutation SurveyUpdate($id: MongoID!, $record: UpdateByIdSurveyInput!) {
  surveyUpdate(_id: $id, record: $record) {
    record {
      _id
    }
  }
}
    `;
export type SurveyUpdateMutationFn = Apollo.MutationFunction<SurveyUpdateMutation, SurveyUpdateMutationVariables>;

/**
 * __useSurveyUpdateMutation__
 *
 * To run a mutation, you first call `useSurveyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSurveyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [surveyUpdateMutation, { data, loading, error }] = useSurveyUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useSurveyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SurveyUpdateMutation, SurveyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SurveyUpdateMutation, SurveyUpdateMutationVariables>(SurveyUpdateDocument, options);
      }
export type SurveyUpdateMutationHookResult = ReturnType<typeof useSurveyUpdateMutation>;
export type SurveyUpdateMutationResult = Apollo.MutationResult<SurveyUpdateMutation>;
export type SurveyUpdateMutationOptions = Apollo.BaseMutationOptions<SurveyUpdateMutation, SurveyUpdateMutationVariables>;
export const TagCreateDocument = gql`
    mutation TagCreate($record: CreateOneTagInput!) {
  tagCreate(record: $record) {
    record {
      ...TagFragment
    }
  }
}
    ${TagFragmentFragmentDoc}`;
export type TagCreateMutationFn = Apollo.MutationFunction<TagCreateMutation, TagCreateMutationVariables>;

/**
 * __useTagCreateMutation__
 *
 * To run a mutation, you first call `useTagCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagCreateMutation, { data, loading, error }] = useTagCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useTagCreateMutation(baseOptions?: Apollo.MutationHookOptions<TagCreateMutation, TagCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagCreateMutation, TagCreateMutationVariables>(TagCreateDocument, options);
      }
export type TagCreateMutationHookResult = ReturnType<typeof useTagCreateMutation>;
export type TagCreateMutationResult = Apollo.MutationResult<TagCreateMutation>;
export type TagCreateMutationOptions = Apollo.BaseMutationOptions<TagCreateMutation, TagCreateMutationVariables>;
export const TagDeleteDocument = gql`
    mutation TagDelete($id: MongoID!) {
  tagDelete(_id: $id) {
    record {
      _id
    }
  }
}
    `;
export type TagDeleteMutationFn = Apollo.MutationFunction<TagDeleteMutation, TagDeleteMutationVariables>;

/**
 * __useTagDeleteMutation__
 *
 * To run a mutation, you first call `useTagDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagDeleteMutation, { data, loading, error }] = useTagDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TagDeleteMutation, TagDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagDeleteMutation, TagDeleteMutationVariables>(TagDeleteDocument, options);
      }
export type TagDeleteMutationHookResult = ReturnType<typeof useTagDeleteMutation>;
export type TagDeleteMutationResult = Apollo.MutationResult<TagDeleteMutation>;
export type TagDeleteMutationOptions = Apollo.BaseMutationOptions<TagDeleteMutation, TagDeleteMutationVariables>;
export const TagGroupManyDocument = gql`
    query TagGroupMany($filter: FilterFindManyTagGroupInput) {
  tagGroupMany(filter: $filter) {
    _id
    key
    name {
      ...MultilingualFragment
    }
    type
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useTagGroupManyQuery__
 *
 * To run a query within a React component, call `useTagGroupManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagGroupManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagGroupManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTagGroupManyQuery(baseOptions?: Apollo.QueryHookOptions<TagGroupManyQuery, TagGroupManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagGroupManyQuery, TagGroupManyQueryVariables>(TagGroupManyDocument, options);
      }
export function useTagGroupManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagGroupManyQuery, TagGroupManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagGroupManyQuery, TagGroupManyQueryVariables>(TagGroupManyDocument, options);
        }
// @ts-ignore
export function useTagGroupManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagGroupManyQuery, TagGroupManyQueryVariables>): Apollo.UseSuspenseQueryResult<TagGroupManyQuery, TagGroupManyQueryVariables>;
export function useTagGroupManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagGroupManyQuery, TagGroupManyQueryVariables>): Apollo.UseSuspenseQueryResult<TagGroupManyQuery | undefined, TagGroupManyQueryVariables>;
export function useTagGroupManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagGroupManyQuery, TagGroupManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagGroupManyQuery, TagGroupManyQueryVariables>(TagGroupManyDocument, options);
        }
export type TagGroupManyQueryHookResult = ReturnType<typeof useTagGroupManyQuery>;
export type TagGroupManyLazyQueryHookResult = ReturnType<typeof useTagGroupManyLazyQuery>;
export type TagGroupManySuspenseQueryHookResult = ReturnType<typeof useTagGroupManySuspenseQuery>;
export type TagGroupManyQueryResult = Apollo.QueryResult<TagGroupManyQuery, TagGroupManyQueryVariables>;
export const TagMergeDocument = gql`
    mutation TagMerge($tagIdToMergeAndDelete: ID!, $tagIdToMergeInto: ID!) {
  tagMerge(
    tagIdToMergeAndDelete: $tagIdToMergeAndDelete
    tagIdToMergeInto: $tagIdToMergeInto
  ) {
    ...TagFragmentWithUsage
  }
}
    ${TagFragmentWithUsageFragmentDoc}`;
export type TagMergeMutationFn = Apollo.MutationFunction<TagMergeMutation, TagMergeMutationVariables>;

/**
 * __useTagMergeMutation__
 *
 * To run a mutation, you first call `useTagMergeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagMergeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagMergeMutation, { data, loading, error }] = useTagMergeMutation({
 *   variables: {
 *      tagIdToMergeAndDelete: // value for 'tagIdToMergeAndDelete'
 *      tagIdToMergeInto: // value for 'tagIdToMergeInto'
 *   },
 * });
 */
export function useTagMergeMutation(baseOptions?: Apollo.MutationHookOptions<TagMergeMutation, TagMergeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagMergeMutation, TagMergeMutationVariables>(TagMergeDocument, options);
      }
export type TagMergeMutationHookResult = ReturnType<typeof useTagMergeMutation>;
export type TagMergeMutationResult = Apollo.MutationResult<TagMergeMutation>;
export type TagMergeMutationOptions = Apollo.BaseMutationOptions<TagMergeMutation, TagMergeMutationVariables>;
export const TagSplitDocument = gql`
    mutation TagSplit($tagSplitId: ID!, $nameForCurrentTag: MultilingualInput!, $namesForNewTags: [MultilingualInput!]!) {
  tagSplit(
    id: $tagSplitId
    nameForCurrentTag: $nameForCurrentTag
    namesForNewTags: $namesForNewTags
  ) {
    ...TagFragmentWithUsage
  }
}
    ${TagFragmentWithUsageFragmentDoc}`;
export type TagSplitMutationFn = Apollo.MutationFunction<TagSplitMutation, TagSplitMutationVariables>;

/**
 * __useTagSplitMutation__
 *
 * To run a mutation, you first call `useTagSplitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagSplitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagSplitMutation, { data, loading, error }] = useTagSplitMutation({
 *   variables: {
 *      tagSplitId: // value for 'tagSplitId'
 *      nameForCurrentTag: // value for 'nameForCurrentTag'
 *      namesForNewTags: // value for 'namesForNewTags'
 *   },
 * });
 */
export function useTagSplitMutation(baseOptions?: Apollo.MutationHookOptions<TagSplitMutation, TagSplitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagSplitMutation, TagSplitMutationVariables>(TagSplitDocument, options);
      }
export type TagSplitMutationHookResult = ReturnType<typeof useTagSplitMutation>;
export type TagSplitMutationResult = Apollo.MutationResult<TagSplitMutation>;
export type TagSplitMutationOptions = Apollo.BaseMutationOptions<TagSplitMutation, TagSplitMutationVariables>;
export const TagSuggestionApproveDocument = gql`
    mutation TagSuggestionApprove($tagSuggestionApproveId: ID!, $tagGroup: ID!, $name: MultilingualInput!, $entityTypes: [EnumTagSuggestionEntityTypes!]!) {
  tagSuggestionApprove(
    id: $tagSuggestionApproveId
    tagGroup: $tagGroup
    name: $name
    entityTypes: $entityTypes
  ) {
    name {
      ...MultilingualFragment
    }
    _id
    entityTypes
    inheritable
    owner {
      entityId
      type
    }
    tagGroup {
      _id
      key
      name {
        ...MultilingualFragment
      }
      type
    }
    usage {
      events
      operators
      products
      total
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type TagSuggestionApproveMutationFn = Apollo.MutationFunction<TagSuggestionApproveMutation, TagSuggestionApproveMutationVariables>;

/**
 * __useTagSuggestionApproveMutation__
 *
 * To run a mutation, you first call `useTagSuggestionApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagSuggestionApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagSuggestionApproveMutation, { data, loading, error }] = useTagSuggestionApproveMutation({
 *   variables: {
 *      tagSuggestionApproveId: // value for 'tagSuggestionApproveId'
 *      tagGroup: // value for 'tagGroup'
 *      name: // value for 'name'
 *      entityTypes: // value for 'entityTypes'
 *   },
 * });
 */
export function useTagSuggestionApproveMutation(baseOptions?: Apollo.MutationHookOptions<TagSuggestionApproveMutation, TagSuggestionApproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagSuggestionApproveMutation, TagSuggestionApproveMutationVariables>(TagSuggestionApproveDocument, options);
      }
export type TagSuggestionApproveMutationHookResult = ReturnType<typeof useTagSuggestionApproveMutation>;
export type TagSuggestionApproveMutationResult = Apollo.MutationResult<TagSuggestionApproveMutation>;
export type TagSuggestionApproveMutationOptions = Apollo.BaseMutationOptions<TagSuggestionApproveMutation, TagSuggestionApproveMutationVariables>;
export const TagSuggestionCreateDocument = gql`
    mutation TagSuggestionCreate($record: CreateOneTagSuggestionInput!) {
  tagSuggestionCreate(record: $record) {
    record {
      ...TagSuggestionFragment
    }
  }
}
    ${TagSuggestionFragmentFragmentDoc}`;
export type TagSuggestionCreateMutationFn = Apollo.MutationFunction<TagSuggestionCreateMutation, TagSuggestionCreateMutationVariables>;

/**
 * __useTagSuggestionCreateMutation__
 *
 * To run a mutation, you first call `useTagSuggestionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagSuggestionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagSuggestionCreateMutation, { data, loading, error }] = useTagSuggestionCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useTagSuggestionCreateMutation(baseOptions?: Apollo.MutationHookOptions<TagSuggestionCreateMutation, TagSuggestionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagSuggestionCreateMutation, TagSuggestionCreateMutationVariables>(TagSuggestionCreateDocument, options);
      }
export type TagSuggestionCreateMutationHookResult = ReturnType<typeof useTagSuggestionCreateMutation>;
export type TagSuggestionCreateMutationResult = Apollo.MutationResult<TagSuggestionCreateMutation>;
export type TagSuggestionCreateMutationOptions = Apollo.BaseMutationOptions<TagSuggestionCreateMutation, TagSuggestionCreateMutationVariables>;
export const TagSuggestionRejectDocument = gql`
    mutation TagSuggestionReject($tagSuggestionRejectId: ID!) {
  tagSuggestionReject(id: $tagSuggestionRejectId)
}
    `;
export type TagSuggestionRejectMutationFn = Apollo.MutationFunction<TagSuggestionRejectMutation, TagSuggestionRejectMutationVariables>;

/**
 * __useTagSuggestionRejectMutation__
 *
 * To run a mutation, you first call `useTagSuggestionRejectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagSuggestionRejectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagSuggestionRejectMutation, { data, loading, error }] = useTagSuggestionRejectMutation({
 *   variables: {
 *      tagSuggestionRejectId: // value for 'tagSuggestionRejectId'
 *   },
 * });
 */
export function useTagSuggestionRejectMutation(baseOptions?: Apollo.MutationHookOptions<TagSuggestionRejectMutation, TagSuggestionRejectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagSuggestionRejectMutation, TagSuggestionRejectMutationVariables>(TagSuggestionRejectDocument, options);
      }
export type TagSuggestionRejectMutationHookResult = ReturnType<typeof useTagSuggestionRejectMutation>;
export type TagSuggestionRejectMutationResult = Apollo.MutationResult<TagSuggestionRejectMutation>;
export type TagSuggestionRejectMutationOptions = Apollo.BaseMutationOptions<TagSuggestionRejectMutation, TagSuggestionRejectMutationVariables>;
export const TagUpdateDocument = gql`
    mutation TagUpdate($id: MongoID!, $record: UpdateByIdTagInput!) {
  tagUpdate(_id: $id, record: $record) {
    record {
      ...TagFragmentWithUsage
    }
  }
}
    ${TagFragmentWithUsageFragmentDoc}`;
export type TagUpdateMutationFn = Apollo.MutationFunction<TagUpdateMutation, TagUpdateMutationVariables>;

/**
 * __useTagUpdateMutation__
 *
 * To run a mutation, you first call `useTagUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagUpdateMutation, { data, loading, error }] = useTagUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useTagUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TagUpdateMutation, TagUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagUpdateMutation, TagUpdateMutationVariables>(TagUpdateDocument, options);
      }
export type TagUpdateMutationHookResult = ReturnType<typeof useTagUpdateMutation>;
export type TagUpdateMutationResult = Apollo.MutationResult<TagUpdateMutation>;
export type TagUpdateMutationOptions = Apollo.BaseMutationOptions<TagUpdateMutation, TagUpdateMutationVariables>;
export const TaxCreateDocument = gql`
    mutation TaxCreate($record: CreateOneTaxInput!) {
  taxCreate(record: $record) {
    recordId
    record {
      _id
    }
  }
}
    `;
export type TaxCreateMutationFn = Apollo.MutationFunction<TaxCreateMutation, TaxCreateMutationVariables>;

/**
 * __useTaxCreateMutation__
 *
 * To run a mutation, you first call `useTaxCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaxCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taxCreateMutation, { data, loading, error }] = useTaxCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useTaxCreateMutation(baseOptions?: Apollo.MutationHookOptions<TaxCreateMutation, TaxCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaxCreateMutation, TaxCreateMutationVariables>(TaxCreateDocument, options);
      }
export type TaxCreateMutationHookResult = ReturnType<typeof useTaxCreateMutation>;
export type TaxCreateMutationResult = Apollo.MutationResult<TaxCreateMutation>;
export type TaxCreateMutationOptions = Apollo.BaseMutationOptions<TaxCreateMutation, TaxCreateMutationVariables>;
export const TaxUpdateDocument = gql`
    mutation TaxUpdate($id: MongoID!, $record: UpdateByIdTaxInput!) {
  taxUpdate(_id: $id, record: $record) {
    record {
      _id
      percentage
    }
  }
}
    `;
export type TaxUpdateMutationFn = Apollo.MutationFunction<TaxUpdateMutation, TaxUpdateMutationVariables>;

/**
 * __useTaxUpdateMutation__
 *
 * To run a mutation, you first call `useTaxUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaxUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taxUpdateMutation, { data, loading, error }] = useTaxUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useTaxUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TaxUpdateMutation, TaxUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaxUpdateMutation, TaxUpdateMutationVariables>(TaxUpdateDocument, options);
      }
export type TaxUpdateMutationHookResult = ReturnType<typeof useTaxUpdateMutation>;
export type TaxUpdateMutationResult = Apollo.MutationResult<TaxUpdateMutation>;
export type TaxUpdateMutationOptions = Apollo.BaseMutationOptions<TaxUpdateMutation, TaxUpdateMutationVariables>;
export const UserApproveAccessDocument = gql`
    mutation UserApproveAccess($userId: ID!, $entity: EntityReferenceInput!) {
  userApproveAccess(userId: $userId, entity: $entity) {
    _id
  }
}
    `;
export type UserApproveAccessMutationFn = Apollo.MutationFunction<UserApproveAccessMutation, UserApproveAccessMutationVariables>;

/**
 * __useUserApproveAccessMutation__
 *
 * To run a mutation, you first call `useUserApproveAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserApproveAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userApproveAccessMutation, { data, loading, error }] = useUserApproveAccessMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entity: // value for 'entity'
 *   },
 * });
 */
export function useUserApproveAccessMutation(baseOptions?: Apollo.MutationHookOptions<UserApproveAccessMutation, UserApproveAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserApproveAccessMutation, UserApproveAccessMutationVariables>(UserApproveAccessDocument, options);
      }
export type UserApproveAccessMutationHookResult = ReturnType<typeof useUserApproveAccessMutation>;
export type UserApproveAccessMutationResult = Apollo.MutationResult<UserApproveAccessMutation>;
export type UserApproveAccessMutationOptions = Apollo.BaseMutationOptions<UserApproveAccessMutation, UserApproveAccessMutationVariables>;
export const UserCreateDocument = gql`
    mutation UserCreate($record: CreateOneUserInput!) {
  userCreate(record: $record) {
    passwordResetUrl
  }
}
    `;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutation, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutation, UserCreateMutationVariables>;
export const UserCreateConfirmationCodeDocument = gql`
    mutation UserCreateConfirmationCode($id: ID!, $email: String!, $confirmationCodeType: EnumConfirmationCodeType!) {
  userCreateConfirmationCode(
    _id: $id
    email: $email
    confirmationCodeType: $confirmationCodeType
  ) {
    _id
  }
}
    `;
export type UserCreateConfirmationCodeMutationFn = Apollo.MutationFunction<UserCreateConfirmationCodeMutation, UserCreateConfirmationCodeMutationVariables>;

/**
 * __useUserCreateConfirmationCodeMutation__
 *
 * To run a mutation, you first call `useUserCreateConfirmationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateConfirmationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateConfirmationCodeMutation, { data, loading, error }] = useUserCreateConfirmationCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      confirmationCodeType: // value for 'confirmationCodeType'
 *   },
 * });
 */
export function useUserCreateConfirmationCodeMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateConfirmationCodeMutation, UserCreateConfirmationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateConfirmationCodeMutation, UserCreateConfirmationCodeMutationVariables>(UserCreateConfirmationCodeDocument, options);
      }
export type UserCreateConfirmationCodeMutationHookResult = ReturnType<typeof useUserCreateConfirmationCodeMutation>;
export type UserCreateConfirmationCodeMutationResult = Apollo.MutationResult<UserCreateConfirmationCodeMutation>;
export type UserCreateConfirmationCodeMutationOptions = Apollo.BaseMutationOptions<UserCreateConfirmationCodeMutation, UserCreateConfirmationCodeMutationVariables>;
export const UserCreateInviteDocument = gql`
    mutation UserCreateInvite($email: String!, $firstName: String!, $lastName: String!, $photo: String, $title: String, $sendInvitationEmail: Boolean!, $entity: EntityReferenceInput!, $role: RoleType, $contactRoles: [ContactRole], $emailPreferences: [UserEmailPreferencesInput!]) {
  userCreateInvite(
    email: $email
    firstName: $firstName
    lastName: $lastName
    photo: $photo
    title: $title
    sendInvitationEmail: $sendInvitationEmail
    entity: $entity
    role: $role
    contactRoles: $contactRoles
    emailPreferences: $emailPreferences
  ) {
    _id
    email
    firstName
    lastName
  }
}
    `;
export type UserCreateInviteMutationFn = Apollo.MutationFunction<UserCreateInviteMutation, UserCreateInviteMutationVariables>;

/**
 * __useUserCreateInviteMutation__
 *
 * To run a mutation, you first call `useUserCreateInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateInviteMutation, { data, loading, error }] = useUserCreateInviteMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      photo: // value for 'photo'
 *      title: // value for 'title'
 *      sendInvitationEmail: // value for 'sendInvitationEmail'
 *      entity: // value for 'entity'
 *      role: // value for 'role'
 *      contactRoles: // value for 'contactRoles'
 *      emailPreferences: // value for 'emailPreferences'
 *   },
 * });
 */
export function useUserCreateInviteMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateInviteMutation, UserCreateInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateInviteMutation, UserCreateInviteMutationVariables>(UserCreateInviteDocument, options);
      }
export type UserCreateInviteMutationHookResult = ReturnType<typeof useUserCreateInviteMutation>;
export type UserCreateInviteMutationResult = Apollo.MutationResult<UserCreateInviteMutation>;
export type UserCreateInviteMutationOptions = Apollo.BaseMutationOptions<UserCreateInviteMutation, UserCreateInviteMutationVariables>;
export const UserJoinOrganizationFromColdSignupDocument = gql`
    mutation UserJoinOrganizationFromColdSignup($organizationId: MongoID!) {
  userJoinOrganizationFromColdSignup(organizationId: $organizationId)
}
    `;
export type UserJoinOrganizationFromColdSignupMutationFn = Apollo.MutationFunction<UserJoinOrganizationFromColdSignupMutation, UserJoinOrganizationFromColdSignupMutationVariables>;

/**
 * __useUserJoinOrganizationFromColdSignupMutation__
 *
 * To run a mutation, you first call `useUserJoinOrganizationFromColdSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserJoinOrganizationFromColdSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userJoinOrganizationFromColdSignupMutation, { data, loading, error }] = useUserJoinOrganizationFromColdSignupMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useUserJoinOrganizationFromColdSignupMutation(baseOptions?: Apollo.MutationHookOptions<UserJoinOrganizationFromColdSignupMutation, UserJoinOrganizationFromColdSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserJoinOrganizationFromColdSignupMutation, UserJoinOrganizationFromColdSignupMutationVariables>(UserJoinOrganizationFromColdSignupDocument, options);
      }
export type UserJoinOrganizationFromColdSignupMutationHookResult = ReturnType<typeof useUserJoinOrganizationFromColdSignupMutation>;
export type UserJoinOrganizationFromColdSignupMutationResult = Apollo.MutationResult<UserJoinOrganizationFromColdSignupMutation>;
export type UserJoinOrganizationFromColdSignupMutationOptions = Apollo.BaseMutationOptions<UserJoinOrganizationFromColdSignupMutation, UserJoinOrganizationFromColdSignupMutationVariables>;
export const UserRequestAccessDocument = gql`
    mutation UserRequestAccess($entity: EntityReferenceInput!) {
  userRequestAccess(entity: $entity) {
    ...UserWithPictureFragment
  }
}
    ${UserWithPictureFragmentFragmentDoc}`;
export type UserRequestAccessMutationFn = Apollo.MutationFunction<UserRequestAccessMutation, UserRequestAccessMutationVariables>;

/**
 * __useUserRequestAccessMutation__
 *
 * To run a mutation, you first call `useUserRequestAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRequestAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRequestAccessMutation, { data, loading, error }] = useUserRequestAccessMutation({
 *   variables: {
 *      entity: // value for 'entity'
 *   },
 * });
 */
export function useUserRequestAccessMutation(baseOptions?: Apollo.MutationHookOptions<UserRequestAccessMutation, UserRequestAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRequestAccessMutation, UserRequestAccessMutationVariables>(UserRequestAccessDocument, options);
      }
export type UserRequestAccessMutationHookResult = ReturnType<typeof useUserRequestAccessMutation>;
export type UserRequestAccessMutationResult = Apollo.MutationResult<UserRequestAccessMutation>;
export type UserRequestAccessMutationOptions = Apollo.BaseMutationOptions<UserRequestAccessMutation, UserRequestAccessMutationVariables>;
export const UserResendConfirmationCodeDocument = gql`
    mutation UserResendConfirmationCode($id: ID!, $sentToEmail: String!, $type: EnumConfirmationCodeType!) {
  userResendConfirmationCode(_id: $id, sentToEmail: $sentToEmail, type: $type) {
    _id
  }
}
    `;
export type UserResendConfirmationCodeMutationFn = Apollo.MutationFunction<UserResendConfirmationCodeMutation, UserResendConfirmationCodeMutationVariables>;

/**
 * __useUserResendConfirmationCodeMutation__
 *
 * To run a mutation, you first call `useUserResendConfirmationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserResendConfirmationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userResendConfirmationCodeMutation, { data, loading, error }] = useUserResendConfirmationCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sentToEmail: // value for 'sentToEmail'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUserResendConfirmationCodeMutation(baseOptions?: Apollo.MutationHookOptions<UserResendConfirmationCodeMutation, UserResendConfirmationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserResendConfirmationCodeMutation, UserResendConfirmationCodeMutationVariables>(UserResendConfirmationCodeDocument, options);
      }
export type UserResendConfirmationCodeMutationHookResult = ReturnType<typeof useUserResendConfirmationCodeMutation>;
export type UserResendConfirmationCodeMutationResult = Apollo.MutationResult<UserResendConfirmationCodeMutation>;
export type UserResendConfirmationCodeMutationOptions = Apollo.BaseMutationOptions<UserResendConfirmationCodeMutation, UserResendConfirmationCodeMutationVariables>;
export const UserRevokeInviteDocument = gql`
    mutation UserRevokeInvite($userId: ID!, $entity: EntityReferenceInput!, $primaryContactReplacementUserId: ID) {
  userRevokeInvite(
    userId: $userId
    entity: $entity
    primaryContactReplacementUserId: $primaryContactReplacementUserId
  ) {
    _id
  }
}
    `;
export type UserRevokeInviteMutationFn = Apollo.MutationFunction<UserRevokeInviteMutation, UserRevokeInviteMutationVariables>;

/**
 * __useUserRevokeInviteMutation__
 *
 * To run a mutation, you first call `useUserRevokeInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRevokeInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRevokeInviteMutation, { data, loading, error }] = useUserRevokeInviteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entity: // value for 'entity'
 *      primaryContactReplacementUserId: // value for 'primaryContactReplacementUserId'
 *   },
 * });
 */
export function useUserRevokeInviteMutation(baseOptions?: Apollo.MutationHookOptions<UserRevokeInviteMutation, UserRevokeInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserRevokeInviteMutation, UserRevokeInviteMutationVariables>(UserRevokeInviteDocument, options);
      }
export type UserRevokeInviteMutationHookResult = ReturnType<typeof useUserRevokeInviteMutation>;
export type UserRevokeInviteMutationResult = Apollo.MutationResult<UserRevokeInviteMutation>;
export type UserRevokeInviteMutationOptions = Apollo.BaseMutationOptions<UserRevokeInviteMutation, UserRevokeInviteMutationVariables>;
export const UserSaveQuickLinksDocument = gql`
    mutation UserSaveQuickLinks($id: MongoID!, $baseQuickLinks: [UserQuickLinksInput!]!, $quickLinks: [UserQuickLinksInput!]!) {
  userSaveQuickLinks(
    _id: $id
    baseQuickLinks: $baseQuickLinks
    quickLinks: $quickLinks
  ) {
    _id
    passwordResetUrl
  }
}
    `;
export type UserSaveQuickLinksMutationFn = Apollo.MutationFunction<UserSaveQuickLinksMutation, UserSaveQuickLinksMutationVariables>;

/**
 * __useUserSaveQuickLinksMutation__
 *
 * To run a mutation, you first call `useUserSaveQuickLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSaveQuickLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSaveQuickLinksMutation, { data, loading, error }] = useUserSaveQuickLinksMutation({
 *   variables: {
 *      id: // value for 'id'
 *      baseQuickLinks: // value for 'baseQuickLinks'
 *      quickLinks: // value for 'quickLinks'
 *   },
 * });
 */
export function useUserSaveQuickLinksMutation(baseOptions?: Apollo.MutationHookOptions<UserSaveQuickLinksMutation, UserSaveQuickLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSaveQuickLinksMutation, UserSaveQuickLinksMutationVariables>(UserSaveQuickLinksDocument, options);
      }
export type UserSaveQuickLinksMutationHookResult = ReturnType<typeof useUserSaveQuickLinksMutation>;
export type UserSaveQuickLinksMutationResult = Apollo.MutationResult<UserSaveQuickLinksMutation>;
export type UserSaveQuickLinksMutationOptions = Apollo.BaseMutationOptions<UserSaveQuickLinksMutation, UserSaveQuickLinksMutationVariables>;
export const UserUpdateDocument = gql`
    mutation UserUpdate($id: MongoID!, $record: UpdateByIdUserInput!) {
  userUpdate(_id: $id, record: $record) {
    _id
    passwordResetUrl
    lastViewedListId
  }
}
    `;
export type UserUpdateMutationFn = Apollo.MutationFunction<UserUpdateMutation, UserUpdateMutationVariables>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useUserUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
      }
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = Apollo.MutationResult<UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<UserUpdateMutation, UserUpdateMutationVariables>;
export const UserValidateConfirmationCodeDocument = gql`
    mutation UserValidateConfirmationCode($id: ID!, $code: String!) {
  userValidateConfirmationCode(_id: $id, code: $code) {
    _id
  }
}
    `;
export type UserValidateConfirmationCodeMutationFn = Apollo.MutationFunction<UserValidateConfirmationCodeMutation, UserValidateConfirmationCodeMutationVariables>;

/**
 * __useUserValidateConfirmationCodeMutation__
 *
 * To run a mutation, you first call `useUserValidateConfirmationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserValidateConfirmationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userValidateConfirmationCodeMutation, { data, loading, error }] = useUserValidateConfirmationCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useUserValidateConfirmationCodeMutation(baseOptions?: Apollo.MutationHookOptions<UserValidateConfirmationCodeMutation, UserValidateConfirmationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserValidateConfirmationCodeMutation, UserValidateConfirmationCodeMutationVariables>(UserValidateConfirmationCodeDocument, options);
      }
export type UserValidateConfirmationCodeMutationHookResult = ReturnType<typeof useUserValidateConfirmationCodeMutation>;
export type UserValidateConfirmationCodeMutationResult = Apollo.MutationResult<UserValidateConfirmationCodeMutation>;
export type UserValidateConfirmationCodeMutationOptions = Apollo.BaseMutationOptions<UserValidateConfirmationCodeMutation, UserValidateConfirmationCodeMutationVariables>;
export const VideoCreateFromMuxDocument = gql`
    mutation VideoCreateFromMux($muxAssetId: String!, $muxPlaybackId: String, $muxStatus: String, $width: Int, $height: Int, $duration: Float, $bytes: Float, $defaultCaption: MultilingualInput) {
  videoCreateFromMux(
    muxAssetId: $muxAssetId
    muxPlaybackId: $muxPlaybackId
    muxStatus: $muxStatus
    width: $width
    height: $height
    duration: $duration
    bytes: $bytes
    defaultCaption: $defaultCaption
  ) {
    ...ImageFragment
    mux {
      assetId
      playbackId
      status
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export type VideoCreateFromMuxMutationFn = Apollo.MutationFunction<VideoCreateFromMuxMutation, VideoCreateFromMuxMutationVariables>;

/**
 * __useVideoCreateFromMuxMutation__
 *
 * To run a mutation, you first call `useVideoCreateFromMuxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoCreateFromMuxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoCreateFromMuxMutation, { data, loading, error }] = useVideoCreateFromMuxMutation({
 *   variables: {
 *      muxAssetId: // value for 'muxAssetId'
 *      muxPlaybackId: // value for 'muxPlaybackId'
 *      muxStatus: // value for 'muxStatus'
 *      width: // value for 'width'
 *      height: // value for 'height'
 *      duration: // value for 'duration'
 *      bytes: // value for 'bytes'
 *      defaultCaption: // value for 'defaultCaption'
 *   },
 * });
 */
export function useVideoCreateFromMuxMutation(baseOptions?: Apollo.MutationHookOptions<VideoCreateFromMuxMutation, VideoCreateFromMuxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VideoCreateFromMuxMutation, VideoCreateFromMuxMutationVariables>(VideoCreateFromMuxDocument, options);
      }
export type VideoCreateFromMuxMutationHookResult = ReturnType<typeof useVideoCreateFromMuxMutation>;
export type VideoCreateFromMuxMutationResult = Apollo.MutationResult<VideoCreateFromMuxMutation>;
export type VideoCreateFromMuxMutationOptions = Apollo.BaseMutationOptions<VideoCreateFromMuxMutation, VideoCreateFromMuxMutationVariables>;
export const VideoDeleteFromMuxOnlyDocument = gql`
    mutation VideoDeleteFromMuxOnly($muxAssetId: String!) {
  videoDeleteFromMuxOnly(muxAssetId: $muxAssetId)
}
    `;
export type VideoDeleteFromMuxOnlyMutationFn = Apollo.MutationFunction<VideoDeleteFromMuxOnlyMutation, VideoDeleteFromMuxOnlyMutationVariables>;

/**
 * __useVideoDeleteFromMuxOnlyMutation__
 *
 * To run a mutation, you first call `useVideoDeleteFromMuxOnlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoDeleteFromMuxOnlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoDeleteFromMuxOnlyMutation, { data, loading, error }] = useVideoDeleteFromMuxOnlyMutation({
 *   variables: {
 *      muxAssetId: // value for 'muxAssetId'
 *   },
 * });
 */
export function useVideoDeleteFromMuxOnlyMutation(baseOptions?: Apollo.MutationHookOptions<VideoDeleteFromMuxOnlyMutation, VideoDeleteFromMuxOnlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VideoDeleteFromMuxOnlyMutation, VideoDeleteFromMuxOnlyMutationVariables>(VideoDeleteFromMuxOnlyDocument, options);
      }
export type VideoDeleteFromMuxOnlyMutationHookResult = ReturnType<typeof useVideoDeleteFromMuxOnlyMutation>;
export type VideoDeleteFromMuxOnlyMutationResult = Apollo.MutationResult<VideoDeleteFromMuxOnlyMutation>;
export type VideoDeleteFromMuxOnlyMutationOptions = Apollo.BaseMutationOptions<VideoDeleteFromMuxOnlyMutation, VideoDeleteFromMuxOnlyMutationVariables>;
export const VideoMuxStatusRefreshDocument = gql`
    mutation VideoMuxStatusRefresh($_id: String!) {
  videoMuxStatusRefresh(_id: $_id) {
    ...ImageFragment
    mux {
      assetId
      playbackId
      status
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export type VideoMuxStatusRefreshMutationFn = Apollo.MutationFunction<VideoMuxStatusRefreshMutation, VideoMuxStatusRefreshMutationVariables>;

/**
 * __useVideoMuxStatusRefreshMutation__
 *
 * To run a mutation, you first call `useVideoMuxStatusRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoMuxStatusRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoMuxStatusRefreshMutation, { data, loading, error }] = useVideoMuxStatusRefreshMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useVideoMuxStatusRefreshMutation(baseOptions?: Apollo.MutationHookOptions<VideoMuxStatusRefreshMutation, VideoMuxStatusRefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VideoMuxStatusRefreshMutation, VideoMuxStatusRefreshMutationVariables>(VideoMuxStatusRefreshDocument, options);
      }
export type VideoMuxStatusRefreshMutationHookResult = ReturnType<typeof useVideoMuxStatusRefreshMutation>;
export type VideoMuxStatusRefreshMutationResult = Apollo.MutationResult<VideoMuxStatusRefreshMutation>;
export type VideoMuxStatusRefreshMutationOptions = Apollo.BaseMutationOptions<VideoMuxStatusRefreshMutation, VideoMuxStatusRefreshMutationVariables>;
export const WhereabotChatCreateDocument = gql`
    mutation WhereabotChatCreate($title: String) {
  whereabotChatCreate(title: $title) {
    _id
    title
    createdBy {
      _id
      firstName
      lastName
      picture
    }
    chatModel
    status
    createdDateISO
  }
}
    `;
export type WhereabotChatCreateMutationFn = Apollo.MutationFunction<WhereabotChatCreateMutation, WhereabotChatCreateMutationVariables>;

/**
 * __useWhereabotChatCreateMutation__
 *
 * To run a mutation, you first call `useWhereabotChatCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWhereabotChatCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [whereabotChatCreateMutation, { data, loading, error }] = useWhereabotChatCreateMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useWhereabotChatCreateMutation(baseOptions?: Apollo.MutationHookOptions<WhereabotChatCreateMutation, WhereabotChatCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WhereabotChatCreateMutation, WhereabotChatCreateMutationVariables>(WhereabotChatCreateDocument, options);
      }
export type WhereabotChatCreateMutationHookResult = ReturnType<typeof useWhereabotChatCreateMutation>;
export type WhereabotChatCreateMutationResult = Apollo.MutationResult<WhereabotChatCreateMutation>;
export type WhereabotChatCreateMutationOptions = Apollo.BaseMutationOptions<WhereabotChatCreateMutation, WhereabotChatCreateMutationVariables>;
export const WhereabotChatSendMessageDocument = gql`
    mutation WhereabotChatSendMessage($chatId: MongoID!, $content: String!) {
  whereabotChatSendMessage(chatId: $chatId, content: $content) {
    _id
    chat
    role
    content
    isError
    operatorResults {
      operatorEntityId
      operatorName
      operatorType
      organizationId
      score
      isRelated
    }
    metadata {
      embeddingTimeMs
      searchTimeMs
      llmTimeMs
      totalTimeMs
      operatorsSearched
    }
    createdDateISO
  }
}
    `;
export type WhereabotChatSendMessageMutationFn = Apollo.MutationFunction<WhereabotChatSendMessageMutation, WhereabotChatSendMessageMutationVariables>;

/**
 * __useWhereabotChatSendMessageMutation__
 *
 * To run a mutation, you first call `useWhereabotChatSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWhereabotChatSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [whereabotChatSendMessageMutation, { data, loading, error }] = useWhereabotChatSendMessageMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useWhereabotChatSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<WhereabotChatSendMessageMutation, WhereabotChatSendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WhereabotChatSendMessageMutation, WhereabotChatSendMessageMutationVariables>(WhereabotChatSendMessageDocument, options);
      }
export type WhereabotChatSendMessageMutationHookResult = ReturnType<typeof useWhereabotChatSendMessageMutation>;
export type WhereabotChatSendMessageMutationResult = Apollo.MutationResult<WhereabotChatSendMessageMutation>;
export type WhereabotChatSendMessageMutationOptions = Apollo.BaseMutationOptions<WhereabotChatSendMessageMutation, WhereabotChatSendMessageMutationVariables>;
export const WhereabotChatUpdateDocument = gql`
    mutation WhereabotChatUpdate($_id: MongoID!, $title: String, $rating: Int, $notes: String, $status: String) {
  whereabotChatUpdate(
    _id: $_id
    title: $title
    rating: $rating
    notes: $notes
    status: $status
  ) {
    _id
    title
    rating
    notes
    status
    updatedDateISO
  }
}
    `;
export type WhereabotChatUpdateMutationFn = Apollo.MutationFunction<WhereabotChatUpdateMutation, WhereabotChatUpdateMutationVariables>;

/**
 * __useWhereabotChatUpdateMutation__
 *
 * To run a mutation, you first call `useWhereabotChatUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWhereabotChatUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [whereabotChatUpdateMutation, { data, loading, error }] = useWhereabotChatUpdateMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      title: // value for 'title'
 *      rating: // value for 'rating'
 *      notes: // value for 'notes'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useWhereabotChatUpdateMutation(baseOptions?: Apollo.MutationHookOptions<WhereabotChatUpdateMutation, WhereabotChatUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WhereabotChatUpdateMutation, WhereabotChatUpdateMutationVariables>(WhereabotChatUpdateDocument, options);
      }
export type WhereabotChatUpdateMutationHookResult = ReturnType<typeof useWhereabotChatUpdateMutation>;
export type WhereabotChatUpdateMutationResult = Apollo.MutationResult<WhereabotChatUpdateMutation>;
export type WhereabotChatUpdateMutationOptions = Apollo.BaseMutationOptions<WhereabotChatUpdateMutation, WhereabotChatUpdateMutationVariables>;
export const WhereabotHelpAskDocument = gql`
    mutation WhereabotHelpAsk($question: String!, $history: [WhereabotHelpMessageInput!]) {
  whereabotHelpAsk(question: $question, history: $history) {
    answer
  }
}
    `;
export type WhereabotHelpAskMutationFn = Apollo.MutationFunction<WhereabotHelpAskMutation, WhereabotHelpAskMutationVariables>;

/**
 * __useWhereabotHelpAskMutation__
 *
 * To run a mutation, you first call `useWhereabotHelpAskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWhereabotHelpAskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [whereabotHelpAskMutation, { data, loading, error }] = useWhereabotHelpAskMutation({
 *   variables: {
 *      question: // value for 'question'
 *      history: // value for 'history'
 *   },
 * });
 */
export function useWhereabotHelpAskMutation(baseOptions?: Apollo.MutationHookOptions<WhereabotHelpAskMutation, WhereabotHelpAskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WhereabotHelpAskMutation, WhereabotHelpAskMutationVariables>(WhereabotHelpAskDocument, options);
      }
export type WhereabotHelpAskMutationHookResult = ReturnType<typeof useWhereabotHelpAskMutation>;
export type WhereabotHelpAskMutationResult = Apollo.MutationResult<WhereabotHelpAskMutation>;
export type WhereabotHelpAskMutationOptions = Apollo.BaseMutationOptions<WhereabotHelpAskMutation, WhereabotHelpAskMutationVariables>;
export const WhereabotSettingsUpdateDocument = gql`
    mutation WhereabotSettingsUpdate($chatModel: String!) {
  whereabotSettingsUpdate(chatModel: $chatModel) {
    _id
    chatModel
    updatedBy
    updatedDateISO
  }
}
    `;
export type WhereabotSettingsUpdateMutationFn = Apollo.MutationFunction<WhereabotSettingsUpdateMutation, WhereabotSettingsUpdateMutationVariables>;

/**
 * __useWhereabotSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useWhereabotSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWhereabotSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [whereabotSettingsUpdateMutation, { data, loading, error }] = useWhereabotSettingsUpdateMutation({
 *   variables: {
 *      chatModel: // value for 'chatModel'
 *   },
 * });
 */
export function useWhereabotSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<WhereabotSettingsUpdateMutation, WhereabotSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WhereabotSettingsUpdateMutation, WhereabotSettingsUpdateMutationVariables>(WhereabotSettingsUpdateDocument, options);
      }
export type WhereabotSettingsUpdateMutationHookResult = ReturnType<typeof useWhereabotSettingsUpdateMutation>;
export type WhereabotSettingsUpdateMutationResult = Apollo.MutationResult<WhereabotSettingsUpdateMutation>;
export type WhereabotSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<WhereabotSettingsUpdateMutation, WhereabotSettingsUpdateMutationVariables>;
export const WidgetCreateDocument = gql`
    mutation WidgetCreate($record: CreateOneWidgetInput!) {
  widgetCreate(record: $record) {
    record {
      _id
      name {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type WidgetCreateMutationFn = Apollo.MutationFunction<WidgetCreateMutation, WidgetCreateMutationVariables>;

/**
 * __useWidgetCreateMutation__
 *
 * To run a mutation, you first call `useWidgetCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetCreateMutation, { data, loading, error }] = useWidgetCreateMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useWidgetCreateMutation(baseOptions?: Apollo.MutationHookOptions<WidgetCreateMutation, WidgetCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetCreateMutation, WidgetCreateMutationVariables>(WidgetCreateDocument, options);
      }
export type WidgetCreateMutationHookResult = ReturnType<typeof useWidgetCreateMutation>;
export type WidgetCreateMutationResult = Apollo.MutationResult<WidgetCreateMutation>;
export type WidgetCreateMutationOptions = Apollo.BaseMutationOptions<WidgetCreateMutation, WidgetCreateMutationVariables>;
export const WidgetDeleteByIdDocument = gql`
    mutation WidgetDeleteById($id: MongoID!) {
  widgetDeleteById(_id: $id) {
    record {
      _id
    }
  }
}
    `;
export type WidgetDeleteByIdMutationFn = Apollo.MutationFunction<WidgetDeleteByIdMutation, WidgetDeleteByIdMutationVariables>;

/**
 * __useWidgetDeleteByIdMutation__
 *
 * To run a mutation, you first call `useWidgetDeleteByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetDeleteByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetDeleteByIdMutation, { data, loading, error }] = useWidgetDeleteByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetDeleteByIdMutation(baseOptions?: Apollo.MutationHookOptions<WidgetDeleteByIdMutation, WidgetDeleteByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetDeleteByIdMutation, WidgetDeleteByIdMutationVariables>(WidgetDeleteByIdDocument, options);
      }
export type WidgetDeleteByIdMutationHookResult = ReturnType<typeof useWidgetDeleteByIdMutation>;
export type WidgetDeleteByIdMutationResult = Apollo.MutationResult<WidgetDeleteByIdMutation>;
export type WidgetDeleteByIdMutationOptions = Apollo.BaseMutationOptions<WidgetDeleteByIdMutation, WidgetDeleteByIdMutationVariables>;
export const WidgetUpdateByIdDocument = gql`
    mutation WidgetUpdateById($id: MongoID!, $record: UpdateByIdWidgetInput!) {
  widgetUpdateById(_id: $id, record: $record) {
    record {
      _id
      name {
        ...MultilingualFragment
      }
      description {
        ...MultilingualFragment
      }
      favorited
      archived
      eventSettings {
        displayType
        eventTags
        hiddenPublicFilterTags
        publicFilterMode
        publicFilterSort
        shownPublicFilterTags
        lookAheadMonths
        startMonth
        hideCancelledEvents
      }
      gallerySettings {
        items
        enableUrlPush
        playerPagePath
        profilePageEnabled
        allMedia
        infiniteScroll {
          enabled
          mediaTagFilters
          listingFilters
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;
export type WidgetUpdateByIdMutationFn = Apollo.MutationFunction<WidgetUpdateByIdMutation, WidgetUpdateByIdMutationVariables>;

/**
 * __useWidgetUpdateByIdMutation__
 *
 * To run a mutation, you first call `useWidgetUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWidgetUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [widgetUpdateByIdMutation, { data, loading, error }] = useWidgetUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useWidgetUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<WidgetUpdateByIdMutation, WidgetUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WidgetUpdateByIdMutation, WidgetUpdateByIdMutationVariables>(WidgetUpdateByIdDocument, options);
      }
export type WidgetUpdateByIdMutationHookResult = ReturnType<typeof useWidgetUpdateByIdMutation>;
export type WidgetUpdateByIdMutationResult = Apollo.MutationResult<WidgetUpdateByIdMutation>;
export type WidgetUpdateByIdMutationOptions = Apollo.BaseMutationOptions<WidgetUpdateByIdMutation, WidgetUpdateByIdMutationVariables>;
export const WorkbenchChatCreateDocument = gql`
    mutation WorkbenchChatCreate($featureFlagKey: String!, $testOrganizationId: MongoID) {
  workbenchChatCreate(
    featureFlagKey: $featureFlagKey
    testOrganizationId: $testOrganizationId
  ) {
    _id
    title
    status
    featureFlagKey
    testOrganizationId
  }
}
    `;
export type WorkbenchChatCreateMutationFn = Apollo.MutationFunction<WorkbenchChatCreateMutation, WorkbenchChatCreateMutationVariables>;

/**
 * __useWorkbenchChatCreateMutation__
 *
 * To run a mutation, you first call `useWorkbenchChatCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchChatCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchChatCreateMutation, { data, loading, error }] = useWorkbenchChatCreateMutation({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *      testOrganizationId: // value for 'testOrganizationId'
 *   },
 * });
 */
export function useWorkbenchChatCreateMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchChatCreateMutation, WorkbenchChatCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchChatCreateMutation, WorkbenchChatCreateMutationVariables>(WorkbenchChatCreateDocument, options);
      }
export type WorkbenchChatCreateMutationHookResult = ReturnType<typeof useWorkbenchChatCreateMutation>;
export type WorkbenchChatCreateMutationResult = Apollo.MutationResult<WorkbenchChatCreateMutation>;
export type WorkbenchChatCreateMutationOptions = Apollo.BaseMutationOptions<WorkbenchChatCreateMutation, WorkbenchChatCreateMutationVariables>;
export const WorkbenchChatSendMessageDocument = gql`
    mutation WorkbenchChatSendMessage($chatId: MongoID!, $content: String!, $sessionEvents: [WorkbenchSessionEventInput!]) {
  workbenchChatSendMessage(
    chatId: $chatId
    content: $content
    sessionEvents: $sessionEvents
  ) {
    ...WorkbenchMessageFields
  }
}
    ${WorkbenchMessageFieldsFragmentDoc}`;
export type WorkbenchChatSendMessageMutationFn = Apollo.MutationFunction<WorkbenchChatSendMessageMutation, WorkbenchChatSendMessageMutationVariables>;

/**
 * __useWorkbenchChatSendMessageMutation__
 *
 * To run a mutation, you first call `useWorkbenchChatSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchChatSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchChatSendMessageMutation, { data, loading, error }] = useWorkbenchChatSendMessageMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      content: // value for 'content'
 *      sessionEvents: // value for 'sessionEvents'
 *   },
 * });
 */
export function useWorkbenchChatSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchChatSendMessageMutation, WorkbenchChatSendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchChatSendMessageMutation, WorkbenchChatSendMessageMutationVariables>(WorkbenchChatSendMessageDocument, options);
      }
export type WorkbenchChatSendMessageMutationHookResult = ReturnType<typeof useWorkbenchChatSendMessageMutation>;
export type WorkbenchChatSendMessageMutationResult = Apollo.MutationResult<WorkbenchChatSendMessageMutation>;
export type WorkbenchChatSendMessageMutationOptions = Apollo.BaseMutationOptions<WorkbenchChatSendMessageMutation, WorkbenchChatSendMessageMutationVariables>;
export const WorkbenchSuggestionAcceptDocument = gql`
    mutation WorkbenchSuggestionAccept($_id: MongoID!) {
  workbenchSuggestionAccept(_id: $_id) {
    ...WorkbenchSuggestionFields
  }
}
    ${WorkbenchSuggestionFieldsFragmentDoc}`;
export type WorkbenchSuggestionAcceptMutationFn = Apollo.MutationFunction<WorkbenchSuggestionAcceptMutation, WorkbenchSuggestionAcceptMutationVariables>;

/**
 * __useWorkbenchSuggestionAcceptMutation__
 *
 * To run a mutation, you first call `useWorkbenchSuggestionAcceptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchSuggestionAcceptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchSuggestionAcceptMutation, { data, loading, error }] = useWorkbenchSuggestionAcceptMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useWorkbenchSuggestionAcceptMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchSuggestionAcceptMutation, WorkbenchSuggestionAcceptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchSuggestionAcceptMutation, WorkbenchSuggestionAcceptMutationVariables>(WorkbenchSuggestionAcceptDocument, options);
      }
export type WorkbenchSuggestionAcceptMutationHookResult = ReturnType<typeof useWorkbenchSuggestionAcceptMutation>;
export type WorkbenchSuggestionAcceptMutationResult = Apollo.MutationResult<WorkbenchSuggestionAcceptMutation>;
export type WorkbenchSuggestionAcceptMutationOptions = Apollo.BaseMutationOptions<WorkbenchSuggestionAcceptMutation, WorkbenchSuggestionAcceptMutationVariables>;
export const WorkbenchSuggestionDismissDocument = gql`
    mutation WorkbenchSuggestionDismiss($_id: MongoID!) {
  workbenchSuggestionDismiss(_id: $_id) {
    ...WorkbenchSuggestionFields
  }
}
    ${WorkbenchSuggestionFieldsFragmentDoc}`;
export type WorkbenchSuggestionDismissMutationFn = Apollo.MutationFunction<WorkbenchSuggestionDismissMutation, WorkbenchSuggestionDismissMutationVariables>;

/**
 * __useWorkbenchSuggestionDismissMutation__
 *
 * To run a mutation, you first call `useWorkbenchSuggestionDismissMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchSuggestionDismissMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchSuggestionDismissMutation, { data, loading, error }] = useWorkbenchSuggestionDismissMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useWorkbenchSuggestionDismissMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchSuggestionDismissMutation, WorkbenchSuggestionDismissMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchSuggestionDismissMutation, WorkbenchSuggestionDismissMutationVariables>(WorkbenchSuggestionDismissDocument, options);
      }
export type WorkbenchSuggestionDismissMutationHookResult = ReturnType<typeof useWorkbenchSuggestionDismissMutation>;
export type WorkbenchSuggestionDismissMutationResult = Apollo.MutationResult<WorkbenchSuggestionDismissMutation>;
export type WorkbenchSuggestionDismissMutationOptions = Apollo.BaseMutationOptions<WorkbenchSuggestionDismissMutation, WorkbenchSuggestionDismissMutationVariables>;
export const WorkbenchSuggestionUpdateStatusDocument = gql`
    mutation WorkbenchSuggestionUpdateStatus($_id: MongoID!, $status: String!) {
  workbenchSuggestionUpdateStatus(_id: $_id, status: $status) {
    ...WorkbenchSuggestionFields
  }
}
    ${WorkbenchSuggestionFieldsFragmentDoc}`;
export type WorkbenchSuggestionUpdateStatusMutationFn = Apollo.MutationFunction<WorkbenchSuggestionUpdateStatusMutation, WorkbenchSuggestionUpdateStatusMutationVariables>;

/**
 * __useWorkbenchSuggestionUpdateStatusMutation__
 *
 * To run a mutation, you first call `useWorkbenchSuggestionUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchSuggestionUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchSuggestionUpdateStatusMutation, { data, loading, error }] = useWorkbenchSuggestionUpdateStatusMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useWorkbenchSuggestionUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchSuggestionUpdateStatusMutation, WorkbenchSuggestionUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchSuggestionUpdateStatusMutation, WorkbenchSuggestionUpdateStatusMutationVariables>(WorkbenchSuggestionUpdateStatusDocument, options);
      }
export type WorkbenchSuggestionUpdateStatusMutationHookResult = ReturnType<typeof useWorkbenchSuggestionUpdateStatusMutation>;
export type WorkbenchSuggestionUpdateStatusMutationResult = Apollo.MutationResult<WorkbenchSuggestionUpdateStatusMutation>;
export type WorkbenchSuggestionUpdateStatusMutationOptions = Apollo.BaseMutationOptions<WorkbenchSuggestionUpdateStatusMutation, WorkbenchSuggestionUpdateStatusMutationVariables>;
export const WorkbenchReviewCompleteDocument = gql`
    mutation WorkbenchReviewComplete($chatId: MongoID!) {
  workbenchReviewComplete(chatId: $chatId) {
    _id
    status
    reviewSummary
    reviewCompletedAt
  }
}
    `;
export type WorkbenchReviewCompleteMutationFn = Apollo.MutationFunction<WorkbenchReviewCompleteMutation, WorkbenchReviewCompleteMutationVariables>;

/**
 * __useWorkbenchReviewCompleteMutation__
 *
 * To run a mutation, you first call `useWorkbenchReviewCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchReviewCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchReviewCompleteMutation, { data, loading, error }] = useWorkbenchReviewCompleteMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useWorkbenchReviewCompleteMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchReviewCompleteMutation, WorkbenchReviewCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchReviewCompleteMutation, WorkbenchReviewCompleteMutationVariables>(WorkbenchReviewCompleteDocument, options);
      }
export type WorkbenchReviewCompleteMutationHookResult = ReturnType<typeof useWorkbenchReviewCompleteMutation>;
export type WorkbenchReviewCompleteMutationResult = Apollo.MutationResult<WorkbenchReviewCompleteMutation>;
export type WorkbenchReviewCompleteMutationOptions = Apollo.BaseMutationOptions<WorkbenchReviewCompleteMutation, WorkbenchReviewCompleteMutationVariables>;
export const WorkbenchChangeRequestSummaryDocument = gql`
    mutation WorkbenchChangeRequestSummary($featureFlagKey: String!, $target: String!, $regenerate: Boolean) {
  workbenchChangeRequestSummary(
    featureFlagKey: $featureFlagKey
    target: $target
    regenerate: $regenerate
  ) {
    ...WorkbenchChangeRequestFields
  }
}
    ${WorkbenchChangeRequestFieldsFragmentDoc}`;
export type WorkbenchChangeRequestSummaryMutationFn = Apollo.MutationFunction<WorkbenchChangeRequestSummaryMutation, WorkbenchChangeRequestSummaryMutationVariables>;

/**
 * __useWorkbenchChangeRequestSummaryMutation__
 *
 * To run a mutation, you first call `useWorkbenchChangeRequestSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchChangeRequestSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchChangeRequestSummaryMutation, { data, loading, error }] = useWorkbenchChangeRequestSummaryMutation({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *      target: // value for 'target'
 *      regenerate: // value for 'regenerate'
 *   },
 * });
 */
export function useWorkbenchChangeRequestSummaryMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchChangeRequestSummaryMutation, WorkbenchChangeRequestSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchChangeRequestSummaryMutation, WorkbenchChangeRequestSummaryMutationVariables>(WorkbenchChangeRequestSummaryDocument, options);
      }
export type WorkbenchChangeRequestSummaryMutationHookResult = ReturnType<typeof useWorkbenchChangeRequestSummaryMutation>;
export type WorkbenchChangeRequestSummaryMutationResult = Apollo.MutationResult<WorkbenchChangeRequestSummaryMutation>;
export type WorkbenchChangeRequestSummaryMutationOptions = Apollo.BaseMutationOptions<WorkbenchChangeRequestSummaryMutation, WorkbenchChangeRequestSummaryMutationVariables>;
export const WorkbenchChangeRequestsMarkIntegratedDocument = gql`
    mutation WorkbenchChangeRequestsMarkIntegrated($featureFlagKey: String!, $target: String, $suggestionIds: [MongoID!]) {
  workbenchChangeRequestsMarkIntegrated(
    featureFlagKey: $featureFlagKey
    target: $target
    suggestionIds: $suggestionIds
  )
}
    `;
export type WorkbenchChangeRequestsMarkIntegratedMutationFn = Apollo.MutationFunction<WorkbenchChangeRequestsMarkIntegratedMutation, WorkbenchChangeRequestsMarkIntegratedMutationVariables>;

/**
 * __useWorkbenchChangeRequestsMarkIntegratedMutation__
 *
 * To run a mutation, you first call `useWorkbenchChangeRequestsMarkIntegratedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchChangeRequestsMarkIntegratedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchChangeRequestsMarkIntegratedMutation, { data, loading, error }] = useWorkbenchChangeRequestsMarkIntegratedMutation({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *      target: // value for 'target'
 *      suggestionIds: // value for 'suggestionIds'
 *   },
 * });
 */
export function useWorkbenchChangeRequestsMarkIntegratedMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchChangeRequestsMarkIntegratedMutation, WorkbenchChangeRequestsMarkIntegratedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchChangeRequestsMarkIntegratedMutation, WorkbenchChangeRequestsMarkIntegratedMutationVariables>(WorkbenchChangeRequestsMarkIntegratedDocument, options);
      }
export type WorkbenchChangeRequestsMarkIntegratedMutationHookResult = ReturnType<typeof useWorkbenchChangeRequestsMarkIntegratedMutation>;
export type WorkbenchChangeRequestsMarkIntegratedMutationResult = Apollo.MutationResult<WorkbenchChangeRequestsMarkIntegratedMutation>;
export type WorkbenchChangeRequestsMarkIntegratedMutationOptions = Apollo.BaseMutationOptions<WorkbenchChangeRequestsMarkIntegratedMutation, WorkbenchChangeRequestsMarkIntegratedMutationVariables>;
export const WorkbenchSetHelpScoutUrlDocument = gql`
    mutation WorkbenchSetHelpScoutUrl($featureFlagKey: String!, $url: String) {
  workbenchSetHelpScoutUrl(featureFlagKey: $featureFlagKey, url: $url) {
    _id
    helpScoutArticleUrl
  }
}
    `;
export type WorkbenchSetHelpScoutUrlMutationFn = Apollo.MutationFunction<WorkbenchSetHelpScoutUrlMutation, WorkbenchSetHelpScoutUrlMutationVariables>;

/**
 * __useWorkbenchSetHelpScoutUrlMutation__
 *
 * To run a mutation, you first call `useWorkbenchSetHelpScoutUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchSetHelpScoutUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchSetHelpScoutUrlMutation, { data, loading, error }] = useWorkbenchSetHelpScoutUrlMutation({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useWorkbenchSetHelpScoutUrlMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchSetHelpScoutUrlMutation, WorkbenchSetHelpScoutUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchSetHelpScoutUrlMutation, WorkbenchSetHelpScoutUrlMutationVariables>(WorkbenchSetHelpScoutUrlDocument, options);
      }
export type WorkbenchSetHelpScoutUrlMutationHookResult = ReturnType<typeof useWorkbenchSetHelpScoutUrlMutation>;
export type WorkbenchSetHelpScoutUrlMutationResult = Apollo.MutationResult<WorkbenchSetHelpScoutUrlMutation>;
export type WorkbenchSetHelpScoutUrlMutationOptions = Apollo.BaseMutationOptions<WorkbenchSetHelpScoutUrlMutation, WorkbenchSetHelpScoutUrlMutationVariables>;
export const WorkbenchSettingsUpdateDocument = gql`
    mutation WorkbenchSettingsUpdate($defaultTestOrganizationId: MongoID, $defaultTestStorefrontId: MongoID, $allowSeedingInProduction: Boolean, $chatModel: WorkbenchModelTierInput, $summaryModel: WorkbenchModelTierInput) {
  workbenchSettingsUpdate(
    defaultTestOrganizationId: $defaultTestOrganizationId
    defaultTestStorefrontId: $defaultTestStorefrontId
    allowSeedingInProduction: $allowSeedingInProduction
    chatModel: $chatModel
    summaryModel: $summaryModel
  )
}
    `;
export type WorkbenchSettingsUpdateMutationFn = Apollo.MutationFunction<WorkbenchSettingsUpdateMutation, WorkbenchSettingsUpdateMutationVariables>;

/**
 * __useWorkbenchSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useWorkbenchSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchSettingsUpdateMutation, { data, loading, error }] = useWorkbenchSettingsUpdateMutation({
 *   variables: {
 *      defaultTestOrganizationId: // value for 'defaultTestOrganizationId'
 *      defaultTestStorefrontId: // value for 'defaultTestStorefrontId'
 *      allowSeedingInProduction: // value for 'allowSeedingInProduction'
 *      chatModel: // value for 'chatModel'
 *      summaryModel: // value for 'summaryModel'
 *   },
 * });
 */
export function useWorkbenchSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchSettingsUpdateMutation, WorkbenchSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchSettingsUpdateMutation, WorkbenchSettingsUpdateMutationVariables>(WorkbenchSettingsUpdateDocument, options);
      }
export type WorkbenchSettingsUpdateMutationHookResult = ReturnType<typeof useWorkbenchSettingsUpdateMutation>;
export type WorkbenchSettingsUpdateMutationResult = Apollo.MutationResult<WorkbenchSettingsUpdateMutation>;
export type WorkbenchSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<WorkbenchSettingsUpdateMutation, WorkbenchSettingsUpdateMutationVariables>;
export const WorkbenchSetTestOrganizationDocument = gql`
    mutation WorkbenchSetTestOrganization($featureFlagKey: String!, $organizationId: MongoID) {
  workbenchSetTestOrganization(
    featureFlagKey: $featureFlagKey
    organizationId: $organizationId
  ) {
    _id
    testOrganizationId
    effectiveTestOrganizationId
    effectiveTestOrganizationName
  }
}
    `;
export type WorkbenchSetTestOrganizationMutationFn = Apollo.MutationFunction<WorkbenchSetTestOrganizationMutation, WorkbenchSetTestOrganizationMutationVariables>;

/**
 * __useWorkbenchSetTestOrganizationMutation__
 *
 * To run a mutation, you first call `useWorkbenchSetTestOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchSetTestOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchSetTestOrganizationMutation, { data, loading, error }] = useWorkbenchSetTestOrganizationMutation({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useWorkbenchSetTestOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchSetTestOrganizationMutation, WorkbenchSetTestOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchSetTestOrganizationMutation, WorkbenchSetTestOrganizationMutationVariables>(WorkbenchSetTestOrganizationDocument, options);
      }
export type WorkbenchSetTestOrganizationMutationHookResult = ReturnType<typeof useWorkbenchSetTestOrganizationMutation>;
export type WorkbenchSetTestOrganizationMutationResult = Apollo.MutationResult<WorkbenchSetTestOrganizationMutation>;
export type WorkbenchSetTestOrganizationMutationOptions = Apollo.BaseMutationOptions<WorkbenchSetTestOrganizationMutation, WorkbenchSetTestOrganizationMutationVariables>;
export const WorkbenchSeedPreviewDocument = gql`
    mutation WorkbenchSeedPreview($scenarioKey: String!, $organizationId: MongoID!) {
  workbenchSeedPreview(scenarioKey: $scenarioKey, organizationId: $organizationId) {
    counts {
      label
      count
    }
    sampleNames
    notes
  }
}
    `;
export type WorkbenchSeedPreviewMutationFn = Apollo.MutationFunction<WorkbenchSeedPreviewMutation, WorkbenchSeedPreviewMutationVariables>;

/**
 * __useWorkbenchSeedPreviewMutation__
 *
 * To run a mutation, you first call `useWorkbenchSeedPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchSeedPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchSeedPreviewMutation, { data, loading, error }] = useWorkbenchSeedPreviewMutation({
 *   variables: {
 *      scenarioKey: // value for 'scenarioKey'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useWorkbenchSeedPreviewMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchSeedPreviewMutation, WorkbenchSeedPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchSeedPreviewMutation, WorkbenchSeedPreviewMutationVariables>(WorkbenchSeedPreviewDocument, options);
      }
export type WorkbenchSeedPreviewMutationHookResult = ReturnType<typeof useWorkbenchSeedPreviewMutation>;
export type WorkbenchSeedPreviewMutationResult = Apollo.MutationResult<WorkbenchSeedPreviewMutation>;
export type WorkbenchSeedPreviewMutationOptions = Apollo.BaseMutationOptions<WorkbenchSeedPreviewMutation, WorkbenchSeedPreviewMutationVariables>;
export const WorkbenchSeedCreateDocument = gql`
    mutation WorkbenchSeedCreate($scenarioKey: String!, $organizationId: MongoID!) {
  workbenchSeedCreate(scenarioKey: $scenarioKey, organizationId: $organizationId) {
    ...WorkbenchSeedRunFields
  }
}
    ${WorkbenchSeedRunFieldsFragmentDoc}`;
export type WorkbenchSeedCreateMutationFn = Apollo.MutationFunction<WorkbenchSeedCreateMutation, WorkbenchSeedCreateMutationVariables>;

/**
 * __useWorkbenchSeedCreateMutation__
 *
 * To run a mutation, you first call `useWorkbenchSeedCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchSeedCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchSeedCreateMutation, { data, loading, error }] = useWorkbenchSeedCreateMutation({
 *   variables: {
 *      scenarioKey: // value for 'scenarioKey'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useWorkbenchSeedCreateMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchSeedCreateMutation, WorkbenchSeedCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchSeedCreateMutation, WorkbenchSeedCreateMutationVariables>(WorkbenchSeedCreateDocument, options);
      }
export type WorkbenchSeedCreateMutationHookResult = ReturnType<typeof useWorkbenchSeedCreateMutation>;
export type WorkbenchSeedCreateMutationResult = Apollo.MutationResult<WorkbenchSeedCreateMutation>;
export type WorkbenchSeedCreateMutationOptions = Apollo.BaseMutationOptions<WorkbenchSeedCreateMutation, WorkbenchSeedCreateMutationVariables>;
export const WorkbenchSeedRegenerateDocument = gql`
    mutation WorkbenchSeedRegenerate($runId: MongoID!) {
  workbenchSeedRegenerate(runId: $runId) {
    ...WorkbenchSeedRunFields
  }
}
    ${WorkbenchSeedRunFieldsFragmentDoc}`;
export type WorkbenchSeedRegenerateMutationFn = Apollo.MutationFunction<WorkbenchSeedRegenerateMutation, WorkbenchSeedRegenerateMutationVariables>;

/**
 * __useWorkbenchSeedRegenerateMutation__
 *
 * To run a mutation, you first call `useWorkbenchSeedRegenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchSeedRegenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchSeedRegenerateMutation, { data, loading, error }] = useWorkbenchSeedRegenerateMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useWorkbenchSeedRegenerateMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchSeedRegenerateMutation, WorkbenchSeedRegenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchSeedRegenerateMutation, WorkbenchSeedRegenerateMutationVariables>(WorkbenchSeedRegenerateDocument, options);
      }
export type WorkbenchSeedRegenerateMutationHookResult = ReturnType<typeof useWorkbenchSeedRegenerateMutation>;
export type WorkbenchSeedRegenerateMutationResult = Apollo.MutationResult<WorkbenchSeedRegenerateMutation>;
export type WorkbenchSeedRegenerateMutationOptions = Apollo.BaseMutationOptions<WorkbenchSeedRegenerateMutation, WorkbenchSeedRegenerateMutationVariables>;
export const WorkbenchSeedCleanupDocument = gql`
    mutation WorkbenchSeedCleanup($runId: MongoID!) {
  workbenchSeedCleanup(runId: $runId) {
    ...WorkbenchSeedRunFields
  }
}
    ${WorkbenchSeedRunFieldsFragmentDoc}`;
export type WorkbenchSeedCleanupMutationFn = Apollo.MutationFunction<WorkbenchSeedCleanupMutation, WorkbenchSeedCleanupMutationVariables>;

/**
 * __useWorkbenchSeedCleanupMutation__
 *
 * To run a mutation, you first call `useWorkbenchSeedCleanupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchSeedCleanupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchSeedCleanupMutation, { data, loading, error }] = useWorkbenchSeedCleanupMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useWorkbenchSeedCleanupMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchSeedCleanupMutation, WorkbenchSeedCleanupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchSeedCleanupMutation, WorkbenchSeedCleanupMutationVariables>(WorkbenchSeedCleanupDocument, options);
      }
export type WorkbenchSeedCleanupMutationHookResult = ReturnType<typeof useWorkbenchSeedCleanupMutation>;
export type WorkbenchSeedCleanupMutationResult = Apollo.MutationResult<WorkbenchSeedCleanupMutation>;
export type WorkbenchSeedCleanupMutationOptions = Apollo.BaseMutationOptions<WorkbenchSeedCleanupMutation, WorkbenchSeedCleanupMutationVariables>;
export const WorkbenchTesterAddDocument = gql`
    mutation WorkbenchTesterAdd($featureFlagKey: String!, $userIds: [MongoID!]!) {
  workbenchTesterAdd(featureFlagKey: $featureFlagKey, userIds: $userIds) {
    _id
    testerUsers {
      ...WorkbenchTesterFields
    }
  }
}
    ${WorkbenchTesterFieldsFragmentDoc}`;
export type WorkbenchTesterAddMutationFn = Apollo.MutationFunction<WorkbenchTesterAddMutation, WorkbenchTesterAddMutationVariables>;

/**
 * __useWorkbenchTesterAddMutation__
 *
 * To run a mutation, you first call `useWorkbenchTesterAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchTesterAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchTesterAddMutation, { data, loading, error }] = useWorkbenchTesterAddMutation({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useWorkbenchTesterAddMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchTesterAddMutation, WorkbenchTesterAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchTesterAddMutation, WorkbenchTesterAddMutationVariables>(WorkbenchTesterAddDocument, options);
      }
export type WorkbenchTesterAddMutationHookResult = ReturnType<typeof useWorkbenchTesterAddMutation>;
export type WorkbenchTesterAddMutationResult = Apollo.MutationResult<WorkbenchTesterAddMutation>;
export type WorkbenchTesterAddMutationOptions = Apollo.BaseMutationOptions<WorkbenchTesterAddMutation, WorkbenchTesterAddMutationVariables>;
export const WorkbenchTesterRemoveDocument = gql`
    mutation WorkbenchTesterRemove($featureFlagKey: String!, $userId: MongoID!) {
  workbenchTesterRemove(featureFlagKey: $featureFlagKey, userId: $userId) {
    _id
    testerUsers {
      ...WorkbenchTesterFields
    }
  }
}
    ${WorkbenchTesterFieldsFragmentDoc}`;
export type WorkbenchTesterRemoveMutationFn = Apollo.MutationFunction<WorkbenchTesterRemoveMutation, WorkbenchTesterRemoveMutationVariables>;

/**
 * __useWorkbenchTesterRemoveMutation__
 *
 * To run a mutation, you first call `useWorkbenchTesterRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchTesterRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchTesterRemoveMutation, { data, loading, error }] = useWorkbenchTesterRemoveMutation({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useWorkbenchTesterRemoveMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchTesterRemoveMutation, WorkbenchTesterRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchTesterRemoveMutation, WorkbenchTesterRemoveMutationVariables>(WorkbenchTesterRemoveDocument, options);
      }
export type WorkbenchTesterRemoveMutationHookResult = ReturnType<typeof useWorkbenchTesterRemoveMutation>;
export type WorkbenchTesterRemoveMutationResult = Apollo.MutationResult<WorkbenchTesterRemoveMutation>;
export type WorkbenchTesterRemoveMutationOptions = Apollo.BaseMutationOptions<WorkbenchTesterRemoveMutation, WorkbenchTesterRemoveMutationVariables>;
export const WorkbenchTestersContactDocument = gql`
    mutation WorkbenchTestersContact($featureFlagKey: String!, $subject: String!, $message: String!) {
  workbenchTestersContact(
    featureFlagKey: $featureFlagKey
    subject: $subject
    message: $message
  ) {
    sent
    failed
  }
}
    `;
export type WorkbenchTestersContactMutationFn = Apollo.MutationFunction<WorkbenchTestersContactMutation, WorkbenchTestersContactMutationVariables>;

/**
 * __useWorkbenchTestersContactMutation__
 *
 * To run a mutation, you first call `useWorkbenchTestersContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchTestersContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchTestersContactMutation, { data, loading, error }] = useWorkbenchTestersContactMutation({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *      subject: // value for 'subject'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useWorkbenchTestersContactMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchTestersContactMutation, WorkbenchTestersContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchTestersContactMutation, WorkbenchTestersContactMutationVariables>(WorkbenchTestersContactDocument, options);
      }
export type WorkbenchTestersContactMutationHookResult = ReturnType<typeof useWorkbenchTestersContactMutation>;
export type WorkbenchTestersContactMutationResult = Apollo.MutationResult<WorkbenchTestersContactMutation>;
export type WorkbenchTestersContactMutationOptions = Apollo.BaseMutationOptions<WorkbenchTestersContactMutation, WorkbenchTestersContactMutationVariables>;
export const WorkbenchExpelDocument = gql`
    mutation WorkbenchExpel($featureFlagKey: String!, $reason: String!) {
  workbenchExpel(featureFlagKey: $featureFlagKey, reason: $reason) {
    success
    error
    seedRunsCleaned
  }
}
    `;
export type WorkbenchExpelMutationFn = Apollo.MutationFunction<WorkbenchExpelMutation, WorkbenchExpelMutationVariables>;

/**
 * __useWorkbenchExpelMutation__
 *
 * To run a mutation, you first call `useWorkbenchExpelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchExpelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchExpelMutation, { data, loading, error }] = useWorkbenchExpelMutation({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useWorkbenchExpelMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchExpelMutation, WorkbenchExpelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchExpelMutation, WorkbenchExpelMutationVariables>(WorkbenchExpelDocument, options);
      }
export type WorkbenchExpelMutationHookResult = ReturnType<typeof useWorkbenchExpelMutation>;
export type WorkbenchExpelMutationResult = Apollo.MutationResult<WorkbenchExpelMutation>;
export type WorkbenchExpelMutationOptions = Apollo.BaseMutationOptions<WorkbenchExpelMutation, WorkbenchExpelMutationVariables>;
export const WorkbenchReinstateDocument = gql`
    mutation WorkbenchReinstate($featureFlagKey: String!) {
  workbenchReinstate(featureFlagKey: $featureFlagKey) {
    success
    error
  }
}
    `;
export type WorkbenchReinstateMutationFn = Apollo.MutationFunction<WorkbenchReinstateMutation, WorkbenchReinstateMutationVariables>;

/**
 * __useWorkbenchReinstateMutation__
 *
 * To run a mutation, you first call `useWorkbenchReinstateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchReinstateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchReinstateMutation, { data, loading, error }] = useWorkbenchReinstateMutation({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *   },
 * });
 */
export function useWorkbenchReinstateMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchReinstateMutation, WorkbenchReinstateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchReinstateMutation, WorkbenchReinstateMutationVariables>(WorkbenchReinstateDocument, options);
      }
export type WorkbenchReinstateMutationHookResult = ReturnType<typeof useWorkbenchReinstateMutation>;
export type WorkbenchReinstateMutationResult = Apollo.MutationResult<WorkbenchReinstateMutation>;
export type WorkbenchReinstateMutationOptions = Apollo.BaseMutationOptions<WorkbenchReinstateMutation, WorkbenchReinstateMutationVariables>;
export const WorkbenchAdminGateToggleDocument = gql`
    mutation WorkbenchAdminGateToggle($featureFlagId: MongoID!, $userId: MongoID!, $enabled: Boolean!) {
  adminFeatureGateToggle(
    featureFlagId: $featureFlagId
    userId: $userId
    enabled: $enabled
  ) {
    success
    error
  }
}
    `;
export type WorkbenchAdminGateToggleMutationFn = Apollo.MutationFunction<WorkbenchAdminGateToggleMutation, WorkbenchAdminGateToggleMutationVariables>;

/**
 * __useWorkbenchAdminGateToggleMutation__
 *
 * To run a mutation, you first call `useWorkbenchAdminGateToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchAdminGateToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workbenchAdminGateToggleMutation, { data, loading, error }] = useWorkbenchAdminGateToggleMutation({
 *   variables: {
 *      featureFlagId: // value for 'featureFlagId'
 *      userId: // value for 'userId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useWorkbenchAdminGateToggleMutation(baseOptions?: Apollo.MutationHookOptions<WorkbenchAdminGateToggleMutation, WorkbenchAdminGateToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorkbenchAdminGateToggleMutation, WorkbenchAdminGateToggleMutationVariables>(WorkbenchAdminGateToggleDocument, options);
      }
export type WorkbenchAdminGateToggleMutationHookResult = ReturnType<typeof useWorkbenchAdminGateToggleMutation>;
export type WorkbenchAdminGateToggleMutationResult = Apollo.MutationResult<WorkbenchAdminGateToggleMutation>;
export type WorkbenchAdminGateToggleMutationOptions = Apollo.BaseMutationOptions<WorkbenchAdminGateToggleMutation, WorkbenchAdminGateToggleMutationVariables>;
export const FeatureFlagExpelDocument = gql`
    mutation FeatureFlagExpel($featureFlagId: MongoID!, $reason: String!) {
  featureFlagExpel(featureFlagId: $featureFlagId, reason: $reason) {
    success
    error
    orgGatesCleared
    adminGatesCleared
    storefrontGatesCleared
  }
}
    `;
export type FeatureFlagExpelMutationFn = Apollo.MutationFunction<FeatureFlagExpelMutation, FeatureFlagExpelMutationVariables>;

/**
 * __useFeatureFlagExpelMutation__
 *
 * To run a mutation, you first call `useFeatureFlagExpelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagExpelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featureFlagExpelMutation, { data, loading, error }] = useFeatureFlagExpelMutation({
 *   variables: {
 *      featureFlagId: // value for 'featureFlagId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useFeatureFlagExpelMutation(baseOptions?: Apollo.MutationHookOptions<FeatureFlagExpelMutation, FeatureFlagExpelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeatureFlagExpelMutation, FeatureFlagExpelMutationVariables>(FeatureFlagExpelDocument, options);
      }
export type FeatureFlagExpelMutationHookResult = ReturnType<typeof useFeatureFlagExpelMutation>;
export type FeatureFlagExpelMutationResult = Apollo.MutationResult<FeatureFlagExpelMutation>;
export type FeatureFlagExpelMutationOptions = Apollo.BaseMutationOptions<FeatureFlagExpelMutation, FeatureFlagExpelMutationVariables>;
export const FeatureFlagReinstateDocument = gql`
    mutation FeatureFlagReinstate($featureFlagId: MongoID!) {
  featureFlagReinstate(featureFlagId: $featureFlagId) {
    success
    error
  }
}
    `;
export type FeatureFlagReinstateMutationFn = Apollo.MutationFunction<FeatureFlagReinstateMutation, FeatureFlagReinstateMutationVariables>;

/**
 * __useFeatureFlagReinstateMutation__
 *
 * To run a mutation, you first call `useFeatureFlagReinstateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagReinstateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featureFlagReinstateMutation, { data, loading, error }] = useFeatureFlagReinstateMutation({
 *   variables: {
 *      featureFlagId: // value for 'featureFlagId'
 *   },
 * });
 */
export function useFeatureFlagReinstateMutation(baseOptions?: Apollo.MutationHookOptions<FeatureFlagReinstateMutation, FeatureFlagReinstateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeatureFlagReinstateMutation, FeatureFlagReinstateMutationVariables>(FeatureFlagReinstateDocument, options);
      }
export type FeatureFlagReinstateMutationHookResult = ReturnType<typeof useFeatureFlagReinstateMutation>;
export type FeatureFlagReinstateMutationResult = Apollo.MutationResult<FeatureFlagReinstateMutation>;
export type FeatureFlagReinstateMutationOptions = Apollo.BaseMutationOptions<FeatureFlagReinstateMutation, FeatureFlagReinstateMutationVariables>;
export const ActivityLogCountDocument = gql`
    query ActivityLogCount($filter: FilterCountActivityLogInput) {
  activityLogCount(filter: $filter)
}
    `;

/**
 * __useActivityLogCountQuery__
 *
 * To run a query within a React component, call `useActivityLogCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLogCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLogCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useActivityLogCountQuery(baseOptions?: Apollo.QueryHookOptions<ActivityLogCountQuery, ActivityLogCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityLogCountQuery, ActivityLogCountQueryVariables>(ActivityLogCountDocument, options);
      }
export function useActivityLogCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityLogCountQuery, ActivityLogCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityLogCountQuery, ActivityLogCountQueryVariables>(ActivityLogCountDocument, options);
        }
// @ts-ignore
export function useActivityLogCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActivityLogCountQuery, ActivityLogCountQueryVariables>): Apollo.UseSuspenseQueryResult<ActivityLogCountQuery, ActivityLogCountQueryVariables>;
export function useActivityLogCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityLogCountQuery, ActivityLogCountQueryVariables>): Apollo.UseSuspenseQueryResult<ActivityLogCountQuery | undefined, ActivityLogCountQueryVariables>;
export function useActivityLogCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityLogCountQuery, ActivityLogCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityLogCountQuery, ActivityLogCountQueryVariables>(ActivityLogCountDocument, options);
        }
export type ActivityLogCountQueryHookResult = ReturnType<typeof useActivityLogCountQuery>;
export type ActivityLogCountLazyQueryHookResult = ReturnType<typeof useActivityLogCountLazyQuery>;
export type ActivityLogCountSuspenseQueryHookResult = ReturnType<typeof useActivityLogCountSuspenseQuery>;
export type ActivityLogCountQueryResult = Apollo.QueryResult<ActivityLogCountQuery, ActivityLogCountQueryVariables>;
export const ActivityLogManyDocument = gql`
    query ActivityLogMany($filter: FilterFindManyActivityLogInput, $limit: Int, $skip: Int, $sort: SortFindManyActivityLogInput) {
  activityLogMany(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
    _id
    entityName {
      ...MultilingualFragment
    }
    message {
      ...MultilingualFragment
    }
    initiatedBy
    type
    createdDateISO
    importRunId
    entity {
      _entityId
      type
    }
    owner {
      entityId
      type
    }
    resourceId
    surveyResponseId
    surveyResponse {
      _id
      adminStatus
      reviewStatus
      status
      tags
    }
    tags
    emailActivity {
      sentHtml
      templatePreviewHtml
      fromAddress {
        name
        email
      }
      subject
      recipients {
        userId
        personId
        email
        displayName
        deliveredAt
        openedAt
        clickedAt
        bouncedAt
        droppedAt
        deferredAt
        spamReportedAt
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useActivityLogManyQuery__
 *
 * To run a query within a React component, call `useActivityLogManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLogManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLogManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useActivityLogManyQuery(baseOptions?: Apollo.QueryHookOptions<ActivityLogManyQuery, ActivityLogManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityLogManyQuery, ActivityLogManyQueryVariables>(ActivityLogManyDocument, options);
      }
export function useActivityLogManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityLogManyQuery, ActivityLogManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityLogManyQuery, ActivityLogManyQueryVariables>(ActivityLogManyDocument, options);
        }
// @ts-ignore
export function useActivityLogManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActivityLogManyQuery, ActivityLogManyQueryVariables>): Apollo.UseSuspenseQueryResult<ActivityLogManyQuery, ActivityLogManyQueryVariables>;
export function useActivityLogManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityLogManyQuery, ActivityLogManyQueryVariables>): Apollo.UseSuspenseQueryResult<ActivityLogManyQuery | undefined, ActivityLogManyQueryVariables>;
export function useActivityLogManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityLogManyQuery, ActivityLogManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityLogManyQuery, ActivityLogManyQueryVariables>(ActivityLogManyDocument, options);
        }
export type ActivityLogManyQueryHookResult = ReturnType<typeof useActivityLogManyQuery>;
export type ActivityLogManyLazyQueryHookResult = ReturnType<typeof useActivityLogManyLazyQuery>;
export type ActivityLogManySuspenseQueryHookResult = ReturnType<typeof useActivityLogManySuspenseQuery>;
export type ActivityLogManyQueryResult = Apollo.QueryResult<ActivityLogManyQuery, ActivityLogManyQueryVariables>;
export const AdminStorefrontSalesReportDocument = gql`
    query AdminStorefrontSalesReport($startDate: String!, $endDate: String!) {
  adminStorefrontSalesReport(startDate: $startDate, endDate: $endDate) {
    storefrontId
    name
    currency
    grossSales
    refunds
    stripeFees
    whereaboutsFees
    chargeCount
  }
}
    `;

/**
 * __useAdminStorefrontSalesReportQuery__
 *
 * To run a query within a React component, call `useAdminStorefrontSalesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStorefrontSalesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStorefrontSalesReportQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAdminStorefrontSalesReportQuery(baseOptions: Apollo.QueryHookOptions<AdminStorefrontSalesReportQuery, AdminStorefrontSalesReportQueryVariables> & ({ variables: AdminStorefrontSalesReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminStorefrontSalesReportQuery, AdminStorefrontSalesReportQueryVariables>(AdminStorefrontSalesReportDocument, options);
      }
export function useAdminStorefrontSalesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminStorefrontSalesReportQuery, AdminStorefrontSalesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminStorefrontSalesReportQuery, AdminStorefrontSalesReportQueryVariables>(AdminStorefrontSalesReportDocument, options);
        }
// @ts-ignore
export function useAdminStorefrontSalesReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminStorefrontSalesReportQuery, AdminStorefrontSalesReportQueryVariables>): Apollo.UseSuspenseQueryResult<AdminStorefrontSalesReportQuery, AdminStorefrontSalesReportQueryVariables>;
export function useAdminStorefrontSalesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminStorefrontSalesReportQuery, AdminStorefrontSalesReportQueryVariables>): Apollo.UseSuspenseQueryResult<AdminStorefrontSalesReportQuery | undefined, AdminStorefrontSalesReportQueryVariables>;
export function useAdminStorefrontSalesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminStorefrontSalesReportQuery, AdminStorefrontSalesReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminStorefrontSalesReportQuery, AdminStorefrontSalesReportQueryVariables>(AdminStorefrontSalesReportDocument, options);
        }
export type AdminStorefrontSalesReportQueryHookResult = ReturnType<typeof useAdminStorefrontSalesReportQuery>;
export type AdminStorefrontSalesReportLazyQueryHookResult = ReturnType<typeof useAdminStorefrontSalesReportLazyQuery>;
export type AdminStorefrontSalesReportSuspenseQueryHookResult = ReturnType<typeof useAdminStorefrontSalesReportSuspenseQuery>;
export type AdminStorefrontSalesReportQueryResult = Apollo.QueryResult<AdminStorefrontSalesReportQuery, AdminStorefrontSalesReportQueryVariables>;
export const AdminUsersListDocument = gql`
    query AdminUsersList {
  adminUsersList {
    _id
    email
    firstName
    lastName
    status
    userType
    systemPermissions
  }
}
    `;

/**
 * __useAdminUsersListQuery__
 *
 * To run a query within a React component, call `useAdminUsersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUsersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUsersListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminUsersListQuery(baseOptions?: Apollo.QueryHookOptions<AdminUsersListQuery, AdminUsersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUsersListQuery, AdminUsersListQueryVariables>(AdminUsersListDocument, options);
      }
export function useAdminUsersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUsersListQuery, AdminUsersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUsersListQuery, AdminUsersListQueryVariables>(AdminUsersListDocument, options);
        }
// @ts-ignore
export function useAdminUsersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminUsersListQuery, AdminUsersListQueryVariables>): Apollo.UseSuspenseQueryResult<AdminUsersListQuery, AdminUsersListQueryVariables>;
export function useAdminUsersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminUsersListQuery, AdminUsersListQueryVariables>): Apollo.UseSuspenseQueryResult<AdminUsersListQuery | undefined, AdminUsersListQueryVariables>;
export function useAdminUsersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminUsersListQuery, AdminUsersListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminUsersListQuery, AdminUsersListQueryVariables>(AdminUsersListDocument, options);
        }
export type AdminUsersListQueryHookResult = ReturnType<typeof useAdminUsersListQuery>;
export type AdminUsersListLazyQueryHookResult = ReturnType<typeof useAdminUsersListLazyQuery>;
export type AdminUsersListSuspenseQueryHookResult = ReturnType<typeof useAdminUsersListSuspenseQuery>;
export type AdminUsersListQueryResult = Apollo.QueryResult<AdminUsersListQuery, AdminUsersListQueryVariables>;
export const AdminUsersSearchableDocument = gql`
    query AdminUsersSearchable($search: String!) {
  adminUsersSearchable(search: $search) {
    _id
    email
    firstName
    lastName
    status
    userType
  }
}
    `;

/**
 * __useAdminUsersSearchableQuery__
 *
 * To run a query within a React component, call `useAdminUsersSearchableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUsersSearchableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUsersSearchableQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdminUsersSearchableQuery(baseOptions: Apollo.QueryHookOptions<AdminUsersSearchableQuery, AdminUsersSearchableQueryVariables> & ({ variables: AdminUsersSearchableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUsersSearchableQuery, AdminUsersSearchableQueryVariables>(AdminUsersSearchableDocument, options);
      }
export function useAdminUsersSearchableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUsersSearchableQuery, AdminUsersSearchableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUsersSearchableQuery, AdminUsersSearchableQueryVariables>(AdminUsersSearchableDocument, options);
        }
// @ts-ignore
export function useAdminUsersSearchableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminUsersSearchableQuery, AdminUsersSearchableQueryVariables>): Apollo.UseSuspenseQueryResult<AdminUsersSearchableQuery, AdminUsersSearchableQueryVariables>;
export function useAdminUsersSearchableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminUsersSearchableQuery, AdminUsersSearchableQueryVariables>): Apollo.UseSuspenseQueryResult<AdminUsersSearchableQuery | undefined, AdminUsersSearchableQueryVariables>;
export function useAdminUsersSearchableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminUsersSearchableQuery, AdminUsersSearchableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminUsersSearchableQuery, AdminUsersSearchableQueryVariables>(AdminUsersSearchableDocument, options);
        }
export type AdminUsersSearchableQueryHookResult = ReturnType<typeof useAdminUsersSearchableQuery>;
export type AdminUsersSearchableLazyQueryHookResult = ReturnType<typeof useAdminUsersSearchableLazyQuery>;
export type AdminUsersSearchableSuspenseQueryHookResult = ReturnType<typeof useAdminUsersSearchableSuspenseQuery>;
export type AdminUsersSearchableQueryResult = Apollo.QueryResult<AdminUsersSearchableQuery, AdminUsersSearchableQueryVariables>;
export const AiTasksByOperatorDocument = gql`
    query AiTasksByOperator($operatorId: String!) {
  aiTasksByOperator(operatorId: $operatorId) {
    _id
    taskType
    operatorId
    initiatedBy
    status
    applied
    appliedAt
    organizationId
    createdDateISO
    durationMs
    rating
    feedbackNotes
  }
}
    `;

/**
 * __useAiTasksByOperatorQuery__
 *
 * To run a query within a React component, call `useAiTasksByOperatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiTasksByOperatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiTasksByOperatorQuery({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *   },
 * });
 */
export function useAiTasksByOperatorQuery(baseOptions: Apollo.QueryHookOptions<AiTasksByOperatorQuery, AiTasksByOperatorQueryVariables> & ({ variables: AiTasksByOperatorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiTasksByOperatorQuery, AiTasksByOperatorQueryVariables>(AiTasksByOperatorDocument, options);
      }
export function useAiTasksByOperatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiTasksByOperatorQuery, AiTasksByOperatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiTasksByOperatorQuery, AiTasksByOperatorQueryVariables>(AiTasksByOperatorDocument, options);
        }
// @ts-ignore
export function useAiTasksByOperatorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AiTasksByOperatorQuery, AiTasksByOperatorQueryVariables>): Apollo.UseSuspenseQueryResult<AiTasksByOperatorQuery, AiTasksByOperatorQueryVariables>;
export function useAiTasksByOperatorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AiTasksByOperatorQuery, AiTasksByOperatorQueryVariables>): Apollo.UseSuspenseQueryResult<AiTasksByOperatorQuery | undefined, AiTasksByOperatorQueryVariables>;
export function useAiTasksByOperatorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AiTasksByOperatorQuery, AiTasksByOperatorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AiTasksByOperatorQuery, AiTasksByOperatorQueryVariables>(AiTasksByOperatorDocument, options);
        }
export type AiTasksByOperatorQueryHookResult = ReturnType<typeof useAiTasksByOperatorQuery>;
export type AiTasksByOperatorLazyQueryHookResult = ReturnType<typeof useAiTasksByOperatorLazyQuery>;
export type AiTasksByOperatorSuspenseQueryHookResult = ReturnType<typeof useAiTasksByOperatorSuspenseQuery>;
export type AiTasksByOperatorQueryResult = Apollo.QueryResult<AiTasksByOperatorQuery, AiTasksByOperatorQueryVariables>;
export const AnalyticsDashboardManyDocument = gql`
    query AnalyticsDashboardMany($sort: SortFindManyAnalyticsDashboardInput) {
  analyticsDashboardMany(sort: $sort) {
    _id
    name
    description
    dashboardId
    sortOrder
  }
}
    `;

/**
 * __useAnalyticsDashboardManyQuery__
 *
 * To run a query within a React component, call `useAnalyticsDashboardManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsDashboardManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsDashboardManyQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAnalyticsDashboardManyQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsDashboardManyQuery, AnalyticsDashboardManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsDashboardManyQuery, AnalyticsDashboardManyQueryVariables>(AnalyticsDashboardManyDocument, options);
      }
export function useAnalyticsDashboardManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsDashboardManyQuery, AnalyticsDashboardManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsDashboardManyQuery, AnalyticsDashboardManyQueryVariables>(AnalyticsDashboardManyDocument, options);
        }
// @ts-ignore
export function useAnalyticsDashboardManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnalyticsDashboardManyQuery, AnalyticsDashboardManyQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsDashboardManyQuery, AnalyticsDashboardManyQueryVariables>;
export function useAnalyticsDashboardManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsDashboardManyQuery, AnalyticsDashboardManyQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsDashboardManyQuery | undefined, AnalyticsDashboardManyQueryVariables>;
export function useAnalyticsDashboardManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsDashboardManyQuery, AnalyticsDashboardManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsDashboardManyQuery, AnalyticsDashboardManyQueryVariables>(AnalyticsDashboardManyDocument, options);
        }
export type AnalyticsDashboardManyQueryHookResult = ReturnType<typeof useAnalyticsDashboardManyQuery>;
export type AnalyticsDashboardManyLazyQueryHookResult = ReturnType<typeof useAnalyticsDashboardManyLazyQuery>;
export type AnalyticsDashboardManySuspenseQueryHookResult = ReturnType<typeof useAnalyticsDashboardManySuspenseQuery>;
export type AnalyticsDashboardManyQueryResult = Apollo.QueryResult<AnalyticsDashboardManyQuery, AnalyticsDashboardManyQueryVariables>;
export const ApiAccessByOrgDocument = gql`
    query ApiAccessByOrg {
  apiAccessByOrg {
    _id
    token
    name
    description
    lastUsedAt
    createdDateISO
    organization {
      _id
      name {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useApiAccessByOrgQuery__
 *
 * To run a query within a React component, call `useApiAccessByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiAccessByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiAccessByOrgQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiAccessByOrgQuery(baseOptions?: Apollo.QueryHookOptions<ApiAccessByOrgQuery, ApiAccessByOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiAccessByOrgQuery, ApiAccessByOrgQueryVariables>(ApiAccessByOrgDocument, options);
      }
export function useApiAccessByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiAccessByOrgQuery, ApiAccessByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiAccessByOrgQuery, ApiAccessByOrgQueryVariables>(ApiAccessByOrgDocument, options);
        }
// @ts-ignore
export function useApiAccessByOrgSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiAccessByOrgQuery, ApiAccessByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<ApiAccessByOrgQuery, ApiAccessByOrgQueryVariables>;
export function useApiAccessByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiAccessByOrgQuery, ApiAccessByOrgQueryVariables>): Apollo.UseSuspenseQueryResult<ApiAccessByOrgQuery | undefined, ApiAccessByOrgQueryVariables>;
export function useApiAccessByOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiAccessByOrgQuery, ApiAccessByOrgQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiAccessByOrgQuery, ApiAccessByOrgQueryVariables>(ApiAccessByOrgDocument, options);
        }
export type ApiAccessByOrgQueryHookResult = ReturnType<typeof useApiAccessByOrgQuery>;
export type ApiAccessByOrgLazyQueryHookResult = ReturnType<typeof useApiAccessByOrgLazyQuery>;
export type ApiAccessByOrgSuspenseQueryHookResult = ReturnType<typeof useApiAccessByOrgSuspenseQuery>;
export type ApiAccessByOrgQueryResult = Apollo.QueryResult<ApiAccessByOrgQuery, ApiAccessByOrgQueryVariables>;
export const ApiAccessManyDocument = gql`
    query ApiAccessMany {
  apiAccessMany {
    _id
    token
    name
    description
    lastUsedAt
    createdDateISO
    updatedDateISO
    organization {
      _id
      name {
        ...MultilingualFragment
      }
    }
    user {
      _id
      email
      firstName
      lastName
      userType
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useApiAccessManyQuery__
 *
 * To run a query within a React component, call `useApiAccessManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiAccessManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiAccessManyQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiAccessManyQuery(baseOptions?: Apollo.QueryHookOptions<ApiAccessManyQuery, ApiAccessManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiAccessManyQuery, ApiAccessManyQueryVariables>(ApiAccessManyDocument, options);
      }
export function useApiAccessManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiAccessManyQuery, ApiAccessManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiAccessManyQuery, ApiAccessManyQueryVariables>(ApiAccessManyDocument, options);
        }
// @ts-ignore
export function useApiAccessManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiAccessManyQuery, ApiAccessManyQueryVariables>): Apollo.UseSuspenseQueryResult<ApiAccessManyQuery, ApiAccessManyQueryVariables>;
export function useApiAccessManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiAccessManyQuery, ApiAccessManyQueryVariables>): Apollo.UseSuspenseQueryResult<ApiAccessManyQuery | undefined, ApiAccessManyQueryVariables>;
export function useApiAccessManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiAccessManyQuery, ApiAccessManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiAccessManyQuery, ApiAccessManyQueryVariables>(ApiAccessManyDocument, options);
        }
export type ApiAccessManyQueryHookResult = ReturnType<typeof useApiAccessManyQuery>;
export type ApiAccessManyLazyQueryHookResult = ReturnType<typeof useApiAccessManyLazyQuery>;
export type ApiAccessManySuspenseQueryHookResult = ReturnType<typeof useApiAccessManySuspenseQuery>;
export type ApiAccessManyQueryResult = Apollo.QueryResult<ApiAccessManyQuery, ApiAccessManyQueryVariables>;
export const AssetManyDocument = gql`
    query AssetMany($filter: FilterFindManyAssetInput, $limit: Int) {
  assetMany(filter: $filter, limit: $limit) {
    ...FileFragment
    ...ImageFragment
  }
}
    ${FileFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useAssetManyQuery__
 *
 * To run a query within a React component, call `useAssetManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAssetManyQuery(baseOptions?: Apollo.QueryHookOptions<AssetManyQuery, AssetManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetManyQuery, AssetManyQueryVariables>(AssetManyDocument, options);
      }
export function useAssetManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetManyQuery, AssetManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetManyQuery, AssetManyQueryVariables>(AssetManyDocument, options);
        }
// @ts-ignore
export function useAssetManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssetManyQuery, AssetManyQueryVariables>): Apollo.UseSuspenseQueryResult<AssetManyQuery, AssetManyQueryVariables>;
export function useAssetManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssetManyQuery, AssetManyQueryVariables>): Apollo.UseSuspenseQueryResult<AssetManyQuery | undefined, AssetManyQueryVariables>;
export function useAssetManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssetManyQuery, AssetManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssetManyQuery, AssetManyQueryVariables>(AssetManyDocument, options);
        }
export type AssetManyQueryHookResult = ReturnType<typeof useAssetManyQuery>;
export type AssetManyLazyQueryHookResult = ReturnType<typeof useAssetManyLazyQuery>;
export type AssetManySuspenseQueryHookResult = ReturnType<typeof useAssetManySuspenseQuery>;
export type AssetManyQueryResult = Apollo.QueryResult<AssetManyQuery, AssetManyQueryVariables>;
export const BookerByIdDocument = gql`
    query BookerById($id: MongoID!) {
  bookerById(_id: $id) {
    name {
      ...MultilingualFragment
    }
    storefront
    bundles {
      product {
        ...ProductFragment
      }
      upsells {
        ...UpsellProductFragment
      }
      _id
    }
    paymentMetadata {
      connectedAccountId
      currency
      stripeRegion
      depositSettings {
        enabled
        rate
        rateType
        chargeBalanceDaysBeforeCheckIn
      }
      securityDepositSettings {
        enabled
        placeHoldDaysBeforeCheckOut
        rate
        rateType
      }
      tax {
        _id
        percentage
        subdivision
        country
      }
      customerApplicationPercentage
      applicationPercentage
      acceptedPaymentMethods
      bankTransferInstructions
      offerTaxExemption
      optionalCardPostalCode
      feeAbsorption {
        stripePercent
        stripeFixedCents
        roundingIncrementCents
        showBreakdownInCheckout
      }
    }
    waivers {
      ...FileFragment
    }
    rules {
      _id
      activePeriod {
        _id
        end
        start
        metadata
      }
      isActive
      type
      value
    }
    policies {
      ...PolicyFragment
    }
    fulfillmentProfile {
      ...FulfillmentProfileFragment
    }
    status
    copiedFrom
    requiresPayment
    renewableFeeAddOnsEnabled
    perBusinessAnswersEnabled
    statusNotification {
      ...MultilingualFragment
    }
    customizations {
      featuredImage {
        ...ImageFragment
      }
      logo {
        ...ImageFragment
      }
      overrideProductName {
        ...MultilingualFragment
      }
      overrideProductDescription {
        ...MultilingualFragment
      }
      overridePricingCallout {
        ...MultilingualFragment
      }
      overrideDiscountCallout {
        ...MultilingualFragment
      }
      overrideAddOnsDescription {
        ...MultilingualFragment
      }
      overrideQuestionnaireTitle {
        ...MultilingualFragment
      }
      overrideQuestionnaireDescription {
        ...MultilingualFragment
      }
      sectionOrder
      confirmationEmailSubject {
        ...MultilingualFragment
      }
      confirmationEmailBody {
        ...MultilingualFragment
      }
      confirmationEmailCtaLabel {
        ...MultilingualFragment
      }
      confirmationEmailCtaUrl
      showCheckoutChecklist
      addressDisplay
    }
    brandingLogo {
      ...ImageFragment
    }
    discounts {
      ...DiscountFragment
    }
    renewalSettings {
      renewalMode
      requireApproval
      sendRenewalReminders
      renewalReminderDaysBefore
    }
    _id
    survey {
      ...SurveyFragment
    }
    surveyInline
    paymentMethodSet {
      ...PaymentMethodSetFragment
    }
    completionTags
    businessCompletionTags
    completionScreen {
      message {
        ...MultilingualFragment
      }
      ctaLabel {
        ...MultilingualFragment
      }
      ctaBroadcastId
      ctaUrl
    }
    customerFields {
      businessFieldEnabled
      businessFieldDescription {
        ...MultilingualFragment
      }
      phoneEnabled
      guestNamesEnabled
      guestEmailEnabled
      guestInfoRequired
      addressRequired
    }
    eligibility {
      mode
      rule
      tagId
      ineligibleBehavior
      blockedMessage {
        ...MultilingualFragment
      }
    }
    approvalSettings {
      enabled
      requestExpiryHours
      autoCancelUnpaidAfterDays
      messageToGuest {
        ...MultilingualFragment
      }
    }
    paymentTiming {
      timing
      invoiceDueDays
      afterServiceOffsetDays
      consolidation
    }
    promoCodeTagOverrides {
      discountId
      tagId
      mode
    }
    discountScopes {
      discount
      appliesToTierIds
    }
    publiclyPublishable
    isInvoiceTemplate
    createdDateISO
  }
}
    ${MultilingualFragmentFragmentDoc}
${ProductFragmentFragmentDoc}
${UpsellProductFragmentFragmentDoc}
${FileFragmentFragmentDoc}
${PolicyFragmentFragmentDoc}
${FulfillmentProfileFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${DiscountFragmentFragmentDoc}
${SurveyFragmentFragmentDoc}
${PaymentMethodSetFragmentFragmentDoc}`;

/**
 * __useBookerByIdQuery__
 *
 * To run a query within a React component, call `useBookerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookerByIdQuery(baseOptions: Apollo.QueryHookOptions<BookerByIdQuery, BookerByIdQueryVariables> & ({ variables: BookerByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerByIdQuery, BookerByIdQueryVariables>(BookerByIdDocument, options);
      }
export function useBookerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerByIdQuery, BookerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerByIdQuery, BookerByIdQueryVariables>(BookerByIdDocument, options);
        }
// @ts-ignore
export function useBookerByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookerByIdQuery, BookerByIdQueryVariables>): Apollo.UseSuspenseQueryResult<BookerByIdQuery, BookerByIdQueryVariables>;
export function useBookerByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerByIdQuery, BookerByIdQueryVariables>): Apollo.UseSuspenseQueryResult<BookerByIdQuery | undefined, BookerByIdQueryVariables>;
export function useBookerByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerByIdQuery, BookerByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerByIdQuery, BookerByIdQueryVariables>(BookerByIdDocument, options);
        }
export type BookerByIdQueryHookResult = ReturnType<typeof useBookerByIdQuery>;
export type BookerByIdLazyQueryHookResult = ReturnType<typeof useBookerByIdLazyQuery>;
export type BookerByIdSuspenseQueryHookResult = ReturnType<typeof useBookerByIdSuspenseQuery>;
export type BookerByIdQueryResult = Apollo.QueryResult<BookerByIdQuery, BookerByIdQueryVariables>;
export const BookerCartPriceDocument = gql`
    query BookerCartPrice($bookerId: ID!, $productPurchaseRequests: [ProductPurchaseRequest!]!, $promoCode: String, $taxExempt: Boolean, $delivery: OrderDeliveryInput) {
  bookerCartPrice(
    bookerId: $bookerId
    productPurchaseRequests: $productPurchaseRequests
    promoCode: $promoCode
    taxExempt: $taxExempt
    delivery: $delivery
  ) {
    depositTotal
    discountTotal
    discountTotals {
      discountId
      total
    }
    grandTotal
    subTotal
    taxTotal
    taxLines {
      name
      ratePercent
      amount
    }
    customerFee
    productPrices {
      price
      productId
    }
    promoCodeApplicable
    shippingTotal
    deliveryAvailable
  }
}
    `;

/**
 * __useBookerCartPriceQuery__
 *
 * To run a query within a React component, call `useBookerCartPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerCartPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerCartPriceQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      productPurchaseRequests: // value for 'productPurchaseRequests'
 *      promoCode: // value for 'promoCode'
 *      taxExempt: // value for 'taxExempt'
 *      delivery: // value for 'delivery'
 *   },
 * });
 */
export function useBookerCartPriceQuery(baseOptions: Apollo.QueryHookOptions<BookerCartPriceQuery, BookerCartPriceQueryVariables> & ({ variables: BookerCartPriceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerCartPriceQuery, BookerCartPriceQueryVariables>(BookerCartPriceDocument, options);
      }
export function useBookerCartPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerCartPriceQuery, BookerCartPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerCartPriceQuery, BookerCartPriceQueryVariables>(BookerCartPriceDocument, options);
        }
// @ts-ignore
export function useBookerCartPriceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookerCartPriceQuery, BookerCartPriceQueryVariables>): Apollo.UseSuspenseQueryResult<BookerCartPriceQuery, BookerCartPriceQueryVariables>;
export function useBookerCartPriceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerCartPriceQuery, BookerCartPriceQueryVariables>): Apollo.UseSuspenseQueryResult<BookerCartPriceQuery | undefined, BookerCartPriceQueryVariables>;
export function useBookerCartPriceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerCartPriceQuery, BookerCartPriceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerCartPriceQuery, BookerCartPriceQueryVariables>(BookerCartPriceDocument, options);
        }
export type BookerCartPriceQueryHookResult = ReturnType<typeof useBookerCartPriceQuery>;
export type BookerCartPriceLazyQueryHookResult = ReturnType<typeof useBookerCartPriceLazyQuery>;
export type BookerCartPriceSuspenseQueryHookResult = ReturnType<typeof useBookerCartPriceSuspenseQuery>;
export type BookerCartPriceQueryResult = Apollo.QueryResult<BookerCartPriceQuery, BookerCartPriceQueryVariables>;
export const BookerCheckEligibilityDocument = gql`
    query BookerCheckEligibility($bookerId: ID!, $email: String, $phone: String) {
  bookerCheckEligibility(bookerId: $bookerId, email: $email, phone: $phone) {
    required
    eligible
    ineligibleBehavior
    blockedMessage {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useBookerCheckEligibilityQuery__
 *
 * To run a query within a React component, call `useBookerCheckEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerCheckEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerCheckEligibilityQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useBookerCheckEligibilityQuery(baseOptions: Apollo.QueryHookOptions<BookerCheckEligibilityQuery, BookerCheckEligibilityQueryVariables> & ({ variables: BookerCheckEligibilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerCheckEligibilityQuery, BookerCheckEligibilityQueryVariables>(BookerCheckEligibilityDocument, options);
      }
export function useBookerCheckEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerCheckEligibilityQuery, BookerCheckEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerCheckEligibilityQuery, BookerCheckEligibilityQueryVariables>(BookerCheckEligibilityDocument, options);
        }
// @ts-ignore
export function useBookerCheckEligibilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookerCheckEligibilityQuery, BookerCheckEligibilityQueryVariables>): Apollo.UseSuspenseQueryResult<BookerCheckEligibilityQuery, BookerCheckEligibilityQueryVariables>;
export function useBookerCheckEligibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerCheckEligibilityQuery, BookerCheckEligibilityQueryVariables>): Apollo.UseSuspenseQueryResult<BookerCheckEligibilityQuery | undefined, BookerCheckEligibilityQueryVariables>;
export function useBookerCheckEligibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerCheckEligibilityQuery, BookerCheckEligibilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerCheckEligibilityQuery, BookerCheckEligibilityQueryVariables>(BookerCheckEligibilityDocument, options);
        }
export type BookerCheckEligibilityQueryHookResult = ReturnType<typeof useBookerCheckEligibilityQuery>;
export type BookerCheckEligibilityLazyQueryHookResult = ReturnType<typeof useBookerCheckEligibilityLazyQuery>;
export type BookerCheckEligibilitySuspenseQueryHookResult = ReturnType<typeof useBookerCheckEligibilitySuspenseQuery>;
export type BookerCheckEligibilityQueryResult = Apollo.QueryResult<BookerCheckEligibilityQuery, BookerCheckEligibilityQueryVariables>;
export const BookerConfirmationEmailPreviewDocument = gql`
    query BookerConfirmationEmailPreview($bookerId: MongoID!, $subject: String, $bodyHtml: String, $ctaLabel: String, $ctaUrl: String) {
  bookerConfirmationEmailPreview(
    bookerId: $bookerId
    subject: $subject
    bodyHtml: $bodyHtml
    ctaLabel: $ctaLabel
    ctaUrl: $ctaUrl
  ) {
    subject
    html
  }
}
    `;

/**
 * __useBookerConfirmationEmailPreviewQuery__
 *
 * To run a query within a React component, call `useBookerConfirmationEmailPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerConfirmationEmailPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerConfirmationEmailPreviewQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      subject: // value for 'subject'
 *      bodyHtml: // value for 'bodyHtml'
 *      ctaLabel: // value for 'ctaLabel'
 *      ctaUrl: // value for 'ctaUrl'
 *   },
 * });
 */
export function useBookerConfirmationEmailPreviewQuery(baseOptions: Apollo.QueryHookOptions<BookerConfirmationEmailPreviewQuery, BookerConfirmationEmailPreviewQueryVariables> & ({ variables: BookerConfirmationEmailPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerConfirmationEmailPreviewQuery, BookerConfirmationEmailPreviewQueryVariables>(BookerConfirmationEmailPreviewDocument, options);
      }
export function useBookerConfirmationEmailPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerConfirmationEmailPreviewQuery, BookerConfirmationEmailPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerConfirmationEmailPreviewQuery, BookerConfirmationEmailPreviewQueryVariables>(BookerConfirmationEmailPreviewDocument, options);
        }
// @ts-ignore
export function useBookerConfirmationEmailPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookerConfirmationEmailPreviewQuery, BookerConfirmationEmailPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<BookerConfirmationEmailPreviewQuery, BookerConfirmationEmailPreviewQueryVariables>;
export function useBookerConfirmationEmailPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerConfirmationEmailPreviewQuery, BookerConfirmationEmailPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<BookerConfirmationEmailPreviewQuery | undefined, BookerConfirmationEmailPreviewQueryVariables>;
export function useBookerConfirmationEmailPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerConfirmationEmailPreviewQuery, BookerConfirmationEmailPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerConfirmationEmailPreviewQuery, BookerConfirmationEmailPreviewQueryVariables>(BookerConfirmationEmailPreviewDocument, options);
        }
export type BookerConfirmationEmailPreviewQueryHookResult = ReturnType<typeof useBookerConfirmationEmailPreviewQuery>;
export type BookerConfirmationEmailPreviewLazyQueryHookResult = ReturnType<typeof useBookerConfirmationEmailPreviewLazyQuery>;
export type BookerConfirmationEmailPreviewSuspenseQueryHookResult = ReturnType<typeof useBookerConfirmationEmailPreviewSuspenseQuery>;
export type BookerConfirmationEmailPreviewQueryResult = Apollo.QueryResult<BookerConfirmationEmailPreviewQuery, BookerConfirmationEmailPreviewQueryVariables>;
export const BookerFeeAbsorptionPreviewDocument = gql`
    query BookerFeeAbsorptionPreview($bookerId: MongoID!) {
  bookerFeeAbsorptionPreview(bookerId: $bookerId) {
    applicationPercent
    taxPercent
    snapshotAppliedAt
    products {
      productId
      name
      productType
      isMain
      otherWidgetCount
      pricePoints {
        path
        label
        currentPrice
        basePrice
      }
    }
  }
}
    `;

/**
 * __useBookerFeeAbsorptionPreviewQuery__
 *
 * To run a query within a React component, call `useBookerFeeAbsorptionPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerFeeAbsorptionPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerFeeAbsorptionPreviewQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *   },
 * });
 */
export function useBookerFeeAbsorptionPreviewQuery(baseOptions: Apollo.QueryHookOptions<BookerFeeAbsorptionPreviewQuery, BookerFeeAbsorptionPreviewQueryVariables> & ({ variables: BookerFeeAbsorptionPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerFeeAbsorptionPreviewQuery, BookerFeeAbsorptionPreviewQueryVariables>(BookerFeeAbsorptionPreviewDocument, options);
      }
export function useBookerFeeAbsorptionPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerFeeAbsorptionPreviewQuery, BookerFeeAbsorptionPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerFeeAbsorptionPreviewQuery, BookerFeeAbsorptionPreviewQueryVariables>(BookerFeeAbsorptionPreviewDocument, options);
        }
// @ts-ignore
export function useBookerFeeAbsorptionPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookerFeeAbsorptionPreviewQuery, BookerFeeAbsorptionPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<BookerFeeAbsorptionPreviewQuery, BookerFeeAbsorptionPreviewQueryVariables>;
export function useBookerFeeAbsorptionPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerFeeAbsorptionPreviewQuery, BookerFeeAbsorptionPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<BookerFeeAbsorptionPreviewQuery | undefined, BookerFeeAbsorptionPreviewQueryVariables>;
export function useBookerFeeAbsorptionPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerFeeAbsorptionPreviewQuery, BookerFeeAbsorptionPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerFeeAbsorptionPreviewQuery, BookerFeeAbsorptionPreviewQueryVariables>(BookerFeeAbsorptionPreviewDocument, options);
        }
export type BookerFeeAbsorptionPreviewQueryHookResult = ReturnType<typeof useBookerFeeAbsorptionPreviewQuery>;
export type BookerFeeAbsorptionPreviewLazyQueryHookResult = ReturnType<typeof useBookerFeeAbsorptionPreviewLazyQuery>;
export type BookerFeeAbsorptionPreviewSuspenseQueryHookResult = ReturnType<typeof useBookerFeeAbsorptionPreviewSuspenseQuery>;
export type BookerFeeAbsorptionPreviewQueryResult = Apollo.QueryResult<BookerFeeAbsorptionPreviewQuery, BookerFeeAbsorptionPreviewQueryVariables>;
export const BookerFulfillmentOptionsDocument = gql`
    query BookerFulfillmentOptions($bookerId: ID!) {
  bookerFulfillmentOptions(bookerId: $bookerId) {
    pickupEnabled
    pickupLocations {
      _id
      name
      address
      instructions
    }
    shippingEnabled
    shippingZones {
      name
      countries
      subdivisions
      flatRate
      perAdditionalItem
      freeOver
    }
  }
}
    `;

/**
 * __useBookerFulfillmentOptionsQuery__
 *
 * To run a query within a React component, call `useBookerFulfillmentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerFulfillmentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerFulfillmentOptionsQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *   },
 * });
 */
export function useBookerFulfillmentOptionsQuery(baseOptions: Apollo.QueryHookOptions<BookerFulfillmentOptionsQuery, BookerFulfillmentOptionsQueryVariables> & ({ variables: BookerFulfillmentOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerFulfillmentOptionsQuery, BookerFulfillmentOptionsQueryVariables>(BookerFulfillmentOptionsDocument, options);
      }
export function useBookerFulfillmentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerFulfillmentOptionsQuery, BookerFulfillmentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerFulfillmentOptionsQuery, BookerFulfillmentOptionsQueryVariables>(BookerFulfillmentOptionsDocument, options);
        }
// @ts-ignore
export function useBookerFulfillmentOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookerFulfillmentOptionsQuery, BookerFulfillmentOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<BookerFulfillmentOptionsQuery, BookerFulfillmentOptionsQueryVariables>;
export function useBookerFulfillmentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerFulfillmentOptionsQuery, BookerFulfillmentOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<BookerFulfillmentOptionsQuery | undefined, BookerFulfillmentOptionsQueryVariables>;
export function useBookerFulfillmentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerFulfillmentOptionsQuery, BookerFulfillmentOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerFulfillmentOptionsQuery, BookerFulfillmentOptionsQueryVariables>(BookerFulfillmentOptionsDocument, options);
        }
export type BookerFulfillmentOptionsQueryHookResult = ReturnType<typeof useBookerFulfillmentOptionsQuery>;
export type BookerFulfillmentOptionsLazyQueryHookResult = ReturnType<typeof useBookerFulfillmentOptionsLazyQuery>;
export type BookerFulfillmentOptionsSuspenseQueryHookResult = ReturnType<typeof useBookerFulfillmentOptionsSuspenseQuery>;
export type BookerFulfillmentOptionsQueryResult = Apollo.QueryResult<BookerFulfillmentOptionsQuery, BookerFulfillmentOptionsQueryVariables>;
export const BookerInvoiceHeaderDocument = gql`
    query BookerInvoiceHeader($id: MongoID!) {
  bookerById(_id: $id) {
    _id
    name {
      ...MultilingualFragment
    }
    customizations {
      logo {
        ...ImageFragment
      }
    }
    brandingLogo {
      ...ImageFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useBookerInvoiceHeaderQuery__
 *
 * To run a query within a React component, call `useBookerInvoiceHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerInvoiceHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerInvoiceHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookerInvoiceHeaderQuery(baseOptions: Apollo.QueryHookOptions<BookerInvoiceHeaderQuery, BookerInvoiceHeaderQueryVariables> & ({ variables: BookerInvoiceHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerInvoiceHeaderQuery, BookerInvoiceHeaderQueryVariables>(BookerInvoiceHeaderDocument, options);
      }
export function useBookerInvoiceHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerInvoiceHeaderQuery, BookerInvoiceHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerInvoiceHeaderQuery, BookerInvoiceHeaderQueryVariables>(BookerInvoiceHeaderDocument, options);
        }
// @ts-ignore
export function useBookerInvoiceHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookerInvoiceHeaderQuery, BookerInvoiceHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<BookerInvoiceHeaderQuery, BookerInvoiceHeaderQueryVariables>;
export function useBookerInvoiceHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerInvoiceHeaderQuery, BookerInvoiceHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<BookerInvoiceHeaderQuery | undefined, BookerInvoiceHeaderQueryVariables>;
export function useBookerInvoiceHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerInvoiceHeaderQuery, BookerInvoiceHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerInvoiceHeaderQuery, BookerInvoiceHeaderQueryVariables>(BookerInvoiceHeaderDocument, options);
        }
export type BookerInvoiceHeaderQueryHookResult = ReturnType<typeof useBookerInvoiceHeaderQuery>;
export type BookerInvoiceHeaderLazyQueryHookResult = ReturnType<typeof useBookerInvoiceHeaderLazyQuery>;
export type BookerInvoiceHeaderSuspenseQueryHookResult = ReturnType<typeof useBookerInvoiceHeaderSuspenseQuery>;
export type BookerInvoiceHeaderQueryResult = Apollo.QueryResult<BookerInvoiceHeaderQuery, BookerInvoiceHeaderQueryVariables>;
export const BookerManyDocument = gql`
    query BookerMany($filter: FilterFindManyBookerInput, $limit: Int) {
  bookerMany(filter: $filter, limit: $limit) {
    _id
    updatedDateISO
    createdDateISO
    name {
      ...MultilingualFragment
    }
    status
    copiedFrom
    requiresPayment
    statusNotification {
      ...MultilingualFragment
    }
    storefront
    bundles {
      product {
        ...ProductFragment
      }
      upsells {
        ...UpsellProductFragment
      }
      _id
    }
    customizations {
      logo {
        ...ImageFragment
      }
      featuredImage {
        ...ImageFragment
      }
    }
    discounts {
      name {
        ...MultilingualFragment
      }
      description {
        ...MultilingualFragment
      }
      type
      isActive
      amount
      unit
      daysInAdvance
      minGuestCount
      minNights
      maxNights
      promoCode
      discountActivePeriod {
        ...DateRangeISOOptionalFragment
      }
      maxUsageCount
      currentUsageCount
      canCombine
      excludeUpsells
      storefront
      _id
    }
    paymentMetadata {
      connectedAccountId
      applicationPercentage
      tax {
        country
        subdivision
        percentage
        _id
      }
      currency
      depositSettings {
        rate
        rateType
        chargeBalanceDaysBeforeCheckIn
        enabled
      }
      securityDepositSettings {
        rate
        rateType
        placeHoldDaysBeforeCheckOut
        enabled
      }
    }
    policies {
      ...PolicyFragment
    }
    rules {
      type
      value
      activePeriod {
        ...DateRangeISOFragment
      }
      isActive
      storefront
      _id
    }
    waivers {
      ...FileFragment
    }
    isInvoiceTemplate
  }
}
    ${MultilingualFragmentFragmentDoc}
${ProductFragmentFragmentDoc}
${UpsellProductFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${DateRangeIsoOptionalFragmentFragmentDoc}
${PolicyFragmentFragmentDoc}
${DateRangeIsoFragmentFragmentDoc}
${FileFragmentFragmentDoc}`;

/**
 * __useBookerManyQuery__
 *
 * To run a query within a React component, call `useBookerManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBookerManyQuery(baseOptions?: Apollo.QueryHookOptions<BookerManyQuery, BookerManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerManyQuery, BookerManyQueryVariables>(BookerManyDocument, options);
      }
export function useBookerManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerManyQuery, BookerManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerManyQuery, BookerManyQueryVariables>(BookerManyDocument, options);
        }
// @ts-ignore
export function useBookerManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookerManyQuery, BookerManyQueryVariables>): Apollo.UseSuspenseQueryResult<BookerManyQuery, BookerManyQueryVariables>;
export function useBookerManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerManyQuery, BookerManyQueryVariables>): Apollo.UseSuspenseQueryResult<BookerManyQuery | undefined, BookerManyQueryVariables>;
export function useBookerManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerManyQuery, BookerManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerManyQuery, BookerManyQueryVariables>(BookerManyDocument, options);
        }
export type BookerManyQueryHookResult = ReturnType<typeof useBookerManyQuery>;
export type BookerManyLazyQueryHookResult = ReturnType<typeof useBookerManyLazyQuery>;
export type BookerManySuspenseQueryHookResult = ReturnType<typeof useBookerManySuspenseQuery>;
export type BookerManyQueryResult = Apollo.QueryResult<BookerManyQuery, BookerManyQueryVariables>;
export const BookerManyAdminlandDocument = gql`
    query BookerManyAdminland($filter: FilterFindManyBookerInput, $limit: Int) {
  bookerMany(filter: $filter, limit: $limit) {
    _id
    updatedDateISO
    status
    storefront
    isInvoiceTemplate
    name {
      ...MultilingualFragment
    }
    bundles {
      _id
      product {
        _id
        type
        name {
          ...MultilingualFragment
        }
        eventMetadata {
          event
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useBookerManyAdminlandQuery__
 *
 * To run a query within a React component, call `useBookerManyAdminlandQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerManyAdminlandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerManyAdminlandQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBookerManyAdminlandQuery(baseOptions?: Apollo.QueryHookOptions<BookerManyAdminlandQuery, BookerManyAdminlandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerManyAdminlandQuery, BookerManyAdminlandQueryVariables>(BookerManyAdminlandDocument, options);
      }
export function useBookerManyAdminlandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerManyAdminlandQuery, BookerManyAdminlandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerManyAdminlandQuery, BookerManyAdminlandQueryVariables>(BookerManyAdminlandDocument, options);
        }
// @ts-ignore
export function useBookerManyAdminlandSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookerManyAdminlandQuery, BookerManyAdminlandQueryVariables>): Apollo.UseSuspenseQueryResult<BookerManyAdminlandQuery, BookerManyAdminlandQueryVariables>;
export function useBookerManyAdminlandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerManyAdminlandQuery, BookerManyAdminlandQueryVariables>): Apollo.UseSuspenseQueryResult<BookerManyAdminlandQuery | undefined, BookerManyAdminlandQueryVariables>;
export function useBookerManyAdminlandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerManyAdminlandQuery, BookerManyAdminlandQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerManyAdminlandQuery, BookerManyAdminlandQueryVariables>(BookerManyAdminlandDocument, options);
        }
export type BookerManyAdminlandQueryHookResult = ReturnType<typeof useBookerManyAdminlandQuery>;
export type BookerManyAdminlandLazyQueryHookResult = ReturnType<typeof useBookerManyAdminlandLazyQuery>;
export type BookerManyAdminlandSuspenseQueryHookResult = ReturnType<typeof useBookerManyAdminlandSuspenseQuery>;
export type BookerManyAdminlandQueryResult = Apollo.QueryResult<BookerManyAdminlandQuery, BookerManyAdminlandQueryVariables>;
export const BookerSendContactUsEmailDocument = gql`
    query BookerSendContactUsEmail($bookerId: ID!, $details: ContactUsEmailDetails!) {
  bookerSendContactUsEmail(bookerId: $bookerId, details: $details) {
    message
    success
  }
}
    `;

/**
 * __useBookerSendContactUsEmailQuery__
 *
 * To run a query within a React component, call `useBookerSendContactUsEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookerSendContactUsEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookerSendContactUsEmailQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useBookerSendContactUsEmailQuery(baseOptions: Apollo.QueryHookOptions<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables> & ({ variables: BookerSendContactUsEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>(BookerSendContactUsEmailDocument, options);
      }
export function useBookerSendContactUsEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>(BookerSendContactUsEmailDocument, options);
        }
// @ts-ignore
export function useBookerSendContactUsEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>): Apollo.UseSuspenseQueryResult<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>;
export function useBookerSendContactUsEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>): Apollo.UseSuspenseQueryResult<BookerSendContactUsEmailQuery | undefined, BookerSendContactUsEmailQueryVariables>;
export function useBookerSendContactUsEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>(BookerSendContactUsEmailDocument, options);
        }
export type BookerSendContactUsEmailQueryHookResult = ReturnType<typeof useBookerSendContactUsEmailQuery>;
export type BookerSendContactUsEmailLazyQueryHookResult = ReturnType<typeof useBookerSendContactUsEmailLazyQuery>;
export type BookerSendContactUsEmailSuspenseQueryHookResult = ReturnType<typeof useBookerSendContactUsEmailSuspenseQuery>;
export type BookerSendContactUsEmailQueryResult = Apollo.QueryResult<BookerSendContactUsEmailQuery, BookerSendContactUsEmailQueryVariables>;
export const BookersByStorefrontForFeesDocument = gql`
    query BookersByStorefrontForFees($filter: FilterFindManyBookerInput) {
  bookerMany(filter: $filter) {
    _id
    name {
      ...MultilingualFragment
    }
    status
    paymentMetadata {
      applicationPercentage
      applicationPercentageFollowsDefault
      customerApplicationPercentage
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useBookersByStorefrontForFeesQuery__
 *
 * To run a query within a React component, call `useBookersByStorefrontForFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookersByStorefrontForFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookersByStorefrontForFeesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBookersByStorefrontForFeesQuery(baseOptions?: Apollo.QueryHookOptions<BookersByStorefrontForFeesQuery, BookersByStorefrontForFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookersByStorefrontForFeesQuery, BookersByStorefrontForFeesQueryVariables>(BookersByStorefrontForFeesDocument, options);
      }
export function useBookersByStorefrontForFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookersByStorefrontForFeesQuery, BookersByStorefrontForFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookersByStorefrontForFeesQuery, BookersByStorefrontForFeesQueryVariables>(BookersByStorefrontForFeesDocument, options);
        }
// @ts-ignore
export function useBookersByStorefrontForFeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookersByStorefrontForFeesQuery, BookersByStorefrontForFeesQueryVariables>): Apollo.UseSuspenseQueryResult<BookersByStorefrontForFeesQuery, BookersByStorefrontForFeesQueryVariables>;
export function useBookersByStorefrontForFeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookersByStorefrontForFeesQuery, BookersByStorefrontForFeesQueryVariables>): Apollo.UseSuspenseQueryResult<BookersByStorefrontForFeesQuery | undefined, BookersByStorefrontForFeesQueryVariables>;
export function useBookersByStorefrontForFeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookersByStorefrontForFeesQuery, BookersByStorefrontForFeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookersByStorefrontForFeesQuery, BookersByStorefrontForFeesQueryVariables>(BookersByStorefrontForFeesDocument, options);
        }
export type BookersByStorefrontForFeesQueryHookResult = ReturnType<typeof useBookersByStorefrontForFeesQuery>;
export type BookersByStorefrontForFeesLazyQueryHookResult = ReturnType<typeof useBookersByStorefrontForFeesLazyQuery>;
export type BookersByStorefrontForFeesSuspenseQueryHookResult = ReturnType<typeof useBookersByStorefrontForFeesSuspenseQuery>;
export type BookersByStorefrontForFeesQueryResult = Apollo.QueryResult<BookersByStorefrontForFeesQuery, BookersByStorefrontForFeesQueryVariables>;
export const BroadcastAllStatsDocument = gql`
    query BroadcastAllStats($skip: Int, $limit: Int, $ownerEntityId: MongoID) {
  broadcastAllStats(skip: $skip, limit: $limit, ownerEntityId: $ownerEntityId) {
    items {
      broadcastId
      name {
        ...MultilingualFragment
      }
      ownerName
      ownerType
      status
      totalViews
      totalCompletions
      totalResources
    }
    totalCount
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useBroadcastAllStatsQuery__
 *
 * To run a query within a React component, call `useBroadcastAllStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBroadcastAllStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBroadcastAllStatsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      ownerEntityId: // value for 'ownerEntityId'
 *   },
 * });
 */
export function useBroadcastAllStatsQuery(baseOptions?: Apollo.QueryHookOptions<BroadcastAllStatsQuery, BroadcastAllStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BroadcastAllStatsQuery, BroadcastAllStatsQueryVariables>(BroadcastAllStatsDocument, options);
      }
export function useBroadcastAllStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BroadcastAllStatsQuery, BroadcastAllStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BroadcastAllStatsQuery, BroadcastAllStatsQueryVariables>(BroadcastAllStatsDocument, options);
        }
// @ts-ignore
export function useBroadcastAllStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BroadcastAllStatsQuery, BroadcastAllStatsQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastAllStatsQuery, BroadcastAllStatsQueryVariables>;
export function useBroadcastAllStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastAllStatsQuery, BroadcastAllStatsQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastAllStatsQuery | undefined, BroadcastAllStatsQueryVariables>;
export function useBroadcastAllStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastAllStatsQuery, BroadcastAllStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BroadcastAllStatsQuery, BroadcastAllStatsQueryVariables>(BroadcastAllStatsDocument, options);
        }
export type BroadcastAllStatsQueryHookResult = ReturnType<typeof useBroadcastAllStatsQuery>;
export type BroadcastAllStatsLazyQueryHookResult = ReturnType<typeof useBroadcastAllStatsLazyQuery>;
export type BroadcastAllStatsSuspenseQueryHookResult = ReturnType<typeof useBroadcastAllStatsSuspenseQuery>;
export type BroadcastAllStatsQueryResult = Apollo.QueryResult<BroadcastAllStatsQuery, BroadcastAllStatsQueryVariables>;
export const BroadcastByIdStatsPerPersonDocument = gql`
    query BroadcastByIdStatsPerPerson($broadcastId: ID!) {
  broadcastByIdStatsPerPerson(broadcastId: $broadcastId) {
    broadcastId
    viewedPeople {
      _id
    }
    totalViews
    resources {
      resourceId
      viewedPeople {
        _id
        firstName
        lastName
        email
      }
      inProgressPeople {
        _id
      }
      completedPeople {
        _id
      }
      downloadedPeople {
        _id
      }
      playedPeople {
        _id
      }
    }
  }
}
    `;

/**
 * __useBroadcastByIdStatsPerPersonQuery__
 *
 * To run a query within a React component, call `useBroadcastByIdStatsPerPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useBroadcastByIdStatsPerPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBroadcastByIdStatsPerPersonQuery({
 *   variables: {
 *      broadcastId: // value for 'broadcastId'
 *   },
 * });
 */
export function useBroadcastByIdStatsPerPersonQuery(baseOptions: Apollo.QueryHookOptions<BroadcastByIdStatsPerPersonQuery, BroadcastByIdStatsPerPersonQueryVariables> & ({ variables: BroadcastByIdStatsPerPersonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BroadcastByIdStatsPerPersonQuery, BroadcastByIdStatsPerPersonQueryVariables>(BroadcastByIdStatsPerPersonDocument, options);
      }
export function useBroadcastByIdStatsPerPersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BroadcastByIdStatsPerPersonQuery, BroadcastByIdStatsPerPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BroadcastByIdStatsPerPersonQuery, BroadcastByIdStatsPerPersonQueryVariables>(BroadcastByIdStatsPerPersonDocument, options);
        }
// @ts-ignore
export function useBroadcastByIdStatsPerPersonSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BroadcastByIdStatsPerPersonQuery, BroadcastByIdStatsPerPersonQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastByIdStatsPerPersonQuery, BroadcastByIdStatsPerPersonQueryVariables>;
export function useBroadcastByIdStatsPerPersonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastByIdStatsPerPersonQuery, BroadcastByIdStatsPerPersonQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastByIdStatsPerPersonQuery | undefined, BroadcastByIdStatsPerPersonQueryVariables>;
export function useBroadcastByIdStatsPerPersonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastByIdStatsPerPersonQuery, BroadcastByIdStatsPerPersonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BroadcastByIdStatsPerPersonQuery, BroadcastByIdStatsPerPersonQueryVariables>(BroadcastByIdStatsPerPersonDocument, options);
        }
export type BroadcastByIdStatsPerPersonQueryHookResult = ReturnType<typeof useBroadcastByIdStatsPerPersonQuery>;
export type BroadcastByIdStatsPerPersonLazyQueryHookResult = ReturnType<typeof useBroadcastByIdStatsPerPersonLazyQuery>;
export type BroadcastByIdStatsPerPersonSuspenseQueryHookResult = ReturnType<typeof useBroadcastByIdStatsPerPersonSuspenseQuery>;
export type BroadcastByIdStatsPerPersonQueryResult = Apollo.QueryResult<BroadcastByIdStatsPerPersonQuery, BroadcastByIdStatsPerPersonQueryVariables>;
export const BroadcastByUserDocument = gql`
    query BroadcastByUser {
  broadcastByUser {
    _id
    createdDateISO
    updatedDateISO
    coverImage {
      ...ImageFragment
    }
    description {
      ...MultilingualFragment
    }
    name {
      ...MultilingualFragment
    }
    publicName {
      ...MultilingualFragment
    }
    owner {
      type
      entityId
    }
    ownerName {
      ...MultilingualFragment
    }
    status
    sharedTo {
      type
      sentToPeople
      sentToPeopleTags
    }
    resources {
      type
      title {
        ...MultilingualFragment
      }
      description {
        ...MultilingualFragment
      }
      coverImage {
        ...ImageFragment
      }
      message {
        ...MultilingualFragment
      }
      file {
        ...FileFragment
      }
      video {
        ...ImageFragment
      }
      videoURL
      photos {
        ...ImageFragment
      }
      course
      iframeUrl
      survey {
        _id
        perBusinessAnswersEnabled
        name {
          ...MultilingualFragment
        }
        owner {
          type
          entityId
        }
        questions {
          _id
          isActive
          name {
            ...MultilingualFragment
          }
          owner {
            type
            entityId
          }
          required
          type
          parentQuestion
          businessScope
          description {
            ...MultilingualFragment
          }
          options {
            _id
            isActive
            label {
              ...MultilingualFragment
            }
          }
        }
      }
      formMode
      allowSaveAndEdit
      requireApproval
      allowResubmission
      completionTags
      submissionTags
      booker {
        _id
        name {
          ...MultilingualFragment
        }
        status
        bundles {
          product {
            _id
            type
            name {
              ...MultilingualFragment
            }
          }
          _id
        }
      }
      expirationTags
      teamVisible
      ctaLabel {
        ...MultilingualFragment
      }
      _id
    }
  }
}
    ${ImageFragmentFragmentDoc}
${MultilingualFragmentFragmentDoc}
${FileFragmentFragmentDoc}`;

/**
 * __useBroadcastByUserQuery__
 *
 * To run a query within a React component, call `useBroadcastByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useBroadcastByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBroadcastByUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useBroadcastByUserQuery(baseOptions?: Apollo.QueryHookOptions<BroadcastByUserQuery, BroadcastByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BroadcastByUserQuery, BroadcastByUserQueryVariables>(BroadcastByUserDocument, options);
      }
export function useBroadcastByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BroadcastByUserQuery, BroadcastByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BroadcastByUserQuery, BroadcastByUserQueryVariables>(BroadcastByUserDocument, options);
        }
// @ts-ignore
export function useBroadcastByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BroadcastByUserQuery, BroadcastByUserQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastByUserQuery, BroadcastByUserQueryVariables>;
export function useBroadcastByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastByUserQuery, BroadcastByUserQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastByUserQuery | undefined, BroadcastByUserQueryVariables>;
export function useBroadcastByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastByUserQuery, BroadcastByUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BroadcastByUserQuery, BroadcastByUserQueryVariables>(BroadcastByUserDocument, options);
        }
export type BroadcastByUserQueryHookResult = ReturnType<typeof useBroadcastByUserQuery>;
export type BroadcastByUserLazyQueryHookResult = ReturnType<typeof useBroadcastByUserLazyQuery>;
export type BroadcastByUserSuspenseQueryHookResult = ReturnType<typeof useBroadcastByUserSuspenseQuery>;
export type BroadcastByUserQueryResult = Apollo.QueryResult<BroadcastByUserQuery, BroadcastByUserQueryVariables>;
export const BroadcastCountDocument = gql`
    query BroadcastCount($filter: FilterCountBroadcastInput) {
  broadcastCount(filter: $filter)
}
    `;

/**
 * __useBroadcastCountQuery__
 *
 * To run a query within a React component, call `useBroadcastCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBroadcastCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBroadcastCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBroadcastCountQuery(baseOptions?: Apollo.QueryHookOptions<BroadcastCountQuery, BroadcastCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BroadcastCountQuery, BroadcastCountQueryVariables>(BroadcastCountDocument, options);
      }
export function useBroadcastCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BroadcastCountQuery, BroadcastCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BroadcastCountQuery, BroadcastCountQueryVariables>(BroadcastCountDocument, options);
        }
// @ts-ignore
export function useBroadcastCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BroadcastCountQuery, BroadcastCountQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastCountQuery, BroadcastCountQueryVariables>;
export function useBroadcastCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastCountQuery, BroadcastCountQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastCountQuery | undefined, BroadcastCountQueryVariables>;
export function useBroadcastCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastCountQuery, BroadcastCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BroadcastCountQuery, BroadcastCountQueryVariables>(BroadcastCountDocument, options);
        }
export type BroadcastCountQueryHookResult = ReturnType<typeof useBroadcastCountQuery>;
export type BroadcastCountLazyQueryHookResult = ReturnType<typeof useBroadcastCountLazyQuery>;
export type BroadcastCountSuspenseQueryHookResult = ReturnType<typeof useBroadcastCountSuspenseQuery>;
export type BroadcastCountQueryResult = Apollo.QueryResult<BroadcastCountQuery, BroadcastCountQueryVariables>;
export const BroadcastManyDocument = gql`
    query BroadcastMany($filter: FilterFindManyBroadcastInput, $skip: Int, $limit: Int, $sort: SortFindManyBroadcastInput) {
  broadcastMany(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    ...BroadcastFragment
  }
}
    ${BroadcastFragmentFragmentDoc}`;

/**
 * __useBroadcastManyQuery__
 *
 * To run a query within a React component, call `useBroadcastManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useBroadcastManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBroadcastManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useBroadcastManyQuery(baseOptions?: Apollo.QueryHookOptions<BroadcastManyQuery, BroadcastManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BroadcastManyQuery, BroadcastManyQueryVariables>(BroadcastManyDocument, options);
      }
export function useBroadcastManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BroadcastManyQuery, BroadcastManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BroadcastManyQuery, BroadcastManyQueryVariables>(BroadcastManyDocument, options);
        }
// @ts-ignore
export function useBroadcastManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BroadcastManyQuery, BroadcastManyQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastManyQuery, BroadcastManyQueryVariables>;
export function useBroadcastManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastManyQuery, BroadcastManyQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastManyQuery | undefined, BroadcastManyQueryVariables>;
export function useBroadcastManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastManyQuery, BroadcastManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BroadcastManyQuery, BroadcastManyQueryVariables>(BroadcastManyDocument, options);
        }
export type BroadcastManyQueryHookResult = ReturnType<typeof useBroadcastManyQuery>;
export type BroadcastManyLazyQueryHookResult = ReturnType<typeof useBroadcastManyLazyQuery>;
export type BroadcastManySuspenseQueryHookResult = ReturnType<typeof useBroadcastManySuspenseQuery>;
export type BroadcastManyQueryResult = Apollo.QueryResult<BroadcastManyQuery, BroadcastManyQueryVariables>;
export const BroadcastStatsByOrganizationDocument = gql`
    query BroadcastStatsByOrganization($organizationId: ID!) {
  broadcastStatsByOrganization(organizationId: $organizationId) {
    completions
    messageViews
    videoViews
    photoViews
    pdfDownloads
  }
}
    `;

/**
 * __useBroadcastStatsByOrganizationQuery__
 *
 * To run a query within a React component, call `useBroadcastStatsByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBroadcastStatsByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBroadcastStatsByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useBroadcastStatsByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<BroadcastStatsByOrganizationQuery, BroadcastStatsByOrganizationQueryVariables> & ({ variables: BroadcastStatsByOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BroadcastStatsByOrganizationQuery, BroadcastStatsByOrganizationQueryVariables>(BroadcastStatsByOrganizationDocument, options);
      }
export function useBroadcastStatsByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BroadcastStatsByOrganizationQuery, BroadcastStatsByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BroadcastStatsByOrganizationQuery, BroadcastStatsByOrganizationQueryVariables>(BroadcastStatsByOrganizationDocument, options);
        }
// @ts-ignore
export function useBroadcastStatsByOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BroadcastStatsByOrganizationQuery, BroadcastStatsByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastStatsByOrganizationQuery, BroadcastStatsByOrganizationQueryVariables>;
export function useBroadcastStatsByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastStatsByOrganizationQuery, BroadcastStatsByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastStatsByOrganizationQuery | undefined, BroadcastStatsByOrganizationQueryVariables>;
export function useBroadcastStatsByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastStatsByOrganizationQuery, BroadcastStatsByOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BroadcastStatsByOrganizationQuery, BroadcastStatsByOrganizationQueryVariables>(BroadcastStatsByOrganizationDocument, options);
        }
export type BroadcastStatsByOrganizationQueryHookResult = ReturnType<typeof useBroadcastStatsByOrganizationQuery>;
export type BroadcastStatsByOrganizationLazyQueryHookResult = ReturnType<typeof useBroadcastStatsByOrganizationLazyQuery>;
export type BroadcastStatsByOrganizationSuspenseQueryHookResult = ReturnType<typeof useBroadcastStatsByOrganizationSuspenseQuery>;
export type BroadcastStatsByOrganizationQueryResult = Apollo.QueryResult<BroadcastStatsByOrganizationQuery, BroadcastStatsByOrganizationQueryVariables>;
export const BroadcastTeaserByIdDocument = gql`
    query BroadcastTeaserById($broadcastId: MongoID!) {
  broadcastTeaserById(broadcastId: $broadcastId) {
    description
  }
}
    `;

/**
 * __useBroadcastTeaserByIdQuery__
 *
 * To run a query within a React component, call `useBroadcastTeaserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBroadcastTeaserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBroadcastTeaserByIdQuery({
 *   variables: {
 *      broadcastId: // value for 'broadcastId'
 *   },
 * });
 */
export function useBroadcastTeaserByIdQuery(baseOptions: Apollo.QueryHookOptions<BroadcastTeaserByIdQuery, BroadcastTeaserByIdQueryVariables> & ({ variables: BroadcastTeaserByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BroadcastTeaserByIdQuery, BroadcastTeaserByIdQueryVariables>(BroadcastTeaserByIdDocument, options);
      }
export function useBroadcastTeaserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BroadcastTeaserByIdQuery, BroadcastTeaserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BroadcastTeaserByIdQuery, BroadcastTeaserByIdQueryVariables>(BroadcastTeaserByIdDocument, options);
        }
// @ts-ignore
export function useBroadcastTeaserByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BroadcastTeaserByIdQuery, BroadcastTeaserByIdQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastTeaserByIdQuery, BroadcastTeaserByIdQueryVariables>;
export function useBroadcastTeaserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastTeaserByIdQuery, BroadcastTeaserByIdQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastTeaserByIdQuery | undefined, BroadcastTeaserByIdQueryVariables>;
export function useBroadcastTeaserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastTeaserByIdQuery, BroadcastTeaserByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BroadcastTeaserByIdQuery, BroadcastTeaserByIdQueryVariables>(BroadcastTeaserByIdDocument, options);
        }
export type BroadcastTeaserByIdQueryHookResult = ReturnType<typeof useBroadcastTeaserByIdQuery>;
export type BroadcastTeaserByIdLazyQueryHookResult = ReturnType<typeof useBroadcastTeaserByIdLazyQuery>;
export type BroadcastTeaserByIdSuspenseQueryHookResult = ReturnType<typeof useBroadcastTeaserByIdSuspenseQuery>;
export type BroadcastTeaserByIdQueryResult = Apollo.QueryResult<BroadcastTeaserByIdQuery, BroadcastTeaserByIdQueryVariables>;
export const BroadcastsByIdsStatsForSingleUserDocument = gql`
    query BroadcastsByIdsStatsForSingleUser($broadcastIds: [ID!]!) {
  broadcastsByIdsStatsForSingleUser(broadcastIds: $broadcastIds) {
    broadcastId
    resources {
      resourceId
      viewed
      downloaded
      played
      completed
      inProgress
    }
    viewed
  }
}
    `;

/**
 * __useBroadcastsByIdsStatsForSingleUserQuery__
 *
 * To run a query within a React component, call `useBroadcastsByIdsStatsForSingleUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useBroadcastsByIdsStatsForSingleUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBroadcastsByIdsStatsForSingleUserQuery({
 *   variables: {
 *      broadcastIds: // value for 'broadcastIds'
 *   },
 * });
 */
export function useBroadcastsByIdsStatsForSingleUserQuery(baseOptions: Apollo.QueryHookOptions<BroadcastsByIdsStatsForSingleUserQuery, BroadcastsByIdsStatsForSingleUserQueryVariables> & ({ variables: BroadcastsByIdsStatsForSingleUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BroadcastsByIdsStatsForSingleUserQuery, BroadcastsByIdsStatsForSingleUserQueryVariables>(BroadcastsByIdsStatsForSingleUserDocument, options);
      }
export function useBroadcastsByIdsStatsForSingleUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BroadcastsByIdsStatsForSingleUserQuery, BroadcastsByIdsStatsForSingleUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BroadcastsByIdsStatsForSingleUserQuery, BroadcastsByIdsStatsForSingleUserQueryVariables>(BroadcastsByIdsStatsForSingleUserDocument, options);
        }
// @ts-ignore
export function useBroadcastsByIdsStatsForSingleUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BroadcastsByIdsStatsForSingleUserQuery, BroadcastsByIdsStatsForSingleUserQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastsByIdsStatsForSingleUserQuery, BroadcastsByIdsStatsForSingleUserQueryVariables>;
export function useBroadcastsByIdsStatsForSingleUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastsByIdsStatsForSingleUserQuery, BroadcastsByIdsStatsForSingleUserQueryVariables>): Apollo.UseSuspenseQueryResult<BroadcastsByIdsStatsForSingleUserQuery | undefined, BroadcastsByIdsStatsForSingleUserQueryVariables>;
export function useBroadcastsByIdsStatsForSingleUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BroadcastsByIdsStatsForSingleUserQuery, BroadcastsByIdsStatsForSingleUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BroadcastsByIdsStatsForSingleUserQuery, BroadcastsByIdsStatsForSingleUserQueryVariables>(BroadcastsByIdsStatsForSingleUserDocument, options);
        }
export type BroadcastsByIdsStatsForSingleUserQueryHookResult = ReturnType<typeof useBroadcastsByIdsStatsForSingleUserQuery>;
export type BroadcastsByIdsStatsForSingleUserLazyQueryHookResult = ReturnType<typeof useBroadcastsByIdsStatsForSingleUserLazyQuery>;
export type BroadcastsByIdsStatsForSingleUserSuspenseQueryHookResult = ReturnType<typeof useBroadcastsByIdsStatsForSingleUserSuspenseQuery>;
export type BroadcastsByIdsStatsForSingleUserQueryResult = Apollo.QueryResult<BroadcastsByIdsStatsForSingleUserQuery, BroadcastsByIdsStatsForSingleUserQueryVariables>;
export const BulkConnectLogManyDocument = gql`
    query BulkConnectLogMany($limit: Int, $skip: Int) {
  bulkConnectLogMany(limit: $limit, skip: $skip) {
    _id
    operatorEntityIds
    organizationIds
    results {
      operatorEntityId
      operatorName
      organizationId
      organizationName
      status
      error
    }
    totalCount
    successCount
    alreadyConnectedCount
    errorCount
    appliedBackOfficeTagIds
    rollbackInfo {
      rolledBackAt
      rolledBackBy
      disconnectedCount
      errorCount
      errorMessages
    }
    initiatedByUser
    createdDateISO
  }
}
    `;

/**
 * __useBulkConnectLogManyQuery__
 *
 * To run a query within a React component, call `useBulkConnectLogManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkConnectLogManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkConnectLogManyQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useBulkConnectLogManyQuery(baseOptions?: Apollo.QueryHookOptions<BulkConnectLogManyQuery, BulkConnectLogManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkConnectLogManyQuery, BulkConnectLogManyQueryVariables>(BulkConnectLogManyDocument, options);
      }
export function useBulkConnectLogManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkConnectLogManyQuery, BulkConnectLogManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkConnectLogManyQuery, BulkConnectLogManyQueryVariables>(BulkConnectLogManyDocument, options);
        }
// @ts-ignore
export function useBulkConnectLogManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BulkConnectLogManyQuery, BulkConnectLogManyQueryVariables>): Apollo.UseSuspenseQueryResult<BulkConnectLogManyQuery, BulkConnectLogManyQueryVariables>;
export function useBulkConnectLogManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkConnectLogManyQuery, BulkConnectLogManyQueryVariables>): Apollo.UseSuspenseQueryResult<BulkConnectLogManyQuery | undefined, BulkConnectLogManyQueryVariables>;
export function useBulkConnectLogManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkConnectLogManyQuery, BulkConnectLogManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BulkConnectLogManyQuery, BulkConnectLogManyQueryVariables>(BulkConnectLogManyDocument, options);
        }
export type BulkConnectLogManyQueryHookResult = ReturnType<typeof useBulkConnectLogManyQuery>;
export type BulkConnectLogManyLazyQueryHookResult = ReturnType<typeof useBulkConnectLogManyLazyQuery>;
export type BulkConnectLogManySuspenseQueryHookResult = ReturnType<typeof useBulkConnectLogManySuspenseQuery>;
export type BulkConnectLogManyQueryResult = Apollo.QueryResult<BulkConnectLogManyQuery, BulkConnectLogManyQueryVariables>;
export const ChangeLogManyDocument = gql`
    query ChangeLogMany($filter: FilterFindManyChangelogInput, $sort: SortFindManyChangelogInput, $limit: Int) {
  changeLogMany(filter: $filter, sort: $sort, limit: $limit) {
    _id
    initiatedByUser {
      firstName
    }
    owner {
      type
    }
    message {
      ...MultilingualFragment
    }
    createdDateISO
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useChangeLogManyQuery__
 *
 * To run a query within a React component, call `useChangeLogManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeLogManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeLogManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useChangeLogManyQuery(baseOptions?: Apollo.QueryHookOptions<ChangeLogManyQuery, ChangeLogManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChangeLogManyQuery, ChangeLogManyQueryVariables>(ChangeLogManyDocument, options);
      }
export function useChangeLogManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChangeLogManyQuery, ChangeLogManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChangeLogManyQuery, ChangeLogManyQueryVariables>(ChangeLogManyDocument, options);
        }
// @ts-ignore
export function useChangeLogManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChangeLogManyQuery, ChangeLogManyQueryVariables>): Apollo.UseSuspenseQueryResult<ChangeLogManyQuery, ChangeLogManyQueryVariables>;
export function useChangeLogManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChangeLogManyQuery, ChangeLogManyQueryVariables>): Apollo.UseSuspenseQueryResult<ChangeLogManyQuery | undefined, ChangeLogManyQueryVariables>;
export function useChangeLogManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChangeLogManyQuery, ChangeLogManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChangeLogManyQuery, ChangeLogManyQueryVariables>(ChangeLogManyDocument, options);
        }
export type ChangeLogManyQueryHookResult = ReturnType<typeof useChangeLogManyQuery>;
export type ChangeLogManyLazyQueryHookResult = ReturnType<typeof useChangeLogManyLazyQuery>;
export type ChangeLogManySuspenseQueryHookResult = ReturnType<typeof useChangeLogManySuspenseQuery>;
export type ChangeLogManyQueryResult = Apollo.QueryResult<ChangeLogManyQuery, ChangeLogManyQueryVariables>;
export const ChangeLogManyPersonDetailsDocument = gql`
    query ChangeLogManyPersonDetails($filter: FilterFindManyChangelogInput, $sort: SortFindManyChangelogInput, $limit: Int) {
  changeLogManyPersonDetails(filter: $filter, sort: $sort, limit: $limit) {
    _id
    changedEntity {
      _entityId
      _versionId
      name {
        ...MultilingualFragment
      }
    }
    changedEntityOwner {
      type
      entityId
      name {
        ...MultilingualFragment
      }
    }
    message {
      ...MultilingualFragment
    }
    createdDateISO
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useChangeLogManyPersonDetailsQuery__
 *
 * To run a query within a React component, call `useChangeLogManyPersonDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeLogManyPersonDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeLogManyPersonDetailsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useChangeLogManyPersonDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ChangeLogManyPersonDetailsQuery, ChangeLogManyPersonDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChangeLogManyPersonDetailsQuery, ChangeLogManyPersonDetailsQueryVariables>(ChangeLogManyPersonDetailsDocument, options);
      }
export function useChangeLogManyPersonDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChangeLogManyPersonDetailsQuery, ChangeLogManyPersonDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChangeLogManyPersonDetailsQuery, ChangeLogManyPersonDetailsQueryVariables>(ChangeLogManyPersonDetailsDocument, options);
        }
// @ts-ignore
export function useChangeLogManyPersonDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChangeLogManyPersonDetailsQuery, ChangeLogManyPersonDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<ChangeLogManyPersonDetailsQuery, ChangeLogManyPersonDetailsQueryVariables>;
export function useChangeLogManyPersonDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChangeLogManyPersonDetailsQuery, ChangeLogManyPersonDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<ChangeLogManyPersonDetailsQuery | undefined, ChangeLogManyPersonDetailsQueryVariables>;
export function useChangeLogManyPersonDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChangeLogManyPersonDetailsQuery, ChangeLogManyPersonDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChangeLogManyPersonDetailsQuery, ChangeLogManyPersonDetailsQueryVariables>(ChangeLogManyPersonDetailsDocument, options);
        }
export type ChangeLogManyPersonDetailsQueryHookResult = ReturnType<typeof useChangeLogManyPersonDetailsQuery>;
export type ChangeLogManyPersonDetailsLazyQueryHookResult = ReturnType<typeof useChangeLogManyPersonDetailsLazyQuery>;
export type ChangeLogManyPersonDetailsSuspenseQueryHookResult = ReturnType<typeof useChangeLogManyPersonDetailsSuspenseQuery>;
export type ChangeLogManyPersonDetailsQueryResult = Apollo.QueryResult<ChangeLogManyPersonDetailsQuery, ChangeLogManyPersonDetailsQueryVariables>;
export const CourseProgressGetDocument = gql`
    query CourseProgressGet($resourceId: MongoID!, $broadcastId: MongoID!) {
  courseProgressGet(resourceId: $resourceId, broadcastId: $broadcastId) {
    _id
    user
    resourceId
    broadcast
    completionStatus
    successStatus
    scoreScaled
    scoreRaw
    scoreMin
    scoreMax
    location
    suspendData
    sessionTime
    totalTime
    progressMeasure
    firstAccessedAt
    lastAccessedAt
    completedAt
    scormDataSnapshot
    scormVersion
  }
}
    `;

/**
 * __useCourseProgressGetQuery__
 *
 * To run a query within a React component, call `useCourseProgressGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseProgressGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseProgressGetQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      broadcastId: // value for 'broadcastId'
 *   },
 * });
 */
export function useCourseProgressGetQuery(baseOptions: Apollo.QueryHookOptions<CourseProgressGetQuery, CourseProgressGetQueryVariables> & ({ variables: CourseProgressGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseProgressGetQuery, CourseProgressGetQueryVariables>(CourseProgressGetDocument, options);
      }
export function useCourseProgressGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseProgressGetQuery, CourseProgressGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseProgressGetQuery, CourseProgressGetQueryVariables>(CourseProgressGetDocument, options);
        }
// @ts-ignore
export function useCourseProgressGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CourseProgressGetQuery, CourseProgressGetQueryVariables>): Apollo.UseSuspenseQueryResult<CourseProgressGetQuery, CourseProgressGetQueryVariables>;
export function useCourseProgressGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseProgressGetQuery, CourseProgressGetQueryVariables>): Apollo.UseSuspenseQueryResult<CourseProgressGetQuery | undefined, CourseProgressGetQueryVariables>;
export function useCourseProgressGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CourseProgressGetQuery, CourseProgressGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CourseProgressGetQuery, CourseProgressGetQueryVariables>(CourseProgressGetDocument, options);
        }
export type CourseProgressGetQueryHookResult = ReturnType<typeof useCourseProgressGetQuery>;
export type CourseProgressGetLazyQueryHookResult = ReturnType<typeof useCourseProgressGetLazyQuery>;
export type CourseProgressGetSuspenseQueryHookResult = ReturnType<typeof useCourseProgressGetSuspenseQuery>;
export type CourseProgressGetQueryResult = Apollo.QueryResult<CourseProgressGetQuery, CourseProgressGetQueryVariables>;
export const CronJobsListDocument = gql`
    query CronJobsList {
  cronJobsList {
    name
    description
    schedule
    timezone
    enabledForCurrentEnv
    lastRun {
      startedAt
      completedAt
      status
      durationMs
      error
    }
  }
}
    `;

/**
 * __useCronJobsListQuery__
 *
 * To run a query within a React component, call `useCronJobsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCronJobsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCronJobsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCronJobsListQuery(baseOptions?: Apollo.QueryHookOptions<CronJobsListQuery, CronJobsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CronJobsListQuery, CronJobsListQueryVariables>(CronJobsListDocument, options);
      }
export function useCronJobsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CronJobsListQuery, CronJobsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CronJobsListQuery, CronJobsListQueryVariables>(CronJobsListDocument, options);
        }
// @ts-ignore
export function useCronJobsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CronJobsListQuery, CronJobsListQueryVariables>): Apollo.UseSuspenseQueryResult<CronJobsListQuery, CronJobsListQueryVariables>;
export function useCronJobsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CronJobsListQuery, CronJobsListQueryVariables>): Apollo.UseSuspenseQueryResult<CronJobsListQuery | undefined, CronJobsListQueryVariables>;
export function useCronJobsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CronJobsListQuery, CronJobsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CronJobsListQuery, CronJobsListQueryVariables>(CronJobsListDocument, options);
        }
export type CronJobsListQueryHookResult = ReturnType<typeof useCronJobsListQuery>;
export type CronJobsListLazyQueryHookResult = ReturnType<typeof useCronJobsListLazyQuery>;
export type CronJobsListSuspenseQueryHookResult = ReturnType<typeof useCronJobsListSuspenseQuery>;
export type CronJobsListQueryResult = Apollo.QueryResult<CronJobsListQuery, CronJobsListQueryVariables>;
export const DevToolsEmailReplaceProgressDocument = gql`
    query DevToolsEmailReplaceProgress {
  devToolsEmailReplaceProgress {
    total
    completed
    isRunning
  }
}
    `;

/**
 * __useDevToolsEmailReplaceProgressQuery__
 *
 * To run a query within a React component, call `useDevToolsEmailReplaceProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevToolsEmailReplaceProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevToolsEmailReplaceProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useDevToolsEmailReplaceProgressQuery(baseOptions?: Apollo.QueryHookOptions<DevToolsEmailReplaceProgressQuery, DevToolsEmailReplaceProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevToolsEmailReplaceProgressQuery, DevToolsEmailReplaceProgressQueryVariables>(DevToolsEmailReplaceProgressDocument, options);
      }
export function useDevToolsEmailReplaceProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevToolsEmailReplaceProgressQuery, DevToolsEmailReplaceProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevToolsEmailReplaceProgressQuery, DevToolsEmailReplaceProgressQueryVariables>(DevToolsEmailReplaceProgressDocument, options);
        }
// @ts-ignore
export function useDevToolsEmailReplaceProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevToolsEmailReplaceProgressQuery, DevToolsEmailReplaceProgressQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsEmailReplaceProgressQuery, DevToolsEmailReplaceProgressQueryVariables>;
export function useDevToolsEmailReplaceProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsEmailReplaceProgressQuery, DevToolsEmailReplaceProgressQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsEmailReplaceProgressQuery | undefined, DevToolsEmailReplaceProgressQueryVariables>;
export function useDevToolsEmailReplaceProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsEmailReplaceProgressQuery, DevToolsEmailReplaceProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevToolsEmailReplaceProgressQuery, DevToolsEmailReplaceProgressQueryVariables>(DevToolsEmailReplaceProgressDocument, options);
        }
export type DevToolsEmailReplaceProgressQueryHookResult = ReturnType<typeof useDevToolsEmailReplaceProgressQuery>;
export type DevToolsEmailReplaceProgressLazyQueryHookResult = ReturnType<typeof useDevToolsEmailReplaceProgressLazyQuery>;
export type DevToolsEmailReplaceProgressSuspenseQueryHookResult = ReturnType<typeof useDevToolsEmailReplaceProgressSuspenseQuery>;
export type DevToolsEmailReplaceProgressQueryResult = Apollo.QueryResult<DevToolsEmailReplaceProgressQuery, DevToolsEmailReplaceProgressQueryVariables>;
export const DevToolsEmailScanDocument = gql`
    query DevToolsEmailScan($skipDomains: [String!]!, $targetEmailFormat: String) {
  devToolsEmailScan(
    skipDomains: $skipDomains
    targetEmailFormat: $targetEmailFormat
  ) {
    toReplace {
      entityType
      entityId
      currentEmail
      suggestedNewEmail
      context
      visibleToIndex
      emailIndex
    }
    skipped {
      email
      reason
    }
  }
}
    `;

/**
 * __useDevToolsEmailScanQuery__
 *
 * To run a query within a React component, call `useDevToolsEmailScanQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevToolsEmailScanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevToolsEmailScanQuery({
 *   variables: {
 *      skipDomains: // value for 'skipDomains'
 *      targetEmailFormat: // value for 'targetEmailFormat'
 *   },
 * });
 */
export function useDevToolsEmailScanQuery(baseOptions: Apollo.QueryHookOptions<DevToolsEmailScanQuery, DevToolsEmailScanQueryVariables> & ({ variables: DevToolsEmailScanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevToolsEmailScanQuery, DevToolsEmailScanQueryVariables>(DevToolsEmailScanDocument, options);
      }
export function useDevToolsEmailScanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevToolsEmailScanQuery, DevToolsEmailScanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevToolsEmailScanQuery, DevToolsEmailScanQueryVariables>(DevToolsEmailScanDocument, options);
        }
// @ts-ignore
export function useDevToolsEmailScanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevToolsEmailScanQuery, DevToolsEmailScanQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsEmailScanQuery, DevToolsEmailScanQueryVariables>;
export function useDevToolsEmailScanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsEmailScanQuery, DevToolsEmailScanQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsEmailScanQuery | undefined, DevToolsEmailScanQueryVariables>;
export function useDevToolsEmailScanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsEmailScanQuery, DevToolsEmailScanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevToolsEmailScanQuery, DevToolsEmailScanQueryVariables>(DevToolsEmailScanDocument, options);
        }
export type DevToolsEmailScanQueryHookResult = ReturnType<typeof useDevToolsEmailScanQuery>;
export type DevToolsEmailScanLazyQueryHookResult = ReturnType<typeof useDevToolsEmailScanLazyQuery>;
export type DevToolsEmailScanSuspenseQueryHookResult = ReturnType<typeof useDevToolsEmailScanSuspenseQuery>;
export type DevToolsEmailScanQueryResult = Apollo.QueryResult<DevToolsEmailScanQuery, DevToolsEmailScanQueryVariables>;
export const DevToolsMembershipSeedPreviewDocument = gql`
    query DevToolsMembershipSeedPreview($input: DevMembershipSeedInput!) {
  devToolsMembershipSeedPreview(input: $input) {
    organizationId
    organizationName
    blockedCount
    readyCount
    coverage {
      generationMode
      directoryRecords
      untaggedControls
      storefrontId
      storefrontName
      businessTiers {
        covered
        blocked {
          name
          reason
        }
      }
      individualTiers {
        covered
        blocked {
          name
          reason
        }
      }
      rateVariants {
        covered
        blocked {
          name
          reason
        }
      }
    }
    rows {
      caseKey
      mode
      subjectType
      entityComposition
      publicationStatus
      blocked
      blockReason
      warnings
      tierTagId
      tierName
      statusTagIds
      statusTagNames
      renewalDate
      renewalPhase
      rateKind
      rateLabel
      productName
      productTierName
      bookerName
      expectedRenewalAmount
    }
  }
}
    `;

/**
 * __useDevToolsMembershipSeedPreviewQuery__
 *
 * To run a query within a React component, call `useDevToolsMembershipSeedPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevToolsMembershipSeedPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevToolsMembershipSeedPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDevToolsMembershipSeedPreviewQuery(baseOptions: Apollo.QueryHookOptions<DevToolsMembershipSeedPreviewQuery, DevToolsMembershipSeedPreviewQueryVariables> & ({ variables: DevToolsMembershipSeedPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevToolsMembershipSeedPreviewQuery, DevToolsMembershipSeedPreviewQueryVariables>(DevToolsMembershipSeedPreviewDocument, options);
      }
export function useDevToolsMembershipSeedPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevToolsMembershipSeedPreviewQuery, DevToolsMembershipSeedPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevToolsMembershipSeedPreviewQuery, DevToolsMembershipSeedPreviewQueryVariables>(DevToolsMembershipSeedPreviewDocument, options);
        }
// @ts-ignore
export function useDevToolsMembershipSeedPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevToolsMembershipSeedPreviewQuery, DevToolsMembershipSeedPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsMembershipSeedPreviewQuery, DevToolsMembershipSeedPreviewQueryVariables>;
export function useDevToolsMembershipSeedPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsMembershipSeedPreviewQuery, DevToolsMembershipSeedPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsMembershipSeedPreviewQuery | undefined, DevToolsMembershipSeedPreviewQueryVariables>;
export function useDevToolsMembershipSeedPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsMembershipSeedPreviewQuery, DevToolsMembershipSeedPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevToolsMembershipSeedPreviewQuery, DevToolsMembershipSeedPreviewQueryVariables>(DevToolsMembershipSeedPreviewDocument, options);
        }
export type DevToolsMembershipSeedPreviewQueryHookResult = ReturnType<typeof useDevToolsMembershipSeedPreviewQuery>;
export type DevToolsMembershipSeedPreviewLazyQueryHookResult = ReturnType<typeof useDevToolsMembershipSeedPreviewLazyQuery>;
export type DevToolsMembershipSeedPreviewSuspenseQueryHookResult = ReturnType<typeof useDevToolsMembershipSeedPreviewSuspenseQuery>;
export type DevToolsMembershipSeedPreviewQueryResult = Apollo.QueryResult<DevToolsMembershipSeedPreviewQuery, DevToolsMembershipSeedPreviewQueryVariables>;
export const DevToolsMembershipSeedRunsDocument = gql`
    query DevToolsMembershipSeedRuns($organizationId: String) {
  devToolsMembershipSeedRuns(organizationId: $organizationId) {
    _id
    organization
    status
    createdByName
    createdDateISO
    cleanedAt
    cleanedByName
    input {
      organizationId
      mode
      entityComposition
      publicationStatus
      includeBusinessTiers
      includeIndividualTiers
      includeUntaggedControls
      untaggedControlCount
      includeSpecialRateVariants
      recordsPerTier
      renewalEvidence
      renewalExactDate
      renewalPeriodStart
      renewalPeriodEnd
      statusTagIds
    }
    rows {
      caseKey
      mode
      subjectType
      entityComposition
      publicationStatus
      blocked
      blockReason
      warnings
      tierName
      statusTagNames
      renewalDate
      renewalPhase
      rateKind
      rateLabel
      productName
      bookerName
      expectedRenewalAmount
      operatorEntityId
      operatorName
      personId
      personEmail
      membershipId
      originalOrderId
      renewablePurchaseId
      validationOk
      validationMessages
      cleanupMessages
    }
  }
}
    `;

/**
 * __useDevToolsMembershipSeedRunsQuery__
 *
 * To run a query within a React component, call `useDevToolsMembershipSeedRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevToolsMembershipSeedRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevToolsMembershipSeedRunsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDevToolsMembershipSeedRunsQuery(baseOptions?: Apollo.QueryHookOptions<DevToolsMembershipSeedRunsQuery, DevToolsMembershipSeedRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevToolsMembershipSeedRunsQuery, DevToolsMembershipSeedRunsQueryVariables>(DevToolsMembershipSeedRunsDocument, options);
      }
export function useDevToolsMembershipSeedRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevToolsMembershipSeedRunsQuery, DevToolsMembershipSeedRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevToolsMembershipSeedRunsQuery, DevToolsMembershipSeedRunsQueryVariables>(DevToolsMembershipSeedRunsDocument, options);
        }
// @ts-ignore
export function useDevToolsMembershipSeedRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevToolsMembershipSeedRunsQuery, DevToolsMembershipSeedRunsQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsMembershipSeedRunsQuery, DevToolsMembershipSeedRunsQueryVariables>;
export function useDevToolsMembershipSeedRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsMembershipSeedRunsQuery, DevToolsMembershipSeedRunsQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsMembershipSeedRunsQuery | undefined, DevToolsMembershipSeedRunsQueryVariables>;
export function useDevToolsMembershipSeedRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsMembershipSeedRunsQuery, DevToolsMembershipSeedRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevToolsMembershipSeedRunsQuery, DevToolsMembershipSeedRunsQueryVariables>(DevToolsMembershipSeedRunsDocument, options);
        }
export type DevToolsMembershipSeedRunsQueryHookResult = ReturnType<typeof useDevToolsMembershipSeedRunsQuery>;
export type DevToolsMembershipSeedRunsLazyQueryHookResult = ReturnType<typeof useDevToolsMembershipSeedRunsLazyQuery>;
export type DevToolsMembershipSeedRunsSuspenseQueryHookResult = ReturnType<typeof useDevToolsMembershipSeedRunsSuspenseQuery>;
export type DevToolsMembershipSeedRunsQueryResult = Apollo.QueryResult<DevToolsMembershipSeedRunsQuery, DevToolsMembershipSeedRunsQueryVariables>;
export const DevToolsProdSyncCheckDocument = gql`
    query DevToolsProdSyncCheck {
  devToolsProdSyncCheck {
    isAvailable
    message
    collections {
      name
      docCount
      skipped
    }
    totalDocuments
    defaultSkipped
  }
}
    `;

/**
 * __useDevToolsProdSyncCheckQuery__
 *
 * To run a query within a React component, call `useDevToolsProdSyncCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevToolsProdSyncCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevToolsProdSyncCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useDevToolsProdSyncCheckQuery(baseOptions?: Apollo.QueryHookOptions<DevToolsProdSyncCheckQuery, DevToolsProdSyncCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevToolsProdSyncCheckQuery, DevToolsProdSyncCheckQueryVariables>(DevToolsProdSyncCheckDocument, options);
      }
export function useDevToolsProdSyncCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevToolsProdSyncCheckQuery, DevToolsProdSyncCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevToolsProdSyncCheckQuery, DevToolsProdSyncCheckQueryVariables>(DevToolsProdSyncCheckDocument, options);
        }
// @ts-ignore
export function useDevToolsProdSyncCheckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevToolsProdSyncCheckQuery, DevToolsProdSyncCheckQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsProdSyncCheckQuery, DevToolsProdSyncCheckQueryVariables>;
export function useDevToolsProdSyncCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsProdSyncCheckQuery, DevToolsProdSyncCheckQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsProdSyncCheckQuery | undefined, DevToolsProdSyncCheckQueryVariables>;
export function useDevToolsProdSyncCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsProdSyncCheckQuery, DevToolsProdSyncCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevToolsProdSyncCheckQuery, DevToolsProdSyncCheckQueryVariables>(DevToolsProdSyncCheckDocument, options);
        }
export type DevToolsProdSyncCheckQueryHookResult = ReturnType<typeof useDevToolsProdSyncCheckQuery>;
export type DevToolsProdSyncCheckLazyQueryHookResult = ReturnType<typeof useDevToolsProdSyncCheckLazyQuery>;
export type DevToolsProdSyncCheckSuspenseQueryHookResult = ReturnType<typeof useDevToolsProdSyncCheckSuspenseQuery>;
export type DevToolsProdSyncCheckQueryResult = Apollo.QueryResult<DevToolsProdSyncCheckQuery, DevToolsProdSyncCheckQueryVariables>;
export const DirectoryBulkInvitePreviewDocument = gql`
    query DirectoryBulkInvitePreview($organizationId: ID!, $viewContext: BulkInviteViewContext, $tagFilters: [BulkInviteTagFilterInput], $recipientMode: BulkInviteRecipientMode, $includeDmoManaged: Boolean) {
  directoryBulkInvitePreview(
    organizationId: $organizationId
    viewContext: $viewContext
    tagFilters: $tagFilters
    recipientMode: $recipientMode
    includeDmoManaged: $includeDmoManaged
  ) {
    totalInView
    totalEligible
    totalDmoManaged
    totalAlreadyClaimed
    totalAlreadyInvited
    totalConnectedStaff
    primaryContactCount
    financialContactCount
    publicEmailCount
    hasMultiStaffListings
    listingsWithoutContact {
      entityId
      name
    }
  }
}
    `;

/**
 * __useDirectoryBulkInvitePreviewQuery__
 *
 * To run a query within a React component, call `useDirectoryBulkInvitePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectoryBulkInvitePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectoryBulkInvitePreviewQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      viewContext: // value for 'viewContext'
 *      tagFilters: // value for 'tagFilters'
 *      recipientMode: // value for 'recipientMode'
 *      includeDmoManaged: // value for 'includeDmoManaged'
 *   },
 * });
 */
export function useDirectoryBulkInvitePreviewQuery(baseOptions: Apollo.QueryHookOptions<DirectoryBulkInvitePreviewQuery, DirectoryBulkInvitePreviewQueryVariables> & ({ variables: DirectoryBulkInvitePreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DirectoryBulkInvitePreviewQuery, DirectoryBulkInvitePreviewQueryVariables>(DirectoryBulkInvitePreviewDocument, options);
      }
export function useDirectoryBulkInvitePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DirectoryBulkInvitePreviewQuery, DirectoryBulkInvitePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DirectoryBulkInvitePreviewQuery, DirectoryBulkInvitePreviewQueryVariables>(DirectoryBulkInvitePreviewDocument, options);
        }
// @ts-ignore
export function useDirectoryBulkInvitePreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DirectoryBulkInvitePreviewQuery, DirectoryBulkInvitePreviewQueryVariables>): Apollo.UseSuspenseQueryResult<DirectoryBulkInvitePreviewQuery, DirectoryBulkInvitePreviewQueryVariables>;
export function useDirectoryBulkInvitePreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectoryBulkInvitePreviewQuery, DirectoryBulkInvitePreviewQueryVariables>): Apollo.UseSuspenseQueryResult<DirectoryBulkInvitePreviewQuery | undefined, DirectoryBulkInvitePreviewQueryVariables>;
export function useDirectoryBulkInvitePreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectoryBulkInvitePreviewQuery, DirectoryBulkInvitePreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DirectoryBulkInvitePreviewQuery, DirectoryBulkInvitePreviewQueryVariables>(DirectoryBulkInvitePreviewDocument, options);
        }
export type DirectoryBulkInvitePreviewQueryHookResult = ReturnType<typeof useDirectoryBulkInvitePreviewQuery>;
export type DirectoryBulkInvitePreviewLazyQueryHookResult = ReturnType<typeof useDirectoryBulkInvitePreviewLazyQuery>;
export type DirectoryBulkInvitePreviewSuspenseQueryHookResult = ReturnType<typeof useDirectoryBulkInvitePreviewSuspenseQuery>;
export type DirectoryBulkInvitePreviewQueryResult = Apollo.QueryResult<DirectoryBulkInvitePreviewQuery, DirectoryBulkInvitePreviewQueryVariables>;
export const DirectoryMediaSearchDocument = gql`
    query DirectoryMediaSearch($organizationId: MongoID, $search: String, $alreadyUsed: Boolean, $mediaType: String, $mediaTagIds: [MongoID!], $businessTypeTagIds: [MongoID!], $amenityTagIds: [MongoID!], $backOfficeTagIds: [MongoID!], $keywordTagIds: [MongoID!], $selectedTagGroupIds: [MongoID!], $location: [Float!], $listId: MongoID, $limit: Int) {
  directoryMediaSearch(
    organizationId: $organizationId
    search: $search
    alreadyUsed: $alreadyUsed
    mediaType: $mediaType
    mediaTagIds: $mediaTagIds
    businessTypeTagIds: $businessTypeTagIds
    amenityTagIds: $amenityTagIds
    backOfficeTagIds: $backOfficeTagIds
    keywordTagIds: $keywordTagIds
    selectedTagGroupIds: $selectedTagGroupIds
    location: $location
    listId: $listId
    limit: $limit
  )
}
    `;

/**
 * __useDirectoryMediaSearchQuery__
 *
 * To run a query within a React component, call `useDirectoryMediaSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectoryMediaSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectoryMediaSearchQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      search: // value for 'search'
 *      alreadyUsed: // value for 'alreadyUsed'
 *      mediaType: // value for 'mediaType'
 *      mediaTagIds: // value for 'mediaTagIds'
 *      businessTypeTagIds: // value for 'businessTypeTagIds'
 *      amenityTagIds: // value for 'amenityTagIds'
 *      backOfficeTagIds: // value for 'backOfficeTagIds'
 *      keywordTagIds: // value for 'keywordTagIds'
 *      selectedTagGroupIds: // value for 'selectedTagGroupIds'
 *      location: // value for 'location'
 *      listId: // value for 'listId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDirectoryMediaSearchQuery(baseOptions?: Apollo.QueryHookOptions<DirectoryMediaSearchQuery, DirectoryMediaSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DirectoryMediaSearchQuery, DirectoryMediaSearchQueryVariables>(DirectoryMediaSearchDocument, options);
      }
export function useDirectoryMediaSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DirectoryMediaSearchQuery, DirectoryMediaSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DirectoryMediaSearchQuery, DirectoryMediaSearchQueryVariables>(DirectoryMediaSearchDocument, options);
        }
// @ts-ignore
export function useDirectoryMediaSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DirectoryMediaSearchQuery, DirectoryMediaSearchQueryVariables>): Apollo.UseSuspenseQueryResult<DirectoryMediaSearchQuery, DirectoryMediaSearchQueryVariables>;
export function useDirectoryMediaSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectoryMediaSearchQuery, DirectoryMediaSearchQueryVariables>): Apollo.UseSuspenseQueryResult<DirectoryMediaSearchQuery | undefined, DirectoryMediaSearchQueryVariables>;
export function useDirectoryMediaSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectoryMediaSearchQuery, DirectoryMediaSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DirectoryMediaSearchQuery, DirectoryMediaSearchQueryVariables>(DirectoryMediaSearchDocument, options);
        }
export type DirectoryMediaSearchQueryHookResult = ReturnType<typeof useDirectoryMediaSearchQuery>;
export type DirectoryMediaSearchLazyQueryHookResult = ReturnType<typeof useDirectoryMediaSearchLazyQuery>;
export type DirectoryMediaSearchSuspenseQueryHookResult = ReturnType<typeof useDirectoryMediaSearchSuspenseQuery>;
export type DirectoryMediaSearchQueryResult = Apollo.QueryResult<DirectoryMediaSearchQuery, DirectoryMediaSearchQueryVariables>;
export const DirectoryOperatorEntityIdsDocument = gql`
    query DirectoryOperatorEntityIds($organizationId: ID!, $publicationStatus: PublicationStatusType, $search: String, $type: String, $claimed: Boolean, $organizationControlled: Boolean, $operationalStatus: [String], $entityIds: [String], $audienceTagIds: [String], $usedInWidgets: Boolean, $notInWidgets: Boolean, $noAudienceTags: Boolean) {
  directoryOperatorEntityIds(
    organizationId: $organizationId
    publicationStatus: $publicationStatus
    search: $search
    type: $type
    claimed: $claimed
    organizationControlled: $organizationControlled
    operationalStatus: $operationalStatus
    entityIds: $entityIds
    audienceTagIds: $audienceTagIds
    usedInWidgets: $usedInWidgets
    notInWidgets: $notInWidgets
    noAudienceTags: $noAudienceTags
  )
}
    `;

/**
 * __useDirectoryOperatorEntityIdsQuery__
 *
 * To run a query within a React component, call `useDirectoryOperatorEntityIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectoryOperatorEntityIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectoryOperatorEntityIdsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      publicationStatus: // value for 'publicationStatus'
 *      search: // value for 'search'
 *      type: // value for 'type'
 *      claimed: // value for 'claimed'
 *      organizationControlled: // value for 'organizationControlled'
 *      operationalStatus: // value for 'operationalStatus'
 *      entityIds: // value for 'entityIds'
 *      audienceTagIds: // value for 'audienceTagIds'
 *      usedInWidgets: // value for 'usedInWidgets'
 *      notInWidgets: // value for 'notInWidgets'
 *      noAudienceTags: // value for 'noAudienceTags'
 *   },
 * });
 */
export function useDirectoryOperatorEntityIdsQuery(baseOptions: Apollo.QueryHookOptions<DirectoryOperatorEntityIdsQuery, DirectoryOperatorEntityIdsQueryVariables> & ({ variables: DirectoryOperatorEntityIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DirectoryOperatorEntityIdsQuery, DirectoryOperatorEntityIdsQueryVariables>(DirectoryOperatorEntityIdsDocument, options);
      }
export function useDirectoryOperatorEntityIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DirectoryOperatorEntityIdsQuery, DirectoryOperatorEntityIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DirectoryOperatorEntityIdsQuery, DirectoryOperatorEntityIdsQueryVariables>(DirectoryOperatorEntityIdsDocument, options);
        }
// @ts-ignore
export function useDirectoryOperatorEntityIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DirectoryOperatorEntityIdsQuery, DirectoryOperatorEntityIdsQueryVariables>): Apollo.UseSuspenseQueryResult<DirectoryOperatorEntityIdsQuery, DirectoryOperatorEntityIdsQueryVariables>;
export function useDirectoryOperatorEntityIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectoryOperatorEntityIdsQuery, DirectoryOperatorEntityIdsQueryVariables>): Apollo.UseSuspenseQueryResult<DirectoryOperatorEntityIdsQuery | undefined, DirectoryOperatorEntityIdsQueryVariables>;
export function useDirectoryOperatorEntityIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectoryOperatorEntityIdsQuery, DirectoryOperatorEntityIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DirectoryOperatorEntityIdsQuery, DirectoryOperatorEntityIdsQueryVariables>(DirectoryOperatorEntityIdsDocument, options);
        }
export type DirectoryOperatorEntityIdsQueryHookResult = ReturnType<typeof useDirectoryOperatorEntityIdsQuery>;
export type DirectoryOperatorEntityIdsLazyQueryHookResult = ReturnType<typeof useDirectoryOperatorEntityIdsLazyQuery>;
export type DirectoryOperatorEntityIdsSuspenseQueryHookResult = ReturnType<typeof useDirectoryOperatorEntityIdsSuspenseQuery>;
export type DirectoryOperatorEntityIdsQueryResult = Apollo.QueryResult<DirectoryOperatorEntityIdsQuery, DirectoryOperatorEntityIdsQueryVariables>;
export const DirectoryOperatorsDocument = gql`
    query DirectoryOperators($organizationId: ID!, $publicationStatus: PublicationStatusType, $sort: DirectorySortEnum, $limit: Int, $after: String, $search: String, $type: String, $claimed: Boolean, $organizationControlled: Boolean, $operationalStatus: [String], $entityIds: [String], $audienceTagIds: [String], $usedInWidgets: Boolean, $notInWidgets: Boolean, $noAudienceTags: Boolean, $includeCount: Boolean = true) {
  directoryOperators(
    organizationId: $organizationId
    publicationStatus: $publicationStatus
    sort: $sort
    limit: $limit
    after: $after
    search: $search
    type: $type
    claimed: $claimed
    organizationControlled: $organizationControlled
    operationalStatus: $operationalStatus
    entityIds: $entityIds
    audienceTagIds: $audienceTagIds
    usedInWidgets: $usedInWidgets
    notInWidgets: $notInWidgets
    noAudienceTags: $noAudienceTags
    includeCount: $includeCount
  ) {
    items {
      _entityId
      _versionId
      updatedDateISO
      claimed
      name {
        ...MultilingualFragment
      }
      type
      operationalStatus
      images(limit: 1) {
        ...ImageFragment
      }
      status
      iasc
      enrollments {
        organization {
          _id
          shortName
        }
        organizationControlled
        onboardingStatus
      }
      connectedOrganization {
        _id
        name {
          ...MultilingualFragment
        }
        logo {
          ...ImageFragment
        }
      }
    }
    totalCount @include(if: $includeCount)
    nextCursor
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useDirectoryOperatorsQuery__
 *
 * To run a query within a React component, call `useDirectoryOperatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectoryOperatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectoryOperatorsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      publicationStatus: // value for 'publicationStatus'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      type: // value for 'type'
 *      claimed: // value for 'claimed'
 *      organizationControlled: // value for 'organizationControlled'
 *      operationalStatus: // value for 'operationalStatus'
 *      entityIds: // value for 'entityIds'
 *      audienceTagIds: // value for 'audienceTagIds'
 *      usedInWidgets: // value for 'usedInWidgets'
 *      notInWidgets: // value for 'notInWidgets'
 *      noAudienceTags: // value for 'noAudienceTags'
 *      includeCount: // value for 'includeCount'
 *   },
 * });
 */
export function useDirectoryOperatorsQuery(baseOptions: Apollo.QueryHookOptions<DirectoryOperatorsQuery, DirectoryOperatorsQueryVariables> & ({ variables: DirectoryOperatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DirectoryOperatorsQuery, DirectoryOperatorsQueryVariables>(DirectoryOperatorsDocument, options);
      }
export function useDirectoryOperatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DirectoryOperatorsQuery, DirectoryOperatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DirectoryOperatorsQuery, DirectoryOperatorsQueryVariables>(DirectoryOperatorsDocument, options);
        }
// @ts-ignore
export function useDirectoryOperatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DirectoryOperatorsQuery, DirectoryOperatorsQueryVariables>): Apollo.UseSuspenseQueryResult<DirectoryOperatorsQuery, DirectoryOperatorsQueryVariables>;
export function useDirectoryOperatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectoryOperatorsQuery, DirectoryOperatorsQueryVariables>): Apollo.UseSuspenseQueryResult<DirectoryOperatorsQuery | undefined, DirectoryOperatorsQueryVariables>;
export function useDirectoryOperatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectoryOperatorsQuery, DirectoryOperatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DirectoryOperatorsQuery, DirectoryOperatorsQueryVariables>(DirectoryOperatorsDocument, options);
        }
export type DirectoryOperatorsQueryHookResult = ReturnType<typeof useDirectoryOperatorsQuery>;
export type DirectoryOperatorsLazyQueryHookResult = ReturnType<typeof useDirectoryOperatorsLazyQuery>;
export type DirectoryOperatorsSuspenseQueryHookResult = ReturnType<typeof useDirectoryOperatorsSuspenseQuery>;
export type DirectoryOperatorsQueryResult = Apollo.QueryResult<DirectoryOperatorsQuery, DirectoryOperatorsQueryVariables>;
export const DiscountByIdsDocument = gql`
    query DiscountByIds($ids: [MongoID!]!) {
  discountByIds(_ids: $ids) {
    _id
    name {
      en
      fr
      es
    }
    promoCode
    unit
    type
    amount
    excludeUpsells
    isOngoing
    perTicket
  }
}
    `;

/**
 * __useDiscountByIdsQuery__
 *
 * To run a query within a React component, call `useDiscountByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDiscountByIdsQuery(baseOptions: Apollo.QueryHookOptions<DiscountByIdsQuery, DiscountByIdsQueryVariables> & ({ variables: DiscountByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountByIdsQuery, DiscountByIdsQueryVariables>(DiscountByIdsDocument, options);
      }
export function useDiscountByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountByIdsQuery, DiscountByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountByIdsQuery, DiscountByIdsQueryVariables>(DiscountByIdsDocument, options);
        }
// @ts-ignore
export function useDiscountByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiscountByIdsQuery, DiscountByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<DiscountByIdsQuery, DiscountByIdsQueryVariables>;
export function useDiscountByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscountByIdsQuery, DiscountByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<DiscountByIdsQuery | undefined, DiscountByIdsQueryVariables>;
export function useDiscountByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscountByIdsQuery, DiscountByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscountByIdsQuery, DiscountByIdsQueryVariables>(DiscountByIdsDocument, options);
        }
export type DiscountByIdsQueryHookResult = ReturnType<typeof useDiscountByIdsQuery>;
export type DiscountByIdsLazyQueryHookResult = ReturnType<typeof useDiscountByIdsLazyQuery>;
export type DiscountByIdsSuspenseQueryHookResult = ReturnType<typeof useDiscountByIdsSuspenseQuery>;
export type DiscountByIdsQueryResult = Apollo.QueryResult<DiscountByIdsQuery, DiscountByIdsQueryVariables>;
export const DiscountManyDocument = gql`
    query DiscountMany($filter: FilterFindManyDiscountInput, $isUsable: Boolean, $limit: Int) {
  discountMany(filter: $filter, isUsable: $isUsable, limit: $limit) {
    ...DiscountFragment
  }
}
    ${DiscountFragmentFragmentDoc}`;

/**
 * __useDiscountManyQuery__
 *
 * To run a query within a React component, call `useDiscountManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      isUsable: // value for 'isUsable'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDiscountManyQuery(baseOptions?: Apollo.QueryHookOptions<DiscountManyQuery, DiscountManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountManyQuery, DiscountManyQueryVariables>(DiscountManyDocument, options);
      }
export function useDiscountManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountManyQuery, DiscountManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountManyQuery, DiscountManyQueryVariables>(DiscountManyDocument, options);
        }
// @ts-ignore
export function useDiscountManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiscountManyQuery, DiscountManyQueryVariables>): Apollo.UseSuspenseQueryResult<DiscountManyQuery, DiscountManyQueryVariables>;
export function useDiscountManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscountManyQuery, DiscountManyQueryVariables>): Apollo.UseSuspenseQueryResult<DiscountManyQuery | undefined, DiscountManyQueryVariables>;
export function useDiscountManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscountManyQuery, DiscountManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscountManyQuery, DiscountManyQueryVariables>(DiscountManyDocument, options);
        }
export type DiscountManyQueryHookResult = ReturnType<typeof useDiscountManyQuery>;
export type DiscountManyLazyQueryHookResult = ReturnType<typeof useDiscountManyLazyQuery>;
export type DiscountManySuspenseQueryHookResult = ReturnType<typeof useDiscountManySuspenseQuery>;
export type DiscountManyQueryResult = Apollo.QueryResult<DiscountManyQuery, DiscountManyQueryVariables>;
export const EmailSuppressionsAdminDocument = gql`
    query EmailSuppressionsAdmin($organizationId: MongoID, $reason: EmailSuppressionReasonEnum, $search: String, $limit: Int, $offset: Int) {
  emailSuppressionsAdmin(
    organizationId: $organizationId
    reason: $reason
    search: $search
    limit: $limit
    offset: $offset
  ) {
    total
    items {
      _id
      email
      organizationId
      organizationName
      reason
      source
      createdDateISO
    }
  }
}
    `;

/**
 * __useEmailSuppressionsAdminQuery__
 *
 * To run a query within a React component, call `useEmailSuppressionsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailSuppressionsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailSuppressionsAdminQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      reason: // value for 'reason'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useEmailSuppressionsAdminQuery(baseOptions?: Apollo.QueryHookOptions<EmailSuppressionsAdminQuery, EmailSuppressionsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailSuppressionsAdminQuery, EmailSuppressionsAdminQueryVariables>(EmailSuppressionsAdminDocument, options);
      }
export function useEmailSuppressionsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailSuppressionsAdminQuery, EmailSuppressionsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailSuppressionsAdminQuery, EmailSuppressionsAdminQueryVariables>(EmailSuppressionsAdminDocument, options);
        }
// @ts-ignore
export function useEmailSuppressionsAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailSuppressionsAdminQuery, EmailSuppressionsAdminQueryVariables>): Apollo.UseSuspenseQueryResult<EmailSuppressionsAdminQuery, EmailSuppressionsAdminQueryVariables>;
export function useEmailSuppressionsAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailSuppressionsAdminQuery, EmailSuppressionsAdminQueryVariables>): Apollo.UseSuspenseQueryResult<EmailSuppressionsAdminQuery | undefined, EmailSuppressionsAdminQueryVariables>;
export function useEmailSuppressionsAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailSuppressionsAdminQuery, EmailSuppressionsAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailSuppressionsAdminQuery, EmailSuppressionsAdminQueryVariables>(EmailSuppressionsAdminDocument, options);
        }
export type EmailSuppressionsAdminQueryHookResult = ReturnType<typeof useEmailSuppressionsAdminQuery>;
export type EmailSuppressionsAdminLazyQueryHookResult = ReturnType<typeof useEmailSuppressionsAdminLazyQuery>;
export type EmailSuppressionsAdminSuspenseQueryHookResult = ReturnType<typeof useEmailSuppressionsAdminSuspenseQuery>;
export type EmailSuppressionsAdminQueryResult = Apollo.QueryResult<EmailSuppressionsAdminQuery, EmailSuppressionsAdminQueryVariables>;
export const EventByIdDocument = gql`
    query EventById($id: MongoID!) {
  eventById(_id: $id) {
    ...EventDetailsFragment
  }
}
    ${EventDetailsFragmentFragmentDoc}`;

/**
 * __useEventByIdQuery__
 *
 * To run a query within a React component, call `useEventByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventByIdQuery(baseOptions: Apollo.QueryHookOptions<EventByIdQuery, EventByIdQueryVariables> & ({ variables: EventByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventByIdQuery, EventByIdQueryVariables>(EventByIdDocument, options);
      }
export function useEventByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventByIdQuery, EventByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventByIdQuery, EventByIdQueryVariables>(EventByIdDocument, options);
        }
// @ts-ignore
export function useEventByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventByIdQuery, EventByIdQueryVariables>): Apollo.UseSuspenseQueryResult<EventByIdQuery, EventByIdQueryVariables>;
export function useEventByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventByIdQuery, EventByIdQueryVariables>): Apollo.UseSuspenseQueryResult<EventByIdQuery | undefined, EventByIdQueryVariables>;
export function useEventByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventByIdQuery, EventByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventByIdQuery, EventByIdQueryVariables>(EventByIdDocument, options);
        }
export type EventByIdQueryHookResult = ReturnType<typeof useEventByIdQuery>;
export type EventByIdLazyQueryHookResult = ReturnType<typeof useEventByIdLazyQuery>;
export type EventByIdSuspenseQueryHookResult = ReturnType<typeof useEventByIdSuspenseQuery>;
export type EventByIdQueryResult = Apollo.QueryResult<EventByIdQuery, EventByIdQueryVariables>;
export const EventByIdPartialDetailsDocument = gql`
    query EventByIdPartialDetails($id: MongoID!) {
  eventById(_id: $id) {
    description {
      ...MultilingualFragment
    }
    eventLocations {
      ...EventLocationFragment
    }
    images {
      ...ImageFragment
    }
    checkoutWidgets {
      bookerId
      name {
        ...MultilingualFragment
      }
      status
      ticketStructure
      sellingType
      image {
        ...ImageFragment
      }
      embed {
        customElementHtml
        scriptSrc
        scriptHtml
        launcherHtml
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${EventLocationFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useEventByIdPartialDetailsQuery__
 *
 * To run a query within a React component, call `useEventByIdPartialDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventByIdPartialDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventByIdPartialDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventByIdPartialDetailsQuery(baseOptions: Apollo.QueryHookOptions<EventByIdPartialDetailsQuery, EventByIdPartialDetailsQueryVariables> & ({ variables: EventByIdPartialDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventByIdPartialDetailsQuery, EventByIdPartialDetailsQueryVariables>(EventByIdPartialDetailsDocument, options);
      }
export function useEventByIdPartialDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventByIdPartialDetailsQuery, EventByIdPartialDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventByIdPartialDetailsQuery, EventByIdPartialDetailsQueryVariables>(EventByIdPartialDetailsDocument, options);
        }
// @ts-ignore
export function useEventByIdPartialDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventByIdPartialDetailsQuery, EventByIdPartialDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<EventByIdPartialDetailsQuery, EventByIdPartialDetailsQueryVariables>;
export function useEventByIdPartialDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventByIdPartialDetailsQuery, EventByIdPartialDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<EventByIdPartialDetailsQuery | undefined, EventByIdPartialDetailsQueryVariables>;
export function useEventByIdPartialDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventByIdPartialDetailsQuery, EventByIdPartialDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventByIdPartialDetailsQuery, EventByIdPartialDetailsQueryVariables>(EventByIdPartialDetailsDocument, options);
        }
export type EventByIdPartialDetailsQueryHookResult = ReturnType<typeof useEventByIdPartialDetailsQuery>;
export type EventByIdPartialDetailsLazyQueryHookResult = ReturnType<typeof useEventByIdPartialDetailsLazyQuery>;
export type EventByIdPartialDetailsSuspenseQueryHookResult = ReturnType<typeof useEventByIdPartialDetailsSuspenseQuery>;
export type EventByIdPartialDetailsQueryResult = Apollo.QueryResult<EventByIdPartialDetailsQuery, EventByIdPartialDetailsQueryVariables>;
export const EventCalendarSalesDocument = gql`
    query EventCalendarSales($storefrontId: ID!, $startDate: String!, $endDate: String!) {
  eventCalendarSales(
    storefrontId: $storefrontId
    startDate: $startDate
    endDate: $endDate
  ) {
    productId
    productName
    tierId
    tierName
    totalSold
    sessions
    spanStartDate
    spanEndDate
    timeSlots {
      sessionId
      from
      to
    }
  }
}
    `;

/**
 * __useEventCalendarSalesQuery__
 *
 * To run a query within a React component, call `useEventCalendarSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventCalendarSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventCalendarSalesQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useEventCalendarSalesQuery(baseOptions: Apollo.QueryHookOptions<EventCalendarSalesQuery, EventCalendarSalesQueryVariables> & ({ variables: EventCalendarSalesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventCalendarSalesQuery, EventCalendarSalesQueryVariables>(EventCalendarSalesDocument, options);
      }
export function useEventCalendarSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventCalendarSalesQuery, EventCalendarSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventCalendarSalesQuery, EventCalendarSalesQueryVariables>(EventCalendarSalesDocument, options);
        }
// @ts-ignore
export function useEventCalendarSalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventCalendarSalesQuery, EventCalendarSalesQueryVariables>): Apollo.UseSuspenseQueryResult<EventCalendarSalesQuery, EventCalendarSalesQueryVariables>;
export function useEventCalendarSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventCalendarSalesQuery, EventCalendarSalesQueryVariables>): Apollo.UseSuspenseQueryResult<EventCalendarSalesQuery | undefined, EventCalendarSalesQueryVariables>;
export function useEventCalendarSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventCalendarSalesQuery, EventCalendarSalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventCalendarSalesQuery, EventCalendarSalesQueryVariables>(EventCalendarSalesDocument, options);
        }
export type EventCalendarSalesQueryHookResult = ReturnType<typeof useEventCalendarSalesQuery>;
export type EventCalendarSalesLazyQueryHookResult = ReturnType<typeof useEventCalendarSalesLazyQuery>;
export type EventCalendarSalesSuspenseQueryHookResult = ReturnType<typeof useEventCalendarSalesSuspenseQuery>;
export type EventCalendarSalesQueryResult = Apollo.QueryResult<EventCalendarSalesQuery, EventCalendarSalesQueryVariables>;
export const EventCalendarSessionSalesDocument = gql`
    query EventCalendarSessionSales($storefrontId: ID!, $startDate: String!, $endDate: String!) {
  eventCalendarSessionSales(
    storefrontId: $storefrontId
    startDate: $startDate
    endDate: $endDate
  ) {
    eventId
    eventName
    productId
    sessionId
    sessionDate
    timeSlotLabel
    totalSold
    passesSold
    ticketsSold
    eventDateTotalSold
    eventDatePassesSold
    eventDateTicketsSold
    totalCapacity
    remainingCapacity
    isUnlimited
  }
}
    `;

/**
 * __useEventCalendarSessionSalesQuery__
 *
 * To run a query within a React component, call `useEventCalendarSessionSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventCalendarSessionSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventCalendarSessionSalesQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useEventCalendarSessionSalesQuery(baseOptions: Apollo.QueryHookOptions<EventCalendarSessionSalesQuery, EventCalendarSessionSalesQueryVariables> & ({ variables: EventCalendarSessionSalesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventCalendarSessionSalesQuery, EventCalendarSessionSalesQueryVariables>(EventCalendarSessionSalesDocument, options);
      }
export function useEventCalendarSessionSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventCalendarSessionSalesQuery, EventCalendarSessionSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventCalendarSessionSalesQuery, EventCalendarSessionSalesQueryVariables>(EventCalendarSessionSalesDocument, options);
        }
// @ts-ignore
export function useEventCalendarSessionSalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventCalendarSessionSalesQuery, EventCalendarSessionSalesQueryVariables>): Apollo.UseSuspenseQueryResult<EventCalendarSessionSalesQuery, EventCalendarSessionSalesQueryVariables>;
export function useEventCalendarSessionSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventCalendarSessionSalesQuery, EventCalendarSessionSalesQueryVariables>): Apollo.UseSuspenseQueryResult<EventCalendarSessionSalesQuery | undefined, EventCalendarSessionSalesQueryVariables>;
export function useEventCalendarSessionSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventCalendarSessionSalesQuery, EventCalendarSessionSalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventCalendarSessionSalesQuery, EventCalendarSessionSalesQueryVariables>(EventCalendarSessionSalesDocument, options);
        }
export type EventCalendarSessionSalesQueryHookResult = ReturnType<typeof useEventCalendarSessionSalesQuery>;
export type EventCalendarSessionSalesLazyQueryHookResult = ReturnType<typeof useEventCalendarSessionSalesLazyQuery>;
export type EventCalendarSessionSalesSuspenseQueryHookResult = ReturnType<typeof useEventCalendarSessionSalesSuspenseQuery>;
export type EventCalendarSessionSalesQueryResult = Apollo.QueryResult<EventCalendarSessionSalesQuery, EventCalendarSessionSalesQueryVariables>;
export const EventCountDocument = gql`
    query EventCount($startDate: String!, $endDate: String!, $organizationId: ID, $operatorId: ID) {
  eventCount(
    startDate: $startDate
    endDate: $endDate
    organizationId: $organizationId
    operatorId: $operatorId
  )
}
    `;

/**
 * __useEventCountQuery__
 *
 * To run a query within a React component, call `useEventCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventCountQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      organizationId: // value for 'organizationId'
 *      operatorId: // value for 'operatorId'
 *   },
 * });
 */
export function useEventCountQuery(baseOptions: Apollo.QueryHookOptions<EventCountQuery, EventCountQueryVariables> & ({ variables: EventCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventCountQuery, EventCountQueryVariables>(EventCountDocument, options);
      }
export function useEventCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventCountQuery, EventCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventCountQuery, EventCountQueryVariables>(EventCountDocument, options);
        }
// @ts-ignore
export function useEventCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventCountQuery, EventCountQueryVariables>): Apollo.UseSuspenseQueryResult<EventCountQuery, EventCountQueryVariables>;
export function useEventCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventCountQuery, EventCountQueryVariables>): Apollo.UseSuspenseQueryResult<EventCountQuery | undefined, EventCountQueryVariables>;
export function useEventCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventCountQuery, EventCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventCountQuery, EventCountQueryVariables>(EventCountDocument, options);
        }
export type EventCountQueryHookResult = ReturnType<typeof useEventCountQuery>;
export type EventCountLazyQueryHookResult = ReturnType<typeof useEventCountLazyQuery>;
export type EventCountSuspenseQueryHookResult = ReturnType<typeof useEventCountSuspenseQuery>;
export type EventCountQueryResult = Apollo.QueryResult<EventCountQuery, EventCountQueryVariables>;
export const EventInventorySettingsDocument = gql`
    query EventInventorySettings($eventId: ID!) {
  eventInventorySettings(eventId: $eventId) {
    event
    defaultCapacityPerSession
    sessionOverrides {
      sessionId
      capacity
    }
  }
}
    `;

/**
 * __useEventInventorySettingsQuery__
 *
 * To run a query within a React component, call `useEventInventorySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventInventorySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventInventorySettingsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventInventorySettingsQuery(baseOptions: Apollo.QueryHookOptions<EventInventorySettingsQuery, EventInventorySettingsQueryVariables> & ({ variables: EventInventorySettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventInventorySettingsQuery, EventInventorySettingsQueryVariables>(EventInventorySettingsDocument, options);
      }
export function useEventInventorySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventInventorySettingsQuery, EventInventorySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventInventorySettingsQuery, EventInventorySettingsQueryVariables>(EventInventorySettingsDocument, options);
        }
// @ts-ignore
export function useEventInventorySettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventInventorySettingsQuery, EventInventorySettingsQueryVariables>): Apollo.UseSuspenseQueryResult<EventInventorySettingsQuery, EventInventorySettingsQueryVariables>;
export function useEventInventorySettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventInventorySettingsQuery, EventInventorySettingsQueryVariables>): Apollo.UseSuspenseQueryResult<EventInventorySettingsQuery | undefined, EventInventorySettingsQueryVariables>;
export function useEventInventorySettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventInventorySettingsQuery, EventInventorySettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventInventorySettingsQuery, EventInventorySettingsQueryVariables>(EventInventorySettingsDocument, options);
        }
export type EventInventorySettingsQueryHookResult = ReturnType<typeof useEventInventorySettingsQuery>;
export type EventInventorySettingsLazyQueryHookResult = ReturnType<typeof useEventInventorySettingsLazyQuery>;
export type EventInventorySettingsSuspenseQueryHookResult = ReturnType<typeof useEventInventorySettingsSuspenseQuery>;
export type EventInventorySettingsQueryResult = Apollo.QueryResult<EventInventorySettingsQuery, EventInventorySettingsQueryVariables>;
export const EventLinkedWidgetsDocument = gql`
    query EventLinkedWidgets($eventId: ID!, $notInBookerId: ID) {
  eventLinkedWidgets(eventId: $eventId, notInBookerId: $notInBookerId) {
    bookerId
    name {
      ...MultilingualFragment
    }
    status
    productId
    ticketStructure
    sellingType
    storefrontId
    storefrontName {
      ...MultilingualFragment
    }
    organizationId
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useEventLinkedWidgetsQuery__
 *
 * To run a query within a React component, call `useEventLinkedWidgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventLinkedWidgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventLinkedWidgetsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      notInBookerId: // value for 'notInBookerId'
 *   },
 * });
 */
export function useEventLinkedWidgetsQuery(baseOptions: Apollo.QueryHookOptions<EventLinkedWidgetsQuery, EventLinkedWidgetsQueryVariables> & ({ variables: EventLinkedWidgetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventLinkedWidgetsQuery, EventLinkedWidgetsQueryVariables>(EventLinkedWidgetsDocument, options);
      }
export function useEventLinkedWidgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventLinkedWidgetsQuery, EventLinkedWidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventLinkedWidgetsQuery, EventLinkedWidgetsQueryVariables>(EventLinkedWidgetsDocument, options);
        }
// @ts-ignore
export function useEventLinkedWidgetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventLinkedWidgetsQuery, EventLinkedWidgetsQueryVariables>): Apollo.UseSuspenseQueryResult<EventLinkedWidgetsQuery, EventLinkedWidgetsQueryVariables>;
export function useEventLinkedWidgetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventLinkedWidgetsQuery, EventLinkedWidgetsQueryVariables>): Apollo.UseSuspenseQueryResult<EventLinkedWidgetsQuery | undefined, EventLinkedWidgetsQueryVariables>;
export function useEventLinkedWidgetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventLinkedWidgetsQuery, EventLinkedWidgetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventLinkedWidgetsQuery, EventLinkedWidgetsQueryVariables>(EventLinkedWidgetsDocument, options);
        }
export type EventLinkedWidgetsQueryHookResult = ReturnType<typeof useEventLinkedWidgetsQuery>;
export type EventLinkedWidgetsLazyQueryHookResult = ReturnType<typeof useEventLinkedWidgetsLazyQuery>;
export type EventLinkedWidgetsSuspenseQueryHookResult = ReturnType<typeof useEventLinkedWidgetsSuspenseQuery>;
export type EventLinkedWidgetsQueryResult = Apollo.QueryResult<EventLinkedWidgetsQuery, EventLinkedWidgetsQueryVariables>;
export const EventLookaheadMonthsDocument = gql`
    query EventLookaheadMonths($organizationId: ID, $operatorId: ID) {
  eventLookaheadMonths(organizationId: $organizationId, operatorId: $operatorId)
}
    `;

/**
 * __useEventLookaheadMonthsQuery__
 *
 * To run a query within a React component, call `useEventLookaheadMonthsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventLookaheadMonthsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventLookaheadMonthsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      operatorId: // value for 'operatorId'
 *   },
 * });
 */
export function useEventLookaheadMonthsQuery(baseOptions?: Apollo.QueryHookOptions<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>(EventLookaheadMonthsDocument, options);
      }
export function useEventLookaheadMonthsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>(EventLookaheadMonthsDocument, options);
        }
// @ts-ignore
export function useEventLookaheadMonthsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>): Apollo.UseSuspenseQueryResult<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>;
export function useEventLookaheadMonthsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>): Apollo.UseSuspenseQueryResult<EventLookaheadMonthsQuery | undefined, EventLookaheadMonthsQueryVariables>;
export function useEventLookaheadMonthsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>(EventLookaheadMonthsDocument, options);
        }
export type EventLookaheadMonthsQueryHookResult = ReturnType<typeof useEventLookaheadMonthsQuery>;
export type EventLookaheadMonthsLazyQueryHookResult = ReturnType<typeof useEventLookaheadMonthsLazyQuery>;
export type EventLookaheadMonthsSuspenseQueryHookResult = ReturnType<typeof useEventLookaheadMonthsSuspenseQuery>;
export type EventLookaheadMonthsQueryResult = Apollo.QueryResult<EventLookaheadMonthsQuery, EventLookaheadMonthsQueryVariables>;
export const EventSessionAvailabilityDocument = gql`
    query EventSessionAvailability($productId: ID!, $sessionIds: [String!]!) {
  eventSessionAvailability(productId: $productId, sessionIds: $sessionIds) {
    sessionId
    totalCapacity
    remainingCapacity
    isUnlimited
  }
}
    `;

/**
 * __useEventSessionAvailabilityQuery__
 *
 * To run a query within a React component, call `useEventSessionAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventSessionAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventSessionAvailabilityQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      sessionIds: // value for 'sessionIds'
 *   },
 * });
 */
export function useEventSessionAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<EventSessionAvailabilityQuery, EventSessionAvailabilityQueryVariables> & ({ variables: EventSessionAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventSessionAvailabilityQuery, EventSessionAvailabilityQueryVariables>(EventSessionAvailabilityDocument, options);
      }
export function useEventSessionAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventSessionAvailabilityQuery, EventSessionAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventSessionAvailabilityQuery, EventSessionAvailabilityQueryVariables>(EventSessionAvailabilityDocument, options);
        }
// @ts-ignore
export function useEventSessionAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventSessionAvailabilityQuery, EventSessionAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<EventSessionAvailabilityQuery, EventSessionAvailabilityQueryVariables>;
export function useEventSessionAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventSessionAvailabilityQuery, EventSessionAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<EventSessionAvailabilityQuery | undefined, EventSessionAvailabilityQueryVariables>;
export function useEventSessionAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventSessionAvailabilityQuery, EventSessionAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventSessionAvailabilityQuery, EventSessionAvailabilityQueryVariables>(EventSessionAvailabilityDocument, options);
        }
export type EventSessionAvailabilityQueryHookResult = ReturnType<typeof useEventSessionAvailabilityQuery>;
export type EventSessionAvailabilityLazyQueryHookResult = ReturnType<typeof useEventSessionAvailabilityLazyQuery>;
export type EventSessionAvailabilitySuspenseQueryHookResult = ReturnType<typeof useEventSessionAvailabilitySuspenseQuery>;
export type EventSessionAvailabilityQueryResult = Apollo.QueryResult<EventSessionAvailabilityQuery, EventSessionAvailabilityQueryVariables>;
export const EventSessionOrdersDocument = gql`
    query EventSessionOrders($storefrontId: ID!, $eventId: ID!, $sessionDate: String) {
  eventSessionOrders(
    storefrontId: $storefrontId
    eventId: $eventId
    sessionDate: $sessionDate
  ) {
    orderId
    purchaseDate
    customerName
    tierName
    quantity
    cancelled
    guestNames
    guests {
      name
      email
      eventOptions {
        label
        sourceTransactionId
        amount
      }
    }
    sessionIds
    isPass
    arrivalHistory {
      action
      source
      sessionIds
      guestIndexes
      attendanceKeys
      note
      timestamp
      performedBy
      performedByName
    }
  }
}
    `;

/**
 * __useEventSessionOrdersQuery__
 *
 * To run a query within a React component, call `useEventSessionOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventSessionOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventSessionOrdersQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      eventId: // value for 'eventId'
 *      sessionDate: // value for 'sessionDate'
 *   },
 * });
 */
export function useEventSessionOrdersQuery(baseOptions: Apollo.QueryHookOptions<EventSessionOrdersQuery, EventSessionOrdersQueryVariables> & ({ variables: EventSessionOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventSessionOrdersQuery, EventSessionOrdersQueryVariables>(EventSessionOrdersDocument, options);
      }
export function useEventSessionOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventSessionOrdersQuery, EventSessionOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventSessionOrdersQuery, EventSessionOrdersQueryVariables>(EventSessionOrdersDocument, options);
        }
// @ts-ignore
export function useEventSessionOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventSessionOrdersQuery, EventSessionOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<EventSessionOrdersQuery, EventSessionOrdersQueryVariables>;
export function useEventSessionOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventSessionOrdersQuery, EventSessionOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<EventSessionOrdersQuery | undefined, EventSessionOrdersQueryVariables>;
export function useEventSessionOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventSessionOrdersQuery, EventSessionOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventSessionOrdersQuery, EventSessionOrdersQueryVariables>(EventSessionOrdersDocument, options);
        }
export type EventSessionOrdersQueryHookResult = ReturnType<typeof useEventSessionOrdersQuery>;
export type EventSessionOrdersLazyQueryHookResult = ReturnType<typeof useEventSessionOrdersLazyQuery>;
export type EventSessionOrdersSuspenseQueryHookResult = ReturnType<typeof useEventSessionOrdersSuspenseQuery>;
export type EventSessionOrdersQueryResult = Apollo.QueryResult<EventSessionOrdersQuery, EventSessionOrdersQueryVariables>;
export const EventsByIdsDocument = gql`
    query EventsByIds($ids: [MongoID!]!) {
  eventsByIds(_ids: $ids) {
    ...EventDetailsFragment
  }
}
    ${EventDetailsFragmentFragmentDoc}`;

/**
 * __useEventsByIdsQuery__
 *
 * To run a query within a React component, call `useEventsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useEventsByIdsQuery(baseOptions: Apollo.QueryHookOptions<EventsByIdsQuery, EventsByIdsQueryVariables> & ({ variables: EventsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsByIdsQuery, EventsByIdsQueryVariables>(EventsByIdsDocument, options);
      }
export function useEventsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsByIdsQuery, EventsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsByIdsQuery, EventsByIdsQueryVariables>(EventsByIdsDocument, options);
        }
// @ts-ignore
export function useEventsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventsByIdsQuery, EventsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<EventsByIdsQuery, EventsByIdsQueryVariables>;
export function useEventsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsByIdsQuery, EventsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<EventsByIdsQuery | undefined, EventsByIdsQueryVariables>;
export function useEventsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsByIdsQuery, EventsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsByIdsQuery, EventsByIdsQueryVariables>(EventsByIdsDocument, options);
        }
export type EventsByIdsQueryHookResult = ReturnType<typeof useEventsByIdsQuery>;
export type EventsByIdsLazyQueryHookResult = ReturnType<typeof useEventsByIdsLazyQuery>;
export type EventsByIdsSuspenseQueryHookResult = ReturnType<typeof useEventsByIdsSuspenseQuery>;
export type EventsByIdsQueryResult = Apollo.QueryResult<EventsByIdsQuery, EventsByIdsQueryVariables>;
export const EventManyDocument = gql`
    query EventMany($startDate: String!, $endDate: String!, $organizationId: ID, $operatorId: ID, $status: EventStatus, $tags: [ID], $keepEventsWithNoFutureOccurrences: Boolean, $location: [Float!], $useOrgEventWidgetSettings: Boolean) {
  eventMany(
    startDate: $startDate
    endDate: $endDate
    organizationId: $organizationId
    operatorId: $operatorId
    status: $status
    tags: $tags
    keepEventsWithNoFutureOccurrences: $keepEventsWithNoFutureOccurrences
    location: $location
    useOrgEventWidgetSettings: $useOrgEventWidgetSettings
  ) {
    _id
    locationType
    eventOrganizer {
      ...EventLocationFragment
    }
    title {
      ...MultilingualFragment
    }
    eventLocations(limit: 1) {
      ...EventLocationFragment
    }
    type
    startDate
    endDate
    occurrences
    schedules {
      allDay
      timeSlots {
        from
        to
        endsNextDay
        note
      }
    }
    recurrencePattern {
      frequency
      interval
      multiDates
      daysOfWeek
      dateOfMonth
      dayOfMonth
      dayOfMonthOccurrence
      monthAndDateOfYear
      endDate
      skipDates
    }
    price
    ticketUrl
    images(limit: 1) {
      ...ImageFragment
    }
    tags {
      global {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          name {
            ...MultilingualFragment
          }
          key
        }
      }
      organizationSpecific {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          name {
            ...MultilingualFragment
          }
        }
      }
    }
    access {
      organizations {
        _entityId
        status
      }
    }
  }
}
    ${EventLocationFragmentFragmentDoc}
${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useEventManyQuery__
 *
 * To run a query within a React component, call `useEventManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventManyQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      organizationId: // value for 'organizationId'
 *      operatorId: // value for 'operatorId'
 *      status: // value for 'status'
 *      tags: // value for 'tags'
 *      keepEventsWithNoFutureOccurrences: // value for 'keepEventsWithNoFutureOccurrences'
 *      location: // value for 'location'
 *      useOrgEventWidgetSettings: // value for 'useOrgEventWidgetSettings'
 *   },
 * });
 */
export function useEventManyQuery(baseOptions: Apollo.QueryHookOptions<EventManyQuery, EventManyQueryVariables> & ({ variables: EventManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventManyQuery, EventManyQueryVariables>(EventManyDocument, options);
      }
export function useEventManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventManyQuery, EventManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventManyQuery, EventManyQueryVariables>(EventManyDocument, options);
        }
// @ts-ignore
export function useEventManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventManyQuery, EventManyQueryVariables>): Apollo.UseSuspenseQueryResult<EventManyQuery, EventManyQueryVariables>;
export function useEventManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventManyQuery, EventManyQueryVariables>): Apollo.UseSuspenseQueryResult<EventManyQuery | undefined, EventManyQueryVariables>;
export function useEventManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventManyQuery, EventManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventManyQuery, EventManyQueryVariables>(EventManyDocument, options);
        }
export type EventManyQueryHookResult = ReturnType<typeof useEventManyQuery>;
export type EventManyLazyQueryHookResult = ReturnType<typeof useEventManyLazyQuery>;
export type EventManySuspenseQueryHookResult = ReturnType<typeof useEventManySuspenseQuery>;
export type EventManyQueryResult = Apollo.QueryResult<EventManyQuery, EventManyQueryVariables>;
export const EventManyAppDocument = gql`
    query EventManyApp($startDate: String!, $endDate: String!, $organizationId: ID, $operatorId: ID, $operatorIds: [ID], $status: EventStatus, $tags: [ID], $skipRecurrences: Boolean, $keepEventsWithNoFutureOccurrences: Boolean, $useOrgEventWidgetSettings: Boolean) {
  eventMany(
    startDate: $startDate
    endDate: $endDate
    organizationId: $organizationId
    operatorId: $operatorId
    operatorIds: $operatorIds
    status: $status
    tags: $tags
    skipRecurrences: $skipRecurrences
    keepEventsWithNoFutureOccurrences: $keepEventsWithNoFutureOccurrences
    useOrgEventWidgetSettings: $useOrgEventWidgetSettings
  ) {
    _id
    title {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    type
    startDate
    endDate
    occurrences
    schedules {
      allDay
      timeSlots {
        _id
        from
        to
        endsNextDay
        note
      }
    }
    recurrencePattern {
      frequency
      interval
      multiDates
      daysOfWeek
      dateOfMonth
      dayOfMonth
      dayOfMonthOccurrence
      monthAndDateOfYear
      endDate
      skipDates
    }
    attentionIssues {
      type
      sourceName
      venueIndex
    }
    eventOrganizer {
      venue {
        ...MultilingualFragment
      }
      locationInfo {
        _entityId
        type
      }
    }
    eventLocations {
      venue {
        ...MultilingualFragment
      }
      locationInfo {
        _entityId
        type
      }
    }
    images(limit: 1) {
      ...ImageFragment
    }
    tags {
      organizationSpecific {
        _id
        name {
          ...MultilingualFragment
        }
        owner {
          entityId
        }
      }
    }
    access {
      operator {
        _entityId
      }
      organizations {
        _entityId
        status
        source
        addedVia
      }
    }
    updatedDateISO
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useEventManyAppQuery__
 *
 * To run a query within a React component, call `useEventManyAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventManyAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventManyAppQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      organizationId: // value for 'organizationId'
 *      operatorId: // value for 'operatorId'
 *      operatorIds: // value for 'operatorIds'
 *      status: // value for 'status'
 *      tags: // value for 'tags'
 *      skipRecurrences: // value for 'skipRecurrences'
 *      keepEventsWithNoFutureOccurrences: // value for 'keepEventsWithNoFutureOccurrences'
 *      useOrgEventWidgetSettings: // value for 'useOrgEventWidgetSettings'
 *   },
 * });
 */
export function useEventManyAppQuery(baseOptions: Apollo.QueryHookOptions<EventManyAppQuery, EventManyAppQueryVariables> & ({ variables: EventManyAppQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventManyAppQuery, EventManyAppQueryVariables>(EventManyAppDocument, options);
      }
export function useEventManyAppLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventManyAppQuery, EventManyAppQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventManyAppQuery, EventManyAppQueryVariables>(EventManyAppDocument, options);
        }
// @ts-ignore
export function useEventManyAppSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventManyAppQuery, EventManyAppQueryVariables>): Apollo.UseSuspenseQueryResult<EventManyAppQuery, EventManyAppQueryVariables>;
export function useEventManyAppSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventManyAppQuery, EventManyAppQueryVariables>): Apollo.UseSuspenseQueryResult<EventManyAppQuery | undefined, EventManyAppQueryVariables>;
export function useEventManyAppSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventManyAppQuery, EventManyAppQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventManyAppQuery, EventManyAppQueryVariables>(EventManyAppDocument, options);
        }
export type EventManyAppQueryHookResult = ReturnType<typeof useEventManyAppQuery>;
export type EventManyAppLazyQueryHookResult = ReturnType<typeof useEventManyAppLazyQuery>;
export type EventManyAppSuspenseQueryHookResult = ReturnType<typeof useEventManyAppSuspenseQuery>;
export type EventManyAppQueryResult = Apollo.QueryResult<EventManyAppQuery, EventManyAppQueryVariables>;
export const FeatureFlagGroupsDocument = gql`
    query FeatureFlagGroups {
  featureFlagGroups
}
    `;

/**
 * __useFeatureFlagGroupsQuery__
 *
 * To run a query within a React component, call `useFeatureFlagGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureFlagGroupsQuery(baseOptions?: Apollo.QueryHookOptions<FeatureFlagGroupsQuery, FeatureFlagGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureFlagGroupsQuery, FeatureFlagGroupsQueryVariables>(FeatureFlagGroupsDocument, options);
      }
export function useFeatureFlagGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureFlagGroupsQuery, FeatureFlagGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureFlagGroupsQuery, FeatureFlagGroupsQueryVariables>(FeatureFlagGroupsDocument, options);
        }
// @ts-ignore
export function useFeatureFlagGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeatureFlagGroupsQuery, FeatureFlagGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<FeatureFlagGroupsQuery, FeatureFlagGroupsQueryVariables>;
export function useFeatureFlagGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeatureFlagGroupsQuery, FeatureFlagGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<FeatureFlagGroupsQuery | undefined, FeatureFlagGroupsQueryVariables>;
export function useFeatureFlagGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeatureFlagGroupsQuery, FeatureFlagGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeatureFlagGroupsQuery, FeatureFlagGroupsQueryVariables>(FeatureFlagGroupsDocument, options);
        }
export type FeatureFlagGroupsQueryHookResult = ReturnType<typeof useFeatureFlagGroupsQuery>;
export type FeatureFlagGroupsLazyQueryHookResult = ReturnType<typeof useFeatureFlagGroupsLazyQuery>;
export type FeatureFlagGroupsSuspenseQueryHookResult = ReturnType<typeof useFeatureFlagGroupsSuspenseQuery>;
export type FeatureFlagGroupsQueryResult = Apollo.QueryResult<FeatureFlagGroupsQuery, FeatureFlagGroupsQueryVariables>;
export const FeatureFlagListDocument = gql`
    query FeatureFlagList($includeGraduated: Boolean) {
  featureFlagList(includeGraduated: $includeGraduated) {
    _id
    key
    name
    description
    group
    graduatedAt
    enabledCount
    totalTargetCount
    scope
    graduated
  }
}
    `;

/**
 * __useFeatureFlagListQuery__
 *
 * To run a query within a React component, call `useFeatureFlagListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagListQuery({
 *   variables: {
 *      includeGraduated: // value for 'includeGraduated'
 *   },
 * });
 */
export function useFeatureFlagListQuery(baseOptions?: Apollo.QueryHookOptions<FeatureFlagListQuery, FeatureFlagListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureFlagListQuery, FeatureFlagListQueryVariables>(FeatureFlagListDocument, options);
      }
export function useFeatureFlagListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureFlagListQuery, FeatureFlagListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureFlagListQuery, FeatureFlagListQueryVariables>(FeatureFlagListDocument, options);
        }
// @ts-ignore
export function useFeatureFlagListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeatureFlagListQuery, FeatureFlagListQueryVariables>): Apollo.UseSuspenseQueryResult<FeatureFlagListQuery, FeatureFlagListQueryVariables>;
export function useFeatureFlagListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeatureFlagListQuery, FeatureFlagListQueryVariables>): Apollo.UseSuspenseQueryResult<FeatureFlagListQuery | undefined, FeatureFlagListQueryVariables>;
export function useFeatureFlagListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeatureFlagListQuery, FeatureFlagListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeatureFlagListQuery, FeatureFlagListQueryVariables>(FeatureFlagListDocument, options);
        }
export type FeatureFlagListQueryHookResult = ReturnType<typeof useFeatureFlagListQuery>;
export type FeatureFlagListLazyQueryHookResult = ReturnType<typeof useFeatureFlagListLazyQuery>;
export type FeatureFlagListSuspenseQueryHookResult = ReturnType<typeof useFeatureFlagListSuspenseQuery>;
export type FeatureFlagListQueryResult = Apollo.QueryResult<FeatureFlagListQuery, FeatureFlagListQueryVariables>;
export const FeatureFlagOrgGatesDocument = gql`
    query FeatureFlagOrgGates($featureFlagId: MongoID!) {
  featureFlagOrgGates(featureFlagId: $featureFlagId) {
    organizationId
    organizationName
    shortName
    enabled
    hasExplicitGate
  }
}
    `;

/**
 * __useFeatureFlagOrgGatesQuery__
 *
 * To run a query within a React component, call `useFeatureFlagOrgGatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagOrgGatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagOrgGatesQuery({
 *   variables: {
 *      featureFlagId: // value for 'featureFlagId'
 *   },
 * });
 */
export function useFeatureFlagOrgGatesQuery(baseOptions: Apollo.QueryHookOptions<FeatureFlagOrgGatesQuery, FeatureFlagOrgGatesQueryVariables> & ({ variables: FeatureFlagOrgGatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureFlagOrgGatesQuery, FeatureFlagOrgGatesQueryVariables>(FeatureFlagOrgGatesDocument, options);
      }
export function useFeatureFlagOrgGatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureFlagOrgGatesQuery, FeatureFlagOrgGatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureFlagOrgGatesQuery, FeatureFlagOrgGatesQueryVariables>(FeatureFlagOrgGatesDocument, options);
        }
// @ts-ignore
export function useFeatureFlagOrgGatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeatureFlagOrgGatesQuery, FeatureFlagOrgGatesQueryVariables>): Apollo.UseSuspenseQueryResult<FeatureFlagOrgGatesQuery, FeatureFlagOrgGatesQueryVariables>;
export function useFeatureFlagOrgGatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeatureFlagOrgGatesQuery, FeatureFlagOrgGatesQueryVariables>): Apollo.UseSuspenseQueryResult<FeatureFlagOrgGatesQuery | undefined, FeatureFlagOrgGatesQueryVariables>;
export function useFeatureFlagOrgGatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeatureFlagOrgGatesQuery, FeatureFlagOrgGatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeatureFlagOrgGatesQuery, FeatureFlagOrgGatesQueryVariables>(FeatureFlagOrgGatesDocument, options);
        }
export type FeatureFlagOrgGatesQueryHookResult = ReturnType<typeof useFeatureFlagOrgGatesQuery>;
export type FeatureFlagOrgGatesLazyQueryHookResult = ReturnType<typeof useFeatureFlagOrgGatesLazyQuery>;
export type FeatureFlagOrgGatesSuspenseQueryHookResult = ReturnType<typeof useFeatureFlagOrgGatesSuspenseQuery>;
export type FeatureFlagOrgGatesQueryResult = Apollo.QueryResult<FeatureFlagOrgGatesQuery, FeatureFlagOrgGatesQueryVariables>;
export const FeatureFlagsByOrganizationDocument = gql`
    query FeatureFlagsByOrganization($organizationId: MongoID!) {
  featureFlagsByOrganization(organizationId: $organizationId) {
    _id
    key
    name
    description
    group
    enabled
    graduated
    hasExplicitGate
  }
}
    `;

/**
 * __useFeatureFlagsByOrganizationQuery__
 *
 * To run a query within a React component, call `useFeatureFlagsByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagsByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFeatureFlagsByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<FeatureFlagsByOrganizationQuery, FeatureFlagsByOrganizationQueryVariables> & ({ variables: FeatureFlagsByOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureFlagsByOrganizationQuery, FeatureFlagsByOrganizationQueryVariables>(FeatureFlagsByOrganizationDocument, options);
      }
export function useFeatureFlagsByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureFlagsByOrganizationQuery, FeatureFlagsByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureFlagsByOrganizationQuery, FeatureFlagsByOrganizationQueryVariables>(FeatureFlagsByOrganizationDocument, options);
        }
// @ts-ignore
export function useFeatureFlagsByOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeatureFlagsByOrganizationQuery, FeatureFlagsByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<FeatureFlagsByOrganizationQuery, FeatureFlagsByOrganizationQueryVariables>;
export function useFeatureFlagsByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeatureFlagsByOrganizationQuery, FeatureFlagsByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<FeatureFlagsByOrganizationQuery | undefined, FeatureFlagsByOrganizationQueryVariables>;
export function useFeatureFlagsByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeatureFlagsByOrganizationQuery, FeatureFlagsByOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeatureFlagsByOrganizationQuery, FeatureFlagsByOrganizationQueryVariables>(FeatureFlagsByOrganizationDocument, options);
        }
export type FeatureFlagsByOrganizationQueryHookResult = ReturnType<typeof useFeatureFlagsByOrganizationQuery>;
export type FeatureFlagsByOrganizationLazyQueryHookResult = ReturnType<typeof useFeatureFlagsByOrganizationLazyQuery>;
export type FeatureFlagsByOrganizationSuspenseQueryHookResult = ReturnType<typeof useFeatureFlagsByOrganizationSuspenseQuery>;
export type FeatureFlagsByOrganizationQueryResult = Apollo.QueryResult<FeatureFlagsByOrganizationQuery, FeatureFlagsByOrganizationQueryVariables>;
export const FulfillmentProfileManyDocument = gql`
    query FulfillmentProfileMany($filter: FilterFindManyFulfillmentProfileInput) {
  fulfillmentProfileMany(filter: $filter) {
    ...FulfillmentProfileFragment
  }
}
    ${FulfillmentProfileFragmentFragmentDoc}`;

/**
 * __useFulfillmentProfileManyQuery__
 *
 * To run a query within a React component, call `useFulfillmentProfileManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentProfileManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFulfillmentProfileManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFulfillmentProfileManyQuery(baseOptions?: Apollo.QueryHookOptions<FulfillmentProfileManyQuery, FulfillmentProfileManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FulfillmentProfileManyQuery, FulfillmentProfileManyQueryVariables>(FulfillmentProfileManyDocument, options);
      }
export function useFulfillmentProfileManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FulfillmentProfileManyQuery, FulfillmentProfileManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FulfillmentProfileManyQuery, FulfillmentProfileManyQueryVariables>(FulfillmentProfileManyDocument, options);
        }
// @ts-ignore
export function useFulfillmentProfileManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FulfillmentProfileManyQuery, FulfillmentProfileManyQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentProfileManyQuery, FulfillmentProfileManyQueryVariables>;
export function useFulfillmentProfileManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentProfileManyQuery, FulfillmentProfileManyQueryVariables>): Apollo.UseSuspenseQueryResult<FulfillmentProfileManyQuery | undefined, FulfillmentProfileManyQueryVariables>;
export function useFulfillmentProfileManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FulfillmentProfileManyQuery, FulfillmentProfileManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FulfillmentProfileManyQuery, FulfillmentProfileManyQueryVariables>(FulfillmentProfileManyDocument, options);
        }
export type FulfillmentProfileManyQueryHookResult = ReturnType<typeof useFulfillmentProfileManyQuery>;
export type FulfillmentProfileManyLazyQueryHookResult = ReturnType<typeof useFulfillmentProfileManyLazyQuery>;
export type FulfillmentProfileManySuspenseQueryHookResult = ReturnType<typeof useFulfillmentProfileManySuspenseQuery>;
export type FulfillmentProfileManyQueryResult = Apollo.QueryResult<FulfillmentProfileManyQuery, FulfillmentProfileManyQueryVariables>;
export const GalleryNewMediaCountDocument = gql`
    query GalleryNewMediaCount($organizationId: MongoID, $status: String) {
  galleryNewMediaCount(organizationId: $organizationId, status: $status)
}
    `;

/**
 * __useGalleryNewMediaCountQuery__
 *
 * To run a query within a React component, call `useGalleryNewMediaCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGalleryNewMediaCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGalleryNewMediaCountQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGalleryNewMediaCountQuery(baseOptions?: Apollo.QueryHookOptions<GalleryNewMediaCountQuery, GalleryNewMediaCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GalleryNewMediaCountQuery, GalleryNewMediaCountQueryVariables>(GalleryNewMediaCountDocument, options);
      }
export function useGalleryNewMediaCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GalleryNewMediaCountQuery, GalleryNewMediaCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GalleryNewMediaCountQuery, GalleryNewMediaCountQueryVariables>(GalleryNewMediaCountDocument, options);
        }
// @ts-ignore
export function useGalleryNewMediaCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GalleryNewMediaCountQuery, GalleryNewMediaCountQueryVariables>): Apollo.UseSuspenseQueryResult<GalleryNewMediaCountQuery, GalleryNewMediaCountQueryVariables>;
export function useGalleryNewMediaCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GalleryNewMediaCountQuery, GalleryNewMediaCountQueryVariables>): Apollo.UseSuspenseQueryResult<GalleryNewMediaCountQuery | undefined, GalleryNewMediaCountQueryVariables>;
export function useGalleryNewMediaCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GalleryNewMediaCountQuery, GalleryNewMediaCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GalleryNewMediaCountQuery, GalleryNewMediaCountQueryVariables>(GalleryNewMediaCountDocument, options);
        }
export type GalleryNewMediaCountQueryHookResult = ReturnType<typeof useGalleryNewMediaCountQuery>;
export type GalleryNewMediaCountLazyQueryHookResult = ReturnType<typeof useGalleryNewMediaCountLazyQuery>;
export type GalleryNewMediaCountSuspenseQueryHookResult = ReturnType<typeof useGalleryNewMediaCountSuspenseQuery>;
export type GalleryNewMediaCountQueryResult = Apollo.QueryResult<GalleryNewMediaCountQuery, GalleryNewMediaCountQueryVariables>;
export const GalleryNewMediaManyDocument = gql`
    query GalleryNewMediaMany($organizationId: MongoID, $status: String, $limit: Int, $skip: Int) {
  galleryNewMediaMany(
    organizationId: $organizationId
    status: $status
    limit: $limit
    skip: $skip
  ) {
    _id
    listingId
    listingName
    originalAssetId
    mediaType
    url
    muxPlaybackId
    width
    height
    blurhash
    status
    publicMediaId
    createdDateISO
  }
}
    `;

/**
 * __useGalleryNewMediaManyQuery__
 *
 * To run a query within a React component, call `useGalleryNewMediaManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGalleryNewMediaManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGalleryNewMediaManyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGalleryNewMediaManyQuery(baseOptions?: Apollo.QueryHookOptions<GalleryNewMediaManyQuery, GalleryNewMediaManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GalleryNewMediaManyQuery, GalleryNewMediaManyQueryVariables>(GalleryNewMediaManyDocument, options);
      }
export function useGalleryNewMediaManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GalleryNewMediaManyQuery, GalleryNewMediaManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GalleryNewMediaManyQuery, GalleryNewMediaManyQueryVariables>(GalleryNewMediaManyDocument, options);
        }
// @ts-ignore
export function useGalleryNewMediaManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GalleryNewMediaManyQuery, GalleryNewMediaManyQueryVariables>): Apollo.UseSuspenseQueryResult<GalleryNewMediaManyQuery, GalleryNewMediaManyQueryVariables>;
export function useGalleryNewMediaManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GalleryNewMediaManyQuery, GalleryNewMediaManyQueryVariables>): Apollo.UseSuspenseQueryResult<GalleryNewMediaManyQuery | undefined, GalleryNewMediaManyQueryVariables>;
export function useGalleryNewMediaManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GalleryNewMediaManyQuery, GalleryNewMediaManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GalleryNewMediaManyQuery, GalleryNewMediaManyQueryVariables>(GalleryNewMediaManyDocument, options);
        }
export type GalleryNewMediaManyQueryHookResult = ReturnType<typeof useGalleryNewMediaManyQuery>;
export type GalleryNewMediaManyLazyQueryHookResult = ReturnType<typeof useGalleryNewMediaManyLazyQuery>;
export type GalleryNewMediaManySuspenseQueryHookResult = ReturnType<typeof useGalleryNewMediaManySuspenseQuery>;
export type GalleryNewMediaManyQueryResult = Apollo.QueryResult<GalleryNewMediaManyQuery, GalleryNewMediaManyQueryVariables>;
export const ImageByIdsDocument = gql`
    query ImageByIds($_ids: [String!]!, $limit: Int, $sort: SortFindByIdsAssetImageInput) {
  imageByIds(_ids: $_ids, limit: $limit, sort: $sort) {
    ...ImageFragment
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useImageByIdsQuery__
 *
 * To run a query within a React component, call `useImageByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageByIdsQuery({
 *   variables: {
 *      _ids: // value for '_ids'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useImageByIdsQuery(baseOptions: Apollo.QueryHookOptions<ImageByIdsQuery, ImageByIdsQueryVariables> & ({ variables: ImageByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImageByIdsQuery, ImageByIdsQueryVariables>(ImageByIdsDocument, options);
      }
export function useImageByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImageByIdsQuery, ImageByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImageByIdsQuery, ImageByIdsQueryVariables>(ImageByIdsDocument, options);
        }
// @ts-ignore
export function useImageByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImageByIdsQuery, ImageByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<ImageByIdsQuery, ImageByIdsQueryVariables>;
export function useImageByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImageByIdsQuery, ImageByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<ImageByIdsQuery | undefined, ImageByIdsQueryVariables>;
export function useImageByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImageByIdsQuery, ImageByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImageByIdsQuery, ImageByIdsQueryVariables>(ImageByIdsDocument, options);
        }
export type ImageByIdsQueryHookResult = ReturnType<typeof useImageByIdsQuery>;
export type ImageByIdsLazyQueryHookResult = ReturnType<typeof useImageByIdsLazyQuery>;
export type ImageByIdsSuspenseQueryHookResult = ReturnType<typeof useImageByIdsSuspenseQuery>;
export type ImageByIdsQueryResult = Apollo.QueryResult<ImageByIdsQuery, ImageByIdsQueryVariables>;
export const ImpersonationUserSearchDocument = gql`
    query ImpersonationUserSearch($search: String!) {
  impersonationUserSearch(search: $search) {
    _id
    email
    firstName
    lastName
    userType
  }
}
    `;

/**
 * __useImpersonationUserSearchQuery__
 *
 * To run a query within a React component, call `useImpersonationUserSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpersonationUserSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpersonationUserSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useImpersonationUserSearchQuery(baseOptions: Apollo.QueryHookOptions<ImpersonationUserSearchQuery, ImpersonationUserSearchQueryVariables> & ({ variables: ImpersonationUserSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpersonationUserSearchQuery, ImpersonationUserSearchQueryVariables>(ImpersonationUserSearchDocument, options);
      }
export function useImpersonationUserSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpersonationUserSearchQuery, ImpersonationUserSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpersonationUserSearchQuery, ImpersonationUserSearchQueryVariables>(ImpersonationUserSearchDocument, options);
        }
// @ts-ignore
export function useImpersonationUserSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImpersonationUserSearchQuery, ImpersonationUserSearchQueryVariables>): Apollo.UseSuspenseQueryResult<ImpersonationUserSearchQuery, ImpersonationUserSearchQueryVariables>;
export function useImpersonationUserSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImpersonationUserSearchQuery, ImpersonationUserSearchQueryVariables>): Apollo.UseSuspenseQueryResult<ImpersonationUserSearchQuery | undefined, ImpersonationUserSearchQueryVariables>;
export function useImpersonationUserSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImpersonationUserSearchQuery, ImpersonationUserSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImpersonationUserSearchQuery, ImpersonationUserSearchQueryVariables>(ImpersonationUserSearchDocument, options);
        }
export type ImpersonationUserSearchQueryHookResult = ReturnType<typeof useImpersonationUserSearchQuery>;
export type ImpersonationUserSearchLazyQueryHookResult = ReturnType<typeof useImpersonationUserSearchLazyQuery>;
export type ImpersonationUserSearchSuspenseQueryHookResult = ReturnType<typeof useImpersonationUserSearchSuspenseQuery>;
export type ImpersonationUserSearchQueryResult = Apollo.QueryResult<ImpersonationUserSearchQuery, ImpersonationUserSearchQueryVariables>;
export const ImportByIdDocument = gql`
    query ImportById($id: MongoID!) {
  importById(_id: $id) {
    _id
    name
    organization {
      _id
      name {
        ...MultilingualFragment
      }
    }
    googleSheetsConfig {
      sheetUrl
      sheetId
      range
      apiKey
      serviceAccountKey
    }
    status
    importType
    createdBy {
      _id
      firstName
      lastName
      email
    }
    createdDateISO
    updatedDateISO
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useImportByIdQuery__
 *
 * To run a query within a React component, call `useImportByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImportByIdQuery(baseOptions: Apollo.QueryHookOptions<ImportByIdQuery, ImportByIdQueryVariables> & ({ variables: ImportByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportByIdQuery, ImportByIdQueryVariables>(ImportByIdDocument, options);
      }
export function useImportByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportByIdQuery, ImportByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportByIdQuery, ImportByIdQueryVariables>(ImportByIdDocument, options);
        }
// @ts-ignore
export function useImportByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImportByIdQuery, ImportByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ImportByIdQuery, ImportByIdQueryVariables>;
export function useImportByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportByIdQuery, ImportByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ImportByIdQuery | undefined, ImportByIdQueryVariables>;
export function useImportByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportByIdQuery, ImportByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImportByIdQuery, ImportByIdQueryVariables>(ImportByIdDocument, options);
        }
export type ImportByIdQueryHookResult = ReturnType<typeof useImportByIdQuery>;
export type ImportByIdLazyQueryHookResult = ReturnType<typeof useImportByIdLazyQuery>;
export type ImportByIdSuspenseQueryHookResult = ReturnType<typeof useImportByIdSuspenseQuery>;
export type ImportByIdQueryResult = Apollo.QueryResult<ImportByIdQuery, ImportByIdQueryVariables>;
export const ImportManagerSettingsFindOneDocument = gql`
    query ImportManagerSettingsFindOne {
  importManagerSettingsFindOne {
    _id
    googleSheetTemplates {
      tags
      operators
      people
      events
    }
    dummyDataSheets {
      tags
      operators
      people
      events
    }
    aiScraperGenerator {
      aiEngine
      defaultPrompt
    }
    googleDriveDestinationFolderId
  }
}
    `;

/**
 * __useImportManagerSettingsFindOneQuery__
 *
 * To run a query within a React component, call `useImportManagerSettingsFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportManagerSettingsFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportManagerSettingsFindOneQuery({
 *   variables: {
 *   },
 * });
 */
export function useImportManagerSettingsFindOneQuery(baseOptions?: Apollo.QueryHookOptions<ImportManagerSettingsFindOneQuery, ImportManagerSettingsFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportManagerSettingsFindOneQuery, ImportManagerSettingsFindOneQueryVariables>(ImportManagerSettingsFindOneDocument, options);
      }
export function useImportManagerSettingsFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportManagerSettingsFindOneQuery, ImportManagerSettingsFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportManagerSettingsFindOneQuery, ImportManagerSettingsFindOneQueryVariables>(ImportManagerSettingsFindOneDocument, options);
        }
// @ts-ignore
export function useImportManagerSettingsFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImportManagerSettingsFindOneQuery, ImportManagerSettingsFindOneQueryVariables>): Apollo.UseSuspenseQueryResult<ImportManagerSettingsFindOneQuery, ImportManagerSettingsFindOneQueryVariables>;
export function useImportManagerSettingsFindOneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportManagerSettingsFindOneQuery, ImportManagerSettingsFindOneQueryVariables>): Apollo.UseSuspenseQueryResult<ImportManagerSettingsFindOneQuery | undefined, ImportManagerSettingsFindOneQueryVariables>;
export function useImportManagerSettingsFindOneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportManagerSettingsFindOneQuery, ImportManagerSettingsFindOneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImportManagerSettingsFindOneQuery, ImportManagerSettingsFindOneQueryVariables>(ImportManagerSettingsFindOneDocument, options);
        }
export type ImportManagerSettingsFindOneQueryHookResult = ReturnType<typeof useImportManagerSettingsFindOneQuery>;
export type ImportManagerSettingsFindOneLazyQueryHookResult = ReturnType<typeof useImportManagerSettingsFindOneLazyQuery>;
export type ImportManagerSettingsFindOneSuspenseQueryHookResult = ReturnType<typeof useImportManagerSettingsFindOneSuspenseQuery>;
export type ImportManagerSettingsFindOneQueryResult = Apollo.QueryResult<ImportManagerSettingsFindOneQuery, ImportManagerSettingsFindOneQueryVariables>;
export const ImportManyDocument = gql`
    query ImportMany($filter: FilterFindManyImportInput, $limit: Int, $skip: Int) {
  importMany(filter: $filter, limit: $limit, skip: $skip) {
    _id
    name
    organization {
      _id
      name {
        ...MultilingualFragment
      }
    }
    googleSheetsConfig {
      sheetUrl
      sheetId
      range
    }
    status
    importType
    createdBy {
      _id
      firstName
      lastName
      email
    }
    createdDateISO
    updatedDateISO
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useImportManyQuery__
 *
 * To run a query within a React component, call `useImportManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useImportManyQuery(baseOptions?: Apollo.QueryHookOptions<ImportManyQuery, ImportManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportManyQuery, ImportManyQueryVariables>(ImportManyDocument, options);
      }
export function useImportManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportManyQuery, ImportManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportManyQuery, ImportManyQueryVariables>(ImportManyDocument, options);
        }
// @ts-ignore
export function useImportManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImportManyQuery, ImportManyQueryVariables>): Apollo.UseSuspenseQueryResult<ImportManyQuery, ImportManyQueryVariables>;
export function useImportManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportManyQuery, ImportManyQueryVariables>): Apollo.UseSuspenseQueryResult<ImportManyQuery | undefined, ImportManyQueryVariables>;
export function useImportManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportManyQuery, ImportManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImportManyQuery, ImportManyQueryVariables>(ImportManyDocument, options);
        }
export type ImportManyQueryHookResult = ReturnType<typeof useImportManyQuery>;
export type ImportManyLazyQueryHookResult = ReturnType<typeof useImportManyLazyQuery>;
export type ImportManySuspenseQueryHookResult = ReturnType<typeof useImportManySuspenseQuery>;
export type ImportManyQueryResult = Apollo.QueryResult<ImportManyQuery, ImportManyQueryVariables>;
export const ImportRunManyDocument = gql`
    query ImportRunMany($filter: FilterFindManyImportRunInput, $limit: Int, $skip: Int, $sort: SortFindManyImportRunInput) {
  importRunMany(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
    _id
    status
    operatorCount
    errors
    errorMessage
    createdOperatorIds
    createdEntityIds
    importedOperators {
      entityId
      name
      type
    }
    importedEntities {
      entityId
      name
      type
    }
    existingOperators {
      entityId
      name
      type
      website
      organizationNames
    }
    operatorsManuallyConnectedToOrg {
      entityId
      name
      type
      website
      organizationNames
    }
    dryRun
    isUpdateMode
    limit
    startingRow
    rowsImported
    endingRow
    totalRowsAvailable
    dryRunLog {
      entityName
      entityType
      imageCount
      hasContact
      hasAddress
      hasDescription
      status
      errorMessages
      isExisting
      existingEntityId
      willBeConnectedToOperator
      connectedOperatorName
      isUpdate
      fieldsToUpdate
      willConnectToExistingOperator
      existingOperatorVenueName
      existingOperatorVenueId
      tagsAddedCount
      organizerCouldNotConnect
      missingOrganizer
      unresolvedOrganizerName
      unresolvedVenueNames
      missingVenue
      willConnectToExistingOperatorAsOrganizer
      existingOperatorOrganizerName
      existingOperatorOrganizerId
    }
    jobs {
      errorList
    }
    import {
      _id
      importType
      organization {
        _id
      }
    }
    startedBy
    createdDateISO
    updatedDateISO
    completedAt
    rollbackInfo {
      rolledBackAt
      rolledBackBy
      deletedCount
      imagesDeleted
      errorMessages
    }
    serverLogs
    skipImages
  }
}
    `;

/**
 * __useImportRunManyQuery__
 *
 * To run a query within a React component, call `useImportRunManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportRunManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportRunManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useImportRunManyQuery(baseOptions?: Apollo.QueryHookOptions<ImportRunManyQuery, ImportRunManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportRunManyQuery, ImportRunManyQueryVariables>(ImportRunManyDocument, options);
      }
export function useImportRunManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportRunManyQuery, ImportRunManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportRunManyQuery, ImportRunManyQueryVariables>(ImportRunManyDocument, options);
        }
// @ts-ignore
export function useImportRunManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImportRunManyQuery, ImportRunManyQueryVariables>): Apollo.UseSuspenseQueryResult<ImportRunManyQuery, ImportRunManyQueryVariables>;
export function useImportRunManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportRunManyQuery, ImportRunManyQueryVariables>): Apollo.UseSuspenseQueryResult<ImportRunManyQuery | undefined, ImportRunManyQueryVariables>;
export function useImportRunManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportRunManyQuery, ImportRunManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImportRunManyQuery, ImportRunManyQueryVariables>(ImportRunManyDocument, options);
        }
export type ImportRunManyQueryHookResult = ReturnType<typeof useImportRunManyQuery>;
export type ImportRunManyLazyQueryHookResult = ReturnType<typeof useImportRunManyLazyQuery>;
export type ImportRunManySuspenseQueryHookResult = ReturnType<typeof useImportRunManySuspenseQuery>;
export type ImportRunManyQueryResult = Apollo.QueryResult<ImportRunManyQuery, ImportRunManyQueryVariables>;
export const ImportScrapeByIdDocument = gql`
    query ImportScrapeById($id: MongoID!) {
  importScrapeById(_id: $id) {
    _id
    name
    typeOfData
    typeOfScrape
    status
    googleSheetsConfig {
      sheetUrl
      sheetId
      sheetName
    }
    websiteUrl
    maxRows
    scraperPrompt
    targetOrganization
    sitemapUrlCount
    sitemapRevision
    createdBy
    createdDateISO
    updatedDateISO
  }
}
    `;

/**
 * __useImportScrapeByIdQuery__
 *
 * To run a query within a React component, call `useImportScrapeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportScrapeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportScrapeByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImportScrapeByIdQuery(baseOptions: Apollo.QueryHookOptions<ImportScrapeByIdQuery, ImportScrapeByIdQueryVariables> & ({ variables: ImportScrapeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportScrapeByIdQuery, ImportScrapeByIdQueryVariables>(ImportScrapeByIdDocument, options);
      }
export function useImportScrapeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportScrapeByIdQuery, ImportScrapeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportScrapeByIdQuery, ImportScrapeByIdQueryVariables>(ImportScrapeByIdDocument, options);
        }
// @ts-ignore
export function useImportScrapeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImportScrapeByIdQuery, ImportScrapeByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ImportScrapeByIdQuery, ImportScrapeByIdQueryVariables>;
export function useImportScrapeByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportScrapeByIdQuery, ImportScrapeByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ImportScrapeByIdQuery | undefined, ImportScrapeByIdQueryVariables>;
export function useImportScrapeByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportScrapeByIdQuery, ImportScrapeByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImportScrapeByIdQuery, ImportScrapeByIdQueryVariables>(ImportScrapeByIdDocument, options);
        }
export type ImportScrapeByIdQueryHookResult = ReturnType<typeof useImportScrapeByIdQuery>;
export type ImportScrapeByIdLazyQueryHookResult = ReturnType<typeof useImportScrapeByIdLazyQuery>;
export type ImportScrapeByIdSuspenseQueryHookResult = ReturnType<typeof useImportScrapeByIdSuspenseQuery>;
export type ImportScrapeByIdQueryResult = Apollo.QueryResult<ImportScrapeByIdQuery, ImportScrapeByIdQueryVariables>;
export const ImportScrapeManyDocument = gql`
    query ImportScrapeMany {
  importScrapeMany {
    _id
    name
    typeOfData
    typeOfScrape
    status
    googleSheetsConfig {
      sheetUrl
      sheetId
      sheetName
    }
    websiteUrl
    maxRows
    scraperPrompt
    createdBy
    createdDateISO
    updatedDateISO
  }
}
    `;

/**
 * __useImportScrapeManyQuery__
 *
 * To run a query within a React component, call `useImportScrapeManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportScrapeManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportScrapeManyQuery({
 *   variables: {
 *   },
 * });
 */
export function useImportScrapeManyQuery(baseOptions?: Apollo.QueryHookOptions<ImportScrapeManyQuery, ImportScrapeManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportScrapeManyQuery, ImportScrapeManyQueryVariables>(ImportScrapeManyDocument, options);
      }
export function useImportScrapeManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportScrapeManyQuery, ImportScrapeManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportScrapeManyQuery, ImportScrapeManyQueryVariables>(ImportScrapeManyDocument, options);
        }
// @ts-ignore
export function useImportScrapeManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImportScrapeManyQuery, ImportScrapeManyQueryVariables>): Apollo.UseSuspenseQueryResult<ImportScrapeManyQuery, ImportScrapeManyQueryVariables>;
export function useImportScrapeManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportScrapeManyQuery, ImportScrapeManyQueryVariables>): Apollo.UseSuspenseQueryResult<ImportScrapeManyQuery | undefined, ImportScrapeManyQueryVariables>;
export function useImportScrapeManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportScrapeManyQuery, ImportScrapeManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImportScrapeManyQuery, ImportScrapeManyQueryVariables>(ImportScrapeManyDocument, options);
        }
export type ImportScrapeManyQueryHookResult = ReturnType<typeof useImportScrapeManyQuery>;
export type ImportScrapeManyLazyQueryHookResult = ReturnType<typeof useImportScrapeManyLazyQuery>;
export type ImportScrapeManySuspenseQueryHookResult = ReturnType<typeof useImportScrapeManySuspenseQuery>;
export type ImportScrapeManyQueryResult = Apollo.QueryResult<ImportScrapeManyQuery, ImportScrapeManyQueryVariables>;
export const ImportScrapeRunManyDocument = gql`
    query ImportScrapeRunMany($filter: FilterFindManyImportScrapeRunInput, $limit: Int, $skip: Int, $sort: SortFindManyImportScrapeRunInput) {
  importScrapeRunMany(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
    _id
    scrapeId
    initiatedBy
    promptUsed
    websiteUrl
    status
    errorMessages
    rawAIResponse
    googleSheetsResponse
    results
    rowsAdded
    sitemapOffset
    sitemapTotalUrls
    sitemapRevision
    rating
    notes
    createdDateISO
  }
}
    `;

/**
 * __useImportScrapeRunManyQuery__
 *
 * To run a query within a React component, call `useImportScrapeRunManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportScrapeRunManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportScrapeRunManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useImportScrapeRunManyQuery(baseOptions?: Apollo.QueryHookOptions<ImportScrapeRunManyQuery, ImportScrapeRunManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportScrapeRunManyQuery, ImportScrapeRunManyQueryVariables>(ImportScrapeRunManyDocument, options);
      }
export function useImportScrapeRunManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportScrapeRunManyQuery, ImportScrapeRunManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportScrapeRunManyQuery, ImportScrapeRunManyQueryVariables>(ImportScrapeRunManyDocument, options);
        }
// @ts-ignore
export function useImportScrapeRunManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImportScrapeRunManyQuery, ImportScrapeRunManyQueryVariables>): Apollo.UseSuspenseQueryResult<ImportScrapeRunManyQuery, ImportScrapeRunManyQueryVariables>;
export function useImportScrapeRunManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportScrapeRunManyQuery, ImportScrapeRunManyQueryVariables>): Apollo.UseSuspenseQueryResult<ImportScrapeRunManyQuery | undefined, ImportScrapeRunManyQueryVariables>;
export function useImportScrapeRunManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportScrapeRunManyQuery, ImportScrapeRunManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImportScrapeRunManyQuery, ImportScrapeRunManyQueryVariables>(ImportScrapeRunManyDocument, options);
        }
export type ImportScrapeRunManyQueryHookResult = ReturnType<typeof useImportScrapeRunManyQuery>;
export type ImportScrapeRunManyLazyQueryHookResult = ReturnType<typeof useImportScrapeRunManyLazyQuery>;
export type ImportScrapeRunManySuspenseQueryHookResult = ReturnType<typeof useImportScrapeRunManySuspenseQuery>;
export type ImportScrapeRunManyQueryResult = Apollo.QueryResult<ImportScrapeRunManyQuery, ImportScrapeRunManyQueryVariables>;
export const InventoryByProductBookedDatesDocument = gql`
    query InventoryByProductBookedDates($productId: ID!) {
  inventoryDatesByProduct(productId: $productId) {
    bookedDatesISO
    checkOutOnlyDatesISO
  }
}
    `;

/**
 * __useInventoryByProductBookedDatesQuery__
 *
 * To run a query within a React component, call `useInventoryByProductBookedDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryByProductBookedDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryByProductBookedDatesQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useInventoryByProductBookedDatesQuery(baseOptions: Apollo.QueryHookOptions<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables> & ({ variables: InventoryByProductBookedDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>(InventoryByProductBookedDatesDocument, options);
      }
export function useInventoryByProductBookedDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>(InventoryByProductBookedDatesDocument, options);
        }
// @ts-ignore
export function useInventoryByProductBookedDatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>): Apollo.UseSuspenseQueryResult<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>;
export function useInventoryByProductBookedDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>): Apollo.UseSuspenseQueryResult<InventoryByProductBookedDatesQuery | undefined, InventoryByProductBookedDatesQueryVariables>;
export function useInventoryByProductBookedDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>(InventoryByProductBookedDatesDocument, options);
        }
export type InventoryByProductBookedDatesQueryHookResult = ReturnType<typeof useInventoryByProductBookedDatesQuery>;
export type InventoryByProductBookedDatesLazyQueryHookResult = ReturnType<typeof useInventoryByProductBookedDatesLazyQuery>;
export type InventoryByProductBookedDatesSuspenseQueryHookResult = ReturnType<typeof useInventoryByProductBookedDatesSuspenseQuery>;
export type InventoryByProductBookedDatesQueryResult = Apollo.QueryResult<InventoryByProductBookedDatesQuery, InventoryByProductBookedDatesQueryVariables>;
export const InviteQueueByOperatorAndOrganizationDocument = gql`
    query InviteQueueByOperatorAndOrganization($operatorEntityId: MongoID!, $organizationId: MongoID!) {
  inviteQueueByOperatorAndOrganization(
    operatorEntityId: $operatorEntityId
    organizationId: $organizationId
  ) {
    _id
    invitedOperator
    invitedOperatorName
    inviteByEmailOnly
    invitedEmail
    invitedUser
    invitedUserName
    initiatedByUser
    initiatedByUserName
    initiatedDate
    organizationId
    organizationName
    inviteStatus
    createdDateISO
    updatedDateISO
  }
}
    `;

/**
 * __useInviteQueueByOperatorAndOrganizationQuery__
 *
 * To run a query within a React component, call `useInviteQueueByOperatorAndOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteQueueByOperatorAndOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteQueueByOperatorAndOrganizationQuery({
 *   variables: {
 *      operatorEntityId: // value for 'operatorEntityId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useInviteQueueByOperatorAndOrganizationQuery(baseOptions: Apollo.QueryHookOptions<InviteQueueByOperatorAndOrganizationQuery, InviteQueueByOperatorAndOrganizationQueryVariables> & ({ variables: InviteQueueByOperatorAndOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteQueueByOperatorAndOrganizationQuery, InviteQueueByOperatorAndOrganizationQueryVariables>(InviteQueueByOperatorAndOrganizationDocument, options);
      }
export function useInviteQueueByOperatorAndOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteQueueByOperatorAndOrganizationQuery, InviteQueueByOperatorAndOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteQueueByOperatorAndOrganizationQuery, InviteQueueByOperatorAndOrganizationQueryVariables>(InviteQueueByOperatorAndOrganizationDocument, options);
        }
// @ts-ignore
export function useInviteQueueByOperatorAndOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InviteQueueByOperatorAndOrganizationQuery, InviteQueueByOperatorAndOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<InviteQueueByOperatorAndOrganizationQuery, InviteQueueByOperatorAndOrganizationQueryVariables>;
export function useInviteQueueByOperatorAndOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteQueueByOperatorAndOrganizationQuery, InviteQueueByOperatorAndOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<InviteQueueByOperatorAndOrganizationQuery | undefined, InviteQueueByOperatorAndOrganizationQueryVariables>;
export function useInviteQueueByOperatorAndOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteQueueByOperatorAndOrganizationQuery, InviteQueueByOperatorAndOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InviteQueueByOperatorAndOrganizationQuery, InviteQueueByOperatorAndOrganizationQueryVariables>(InviteQueueByOperatorAndOrganizationDocument, options);
        }
export type InviteQueueByOperatorAndOrganizationQueryHookResult = ReturnType<typeof useInviteQueueByOperatorAndOrganizationQuery>;
export type InviteQueueByOperatorAndOrganizationLazyQueryHookResult = ReturnType<typeof useInviteQueueByOperatorAndOrganizationLazyQuery>;
export type InviteQueueByOperatorAndOrganizationSuspenseQueryHookResult = ReturnType<typeof useInviteQueueByOperatorAndOrganizationSuspenseQuery>;
export type InviteQueueByOperatorAndOrganizationQueryResult = Apollo.QueryResult<InviteQueueByOperatorAndOrganizationQuery, InviteQueueByOperatorAndOrganizationQueryVariables>;
export const InviteQueueCleanupPreviewDocument = gql`
    query InviteQueueCleanupPreview($organizationId: MongoID!, $criteria: InviteQueueCleanupCriteriaInput!) {
  inviteQueueCleanupPreview(organizationId: $organizationId, criteria: $criteria) {
    sentMoreThan
    olderThanDays
    accepted
    bounced
    ready
    total
  }
}
    `;

/**
 * __useInviteQueueCleanupPreviewQuery__
 *
 * To run a query within a React component, call `useInviteQueueCleanupPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteQueueCleanupPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteQueueCleanupPreviewQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useInviteQueueCleanupPreviewQuery(baseOptions: Apollo.QueryHookOptions<InviteQueueCleanupPreviewQuery, InviteQueueCleanupPreviewQueryVariables> & ({ variables: InviteQueueCleanupPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteQueueCleanupPreviewQuery, InviteQueueCleanupPreviewQueryVariables>(InviteQueueCleanupPreviewDocument, options);
      }
export function useInviteQueueCleanupPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteQueueCleanupPreviewQuery, InviteQueueCleanupPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteQueueCleanupPreviewQuery, InviteQueueCleanupPreviewQueryVariables>(InviteQueueCleanupPreviewDocument, options);
        }
// @ts-ignore
export function useInviteQueueCleanupPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InviteQueueCleanupPreviewQuery, InviteQueueCleanupPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<InviteQueueCleanupPreviewQuery, InviteQueueCleanupPreviewQueryVariables>;
export function useInviteQueueCleanupPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteQueueCleanupPreviewQuery, InviteQueueCleanupPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<InviteQueueCleanupPreviewQuery | undefined, InviteQueueCleanupPreviewQueryVariables>;
export function useInviteQueueCleanupPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteQueueCleanupPreviewQuery, InviteQueueCleanupPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InviteQueueCleanupPreviewQuery, InviteQueueCleanupPreviewQueryVariables>(InviteQueueCleanupPreviewDocument, options);
        }
export type InviteQueueCleanupPreviewQueryHookResult = ReturnType<typeof useInviteQueueCleanupPreviewQuery>;
export type InviteQueueCleanupPreviewLazyQueryHookResult = ReturnType<typeof useInviteQueueCleanupPreviewLazyQuery>;
export type InviteQueueCleanupPreviewSuspenseQueryHookResult = ReturnType<typeof useInviteQueueCleanupPreviewSuspenseQuery>;
export type InviteQueueCleanupPreviewQueryResult = Apollo.QueryResult<InviteQueueCleanupPreviewQuery, InviteQueueCleanupPreviewQueryVariables>;
export const InviteQueueManyDocument = gql`
    query InviteQueueMany($filter: FilterFindManyInviteQueueInput, $limit: Int) {
  inviteQueueMany(filter: $filter, limit: $limit) {
    _id
    invitedOperator
    invitedOperatorName
    inviteByEmailOnly
    storedInvitedEmail
    staffDeliveryEmail
    invitedEmail
    invitedUser
    invitedUserName
    initiatedByUserName
    initiatedDate
    organizationId
    organizationName
    inviteStatus
    inviteType
    activityLogIds
    bounced
    personId
    updatedDateISO
  }
}
    `;

/**
 * __useInviteQueueManyQuery__
 *
 * To run a query within a React component, call `useInviteQueueManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteQueueManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteQueueManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useInviteQueueManyQuery(baseOptions?: Apollo.QueryHookOptions<InviteQueueManyQuery, InviteQueueManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteQueueManyQuery, InviteQueueManyQueryVariables>(InviteQueueManyDocument, options);
      }
export function useInviteQueueManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteQueueManyQuery, InviteQueueManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteQueueManyQuery, InviteQueueManyQueryVariables>(InviteQueueManyDocument, options);
        }
// @ts-ignore
export function useInviteQueueManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InviteQueueManyQuery, InviteQueueManyQueryVariables>): Apollo.UseSuspenseQueryResult<InviteQueueManyQuery, InviteQueueManyQueryVariables>;
export function useInviteQueueManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteQueueManyQuery, InviteQueueManyQueryVariables>): Apollo.UseSuspenseQueryResult<InviteQueueManyQuery | undefined, InviteQueueManyQueryVariables>;
export function useInviteQueueManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteQueueManyQuery, InviteQueueManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InviteQueueManyQuery, InviteQueueManyQueryVariables>(InviteQueueManyDocument, options);
        }
export type InviteQueueManyQueryHookResult = ReturnType<typeof useInviteQueueManyQuery>;
export type InviteQueueManyLazyQueryHookResult = ReturnType<typeof useInviteQueueManyLazyQuery>;
export type InviteQueueManySuspenseQueryHookResult = ReturnType<typeof useInviteQueueManySuspenseQuery>;
export type InviteQueueManyQueryResult = Apollo.QueryResult<InviteQueueManyQuery, InviteQueueManyQueryVariables>;
export const ItineraryWidgetsForOrgPreviewDocument = gql`
    query ItineraryWidgetsForOrgPreview($organizationId: MongoID!) {
  itineraryWidgetsByOrganization(organizationId: $organizationId) {
    _id
    itinerary
    organization
    type
    label
    buttonLabel
    embedStyle
    accentColor
    status
  }
}
    `;

/**
 * __useItineraryWidgetsForOrgPreviewQuery__
 *
 * To run a query within a React component, call `useItineraryWidgetsForOrgPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useItineraryWidgetsForOrgPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItineraryWidgetsForOrgPreviewQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useItineraryWidgetsForOrgPreviewQuery(baseOptions: Apollo.QueryHookOptions<ItineraryWidgetsForOrgPreviewQuery, ItineraryWidgetsForOrgPreviewQueryVariables> & ({ variables: ItineraryWidgetsForOrgPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItineraryWidgetsForOrgPreviewQuery, ItineraryWidgetsForOrgPreviewQueryVariables>(ItineraryWidgetsForOrgPreviewDocument, options);
      }
export function useItineraryWidgetsForOrgPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItineraryWidgetsForOrgPreviewQuery, ItineraryWidgetsForOrgPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItineraryWidgetsForOrgPreviewQuery, ItineraryWidgetsForOrgPreviewQueryVariables>(ItineraryWidgetsForOrgPreviewDocument, options);
        }
// @ts-ignore
export function useItineraryWidgetsForOrgPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ItineraryWidgetsForOrgPreviewQuery, ItineraryWidgetsForOrgPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<ItineraryWidgetsForOrgPreviewQuery, ItineraryWidgetsForOrgPreviewQueryVariables>;
export function useItineraryWidgetsForOrgPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ItineraryWidgetsForOrgPreviewQuery, ItineraryWidgetsForOrgPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<ItineraryWidgetsForOrgPreviewQuery | undefined, ItineraryWidgetsForOrgPreviewQueryVariables>;
export function useItineraryWidgetsForOrgPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ItineraryWidgetsForOrgPreviewQuery, ItineraryWidgetsForOrgPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ItineraryWidgetsForOrgPreviewQuery, ItineraryWidgetsForOrgPreviewQueryVariables>(ItineraryWidgetsForOrgPreviewDocument, options);
        }
export type ItineraryWidgetsForOrgPreviewQueryHookResult = ReturnType<typeof useItineraryWidgetsForOrgPreviewQuery>;
export type ItineraryWidgetsForOrgPreviewLazyQueryHookResult = ReturnType<typeof useItineraryWidgetsForOrgPreviewLazyQuery>;
export type ItineraryWidgetsForOrgPreviewSuspenseQueryHookResult = ReturnType<typeof useItineraryWidgetsForOrgPreviewSuspenseQuery>;
export type ItineraryWidgetsForOrgPreviewQueryResult = Apollo.QueryResult<ItineraryWidgetsForOrgPreviewQuery, ItineraryWidgetsForOrgPreviewQueryVariables>;
export const LeadByIdDocument = gql`
    query LeadById($id: MongoID!) {
  leadById(_id: $id) {
    ...LeadFragment
  }
}
    ${LeadFragmentFragmentDoc}`;

/**
 * __useLeadByIdQuery__
 *
 * To run a query within a React component, call `useLeadByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeadByIdQuery(baseOptions: Apollo.QueryHookOptions<LeadByIdQuery, LeadByIdQueryVariables> & ({ variables: LeadByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadByIdQuery, LeadByIdQueryVariables>(LeadByIdDocument, options);
      }
export function useLeadByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadByIdQuery, LeadByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadByIdQuery, LeadByIdQueryVariables>(LeadByIdDocument, options);
        }
// @ts-ignore
export function useLeadByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LeadByIdQuery, LeadByIdQueryVariables>): Apollo.UseSuspenseQueryResult<LeadByIdQuery, LeadByIdQueryVariables>;
export function useLeadByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeadByIdQuery, LeadByIdQueryVariables>): Apollo.UseSuspenseQueryResult<LeadByIdQuery | undefined, LeadByIdQueryVariables>;
export function useLeadByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeadByIdQuery, LeadByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeadByIdQuery, LeadByIdQueryVariables>(LeadByIdDocument, options);
        }
export type LeadByIdQueryHookResult = ReturnType<typeof useLeadByIdQuery>;
export type LeadByIdLazyQueryHookResult = ReturnType<typeof useLeadByIdLazyQuery>;
export type LeadByIdSuspenseQueryHookResult = ReturnType<typeof useLeadByIdSuspenseQuery>;
export type LeadByIdQueryResult = Apollo.QueryResult<LeadByIdQuery, LeadByIdQueryVariables>;
export const ListByIdDocument = gql`
    query ListById($id: MongoID!) {
  listById(_id: $id) {
    _id
    type
    kind
    tierTagId
    memberListKey
    filterTagIds
    owner {
      entityId
      type
    }
    name {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    selections
    archived
    favorited
    orderIndex
    locked
    lockedAt
    lockedBy
    lockedByName
    entities {
      _entityId
      _versionId
      status
      name {
        ...MultilingualFragment
      }
      type
      operationalStatus
      claimed
      tags {
        global {
          _id
        }
        organizationSpecific {
          _id
        }
      }
      images(limit: 1) {
        ...ImageFragment
      }
      iasc
      enrollments {
        organization {
          _id
          shortName
        }
        onboardingStatus
        organizationControlled
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useListByIdQuery__
 *
 * To run a query within a React component, call `useListByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useListByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListByIdQuery(baseOptions: Apollo.QueryHookOptions<ListByIdQuery, ListByIdQueryVariables> & ({ variables: ListByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListByIdQuery, ListByIdQueryVariables>(ListByIdDocument, options);
      }
export function useListByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListByIdQuery, ListByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListByIdQuery, ListByIdQueryVariables>(ListByIdDocument, options);
        }
// @ts-ignore
export function useListByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListByIdQuery, ListByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ListByIdQuery, ListByIdQueryVariables>;
export function useListByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListByIdQuery, ListByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ListByIdQuery | undefined, ListByIdQueryVariables>;
export function useListByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListByIdQuery, ListByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListByIdQuery, ListByIdQueryVariables>(ListByIdDocument, options);
        }
export type ListByIdQueryHookResult = ReturnType<typeof useListByIdQuery>;
export type ListByIdLazyQueryHookResult = ReturnType<typeof useListByIdLazyQuery>;
export type ListByIdSuspenseQueryHookResult = ReturnType<typeof useListByIdSuspenseQuery>;
export type ListByIdQueryResult = Apollo.QueryResult<ListByIdQuery, ListByIdQueryVariables>;
export const ListManyDocument = gql`
    query ListMany($filter: FilterFindManyListInput, $limit: Int, $sort: SortFindManyListInput) {
  listMany(filter: $filter, limit: $limit, sort: $sort) {
    _id
    description {
      ...MultilingualFragment
    }
    name {
      ...MultilingualFragment
    }
    owner {
      entityId
      type
    }
    type
    kind
    tierTagId
    memberListKey
    filterTagIds
    entityReferences {
      _entityId
      _versionId
      type
    }
    updatedDateISO
    archived
    favorited
    orderIndex
    locked
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useListManyQuery__
 *
 * To run a query within a React component, call `useListManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useListManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListManyQuery(baseOptions?: Apollo.QueryHookOptions<ListManyQuery, ListManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListManyQuery, ListManyQueryVariables>(ListManyDocument, options);
      }
export function useListManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListManyQuery, ListManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListManyQuery, ListManyQueryVariables>(ListManyDocument, options);
        }
// @ts-ignore
export function useListManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListManyQuery, ListManyQueryVariables>): Apollo.UseSuspenseQueryResult<ListManyQuery, ListManyQueryVariables>;
export function useListManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListManyQuery, ListManyQueryVariables>): Apollo.UseSuspenseQueryResult<ListManyQuery | undefined, ListManyQueryVariables>;
export function useListManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListManyQuery, ListManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListManyQuery, ListManyQueryVariables>(ListManyDocument, options);
        }
export type ListManyQueryHookResult = ReturnType<typeof useListManyQuery>;
export type ListManyLazyQueryHookResult = ReturnType<typeof useListManyLazyQuery>;
export type ListManySuspenseQueryHookResult = ReturnType<typeof useListManySuspenseQuery>;
export type ListManyQueryResult = Apollo.QueryResult<ListManyQuery, ListManyQueryVariables>;
export const ListManyNamesDocument = gql`
    query ListManyNames($filter: FilterFindManyListInput, $limit: Int, $sort: SortFindManyListInput) {
  listMany(filter: $filter, limit: $limit, sort: $sort) {
    _id
    name {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useListManyNamesQuery__
 *
 * To run a query within a React component, call `useListManyNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListManyNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListManyNamesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListManyNamesQuery(baseOptions?: Apollo.QueryHookOptions<ListManyNamesQuery, ListManyNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListManyNamesQuery, ListManyNamesQueryVariables>(ListManyNamesDocument, options);
      }
export function useListManyNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListManyNamesQuery, ListManyNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListManyNamesQuery, ListManyNamesQueryVariables>(ListManyNamesDocument, options);
        }
// @ts-ignore
export function useListManyNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListManyNamesQuery, ListManyNamesQueryVariables>): Apollo.UseSuspenseQueryResult<ListManyNamesQuery, ListManyNamesQueryVariables>;
export function useListManyNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListManyNamesQuery, ListManyNamesQueryVariables>): Apollo.UseSuspenseQueryResult<ListManyNamesQuery | undefined, ListManyNamesQueryVariables>;
export function useListManyNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListManyNamesQuery, ListManyNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListManyNamesQuery, ListManyNamesQueryVariables>(ListManyNamesDocument, options);
        }
export type ListManyNamesQueryHookResult = ReturnType<typeof useListManyNamesQuery>;
export type ListManyNamesLazyQueryHookResult = ReturnType<typeof useListManyNamesLazyQuery>;
export type ListManyNamesSuspenseQueryHookResult = ReturnType<typeof useListManyNamesSuspenseQuery>;
export type ListManyNamesQueryResult = Apollo.QueryResult<ListManyNamesQuery, ListManyNamesQueryVariables>;
export const MaintenanceFindOneDocument = gql`
    query MaintenanceFindOne {
  maintenanceFindOne {
    banner {
      isLive
      message {
        ...MultilingualFragment
      }
    }
    doorstop {
      isLive
      message {
        ...MultilingualFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useMaintenanceFindOneQuery__
 *
 * To run a query within a React component, call `useMaintenanceFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaintenanceFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaintenanceFindOneQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaintenanceFindOneQuery(baseOptions?: Apollo.QueryHookOptions<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>(MaintenanceFindOneDocument, options);
      }
export function useMaintenanceFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>(MaintenanceFindOneDocument, options);
        }
// @ts-ignore
export function useMaintenanceFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>): Apollo.UseSuspenseQueryResult<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>;
export function useMaintenanceFindOneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>): Apollo.UseSuspenseQueryResult<MaintenanceFindOneQuery | undefined, MaintenanceFindOneQueryVariables>;
export function useMaintenanceFindOneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>(MaintenanceFindOneDocument, options);
        }
export type MaintenanceFindOneQueryHookResult = ReturnType<typeof useMaintenanceFindOneQuery>;
export type MaintenanceFindOneLazyQueryHookResult = ReturnType<typeof useMaintenanceFindOneLazyQuery>;
export type MaintenanceFindOneSuspenseQueryHookResult = ReturnType<typeof useMaintenanceFindOneSuspenseQuery>;
export type MaintenanceFindOneQueryResult = Apollo.QueryResult<MaintenanceFindOneQuery, MaintenanceFindOneQueryVariables>;
export const MediaGalleryTagGroupDocument = gql`
    query MediaGalleryTagGroup {
  mediaGalleryTagGroup
}
    `;

/**
 * __useMediaGalleryTagGroupQuery__
 *
 * To run a query within a React component, call `useMediaGalleryTagGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaGalleryTagGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaGalleryTagGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useMediaGalleryTagGroupQuery(baseOptions?: Apollo.QueryHookOptions<MediaGalleryTagGroupQuery, MediaGalleryTagGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaGalleryTagGroupQuery, MediaGalleryTagGroupQueryVariables>(MediaGalleryTagGroupDocument, options);
      }
export function useMediaGalleryTagGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaGalleryTagGroupQuery, MediaGalleryTagGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaGalleryTagGroupQuery, MediaGalleryTagGroupQueryVariables>(MediaGalleryTagGroupDocument, options);
        }
// @ts-ignore
export function useMediaGalleryTagGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediaGalleryTagGroupQuery, MediaGalleryTagGroupQueryVariables>): Apollo.UseSuspenseQueryResult<MediaGalleryTagGroupQuery, MediaGalleryTagGroupQueryVariables>;
export function useMediaGalleryTagGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaGalleryTagGroupQuery, MediaGalleryTagGroupQueryVariables>): Apollo.UseSuspenseQueryResult<MediaGalleryTagGroupQuery | undefined, MediaGalleryTagGroupQueryVariables>;
export function useMediaGalleryTagGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaGalleryTagGroupQuery, MediaGalleryTagGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaGalleryTagGroupQuery, MediaGalleryTagGroupQueryVariables>(MediaGalleryTagGroupDocument, options);
        }
export type MediaGalleryTagGroupQueryHookResult = ReturnType<typeof useMediaGalleryTagGroupQuery>;
export type MediaGalleryTagGroupLazyQueryHookResult = ReturnType<typeof useMediaGalleryTagGroupLazyQuery>;
export type MediaGalleryTagGroupSuspenseQueryHookResult = ReturnType<typeof useMediaGalleryTagGroupSuspenseQuery>;
export type MediaGalleryTagGroupQueryResult = Apollo.QueryResult<MediaGalleryTagGroupQuery, MediaGalleryTagGroupQueryVariables>;
export const MemberListsByTierTagIdsDocument = gql`
    query MemberListsByTierTagIds($organizationId: ID!, $tierTagIds: [ID!]!) {
  memberListsByTierTagIds(
    organizationId: $organizationId
    tierTagIds: $tierTagIds
  ) {
    _id
    name {
      ...MultilingualFragment
    }
    tierTagId
    memberListKey
    filterTagIds
    archived
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useMemberListsByTierTagIdsQuery__
 *
 * To run a query within a React component, call `useMemberListsByTierTagIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberListsByTierTagIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberListsByTierTagIdsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      tierTagIds: // value for 'tierTagIds'
 *   },
 * });
 */
export function useMemberListsByTierTagIdsQuery(baseOptions: Apollo.QueryHookOptions<MemberListsByTierTagIdsQuery, MemberListsByTierTagIdsQueryVariables> & ({ variables: MemberListsByTierTagIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberListsByTierTagIdsQuery, MemberListsByTierTagIdsQueryVariables>(MemberListsByTierTagIdsDocument, options);
      }
export function useMemberListsByTierTagIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberListsByTierTagIdsQuery, MemberListsByTierTagIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberListsByTierTagIdsQuery, MemberListsByTierTagIdsQueryVariables>(MemberListsByTierTagIdsDocument, options);
        }
// @ts-ignore
export function useMemberListsByTierTagIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemberListsByTierTagIdsQuery, MemberListsByTierTagIdsQueryVariables>): Apollo.UseSuspenseQueryResult<MemberListsByTierTagIdsQuery, MemberListsByTierTagIdsQueryVariables>;
export function useMemberListsByTierTagIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberListsByTierTagIdsQuery, MemberListsByTierTagIdsQueryVariables>): Apollo.UseSuspenseQueryResult<MemberListsByTierTagIdsQuery | undefined, MemberListsByTierTagIdsQueryVariables>;
export function useMemberListsByTierTagIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberListsByTierTagIdsQuery, MemberListsByTierTagIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberListsByTierTagIdsQuery, MemberListsByTierTagIdsQueryVariables>(MemberListsByTierTagIdsDocument, options);
        }
export type MemberListsByTierTagIdsQueryHookResult = ReturnType<typeof useMemberListsByTierTagIdsQuery>;
export type MemberListsByTierTagIdsLazyQueryHookResult = ReturnType<typeof useMemberListsByTierTagIdsLazyQuery>;
export type MemberListsByTierTagIdsSuspenseQueryHookResult = ReturnType<typeof useMemberListsByTierTagIdsSuspenseQuery>;
export type MemberListsByTierTagIdsQueryResult = Apollo.QueryResult<MemberListsByTierTagIdsQuery, MemberListsByTierTagIdsQueryVariables>;
export const MembershipBySubjectAndOrganizationDocument = gql`
    query MembershipBySubjectAndOrganization($subjectType: String!, $subjectEntityId: MongoID!, $organizationId: MongoID!) {
  membershipBySubjectAndOrganization(
    subjectType: $subjectType
    subjectEntityId: $subjectEntityId
    organizationId: $organizationId
  ) {
    _id
    status
    tierTagId
    statusTagIds
    currentPeriodEnd
    nextRenewalDate
    manualRenewalDate
    renewalAnchorDate
    renewalState {
      phase
      paidThroughDate
      nextRenewalDate
      displayDate
    }
  }
}
    `;

/**
 * __useMembershipBySubjectAndOrganizationQuery__
 *
 * To run a query within a React component, call `useMembershipBySubjectAndOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipBySubjectAndOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipBySubjectAndOrganizationQuery({
 *   variables: {
 *      subjectType: // value for 'subjectType'
 *      subjectEntityId: // value for 'subjectEntityId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembershipBySubjectAndOrganizationQuery(baseOptions: Apollo.QueryHookOptions<MembershipBySubjectAndOrganizationQuery, MembershipBySubjectAndOrganizationQueryVariables> & ({ variables: MembershipBySubjectAndOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipBySubjectAndOrganizationQuery, MembershipBySubjectAndOrganizationQueryVariables>(MembershipBySubjectAndOrganizationDocument, options);
      }
export function useMembershipBySubjectAndOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipBySubjectAndOrganizationQuery, MembershipBySubjectAndOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipBySubjectAndOrganizationQuery, MembershipBySubjectAndOrganizationQueryVariables>(MembershipBySubjectAndOrganizationDocument, options);
        }
// @ts-ignore
export function useMembershipBySubjectAndOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembershipBySubjectAndOrganizationQuery, MembershipBySubjectAndOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipBySubjectAndOrganizationQuery, MembershipBySubjectAndOrganizationQueryVariables>;
export function useMembershipBySubjectAndOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipBySubjectAndOrganizationQuery, MembershipBySubjectAndOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipBySubjectAndOrganizationQuery | undefined, MembershipBySubjectAndOrganizationQueryVariables>;
export function useMembershipBySubjectAndOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipBySubjectAndOrganizationQuery, MembershipBySubjectAndOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipBySubjectAndOrganizationQuery, MembershipBySubjectAndOrganizationQueryVariables>(MembershipBySubjectAndOrganizationDocument, options);
        }
export type MembershipBySubjectAndOrganizationQueryHookResult = ReturnType<typeof useMembershipBySubjectAndOrganizationQuery>;
export type MembershipBySubjectAndOrganizationLazyQueryHookResult = ReturnType<typeof useMembershipBySubjectAndOrganizationLazyQuery>;
export type MembershipBySubjectAndOrganizationSuspenseQueryHookResult = ReturnType<typeof useMembershipBySubjectAndOrganizationSuspenseQuery>;
export type MembershipBySubjectAndOrganizationQueryResult = Apollo.QueryResult<MembershipBySubjectAndOrganizationQuery, MembershipBySubjectAndOrganizationQueryVariables>;
export const MembershipChecklistLatestDocument = gql`
    query MembershipChecklistLatest($organizationId: MongoID!) {
  membershipChecklistLatest(organizationId: $organizationId) {
    ...MembershipChecklistResultFragment
  }
}
    ${MembershipChecklistResultFragmentFragmentDoc}`;

/**
 * __useMembershipChecklistLatestQuery__
 *
 * To run a query within a React component, call `useMembershipChecklistLatestQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipChecklistLatestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipChecklistLatestQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembershipChecklistLatestQuery(baseOptions: Apollo.QueryHookOptions<MembershipChecklistLatestQuery, MembershipChecklistLatestQueryVariables> & ({ variables: MembershipChecklistLatestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipChecklistLatestQuery, MembershipChecklistLatestQueryVariables>(MembershipChecklistLatestDocument, options);
      }
export function useMembershipChecklistLatestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipChecklistLatestQuery, MembershipChecklistLatestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipChecklistLatestQuery, MembershipChecklistLatestQueryVariables>(MembershipChecklistLatestDocument, options);
        }
// @ts-ignore
export function useMembershipChecklistLatestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembershipChecklistLatestQuery, MembershipChecklistLatestQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipChecklistLatestQuery, MembershipChecklistLatestQueryVariables>;
export function useMembershipChecklistLatestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipChecklistLatestQuery, MembershipChecklistLatestQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipChecklistLatestQuery | undefined, MembershipChecklistLatestQueryVariables>;
export function useMembershipChecklistLatestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipChecklistLatestQuery, MembershipChecklistLatestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipChecklistLatestQuery, MembershipChecklistLatestQueryVariables>(MembershipChecklistLatestDocument, options);
        }
export type MembershipChecklistLatestQueryHookResult = ReturnType<typeof useMembershipChecklistLatestQuery>;
export type MembershipChecklistLatestLazyQueryHookResult = ReturnType<typeof useMembershipChecklistLatestLazyQuery>;
export type MembershipChecklistLatestSuspenseQueryHookResult = ReturnType<typeof useMembershipChecklistLatestSuspenseQuery>;
export type MembershipChecklistLatestQueryResult = Apollo.QueryResult<MembershipChecklistLatestQuery, MembershipChecklistLatestQueryVariables>;
export const MembershipCheckoutBookersDocument = gql`
    query MembershipCheckoutBookers($filter: FilterFindManyBookerInput) {
  bookerMany(filter: $filter, limit: 10000) {
    _id
    name {
      ...MultilingualFragment
    }
    status
    storefront
    businessCompletionTags
    bundles {
      _id
      product {
        _id
        type
        name {
          ...MultilingualFragment
        }
        renewableFeeMetadata {
          membershipLinked
        }
        sellingConfig {
          recurring {
            membershipLinked
          }
          options {
            _id
            name {
              ...MultilingualFragment
            }
            tagConfig {
              onCheckoutCompleted
            }
          }
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useMembershipCheckoutBookersQuery__
 *
 * To run a query within a React component, call `useMembershipCheckoutBookersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipCheckoutBookersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipCheckoutBookersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMembershipCheckoutBookersQuery(baseOptions?: Apollo.QueryHookOptions<MembershipCheckoutBookersQuery, MembershipCheckoutBookersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipCheckoutBookersQuery, MembershipCheckoutBookersQueryVariables>(MembershipCheckoutBookersDocument, options);
      }
export function useMembershipCheckoutBookersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipCheckoutBookersQuery, MembershipCheckoutBookersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipCheckoutBookersQuery, MembershipCheckoutBookersQueryVariables>(MembershipCheckoutBookersDocument, options);
        }
// @ts-ignore
export function useMembershipCheckoutBookersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembershipCheckoutBookersQuery, MembershipCheckoutBookersQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipCheckoutBookersQuery, MembershipCheckoutBookersQueryVariables>;
export function useMembershipCheckoutBookersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipCheckoutBookersQuery, MembershipCheckoutBookersQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipCheckoutBookersQuery | undefined, MembershipCheckoutBookersQueryVariables>;
export function useMembershipCheckoutBookersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipCheckoutBookersQuery, MembershipCheckoutBookersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipCheckoutBookersQuery, MembershipCheckoutBookersQueryVariables>(MembershipCheckoutBookersDocument, options);
        }
export type MembershipCheckoutBookersQueryHookResult = ReturnType<typeof useMembershipCheckoutBookersQuery>;
export type MembershipCheckoutBookersLazyQueryHookResult = ReturnType<typeof useMembershipCheckoutBookersLazyQuery>;
export type MembershipCheckoutBookersSuspenseQueryHookResult = ReturnType<typeof useMembershipCheckoutBookersSuspenseQuery>;
export type MembershipCheckoutBookersQueryResult = Apollo.QueryResult<MembershipCheckoutBookersQuery, MembershipCheckoutBookersQueryVariables>;
export const MembershipContactStatesByOperatorsDocument = gql`
    query MembershipContactStatesByOperators($organizationId: MongoID!, $operatorEntityIds: [MongoID!]!) {
  membershipPaidUpByOperators(
    organizationId: $organizationId
    operatorEntityIds: $operatorEntityIds
    includeContact: true
  ) {
    operatorEntityId
    contactStatusTagId
    contactKind
    contactState
    lastContactedAt
    queuedListId
    queuedListName
  }
}
    `;

/**
 * __useMembershipContactStatesByOperatorsQuery__
 *
 * To run a query within a React component, call `useMembershipContactStatesByOperatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipContactStatesByOperatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipContactStatesByOperatorsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      operatorEntityIds: // value for 'operatorEntityIds'
 *   },
 * });
 */
export function useMembershipContactStatesByOperatorsQuery(baseOptions: Apollo.QueryHookOptions<MembershipContactStatesByOperatorsQuery, MembershipContactStatesByOperatorsQueryVariables> & ({ variables: MembershipContactStatesByOperatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipContactStatesByOperatorsQuery, MembershipContactStatesByOperatorsQueryVariables>(MembershipContactStatesByOperatorsDocument, options);
      }
export function useMembershipContactStatesByOperatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipContactStatesByOperatorsQuery, MembershipContactStatesByOperatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipContactStatesByOperatorsQuery, MembershipContactStatesByOperatorsQueryVariables>(MembershipContactStatesByOperatorsDocument, options);
        }
// @ts-ignore
export function useMembershipContactStatesByOperatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembershipContactStatesByOperatorsQuery, MembershipContactStatesByOperatorsQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipContactStatesByOperatorsQuery, MembershipContactStatesByOperatorsQueryVariables>;
export function useMembershipContactStatesByOperatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipContactStatesByOperatorsQuery, MembershipContactStatesByOperatorsQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipContactStatesByOperatorsQuery | undefined, MembershipContactStatesByOperatorsQueryVariables>;
export function useMembershipContactStatesByOperatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipContactStatesByOperatorsQuery, MembershipContactStatesByOperatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipContactStatesByOperatorsQuery, MembershipContactStatesByOperatorsQueryVariables>(MembershipContactStatesByOperatorsDocument, options);
        }
export type MembershipContactStatesByOperatorsQueryHookResult = ReturnType<typeof useMembershipContactStatesByOperatorsQuery>;
export type MembershipContactStatesByOperatorsLazyQueryHookResult = ReturnType<typeof useMembershipContactStatesByOperatorsLazyQuery>;
export type MembershipContactStatesByOperatorsSuspenseQueryHookResult = ReturnType<typeof useMembershipContactStatesByOperatorsSuspenseQuery>;
export type MembershipContactStatesByOperatorsQueryResult = Apollo.QueryResult<MembershipContactStatesByOperatorsQuery, MembershipContactStatesByOperatorsQueryVariables>;
export const MembershipCustomEmailPreviewDocument = gql`
    query MembershipCustomEmailPreview($organizationId: MongoID!, $listId: MongoID!, $operatorEntityIds: [MongoID!]) {
  membershipCustomEmailPreview(
    organizationId: $organizationId
    listId: $listId
    operatorEntityIds: $operatorEntityIds
  ) {
    total
    sendable
    skippedQueued
    skippedCoolingDown
    skippedNoEmail
    skippedUnsubscribed
    missing {
      entityId
      name
    }
  }
}
    `;

/**
 * __useMembershipCustomEmailPreviewQuery__
 *
 * To run a query within a React component, call `useMembershipCustomEmailPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipCustomEmailPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipCustomEmailPreviewQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      listId: // value for 'listId'
 *      operatorEntityIds: // value for 'operatorEntityIds'
 *   },
 * });
 */
export function useMembershipCustomEmailPreviewQuery(baseOptions: Apollo.QueryHookOptions<MembershipCustomEmailPreviewQuery, MembershipCustomEmailPreviewQueryVariables> & ({ variables: MembershipCustomEmailPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipCustomEmailPreviewQuery, MembershipCustomEmailPreviewQueryVariables>(MembershipCustomEmailPreviewDocument, options);
      }
export function useMembershipCustomEmailPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipCustomEmailPreviewQuery, MembershipCustomEmailPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipCustomEmailPreviewQuery, MembershipCustomEmailPreviewQueryVariables>(MembershipCustomEmailPreviewDocument, options);
        }
// @ts-ignore
export function useMembershipCustomEmailPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembershipCustomEmailPreviewQuery, MembershipCustomEmailPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipCustomEmailPreviewQuery, MembershipCustomEmailPreviewQueryVariables>;
export function useMembershipCustomEmailPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipCustomEmailPreviewQuery, MembershipCustomEmailPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipCustomEmailPreviewQuery | undefined, MembershipCustomEmailPreviewQueryVariables>;
export function useMembershipCustomEmailPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipCustomEmailPreviewQuery, MembershipCustomEmailPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipCustomEmailPreviewQuery, MembershipCustomEmailPreviewQueryVariables>(MembershipCustomEmailPreviewDocument, options);
        }
export type MembershipCustomEmailPreviewQueryHookResult = ReturnType<typeof useMembershipCustomEmailPreviewQuery>;
export type MembershipCustomEmailPreviewLazyQueryHookResult = ReturnType<typeof useMembershipCustomEmailPreviewLazyQuery>;
export type MembershipCustomEmailPreviewSuspenseQueryHookResult = ReturnType<typeof useMembershipCustomEmailPreviewSuspenseQuery>;
export type MembershipCustomEmailPreviewQueryResult = Apollo.QueryResult<MembershipCustomEmailPreviewQuery, MembershipCustomEmailPreviewQueryVariables>;
export const MembershipDisplayForPersonDocument = gql`
    query MembershipDisplayForPerson($personId: MongoID!, $organizationId: MongoID!) {
  membershipDisplayForPerson(personId: $personId, organizationId: $organizationId) {
    source
    listingEntityId
    listingName
    membership {
      _id
      status
      tierTagId
      statusTagIds
      currentPeriodEnd
      nextRenewalDate
      manualRenewalDate
      renewalAnchorDate
      renewalState {
        phase
        paidThroughDate
        nextRenewalDate
        displayDate
      }
    }
  }
}
    `;

/**
 * __useMembershipDisplayForPersonQuery__
 *
 * To run a query within a React component, call `useMembershipDisplayForPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipDisplayForPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipDisplayForPersonQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembershipDisplayForPersonQuery(baseOptions: Apollo.QueryHookOptions<MembershipDisplayForPersonQuery, MembershipDisplayForPersonQueryVariables> & ({ variables: MembershipDisplayForPersonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipDisplayForPersonQuery, MembershipDisplayForPersonQueryVariables>(MembershipDisplayForPersonDocument, options);
      }
export function useMembershipDisplayForPersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipDisplayForPersonQuery, MembershipDisplayForPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipDisplayForPersonQuery, MembershipDisplayForPersonQueryVariables>(MembershipDisplayForPersonDocument, options);
        }
// @ts-ignore
export function useMembershipDisplayForPersonSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembershipDisplayForPersonQuery, MembershipDisplayForPersonQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipDisplayForPersonQuery, MembershipDisplayForPersonQueryVariables>;
export function useMembershipDisplayForPersonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipDisplayForPersonQuery, MembershipDisplayForPersonQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipDisplayForPersonQuery | undefined, MembershipDisplayForPersonQueryVariables>;
export function useMembershipDisplayForPersonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipDisplayForPersonQuery, MembershipDisplayForPersonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipDisplayForPersonQuery, MembershipDisplayForPersonQueryVariables>(MembershipDisplayForPersonDocument, options);
        }
export type MembershipDisplayForPersonQueryHookResult = ReturnType<typeof useMembershipDisplayForPersonQuery>;
export type MembershipDisplayForPersonLazyQueryHookResult = ReturnType<typeof useMembershipDisplayForPersonLazyQuery>;
export type MembershipDisplayForPersonSuspenseQueryHookResult = ReturnType<typeof useMembershipDisplayForPersonSuspenseQuery>;
export type MembershipDisplayForPersonQueryResult = Apollo.QueryResult<MembershipDisplayForPersonQuery, MembershipDisplayForPersonQueryVariables>;
export const MembershipHubForUserDocument = gql`
    query MembershipHubForUser($organizationIds: [MongoID!]!) {
  membershipHubForUser(organizationIds: $organizationIds) {
    organizationId
    enabled
    hideOfferFromForYou
    contactEmail
    tiers {
      tierTagId
      name {
        ...MultilingualFragment
      }
      subjectType
      description {
        ...MultilingualFragment
      }
      action
      bookerId
      price
      billingIntervalMonths
      applicationBroadcastId
      applicationResourceId
      hideFromNewcomers
    }
    purchases {
      _id
      status
      renewalBilling
      currentPeriodEnd
      tierName {
        ...MultilingualFragment
      }
      addOns {
        description
        amount
        quantity
        operatorId
        businessName
      }
      operatorIds
      pendingOperatorIds
      multiListingMode
      maxListings
      canManage
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useMembershipHubForUserQuery__
 *
 * To run a query within a React component, call `useMembershipHubForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipHubForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipHubForUserQuery({
 *   variables: {
 *      organizationIds: // value for 'organizationIds'
 *   },
 * });
 */
export function useMembershipHubForUserQuery(baseOptions: Apollo.QueryHookOptions<MembershipHubForUserQuery, MembershipHubForUserQueryVariables> & ({ variables: MembershipHubForUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipHubForUserQuery, MembershipHubForUserQueryVariables>(MembershipHubForUserDocument, options);
      }
export function useMembershipHubForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipHubForUserQuery, MembershipHubForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipHubForUserQuery, MembershipHubForUserQueryVariables>(MembershipHubForUserDocument, options);
        }
// @ts-ignore
export function useMembershipHubForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembershipHubForUserQuery, MembershipHubForUserQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipHubForUserQuery, MembershipHubForUserQueryVariables>;
export function useMembershipHubForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipHubForUserQuery, MembershipHubForUserQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipHubForUserQuery | undefined, MembershipHubForUserQueryVariables>;
export function useMembershipHubForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipHubForUserQuery, MembershipHubForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipHubForUserQuery, MembershipHubForUserQueryVariables>(MembershipHubForUserDocument, options);
        }
export type MembershipHubForUserQueryHookResult = ReturnType<typeof useMembershipHubForUserQuery>;
export type MembershipHubForUserLazyQueryHookResult = ReturnType<typeof useMembershipHubForUserLazyQuery>;
export type MembershipHubForUserSuspenseQueryHookResult = ReturnType<typeof useMembershipHubForUserSuspenseQuery>;
export type MembershipHubForUserQueryResult = Apollo.QueryResult<MembershipHubForUserQuery, MembershipHubForUserQueryVariables>;
export const MembershipLaunchStatusDocument = gql`
    query MembershipLaunchStatus($organizationId: MongoID!) {
  membershipLaunchStatus(organizationId: $organizationId) {
    ...MembershipLaunchStatusFragment
  }
}
    ${MembershipLaunchStatusFragmentFragmentDoc}`;

/**
 * __useMembershipLaunchStatusQuery__
 *
 * To run a query within a React component, call `useMembershipLaunchStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipLaunchStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipLaunchStatusQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembershipLaunchStatusQuery(baseOptions: Apollo.QueryHookOptions<MembershipLaunchStatusQuery, MembershipLaunchStatusQueryVariables> & ({ variables: MembershipLaunchStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipLaunchStatusQuery, MembershipLaunchStatusQueryVariables>(MembershipLaunchStatusDocument, options);
      }
export function useMembershipLaunchStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipLaunchStatusQuery, MembershipLaunchStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipLaunchStatusQuery, MembershipLaunchStatusQueryVariables>(MembershipLaunchStatusDocument, options);
        }
// @ts-ignore
export function useMembershipLaunchStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembershipLaunchStatusQuery, MembershipLaunchStatusQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipLaunchStatusQuery, MembershipLaunchStatusQueryVariables>;
export function useMembershipLaunchStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipLaunchStatusQuery, MembershipLaunchStatusQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipLaunchStatusQuery | undefined, MembershipLaunchStatusQueryVariables>;
export function useMembershipLaunchStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipLaunchStatusQuery, MembershipLaunchStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipLaunchStatusQuery, MembershipLaunchStatusQueryVariables>(MembershipLaunchStatusDocument, options);
        }
export type MembershipLaunchStatusQueryHookResult = ReturnType<typeof useMembershipLaunchStatusQuery>;
export type MembershipLaunchStatusLazyQueryHookResult = ReturnType<typeof useMembershipLaunchStatusLazyQuery>;
export type MembershipLaunchStatusSuspenseQueryHookResult = ReturnType<typeof useMembershipLaunchStatusSuspenseQuery>;
export type MembershipLaunchStatusQueryResult = Apollo.QueryResult<MembershipLaunchStatusQuery, MembershipLaunchStatusQueryVariables>;
export const OrganizationRenewalSchedulePreviewDocument = gql`
    query OrganizationRenewalSchedulePreview($organizationId: MongoID!, $kind: String!, $month: Int, $day: Int, $intent: String, $outlierTarget: String, $date: Date, $scope: String, $graceDays: Int, $neverExpire: Boolean) {
  organizationRenewalSchedulePreview(
    organizationId: $organizationId
    kind: $kind
    month: $month
    day: $day
    intent: $intent
    outlierTarget: $outlierTarget
    date: $date
    scope: $scope
    graceDays: $graceDays
    neverExpire: $neverExpire
  ) {
    ...RenewalRebasePlanFragment
  }
}
    ${RenewalRebasePlanFragmentFragmentDoc}`;

/**
 * __useOrganizationRenewalSchedulePreviewQuery__
 *
 * To run a query within a React component, call `useOrganizationRenewalSchedulePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRenewalSchedulePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRenewalSchedulePreviewQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      kind: // value for 'kind'
 *      month: // value for 'month'
 *      day: // value for 'day'
 *      intent: // value for 'intent'
 *      outlierTarget: // value for 'outlierTarget'
 *      date: // value for 'date'
 *      scope: // value for 'scope'
 *      graceDays: // value for 'graceDays'
 *      neverExpire: // value for 'neverExpire'
 *   },
 * });
 */
export function useOrganizationRenewalSchedulePreviewQuery(baseOptions: Apollo.QueryHookOptions<OrganizationRenewalSchedulePreviewQuery, OrganizationRenewalSchedulePreviewQueryVariables> & ({ variables: OrganizationRenewalSchedulePreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationRenewalSchedulePreviewQuery, OrganizationRenewalSchedulePreviewQueryVariables>(OrganizationRenewalSchedulePreviewDocument, options);
      }
export function useOrganizationRenewalSchedulePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationRenewalSchedulePreviewQuery, OrganizationRenewalSchedulePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationRenewalSchedulePreviewQuery, OrganizationRenewalSchedulePreviewQueryVariables>(OrganizationRenewalSchedulePreviewDocument, options);
        }
// @ts-ignore
export function useOrganizationRenewalSchedulePreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationRenewalSchedulePreviewQuery, OrganizationRenewalSchedulePreviewQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationRenewalSchedulePreviewQuery, OrganizationRenewalSchedulePreviewQueryVariables>;
export function useOrganizationRenewalSchedulePreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationRenewalSchedulePreviewQuery, OrganizationRenewalSchedulePreviewQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationRenewalSchedulePreviewQuery | undefined, OrganizationRenewalSchedulePreviewQueryVariables>;
export function useOrganizationRenewalSchedulePreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationRenewalSchedulePreviewQuery, OrganizationRenewalSchedulePreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationRenewalSchedulePreviewQuery, OrganizationRenewalSchedulePreviewQueryVariables>(OrganizationRenewalSchedulePreviewDocument, options);
        }
export type OrganizationRenewalSchedulePreviewQueryHookResult = ReturnType<typeof useOrganizationRenewalSchedulePreviewQuery>;
export type OrganizationRenewalSchedulePreviewLazyQueryHookResult = ReturnType<typeof useOrganizationRenewalSchedulePreviewLazyQuery>;
export type OrganizationRenewalSchedulePreviewSuspenseQueryHookResult = ReturnType<typeof useOrganizationRenewalSchedulePreviewSuspenseQuery>;
export type OrganizationRenewalSchedulePreviewQueryResult = Apollo.QueryResult<OrganizationRenewalSchedulePreviewQuery, OrganizationRenewalSchedulePreviewQueryVariables>;
export const MembershipListEmailCoverageDocument = gql`
    query MembershipListEmailCoverage($organizationId: MongoID!, $listId: MongoID!) {
  membershipListEmailCoverage(organizationId: $organizationId, listId: $listId) {
    total
    missing {
      entityId
      name
    }
  }
}
    `;

/**
 * __useMembershipListEmailCoverageQuery__
 *
 * To run a query within a React component, call `useMembershipListEmailCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipListEmailCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipListEmailCoverageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useMembershipListEmailCoverageQuery(baseOptions: Apollo.QueryHookOptions<MembershipListEmailCoverageQuery, MembershipListEmailCoverageQueryVariables> & ({ variables: MembershipListEmailCoverageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipListEmailCoverageQuery, MembershipListEmailCoverageQueryVariables>(MembershipListEmailCoverageDocument, options);
      }
export function useMembershipListEmailCoverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipListEmailCoverageQuery, MembershipListEmailCoverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipListEmailCoverageQuery, MembershipListEmailCoverageQueryVariables>(MembershipListEmailCoverageDocument, options);
        }
// @ts-ignore
export function useMembershipListEmailCoverageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembershipListEmailCoverageQuery, MembershipListEmailCoverageQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipListEmailCoverageQuery, MembershipListEmailCoverageQueryVariables>;
export function useMembershipListEmailCoverageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipListEmailCoverageQuery, MembershipListEmailCoverageQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipListEmailCoverageQuery | undefined, MembershipListEmailCoverageQueryVariables>;
export function useMembershipListEmailCoverageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipListEmailCoverageQuery, MembershipListEmailCoverageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipListEmailCoverageQuery, MembershipListEmailCoverageQueryVariables>(MembershipListEmailCoverageDocument, options);
        }
export type MembershipListEmailCoverageQueryHookResult = ReturnType<typeof useMembershipListEmailCoverageQuery>;
export type MembershipListEmailCoverageLazyQueryHookResult = ReturnType<typeof useMembershipListEmailCoverageLazyQuery>;
export type MembershipListEmailCoverageSuspenseQueryHookResult = ReturnType<typeof useMembershipListEmailCoverageSuspenseQuery>;
export type MembershipListEmailCoverageQueryResult = Apollo.QueryResult<MembershipListEmailCoverageQuery, MembershipListEmailCoverageQueryVariables>;
export const MembershipPaidUpByOperatorsDocument = gql`
    query MembershipPaidUpByOperators($organizationId: MongoID!, $operatorEntityIds: [MongoID!]!) {
  membershipPaidUpByOperators(
    organizationId: $organizationId
    operatorEntityIds: $operatorEntityIds
  ) {
    operatorEntityId
    manualRenewalDate
    currentPeriodEnd
    nextRenewalDate
    renewalPhase
    renewalDisplayDate
    renewalDay
  }
}
    `;

/**
 * __useMembershipPaidUpByOperatorsQuery__
 *
 * To run a query within a React component, call `useMembershipPaidUpByOperatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipPaidUpByOperatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipPaidUpByOperatorsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      operatorEntityIds: // value for 'operatorEntityIds'
 *   },
 * });
 */
export function useMembershipPaidUpByOperatorsQuery(baseOptions: Apollo.QueryHookOptions<MembershipPaidUpByOperatorsQuery, MembershipPaidUpByOperatorsQueryVariables> & ({ variables: MembershipPaidUpByOperatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipPaidUpByOperatorsQuery, MembershipPaidUpByOperatorsQueryVariables>(MembershipPaidUpByOperatorsDocument, options);
      }
export function useMembershipPaidUpByOperatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipPaidUpByOperatorsQuery, MembershipPaidUpByOperatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipPaidUpByOperatorsQuery, MembershipPaidUpByOperatorsQueryVariables>(MembershipPaidUpByOperatorsDocument, options);
        }
// @ts-ignore
export function useMembershipPaidUpByOperatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembershipPaidUpByOperatorsQuery, MembershipPaidUpByOperatorsQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipPaidUpByOperatorsQuery, MembershipPaidUpByOperatorsQueryVariables>;
export function useMembershipPaidUpByOperatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipPaidUpByOperatorsQuery, MembershipPaidUpByOperatorsQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipPaidUpByOperatorsQuery | undefined, MembershipPaidUpByOperatorsQueryVariables>;
export function useMembershipPaidUpByOperatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipPaidUpByOperatorsQuery, MembershipPaidUpByOperatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipPaidUpByOperatorsQuery, MembershipPaidUpByOperatorsQueryVariables>(MembershipPaidUpByOperatorsDocument, options);
        }
export type MembershipPaidUpByOperatorsQueryHookResult = ReturnType<typeof useMembershipPaidUpByOperatorsQuery>;
export type MembershipPaidUpByOperatorsLazyQueryHookResult = ReturnType<typeof useMembershipPaidUpByOperatorsLazyQuery>;
export type MembershipPaidUpByOperatorsSuspenseQueryHookResult = ReturnType<typeof useMembershipPaidUpByOperatorsSuspenseQuery>;
export type MembershipPaidUpByOperatorsQueryResult = Apollo.QueryResult<MembershipPaidUpByOperatorsQuery, MembershipPaidUpByOperatorsQueryVariables>;
export const MembershipRenewalAuditByOrganizationDocument = gql`
    query MembershipRenewalAuditByOrganization($organizationId: MongoID!) {
  membershipRenewalAuditByOrganization(organizationId: $organizationId) {
    organizationId
    organizationName
    renewalEngineEnabled
    counts {
      total
      paidUp
      renewalWindow
      expired
      unknown
      noPolicy
      tagDrift
    }
    discrepancies {
      membershipId
      subjectType
      entityId
      displayName
      personId
      kind
      phase
      paidThroughDate
      nextRenewalDate
      currentStatusTags {
        tagId
        name
      }
      suggestedAddTags {
        tagId
        name
      }
      suggestedRemoveTags {
        tagId
        name
      }
    }
  }
}
    `;

/**
 * __useMembershipRenewalAuditByOrganizationQuery__
 *
 * To run a query within a React component, call `useMembershipRenewalAuditByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipRenewalAuditByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipRenewalAuditByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembershipRenewalAuditByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<MembershipRenewalAuditByOrganizationQuery, MembershipRenewalAuditByOrganizationQueryVariables> & ({ variables: MembershipRenewalAuditByOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipRenewalAuditByOrganizationQuery, MembershipRenewalAuditByOrganizationQueryVariables>(MembershipRenewalAuditByOrganizationDocument, options);
      }
export function useMembershipRenewalAuditByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipRenewalAuditByOrganizationQuery, MembershipRenewalAuditByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipRenewalAuditByOrganizationQuery, MembershipRenewalAuditByOrganizationQueryVariables>(MembershipRenewalAuditByOrganizationDocument, options);
        }
// @ts-ignore
export function useMembershipRenewalAuditByOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembershipRenewalAuditByOrganizationQuery, MembershipRenewalAuditByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipRenewalAuditByOrganizationQuery, MembershipRenewalAuditByOrganizationQueryVariables>;
export function useMembershipRenewalAuditByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipRenewalAuditByOrganizationQuery, MembershipRenewalAuditByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipRenewalAuditByOrganizationQuery | undefined, MembershipRenewalAuditByOrganizationQueryVariables>;
export function useMembershipRenewalAuditByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipRenewalAuditByOrganizationQuery, MembershipRenewalAuditByOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipRenewalAuditByOrganizationQuery, MembershipRenewalAuditByOrganizationQueryVariables>(MembershipRenewalAuditByOrganizationDocument, options);
        }
export type MembershipRenewalAuditByOrganizationQueryHookResult = ReturnType<typeof useMembershipRenewalAuditByOrganizationQuery>;
export type MembershipRenewalAuditByOrganizationLazyQueryHookResult = ReturnType<typeof useMembershipRenewalAuditByOrganizationLazyQuery>;
export type MembershipRenewalAuditByOrganizationSuspenseQueryHookResult = ReturnType<typeof useMembershipRenewalAuditByOrganizationSuspenseQuery>;
export type MembershipRenewalAuditByOrganizationQueryResult = Apollo.QueryResult<MembershipRenewalAuditByOrganizationQuery, MembershipRenewalAuditByOrganizationQueryVariables>;
export const MembershipStatsByOrganizationDocument = gql`
    query MembershipStatsByOrganization($organizationId: ID!) {
  membershipStatsByOrganization(organizationId: $organizationId) {
    total
    byTier {
      tagId
      name
      count
    }
    byStatus {
      tagId
      name
      count
    }
  }
}
    `;

/**
 * __useMembershipStatsByOrganizationQuery__
 *
 * To run a query within a React component, call `useMembershipStatsByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipStatsByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipStatsByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembershipStatsByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<MembershipStatsByOrganizationQuery, MembershipStatsByOrganizationQueryVariables> & ({ variables: MembershipStatsByOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipStatsByOrganizationQuery, MembershipStatsByOrganizationQueryVariables>(MembershipStatsByOrganizationDocument, options);
      }
export function useMembershipStatsByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipStatsByOrganizationQuery, MembershipStatsByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipStatsByOrganizationQuery, MembershipStatsByOrganizationQueryVariables>(MembershipStatsByOrganizationDocument, options);
        }
// @ts-ignore
export function useMembershipStatsByOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembershipStatsByOrganizationQuery, MembershipStatsByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipStatsByOrganizationQuery, MembershipStatsByOrganizationQueryVariables>;
export function useMembershipStatsByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipStatsByOrganizationQuery, MembershipStatsByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipStatsByOrganizationQuery | undefined, MembershipStatsByOrganizationQueryVariables>;
export function useMembershipStatsByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipStatsByOrganizationQuery, MembershipStatsByOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipStatsByOrganizationQuery, MembershipStatsByOrganizationQueryVariables>(MembershipStatsByOrganizationDocument, options);
        }
export type MembershipStatsByOrganizationQueryHookResult = ReturnType<typeof useMembershipStatsByOrganizationQuery>;
export type MembershipStatsByOrganizationLazyQueryHookResult = ReturnType<typeof useMembershipStatsByOrganizationLazyQuery>;
export type MembershipStatsByOrganizationSuspenseQueryHookResult = ReturnType<typeof useMembershipStatsByOrganizationSuspenseQuery>;
export type MembershipStatsByOrganizationQueryResult = Apollo.QueryResult<MembershipStatsByOrganizationQuery, MembershipStatsByOrganizationQueryVariables>;
export const MembershipSuggestedRenewalDateDocument = gql`
    query MembershipSuggestedRenewalDate($subjectType: String!, $subjectEntityId: MongoID!, $organizationId: MongoID!) {
  membershipSuggestedRenewalDate(
    subjectType: $subjectType
    subjectEntityId: $subjectEntityId
    organizationId: $organizationId
  ) {
    suggestedDate
    isFreshGrant
    currentPaidThroughDate
    periodStart
    periodEnd
    blockedByInvoice {
      storefrontId
      paymentRequestId
      invoiceNumber
      amount
      currency
      dueDate
    }
  }
}
    `;

/**
 * __useMembershipSuggestedRenewalDateQuery__
 *
 * To run a query within a React component, call `useMembershipSuggestedRenewalDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipSuggestedRenewalDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipSuggestedRenewalDateQuery({
 *   variables: {
 *      subjectType: // value for 'subjectType'
 *      subjectEntityId: // value for 'subjectEntityId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembershipSuggestedRenewalDateQuery(baseOptions: Apollo.QueryHookOptions<MembershipSuggestedRenewalDateQuery, MembershipSuggestedRenewalDateQueryVariables> & ({ variables: MembershipSuggestedRenewalDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipSuggestedRenewalDateQuery, MembershipSuggestedRenewalDateQueryVariables>(MembershipSuggestedRenewalDateDocument, options);
      }
export function useMembershipSuggestedRenewalDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipSuggestedRenewalDateQuery, MembershipSuggestedRenewalDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipSuggestedRenewalDateQuery, MembershipSuggestedRenewalDateQueryVariables>(MembershipSuggestedRenewalDateDocument, options);
        }
// @ts-ignore
export function useMembershipSuggestedRenewalDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembershipSuggestedRenewalDateQuery, MembershipSuggestedRenewalDateQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipSuggestedRenewalDateQuery, MembershipSuggestedRenewalDateQueryVariables>;
export function useMembershipSuggestedRenewalDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipSuggestedRenewalDateQuery, MembershipSuggestedRenewalDateQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipSuggestedRenewalDateQuery | undefined, MembershipSuggestedRenewalDateQueryVariables>;
export function useMembershipSuggestedRenewalDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipSuggestedRenewalDateQuery, MembershipSuggestedRenewalDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipSuggestedRenewalDateQuery, MembershipSuggestedRenewalDateQueryVariables>(MembershipSuggestedRenewalDateDocument, options);
        }
export type MembershipSuggestedRenewalDateQueryHookResult = ReturnType<typeof useMembershipSuggestedRenewalDateQuery>;
export type MembershipSuggestedRenewalDateLazyQueryHookResult = ReturnType<typeof useMembershipSuggestedRenewalDateLazyQuery>;
export type MembershipSuggestedRenewalDateSuspenseQueryHookResult = ReturnType<typeof useMembershipSuggestedRenewalDateSuspenseQuery>;
export type MembershipSuggestedRenewalDateQueryResult = Apollo.QueryResult<MembershipSuggestedRenewalDateQuery, MembershipSuggestedRenewalDateQueryVariables>;
export const MembershipTimelineManyDocument = gql`
    query MembershipTimelineMany($subjectType: String!, $subjectEntityId: ID!, $organizationId: ID!) {
  membershipTimelineMany(
    subjectType: $subjectType
    subjectEntityId: $subjectEntityId
    organizationId: $organizationId
  ) {
    _id
    kind
    tagName
    viaSuffix
    actorName
    createdDateISO
  }
}
    `;

/**
 * __useMembershipTimelineManyQuery__
 *
 * To run a query within a React component, call `useMembershipTimelineManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipTimelineManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipTimelineManyQuery({
 *   variables: {
 *      subjectType: // value for 'subjectType'
 *      subjectEntityId: // value for 'subjectEntityId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembershipTimelineManyQuery(baseOptions: Apollo.QueryHookOptions<MembershipTimelineManyQuery, MembershipTimelineManyQueryVariables> & ({ variables: MembershipTimelineManyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipTimelineManyQuery, MembershipTimelineManyQueryVariables>(MembershipTimelineManyDocument, options);
      }
export function useMembershipTimelineManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipTimelineManyQuery, MembershipTimelineManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipTimelineManyQuery, MembershipTimelineManyQueryVariables>(MembershipTimelineManyDocument, options);
        }
// @ts-ignore
export function useMembershipTimelineManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembershipTimelineManyQuery, MembershipTimelineManyQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipTimelineManyQuery, MembershipTimelineManyQueryVariables>;
export function useMembershipTimelineManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipTimelineManyQuery, MembershipTimelineManyQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipTimelineManyQuery | undefined, MembershipTimelineManyQueryVariables>;
export function useMembershipTimelineManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipTimelineManyQuery, MembershipTimelineManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipTimelineManyQuery, MembershipTimelineManyQueryVariables>(MembershipTimelineManyDocument, options);
        }
export type MembershipTimelineManyQueryHookResult = ReturnType<typeof useMembershipTimelineManyQuery>;
export type MembershipTimelineManyLazyQueryHookResult = ReturnType<typeof useMembershipTimelineManyLazyQuery>;
export type MembershipTimelineManySuspenseQueryHookResult = ReturnType<typeof useMembershipTimelineManySuspenseQuery>;
export type MembershipTimelineManyQueryResult = Apollo.QueryResult<MembershipTimelineManyQuery, MembershipTimelineManyQueryVariables>;
export const NoteCountDocument = gql`
    query NoteCount($filter: FilterCountNoteInput) {
  noteCount(filter: $filter)
}
    `;

/**
 * __useNoteCountQuery__
 *
 * To run a query within a React component, call `useNoteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoteCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useNoteCountQuery(baseOptions?: Apollo.QueryHookOptions<NoteCountQuery, NoteCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoteCountQuery, NoteCountQueryVariables>(NoteCountDocument, options);
      }
export function useNoteCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoteCountQuery, NoteCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoteCountQuery, NoteCountQueryVariables>(NoteCountDocument, options);
        }
// @ts-ignore
export function useNoteCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NoteCountQuery, NoteCountQueryVariables>): Apollo.UseSuspenseQueryResult<NoteCountQuery, NoteCountQueryVariables>;
export function useNoteCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoteCountQuery, NoteCountQueryVariables>): Apollo.UseSuspenseQueryResult<NoteCountQuery | undefined, NoteCountQueryVariables>;
export function useNoteCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoteCountQuery, NoteCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NoteCountQuery, NoteCountQueryVariables>(NoteCountDocument, options);
        }
export type NoteCountQueryHookResult = ReturnType<typeof useNoteCountQuery>;
export type NoteCountLazyQueryHookResult = ReturnType<typeof useNoteCountLazyQuery>;
export type NoteCountSuspenseQueryHookResult = ReturnType<typeof useNoteCountSuspenseQuery>;
export type NoteCountQueryResult = Apollo.QueryResult<NoteCountQuery, NoteCountQueryVariables>;
export const NoteManyDocument = gql`
    query NoteMany($filter: FilterFindManyNoteInput, $sort: SortFindManyNoteInput, $limit: Int, $skip: Int) {
  noteMany(filter: $filter, sort: $sort, limit: $limit, skip: $skip) {
    ...NoteFramgment
  }
}
    ${NoteFramgmentFragmentDoc}`;

/**
 * __useNoteManyQuery__
 *
 * To run a query within a React component, call `useNoteManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoteManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useNoteManyQuery(baseOptions?: Apollo.QueryHookOptions<NoteManyQuery, NoteManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoteManyQuery, NoteManyQueryVariables>(NoteManyDocument, options);
      }
export function useNoteManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoteManyQuery, NoteManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoteManyQuery, NoteManyQueryVariables>(NoteManyDocument, options);
        }
// @ts-ignore
export function useNoteManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NoteManyQuery, NoteManyQueryVariables>): Apollo.UseSuspenseQueryResult<NoteManyQuery, NoteManyQueryVariables>;
export function useNoteManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoteManyQuery, NoteManyQueryVariables>): Apollo.UseSuspenseQueryResult<NoteManyQuery | undefined, NoteManyQueryVariables>;
export function useNoteManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoteManyQuery, NoteManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NoteManyQuery, NoteManyQueryVariables>(NoteManyDocument, options);
        }
export type NoteManyQueryHookResult = ReturnType<typeof useNoteManyQuery>;
export type NoteManyLazyQueryHookResult = ReturnType<typeof useNoteManyLazyQuery>;
export type NoteManySuspenseQueryHookResult = ReturnType<typeof useNoteManySuspenseQuery>;
export type NoteManyQueryResult = Apollo.QueryResult<NoteManyQuery, NoteManyQueryVariables>;
export const NotesForListingStaffDocument = gql`
    query NotesForListingStaff($operatorEntityId: ID!, $organizationId: ID!) {
  notesForListingStaff(
    operatorEntityId: $operatorEntityId
    organizationId: $organizationId
  ) {
    ...NoteFramgment
  }
}
    ${NoteFramgmentFragmentDoc}`;

/**
 * __useNotesForListingStaffQuery__
 *
 * To run a query within a React component, call `useNotesForListingStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesForListingStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesForListingStaffQuery({
 *   variables: {
 *      operatorEntityId: // value for 'operatorEntityId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useNotesForListingStaffQuery(baseOptions: Apollo.QueryHookOptions<NotesForListingStaffQuery, NotesForListingStaffQueryVariables> & ({ variables: NotesForListingStaffQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesForListingStaffQuery, NotesForListingStaffQueryVariables>(NotesForListingStaffDocument, options);
      }
export function useNotesForListingStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesForListingStaffQuery, NotesForListingStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesForListingStaffQuery, NotesForListingStaffQueryVariables>(NotesForListingStaffDocument, options);
        }
// @ts-ignore
export function useNotesForListingStaffSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotesForListingStaffQuery, NotesForListingStaffQueryVariables>): Apollo.UseSuspenseQueryResult<NotesForListingStaffQuery, NotesForListingStaffQueryVariables>;
export function useNotesForListingStaffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotesForListingStaffQuery, NotesForListingStaffQueryVariables>): Apollo.UseSuspenseQueryResult<NotesForListingStaffQuery | undefined, NotesForListingStaffQueryVariables>;
export function useNotesForListingStaffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotesForListingStaffQuery, NotesForListingStaffQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotesForListingStaffQuery, NotesForListingStaffQueryVariables>(NotesForListingStaffDocument, options);
        }
export type NotesForListingStaffQueryHookResult = ReturnType<typeof useNotesForListingStaffQuery>;
export type NotesForListingStaffLazyQueryHookResult = ReturnType<typeof useNotesForListingStaffLazyQuery>;
export type NotesForListingStaffSuspenseQueryHookResult = ReturnType<typeof useNotesForListingStaffSuspenseQuery>;
export type NotesForListingStaffQueryResult = Apollo.QueryResult<NotesForListingStaffQuery, NotesForListingStaffQueryVariables>;
export const OperatorByIdDocument = gql`
    query OperatorById($operatorId: ID!) {
  operatorById(operatorEntityId: $operatorId) {
    _entityId
    _versionId
    updatedDateISO
    name {
      ...MultilingualFragment
    }
    type
    claimed
    operationalStatus
    images {
      ...ImageFragment
    }
    tags {
      organizationSpecific {
        _id
        name {
          ...MultilingualFragment
        }
        owner {
          entityId
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
      global {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
      businessType {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
      amenity {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
    }
    description {
      ...MultilingualFragment
    }
    shortDescription {
      ...MultilingualFragment
    }
    pricing
    contact {
      ...ContactFragment
    }
    seasonality {
      jan
      feb
      mar
      apr
      may
      jun
      jul
      aug
      sep
      oct
      nov
      dec
    }
    hoursOfOperation {
      sun {
        start
        end
      }
      mon {
        start
        end
      }
      tue {
        start
        end
      }
      wed {
        start
        end
      }
      thu {
        start
        end
      }
      fri {
        start
        end
      }
      sat {
        start
        end
      }
    }
    accommodationMetadata {
      shortTermAccommodationLicense
    }
    status
    enrollments {
      organization {
        _id
        name {
          ...MultilingualFragment
        }
        logo {
          ...ImageFragment
        }
        contact {
          ...ContactFragment
        }
        metadata {
          disabledApps
          crowdriffEnabled
          membershipTiers
          individualMembershipTiers
          nomenclature {
            membership
          }
        }
      }
      organizationControlled
      onboardingStatus
    }
    connectedOrganization {
      _id
      name {
        ...MultilingualFragment
      }
      logo {
        ...ImageFragment
      }
    }
    enableMembershipLink
    externalVideoLinks {
      _id
      url
      service
    }
    crowdriffGalleryId
    whereabotDismissed {
      listingScan
      imageScan
    }
    staff {
      _id
      firstName
      lastName
      email
      status
      access {
        operators {
          entityId
          role
          status
          contactRoles
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${ContactFragmentFragmentDoc}`;

/**
 * __useOperatorByIdQuery__
 *
 * To run a query within a React component, call `useOperatorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorByIdQuery({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *   },
 * });
 */
export function useOperatorByIdQuery(baseOptions: Apollo.QueryHookOptions<OperatorByIdQuery, OperatorByIdQueryVariables> & ({ variables: OperatorByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorByIdQuery, OperatorByIdQueryVariables>(OperatorByIdDocument, options);
      }
export function useOperatorByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorByIdQuery, OperatorByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorByIdQuery, OperatorByIdQueryVariables>(OperatorByIdDocument, options);
        }
// @ts-ignore
export function useOperatorByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorByIdQuery, OperatorByIdQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorByIdQuery, OperatorByIdQueryVariables>;
export function useOperatorByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorByIdQuery, OperatorByIdQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorByIdQuery | undefined, OperatorByIdQueryVariables>;
export function useOperatorByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorByIdQuery, OperatorByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorByIdQuery, OperatorByIdQueryVariables>(OperatorByIdDocument, options);
        }
export type OperatorByIdQueryHookResult = ReturnType<typeof useOperatorByIdQuery>;
export type OperatorByIdLazyQueryHookResult = ReturnType<typeof useOperatorByIdLazyQuery>;
export type OperatorByIdSuspenseQueryHookResult = ReturnType<typeof useOperatorByIdSuspenseQuery>;
export type OperatorByIdQueryResult = Apollo.QueryResult<OperatorByIdQuery, OperatorByIdQueryVariables>;
export const OperatorEntityIdsByFilterDocument = gql`
    query OperatorEntityIdsByFilter($search: String, $organizationId: String, $businessType: EnumOperatorType, $tagIds: [String], $organizationIds: [String], $tagMode: String) {
  operatorEntityIdsByFilter(
    search: $search
    organizationId: $organizationId
    businessType: $businessType
    tagIds: $tagIds
    organizationIds: $organizationIds
    tagMode: $tagMode
  )
}
    `;

/**
 * __useOperatorEntityIdsByFilterQuery__
 *
 * To run a query within a React component, call `useOperatorEntityIdsByFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorEntityIdsByFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorEntityIdsByFilterQuery({
 *   variables: {
 *      search: // value for 'search'
 *      organizationId: // value for 'organizationId'
 *      businessType: // value for 'businessType'
 *      tagIds: // value for 'tagIds'
 *      organizationIds: // value for 'organizationIds'
 *      tagMode: // value for 'tagMode'
 *   },
 * });
 */
export function useOperatorEntityIdsByFilterQuery(baseOptions?: Apollo.QueryHookOptions<OperatorEntityIdsByFilterQuery, OperatorEntityIdsByFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorEntityIdsByFilterQuery, OperatorEntityIdsByFilterQueryVariables>(OperatorEntityIdsByFilterDocument, options);
      }
export function useOperatorEntityIdsByFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorEntityIdsByFilterQuery, OperatorEntityIdsByFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorEntityIdsByFilterQuery, OperatorEntityIdsByFilterQueryVariables>(OperatorEntityIdsByFilterDocument, options);
        }
// @ts-ignore
export function useOperatorEntityIdsByFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorEntityIdsByFilterQuery, OperatorEntityIdsByFilterQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorEntityIdsByFilterQuery, OperatorEntityIdsByFilterQueryVariables>;
export function useOperatorEntityIdsByFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorEntityIdsByFilterQuery, OperatorEntityIdsByFilterQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorEntityIdsByFilterQuery | undefined, OperatorEntityIdsByFilterQueryVariables>;
export function useOperatorEntityIdsByFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorEntityIdsByFilterQuery, OperatorEntityIdsByFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorEntityIdsByFilterQuery, OperatorEntityIdsByFilterQueryVariables>(OperatorEntityIdsByFilterDocument, options);
        }
export type OperatorEntityIdsByFilterQueryHookResult = ReturnType<typeof useOperatorEntityIdsByFilterQuery>;
export type OperatorEntityIdsByFilterLazyQueryHookResult = ReturnType<typeof useOperatorEntityIdsByFilterLazyQuery>;
export type OperatorEntityIdsByFilterSuspenseQueryHookResult = ReturnType<typeof useOperatorEntityIdsByFilterSuspenseQuery>;
export type OperatorEntityIdsByFilterQueryResult = Apollo.QueryResult<OperatorEntityIdsByFilterQuery, OperatorEntityIdsByFilterQueryVariables>;
export const OperatorInvoiceHeaderDocument = gql`
    query OperatorInvoiceHeader($operatorId: ID!) {
  operatorById(operatorEntityId: $operatorId) {
    _entityId
    name {
      ...MultilingualFragment
    }
    contact {
      ...ContactFragment
    }
    connectedOrganization {
      _id
      name {
        ...MultilingualFragment
      }
      logo {
        ...ImageFragment
      }
      contact {
        ...ContactFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ContactFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useOperatorInvoiceHeaderQuery__
 *
 * To run a query within a React component, call `useOperatorInvoiceHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorInvoiceHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorInvoiceHeaderQuery({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *   },
 * });
 */
export function useOperatorInvoiceHeaderQuery(baseOptions: Apollo.QueryHookOptions<OperatorInvoiceHeaderQuery, OperatorInvoiceHeaderQueryVariables> & ({ variables: OperatorInvoiceHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorInvoiceHeaderQuery, OperatorInvoiceHeaderQueryVariables>(OperatorInvoiceHeaderDocument, options);
      }
export function useOperatorInvoiceHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorInvoiceHeaderQuery, OperatorInvoiceHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorInvoiceHeaderQuery, OperatorInvoiceHeaderQueryVariables>(OperatorInvoiceHeaderDocument, options);
        }
// @ts-ignore
export function useOperatorInvoiceHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorInvoiceHeaderQuery, OperatorInvoiceHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorInvoiceHeaderQuery, OperatorInvoiceHeaderQueryVariables>;
export function useOperatorInvoiceHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorInvoiceHeaderQuery, OperatorInvoiceHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorInvoiceHeaderQuery | undefined, OperatorInvoiceHeaderQueryVariables>;
export function useOperatorInvoiceHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorInvoiceHeaderQuery, OperatorInvoiceHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorInvoiceHeaderQuery, OperatorInvoiceHeaderQueryVariables>(OperatorInvoiceHeaderDocument, options);
        }
export type OperatorInvoiceHeaderQueryHookResult = ReturnType<typeof useOperatorInvoiceHeaderQuery>;
export type OperatorInvoiceHeaderLazyQueryHookResult = ReturnType<typeof useOperatorInvoiceHeaderLazyQuery>;
export type OperatorInvoiceHeaderSuspenseQueryHookResult = ReturnType<typeof useOperatorInvoiceHeaderSuspenseQuery>;
export type OperatorInvoiceHeaderQueryResult = Apollo.QueryResult<OperatorInvoiceHeaderQuery, OperatorInvoiceHeaderQueryVariables>;
export const OperatorManyBillingContactSearchDocument = gql`
    query OperatorManyBillingContactSearch($organizationId: MongoID!, $search: String!, $limit: Int) {
  operatorManyBillingContactSearch(
    organizationId: $organizationId
    search: $search
    limit: $limit
  ) {
    _entityId
    name {
      ...MultilingualFragment
    }
    staffCount
    previewStaff {
      _id
      firstName
      lastName
      email
      isOwner
      contactRoles
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOperatorManyBillingContactSearchQuery__
 *
 * To run a query within a React component, call `useOperatorManyBillingContactSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorManyBillingContactSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorManyBillingContactSearchQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useOperatorManyBillingContactSearchQuery(baseOptions: Apollo.QueryHookOptions<OperatorManyBillingContactSearchQuery, OperatorManyBillingContactSearchQueryVariables> & ({ variables: OperatorManyBillingContactSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorManyBillingContactSearchQuery, OperatorManyBillingContactSearchQueryVariables>(OperatorManyBillingContactSearchDocument, options);
      }
export function useOperatorManyBillingContactSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorManyBillingContactSearchQuery, OperatorManyBillingContactSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorManyBillingContactSearchQuery, OperatorManyBillingContactSearchQueryVariables>(OperatorManyBillingContactSearchDocument, options);
        }
// @ts-ignore
export function useOperatorManyBillingContactSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorManyBillingContactSearchQuery, OperatorManyBillingContactSearchQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorManyBillingContactSearchQuery, OperatorManyBillingContactSearchQueryVariables>;
export function useOperatorManyBillingContactSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorManyBillingContactSearchQuery, OperatorManyBillingContactSearchQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorManyBillingContactSearchQuery | undefined, OperatorManyBillingContactSearchQueryVariables>;
export function useOperatorManyBillingContactSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorManyBillingContactSearchQuery, OperatorManyBillingContactSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorManyBillingContactSearchQuery, OperatorManyBillingContactSearchQueryVariables>(OperatorManyBillingContactSearchDocument, options);
        }
export type OperatorManyBillingContactSearchQueryHookResult = ReturnType<typeof useOperatorManyBillingContactSearchQuery>;
export type OperatorManyBillingContactSearchLazyQueryHookResult = ReturnType<typeof useOperatorManyBillingContactSearchLazyQuery>;
export type OperatorManyBillingContactSearchSuspenseQueryHookResult = ReturnType<typeof useOperatorManyBillingContactSearchSuspenseQuery>;
export type OperatorManyBillingContactSearchQueryResult = Apollo.QueryResult<OperatorManyBillingContactSearchQuery, OperatorManyBillingContactSearchQueryVariables>;
export const OperatorManyDirectoryCountDocument = gql`
    query OperatorManyDirectoryCount($organizationId: ID!, $publicationStatus: PublicationStatusType, $operationalStatus: [String], $search: String, $type: String, $claimed: Boolean, $organizationControlled: Boolean, $entityIds: [String]) {
  operatorManyDirectoryCount(
    organizationId: $organizationId
    publicationStatus: $publicationStatus
    operationalStatus: $operationalStatus
    search: $search
    type: $type
    claimed: $claimed
    organizationControlled: $organizationControlled
    entityIds: $entityIds
  )
}
    `;

/**
 * __useOperatorManyDirectoryCountQuery__
 *
 * To run a query within a React component, call `useOperatorManyDirectoryCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorManyDirectoryCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorManyDirectoryCountQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      publicationStatus: // value for 'publicationStatus'
 *      operationalStatus: // value for 'operationalStatus'
 *      search: // value for 'search'
 *      type: // value for 'type'
 *      claimed: // value for 'claimed'
 *      organizationControlled: // value for 'organizationControlled'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useOperatorManyDirectoryCountQuery(baseOptions: Apollo.QueryHookOptions<OperatorManyDirectoryCountQuery, OperatorManyDirectoryCountQueryVariables> & ({ variables: OperatorManyDirectoryCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorManyDirectoryCountQuery, OperatorManyDirectoryCountQueryVariables>(OperatorManyDirectoryCountDocument, options);
      }
export function useOperatorManyDirectoryCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorManyDirectoryCountQuery, OperatorManyDirectoryCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorManyDirectoryCountQuery, OperatorManyDirectoryCountQueryVariables>(OperatorManyDirectoryCountDocument, options);
        }
// @ts-ignore
export function useOperatorManyDirectoryCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorManyDirectoryCountQuery, OperatorManyDirectoryCountQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorManyDirectoryCountQuery, OperatorManyDirectoryCountQueryVariables>;
export function useOperatorManyDirectoryCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorManyDirectoryCountQuery, OperatorManyDirectoryCountQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorManyDirectoryCountQuery | undefined, OperatorManyDirectoryCountQueryVariables>;
export function useOperatorManyDirectoryCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorManyDirectoryCountQuery, OperatorManyDirectoryCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorManyDirectoryCountQuery, OperatorManyDirectoryCountQueryVariables>(OperatorManyDirectoryCountDocument, options);
        }
export type OperatorManyDirectoryCountQueryHookResult = ReturnType<typeof useOperatorManyDirectoryCountQuery>;
export type OperatorManyDirectoryCountLazyQueryHookResult = ReturnType<typeof useOperatorManyDirectoryCountLazyQuery>;
export type OperatorManyDirectoryCountSuspenseQueryHookResult = ReturnType<typeof useOperatorManyDirectoryCountSuspenseQuery>;
export type OperatorManyDirectoryCountQueryResult = Apollo.QueryResult<OperatorManyDirectoryCountQuery, OperatorManyDirectoryCountQueryVariables>;
export const OperatorManyInternalSearchDocument = gql`
    query OperatorManyInternalSearch($search: String, $excludeOrganizationId: ID) {
  operatorManyInternalSearch(
    search: $search
    excludeOrganizationId: $excludeOrganizationId
  ) {
    _entityId
    _versionId
    name {
      ...MultilingualFragment
    }
    contact {
      email
      address {
        ...AddressFragment
      }
    }
    status
    claimed
    connectedOrganization {
      _id
      name {
        ...MultilingualFragment
      }
      logo {
        ...ImageFragment
      }
    }
    enrollments {
      organization {
        _id
        name {
          ...MultilingualFragment
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useOperatorManyInternalSearchQuery__
 *
 * To run a query within a React component, call `useOperatorManyInternalSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorManyInternalSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorManyInternalSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      excludeOrganizationId: // value for 'excludeOrganizationId'
 *   },
 * });
 */
export function useOperatorManyInternalSearchQuery(baseOptions?: Apollo.QueryHookOptions<OperatorManyInternalSearchQuery, OperatorManyInternalSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorManyInternalSearchQuery, OperatorManyInternalSearchQueryVariables>(OperatorManyInternalSearchDocument, options);
      }
export function useOperatorManyInternalSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorManyInternalSearchQuery, OperatorManyInternalSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorManyInternalSearchQuery, OperatorManyInternalSearchQueryVariables>(OperatorManyInternalSearchDocument, options);
        }
// @ts-ignore
export function useOperatorManyInternalSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorManyInternalSearchQuery, OperatorManyInternalSearchQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorManyInternalSearchQuery, OperatorManyInternalSearchQueryVariables>;
export function useOperatorManyInternalSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorManyInternalSearchQuery, OperatorManyInternalSearchQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorManyInternalSearchQuery | undefined, OperatorManyInternalSearchQueryVariables>;
export function useOperatorManyInternalSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorManyInternalSearchQuery, OperatorManyInternalSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorManyInternalSearchQuery, OperatorManyInternalSearchQueryVariables>(OperatorManyInternalSearchDocument, options);
        }
export type OperatorManyInternalSearchQueryHookResult = ReturnType<typeof useOperatorManyInternalSearchQuery>;
export type OperatorManyInternalSearchLazyQueryHookResult = ReturnType<typeof useOperatorManyInternalSearchLazyQuery>;
export type OperatorManyInternalSearchSuspenseQueryHookResult = ReturnType<typeof useOperatorManyInternalSearchSuspenseQuery>;
export type OperatorManyInternalSearchQueryResult = Apollo.QueryResult<OperatorManyInternalSearchQuery, OperatorManyInternalSearchQueryVariables>;
export const OperatorManyWithOrganizationStatusesDocument = gql`
    query OperatorManyWithOrganizationStatuses($search: String, $organizationId: String, $businessType: EnumOperatorType, $tagIds: [String], $organizationIds: [String], $tagMode: String, $sort: OperatorManyWithOrganizationStatusesSortEnum, $limit: Int, $skip: Int) {
  operatorManyWithOrganizationStatuses(
    search: $search
    organizationId: $organizationId
    businessType: $businessType
    tagIds: $tagIds
    organizationIds: $organizationIds
    tagMode: $tagMode
    sort: $sort
    limit: $limit
    skip: $skip
  ) {
    _entityId
    _versionId
    name {
      ...MultilingualFragment
    }
    type
    operationalStatus
    organizations {
      _id
      name {
        ...MultilingualFragment
      }
      status
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOperatorManyWithOrganizationStatusesQuery__
 *
 * To run a query within a React component, call `useOperatorManyWithOrganizationStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorManyWithOrganizationStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorManyWithOrganizationStatusesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      organizationId: // value for 'organizationId'
 *      businessType: // value for 'businessType'
 *      tagIds: // value for 'tagIds'
 *      organizationIds: // value for 'organizationIds'
 *      tagMode: // value for 'tagMode'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useOperatorManyWithOrganizationStatusesQuery(baseOptions?: Apollo.QueryHookOptions<OperatorManyWithOrganizationStatusesQuery, OperatorManyWithOrganizationStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorManyWithOrganizationStatusesQuery, OperatorManyWithOrganizationStatusesQueryVariables>(OperatorManyWithOrganizationStatusesDocument, options);
      }
export function useOperatorManyWithOrganizationStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorManyWithOrganizationStatusesQuery, OperatorManyWithOrganizationStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorManyWithOrganizationStatusesQuery, OperatorManyWithOrganizationStatusesQueryVariables>(OperatorManyWithOrganizationStatusesDocument, options);
        }
// @ts-ignore
export function useOperatorManyWithOrganizationStatusesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorManyWithOrganizationStatusesQuery, OperatorManyWithOrganizationStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorManyWithOrganizationStatusesQuery, OperatorManyWithOrganizationStatusesQueryVariables>;
export function useOperatorManyWithOrganizationStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorManyWithOrganizationStatusesQuery, OperatorManyWithOrganizationStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorManyWithOrganizationStatusesQuery | undefined, OperatorManyWithOrganizationStatusesQueryVariables>;
export function useOperatorManyWithOrganizationStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorManyWithOrganizationStatusesQuery, OperatorManyWithOrganizationStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorManyWithOrganizationStatusesQuery, OperatorManyWithOrganizationStatusesQueryVariables>(OperatorManyWithOrganizationStatusesDocument, options);
        }
export type OperatorManyWithOrganizationStatusesQueryHookResult = ReturnType<typeof useOperatorManyWithOrganizationStatusesQuery>;
export type OperatorManyWithOrganizationStatusesLazyQueryHookResult = ReturnType<typeof useOperatorManyWithOrganizationStatusesLazyQuery>;
export type OperatorManyWithOrganizationStatusesSuspenseQueryHookResult = ReturnType<typeof useOperatorManyWithOrganizationStatusesSuspenseQuery>;
export type OperatorManyWithOrganizationStatusesQueryResult = Apollo.QueryResult<OperatorManyWithOrganizationStatusesQuery, OperatorManyWithOrganizationStatusesQueryVariables>;
export const OperatorWithOrganizationStatusesCountDocument = gql`
    query OperatorWithOrganizationStatusesCount($search: String, $organizationId: String, $businessType: EnumOperatorType, $tagIds: [String], $organizationIds: [String], $tagMode: String) {
  operatorWithOrganizationStatusesCount(
    search: $search
    organizationId: $organizationId
    businessType: $businessType
    tagIds: $tagIds
    organizationIds: $organizationIds
    tagMode: $tagMode
  )
}
    `;

/**
 * __useOperatorWithOrganizationStatusesCountQuery__
 *
 * To run a query within a React component, call `useOperatorWithOrganizationStatusesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorWithOrganizationStatusesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorWithOrganizationStatusesCountQuery({
 *   variables: {
 *      search: // value for 'search'
 *      organizationId: // value for 'organizationId'
 *      businessType: // value for 'businessType'
 *      tagIds: // value for 'tagIds'
 *      organizationIds: // value for 'organizationIds'
 *      tagMode: // value for 'tagMode'
 *   },
 * });
 */
export function useOperatorWithOrganizationStatusesCountQuery(baseOptions?: Apollo.QueryHookOptions<OperatorWithOrganizationStatusesCountQuery, OperatorWithOrganizationStatusesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorWithOrganizationStatusesCountQuery, OperatorWithOrganizationStatusesCountQueryVariables>(OperatorWithOrganizationStatusesCountDocument, options);
      }
export function useOperatorWithOrganizationStatusesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorWithOrganizationStatusesCountQuery, OperatorWithOrganizationStatusesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorWithOrganizationStatusesCountQuery, OperatorWithOrganizationStatusesCountQueryVariables>(OperatorWithOrganizationStatusesCountDocument, options);
        }
// @ts-ignore
export function useOperatorWithOrganizationStatusesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorWithOrganizationStatusesCountQuery, OperatorWithOrganizationStatusesCountQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorWithOrganizationStatusesCountQuery, OperatorWithOrganizationStatusesCountQueryVariables>;
export function useOperatorWithOrganizationStatusesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorWithOrganizationStatusesCountQuery, OperatorWithOrganizationStatusesCountQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorWithOrganizationStatusesCountQuery | undefined, OperatorWithOrganizationStatusesCountQueryVariables>;
export function useOperatorWithOrganizationStatusesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorWithOrganizationStatusesCountQuery, OperatorWithOrganizationStatusesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorWithOrganizationStatusesCountQuery, OperatorWithOrganizationStatusesCountQueryVariables>(OperatorWithOrganizationStatusesCountDocument, options);
        }
export type OperatorWithOrganizationStatusesCountQueryHookResult = ReturnType<typeof useOperatorWithOrganizationStatusesCountQuery>;
export type OperatorWithOrganizationStatusesCountLazyQueryHookResult = ReturnType<typeof useOperatorWithOrganizationStatusesCountLazyQuery>;
export type OperatorWithOrganizationStatusesCountSuspenseQueryHookResult = ReturnType<typeof useOperatorWithOrganizationStatusesCountSuspenseQuery>;
export type OperatorWithOrganizationStatusesCountQueryResult = Apollo.QueryResult<OperatorWithOrganizationStatusesCountQuery, OperatorWithOrganizationStatusesCountQueryVariables>;
export const OperatorNameByIdDocument = gql`
    query OperatorNameById($operatorEntityId: ID!) {
  operatorById(operatorEntityId: $operatorEntityId) {
    name {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOperatorNameByIdQuery__
 *
 * To run a query within a React component, call `useOperatorNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorNameByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorNameByIdQuery({
 *   variables: {
 *      operatorEntityId: // value for 'operatorEntityId'
 *   },
 * });
 */
export function useOperatorNameByIdQuery(baseOptions: Apollo.QueryHookOptions<OperatorNameByIdQuery, OperatorNameByIdQueryVariables> & ({ variables: OperatorNameByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorNameByIdQuery, OperatorNameByIdQueryVariables>(OperatorNameByIdDocument, options);
      }
export function useOperatorNameByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorNameByIdQuery, OperatorNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorNameByIdQuery, OperatorNameByIdQueryVariables>(OperatorNameByIdDocument, options);
        }
// @ts-ignore
export function useOperatorNameByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorNameByIdQuery, OperatorNameByIdQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorNameByIdQuery, OperatorNameByIdQueryVariables>;
export function useOperatorNameByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorNameByIdQuery, OperatorNameByIdQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorNameByIdQuery | undefined, OperatorNameByIdQueryVariables>;
export function useOperatorNameByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorNameByIdQuery, OperatorNameByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorNameByIdQuery, OperatorNameByIdQueryVariables>(OperatorNameByIdDocument, options);
        }
export type OperatorNameByIdQueryHookResult = ReturnType<typeof useOperatorNameByIdQuery>;
export type OperatorNameByIdLazyQueryHookResult = ReturnType<typeof useOperatorNameByIdLazyQuery>;
export type OperatorNameByIdSuspenseQueryHookResult = ReturnType<typeof useOperatorNameByIdSuspenseQuery>;
export type OperatorNameByIdQueryResult = Apollo.QueryResult<OperatorNameByIdQuery, OperatorNameByIdQueryVariables>;
export const OperatorStaffDocument = gql`
    query OperatorStaff($operatorId: ID!) {
  operatorStaff(operatorId: $operatorId) {
    ...UserWithPictureFragment
    email
  }
}
    ${UserWithPictureFragmentFragmentDoc}`;

/**
 * __useOperatorStaffQuery__
 *
 * To run a query within a React component, call `useOperatorStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorStaffQuery({
 *   variables: {
 *      operatorId: // value for 'operatorId'
 *   },
 * });
 */
export function useOperatorStaffQuery(baseOptions: Apollo.QueryHookOptions<OperatorStaffQuery, OperatorStaffQueryVariables> & ({ variables: OperatorStaffQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorStaffQuery, OperatorStaffQueryVariables>(OperatorStaffDocument, options);
      }
export function useOperatorStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorStaffQuery, OperatorStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorStaffQuery, OperatorStaffQueryVariables>(OperatorStaffDocument, options);
        }
// @ts-ignore
export function useOperatorStaffSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorStaffQuery, OperatorStaffQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorStaffQuery, OperatorStaffQueryVariables>;
export function useOperatorStaffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorStaffQuery, OperatorStaffQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorStaffQuery | undefined, OperatorStaffQueryVariables>;
export function useOperatorStaffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorStaffQuery, OperatorStaffQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorStaffQuery, OperatorStaffQueryVariables>(OperatorStaffDocument, options);
        }
export type OperatorStaffQueryHookResult = ReturnType<typeof useOperatorStaffQuery>;
export type OperatorStaffLazyQueryHookResult = ReturnType<typeof useOperatorStaffLazyQuery>;
export type OperatorStaffSuspenseQueryHookResult = ReturnType<typeof useOperatorStaffSuspenseQuery>;
export type OperatorStaffQueryResult = Apollo.QueryResult<OperatorStaffQuery, OperatorStaffQueryVariables>;
export const OperatorsByIdsDocument = gql`
    query OperatorsByIds($operatorEntityIds: [ID!], $status: PublicationStatusType) {
  operatorsByIds(operatorEntityIds: $operatorEntityIds, status: $status) {
    _entityId
    _versionId
    name {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    pricing
    type
    staff {
      email
      firstName
      lastName
      _id
    }
    contact {
      address {
        ...AddressFragment
      }
      phone
      email
      links {
        website
      }
    }
    status
    tags {
      organizationSpecific {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          key
          name {
            ...MultilingualFragment
          }
          type
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;

/**
 * __useOperatorsByIdsQuery__
 *
 * To run a query within a React component, call `useOperatorsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorsByIdsQuery({
 *   variables: {
 *      operatorEntityIds: // value for 'operatorEntityIds'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useOperatorsByIdsQuery(baseOptions?: Apollo.QueryHookOptions<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>(OperatorsByIdsDocument, options);
      }
export function useOperatorsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>(OperatorsByIdsDocument, options);
        }
// @ts-ignore
export function useOperatorsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>;
export function useOperatorsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorsByIdsQuery | undefined, OperatorsByIdsQueryVariables>;
export function useOperatorsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>(OperatorsByIdsDocument, options);
        }
export type OperatorsByIdsQueryHookResult = ReturnType<typeof useOperatorsByIdsQuery>;
export type OperatorsByIdsLazyQueryHookResult = ReturnType<typeof useOperatorsByIdsLazyQuery>;
export type OperatorsByIdsSuspenseQueryHookResult = ReturnType<typeof useOperatorsByIdsSuspenseQuery>;
export type OperatorsByIdsQueryResult = Apollo.QueryResult<OperatorsByIdsQuery, OperatorsByIdsQueryVariables>;
export const OperatorsByIdsEnrollmentsDocument = gql`
    query OperatorsByIdsEnrollments($operatorEntityIds: [ID!], $status: PublicationStatusType) {
  operatorsByIds(operatorEntityIds: $operatorEntityIds, status: $status) {
    _entityId
    _versionId
    enrollments {
      organization {
        _id
      }
    }
  }
}
    `;

/**
 * __useOperatorsByIdsEnrollmentsQuery__
 *
 * To run a query within a React component, call `useOperatorsByIdsEnrollmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorsByIdsEnrollmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorsByIdsEnrollmentsQuery({
 *   variables: {
 *      operatorEntityIds: // value for 'operatorEntityIds'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useOperatorsByIdsEnrollmentsQuery(baseOptions?: Apollo.QueryHookOptions<OperatorsByIdsEnrollmentsQuery, OperatorsByIdsEnrollmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorsByIdsEnrollmentsQuery, OperatorsByIdsEnrollmentsQueryVariables>(OperatorsByIdsEnrollmentsDocument, options);
      }
export function useOperatorsByIdsEnrollmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorsByIdsEnrollmentsQuery, OperatorsByIdsEnrollmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorsByIdsEnrollmentsQuery, OperatorsByIdsEnrollmentsQueryVariables>(OperatorsByIdsEnrollmentsDocument, options);
        }
// @ts-ignore
export function useOperatorsByIdsEnrollmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorsByIdsEnrollmentsQuery, OperatorsByIdsEnrollmentsQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorsByIdsEnrollmentsQuery, OperatorsByIdsEnrollmentsQueryVariables>;
export function useOperatorsByIdsEnrollmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsByIdsEnrollmentsQuery, OperatorsByIdsEnrollmentsQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorsByIdsEnrollmentsQuery | undefined, OperatorsByIdsEnrollmentsQueryVariables>;
export function useOperatorsByIdsEnrollmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsByIdsEnrollmentsQuery, OperatorsByIdsEnrollmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorsByIdsEnrollmentsQuery, OperatorsByIdsEnrollmentsQueryVariables>(OperatorsByIdsEnrollmentsDocument, options);
        }
export type OperatorsByIdsEnrollmentsQueryHookResult = ReturnType<typeof useOperatorsByIdsEnrollmentsQuery>;
export type OperatorsByIdsEnrollmentsLazyQueryHookResult = ReturnType<typeof useOperatorsByIdsEnrollmentsLazyQuery>;
export type OperatorsByIdsEnrollmentsSuspenseQueryHookResult = ReturnType<typeof useOperatorsByIdsEnrollmentsSuspenseQuery>;
export type OperatorsByIdsEnrollmentsQueryResult = Apollo.QueryResult<OperatorsByIdsEnrollmentsQuery, OperatorsByIdsEnrollmentsQueryVariables>;
export const OperatorsByIdsEventCreationDocument = gql`
    query OperatorsByIdsEventCreation($operatorEntityIds: [ID!], $status: PublicationStatusType) {
  operatorsByIds(operatorEntityIds: $operatorEntityIds, status: $status) {
    _entityId
    _versionId
    name {
      ...MultilingualFragment
    }
    enrollments {
      onboardingStatus
      organization {
        _id
      }
      organizationControlled
    }
    contact {
      email
      phone
      links {
        website
        instagram
        x
        bookNow
        youtube
        pinterest
        googleMyBusiness
        tiktok
        facebook
        tripAdvisor
      }
      address {
        ...AddressFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;

/**
 * __useOperatorsByIdsEventCreationQuery__
 *
 * To run a query within a React component, call `useOperatorsByIdsEventCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorsByIdsEventCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorsByIdsEventCreationQuery({
 *   variables: {
 *      operatorEntityIds: // value for 'operatorEntityIds'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useOperatorsByIdsEventCreationQuery(baseOptions?: Apollo.QueryHookOptions<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>(OperatorsByIdsEventCreationDocument, options);
      }
export function useOperatorsByIdsEventCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>(OperatorsByIdsEventCreationDocument, options);
        }
// @ts-ignore
export function useOperatorsByIdsEventCreationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>;
export function useOperatorsByIdsEventCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorsByIdsEventCreationQuery | undefined, OperatorsByIdsEventCreationQueryVariables>;
export function useOperatorsByIdsEventCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>(OperatorsByIdsEventCreationDocument, options);
        }
export type OperatorsByIdsEventCreationQueryHookResult = ReturnType<typeof useOperatorsByIdsEventCreationQuery>;
export type OperatorsByIdsEventCreationLazyQueryHookResult = ReturnType<typeof useOperatorsByIdsEventCreationLazyQuery>;
export type OperatorsByIdsEventCreationSuspenseQueryHookResult = ReturnType<typeof useOperatorsByIdsEventCreationSuspenseQuery>;
export type OperatorsByIdsEventCreationQueryResult = Apollo.QueryResult<OperatorsByIdsEventCreationQuery, OperatorsByIdsEventCreationQueryVariables>;
export const OperatorsByUserDocument = gql`
    query OperatorsByUser {
  operatorsByUser {
    _id
    _entityId
    _versionId
    claimed
    contact {
      address {
        ...AddressFragment
      }
    }
    enrollments {
      organization {
        _id
        name {
          ...MultilingualFragment
        }
        logo {
          ...ImageFragment
        }
        contact {
          links {
            website
          }
          email
        }
        metadata {
          internalOnly
          sandbox
          membershipBroadcastId
        }
      }
      organizationControlled
      onboardingStatus
    }
    name {
      ...MultilingualFragment
    }
    images {
      ...ImageFragment
    }
    connectedOrganization
  }
}
    ${AddressFragmentFragmentDoc}
${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useOperatorsByUserQuery__
 *
 * To run a query within a React component, call `useOperatorsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorsByUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useOperatorsByUserQuery(baseOptions?: Apollo.QueryHookOptions<OperatorsByUserQuery, OperatorsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorsByUserQuery, OperatorsByUserQueryVariables>(OperatorsByUserDocument, options);
      }
export function useOperatorsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorsByUserQuery, OperatorsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorsByUserQuery, OperatorsByUserQueryVariables>(OperatorsByUserDocument, options);
        }
// @ts-ignore
export function useOperatorsByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorsByUserQuery, OperatorsByUserQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorsByUserQuery, OperatorsByUserQueryVariables>;
export function useOperatorsByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsByUserQuery, OperatorsByUserQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorsByUserQuery | undefined, OperatorsByUserQueryVariables>;
export function useOperatorsByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsByUserQuery, OperatorsByUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorsByUserQuery, OperatorsByUserQueryVariables>(OperatorsByUserDocument, options);
        }
export type OperatorsByUserQueryHookResult = ReturnType<typeof useOperatorsByUserQuery>;
export type OperatorsByUserLazyQueryHookResult = ReturnType<typeof useOperatorsByUserLazyQuery>;
export type OperatorsByUserSuspenseQueryHookResult = ReturnType<typeof useOperatorsByUserSuspenseQuery>;
export type OperatorsByUserQueryResult = Apollo.QueryResult<OperatorsByUserQuery, OperatorsByUserQueryVariables>;
export const OperatorsCountDocument = gql`
    query OperatorsCount($organizationId: ID) {
  operatorsCount(organizationId: $organizationId)
}
    `;

/**
 * __useOperatorsCountQuery__
 *
 * To run a query within a React component, call `useOperatorsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorsCountQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOperatorsCountQuery(baseOptions?: Apollo.QueryHookOptions<OperatorsCountQuery, OperatorsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorsCountQuery, OperatorsCountQueryVariables>(OperatorsCountDocument, options);
      }
export function useOperatorsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorsCountQuery, OperatorsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorsCountQuery, OperatorsCountQueryVariables>(OperatorsCountDocument, options);
        }
// @ts-ignore
export function useOperatorsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorsCountQuery, OperatorsCountQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorsCountQuery, OperatorsCountQueryVariables>;
export function useOperatorsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsCountQuery, OperatorsCountQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorsCountQuery | undefined, OperatorsCountQueryVariables>;
export function useOperatorsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsCountQuery, OperatorsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorsCountQuery, OperatorsCountQueryVariables>(OperatorsCountDocument, options);
        }
export type OperatorsCountQueryHookResult = ReturnType<typeof useOperatorsCountQuery>;
export type OperatorsCountLazyQueryHookResult = ReturnType<typeof useOperatorsCountLazyQuery>;
export type OperatorsCountSuspenseQueryHookResult = ReturnType<typeof useOperatorsCountSuspenseQuery>;
export type OperatorsCountQueryResult = Apollo.QueryResult<OperatorsCountQuery, OperatorsCountQueryVariables>;
export const OperatorManyDocument = gql`
    query OperatorMany($filter: FilterFindManyOperatorInput, $avgImageQuality: [ImageQualityRating!], $publicationStatus: PublicationStatusType, $limit: Int, $skip: Int, $useCase: OperatorManyUseCaseEnum, $imageCount: NumberInput, $includeInvitedOrAcceptedStaffCounts: Boolean) {
  operatorMany(
    filter: $filter
    avgImageQuality: $avgImageQuality
    publicationStatus: $publicationStatus
    limit: $limit
    skip: $skip
    useCase: $useCase
    imageCount: $imageCount
    includeInvitedOrAcceptedStaffCounts: $includeInvitedOrAcceptedStaffCounts
  ) {
    _entityId
    _versionId
    updatedDateISO
    claimed
    name {
      ...MultilingualFragment
    }
    shortDescription {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    type
    operationalStatus
    images {
      ...ImageFragment
    }
    status
    iasc
    enrollments {
      onboardingStatus
      organization {
        _id
      }
      organizationControlled
    }
    contact {
      email
      address {
        ...AddressFragment
      }
    }
    hoursOfOperation {
      sun {
        ...DateRangeISOFragment
      }
      mon {
        ...DateRangeISOFragment
      }
      tue {
        ...DateRangeISOFragment
      }
      wed {
        ...DateRangeISOFragment
      }
      thu {
        ...DateRangeISOFragment
      }
      fri {
        ...DateRangeISOFragment
      }
      sat {
        ...DateRangeISOFragment
      }
    }
    pricing
    tags {
      organizationSpecific {
        _id
      }
    }
    selectedTagGroups {
      _id
      name {
        ...MultilingualFragment
      }
      key
      type
    }
    connectedOrganization {
      _id
      name {
        ...MultilingualFragment
      }
      logo {
        ...ImageFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${DateRangeIsoFragmentFragmentDoc}`;

/**
 * __useOperatorManyQuery__
 *
 * To run a query within a React component, call `useOperatorManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      avgImageQuality: // value for 'avgImageQuality'
 *      publicationStatus: // value for 'publicationStatus'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      useCase: // value for 'useCase'
 *      imageCount: // value for 'imageCount'
 *      includeInvitedOrAcceptedStaffCounts: // value for 'includeInvitedOrAcceptedStaffCounts'
 *   },
 * });
 */
export function useOperatorManyQuery(baseOptions?: Apollo.QueryHookOptions<OperatorManyQuery, OperatorManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorManyQuery, OperatorManyQueryVariables>(OperatorManyDocument, options);
      }
export function useOperatorManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorManyQuery, OperatorManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorManyQuery, OperatorManyQueryVariables>(OperatorManyDocument, options);
        }
// @ts-ignore
export function useOperatorManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorManyQuery, OperatorManyQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorManyQuery, OperatorManyQueryVariables>;
export function useOperatorManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorManyQuery, OperatorManyQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorManyQuery | undefined, OperatorManyQueryVariables>;
export function useOperatorManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorManyQuery, OperatorManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorManyQuery, OperatorManyQueryVariables>(OperatorManyDocument, options);
        }
export type OperatorManyQueryHookResult = ReturnType<typeof useOperatorManyQuery>;
export type OperatorManyLazyQueryHookResult = ReturnType<typeof useOperatorManyLazyQuery>;
export type OperatorManySuspenseQueryHookResult = ReturnType<typeof useOperatorManySuspenseQuery>;
export type OperatorManyQueryResult = Apollo.QueryResult<OperatorManyQuery, OperatorManyQueryVariables>;
export const OperatorManyDirectoryDocument = gql`
    query OperatorManyDirectory($filter: FilterFindManyOperatorInput, $avgImageQuality: [ImageQualityRating!], $publicationStatus: PublicationStatusType, $sort: SortFindManyOperatorInput, $limit: Int, $skip: Int, $useCase: OperatorManyUseCaseEnum, $imageCount: NumberInput, $includeInvitedOrAcceptedStaffCounts: Boolean) {
  operatorMany(
    filter: $filter
    avgImageQuality: $avgImageQuality
    publicationStatus: $publicationStatus
    sort: $sort
    limit: $limit
    skip: $skip
    useCase: $useCase
    imageCount: $imageCount
    includeInvitedOrAcceptedStaffCounts: $includeInvitedOrAcceptedStaffCounts
  ) {
    _entityId
    _versionId
    updatedDateISO
    claimed
    name {
      ...MultilingualFragment
    }
    type
    operationalStatus
    images(limit: 1) {
      ...ImageFragment
    }
    status
    iasc
    enrollments {
      organization {
        _id
        shortName
      }
      organizationControlled
      onboardingStatus
    }
    connectedOrganization {
      _id
      name {
        ...MultilingualFragment
      }
      logo {
        ...ImageFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useOperatorManyDirectoryQuery__
 *
 * To run a query within a React component, call `useOperatorManyDirectoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorManyDirectoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorManyDirectoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      avgImageQuality: // value for 'avgImageQuality'
 *      publicationStatus: // value for 'publicationStatus'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      useCase: // value for 'useCase'
 *      imageCount: // value for 'imageCount'
 *      includeInvitedOrAcceptedStaffCounts: // value for 'includeInvitedOrAcceptedStaffCounts'
 *   },
 * });
 */
export function useOperatorManyDirectoryQuery(baseOptions?: Apollo.QueryHookOptions<OperatorManyDirectoryQuery, OperatorManyDirectoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorManyDirectoryQuery, OperatorManyDirectoryQueryVariables>(OperatorManyDirectoryDocument, options);
      }
export function useOperatorManyDirectoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorManyDirectoryQuery, OperatorManyDirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorManyDirectoryQuery, OperatorManyDirectoryQueryVariables>(OperatorManyDirectoryDocument, options);
        }
// @ts-ignore
export function useOperatorManyDirectorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorManyDirectoryQuery, OperatorManyDirectoryQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorManyDirectoryQuery, OperatorManyDirectoryQueryVariables>;
export function useOperatorManyDirectorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorManyDirectoryQuery, OperatorManyDirectoryQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorManyDirectoryQuery | undefined, OperatorManyDirectoryQueryVariables>;
export function useOperatorManyDirectorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorManyDirectoryQuery, OperatorManyDirectoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorManyDirectoryQuery, OperatorManyDirectoryQueryVariables>(OperatorManyDirectoryDocument, options);
        }
export type OperatorManyDirectoryQueryHookResult = ReturnType<typeof useOperatorManyDirectoryQuery>;
export type OperatorManyDirectoryLazyQueryHookResult = ReturnType<typeof useOperatorManyDirectoryLazyQuery>;
export type OperatorManyDirectorySuspenseQueryHookResult = ReturnType<typeof useOperatorManyDirectorySuspenseQuery>;
export type OperatorManyDirectoryQueryResult = Apollo.QueryResult<OperatorManyDirectoryQuery, OperatorManyDirectoryQueryVariables>;
export const OperatorsManyEventCreationDocument = gql`
    query OperatorsManyEventCreation($filter: FilterFindManyOperatorInput, $avgImageQuality: [ImageQualityRating!], $publicationStatus: PublicationStatusType, $limit: Int, $skip: Int, $useCase: OperatorManyUseCaseEnum, $imageCount: NumberInput, $includeInvitedOrAcceptedStaffCounts: Boolean) {
  operatorMany(
    filter: $filter
    avgImageQuality: $avgImageQuality
    publicationStatus: $publicationStatus
    limit: $limit
    skip: $skip
    useCase: $useCase
    imageCount: $imageCount
    includeInvitedOrAcceptedStaffCounts: $includeInvitedOrAcceptedStaffCounts
  ) {
    _entityId
    _versionId
    name {
      ...MultilingualFragment
    }
    enrollments {
      organization {
        _id
      }
      onboardingStatus
    }
    contact {
      email
      phone
      links {
        website
      }
      address {
        ...AddressFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;

/**
 * __useOperatorsManyEventCreationQuery__
 *
 * To run a query within a React component, call `useOperatorsManyEventCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorsManyEventCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorsManyEventCreationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      avgImageQuality: // value for 'avgImageQuality'
 *      publicationStatus: // value for 'publicationStatus'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      useCase: // value for 'useCase'
 *      imageCount: // value for 'imageCount'
 *      includeInvitedOrAcceptedStaffCounts: // value for 'includeInvitedOrAcceptedStaffCounts'
 *   },
 * });
 */
export function useOperatorsManyEventCreationQuery(baseOptions?: Apollo.QueryHookOptions<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>(OperatorsManyEventCreationDocument, options);
      }
export function useOperatorsManyEventCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>(OperatorsManyEventCreationDocument, options);
        }
// @ts-ignore
export function useOperatorsManyEventCreationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>;
export function useOperatorsManyEventCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorsManyEventCreationQuery | undefined, OperatorsManyEventCreationQueryVariables>;
export function useOperatorsManyEventCreationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>(OperatorsManyEventCreationDocument, options);
        }
export type OperatorsManyEventCreationQueryHookResult = ReturnType<typeof useOperatorsManyEventCreationQuery>;
export type OperatorsManyEventCreationLazyQueryHookResult = ReturnType<typeof useOperatorsManyEventCreationLazyQuery>;
export type OperatorsManyEventCreationSuspenseQueryHookResult = ReturnType<typeof useOperatorsManyEventCreationSuspenseQuery>;
export type OperatorsManyEventCreationQueryResult = Apollo.QueryResult<OperatorsManyEventCreationQuery, OperatorsManyEventCreationQueryVariables>;
export const OperatorManyNamesDocument = gql`
    query OperatorManyNames($filter: FilterFindManyOperatorInput, $avgImageQuality: [ImageQualityRating!], $publicationStatus: PublicationStatusType, $limit: Int, $skip: Int, $useCase: OperatorManyUseCaseEnum, $imageCount: NumberInput, $includeInvitedOrAcceptedStaffCounts: Boolean) {
  operatorMany(
    filter: $filter
    avgImageQuality: $avgImageQuality
    publicationStatus: $publicationStatus
    limit: $limit
    skip: $skip
    useCase: $useCase
    imageCount: $imageCount
    includeInvitedOrAcceptedStaffCounts: $includeInvitedOrAcceptedStaffCounts
  ) {
    _entityId
    _versionId
    name {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOperatorManyNamesQuery__
 *
 * To run a query within a React component, call `useOperatorManyNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorManyNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorManyNamesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      avgImageQuality: // value for 'avgImageQuality'
 *      publicationStatus: // value for 'publicationStatus'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      useCase: // value for 'useCase'
 *      imageCount: // value for 'imageCount'
 *      includeInvitedOrAcceptedStaffCounts: // value for 'includeInvitedOrAcceptedStaffCounts'
 *   },
 * });
 */
export function useOperatorManyNamesQuery(baseOptions?: Apollo.QueryHookOptions<OperatorManyNamesQuery, OperatorManyNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorManyNamesQuery, OperatorManyNamesQueryVariables>(OperatorManyNamesDocument, options);
      }
export function useOperatorManyNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorManyNamesQuery, OperatorManyNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorManyNamesQuery, OperatorManyNamesQueryVariables>(OperatorManyNamesDocument, options);
        }
// @ts-ignore
export function useOperatorManyNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorManyNamesQuery, OperatorManyNamesQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorManyNamesQuery, OperatorManyNamesQueryVariables>;
export function useOperatorManyNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorManyNamesQuery, OperatorManyNamesQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorManyNamesQuery | undefined, OperatorManyNamesQueryVariables>;
export function useOperatorManyNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorManyNamesQuery, OperatorManyNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorManyNamesQuery, OperatorManyNamesQueryVariables>(OperatorManyNamesDocument, options);
        }
export type OperatorManyNamesQueryHookResult = ReturnType<typeof useOperatorManyNamesQuery>;
export type OperatorManyNamesLazyQueryHookResult = ReturnType<typeof useOperatorManyNamesLazyQuery>;
export type OperatorManyNamesSuspenseQueryHookResult = ReturnType<typeof useOperatorManyNamesSuspenseQuery>;
export type OperatorManyNamesQueryResult = Apollo.QueryResult<OperatorManyNamesQuery, OperatorManyNamesQueryVariables>;
export const OperatorsManyPersonConnectToListingDocument = gql`
    query OperatorsManyPersonConnectToListing($filter: FilterFindManyOperatorInput, $limit: Int, $skip: Int, $useCase: OperatorManyUseCaseEnum, $includeInvitedOrAcceptedStaffCounts: Boolean) {
  operatorMany(
    filter: $filter
    limit: $limit
    skip: $skip
    useCase: $useCase
    includeInvitedOrAcceptedStaffCounts: $includeInvitedOrAcceptedStaffCounts
  ) {
    _entityId
    name {
      ...MultilingualFragment
    }
    contact {
      address {
        ...AddressFragment
      }
    }
    connectedOrganization {
      _id
      name {
        ...MultilingualFragment
      }
      logo {
        ...ImageFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useOperatorsManyPersonConnectToListingQuery__
 *
 * To run a query within a React component, call `useOperatorsManyPersonConnectToListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperatorsManyPersonConnectToListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperatorsManyPersonConnectToListingQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      useCase: // value for 'useCase'
 *      includeInvitedOrAcceptedStaffCounts: // value for 'includeInvitedOrAcceptedStaffCounts'
 *   },
 * });
 */
export function useOperatorsManyPersonConnectToListingQuery(baseOptions?: Apollo.QueryHookOptions<OperatorsManyPersonConnectToListingQuery, OperatorsManyPersonConnectToListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperatorsManyPersonConnectToListingQuery, OperatorsManyPersonConnectToListingQueryVariables>(OperatorsManyPersonConnectToListingDocument, options);
      }
export function useOperatorsManyPersonConnectToListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperatorsManyPersonConnectToListingQuery, OperatorsManyPersonConnectToListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperatorsManyPersonConnectToListingQuery, OperatorsManyPersonConnectToListingQueryVariables>(OperatorsManyPersonConnectToListingDocument, options);
        }
// @ts-ignore
export function useOperatorsManyPersonConnectToListingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OperatorsManyPersonConnectToListingQuery, OperatorsManyPersonConnectToListingQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorsManyPersonConnectToListingQuery, OperatorsManyPersonConnectToListingQueryVariables>;
export function useOperatorsManyPersonConnectToListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsManyPersonConnectToListingQuery, OperatorsManyPersonConnectToListingQueryVariables>): Apollo.UseSuspenseQueryResult<OperatorsManyPersonConnectToListingQuery | undefined, OperatorsManyPersonConnectToListingQueryVariables>;
export function useOperatorsManyPersonConnectToListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OperatorsManyPersonConnectToListingQuery, OperatorsManyPersonConnectToListingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OperatorsManyPersonConnectToListingQuery, OperatorsManyPersonConnectToListingQueryVariables>(OperatorsManyPersonConnectToListingDocument, options);
        }
export type OperatorsManyPersonConnectToListingQueryHookResult = ReturnType<typeof useOperatorsManyPersonConnectToListingQuery>;
export type OperatorsManyPersonConnectToListingLazyQueryHookResult = ReturnType<typeof useOperatorsManyPersonConnectToListingLazyQuery>;
export type OperatorsManyPersonConnectToListingSuspenseQueryHookResult = ReturnType<typeof useOperatorsManyPersonConnectToListingSuspenseQuery>;
export type OperatorsManyPersonConnectToListingQueryResult = Apollo.QueryResult<OperatorsManyPersonConnectToListingQuery, OperatorsManyPersonConnectToListingQueryVariables>;
export const OrderByIdDocument = gql`
    query OrderById($id: String!) {
  orderById(_id: $id) {
    _id
    cancelled
    testMode
    approval {
      status
      requestedAt
      expiresAt
      messageFromGuest
      declineReason
      decidedAt
    }
    billing {
      timing
      consolidation
      serviceEndAt
      statementPeriod
      invoicePaymentRequestId
    }
    fulfillment {
      status
      note
      fulfilledAt
      carrier
      trackingNumber
    }
    delivery {
      method
      pickupLocationName
      pickupLocationAddress
      shippingAddress {
        ...AddressFragment
      }
      shippingZoneName
      shippingTotal
    }
    manualPaymentNote {
      note
      recordedAt
    }
    customer {
      _id
      email
      firstName
      lastName
      phone
      address {
        ...AddressFragment
      }
    }
    discounts {
      _id
      amount
      isActive
      name {
        en
        es
        fr
      }
      promoCode
      type
      unit
      excludeUpsells
      perTicket
    }
    guests {
      name
      email
    }
    purchasedProducts {
      _id
      tierId
      sessionIds
      merchVariantId
      customFieldResponses {
        fieldId
        label
        type
        isChoiceList
        response
      }
      guestsPerTier {
        count
        tierId
        sessionId
        sessionIds
      }
      inventoryClaims {
        _id
        claimedDateRangeISO {
          _id
          start
          end
          metadata
        }
      }
      product {
        _id
        type
        isUpsellOnly
        name {
          ...MultilingualFragment
        }
        owner {
          type
          entityId
        }
        images {
          ...ImageFragment
        }
        contact {
          useOwnerContact
          address {
            ...AddressFragment
          }
          email
          phone
          tollFreePublicPhone
        }
        pricing {
          description {
            ...MultilingualFragment
          }
          tiers {
            _id
            label {
              ...MultilingualFragment
            }
            price
            type
            priceType
            discountAmount
            discountUnit
          }
        }
        accommodationMetadata {
          checkIn
          checkOut
        }
        sellingConfig {
          options {
            _id
            name {
              ...MultilingualFragment
            }
          }
        }
        productTiers {
          _id
          name {
            ...MultilingualFragment
          }
          sessionScope
        }
        eventMetadata {
          event
          sessionGranularity
          ticketStructure
        }
        merchMetadata {
          dimensions {
            _id
            drivesImages
            name {
              ...MultilingualFragment
            }
            values {
              _id
              imageIds
              label {
                ...MultilingualFragment
              }
            }
          }
          variants {
            _id
            label
            sku
            dimensionValueIds
          }
        }
      }
      quantity
    }
    additionalLineItems {
      description
      amount
      quantity
    }
    pricingSnapshot {
      lineItems {
        productId
        tierId
        name {
          ...MultilingualFragment
        }
        unitPrice
        quantity
        amount
      }
    }
    source {
      type
      booker
      storefront
      operatorId
      businessName
      renewablePurchaseId
      renewalRecordId
      paymentRequestId
      customerInvoicePayment
    }
    stripeMetadata {
      chargeId
      customerId
      invoiceId
      invoiceStatus
      paymentMethodId
      connectedAccountId
      securityHoldPaymentIntentId
      securityHoldStatus
    }
    surveyResponse {
      responses {
        questionData {
          _id
          parentQuestion
          name {
            en
            es
            fr
          }
          type
          required
          options {
            isActive
            label {
              en
              es
              fr
            }
          }
        }
        response
      }
    }
    paymentMetadata {
      depositSettings {
        chargeBalanceDaysBeforeCheckIn
        enabled
        rate
        rateType
      }
    }
    taxExemption {
      claimed
      exemptionNumber
    }
    complimentaryAmount
    linkedPaymentRequest {
      _id
      version
      status
      accountingCode
      internalAccountingNotes
      externalReference
      accountingDate
    }
    createdDateISO
    updatedDateISO
  }
}
    ${AddressFragmentFragmentDoc}
${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useOrderByIdQuery__
 *
 * To run a query within a React component, call `useOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderByIdQuery(baseOptions: Apollo.QueryHookOptions<OrderByIdQuery, OrderByIdQueryVariables> & ({ variables: OrderByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderByIdQuery, OrderByIdQueryVariables>(OrderByIdDocument, options);
      }
export function useOrderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderByIdQuery, OrderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderByIdQuery, OrderByIdQueryVariables>(OrderByIdDocument, options);
        }
// @ts-ignore
export function useOrderByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderByIdQuery, OrderByIdQueryVariables>): Apollo.UseSuspenseQueryResult<OrderByIdQuery, OrderByIdQueryVariables>;
export function useOrderByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderByIdQuery, OrderByIdQueryVariables>): Apollo.UseSuspenseQueryResult<OrderByIdQuery | undefined, OrderByIdQueryVariables>;
export function useOrderByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderByIdQuery, OrderByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderByIdQuery, OrderByIdQueryVariables>(OrderByIdDocument, options);
        }
export type OrderByIdQueryHookResult = ReturnType<typeof useOrderByIdQuery>;
export type OrderByIdLazyQueryHookResult = ReturnType<typeof useOrderByIdLazyQuery>;
export type OrderByIdSuspenseQueryHookResult = ReturnType<typeof useOrderByIdSuspenseQuery>;
export type OrderByIdQueryResult = Apollo.QueryResult<OrderByIdQuery, OrderByIdQueryVariables>;
export const OrderManyDocument = gql`
    query OrderMany($filter: FilterFindManyOrderInput, $perPage: Int, $page: Int, $sort: SortFindManyOrderInput) {
  orderMany(filter: $filter, perPage: $perPage, page: $page, sort: $sort) {
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      cancelled
      testMode
      approval {
        status
        requestedAt
        expiresAt
        messageFromGuest
        declineReason
      }
      billing {
        timing
        consolidation
        serviceEndAt
        statementPeriod
        invoicePaymentRequestId
      }
      fulfillment {
        status
        note
        fulfilledAt
        carrier
        trackingNumber
      }
      delivery {
        method
      }
      purchasedProducts {
        product {
          _id
          name {
            ...MultilingualFragment
          }
          type
        }
        guestsPerTier {
          count
          tierId
        }
        quantity
        _id
        inventoryClaims {
          _id
          claimedDateRangeISO {
            _id
            end
            metadata
            start
          }
        }
      }
      source {
        type
        booker
        storefront
        renewablePurchaseId
        renewalRecordId
        renewalNextDate
        renewalStatus
      }
      customer {
        _id
        firstName
        lastName
        email
      }
      createdDateISO
      stripeMetadata {
        chargeId
        invoiceId
        invoiceStatus
        paymentMethodId
      }
      paymentMetadata {
        depositSettings {
          enabled
        }
      }
      linkedPaymentRequest {
        _id
        version
        status
        accountingCode
        internalAccountingNotes
        externalReference
        accountingDate
      }
    }
    count
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOrderManyQuery__
 *
 * To run a query within a React component, call `useOrderManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useOrderManyQuery(baseOptions?: Apollo.QueryHookOptions<OrderManyQuery, OrderManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderManyQuery, OrderManyQueryVariables>(OrderManyDocument, options);
      }
export function useOrderManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderManyQuery, OrderManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderManyQuery, OrderManyQueryVariables>(OrderManyDocument, options);
        }
// @ts-ignore
export function useOrderManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderManyQuery, OrderManyQueryVariables>): Apollo.UseSuspenseQueryResult<OrderManyQuery, OrderManyQueryVariables>;
export function useOrderManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderManyQuery, OrderManyQueryVariables>): Apollo.UseSuspenseQueryResult<OrderManyQuery | undefined, OrderManyQueryVariables>;
export function useOrderManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderManyQuery, OrderManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderManyQuery, OrderManyQueryVariables>(OrderManyDocument, options);
        }
export type OrderManyQueryHookResult = ReturnType<typeof useOrderManyQuery>;
export type OrderManyLazyQueryHookResult = ReturnType<typeof useOrderManyLazyQuery>;
export type OrderManySuspenseQueryHookResult = ReturnType<typeof useOrderManySuspenseQuery>;
export type OrderManyQueryResult = Apollo.QueryResult<OrderManyQuery, OrderManyQueryVariables>;
export const OrderManyIndexDocument = gql`
    query OrderManyIndex($filter: FilterFindManyOrderInput, $perPage: Int, $page: Int, $sort: SortFindManyOrderInput) {
  orderMany(filter: $filter, perPage: $perPage, page: $page, sort: $sort) {
    items {
      _id
      createdDateISO
      source {
        renewablePurchaseId
      }
    }
    count
  }
}
    `;

/**
 * __useOrderManyIndexQuery__
 *
 * To run a query within a React component, call `useOrderManyIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderManyIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderManyIndexQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useOrderManyIndexQuery(baseOptions?: Apollo.QueryHookOptions<OrderManyIndexQuery, OrderManyIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderManyIndexQuery, OrderManyIndexQueryVariables>(OrderManyIndexDocument, options);
      }
export function useOrderManyIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderManyIndexQuery, OrderManyIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderManyIndexQuery, OrderManyIndexQueryVariables>(OrderManyIndexDocument, options);
        }
// @ts-ignore
export function useOrderManyIndexSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderManyIndexQuery, OrderManyIndexQueryVariables>): Apollo.UseSuspenseQueryResult<OrderManyIndexQuery, OrderManyIndexQueryVariables>;
export function useOrderManyIndexSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderManyIndexQuery, OrderManyIndexQueryVariables>): Apollo.UseSuspenseQueryResult<OrderManyIndexQuery | undefined, OrderManyIndexQueryVariables>;
export function useOrderManyIndexSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderManyIndexQuery, OrderManyIndexQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderManyIndexQuery, OrderManyIndexQueryVariables>(OrderManyIndexDocument, options);
        }
export type OrderManyIndexQueryHookResult = ReturnType<typeof useOrderManyIndexQuery>;
export type OrderManyIndexLazyQueryHookResult = ReturnType<typeof useOrderManyIndexLazyQuery>;
export type OrderManyIndexSuspenseQueryHookResult = ReturnType<typeof useOrderManyIndexSuspenseQuery>;
export type OrderManyIndexQueryResult = Apollo.QueryResult<OrderManyIndexQuery, OrderManyIndexQueryVariables>;
export const OrderPricesByIdsDocument = gql`
    query OrderPricesByIds($orderIds: [String!]!) {
  orderPricesByIds(orderIds: $orderIds) {
    orderId
    prices {
      subTotal
      taxTotal
      grandTotal
      depositTotal
      discountTotal
    }
  }
}
    `;

/**
 * __useOrderPricesByIdsQuery__
 *
 * To run a query within a React component, call `useOrderPricesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderPricesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderPricesByIdsQuery({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *   },
 * });
 */
export function useOrderPricesByIdsQuery(baseOptions: Apollo.QueryHookOptions<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables> & ({ variables: OrderPricesByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables>(OrderPricesByIdsDocument, options);
      }
export function useOrderPricesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables>(OrderPricesByIdsDocument, options);
        }
// @ts-ignore
export function useOrderPricesByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables>;
export function useOrderPricesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<OrderPricesByIdsQuery | undefined, OrderPricesByIdsQueryVariables>;
export function useOrderPricesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables>(OrderPricesByIdsDocument, options);
        }
export type OrderPricesByIdsQueryHookResult = ReturnType<typeof useOrderPricesByIdsQuery>;
export type OrderPricesByIdsLazyQueryHookResult = ReturnType<typeof useOrderPricesByIdsLazyQuery>;
export type OrderPricesByIdsSuspenseQueryHookResult = ReturnType<typeof useOrderPricesByIdsSuspenseQuery>;
export type OrderPricesByIdsQueryResult = Apollo.QueryResult<OrderPricesByIdsQuery, OrderPricesByIdsQueryVariables>;
export const OrderPricesByIdDocument = gql`
    query OrderPricesById($orderId: String!) {
  orderPricesById(orderId: $orderId) {
    depositTotal
    discountTotal
    discountTotals {
      discountId
      total
    }
    grandTotal
    shippingTotal
    productPrices {
      price
      productId
    }
    subTotal
    taxTotal
    taxLines {
      name
      ratePercent
      amount
    }
    customerFee
  }
}
    `;

/**
 * __useOrderPricesByIdQuery__
 *
 * To run a query within a React component, call `useOrderPricesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderPricesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderPricesByIdQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderPricesByIdQuery(baseOptions: Apollo.QueryHookOptions<OrderPricesByIdQuery, OrderPricesByIdQueryVariables> & ({ variables: OrderPricesByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderPricesByIdQuery, OrderPricesByIdQueryVariables>(OrderPricesByIdDocument, options);
      }
export function useOrderPricesByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderPricesByIdQuery, OrderPricesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderPricesByIdQuery, OrderPricesByIdQueryVariables>(OrderPricesByIdDocument, options);
        }
// @ts-ignore
export function useOrderPricesByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderPricesByIdQuery, OrderPricesByIdQueryVariables>): Apollo.UseSuspenseQueryResult<OrderPricesByIdQuery, OrderPricesByIdQueryVariables>;
export function useOrderPricesByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderPricesByIdQuery, OrderPricesByIdQueryVariables>): Apollo.UseSuspenseQueryResult<OrderPricesByIdQuery | undefined, OrderPricesByIdQueryVariables>;
export function useOrderPricesByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderPricesByIdQuery, OrderPricesByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderPricesByIdQuery, OrderPricesByIdQueryVariables>(OrderPricesByIdDocument, options);
        }
export type OrderPricesByIdQueryHookResult = ReturnType<typeof useOrderPricesByIdQuery>;
export type OrderPricesByIdLazyQueryHookResult = ReturnType<typeof useOrderPricesByIdLazyQuery>;
export type OrderPricesByIdSuspenseQueryHookResult = ReturnType<typeof useOrderPricesByIdSuspenseQuery>;
export type OrderPricesByIdQueryResult = Apollo.QueryResult<OrderPricesByIdQuery, OrderPricesByIdQueryVariables>;
export const OrdersForBroadcastResourceDocument = gql`
    query OrdersForBroadcastResource($broadcastResourceId: String!, $personId: String!, $bookerId: String) {
  ordersForBroadcastResource(
    broadcastResourceId: $broadcastResourceId
    personId: $personId
    bookerId: $bookerId
  ) {
    _id
    cancelled
    createdDateISO
    stripeMetadata {
      chargeId
    }
    purchasedProducts {
      product {
        _id
        name {
          ...MultilingualFragment
        }
        type
      }
    }
    customer {
      _id
      firstName
      lastName
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOrdersForBroadcastResourceQuery__
 *
 * To run a query within a React component, call `useOrdersForBroadcastResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersForBroadcastResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersForBroadcastResourceQuery({
 *   variables: {
 *      broadcastResourceId: // value for 'broadcastResourceId'
 *      personId: // value for 'personId'
 *      bookerId: // value for 'bookerId'
 *   },
 * });
 */
export function useOrdersForBroadcastResourceQuery(baseOptions: Apollo.QueryHookOptions<OrdersForBroadcastResourceQuery, OrdersForBroadcastResourceQueryVariables> & ({ variables: OrdersForBroadcastResourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersForBroadcastResourceQuery, OrdersForBroadcastResourceQueryVariables>(OrdersForBroadcastResourceDocument, options);
      }
export function useOrdersForBroadcastResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersForBroadcastResourceQuery, OrdersForBroadcastResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersForBroadcastResourceQuery, OrdersForBroadcastResourceQueryVariables>(OrdersForBroadcastResourceDocument, options);
        }
// @ts-ignore
export function useOrdersForBroadcastResourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrdersForBroadcastResourceQuery, OrdersForBroadcastResourceQueryVariables>): Apollo.UseSuspenseQueryResult<OrdersForBroadcastResourceQuery, OrdersForBroadcastResourceQueryVariables>;
export function useOrdersForBroadcastResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrdersForBroadcastResourceQuery, OrdersForBroadcastResourceQueryVariables>): Apollo.UseSuspenseQueryResult<OrdersForBroadcastResourceQuery | undefined, OrdersForBroadcastResourceQueryVariables>;
export function useOrdersForBroadcastResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrdersForBroadcastResourceQuery, OrdersForBroadcastResourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrdersForBroadcastResourceQuery, OrdersForBroadcastResourceQueryVariables>(OrdersForBroadcastResourceDocument, options);
        }
export type OrdersForBroadcastResourceQueryHookResult = ReturnType<typeof useOrdersForBroadcastResourceQuery>;
export type OrdersForBroadcastResourceLazyQueryHookResult = ReturnType<typeof useOrdersForBroadcastResourceLazyQuery>;
export type OrdersForBroadcastResourceSuspenseQueryHookResult = ReturnType<typeof useOrdersForBroadcastResourceSuspenseQuery>;
export type OrdersForBroadcastResourceQueryResult = Apollo.QueryResult<OrdersForBroadcastResourceQuery, OrdersForBroadcastResourceQueryVariables>;
export const OrdersForCurrentUserDocument = gql`
    query OrdersForCurrentUser($teamOnly: Boolean!, $limit: Int, $skip: Int) {
  ordersForCurrentUser(teamOnly: $teamOnly, limit: $limit, skip: $skip) {
    _id
    cancelled
    createdDateISO
    stripeMetadata {
      chargeId
    }
    purchasedProducts {
      product {
        _id
        name {
          ...MultilingualFragment
        }
        type
      }
    }
    customer {
      _id
      firstName
      lastName
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOrdersForCurrentUserQuery__
 *
 * To run a query within a React component, call `useOrdersForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersForCurrentUserQuery({
 *   variables: {
 *      teamOnly: // value for 'teamOnly'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useOrdersForCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<OrdersForCurrentUserQuery, OrdersForCurrentUserQueryVariables> & ({ variables: OrdersForCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersForCurrentUserQuery, OrdersForCurrentUserQueryVariables>(OrdersForCurrentUserDocument, options);
      }
export function useOrdersForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersForCurrentUserQuery, OrdersForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersForCurrentUserQuery, OrdersForCurrentUserQueryVariables>(OrdersForCurrentUserDocument, options);
        }
// @ts-ignore
export function useOrdersForCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrdersForCurrentUserQuery, OrdersForCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<OrdersForCurrentUserQuery, OrdersForCurrentUserQueryVariables>;
export function useOrdersForCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrdersForCurrentUserQuery, OrdersForCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<OrdersForCurrentUserQuery | undefined, OrdersForCurrentUserQueryVariables>;
export function useOrdersForCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrdersForCurrentUserQuery, OrdersForCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrdersForCurrentUserQuery, OrdersForCurrentUserQueryVariables>(OrdersForCurrentUserDocument, options);
        }
export type OrdersForCurrentUserQueryHookResult = ReturnType<typeof useOrdersForCurrentUserQuery>;
export type OrdersForCurrentUserLazyQueryHookResult = ReturnType<typeof useOrdersForCurrentUserLazyQuery>;
export type OrdersForCurrentUserSuspenseQueryHookResult = ReturnType<typeof useOrdersForCurrentUserSuspenseQuery>;
export type OrdersForCurrentUserQueryResult = Apollo.QueryResult<OrdersForCurrentUserQuery, OrdersForCurrentUserQueryVariables>;
export const OrgOperatorOverlayFindOneDocument = gql`
    query OrgOperatorOverlayFindOne($organizationId: MongoID!, $operatorId: MongoID!) {
  orgOperatorOverlayFindOne(
    organizationId: $organizationId
    operatorId: $operatorId
  ) {
    ...OrgOperatorOverlayFragment
  }
}
    ${OrgOperatorOverlayFragmentFragmentDoc}`;

/**
 * __useOrgOperatorOverlayFindOneQuery__
 *
 * To run a query within a React component, call `useOrgOperatorOverlayFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgOperatorOverlayFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgOperatorOverlayFindOneQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      operatorId: // value for 'operatorId'
 *   },
 * });
 */
export function useOrgOperatorOverlayFindOneQuery(baseOptions: Apollo.QueryHookOptions<OrgOperatorOverlayFindOneQuery, OrgOperatorOverlayFindOneQueryVariables> & ({ variables: OrgOperatorOverlayFindOneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgOperatorOverlayFindOneQuery, OrgOperatorOverlayFindOneQueryVariables>(OrgOperatorOverlayFindOneDocument, options);
      }
export function useOrgOperatorOverlayFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgOperatorOverlayFindOneQuery, OrgOperatorOverlayFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgOperatorOverlayFindOneQuery, OrgOperatorOverlayFindOneQueryVariables>(OrgOperatorOverlayFindOneDocument, options);
        }
// @ts-ignore
export function useOrgOperatorOverlayFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgOperatorOverlayFindOneQuery, OrgOperatorOverlayFindOneQueryVariables>): Apollo.UseSuspenseQueryResult<OrgOperatorOverlayFindOneQuery, OrgOperatorOverlayFindOneQueryVariables>;
export function useOrgOperatorOverlayFindOneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgOperatorOverlayFindOneQuery, OrgOperatorOverlayFindOneQueryVariables>): Apollo.UseSuspenseQueryResult<OrgOperatorOverlayFindOneQuery | undefined, OrgOperatorOverlayFindOneQueryVariables>;
export function useOrgOperatorOverlayFindOneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgOperatorOverlayFindOneQuery, OrgOperatorOverlayFindOneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgOperatorOverlayFindOneQuery, OrgOperatorOverlayFindOneQueryVariables>(OrgOperatorOverlayFindOneDocument, options);
        }
export type OrgOperatorOverlayFindOneQueryHookResult = ReturnType<typeof useOrgOperatorOverlayFindOneQuery>;
export type OrgOperatorOverlayFindOneLazyQueryHookResult = ReturnType<typeof useOrgOperatorOverlayFindOneLazyQuery>;
export type OrgOperatorOverlayFindOneSuspenseQueryHookResult = ReturnType<typeof useOrgOperatorOverlayFindOneSuspenseQuery>;
export type OrgOperatorOverlayFindOneQueryResult = Apollo.QueryResult<OrgOperatorOverlayFindOneQuery, OrgOperatorOverlayFindOneQueryVariables>;
export const OrgOverviewByOrganizationDocument = gql`
    query OrgOverviewByOrganization($organizationId: ID!) {
  orgOverviewByOrganization(organizationId: $organizationId) {
    builtAt
    rows {
      _id
      entityType
      entityId
      name
      searchText
      status
      peopleCount
      primaryContactName
      financialContactName
      staffNames
      paidInvoiceTotal
      paidInvoiceCount
      paidInvoiceNumbers
      invoiceStorefrontId
      unpaidInvoiceTotal
      unpaidInvoiceCount
      unpaidInvoiceNumbers
      unpaidInvoiceStorefrontId
      membershipTierName
      membershipStatusNames
      membershipRenewalDate
      noteCount
      eventCount
      eventStartDate
      eventEndDate
      recurrenceType
      attendeeCount
      attendeeStorefrontId
      attendeeSessionDate
      attendeeSessionDateCount
      customTagNames
      primaryTag
    }
  }
}
    `;

/**
 * __useOrgOverviewByOrganizationQuery__
 *
 * To run a query within a React component, call `useOrgOverviewByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgOverviewByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgOverviewByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrgOverviewByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<OrgOverviewByOrganizationQuery, OrgOverviewByOrganizationQueryVariables> & ({ variables: OrgOverviewByOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgOverviewByOrganizationQuery, OrgOverviewByOrganizationQueryVariables>(OrgOverviewByOrganizationDocument, options);
      }
export function useOrgOverviewByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgOverviewByOrganizationQuery, OrgOverviewByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgOverviewByOrganizationQuery, OrgOverviewByOrganizationQueryVariables>(OrgOverviewByOrganizationDocument, options);
        }
// @ts-ignore
export function useOrgOverviewByOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgOverviewByOrganizationQuery, OrgOverviewByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<OrgOverviewByOrganizationQuery, OrgOverviewByOrganizationQueryVariables>;
export function useOrgOverviewByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgOverviewByOrganizationQuery, OrgOverviewByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<OrgOverviewByOrganizationQuery | undefined, OrgOverviewByOrganizationQueryVariables>;
export function useOrgOverviewByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgOverviewByOrganizationQuery, OrgOverviewByOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgOverviewByOrganizationQuery, OrgOverviewByOrganizationQueryVariables>(OrgOverviewByOrganizationDocument, options);
        }
export type OrgOverviewByOrganizationQueryHookResult = ReturnType<typeof useOrgOverviewByOrganizationQuery>;
export type OrgOverviewByOrganizationLazyQueryHookResult = ReturnType<typeof useOrgOverviewByOrganizationLazyQuery>;
export type OrgOverviewByOrganizationSuspenseQueryHookResult = ReturnType<typeof useOrgOverviewByOrganizationSuspenseQuery>;
export type OrgOverviewByOrganizationQueryResult = Apollo.QueryResult<OrgOverviewByOrganizationQuery, OrgOverviewByOrganizationQueryVariables>;
export const OrganizationAppSettingsWidgetsDocument = gql`
    query OrganizationAppSettingsWidgets($id: MongoID!) {
  organizationById(_id: $id) {
    _id
    logo {
      ...ImageFragment
    }
    appSettings {
      widgets {
        operator {
          hideTemporarilyClosed
          showPermanentlyClosed
          tieredSortOrder
          defaultImageMode
          defaultImageId
          customDefaultFallbackImage {
            ...ImageFragment
          }
          tierDisplayOverrides {
            tagId
            statusSortOrder
            teaser {
              hideImage
            }
            slideout {
              limitImages
              hideAddress
              hideLongDescription
              hideExternalLinks
              hideOperatingHours
              hideMap
            }
          }
          operatorWidgetFilter
          prioritizeClaimedAndDmoManaged
          audienceTagIds
          audienceTagFilters {
            tagId
            mode
          }
        }
        whatsNearby {
          audienceTagIds
          audienceTagFilters {
            tagId
            mode
          }
        }
        event {
          hideCancelledEvents
          organizerAudienceTagFilters {
            tagId
            mode
          }
          venueAudienceTagFilters {
            tagId
            mode
          }
        }
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useOrganizationAppSettingsWidgetsQuery__
 *
 * To run a query within a React component, call `useOrganizationAppSettingsWidgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationAppSettingsWidgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationAppSettingsWidgetsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationAppSettingsWidgetsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationAppSettingsWidgetsQuery, OrganizationAppSettingsWidgetsQueryVariables> & ({ variables: OrganizationAppSettingsWidgetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationAppSettingsWidgetsQuery, OrganizationAppSettingsWidgetsQueryVariables>(OrganizationAppSettingsWidgetsDocument, options);
      }
export function useOrganizationAppSettingsWidgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationAppSettingsWidgetsQuery, OrganizationAppSettingsWidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationAppSettingsWidgetsQuery, OrganizationAppSettingsWidgetsQueryVariables>(OrganizationAppSettingsWidgetsDocument, options);
        }
// @ts-ignore
export function useOrganizationAppSettingsWidgetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationAppSettingsWidgetsQuery, OrganizationAppSettingsWidgetsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationAppSettingsWidgetsQuery, OrganizationAppSettingsWidgetsQueryVariables>;
export function useOrganizationAppSettingsWidgetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationAppSettingsWidgetsQuery, OrganizationAppSettingsWidgetsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationAppSettingsWidgetsQuery | undefined, OrganizationAppSettingsWidgetsQueryVariables>;
export function useOrganizationAppSettingsWidgetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationAppSettingsWidgetsQuery, OrganizationAppSettingsWidgetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationAppSettingsWidgetsQuery, OrganizationAppSettingsWidgetsQueryVariables>(OrganizationAppSettingsWidgetsDocument, options);
        }
export type OrganizationAppSettingsWidgetsQueryHookResult = ReturnType<typeof useOrganizationAppSettingsWidgetsQuery>;
export type OrganizationAppSettingsWidgetsLazyQueryHookResult = ReturnType<typeof useOrganizationAppSettingsWidgetsLazyQuery>;
export type OrganizationAppSettingsWidgetsSuspenseQueryHookResult = ReturnType<typeof useOrganizationAppSettingsWidgetsSuspenseQuery>;
export type OrganizationAppSettingsWidgetsQueryResult = Apollo.QueryResult<OrganizationAppSettingsWidgetsQuery, OrganizationAppSettingsWidgetsQueryVariables>;
export const OrganizationByEventSharingCodeDocument = gql`
    query OrganizationByEventSharingCode($code: String!) {
  organizationByEventSharingCode(code: $code) {
    ...OrganizationPartnerSummaryFragment
  }
}
    ${OrganizationPartnerSummaryFragmentFragmentDoc}`;

/**
 * __useOrganizationByEventSharingCodeQuery__
 *
 * To run a query within a React component, call `useOrganizationByEventSharingCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationByEventSharingCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationByEventSharingCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useOrganizationByEventSharingCodeQuery(baseOptions: Apollo.QueryHookOptions<OrganizationByEventSharingCodeQuery, OrganizationByEventSharingCodeQueryVariables> & ({ variables: OrganizationByEventSharingCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationByEventSharingCodeQuery, OrganizationByEventSharingCodeQueryVariables>(OrganizationByEventSharingCodeDocument, options);
      }
export function useOrganizationByEventSharingCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationByEventSharingCodeQuery, OrganizationByEventSharingCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationByEventSharingCodeQuery, OrganizationByEventSharingCodeQueryVariables>(OrganizationByEventSharingCodeDocument, options);
        }
// @ts-ignore
export function useOrganizationByEventSharingCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationByEventSharingCodeQuery, OrganizationByEventSharingCodeQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationByEventSharingCodeQuery, OrganizationByEventSharingCodeQueryVariables>;
export function useOrganizationByEventSharingCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationByEventSharingCodeQuery, OrganizationByEventSharingCodeQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationByEventSharingCodeQuery | undefined, OrganizationByEventSharingCodeQueryVariables>;
export function useOrganizationByEventSharingCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationByEventSharingCodeQuery, OrganizationByEventSharingCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationByEventSharingCodeQuery, OrganizationByEventSharingCodeQueryVariables>(OrganizationByEventSharingCodeDocument, options);
        }
export type OrganizationByEventSharingCodeQueryHookResult = ReturnType<typeof useOrganizationByEventSharingCodeQuery>;
export type OrganizationByEventSharingCodeLazyQueryHookResult = ReturnType<typeof useOrganizationByEventSharingCodeLazyQuery>;
export type OrganizationByEventSharingCodeSuspenseQueryHookResult = ReturnType<typeof useOrganizationByEventSharingCodeSuspenseQuery>;
export type OrganizationByEventSharingCodeQueryResult = Apollo.QueryResult<OrganizationByEventSharingCodeQuery, OrganizationByEventSharingCodeQueryVariables>;
export const OrganizationByIdDocument = gql`
    query OrganizationById($id: MongoID!) {
  organizationById(_id: $id) {
    _id
    name {
      ...MultilingualFragment
    }
    shortName
    description {
      ...MultilingualFragment
    }
    shortDescription {
      ...MultilingualFragment
    }
    contact {
      ...ContactFragment
    }
    logo {
      ...ImageFragment
    }
    images {
      ...ImageFragment
    }
    onboardingMetadata {
      videoId
      introMessage
      allowColdSignup
      typeformSurveyId
      comingSoonMessage
    }
    brandColors
    emailBranding {
      fromName
      replyTo
      accentColor
      showContact
      footerText {
        en
        fr
        es
      }
    }
    metadata {
      inviteWhenAddingStaff
      eventLookaheadMonths
      disabledApps
      connectedStorefront
      connectedTestStorefront
      storefrontOrgConnectionsEnabled
      storefrontMode
      connectedUsdStorefront
      connectedUsdTestStorefront
      internalOnly
      sandbox
      connectedOperator
      canEnableMembershipLink
      membershipPageUrl
      crowdriffEnabled
      externalVideoEnabled
      membershipTiers
      individualMembershipTiers
      membershipStatusTagIds
      listingAudienceTagIds
      nomenclature {
        membership
        member
        members
      }
      listingFreshnessEnabled
      dmoListingStaleDays
      claimedListingStaleDays
      operatorOnboardingDisabled
      whereabotListingUpdatePrompt
      whereabotImageDownloadPrompt
      customClaimEmailSubject
      customClaimEmailBody
      customPingEmailSubject
      customPingEmailBody
      renewalSettings {
        enabled
        renewalType
        fixedRenewalMonth
        fixedRenewalDay
        proRateEnabled
        term
        termYears
        pendingStatusTagId
        activeStatusTagId
        expiredStatusTagId
        clearStatusTagsOnExpiration
        engineOwnedTags
        renewalGraceDays
        neverExpireMembers
        overdueStatusTagId
        cancelledStatusTagId
        sendRenewalEmails
        sendExpirationEmails
        sendSuccessEmails
        sendOverdueEmails
        sendCancelledEmails
        automaticRenewalEmails
        emailCooldownDays
        renewalReminderLeadDays
        instructionsEmail {
          subject
          body
          ctaLabel
        }
        expiredEmail {
          subject
          body
          ctaLabel
        }
        successEmail {
          subject
          body
          ctaLabel
        }
        overdueEmail {
          subject
          body
          ctaLabel
        }
        cancelledEmail {
          subject
          body
          ctaLabel
        }
        tierReminderEmails {
          tierTagId
          subject
          body
          hideRenewalDateLine
          ctaLabel
        }
      }
      membershipTierCheckouts {
        tierTagId
        bookerId
        free
      }
      membershipPaymentsEnabled
      timezone
    }
    license {
      activatedDate
      activatedBy {
        _id
        firstName
        lastName
        email
      }
      isActive
    }
    domains
    subdomain
  }
}
    ${MultilingualFragmentFragmentDoc}
${ContactFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useOrganizationByIdQuery__
 *
 * To run a query within a React component, call `useOrganizationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationByIdQuery(baseOptions: Apollo.QueryHookOptions<OrganizationByIdQuery, OrganizationByIdQueryVariables> & ({ variables: OrganizationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationByIdQuery, OrganizationByIdQueryVariables>(OrganizationByIdDocument, options);
      }
export function useOrganizationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationByIdQuery, OrganizationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationByIdQuery, OrganizationByIdQueryVariables>(OrganizationByIdDocument, options);
        }
// @ts-ignore
export function useOrganizationByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationByIdQuery, OrganizationByIdQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationByIdQuery, OrganizationByIdQueryVariables>;
export function useOrganizationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationByIdQuery, OrganizationByIdQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationByIdQuery | undefined, OrganizationByIdQueryVariables>;
export function useOrganizationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationByIdQuery, OrganizationByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationByIdQuery, OrganizationByIdQueryVariables>(OrganizationByIdDocument, options);
        }
export type OrganizationByIdQueryHookResult = ReturnType<typeof useOrganizationByIdQuery>;
export type OrganizationByIdLazyQueryHookResult = ReturnType<typeof useOrganizationByIdLazyQuery>;
export type OrganizationByIdSuspenseQueryHookResult = ReturnType<typeof useOrganizationByIdSuspenseQuery>;
export type OrganizationByIdQueryResult = Apollo.QueryResult<OrganizationByIdQuery, OrganizationByIdQueryVariables>;
export const OrganizationCountDocument = gql`
    query OrganizationCount($filter: FilterCountOrganizationInput) {
  organizationCount(filter: $filter)
}
    `;

/**
 * __useOrganizationCountQuery__
 *
 * To run a query within a React component, call `useOrganizationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrganizationCountQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationCountQuery, OrganizationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationCountQuery, OrganizationCountQueryVariables>(OrganizationCountDocument, options);
      }
export function useOrganizationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationCountQuery, OrganizationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationCountQuery, OrganizationCountQueryVariables>(OrganizationCountDocument, options);
        }
// @ts-ignore
export function useOrganizationCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationCountQuery, OrganizationCountQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationCountQuery, OrganizationCountQueryVariables>;
export function useOrganizationCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationCountQuery, OrganizationCountQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationCountQuery | undefined, OrganizationCountQueryVariables>;
export function useOrganizationCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationCountQuery, OrganizationCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationCountQuery, OrganizationCountQueryVariables>(OrganizationCountDocument, options);
        }
export type OrganizationCountQueryHookResult = ReturnType<typeof useOrganizationCountQuery>;
export type OrganizationCountLazyQueryHookResult = ReturnType<typeof useOrganizationCountLazyQuery>;
export type OrganizationCountSuspenseQueryHookResult = ReturnType<typeof useOrganizationCountSuspenseQuery>;
export type OrganizationCountQueryResult = Apollo.QueryResult<OrganizationCountQuery, OrganizationCountQueryVariables>;
export const OrganizationEmailDomainAdminByOrganizationDocument = gql`
    query OrganizationEmailDomainAdminByOrganization($organizationId: ID!) {
  organizationEmailDomainAdminByOrganization(organizationId: $organizationId) {
    _id
    fromAddress
    domain
    status
    previousStatus
    sendgridDomainId
    internalNote
    allowNonProductionSending
    requestedBy
    requestedAt
    activatedAt
    lastValidatedAt
    disabledAt
    dnsRecords {
      mailCname {
        valid
        type
        host
        data
      }
      dkim1 {
        valid
        type
        host
        data
      }
      dkim2 {
        valid
        type
        host
        data
      }
    }
    validationResults {
      mailCname {
        valid
        reason
      }
      dkim1 {
        valid
        reason
      }
      dkim2 {
        valid
        reason
      }
      spf {
        valid
        reason
      }
    }
  }
}
    `;

/**
 * __useOrganizationEmailDomainAdminByOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationEmailDomainAdminByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEmailDomainAdminByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationEmailDomainAdminByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationEmailDomainAdminByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<OrganizationEmailDomainAdminByOrganizationQuery, OrganizationEmailDomainAdminByOrganizationQueryVariables> & ({ variables: OrganizationEmailDomainAdminByOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationEmailDomainAdminByOrganizationQuery, OrganizationEmailDomainAdminByOrganizationQueryVariables>(OrganizationEmailDomainAdminByOrganizationDocument, options);
      }
export function useOrganizationEmailDomainAdminByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationEmailDomainAdminByOrganizationQuery, OrganizationEmailDomainAdminByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationEmailDomainAdminByOrganizationQuery, OrganizationEmailDomainAdminByOrganizationQueryVariables>(OrganizationEmailDomainAdminByOrganizationDocument, options);
        }
// @ts-ignore
export function useOrganizationEmailDomainAdminByOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationEmailDomainAdminByOrganizationQuery, OrganizationEmailDomainAdminByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationEmailDomainAdminByOrganizationQuery, OrganizationEmailDomainAdminByOrganizationQueryVariables>;
export function useOrganizationEmailDomainAdminByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationEmailDomainAdminByOrganizationQuery, OrganizationEmailDomainAdminByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationEmailDomainAdminByOrganizationQuery | undefined, OrganizationEmailDomainAdminByOrganizationQueryVariables>;
export function useOrganizationEmailDomainAdminByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationEmailDomainAdminByOrganizationQuery, OrganizationEmailDomainAdminByOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationEmailDomainAdminByOrganizationQuery, OrganizationEmailDomainAdminByOrganizationQueryVariables>(OrganizationEmailDomainAdminByOrganizationDocument, options);
        }
export type OrganizationEmailDomainAdminByOrganizationQueryHookResult = ReturnType<typeof useOrganizationEmailDomainAdminByOrganizationQuery>;
export type OrganizationEmailDomainAdminByOrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationEmailDomainAdminByOrganizationLazyQuery>;
export type OrganizationEmailDomainAdminByOrganizationSuspenseQueryHookResult = ReturnType<typeof useOrganizationEmailDomainAdminByOrganizationSuspenseQuery>;
export type OrganizationEmailDomainAdminByOrganizationQueryResult = Apollo.QueryResult<OrganizationEmailDomainAdminByOrganizationQuery, OrganizationEmailDomainAdminByOrganizationQueryVariables>;
export const OrganizationEmailDomainByOrganizationDocument = gql`
    query OrganizationEmailDomainByOrganization($organizationId: ID!) {
  organizationEmailDomainByOrganization(organizationId: $organizationId) {
    _id
    fromAddress
    domain
    status
    requestedAt
    activatedAt
    lastValidatedAt
    disabledAt
    dnsRecords {
      mailCname {
        valid
        type
        host
        data
      }
      dkim1 {
        valid
        type
        host
        data
      }
      dkim2 {
        valid
        type
        host
        data
      }
    }
    validationResults {
      mailCname {
        valid
        reason
      }
      dkim1 {
        valid
        reason
      }
      dkim2 {
        valid
        reason
      }
      spf {
        valid
        reason
      }
    }
  }
}
    `;

/**
 * __useOrganizationEmailDomainByOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationEmailDomainByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEmailDomainByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationEmailDomainByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationEmailDomainByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<OrganizationEmailDomainByOrganizationQuery, OrganizationEmailDomainByOrganizationQueryVariables> & ({ variables: OrganizationEmailDomainByOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationEmailDomainByOrganizationQuery, OrganizationEmailDomainByOrganizationQueryVariables>(OrganizationEmailDomainByOrganizationDocument, options);
      }
export function useOrganizationEmailDomainByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationEmailDomainByOrganizationQuery, OrganizationEmailDomainByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationEmailDomainByOrganizationQuery, OrganizationEmailDomainByOrganizationQueryVariables>(OrganizationEmailDomainByOrganizationDocument, options);
        }
// @ts-ignore
export function useOrganizationEmailDomainByOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationEmailDomainByOrganizationQuery, OrganizationEmailDomainByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationEmailDomainByOrganizationQuery, OrganizationEmailDomainByOrganizationQueryVariables>;
export function useOrganizationEmailDomainByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationEmailDomainByOrganizationQuery, OrganizationEmailDomainByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationEmailDomainByOrganizationQuery | undefined, OrganizationEmailDomainByOrganizationQueryVariables>;
export function useOrganizationEmailDomainByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationEmailDomainByOrganizationQuery, OrganizationEmailDomainByOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationEmailDomainByOrganizationQuery, OrganizationEmailDomainByOrganizationQueryVariables>(OrganizationEmailDomainByOrganizationDocument, options);
        }
export type OrganizationEmailDomainByOrganizationQueryHookResult = ReturnType<typeof useOrganizationEmailDomainByOrganizationQuery>;
export type OrganizationEmailDomainByOrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationEmailDomainByOrganizationLazyQuery>;
export type OrganizationEmailDomainByOrganizationSuspenseQueryHookResult = ReturnType<typeof useOrganizationEmailDomainByOrganizationSuspenseQuery>;
export type OrganizationEmailDomainByOrganizationQueryResult = Apollo.QueryResult<OrganizationEmailDomainByOrganizationQuery, OrganizationEmailDomainByOrganizationQueryVariables>;
export const OrganizationEventPartnerSettingsDocument = gql`
    query OrganizationEventPartnerSettings {
  organizationEventPartnerSettings {
    ...OrganizationEventPartnerSettingsFragment
  }
}
    ${OrganizationEventPartnerSettingsFragmentFragmentDoc}`;

/**
 * __useOrganizationEventPartnerSettingsQuery__
 *
 * To run a query within a React component, call `useOrganizationEventPartnerSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEventPartnerSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationEventPartnerSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationEventPartnerSettingsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationEventPartnerSettingsQuery, OrganizationEventPartnerSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationEventPartnerSettingsQuery, OrganizationEventPartnerSettingsQueryVariables>(OrganizationEventPartnerSettingsDocument, options);
      }
export function useOrganizationEventPartnerSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationEventPartnerSettingsQuery, OrganizationEventPartnerSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationEventPartnerSettingsQuery, OrganizationEventPartnerSettingsQueryVariables>(OrganizationEventPartnerSettingsDocument, options);
        }
// @ts-ignore
export function useOrganizationEventPartnerSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationEventPartnerSettingsQuery, OrganizationEventPartnerSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationEventPartnerSettingsQuery, OrganizationEventPartnerSettingsQueryVariables>;
export function useOrganizationEventPartnerSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationEventPartnerSettingsQuery, OrganizationEventPartnerSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationEventPartnerSettingsQuery | undefined, OrganizationEventPartnerSettingsQueryVariables>;
export function useOrganizationEventPartnerSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationEventPartnerSettingsQuery, OrganizationEventPartnerSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationEventPartnerSettingsQuery, OrganizationEventPartnerSettingsQueryVariables>(OrganizationEventPartnerSettingsDocument, options);
        }
export type OrganizationEventPartnerSettingsQueryHookResult = ReturnType<typeof useOrganizationEventPartnerSettingsQuery>;
export type OrganizationEventPartnerSettingsLazyQueryHookResult = ReturnType<typeof useOrganizationEventPartnerSettingsLazyQuery>;
export type OrganizationEventPartnerSettingsSuspenseQueryHookResult = ReturnType<typeof useOrganizationEventPartnerSettingsSuspenseQuery>;
export type OrganizationEventPartnerSettingsQueryResult = Apollo.QueryResult<OrganizationEventPartnerSettingsQuery, OrganizationEventPartnerSettingsQueryVariables>;
export const OrganizationEventWidgetSettingsDocument = gql`
    query OrganizationEventWidgetSettings {
  organizationEventWidgetSettings {
    hideCancelledEvents
  }
}
    `;

/**
 * __useOrganizationEventWidgetSettingsQuery__
 *
 * To run a query within a React component, call `useOrganizationEventWidgetSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEventWidgetSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationEventWidgetSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationEventWidgetSettingsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationEventWidgetSettingsQuery, OrganizationEventWidgetSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationEventWidgetSettingsQuery, OrganizationEventWidgetSettingsQueryVariables>(OrganizationEventWidgetSettingsDocument, options);
      }
export function useOrganizationEventWidgetSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationEventWidgetSettingsQuery, OrganizationEventWidgetSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationEventWidgetSettingsQuery, OrganizationEventWidgetSettingsQueryVariables>(OrganizationEventWidgetSettingsDocument, options);
        }
// @ts-ignore
export function useOrganizationEventWidgetSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationEventWidgetSettingsQuery, OrganizationEventWidgetSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationEventWidgetSettingsQuery, OrganizationEventWidgetSettingsQueryVariables>;
export function useOrganizationEventWidgetSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationEventWidgetSettingsQuery, OrganizationEventWidgetSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationEventWidgetSettingsQuery | undefined, OrganizationEventWidgetSettingsQueryVariables>;
export function useOrganizationEventWidgetSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationEventWidgetSettingsQuery, OrganizationEventWidgetSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationEventWidgetSettingsQuery, OrganizationEventWidgetSettingsQueryVariables>(OrganizationEventWidgetSettingsDocument, options);
        }
export type OrganizationEventWidgetSettingsQueryHookResult = ReturnType<typeof useOrganizationEventWidgetSettingsQuery>;
export type OrganizationEventWidgetSettingsLazyQueryHookResult = ReturnType<typeof useOrganizationEventWidgetSettingsLazyQuery>;
export type OrganizationEventWidgetSettingsSuspenseQueryHookResult = ReturnType<typeof useOrganizationEventWidgetSettingsSuspenseQuery>;
export type OrganizationEventWidgetSettingsQueryResult = Apollo.QueryResult<OrganizationEventWidgetSettingsQuery, OrganizationEventWidgetSettingsQueryVariables>;
export const OrganizationLogoByIdDocument = gql`
    query OrganizationLogoById($id: MongoID!) {
  organizationById(_id: $id) {
    logo {
      ...ImageFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useOrganizationLogoByIdQuery__
 *
 * To run a query within a React component, call `useOrganizationLogoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationLogoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationLogoByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationLogoByIdQuery(baseOptions: Apollo.QueryHookOptions<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables> & ({ variables: OrganizationLogoByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables>(OrganizationLogoByIdDocument, options);
      }
export function useOrganizationLogoByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables>(OrganizationLogoByIdDocument, options);
        }
// @ts-ignore
export function useOrganizationLogoByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables>;
export function useOrganizationLogoByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationLogoByIdQuery | undefined, OrganizationLogoByIdQueryVariables>;
export function useOrganizationLogoByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables>(OrganizationLogoByIdDocument, options);
        }
export type OrganizationLogoByIdQueryHookResult = ReturnType<typeof useOrganizationLogoByIdQuery>;
export type OrganizationLogoByIdLazyQueryHookResult = ReturnType<typeof useOrganizationLogoByIdLazyQuery>;
export type OrganizationLogoByIdSuspenseQueryHookResult = ReturnType<typeof useOrganizationLogoByIdSuspenseQuery>;
export type OrganizationLogoByIdQueryResult = Apollo.QueryResult<OrganizationLogoByIdQuery, OrganizationLogoByIdQueryVariables>;
export const OrganizationManifestByOrganizationIdDocument = gql`
    query OrganizationManifestByOrganizationId($filter: FilterFindOneOrganizationManifestInput!) {
  organizationManifestByOrganizationId(filter: $filter) {
    _id
    organizationId
    generatedAt
    generatedBy
    assetCounts {
      people {
        total
        toDisconnect
        toDelete
      }
      operators {
        total
        toDisconnect
        toDelete
      }
      widgets
      lists
      customTags
      notes
      events
      broadcasts
      images
      users
      activityLogs
      imports
      importRuns
    }
    assets {
      people {
        _id
        action
        name
        entityId
      }
      operators {
        _id
        action
        name
        entityId
      }
      widgets {
        _id
        action
        name
      }
      lists {
        _id
        action
        name
      }
      customTags {
        _id
        action
        name
      }
      notes {
        _id
        action
        name
      }
      events {
        _id
        action
        name
      }
      broadcasts {
        _id
        action
        name
      }
      images {
        _id
        action
        name
      }
      activityLogs {
        _id
        action
        name
      }
      imports {
        _id
        action
        name
      }
      importRuns {
        _id
        action
        name
      }
    }
    deletionLog {
      completedAt
      completedBy
      results {
        people {
          disconnected
          deleted
          errors
        }
        operators {
          disconnected
          deleted
          errors
        }
        widgets {
          deleted
          errors
        }
        lists {
          deleted
          errors
        }
        notes {
          deleted
          errors
        }
        events {
          deleted
          errors
        }
        broadcasts {
          deleted
          errors
        }
        images {
          deleted
          errors
        }
        activityLogs {
          deleted
          errors
        }
        imports {
          deleted
          errors
        }
        importRuns {
          deleted
          errors
        }
      }
      deletionErrors {
        type
        message
        assetId
      }
    }
    manifestErrors {
      type
      message
      assetId
    }
  }
}
    `;

/**
 * __useOrganizationManifestByOrganizationIdQuery__
 *
 * To run a query within a React component, call `useOrganizationManifestByOrganizationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationManifestByOrganizationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationManifestByOrganizationIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrganizationManifestByOrganizationIdQuery(baseOptions: Apollo.QueryHookOptions<OrganizationManifestByOrganizationIdQuery, OrganizationManifestByOrganizationIdQueryVariables> & ({ variables: OrganizationManifestByOrganizationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationManifestByOrganizationIdQuery, OrganizationManifestByOrganizationIdQueryVariables>(OrganizationManifestByOrganizationIdDocument, options);
      }
export function useOrganizationManifestByOrganizationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationManifestByOrganizationIdQuery, OrganizationManifestByOrganizationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationManifestByOrganizationIdQuery, OrganizationManifestByOrganizationIdQueryVariables>(OrganizationManifestByOrganizationIdDocument, options);
        }
// @ts-ignore
export function useOrganizationManifestByOrganizationIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationManifestByOrganizationIdQuery, OrganizationManifestByOrganizationIdQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationManifestByOrganizationIdQuery, OrganizationManifestByOrganizationIdQueryVariables>;
export function useOrganizationManifestByOrganizationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationManifestByOrganizationIdQuery, OrganizationManifestByOrganizationIdQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationManifestByOrganizationIdQuery | undefined, OrganizationManifestByOrganizationIdQueryVariables>;
export function useOrganizationManifestByOrganizationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationManifestByOrganizationIdQuery, OrganizationManifestByOrganizationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationManifestByOrganizationIdQuery, OrganizationManifestByOrganizationIdQueryVariables>(OrganizationManifestByOrganizationIdDocument, options);
        }
export type OrganizationManifestByOrganizationIdQueryHookResult = ReturnType<typeof useOrganizationManifestByOrganizationIdQuery>;
export type OrganizationManifestByOrganizationIdLazyQueryHookResult = ReturnType<typeof useOrganizationManifestByOrganizationIdLazyQuery>;
export type OrganizationManifestByOrganizationIdSuspenseQueryHookResult = ReturnType<typeof useOrganizationManifestByOrganizationIdSuspenseQuery>;
export type OrganizationManifestByOrganizationIdQueryResult = Apollo.QueryResult<OrganizationManifestByOrganizationIdQuery, OrganizationManifestByOrganizationIdQueryVariables>;
export const OrganizationManyDocument = gql`
    query OrganizationMany($filter: FilterFindManyOrganizationInput, $limit: Int, $skip: Int) {
  organizationMany(filter: $filter, limit: $limit, skip: $skip) {
    _id
    name {
      ...MultilingualFragment
    }
    logo {
      ...ImageFragment
    }
    metadata {
      sandbox
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useOrganizationManyQuery__
 *
 * To run a query within a React component, call `useOrganizationManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useOrganizationManyQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationManyQuery, OrganizationManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationManyQuery, OrganizationManyQueryVariables>(OrganizationManyDocument, options);
      }
export function useOrganizationManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationManyQuery, OrganizationManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationManyQuery, OrganizationManyQueryVariables>(OrganizationManyDocument, options);
        }
// @ts-ignore
export function useOrganizationManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationManyQuery, OrganizationManyQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationManyQuery, OrganizationManyQueryVariables>;
export function useOrganizationManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationManyQuery, OrganizationManyQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationManyQuery | undefined, OrganizationManyQueryVariables>;
export function useOrganizationManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationManyQuery, OrganizationManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationManyQuery, OrganizationManyQueryVariables>(OrganizationManyDocument, options);
        }
export type OrganizationManyQueryHookResult = ReturnType<typeof useOrganizationManyQuery>;
export type OrganizationManyLazyQueryHookResult = ReturnType<typeof useOrganizationManyLazyQuery>;
export type OrganizationManySuspenseQueryHookResult = ReturnType<typeof useOrganizationManySuspenseQuery>;
export type OrganizationManyQueryResult = Apollo.QueryResult<OrganizationManyQuery, OrganizationManyQueryVariables>;
export const OrganizationMembershipHubSettingsDocument = gql`
    query OrganizationMembershipHubSettings($id: MongoID!) {
  organizationById(_id: $id) {
    _id
    metadata {
      membershipBroadcastId
      membershipHub {
        hideOfferFromForYou
        tiers {
          tierTagId
          description {
            ...MultilingualFragment
          }
          applicationBroadcastId
          applicationResourceId
          hideFromNewcomers
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOrganizationMembershipHubSettingsQuery__
 *
 * To run a query within a React component, call `useOrganizationMembershipHubSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMembershipHubSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMembershipHubSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationMembershipHubSettingsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationMembershipHubSettingsQuery, OrganizationMembershipHubSettingsQueryVariables> & ({ variables: OrganizationMembershipHubSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationMembershipHubSettingsQuery, OrganizationMembershipHubSettingsQueryVariables>(OrganizationMembershipHubSettingsDocument, options);
      }
export function useOrganizationMembershipHubSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationMembershipHubSettingsQuery, OrganizationMembershipHubSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationMembershipHubSettingsQuery, OrganizationMembershipHubSettingsQueryVariables>(OrganizationMembershipHubSettingsDocument, options);
        }
// @ts-ignore
export function useOrganizationMembershipHubSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationMembershipHubSettingsQuery, OrganizationMembershipHubSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationMembershipHubSettingsQuery, OrganizationMembershipHubSettingsQueryVariables>;
export function useOrganizationMembershipHubSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationMembershipHubSettingsQuery, OrganizationMembershipHubSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationMembershipHubSettingsQuery | undefined, OrganizationMembershipHubSettingsQueryVariables>;
export function useOrganizationMembershipHubSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationMembershipHubSettingsQuery, OrganizationMembershipHubSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationMembershipHubSettingsQuery, OrganizationMembershipHubSettingsQueryVariables>(OrganizationMembershipHubSettingsDocument, options);
        }
export type OrganizationMembershipHubSettingsQueryHookResult = ReturnType<typeof useOrganizationMembershipHubSettingsQuery>;
export type OrganizationMembershipHubSettingsLazyQueryHookResult = ReturnType<typeof useOrganizationMembershipHubSettingsLazyQuery>;
export type OrganizationMembershipHubSettingsSuspenseQueryHookResult = ReturnType<typeof useOrganizationMembershipHubSettingsSuspenseQuery>;
export type OrganizationMembershipHubSettingsQueryResult = Apollo.QueryResult<OrganizationMembershipHubSettingsQuery, OrganizationMembershipHubSettingsQueryVariables>;
export const OrganizationNameByIdDocument = gql`
    query OrganizationNameById($id: MongoID!) {
  organizationById(_id: $id) {
    _id
    name {
      ...MultilingualFragment
    }
    shortName
    subdomain
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOrganizationNameByIdQuery__
 *
 * To run a query within a React component, call `useOrganizationNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationNameByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationNameByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationNameByIdQuery(baseOptions: Apollo.QueryHookOptions<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables> & ({ variables: OrganizationNameByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables>(OrganizationNameByIdDocument, options);
      }
export function useOrganizationNameByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables>(OrganizationNameByIdDocument, options);
        }
// @ts-ignore
export function useOrganizationNameByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables>;
export function useOrganizationNameByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationNameByIdQuery | undefined, OrganizationNameByIdQueryVariables>;
export function useOrganizationNameByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables>(OrganizationNameByIdDocument, options);
        }
export type OrganizationNameByIdQueryHookResult = ReturnType<typeof useOrganizationNameByIdQuery>;
export type OrganizationNameByIdLazyQueryHookResult = ReturnType<typeof useOrganizationNameByIdLazyQuery>;
export type OrganizationNameByIdSuspenseQueryHookResult = ReturnType<typeof useOrganizationNameByIdSuspenseQuery>;
export type OrganizationNameByIdQueryResult = Apollo.QueryResult<OrganizationNameByIdQuery, OrganizationNameByIdQueryVariables>;
export const OrganizationNamesByIdsDocument = gql`
    query OrganizationNamesByIds($ids: [MongoID!]!, $limit: Int) {
  organizationsByIds(_ids: $ids, limit: $limit) {
    _id
    name {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOrganizationNamesByIdsQuery__
 *
 * To run a query within a React component, call `useOrganizationNamesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationNamesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationNamesByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useOrganizationNamesByIdsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationNamesByIdsQuery, OrganizationNamesByIdsQueryVariables> & ({ variables: OrganizationNamesByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationNamesByIdsQuery, OrganizationNamesByIdsQueryVariables>(OrganizationNamesByIdsDocument, options);
      }
export function useOrganizationNamesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationNamesByIdsQuery, OrganizationNamesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationNamesByIdsQuery, OrganizationNamesByIdsQueryVariables>(OrganizationNamesByIdsDocument, options);
        }
// @ts-ignore
export function useOrganizationNamesByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationNamesByIdsQuery, OrganizationNamesByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationNamesByIdsQuery, OrganizationNamesByIdsQueryVariables>;
export function useOrganizationNamesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationNamesByIdsQuery, OrganizationNamesByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationNamesByIdsQuery | undefined, OrganizationNamesByIdsQueryVariables>;
export function useOrganizationNamesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationNamesByIdsQuery, OrganizationNamesByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationNamesByIdsQuery, OrganizationNamesByIdsQueryVariables>(OrganizationNamesByIdsDocument, options);
        }
export type OrganizationNamesByIdsQueryHookResult = ReturnType<typeof useOrganizationNamesByIdsQuery>;
export type OrganizationNamesByIdsLazyQueryHookResult = ReturnType<typeof useOrganizationNamesByIdsLazyQuery>;
export type OrganizationNamesByIdsSuspenseQueryHookResult = ReturnType<typeof useOrganizationNamesByIdsSuspenseQuery>;
export type OrganizationNamesByIdsQueryResult = Apollo.QueryResult<OrganizationNamesByIdsQuery, OrganizationNamesByIdsQueryVariables>;
export const OrganizationSearchHarnessDocument = gql`
    query OrganizationSearchHarness($search: String!, $limit: Int) {
  organizationSearchHarness(search: $search, limit: $limit) {
    _id
    name {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOrganizationSearchHarnessQuery__
 *
 * To run a query within a React component, call `useOrganizationSearchHarnessQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSearchHarnessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSearchHarnessQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useOrganizationSearchHarnessQuery(baseOptions: Apollo.QueryHookOptions<OrganizationSearchHarnessQuery, OrganizationSearchHarnessQueryVariables> & ({ variables: OrganizationSearchHarnessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationSearchHarnessQuery, OrganizationSearchHarnessQueryVariables>(OrganizationSearchHarnessDocument, options);
      }
export function useOrganizationSearchHarnessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSearchHarnessQuery, OrganizationSearchHarnessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationSearchHarnessQuery, OrganizationSearchHarnessQueryVariables>(OrganizationSearchHarnessDocument, options);
        }
// @ts-ignore
export function useOrganizationSearchHarnessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationSearchHarnessQuery, OrganizationSearchHarnessQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationSearchHarnessQuery, OrganizationSearchHarnessQueryVariables>;
export function useOrganizationSearchHarnessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationSearchHarnessQuery, OrganizationSearchHarnessQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationSearchHarnessQuery | undefined, OrganizationSearchHarnessQueryVariables>;
export function useOrganizationSearchHarnessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationSearchHarnessQuery, OrganizationSearchHarnessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationSearchHarnessQuery, OrganizationSearchHarnessQueryVariables>(OrganizationSearchHarnessDocument, options);
        }
export type OrganizationSearchHarnessQueryHookResult = ReturnType<typeof useOrganizationSearchHarnessQuery>;
export type OrganizationSearchHarnessLazyQueryHookResult = ReturnType<typeof useOrganizationSearchHarnessLazyQuery>;
export type OrganizationSearchHarnessSuspenseQueryHookResult = ReturnType<typeof useOrganizationSearchHarnessSuspenseQuery>;
export type OrganizationSearchHarnessQueryResult = Apollo.QueryResult<OrganizationSearchHarnessQuery, OrganizationSearchHarnessQueryVariables>;
export const OrganizationShortNamesForAdminDocument = gql`
    query OrganizationShortNamesForAdmin {
  organizationsByUser {
    _id
    shortName
    name {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useOrganizationShortNamesForAdminQuery__
 *
 * To run a query within a React component, call `useOrganizationShortNamesForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationShortNamesForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationShortNamesForAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationShortNamesForAdminQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationShortNamesForAdminQuery, OrganizationShortNamesForAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationShortNamesForAdminQuery, OrganizationShortNamesForAdminQueryVariables>(OrganizationShortNamesForAdminDocument, options);
      }
export function useOrganizationShortNamesForAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationShortNamesForAdminQuery, OrganizationShortNamesForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationShortNamesForAdminQuery, OrganizationShortNamesForAdminQueryVariables>(OrganizationShortNamesForAdminDocument, options);
        }
// @ts-ignore
export function useOrganizationShortNamesForAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationShortNamesForAdminQuery, OrganizationShortNamesForAdminQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationShortNamesForAdminQuery, OrganizationShortNamesForAdminQueryVariables>;
export function useOrganizationShortNamesForAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationShortNamesForAdminQuery, OrganizationShortNamesForAdminQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationShortNamesForAdminQuery | undefined, OrganizationShortNamesForAdminQueryVariables>;
export function useOrganizationShortNamesForAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationShortNamesForAdminQuery, OrganizationShortNamesForAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationShortNamesForAdminQuery, OrganizationShortNamesForAdminQueryVariables>(OrganizationShortNamesForAdminDocument, options);
        }
export type OrganizationShortNamesForAdminQueryHookResult = ReturnType<typeof useOrganizationShortNamesForAdminQuery>;
export type OrganizationShortNamesForAdminLazyQueryHookResult = ReturnType<typeof useOrganizationShortNamesForAdminLazyQuery>;
export type OrganizationShortNamesForAdminSuspenseQueryHookResult = ReturnType<typeof useOrganizationShortNamesForAdminSuspenseQuery>;
export type OrganizationShortNamesForAdminQueryResult = Apollo.QueryResult<OrganizationShortNamesForAdminQuery, OrganizationShortNamesForAdminQueryVariables>;
export const OrganizationStaffDocument = gql`
    query OrganizationStaff($organizationId: ID!) {
  organizationStaff(organizationId: $organizationId) {
    ...UserWithPictureFragment
    email
  }
}
    ${UserWithPictureFragmentFragmentDoc}`;

/**
 * __useOrganizationStaffQuery__
 *
 * To run a query within a React component, call `useOrganizationStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationStaffQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationStaffQuery(baseOptions: Apollo.QueryHookOptions<OrganizationStaffQuery, OrganizationStaffQueryVariables> & ({ variables: OrganizationStaffQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationStaffQuery, OrganizationStaffQueryVariables>(OrganizationStaffDocument, options);
      }
export function useOrganizationStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationStaffQuery, OrganizationStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationStaffQuery, OrganizationStaffQueryVariables>(OrganizationStaffDocument, options);
        }
// @ts-ignore
export function useOrganizationStaffSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationStaffQuery, OrganizationStaffQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationStaffQuery, OrganizationStaffQueryVariables>;
export function useOrganizationStaffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationStaffQuery, OrganizationStaffQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationStaffQuery | undefined, OrganizationStaffQueryVariables>;
export function useOrganizationStaffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationStaffQuery, OrganizationStaffQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationStaffQuery, OrganizationStaffQueryVariables>(OrganizationStaffDocument, options);
        }
export type OrganizationStaffQueryHookResult = ReturnType<typeof useOrganizationStaffQuery>;
export type OrganizationStaffLazyQueryHookResult = ReturnType<typeof useOrganizationStaffLazyQuery>;
export type OrganizationStaffSuspenseQueryHookResult = ReturnType<typeof useOrganizationStaffSuspenseQuery>;
export type OrganizationStaffQueryResult = Apollo.QueryResult<OrganizationStaffQuery, OrganizationStaffQueryVariables>;
export const OrganizationsByIdsDocument = gql`
    query OrganizationsByIds($ids: [MongoID!]!, $limit: Int, $sort: SortFindByIdsOrganizationInput) {
  organizationsByIds(_ids: $ids, limit: $limit, sort: $sort) {
    _id
    name {
      ...MultilingualFragment
    }
    logo {
      ...ImageFragment
    }
    contact {
      email
      links {
        website
      }
      phone
    }
    metadata {
      eventLookaheadMonths
      inviteWhenAddingStaff
      disabledApps
      connectedStorefront
      connectedTestStorefront
      internalOnly
      connectedOperator
      canEnableMembershipLink
      membershipPageUrl
      crowdriffEnabled
      externalVideoEnabled
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useOrganizationsByIdsQuery__
 *
 * To run a query within a React component, call `useOrganizationsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useOrganizationsByIdsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables> & ({ variables: OrganizationsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables>(OrganizationsByIdsDocument, options);
      }
export function useOrganizationsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables>(OrganizationsByIdsDocument, options);
        }
// @ts-ignore
export function useOrganizationsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables>;
export function useOrganizationsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationsByIdsQuery | undefined, OrganizationsByIdsQueryVariables>;
export function useOrganizationsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables>(OrganizationsByIdsDocument, options);
        }
export type OrganizationsByIdsQueryHookResult = ReturnType<typeof useOrganizationsByIdsQuery>;
export type OrganizationsByIdsLazyQueryHookResult = ReturnType<typeof useOrganizationsByIdsLazyQuery>;
export type OrganizationsByIdsSuspenseQueryHookResult = ReturnType<typeof useOrganizationsByIdsSuspenseQuery>;
export type OrganizationsByIdsQueryResult = Apollo.QueryResult<OrganizationsByIdsQuery, OrganizationsByIdsQueryVariables>;
export const OrganizationsByUserDocument = gql`
    query OrganizationsByUser {
  organizationsByUser {
    _id
    shortName
    name {
      ...MultilingualFragment
    }
    logo {
      ...ImageFragment
    }
    contact {
      links {
        website
      }
    }
    brandColors
    emailBranding {
      fromName
      replyTo
      accentColor
      showContact
      footerText {
        en
        fr
        es
      }
    }
    metadata {
      inviteWhenAddingStaff
      eventLookaheadMonths
      disabledApps
      connectedStorefront
      connectedTestStorefront
      storefrontOrgConnectionsEnabled
      storefrontMode
      connectedUsdStorefront
      connectedUsdTestStorefront
      internalOnly
      sandbox
      connectedOperator
      canEnableMembershipLink
      membershipPageUrl
      crowdriffEnabled
      externalVideoEnabled
      membershipTiers
      individualMembershipTiers
      membershipStatusTagIds
      listingAudienceTagIds
      nomenclature {
        membership
        member
        members
      }
      listingFreshnessEnabled
      dmoListingStaleDays
      claimedListingStaleDays
      operatorOnboardingDisabled
      whereabotListingUpdatePrompt
      whereabotImageDownloadPrompt
      customClaimEmailSubject
      customClaimEmailBody
      customPingEmailSubject
      customPingEmailBody
      membershipBroadcastId
      membershipTierCheckouts {
        tierTagId
        bookerId
        free
      }
      membershipPaymentsEnabled
      timezone
    }
    onboardingMetadata {
      allowColdSignup
      coldSignupTagId
      introMessage
      comingSoonMessage
    }
    license {
      activatedDate
      activatedBy {
        _id
        firstName
        lastName
        email
      }
      isActive
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useOrganizationsByUserQuery__
 *
 * To run a query within a React component, call `useOrganizationsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsByUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationsByUserQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>(OrganizationsByUserDocument, options);
      }
export function useOrganizationsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>(OrganizationsByUserDocument, options);
        }
// @ts-ignore
export function useOrganizationsByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>;
export function useOrganizationsByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationsByUserQuery | undefined, OrganizationsByUserQueryVariables>;
export function useOrganizationsByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>(OrganizationsByUserDocument, options);
        }
export type OrganizationsByUserQueryHookResult = ReturnType<typeof useOrganizationsByUserQuery>;
export type OrganizationsByUserLazyQueryHookResult = ReturnType<typeof useOrganizationsByUserLazyQuery>;
export type OrganizationsByUserSuspenseQueryHookResult = ReturnType<typeof useOrganizationsByUserSuspenseQuery>;
export type OrganizationsByUserQueryResult = Apollo.QueryResult<OrganizationsByUserQuery, OrganizationsByUserQueryVariables>;
export const PaymentMethodSetManyDocument = gql`
    query PaymentMethodSetMany($filter: FilterFindManyPaymentMethodSetInput) {
  paymentMethodSetMany(filter: $filter) {
    ...PaymentMethodSetFragment
  }
}
    ${PaymentMethodSetFragmentFragmentDoc}`;

/**
 * __usePaymentMethodSetManyQuery__
 *
 * To run a query within a React component, call `usePaymentMethodSetManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodSetManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodSetManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaymentMethodSetManyQuery(baseOptions?: Apollo.QueryHookOptions<PaymentMethodSetManyQuery, PaymentMethodSetManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodSetManyQuery, PaymentMethodSetManyQueryVariables>(PaymentMethodSetManyDocument, options);
      }
export function usePaymentMethodSetManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodSetManyQuery, PaymentMethodSetManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodSetManyQuery, PaymentMethodSetManyQueryVariables>(PaymentMethodSetManyDocument, options);
        }
// @ts-ignore
export function usePaymentMethodSetManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentMethodSetManyQuery, PaymentMethodSetManyQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentMethodSetManyQuery, PaymentMethodSetManyQueryVariables>;
export function usePaymentMethodSetManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentMethodSetManyQuery, PaymentMethodSetManyQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentMethodSetManyQuery | undefined, PaymentMethodSetManyQueryVariables>;
export function usePaymentMethodSetManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentMethodSetManyQuery, PaymentMethodSetManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentMethodSetManyQuery, PaymentMethodSetManyQueryVariables>(PaymentMethodSetManyDocument, options);
        }
export type PaymentMethodSetManyQueryHookResult = ReturnType<typeof usePaymentMethodSetManyQuery>;
export type PaymentMethodSetManyLazyQueryHookResult = ReturnType<typeof usePaymentMethodSetManyLazyQuery>;
export type PaymentMethodSetManySuspenseQueryHookResult = ReturnType<typeof usePaymentMethodSetManySuspenseQuery>;
export type PaymentMethodSetManyQueryResult = Apollo.QueryResult<PaymentMethodSetManyQuery, PaymentMethodSetManyQueryVariables>;
export const PaymentRequestsForCurrentUserDocument = gql`
    query PaymentRequestsForCurrentUser {
  paymentRequestsForCurrentUser {
    _id
    invoiceNumber
    status
    grandTotal
    currency
    dueDate
    sentAt
    createdDateISO
    renewablePurchaseId
    organizationId
    productTitle
  }
}
    `;

/**
 * __usePaymentRequestsForCurrentUserQuery__
 *
 * To run a query within a React component, call `usePaymentRequestsForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentRequestsForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentRequestsForCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentRequestsForCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<PaymentRequestsForCurrentUserQuery, PaymentRequestsForCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentRequestsForCurrentUserQuery, PaymentRequestsForCurrentUserQueryVariables>(PaymentRequestsForCurrentUserDocument, options);
      }
export function usePaymentRequestsForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentRequestsForCurrentUserQuery, PaymentRequestsForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentRequestsForCurrentUserQuery, PaymentRequestsForCurrentUserQueryVariables>(PaymentRequestsForCurrentUserDocument, options);
        }
// @ts-ignore
export function usePaymentRequestsForCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentRequestsForCurrentUserQuery, PaymentRequestsForCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentRequestsForCurrentUserQuery, PaymentRequestsForCurrentUserQueryVariables>;
export function usePaymentRequestsForCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentRequestsForCurrentUserQuery, PaymentRequestsForCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentRequestsForCurrentUserQuery | undefined, PaymentRequestsForCurrentUserQueryVariables>;
export function usePaymentRequestsForCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentRequestsForCurrentUserQuery, PaymentRequestsForCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentRequestsForCurrentUserQuery, PaymentRequestsForCurrentUserQueryVariables>(PaymentRequestsForCurrentUserDocument, options);
        }
export type PaymentRequestsForCurrentUserQueryHookResult = ReturnType<typeof usePaymentRequestsForCurrentUserQuery>;
export type PaymentRequestsForCurrentUserLazyQueryHookResult = ReturnType<typeof usePaymentRequestsForCurrentUserLazyQuery>;
export type PaymentRequestsForCurrentUserSuspenseQueryHookResult = ReturnType<typeof usePaymentRequestsForCurrentUserSuspenseQuery>;
export type PaymentRequestsForCurrentUserQueryResult = Apollo.QueryResult<PaymentRequestsForCurrentUserQuery, PaymentRequestsForCurrentUserQueryVariables>;
export const PendingRenewalEmailsDocument = gql`
    query PendingRenewalEmails($organizationId: MongoID!, $operatorEntityId: MongoID, $listId: MongoID) {
  pendingRenewalEmails(
    organizationId: $organizationId
    operatorEntityId: $operatorEntityId
    listId: $listId
  ) {
    _id
    emailKind
    scheduledSendAt
    status
    listId
    sendNowRequestedAt
    subject {
      type
      entityId
    }
  }
}
    `;

/**
 * __usePendingRenewalEmailsQuery__
 *
 * To run a query within a React component, call `usePendingRenewalEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingRenewalEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingRenewalEmailsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      operatorEntityId: // value for 'operatorEntityId'
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function usePendingRenewalEmailsQuery(baseOptions: Apollo.QueryHookOptions<PendingRenewalEmailsQuery, PendingRenewalEmailsQueryVariables> & ({ variables: PendingRenewalEmailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingRenewalEmailsQuery, PendingRenewalEmailsQueryVariables>(PendingRenewalEmailsDocument, options);
      }
export function usePendingRenewalEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingRenewalEmailsQuery, PendingRenewalEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingRenewalEmailsQuery, PendingRenewalEmailsQueryVariables>(PendingRenewalEmailsDocument, options);
        }
// @ts-ignore
export function usePendingRenewalEmailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PendingRenewalEmailsQuery, PendingRenewalEmailsQueryVariables>): Apollo.UseSuspenseQueryResult<PendingRenewalEmailsQuery, PendingRenewalEmailsQueryVariables>;
export function usePendingRenewalEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PendingRenewalEmailsQuery, PendingRenewalEmailsQueryVariables>): Apollo.UseSuspenseQueryResult<PendingRenewalEmailsQuery | undefined, PendingRenewalEmailsQueryVariables>;
export function usePendingRenewalEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PendingRenewalEmailsQuery, PendingRenewalEmailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PendingRenewalEmailsQuery, PendingRenewalEmailsQueryVariables>(PendingRenewalEmailsDocument, options);
        }
export type PendingRenewalEmailsQueryHookResult = ReturnType<typeof usePendingRenewalEmailsQuery>;
export type PendingRenewalEmailsLazyQueryHookResult = ReturnType<typeof usePendingRenewalEmailsLazyQuery>;
export type PendingRenewalEmailsSuspenseQueryHookResult = ReturnType<typeof usePendingRenewalEmailsSuspenseQuery>;
export type PendingRenewalEmailsQueryResult = Apollo.QueryResult<PendingRenewalEmailsQuery, PendingRenewalEmailsQueryVariables>;
export const PeopleByIdsNamesDocument = gql`
    query PeopleByIdsNames($ids: [MongoID!]!, $limit: Int) {
  peopleByIds(_ids: $ids, limit: $limit) {
    firstName
    lastName
    _id
  }
}
    `;

/**
 * __usePeopleByIdsNamesQuery__
 *
 * To run a query within a React component, call `usePeopleByIdsNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleByIdsNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleByIdsNamesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePeopleByIdsNamesQuery(baseOptions: Apollo.QueryHookOptions<PeopleByIdsNamesQuery, PeopleByIdsNamesQueryVariables> & ({ variables: PeopleByIdsNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeopleByIdsNamesQuery, PeopleByIdsNamesQueryVariables>(PeopleByIdsNamesDocument, options);
      }
export function usePeopleByIdsNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeopleByIdsNamesQuery, PeopleByIdsNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeopleByIdsNamesQuery, PeopleByIdsNamesQueryVariables>(PeopleByIdsNamesDocument, options);
        }
// @ts-ignore
export function usePeopleByIdsNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PeopleByIdsNamesQuery, PeopleByIdsNamesQueryVariables>): Apollo.UseSuspenseQueryResult<PeopleByIdsNamesQuery, PeopleByIdsNamesQueryVariables>;
export function usePeopleByIdsNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PeopleByIdsNamesQuery, PeopleByIdsNamesQueryVariables>): Apollo.UseSuspenseQueryResult<PeopleByIdsNamesQuery | undefined, PeopleByIdsNamesQueryVariables>;
export function usePeopleByIdsNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PeopleByIdsNamesQuery, PeopleByIdsNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PeopleByIdsNamesQuery, PeopleByIdsNamesQueryVariables>(PeopleByIdsNamesDocument, options);
        }
export type PeopleByIdsNamesQueryHookResult = ReturnType<typeof usePeopleByIdsNamesQuery>;
export type PeopleByIdsNamesLazyQueryHookResult = ReturnType<typeof usePeopleByIdsNamesLazyQuery>;
export type PeopleByIdsNamesSuspenseQueryHookResult = ReturnType<typeof usePeopleByIdsNamesSuspenseQuery>;
export type PeopleByIdsNamesQueryResult = Apollo.QueryResult<PeopleByIdsNamesQuery, PeopleByIdsNamesQueryVariables>;
export const PeopleCountDocument = gql`
    query PeopleCount($filter: FilterCountPeopleInput, $queryBuilder: JSON) {
  peopleCount(filter: $filter, queryBuilder: $queryBuilder)
}
    `;

/**
 * __usePeopleCountQuery__
 *
 * To run a query within a React component, call `usePeopleCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      queryBuilder: // value for 'queryBuilder'
 *   },
 * });
 */
export function usePeopleCountQuery(baseOptions?: Apollo.QueryHookOptions<PeopleCountQuery, PeopleCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeopleCountQuery, PeopleCountQueryVariables>(PeopleCountDocument, options);
      }
export function usePeopleCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeopleCountQuery, PeopleCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeopleCountQuery, PeopleCountQueryVariables>(PeopleCountDocument, options);
        }
// @ts-ignore
export function usePeopleCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PeopleCountQuery, PeopleCountQueryVariables>): Apollo.UseSuspenseQueryResult<PeopleCountQuery, PeopleCountQueryVariables>;
export function usePeopleCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PeopleCountQuery, PeopleCountQueryVariables>): Apollo.UseSuspenseQueryResult<PeopleCountQuery | undefined, PeopleCountQueryVariables>;
export function usePeopleCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PeopleCountQuery, PeopleCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PeopleCountQuery, PeopleCountQueryVariables>(PeopleCountDocument, options);
        }
export type PeopleCountQueryHookResult = ReturnType<typeof usePeopleCountQuery>;
export type PeopleCountLazyQueryHookResult = ReturnType<typeof usePeopleCountLazyQuery>;
export type PeopleCountSuspenseQueryHookResult = ReturnType<typeof usePeopleCountSuspenseQuery>;
export type PeopleCountQueryResult = Apollo.QueryResult<PeopleCountQuery, PeopleCountQueryVariables>;
export const PeopleManyNamesDocument = gql`
    query PeopleManyNames($filter: FilterFindManyPeopleInput, $limit: Int, $skip: Int) {
  peopleManySimple(filter: $filter, limit: $limit, skip: $skip) {
    _id
    firstName
    lastName
  }
}
    `;

/**
 * __usePeopleManyNamesQuery__
 *
 * To run a query within a React component, call `usePeopleManyNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleManyNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleManyNamesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePeopleManyNamesQuery(baseOptions?: Apollo.QueryHookOptions<PeopleManyNamesQuery, PeopleManyNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeopleManyNamesQuery, PeopleManyNamesQueryVariables>(PeopleManyNamesDocument, options);
      }
export function usePeopleManyNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeopleManyNamesQuery, PeopleManyNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeopleManyNamesQuery, PeopleManyNamesQueryVariables>(PeopleManyNamesDocument, options);
        }
// @ts-ignore
export function usePeopleManyNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PeopleManyNamesQuery, PeopleManyNamesQueryVariables>): Apollo.UseSuspenseQueryResult<PeopleManyNamesQuery, PeopleManyNamesQueryVariables>;
export function usePeopleManyNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PeopleManyNamesQuery, PeopleManyNamesQueryVariables>): Apollo.UseSuspenseQueryResult<PeopleManyNamesQuery | undefined, PeopleManyNamesQueryVariables>;
export function usePeopleManyNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PeopleManyNamesQuery, PeopleManyNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PeopleManyNamesQuery, PeopleManyNamesQueryVariables>(PeopleManyNamesDocument, options);
        }
export type PeopleManyNamesQueryHookResult = ReturnType<typeof usePeopleManyNamesQuery>;
export type PeopleManyNamesLazyQueryHookResult = ReturnType<typeof usePeopleManyNamesLazyQuery>;
export type PeopleManyNamesSuspenseQueryHookResult = ReturnType<typeof usePeopleManyNamesSuspenseQuery>;
export type PeopleManyNamesQueryResult = Apollo.QueryResult<PeopleManyNamesQuery, PeopleManyNamesQueryVariables>;
export const PeopleManySimpleDocument = gql`
    query PeopleManySimple($filter: FilterFindManyPeopleInput, $queryBuilder: JSON, $sort: SortFindManyPeopleInput, $limit: Int, $skip: Int) {
  peopleManySimple(
    filter: $filter
    queryBuilder: $queryBuilder
    sort: $sort
    limit: $limit
    skip: $skip
  ) {
    ...PersonSimpleManyFragment
  }
}
    ${PersonSimpleManyFragmentFragmentDoc}`;

/**
 * __usePeopleManySimpleQuery__
 *
 * To run a query within a React component, call `usePeopleManySimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleManySimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleManySimpleQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      queryBuilder: // value for 'queryBuilder'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePeopleManySimpleQuery(baseOptions?: Apollo.QueryHookOptions<PeopleManySimpleQuery, PeopleManySimpleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeopleManySimpleQuery, PeopleManySimpleQueryVariables>(PeopleManySimpleDocument, options);
      }
export function usePeopleManySimpleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeopleManySimpleQuery, PeopleManySimpleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeopleManySimpleQuery, PeopleManySimpleQueryVariables>(PeopleManySimpleDocument, options);
        }
// @ts-ignore
export function usePeopleManySimpleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PeopleManySimpleQuery, PeopleManySimpleQueryVariables>): Apollo.UseSuspenseQueryResult<PeopleManySimpleQuery, PeopleManySimpleQueryVariables>;
export function usePeopleManySimpleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PeopleManySimpleQuery, PeopleManySimpleQueryVariables>): Apollo.UseSuspenseQueryResult<PeopleManySimpleQuery | undefined, PeopleManySimpleQueryVariables>;
export function usePeopleManySimpleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PeopleManySimpleQuery, PeopleManySimpleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PeopleManySimpleQuery, PeopleManySimpleQueryVariables>(PeopleManySimpleDocument, options);
        }
export type PeopleManySimpleQueryHookResult = ReturnType<typeof usePeopleManySimpleQuery>;
export type PeopleManySimpleLazyQueryHookResult = ReturnType<typeof usePeopleManySimpleLazyQuery>;
export type PeopleManySimpleSuspenseQueryHookResult = ReturnType<typeof usePeopleManySimpleSuspenseQuery>;
export type PeopleManySimpleQueryResult = Apollo.QueryResult<PeopleManySimpleQuery, PeopleManySimpleQueryVariables>;
export const PerBusinessAnswersEnabledForOrganizationDocument = gql`
    query PerBusinessAnswersEnabledForOrganization($organizationId: MongoID!) {
  perBusinessAnswersEnabledForOrganization(organizationId: $organizationId)
}
    `;

/**
 * __usePerBusinessAnswersEnabledForOrganizationQuery__
 *
 * To run a query within a React component, call `usePerBusinessAnswersEnabledForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerBusinessAnswersEnabledForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerBusinessAnswersEnabledForOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function usePerBusinessAnswersEnabledForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<PerBusinessAnswersEnabledForOrganizationQuery, PerBusinessAnswersEnabledForOrganizationQueryVariables> & ({ variables: PerBusinessAnswersEnabledForOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerBusinessAnswersEnabledForOrganizationQuery, PerBusinessAnswersEnabledForOrganizationQueryVariables>(PerBusinessAnswersEnabledForOrganizationDocument, options);
      }
export function usePerBusinessAnswersEnabledForOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerBusinessAnswersEnabledForOrganizationQuery, PerBusinessAnswersEnabledForOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerBusinessAnswersEnabledForOrganizationQuery, PerBusinessAnswersEnabledForOrganizationQueryVariables>(PerBusinessAnswersEnabledForOrganizationDocument, options);
        }
// @ts-ignore
export function usePerBusinessAnswersEnabledForOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PerBusinessAnswersEnabledForOrganizationQuery, PerBusinessAnswersEnabledForOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<PerBusinessAnswersEnabledForOrganizationQuery, PerBusinessAnswersEnabledForOrganizationQueryVariables>;
export function usePerBusinessAnswersEnabledForOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerBusinessAnswersEnabledForOrganizationQuery, PerBusinessAnswersEnabledForOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<PerBusinessAnswersEnabledForOrganizationQuery | undefined, PerBusinessAnswersEnabledForOrganizationQueryVariables>;
export function usePerBusinessAnswersEnabledForOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerBusinessAnswersEnabledForOrganizationQuery, PerBusinessAnswersEnabledForOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerBusinessAnswersEnabledForOrganizationQuery, PerBusinessAnswersEnabledForOrganizationQueryVariables>(PerBusinessAnswersEnabledForOrganizationDocument, options);
        }
export type PerBusinessAnswersEnabledForOrganizationQueryHookResult = ReturnType<typeof usePerBusinessAnswersEnabledForOrganizationQuery>;
export type PerBusinessAnswersEnabledForOrganizationLazyQueryHookResult = ReturnType<typeof usePerBusinessAnswersEnabledForOrganizationLazyQuery>;
export type PerBusinessAnswersEnabledForOrganizationSuspenseQueryHookResult = ReturnType<typeof usePerBusinessAnswersEnabledForOrganizationSuspenseQuery>;
export type PerBusinessAnswersEnabledForOrganizationQueryResult = Apollo.QueryResult<PerBusinessAnswersEnabledForOrganizationQuery, PerBusinessAnswersEnabledForOrganizationQueryVariables>;
export const PersonCheckIfExistsByEmailDocument = gql`
    query PersonCheckIfExistsByEmail($email: String!, $entityId: ID!, $type: EnumOwnerType!) {
  personCheckIfExistsByEmail(email: $email, entityId: $entityId, type: $type) {
    exists
    existsInEntity
    email
    firstName
    lastName
    phone
    phoneExt
  }
}
    `;

/**
 * __usePersonCheckIfExistsByEmailQuery__
 *
 * To run a query within a React component, call `usePersonCheckIfExistsByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonCheckIfExistsByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonCheckIfExistsByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *      entityId: // value for 'entityId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePersonCheckIfExistsByEmailQuery(baseOptions: Apollo.QueryHookOptions<PersonCheckIfExistsByEmailQuery, PersonCheckIfExistsByEmailQueryVariables> & ({ variables: PersonCheckIfExistsByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonCheckIfExistsByEmailQuery, PersonCheckIfExistsByEmailQueryVariables>(PersonCheckIfExistsByEmailDocument, options);
      }
export function usePersonCheckIfExistsByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonCheckIfExistsByEmailQuery, PersonCheckIfExistsByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonCheckIfExistsByEmailQuery, PersonCheckIfExistsByEmailQueryVariables>(PersonCheckIfExistsByEmailDocument, options);
        }
// @ts-ignore
export function usePersonCheckIfExistsByEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PersonCheckIfExistsByEmailQuery, PersonCheckIfExistsByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<PersonCheckIfExistsByEmailQuery, PersonCheckIfExistsByEmailQueryVariables>;
export function usePersonCheckIfExistsByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonCheckIfExistsByEmailQuery, PersonCheckIfExistsByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<PersonCheckIfExistsByEmailQuery | undefined, PersonCheckIfExistsByEmailQueryVariables>;
export function usePersonCheckIfExistsByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonCheckIfExistsByEmailQuery, PersonCheckIfExistsByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonCheckIfExistsByEmailQuery, PersonCheckIfExistsByEmailQueryVariables>(PersonCheckIfExistsByEmailDocument, options);
        }
export type PersonCheckIfExistsByEmailQueryHookResult = ReturnType<typeof usePersonCheckIfExistsByEmailQuery>;
export type PersonCheckIfExistsByEmailLazyQueryHookResult = ReturnType<typeof usePersonCheckIfExistsByEmailLazyQuery>;
export type PersonCheckIfExistsByEmailSuspenseQueryHookResult = ReturnType<typeof usePersonCheckIfExistsByEmailSuspenseQuery>;
export type PersonCheckIfExistsByEmailQueryResult = Apollo.QueryResult<PersonCheckIfExistsByEmailQuery, PersonCheckIfExistsByEmailQueryVariables>;
export const PersonDetailsDocument = gql`
    query PersonDetails($personId: ID!, $entityId: ID, $type: EnumOwnerType) {
  personDetails(personId: $personId, entityId: $entityId, type: $type) {
    ...PersonDetailsFragment
  }
}
    ${PersonDetailsFragmentFragmentDoc}`;

/**
 * __usePersonDetailsQuery__
 *
 * To run a query within a React component, call `usePersonDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonDetailsQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *      entityId: // value for 'entityId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePersonDetailsQuery(baseOptions: Apollo.QueryHookOptions<PersonDetailsQuery, PersonDetailsQueryVariables> & ({ variables: PersonDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonDetailsQuery, PersonDetailsQueryVariables>(PersonDetailsDocument, options);
      }
export function usePersonDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonDetailsQuery, PersonDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonDetailsQuery, PersonDetailsQueryVariables>(PersonDetailsDocument, options);
        }
// @ts-ignore
export function usePersonDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PersonDetailsQuery, PersonDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<PersonDetailsQuery, PersonDetailsQueryVariables>;
export function usePersonDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonDetailsQuery, PersonDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<PersonDetailsQuery | undefined, PersonDetailsQueryVariables>;
export function usePersonDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonDetailsQuery, PersonDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonDetailsQuery, PersonDetailsQueryVariables>(PersonDetailsDocument, options);
        }
export type PersonDetailsQueryHookResult = ReturnType<typeof usePersonDetailsQuery>;
export type PersonDetailsLazyQueryHookResult = ReturnType<typeof usePersonDetailsLazyQuery>;
export type PersonDetailsSuspenseQueryHookResult = ReturnType<typeof usePersonDetailsSuspenseQuery>;
export type PersonDetailsQueryResult = Apollo.QueryResult<PersonDetailsQuery, PersonDetailsQueryVariables>;
export const PersonFindOneNameDocument = gql`
    query PersonFindOneName($filter: FilterFindOnePeopleInput) {
  personFindOne(filter: $filter) {
    _id
    firstName
    lastName
    email
    phone
    address {
      line1
      line2
      city
      subdivision
      postalCode
      country
      location {
        type
        coordinates
      }
    }
    photo {
      _id
    }
  }
}
    `;

/**
 * __usePersonFindOneNameQuery__
 *
 * To run a query within a React component, call `usePersonFindOneNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonFindOneNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonFindOneNameQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePersonFindOneNameQuery(baseOptions?: Apollo.QueryHookOptions<PersonFindOneNameQuery, PersonFindOneNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonFindOneNameQuery, PersonFindOneNameQueryVariables>(PersonFindOneNameDocument, options);
      }
export function usePersonFindOneNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonFindOneNameQuery, PersonFindOneNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonFindOneNameQuery, PersonFindOneNameQueryVariables>(PersonFindOneNameDocument, options);
        }
// @ts-ignore
export function usePersonFindOneNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PersonFindOneNameQuery, PersonFindOneNameQueryVariables>): Apollo.UseSuspenseQueryResult<PersonFindOneNameQuery, PersonFindOneNameQueryVariables>;
export function usePersonFindOneNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonFindOneNameQuery, PersonFindOneNameQueryVariables>): Apollo.UseSuspenseQueryResult<PersonFindOneNameQuery | undefined, PersonFindOneNameQueryVariables>;
export function usePersonFindOneNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonFindOneNameQuery, PersonFindOneNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonFindOneNameQuery, PersonFindOneNameQueryVariables>(PersonFindOneNameDocument, options);
        }
export type PersonFindOneNameQueryHookResult = ReturnType<typeof usePersonFindOneNameQuery>;
export type PersonFindOneNameLazyQueryHookResult = ReturnType<typeof usePersonFindOneNameLazyQuery>;
export type PersonFindOneNameSuspenseQueryHookResult = ReturnType<typeof usePersonFindOneNameSuspenseQuery>;
export type PersonFindOneNameQueryResult = Apollo.QueryResult<PersonFindOneNameQuery, PersonFindOneNameQueryVariables>;
export const PersonNextOrderDocument = gql`
    query PersonNextOrder($personId: ID!, $entityId: ID, $type: EnumEntityReferenceType) {
  personNextOrder(personId: $personId, entityId: $entityId, type: $type) {
    _id
    purchasedProducts {
      _id
      inventoryClaims {
        _id
        claimedDateRangeISO {
          _id
          start
          end
          metadata
        }
      }
      product {
        _id
        type
        isUpsellOnly
        name {
          ...MultilingualFragment
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __usePersonNextOrderQuery__
 *
 * To run a query within a React component, call `usePersonNextOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonNextOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonNextOrderQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *      entityId: // value for 'entityId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePersonNextOrderQuery(baseOptions: Apollo.QueryHookOptions<PersonNextOrderQuery, PersonNextOrderQueryVariables> & ({ variables: PersonNextOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonNextOrderQuery, PersonNextOrderQueryVariables>(PersonNextOrderDocument, options);
      }
export function usePersonNextOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonNextOrderQuery, PersonNextOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonNextOrderQuery, PersonNextOrderQueryVariables>(PersonNextOrderDocument, options);
        }
// @ts-ignore
export function usePersonNextOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PersonNextOrderQuery, PersonNextOrderQueryVariables>): Apollo.UseSuspenseQueryResult<PersonNextOrderQuery, PersonNextOrderQueryVariables>;
export function usePersonNextOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonNextOrderQuery, PersonNextOrderQueryVariables>): Apollo.UseSuspenseQueryResult<PersonNextOrderQuery | undefined, PersonNextOrderQueryVariables>;
export function usePersonNextOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonNextOrderQuery, PersonNextOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonNextOrderQuery, PersonNextOrderQueryVariables>(PersonNextOrderDocument, options);
        }
export type PersonNextOrderQueryHookResult = ReturnType<typeof usePersonNextOrderQuery>;
export type PersonNextOrderLazyQueryHookResult = ReturnType<typeof usePersonNextOrderLazyQuery>;
export type PersonNextOrderSuspenseQueryHookResult = ReturnType<typeof usePersonNextOrderSuspenseQuery>;
export type PersonNextOrderQueryResult = Apollo.QueryResult<PersonNextOrderQuery, PersonNextOrderQueryVariables>;
export const PersonNextPaymentDocument = gql`
    query PersonNextPayment($personId: ID!, $entityId: ID, $type: EnumEntityReferenceType) {
  personNextPayment(personId: $personId, entityId: $entityId, type: $type) {
    _id
    amount
    dueDate
    order
    status
    type
  }
}
    `;

/**
 * __usePersonNextPaymentQuery__
 *
 * To run a query within a React component, call `usePersonNextPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonNextPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonNextPaymentQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *      entityId: // value for 'entityId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePersonNextPaymentQuery(baseOptions: Apollo.QueryHookOptions<PersonNextPaymentQuery, PersonNextPaymentQueryVariables> & ({ variables: PersonNextPaymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonNextPaymentQuery, PersonNextPaymentQueryVariables>(PersonNextPaymentDocument, options);
      }
export function usePersonNextPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonNextPaymentQuery, PersonNextPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonNextPaymentQuery, PersonNextPaymentQueryVariables>(PersonNextPaymentDocument, options);
        }
// @ts-ignore
export function usePersonNextPaymentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PersonNextPaymentQuery, PersonNextPaymentQueryVariables>): Apollo.UseSuspenseQueryResult<PersonNextPaymentQuery, PersonNextPaymentQueryVariables>;
export function usePersonNextPaymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonNextPaymentQuery, PersonNextPaymentQueryVariables>): Apollo.UseSuspenseQueryResult<PersonNextPaymentQuery | undefined, PersonNextPaymentQueryVariables>;
export function usePersonNextPaymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonNextPaymentQuery, PersonNextPaymentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonNextPaymentQuery, PersonNextPaymentQueryVariables>(PersonNextPaymentDocument, options);
        }
export type PersonNextPaymentQueryHookResult = ReturnType<typeof usePersonNextPaymentQuery>;
export type PersonNextPaymentLazyQueryHookResult = ReturnType<typeof usePersonNextPaymentLazyQuery>;
export type PersonNextPaymentSuspenseQueryHookResult = ReturnType<typeof usePersonNextPaymentSuspenseQuery>;
export type PersonNextPaymentQueryResult = Apollo.QueryResult<PersonNextPaymentQuery, PersonNextPaymentQueryVariables>;
export const PlaceByIdDocument = gql`
    query PlaceById($id: MongoID!) {
  placeById(_id: $id) {
    _id
    name {
      en
      fr
      es
    }
    type
    parentPlace
    connectedListing
    connectedDmoListing
    subPlaces {
      _id
      name {
        en
        fr
        es
      }
      type
    }
    outline {
      type
      coordinates
    }
    outlineSimplified {
      type
      coordinates
    }
    createdDateISO
    updatedDateISO
  }
}
    `;

/**
 * __usePlaceByIdQuery__
 *
 * To run a query within a React component, call `usePlaceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlaceByIdQuery(baseOptions: Apollo.QueryHookOptions<PlaceByIdQuery, PlaceByIdQueryVariables> & ({ variables: PlaceByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaceByIdQuery, PlaceByIdQueryVariables>(PlaceByIdDocument, options);
      }
export function usePlaceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaceByIdQuery, PlaceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaceByIdQuery, PlaceByIdQueryVariables>(PlaceByIdDocument, options);
        }
// @ts-ignore
export function usePlaceByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlaceByIdQuery, PlaceByIdQueryVariables>): Apollo.UseSuspenseQueryResult<PlaceByIdQuery, PlaceByIdQueryVariables>;
export function usePlaceByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaceByIdQuery, PlaceByIdQueryVariables>): Apollo.UseSuspenseQueryResult<PlaceByIdQuery | undefined, PlaceByIdQueryVariables>;
export function usePlaceByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaceByIdQuery, PlaceByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlaceByIdQuery, PlaceByIdQueryVariables>(PlaceByIdDocument, options);
        }
export type PlaceByIdQueryHookResult = ReturnType<typeof usePlaceByIdQuery>;
export type PlaceByIdLazyQueryHookResult = ReturnType<typeof usePlaceByIdLazyQuery>;
export type PlaceByIdSuspenseQueryHookResult = ReturnType<typeof usePlaceByIdSuspenseQuery>;
export type PlaceByIdQueryResult = Apollo.QueryResult<PlaceByIdQuery, PlaceByIdQueryVariables>;
export const PlaceManyDocument = gql`
    query PlaceMany($filter: FilterFindManyPlaceInput, $sort: SortFindManyPlaceInput, $limit: Int, $skip: Int) {
  placeMany(filter: $filter, sort: $sort, limit: $limit, skip: $skip) {
    _id
    name {
      en
      fr
      es
    }
    type
    connectedListing
    connectedDmoListing
    subPlaces {
      _id
      name {
        en
        fr
        es
      }
      type
    }
    outlineSimplified {
      type
      coordinates
    }
    createdDateISO
    updatedDateISO
  }
}
    `;

/**
 * __usePlaceManyQuery__
 *
 * To run a query within a React component, call `usePlaceManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePlaceManyQuery(baseOptions?: Apollo.QueryHookOptions<PlaceManyQuery, PlaceManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaceManyQuery, PlaceManyQueryVariables>(PlaceManyDocument, options);
      }
export function usePlaceManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaceManyQuery, PlaceManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaceManyQuery, PlaceManyQueryVariables>(PlaceManyDocument, options);
        }
// @ts-ignore
export function usePlaceManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlaceManyQuery, PlaceManyQueryVariables>): Apollo.UseSuspenseQueryResult<PlaceManyQuery, PlaceManyQueryVariables>;
export function usePlaceManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaceManyQuery, PlaceManyQueryVariables>): Apollo.UseSuspenseQueryResult<PlaceManyQuery | undefined, PlaceManyQueryVariables>;
export function usePlaceManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaceManyQuery, PlaceManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlaceManyQuery, PlaceManyQueryVariables>(PlaceManyDocument, options);
        }
export type PlaceManyQueryHookResult = ReturnType<typeof usePlaceManyQuery>;
export type PlaceManyLazyQueryHookResult = ReturnType<typeof usePlaceManyLazyQuery>;
export type PlaceManySuspenseQueryHookResult = ReturnType<typeof usePlaceManySuspenseQuery>;
export type PlaceManyQueryResult = Apollo.QueryResult<PlaceManyQuery, PlaceManyQueryVariables>;
export const PlaceTreeDocument = gql`
    query PlaceTree {
  placeTree {
    _id
    name {
      en
    }
    type
    parentPlace
    subPlaces {
      _id
    }
  }
}
    `;

/**
 * __usePlaceTreeQuery__
 *
 * To run a query within a React component, call `usePlaceTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceTreeQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlaceTreeQuery(baseOptions?: Apollo.QueryHookOptions<PlaceTreeQuery, PlaceTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaceTreeQuery, PlaceTreeQueryVariables>(PlaceTreeDocument, options);
      }
export function usePlaceTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaceTreeQuery, PlaceTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaceTreeQuery, PlaceTreeQueryVariables>(PlaceTreeDocument, options);
        }
// @ts-ignore
export function usePlaceTreeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlaceTreeQuery, PlaceTreeQueryVariables>): Apollo.UseSuspenseQueryResult<PlaceTreeQuery, PlaceTreeQueryVariables>;
export function usePlaceTreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaceTreeQuery, PlaceTreeQueryVariables>): Apollo.UseSuspenseQueryResult<PlaceTreeQuery | undefined, PlaceTreeQueryVariables>;
export function usePlaceTreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaceTreeQuery, PlaceTreeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlaceTreeQuery, PlaceTreeQueryVariables>(PlaceTreeDocument, options);
        }
export type PlaceTreeQueryHookResult = ReturnType<typeof usePlaceTreeQuery>;
export type PlaceTreeLazyQueryHookResult = ReturnType<typeof usePlaceTreeLazyQuery>;
export type PlaceTreeSuspenseQueryHookResult = ReturnType<typeof usePlaceTreeSuspenseQuery>;
export type PlaceTreeQueryResult = Apollo.QueryResult<PlaceTreeQuery, PlaceTreeQueryVariables>;
export const PlacesCountDocument = gql`
    query PlacesCount {
  placesCount
}
    `;

/**
 * __usePlacesCountQuery__
 *
 * To run a query within a React component, call `usePlacesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlacesCountQuery(baseOptions?: Apollo.QueryHookOptions<PlacesCountQuery, PlacesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacesCountQuery, PlacesCountQueryVariables>(PlacesCountDocument, options);
      }
export function usePlacesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacesCountQuery, PlacesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacesCountQuery, PlacesCountQueryVariables>(PlacesCountDocument, options);
        }
// @ts-ignore
export function usePlacesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlacesCountQuery, PlacesCountQueryVariables>): Apollo.UseSuspenseQueryResult<PlacesCountQuery, PlacesCountQueryVariables>;
export function usePlacesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlacesCountQuery, PlacesCountQueryVariables>): Apollo.UseSuspenseQueryResult<PlacesCountQuery | undefined, PlacesCountQueryVariables>;
export function usePlacesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlacesCountQuery, PlacesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlacesCountQuery, PlacesCountQueryVariables>(PlacesCountDocument, options);
        }
export type PlacesCountQueryHookResult = ReturnType<typeof usePlacesCountQuery>;
export type PlacesCountLazyQueryHookResult = ReturnType<typeof usePlacesCountLazyQuery>;
export type PlacesCountSuspenseQueryHookResult = ReturnType<typeof usePlacesCountSuspenseQuery>;
export type PlacesCountQueryResult = Apollo.QueryResult<PlacesCountQuery, PlacesCountQueryVariables>;
export const PolicyManyDocument = gql`
    query PolicyMany($filter: FilterFindManyPolicyInput) {
  policyMany(filter: $filter) {
    _id
    content {
      ...MultilingualFragment
    }
    isActive
    name {
      ...MultilingualFragment
    }
    storefront
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __usePolicyManyQuery__
 *
 * To run a query within a React component, call `usePolicyManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePolicyManyQuery(baseOptions?: Apollo.QueryHookOptions<PolicyManyQuery, PolicyManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolicyManyQuery, PolicyManyQueryVariables>(PolicyManyDocument, options);
      }
export function usePolicyManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolicyManyQuery, PolicyManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolicyManyQuery, PolicyManyQueryVariables>(PolicyManyDocument, options);
        }
// @ts-ignore
export function usePolicyManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PolicyManyQuery, PolicyManyQueryVariables>): Apollo.UseSuspenseQueryResult<PolicyManyQuery, PolicyManyQueryVariables>;
export function usePolicyManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolicyManyQuery, PolicyManyQueryVariables>): Apollo.UseSuspenseQueryResult<PolicyManyQuery | undefined, PolicyManyQueryVariables>;
export function usePolicyManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PolicyManyQuery, PolicyManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PolicyManyQuery, PolicyManyQueryVariables>(PolicyManyDocument, options);
        }
export type PolicyManyQueryHookResult = ReturnType<typeof usePolicyManyQuery>;
export type PolicyManyLazyQueryHookResult = ReturnType<typeof usePolicyManyLazyQuery>;
export type PolicyManySuspenseQueryHookResult = ReturnType<typeof usePolicyManySuspenseQuery>;
export type PolicyManyQueryResult = Apollo.QueryResult<PolicyManyQuery, PolicyManyQueryVariables>;
export const PostHogEventAndOperatorWidgetStatsByOrganizationDocument = gql`
    query PostHogEventAndOperatorWidgetStatsByOrganization($timestampRange: DateInput!, $organizationId: ID!) {
  postHogEventAndOperatorWidgetStatsByOrganization(
    timestampRange: $timestampRange
    organizationId: $organizationId
  ) {
    events {
      impressions
      outboundClicks
      views
    }
    operators {
      impressions
      outboundClicks
      views
    }
  }
}
    `;

/**
 * __usePostHogEventAndOperatorWidgetStatsByOrganizationQuery__
 *
 * To run a query within a React component, call `usePostHogEventAndOperatorWidgetStatsByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostHogEventAndOperatorWidgetStatsByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostHogEventAndOperatorWidgetStatsByOrganizationQuery({
 *   variables: {
 *      timestampRange: // value for 'timestampRange'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function usePostHogEventAndOperatorWidgetStatsByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<PostHogEventAndOperatorWidgetStatsByOrganizationQuery, PostHogEventAndOperatorWidgetStatsByOrganizationQueryVariables> & ({ variables: PostHogEventAndOperatorWidgetStatsByOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostHogEventAndOperatorWidgetStatsByOrganizationQuery, PostHogEventAndOperatorWidgetStatsByOrganizationQueryVariables>(PostHogEventAndOperatorWidgetStatsByOrganizationDocument, options);
      }
export function usePostHogEventAndOperatorWidgetStatsByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostHogEventAndOperatorWidgetStatsByOrganizationQuery, PostHogEventAndOperatorWidgetStatsByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostHogEventAndOperatorWidgetStatsByOrganizationQuery, PostHogEventAndOperatorWidgetStatsByOrganizationQueryVariables>(PostHogEventAndOperatorWidgetStatsByOrganizationDocument, options);
        }
// @ts-ignore
export function usePostHogEventAndOperatorWidgetStatsByOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PostHogEventAndOperatorWidgetStatsByOrganizationQuery, PostHogEventAndOperatorWidgetStatsByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<PostHogEventAndOperatorWidgetStatsByOrganizationQuery, PostHogEventAndOperatorWidgetStatsByOrganizationQueryVariables>;
export function usePostHogEventAndOperatorWidgetStatsByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostHogEventAndOperatorWidgetStatsByOrganizationQuery, PostHogEventAndOperatorWidgetStatsByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<PostHogEventAndOperatorWidgetStatsByOrganizationQuery | undefined, PostHogEventAndOperatorWidgetStatsByOrganizationQueryVariables>;
export function usePostHogEventAndOperatorWidgetStatsByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostHogEventAndOperatorWidgetStatsByOrganizationQuery, PostHogEventAndOperatorWidgetStatsByOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostHogEventAndOperatorWidgetStatsByOrganizationQuery, PostHogEventAndOperatorWidgetStatsByOrganizationQueryVariables>(PostHogEventAndOperatorWidgetStatsByOrganizationDocument, options);
        }
export type PostHogEventAndOperatorWidgetStatsByOrganizationQueryHookResult = ReturnType<typeof usePostHogEventAndOperatorWidgetStatsByOrganizationQuery>;
export type PostHogEventAndOperatorWidgetStatsByOrganizationLazyQueryHookResult = ReturnType<typeof usePostHogEventAndOperatorWidgetStatsByOrganizationLazyQuery>;
export type PostHogEventAndOperatorWidgetStatsByOrganizationSuspenseQueryHookResult = ReturnType<typeof usePostHogEventAndOperatorWidgetStatsByOrganizationSuspenseQuery>;
export type PostHogEventAndOperatorWidgetStatsByOrganizationQueryResult = Apollo.QueryResult<PostHogEventAndOperatorWidgetStatsByOrganizationQuery, PostHogEventAndOperatorWidgetStatsByOrganizationQueryVariables>;
export const PostHogStatsTripperAggregateDocument = gql`
    query PostHogStatsTripperAggregate($timestampRange: DateInput!, $organizationId: ID!, $itineraryId: ID, $widgetId: ID) {
  postHogStatsTripperAggregate(
    timestampRange: $timestampRange
    organizationId: $organizationId
    itineraryId: $itineraryId
    widgetId: $widgetId
  ) {
    views
    engagements
    referrals
    pdfDownloads
  }
}
    `;

/**
 * __usePostHogStatsTripperAggregateQuery__
 *
 * To run a query within a React component, call `usePostHogStatsTripperAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostHogStatsTripperAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostHogStatsTripperAggregateQuery({
 *   variables: {
 *      timestampRange: // value for 'timestampRange'
 *      organizationId: // value for 'organizationId'
 *      itineraryId: // value for 'itineraryId'
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function usePostHogStatsTripperAggregateQuery(baseOptions: Apollo.QueryHookOptions<PostHogStatsTripperAggregateQuery, PostHogStatsTripperAggregateQueryVariables> & ({ variables: PostHogStatsTripperAggregateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostHogStatsTripperAggregateQuery, PostHogStatsTripperAggregateQueryVariables>(PostHogStatsTripperAggregateDocument, options);
      }
export function usePostHogStatsTripperAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostHogStatsTripperAggregateQuery, PostHogStatsTripperAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostHogStatsTripperAggregateQuery, PostHogStatsTripperAggregateQueryVariables>(PostHogStatsTripperAggregateDocument, options);
        }
// @ts-ignore
export function usePostHogStatsTripperAggregateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PostHogStatsTripperAggregateQuery, PostHogStatsTripperAggregateQueryVariables>): Apollo.UseSuspenseQueryResult<PostHogStatsTripperAggregateQuery, PostHogStatsTripperAggregateQueryVariables>;
export function usePostHogStatsTripperAggregateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostHogStatsTripperAggregateQuery, PostHogStatsTripperAggregateQueryVariables>): Apollo.UseSuspenseQueryResult<PostHogStatsTripperAggregateQuery | undefined, PostHogStatsTripperAggregateQueryVariables>;
export function usePostHogStatsTripperAggregateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostHogStatsTripperAggregateQuery, PostHogStatsTripperAggregateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostHogStatsTripperAggregateQuery, PostHogStatsTripperAggregateQueryVariables>(PostHogStatsTripperAggregateDocument, options);
        }
export type PostHogStatsTripperAggregateQueryHookResult = ReturnType<typeof usePostHogStatsTripperAggregateQuery>;
export type PostHogStatsTripperAggregateLazyQueryHookResult = ReturnType<typeof usePostHogStatsTripperAggregateLazyQuery>;
export type PostHogStatsTripperAggregateSuspenseQueryHookResult = ReturnType<typeof usePostHogStatsTripperAggregateSuspenseQuery>;
export type PostHogStatsTripperAggregateQueryResult = Apollo.QueryResult<PostHogStatsTripperAggregateQuery, PostHogStatsTripperAggregateQueryVariables>;
export const PostHogStatsTripperOperatorsDocument = gql`
    query PostHogStatsTripperOperators($timestampRange: DateInput!, $appContext: PostHogAppContext!, $organizationId: ID, $itineraryId: ID, $widgetId: ID) {
  postHogStatsTripperOperators(
    timestampRange: $timestampRange
    appContext: $appContext
    organizationId: $organizationId
    itineraryId: $itineraryId
    widgetId: $widgetId
  ) {
    views
    clicks
    referrals
    metadata {
      operator {
        _entityId
        name {
          ...MultilingualFragment
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __usePostHogStatsTripperOperatorsQuery__
 *
 * To run a query within a React component, call `usePostHogStatsTripperOperatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostHogStatsTripperOperatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostHogStatsTripperOperatorsQuery({
 *   variables: {
 *      timestampRange: // value for 'timestampRange'
 *      appContext: // value for 'appContext'
 *      organizationId: // value for 'organizationId'
 *      itineraryId: // value for 'itineraryId'
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function usePostHogStatsTripperOperatorsQuery(baseOptions: Apollo.QueryHookOptions<PostHogStatsTripperOperatorsQuery, PostHogStatsTripperOperatorsQueryVariables> & ({ variables: PostHogStatsTripperOperatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostHogStatsTripperOperatorsQuery, PostHogStatsTripperOperatorsQueryVariables>(PostHogStatsTripperOperatorsDocument, options);
      }
export function usePostHogStatsTripperOperatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostHogStatsTripperOperatorsQuery, PostHogStatsTripperOperatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostHogStatsTripperOperatorsQuery, PostHogStatsTripperOperatorsQueryVariables>(PostHogStatsTripperOperatorsDocument, options);
        }
// @ts-ignore
export function usePostHogStatsTripperOperatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PostHogStatsTripperOperatorsQuery, PostHogStatsTripperOperatorsQueryVariables>): Apollo.UseSuspenseQueryResult<PostHogStatsTripperOperatorsQuery, PostHogStatsTripperOperatorsQueryVariables>;
export function usePostHogStatsTripperOperatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostHogStatsTripperOperatorsQuery, PostHogStatsTripperOperatorsQueryVariables>): Apollo.UseSuspenseQueryResult<PostHogStatsTripperOperatorsQuery | undefined, PostHogStatsTripperOperatorsQueryVariables>;
export function usePostHogStatsTripperOperatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostHogStatsTripperOperatorsQuery, PostHogStatsTripperOperatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostHogStatsTripperOperatorsQuery, PostHogStatsTripperOperatorsQueryVariables>(PostHogStatsTripperOperatorsDocument, options);
        }
export type PostHogStatsTripperOperatorsQueryHookResult = ReturnType<typeof usePostHogStatsTripperOperatorsQuery>;
export type PostHogStatsTripperOperatorsLazyQueryHookResult = ReturnType<typeof usePostHogStatsTripperOperatorsLazyQuery>;
export type PostHogStatsTripperOperatorsSuspenseQueryHookResult = ReturnType<typeof usePostHogStatsTripperOperatorsSuspenseQuery>;
export type PostHogStatsTripperOperatorsQueryResult = Apollo.QueryResult<PostHogStatsTripperOperatorsQuery, PostHogStatsTripperOperatorsQueryVariables>;
export const PostHogStatsTripperTimeSeriesDocument = gql`
    query PostHogStatsTripperTimeSeries($timestampRange: DateInput!, $organizationId: ID!, $itineraryId: ID, $widgetId: ID) {
  postHogStatsTripperTimeSeries(
    timestampRange: $timestampRange
    organizationId: $organizationId
    itineraryId: $itineraryId
    widgetId: $widgetId
  ) {
    date
    views
    engagements
    referrals
    pdfDownloads
  }
}
    `;

/**
 * __usePostHogStatsTripperTimeSeriesQuery__
 *
 * To run a query within a React component, call `usePostHogStatsTripperTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostHogStatsTripperTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostHogStatsTripperTimeSeriesQuery({
 *   variables: {
 *      timestampRange: // value for 'timestampRange'
 *      organizationId: // value for 'organizationId'
 *      itineraryId: // value for 'itineraryId'
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function usePostHogStatsTripperTimeSeriesQuery(baseOptions: Apollo.QueryHookOptions<PostHogStatsTripperTimeSeriesQuery, PostHogStatsTripperTimeSeriesQueryVariables> & ({ variables: PostHogStatsTripperTimeSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostHogStatsTripperTimeSeriesQuery, PostHogStatsTripperTimeSeriesQueryVariables>(PostHogStatsTripperTimeSeriesDocument, options);
      }
export function usePostHogStatsTripperTimeSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostHogStatsTripperTimeSeriesQuery, PostHogStatsTripperTimeSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostHogStatsTripperTimeSeriesQuery, PostHogStatsTripperTimeSeriesQueryVariables>(PostHogStatsTripperTimeSeriesDocument, options);
        }
// @ts-ignore
export function usePostHogStatsTripperTimeSeriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PostHogStatsTripperTimeSeriesQuery, PostHogStatsTripperTimeSeriesQueryVariables>): Apollo.UseSuspenseQueryResult<PostHogStatsTripperTimeSeriesQuery, PostHogStatsTripperTimeSeriesQueryVariables>;
export function usePostHogStatsTripperTimeSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostHogStatsTripperTimeSeriesQuery, PostHogStatsTripperTimeSeriesQueryVariables>): Apollo.UseSuspenseQueryResult<PostHogStatsTripperTimeSeriesQuery | undefined, PostHogStatsTripperTimeSeriesQueryVariables>;
export function usePostHogStatsTripperTimeSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostHogStatsTripperTimeSeriesQuery, PostHogStatsTripperTimeSeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostHogStatsTripperTimeSeriesQuery, PostHogStatsTripperTimeSeriesQueryVariables>(PostHogStatsTripperTimeSeriesDocument, options);
        }
export type PostHogStatsTripperTimeSeriesQueryHookResult = ReturnType<typeof usePostHogStatsTripperTimeSeriesQuery>;
export type PostHogStatsTripperTimeSeriesLazyQueryHookResult = ReturnType<typeof usePostHogStatsTripperTimeSeriesLazyQuery>;
export type PostHogStatsTripperTimeSeriesSuspenseQueryHookResult = ReturnType<typeof usePostHogStatsTripperTimeSeriesSuspenseQuery>;
export type PostHogStatsTripperTimeSeriesQueryResult = Apollo.QueryResult<PostHogStatsTripperTimeSeriesQuery, PostHogStatsTripperTimeSeriesQueryVariables>;
export const PostHogStatsWidgetEventsDocument = gql`
    query PostHogStatsWidgetEvents($timestampRange: DateInput!, $appContext: PostHogAppContext!, $organizationId: ID) {
  postHogStatsWidgetEvents(
    timestampRange: $timestampRange
    appContext: $appContext
    organizationId: $organizationId
  ) {
    impressions
    outboundClicks
    views
    metadata {
      event {
        _id
        title {
          ...MultilingualFragment
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __usePostHogStatsWidgetEventsQuery__
 *
 * To run a query within a React component, call `usePostHogStatsWidgetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostHogStatsWidgetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostHogStatsWidgetEventsQuery({
 *   variables: {
 *      timestampRange: // value for 'timestampRange'
 *      appContext: // value for 'appContext'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function usePostHogStatsWidgetEventsQuery(baseOptions: Apollo.QueryHookOptions<PostHogStatsWidgetEventsQuery, PostHogStatsWidgetEventsQueryVariables> & ({ variables: PostHogStatsWidgetEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostHogStatsWidgetEventsQuery, PostHogStatsWidgetEventsQueryVariables>(PostHogStatsWidgetEventsDocument, options);
      }
export function usePostHogStatsWidgetEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostHogStatsWidgetEventsQuery, PostHogStatsWidgetEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostHogStatsWidgetEventsQuery, PostHogStatsWidgetEventsQueryVariables>(PostHogStatsWidgetEventsDocument, options);
        }
// @ts-ignore
export function usePostHogStatsWidgetEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PostHogStatsWidgetEventsQuery, PostHogStatsWidgetEventsQueryVariables>): Apollo.UseSuspenseQueryResult<PostHogStatsWidgetEventsQuery, PostHogStatsWidgetEventsQueryVariables>;
export function usePostHogStatsWidgetEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostHogStatsWidgetEventsQuery, PostHogStatsWidgetEventsQueryVariables>): Apollo.UseSuspenseQueryResult<PostHogStatsWidgetEventsQuery | undefined, PostHogStatsWidgetEventsQueryVariables>;
export function usePostHogStatsWidgetEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostHogStatsWidgetEventsQuery, PostHogStatsWidgetEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostHogStatsWidgetEventsQuery, PostHogStatsWidgetEventsQueryVariables>(PostHogStatsWidgetEventsDocument, options);
        }
export type PostHogStatsWidgetEventsQueryHookResult = ReturnType<typeof usePostHogStatsWidgetEventsQuery>;
export type PostHogStatsWidgetEventsLazyQueryHookResult = ReturnType<typeof usePostHogStatsWidgetEventsLazyQuery>;
export type PostHogStatsWidgetEventsSuspenseQueryHookResult = ReturnType<typeof usePostHogStatsWidgetEventsSuspenseQuery>;
export type PostHogStatsWidgetEventsQueryResult = Apollo.QueryResult<PostHogStatsWidgetEventsQuery, PostHogStatsWidgetEventsQueryVariables>;
export const PostHogStatsWidgetOperatorsDocument = gql`
    query PostHogStatsWidgetOperators($timestampRange: DateInput!, $appContext: PostHogAppContext!, $organizationId: ID, $listId: ID) {
  postHogStatsWidgetOperators(
    timestampRange: $timestampRange
    appContext: $appContext
    organizationId: $organizationId
    listId: $listId
  ) {
    impressions
    outboundClicks
    views
    metadata {
      operator {
        _entityId
        name {
          ...MultilingualFragment
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __usePostHogStatsWidgetOperatorsQuery__
 *
 * To run a query within a React component, call `usePostHogStatsWidgetOperatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostHogStatsWidgetOperatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostHogStatsWidgetOperatorsQuery({
 *   variables: {
 *      timestampRange: // value for 'timestampRange'
 *      appContext: // value for 'appContext'
 *      organizationId: // value for 'organizationId'
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function usePostHogStatsWidgetOperatorsQuery(baseOptions: Apollo.QueryHookOptions<PostHogStatsWidgetOperatorsQuery, PostHogStatsWidgetOperatorsQueryVariables> & ({ variables: PostHogStatsWidgetOperatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostHogStatsWidgetOperatorsQuery, PostHogStatsWidgetOperatorsQueryVariables>(PostHogStatsWidgetOperatorsDocument, options);
      }
export function usePostHogStatsWidgetOperatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostHogStatsWidgetOperatorsQuery, PostHogStatsWidgetOperatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostHogStatsWidgetOperatorsQuery, PostHogStatsWidgetOperatorsQueryVariables>(PostHogStatsWidgetOperatorsDocument, options);
        }
// @ts-ignore
export function usePostHogStatsWidgetOperatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PostHogStatsWidgetOperatorsQuery, PostHogStatsWidgetOperatorsQueryVariables>): Apollo.UseSuspenseQueryResult<PostHogStatsWidgetOperatorsQuery, PostHogStatsWidgetOperatorsQueryVariables>;
export function usePostHogStatsWidgetOperatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostHogStatsWidgetOperatorsQuery, PostHogStatsWidgetOperatorsQueryVariables>): Apollo.UseSuspenseQueryResult<PostHogStatsWidgetOperatorsQuery | undefined, PostHogStatsWidgetOperatorsQueryVariables>;
export function usePostHogStatsWidgetOperatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostHogStatsWidgetOperatorsQuery, PostHogStatsWidgetOperatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostHogStatsWidgetOperatorsQuery, PostHogStatsWidgetOperatorsQueryVariables>(PostHogStatsWidgetOperatorsDocument, options);
        }
export type PostHogStatsWidgetOperatorsQueryHookResult = ReturnType<typeof usePostHogStatsWidgetOperatorsQuery>;
export type PostHogStatsWidgetOperatorsLazyQueryHookResult = ReturnType<typeof usePostHogStatsWidgetOperatorsLazyQuery>;
export type PostHogStatsWidgetOperatorsSuspenseQueryHookResult = ReturnType<typeof usePostHogStatsWidgetOperatorsSuspenseQuery>;
export type PostHogStatsWidgetOperatorsQueryResult = Apollo.QueryResult<PostHogStatsWidgetOperatorsQuery, PostHogStatsWidgetOperatorsQueryVariables>;
export const ProductCalendarLinkByIdDocument = gql`
    query ProductCalendarLinkById($id: ID!) {
  productCalendarLinkById(id: $id)
}
    `;

/**
 * __useProductCalendarLinkByIdQuery__
 *
 * To run a query within a React component, call `useProductCalendarLinkByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCalendarLinkByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCalendarLinkByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductCalendarLinkByIdQuery(baseOptions: Apollo.QueryHookOptions<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables> & ({ variables: ProductCalendarLinkByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables>(ProductCalendarLinkByIdDocument, options);
      }
export function useProductCalendarLinkByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables>(ProductCalendarLinkByIdDocument, options);
        }
// @ts-ignore
export function useProductCalendarLinkByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables>;
export function useProductCalendarLinkByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ProductCalendarLinkByIdQuery | undefined, ProductCalendarLinkByIdQueryVariables>;
export function useProductCalendarLinkByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables>(ProductCalendarLinkByIdDocument, options);
        }
export type ProductCalendarLinkByIdQueryHookResult = ReturnType<typeof useProductCalendarLinkByIdQuery>;
export type ProductCalendarLinkByIdLazyQueryHookResult = ReturnType<typeof useProductCalendarLinkByIdLazyQuery>;
export type ProductCalendarLinkByIdSuspenseQueryHookResult = ReturnType<typeof useProductCalendarLinkByIdSuspenseQuery>;
export type ProductCalendarLinkByIdQueryResult = Apollo.QueryResult<ProductCalendarLinkByIdQuery, ProductCalendarLinkByIdQueryVariables>;
export const ProductClosureByIdDocument = gql`
    query ProductClosureById($closureId: ID!) {
  productClosureById(closureId: $closureId) {
    productIds
    closure {
      _id
      dateRangeISO {
        _id
        end
        start
        metadata
      }
      name
    }
  }
}
    `;

/**
 * __useProductClosureByIdQuery__
 *
 * To run a query within a React component, call `useProductClosureByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductClosureByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductClosureByIdQuery({
 *   variables: {
 *      closureId: // value for 'closureId'
 *   },
 * });
 */
export function useProductClosureByIdQuery(baseOptions: Apollo.QueryHookOptions<ProductClosureByIdQuery, ProductClosureByIdQueryVariables> & ({ variables: ProductClosureByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductClosureByIdQuery, ProductClosureByIdQueryVariables>(ProductClosureByIdDocument, options);
      }
export function useProductClosureByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductClosureByIdQuery, ProductClosureByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductClosureByIdQuery, ProductClosureByIdQueryVariables>(ProductClosureByIdDocument, options);
        }
// @ts-ignore
export function useProductClosureByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductClosureByIdQuery, ProductClosureByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ProductClosureByIdQuery, ProductClosureByIdQueryVariables>;
export function useProductClosureByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductClosureByIdQuery, ProductClosureByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ProductClosureByIdQuery | undefined, ProductClosureByIdQueryVariables>;
export function useProductClosureByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductClosureByIdQuery, ProductClosureByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductClosureByIdQuery, ProductClosureByIdQueryVariables>(ProductClosureByIdDocument, options);
        }
export type ProductClosureByIdQueryHookResult = ReturnType<typeof useProductClosureByIdQuery>;
export type ProductClosureByIdLazyQueryHookResult = ReturnType<typeof useProductClosureByIdLazyQuery>;
export type ProductClosureByIdSuspenseQueryHookResult = ReturnType<typeof useProductClosureByIdSuspenseQuery>;
export type ProductClosureByIdQueryResult = Apollo.QueryResult<ProductClosureByIdQuery, ProductClosureByIdQueryVariables>;
export const ProductInBookersDocument = gql`
    query ProductInBookers($productId: ID!, $notInBookerId: ID) {
  productInBookers(productId: $productId, notInBookerId: $notInBookerId) {
    ...MultilingualFragment
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useProductInBookersQuery__
 *
 * To run a query within a React component, call `useProductInBookersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductInBookersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductInBookersQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      notInBookerId: // value for 'notInBookerId'
 *   },
 * });
 */
export function useProductInBookersQuery(baseOptions: Apollo.QueryHookOptions<ProductInBookersQuery, ProductInBookersQueryVariables> & ({ variables: ProductInBookersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductInBookersQuery, ProductInBookersQueryVariables>(ProductInBookersDocument, options);
      }
export function useProductInBookersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductInBookersQuery, ProductInBookersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductInBookersQuery, ProductInBookersQueryVariables>(ProductInBookersDocument, options);
        }
// @ts-ignore
export function useProductInBookersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductInBookersQuery, ProductInBookersQueryVariables>): Apollo.UseSuspenseQueryResult<ProductInBookersQuery, ProductInBookersQueryVariables>;
export function useProductInBookersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductInBookersQuery, ProductInBookersQueryVariables>): Apollo.UseSuspenseQueryResult<ProductInBookersQuery | undefined, ProductInBookersQueryVariables>;
export function useProductInBookersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductInBookersQuery, ProductInBookersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductInBookersQuery, ProductInBookersQueryVariables>(ProductInBookersDocument, options);
        }
export type ProductInBookersQueryHookResult = ReturnType<typeof useProductInBookersQuery>;
export type ProductInBookersLazyQueryHookResult = ReturnType<typeof useProductInBookersLazyQuery>;
export type ProductInBookersSuspenseQueryHookResult = ReturnType<typeof useProductInBookersSuspenseQuery>;
export type ProductInBookersQueryResult = Apollo.QueryResult<ProductInBookersQuery, ProductInBookersQueryVariables>;
export const ProductManyDocument = gql`
    query ProductMany($filter: FilterFindManyProductInput, $limit: Int) {
  productMany(filter: $filter, limit: $limit) {
    ...ProductFragment
  }
}
    ${ProductFragmentFragmentDoc}`;

/**
 * __useProductManyQuery__
 *
 * To run a query within a React component, call `useProductManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProductManyQuery(baseOptions?: Apollo.QueryHookOptions<ProductManyQuery, ProductManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductManyQuery, ProductManyQueryVariables>(ProductManyDocument, options);
      }
export function useProductManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductManyQuery, ProductManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductManyQuery, ProductManyQueryVariables>(ProductManyDocument, options);
        }
// @ts-ignore
export function useProductManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductManyQuery, ProductManyQueryVariables>): Apollo.UseSuspenseQueryResult<ProductManyQuery, ProductManyQueryVariables>;
export function useProductManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductManyQuery, ProductManyQueryVariables>): Apollo.UseSuspenseQueryResult<ProductManyQuery | undefined, ProductManyQueryVariables>;
export function useProductManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductManyQuery, ProductManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductManyQuery, ProductManyQueryVariables>(ProductManyDocument, options);
        }
export type ProductManyQueryHookResult = ReturnType<typeof useProductManyQuery>;
export type ProductManyLazyQueryHookResult = ReturnType<typeof useProductManyLazyQuery>;
export type ProductManySuspenseQueryHookResult = ReturnType<typeof useProductManySuspenseQuery>;
export type ProductManyQueryResult = Apollo.QueryResult<ProductManyQuery, ProductManyQueryVariables>;
export const PromotionByIdDocument = gql`
    query PromotionById($id: MongoID!) {
  promotionById(_id: $id) {
    ...PromotionFragment
  }
}
    ${PromotionFragmentFragmentDoc}`;

/**
 * __usePromotionByIdQuery__
 *
 * To run a query within a React component, call `usePromotionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromotionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromotionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePromotionByIdQuery(baseOptions: Apollo.QueryHookOptions<PromotionByIdQuery, PromotionByIdQueryVariables> & ({ variables: PromotionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromotionByIdQuery, PromotionByIdQueryVariables>(PromotionByIdDocument, options);
      }
export function usePromotionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromotionByIdQuery, PromotionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromotionByIdQuery, PromotionByIdQueryVariables>(PromotionByIdDocument, options);
        }
// @ts-ignore
export function usePromotionByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromotionByIdQuery, PromotionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<PromotionByIdQuery, PromotionByIdQueryVariables>;
export function usePromotionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromotionByIdQuery, PromotionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<PromotionByIdQuery | undefined, PromotionByIdQueryVariables>;
export function usePromotionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromotionByIdQuery, PromotionByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromotionByIdQuery, PromotionByIdQueryVariables>(PromotionByIdDocument, options);
        }
export type PromotionByIdQueryHookResult = ReturnType<typeof usePromotionByIdQuery>;
export type PromotionByIdLazyQueryHookResult = ReturnType<typeof usePromotionByIdLazyQuery>;
export type PromotionByIdSuspenseQueryHookResult = ReturnType<typeof usePromotionByIdSuspenseQuery>;
export type PromotionByIdQueryResult = Apollo.QueryResult<PromotionByIdQuery, PromotionByIdQueryVariables>;
export const PromotionEligibleOrganizationsDocument = gql`
    query PromotionEligibleOrganizations($operatorEntityId: ID!) {
  promotionEligibleOrganizations(operatorEntityId: $operatorEntityId) {
    _id
    name {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __usePromotionEligibleOrganizationsQuery__
 *
 * To run a query within a React component, call `usePromotionEligibleOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromotionEligibleOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromotionEligibleOrganizationsQuery({
 *   variables: {
 *      operatorEntityId: // value for 'operatorEntityId'
 *   },
 * });
 */
export function usePromotionEligibleOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<PromotionEligibleOrganizationsQuery, PromotionEligibleOrganizationsQueryVariables> & ({ variables: PromotionEligibleOrganizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromotionEligibleOrganizationsQuery, PromotionEligibleOrganizationsQueryVariables>(PromotionEligibleOrganizationsDocument, options);
      }
export function usePromotionEligibleOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromotionEligibleOrganizationsQuery, PromotionEligibleOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromotionEligibleOrganizationsQuery, PromotionEligibleOrganizationsQueryVariables>(PromotionEligibleOrganizationsDocument, options);
        }
// @ts-ignore
export function usePromotionEligibleOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromotionEligibleOrganizationsQuery, PromotionEligibleOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<PromotionEligibleOrganizationsQuery, PromotionEligibleOrganizationsQueryVariables>;
export function usePromotionEligibleOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromotionEligibleOrganizationsQuery, PromotionEligibleOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<PromotionEligibleOrganizationsQuery | undefined, PromotionEligibleOrganizationsQueryVariables>;
export function usePromotionEligibleOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromotionEligibleOrganizationsQuery, PromotionEligibleOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromotionEligibleOrganizationsQuery, PromotionEligibleOrganizationsQueryVariables>(PromotionEligibleOrganizationsDocument, options);
        }
export type PromotionEligibleOrganizationsQueryHookResult = ReturnType<typeof usePromotionEligibleOrganizationsQuery>;
export type PromotionEligibleOrganizationsLazyQueryHookResult = ReturnType<typeof usePromotionEligibleOrganizationsLazyQuery>;
export type PromotionEligibleOrganizationsSuspenseQueryHookResult = ReturnType<typeof usePromotionEligibleOrganizationsSuspenseQuery>;
export type PromotionEligibleOrganizationsQueryResult = Apollo.QueryResult<PromotionEligibleOrganizationsQuery, PromotionEligibleOrganizationsQueryVariables>;
export const PromotionManyDocument = gql`
    query PromotionMany($organizationId: ID, $operatorId: ID, $operatorIds: [ID], $status: EnumPromotionAccessOperatorStatus, $timeframe: PromotionTimeframe, $tags: [ID], $limit: Int) {
  promotionMany(
    organizationId: $organizationId
    operatorId: $operatorId
    operatorIds: $operatorIds
    status: $status
    timeframe: $timeframe
    tags: $tags
    limit: $limit
  ) {
    ...PromotionFragment
  }
}
    ${PromotionFragmentFragmentDoc}`;

/**
 * __usePromotionManyQuery__
 *
 * To run a query within a React component, call `usePromotionManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromotionManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromotionManyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      operatorId: // value for 'operatorId'
 *      operatorIds: // value for 'operatorIds'
 *      status: // value for 'status'
 *      timeframe: // value for 'timeframe'
 *      tags: // value for 'tags'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePromotionManyQuery(baseOptions?: Apollo.QueryHookOptions<PromotionManyQuery, PromotionManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromotionManyQuery, PromotionManyQueryVariables>(PromotionManyDocument, options);
      }
export function usePromotionManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromotionManyQuery, PromotionManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromotionManyQuery, PromotionManyQueryVariables>(PromotionManyDocument, options);
        }
// @ts-ignore
export function usePromotionManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromotionManyQuery, PromotionManyQueryVariables>): Apollo.UseSuspenseQueryResult<PromotionManyQuery, PromotionManyQueryVariables>;
export function usePromotionManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromotionManyQuery, PromotionManyQueryVariables>): Apollo.UseSuspenseQueryResult<PromotionManyQuery | undefined, PromotionManyQueryVariables>;
export function usePromotionManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromotionManyQuery, PromotionManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromotionManyQuery, PromotionManyQueryVariables>(PromotionManyDocument, options);
        }
export type PromotionManyQueryHookResult = ReturnType<typeof usePromotionManyQuery>;
export type PromotionManyLazyQueryHookResult = ReturnType<typeof usePromotionManyLazyQuery>;
export type PromotionManySuspenseQueryHookResult = ReturnType<typeof usePromotionManySuspenseQuery>;
export type PromotionManyQueryResult = Apollo.QueryResult<PromotionManyQuery, PromotionManyQueryVariables>;
export const PromotionManyPromotionsWidgetDocument = gql`
    query PromotionManyPromotionsWidget($organizationId: ID, $tags: [ID], $limit: Int) {
  promotionMany(
    organizationId: $organizationId
    tags: $tags
    timeframe: Active
    limit: $limit
  ) {
    _id
    title {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    link
    availability {
      type
      dates
      startDate
      endDate
    }
    firstDate
    lastDate
    images {
      ...ImageFragment
    }
    tags {
      organizationSpecific {
        _id
        name {
          ...MultilingualFragment
        }
      }
    }
    access {
      operator {
        _entityId
      }
    }
    listing {
      _entityId
      _versionId
      name {
        ...MultilingualFragment
      }
      shortDescription {
        ...MultilingualFragment
      }
      description {
        ...MultilingualFragment
      }
      type
      operationalStatus
      status
      images {
        ...ImageFragment
      }
      contact {
        email
        address {
          ...AddressFragment
        }
      }
      hoursOfOperation {
        sun {
          ...DateRangeISOFragment
        }
        mon {
          ...DateRangeISOFragment
        }
        tue {
          ...DateRangeISOFragment
        }
        wed {
          ...DateRangeISOFragment
        }
        thu {
          ...DateRangeISOFragment
        }
        fri {
          ...DateRangeISOFragment
        }
        sat {
          ...DateRangeISOFragment
        }
      }
      pricing
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${DateRangeIsoFragmentFragmentDoc}`;

/**
 * __usePromotionManyPromotionsWidgetQuery__
 *
 * To run a query within a React component, call `usePromotionManyPromotionsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromotionManyPromotionsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromotionManyPromotionsWidgetQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      tags: // value for 'tags'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePromotionManyPromotionsWidgetQuery(baseOptions?: Apollo.QueryHookOptions<PromotionManyPromotionsWidgetQuery, PromotionManyPromotionsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromotionManyPromotionsWidgetQuery, PromotionManyPromotionsWidgetQueryVariables>(PromotionManyPromotionsWidgetDocument, options);
      }
export function usePromotionManyPromotionsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromotionManyPromotionsWidgetQuery, PromotionManyPromotionsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromotionManyPromotionsWidgetQuery, PromotionManyPromotionsWidgetQueryVariables>(PromotionManyPromotionsWidgetDocument, options);
        }
// @ts-ignore
export function usePromotionManyPromotionsWidgetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromotionManyPromotionsWidgetQuery, PromotionManyPromotionsWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<PromotionManyPromotionsWidgetQuery, PromotionManyPromotionsWidgetQueryVariables>;
export function usePromotionManyPromotionsWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromotionManyPromotionsWidgetQuery, PromotionManyPromotionsWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<PromotionManyPromotionsWidgetQuery | undefined, PromotionManyPromotionsWidgetQueryVariables>;
export function usePromotionManyPromotionsWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromotionManyPromotionsWidgetQuery, PromotionManyPromotionsWidgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromotionManyPromotionsWidgetQuery, PromotionManyPromotionsWidgetQueryVariables>(PromotionManyPromotionsWidgetDocument, options);
        }
export type PromotionManyPromotionsWidgetQueryHookResult = ReturnType<typeof usePromotionManyPromotionsWidgetQuery>;
export type PromotionManyPromotionsWidgetLazyQueryHookResult = ReturnType<typeof usePromotionManyPromotionsWidgetLazyQuery>;
export type PromotionManyPromotionsWidgetSuspenseQueryHookResult = ReturnType<typeof usePromotionManyPromotionsWidgetSuspenseQuery>;
export type PromotionManyPromotionsWidgetQueryResult = Apollo.QueryResult<PromotionManyPromotionsWidgetQuery, PromotionManyPromotionsWidgetQueryVariables>;
export const PromotionManyWidgetDocument = gql`
    query PromotionManyWidget($organizationId: ID, $operatorIds: [ID], $limit: Int) {
  promotionMany(
    organizationId: $organizationId
    operatorIds: $operatorIds
    timeframe: Active
    limit: $limit
  ) {
    _id
    title {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    link
    availability {
      type
      dates
      startDate
      endDate
    }
    firstDate
    lastDate
    images {
      ...ImageFragment
    }
    access {
      operator {
        _entityId
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __usePromotionManyWidgetQuery__
 *
 * To run a query within a React component, call `usePromotionManyWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromotionManyWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromotionManyWidgetQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      operatorIds: // value for 'operatorIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePromotionManyWidgetQuery(baseOptions?: Apollo.QueryHookOptions<PromotionManyWidgetQuery, PromotionManyWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromotionManyWidgetQuery, PromotionManyWidgetQueryVariables>(PromotionManyWidgetDocument, options);
      }
export function usePromotionManyWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromotionManyWidgetQuery, PromotionManyWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromotionManyWidgetQuery, PromotionManyWidgetQueryVariables>(PromotionManyWidgetDocument, options);
        }
// @ts-ignore
export function usePromotionManyWidgetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromotionManyWidgetQuery, PromotionManyWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<PromotionManyWidgetQuery, PromotionManyWidgetQueryVariables>;
export function usePromotionManyWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromotionManyWidgetQuery, PromotionManyWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<PromotionManyWidgetQuery | undefined, PromotionManyWidgetQueryVariables>;
export function usePromotionManyWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromotionManyWidgetQuery, PromotionManyWidgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromotionManyWidgetQuery, PromotionManyWidgetQueryVariables>(PromotionManyWidgetDocument, options);
        }
export type PromotionManyWidgetQueryHookResult = ReturnType<typeof usePromotionManyWidgetQuery>;
export type PromotionManyWidgetLazyQueryHookResult = ReturnType<typeof usePromotionManyWidgetLazyQuery>;
export type PromotionManyWidgetSuspenseQueryHookResult = ReturnType<typeof usePromotionManyWidgetSuspenseQuery>;
export type PromotionManyWidgetQueryResult = Apollo.QueryResult<PromotionManyWidgetQuery, PromotionManyWidgetQueryVariables>;
export const PublicMediaCountDocument = gql`
    query PublicMediaCount($organizationId: MongoID, $status: String, $needsAttentionOnly: Boolean) {
  publicMediaCount(
    organizationId: $organizationId
    status: $status
    needsAttentionOnly: $needsAttentionOnly
  )
}
    `;

/**
 * __usePublicMediaCountQuery__
 *
 * To run a query within a React component, call `usePublicMediaCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicMediaCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicMediaCountQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      status: // value for 'status'
 *      needsAttentionOnly: // value for 'needsAttentionOnly'
 *   },
 * });
 */
export function usePublicMediaCountQuery(baseOptions?: Apollo.QueryHookOptions<PublicMediaCountQuery, PublicMediaCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicMediaCountQuery, PublicMediaCountQueryVariables>(PublicMediaCountDocument, options);
      }
export function usePublicMediaCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicMediaCountQuery, PublicMediaCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicMediaCountQuery, PublicMediaCountQueryVariables>(PublicMediaCountDocument, options);
        }
// @ts-ignore
export function usePublicMediaCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicMediaCountQuery, PublicMediaCountQueryVariables>): Apollo.UseSuspenseQueryResult<PublicMediaCountQuery, PublicMediaCountQueryVariables>;
export function usePublicMediaCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicMediaCountQuery, PublicMediaCountQueryVariables>): Apollo.UseSuspenseQueryResult<PublicMediaCountQuery | undefined, PublicMediaCountQueryVariables>;
export function usePublicMediaCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicMediaCountQuery, PublicMediaCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicMediaCountQuery, PublicMediaCountQueryVariables>(PublicMediaCountDocument, options);
        }
export type PublicMediaCountQueryHookResult = ReturnType<typeof usePublicMediaCountQuery>;
export type PublicMediaCountLazyQueryHookResult = ReturnType<typeof usePublicMediaCountLazyQuery>;
export type PublicMediaCountSuspenseQueryHookResult = ReturnType<typeof usePublicMediaCountSuspenseQuery>;
export type PublicMediaCountQueryResult = Apollo.QueryResult<PublicMediaCountQuery, PublicMediaCountQueryVariables>;
export const PublicMediaForGalleryWidgetDocument = gql`
    query PublicMediaForGalleryWidget($widgetId: MongoID!, $organizationId: MongoID!, $mode: String, $excludeIds: [MongoID!], $limit: Int, $skip: Int) {
  publicMediaForGalleryWidget(
    widgetId: $widgetId
    organizationId: $organizationId
    mode: $mode
    excludeIds: $excludeIds
    limit: $limit
    skip: $skip
  ) {
    _id
    mediaType
    asset
    width
    height
    posterUrl
    carouselThumbnailAsset
    useCarouselThumbnail
    blurhash
    ctaLink
    copyright
    likeCount
    relatedListings
    relatedListingNames
    headline {
      en
      es
      fr
    }
    caption {
      en
      es
      fr
    }
    mux {
      assetId
      playbackId
    }
  }
}
    `;

/**
 * __usePublicMediaForGalleryWidgetQuery__
 *
 * To run a query within a React component, call `usePublicMediaForGalleryWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicMediaForGalleryWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicMediaForGalleryWidgetQuery({
 *   variables: {
 *      widgetId: // value for 'widgetId'
 *      organizationId: // value for 'organizationId'
 *      mode: // value for 'mode'
 *      excludeIds: // value for 'excludeIds'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePublicMediaForGalleryWidgetQuery(baseOptions: Apollo.QueryHookOptions<PublicMediaForGalleryWidgetQuery, PublicMediaForGalleryWidgetQueryVariables> & ({ variables: PublicMediaForGalleryWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicMediaForGalleryWidgetQuery, PublicMediaForGalleryWidgetQueryVariables>(PublicMediaForGalleryWidgetDocument, options);
      }
export function usePublicMediaForGalleryWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicMediaForGalleryWidgetQuery, PublicMediaForGalleryWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicMediaForGalleryWidgetQuery, PublicMediaForGalleryWidgetQueryVariables>(PublicMediaForGalleryWidgetDocument, options);
        }
// @ts-ignore
export function usePublicMediaForGalleryWidgetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicMediaForGalleryWidgetQuery, PublicMediaForGalleryWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<PublicMediaForGalleryWidgetQuery, PublicMediaForGalleryWidgetQueryVariables>;
export function usePublicMediaForGalleryWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicMediaForGalleryWidgetQuery, PublicMediaForGalleryWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<PublicMediaForGalleryWidgetQuery | undefined, PublicMediaForGalleryWidgetQueryVariables>;
export function usePublicMediaForGalleryWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicMediaForGalleryWidgetQuery, PublicMediaForGalleryWidgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicMediaForGalleryWidgetQuery, PublicMediaForGalleryWidgetQueryVariables>(PublicMediaForGalleryWidgetDocument, options);
        }
export type PublicMediaForGalleryWidgetQueryHookResult = ReturnType<typeof usePublicMediaForGalleryWidgetQuery>;
export type PublicMediaForGalleryWidgetLazyQueryHookResult = ReturnType<typeof usePublicMediaForGalleryWidgetLazyQuery>;
export type PublicMediaForGalleryWidgetSuspenseQueryHookResult = ReturnType<typeof usePublicMediaForGalleryWidgetSuspenseQuery>;
export type PublicMediaForGalleryWidgetQueryResult = Apollo.QueryResult<PublicMediaForGalleryWidgetQuery, PublicMediaForGalleryWidgetQueryVariables>;
export const PublicMediaManyDocument = gql`
    query PublicMediaMany($organizationId: MongoID, $status: String, $needsAttentionOnly: Boolean, $ids: [MongoID!], $search: String, $mediaType: String, $mediaTagIds: [MongoID!], $usedInWidget: Boolean, $limit: Int, $skip: Int) {
  publicMediaMany(
    organizationId: $organizationId
    status: $status
    needsAttentionOnly: $needsAttentionOnly
    ids: $ids
    search: $search
    mediaType: $mediaType
    mediaTagIds: $mediaTagIds
    usedInWidget: $usedInWidget
    limit: $limit
    skip: $skip
  ) {
    _id
    mediaType
    status
    asset
    width
    height
    posterUrl
    carouselThumbnailAsset
    useCarouselThumbnail
    blurhash
    ctaLink
    copyright
    mediaTags
    relatedListings
    likeCount
    stats {
      views
      shares
      ctaClicks
    }
    createdDateISO
    headline {
      en
      es
      fr
    }
    caption {
      en
      es
      fr
    }
    mux {
      assetId
      playbackId
    }
    source {
      kind
      listingId
      originalAssetId
    }
    attention {
      ignoredAt
      issues {
        flag
        listingId
        listingName
        flaggedAt
      }
    }
  }
}
    `;

/**
 * __usePublicMediaManyQuery__
 *
 * To run a query within a React component, call `usePublicMediaManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicMediaManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicMediaManyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      status: // value for 'status'
 *      needsAttentionOnly: // value for 'needsAttentionOnly'
 *      ids: // value for 'ids'
 *      search: // value for 'search'
 *      mediaType: // value for 'mediaType'
 *      mediaTagIds: // value for 'mediaTagIds'
 *      usedInWidget: // value for 'usedInWidget'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePublicMediaManyQuery(baseOptions?: Apollo.QueryHookOptions<PublicMediaManyQuery, PublicMediaManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicMediaManyQuery, PublicMediaManyQueryVariables>(PublicMediaManyDocument, options);
      }
export function usePublicMediaManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicMediaManyQuery, PublicMediaManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicMediaManyQuery, PublicMediaManyQueryVariables>(PublicMediaManyDocument, options);
        }
// @ts-ignore
export function usePublicMediaManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicMediaManyQuery, PublicMediaManyQueryVariables>): Apollo.UseSuspenseQueryResult<PublicMediaManyQuery, PublicMediaManyQueryVariables>;
export function usePublicMediaManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicMediaManyQuery, PublicMediaManyQueryVariables>): Apollo.UseSuspenseQueryResult<PublicMediaManyQuery | undefined, PublicMediaManyQueryVariables>;
export function usePublicMediaManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicMediaManyQuery, PublicMediaManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicMediaManyQuery, PublicMediaManyQueryVariables>(PublicMediaManyDocument, options);
        }
export type PublicMediaManyQueryHookResult = ReturnType<typeof usePublicMediaManyQuery>;
export type PublicMediaManyLazyQueryHookResult = ReturnType<typeof usePublicMediaManyLazyQuery>;
export type PublicMediaManySuspenseQueryHookResult = ReturnType<typeof usePublicMediaManySuspenseQuery>;
export type PublicMediaManyQueryResult = Apollo.QueryResult<PublicMediaManyQuery, PublicMediaManyQueryVariables>;
export const PublicMediaProfileByIdDocument = gql`
    query PublicMediaProfileById($_id: MongoID!) {
  publicMediaById(_id: $_id) {
    _id
    mediaType
    status
    asset
    width
    height
    posterUrl
    blurhash
    ctaLink
    copyright
    likeCount
    relatedListings
    relatedListingNames
    headline {
      en
      es
      fr
    }
    caption {
      en
      es
      fr
    }
    mux {
      assetId
      playbackId
    }
  }
}
    `;

/**
 * __usePublicMediaProfileByIdQuery__
 *
 * To run a query within a React component, call `usePublicMediaProfileByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicMediaProfileByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicMediaProfileByIdQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePublicMediaProfileByIdQuery(baseOptions: Apollo.QueryHookOptions<PublicMediaProfileByIdQuery, PublicMediaProfileByIdQueryVariables> & ({ variables: PublicMediaProfileByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicMediaProfileByIdQuery, PublicMediaProfileByIdQueryVariables>(PublicMediaProfileByIdDocument, options);
      }
export function usePublicMediaProfileByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicMediaProfileByIdQuery, PublicMediaProfileByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicMediaProfileByIdQuery, PublicMediaProfileByIdQueryVariables>(PublicMediaProfileByIdDocument, options);
        }
// @ts-ignore
export function usePublicMediaProfileByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicMediaProfileByIdQuery, PublicMediaProfileByIdQueryVariables>): Apollo.UseSuspenseQueryResult<PublicMediaProfileByIdQuery, PublicMediaProfileByIdQueryVariables>;
export function usePublicMediaProfileByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicMediaProfileByIdQuery, PublicMediaProfileByIdQueryVariables>): Apollo.UseSuspenseQueryResult<PublicMediaProfileByIdQuery | undefined, PublicMediaProfileByIdQueryVariables>;
export function usePublicMediaProfileByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicMediaProfileByIdQuery, PublicMediaProfileByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicMediaProfileByIdQuery, PublicMediaProfileByIdQueryVariables>(PublicMediaProfileByIdDocument, options);
        }
export type PublicMediaProfileByIdQueryHookResult = ReturnType<typeof usePublicMediaProfileByIdQuery>;
export type PublicMediaProfileByIdLazyQueryHookResult = ReturnType<typeof usePublicMediaProfileByIdLazyQuery>;
export type PublicMediaProfileByIdSuspenseQueryHookResult = ReturnType<typeof usePublicMediaProfileByIdSuspenseQuery>;
export type PublicMediaProfileByIdQueryResult = Apollo.QueryResult<PublicMediaProfileByIdQuery, PublicMediaProfileByIdQueryVariables>;
export const RefundManyDocument = gql`
    query RefundMany($filter: FilterFindManyRefundInput) {
  refundMany(filter: $filter) {
    _id
    amount
    orderId
    status
    createdDateISO
    updatedDateISO
  }
}
    `;

/**
 * __useRefundManyQuery__
 *
 * To run a query within a React component, call `useRefundManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRefundManyQuery(baseOptions?: Apollo.QueryHookOptions<RefundManyQuery, RefundManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefundManyQuery, RefundManyQueryVariables>(RefundManyDocument, options);
      }
export function useRefundManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefundManyQuery, RefundManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefundManyQuery, RefundManyQueryVariables>(RefundManyDocument, options);
        }
// @ts-ignore
export function useRefundManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RefundManyQuery, RefundManyQueryVariables>): Apollo.UseSuspenseQueryResult<RefundManyQuery, RefundManyQueryVariables>;
export function useRefundManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RefundManyQuery, RefundManyQueryVariables>): Apollo.UseSuspenseQueryResult<RefundManyQuery | undefined, RefundManyQueryVariables>;
export function useRefundManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RefundManyQuery, RefundManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RefundManyQuery, RefundManyQueryVariables>(RefundManyDocument, options);
        }
export type RefundManyQueryHookResult = ReturnType<typeof useRefundManyQuery>;
export type RefundManyLazyQueryHookResult = ReturnType<typeof useRefundManyLazyQuery>;
export type RefundManySuspenseQueryHookResult = ReturnType<typeof useRefundManySuspenseQuery>;
export type RefundManyQueryResult = Apollo.QueryResult<RefundManyQuery, RefundManyQueryVariables>;
export const RefundsByOrderIdsDocument = gql`
    query RefundsByOrderIds($orderIds: [ID!]!) {
  refundsByOrderIds(orderIds: $orderIds) {
    _id
    amount
    orderId
    status
    createdDateISO
    updatedDateISO
  }
}
    `;

/**
 * __useRefundsByOrderIdsQuery__
 *
 * To run a query within a React component, call `useRefundsByOrderIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundsByOrderIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundsByOrderIdsQuery({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *   },
 * });
 */
export function useRefundsByOrderIdsQuery(baseOptions: Apollo.QueryHookOptions<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables> & ({ variables: RefundsByOrderIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables>(RefundsByOrderIdsDocument, options);
      }
export function useRefundsByOrderIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables>(RefundsByOrderIdsDocument, options);
        }
// @ts-ignore
export function useRefundsByOrderIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables>): Apollo.UseSuspenseQueryResult<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables>;
export function useRefundsByOrderIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables>): Apollo.UseSuspenseQueryResult<RefundsByOrderIdsQuery | undefined, RefundsByOrderIdsQueryVariables>;
export function useRefundsByOrderIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables>(RefundsByOrderIdsDocument, options);
        }
export type RefundsByOrderIdsQueryHookResult = ReturnType<typeof useRefundsByOrderIdsQuery>;
export type RefundsByOrderIdsLazyQueryHookResult = ReturnType<typeof useRefundsByOrderIdsLazyQuery>;
export type RefundsByOrderIdsSuspenseQueryHookResult = ReturnType<typeof useRefundsByOrderIdsSuspenseQuery>;
export type RefundsByOrderIdsQueryResult = Apollo.QueryResult<RefundsByOrderIdsQuery, RefundsByOrderIdsQueryVariables>;
export const RenewableFeeCoveredOperatorsDocument = gql`
    query RenewableFeeCoveredOperators($organizationId: MongoID!, $operatorIds: [MongoID!]!, $customerEmail: String) {
  renewableFeeCoveredOperators(
    organizationId: $organizationId
    operatorIds: $operatorIds
    customerEmail: $customerEmail
  ) {
    operatorId
    coveredByYou
    currentPeriodEnd
  }
}
    `;

/**
 * __useRenewableFeeCoveredOperatorsQuery__
 *
 * To run a query within a React component, call `useRenewableFeeCoveredOperatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenewableFeeCoveredOperatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenewableFeeCoveredOperatorsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      operatorIds: // value for 'operatorIds'
 *      customerEmail: // value for 'customerEmail'
 *   },
 * });
 */
export function useRenewableFeeCoveredOperatorsQuery(baseOptions: Apollo.QueryHookOptions<RenewableFeeCoveredOperatorsQuery, RenewableFeeCoveredOperatorsQueryVariables> & ({ variables: RenewableFeeCoveredOperatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenewableFeeCoveredOperatorsQuery, RenewableFeeCoveredOperatorsQueryVariables>(RenewableFeeCoveredOperatorsDocument, options);
      }
export function useRenewableFeeCoveredOperatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenewableFeeCoveredOperatorsQuery, RenewableFeeCoveredOperatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenewableFeeCoveredOperatorsQuery, RenewableFeeCoveredOperatorsQueryVariables>(RenewableFeeCoveredOperatorsDocument, options);
        }
// @ts-ignore
export function useRenewableFeeCoveredOperatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RenewableFeeCoveredOperatorsQuery, RenewableFeeCoveredOperatorsQueryVariables>): Apollo.UseSuspenseQueryResult<RenewableFeeCoveredOperatorsQuery, RenewableFeeCoveredOperatorsQueryVariables>;
export function useRenewableFeeCoveredOperatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewableFeeCoveredOperatorsQuery, RenewableFeeCoveredOperatorsQueryVariables>): Apollo.UseSuspenseQueryResult<RenewableFeeCoveredOperatorsQuery | undefined, RenewableFeeCoveredOperatorsQueryVariables>;
export function useRenewableFeeCoveredOperatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewableFeeCoveredOperatorsQuery, RenewableFeeCoveredOperatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RenewableFeeCoveredOperatorsQuery, RenewableFeeCoveredOperatorsQueryVariables>(RenewableFeeCoveredOperatorsDocument, options);
        }
export type RenewableFeeCoveredOperatorsQueryHookResult = ReturnType<typeof useRenewableFeeCoveredOperatorsQuery>;
export type RenewableFeeCoveredOperatorsLazyQueryHookResult = ReturnType<typeof useRenewableFeeCoveredOperatorsLazyQuery>;
export type RenewableFeeCoveredOperatorsSuspenseQueryHookResult = ReturnType<typeof useRenewableFeeCoveredOperatorsSuspenseQuery>;
export type RenewableFeeCoveredOperatorsQueryResult = Apollo.QueryResult<RenewableFeeCoveredOperatorsQuery, RenewableFeeCoveredOperatorsQueryVariables>;
export const RenewableFeeEarlyRenewalsDocument = gql`
    query RenewableFeeEarlyRenewals($bookerId: MongoID!, $productId: MongoID!, $organizationId: String, $tierId: String, $operatorIds: [MongoID!], $customerEmail: String) {
  renewableFeeEarlyRenewals(
    bookerId: $bookerId
    productId: $productId
    organizationId: $organizationId
    tierId: $tierId
    operatorIds: $operatorIds
    customerEmail: $customerEmail
  ) {
    operatorId
    renewsOn
    renewalOpensOn
  }
}
    `;

/**
 * __useRenewableFeeEarlyRenewalsQuery__
 *
 * To run a query within a React component, call `useRenewableFeeEarlyRenewalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenewableFeeEarlyRenewalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenewableFeeEarlyRenewalsQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      productId: // value for 'productId'
 *      organizationId: // value for 'organizationId'
 *      tierId: // value for 'tierId'
 *      operatorIds: // value for 'operatorIds'
 *      customerEmail: // value for 'customerEmail'
 *   },
 * });
 */
export function useRenewableFeeEarlyRenewalsQuery(baseOptions: Apollo.QueryHookOptions<RenewableFeeEarlyRenewalsQuery, RenewableFeeEarlyRenewalsQueryVariables> & ({ variables: RenewableFeeEarlyRenewalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenewableFeeEarlyRenewalsQuery, RenewableFeeEarlyRenewalsQueryVariables>(RenewableFeeEarlyRenewalsDocument, options);
      }
export function useRenewableFeeEarlyRenewalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenewableFeeEarlyRenewalsQuery, RenewableFeeEarlyRenewalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenewableFeeEarlyRenewalsQuery, RenewableFeeEarlyRenewalsQueryVariables>(RenewableFeeEarlyRenewalsDocument, options);
        }
// @ts-ignore
export function useRenewableFeeEarlyRenewalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RenewableFeeEarlyRenewalsQuery, RenewableFeeEarlyRenewalsQueryVariables>): Apollo.UseSuspenseQueryResult<RenewableFeeEarlyRenewalsQuery, RenewableFeeEarlyRenewalsQueryVariables>;
export function useRenewableFeeEarlyRenewalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewableFeeEarlyRenewalsQuery, RenewableFeeEarlyRenewalsQueryVariables>): Apollo.UseSuspenseQueryResult<RenewableFeeEarlyRenewalsQuery | undefined, RenewableFeeEarlyRenewalsQueryVariables>;
export function useRenewableFeeEarlyRenewalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewableFeeEarlyRenewalsQuery, RenewableFeeEarlyRenewalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RenewableFeeEarlyRenewalsQuery, RenewableFeeEarlyRenewalsQueryVariables>(RenewableFeeEarlyRenewalsDocument, options);
        }
export type RenewableFeeEarlyRenewalsQueryHookResult = ReturnType<typeof useRenewableFeeEarlyRenewalsQuery>;
export type RenewableFeeEarlyRenewalsLazyQueryHookResult = ReturnType<typeof useRenewableFeeEarlyRenewalsLazyQuery>;
export type RenewableFeeEarlyRenewalsSuspenseQueryHookResult = ReturnType<typeof useRenewableFeeEarlyRenewalsSuspenseQuery>;
export type RenewableFeeEarlyRenewalsQueryResult = Apollo.QueryResult<RenewableFeeEarlyRenewalsQuery, RenewableFeeEarlyRenewalsQueryVariables>;
export const RenewableFeeQuoteDocument = gql`
    query RenewableFeeQuote($bookerId: MongoID!, $productId: MongoID!, $tierId: String, $organizationId: MongoID!, $customerEmail: String, $operatorId: MongoID, $operatorIds: [MongoID!]) {
  renewableFeeQuote(
    bookerId: $bookerId
    productId: $productId
    tierId: $tierId
    organizationId: $organizationId
    customerEmail: $customerEmail
    operatorId: $operatorId
    operatorIds: $operatorIds
  ) {
    fullAmount
    chargeAmount
    pricingKind
    periodEnd
    bonusDays
    freeDaysUntil
    tierAmount
    additionalBusinessSavings
    listingLines {
      index
      fullPrice
      amount
    }
  }
}
    `;

/**
 * __useRenewableFeeQuoteQuery__
 *
 * To run a query within a React component, call `useRenewableFeeQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenewableFeeQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenewableFeeQuoteQuery({
 *   variables: {
 *      bookerId: // value for 'bookerId'
 *      productId: // value for 'productId'
 *      tierId: // value for 'tierId'
 *      organizationId: // value for 'organizationId'
 *      customerEmail: // value for 'customerEmail'
 *      operatorId: // value for 'operatorId'
 *      operatorIds: // value for 'operatorIds'
 *   },
 * });
 */
export function useRenewableFeeQuoteQuery(baseOptions: Apollo.QueryHookOptions<RenewableFeeQuoteQuery, RenewableFeeQuoteQueryVariables> & ({ variables: RenewableFeeQuoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenewableFeeQuoteQuery, RenewableFeeQuoteQueryVariables>(RenewableFeeQuoteDocument, options);
      }
export function useRenewableFeeQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenewableFeeQuoteQuery, RenewableFeeQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenewableFeeQuoteQuery, RenewableFeeQuoteQueryVariables>(RenewableFeeQuoteDocument, options);
        }
// @ts-ignore
export function useRenewableFeeQuoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RenewableFeeQuoteQuery, RenewableFeeQuoteQueryVariables>): Apollo.UseSuspenseQueryResult<RenewableFeeQuoteQuery, RenewableFeeQuoteQueryVariables>;
export function useRenewableFeeQuoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewableFeeQuoteQuery, RenewableFeeQuoteQueryVariables>): Apollo.UseSuspenseQueryResult<RenewableFeeQuoteQuery | undefined, RenewableFeeQuoteQueryVariables>;
export function useRenewableFeeQuoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewableFeeQuoteQuery, RenewableFeeQuoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RenewableFeeQuoteQuery, RenewableFeeQuoteQueryVariables>(RenewableFeeQuoteDocument, options);
        }
export type RenewableFeeQuoteQueryHookResult = ReturnType<typeof useRenewableFeeQuoteQuery>;
export type RenewableFeeQuoteLazyQueryHookResult = ReturnType<typeof useRenewableFeeQuoteLazyQuery>;
export type RenewableFeeQuoteSuspenseQueryHookResult = ReturnType<typeof useRenewableFeeQuoteSuspenseQuery>;
export type RenewableFeeQuoteQueryResult = Apollo.QueryResult<RenewableFeeQuoteQuery, RenewableFeeQuoteQueryVariables>;
export const RenewablePurchaseByIdDocument = gql`
    query RenewablePurchaseById($id: MongoID!) {
  renewablePurchaseById(id: $id) {
    _id
    status
    renewalBilling
    billingIntervalMonths
    renewalType
    fixedRenewalMonth
    fixedRenewalDay
    proRateEnabled
    currentPeriodStart
    currentPeriodEnd
    cancelledAt
    retryCount
    selectedTier {
      tierId
      tierName {
        en
        fr
        es
      }
      price
    }
    originalChargeAmount
    appliedDiscount {
      discountId
      promoCode
      name
      unit
      amount
      discountAmount
      isOngoing
    }
    pendingTierChange {
      tierId
      tierName {
        en
        fr
        es
      }
      price
    }
    originalOrder
    renewalOrders
    createdDateISO
  }
}
    `;

/**
 * __useRenewablePurchaseByIdQuery__
 *
 * To run a query within a React component, call `useRenewablePurchaseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenewablePurchaseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenewablePurchaseByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRenewablePurchaseByIdQuery(baseOptions: Apollo.QueryHookOptions<RenewablePurchaseByIdQuery, RenewablePurchaseByIdQueryVariables> & ({ variables: RenewablePurchaseByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenewablePurchaseByIdQuery, RenewablePurchaseByIdQueryVariables>(RenewablePurchaseByIdDocument, options);
      }
export function useRenewablePurchaseByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenewablePurchaseByIdQuery, RenewablePurchaseByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenewablePurchaseByIdQuery, RenewablePurchaseByIdQueryVariables>(RenewablePurchaseByIdDocument, options);
        }
// @ts-ignore
export function useRenewablePurchaseByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RenewablePurchaseByIdQuery, RenewablePurchaseByIdQueryVariables>): Apollo.UseSuspenseQueryResult<RenewablePurchaseByIdQuery, RenewablePurchaseByIdQueryVariables>;
export function useRenewablePurchaseByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewablePurchaseByIdQuery, RenewablePurchaseByIdQueryVariables>): Apollo.UseSuspenseQueryResult<RenewablePurchaseByIdQuery | undefined, RenewablePurchaseByIdQueryVariables>;
export function useRenewablePurchaseByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewablePurchaseByIdQuery, RenewablePurchaseByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RenewablePurchaseByIdQuery, RenewablePurchaseByIdQueryVariables>(RenewablePurchaseByIdDocument, options);
        }
export type RenewablePurchaseByIdQueryHookResult = ReturnType<typeof useRenewablePurchaseByIdQuery>;
export type RenewablePurchaseByIdLazyQueryHookResult = ReturnType<typeof useRenewablePurchaseByIdLazyQuery>;
export type RenewablePurchaseByIdSuspenseQueryHookResult = ReturnType<typeof useRenewablePurchaseByIdSuspenseQuery>;
export type RenewablePurchaseByIdQueryResult = Apollo.QueryResult<RenewablePurchaseByIdQuery, RenewablePurchaseByIdQueryVariables>;
export const RenewablePurchaseByIdPublicDocument = gql`
    query RenewablePurchaseByIdPublic($id: MongoID!) {
  renewablePurchaseByIdPublic(id: $id) {
    _id
    status
    billingIntervalMonths
    currentPeriodStart
    currentPeriodEnd
    cancelledAt
    retryCount
    selectedTier {
      tierId
      tierName {
        en
        fr
        es
      }
      price
    }
    originalChargeAmount
    appliedDiscount {
      name
      promoCode
      discountAmount
    }
    originalOrder
    renewalOrders
    createdDateISO
  }
}
    `;

/**
 * __useRenewablePurchaseByIdPublicQuery__
 *
 * To run a query within a React component, call `useRenewablePurchaseByIdPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenewablePurchaseByIdPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenewablePurchaseByIdPublicQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRenewablePurchaseByIdPublicQuery(baseOptions: Apollo.QueryHookOptions<RenewablePurchaseByIdPublicQuery, RenewablePurchaseByIdPublicQueryVariables> & ({ variables: RenewablePurchaseByIdPublicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenewablePurchaseByIdPublicQuery, RenewablePurchaseByIdPublicQueryVariables>(RenewablePurchaseByIdPublicDocument, options);
      }
export function useRenewablePurchaseByIdPublicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenewablePurchaseByIdPublicQuery, RenewablePurchaseByIdPublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenewablePurchaseByIdPublicQuery, RenewablePurchaseByIdPublicQueryVariables>(RenewablePurchaseByIdPublicDocument, options);
        }
// @ts-ignore
export function useRenewablePurchaseByIdPublicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RenewablePurchaseByIdPublicQuery, RenewablePurchaseByIdPublicQueryVariables>): Apollo.UseSuspenseQueryResult<RenewablePurchaseByIdPublicQuery, RenewablePurchaseByIdPublicQueryVariables>;
export function useRenewablePurchaseByIdPublicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewablePurchaseByIdPublicQuery, RenewablePurchaseByIdPublicQueryVariables>): Apollo.UseSuspenseQueryResult<RenewablePurchaseByIdPublicQuery | undefined, RenewablePurchaseByIdPublicQueryVariables>;
export function useRenewablePurchaseByIdPublicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewablePurchaseByIdPublicQuery, RenewablePurchaseByIdPublicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RenewablePurchaseByIdPublicQuery, RenewablePurchaseByIdPublicQueryVariables>(RenewablePurchaseByIdPublicDocument, options);
        }
export type RenewablePurchaseByIdPublicQueryHookResult = ReturnType<typeof useRenewablePurchaseByIdPublicQuery>;
export type RenewablePurchaseByIdPublicLazyQueryHookResult = ReturnType<typeof useRenewablePurchaseByIdPublicLazyQuery>;
export type RenewablePurchaseByIdPublicSuspenseQueryHookResult = ReturnType<typeof useRenewablePurchaseByIdPublicSuspenseQuery>;
export type RenewablePurchaseByIdPublicQueryResult = Apollo.QueryResult<RenewablePurchaseByIdPublicQuery, RenewablePurchaseByIdPublicQueryVariables>;
export const RenewalEngineSetupPreviewDocument = gql`
    query RenewalEngineSetupPreview($organizationId: MongoID!) {
  renewalEngineSetupPreview(organizationId: $organizationId) {
    engineOwned
    detected {
      role
      tagId
      tagName
      source
    }
    membersChanging
    byRole {
      role
      count
    }
  }
}
    `;

/**
 * __useRenewalEngineSetupPreviewQuery__
 *
 * To run a query within a React component, call `useRenewalEngineSetupPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenewalEngineSetupPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenewalEngineSetupPreviewQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRenewalEngineSetupPreviewQuery(baseOptions: Apollo.QueryHookOptions<RenewalEngineSetupPreviewQuery, RenewalEngineSetupPreviewQueryVariables> & ({ variables: RenewalEngineSetupPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenewalEngineSetupPreviewQuery, RenewalEngineSetupPreviewQueryVariables>(RenewalEngineSetupPreviewDocument, options);
      }
export function useRenewalEngineSetupPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenewalEngineSetupPreviewQuery, RenewalEngineSetupPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenewalEngineSetupPreviewQuery, RenewalEngineSetupPreviewQueryVariables>(RenewalEngineSetupPreviewDocument, options);
        }
// @ts-ignore
export function useRenewalEngineSetupPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RenewalEngineSetupPreviewQuery, RenewalEngineSetupPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<RenewalEngineSetupPreviewQuery, RenewalEngineSetupPreviewQueryVariables>;
export function useRenewalEngineSetupPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewalEngineSetupPreviewQuery, RenewalEngineSetupPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<RenewalEngineSetupPreviewQuery | undefined, RenewalEngineSetupPreviewQueryVariables>;
export function useRenewalEngineSetupPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewalEngineSetupPreviewQuery, RenewalEngineSetupPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RenewalEngineSetupPreviewQuery, RenewalEngineSetupPreviewQueryVariables>(RenewalEngineSetupPreviewDocument, options);
        }
export type RenewalEngineSetupPreviewQueryHookResult = ReturnType<typeof useRenewalEngineSetupPreviewQuery>;
export type RenewalEngineSetupPreviewLazyQueryHookResult = ReturnType<typeof useRenewalEngineSetupPreviewLazyQuery>;
export type RenewalEngineSetupPreviewSuspenseQueryHookResult = ReturnType<typeof useRenewalEngineSetupPreviewSuspenseQuery>;
export type RenewalEngineSetupPreviewQueryResult = Apollo.QueryResult<RenewalEngineSetupPreviewQuery, RenewalEngineSetupPreviewQueryVariables>;
export const RenewalRecordsByPurchaseDocument = gql`
    query RenewalRecordsByPurchase($renewablePurchaseId: MongoID!) {
  renewalRecordsByPurchase(renewablePurchaseId: $renewablePurchaseId) {
    _id
    status
    amount
    tierPrice
    currency
    periodStart
    periodEnd
    order
    paymentRequest
    failureReason
    stripePaymentIntentId
    appliedDiscount {
      discountId
      name
      promoCode
      unit
      amount
      discountAmount
      isOngoing
    }
  }
}
    `;

/**
 * __useRenewalRecordsByPurchaseQuery__
 *
 * To run a query within a React component, call `useRenewalRecordsByPurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenewalRecordsByPurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenewalRecordsByPurchaseQuery({
 *   variables: {
 *      renewablePurchaseId: // value for 'renewablePurchaseId'
 *   },
 * });
 */
export function useRenewalRecordsByPurchaseQuery(baseOptions: Apollo.QueryHookOptions<RenewalRecordsByPurchaseQuery, RenewalRecordsByPurchaseQueryVariables> & ({ variables: RenewalRecordsByPurchaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenewalRecordsByPurchaseQuery, RenewalRecordsByPurchaseQueryVariables>(RenewalRecordsByPurchaseDocument, options);
      }
export function useRenewalRecordsByPurchaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenewalRecordsByPurchaseQuery, RenewalRecordsByPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenewalRecordsByPurchaseQuery, RenewalRecordsByPurchaseQueryVariables>(RenewalRecordsByPurchaseDocument, options);
        }
// @ts-ignore
export function useRenewalRecordsByPurchaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RenewalRecordsByPurchaseQuery, RenewalRecordsByPurchaseQueryVariables>): Apollo.UseSuspenseQueryResult<RenewalRecordsByPurchaseQuery, RenewalRecordsByPurchaseQueryVariables>;
export function useRenewalRecordsByPurchaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewalRecordsByPurchaseQuery, RenewalRecordsByPurchaseQueryVariables>): Apollo.UseSuspenseQueryResult<RenewalRecordsByPurchaseQuery | undefined, RenewalRecordsByPurchaseQueryVariables>;
export function useRenewalRecordsByPurchaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewalRecordsByPurchaseQuery, RenewalRecordsByPurchaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RenewalRecordsByPurchaseQuery, RenewalRecordsByPurchaseQueryVariables>(RenewalRecordsByPurchaseDocument, options);
        }
export type RenewalRecordsByPurchaseQueryHookResult = ReturnType<typeof useRenewalRecordsByPurchaseQuery>;
export type RenewalRecordsByPurchaseLazyQueryHookResult = ReturnType<typeof useRenewalRecordsByPurchaseLazyQuery>;
export type RenewalRecordsByPurchaseSuspenseQueryHookResult = ReturnType<typeof useRenewalRecordsByPurchaseSuspenseQuery>;
export type RenewalRecordsByPurchaseQueryResult = Apollo.QueryResult<RenewalRecordsByPurchaseQuery, RenewalRecordsByPurchaseQueryVariables>;
export const RenewalRecordsByPurchasePublicDocument = gql`
    query RenewalRecordsByPurchasePublic($renewablePurchaseId: MongoID!) {
  renewalRecordsByPurchasePublic(renewablePurchaseId: $renewablePurchaseId) {
    _id
    status
    amount
    currency
    periodStart
    periodEnd
    order
  }
}
    `;

/**
 * __useRenewalRecordsByPurchasePublicQuery__
 *
 * To run a query within a React component, call `useRenewalRecordsByPurchasePublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenewalRecordsByPurchasePublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenewalRecordsByPurchasePublicQuery({
 *   variables: {
 *      renewablePurchaseId: // value for 'renewablePurchaseId'
 *   },
 * });
 */
export function useRenewalRecordsByPurchasePublicQuery(baseOptions: Apollo.QueryHookOptions<RenewalRecordsByPurchasePublicQuery, RenewalRecordsByPurchasePublicQueryVariables> & ({ variables: RenewalRecordsByPurchasePublicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenewalRecordsByPurchasePublicQuery, RenewalRecordsByPurchasePublicQueryVariables>(RenewalRecordsByPurchasePublicDocument, options);
      }
export function useRenewalRecordsByPurchasePublicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenewalRecordsByPurchasePublicQuery, RenewalRecordsByPurchasePublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenewalRecordsByPurchasePublicQuery, RenewalRecordsByPurchasePublicQueryVariables>(RenewalRecordsByPurchasePublicDocument, options);
        }
// @ts-ignore
export function useRenewalRecordsByPurchasePublicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RenewalRecordsByPurchasePublicQuery, RenewalRecordsByPurchasePublicQueryVariables>): Apollo.UseSuspenseQueryResult<RenewalRecordsByPurchasePublicQuery, RenewalRecordsByPurchasePublicQueryVariables>;
export function useRenewalRecordsByPurchasePublicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewalRecordsByPurchasePublicQuery, RenewalRecordsByPurchasePublicQueryVariables>): Apollo.UseSuspenseQueryResult<RenewalRecordsByPurchasePublicQuery | undefined, RenewalRecordsByPurchasePublicQueryVariables>;
export function useRenewalRecordsByPurchasePublicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenewalRecordsByPurchasePublicQuery, RenewalRecordsByPurchasePublicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RenewalRecordsByPurchasePublicQuery, RenewalRecordsByPurchasePublicQueryVariables>(RenewalRecordsByPurchasePublicDocument, options);
        }
export type RenewalRecordsByPurchasePublicQueryHookResult = ReturnType<typeof useRenewalRecordsByPurchasePublicQuery>;
export type RenewalRecordsByPurchasePublicLazyQueryHookResult = ReturnType<typeof useRenewalRecordsByPurchasePublicLazyQuery>;
export type RenewalRecordsByPurchasePublicSuspenseQueryHookResult = ReturnType<typeof useRenewalRecordsByPurchasePublicSuspenseQuery>;
export type RenewalRecordsByPurchasePublicQueryResult = Apollo.QueryResult<RenewalRecordsByPurchasePublicQuery, RenewalRecordsByPurchasePublicQueryVariables>;
export const ReportByStorefrontDocument = gql`
    query ReportByStorefront($storefrontId: MongoID!, $reportType: String!) {
  reportByStorefront(storefrontId: $storefrontId, reportType: $reportType) {
    builtAt
    timezone
    timezoneSource
    builtTimezone
    columns {
      title
      field
    }
    rows {
      _id
      searchText
      rowDateISO
      cells {
        field
        value
      }
    }
  }
}
    `;

/**
 * __useReportByStorefrontQuery__
 *
 * To run a query within a React component, call `useReportByStorefrontQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportByStorefrontQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportByStorefrontQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      reportType: // value for 'reportType'
 *   },
 * });
 */
export function useReportByStorefrontQuery(baseOptions: Apollo.QueryHookOptions<ReportByStorefrontQuery, ReportByStorefrontQueryVariables> & ({ variables: ReportByStorefrontQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportByStorefrontQuery, ReportByStorefrontQueryVariables>(ReportByStorefrontDocument, options);
      }
export function useReportByStorefrontLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportByStorefrontQuery, ReportByStorefrontQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportByStorefrontQuery, ReportByStorefrontQueryVariables>(ReportByStorefrontDocument, options);
        }
// @ts-ignore
export function useReportByStorefrontSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportByStorefrontQuery, ReportByStorefrontQueryVariables>): Apollo.UseSuspenseQueryResult<ReportByStorefrontQuery, ReportByStorefrontQueryVariables>;
export function useReportByStorefrontSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportByStorefrontQuery, ReportByStorefrontQueryVariables>): Apollo.UseSuspenseQueryResult<ReportByStorefrontQuery | undefined, ReportByStorefrontQueryVariables>;
export function useReportByStorefrontSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportByStorefrontQuery, ReportByStorefrontQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportByStorefrontQuery, ReportByStorefrontQueryVariables>(ReportByStorefrontDocument, options);
        }
export type ReportByStorefrontQueryHookResult = ReturnType<typeof useReportByStorefrontQuery>;
export type ReportByStorefrontLazyQueryHookResult = ReturnType<typeof useReportByStorefrontLazyQuery>;
export type ReportByStorefrontSuspenseQueryHookResult = ReturnType<typeof useReportByStorefrontSuspenseQuery>;
export type ReportByStorefrontQueryResult = Apollo.QueryResult<ReportByStorefrontQuery, ReportByStorefrontQueryVariables>;
export const ReportDatasetFieldsDocument = gql`
    query ReportDatasetFields($storefrontId: MongoID!, $dataset: String!) {
  reportDatasetFields(storefrontId: $storefrontId, dataset: $dataset) {
    baseColumns
    timezone
    timezoneSource
    builtAt
    lastStripeSyncAt
    fields {
      key
      title
      type
      category
      isBase
      operators
      enumValues {
        value
        label
      }
    }
  }
}
    `;

/**
 * __useReportDatasetFieldsQuery__
 *
 * To run a query within a React component, call `useReportDatasetFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDatasetFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDatasetFieldsQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      dataset: // value for 'dataset'
 *   },
 * });
 */
export function useReportDatasetFieldsQuery(baseOptions: Apollo.QueryHookOptions<ReportDatasetFieldsQuery, ReportDatasetFieldsQueryVariables> & ({ variables: ReportDatasetFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDatasetFieldsQuery, ReportDatasetFieldsQueryVariables>(ReportDatasetFieldsDocument, options);
      }
export function useReportDatasetFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDatasetFieldsQuery, ReportDatasetFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDatasetFieldsQuery, ReportDatasetFieldsQueryVariables>(ReportDatasetFieldsDocument, options);
        }
// @ts-ignore
export function useReportDatasetFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportDatasetFieldsQuery, ReportDatasetFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportDatasetFieldsQuery, ReportDatasetFieldsQueryVariables>;
export function useReportDatasetFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportDatasetFieldsQuery, ReportDatasetFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<ReportDatasetFieldsQuery | undefined, ReportDatasetFieldsQueryVariables>;
export function useReportDatasetFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportDatasetFieldsQuery, ReportDatasetFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportDatasetFieldsQuery, ReportDatasetFieldsQueryVariables>(ReportDatasetFieldsDocument, options);
        }
export type ReportDatasetFieldsQueryHookResult = ReturnType<typeof useReportDatasetFieldsQuery>;
export type ReportDatasetFieldsLazyQueryHookResult = ReturnType<typeof useReportDatasetFieldsLazyQuery>;
export type ReportDatasetFieldsSuspenseQueryHookResult = ReturnType<typeof useReportDatasetFieldsSuspenseQuery>;
export type ReportDatasetFieldsQueryResult = Apollo.QueryResult<ReportDatasetFieldsQuery, ReportDatasetFieldsQueryVariables>;
export const ReportFieldValuesDocument = gql`
    query ReportFieldValues($storefrontId: MongoID!, $dataset: String!, $field: String!, $search: String, $limit: Int) {
  reportFieldValues(
    storefrontId: $storefrontId
    dataset: $dataset
    field: $field
    search: $search
    limit: $limit
  )
}
    `;

/**
 * __useReportFieldValuesQuery__
 *
 * To run a query within a React component, call `useReportFieldValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportFieldValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportFieldValuesQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      dataset: // value for 'dataset'
 *      field: // value for 'field'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useReportFieldValuesQuery(baseOptions: Apollo.QueryHookOptions<ReportFieldValuesQuery, ReportFieldValuesQueryVariables> & ({ variables: ReportFieldValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportFieldValuesQuery, ReportFieldValuesQueryVariables>(ReportFieldValuesDocument, options);
      }
export function useReportFieldValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportFieldValuesQuery, ReportFieldValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportFieldValuesQuery, ReportFieldValuesQueryVariables>(ReportFieldValuesDocument, options);
        }
// @ts-ignore
export function useReportFieldValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportFieldValuesQuery, ReportFieldValuesQueryVariables>): Apollo.UseSuspenseQueryResult<ReportFieldValuesQuery, ReportFieldValuesQueryVariables>;
export function useReportFieldValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportFieldValuesQuery, ReportFieldValuesQueryVariables>): Apollo.UseSuspenseQueryResult<ReportFieldValuesQuery | undefined, ReportFieldValuesQueryVariables>;
export function useReportFieldValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportFieldValuesQuery, ReportFieldValuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportFieldValuesQuery, ReportFieldValuesQueryVariables>(ReportFieldValuesDocument, options);
        }
export type ReportFieldValuesQueryHookResult = ReturnType<typeof useReportFieldValuesQuery>;
export type ReportFieldValuesLazyQueryHookResult = ReturnType<typeof useReportFieldValuesLazyQuery>;
export type ReportFieldValuesSuspenseQueryHookResult = ReturnType<typeof useReportFieldValuesSuspenseQuery>;
export type ReportFieldValuesQueryResult = Apollo.QueryResult<ReportFieldValuesQuery, ReportFieldValuesQueryVariables>;
export const ReportRunDocument = gql`
    query ReportRun($storefrontId: MongoID!, $savedReportId: MongoID, $definition: ReportDefinitionInput, $search: String, $startDate: String, $endDate: String, $limit: Int) {
  reportRun(
    storefrontId: $storefrontId
    savedReportId: $savedReportId
    definition: $definition
    search: $search
    startDate: $startDate
    endDate: $endDate
    limit: $limit
  ) {
    builtAt
    hasBuilt
    timezone
    timezoneSource
    builtTimezone
    missingFields
    rowCount
    columns {
      field
      title
      type
    }
    rows {
      _id
      groupKey
      cells {
        field
        value
      }
    }
    groups {
      key
      label
      count
      totals {
        currency
        count
        values {
          field
          value
        }
      }
    }
    totals {
      currency
      count
      values {
        field
        value
      }
    }
    resolvedConditions {
      field
      title
      type
      op
      values
      valueLabels
      rangeStart
      rangeEnd
    }
  }
}
    `;

/**
 * __useReportRunQuery__
 *
 * To run a query within a React component, call `useReportRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportRunQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      savedReportId: // value for 'savedReportId'
 *      definition: // value for 'definition'
 *      search: // value for 'search'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useReportRunQuery(baseOptions: Apollo.QueryHookOptions<ReportRunQuery, ReportRunQueryVariables> & ({ variables: ReportRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportRunQuery, ReportRunQueryVariables>(ReportRunDocument, options);
      }
export function useReportRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportRunQuery, ReportRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportRunQuery, ReportRunQueryVariables>(ReportRunDocument, options);
        }
// @ts-ignore
export function useReportRunSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportRunQuery, ReportRunQueryVariables>): Apollo.UseSuspenseQueryResult<ReportRunQuery, ReportRunQueryVariables>;
export function useReportRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportRunQuery, ReportRunQueryVariables>): Apollo.UseSuspenseQueryResult<ReportRunQuery | undefined, ReportRunQueryVariables>;
export function useReportRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportRunQuery, ReportRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportRunQuery, ReportRunQueryVariables>(ReportRunDocument, options);
        }
export type ReportRunQueryHookResult = ReturnType<typeof useReportRunQuery>;
export type ReportRunLazyQueryHookResult = ReturnType<typeof useReportRunLazyQuery>;
export type ReportRunSuspenseQueryHookResult = ReturnType<typeof useReportRunSuspenseQuery>;
export type ReportRunQueryResult = Apollo.QueryResult<ReportRunQuery, ReportRunQueryVariables>;
export const SavedReportsByStorefrontDocument = gql`
    query SavedReportsByStorefront($storefrontId: MongoID!) {
  savedReportsByStorefront(storefrontId: $storefrontId) {
    ...SavedReportFields
  }
}
    ${SavedReportFieldsFragmentDoc}`;

/**
 * __useSavedReportsByStorefrontQuery__
 *
 * To run a query within a React component, call `useSavedReportsByStorefrontQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedReportsByStorefrontQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedReportsByStorefrontQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *   },
 * });
 */
export function useSavedReportsByStorefrontQuery(baseOptions: Apollo.QueryHookOptions<SavedReportsByStorefrontQuery, SavedReportsByStorefrontQueryVariables> & ({ variables: SavedReportsByStorefrontQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedReportsByStorefrontQuery, SavedReportsByStorefrontQueryVariables>(SavedReportsByStorefrontDocument, options);
      }
export function useSavedReportsByStorefrontLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedReportsByStorefrontQuery, SavedReportsByStorefrontQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedReportsByStorefrontQuery, SavedReportsByStorefrontQueryVariables>(SavedReportsByStorefrontDocument, options);
        }
// @ts-ignore
export function useSavedReportsByStorefrontSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SavedReportsByStorefrontQuery, SavedReportsByStorefrontQueryVariables>): Apollo.UseSuspenseQueryResult<SavedReportsByStorefrontQuery, SavedReportsByStorefrontQueryVariables>;
export function useSavedReportsByStorefrontSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SavedReportsByStorefrontQuery, SavedReportsByStorefrontQueryVariables>): Apollo.UseSuspenseQueryResult<SavedReportsByStorefrontQuery | undefined, SavedReportsByStorefrontQueryVariables>;
export function useSavedReportsByStorefrontSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SavedReportsByStorefrontQuery, SavedReportsByStorefrontQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SavedReportsByStorefrontQuery, SavedReportsByStorefrontQueryVariables>(SavedReportsByStorefrontDocument, options);
        }
export type SavedReportsByStorefrontQueryHookResult = ReturnType<typeof useSavedReportsByStorefrontQuery>;
export type SavedReportsByStorefrontLazyQueryHookResult = ReturnType<typeof useSavedReportsByStorefrontLazyQuery>;
export type SavedReportsByStorefrontSuspenseQueryHookResult = ReturnType<typeof useSavedReportsByStorefrontSuspenseQuery>;
export type SavedReportsByStorefrontQueryResult = Apollo.QueryResult<SavedReportsByStorefrontQuery, SavedReportsByStorefrontQueryVariables>;
export const ScheduledPaymentFindOneDocument = gql`
    query ScheduledPaymentFindOne($filter: FilterFindOneScheduledPaymentInput) {
  scheduledPaymentFindOne(filter: $filter) {
    _id
    amount
    dueDate
    order
    status
    type
    stripeMetadata {
      connectedAccountId
    }
  }
}
    `;

/**
 * __useScheduledPaymentFindOneQuery__
 *
 * To run a query within a React component, call `useScheduledPaymentFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledPaymentFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledPaymentFindOneQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useScheduledPaymentFindOneQuery(baseOptions?: Apollo.QueryHookOptions<ScheduledPaymentFindOneQuery, ScheduledPaymentFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledPaymentFindOneQuery, ScheduledPaymentFindOneQueryVariables>(ScheduledPaymentFindOneDocument, options);
      }
export function useScheduledPaymentFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledPaymentFindOneQuery, ScheduledPaymentFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledPaymentFindOneQuery, ScheduledPaymentFindOneQueryVariables>(ScheduledPaymentFindOneDocument, options);
        }
// @ts-ignore
export function useScheduledPaymentFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduledPaymentFindOneQuery, ScheduledPaymentFindOneQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduledPaymentFindOneQuery, ScheduledPaymentFindOneQueryVariables>;
export function useScheduledPaymentFindOneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduledPaymentFindOneQuery, ScheduledPaymentFindOneQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduledPaymentFindOneQuery | undefined, ScheduledPaymentFindOneQueryVariables>;
export function useScheduledPaymentFindOneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduledPaymentFindOneQuery, ScheduledPaymentFindOneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduledPaymentFindOneQuery, ScheduledPaymentFindOneQueryVariables>(ScheduledPaymentFindOneDocument, options);
        }
export type ScheduledPaymentFindOneQueryHookResult = ReturnType<typeof useScheduledPaymentFindOneQuery>;
export type ScheduledPaymentFindOneLazyQueryHookResult = ReturnType<typeof useScheduledPaymentFindOneLazyQuery>;
export type ScheduledPaymentFindOneSuspenseQueryHookResult = ReturnType<typeof useScheduledPaymentFindOneSuspenseQuery>;
export type ScheduledPaymentFindOneQueryResult = Apollo.QueryResult<ScheduledPaymentFindOneQuery, ScheduledPaymentFindOneQueryVariables>;
export const ScheduledPaymentFindManyDocument = gql`
    query ScheduledPaymentFindMany($filter: FilterFindManyScheduledPaymentInput) {
  scheduledPaymentFindMany(filter: $filter) {
    _id
    amount
    dueDate
    order
    status
    type
    stripeMetadata {
      connectedAccountId
    }
  }
}
    `;

/**
 * __useScheduledPaymentFindManyQuery__
 *
 * To run a query within a React component, call `useScheduledPaymentFindManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledPaymentFindManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledPaymentFindManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useScheduledPaymentFindManyQuery(baseOptions?: Apollo.QueryHookOptions<ScheduledPaymentFindManyQuery, ScheduledPaymentFindManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledPaymentFindManyQuery, ScheduledPaymentFindManyQueryVariables>(ScheduledPaymentFindManyDocument, options);
      }
export function useScheduledPaymentFindManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledPaymentFindManyQuery, ScheduledPaymentFindManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledPaymentFindManyQuery, ScheduledPaymentFindManyQueryVariables>(ScheduledPaymentFindManyDocument, options);
        }
// @ts-ignore
export function useScheduledPaymentFindManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduledPaymentFindManyQuery, ScheduledPaymentFindManyQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduledPaymentFindManyQuery, ScheduledPaymentFindManyQueryVariables>;
export function useScheduledPaymentFindManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduledPaymentFindManyQuery, ScheduledPaymentFindManyQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduledPaymentFindManyQuery | undefined, ScheduledPaymentFindManyQueryVariables>;
export function useScheduledPaymentFindManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduledPaymentFindManyQuery, ScheduledPaymentFindManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduledPaymentFindManyQuery, ScheduledPaymentFindManyQueryVariables>(ScheduledPaymentFindManyDocument, options);
        }
export type ScheduledPaymentFindManyQueryHookResult = ReturnType<typeof useScheduledPaymentFindManyQuery>;
export type ScheduledPaymentFindManyLazyQueryHookResult = ReturnType<typeof useScheduledPaymentFindManyLazyQuery>;
export type ScheduledPaymentFindManySuspenseQueryHookResult = ReturnType<typeof useScheduledPaymentFindManySuspenseQuery>;
export type ScheduledPaymentFindManyQueryResult = Apollo.QueryResult<ScheduledPaymentFindManyQuery, ScheduledPaymentFindManyQueryVariables>;
export const StatsSnapshotsByOrganizationDocument = gql`
    query StatsSnapshotsByOrganization($organizationId: ID!) {
  statsSnapshotsByOrganization(organizationId: $organizationId) {
    _id
    periodKey
    capturedAt
    account {
      operators
      people
      notes
      events
    }
    widget {
      operatorViews
      operatorClicks
      eventImpressions
      eventClicks
      tripperViews
      tripperEngagements
      tripperReferrals
      tripperPdfDownloads
    }
    broadcast {
      completions
      messageViews
      videoViews
      photoViews
      pdfDownloads
    }
    membership {
      total
      byTier {
        tagId
        name
        count
      }
      byStatus {
        tagId
        name
        count
      }
    }
  }
}
    `;

/**
 * __useStatsSnapshotsByOrganizationQuery__
 *
 * To run a query within a React component, call `useStatsSnapshotsByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatsSnapshotsByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatsSnapshotsByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useStatsSnapshotsByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<StatsSnapshotsByOrganizationQuery, StatsSnapshotsByOrganizationQueryVariables> & ({ variables: StatsSnapshotsByOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatsSnapshotsByOrganizationQuery, StatsSnapshotsByOrganizationQueryVariables>(StatsSnapshotsByOrganizationDocument, options);
      }
export function useStatsSnapshotsByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatsSnapshotsByOrganizationQuery, StatsSnapshotsByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatsSnapshotsByOrganizationQuery, StatsSnapshotsByOrganizationQueryVariables>(StatsSnapshotsByOrganizationDocument, options);
        }
// @ts-ignore
export function useStatsSnapshotsByOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StatsSnapshotsByOrganizationQuery, StatsSnapshotsByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<StatsSnapshotsByOrganizationQuery, StatsSnapshotsByOrganizationQueryVariables>;
export function useStatsSnapshotsByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StatsSnapshotsByOrganizationQuery, StatsSnapshotsByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<StatsSnapshotsByOrganizationQuery | undefined, StatsSnapshotsByOrganizationQueryVariables>;
export function useStatsSnapshotsByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StatsSnapshotsByOrganizationQuery, StatsSnapshotsByOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StatsSnapshotsByOrganizationQuery, StatsSnapshotsByOrganizationQueryVariables>(StatsSnapshotsByOrganizationDocument, options);
        }
export type StatsSnapshotsByOrganizationQueryHookResult = ReturnType<typeof useStatsSnapshotsByOrganizationQuery>;
export type StatsSnapshotsByOrganizationLazyQueryHookResult = ReturnType<typeof useStatsSnapshotsByOrganizationLazyQuery>;
export type StatsSnapshotsByOrganizationSuspenseQueryHookResult = ReturnType<typeof useStatsSnapshotsByOrganizationSuspenseQuery>;
export type StatsSnapshotsByOrganizationQueryResult = Apollo.QueryResult<StatsSnapshotsByOrganizationQuery, StatsSnapshotsByOrganizationQueryVariables>;
export const StorefrontByIdDocument = gql`
    query StorefrontById($id: MongoID!) {
  storefrontById(_id: $id) {
    _id
    organization
    connectedAccountIds
    testMode
    stripeRegion
    testStorefront
    liveStorefront
    isPaired
    isLaunched
    launchedAt
    paymentsMode
    defaultWidgetLogo {
      ...ImageFragment
    }
    name {
      en
      fr
      es
    }
    enabledFeeTypes {
      accommodations
      oneTimeFee
      renewableFees
      events
      merch
    }
    accountingCodes
    customProductNames
    defaultInvoicePolicy
    connectedListings
    lowStockDigestEnabled
    invoicingEnabled
    statementSettings {
      dayOfMonth
    }
    timezone
    resolvedTimezone {
      timezone
      source
    }
    emailBranding {
      fromName
      replyTo
      accentColor
      showContact
      useOrganizationEmailSettings
      footerText {
        en
        fr
        es
      }
      logo {
        ...ImageFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useStorefrontByIdQuery__
 *
 * To run a query within a React component, call `useStorefrontByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStorefrontByIdQuery(baseOptions: Apollo.QueryHookOptions<StorefrontByIdQuery, StorefrontByIdQueryVariables> & ({ variables: StorefrontByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontByIdQuery, StorefrontByIdQueryVariables>(StorefrontByIdDocument, options);
      }
export function useStorefrontByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontByIdQuery, StorefrontByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontByIdQuery, StorefrontByIdQueryVariables>(StorefrontByIdDocument, options);
        }
// @ts-ignore
export function useStorefrontByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontByIdQuery, StorefrontByIdQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontByIdQuery, StorefrontByIdQueryVariables>;
export function useStorefrontByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontByIdQuery, StorefrontByIdQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontByIdQuery | undefined, StorefrontByIdQueryVariables>;
export function useStorefrontByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontByIdQuery, StorefrontByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontByIdQuery, StorefrontByIdQueryVariables>(StorefrontByIdDocument, options);
        }
export type StorefrontByIdQueryHookResult = ReturnType<typeof useStorefrontByIdQuery>;
export type StorefrontByIdLazyQueryHookResult = ReturnType<typeof useStorefrontByIdLazyQuery>;
export type StorefrontByIdSuspenseQueryHookResult = ReturnType<typeof useStorefrontByIdSuspenseQuery>;
export type StorefrontByIdQueryResult = Apollo.QueryResult<StorefrontByIdQuery, StorefrontByIdQueryVariables>;
export const StorefrontCalendarFeedDocument = gql`
    query StorefrontCalendarFeed($storefrontId: ID!, $kind: StorefrontCalendarKind!, $rangeStart: String!, $rangeEnd: String!, $summaryYear: Int!) {
  storefrontCalendarFeed(
    storefrontId: $storefrontId
    kind: $kind
    rangeStart: $rangeStart
    rangeEnd: $rangeEnd
    summaryYear: $summaryYear
  ) {
    accommodationRows {
      orderId
      cancelled
      approvalStatus
      customerName
      productId
      productName {
        en
        fr
        es
      }
      startDate
      endDate
      guests
    }
    eventSales {
      eventId
      eventName
      productId
      sessionId
      sessionDate
      timeSlotLabel
      totalSold
      passesSold
      ticketsSold
      eventDateTotalSold
      eventDatePassesSold
      eventDateTicketsSold
      eventDateArrivedCount
      totalCapacity
      remainingCapacity
      isUnlimited
      eventYearSessionCount
    }
    products {
      _id
      type
      name {
        en
        fr
        es
      }
      accommodationMetadata {
        closures {
          _id
          name
          dateRangeISO {
            start
            end
          }
        }
      }
    }
    availableYears
    yearSummary {
      year
      months {
        month
        count
        hasBookings
        hasClosures
      }
    }
  }
}
    `;

/**
 * __useStorefrontCalendarFeedQuery__
 *
 * To run a query within a React component, call `useStorefrontCalendarFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontCalendarFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontCalendarFeedQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      kind: // value for 'kind'
 *      rangeStart: // value for 'rangeStart'
 *      rangeEnd: // value for 'rangeEnd'
 *      summaryYear: // value for 'summaryYear'
 *   },
 * });
 */
export function useStorefrontCalendarFeedQuery(baseOptions: Apollo.QueryHookOptions<StorefrontCalendarFeedQuery, StorefrontCalendarFeedQueryVariables> & ({ variables: StorefrontCalendarFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontCalendarFeedQuery, StorefrontCalendarFeedQueryVariables>(StorefrontCalendarFeedDocument, options);
      }
export function useStorefrontCalendarFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontCalendarFeedQuery, StorefrontCalendarFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontCalendarFeedQuery, StorefrontCalendarFeedQueryVariables>(StorefrontCalendarFeedDocument, options);
        }
// @ts-ignore
export function useStorefrontCalendarFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontCalendarFeedQuery, StorefrontCalendarFeedQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontCalendarFeedQuery, StorefrontCalendarFeedQueryVariables>;
export function useStorefrontCalendarFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontCalendarFeedQuery, StorefrontCalendarFeedQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontCalendarFeedQuery | undefined, StorefrontCalendarFeedQueryVariables>;
export function useStorefrontCalendarFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontCalendarFeedQuery, StorefrontCalendarFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontCalendarFeedQuery, StorefrontCalendarFeedQueryVariables>(StorefrontCalendarFeedDocument, options);
        }
export type StorefrontCalendarFeedQueryHookResult = ReturnType<typeof useStorefrontCalendarFeedQuery>;
export type StorefrontCalendarFeedLazyQueryHookResult = ReturnType<typeof useStorefrontCalendarFeedLazyQuery>;
export type StorefrontCalendarFeedSuspenseQueryHookResult = ReturnType<typeof useStorefrontCalendarFeedSuspenseQuery>;
export type StorefrontCalendarFeedQueryResult = Apollo.QueryResult<StorefrontCalendarFeedQuery, StorefrontCalendarFeedQueryVariables>;
export const StorefrontConnectedAccountsDocument = gql`
    query StorefrontConnectedAccounts($id: ID!) {
  storefrontConnectedAccounts(id: $id) {
    id
    name
    currency
    status
    canDelete
  }
}
    `;

/**
 * __useStorefrontConnectedAccountsQuery__
 *
 * To run a query within a React component, call `useStorefrontConnectedAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontConnectedAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontConnectedAccountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStorefrontConnectedAccountsQuery(baseOptions: Apollo.QueryHookOptions<StorefrontConnectedAccountsQuery, StorefrontConnectedAccountsQueryVariables> & ({ variables: StorefrontConnectedAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontConnectedAccountsQuery, StorefrontConnectedAccountsQueryVariables>(StorefrontConnectedAccountsDocument, options);
      }
export function useStorefrontConnectedAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontConnectedAccountsQuery, StorefrontConnectedAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontConnectedAccountsQuery, StorefrontConnectedAccountsQueryVariables>(StorefrontConnectedAccountsDocument, options);
        }
// @ts-ignore
export function useStorefrontConnectedAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontConnectedAccountsQuery, StorefrontConnectedAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontConnectedAccountsQuery, StorefrontConnectedAccountsQueryVariables>;
export function useStorefrontConnectedAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontConnectedAccountsQuery, StorefrontConnectedAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontConnectedAccountsQuery | undefined, StorefrontConnectedAccountsQueryVariables>;
export function useStorefrontConnectedAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontConnectedAccountsQuery, StorefrontConnectedAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontConnectedAccountsQuery, StorefrontConnectedAccountsQueryVariables>(StorefrontConnectedAccountsDocument, options);
        }
export type StorefrontConnectedAccountsQueryHookResult = ReturnType<typeof useStorefrontConnectedAccountsQuery>;
export type StorefrontConnectedAccountsLazyQueryHookResult = ReturnType<typeof useStorefrontConnectedAccountsLazyQuery>;
export type StorefrontConnectedAccountsSuspenseQueryHookResult = ReturnType<typeof useStorefrontConnectedAccountsSuspenseQuery>;
export type StorefrontConnectedAccountsQueryResult = Apollo.QueryResult<StorefrontConnectedAccountsQuery, StorefrontConnectedAccountsQueryVariables>;
export const StorefrontCountDocument = gql`
    query StorefrontCount($filter: FilterCountStorefrontInput) {
  storefrontCount(filter: $filter)
}
    `;

/**
 * __useStorefrontCountQuery__
 *
 * To run a query within a React component, call `useStorefrontCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useStorefrontCountQuery(baseOptions?: Apollo.QueryHookOptions<StorefrontCountQuery, StorefrontCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontCountQuery, StorefrontCountQueryVariables>(StorefrontCountDocument, options);
      }
export function useStorefrontCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontCountQuery, StorefrontCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontCountQuery, StorefrontCountQueryVariables>(StorefrontCountDocument, options);
        }
// @ts-ignore
export function useStorefrontCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontCountQuery, StorefrontCountQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontCountQuery, StorefrontCountQueryVariables>;
export function useStorefrontCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontCountQuery, StorefrontCountQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontCountQuery | undefined, StorefrontCountQueryVariables>;
export function useStorefrontCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontCountQuery, StorefrontCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontCountQuery, StorefrontCountQueryVariables>(StorefrontCountDocument, options);
        }
export type StorefrontCountQueryHookResult = ReturnType<typeof useStorefrontCountQuery>;
export type StorefrontCountLazyQueryHookResult = ReturnType<typeof useStorefrontCountLazyQuery>;
export type StorefrontCountSuspenseQueryHookResult = ReturnType<typeof useStorefrontCountSuspenseQuery>;
export type StorefrontCountQueryResult = Apollo.QueryResult<StorefrontCountQuery, StorefrontCountQueryVariables>;
export const StorefrontInventoryDocument = gql`
    query StorefrontInventory($storefrontId: ID!) {
  storefrontInventory(storefrontId: $storefrontId) {
    id
    productId
    productName
    productType
    variantId
    variantLabel
    sku
    remaining
    total
    maxCapacity
    sold
    threshold
    status
    isActive
    lastSoldAt
  }
}
    `;

/**
 * __useStorefrontInventoryQuery__
 *
 * To run a query within a React component, call `useStorefrontInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontInventoryQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *   },
 * });
 */
export function useStorefrontInventoryQuery(baseOptions: Apollo.QueryHookOptions<StorefrontInventoryQuery, StorefrontInventoryQueryVariables> & ({ variables: StorefrontInventoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontInventoryQuery, StorefrontInventoryQueryVariables>(StorefrontInventoryDocument, options);
      }
export function useStorefrontInventoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontInventoryQuery, StorefrontInventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontInventoryQuery, StorefrontInventoryQueryVariables>(StorefrontInventoryDocument, options);
        }
// @ts-ignore
export function useStorefrontInventorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontInventoryQuery, StorefrontInventoryQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontInventoryQuery, StorefrontInventoryQueryVariables>;
export function useStorefrontInventorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontInventoryQuery, StorefrontInventoryQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontInventoryQuery | undefined, StorefrontInventoryQueryVariables>;
export function useStorefrontInventorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontInventoryQuery, StorefrontInventoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontInventoryQuery, StorefrontInventoryQueryVariables>(StorefrontInventoryDocument, options);
        }
export type StorefrontInventoryQueryHookResult = ReturnType<typeof useStorefrontInventoryQuery>;
export type StorefrontInventoryLazyQueryHookResult = ReturnType<typeof useStorefrontInventoryLazyQuery>;
export type StorefrontInventorySuspenseQueryHookResult = ReturnType<typeof useStorefrontInventorySuspenseQuery>;
export type StorefrontInventoryQueryResult = Apollo.QueryResult<StorefrontInventoryQuery, StorefrontInventoryQueryVariables>;
export const StorefrontInventoryLogDocument = gql`
    query StorefrontInventoryLog($storefrontId: ID!, $limit: Int) {
  storefrontInventoryLog(storefrontId: $storefrontId, limit: $limit) {
    id
    createdAt
    productId
    productName
    productType
    variantLabel
    type
    reason
    change
    previousCount
    newCount
    note
    orderId
    userName
  }
}
    `;

/**
 * __useStorefrontInventoryLogQuery__
 *
 * To run a query within a React component, call `useStorefrontInventoryLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontInventoryLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontInventoryLogQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useStorefrontInventoryLogQuery(baseOptions: Apollo.QueryHookOptions<StorefrontInventoryLogQuery, StorefrontInventoryLogQueryVariables> & ({ variables: StorefrontInventoryLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontInventoryLogQuery, StorefrontInventoryLogQueryVariables>(StorefrontInventoryLogDocument, options);
      }
export function useStorefrontInventoryLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontInventoryLogQuery, StorefrontInventoryLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontInventoryLogQuery, StorefrontInventoryLogQueryVariables>(StorefrontInventoryLogDocument, options);
        }
// @ts-ignore
export function useStorefrontInventoryLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontInventoryLogQuery, StorefrontInventoryLogQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontInventoryLogQuery, StorefrontInventoryLogQueryVariables>;
export function useStorefrontInventoryLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontInventoryLogQuery, StorefrontInventoryLogQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontInventoryLogQuery | undefined, StorefrontInventoryLogQueryVariables>;
export function useStorefrontInventoryLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontInventoryLogQuery, StorefrontInventoryLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontInventoryLogQuery, StorefrontInventoryLogQueryVariables>(StorefrontInventoryLogDocument, options);
        }
export type StorefrontInventoryLogQueryHookResult = ReturnType<typeof useStorefrontInventoryLogQuery>;
export type StorefrontInventoryLogLazyQueryHookResult = ReturnType<typeof useStorefrontInventoryLogLazyQuery>;
export type StorefrontInventoryLogSuspenseQueryHookResult = ReturnType<typeof useStorefrontInventoryLogSuspenseQuery>;
export type StorefrontInventoryLogQueryResult = Apollo.QueryResult<StorefrontInventoryLogQuery, StorefrontInventoryLogQueryVariables>;
export const StorefrontInvoiceHeaderDocument = gql`
    query StorefrontInvoiceHeader($id: MongoID!) {
  storefrontById(_id: $id) {
    _id
    name {
      ...MultilingualFragment
    }
    siteMetadata {
      name
      email
      phone
      logo {
        ...ImageFragment
      }
    }
    linkedOrganization {
      _id
      name {
        ...MultilingualFragment
      }
      logo {
        ...ImageFragment
      }
      contact {
        ...ContactFragment
      }
      metadata {
        connectedOperator
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${ContactFragmentFragmentDoc}`;

/**
 * __useStorefrontInvoiceHeaderQuery__
 *
 * To run a query within a React component, call `useStorefrontInvoiceHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontInvoiceHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontInvoiceHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStorefrontInvoiceHeaderQuery(baseOptions: Apollo.QueryHookOptions<StorefrontInvoiceHeaderQuery, StorefrontInvoiceHeaderQueryVariables> & ({ variables: StorefrontInvoiceHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontInvoiceHeaderQuery, StorefrontInvoiceHeaderQueryVariables>(StorefrontInvoiceHeaderDocument, options);
      }
export function useStorefrontInvoiceHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontInvoiceHeaderQuery, StorefrontInvoiceHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontInvoiceHeaderQuery, StorefrontInvoiceHeaderQueryVariables>(StorefrontInvoiceHeaderDocument, options);
        }
// @ts-ignore
export function useStorefrontInvoiceHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontInvoiceHeaderQuery, StorefrontInvoiceHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontInvoiceHeaderQuery, StorefrontInvoiceHeaderQueryVariables>;
export function useStorefrontInvoiceHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontInvoiceHeaderQuery, StorefrontInvoiceHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontInvoiceHeaderQuery | undefined, StorefrontInvoiceHeaderQueryVariables>;
export function useStorefrontInvoiceHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontInvoiceHeaderQuery, StorefrontInvoiceHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontInvoiceHeaderQuery, StorefrontInvoiceHeaderQueryVariables>(StorefrontInvoiceHeaderDocument, options);
        }
export type StorefrontInvoiceHeaderQueryHookResult = ReturnType<typeof useStorefrontInvoiceHeaderQuery>;
export type StorefrontInvoiceHeaderLazyQueryHookResult = ReturnType<typeof useStorefrontInvoiceHeaderLazyQuery>;
export type StorefrontInvoiceHeaderSuspenseQueryHookResult = ReturnType<typeof useStorefrontInvoiceHeaderSuspenseQuery>;
export type StorefrontInvoiceHeaderQueryResult = Apollo.QueryResult<StorefrontInvoiceHeaderQuery, StorefrontInvoiceHeaderQueryVariables>;
export const StorefrontListingCandidatesDocument = gql`
    query StorefrontListingCandidates($storefrontId: ID!) {
  storefrontListingCandidates(storefrontId: $storefrontId) {
    type
    entityId
    name {
      ...MultilingualFragment
    }
    contact {
      ...ContactFragment
    }
    isConnected
    productCount
  }
}
    ${MultilingualFragmentFragmentDoc}
${ContactFragmentFragmentDoc}`;

/**
 * __useStorefrontListingCandidatesQuery__
 *
 * To run a query within a React component, call `useStorefrontListingCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontListingCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontListingCandidatesQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *   },
 * });
 */
export function useStorefrontListingCandidatesQuery(baseOptions: Apollo.QueryHookOptions<StorefrontListingCandidatesQuery, StorefrontListingCandidatesQueryVariables> & ({ variables: StorefrontListingCandidatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontListingCandidatesQuery, StorefrontListingCandidatesQueryVariables>(StorefrontListingCandidatesDocument, options);
      }
export function useStorefrontListingCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontListingCandidatesQuery, StorefrontListingCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontListingCandidatesQuery, StorefrontListingCandidatesQueryVariables>(StorefrontListingCandidatesDocument, options);
        }
// @ts-ignore
export function useStorefrontListingCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontListingCandidatesQuery, StorefrontListingCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontListingCandidatesQuery, StorefrontListingCandidatesQueryVariables>;
export function useStorefrontListingCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontListingCandidatesQuery, StorefrontListingCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontListingCandidatesQuery | undefined, StorefrontListingCandidatesQueryVariables>;
export function useStorefrontListingCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontListingCandidatesQuery, StorefrontListingCandidatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontListingCandidatesQuery, StorefrontListingCandidatesQueryVariables>(StorefrontListingCandidatesDocument, options);
        }
export type StorefrontListingCandidatesQueryHookResult = ReturnType<typeof useStorefrontListingCandidatesQuery>;
export type StorefrontListingCandidatesLazyQueryHookResult = ReturnType<typeof useStorefrontListingCandidatesLazyQuery>;
export type StorefrontListingCandidatesSuspenseQueryHookResult = ReturnType<typeof useStorefrontListingCandidatesSuspenseQuery>;
export type StorefrontListingCandidatesQueryResult = Apollo.QueryResult<StorefrontListingCandidatesQuery, StorefrontListingCandidatesQueryVariables>;
export const StorefrontManyDocument = gql`
    query StorefrontMany($filter: FilterFindManyStorefrontInput, $limit: Int, $skip: Int) {
  storefrontMany(filter: $filter, limit: $limit, skip: $skip) {
    _id
    testMode
    invoicingEnabled
    applicationPercentage
    applicationFeeDefaults {
      membership
      merch
    }
    name {
      ...MultilingualFragment
    }
    siteMetadata {
      name
      slug
      isActive
      logo {
        ...ImageFragment
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useStorefrontManyQuery__
 *
 * To run a query within a React component, call `useStorefrontManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useStorefrontManyQuery(baseOptions?: Apollo.QueryHookOptions<StorefrontManyQuery, StorefrontManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontManyQuery, StorefrontManyQueryVariables>(StorefrontManyDocument, options);
      }
export function useStorefrontManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontManyQuery, StorefrontManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontManyQuery, StorefrontManyQueryVariables>(StorefrontManyDocument, options);
        }
// @ts-ignore
export function useStorefrontManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontManyQuery, StorefrontManyQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontManyQuery, StorefrontManyQueryVariables>;
export function useStorefrontManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontManyQuery, StorefrontManyQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontManyQuery | undefined, StorefrontManyQueryVariables>;
export function useStorefrontManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontManyQuery, StorefrontManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontManyQuery, StorefrontManyQueryVariables>(StorefrontManyDocument, options);
        }
export type StorefrontManyQueryHookResult = ReturnType<typeof useStorefrontManyQuery>;
export type StorefrontManyLazyQueryHookResult = ReturnType<typeof useStorefrontManyLazyQuery>;
export type StorefrontManySuspenseQueryHookResult = ReturnType<typeof useStorefrontManySuspenseQuery>;
export type StorefrontManyQueryResult = Apollo.QueryResult<StorefrontManyQuery, StorefrontManyQueryVariables>;
export const StorefrontOrderHasCompanyDataDocument = gql`
    query StorefrontOrderHasCompanyData($storefrontId: MongoID!, $includeInvoices: Boolean!) {
  storefrontOrderHasCompanyData(
    storefrontId: $storefrontId
    includeInvoices: $includeInvoices
  )
}
    `;

/**
 * __useStorefrontOrderHasCompanyDataQuery__
 *
 * To run a query within a React component, call `useStorefrontOrderHasCompanyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontOrderHasCompanyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontOrderHasCompanyDataQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      includeInvoices: // value for 'includeInvoices'
 *   },
 * });
 */
export function useStorefrontOrderHasCompanyDataQuery(baseOptions: Apollo.QueryHookOptions<StorefrontOrderHasCompanyDataQuery, StorefrontOrderHasCompanyDataQueryVariables> & ({ variables: StorefrontOrderHasCompanyDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontOrderHasCompanyDataQuery, StorefrontOrderHasCompanyDataQueryVariables>(StorefrontOrderHasCompanyDataDocument, options);
      }
export function useStorefrontOrderHasCompanyDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontOrderHasCompanyDataQuery, StorefrontOrderHasCompanyDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontOrderHasCompanyDataQuery, StorefrontOrderHasCompanyDataQueryVariables>(StorefrontOrderHasCompanyDataDocument, options);
        }
// @ts-ignore
export function useStorefrontOrderHasCompanyDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontOrderHasCompanyDataQuery, StorefrontOrderHasCompanyDataQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontOrderHasCompanyDataQuery, StorefrontOrderHasCompanyDataQueryVariables>;
export function useStorefrontOrderHasCompanyDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontOrderHasCompanyDataQuery, StorefrontOrderHasCompanyDataQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontOrderHasCompanyDataQuery | undefined, StorefrontOrderHasCompanyDataQueryVariables>;
export function useStorefrontOrderHasCompanyDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontOrderHasCompanyDataQuery, StorefrontOrderHasCompanyDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontOrderHasCompanyDataQuery, StorefrontOrderHasCompanyDataQueryVariables>(StorefrontOrderHasCompanyDataDocument, options);
        }
export type StorefrontOrderHasCompanyDataQueryHookResult = ReturnType<typeof useStorefrontOrderHasCompanyDataQuery>;
export type StorefrontOrderHasCompanyDataLazyQueryHookResult = ReturnType<typeof useStorefrontOrderHasCompanyDataLazyQuery>;
export type StorefrontOrderHasCompanyDataSuspenseQueryHookResult = ReturnType<typeof useStorefrontOrderHasCompanyDataSuspenseQuery>;
export type StorefrontOrderHasCompanyDataQueryResult = Apollo.QueryResult<StorefrontOrderHasCompanyDataQuery, StorefrontOrderHasCompanyDataQueryVariables>;
export const StorefrontOrderInvoiceFeedDocument = gql`
    query StorefrontOrderInvoiceFeed($storefrontId: MongoID!, $filter: StorefrontOrderInvoiceFeedFilter!, $includeInvoices: Boolean!, $search: String, $createdStartDate: String, $createdEndDate: String, $page: Int, $perPage: Int) {
  storefrontOrderInvoiceFeed(
    storefrontId: $storefrontId
    filter: $filter
    includeInvoices: $includeInvoices
    search: $search
    createdStartDate: $createdStartDate
    createdEndDate: $createdEndDate
    page: $page
    perPage: $perPage
  ) {
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    forReviewCount
    needsAttentionCount
    approvalsPendingCount
    items {
      kind
      businessName
      order {
        _id
        cancelled
        testMode
        approval {
          status
          requestedAt
          expiresAt
          messageFromGuest
          declineReason
        }
        billing {
          timing
          consolidation
          serviceEndAt
          statementPeriod
          invoicePaymentRequestId
        }
        fulfillment {
          status
          note
          fulfilledAt
          carrier
          trackingNumber
        }
        delivery {
          method
        }
        purchasedProducts {
          product {
            _id
            name {
              ...MultilingualFragment
            }
            type
          }
          guestsPerTier {
            count
            tierId
          }
          quantity
          _id
          inventoryClaims {
            _id
            claimedDateRangeISO {
              _id
              end
              metadata
              start
            }
          }
        }
        source {
          type
          booker
          storefront
          renewablePurchaseId
          renewalRecordId
          renewalNextDate
          renewalStatus
        }
        customer {
          _id
          firstName
          lastName
          email
        }
        createdDateISO
        stripeMetadata {
          chargeId
          invoiceId
          invoiceStatus
          paymentMethodId
        }
        paymentMetadata {
          depositSettings {
            enabled
          }
        }
        linkedPaymentRequest {
          _id
          version
          status
          accountingCode
          internalAccountingNotes
          externalReference
          accountingDate
        }
      }
      paymentRequest {
        _id
        invoiceNumber
        booker
        order
        status
        isComplimentary
        version
        grandTotal
        currency
        accountingCode
        internalAccountingNotes
        externalReference
        accountingDate
        dueDate
        createdDateISO
        sentAt
        recipientContact {
          firstName
          lastName
          email
        }
        renewablePurchaseId
        originalOrderId
        nextRenewalDate
        needsAttention
        productNameOverride
        kind
        statementPeriod
        statementLines {
          orderId
        }
        cartSnapshot {
          cart {
            productName
          }
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useStorefrontOrderInvoiceFeedQuery__
 *
 * To run a query within a React component, call `useStorefrontOrderInvoiceFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontOrderInvoiceFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontOrderInvoiceFeedQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      filter: // value for 'filter'
 *      includeInvoices: // value for 'includeInvoices'
 *      search: // value for 'search'
 *      createdStartDate: // value for 'createdStartDate'
 *      createdEndDate: // value for 'createdEndDate'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useStorefrontOrderInvoiceFeedQuery(baseOptions: Apollo.QueryHookOptions<StorefrontOrderInvoiceFeedQuery, StorefrontOrderInvoiceFeedQueryVariables> & ({ variables: StorefrontOrderInvoiceFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontOrderInvoiceFeedQuery, StorefrontOrderInvoiceFeedQueryVariables>(StorefrontOrderInvoiceFeedDocument, options);
      }
export function useStorefrontOrderInvoiceFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontOrderInvoiceFeedQuery, StorefrontOrderInvoiceFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontOrderInvoiceFeedQuery, StorefrontOrderInvoiceFeedQueryVariables>(StorefrontOrderInvoiceFeedDocument, options);
        }
// @ts-ignore
export function useStorefrontOrderInvoiceFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontOrderInvoiceFeedQuery, StorefrontOrderInvoiceFeedQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontOrderInvoiceFeedQuery, StorefrontOrderInvoiceFeedQueryVariables>;
export function useStorefrontOrderInvoiceFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontOrderInvoiceFeedQuery, StorefrontOrderInvoiceFeedQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontOrderInvoiceFeedQuery | undefined, StorefrontOrderInvoiceFeedQueryVariables>;
export function useStorefrontOrderInvoiceFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontOrderInvoiceFeedQuery, StorefrontOrderInvoiceFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontOrderInvoiceFeedQuery, StorefrontOrderInvoiceFeedQueryVariables>(StorefrontOrderInvoiceFeedDocument, options);
        }
export type StorefrontOrderInvoiceFeedQueryHookResult = ReturnType<typeof useStorefrontOrderInvoiceFeedQuery>;
export type StorefrontOrderInvoiceFeedLazyQueryHookResult = ReturnType<typeof useStorefrontOrderInvoiceFeedLazyQuery>;
export type StorefrontOrderInvoiceFeedSuspenseQueryHookResult = ReturnType<typeof useStorefrontOrderInvoiceFeedSuspenseQuery>;
export type StorefrontOrderInvoiceFeedQueryResult = Apollo.QueryResult<StorefrontOrderInvoiceFeedQuery, StorefrontOrderInvoiceFeedQueryVariables>;
export const StorefrontOwnerEntitiesDocument = gql`
    query StorefrontOwnerEntities($storefrontId: ID!) {
  storefrontOwnerEntities(storefrontId: $storefrontId) {
    type
    entityId
    name {
      ...MultilingualFragment
    }
    contact {
      ...ContactFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ContactFragmentFragmentDoc}`;

/**
 * __useStorefrontOwnerEntitiesQuery__
 *
 * To run a query within a React component, call `useStorefrontOwnerEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontOwnerEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontOwnerEntitiesQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *   },
 * });
 */
export function useStorefrontOwnerEntitiesQuery(baseOptions: Apollo.QueryHookOptions<StorefrontOwnerEntitiesQuery, StorefrontOwnerEntitiesQueryVariables> & ({ variables: StorefrontOwnerEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontOwnerEntitiesQuery, StorefrontOwnerEntitiesQueryVariables>(StorefrontOwnerEntitiesDocument, options);
      }
export function useStorefrontOwnerEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontOwnerEntitiesQuery, StorefrontOwnerEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontOwnerEntitiesQuery, StorefrontOwnerEntitiesQueryVariables>(StorefrontOwnerEntitiesDocument, options);
        }
// @ts-ignore
export function useStorefrontOwnerEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontOwnerEntitiesQuery, StorefrontOwnerEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontOwnerEntitiesQuery, StorefrontOwnerEntitiesQueryVariables>;
export function useStorefrontOwnerEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontOwnerEntitiesQuery, StorefrontOwnerEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontOwnerEntitiesQuery | undefined, StorefrontOwnerEntitiesQueryVariables>;
export function useStorefrontOwnerEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontOwnerEntitiesQuery, StorefrontOwnerEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontOwnerEntitiesQuery, StorefrontOwnerEntitiesQueryVariables>(StorefrontOwnerEntitiesDocument, options);
        }
export type StorefrontOwnerEntitiesQueryHookResult = ReturnType<typeof useStorefrontOwnerEntitiesQuery>;
export type StorefrontOwnerEntitiesLazyQueryHookResult = ReturnType<typeof useStorefrontOwnerEntitiesLazyQuery>;
export type StorefrontOwnerEntitiesSuspenseQueryHookResult = ReturnType<typeof useStorefrontOwnerEntitiesSuspenseQuery>;
export type StorefrontOwnerEntitiesQueryResult = Apollo.QueryResult<StorefrontOwnerEntitiesQuery, StorefrontOwnerEntitiesQueryVariables>;
export const StorefrontPagesByStorefrontDocument = gql`
    query StorefrontPagesByStorefront($storefrontId: MongoID!) {
  storefrontPagesByStorefront(storefrontId: $storefrontId) {
    _id
    storefront
    booker
    type
    slug
    generatedPageHtml
    pageGeneratedAt
    editPromptHistory
    status
    pageUrl
    createdDateISO
    updatedDateISO
  }
}
    `;

/**
 * __useStorefrontPagesByStorefrontQuery__
 *
 * To run a query within a React component, call `useStorefrontPagesByStorefrontQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontPagesByStorefrontQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontPagesByStorefrontQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *   },
 * });
 */
export function useStorefrontPagesByStorefrontQuery(baseOptions: Apollo.QueryHookOptions<StorefrontPagesByStorefrontQuery, StorefrontPagesByStorefrontQueryVariables> & ({ variables: StorefrontPagesByStorefrontQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontPagesByStorefrontQuery, StorefrontPagesByStorefrontQueryVariables>(StorefrontPagesByStorefrontDocument, options);
      }
export function useStorefrontPagesByStorefrontLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontPagesByStorefrontQuery, StorefrontPagesByStorefrontQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontPagesByStorefrontQuery, StorefrontPagesByStorefrontQueryVariables>(StorefrontPagesByStorefrontDocument, options);
        }
// @ts-ignore
export function useStorefrontPagesByStorefrontSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontPagesByStorefrontQuery, StorefrontPagesByStorefrontQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontPagesByStorefrontQuery, StorefrontPagesByStorefrontQueryVariables>;
export function useStorefrontPagesByStorefrontSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontPagesByStorefrontQuery, StorefrontPagesByStorefrontQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontPagesByStorefrontQuery | undefined, StorefrontPagesByStorefrontQueryVariables>;
export function useStorefrontPagesByStorefrontSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontPagesByStorefrontQuery, StorefrontPagesByStorefrontQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontPagesByStorefrontQuery, StorefrontPagesByStorefrontQueryVariables>(StorefrontPagesByStorefrontDocument, options);
        }
export type StorefrontPagesByStorefrontQueryHookResult = ReturnType<typeof useStorefrontPagesByStorefrontQuery>;
export type StorefrontPagesByStorefrontLazyQueryHookResult = ReturnType<typeof useStorefrontPagesByStorefrontLazyQuery>;
export type StorefrontPagesByStorefrontSuspenseQueryHookResult = ReturnType<typeof useStorefrontPagesByStorefrontSuspenseQuery>;
export type StorefrontPagesByStorefrontQueryResult = Apollo.QueryResult<StorefrontPagesByStorefrontQuery, StorefrontPagesByStorefrontQueryVariables>;
export const StorefrontPlatformSettingsDocument = gql`
    query StorefrontPlatformSettings {
  storefrontPlatformSettings {
    _id
    gettingStartedWistiaId
  }
}
    `;

/**
 * __useStorefrontPlatformSettingsQuery__
 *
 * To run a query within a React component, call `useStorefrontPlatformSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontPlatformSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontPlatformSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStorefrontPlatformSettingsQuery(baseOptions?: Apollo.QueryHookOptions<StorefrontPlatformSettingsQuery, StorefrontPlatformSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontPlatformSettingsQuery, StorefrontPlatformSettingsQueryVariables>(StorefrontPlatformSettingsDocument, options);
      }
export function useStorefrontPlatformSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontPlatformSettingsQuery, StorefrontPlatformSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontPlatformSettingsQuery, StorefrontPlatformSettingsQueryVariables>(StorefrontPlatformSettingsDocument, options);
        }
// @ts-ignore
export function useStorefrontPlatformSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontPlatformSettingsQuery, StorefrontPlatformSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontPlatformSettingsQuery, StorefrontPlatformSettingsQueryVariables>;
export function useStorefrontPlatformSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontPlatformSettingsQuery, StorefrontPlatformSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontPlatformSettingsQuery | undefined, StorefrontPlatformSettingsQueryVariables>;
export function useStorefrontPlatformSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontPlatformSettingsQuery, StorefrontPlatformSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontPlatformSettingsQuery, StorefrontPlatformSettingsQueryVariables>(StorefrontPlatformSettingsDocument, options);
        }
export type StorefrontPlatformSettingsQueryHookResult = ReturnType<typeof useStorefrontPlatformSettingsQuery>;
export type StorefrontPlatformSettingsLazyQueryHookResult = ReturnType<typeof useStorefrontPlatformSettingsLazyQuery>;
export type StorefrontPlatformSettingsSuspenseQueryHookResult = ReturnType<typeof useStorefrontPlatformSettingsSuspenseQuery>;
export type StorefrontPlatformSettingsQueryResult = Apollo.QueryResult<StorefrontPlatformSettingsQuery, StorefrontPlatformSettingsQueryVariables>;
export const StorefrontResumeStripeAccountSetupDocument = gql`
    query StorefrontResumeStripeAccountSetup($connectedAccountId: ID!, $redirectUrl: String!, $storefrontId: ID) {
  storefrontResumeStripeAccountSetup(
    connectedAccountId: $connectedAccountId
    redirectUrl: $redirectUrl
    storefrontId: $storefrontId
  )
}
    `;

/**
 * __useStorefrontResumeStripeAccountSetupQuery__
 *
 * To run a query within a React component, call `useStorefrontResumeStripeAccountSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontResumeStripeAccountSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontResumeStripeAccountSetupQuery({
 *   variables: {
 *      connectedAccountId: // value for 'connectedAccountId'
 *      redirectUrl: // value for 'redirectUrl'
 *      storefrontId: // value for 'storefrontId'
 *   },
 * });
 */
export function useStorefrontResumeStripeAccountSetupQuery(baseOptions: Apollo.QueryHookOptions<StorefrontResumeStripeAccountSetupQuery, StorefrontResumeStripeAccountSetupQueryVariables> & ({ variables: StorefrontResumeStripeAccountSetupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontResumeStripeAccountSetupQuery, StorefrontResumeStripeAccountSetupQueryVariables>(StorefrontResumeStripeAccountSetupDocument, options);
      }
export function useStorefrontResumeStripeAccountSetupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontResumeStripeAccountSetupQuery, StorefrontResumeStripeAccountSetupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontResumeStripeAccountSetupQuery, StorefrontResumeStripeAccountSetupQueryVariables>(StorefrontResumeStripeAccountSetupDocument, options);
        }
// @ts-ignore
export function useStorefrontResumeStripeAccountSetupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontResumeStripeAccountSetupQuery, StorefrontResumeStripeAccountSetupQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontResumeStripeAccountSetupQuery, StorefrontResumeStripeAccountSetupQueryVariables>;
export function useStorefrontResumeStripeAccountSetupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontResumeStripeAccountSetupQuery, StorefrontResumeStripeAccountSetupQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontResumeStripeAccountSetupQuery | undefined, StorefrontResumeStripeAccountSetupQueryVariables>;
export function useStorefrontResumeStripeAccountSetupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontResumeStripeAccountSetupQuery, StorefrontResumeStripeAccountSetupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontResumeStripeAccountSetupQuery, StorefrontResumeStripeAccountSetupQueryVariables>(StorefrontResumeStripeAccountSetupDocument, options);
        }
export type StorefrontResumeStripeAccountSetupQueryHookResult = ReturnType<typeof useStorefrontResumeStripeAccountSetupQuery>;
export type StorefrontResumeStripeAccountSetupLazyQueryHookResult = ReturnType<typeof useStorefrontResumeStripeAccountSetupLazyQuery>;
export type StorefrontResumeStripeAccountSetupSuspenseQueryHookResult = ReturnType<typeof useStorefrontResumeStripeAccountSetupSuspenseQuery>;
export type StorefrontResumeStripeAccountSetupQueryResult = Apollo.QueryResult<StorefrontResumeStripeAccountSetupQuery, StorefrontResumeStripeAccountSetupQueryVariables>;
export const StorefrontStatementPreviewDocument = gql`
    query StorefrontStatementPreview($storefrontId: MongoID!, $period: String!) {
  storefrontStatementPreview(storefrontId: $storefrontId, period: $period) {
    customerId
    customerName
    email
    currency
    orderIds
    grandTotal
  }
}
    `;

/**
 * __useStorefrontStatementPreviewQuery__
 *
 * To run a query within a React component, call `useStorefrontStatementPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontStatementPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontStatementPreviewQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useStorefrontStatementPreviewQuery(baseOptions: Apollo.QueryHookOptions<StorefrontStatementPreviewQuery, StorefrontStatementPreviewQueryVariables> & ({ variables: StorefrontStatementPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontStatementPreviewQuery, StorefrontStatementPreviewQueryVariables>(StorefrontStatementPreviewDocument, options);
      }
export function useStorefrontStatementPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontStatementPreviewQuery, StorefrontStatementPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontStatementPreviewQuery, StorefrontStatementPreviewQueryVariables>(StorefrontStatementPreviewDocument, options);
        }
// @ts-ignore
export function useStorefrontStatementPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontStatementPreviewQuery, StorefrontStatementPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontStatementPreviewQuery, StorefrontStatementPreviewQueryVariables>;
export function useStorefrontStatementPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontStatementPreviewQuery, StorefrontStatementPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontStatementPreviewQuery | undefined, StorefrontStatementPreviewQueryVariables>;
export function useStorefrontStatementPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontStatementPreviewQuery, StorefrontStatementPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontStatementPreviewQuery, StorefrontStatementPreviewQueryVariables>(StorefrontStatementPreviewDocument, options);
        }
export type StorefrontStatementPreviewQueryHookResult = ReturnType<typeof useStorefrontStatementPreviewQuery>;
export type StorefrontStatementPreviewLazyQueryHookResult = ReturnType<typeof useStorefrontStatementPreviewLazyQuery>;
export type StorefrontStatementPreviewSuspenseQueryHookResult = ReturnType<typeof useStorefrontStatementPreviewSuspenseQuery>;
export type StorefrontStatementPreviewQueryResult = Apollo.QueryResult<StorefrontStatementPreviewQuery, StorefrontStatementPreviewQueryVariables>;
export const StorefrontStatementRunsDocument = gql`
    query StorefrontStatementRuns($storefrontId: MongoID!, $limit: Int) {
  storefrontStatementRuns(storefrontId: $storefrontId, limit: $limit) {
    _id
    period
    status
    createdByName
    statementCount
    grandTotalSum
    currency
    createdDateISO
    rolledBackAt
    rolledBackByName
    items {
      paymentRequestId
      invoiceNumber
      customerName
      orderIds
      grandTotal
      rollbackStatus
    }
  }
}
    `;

/**
 * __useStorefrontStatementRunsQuery__
 *
 * To run a query within a React component, call `useStorefrontStatementRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontStatementRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontStatementRunsQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useStorefrontStatementRunsQuery(baseOptions: Apollo.QueryHookOptions<StorefrontStatementRunsQuery, StorefrontStatementRunsQueryVariables> & ({ variables: StorefrontStatementRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontStatementRunsQuery, StorefrontStatementRunsQueryVariables>(StorefrontStatementRunsDocument, options);
      }
export function useStorefrontStatementRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontStatementRunsQuery, StorefrontStatementRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontStatementRunsQuery, StorefrontStatementRunsQueryVariables>(StorefrontStatementRunsDocument, options);
        }
// @ts-ignore
export function useStorefrontStatementRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontStatementRunsQuery, StorefrontStatementRunsQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontStatementRunsQuery, StorefrontStatementRunsQueryVariables>;
export function useStorefrontStatementRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontStatementRunsQuery, StorefrontStatementRunsQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontStatementRunsQuery | undefined, StorefrontStatementRunsQueryVariables>;
export function useStorefrontStatementRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontStatementRunsQuery, StorefrontStatementRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontStatementRunsQuery, StorefrontStatementRunsQueryVariables>(StorefrontStatementRunsDocument, options);
        }
export type StorefrontStatementRunsQueryHookResult = ReturnType<typeof useStorefrontStatementRunsQuery>;
export type StorefrontStatementRunsLazyQueryHookResult = ReturnType<typeof useStorefrontStatementRunsLazyQuery>;
export type StorefrontStatementRunsSuspenseQueryHookResult = ReturnType<typeof useStorefrontStatementRunsSuspenseQuery>;
export type StorefrontStatementRunsQueryResult = Apollo.QueryResult<StorefrontStatementRunsQuery, StorefrontStatementRunsQueryVariables>;
export const StorefrontStripeAccountBlockingWidgetsDocument = gql`
    query StorefrontStripeAccountBlockingWidgets($storefrontId: ID!, $connectedAccountId: String!) {
  storefrontStripeAccountBlockingWidgets(
    storefrontId: $storefrontId
    connectedAccountId: $connectedAccountId
  )
}
    `;

/**
 * __useStorefrontStripeAccountBlockingWidgetsQuery__
 *
 * To run a query within a React component, call `useStorefrontStripeAccountBlockingWidgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontStripeAccountBlockingWidgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontStripeAccountBlockingWidgetsQuery({
 *   variables: {
 *      storefrontId: // value for 'storefrontId'
 *      connectedAccountId: // value for 'connectedAccountId'
 *   },
 * });
 */
export function useStorefrontStripeAccountBlockingWidgetsQuery(baseOptions: Apollo.QueryHookOptions<StorefrontStripeAccountBlockingWidgetsQuery, StorefrontStripeAccountBlockingWidgetsQueryVariables> & ({ variables: StorefrontStripeAccountBlockingWidgetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontStripeAccountBlockingWidgetsQuery, StorefrontStripeAccountBlockingWidgetsQueryVariables>(StorefrontStripeAccountBlockingWidgetsDocument, options);
      }
export function useStorefrontStripeAccountBlockingWidgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontStripeAccountBlockingWidgetsQuery, StorefrontStripeAccountBlockingWidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontStripeAccountBlockingWidgetsQuery, StorefrontStripeAccountBlockingWidgetsQueryVariables>(StorefrontStripeAccountBlockingWidgetsDocument, options);
        }
// @ts-ignore
export function useStorefrontStripeAccountBlockingWidgetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontStripeAccountBlockingWidgetsQuery, StorefrontStripeAccountBlockingWidgetsQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontStripeAccountBlockingWidgetsQuery, StorefrontStripeAccountBlockingWidgetsQueryVariables>;
export function useStorefrontStripeAccountBlockingWidgetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontStripeAccountBlockingWidgetsQuery, StorefrontStripeAccountBlockingWidgetsQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontStripeAccountBlockingWidgetsQuery | undefined, StorefrontStripeAccountBlockingWidgetsQueryVariables>;
export function useStorefrontStripeAccountBlockingWidgetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontStripeAccountBlockingWidgetsQuery, StorefrontStripeAccountBlockingWidgetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontStripeAccountBlockingWidgetsQuery, StorefrontStripeAccountBlockingWidgetsQueryVariables>(StorefrontStripeAccountBlockingWidgetsDocument, options);
        }
export type StorefrontStripeAccountBlockingWidgetsQueryHookResult = ReturnType<typeof useStorefrontStripeAccountBlockingWidgetsQuery>;
export type StorefrontStripeAccountBlockingWidgetsLazyQueryHookResult = ReturnType<typeof useStorefrontStripeAccountBlockingWidgetsLazyQuery>;
export type StorefrontStripeAccountBlockingWidgetsSuspenseQueryHookResult = ReturnType<typeof useStorefrontStripeAccountBlockingWidgetsSuspenseQuery>;
export type StorefrontStripeAccountBlockingWidgetsQueryResult = Apollo.QueryResult<StorefrontStripeAccountBlockingWidgetsQuery, StorefrontStripeAccountBlockingWidgetsQueryVariables>;
export const StorefrontTestModeFlagDocument = gql`
    query StorefrontTestModeFlag($id: MongoID!) {
  storefrontById(_id: $id) {
    _id
    testMode
  }
}
    `;

/**
 * __useStorefrontTestModeFlagQuery__
 *
 * To run a query within a React component, call `useStorefrontTestModeFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontTestModeFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontTestModeFlagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStorefrontTestModeFlagQuery(baseOptions: Apollo.QueryHookOptions<StorefrontTestModeFlagQuery, StorefrontTestModeFlagQueryVariables> & ({ variables: StorefrontTestModeFlagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontTestModeFlagQuery, StorefrontTestModeFlagQueryVariables>(StorefrontTestModeFlagDocument, options);
      }
export function useStorefrontTestModeFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontTestModeFlagQuery, StorefrontTestModeFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontTestModeFlagQuery, StorefrontTestModeFlagQueryVariables>(StorefrontTestModeFlagDocument, options);
        }
// @ts-ignore
export function useStorefrontTestModeFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontTestModeFlagQuery, StorefrontTestModeFlagQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontTestModeFlagQuery, StorefrontTestModeFlagQueryVariables>;
export function useStorefrontTestModeFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontTestModeFlagQuery, StorefrontTestModeFlagQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontTestModeFlagQuery | undefined, StorefrontTestModeFlagQueryVariables>;
export function useStorefrontTestModeFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontTestModeFlagQuery, StorefrontTestModeFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontTestModeFlagQuery, StorefrontTestModeFlagQueryVariables>(StorefrontTestModeFlagDocument, options);
        }
export type StorefrontTestModeFlagQueryHookResult = ReturnType<typeof useStorefrontTestModeFlagQuery>;
export type StorefrontTestModeFlagLazyQueryHookResult = ReturnType<typeof useStorefrontTestModeFlagLazyQuery>;
export type StorefrontTestModeFlagSuspenseQueryHookResult = ReturnType<typeof useStorefrontTestModeFlagSuspenseQuery>;
export type StorefrontTestModeFlagQueryResult = Apollo.QueryResult<StorefrontTestModeFlagQuery, StorefrontTestModeFlagQueryVariables>;
export const StorefrontsByUserDocument = gql`
    query StorefrontsByUser {
  storefrontsByUser {
    _id
    connectedAccountIds
    createdDateISO
    testMode
    stripeRegion
    testStorefront
    liveStorefront
    isLaunched
    paymentsMode
    name {
      en
      fr
      es
    }
  }
}
    `;

/**
 * __useStorefrontsByUserQuery__
 *
 * To run a query within a React component, call `useStorefrontsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontsByUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useStorefrontsByUserQuery(baseOptions?: Apollo.QueryHookOptions<StorefrontsByUserQuery, StorefrontsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontsByUserQuery, StorefrontsByUserQueryVariables>(StorefrontsByUserDocument, options);
      }
export function useStorefrontsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontsByUserQuery, StorefrontsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontsByUserQuery, StorefrontsByUserQueryVariables>(StorefrontsByUserDocument, options);
        }
// @ts-ignore
export function useStorefrontsByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StorefrontsByUserQuery, StorefrontsByUserQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontsByUserQuery, StorefrontsByUserQueryVariables>;
export function useStorefrontsByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontsByUserQuery, StorefrontsByUserQueryVariables>): Apollo.UseSuspenseQueryResult<StorefrontsByUserQuery | undefined, StorefrontsByUserQueryVariables>;
export function useStorefrontsByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StorefrontsByUserQuery, StorefrontsByUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StorefrontsByUserQuery, StorefrontsByUserQueryVariables>(StorefrontsByUserDocument, options);
        }
export type StorefrontsByUserQueryHookResult = ReturnType<typeof useStorefrontsByUserQuery>;
export type StorefrontsByUserLazyQueryHookResult = ReturnType<typeof useStorefrontsByUserLazyQuery>;
export type StorefrontsByUserSuspenseQueryHookResult = ReturnType<typeof useStorefrontsByUserSuspenseQuery>;
export type StorefrontsByUserQueryResult = Apollo.QueryResult<StorefrontsByUserQuery, StorefrontsByUserQueryVariables>;
export const SurveyByIdDocument = gql`
    query SurveyById($id: MongoID!) {
  surveyById(_id: $id) {
    ...SurveyFragment
  }
}
    ${SurveyFragmentFragmentDoc}`;

/**
 * __useSurveyByIdQuery__
 *
 * To run a query within a React component, call `useSurveyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSurveyByIdQuery(baseOptions: Apollo.QueryHookOptions<SurveyByIdQuery, SurveyByIdQueryVariables> & ({ variables: SurveyByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyByIdQuery, SurveyByIdQueryVariables>(SurveyByIdDocument, options);
      }
export function useSurveyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyByIdQuery, SurveyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyByIdQuery, SurveyByIdQueryVariables>(SurveyByIdDocument, options);
        }
// @ts-ignore
export function useSurveyByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyByIdQuery, SurveyByIdQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyByIdQuery, SurveyByIdQueryVariables>;
export function useSurveyByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyByIdQuery, SurveyByIdQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyByIdQuery | undefined, SurveyByIdQueryVariables>;
export function useSurveyByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyByIdQuery, SurveyByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyByIdQuery, SurveyByIdQueryVariables>(SurveyByIdDocument, options);
        }
export type SurveyByIdQueryHookResult = ReturnType<typeof useSurveyByIdQuery>;
export type SurveyByIdLazyQueryHookResult = ReturnType<typeof useSurveyByIdLazyQuery>;
export type SurveyByIdSuspenseQueryHookResult = ReturnType<typeof useSurveyByIdSuspenseQuery>;
export type SurveyByIdQueryResult = Apollo.QueryResult<SurveyByIdQuery, SurveyByIdQueryVariables>;
export const SurveyManyDocument = gql`
    query SurveyMany($filter: FilterFindManySurveyInput, $limit: Int) {
  surveyMany(filter: $filter, limit: $limit) {
    ...SurveyFragment
  }
}
    ${SurveyFragmentFragmentDoc}`;

/**
 * __useSurveyManyQuery__
 *
 * To run a query within a React component, call `useSurveyManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSurveyManyQuery(baseOptions?: Apollo.QueryHookOptions<SurveyManyQuery, SurveyManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyManyQuery, SurveyManyQueryVariables>(SurveyManyDocument, options);
      }
export function useSurveyManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyManyQuery, SurveyManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyManyQuery, SurveyManyQueryVariables>(SurveyManyDocument, options);
        }
// @ts-ignore
export function useSurveyManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyManyQuery, SurveyManyQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyManyQuery, SurveyManyQueryVariables>;
export function useSurveyManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyManyQuery, SurveyManyQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyManyQuery | undefined, SurveyManyQueryVariables>;
export function useSurveyManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyManyQuery, SurveyManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyManyQuery, SurveyManyQueryVariables>(SurveyManyDocument, options);
        }
export type SurveyManyQueryHookResult = ReturnType<typeof useSurveyManyQuery>;
export type SurveyManyLazyQueryHookResult = ReturnType<typeof useSurveyManyLazyQuery>;
export type SurveyManySuspenseQueryHookResult = ReturnType<typeof useSurveyManySuspenseQuery>;
export type SurveyManyQueryResult = Apollo.QueryResult<SurveyManyQuery, SurveyManyQueryVariables>;
export const SurveyResponseByIdDocument = gql`
    query SurveyResponseById($id: MongoID!) {
  surveyResponseById(_id: $id) {
    _id
    createdDateISO
    status
    adminStatus
    tags
    responses {
      questionData {
        _id
        isActive
        name {
          ...MultilingualFragment
        }
        owner {
          type
          entityId
        }
        type
        required
        whereaboutsSearchEntityType
        parentQuestion
        businessScope
        options {
          _id
          label {
            ...MultilingualFragment
          }
          isActive
        }
      }
      response
      byBusiness {
        operatorId
        response
      }
    }
    ownerBusinesses {
      operatorId
      businessName
    }
    ownerMetadata {
      organization
    }
    history {
      action
      timestamp
      personName
      reviewStatus
      reviewNote
    }
    survey {
      _id
      name {
        ...MultilingualFragment
      }
    }
    person {
      _id
      firstName
      lastName
      email
      phone
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useSurveyResponseByIdQuery__
 *
 * To run a query within a React component, call `useSurveyResponseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyResponseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyResponseByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSurveyResponseByIdQuery(baseOptions: Apollo.QueryHookOptions<SurveyResponseByIdQuery, SurveyResponseByIdQueryVariables> & ({ variables: SurveyResponseByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyResponseByIdQuery, SurveyResponseByIdQueryVariables>(SurveyResponseByIdDocument, options);
      }
export function useSurveyResponseByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyResponseByIdQuery, SurveyResponseByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyResponseByIdQuery, SurveyResponseByIdQueryVariables>(SurveyResponseByIdDocument, options);
        }
// @ts-ignore
export function useSurveyResponseByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyResponseByIdQuery, SurveyResponseByIdQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyResponseByIdQuery, SurveyResponseByIdQueryVariables>;
export function useSurveyResponseByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyResponseByIdQuery, SurveyResponseByIdQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyResponseByIdQuery | undefined, SurveyResponseByIdQueryVariables>;
export function useSurveyResponseByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyResponseByIdQuery, SurveyResponseByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyResponseByIdQuery, SurveyResponseByIdQueryVariables>(SurveyResponseByIdDocument, options);
        }
export type SurveyResponseByIdQueryHookResult = ReturnType<typeof useSurveyResponseByIdQuery>;
export type SurveyResponseByIdLazyQueryHookResult = ReturnType<typeof useSurveyResponseByIdLazyQuery>;
export type SurveyResponseByIdSuspenseQueryHookResult = ReturnType<typeof useSurveyResponseByIdSuspenseQuery>;
export type SurveyResponseByIdQueryResult = Apollo.QueryResult<SurveyResponseByIdQuery, SurveyResponseByIdQueryVariables>;
export const SurveyResponseForBroadcastResourceDocument = gql`
    query SurveyResponseForBroadcastResource($broadcastId: String!, $resourceId: String!, $personId: String!, $isShared: Boolean, $submissionIndex: Int) {
  surveyResponseForBroadcastResource(
    broadcastId: $broadcastId
    resourceId: $resourceId
    personId: $personId
    isShared: $isShared
    submissionIndex: $submissionIndex
  ) {
    _id
    status
    version
    adminStatus
    surveyUpdatedAt
    responses {
      questionData {
        _id
        name {
          en
        }
        type
        options {
          _id
          label {
            en
          }
        }
        required
        parentQuestion
        businessScope
      }
      response
      byBusiness {
        operatorId
        response
      }
    }
    ownerBusinesses {
      operatorId
      businessName
    }
    history {
      action
      savedBy
      personName
      timestamp
      reviewStatus
      reviewedBy
      reviewedAt
      reviewNote
    }
  }
}
    `;

/**
 * __useSurveyResponseForBroadcastResourceQuery__
 *
 * To run a query within a React component, call `useSurveyResponseForBroadcastResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyResponseForBroadcastResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyResponseForBroadcastResourceQuery({
 *   variables: {
 *      broadcastId: // value for 'broadcastId'
 *      resourceId: // value for 'resourceId'
 *      personId: // value for 'personId'
 *      isShared: // value for 'isShared'
 *      submissionIndex: // value for 'submissionIndex'
 *   },
 * });
 */
export function useSurveyResponseForBroadcastResourceQuery(baseOptions: Apollo.QueryHookOptions<SurveyResponseForBroadcastResourceQuery, SurveyResponseForBroadcastResourceQueryVariables> & ({ variables: SurveyResponseForBroadcastResourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyResponseForBroadcastResourceQuery, SurveyResponseForBroadcastResourceQueryVariables>(SurveyResponseForBroadcastResourceDocument, options);
      }
export function useSurveyResponseForBroadcastResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyResponseForBroadcastResourceQuery, SurveyResponseForBroadcastResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyResponseForBroadcastResourceQuery, SurveyResponseForBroadcastResourceQueryVariables>(SurveyResponseForBroadcastResourceDocument, options);
        }
// @ts-ignore
export function useSurveyResponseForBroadcastResourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyResponseForBroadcastResourceQuery, SurveyResponseForBroadcastResourceQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyResponseForBroadcastResourceQuery, SurveyResponseForBroadcastResourceQueryVariables>;
export function useSurveyResponseForBroadcastResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyResponseForBroadcastResourceQuery, SurveyResponseForBroadcastResourceQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyResponseForBroadcastResourceQuery | undefined, SurveyResponseForBroadcastResourceQueryVariables>;
export function useSurveyResponseForBroadcastResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyResponseForBroadcastResourceQuery, SurveyResponseForBroadcastResourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyResponseForBroadcastResourceQuery, SurveyResponseForBroadcastResourceQueryVariables>(SurveyResponseForBroadcastResourceDocument, options);
        }
export type SurveyResponseForBroadcastResourceQueryHookResult = ReturnType<typeof useSurveyResponseForBroadcastResourceQuery>;
export type SurveyResponseForBroadcastResourceLazyQueryHookResult = ReturnType<typeof useSurveyResponseForBroadcastResourceLazyQuery>;
export type SurveyResponseForBroadcastResourceSuspenseQueryHookResult = ReturnType<typeof useSurveyResponseForBroadcastResourceSuspenseQuery>;
export type SurveyResponseForBroadcastResourceQueryResult = Apollo.QueryResult<SurveyResponseForBroadcastResourceQuery, SurveyResponseForBroadcastResourceQueryVariables>;
export const SurveyResponsesByWidgetDocument = gql`
    query SurveyResponsesByWidget($widgetId: String!) {
  surveyResponsesByWidget(widgetId: $widgetId) {
    _id
    createdDateISO
    adminStatus
    isTest
    person {
      _id
      firstName
      lastName
      email
    }
    responses {
      questionData {
        _id
        type
        name {
          en
        }
      }
      response
    }
  }
}
    `;

/**
 * __useSurveyResponsesByWidgetQuery__
 *
 * To run a query within a React component, call `useSurveyResponsesByWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyResponsesByWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyResponsesByWidgetQuery({
 *   variables: {
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useSurveyResponsesByWidgetQuery(baseOptions: Apollo.QueryHookOptions<SurveyResponsesByWidgetQuery, SurveyResponsesByWidgetQueryVariables> & ({ variables: SurveyResponsesByWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyResponsesByWidgetQuery, SurveyResponsesByWidgetQueryVariables>(SurveyResponsesByWidgetDocument, options);
      }
export function useSurveyResponsesByWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyResponsesByWidgetQuery, SurveyResponsesByWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyResponsesByWidgetQuery, SurveyResponsesByWidgetQueryVariables>(SurveyResponsesByWidgetDocument, options);
        }
// @ts-ignore
export function useSurveyResponsesByWidgetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyResponsesByWidgetQuery, SurveyResponsesByWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyResponsesByWidgetQuery, SurveyResponsesByWidgetQueryVariables>;
export function useSurveyResponsesByWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyResponsesByWidgetQuery, SurveyResponsesByWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyResponsesByWidgetQuery | undefined, SurveyResponsesByWidgetQueryVariables>;
export function useSurveyResponsesByWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyResponsesByWidgetQuery, SurveyResponsesByWidgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyResponsesByWidgetQuery, SurveyResponsesByWidgetQueryVariables>(SurveyResponsesByWidgetDocument, options);
        }
export type SurveyResponsesByWidgetQueryHookResult = ReturnType<typeof useSurveyResponsesByWidgetQuery>;
export type SurveyResponsesByWidgetLazyQueryHookResult = ReturnType<typeof useSurveyResponsesByWidgetLazyQuery>;
export type SurveyResponsesByWidgetSuspenseQueryHookResult = ReturnType<typeof useSurveyResponsesByWidgetSuspenseQuery>;
export type SurveyResponsesByWidgetQueryResult = Apollo.QueryResult<SurveyResponsesByWidgetQuery, SurveyResponsesByWidgetQueryVariables>;
export const SurveyResponsesForBroadcastResourceDocument = gql`
    query SurveyResponsesForBroadcastResource($broadcastId: String!, $resourceId: String!, $personId: String!) {
  surveyResponsesForBroadcastResource(
    broadcastId: $broadcastId
    resourceId: $resourceId
    personId: $personId
  ) {
    _id
    person {
      _id
    }
    status
    version
    submissionIndex
    adminStatus
    summary
    surveyUpdatedAt
    responses {
      questionData {
        _id
        name {
          en
        }
        type
        options {
          _id
          label {
            en
          }
        }
        required
      }
      response
    }
    history {
      action
      savedBy
      personName
      timestamp
      reviewStatus
      reviewedBy
      reviewedAt
      reviewNote
    }
  }
}
    `;

/**
 * __useSurveyResponsesForBroadcastResourceQuery__
 *
 * To run a query within a React component, call `useSurveyResponsesForBroadcastResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyResponsesForBroadcastResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyResponsesForBroadcastResourceQuery({
 *   variables: {
 *      broadcastId: // value for 'broadcastId'
 *      resourceId: // value for 'resourceId'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useSurveyResponsesForBroadcastResourceQuery(baseOptions: Apollo.QueryHookOptions<SurveyResponsesForBroadcastResourceQuery, SurveyResponsesForBroadcastResourceQueryVariables> & ({ variables: SurveyResponsesForBroadcastResourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyResponsesForBroadcastResourceQuery, SurveyResponsesForBroadcastResourceQueryVariables>(SurveyResponsesForBroadcastResourceDocument, options);
      }
export function useSurveyResponsesForBroadcastResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyResponsesForBroadcastResourceQuery, SurveyResponsesForBroadcastResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyResponsesForBroadcastResourceQuery, SurveyResponsesForBroadcastResourceQueryVariables>(SurveyResponsesForBroadcastResourceDocument, options);
        }
// @ts-ignore
export function useSurveyResponsesForBroadcastResourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyResponsesForBroadcastResourceQuery, SurveyResponsesForBroadcastResourceQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyResponsesForBroadcastResourceQuery, SurveyResponsesForBroadcastResourceQueryVariables>;
export function useSurveyResponsesForBroadcastResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyResponsesForBroadcastResourceQuery, SurveyResponsesForBroadcastResourceQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyResponsesForBroadcastResourceQuery | undefined, SurveyResponsesForBroadcastResourceQueryVariables>;
export function useSurveyResponsesForBroadcastResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyResponsesForBroadcastResourceQuery, SurveyResponsesForBroadcastResourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyResponsesForBroadcastResourceQuery, SurveyResponsesForBroadcastResourceQueryVariables>(SurveyResponsesForBroadcastResourceDocument, options);
        }
export type SurveyResponsesForBroadcastResourceQueryHookResult = ReturnType<typeof useSurveyResponsesForBroadcastResourceQuery>;
export type SurveyResponsesForBroadcastResourceLazyQueryHookResult = ReturnType<typeof useSurveyResponsesForBroadcastResourceLazyQuery>;
export type SurveyResponsesForBroadcastResourceSuspenseQueryHookResult = ReturnType<typeof useSurveyResponsesForBroadcastResourceSuspenseQuery>;
export type SurveyResponsesForBroadcastResourceQueryResult = Apollo.QueryResult<SurveyResponsesForBroadcastResourceQuery, SurveyResponsesForBroadcastResourceQueryVariables>;
export const SurveyUsageDocument = gql`
    query SurveyUsage($surveyIds: [MongoID!]!) {
  surveyUsage(surveyIds: $surveyIds) {
    surveyId
    bookers {
      ...MultilingualFragment
    }
    products {
      ...MultilingualFragment
    }
    widgets {
      ...MultilingualFragment
    }
    broadcasts {
      ...MultilingualFragment
    }
    responseCount
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useSurveyUsageQuery__
 *
 * To run a query within a React component, call `useSurveyUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyUsageQuery({
 *   variables: {
 *      surveyIds: // value for 'surveyIds'
 *   },
 * });
 */
export function useSurveyUsageQuery(baseOptions: Apollo.QueryHookOptions<SurveyUsageQuery, SurveyUsageQueryVariables> & ({ variables: SurveyUsageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyUsageQuery, SurveyUsageQueryVariables>(SurveyUsageDocument, options);
      }
export function useSurveyUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyUsageQuery, SurveyUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyUsageQuery, SurveyUsageQueryVariables>(SurveyUsageDocument, options);
        }
// @ts-ignore
export function useSurveyUsageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyUsageQuery, SurveyUsageQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyUsageQuery, SurveyUsageQueryVariables>;
export function useSurveyUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyUsageQuery, SurveyUsageQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyUsageQuery | undefined, SurveyUsageQueryVariables>;
export function useSurveyUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyUsageQuery, SurveyUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyUsageQuery, SurveyUsageQueryVariables>(SurveyUsageDocument, options);
        }
export type SurveyUsageQueryHookResult = ReturnType<typeof useSurveyUsageQuery>;
export type SurveyUsageLazyQueryHookResult = ReturnType<typeof useSurveyUsageLazyQuery>;
export type SurveyUsageSuspenseQueryHookResult = ReturnType<typeof useSurveyUsageSuspenseQuery>;
export type SurveyUsageQueryResult = Apollo.QueryResult<SurveyUsageQuery, SurveyUsageQueryVariables>;
export const TagByIdDocument = gql`
    query TagById($id: MongoID!) {
  tagById(_id: $id) {
    ...TagFragmentWithUsage
  }
}
    ${TagFragmentWithUsageFragmentDoc}`;

/**
 * __useTagByIdQuery__
 *
 * To run a query within a React component, call `useTagByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagByIdQuery(baseOptions: Apollo.QueryHookOptions<TagByIdQuery, TagByIdQueryVariables> & ({ variables: TagByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagByIdQuery, TagByIdQueryVariables>(TagByIdDocument, options);
      }
export function useTagByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagByIdQuery, TagByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagByIdQuery, TagByIdQueryVariables>(TagByIdDocument, options);
        }
// @ts-ignore
export function useTagByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagByIdQuery, TagByIdQueryVariables>): Apollo.UseSuspenseQueryResult<TagByIdQuery, TagByIdQueryVariables>;
export function useTagByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagByIdQuery, TagByIdQueryVariables>): Apollo.UseSuspenseQueryResult<TagByIdQuery | undefined, TagByIdQueryVariables>;
export function useTagByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagByIdQuery, TagByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagByIdQuery, TagByIdQueryVariables>(TagByIdDocument, options);
        }
export type TagByIdQueryHookResult = ReturnType<typeof useTagByIdQuery>;
export type TagByIdLazyQueryHookResult = ReturnType<typeof useTagByIdLazyQuery>;
export type TagByIdSuspenseQueryHookResult = ReturnType<typeof useTagByIdSuspenseQuery>;
export type TagByIdQueryResult = Apollo.QueryResult<TagByIdQuery, TagByIdQueryVariables>;
export const TagEntityUsageDocument = gql`
    query TagEntityUsage($id: ID!) {
  tagEntityUsage(id: $id) {
    operators {
      ...TagEntityUsageFragment
    }
    events {
      ...TagEntityUsageFragment
    }
    products {
      ...TagEntityUsageFragment
    }
    lists {
      ...TagEntityUsageFragment
    }
    widgets {
      ...TagEntityUsageFragment
    }
    people {
      ...TagEntityUsageFragment
    }
  }
}
    ${TagEntityUsageFragmentFragmentDoc}`;

/**
 * __useTagEntityUsageQuery__
 *
 * To run a query within a React component, call `useTagEntityUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagEntityUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagEntityUsageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagEntityUsageQuery(baseOptions: Apollo.QueryHookOptions<TagEntityUsageQuery, TagEntityUsageQueryVariables> & ({ variables: TagEntityUsageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagEntityUsageQuery, TagEntityUsageQueryVariables>(TagEntityUsageDocument, options);
      }
export function useTagEntityUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagEntityUsageQuery, TagEntityUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagEntityUsageQuery, TagEntityUsageQueryVariables>(TagEntityUsageDocument, options);
        }
// @ts-ignore
export function useTagEntityUsageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagEntityUsageQuery, TagEntityUsageQueryVariables>): Apollo.UseSuspenseQueryResult<TagEntityUsageQuery, TagEntityUsageQueryVariables>;
export function useTagEntityUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagEntityUsageQuery, TagEntityUsageQueryVariables>): Apollo.UseSuspenseQueryResult<TagEntityUsageQuery | undefined, TagEntityUsageQueryVariables>;
export function useTagEntityUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagEntityUsageQuery, TagEntityUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagEntityUsageQuery, TagEntityUsageQueryVariables>(TagEntityUsageDocument, options);
        }
export type TagEntityUsageQueryHookResult = ReturnType<typeof useTagEntityUsageQuery>;
export type TagEntityUsageLazyQueryHookResult = ReturnType<typeof useTagEntityUsageLazyQuery>;
export type TagEntityUsageSuspenseQueryHookResult = ReturnType<typeof useTagEntityUsageSuspenseQuery>;
export type TagEntityUsageQueryResult = Apollo.QueryResult<TagEntityUsageQuery, TagEntityUsageQueryVariables>;
export const TagGroupOneDocument = gql`
    query TagGroupOne($filter: FilterFindOneTagGroupInput) {
  tagGroupOne(filter: $filter) {
    _id
    key
    name {
      ...MultilingualFragment
    }
    type
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useTagGroupOneQuery__
 *
 * To run a query within a React component, call `useTagGroupOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagGroupOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagGroupOneQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTagGroupOneQuery(baseOptions?: Apollo.QueryHookOptions<TagGroupOneQuery, TagGroupOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagGroupOneQuery, TagGroupOneQueryVariables>(TagGroupOneDocument, options);
      }
export function useTagGroupOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagGroupOneQuery, TagGroupOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagGroupOneQuery, TagGroupOneQueryVariables>(TagGroupOneDocument, options);
        }
// @ts-ignore
export function useTagGroupOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagGroupOneQuery, TagGroupOneQueryVariables>): Apollo.UseSuspenseQueryResult<TagGroupOneQuery, TagGroupOneQueryVariables>;
export function useTagGroupOneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagGroupOneQuery, TagGroupOneQueryVariables>): Apollo.UseSuspenseQueryResult<TagGroupOneQuery | undefined, TagGroupOneQueryVariables>;
export function useTagGroupOneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagGroupOneQuery, TagGroupOneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagGroupOneQuery, TagGroupOneQueryVariables>(TagGroupOneDocument, options);
        }
export type TagGroupOneQueryHookResult = ReturnType<typeof useTagGroupOneQuery>;
export type TagGroupOneLazyQueryHookResult = ReturnType<typeof useTagGroupOneLazyQuery>;
export type TagGroupOneSuspenseQueryHookResult = ReturnType<typeof useTagGroupOneSuspenseQuery>;
export type TagGroupOneQueryResult = Apollo.QueryResult<TagGroupOneQuery, TagGroupOneQueryVariables>;
export const TagGroupByIdsDocument = gql`
    query TagGroupByIds($ids: [MongoID!]!, $limit: Int) {
  tagGroupByIds(_ids: $ids, limit: $limit) {
    _id
    key
    name {
      ...MultilingualFragment
    }
    type
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useTagGroupByIdsQuery__
 *
 * To run a query within a React component, call `useTagGroupByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagGroupByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagGroupByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTagGroupByIdsQuery(baseOptions: Apollo.QueryHookOptions<TagGroupByIdsQuery, TagGroupByIdsQueryVariables> & ({ variables: TagGroupByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagGroupByIdsQuery, TagGroupByIdsQueryVariables>(TagGroupByIdsDocument, options);
      }
export function useTagGroupByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagGroupByIdsQuery, TagGroupByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagGroupByIdsQuery, TagGroupByIdsQueryVariables>(TagGroupByIdsDocument, options);
        }
// @ts-ignore
export function useTagGroupByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagGroupByIdsQuery, TagGroupByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<TagGroupByIdsQuery, TagGroupByIdsQueryVariables>;
export function useTagGroupByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagGroupByIdsQuery, TagGroupByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<TagGroupByIdsQuery | undefined, TagGroupByIdsQueryVariables>;
export function useTagGroupByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagGroupByIdsQuery, TagGroupByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagGroupByIdsQuery, TagGroupByIdsQueryVariables>(TagGroupByIdsDocument, options);
        }
export type TagGroupByIdsQueryHookResult = ReturnType<typeof useTagGroupByIdsQuery>;
export type TagGroupByIdsLazyQueryHookResult = ReturnType<typeof useTagGroupByIdsLazyQuery>;
export type TagGroupByIdsSuspenseQueryHookResult = ReturnType<typeof useTagGroupByIdsSuspenseQuery>;
export type TagGroupByIdsQueryResult = Apollo.QueryResult<TagGroupByIdsQuery, TagGroupByIdsQueryVariables>;
export const TagManyDocument = gql`
    query TagMany($filter: FilterFindManyTagInput, $limit: Int) {
  tagMany(filter: $filter, limit: $limit) {
    ...TagFragment
  }
}
    ${TagFragmentFragmentDoc}`;

/**
 * __useTagManyQuery__
 *
 * To run a query within a React component, call `useTagManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTagManyQuery(baseOptions?: Apollo.QueryHookOptions<TagManyQuery, TagManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagManyQuery, TagManyQueryVariables>(TagManyDocument, options);
      }
export function useTagManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagManyQuery, TagManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagManyQuery, TagManyQueryVariables>(TagManyDocument, options);
        }
// @ts-ignore
export function useTagManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagManyQuery, TagManyQueryVariables>): Apollo.UseSuspenseQueryResult<TagManyQuery, TagManyQueryVariables>;
export function useTagManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagManyQuery, TagManyQueryVariables>): Apollo.UseSuspenseQueryResult<TagManyQuery | undefined, TagManyQueryVariables>;
export function useTagManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagManyQuery, TagManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagManyQuery, TagManyQueryVariables>(TagManyDocument, options);
        }
export type TagManyQueryHookResult = ReturnType<typeof useTagManyQuery>;
export type TagManyLazyQueryHookResult = ReturnType<typeof useTagManyLazyQuery>;
export type TagManySuspenseQueryHookResult = ReturnType<typeof useTagManySuspenseQuery>;
export type TagManyQueryResult = Apollo.QueryResult<TagManyQuery, TagManyQueryVariables>;
export const TagManyLockedIdsDocument = gql`
    query TagManyLockedIds($filter: FilterFindManyTagInput, $limit: Int) {
  tagMany(filter: $filter, limit: $limit) {
    _id
  }
}
    `;

/**
 * __useTagManyLockedIdsQuery__
 *
 * To run a query within a React component, call `useTagManyLockedIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagManyLockedIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagManyLockedIdsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTagManyLockedIdsQuery(baseOptions?: Apollo.QueryHookOptions<TagManyLockedIdsQuery, TagManyLockedIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagManyLockedIdsQuery, TagManyLockedIdsQueryVariables>(TagManyLockedIdsDocument, options);
      }
export function useTagManyLockedIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagManyLockedIdsQuery, TagManyLockedIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagManyLockedIdsQuery, TagManyLockedIdsQueryVariables>(TagManyLockedIdsDocument, options);
        }
// @ts-ignore
export function useTagManyLockedIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagManyLockedIdsQuery, TagManyLockedIdsQueryVariables>): Apollo.UseSuspenseQueryResult<TagManyLockedIdsQuery, TagManyLockedIdsQueryVariables>;
export function useTagManyLockedIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagManyLockedIdsQuery, TagManyLockedIdsQueryVariables>): Apollo.UseSuspenseQueryResult<TagManyLockedIdsQuery | undefined, TagManyLockedIdsQueryVariables>;
export function useTagManyLockedIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagManyLockedIdsQuery, TagManyLockedIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagManyLockedIdsQuery, TagManyLockedIdsQueryVariables>(TagManyLockedIdsDocument, options);
        }
export type TagManyLockedIdsQueryHookResult = ReturnType<typeof useTagManyLockedIdsQuery>;
export type TagManyLockedIdsLazyQueryHookResult = ReturnType<typeof useTagManyLockedIdsLazyQuery>;
export type TagManyLockedIdsSuspenseQueryHookResult = ReturnType<typeof useTagManyLockedIdsSuspenseQuery>;
export type TagManyLockedIdsQueryResult = Apollo.QueryResult<TagManyLockedIdsQuery, TagManyLockedIdsQueryVariables>;
export const TagManyWithCountsDocument = gql`
    query TagManyWithCounts($filter: FilterFindManyTagInput, $limit: Int) {
  tagMany(filter: $filter, limit: $limit) {
    ...TagFragmentWithUsage
  }
}
    ${TagFragmentWithUsageFragmentDoc}`;

/**
 * __useTagManyWithCountsQuery__
 *
 * To run a query within a React component, call `useTagManyWithCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagManyWithCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagManyWithCountsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTagManyWithCountsQuery(baseOptions?: Apollo.QueryHookOptions<TagManyWithCountsQuery, TagManyWithCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagManyWithCountsQuery, TagManyWithCountsQueryVariables>(TagManyWithCountsDocument, options);
      }
export function useTagManyWithCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagManyWithCountsQuery, TagManyWithCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagManyWithCountsQuery, TagManyWithCountsQueryVariables>(TagManyWithCountsDocument, options);
        }
// @ts-ignore
export function useTagManyWithCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagManyWithCountsQuery, TagManyWithCountsQueryVariables>): Apollo.UseSuspenseQueryResult<TagManyWithCountsQuery, TagManyWithCountsQueryVariables>;
export function useTagManyWithCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagManyWithCountsQuery, TagManyWithCountsQueryVariables>): Apollo.UseSuspenseQueryResult<TagManyWithCountsQuery | undefined, TagManyWithCountsQueryVariables>;
export function useTagManyWithCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagManyWithCountsQuery, TagManyWithCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagManyWithCountsQuery, TagManyWithCountsQueryVariables>(TagManyWithCountsDocument, options);
        }
export type TagManyWithCountsQueryHookResult = ReturnType<typeof useTagManyWithCountsQuery>;
export type TagManyWithCountsLazyQueryHookResult = ReturnType<typeof useTagManyWithCountsLazyQuery>;
export type TagManyWithCountsSuspenseQueryHookResult = ReturnType<typeof useTagManyWithCountsSuspenseQuery>;
export type TagManyWithCountsQueryResult = Apollo.QueryResult<TagManyWithCountsQuery, TagManyWithCountsQueryVariables>;
export const TagRefreshCountsDocument = gql`
    query TagRefreshCounts {
  tagRefreshCounts
}
    `;

/**
 * __useTagRefreshCountsQuery__
 *
 * To run a query within a React component, call `useTagRefreshCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagRefreshCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagRefreshCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagRefreshCountsQuery(baseOptions?: Apollo.QueryHookOptions<TagRefreshCountsQuery, TagRefreshCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagRefreshCountsQuery, TagRefreshCountsQueryVariables>(TagRefreshCountsDocument, options);
      }
export function useTagRefreshCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagRefreshCountsQuery, TagRefreshCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagRefreshCountsQuery, TagRefreshCountsQueryVariables>(TagRefreshCountsDocument, options);
        }
// @ts-ignore
export function useTagRefreshCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagRefreshCountsQuery, TagRefreshCountsQueryVariables>): Apollo.UseSuspenseQueryResult<TagRefreshCountsQuery, TagRefreshCountsQueryVariables>;
export function useTagRefreshCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagRefreshCountsQuery, TagRefreshCountsQueryVariables>): Apollo.UseSuspenseQueryResult<TagRefreshCountsQuery | undefined, TagRefreshCountsQueryVariables>;
export function useTagRefreshCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagRefreshCountsQuery, TagRefreshCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagRefreshCountsQuery, TagRefreshCountsQueryVariables>(TagRefreshCountsDocument, options);
        }
export type TagRefreshCountsQueryHookResult = ReturnType<typeof useTagRefreshCountsQuery>;
export type TagRefreshCountsLazyQueryHookResult = ReturnType<typeof useTagRefreshCountsLazyQuery>;
export type TagRefreshCountsSuspenseQueryHookResult = ReturnType<typeof useTagRefreshCountsSuspenseQuery>;
export type TagRefreshCountsQueryResult = Apollo.QueryResult<TagRefreshCountsQuery, TagRefreshCountsQueryVariables>;
export const TagSuggestionAnalyzeDocument = gql`
    query TagSuggestionAnalyze($tagName: String!, $tagGroupId: ID!) {
  tagSuggestionAnalyze(tagName: $tagName, tagGroupId: $tagGroupId) {
    action
    summary
    similarTags
    alternativeSuggestions
  }
}
    `;

/**
 * __useTagSuggestionAnalyzeQuery__
 *
 * To run a query within a React component, call `useTagSuggestionAnalyzeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagSuggestionAnalyzeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagSuggestionAnalyzeQuery({
 *   variables: {
 *      tagName: // value for 'tagName'
 *      tagGroupId: // value for 'tagGroupId'
 *   },
 * });
 */
export function useTagSuggestionAnalyzeQuery(baseOptions: Apollo.QueryHookOptions<TagSuggestionAnalyzeQuery, TagSuggestionAnalyzeQueryVariables> & ({ variables: TagSuggestionAnalyzeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagSuggestionAnalyzeQuery, TagSuggestionAnalyzeQueryVariables>(TagSuggestionAnalyzeDocument, options);
      }
export function useTagSuggestionAnalyzeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagSuggestionAnalyzeQuery, TagSuggestionAnalyzeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagSuggestionAnalyzeQuery, TagSuggestionAnalyzeQueryVariables>(TagSuggestionAnalyzeDocument, options);
        }
// @ts-ignore
export function useTagSuggestionAnalyzeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagSuggestionAnalyzeQuery, TagSuggestionAnalyzeQueryVariables>): Apollo.UseSuspenseQueryResult<TagSuggestionAnalyzeQuery, TagSuggestionAnalyzeQueryVariables>;
export function useTagSuggestionAnalyzeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagSuggestionAnalyzeQuery, TagSuggestionAnalyzeQueryVariables>): Apollo.UseSuspenseQueryResult<TagSuggestionAnalyzeQuery | undefined, TagSuggestionAnalyzeQueryVariables>;
export function useTagSuggestionAnalyzeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagSuggestionAnalyzeQuery, TagSuggestionAnalyzeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagSuggestionAnalyzeQuery, TagSuggestionAnalyzeQueryVariables>(TagSuggestionAnalyzeDocument, options);
        }
export type TagSuggestionAnalyzeQueryHookResult = ReturnType<typeof useTagSuggestionAnalyzeQuery>;
export type TagSuggestionAnalyzeLazyQueryHookResult = ReturnType<typeof useTagSuggestionAnalyzeLazyQuery>;
export type TagSuggestionAnalyzeSuspenseQueryHookResult = ReturnType<typeof useTagSuggestionAnalyzeSuspenseQuery>;
export type TagSuggestionAnalyzeQueryResult = Apollo.QueryResult<TagSuggestionAnalyzeQuery, TagSuggestionAnalyzeQueryVariables>;
export const TagSuggestionByIdDocument = gql`
    query TagSuggestionById($id: MongoID!) {
  tagSuggestionById(_id: $id) {
    ...TagSuggestionFragment
  }
}
    ${TagSuggestionFragmentFragmentDoc}`;

/**
 * __useTagSuggestionByIdQuery__
 *
 * To run a query within a React component, call `useTagSuggestionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagSuggestionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagSuggestionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagSuggestionByIdQuery(baseOptions: Apollo.QueryHookOptions<TagSuggestionByIdQuery, TagSuggestionByIdQueryVariables> & ({ variables: TagSuggestionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagSuggestionByIdQuery, TagSuggestionByIdQueryVariables>(TagSuggestionByIdDocument, options);
      }
export function useTagSuggestionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagSuggestionByIdQuery, TagSuggestionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagSuggestionByIdQuery, TagSuggestionByIdQueryVariables>(TagSuggestionByIdDocument, options);
        }
// @ts-ignore
export function useTagSuggestionByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagSuggestionByIdQuery, TagSuggestionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<TagSuggestionByIdQuery, TagSuggestionByIdQueryVariables>;
export function useTagSuggestionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagSuggestionByIdQuery, TagSuggestionByIdQueryVariables>): Apollo.UseSuspenseQueryResult<TagSuggestionByIdQuery | undefined, TagSuggestionByIdQueryVariables>;
export function useTagSuggestionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagSuggestionByIdQuery, TagSuggestionByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagSuggestionByIdQuery, TagSuggestionByIdQueryVariables>(TagSuggestionByIdDocument, options);
        }
export type TagSuggestionByIdQueryHookResult = ReturnType<typeof useTagSuggestionByIdQuery>;
export type TagSuggestionByIdLazyQueryHookResult = ReturnType<typeof useTagSuggestionByIdLazyQuery>;
export type TagSuggestionByIdSuspenseQueryHookResult = ReturnType<typeof useTagSuggestionByIdSuspenseQuery>;
export type TagSuggestionByIdQueryResult = Apollo.QueryResult<TagSuggestionByIdQuery, TagSuggestionByIdQueryVariables>;
export const TagSuggestionManyDocument = gql`
    query TagSuggestionMany($filter: FilterFindManyTagSuggestionInput, $limit: Int) {
  tagSuggestionMany(filter: $filter, limit: $limit) {
    ...TagSuggestionFragment
  }
}
    ${TagSuggestionFragmentFragmentDoc}`;

/**
 * __useTagSuggestionManyQuery__
 *
 * To run a query within a React component, call `useTagSuggestionManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagSuggestionManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagSuggestionManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTagSuggestionManyQuery(baseOptions?: Apollo.QueryHookOptions<TagSuggestionManyQuery, TagSuggestionManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagSuggestionManyQuery, TagSuggestionManyQueryVariables>(TagSuggestionManyDocument, options);
      }
export function useTagSuggestionManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagSuggestionManyQuery, TagSuggestionManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagSuggestionManyQuery, TagSuggestionManyQueryVariables>(TagSuggestionManyDocument, options);
        }
// @ts-ignore
export function useTagSuggestionManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagSuggestionManyQuery, TagSuggestionManyQueryVariables>): Apollo.UseSuspenseQueryResult<TagSuggestionManyQuery, TagSuggestionManyQueryVariables>;
export function useTagSuggestionManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagSuggestionManyQuery, TagSuggestionManyQueryVariables>): Apollo.UseSuspenseQueryResult<TagSuggestionManyQuery | undefined, TagSuggestionManyQueryVariables>;
export function useTagSuggestionManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagSuggestionManyQuery, TagSuggestionManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagSuggestionManyQuery, TagSuggestionManyQueryVariables>(TagSuggestionManyDocument, options);
        }
export type TagSuggestionManyQueryHookResult = ReturnType<typeof useTagSuggestionManyQuery>;
export type TagSuggestionManyLazyQueryHookResult = ReturnType<typeof useTagSuggestionManyLazyQuery>;
export type TagSuggestionManySuspenseQueryHookResult = ReturnType<typeof useTagSuggestionManySuspenseQuery>;
export type TagSuggestionManyQueryResult = Apollo.QueryResult<TagSuggestionManyQuery, TagSuggestionManyQueryVariables>;
export const TagByIdsDocument = gql`
    query TagByIds($ids: [MongoID!]!, $limit: Int) {
  tagByIds(_ids: $ids, limit: $limit) {
    ...TagFragment
  }
}
    ${TagFragmentFragmentDoc}`;

/**
 * __useTagByIdsQuery__
 *
 * To run a query within a React component, call `useTagByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTagByIdsQuery(baseOptions: Apollo.QueryHookOptions<TagByIdsQuery, TagByIdsQueryVariables> & ({ variables: TagByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagByIdsQuery, TagByIdsQueryVariables>(TagByIdsDocument, options);
      }
export function useTagByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagByIdsQuery, TagByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagByIdsQuery, TagByIdsQueryVariables>(TagByIdsDocument, options);
        }
// @ts-ignore
export function useTagByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagByIdsQuery, TagByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<TagByIdsQuery, TagByIdsQueryVariables>;
export function useTagByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagByIdsQuery, TagByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<TagByIdsQuery | undefined, TagByIdsQueryVariables>;
export function useTagByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagByIdsQuery, TagByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagByIdsQuery, TagByIdsQueryVariables>(TagByIdsDocument, options);
        }
export type TagByIdsQueryHookResult = ReturnType<typeof useTagByIdsQuery>;
export type TagByIdsLazyQueryHookResult = ReturnType<typeof useTagByIdsLazyQuery>;
export type TagByIdsSuspenseQueryHookResult = ReturnType<typeof useTagByIdsSuspenseQuery>;
export type TagByIdsQueryResult = Apollo.QueryResult<TagByIdsQuery, TagByIdsQueryVariables>;
export const TaxManyDocument = gql`
    query TaxMany($filter: FilterFindManyTaxInput, $limit: Int) {
  taxMany(filter: $filter, limit: $limit) {
    _id
    country
    percentage
    subdivision
    owner {
      entityId
      type
    }
  }
}
    `;

/**
 * __useTaxManyQuery__
 *
 * To run a query within a React component, call `useTaxManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTaxManyQuery(baseOptions?: Apollo.QueryHookOptions<TaxManyQuery, TaxManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxManyQuery, TaxManyQueryVariables>(TaxManyDocument, options);
      }
export function useTaxManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxManyQuery, TaxManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxManyQuery, TaxManyQueryVariables>(TaxManyDocument, options);
        }
// @ts-ignore
export function useTaxManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaxManyQuery, TaxManyQueryVariables>): Apollo.UseSuspenseQueryResult<TaxManyQuery, TaxManyQueryVariables>;
export function useTaxManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxManyQuery, TaxManyQueryVariables>): Apollo.UseSuspenseQueryResult<TaxManyQuery | undefined, TaxManyQueryVariables>;
export function useTaxManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxManyQuery, TaxManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxManyQuery, TaxManyQueryVariables>(TaxManyDocument, options);
        }
export type TaxManyQueryHookResult = ReturnType<typeof useTaxManyQuery>;
export type TaxManyLazyQueryHookResult = ReturnType<typeof useTaxManyLazyQuery>;
export type TaxManySuspenseQueryHookResult = ReturnType<typeof useTaxManySuspenseQuery>;
export type TaxManyQueryResult = Apollo.QueryResult<TaxManyQuery, TaxManyQueryVariables>;
export const UserFindOneDocument = gql`
    query UserFindOne($filter: FilterFindOneUserInput) {
  userFindOne(filter: $filter) {
    ...UserWithPictureFragment
  }
}
    ${UserWithPictureFragmentFragmentDoc}`;

/**
 * __useUserFindOneQuery__
 *
 * To run a query within a React component, call `useUserFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFindOneQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserFindOneQuery(baseOptions?: Apollo.QueryHookOptions<UserFindOneQuery, UserFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFindOneQuery, UserFindOneQueryVariables>(UserFindOneDocument, options);
      }
export function useUserFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFindOneQuery, UserFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFindOneQuery, UserFindOneQueryVariables>(UserFindOneDocument, options);
        }
// @ts-ignore
export function useUserFindOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserFindOneQuery, UserFindOneQueryVariables>): Apollo.UseSuspenseQueryResult<UserFindOneQuery, UserFindOneQueryVariables>;
export function useUserFindOneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserFindOneQuery, UserFindOneQueryVariables>): Apollo.UseSuspenseQueryResult<UserFindOneQuery | undefined, UserFindOneQueryVariables>;
export function useUserFindOneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserFindOneQuery, UserFindOneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserFindOneQuery, UserFindOneQueryVariables>(UserFindOneDocument, options);
        }
export type UserFindOneQueryHookResult = ReturnType<typeof useUserFindOneQuery>;
export type UserFindOneLazyQueryHookResult = ReturnType<typeof useUserFindOneLazyQuery>;
export type UserFindOneSuspenseQueryHookResult = ReturnType<typeof useUserFindOneSuspenseQuery>;
export type UserFindOneQueryResult = Apollo.QueryResult<UserFindOneQuery, UserFindOneQueryVariables>;
export const UserFindOneByEmailDocument = gql`
    query UserFindOneByEmail($email: String!) {
  userFindOneByEmail(email: $email) {
    _id
    email
    firstName
    lastName
    photo {
      ...ImageFragment
    }
    photoUploadedBy
    passwordResetUrl
    status
    access {
      operators {
        entityId
        status
      }
      organizations {
        entityId
        status
      }
      storefronts {
        entityId
        status
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useUserFindOneByEmailQuery__
 *
 * To run a query within a React component, call `useUserFindOneByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFindOneByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFindOneByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserFindOneByEmailQuery(baseOptions: Apollo.QueryHookOptions<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables> & ({ variables: UserFindOneByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables>(UserFindOneByEmailDocument, options);
      }
export function useUserFindOneByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables>(UserFindOneByEmailDocument, options);
        }
// @ts-ignore
export function useUserFindOneByEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables>;
export function useUserFindOneByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<UserFindOneByEmailQuery | undefined, UserFindOneByEmailQueryVariables>;
export function useUserFindOneByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables>(UserFindOneByEmailDocument, options);
        }
export type UserFindOneByEmailQueryHookResult = ReturnType<typeof useUserFindOneByEmailQuery>;
export type UserFindOneByEmailLazyQueryHookResult = ReturnType<typeof useUserFindOneByEmailLazyQuery>;
export type UserFindOneByEmailSuspenseQueryHookResult = ReturnType<typeof useUserFindOneByEmailSuspenseQuery>;
export type UserFindOneByEmailQueryResult = Apollo.QueryResult<UserFindOneByEmailQuery, UserFindOneByEmailQueryVariables>;
export const UserFindSelfDocument = gql`
    query UserFindSelf($filter: FilterFindOneUserInput) {
  userFindOne(filter: $filter) {
    ...UserWithPictureFragment
    systemPermissions
    resolvedBroadcasts
  }
}
    ${UserWithPictureFragmentFragmentDoc}`;

/**
 * __useUserFindSelfQuery__
 *
 * To run a query within a React component, call `useUserFindSelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFindSelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFindSelfQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserFindSelfQuery(baseOptions?: Apollo.QueryHookOptions<UserFindSelfQuery, UserFindSelfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFindSelfQuery, UserFindSelfQueryVariables>(UserFindSelfDocument, options);
      }
export function useUserFindSelfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFindSelfQuery, UserFindSelfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFindSelfQuery, UserFindSelfQueryVariables>(UserFindSelfDocument, options);
        }
// @ts-ignore
export function useUserFindSelfSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserFindSelfQuery, UserFindSelfQueryVariables>): Apollo.UseSuspenseQueryResult<UserFindSelfQuery, UserFindSelfQueryVariables>;
export function useUserFindSelfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserFindSelfQuery, UserFindSelfQueryVariables>): Apollo.UseSuspenseQueryResult<UserFindSelfQuery | undefined, UserFindSelfQueryVariables>;
export function useUserFindSelfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserFindSelfQuery, UserFindSelfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserFindSelfQuery, UserFindSelfQueryVariables>(UserFindSelfDocument, options);
        }
export type UserFindSelfQueryHookResult = ReturnType<typeof useUserFindSelfQuery>;
export type UserFindSelfLazyQueryHookResult = ReturnType<typeof useUserFindSelfLazyQuery>;
export type UserFindSelfSuspenseQueryHookResult = ReturnType<typeof useUserFindSelfSuspenseQuery>;
export type UserFindSelfQueryResult = Apollo.QueryResult<UserFindSelfQuery, UserFindSelfQueryVariables>;
export const UserManyDocument = gql`
    query UserMany($filter: FilterFindManyUserInput) {
  userMany(filter: $filter) {
    _id
    email
    firstName
    lastName
    userType
    access {
      organizations {
        entityId
        role
        status
      }
      storefronts {
        entityId
        role
        status
      }
    }
    emailPreferences {
      templateName
      frequency
      entity {
        type
        _entityId
      }
    }
  }
}
    `;

/**
 * __useUserManyQuery__
 *
 * To run a query within a React component, call `useUserManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUserManyQuery(baseOptions?: Apollo.QueryHookOptions<UserManyQuery, UserManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserManyQuery, UserManyQueryVariables>(UserManyDocument, options);
      }
export function useUserManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserManyQuery, UserManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserManyQuery, UserManyQueryVariables>(UserManyDocument, options);
        }
// @ts-ignore
export function useUserManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserManyQuery, UserManyQueryVariables>): Apollo.UseSuspenseQueryResult<UserManyQuery, UserManyQueryVariables>;
export function useUserManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserManyQuery, UserManyQueryVariables>): Apollo.UseSuspenseQueryResult<UserManyQuery | undefined, UserManyQueryVariables>;
export function useUserManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserManyQuery, UserManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserManyQuery, UserManyQueryVariables>(UserManyDocument, options);
        }
export type UserManyQueryHookResult = ReturnType<typeof useUserManyQuery>;
export type UserManyLazyQueryHookResult = ReturnType<typeof useUserManyLazyQuery>;
export type UserManySuspenseQueryHookResult = ReturnType<typeof useUserManySuspenseQuery>;
export type UserManyQueryResult = Apollo.QueryResult<UserManyQuery, UserManyQueryVariables>;
export const UserManyForMentionsDocument = gql`
    query UserManyForMentions {
  userManyForMentions {
    _id
    firstName
    lastName
  }
}
    `;

/**
 * __useUserManyForMentionsQuery__
 *
 * To run a query within a React component, call `useUserManyForMentionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserManyForMentionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserManyForMentionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserManyForMentionsQuery(baseOptions?: Apollo.QueryHookOptions<UserManyForMentionsQuery, UserManyForMentionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserManyForMentionsQuery, UserManyForMentionsQueryVariables>(UserManyForMentionsDocument, options);
      }
export function useUserManyForMentionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserManyForMentionsQuery, UserManyForMentionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserManyForMentionsQuery, UserManyForMentionsQueryVariables>(UserManyForMentionsDocument, options);
        }
// @ts-ignore
export function useUserManyForMentionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserManyForMentionsQuery, UserManyForMentionsQueryVariables>): Apollo.UseSuspenseQueryResult<UserManyForMentionsQuery, UserManyForMentionsQueryVariables>;
export function useUserManyForMentionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserManyForMentionsQuery, UserManyForMentionsQueryVariables>): Apollo.UseSuspenseQueryResult<UserManyForMentionsQuery | undefined, UserManyForMentionsQueryVariables>;
export function useUserManyForMentionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserManyForMentionsQuery, UserManyForMentionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserManyForMentionsQuery, UserManyForMentionsQueryVariables>(UserManyForMentionsDocument, options);
        }
export type UserManyForMentionsQueryHookResult = ReturnType<typeof useUserManyForMentionsQuery>;
export type UserManyForMentionsLazyQueryHookResult = ReturnType<typeof useUserManyForMentionsLazyQuery>;
export type UserManyForMentionsSuspenseQueryHookResult = ReturnType<typeof useUserManyForMentionsSuspenseQuery>;
export type UserManyForMentionsQueryResult = Apollo.QueryResult<UserManyForMentionsQuery, UserManyForMentionsQueryVariables>;
export const UserRequestEmailVerificationDocument = gql`
    query UserRequestEmailVerification {
  userRequestEmailVerification
}
    `;

/**
 * __useUserRequestEmailVerificationQuery__
 *
 * To run a query within a React component, call `useUserRequestEmailVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRequestEmailVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRequestEmailVerificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserRequestEmailVerificationQuery(baseOptions?: Apollo.QueryHookOptions<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>(UserRequestEmailVerificationDocument, options);
      }
export function useUserRequestEmailVerificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>(UserRequestEmailVerificationDocument, options);
        }
// @ts-ignore
export function useUserRequestEmailVerificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>): Apollo.UseSuspenseQueryResult<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>;
export function useUserRequestEmailVerificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>): Apollo.UseSuspenseQueryResult<UserRequestEmailVerificationQuery | undefined, UserRequestEmailVerificationQueryVariables>;
export function useUserRequestEmailVerificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>(UserRequestEmailVerificationDocument, options);
        }
export type UserRequestEmailVerificationQueryHookResult = ReturnType<typeof useUserRequestEmailVerificationQuery>;
export type UserRequestEmailVerificationLazyQueryHookResult = ReturnType<typeof useUserRequestEmailVerificationLazyQuery>;
export type UserRequestEmailVerificationSuspenseQueryHookResult = ReturnType<typeof useUserRequestEmailVerificationSuspenseQuery>;
export type UserRequestEmailVerificationQueryResult = Apollo.QueryResult<UserRequestEmailVerificationQuery, UserRequestEmailVerificationQueryVariables>;
export const WhereabotAvatarDocument = gql`
    query WhereabotAvatar {
  whereabotAvatar {
    ...ImageFragment
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useWhereabotAvatarQuery__
 *
 * To run a query within a React component, call `useWhereabotAvatarQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhereabotAvatarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhereabotAvatarQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhereabotAvatarQuery(baseOptions?: Apollo.QueryHookOptions<WhereabotAvatarQuery, WhereabotAvatarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhereabotAvatarQuery, WhereabotAvatarQueryVariables>(WhereabotAvatarDocument, options);
      }
export function useWhereabotAvatarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhereabotAvatarQuery, WhereabotAvatarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhereabotAvatarQuery, WhereabotAvatarQueryVariables>(WhereabotAvatarDocument, options);
        }
// @ts-ignore
export function useWhereabotAvatarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WhereabotAvatarQuery, WhereabotAvatarQueryVariables>): Apollo.UseSuspenseQueryResult<WhereabotAvatarQuery, WhereabotAvatarQueryVariables>;
export function useWhereabotAvatarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhereabotAvatarQuery, WhereabotAvatarQueryVariables>): Apollo.UseSuspenseQueryResult<WhereabotAvatarQuery | undefined, WhereabotAvatarQueryVariables>;
export function useWhereabotAvatarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhereabotAvatarQuery, WhereabotAvatarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhereabotAvatarQuery, WhereabotAvatarQueryVariables>(WhereabotAvatarDocument, options);
        }
export type WhereabotAvatarQueryHookResult = ReturnType<typeof useWhereabotAvatarQuery>;
export type WhereabotAvatarLazyQueryHookResult = ReturnType<typeof useWhereabotAvatarLazyQuery>;
export type WhereabotAvatarSuspenseQueryHookResult = ReturnType<typeof useWhereabotAvatarSuspenseQuery>;
export type WhereabotAvatarQueryResult = Apollo.QueryResult<WhereabotAvatarQuery, WhereabotAvatarQueryVariables>;
export const WhereabotChatByIdDocument = gql`
    query WhereabotChatById($_id: MongoID!) {
  whereabotChatById(_id: $_id) {
    _id
    title
    createdBy {
      _id
      firstName
      lastName
      picture
    }
    chatModel
    rating
    notes
    status
    createdDateISO
    updatedDateISO
  }
}
    `;

/**
 * __useWhereabotChatByIdQuery__
 *
 * To run a query within a React component, call `useWhereabotChatByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhereabotChatByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhereabotChatByIdQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useWhereabotChatByIdQuery(baseOptions: Apollo.QueryHookOptions<WhereabotChatByIdQuery, WhereabotChatByIdQueryVariables> & ({ variables: WhereabotChatByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhereabotChatByIdQuery, WhereabotChatByIdQueryVariables>(WhereabotChatByIdDocument, options);
      }
export function useWhereabotChatByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhereabotChatByIdQuery, WhereabotChatByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhereabotChatByIdQuery, WhereabotChatByIdQueryVariables>(WhereabotChatByIdDocument, options);
        }
// @ts-ignore
export function useWhereabotChatByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WhereabotChatByIdQuery, WhereabotChatByIdQueryVariables>): Apollo.UseSuspenseQueryResult<WhereabotChatByIdQuery, WhereabotChatByIdQueryVariables>;
export function useWhereabotChatByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhereabotChatByIdQuery, WhereabotChatByIdQueryVariables>): Apollo.UseSuspenseQueryResult<WhereabotChatByIdQuery | undefined, WhereabotChatByIdQueryVariables>;
export function useWhereabotChatByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhereabotChatByIdQuery, WhereabotChatByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhereabotChatByIdQuery, WhereabotChatByIdQueryVariables>(WhereabotChatByIdDocument, options);
        }
export type WhereabotChatByIdQueryHookResult = ReturnType<typeof useWhereabotChatByIdQuery>;
export type WhereabotChatByIdLazyQueryHookResult = ReturnType<typeof useWhereabotChatByIdLazyQuery>;
export type WhereabotChatByIdSuspenseQueryHookResult = ReturnType<typeof useWhereabotChatByIdSuspenseQuery>;
export type WhereabotChatByIdQueryResult = Apollo.QueryResult<WhereabotChatByIdQuery, WhereabotChatByIdQueryVariables>;
export const WhereabotChatManyDocument = gql`
    query WhereabotChatMany($status: String) {
  whereabotChatMany(status: $status) {
    _id
    title
    createdBy {
      _id
      firstName
      lastName
      picture
    }
    chatModel
    rating
    notes
    status
    createdDateISO
    updatedDateISO
  }
}
    `;

/**
 * __useWhereabotChatManyQuery__
 *
 * To run a query within a React component, call `useWhereabotChatManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhereabotChatManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhereabotChatManyQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useWhereabotChatManyQuery(baseOptions?: Apollo.QueryHookOptions<WhereabotChatManyQuery, WhereabotChatManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhereabotChatManyQuery, WhereabotChatManyQueryVariables>(WhereabotChatManyDocument, options);
      }
export function useWhereabotChatManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhereabotChatManyQuery, WhereabotChatManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhereabotChatManyQuery, WhereabotChatManyQueryVariables>(WhereabotChatManyDocument, options);
        }
// @ts-ignore
export function useWhereabotChatManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WhereabotChatManyQuery, WhereabotChatManyQueryVariables>): Apollo.UseSuspenseQueryResult<WhereabotChatManyQuery, WhereabotChatManyQueryVariables>;
export function useWhereabotChatManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhereabotChatManyQuery, WhereabotChatManyQueryVariables>): Apollo.UseSuspenseQueryResult<WhereabotChatManyQuery | undefined, WhereabotChatManyQueryVariables>;
export function useWhereabotChatManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhereabotChatManyQuery, WhereabotChatManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhereabotChatManyQuery, WhereabotChatManyQueryVariables>(WhereabotChatManyDocument, options);
        }
export type WhereabotChatManyQueryHookResult = ReturnType<typeof useWhereabotChatManyQuery>;
export type WhereabotChatManyLazyQueryHookResult = ReturnType<typeof useWhereabotChatManyLazyQuery>;
export type WhereabotChatManySuspenseQueryHookResult = ReturnType<typeof useWhereabotChatManySuspenseQuery>;
export type WhereabotChatManyQueryResult = Apollo.QueryResult<WhereabotChatManyQuery, WhereabotChatManyQueryVariables>;
export const WhereabotMessagesByChatDocument = gql`
    query WhereabotMessagesByChat($chatId: MongoID!, $before: MongoID, $limit: Int) {
  whereabotMessagesByChat(chatId: $chatId, before: $before, limit: $limit) {
    _id
    chat
    role
    content
    isError
    operatorResults {
      operatorEntityId
      operatorName
      operatorType
      organizationId
      score
      isRelated
    }
    metadata {
      embeddingTimeMs
      searchTimeMs
      llmTimeMs
      totalTimeMs
      operatorsSearched
    }
    createdDateISO
  }
}
    `;

/**
 * __useWhereabotMessagesByChatQuery__
 *
 * To run a query within a React component, call `useWhereabotMessagesByChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhereabotMessagesByChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhereabotMessagesByChatQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useWhereabotMessagesByChatQuery(baseOptions: Apollo.QueryHookOptions<WhereabotMessagesByChatQuery, WhereabotMessagesByChatQueryVariables> & ({ variables: WhereabotMessagesByChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhereabotMessagesByChatQuery, WhereabotMessagesByChatQueryVariables>(WhereabotMessagesByChatDocument, options);
      }
export function useWhereabotMessagesByChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhereabotMessagesByChatQuery, WhereabotMessagesByChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhereabotMessagesByChatQuery, WhereabotMessagesByChatQueryVariables>(WhereabotMessagesByChatDocument, options);
        }
// @ts-ignore
export function useWhereabotMessagesByChatSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WhereabotMessagesByChatQuery, WhereabotMessagesByChatQueryVariables>): Apollo.UseSuspenseQueryResult<WhereabotMessagesByChatQuery, WhereabotMessagesByChatQueryVariables>;
export function useWhereabotMessagesByChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhereabotMessagesByChatQuery, WhereabotMessagesByChatQueryVariables>): Apollo.UseSuspenseQueryResult<WhereabotMessagesByChatQuery | undefined, WhereabotMessagesByChatQueryVariables>;
export function useWhereabotMessagesByChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhereabotMessagesByChatQuery, WhereabotMessagesByChatQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhereabotMessagesByChatQuery, WhereabotMessagesByChatQueryVariables>(WhereabotMessagesByChatDocument, options);
        }
export type WhereabotMessagesByChatQueryHookResult = ReturnType<typeof useWhereabotMessagesByChatQuery>;
export type WhereabotMessagesByChatLazyQueryHookResult = ReturnType<typeof useWhereabotMessagesByChatLazyQuery>;
export type WhereabotMessagesByChatSuspenseQueryHookResult = ReturnType<typeof useWhereabotMessagesByChatSuspenseQuery>;
export type WhereabotMessagesByChatQueryResult = Apollo.QueryResult<WhereabotMessagesByChatQuery, WhereabotMessagesByChatQueryVariables>;
export const WhereabotSettingsGetDocument = gql`
    query WhereabotSettingsGet {
  whereabotSettingsGet {
    _id
    chatModel
    updatedBy
    updatedDateISO
  }
}
    `;

/**
 * __useWhereabotSettingsGetQuery__
 *
 * To run a query within a React component, call `useWhereabotSettingsGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhereabotSettingsGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhereabotSettingsGetQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhereabotSettingsGetQuery(baseOptions?: Apollo.QueryHookOptions<WhereabotSettingsGetQuery, WhereabotSettingsGetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhereabotSettingsGetQuery, WhereabotSettingsGetQueryVariables>(WhereabotSettingsGetDocument, options);
      }
export function useWhereabotSettingsGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhereabotSettingsGetQuery, WhereabotSettingsGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhereabotSettingsGetQuery, WhereabotSettingsGetQueryVariables>(WhereabotSettingsGetDocument, options);
        }
// @ts-ignore
export function useWhereabotSettingsGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WhereabotSettingsGetQuery, WhereabotSettingsGetQueryVariables>): Apollo.UseSuspenseQueryResult<WhereabotSettingsGetQuery, WhereabotSettingsGetQueryVariables>;
export function useWhereabotSettingsGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhereabotSettingsGetQuery, WhereabotSettingsGetQueryVariables>): Apollo.UseSuspenseQueryResult<WhereabotSettingsGetQuery | undefined, WhereabotSettingsGetQueryVariables>;
export function useWhereabotSettingsGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhereabotSettingsGetQuery, WhereabotSettingsGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhereabotSettingsGetQuery, WhereabotSettingsGetQueryVariables>(WhereabotSettingsGetDocument, options);
        }
export type WhereabotSettingsGetQueryHookResult = ReturnType<typeof useWhereabotSettingsGetQuery>;
export type WhereabotSettingsGetLazyQueryHookResult = ReturnType<typeof useWhereabotSettingsGetLazyQuery>;
export type WhereabotSettingsGetSuspenseQueryHookResult = ReturnType<typeof useWhereabotSettingsGetSuspenseQuery>;
export type WhereabotSettingsGetQueryResult = Apollo.QueryResult<WhereabotSettingsGetQuery, WhereabotSettingsGetQueryVariables>;
export const WidgetActiveCountDocument = gql`
    query WidgetActiveCount($filter: FilterCountWidgetInput) {
  widgetCount(filter: $filter)
}
    `;

/**
 * __useWidgetActiveCountQuery__
 *
 * To run a query within a React component, call `useWidgetActiveCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetActiveCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetActiveCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useWidgetActiveCountQuery(baseOptions?: Apollo.QueryHookOptions<WidgetActiveCountQuery, WidgetActiveCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetActiveCountQuery, WidgetActiveCountQueryVariables>(WidgetActiveCountDocument, options);
      }
export function useWidgetActiveCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetActiveCountQuery, WidgetActiveCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetActiveCountQuery, WidgetActiveCountQueryVariables>(WidgetActiveCountDocument, options);
        }
// @ts-ignore
export function useWidgetActiveCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetActiveCountQuery, WidgetActiveCountQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetActiveCountQuery, WidgetActiveCountQueryVariables>;
export function useWidgetActiveCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetActiveCountQuery, WidgetActiveCountQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetActiveCountQuery | undefined, WidgetActiveCountQueryVariables>;
export function useWidgetActiveCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetActiveCountQuery, WidgetActiveCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetActiveCountQuery, WidgetActiveCountQueryVariables>(WidgetActiveCountDocument, options);
        }
export type WidgetActiveCountQueryHookResult = ReturnType<typeof useWidgetActiveCountQuery>;
export type WidgetActiveCountLazyQueryHookResult = ReturnType<typeof useWidgetActiveCountLazyQuery>;
export type WidgetActiveCountSuspenseQueryHookResult = ReturnType<typeof useWidgetActiveCountSuspenseQuery>;
export type WidgetActiveCountQueryResult = Apollo.QueryResult<WidgetActiveCountQuery, WidgetActiveCountQueryVariables>;
export const WidgetByIdDocument = gql`
    query WidgetById($id: MongoID!) {
  widgetById(_id: $id) {
    _id
    type
    name {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    archived
    favorited
    list {
      _id
      type
      name {
        ...MultilingualFragment
      }
      selections
      archived
      favorited
      entities {
        _entityId
        _versionId
        status
        type
        name {
          ...MultilingualFragment
        }
        images(limit: 1) {
          ...ImageFragment
        }
        overrides {
          description {
            ...MultilingualFragment
          }
          shortDescription {
            ...MultilingualFragment
          }
          images {
            ...ImageFragment
          }
        }
      }
    }
    operatorSettings {
      filterableTags {
        _id
        name {
          ...MultilingualFragment
        }
      }
      filterableTagGroups {
        _id
        name {
          ...MultilingualFragment
        }
      }
      orderedFilters {
        _id
        isTagGroup
        additionalTagIds
        labelOverride {
          en
          es
          fr
        }
      }
      allowAdditionalFilters
      allowMapView
      sortStrategy
      hideTemporarilyClosed
      showPermanentlyClosed
      tieredSortOrder
      disableTieredSort
      disableOperatorWidgetFilter
      listDisplayMode
      showOnlyMap
      hideFiltersInMapView
      showPromotions
      showEvents
    }
    eventSettings {
      displayType
      eventTags
      hiddenPublicFilterTags
      publicFilterMode
      publicFilterSort
      shownPublicFilterTags
      lookAheadMonths
      startMonth
      hideCancelledEvents
    }
    inquirySettings {
      survey
      buttonLabel {
        en
        es
        fr
      }
      description {
        en
        es
        fr
      }
      thankYouMessage {
        en
        es
        fr
      }
      completionTags
      submissionTags
      preventMultipleSubmissions
      notificationRecipients
    }
    gallerySettings {
      items
      enableUrlPush
      playerPagePath
      profilePageEnabled
      allMedia
      infiniteScroll {
        enabled
        mediaTagFilters
        listingFilters
      }
    }
    promotionSettings {
      displayType
      promotionTags
      hiddenPublicFilterTags
      hidePublicFilters
    }
    owner {
      entityId
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useWidgetByIdQuery__
 *
 * To run a query within a React component, call `useWidgetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetByIdQuery(baseOptions: Apollo.QueryHookOptions<WidgetByIdQuery, WidgetByIdQueryVariables> & ({ variables: WidgetByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetByIdQuery, WidgetByIdQueryVariables>(WidgetByIdDocument, options);
      }
export function useWidgetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetByIdQuery, WidgetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetByIdQuery, WidgetByIdQueryVariables>(WidgetByIdDocument, options);
        }
// @ts-ignore
export function useWidgetByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetByIdQuery, WidgetByIdQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetByIdQuery, WidgetByIdQueryVariables>;
export function useWidgetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetByIdQuery, WidgetByIdQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetByIdQuery | undefined, WidgetByIdQueryVariables>;
export function useWidgetByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetByIdQuery, WidgetByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetByIdQuery, WidgetByIdQueryVariables>(WidgetByIdDocument, options);
        }
export type WidgetByIdQueryHookResult = ReturnType<typeof useWidgetByIdQuery>;
export type WidgetByIdLazyQueryHookResult = ReturnType<typeof useWidgetByIdLazyQuery>;
export type WidgetByIdSuspenseQueryHookResult = ReturnType<typeof useWidgetByIdSuspenseQuery>;
export type WidgetByIdQueryResult = Apollo.QueryResult<WidgetByIdQuery, WidgetByIdQueryVariables>;
export const WidgetByIdEventsWidgetDocument = gql`
    query WidgetByIdEventsWidget($id: MongoID!) {
  widgetById(_id: $id) {
    _id
    eventSettings {
      displayType
      eventTags
      hiddenPublicFilterTags
      publicFilterMode
      publicFilterSort
      shownPublicFilterTags
      lookAheadMonths
      startMonth
      hideCancelledEvents
    }
    owner {
      entityId
    }
  }
}
    `;

/**
 * __useWidgetByIdEventsWidgetQuery__
 *
 * To run a query within a React component, call `useWidgetByIdEventsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetByIdEventsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetByIdEventsWidgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetByIdEventsWidgetQuery(baseOptions: Apollo.QueryHookOptions<WidgetByIdEventsWidgetQuery, WidgetByIdEventsWidgetQueryVariables> & ({ variables: WidgetByIdEventsWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetByIdEventsWidgetQuery, WidgetByIdEventsWidgetQueryVariables>(WidgetByIdEventsWidgetDocument, options);
      }
export function useWidgetByIdEventsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetByIdEventsWidgetQuery, WidgetByIdEventsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetByIdEventsWidgetQuery, WidgetByIdEventsWidgetQueryVariables>(WidgetByIdEventsWidgetDocument, options);
        }
// @ts-ignore
export function useWidgetByIdEventsWidgetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetByIdEventsWidgetQuery, WidgetByIdEventsWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetByIdEventsWidgetQuery, WidgetByIdEventsWidgetQueryVariables>;
export function useWidgetByIdEventsWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetByIdEventsWidgetQuery, WidgetByIdEventsWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetByIdEventsWidgetQuery | undefined, WidgetByIdEventsWidgetQueryVariables>;
export function useWidgetByIdEventsWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetByIdEventsWidgetQuery, WidgetByIdEventsWidgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetByIdEventsWidgetQuery, WidgetByIdEventsWidgetQueryVariables>(WidgetByIdEventsWidgetDocument, options);
        }
export type WidgetByIdEventsWidgetQueryHookResult = ReturnType<typeof useWidgetByIdEventsWidgetQuery>;
export type WidgetByIdEventsWidgetLazyQueryHookResult = ReturnType<typeof useWidgetByIdEventsWidgetLazyQuery>;
export type WidgetByIdEventsWidgetSuspenseQueryHookResult = ReturnType<typeof useWidgetByIdEventsWidgetSuspenseQuery>;
export type WidgetByIdEventsWidgetQueryResult = Apollo.QueryResult<WidgetByIdEventsWidgetQuery, WidgetByIdEventsWidgetQueryVariables>;
export const WidgetByIdPromotionsWidgetDocument = gql`
    query WidgetByIdPromotionsWidget($id: MongoID!) {
  widgetById(_id: $id) {
    _id
    type
    name {
      ...MultilingualFragment
    }
    promotionSettings {
      displayType
      promotionTags
      hiddenPublicFilterTags
      hidePublicFilters
    }
    owner {
      entityId
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useWidgetByIdPromotionsWidgetQuery__
 *
 * To run a query within a React component, call `useWidgetByIdPromotionsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetByIdPromotionsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetByIdPromotionsWidgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetByIdPromotionsWidgetQuery(baseOptions: Apollo.QueryHookOptions<WidgetByIdPromotionsWidgetQuery, WidgetByIdPromotionsWidgetQueryVariables> & ({ variables: WidgetByIdPromotionsWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetByIdPromotionsWidgetQuery, WidgetByIdPromotionsWidgetQueryVariables>(WidgetByIdPromotionsWidgetDocument, options);
      }
export function useWidgetByIdPromotionsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetByIdPromotionsWidgetQuery, WidgetByIdPromotionsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetByIdPromotionsWidgetQuery, WidgetByIdPromotionsWidgetQueryVariables>(WidgetByIdPromotionsWidgetDocument, options);
        }
// @ts-ignore
export function useWidgetByIdPromotionsWidgetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetByIdPromotionsWidgetQuery, WidgetByIdPromotionsWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetByIdPromotionsWidgetQuery, WidgetByIdPromotionsWidgetQueryVariables>;
export function useWidgetByIdPromotionsWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetByIdPromotionsWidgetQuery, WidgetByIdPromotionsWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetByIdPromotionsWidgetQuery | undefined, WidgetByIdPromotionsWidgetQueryVariables>;
export function useWidgetByIdPromotionsWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetByIdPromotionsWidgetQuery, WidgetByIdPromotionsWidgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetByIdPromotionsWidgetQuery, WidgetByIdPromotionsWidgetQueryVariables>(WidgetByIdPromotionsWidgetDocument, options);
        }
export type WidgetByIdPromotionsWidgetQueryHookResult = ReturnType<typeof useWidgetByIdPromotionsWidgetQuery>;
export type WidgetByIdPromotionsWidgetLazyQueryHookResult = ReturnType<typeof useWidgetByIdPromotionsWidgetLazyQuery>;
export type WidgetByIdPromotionsWidgetSuspenseQueryHookResult = ReturnType<typeof useWidgetByIdPromotionsWidgetSuspenseQuery>;
export type WidgetByIdPromotionsWidgetQueryResult = Apollo.QueryResult<WidgetByIdPromotionsWidgetQuery, WidgetByIdPromotionsWidgetQueryVariables>;
export const WidgetByIdWithEntitiesDocument = gql`
    query WidgetByIdWithEntities($id: MongoID!) {
  widgetById(_id: $id) {
    _id
    type
    name {
      ...MultilingualFragment
    }
    list {
      entities {
        _entityId
        _versionId
        name {
          ...MultilingualFragment
        }
        overrides {
          description {
            ...MultilingualFragment
          }
          shortDescription {
            ...MultilingualFragment
          }
          images {
            ...ImageFragment
          }
        }
      }
    }
    operatorSettings {
      filterableTags {
        _id
        name {
          ...MultilingualFragment
        }
      }
      filterableTagGroups {
        _id
        name {
          ...MultilingualFragment
        }
      }
      orderedFilters {
        _id
        isTagGroup
        additionalTagIds
        labelOverride {
          en
          es
          fr
        }
      }
      allowAdditionalFilters
      allowMapView
      sortStrategy
      hideTemporarilyClosed
      showPermanentlyClosed
      tieredSortOrder
      listDisplayMode
      showOnlyMap
      hideFiltersInMapView
      showPromotions
      showEvents
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useWidgetByIdWithEntitiesQuery__
 *
 * To run a query within a React component, call `useWidgetByIdWithEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetByIdWithEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetByIdWithEntitiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetByIdWithEntitiesQuery(baseOptions: Apollo.QueryHookOptions<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables> & ({ variables: WidgetByIdWithEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables>(WidgetByIdWithEntitiesDocument, options);
      }
export function useWidgetByIdWithEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables>(WidgetByIdWithEntitiesDocument, options);
        }
// @ts-ignore
export function useWidgetByIdWithEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables>;
export function useWidgetByIdWithEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetByIdWithEntitiesQuery | undefined, WidgetByIdWithEntitiesQueryVariables>;
export function useWidgetByIdWithEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables>(WidgetByIdWithEntitiesDocument, options);
        }
export type WidgetByIdWithEntitiesQueryHookResult = ReturnType<typeof useWidgetByIdWithEntitiesQuery>;
export type WidgetByIdWithEntitiesLazyQueryHookResult = ReturnType<typeof useWidgetByIdWithEntitiesLazyQuery>;
export type WidgetByIdWithEntitiesSuspenseQueryHookResult = ReturnType<typeof useWidgetByIdWithEntitiesSuspenseQuery>;
export type WidgetByIdWithEntitiesQueryResult = Apollo.QueryResult<WidgetByIdWithEntitiesQuery, WidgetByIdWithEntitiesQueryVariables>;
export const WidgetEmbedActivityAllDocument = gql`
    query WidgetEmbedActivityAll($limit: Int) {
  widgetEmbedActivityAll(limit: $limit) {
    _id
    url
    hostname
    lastViewedAt
    firstViewedAt
    viewCount
    widget {
      _id
      name
      type
    }
    organization {
      _id
      name
    }
  }
}
    `;

/**
 * __useWidgetEmbedActivityAllQuery__
 *
 * To run a query within a React component, call `useWidgetEmbedActivityAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetEmbedActivityAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetEmbedActivityAllQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useWidgetEmbedActivityAllQuery(baseOptions?: Apollo.QueryHookOptions<WidgetEmbedActivityAllQuery, WidgetEmbedActivityAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetEmbedActivityAllQuery, WidgetEmbedActivityAllQueryVariables>(WidgetEmbedActivityAllDocument, options);
      }
export function useWidgetEmbedActivityAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetEmbedActivityAllQuery, WidgetEmbedActivityAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetEmbedActivityAllQuery, WidgetEmbedActivityAllQueryVariables>(WidgetEmbedActivityAllDocument, options);
        }
// @ts-ignore
export function useWidgetEmbedActivityAllSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetEmbedActivityAllQuery, WidgetEmbedActivityAllQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetEmbedActivityAllQuery, WidgetEmbedActivityAllQueryVariables>;
export function useWidgetEmbedActivityAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetEmbedActivityAllQuery, WidgetEmbedActivityAllQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetEmbedActivityAllQuery | undefined, WidgetEmbedActivityAllQueryVariables>;
export function useWidgetEmbedActivityAllSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetEmbedActivityAllQuery, WidgetEmbedActivityAllQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetEmbedActivityAllQuery, WidgetEmbedActivityAllQueryVariables>(WidgetEmbedActivityAllDocument, options);
        }
export type WidgetEmbedActivityAllQueryHookResult = ReturnType<typeof useWidgetEmbedActivityAllQuery>;
export type WidgetEmbedActivityAllLazyQueryHookResult = ReturnType<typeof useWidgetEmbedActivityAllLazyQuery>;
export type WidgetEmbedActivityAllSuspenseQueryHookResult = ReturnType<typeof useWidgetEmbedActivityAllSuspenseQuery>;
export type WidgetEmbedActivityAllQueryResult = Apollo.QueryResult<WidgetEmbedActivityAllQuery, WidgetEmbedActivityAllQueryVariables>;
export const WidgetEmbedActivityByOrganizationDocument = gql`
    query WidgetEmbedActivityByOrganization($organizationId: ID!) {
  widgetEmbedActivityByOrganization(organizationId: $organizationId) {
    _id
    url
    hostname
    lastViewedAt
    firstViewedAt
    viewCount
    widget {
      _id
      name
      type
    }
  }
}
    `;

/**
 * __useWidgetEmbedActivityByOrganizationQuery__
 *
 * To run a query within a React component, call `useWidgetEmbedActivityByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetEmbedActivityByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetEmbedActivityByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useWidgetEmbedActivityByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<WidgetEmbedActivityByOrganizationQuery, WidgetEmbedActivityByOrganizationQueryVariables> & ({ variables: WidgetEmbedActivityByOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetEmbedActivityByOrganizationQuery, WidgetEmbedActivityByOrganizationQueryVariables>(WidgetEmbedActivityByOrganizationDocument, options);
      }
export function useWidgetEmbedActivityByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetEmbedActivityByOrganizationQuery, WidgetEmbedActivityByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetEmbedActivityByOrganizationQuery, WidgetEmbedActivityByOrganizationQueryVariables>(WidgetEmbedActivityByOrganizationDocument, options);
        }
// @ts-ignore
export function useWidgetEmbedActivityByOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetEmbedActivityByOrganizationQuery, WidgetEmbedActivityByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetEmbedActivityByOrganizationQuery, WidgetEmbedActivityByOrganizationQueryVariables>;
export function useWidgetEmbedActivityByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetEmbedActivityByOrganizationQuery, WidgetEmbedActivityByOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetEmbedActivityByOrganizationQuery | undefined, WidgetEmbedActivityByOrganizationQueryVariables>;
export function useWidgetEmbedActivityByOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetEmbedActivityByOrganizationQuery, WidgetEmbedActivityByOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetEmbedActivityByOrganizationQuery, WidgetEmbedActivityByOrganizationQueryVariables>(WidgetEmbedActivityByOrganizationDocument, options);
        }
export type WidgetEmbedActivityByOrganizationQueryHookResult = ReturnType<typeof useWidgetEmbedActivityByOrganizationQuery>;
export type WidgetEmbedActivityByOrganizationLazyQueryHookResult = ReturnType<typeof useWidgetEmbedActivityByOrganizationLazyQuery>;
export type WidgetEmbedActivityByOrganizationSuspenseQueryHookResult = ReturnType<typeof useWidgetEmbedActivityByOrganizationSuspenseQuery>;
export type WidgetEmbedActivityByOrganizationQueryResult = Apollo.QueryResult<WidgetEmbedActivityByOrganizationQuery, WidgetEmbedActivityByOrganizationQueryVariables>;
export const WidgetEmbedActivityByWidgetIdDocument = gql`
    query WidgetEmbedActivityByWidgetId($widgetId: ID!) {
  widgetEmbedActivityByWidgetId(widgetId: $widgetId) {
    _id
    url
    hostname
    lastViewedAt
    firstViewedAt
    viewCount
  }
}
    `;

/**
 * __useWidgetEmbedActivityByWidgetIdQuery__
 *
 * To run a query within a React component, call `useWidgetEmbedActivityByWidgetIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetEmbedActivityByWidgetIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetEmbedActivityByWidgetIdQuery({
 *   variables: {
 *      widgetId: // value for 'widgetId'
 *   },
 * });
 */
export function useWidgetEmbedActivityByWidgetIdQuery(baseOptions: Apollo.QueryHookOptions<WidgetEmbedActivityByWidgetIdQuery, WidgetEmbedActivityByWidgetIdQueryVariables> & ({ variables: WidgetEmbedActivityByWidgetIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetEmbedActivityByWidgetIdQuery, WidgetEmbedActivityByWidgetIdQueryVariables>(WidgetEmbedActivityByWidgetIdDocument, options);
      }
export function useWidgetEmbedActivityByWidgetIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetEmbedActivityByWidgetIdQuery, WidgetEmbedActivityByWidgetIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetEmbedActivityByWidgetIdQuery, WidgetEmbedActivityByWidgetIdQueryVariables>(WidgetEmbedActivityByWidgetIdDocument, options);
        }
// @ts-ignore
export function useWidgetEmbedActivityByWidgetIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetEmbedActivityByWidgetIdQuery, WidgetEmbedActivityByWidgetIdQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetEmbedActivityByWidgetIdQuery, WidgetEmbedActivityByWidgetIdQueryVariables>;
export function useWidgetEmbedActivityByWidgetIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetEmbedActivityByWidgetIdQuery, WidgetEmbedActivityByWidgetIdQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetEmbedActivityByWidgetIdQuery | undefined, WidgetEmbedActivityByWidgetIdQueryVariables>;
export function useWidgetEmbedActivityByWidgetIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetEmbedActivityByWidgetIdQuery, WidgetEmbedActivityByWidgetIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetEmbedActivityByWidgetIdQuery, WidgetEmbedActivityByWidgetIdQueryVariables>(WidgetEmbedActivityByWidgetIdDocument, options);
        }
export type WidgetEmbedActivityByWidgetIdQueryHookResult = ReturnType<typeof useWidgetEmbedActivityByWidgetIdQuery>;
export type WidgetEmbedActivityByWidgetIdLazyQueryHookResult = ReturnType<typeof useWidgetEmbedActivityByWidgetIdLazyQuery>;
export type WidgetEmbedActivityByWidgetIdSuspenseQueryHookResult = ReturnType<typeof useWidgetEmbedActivityByWidgetIdSuspenseQuery>;
export type WidgetEmbedActivityByWidgetIdQueryResult = Apollo.QueryResult<WidgetEmbedActivityByWidgetIdQuery, WidgetEmbedActivityByWidgetIdQueryVariables>;
export const WidgetManyDocument = gql`
    query WidgetMany($filter: FilterFindManyWidgetInput, $limit: Int, $sort: SortFindManyWidgetInput) {
  widgetMany(filter: $filter, limit: $limit, sort: $sort) {
    _id
    type
    itemCount
    name {
      ...MultilingualFragment
    }
    owner {
      entityId
      type
    }
    archived
    favorited
    updatedDateISO
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useWidgetManyQuery__
 *
 * To run a query within a React component, call `useWidgetManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useWidgetManyQuery(baseOptions?: Apollo.QueryHookOptions<WidgetManyQuery, WidgetManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetManyQuery, WidgetManyQueryVariables>(WidgetManyDocument, options);
      }
export function useWidgetManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetManyQuery, WidgetManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetManyQuery, WidgetManyQueryVariables>(WidgetManyDocument, options);
        }
// @ts-ignore
export function useWidgetManySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetManyQuery, WidgetManyQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetManyQuery, WidgetManyQueryVariables>;
export function useWidgetManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetManyQuery, WidgetManyQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetManyQuery | undefined, WidgetManyQueryVariables>;
export function useWidgetManySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetManyQuery, WidgetManyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetManyQuery, WidgetManyQueryVariables>(WidgetManyDocument, options);
        }
export type WidgetManyQueryHookResult = ReturnType<typeof useWidgetManyQuery>;
export type WidgetManyLazyQueryHookResult = ReturnType<typeof useWidgetManyLazyQuery>;
export type WidgetManySuspenseQueryHookResult = ReturnType<typeof useWidgetManySuspenseQuery>;
export type WidgetManyQueryResult = Apollo.QueryResult<WidgetManyQuery, WidgetManyQueryVariables>;
export const WidgetManyAdminlandDocument = gql`
    query WidgetManyAdminland($filter: FilterFindManyWidgetInput, $limit: Int, $sort: SortFindManyWidgetInput) {
  widgetManySimple(filter: $filter, limit: $limit, sort: $sort) {
    _id
    type
    archived
    favorited
    updatedDateISO
    name {
      ...MultilingualFragment
    }
    owner {
      entityId
      type
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useWidgetManyAdminlandQuery__
 *
 * To run a query within a React component, call `useWidgetManyAdminlandQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetManyAdminlandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetManyAdminlandQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useWidgetManyAdminlandQuery(baseOptions?: Apollo.QueryHookOptions<WidgetManyAdminlandQuery, WidgetManyAdminlandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetManyAdminlandQuery, WidgetManyAdminlandQueryVariables>(WidgetManyAdminlandDocument, options);
      }
export function useWidgetManyAdminlandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetManyAdminlandQuery, WidgetManyAdminlandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetManyAdminlandQuery, WidgetManyAdminlandQueryVariables>(WidgetManyAdminlandDocument, options);
        }
// @ts-ignore
export function useWidgetManyAdminlandSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetManyAdminlandQuery, WidgetManyAdminlandQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetManyAdminlandQuery, WidgetManyAdminlandQueryVariables>;
export function useWidgetManyAdminlandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetManyAdminlandQuery, WidgetManyAdminlandQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetManyAdminlandQuery | undefined, WidgetManyAdminlandQueryVariables>;
export function useWidgetManyAdminlandSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetManyAdminlandQuery, WidgetManyAdminlandQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetManyAdminlandQuery, WidgetManyAdminlandQueryVariables>(WidgetManyAdminlandDocument, options);
        }
export type WidgetManyAdminlandQueryHookResult = ReturnType<typeof useWidgetManyAdminlandQuery>;
export type WidgetManyAdminlandLazyQueryHookResult = ReturnType<typeof useWidgetManyAdminlandLazyQuery>;
export type WidgetManyAdminlandSuspenseQueryHookResult = ReturnType<typeof useWidgetManyAdminlandSuspenseQuery>;
export type WidgetManyAdminlandQueryResult = Apollo.QueryResult<WidgetManyAdminlandQuery, WidgetManyAdminlandQueryVariables>;
export const WidgetManyFastDocument = gql`
    query WidgetManyFast($filter: FilterFindManyWidgetInput, $limit: Int, $sort: SortFindManyWidgetInput) {
  widgetManySimple(filter: $filter, limit: $limit, sort: $sort) {
    _id
    type
    name {
      ...MultilingualFragment
    }
    owner {
      entityId
      type
    }
    archived
    favorited
    updatedDateISO
    gallerySettings {
      allMedia
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useWidgetManyFastQuery__
 *
 * To run a query within a React component, call `useWidgetManyFastQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetManyFastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetManyFastQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useWidgetManyFastQuery(baseOptions?: Apollo.QueryHookOptions<WidgetManyFastQuery, WidgetManyFastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetManyFastQuery, WidgetManyFastQueryVariables>(WidgetManyFastDocument, options);
      }
export function useWidgetManyFastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetManyFastQuery, WidgetManyFastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetManyFastQuery, WidgetManyFastQueryVariables>(WidgetManyFastDocument, options);
        }
// @ts-ignore
export function useWidgetManyFastSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetManyFastQuery, WidgetManyFastQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetManyFastQuery, WidgetManyFastQueryVariables>;
export function useWidgetManyFastSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetManyFastQuery, WidgetManyFastQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetManyFastQuery | undefined, WidgetManyFastQueryVariables>;
export function useWidgetManyFastSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetManyFastQuery, WidgetManyFastQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetManyFastQuery, WidgetManyFastQueryVariables>(WidgetManyFastDocument, options);
        }
export type WidgetManyFastQueryHookResult = ReturnType<typeof useWidgetManyFastQuery>;
export type WidgetManyFastLazyQueryHookResult = ReturnType<typeof useWidgetManyFastLazyQuery>;
export type WidgetManyFastSuspenseQueryHookResult = ReturnType<typeof useWidgetManyFastSuspenseQuery>;
export type WidgetManyFastQueryResult = Apollo.QueryResult<WidgetManyFastQuery, WidgetManyFastQueryVariables>;
export const WidgetManyListIdsDocument = gql`
    query WidgetManyListIds($filter: FilterFindManyWidgetInput, $limit: Int, $sort: SortFindManyWidgetInput) {
  widgetManySimple(filter: $filter, limit: $limit, sort: $sort) {
    _id
    archived
    listId
  }
}
    `;

/**
 * __useWidgetManyListIdsQuery__
 *
 * To run a query within a React component, call `useWidgetManyListIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetManyListIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetManyListIdsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useWidgetManyListIdsQuery(baseOptions?: Apollo.QueryHookOptions<WidgetManyListIdsQuery, WidgetManyListIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetManyListIdsQuery, WidgetManyListIdsQueryVariables>(WidgetManyListIdsDocument, options);
      }
export function useWidgetManyListIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetManyListIdsQuery, WidgetManyListIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetManyListIdsQuery, WidgetManyListIdsQueryVariables>(WidgetManyListIdsDocument, options);
        }
// @ts-ignore
export function useWidgetManyListIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetManyListIdsQuery, WidgetManyListIdsQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetManyListIdsQuery, WidgetManyListIdsQueryVariables>;
export function useWidgetManyListIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetManyListIdsQuery, WidgetManyListIdsQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetManyListIdsQuery | undefined, WidgetManyListIdsQueryVariables>;
export function useWidgetManyListIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetManyListIdsQuery, WidgetManyListIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetManyListIdsQuery, WidgetManyListIdsQueryVariables>(WidgetManyListIdsDocument, options);
        }
export type WidgetManyListIdsQueryHookResult = ReturnType<typeof useWidgetManyListIdsQuery>;
export type WidgetManyListIdsLazyQueryHookResult = ReturnType<typeof useWidgetManyListIdsLazyQuery>;
export type WidgetManyListIdsSuspenseQueryHookResult = ReturnType<typeof useWidgetManyListIdsSuspenseQuery>;
export type WidgetManyListIdsQueryResult = Apollo.QueryResult<WidgetManyListIdsQuery, WidgetManyListIdsQueryVariables>;
export const WidgetManyNamesDocument = gql`
    query WidgetManyNames($filter: FilterFindManyWidgetInput, $limit: Int, $sort: SortFindManyWidgetInput) {
  widgetManySimple(filter: $filter, limit: $limit, sort: $sort) {
    _id
    name {
      ...MultilingualFragment
    }
  }
}
    ${MultilingualFragmentFragmentDoc}`;

/**
 * __useWidgetManyNamesQuery__
 *
 * To run a query within a React component, call `useWidgetManyNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetManyNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetManyNamesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useWidgetManyNamesQuery(baseOptions?: Apollo.QueryHookOptions<WidgetManyNamesQuery, WidgetManyNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetManyNamesQuery, WidgetManyNamesQueryVariables>(WidgetManyNamesDocument, options);
      }
export function useWidgetManyNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetManyNamesQuery, WidgetManyNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetManyNamesQuery, WidgetManyNamesQueryVariables>(WidgetManyNamesDocument, options);
        }
// @ts-ignore
export function useWidgetManyNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetManyNamesQuery, WidgetManyNamesQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetManyNamesQuery, WidgetManyNamesQueryVariables>;
export function useWidgetManyNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetManyNamesQuery, WidgetManyNamesQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetManyNamesQuery | undefined, WidgetManyNamesQueryVariables>;
export function useWidgetManyNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetManyNamesQuery, WidgetManyNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetManyNamesQuery, WidgetManyNamesQueryVariables>(WidgetManyNamesDocument, options);
        }
export type WidgetManyNamesQueryHookResult = ReturnType<typeof useWidgetManyNamesQuery>;
export type WidgetManyNamesLazyQueryHookResult = ReturnType<typeof useWidgetManyNamesLazyQuery>;
export type WidgetManyNamesSuspenseQueryHookResult = ReturnType<typeof useWidgetManyNamesSuspenseQuery>;
export type WidgetManyNamesQueryResult = Apollo.QueryResult<WidgetManyNamesQuery, WidgetManyNamesQueryVariables>;
export const WidgetOperatorByVersionIdsWidgetDetailsDocument = gql`
    query WidgetOperatorByVersionIdsWidgetDetails($operatorVersionIds: [ID!]!) {
  operatorByVersionIds(operatorVersionIds: $operatorVersionIds) {
    _versionId
    operationalStatus
    enrollments {
      organization {
        _id
      }
      onboardingStatus
      organizationControlled
    }
    description {
      ...MultilingualFragment
    }
    shortDescription {
      ...MultilingualFragment
    }
    images {
      ...ImageFragment
    }
    selectedTagGroups {
      _id
      type
      key
      name {
        ...MultilingualFragment
      }
    }
    tags {
      businessType {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          type
          key
          name {
            ...MultilingualFragment
          }
        }
      }
      global {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          type
          key
          name {
            ...MultilingualFragment
          }
        }
      }
      organizationSpecific {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          type
          key
          name {
            ...MultilingualFragment
          }
        }
      }
      amenity {
        _id
        name {
          ...MultilingualFragment
        }
        tagGroup {
          _id
          type
          key
          name {
            ...MultilingualFragment
          }
        }
      }
    }
  }
}
    ${MultilingualFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useWidgetOperatorByVersionIdsWidgetDetailsQuery__
 *
 * To run a query within a React component, call `useWidgetOperatorByVersionIdsWidgetDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetOperatorByVersionIdsWidgetDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetOperatorByVersionIdsWidgetDetailsQuery({
 *   variables: {
 *      operatorVersionIds: // value for 'operatorVersionIds'
 *   },
 * });
 */
export function useWidgetOperatorByVersionIdsWidgetDetailsQuery(baseOptions: Apollo.QueryHookOptions<WidgetOperatorByVersionIdsWidgetDetailsQuery, WidgetOperatorByVersionIdsWidgetDetailsQueryVariables> & ({ variables: WidgetOperatorByVersionIdsWidgetDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetOperatorByVersionIdsWidgetDetailsQuery, WidgetOperatorByVersionIdsWidgetDetailsQueryVariables>(WidgetOperatorByVersionIdsWidgetDetailsDocument, options);
      }
export function useWidgetOperatorByVersionIdsWidgetDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetOperatorByVersionIdsWidgetDetailsQuery, WidgetOperatorByVersionIdsWidgetDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetOperatorByVersionIdsWidgetDetailsQuery, WidgetOperatorByVersionIdsWidgetDetailsQueryVariables>(WidgetOperatorByVersionIdsWidgetDetailsDocument, options);
        }
// @ts-ignore
export function useWidgetOperatorByVersionIdsWidgetDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetOperatorByVersionIdsWidgetDetailsQuery, WidgetOperatorByVersionIdsWidgetDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetOperatorByVersionIdsWidgetDetailsQuery, WidgetOperatorByVersionIdsWidgetDetailsQueryVariables>;
export function useWidgetOperatorByVersionIdsWidgetDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetOperatorByVersionIdsWidgetDetailsQuery, WidgetOperatorByVersionIdsWidgetDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetOperatorByVersionIdsWidgetDetailsQuery | undefined, WidgetOperatorByVersionIdsWidgetDetailsQueryVariables>;
export function useWidgetOperatorByVersionIdsWidgetDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetOperatorByVersionIdsWidgetDetailsQuery, WidgetOperatorByVersionIdsWidgetDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetOperatorByVersionIdsWidgetDetailsQuery, WidgetOperatorByVersionIdsWidgetDetailsQueryVariables>(WidgetOperatorByVersionIdsWidgetDetailsDocument, options);
        }
export type WidgetOperatorByVersionIdsWidgetDetailsQueryHookResult = ReturnType<typeof useWidgetOperatorByVersionIdsWidgetDetailsQuery>;
export type WidgetOperatorByVersionIdsWidgetDetailsLazyQueryHookResult = ReturnType<typeof useWidgetOperatorByVersionIdsWidgetDetailsLazyQuery>;
export type WidgetOperatorByVersionIdsWidgetDetailsSuspenseQueryHookResult = ReturnType<typeof useWidgetOperatorByVersionIdsWidgetDetailsSuspenseQuery>;
export type WidgetOperatorByVersionIdsWidgetDetailsQueryResult = Apollo.QueryResult<WidgetOperatorByVersionIdsWidgetDetailsQuery, WidgetOperatorByVersionIdsWidgetDetailsQueryVariables>;
export const WidgetOperatorsByVersionIdsDocument = gql`
    query WidgetOperatorsByVersionIds($operatorVersionIds: [ID!]!) {
  operatorByVersionIds(operatorVersionIds: $operatorVersionIds) {
    _versionId
    operationalStatus
    images {
      ...ImageFragment
    }
    shortDescription {
      ...MultilingualFragment
    }
    description {
      ...MultilingualFragment
    }
    contact {
      phone
      email
      links {
        website
        bookNow
      }
      address {
        ...AddressFragment
      }
    }
    hoursOfOperation {
      mon {
        _id
        start
        end
      }
      tue {
        _id
        start
        end
      }
      wed {
        _id
        start
        end
      }
      thu {
        _id
        start
        end
      }
      fri {
        _id
        start
        end
      }
      sat {
        _id
        start
        end
      }
      sun {
        _id
        start
        end
      }
    }
    pricing
    selectedTagGroups {
      _id
      name {
        ...MultilingualFragment
      }
    }
    tags {
      businessType {
        _id
        name {
          ...MultilingualFragment
        }
      }
      global {
        _id
        name {
          ...MultilingualFragment
        }
      }
      organizationSpecific {
        _id
        name {
          ...MultilingualFragment
        }
      }
      amenity {
        _id
        name {
          ...MultilingualFragment
        }
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}
${MultilingualFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;

/**
 * __useWidgetOperatorsByVersionIdsQuery__
 *
 * To run a query within a React component, call `useWidgetOperatorsByVersionIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetOperatorsByVersionIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetOperatorsByVersionIdsQuery({
 *   variables: {
 *      operatorVersionIds: // value for 'operatorVersionIds'
 *   },
 * });
 */
export function useWidgetOperatorsByVersionIdsQuery(baseOptions: Apollo.QueryHookOptions<WidgetOperatorsByVersionIdsQuery, WidgetOperatorsByVersionIdsQueryVariables> & ({ variables: WidgetOperatorsByVersionIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetOperatorsByVersionIdsQuery, WidgetOperatorsByVersionIdsQueryVariables>(WidgetOperatorsByVersionIdsDocument, options);
      }
export function useWidgetOperatorsByVersionIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetOperatorsByVersionIdsQuery, WidgetOperatorsByVersionIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetOperatorsByVersionIdsQuery, WidgetOperatorsByVersionIdsQueryVariables>(WidgetOperatorsByVersionIdsDocument, options);
        }
// @ts-ignore
export function useWidgetOperatorsByVersionIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WidgetOperatorsByVersionIdsQuery, WidgetOperatorsByVersionIdsQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetOperatorsByVersionIdsQuery, WidgetOperatorsByVersionIdsQueryVariables>;
export function useWidgetOperatorsByVersionIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetOperatorsByVersionIdsQuery, WidgetOperatorsByVersionIdsQueryVariables>): Apollo.UseSuspenseQueryResult<WidgetOperatorsByVersionIdsQuery | undefined, WidgetOperatorsByVersionIdsQueryVariables>;
export function useWidgetOperatorsByVersionIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetOperatorsByVersionIdsQuery, WidgetOperatorsByVersionIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetOperatorsByVersionIdsQuery, WidgetOperatorsByVersionIdsQueryVariables>(WidgetOperatorsByVersionIdsDocument, options);
        }
export type WidgetOperatorsByVersionIdsQueryHookResult = ReturnType<typeof useWidgetOperatorsByVersionIdsQuery>;
export type WidgetOperatorsByVersionIdsLazyQueryHookResult = ReturnType<typeof useWidgetOperatorsByVersionIdsLazyQuery>;
export type WidgetOperatorsByVersionIdsSuspenseQueryHookResult = ReturnType<typeof useWidgetOperatorsByVersionIdsSuspenseQuery>;
export type WidgetOperatorsByVersionIdsQueryResult = Apollo.QueryResult<WidgetOperatorsByVersionIdsQuery, WidgetOperatorsByVersionIdsQueryVariables>;
export const WorkbenchFeatureListDocument = gql`
    query WorkbenchFeatureList($includeGraduated: Boolean, $includeExpelled: Boolean) {
  workbenchFeatureList(
    includeGraduated: $includeGraduated
    includeExpelled: $includeExpelled
  ) {
    featureFlagKey
    featureFlagId
    name
    description
    group
    scope
    graduated
    expelled
    pendingEditCount
    openFeedbackCount
    lastActivityAt
    planSyncStatus
    docsSyncStatus
    testers {
      ...WorkbenchTesterFields
    }
    assignedToMe
    myActiveChatId
    hasActiveSeedRun
  }
}
    ${WorkbenchTesterFieldsFragmentDoc}`;

/**
 * __useWorkbenchFeatureListQuery__
 *
 * To run a query within a React component, call `useWorkbenchFeatureListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchFeatureListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbenchFeatureListQuery({
 *   variables: {
 *      includeGraduated: // value for 'includeGraduated'
 *      includeExpelled: // value for 'includeExpelled'
 *   },
 * });
 */
export function useWorkbenchFeatureListQuery(baseOptions?: Apollo.QueryHookOptions<WorkbenchFeatureListQuery, WorkbenchFeatureListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkbenchFeatureListQuery, WorkbenchFeatureListQueryVariables>(WorkbenchFeatureListDocument, options);
      }
export function useWorkbenchFeatureListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkbenchFeatureListQuery, WorkbenchFeatureListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkbenchFeatureListQuery, WorkbenchFeatureListQueryVariables>(WorkbenchFeatureListDocument, options);
        }
// @ts-ignore
export function useWorkbenchFeatureListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkbenchFeatureListQuery, WorkbenchFeatureListQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchFeatureListQuery, WorkbenchFeatureListQueryVariables>;
export function useWorkbenchFeatureListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchFeatureListQuery, WorkbenchFeatureListQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchFeatureListQuery | undefined, WorkbenchFeatureListQueryVariables>;
export function useWorkbenchFeatureListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchFeatureListQuery, WorkbenchFeatureListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkbenchFeatureListQuery, WorkbenchFeatureListQueryVariables>(WorkbenchFeatureListDocument, options);
        }
export type WorkbenchFeatureListQueryHookResult = ReturnType<typeof useWorkbenchFeatureListQuery>;
export type WorkbenchFeatureListLazyQueryHookResult = ReturnType<typeof useWorkbenchFeatureListLazyQuery>;
export type WorkbenchFeatureListSuspenseQueryHookResult = ReturnType<typeof useWorkbenchFeatureListSuspenseQuery>;
export type WorkbenchFeatureListQueryResult = Apollo.QueryResult<WorkbenchFeatureListQuery, WorkbenchFeatureListQueryVariables>;
export const WorkbenchFeatureDocument = gql`
    query WorkbenchFeature($featureFlagKey: String!) {
  workbenchFeature(featureFlagKey: $featureFlagKey) {
    ...WorkbenchFeatureFields
  }
}
    ${WorkbenchFeatureFieldsFragmentDoc}`;

/**
 * __useWorkbenchFeatureQuery__
 *
 * To run a query within a React component, call `useWorkbenchFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbenchFeatureQuery({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *   },
 * });
 */
export function useWorkbenchFeatureQuery(baseOptions: Apollo.QueryHookOptions<WorkbenchFeatureQuery, WorkbenchFeatureQueryVariables> & ({ variables: WorkbenchFeatureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkbenchFeatureQuery, WorkbenchFeatureQueryVariables>(WorkbenchFeatureDocument, options);
      }
export function useWorkbenchFeatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkbenchFeatureQuery, WorkbenchFeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkbenchFeatureQuery, WorkbenchFeatureQueryVariables>(WorkbenchFeatureDocument, options);
        }
// @ts-ignore
export function useWorkbenchFeatureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkbenchFeatureQuery, WorkbenchFeatureQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchFeatureQuery, WorkbenchFeatureQueryVariables>;
export function useWorkbenchFeatureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchFeatureQuery, WorkbenchFeatureQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchFeatureQuery | undefined, WorkbenchFeatureQueryVariables>;
export function useWorkbenchFeatureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchFeatureQuery, WorkbenchFeatureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkbenchFeatureQuery, WorkbenchFeatureQueryVariables>(WorkbenchFeatureDocument, options);
        }
export type WorkbenchFeatureQueryHookResult = ReturnType<typeof useWorkbenchFeatureQuery>;
export type WorkbenchFeatureLazyQueryHookResult = ReturnType<typeof useWorkbenchFeatureLazyQuery>;
export type WorkbenchFeatureSuspenseQueryHookResult = ReturnType<typeof useWorkbenchFeatureSuspenseQuery>;
export type WorkbenchFeatureQueryResult = Apollo.QueryResult<WorkbenchFeatureQuery, WorkbenchFeatureQueryVariables>;
export const WorkbenchSuggestionsByFlagDocument = gql`
    query WorkbenchSuggestionsByFlag($featureFlagKey: String!, $target: String, $kind: String, $statuses: [String!]) {
  workbenchSuggestionsByFlag(
    featureFlagKey: $featureFlagKey
    target: $target
    kind: $kind
    statuses: $statuses
  ) {
    ...WorkbenchSuggestionFields
  }
}
    ${WorkbenchSuggestionFieldsFragmentDoc}`;

/**
 * __useWorkbenchSuggestionsByFlagQuery__
 *
 * To run a query within a React component, call `useWorkbenchSuggestionsByFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchSuggestionsByFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbenchSuggestionsByFlagQuery({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *      target: // value for 'target'
 *      kind: // value for 'kind'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useWorkbenchSuggestionsByFlagQuery(baseOptions: Apollo.QueryHookOptions<WorkbenchSuggestionsByFlagQuery, WorkbenchSuggestionsByFlagQueryVariables> & ({ variables: WorkbenchSuggestionsByFlagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkbenchSuggestionsByFlagQuery, WorkbenchSuggestionsByFlagQueryVariables>(WorkbenchSuggestionsByFlagDocument, options);
      }
export function useWorkbenchSuggestionsByFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkbenchSuggestionsByFlagQuery, WorkbenchSuggestionsByFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkbenchSuggestionsByFlagQuery, WorkbenchSuggestionsByFlagQueryVariables>(WorkbenchSuggestionsByFlagDocument, options);
        }
// @ts-ignore
export function useWorkbenchSuggestionsByFlagSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkbenchSuggestionsByFlagQuery, WorkbenchSuggestionsByFlagQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchSuggestionsByFlagQuery, WorkbenchSuggestionsByFlagQueryVariables>;
export function useWorkbenchSuggestionsByFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchSuggestionsByFlagQuery, WorkbenchSuggestionsByFlagQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchSuggestionsByFlagQuery | undefined, WorkbenchSuggestionsByFlagQueryVariables>;
export function useWorkbenchSuggestionsByFlagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchSuggestionsByFlagQuery, WorkbenchSuggestionsByFlagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkbenchSuggestionsByFlagQuery, WorkbenchSuggestionsByFlagQueryVariables>(WorkbenchSuggestionsByFlagDocument, options);
        }
export type WorkbenchSuggestionsByFlagQueryHookResult = ReturnType<typeof useWorkbenchSuggestionsByFlagQuery>;
export type WorkbenchSuggestionsByFlagLazyQueryHookResult = ReturnType<typeof useWorkbenchSuggestionsByFlagLazyQuery>;
export type WorkbenchSuggestionsByFlagSuspenseQueryHookResult = ReturnType<typeof useWorkbenchSuggestionsByFlagSuspenseQuery>;
export type WorkbenchSuggestionsByFlagQueryResult = Apollo.QueryResult<WorkbenchSuggestionsByFlagQuery, WorkbenchSuggestionsByFlagQueryVariables>;
export const WorkbenchReviewSummariesDocument = gql`
    query WorkbenchReviewSummaries($featureFlagKey: String!) {
  workbenchReviewSummaries(featureFlagKey: $featureFlagKey) {
    _id
    reviewSummary
    reviewCompletedAt
    createdBy {
      _id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useWorkbenchReviewSummariesQuery__
 *
 * To run a query within a React component, call `useWorkbenchReviewSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchReviewSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbenchReviewSummariesQuery({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *   },
 * });
 */
export function useWorkbenchReviewSummariesQuery(baseOptions: Apollo.QueryHookOptions<WorkbenchReviewSummariesQuery, WorkbenchReviewSummariesQueryVariables> & ({ variables: WorkbenchReviewSummariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkbenchReviewSummariesQuery, WorkbenchReviewSummariesQueryVariables>(WorkbenchReviewSummariesDocument, options);
      }
export function useWorkbenchReviewSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkbenchReviewSummariesQuery, WorkbenchReviewSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkbenchReviewSummariesQuery, WorkbenchReviewSummariesQueryVariables>(WorkbenchReviewSummariesDocument, options);
        }
// @ts-ignore
export function useWorkbenchReviewSummariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkbenchReviewSummariesQuery, WorkbenchReviewSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchReviewSummariesQuery, WorkbenchReviewSummariesQueryVariables>;
export function useWorkbenchReviewSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchReviewSummariesQuery, WorkbenchReviewSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchReviewSummariesQuery | undefined, WorkbenchReviewSummariesQueryVariables>;
export function useWorkbenchReviewSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchReviewSummariesQuery, WorkbenchReviewSummariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkbenchReviewSummariesQuery, WorkbenchReviewSummariesQueryVariables>(WorkbenchReviewSummariesDocument, options);
        }
export type WorkbenchReviewSummariesQueryHookResult = ReturnType<typeof useWorkbenchReviewSummariesQuery>;
export type WorkbenchReviewSummariesLazyQueryHookResult = ReturnType<typeof useWorkbenchReviewSummariesLazyQuery>;
export type WorkbenchReviewSummariesSuspenseQueryHookResult = ReturnType<typeof useWorkbenchReviewSummariesSuspenseQuery>;
export type WorkbenchReviewSummariesQueryResult = Apollo.QueryResult<WorkbenchReviewSummariesQuery, WorkbenchReviewSummariesQueryVariables>;
export const WorkbenchChangeRequestStatusDocument = gql`
    query WorkbenchChangeRequestStatus($featureFlagKey: String!, $target: String!) {
  workbenchChangeRequestStatus(featureFlagKey: $featureFlagKey, target: $target) {
    ...WorkbenchChangeRequestFields
  }
}
    ${WorkbenchChangeRequestFieldsFragmentDoc}`;

/**
 * __useWorkbenchChangeRequestStatusQuery__
 *
 * To run a query within a React component, call `useWorkbenchChangeRequestStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchChangeRequestStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbenchChangeRequestStatusQuery({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *      target: // value for 'target'
 *   },
 * });
 */
export function useWorkbenchChangeRequestStatusQuery(baseOptions: Apollo.QueryHookOptions<WorkbenchChangeRequestStatusQuery, WorkbenchChangeRequestStatusQueryVariables> & ({ variables: WorkbenchChangeRequestStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkbenchChangeRequestStatusQuery, WorkbenchChangeRequestStatusQueryVariables>(WorkbenchChangeRequestStatusDocument, options);
      }
export function useWorkbenchChangeRequestStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkbenchChangeRequestStatusQuery, WorkbenchChangeRequestStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkbenchChangeRequestStatusQuery, WorkbenchChangeRequestStatusQueryVariables>(WorkbenchChangeRequestStatusDocument, options);
        }
// @ts-ignore
export function useWorkbenchChangeRequestStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkbenchChangeRequestStatusQuery, WorkbenchChangeRequestStatusQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchChangeRequestStatusQuery, WorkbenchChangeRequestStatusQueryVariables>;
export function useWorkbenchChangeRequestStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchChangeRequestStatusQuery, WorkbenchChangeRequestStatusQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchChangeRequestStatusQuery | undefined, WorkbenchChangeRequestStatusQueryVariables>;
export function useWorkbenchChangeRequestStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchChangeRequestStatusQuery, WorkbenchChangeRequestStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkbenchChangeRequestStatusQuery, WorkbenchChangeRequestStatusQueryVariables>(WorkbenchChangeRequestStatusDocument, options);
        }
export type WorkbenchChangeRequestStatusQueryHookResult = ReturnType<typeof useWorkbenchChangeRequestStatusQuery>;
export type WorkbenchChangeRequestStatusLazyQueryHookResult = ReturnType<typeof useWorkbenchChangeRequestStatusLazyQuery>;
export type WorkbenchChangeRequestStatusSuspenseQueryHookResult = ReturnType<typeof useWorkbenchChangeRequestStatusSuspenseQuery>;
export type WorkbenchChangeRequestStatusQueryResult = Apollo.QueryResult<WorkbenchChangeRequestStatusQuery, WorkbenchChangeRequestStatusQueryVariables>;
export const WorkbenchSettingsGetDocument = gql`
    query WorkbenchSettingsGet {
  workbenchSettingsGet {
    defaultTestOrganizationId
    defaultTestOrganizationName
    defaultTestStorefrontId
    allowSeedingInProduction
    seedingAllowedHere
    environment
    anthropicConfigured
    chatModel {
      primary
      fallbacks
    }
    summaryModel {
      primary
      fallbacks
    }
  }
}
    `;

/**
 * __useWorkbenchSettingsGetQuery__
 *
 * To run a query within a React component, call `useWorkbenchSettingsGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchSettingsGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbenchSettingsGetQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkbenchSettingsGetQuery(baseOptions?: Apollo.QueryHookOptions<WorkbenchSettingsGetQuery, WorkbenchSettingsGetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkbenchSettingsGetQuery, WorkbenchSettingsGetQueryVariables>(WorkbenchSettingsGetDocument, options);
      }
export function useWorkbenchSettingsGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkbenchSettingsGetQuery, WorkbenchSettingsGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkbenchSettingsGetQuery, WorkbenchSettingsGetQueryVariables>(WorkbenchSettingsGetDocument, options);
        }
// @ts-ignore
export function useWorkbenchSettingsGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkbenchSettingsGetQuery, WorkbenchSettingsGetQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchSettingsGetQuery, WorkbenchSettingsGetQueryVariables>;
export function useWorkbenchSettingsGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchSettingsGetQuery, WorkbenchSettingsGetQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchSettingsGetQuery | undefined, WorkbenchSettingsGetQueryVariables>;
export function useWorkbenchSettingsGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchSettingsGetQuery, WorkbenchSettingsGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkbenchSettingsGetQuery, WorkbenchSettingsGetQueryVariables>(WorkbenchSettingsGetDocument, options);
        }
export type WorkbenchSettingsGetQueryHookResult = ReturnType<typeof useWorkbenchSettingsGetQuery>;
export type WorkbenchSettingsGetLazyQueryHookResult = ReturnType<typeof useWorkbenchSettingsGetLazyQuery>;
export type WorkbenchSettingsGetSuspenseQueryHookResult = ReturnType<typeof useWorkbenchSettingsGetSuspenseQuery>;
export type WorkbenchSettingsGetQueryResult = Apollo.QueryResult<WorkbenchSettingsGetQuery, WorkbenchSettingsGetQueryVariables>;
export const WorkbenchSeedScenariosDocument = gql`
    query WorkbenchSeedScenarios($featureFlagKey: String!) {
  workbenchSeedScenarios(featureFlagKey: $featureFlagKey) {
    key
    label
    description
  }
}
    `;

/**
 * __useWorkbenchSeedScenariosQuery__
 *
 * To run a query within a React component, call `useWorkbenchSeedScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchSeedScenariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbenchSeedScenariosQuery({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *   },
 * });
 */
export function useWorkbenchSeedScenariosQuery(baseOptions: Apollo.QueryHookOptions<WorkbenchSeedScenariosQuery, WorkbenchSeedScenariosQueryVariables> & ({ variables: WorkbenchSeedScenariosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkbenchSeedScenariosQuery, WorkbenchSeedScenariosQueryVariables>(WorkbenchSeedScenariosDocument, options);
      }
export function useWorkbenchSeedScenariosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkbenchSeedScenariosQuery, WorkbenchSeedScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkbenchSeedScenariosQuery, WorkbenchSeedScenariosQueryVariables>(WorkbenchSeedScenariosDocument, options);
        }
// @ts-ignore
export function useWorkbenchSeedScenariosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkbenchSeedScenariosQuery, WorkbenchSeedScenariosQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchSeedScenariosQuery, WorkbenchSeedScenariosQueryVariables>;
export function useWorkbenchSeedScenariosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchSeedScenariosQuery, WorkbenchSeedScenariosQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchSeedScenariosQuery | undefined, WorkbenchSeedScenariosQueryVariables>;
export function useWorkbenchSeedScenariosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchSeedScenariosQuery, WorkbenchSeedScenariosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkbenchSeedScenariosQuery, WorkbenchSeedScenariosQueryVariables>(WorkbenchSeedScenariosDocument, options);
        }
export type WorkbenchSeedScenariosQueryHookResult = ReturnType<typeof useWorkbenchSeedScenariosQuery>;
export type WorkbenchSeedScenariosLazyQueryHookResult = ReturnType<typeof useWorkbenchSeedScenariosLazyQuery>;
export type WorkbenchSeedScenariosSuspenseQueryHookResult = ReturnType<typeof useWorkbenchSeedScenariosSuspenseQuery>;
export type WorkbenchSeedScenariosQueryResult = Apollo.QueryResult<WorkbenchSeedScenariosQuery, WorkbenchSeedScenariosQueryVariables>;
export const WorkbenchSeedRunsDocument = gql`
    query WorkbenchSeedRuns($featureFlagKey: String!, $organizationId: MongoID) {
  workbenchSeedRuns(
    featureFlagKey: $featureFlagKey
    organizationId: $organizationId
  ) {
    ...WorkbenchSeedRunFields
  }
}
    ${WorkbenchSeedRunFieldsFragmentDoc}`;

/**
 * __useWorkbenchSeedRunsQuery__
 *
 * To run a query within a React component, call `useWorkbenchSeedRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchSeedRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbenchSeedRunsQuery({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useWorkbenchSeedRunsQuery(baseOptions: Apollo.QueryHookOptions<WorkbenchSeedRunsQuery, WorkbenchSeedRunsQueryVariables> & ({ variables: WorkbenchSeedRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkbenchSeedRunsQuery, WorkbenchSeedRunsQueryVariables>(WorkbenchSeedRunsDocument, options);
      }
export function useWorkbenchSeedRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkbenchSeedRunsQuery, WorkbenchSeedRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkbenchSeedRunsQuery, WorkbenchSeedRunsQueryVariables>(WorkbenchSeedRunsDocument, options);
        }
// @ts-ignore
export function useWorkbenchSeedRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkbenchSeedRunsQuery, WorkbenchSeedRunsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchSeedRunsQuery, WorkbenchSeedRunsQueryVariables>;
export function useWorkbenchSeedRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchSeedRunsQuery, WorkbenchSeedRunsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchSeedRunsQuery | undefined, WorkbenchSeedRunsQueryVariables>;
export function useWorkbenchSeedRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchSeedRunsQuery, WorkbenchSeedRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkbenchSeedRunsQuery, WorkbenchSeedRunsQueryVariables>(WorkbenchSeedRunsDocument, options);
        }
export type WorkbenchSeedRunsQueryHookResult = ReturnType<typeof useWorkbenchSeedRunsQuery>;
export type WorkbenchSeedRunsLazyQueryHookResult = ReturnType<typeof useWorkbenchSeedRunsLazyQuery>;
export type WorkbenchSeedRunsSuspenseQueryHookResult = ReturnType<typeof useWorkbenchSeedRunsSuspenseQuery>;
export type WorkbenchSeedRunsQueryResult = Apollo.QueryResult<WorkbenchSeedRunsQuery, WorkbenchSeedRunsQueryVariables>;
export const WorkbenchTesterCandidatesDocument = gql`
    query WorkbenchTesterCandidates {
  workbenchTesterCandidates {
    ...WorkbenchTesterFields
  }
}
    ${WorkbenchTesterFieldsFragmentDoc}`;

/**
 * __useWorkbenchTesterCandidatesQuery__
 *
 * To run a query within a React component, call `useWorkbenchTesterCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchTesterCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbenchTesterCandidatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkbenchTesterCandidatesQuery(baseOptions?: Apollo.QueryHookOptions<WorkbenchTesterCandidatesQuery, WorkbenchTesterCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkbenchTesterCandidatesQuery, WorkbenchTesterCandidatesQueryVariables>(WorkbenchTesterCandidatesDocument, options);
      }
export function useWorkbenchTesterCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkbenchTesterCandidatesQuery, WorkbenchTesterCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkbenchTesterCandidatesQuery, WorkbenchTesterCandidatesQueryVariables>(WorkbenchTesterCandidatesDocument, options);
        }
// @ts-ignore
export function useWorkbenchTesterCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkbenchTesterCandidatesQuery, WorkbenchTesterCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchTesterCandidatesQuery, WorkbenchTesterCandidatesQueryVariables>;
export function useWorkbenchTesterCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchTesterCandidatesQuery, WorkbenchTesterCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchTesterCandidatesQuery | undefined, WorkbenchTesterCandidatesQueryVariables>;
export function useWorkbenchTesterCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchTesterCandidatesQuery, WorkbenchTesterCandidatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkbenchTesterCandidatesQuery, WorkbenchTesterCandidatesQueryVariables>(WorkbenchTesterCandidatesDocument, options);
        }
export type WorkbenchTesterCandidatesQueryHookResult = ReturnType<typeof useWorkbenchTesterCandidatesQuery>;
export type WorkbenchTesterCandidatesLazyQueryHookResult = ReturnType<typeof useWorkbenchTesterCandidatesLazyQuery>;
export type WorkbenchTesterCandidatesSuspenseQueryHookResult = ReturnType<typeof useWorkbenchTesterCandidatesSuspenseQuery>;
export type WorkbenchTesterCandidatesQueryResult = Apollo.QueryResult<WorkbenchTesterCandidatesQuery, WorkbenchTesterCandidatesQueryVariables>;
export const WorkbenchGateStateDocument = gql`
    query WorkbenchGateState($featureFlagKey: String!, $organizationId: MongoID) {
  workbenchGateState(
    featureFlagKey: $featureFlagKey
    organizationId: $organizationId
  ) {
    featureFlagId
    scope
    graduated
    expelled
    organizationEnabled
    enabledOrganizationCount
    testerAdminGates {
      userId
      name
      enabled
    }
  }
}
    `;

/**
 * __useWorkbenchGateStateQuery__
 *
 * To run a query within a React component, call `useWorkbenchGateStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchGateStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbenchGateStateQuery({
 *   variables: {
 *      featureFlagKey: // value for 'featureFlagKey'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useWorkbenchGateStateQuery(baseOptions: Apollo.QueryHookOptions<WorkbenchGateStateQuery, WorkbenchGateStateQueryVariables> & ({ variables: WorkbenchGateStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkbenchGateStateQuery, WorkbenchGateStateQueryVariables>(WorkbenchGateStateDocument, options);
      }
export function useWorkbenchGateStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkbenchGateStateQuery, WorkbenchGateStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkbenchGateStateQuery, WorkbenchGateStateQueryVariables>(WorkbenchGateStateDocument, options);
        }
// @ts-ignore
export function useWorkbenchGateStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkbenchGateStateQuery, WorkbenchGateStateQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchGateStateQuery, WorkbenchGateStateQueryVariables>;
export function useWorkbenchGateStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchGateStateQuery, WorkbenchGateStateQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchGateStateQuery | undefined, WorkbenchGateStateQueryVariables>;
export function useWorkbenchGateStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchGateStateQuery, WorkbenchGateStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkbenchGateStateQuery, WorkbenchGateStateQueryVariables>(WorkbenchGateStateDocument, options);
        }
export type WorkbenchGateStateQueryHookResult = ReturnType<typeof useWorkbenchGateStateQuery>;
export type WorkbenchGateStateLazyQueryHookResult = ReturnType<typeof useWorkbenchGateStateLazyQuery>;
export type WorkbenchGateStateSuspenseQueryHookResult = ReturnType<typeof useWorkbenchGateStateSuspenseQuery>;
export type WorkbenchGateStateQueryResult = Apollo.QueryResult<WorkbenchGateStateQuery, WorkbenchGateStateQueryVariables>;
export const WorkbenchMessagesByChatDocument = gql`
    query WorkbenchMessagesByChat($chatId: MongoID!, $before: MongoID, $limit: Int) {
  whereabotMessagesByChat(chatId: $chatId, before: $before, limit: $limit) {
    ...WorkbenchMessageFields
  }
}
    ${WorkbenchMessageFieldsFragmentDoc}`;

/**
 * __useWorkbenchMessagesByChatQuery__
 *
 * To run a query within a React component, call `useWorkbenchMessagesByChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchMessagesByChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbenchMessagesByChatQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useWorkbenchMessagesByChatQuery(baseOptions: Apollo.QueryHookOptions<WorkbenchMessagesByChatQuery, WorkbenchMessagesByChatQueryVariables> & ({ variables: WorkbenchMessagesByChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkbenchMessagesByChatQuery, WorkbenchMessagesByChatQueryVariables>(WorkbenchMessagesByChatDocument, options);
      }
export function useWorkbenchMessagesByChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkbenchMessagesByChatQuery, WorkbenchMessagesByChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkbenchMessagesByChatQuery, WorkbenchMessagesByChatQueryVariables>(WorkbenchMessagesByChatDocument, options);
        }
// @ts-ignore
export function useWorkbenchMessagesByChatSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkbenchMessagesByChatQuery, WorkbenchMessagesByChatQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchMessagesByChatQuery, WorkbenchMessagesByChatQueryVariables>;
export function useWorkbenchMessagesByChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchMessagesByChatQuery, WorkbenchMessagesByChatQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchMessagesByChatQuery | undefined, WorkbenchMessagesByChatQueryVariables>;
export function useWorkbenchMessagesByChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchMessagesByChatQuery, WorkbenchMessagesByChatQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkbenchMessagesByChatQuery, WorkbenchMessagesByChatQueryVariables>(WorkbenchMessagesByChatDocument, options);
        }
export type WorkbenchMessagesByChatQueryHookResult = ReturnType<typeof useWorkbenchMessagesByChatQuery>;
export type WorkbenchMessagesByChatLazyQueryHookResult = ReturnType<typeof useWorkbenchMessagesByChatLazyQuery>;
export type WorkbenchMessagesByChatSuspenseQueryHookResult = ReturnType<typeof useWorkbenchMessagesByChatSuspenseQuery>;
export type WorkbenchMessagesByChatQueryResult = Apollo.QueryResult<WorkbenchMessagesByChatQuery, WorkbenchMessagesByChatQueryVariables>;
export const WorkbenchChatByIdDocument = gql`
    query WorkbenchChatById($_id: MongoID!) {
  whereabotChatById(_id: $_id) {
    _id
    title
    status
    featureFlagKey
    testOrganizationId
    reviewSummary
    reviewCompletedAt
  }
}
    `;

/**
 * __useWorkbenchChatByIdQuery__
 *
 * To run a query within a React component, call `useWorkbenchChatByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchChatByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbenchChatByIdQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useWorkbenchChatByIdQuery(baseOptions: Apollo.QueryHookOptions<WorkbenchChatByIdQuery, WorkbenchChatByIdQueryVariables> & ({ variables: WorkbenchChatByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkbenchChatByIdQuery, WorkbenchChatByIdQueryVariables>(WorkbenchChatByIdDocument, options);
      }
export function useWorkbenchChatByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkbenchChatByIdQuery, WorkbenchChatByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkbenchChatByIdQuery, WorkbenchChatByIdQueryVariables>(WorkbenchChatByIdDocument, options);
        }
// @ts-ignore
export function useWorkbenchChatByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkbenchChatByIdQuery, WorkbenchChatByIdQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchChatByIdQuery, WorkbenchChatByIdQueryVariables>;
export function useWorkbenchChatByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchChatByIdQuery, WorkbenchChatByIdQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchChatByIdQuery | undefined, WorkbenchChatByIdQueryVariables>;
export function useWorkbenchChatByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchChatByIdQuery, WorkbenchChatByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkbenchChatByIdQuery, WorkbenchChatByIdQueryVariables>(WorkbenchChatByIdDocument, options);
        }
export type WorkbenchChatByIdQueryHookResult = ReturnType<typeof useWorkbenchChatByIdQuery>;
export type WorkbenchChatByIdLazyQueryHookResult = ReturnType<typeof useWorkbenchChatByIdLazyQuery>;
export type WorkbenchChatByIdSuspenseQueryHookResult = ReturnType<typeof useWorkbenchChatByIdSuspenseQuery>;
export type WorkbenchChatByIdQueryResult = Apollo.QueryResult<WorkbenchChatByIdQuery, WorkbenchChatByIdQueryVariables>;
export const WorkbenchOrganizationOptionsDocument = gql`
    query WorkbenchOrganizationOptions {
  organizationMany(limit: 2000) {
    _id
    name {
      en
    }
    metadata {
      sandbox
    }
  }
}
    `;

/**
 * __useWorkbenchOrganizationOptionsQuery__
 *
 * To run a query within a React component, call `useWorkbenchOrganizationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchOrganizationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbenchOrganizationOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkbenchOrganizationOptionsQuery(baseOptions?: Apollo.QueryHookOptions<WorkbenchOrganizationOptionsQuery, WorkbenchOrganizationOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkbenchOrganizationOptionsQuery, WorkbenchOrganizationOptionsQueryVariables>(WorkbenchOrganizationOptionsDocument, options);
      }
export function useWorkbenchOrganizationOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkbenchOrganizationOptionsQuery, WorkbenchOrganizationOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkbenchOrganizationOptionsQuery, WorkbenchOrganizationOptionsQueryVariables>(WorkbenchOrganizationOptionsDocument, options);
        }
// @ts-ignore
export function useWorkbenchOrganizationOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkbenchOrganizationOptionsQuery, WorkbenchOrganizationOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchOrganizationOptionsQuery, WorkbenchOrganizationOptionsQueryVariables>;
export function useWorkbenchOrganizationOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchOrganizationOptionsQuery, WorkbenchOrganizationOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchOrganizationOptionsQuery | undefined, WorkbenchOrganizationOptionsQueryVariables>;
export function useWorkbenchOrganizationOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchOrganizationOptionsQuery, WorkbenchOrganizationOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkbenchOrganizationOptionsQuery, WorkbenchOrganizationOptionsQueryVariables>(WorkbenchOrganizationOptionsDocument, options);
        }
export type WorkbenchOrganizationOptionsQueryHookResult = ReturnType<typeof useWorkbenchOrganizationOptionsQuery>;
export type WorkbenchOrganizationOptionsLazyQueryHookResult = ReturnType<typeof useWorkbenchOrganizationOptionsLazyQuery>;
export type WorkbenchOrganizationOptionsSuspenseQueryHookResult = ReturnType<typeof useWorkbenchOrganizationOptionsSuspenseQuery>;
export type WorkbenchOrganizationOptionsQueryResult = Apollo.QueryResult<WorkbenchOrganizationOptionsQuery, WorkbenchOrganizationOptionsQueryVariables>;
export const WorkbenchWhereabotAvatarDocument = gql`
    query WorkbenchWhereabotAvatar($userId: MongoID!) {
  personFindOne(filter: {user: $userId}) {
    _id
    photo {
      _id
      blurhash
      width
      height
      isVideo
      format
    }
  }
  userFindOne(filter: {_id: $userId}) {
    _id
    photo {
      _id
      blurhash
      width
      height
      isVideo
      format
    }
  }
}
    `;

/**
 * __useWorkbenchWhereabotAvatarQuery__
 *
 * To run a query within a React component, call `useWorkbenchWhereabotAvatarQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbenchWhereabotAvatarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbenchWhereabotAvatarQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useWorkbenchWhereabotAvatarQuery(baseOptions: Apollo.QueryHookOptions<WorkbenchWhereabotAvatarQuery, WorkbenchWhereabotAvatarQueryVariables> & ({ variables: WorkbenchWhereabotAvatarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkbenchWhereabotAvatarQuery, WorkbenchWhereabotAvatarQueryVariables>(WorkbenchWhereabotAvatarDocument, options);
      }
export function useWorkbenchWhereabotAvatarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkbenchWhereabotAvatarQuery, WorkbenchWhereabotAvatarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkbenchWhereabotAvatarQuery, WorkbenchWhereabotAvatarQueryVariables>(WorkbenchWhereabotAvatarDocument, options);
        }
// @ts-ignore
export function useWorkbenchWhereabotAvatarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkbenchWhereabotAvatarQuery, WorkbenchWhereabotAvatarQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchWhereabotAvatarQuery, WorkbenchWhereabotAvatarQueryVariables>;
export function useWorkbenchWhereabotAvatarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchWhereabotAvatarQuery, WorkbenchWhereabotAvatarQueryVariables>): Apollo.UseSuspenseQueryResult<WorkbenchWhereabotAvatarQuery | undefined, WorkbenchWhereabotAvatarQueryVariables>;
export function useWorkbenchWhereabotAvatarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkbenchWhereabotAvatarQuery, WorkbenchWhereabotAvatarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkbenchWhereabotAvatarQuery, WorkbenchWhereabotAvatarQueryVariables>(WorkbenchWhereabotAvatarDocument, options);
        }
export type WorkbenchWhereabotAvatarQueryHookResult = ReturnType<typeof useWorkbenchWhereabotAvatarQuery>;
export type WorkbenchWhereabotAvatarLazyQueryHookResult = ReturnType<typeof useWorkbenchWhereabotAvatarLazyQuery>;
export type WorkbenchWhereabotAvatarSuspenseQueryHookResult = ReturnType<typeof useWorkbenchWhereabotAvatarSuspenseQuery>;
export type WorkbenchWhereabotAvatarQueryResult = Apollo.QueryResult<WorkbenchWhereabotAvatarQuery, WorkbenchWhereabotAvatarQueryVariables>;